/**
* vue v3.5.12
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/var Vue=function(e){"use strict";var t,n;let r,i,l,s,o,a,c,u,d,p,f,h,m;/*! #__NO_SIDE_EFFECTS__ */function g(e){let t=/* @__PURE__ */Object.create(null);for(let n of e.split(","))t[n]=1;return e=>e in t}let y={},b=[],_=()=>{},S=()=>!1,x=e=>111===e.charCodeAt(0)&&110===e.charCodeAt(1)&&(e.charCodeAt(2)>122||97>e.charCodeAt(2)),C=e=>e.startsWith("onUpdate:"),k=Object.assign,T=(e,t)=>{let n=e.indexOf(t);n>-1&&e.splice(n,1)},N=Object.prototype.hasOwnProperty,w=(e,t)=>N.call(e,t),A=Array.isArray,E=e=>"[object Map]"===V(e),I=e=>"[object Set]"===V(e),R=e=>"[object Date]"===V(e),O=e=>"[object RegExp]"===V(e),P=e=>"function"==typeof e,M=e=>"string"==typeof e,L=e=>"symbol"==typeof e,$=e=>null!==e&&"object"==typeof e,D=e=>($(e)||P(e))&&P(e.then)&&P(e.catch),F=Object.prototype.toString,V=e=>F.call(e),B=e=>V(e).slice(8,-1),U=e=>"[object Object]"===V(e),j=e=>M(e)&&"NaN"!==e&&"-"!==e[0]&&""+parseInt(e,10)===e,H=/* @__PURE__ */g(",key,ref,ref_for,ref_key,onVnodeBeforeMount,onVnodeMounted,onVnodeBeforeUpdate,onVnodeUpdated,onVnodeBeforeUnmount,onVnodeUnmounted"),q=/* @__PURE__ */g("bind,cloak,else-if,else,for,html,if,model,on,once,pre,show,slot,text,memo"),W=e=>{let t=/* @__PURE__ */Object.create(null);return n=>t[n]||(t[n]=e(n))},K=/-(\w)/g,z=W(e=>e.replace(K,(e,t)=>t?t.toUpperCase():"")),J=/\B([A-Z])/g,G=W(e=>e.replace(J,"-$1").toLowerCase()),X=W(e=>e.charAt(0).toUpperCase()+e.slice(1)),Q=W(e=>e?`on${X(e)}`:""),Z=(e,t)=>!Object.is(e,t),Y=(e,...t)=>{for(let n=0;n<e.length;n++)e[n](...t)},ee=(e,t,n,r=!1)=>{Object.defineProperty(e,t,{configurable:!0,enumerable:!1,writable:r,value:n})},et=e=>{let t=parseFloat(e);return isNaN(t)?e:t},en=e=>{let t=M(e)?Number(e):NaN;return isNaN(t)?e:t},er=()=>r||(r="undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:"undefined"!=typeof window?window:"undefined"!=typeof global?global:{}),ei=/* @__PURE__ */g("Infinity,undefined,NaN,isFinite,isNaN,parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,BigInt,console,Error,Symbol");function el(e){if(A(e)){let t={};for(let n=0;n<e.length;n++){let r=e[n],i=M(r)?ec(r):el(r);if(i)for(let e in i)t[e]=i[e]}return t}if(M(e)||$(e))return e}let es=/;(?![^(]*\))/g,eo=/:([^]+)/,ea=/\/\*[^]*?\*\//g;function ec(e){let t={};return e.replace(ea,"").split(es).forEach(e=>{if(e){let n=e.split(eo);n.length>1&&(t[n[0].trim()]=n[1].trim())}}),t}function eu(e){let t="";if(M(e))t=e;else if(A(e))for(let n=0;n<e.length;n++){let r=eu(e[n]);r&&(t+=r+" ")}else if($(e))for(let n in e)e[n]&&(t+=n+" ");return t.trim()}let ed=/* @__PURE__ */g("html,body,base,head,link,meta,style,title,address,article,aside,footer,header,hgroup,h1,h2,h3,h4,h5,h6,nav,section,div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,ruby,s,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,embed,object,param,source,canvas,script,noscript,del,ins,caption,col,colgroup,table,thead,tbody,td,th,tr,button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,output,progress,select,textarea,details,dialog,menu,summary,template,blockquote,iframe,tfoot"),ep=/* @__PURE__ */g("svg,animate,animateMotion,animateTransform,circle,clipPath,color-profile,defs,desc,discard,ellipse,feBlend,feColorMatrix,feComponentTransfer,feComposite,feConvolveMatrix,feDiffuseLighting,feDisplacementMap,feDistantLight,feDropShadow,feFlood,feFuncA,feFuncB,feFuncG,feFuncR,feGaussianBlur,feImage,feMerge,feMergeNode,feMorphology,feOffset,fePointLight,feSpecularLighting,feSpotLight,feTile,feTurbulence,filter,foreignObject,g,hatch,hatchpath,image,line,linearGradient,marker,mask,mesh,meshgradient,meshpatch,meshrow,metadata,mpath,path,pattern,polygon,polyline,radialGradient,rect,set,solidcolor,stop,switch,symbol,text,textPath,title,tspan,unknown,use,view"),ef=/* @__PURE__ */g("annotation,annotation-xml,maction,maligngroup,malignmark,math,menclose,merror,mfenced,mfrac,mfraction,mglyph,mi,mlabeledtr,mlongdiv,mmultiscripts,mn,mo,mover,mpadded,mphantom,mprescripts,mroot,mrow,ms,mscarries,mscarry,msgroup,msline,mspace,msqrt,msrow,mstack,mstyle,msub,msubsup,msup,mtable,mtd,mtext,mtr,munder,munderover,none,semantics"),eh=/* @__PURE__ */g("area,base,br,col,embed,hr,img,input,link,meta,param,source,track,wbr"),em=/* @__PURE__ */g("itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly");function eg(e,t){if(e===t)return!0;let n=R(e),r=R(t);if(n||r)return!!n&&!!r&&e.getTime()===t.getTime();if(n=L(e),r=L(t),n||r)return e===t;if(n=A(e),r=A(t),n||r)return!!n&&!!r&&function(e,t){if(e.length!==t.length)return!1;let n=!0;for(let r=0;n&&r<e.length;r++)n=eg(e[r],t[r]);return n}(e,t);if(n=$(e),r=$(t),n||r){if(!n||!r||Object.keys(e).length!==Object.keys(t).length)return!1;for(let n in e){let r=e.hasOwnProperty(n),i=t.hasOwnProperty(n);if(r&&!i||!r&&i||!eg(e[n],t[n]))return!1}}return String(e)===String(t)}function ey(e,t){return e.findIndex(e=>eg(e,t))}let ev=e=>!!(e&&!0===e.__v_isRef),eb=e=>M(e)?e:null==e?"":A(e)||$(e)&&(e.toString===F||!P(e.toString))?ev(e)?eb(e.value):JSON.stringify(e,e_,2):String(e),e_=(e,t)=>ev(t)?e_(e,t.value):E(t)?{[`Map(${t.size})`]:[...t.entries()].reduce((e,[t,n],r)=>(e[eS(t,r)+" =>"]=n,e),{})}:I(t)?{[`Set(${t.size})`]:[...t.values()].map(e=>eS(e))}:L(t)?eS(t):!$(t)||A(t)||U(t)?t:String(t),eS=(e,t="")=>{var n;return L(e)?`Symbol(${null!=(n=e.description)?n:t})`:e};class ex{constructor(e=!1){this.detached=e,this._active=!0,this.effects=[],this.cleanups=[],this._isPaused=!1,this.parent=i,!e&&i&&(this.index=(i.scopes||(i.scopes=[])).push(this)-1)}get active(){return this._active}pause(){if(this._active){let e,t;if(this._isPaused=!0,this.scopes)for(e=0,t=this.scopes.length;e<t;e++)this.scopes[e].pause();for(e=0,t=this.effects.length;e<t;e++)this.effects[e].pause()}}resume(){if(this._active&&this._isPaused){let e,t;if(this._isPaused=!1,this.scopes)for(e=0,t=this.scopes.length;e<t;e++)this.scopes[e].resume();for(e=0,t=this.effects.length;e<t;e++)this.effects[e].resume()}}run(e){if(this._active){let t=i;try{return i=this,e()}finally{i=t}}}on(){i=this}off(){i=this.parent}stop(e){if(this._active){let t,n;for(t=0,n=this.effects.length;t<n;t++)this.effects[t].stop();for(t=0,n=this.cleanups.length;t<n;t++)this.cleanups[t]();if(this.scopes)for(t=0,n=this.scopes.length;t<n;t++)this.scopes[t].stop(!0);if(!this.detached&&this.parent&&!e){let e=this.parent.scopes.pop();e&&e!==this&&(this.parent.scopes[this.index]=e,e.index=this.index)}this.parent=void 0,this._active=!1}}}let eC=/* @__PURE__ */new WeakSet;class ek{constructor(e){this.fn=e,this.deps=void 0,this.depsTail=void 0,this.flags=5,this.next=void 0,this.cleanup=void 0,this.scheduler=void 0,i&&i.active&&i.effects.push(this)}pause(){this.flags|=64}resume(){64&this.flags&&(this.flags&=-65,eC.has(this)&&(eC.delete(this),this.trigger()))}notify(){(!(2&this.flags)||32&this.flags)&&(8&this.flags||eN(this))}run(){if(!(1&this.flags))return this.fn();this.flags|=2,eD(this),eA(this);let e=l,t=eP;l=this,eP=!0;try{return this.fn()}finally{eE(this),l=e,eP=t,this.flags&=-3}}stop(){if(1&this.flags){for(let e=this.deps;e;e=e.nextDep)eO(e);this.deps=this.depsTail=void 0,eD(this),this.onStop&&this.onStop(),this.flags&=-2}}trigger(){64&this.flags?eC.add(this):this.scheduler?this.scheduler():this.runIfDirty()}runIfDirty(){eI(this)&&this.run()}get dirty(){return eI(this)}}let eT=0;function eN(e,t=!1){if(e.flags|=8,t){e.next=o,o=e;return}e.next=s,s=e}function ew(){let e;if(!(--eT>0)){if(o){let e=o;for(o=void 0;e;){let t=e.next;e.next=void 0,e.flags&=-9,e=t}}for(;s;){let t=s;for(s=void 0;t;){let n=t.next;if(t.next=void 0,t.flags&=-9,1&t.flags)try{t.trigger()}catch(t){e||(e=t)}t=n}}if(e)throw e}}function eA(e){for(let t=e.deps;t;t=t.nextDep)t.version=-1,t.prevActiveLink=t.dep.activeLink,t.dep.activeLink=t}function eE(e){let t;let n=e.depsTail,r=n;for(;r;){let e=r.prevDep;-1===r.version?(r===n&&(n=e),eO(r),function(e){let{prevDep:t,nextDep:n}=e;t&&(t.nextDep=n,e.prevDep=void 0),n&&(n.prevDep=t,e.nextDep=void 0)}(r)):t=r,r.dep.activeLink=r.prevActiveLink,r.prevActiveLink=void 0,r=e}e.deps=t,e.depsTail=n}function eI(e){for(let t=e.deps;t;t=t.nextDep)if(t.dep.version!==t.version||t.dep.computed&&(eR(t.dep.computed)||t.dep.version!==t.version))return!0;return!!e._dirty}function eR(e){if(4&e.flags&&!(16&e.flags)||(e.flags&=-17,e.globalVersion===eF))return;e.globalVersion=eF;let t=e.dep;if(e.flags|=2,t.version>0&&!e.isSSR&&e.deps&&!eI(e)){e.flags&=-3;return}let n=l,r=eP;l=e,eP=!0;try{eA(e);let n=e.fn(e._value);(0===t.version||Z(n,e._value))&&(e._value=n,t.version++)}catch(e){throw t.version++,e}finally{l=n,eP=r,eE(e),e.flags&=-3}}function eO(e,t=!1){let{dep:n,prevSub:r,nextSub:i}=e;if(r&&(r.nextSub=i,e.prevSub=void 0),i&&(i.prevSub=r,e.nextSub=void 0),n.subs===e&&(n.subs=r,!r&&n.computed)){n.computed.flags&=-5;for(let e=n.computed.deps;e;e=e.nextDep)eO(e,!0)}t||--n.sc||!n.map||n.map.delete(n.key)}let eP=!0,eM=[];function eL(){eM.push(eP),eP=!1}function e$(){let e=eM.pop();eP=void 0===e||e}function eD(e){let{cleanup:t}=e;if(e.cleanup=void 0,t){let e=l;l=void 0;try{t()}finally{l=e}}}let eF=0;class eV{constructor(e,t){this.sub=e,this.dep=t,this.version=t.version,this.nextDep=this.prevDep=this.nextSub=this.prevSub=this.prevActiveLink=void 0}}class eB{constructor(e){this.computed=e,this.version=0,this.activeLink=void 0,this.subs=void 0,this.map=void 0,this.key=void 0,this.sc=0}track(e){if(!l||!eP||l===this.computed)return;let t=this.activeLink;if(void 0===t||t.sub!==l)t=this.activeLink=new eV(l,this),l.deps?(t.prevDep=l.depsTail,l.depsTail.nextDep=t,l.depsTail=t):l.deps=l.depsTail=t,function e(t){if(t.dep.sc++,4&t.sub.flags){let n=t.dep.computed;if(n&&!t.dep.subs){n.flags|=20;for(let t=n.deps;t;t=t.nextDep)e(t)}let r=t.dep.subs;r!==t&&(t.prevSub=r,r&&(r.nextSub=t)),t.dep.subs=t}}(t);else if(-1===t.version&&(t.version=this.version,t.nextDep)){let e=t.nextDep;e.prevDep=t.prevDep,t.prevDep&&(t.prevDep.nextDep=e),t.prevDep=l.depsTail,t.nextDep=void 0,l.depsTail.nextDep=t,l.depsTail=t,l.deps===t&&(l.deps=e)}return t}trigger(e){this.version++,eF++,this.notify(e)}notify(e){eT++;try{for(let e=this.subs;e;e=e.prevSub)e.sub.notify()&&e.sub.dep.notify()}finally{ew()}}}let eU=/* @__PURE__ */new WeakMap,ej=Symbol(""),eH=Symbol(""),eq=Symbol("");function eW(e,t,n){if(eP&&l){let t=eU.get(e);t||eU.set(e,t=/* @__PURE__ */new Map);let r=t.get(n);r||(t.set(n,r=new eB),r.map=t,r.key=n),r.track()}}function eK(e,t,n,r,i,l){let s=eU.get(e);if(!s){eF++;return}let o=e=>{e&&e.trigger()};if(eT++,"clear"===t)s.forEach(o);else{let i=A(e),l=i&&j(n);if(i&&"length"===n){let e=Number(r);s.forEach((t,n)=>{("length"===n||n===eq||!L(n)&&n>=e)&&o(t)})}else switch((void 0!==n||s.has(void 0))&&o(s.get(n)),l&&o(s.get(eq)),t){case"add":i?l&&o(s.get("length")):(o(s.get(ej)),E(e)&&o(s.get(eH)));break;case"delete":!i&&(o(s.get(ej)),E(e)&&o(s.get(eH)));break;case"set":E(e)&&o(s.get(ej))}}ew()}function ez(e){let t=tx(e);return t===e?t:(eW(t,"iterate",eq),t_(e)?t:t.map(tk))}function eJ(e){return eW(e=tx(e),"iterate",eq),e}let eG={__proto__:null,[Symbol.iterator](){return eX(this,Symbol.iterator,tk)},concat(...e){return ez(this).concat(...e.map(e=>A(e)?ez(e):e))},entries(){return eX(this,"entries",e=>(e[1]=tk(e[1]),e))},every(e,t){return eZ(this,"every",e,t,void 0,arguments)},filter(e,t){return eZ(this,"filter",e,t,e=>e.map(tk),arguments)},find(e,t){return eZ(this,"find",e,t,tk,arguments)},findIndex(e,t){return eZ(this,"findIndex",e,t,void 0,arguments)},findLast(e,t){return eZ(this,"findLast",e,t,tk,arguments)},findLastIndex(e,t){return eZ(this,"findLastIndex",e,t,void 0,arguments)},forEach(e,t){return eZ(this,"forEach",e,t,void 0,arguments)},includes(...e){return e0(this,"includes",e)},indexOf(...e){return e0(this,"indexOf",e)},join(e){return ez(this).join(e)},lastIndexOf(...e){return e0(this,"lastIndexOf",e)},map(e,t){return eZ(this,"map",e,t,void 0,arguments)},pop(){return e1(this,"pop")},push(...e){return e1(this,"push",e)},reduce(e,...t){return eY(this,"reduce",e,t)},reduceRight(e,...t){return eY(this,"reduceRight",e,t)},shift(){return e1(this,"shift")},some(e,t){return eZ(this,"some",e,t,void 0,arguments)},splice(...e){return e1(this,"splice",e)},toReversed(){return ez(this).toReversed()},toSorted(e){return ez(this).toSorted(e)},toSpliced(...e){return ez(this).toSpliced(...e)},unshift(...e){return e1(this,"unshift",e)},values(){return eX(this,"values",tk)}};function eX(e,t,n){let r=eJ(e),i=r[t]();return r===e||t_(e)||(i._next=i.next,i.next=()=>{let e=i._next();return e.value&&(e.value=n(e.value)),e}),i}let eQ=Array.prototype;function eZ(e,t,n,r,i,l){let s=eJ(e),o=s!==e&&!t_(e),a=s[t];if(a!==eQ[t]){let t=a.apply(e,l);return o?tk(t):t}let c=n;s!==e&&(o?c=function(t,r){return n.call(this,tk(t),r,e)}:n.length>2&&(c=function(t,r){return n.call(this,t,r,e)}));let u=a.call(s,c,r);return o&&i?i(u):u}function eY(e,t,n,r){let i=eJ(e),l=n;return i!==e&&(t_(e)?n.length>3&&(l=function(t,r,i){return n.call(this,t,r,i,e)}):l=function(t,r,i){return n.call(this,t,tk(r),i,e)}),i[t](l,...r)}function e0(e,t,n){let r=tx(e);eW(r,"iterate",eq);let i=r[t](...n);return(-1===i||!1===i)&&tS(n[0])?(n[0]=tx(n[0]),r[t](...n)):i}function e1(e,t,n=[]){eL(),eT++;let r=tx(e)[t].apply(e,n);return ew(),e$(),r}let e2=/* @__PURE__ */g("__proto__,__v_isRef,__isVue"),e6=new Set(/* @__PURE__ */Object.getOwnPropertyNames(Symbol).filter(e=>"arguments"!==e&&"caller"!==e).map(e=>Symbol[e]).filter(L));function e3(e){L(e)||(e=String(e));let t=tx(this);return eW(t,"has",e),t.hasOwnProperty(e)}class e4{constructor(e=!1,t=!1){this._isReadonly=e,this._isShallow=t}get(e,t,n){let r=this._isReadonly,i=this._isShallow;if("__v_isReactive"===t)return!r;if("__v_isReadonly"===t)return r;if("__v_isShallow"===t)return i;if("__v_raw"===t)return n===(r?i?tf:tp:i?td:tu).get(e)||Object.getPrototypeOf(e)===Object.getPrototypeOf(n)?e:void 0;let l=A(e);if(!r){let e;if(l&&(e=eG[t]))return e;if("hasOwnProperty"===t)return e3}let s=Reflect.get(e,t,tN(e)?e:n);return(L(t)?e6.has(t):e2(t))?s:(r||eW(e,"get",t),i)?s:tN(s)?l&&j(t)?s:s.value:$(s)?r?tg(s):th(s):s}}class e8 extends e4{constructor(e=!1){super(!1,e)}set(e,t,n,r){let i=e[t];if(!this._isShallow){let t=tb(i);if(t_(n)||tb(n)||(i=tx(i),n=tx(n)),!A(e)&&tN(i)&&!tN(n))return!t&&(i.value=n,!0)}let l=A(e)&&j(t)?Number(t)<e.length:w(e,t),s=Reflect.set(e,t,n,tN(e)?e:r);return e===tx(r)&&(l?Z(n,i)&&eK(e,"set",t,n):eK(e,"add",t,n)),s}deleteProperty(e,t){let n=w(e,t);e[t];let r=Reflect.deleteProperty(e,t);return r&&n&&eK(e,"delete",t,void 0),r}has(e,t){let n=Reflect.has(e,t);return L(t)&&e6.has(t)||eW(e,"has",t),n}ownKeys(e){return eW(e,"iterate",A(e)?"length":ej),Reflect.ownKeys(e)}}class e5 extends e4{constructor(e=!1){super(!0,e)}set(e,t){return!0}deleteProperty(e,t){return!0}}let e9=/* @__PURE__ */new e8,e7=/* @__PURE__ */new e5,te=/* @__PURE__ */new e8(!0),tt=/* @__PURE__ */new e5(!0),tn=e=>e,tr=e=>Reflect.getPrototypeOf(e);function ti(e){return function(...t){return"delete"!==e&&("clear"===e?void 0:this)}}function tl(e,t){let n=function(e,t){let n={get(n){let r=this.__v_raw,i=tx(r),l=tx(n);e||(Z(n,l)&&eW(i,"get",n),eW(i,"get",l));let{has:s}=tr(i),o=t?tn:e?tT:tk;return s.call(i,n)?o(r.get(n)):s.call(i,l)?o(r.get(l)):void(r!==i&&r.get(n))},get size(){let t=this.__v_raw;return e||eW(tx(t),"iterate",ej),Reflect.get(t,"size",t)},has(t){let n=this.__v_raw,r=tx(n),i=tx(t);return e||(Z(t,i)&&eW(r,"has",t),eW(r,"has",i)),t===i?n.has(t):n.has(t)||n.has(i)},forEach(n,r){let i=this,l=i.__v_raw,s=tx(l),o=t?tn:e?tT:tk;return e||eW(s,"iterate",ej),l.forEach((e,t)=>n.call(r,o(e),o(t),i))}};return k(n,e?{add:ti("add"),set:ti("set"),delete:ti("delete"),clear:ti("clear")}:{add(e){t||t_(e)||tb(e)||(e=tx(e));let n=tx(this);return tr(n).has.call(n,e)||(n.add(e),eK(n,"add",e,e)),this},set(e,n){t||t_(n)||tb(n)||(n=tx(n));let r=tx(this),{has:i,get:l}=tr(r),s=i.call(r,e);s||(e=tx(e),s=i.call(r,e));let o=l.call(r,e);return r.set(e,n),s?Z(n,o)&&eK(r,"set",e,n):eK(r,"add",e,n),this},delete(e){let t=tx(this),{has:n,get:r}=tr(t),i=n.call(t,e);i||(e=tx(e),i=n.call(t,e)),r&&r.call(t,e);let l=t.delete(e);return i&&eK(t,"delete",e,void 0),l},clear(){let e=tx(this),t=0!==e.size,n=e.clear();return t&&eK(e,"clear",void 0,void 0),n}}),["keys","values","entries",Symbol.iterator].forEach(r=>{n[r]=function(...n){let i=this.__v_raw,l=tx(i),s=E(l),o="entries"===r||r===Symbol.iterator&&s,a=i[r](...n),c=t?tn:e?tT:tk;return e||eW(l,"iterate","keys"===r&&s?eH:ej),{next(){let{value:e,done:t}=a.next();return t?{value:e,done:t}:{value:o?[c(e[0]),c(e[1])]:c(e),done:t}},[Symbol.iterator](){return this}}}}),n}(e,t);return(t,r,i)=>"__v_isReactive"===r?!e:"__v_isReadonly"===r?e:"__v_raw"===r?t:Reflect.get(w(n,r)&&r in t?n:t,r,i)}let ts={get:/* @__PURE__ */tl(!1,!1)},to={get:/* @__PURE__ */tl(!1,!0)},ta={get:/* @__PURE__ */tl(!0,!1)},tc={get:/* @__PURE__ */tl(!0,!0)},tu=/* @__PURE__ */new WeakMap,td=/* @__PURE__ */new WeakMap,tp=/* @__PURE__ */new WeakMap,tf=/* @__PURE__ */new WeakMap;function th(e){return tb(e)?e:ty(e,!1,e9,ts,tu)}function tm(e){return ty(e,!1,te,to,td)}function tg(e){return ty(e,!0,e7,ta,tp)}function ty(e,t,n,r,i){if(!$(e)||e.__v_raw&&!(t&&e.__v_isReactive))return e;let l=i.get(e);if(l)return l;let s=e.__v_skip||!Object.isExtensible(e)?0:function(e){switch(e){case"Object":case"Array":return 1;case"Map":case"Set":case"WeakMap":case"WeakSet":return 2;default:return 0}}(B(e));if(0===s)return e;let o=new Proxy(e,2===s?r:n);return i.set(e,o),o}function tv(e){return tb(e)?tv(e.__v_raw):!!(e&&e.__v_isReactive)}function tb(e){return!!(e&&e.__v_isReadonly)}function t_(e){return!!(e&&e.__v_isShallow)}function tS(e){return!!e&&!!e.__v_raw}function tx(e){let t=e&&e.__v_raw;return t?tx(t):e}function tC(e){return!w(e,"__v_skip")&&Object.isExtensible(e)&&ee(e,"__v_skip",!0),e}let tk=e=>$(e)?th(e):e,tT=e=>$(e)?tg(e):e;function tN(e){return!!e&&!0===e.__v_isRef}function tw(e){return tE(e,!1)}function tA(e){return tE(e,!0)}function tE(e,t){return tN(e)?e:new tI(e,t)}class tI{constructor(e,t){this.dep=new eB,this.__v_isRef=!0,this.__v_isShallow=!1,this._rawValue=t?e:tx(e),this._value=t?e:tk(e),this.__v_isShallow=t}get value(){return this.dep.track(),this._value}set value(e){let t=this._rawValue,n=this.__v_isShallow||t_(e)||tb(e);Z(e=n?e:tx(e),t)&&(this._rawValue=e,this._value=n?e:tk(e),this.dep.trigger())}}function tR(e){return tN(e)?e.value:e}let tO={get:(e,t,n)=>"__v_raw"===t?e:tR(Reflect.get(e,t,n)),set:(e,t,n,r)=>{let i=e[t];return tN(i)&&!tN(n)?(i.value=n,!0):Reflect.set(e,t,n,r)}};function tP(e){return tv(e)?e:new Proxy(e,tO)}class tM{constructor(e){this.__v_isRef=!0,this._value=void 0;let t=this.dep=new eB,{get:n,set:r}=e(t.track.bind(t),t.trigger.bind(t));this._get=n,this._set=r}get value(){return this._value=this._get()}set value(e){this._set(e)}}function tL(e){return new tM(e)}class t${constructor(e,t,n){this._object=e,this._key=t,this._defaultValue=n,this.__v_isRef=!0,this._value=void 0}get value(){let e=this._object[this._key];return this._value=void 0===e?this._defaultValue:e}set value(e){this._object[this._key]=e}get dep(){return function(e,t){let n=eU.get(e);return n&&n.get(t)}(tx(this._object),this._key)}}class tD{constructor(e){this._getter=e,this.__v_isRef=!0,this.__v_isReadonly=!0,this._value=void 0}get value(){return this._value=this._getter()}}function tF(e,t,n){let r=e[t];return tN(r)?r:new t$(e,t,n)}class tV{constructor(e,t,n){this.fn=e,this.setter=t,this._value=void 0,this.dep=new eB(this),this.__v_isRef=!0,this.deps=void 0,this.depsTail=void 0,this.flags=16,this.globalVersion=eF-1,this.next=void 0,this.effect=this,this.__v_isReadonly=!t,this.isSSR=n}notify(){if(this.flags|=16,!(8&this.flags)&&l!==this)return eN(this,!0),!0}get value(){let e=this.dep.track();return eR(this),e&&(e.version=this.dep.version),this._value}set value(e){this.setter&&this.setter(e)}}let tB={},tU=/* @__PURE__ */new WeakMap;function tj(e,t=!1,n=h){if(n){let t=tU.get(n);t||tU.set(n,t=[]),t.push(e)}}function tH(e,t=1/0,n){if(t<=0||!$(e)||e.__v_skip||(n=n||/* @__PURE__ */new Set).has(e))return e;if(n.add(e),t--,tN(e))tH(e.value,t,n);else if(A(e))for(let r=0;r<e.length;r++)tH(e[r],t,n);else if(I(e)||E(e))e.forEach(e=>{tH(e,t,n)});else if(U(e)){for(let r in e)tH(e[r],t,n);for(let r of Object.getOwnPropertySymbols(e))Object.prototype.propertyIsEnumerable.call(e,r)&&tH(e[r],t,n)}return e}function tq(e,t,n,r){try{return r?e(...r):e()}catch(e){tK(e,t,n)}}function tW(e,t,n,r){if(P(e)){let i=tq(e,t,n,r);return i&&D(i)&&i.catch(e=>{tK(e,t,n)}),i}if(A(e)){let i=[];for(let l=0;l<e.length;l++)i.push(tW(e[l],t,n,r));return i}}function tK(e,t,n,r=!0){t&&t.vnode;let{errorHandler:i,throwUnhandledErrorInProduction:l}=t&&t.appContext.config||y;if(t){let r=t.parent,l=t.proxy,s=`https://vuejs.org/error-reference/#runtime-${n}`;for(;r;){let t=r.ec;if(t){for(let n=0;n<t.length;n++)if(!1===t[n](e,l,s))return}r=r.parent}if(i){eL(),tq(i,null,10,[e,l,s]),e$();return}}!function(e,t,n,r=!0,i=!1){if(i)throw e;console.error(e)}(e,0,0,r,l)}let tz=[],tJ=-1,tG=[],tX=null,tQ=0,tZ=/* @__PURE__ */Promise.resolve(),tY=null;function t0(e){let t=tY||tZ;return e?t.then(this?e.bind(this):e):t}function t1(e){if(!(1&e.flags)){let t=t8(e),n=tz[tz.length-1];!n||!(2&e.flags)&&t>=t8(n)?tz.push(e):tz.splice(function(e){let t=tJ+1,n=tz.length;for(;t<n;){let r=t+n>>>1,i=tz[r],l=t8(i);l<e||l===e&&2&i.flags?t=r+1:n=r}return t}(t),0,e),e.flags|=1,t2()}}function t2(){tY||(tY=tZ.then(function e(t){try{for(tJ=0;tJ<tz.length;tJ++){let e=tz[tJ];!e||8&e.flags||(4&e.flags&&(e.flags&=-2),tq(e,e.i,e.i?15:14),4&e.flags||(e.flags&=-2))}}finally{for(;tJ<tz.length;tJ++){let e=tz[tJ];e&&(e.flags&=-2)}tJ=-1,tz.length=0,t4(),tY=null,(tz.length||tG.length)&&e()}}))}function t6(e){A(e)?tG.push(...e):tX&&-1===e.id?tX.splice(tQ+1,0,e):1&e.flags||(tG.push(e),e.flags|=1),t2()}function t3(e,t,n=tJ+1){for(;n<tz.length;n++){let t=tz[n];if(t&&2&t.flags){if(e&&t.id!==e.uid)continue;tz.splice(n,1),n--,4&t.flags&&(t.flags&=-2),t(),4&t.flags||(t.flags&=-2)}}}function t4(e){if(tG.length){let e=[...new Set(tG)].sort((e,t)=>t8(e)-t8(t));if(tG.length=0,tX){tX.push(...e);return}for(tQ=0,tX=e;tQ<tX.length;tQ++){let e=tX[tQ];4&e.flags&&(e.flags&=-2),8&e.flags||e(),e.flags&=-2}tX=null,tQ=0}}let t8=e=>null==e.id?2&e.flags?-1:1/0:e.id,t5=null,t9=null;function t7(e){let t=t5;return t5=e,t9=e&&e.type.__scopeId||null,t}function ne(e,t=t5,n){if(!t||e._n)return e;let r=(...n)=>{let i;r._d&&im(-1);let l=t7(t);try{i=e(...n)}finally{t7(l),r._d&&im(1)}return i};return r._n=!0,r._c=!0,r._d=!0,r}function nt(e,t,n,r){let i=e.dirs,l=t&&t.dirs;for(let s=0;s<i.length;s++){let o=i[s];l&&(o.oldValue=l[s].value);let a=o.dir[r];a&&(eL(),tW(a,n,8,[e.el,o,e,t]),e$())}}let nn=Symbol("_vte"),nr=e=>e.__isTeleport,ni=e=>e&&(e.disabled||""===e.disabled),nl=e=>e&&(e.defer||""===e.defer),ns=e=>"undefined"!=typeof SVGElement&&e instanceof SVGElement,no=e=>"function"==typeof MathMLElement&&e instanceof MathMLElement,na=(e,t)=>{let n=e&&e.to;return M(n)?t?t(n):null:n};function nc(e,t,n,{o:{insert:r},m:i},l=2){0===l&&r(e.targetAnchor,t,n);let{el:s,anchor:o,shapeFlag:a,children:c,props:u}=e,d=2===l;if(d&&r(s,t,n),(!d||ni(u))&&16&a)for(let e=0;e<c.length;e++)i(c[e],t,n,2);d&&r(o,t,n)}function nu(e,t){let n=e.ctx;if(n&&n.ut){let r,i;for(t?(r=e.el,i=e.anchor):(r=e.targetStart,i=e.targetAnchor);r&&r!==i;)1===r.nodeType&&r.setAttribute("data-v-owner",n.uid),r=r.nextSibling;n.ut()}}function nd(e,t,n,r){let i=t.targetStart=n(""),l=t.targetAnchor=n("");return i[nn]=l,e&&(r(i,e),r(l,e)),l}let np=Symbol("_leaveCb"),nf=Symbol("_enterCb");function nh(){let e={isMounted:!1,isLeaving:!1,isUnmounting:!1,leavingVNodes:/* @__PURE__ */new Map};return nY(()=>{e.isMounted=!0}),n2(()=>{e.isUnmounting=!0}),e}let nm=[Function,Array],ng={mode:String,appear:Boolean,persisted:Boolean,onBeforeEnter:nm,onEnter:nm,onAfterEnter:nm,onEnterCancelled:nm,onBeforeLeave:nm,onLeave:nm,onAfterLeave:nm,onLeaveCancelled:nm,onBeforeAppear:nm,onAppear:nm,onAfterAppear:nm,onAppearCancelled:nm},ny=e=>{let t=e.subTree;return t.component?ny(t.component):t};function nv(e){let t=e[0];if(e.length>1){for(let n of e)if(n.type!==io){t=n;break}}return t}let nb={name:"BaseTransition",props:ng,setup(e,{slots:t}){let n=iL(),r=nh();return()=>{let i=t.default&&nT(t.default(),!0);if(!i||!i.length)return;let l=nv(i),s=tx(e),{mode:o}=s;if(r.isLeaving)return nx(l);let a=nC(l);if(!a)return nx(l);let c=nS(a,s,r,n,e=>c=e);a.type!==io&&nk(a,c);let u=n.subTree,d=u&&nC(u);if(d&&d.type!==io&&!ib(a,d)&&ny(n).type!==io){let e=nS(d,s,r,n);if(nk(d,e),"out-in"===o&&a.type!==io)return r.isLeaving=!0,e.afterLeave=()=>{r.isLeaving=!1,8&n.job.flags||n.update(),delete e.afterLeave},nx(l);"in-out"===o&&a.type!==io&&(e.delayLeave=(e,t,n)=>{n_(r,d)[String(d.key)]=d,e[np]=()=>{t(),e[np]=void 0,delete c.delayedLeave},c.delayedLeave=n})}return l}}};function n_(e,t){let{leavingVNodes:n}=e,r=n.get(t.type);return r||(r=/* @__PURE__ */Object.create(null),n.set(t.type,r)),r}function nS(e,t,n,r,i){let{appear:l,mode:s,persisted:o=!1,onBeforeEnter:a,onEnter:c,onAfterEnter:u,onEnterCancelled:d,onBeforeLeave:p,onLeave:f,onAfterLeave:h,onLeaveCancelled:m,onBeforeAppear:g,onAppear:y,onAfterAppear:b,onAppearCancelled:_}=t,S=String(e.key),x=n_(n,e),C=(e,t)=>{e&&tW(e,r,9,t)},k=(e,t)=>{let n=t[1];C(e,t),A(e)?e.every(e=>e.length<=1)&&n():e.length<=1&&n()},T={mode:s,persisted:o,beforeEnter(t){let r=a;if(!n.isMounted){if(!l)return;r=g||a}t[np]&&t[np](!0);let i=x[S];i&&ib(e,i)&&i.el[np]&&i.el[np](),C(r,[t])},enter(e){let t=c,r=u,i=d;if(!n.isMounted){if(!l)return;t=y||c,r=b||u,i=_||d}let s=!1,o=e[nf]=t=>{s||(s=!0,t?C(i,[e]):C(r,[e]),T.delayedLeave&&T.delayedLeave(),e[nf]=void 0)};t?k(t,[e,o]):o()},leave(t,r){let i=String(e.key);if(t[nf]&&t[nf](!0),n.isUnmounting)return r();C(p,[t]);let l=!1,s=t[np]=n=>{l||(l=!0,r(),n?C(m,[t]):C(h,[t]),t[np]=void 0,x[i]!==e||delete x[i])};x[i]=e,f?k(f,[t,s]):s()},clone(e){let l=nS(e,t,n,r,i);return i&&i(l),l}};return T}function nx(e){if(nH(e))return(e=iT(e)).children=null,e}function nC(e){if(!nH(e))return nr(e.type)&&e.children?nv(e.children):e;let{shapeFlag:t,children:n}=e;if(n){if(16&t)return n[0];if(32&t&&P(n.default))return n.default()}}function nk(e,t){6&e.shapeFlag&&e.component?(e.transition=t,nk(e.component.subTree,t)):128&e.shapeFlag?(e.ssContent.transition=t.clone(e.ssContent),e.ssFallback.transition=t.clone(e.ssFallback)):e.transition=t}function nT(e,t=!1,n){let r=[],i=0;for(let l=0;l<e.length;l++){let s=e[l],o=null==n?s.key:String(n)+String(null!=s.key?s.key:l);s.type===il?(128&s.patchFlag&&i++,r=r.concat(nT(s.children,t,o))):(t||s.type!==io)&&r.push(null!=o?iT(s,{key:o}):s)}if(i>1)for(let e=0;e<r.length;e++)r[e].patchFlag=-2;return r}/*! #__NO_SIDE_EFFECTS__ */function nN(e,t){return P(e)?k({name:e.name},t,{setup:e}):e}function nw(e){e.ids=[e.ids[0]+e.ids[2]+++"-",0,0]}function nA(e,t,n,r,i=!1){if(A(e)){e.forEach((e,l)=>nA(e,t&&(A(t)?t[l]:t),n,r,i));return}if(nU(r)&&!i)return;let l=4&r.shapeFlag?iW(r.component):r.el,s=i?null:l,{i:o,r:a}=e,c=t&&t.r,u=o.refs===y?o.refs={}:o.refs,d=o.setupState,p=tx(d),f=d===y?()=>!1:e=>w(p,e);if(null!=c&&c!==a&&(M(c)?(u[c]=null,f(c)&&(d[c]=null)):tN(c)&&(c.value=null)),P(a))tq(a,o,12,[s,u]);else{let t=M(a),r=tN(a);if(t||r){let o=()=>{if(e.f){let n=t?f(a)?d[a]:u[a]:a.value;i?A(n)&&T(n,l):A(n)?n.includes(l)||n.push(l):t?(u[a]=[l],f(a)&&(d[a]=u[a])):(a.value=[l],e.k&&(u[e.k]=a.value))}else t?(u[a]=s,f(a)&&(d[a]=s)):r&&(a.value=s,e.k&&(u[e.k]=s))};s?(o.id=-1,rV(o,n)):o()}}}let nE=!1,nI=()=>{nE||(console.error("Hydration completed but contains mismatches."),nE=!0)},nR=e=>e.namespaceURI.includes("svg")&&"foreignObject"!==e.tagName,nO=e=>e.namespaceURI.includes("MathML"),nP=e=>{if(1===e.nodeType){if(nR(e))return"svg";if(nO(e))return"mathml"}},nM=e=>8===e.nodeType;function nL(e){let{mt:t,p:n,o:{patchProp:r,createText:i,nextSibling:l,parentNode:s,remove:o,insert:a,createComment:c}}=e,u=(n,r,o,c,b,_=!1)=>{_=_||!!r.dynamicChildren;let S=nM(n)&&"["===n.data,x=()=>h(n,r,o,c,b,S),{type:C,ref:k,shapeFlag:T,patchFlag:N}=r,w=n.nodeType;r.el=n,-2===N&&(_=!1,r.dynamicChildren=null);let A=null;switch(C){case is:3!==w?""===r.children?(a(r.el=i(""),s(n),n),A=n):A=x():(n.data!==r.children&&(nI(),n.data=r.children),A=l(n));break;case io:y(n)?(A=l(n),g(r.el=n.content.firstChild,n,o)):A=8!==w||S?x():l(n);break;case ia:if(S&&(w=(n=l(n)).nodeType),1===w||3===w){A=n;let e=!r.children.length;for(let t=0;t<r.staticCount;t++)e&&(r.children+=1===A.nodeType?A.outerHTML:A.data),t===r.staticCount-1&&(r.anchor=A),A=l(A);return S?l(A):A}x();break;case il:A=S?f(n,r,o,c,b,_):x();break;default:if(1&T)A=1===w&&r.type.toLowerCase()===n.tagName.toLowerCase()||y(n)?d(n,r,o,c,b,_):x();else if(6&T){r.slotScopeIds=b;let e=s(n);if(A=S?m(n):nM(n)&&"teleport start"===n.data?m(n,n.data,"teleport end"):l(n),t(r,e,null,o,c,nP(e),_),nU(r)){let t;S?(t=iC(il)).anchor=A?A.previousSibling:e.lastChild:t=3===n.nodeType?iN(""):iC("div"),t.el=n,r.component.subTree=t}}else 64&T?A=8!==w?x():r.type.hydrate(n,r,o,c,b,_,e,p):128&T&&(A=r.type.hydrate(n,r,o,c,nP(s(n)),b,_,e,u))}return null!=k&&nA(k,null,c,r),A},d=(e,t,n,i,l,s)=>{s=s||!!t.dynamicChildren;let{type:a,props:c,patchFlag:u,shapeFlag:d,dirs:f,transition:h}=t,m="input"===a||"option"===a;if(m||-1!==u){let a;f&&nt(t,null,n,"created");let b=!1;if(y(e)){b=rq(null,h)&&n&&n.vnode.props&&n.vnode.props.appear;let r=e.content.firstChild;b&&h.beforeEnter(r),g(r,e,n),t.el=e=r}if(16&d&&!(c&&(c.innerHTML||c.textContent))){let r=p(e.firstChild,t,e,n,i,l,s);for(;r;){nF(e,1)||nI();let t=r;r=r.nextSibling,o(t)}}else if(8&d){let n=t.children;"\n"===n[0]&&("PRE"===e.tagName||"TEXTAREA"===e.tagName)&&(n=n.slice(1)),e.textContent!==n&&(nF(e,0)||nI(),e.textContent=t.children)}if(c){if(m||!s||48&u){let t=e.tagName.includes("-");for(let i in c)(m&&(i.endsWith("value")||"indeterminate"===i)||x(i)&&!H(i)||"."===i[0]||t)&&r(e,i,null,c[i],void 0,n)}else if(c.onClick)r(e,"onClick",null,c.onClick,void 0,n);else if(4&u&&tv(c.style))for(let e in c.style)c.style[e]}(a=c&&c.onVnodeBeforeMount)&&iR(a,n,t),f&&nt(t,null,n,"beforeMount"),((a=c&&c.onVnodeMounted)||f||b)&&ir(()=>{a&&iR(a,n,t),b&&h.enter(e),f&&nt(t,null,n,"mounted")},i)}return e.nextSibling},p=(e,t,r,s,o,c,d)=>{d=d||!!t.dynamicChildren;let p=t.children,f=p.length;for(let t=0;t<f;t++){let h=d?p[t]:p[t]=iw(p[t]),m=h.type===is;e?(m&&!d&&t+1<f&&iw(p[t+1]).type===is&&(a(i(e.data.slice(h.children.length)),r,l(e)),e.data=h.children),e=u(e,h,s,o,c,d)):m&&!h.children?a(h.el=i(""),r):(nF(r,1)||nI(),n(null,h,r,null,s,o,nP(r),c))}return e},f=(e,t,n,r,i,o)=>{let{slotScopeIds:u}=t;u&&(i=i?i.concat(u):u);let d=s(e),f=p(l(e),t,d,n,r,i,o);return f&&nM(f)&&"]"===f.data?l(t.anchor=f):(nI(),a(t.anchor=c("]"),d,f),f)},h=(e,t,r,i,a,c)=>{if(nF(e.parentElement,1)||nI(),t.el=null,c){let t=m(e);for(;;){let n=l(e);if(n&&n!==t)o(n);else break}}let u=l(e),d=s(e);return o(e),n(null,t,d,u,r,i,nP(d),a),u},m=(e,t="[",n="]")=>{let r=0;for(;e;)if((e=l(e))&&nM(e)&&(e.data===t&&r++,e.data===n)){if(0===r)return l(e);r--}return e},g=(e,t,n)=>{let r=t.parentNode;r&&r.replaceChild(e,t);let i=n;for(;i;)i.vnode.el===t&&(i.vnode.el=i.subTree.el=e),i=i.parent},y=e=>1===e.nodeType&&"TEMPLATE"===e.tagName;return[(e,t)=>{if(!t.hasChildNodes()){n(null,e,t),t4(),t._vnode=e;return}u(t.firstChild,e,null,null,null),t4(),t._vnode=e},u]}let n$="data-allow-mismatch",nD={0:"text",1:"children",2:"class",3:"style",4:"attribute"};function nF(e,t){if(0===t||1===t)for(;e&&!e.hasAttribute(n$);)e=e.parentElement;let n=e&&e.getAttribute(n$);if(null==n)return!1;if(""===n)return!0;{let e=n.split(",");return!!(0===t&&e.includes("children"))||n.split(",").includes(nD[t])}}let nV=er().requestIdleCallback||(e=>setTimeout(e,1)),nB=er().cancelIdleCallback||(e=>clearTimeout(e)),nU=e=>!!e.type.__asyncLoader;function nj(e,t){let{ref:n,props:r,children:i,ce:l}=t.vnode,s=iC(e,r,i);return s.ref=n,s.ce=l,delete t.vnode.ce,s}let nH=e=>e.type.__isKeepAlive;function nq(e,t){return A(e)?e.some(e=>nq(e,t)):M(e)?e.split(",").includes(t):!!O(e)&&(e.lastIndex=0,e.test(t))}function nW(e,t){nz(e,"a",t)}function nK(e,t){nz(e,"da",t)}function nz(e,t,n=iM){let r=e.__wdc||(e.__wdc=()=>{let t=n;for(;t;){if(t.isDeactivated)return;t=t.parent}return e()});if(nX(t,r,n),n){let e=n.parent;for(;e&&e.parent;)nH(e.parent.vnode)&&function(e,t,n,r){let i=nX(t,e,r,!0);n6(()=>{T(r[t],i)},n)}(r,t,n,e),e=e.parent}}function nJ(e){e.shapeFlag&=-257,e.shapeFlag&=-513}function nG(e){return 128&e.shapeFlag?e.ssContent:e}function nX(e,t,n=iM,r=!1){if(n){let i=n[e]||(n[e]=[]),l=t.__weh||(t.__weh=(...r)=>{eL();let i=i$(n),l=tW(t,n,e,r);return i(),e$(),l});return r?i.unshift(l):i.push(l),l}}let nQ=e=>(t,n=iM)=>{iV&&"sp"!==e||nX(e,(...e)=>t(...e),n)},nZ=nQ("bm"),nY=nQ("m"),n0=nQ("bu"),n1=nQ("u"),n2=nQ("bum"),n6=nQ("um"),n3=nQ("sp"),n4=nQ("rtg"),n8=nQ("rtc");function n5(e,t=iM){nX("ec",e,t)}let n9="components",n7=Symbol.for("v-ndc");function re(e,t,n=!0,r=!1){let i=t5||iM;if(i){let n=i.type;if(e===n9){let e=iK(n,!1);if(e&&(e===t||e===z(t)||e===X(z(t))))return n}let l=rt(i[e]||n[e],t)||rt(i.appContext[e],t);return!l&&r?n:l}}function rt(e,t){return e&&(e[t]||e[z(t)]||e[X(z(t))])}let rn=e=>e?iF(e)?iW(e):rn(e.parent):null,rr=/* @__PURE__ */k(/* @__PURE__ */Object.create(null),{$:e=>e,$el:e=>e.vnode.el,$data:e=>e.data,$props:e=>e.props,$attrs:e=>e.attrs,$slots:e=>e.slots,$refs:e=>e.refs,$parent:e=>rn(e.parent),$root:e=>rn(e.root),$host:e=>e.ce,$emit:e=>e.emit,$options:e=>rd(e),$forceUpdate:e=>e.f||(e.f=()=>{t1(e.update)}),$nextTick:e=>e.n||(e.n=t0.bind(e.proxy)),$watch:e=>rQ.bind(e)}),ri=(e,t)=>e!==y&&!e.__isScriptSetup&&w(e,t),rl={get({_:e},t){let n,r,i;if("__v_skip"===t)return!0;let{ctx:l,setupState:s,data:o,props:a,accessCache:c,type:u,appContext:d}=e;if("$"!==t[0]){let r=c[t];if(void 0!==r)switch(r){case 1:return s[t];case 2:return o[t];case 4:return l[t];case 3:return a[t]}else{if(ri(s,t))return c[t]=1,s[t];if(o!==y&&w(o,t))return c[t]=2,o[t];if((n=e.propsOptions[0])&&w(n,t))return c[t]=3,a[t];if(l!==y&&w(l,t))return c[t]=4,l[t];rc&&(c[t]=0)}}let p=rr[t];return p?("$attrs"===t&&eW(e.attrs,"get",""),p(e)):(r=u.__cssModules)&&(r=r[t])?r:l!==y&&w(l,t)?(c[t]=4,l[t]):w(i=d.config.globalProperties,t)?i[t]:void 0},set({_:e},t,n){let{data:r,setupState:i,ctx:l}=e;return ri(i,t)?(i[t]=n,!0):r!==y&&w(r,t)?(r[t]=n,!0):!w(e.props,t)&&!("$"===t[0]&&t.slice(1) in e)&&(l[t]=n,!0)},has({_:{data:e,setupState:t,accessCache:n,ctx:r,appContext:i,propsOptions:l}},s){let o;return!!n[s]||e!==y&&w(e,s)||ri(t,s)||(o=l[0])&&w(o,s)||w(r,s)||w(rr,s)||w(i.config.globalProperties,s)},defineProperty(e,t,n){return null!=n.get?e._.accessCache[t]=0:w(n,"value")&&this.set(e,t,n.value,null),Reflect.defineProperty(e,t,n)}},rs=/* @__PURE__ */k({},rl,{get(e,t){if(t!==Symbol.unscopables)return rl.get(e,t,e)},has:(e,t)=>"_"!==t[0]&&!ei(t)});function ro(){let e=iL();return e.setupContext||(e.setupContext=iq(e))}function ra(e){return A(e)?e.reduce((e,t)=>(e[t]=null,e),{}):e}let rc=!0;function ru(e,t,n){tW(A(e)?e.map(e=>e.bind(t.proxy)):e.bind(t.proxy),t,n)}function rd(e){let t;let n=e.type,{mixins:r,extends:i}=n,{mixins:l,optionsCache:s,config:{optionMergeStrategies:o}}=e.appContext,a=s.get(n);return a?t=a:l.length||r||i?(t={},l.length&&l.forEach(e=>rp(t,e,o,!0)),rp(t,n,o)):t=n,$(n)&&s.set(n,t),t}function rp(e,t,n,r=!1){let{mixins:i,extends:l}=t;for(let s in l&&rp(e,l,n,!0),i&&i.forEach(t=>rp(e,t,n,!0)),t)if(r&&"expose"===s);else{let r=rf[s]||n&&n[s];e[s]=r?r(e[s],t[s]):t[s]}return e}let rf={data:rh,props:rv,emits:rv,methods:ry,computed:ry,beforeCreate:rg,created:rg,beforeMount:rg,mounted:rg,beforeUpdate:rg,updated:rg,beforeDestroy:rg,beforeUnmount:rg,destroyed:rg,unmounted:rg,activated:rg,deactivated:rg,errorCaptured:rg,serverPrefetch:rg,components:ry,directives:ry,watch:function(e,t){if(!e)return t;if(!t)return e;let n=k(/* @__PURE__ */Object.create(null),e);for(let r in t)n[r]=rg(e[r],t[r]);return n},provide:rh,inject:function(e,t){return ry(rm(e),rm(t))}};function rh(e,t){return t?e?function(){return k(P(e)?e.call(this,this):e,P(t)?t.call(this,this):t)}:t:e}function rm(e){if(A(e)){let t={};for(let n=0;n<e.length;n++)t[e[n]]=e[n];return t}return e}function rg(e,t){return e?[...new Set([].concat(e,t))]:t}function ry(e,t){return e?k(/* @__PURE__ */Object.create(null),e,t):t}function rv(e,t){return e?A(e)&&A(t)?[.../* @__PURE__ */new Set([...e,...t])]:k(/* @__PURE__ */Object.create(null),ra(e),ra(null!=t?t:{})):t}function rb(){return{app:null,config:{isNativeTag:S,performance:!1,globalProperties:{},optionMergeStrategies:{},errorHandler:void 0,warnHandler:void 0,compilerOptions:{}},mixins:[],components:{},directives:{},provides:/* @__PURE__ */Object.create(null),optionsCache:/* @__PURE__ */new WeakMap,propsCache:/* @__PURE__ */new WeakMap,emitsCache:/* @__PURE__ */new WeakMap}}let r_=0,rS=null;function rx(e,t){if(iM){let n=iM.provides,r=iM.parent&&iM.parent.provides;r===n&&(n=iM.provides=Object.create(r)),n[e]=t}}function rC(e,t,n=!1){let r=iM||t5;if(r||rS){let i=rS?rS._context.provides:r?null==r.parent?r.vnode.appContext&&r.vnode.appContext.provides:r.parent.provides:void 0;if(i&&e in i)return i[e];if(arguments.length>1)return n&&P(t)?t.call(r&&r.proxy):t}}let rk={},rT=()=>Object.create(rk),rN=e=>Object.getPrototypeOf(e)===rk;function rw(e,t,n,r){let i;let[l,s]=e.propsOptions,o=!1;if(t)for(let a in t){let c;if(H(a))continue;let u=t[a];l&&w(l,c=z(a))?s&&s.includes(c)?(i||(i={}))[c]=u:n[c]=u:r1(e.emitsOptions,a)||a in r&&u===r[a]||(r[a]=u,o=!0)}if(s){let t=tx(n),r=i||y;for(let i=0;i<s.length;i++){let o=s[i];n[o]=rA(l,t,o,r[o],e,!w(r,o))}}return o}function rA(e,t,n,r,i,l){let s=e[n];if(null!=s){let e=w(s,"default");if(e&&void 0===r){let e=s.default;if(s.type!==Function&&!s.skipFactory&&P(e)){let{propsDefaults:l}=i;if(n in l)r=l[n];else{let s=i$(i);r=l[n]=e.call(null,t),s()}}else r=e;i.ce&&i.ce._setProp(n,r)}s[0]&&(l&&!e?r=!1:s[1]&&(""===r||r===G(n))&&(r=!0))}return r}let rE=/* @__PURE__ */new WeakMap;function rI(e){return!("$"===e[0]||H(e))}let rR=e=>"_"===e[0]||"$stable"===e,rO=e=>A(e)?e.map(iw):[iw(e)],rP=(e,t,n)=>{if(t._n)return t;let r=ne((...e)=>rO(t(...e)),n);return r._c=!1,r},rM=(e,t,n)=>{let r=e._ctx;for(let n in e){if(rR(n))continue;let i=e[n];if(P(i))t[n]=rP(n,i,r);else if(null!=i){let e=rO(i);t[n]=()=>e}}},rL=(e,t)=>{let n=rO(t);e.slots.default=()=>n},r$=(e,t,n)=>{for(let r in t)(n||"_"!==r)&&(e[r]=t[r])},rD=(e,t,n)=>{let r=e.slots=rT();if(32&e.vnode.shapeFlag){let e=t._;e?(r$(r,t,n),n&&ee(r,"_",e,!0)):rM(t,r)}else t&&rL(e,t)},rF=(e,t,n)=>{let{vnode:r,slots:i}=e,l=!0,s=y;if(32&r.shapeFlag){let e=t._;e?n&&1===e?l=!1:r$(i,t,n):(l=!t.$stable,rM(t,i)),s=t}else t&&(rL(e,t),s={default:1});if(l)for(let e in i)rR(e)||null!=s[e]||delete i[e]},rV=ir;function rB(e){return rU(e,nL)}function rU(e,t){var n;let r,i;er().__VUE__=!0;let{insert:l,remove:s,patchProp:o,createElement:a,createText:u,createComment:d,setText:p,setElementText:f,parentNode:h,nextSibling:m,setScopeId:g=_,insertStaticContent:S}=e,x=(e,t,n,r=null,i=null,l=null,s,o=null,a=!!t.dynamicChildren)=>{if(e===t)return;e&&!ib(e,t)&&(r=eo(e),et(e,i,l,!0),e=null),-2===t.patchFlag&&(a=!1,t.dynamicChildren=null);let{type:c,ref:u,shapeFlag:d}=t;switch(c){case is:C(e,t,n,r);break;case io:T(e,t,n,r);break;case ia:null==e&&N(t,n,r,s);break;case il:U(e,t,n,r,i,l,s,o,a);break;default:1&d?R(e,t,n,r,i,l,s,o,a):6&d?j(e,t,n,r,i,l,s,o,a):64&d?c.process(e,t,n,r,i,l,s,o,a,eu):128&d&&c.process(e,t,n,r,i,l,s,o,a,eu)}null!=u&&i&&nA(u,e&&e.ref,l,t||e,!t)},C=(e,t,n,r)=>{if(null==e)l(t.el=u(t.children),n,r);else{let n=t.el=e.el;t.children!==e.children&&p(n,t.children)}},T=(e,t,n,r)=>{null==e?l(t.el=d(t.children||""),n,r):t.el=e.el},N=(e,t,n,r)=>{[e.el,e.anchor]=S(e.children,t,n,r,e.el,e.anchor)},E=({el:e,anchor:t},n,r)=>{let i;for(;e&&e!==t;)i=m(e),l(e,n,r),e=i;l(t,n,r)},I=({el:e,anchor:t})=>{let n;for(;e&&e!==t;)n=m(e),s(e),e=n;s(t)},R=(e,t,n,r,i,l,s,o,a)=>{"svg"===t.type?s="svg":"math"===t.type&&(s="mathml"),null==e?O(t,n,r,i,l,s,o,a):F(e,t,i,l,s,o,a)},O=(e,t,n,r,i,s,c,u)=>{let d,p;let{props:h,shapeFlag:m,transition:g,dirs:y}=e;if(d=e.el=a(e.type,s,h&&h.is,h),8&m?f(d,e.children):16&m&&L(e.children,d,null,r,i,rj(e,s),c,u),y&&nt(e,null,r,"created"),M(d,e,e.scopeId,c,r),h){for(let e in h)"value"===e||H(e)||o(d,e,null,h[e],s,r);"value"in h&&o(d,"value",null,h.value,s),(p=h.onVnodeBeforeMount)&&iR(p,r,e)}y&&nt(e,null,r,"beforeMount");let b=rq(i,g);b&&g.beforeEnter(d),l(d,t,n),((p=h&&h.onVnodeMounted)||b||y)&&rV(()=>{p&&iR(p,r,e),b&&g.enter(d),y&&nt(e,null,r,"mounted")},i)},M=(e,t,n,r,i)=>{if(n&&g(e,n),r)for(let t=0;t<r.length;t++)g(e,r[t]);if(i){let n=i.subTree;if(t===n||r5(n.type)&&(n.ssContent===t||n.ssFallback===t)){let t=i.vnode;M(e,t,t.scopeId,t.slotScopeIds,i.parent)}}},L=(e,t,n,r,i,l,s,o,a=0)=>{for(let c=a;c<e.length;c++)x(null,e[c]=o?iA(e[c]):iw(e[c]),t,n,r,i,l,s,o)},F=(e,t,n,r,i,l,s)=>{let a;let c=t.el=e.el,{patchFlag:u,dynamicChildren:d,dirs:p}=t;u|=16&e.patchFlag;let h=e.props||y,m=t.props||y;if(n&&rH(n,!1),(a=m.onVnodeBeforeUpdate)&&iR(a,n,t,e),p&&nt(t,e,n,"beforeUpdate"),n&&rH(n,!0),(h.innerHTML&&null==m.innerHTML||h.textContent&&null==m.textContent)&&f(c,""),d?V(e.dynamicChildren,d,c,n,r,rj(t,i),l):s||X(e,t,c,null,n,r,rj(t,i),l,!1),u>0){if(16&u)B(c,h,m,n,i);else if(2&u&&h.class!==m.class&&o(c,"class",null,m.class,i),4&u&&o(c,"style",h.style,m.style,i),8&u){let e=t.dynamicProps;for(let t=0;t<e.length;t++){let r=e[t],l=h[r],s=m[r];(s!==l||"value"===r)&&o(c,r,l,s,i,n)}}1&u&&e.children!==t.children&&f(c,t.children)}else s||null!=d||B(c,h,m,n,i);((a=m.onVnodeUpdated)||p)&&rV(()=>{a&&iR(a,n,t,e),p&&nt(t,e,n,"updated")},r)},V=(e,t,n,r,i,l,s)=>{for(let o=0;o<t.length;o++){let a=e[o],c=t[o],u=a.el&&(a.type===il||!ib(a,c)||70&a.shapeFlag)?h(a.el):n;x(a,c,u,null,r,i,l,s,!0)}},B=(e,t,n,r,i)=>{if(t!==n){if(t!==y)for(let l in t)H(l)||l in n||o(e,l,t[l],null,i,r);for(let l in n){if(H(l))continue;let s=n[l],a=t[l];s!==a&&"value"!==l&&o(e,l,a,s,i,r)}"value"in n&&o(e,"value",t.value,n.value,i)}},U=(e,t,n,r,i,s,o,a,c)=>{let d=t.el=e?e.el:u(""),p=t.anchor=e?e.anchor:u(""),{patchFlag:f,dynamicChildren:h,slotScopeIds:m}=t;m&&(a=a?a.concat(m):m),null==e?(l(d,n,r),l(p,n,r),L(t.children||[],n,p,i,s,o,a,c)):f>0&&64&f&&h&&e.dynamicChildren?(V(e.dynamicChildren,h,n,i,s,o,a),(null!=t.key||i&&t===i.subTree)&&rW(e,t,!0)):X(e,t,n,p,i,s,o,a,c)},j=(e,t,n,r,i,l,s,o,a)=>{t.slotScopeIds=o,null==e?512&t.shapeFlag?i.ctx.activate(t,n,r,s,a):q(t,n,r,i,l,s,a):W(e,t,a)},q=(e,t,n,r,i,l,s)=>{let o=e.component=function(e,t,n){let r=e.type,i=(t?t.appContext:e.appContext)||iO,l={uid:iP++,vnode:e,type:r,parent:t,appContext:i,root:null,next:null,subTree:null,effect:null,update:null,job:null,scope:new ex(!0),render:null,proxy:null,exposed:null,exposeProxy:null,withProxy:null,provides:t?t.provides:Object.create(i.provides),ids:t?t.ids:["",0,0],accessCache:null,renderCache:[],components:null,directives:null,propsOptions:function e(t,n,r=!1){let i=r?rE:n.propsCache,l=i.get(t);if(l)return l;let s=t.props,o={},a=[],c=!1;if(!P(t)){let i=t=>{c=!0;let[r,i]=e(t,n,!0);k(o,r),i&&a.push(...i)};!r&&n.mixins.length&&n.mixins.forEach(i),t.extends&&i(t.extends),t.mixins&&t.mixins.forEach(i)}if(!s&&!c)return $(t)&&i.set(t,b),b;if(A(s))for(let e=0;e<s.length;e++){let t=z(s[e]);rI(t)&&(o[t]=y)}else if(s)for(let e in s){let t=z(e);if(rI(t)){let n=s[e],r=o[t]=A(n)||P(n)?{type:n}:k({},n),i=r.type,l=!1,c=!0;if(A(i))for(let e=0;e<i.length;++e){let t=i[e],n=P(t)&&t.name;if("Boolean"===n){l=!0;break}"String"===n&&(c=!1)}else l=P(i)&&"Boolean"===i.name;r[0]=l,r[1]=c,(l||w(r,"default"))&&a.push(t)}}let u=[o,a];return $(t)&&i.set(t,u),u}(r,i),emitsOptions:function e(t,n,r=!1){let i=n.emitsCache,l=i.get(t);if(void 0!==l)return l;let s=t.emits,o={},a=!1;if(!P(t)){let i=t=>{let r=e(t,n,!0);r&&(a=!0,k(o,r))};!r&&n.mixins.length&&n.mixins.forEach(i),t.extends&&i(t.extends),t.mixins&&t.mixins.forEach(i)}return s||a?(A(s)?s.forEach(e=>o[e]=null):k(o,s),$(t)&&i.set(t,o),o):($(t)&&i.set(t,null),null)}(r,i),emit:null,emitted:null,propsDefaults:y,inheritAttrs:r.inheritAttrs,ctx:y,data:y,props:y,attrs:y,slots:y,refs:y,setupState:y,setupContext:null,suspense:n,suspenseId:n?n.pendingId:0,asyncDep:null,asyncResolved:!1,isMounted:!1,isUnmounted:!1,isDeactivated:!1,bc:null,c:null,bm:null,m:null,bu:null,u:null,um:null,bum:null,da:null,a:null,rtg:null,rtc:null,ec:null,sp:null};return l.ctx={_:l},l.root=t?t.root:l,l.emit=r0.bind(null,l),e.ce&&e.ce(l),l}(e,r,i);nH(e)&&(o.ctx.renderer=eu),function(e,t=!1,n=!1){t&&c(t);let{props:r,children:i}=e.vnode,l=iF(e);(function(e,t,n,r=!1){let i={},l=rT();for(let n in e.propsDefaults=/* @__PURE__ */Object.create(null),rw(e,t,i,l),e.propsOptions[0])n in i||(i[n]=void 0);n?e.props=r?i:tm(i):e.type.props?e.props=i:e.props=l,e.attrs=l})(e,r,l,t),rD(e,i,n),l&&function(e,t){let n=e.type;e.accessCache=/* @__PURE__ */Object.create(null),e.proxy=new Proxy(e.ctx,rl);let{setup:r}=n;if(r){eL();let n=e.setupContext=r.length>1?iq(e):null,i=i$(e),l=tq(r,e,0,[e.props,n]),s=D(l);if(e$(),i(),(s||e.sp)&&!nU(e)&&nw(e),s){if(l.then(iD,iD),t)return l.then(n=>{iB(e,n,t)}).catch(t=>{tK(t,e,0)});e.asyncDep=l}else iB(e,l,t)}else ij(e,t)}(e,t),t&&c(!1)}(o,!1,s),o.asyncDep?(i&&i.registerDep(o,K,s),e.el||T(null,o.subTree=iC(io),t,n)):K(o,e,t,n,i,l,s)},W=(e,t,n)=>{let r=t.component=e.component;if(function(e,t,n){let{props:r,children:i,component:l}=e,{props:s,children:o,patchFlag:a}=t,c=l.emitsOptions;if(t.dirs||t.transition)return!0;if(!n||!(a>=0))return(!!i||!!o)&&(!o||!o.$stable)||r!==s&&(r?!s||r4(r,s,c):!!s);if(1024&a)return!0;if(16&a)return r?r4(r,s,c):!!s;if(8&a){let e=t.dynamicProps;for(let t=0;t<e.length;t++){let n=e[t];if(s[n]!==r[n]&&!r1(c,n))return!0}}return!1}(e,t,n)){if(r.asyncDep&&!r.asyncResolved){J(r,t,n);return}r.next=t,r.update()}else t.el=e.el,r.vnode=t},K=(e,t,n,r,l,s,o)=>{let a=()=>{if(e.isMounted){let t,{next:n,bu:r,u:i,parent:c,vnode:u}=e;{let t=function e(t){let n=t.subTree.component;if(n)return n.asyncDep&&!n.asyncResolved?n:e(n)}(e);if(t){n&&(n.el=u.el,J(e,n,o)),t.asyncDep.then(()=>{e.isUnmounted||a()});return}}let d=n;rH(e,!1),n?(n.el=u.el,J(e,n,o)):n=u,r&&Y(r),(t=n.props&&n.props.onVnodeBeforeUpdate)&&iR(t,c,n,u),rH(e,!0);let p=r2(e),f=e.subTree;e.subTree=p,x(f,p,h(f.el),eo(f),e,l,s),n.el=p.el,null===d&&r8(e,p.el),i&&rV(i,l),(t=n.props&&n.props.onVnodeUpdated)&&rV(()=>iR(t,c,n,u),l)}else{let o;let{el:a,props:c}=t,{bm:u,m:d,parent:p,root:f,type:h}=e,m=nU(t);if(rH(e,!1),u&&Y(u),!m&&(o=c&&c.onVnodeBeforeMount)&&iR(o,p,t),rH(e,!0),a&&i){let t=()=>{e.subTree=r2(e),i(a,e.subTree,e,l,null)};m&&h.__asyncHydrate?h.__asyncHydrate(a,e,t):t()}else{f.ce&&f.ce._injectChildStyle(h);let i=e.subTree=r2(e);x(null,i,n,r,e,l,s),t.el=i.el}if(d&&rV(d,l),!m&&(o=c&&c.onVnodeMounted)){let e=t;rV(()=>iR(o,p,e),l)}(256&t.shapeFlag||p&&nU(p.vnode)&&256&p.vnode.shapeFlag)&&e.a&&rV(e.a,l),e.isMounted=!0,t=n=r=null}};e.scope.on();let c=e.effect=new ek(a);e.scope.off();let u=e.update=c.run.bind(c),d=e.job=c.runIfDirty.bind(c);d.i=e,d.id=e.uid,c.scheduler=()=>t1(d),rH(e,!0),u()},J=(e,t,n)=>{t.component=e;let r=e.vnode.props;e.vnode=t,e.next=null,function(e,t,n,r){let{props:i,attrs:l,vnode:{patchFlag:s}}=e,o=tx(i),[a]=e.propsOptions,c=!1;if((r||s>0)&&!(16&s)){if(8&s){let n=e.vnode.dynamicProps;for(let r=0;r<n.length;r++){let s=n[r];if(r1(e.emitsOptions,s))continue;let u=t[s];if(a){if(w(l,s))u!==l[s]&&(l[s]=u,c=!0);else{let t=z(s);i[t]=rA(a,o,t,u,e,!1)}}else u!==l[s]&&(l[s]=u,c=!0)}}}else{let r;for(let s in rw(e,t,i,l)&&(c=!0),o)t&&(w(t,s)||(r=G(s))!==s&&w(t,r))||(a?n&&(void 0!==n[s]||void 0!==n[r])&&(i[s]=rA(a,o,s,void 0,e,!0)):delete i[s]);if(l!==o)for(let e in l)t&&w(t,e)||(delete l[e],c=!0)}c&&eK(e.attrs,"set","")}(e,t.props,r,n),rF(e,t.children,n),eL(),t3(e),e$()},X=(e,t,n,r,i,l,s,o,a=!1)=>{let c=e&&e.children,u=e?e.shapeFlag:0,d=t.children,{patchFlag:p,shapeFlag:h}=t;if(p>0){if(128&p){Z(c,d,n,r,i,l,s,o,a);return}if(256&p){Q(c,d,n,r,i,l,s,o,a);return}}8&h?(16&u&&es(c,i,l),d!==c&&f(n,d)):16&u?16&h?Z(c,d,n,r,i,l,s,o,a):es(c,i,l,!0):(8&u&&f(n,""),16&h&&L(d,n,r,i,l,s,o,a))},Q=(e,t,n,r,i,l,s,o,a)=>{let c;e=e||b,t=t||b;let u=e.length,d=t.length,p=Math.min(u,d);for(c=0;c<p;c++){let r=t[c]=a?iA(t[c]):iw(t[c]);x(e[c],r,n,null,i,l,s,o,a)}u>d?es(e,i,l,!0,!1,p):L(t,n,r,i,l,s,o,a,p)},Z=(e,t,n,r,i,l,s,o,a)=>{let c=0,u=t.length,d=e.length-1,p=u-1;for(;c<=d&&c<=p;){let r=e[c],u=t[c]=a?iA(t[c]):iw(t[c]);if(ib(r,u))x(r,u,n,null,i,l,s,o,a);else break;c++}for(;c<=d&&c<=p;){let r=e[d],c=t[p]=a?iA(t[p]):iw(t[p]);if(ib(r,c))x(r,c,n,null,i,l,s,o,a);else break;d--,p--}if(c>d){if(c<=p){let e=p+1,d=e<u?t[e].el:r;for(;c<=p;)x(null,t[c]=a?iA(t[c]):iw(t[c]),n,d,i,l,s,o,a),c++}}else if(c>p)for(;c<=d;)et(e[c],i,l,!0),c++;else{let f;let h=c,m=c,g=/* @__PURE__ */new Map;for(c=m;c<=p;c++){let e=t[c]=a?iA(t[c]):iw(t[c]);null!=e.key&&g.set(e.key,c)}let y=0,_=p-m+1,S=!1,C=0,k=Array(_);for(c=0;c<_;c++)k[c]=0;for(c=h;c<=d;c++){let r;let u=e[c];if(y>=_){et(u,i,l,!0);continue}if(null!=u.key)r=g.get(u.key);else for(f=m;f<=p;f++)if(0===k[f-m]&&ib(u,t[f])){r=f;break}void 0===r?et(u,i,l,!0):(k[r-m]=c+1,r>=C?C=r:S=!0,x(u,t[r],n,null,i,l,s,o,a),y++)}let T=S?function(e){let t,n,r,i,l;let s=e.slice(),o=[0],a=e.length;for(t=0;t<a;t++){let a=e[t];if(0!==a){if(e[n=o[o.length-1]]<a){s[t]=n,o.push(t);continue}for(r=0,i=o.length-1;r<i;)e[o[l=r+i>>1]]<a?r=l+1:i=l;a<e[o[r]]&&(r>0&&(s[t]=o[r-1]),o[r]=t)}}for(r=o.length,i=o[r-1];r-- >0;)o[r]=i,i=s[i];return o}(k):b;for(f=T.length-1,c=_-1;c>=0;c--){let e=m+c,d=t[e],p=e+1<u?t[e+1].el:r;0===k[c]?x(null,d,n,p,i,l,s,o,a):S&&(f<0||c!==T[f]?ee(d,n,p,2):f--)}}},ee=(e,t,n,r,i=null)=>{let{el:s,type:o,transition:a,children:c,shapeFlag:u}=e;if(6&u){ee(e.component.subTree,t,n,r);return}if(128&u){e.suspense.move(t,n,r);return}if(64&u){o.move(e,t,n,eu);return}if(o===il){l(s,t,n);for(let e=0;e<c.length;e++)ee(c[e],t,n,r);l(e.anchor,t,n);return}if(o===ia){E(e,t,n);return}if(2!==r&&1&u&&a){if(0===r)a.beforeEnter(s),l(s,t,n),rV(()=>a.enter(s),i);else{let{leave:e,delayLeave:r,afterLeave:i}=a,o=()=>l(s,t,n),c=()=>{e(s,()=>{o(),i&&i()})};r?r(s,o,c):c()}}else l(s,t,n)},et=(e,t,n,r=!1,i=!1)=>{let l;let{type:s,props:o,ref:a,children:c,dynamicChildren:u,shapeFlag:d,patchFlag:p,dirs:f,cacheIndex:h}=e;if(-2===p&&(i=!1),null!=a&&nA(a,null,n,e,!0),null!=h&&(t.renderCache[h]=void 0),256&d){t.ctx.deactivate(e);return}let m=1&d&&f,g=!nU(e);if(g&&(l=o&&o.onVnodeBeforeUnmount)&&iR(l,t,e),6&d)el(e.component,n,r);else{if(128&d){e.suspense.unmount(n,r);return}m&&nt(e,null,t,"beforeUnmount"),64&d?e.type.remove(e,t,n,eu,r):u&&!u.hasOnce&&(s!==il||p>0&&64&p)?es(u,t,n,!1,!0):(s===il&&384&p||!i&&16&d)&&es(c,t,n),r&&en(e)}(g&&(l=o&&o.onVnodeUnmounted)||m)&&rV(()=>{l&&iR(l,t,e),m&&nt(e,null,t,"unmounted")},n)},en=e=>{let{type:t,el:n,anchor:r,transition:i}=e;if(t===il){ei(n,r);return}if(t===ia){I(e);return}let l=()=>{s(n),i&&!i.persisted&&i.afterLeave&&i.afterLeave()};if(1&e.shapeFlag&&i&&!i.persisted){let{leave:t,delayLeave:r}=i,s=()=>t(n,l);r?r(e.el,l,s):s()}else l()},ei=(e,t)=>{let n;for(;e!==t;)n=m(e),s(e),e=n;s(t)},el=(e,t,n)=>{let{bum:r,scope:i,job:l,subTree:s,um:o,m:a,a:c}=e;rK(a),rK(c),r&&Y(r),i.stop(),l&&(l.flags|=8,et(s,e,t,n)),o&&rV(o,t),rV(()=>{e.isUnmounted=!0},t),t&&t.pendingBranch&&!t.isUnmounted&&e.asyncDep&&!e.asyncResolved&&e.suspenseId===t.pendingId&&(t.deps--,0===t.deps&&t.resolve())},es=(e,t,n,r=!1,i=!1,l=0)=>{for(let s=l;s<e.length;s++)et(e[s],t,n,r,i)},eo=e=>{if(6&e.shapeFlag)return eo(e.component.subTree);if(128&e.shapeFlag)return e.suspense.next();let t=m(e.anchor||e.el),n=t&&t[nn];return n?m(n):t},ea=!1,ec=(e,t,n)=>{null==e?t._vnode&&et(t._vnode,null,null,!0):x(t._vnode||null,e,t,null,null,null,n),t._vnode=e,ea||(ea=!0,t3(),t4(),ea=!1)},eu={p:x,um:et,m:ee,r:en,mt:q,mc:L,pc:X,pbc:V,n:eo,o:e};return t&&([r,i]=t(eu)),{render:ec,hydrate:r,createApp:(n=r,function(e,t=null){P(e)||(e=k({},e)),null==t||$(t)||(t=null);let r=rb(),i=/* @__PURE__ */new WeakSet,l=[],s=!1,o=r.app={_uid:r_++,_component:e,_props:t,_container:null,_context:r,_instance:null,version:iX,get config(){return r.config},set config(v){},use:(e,...t)=>(i.has(e)||(e&&P(e.install)?(i.add(e),e.install(o,...t)):P(e)&&(i.add(e),e(o,...t))),o),mixin:e=>(r.mixins.includes(e)||r.mixins.push(e),o),component:(e,t)=>t?(r.components[e]=t,o):r.components[e],directive:(e,t)=>t?(r.directives[e]=t,o):r.directives[e],mount(i,l,a){if(!s){let c=o._ceVNode||iC(e,t);return c.appContext=r,!0===a?a="svg":!1===a&&(a=void 0),l&&n?n(c,i):ec(c,i,a),s=!0,o._container=i,i.__vue_app__=o,iW(c.component)}},onUnmount(e){l.push(e)},unmount(){s&&(tW(l,o._instance,16),ec(null,o._container),delete o._container.__vue_app__)},provide:(e,t)=>(r.provides[e]=t,o),runWithContext(e){let t=rS;rS=o;try{return e()}finally{rS=t}}};return o})}}function rj({type:e,props:t},n){return"svg"===n&&"foreignObject"===e||"mathml"===n&&"annotation-xml"===e&&t&&t.encoding&&t.encoding.includes("html")?void 0:n}function rH({effect:e,job:t},n){n?(e.flags|=32,t.flags|=4):(e.flags&=-33,t.flags&=-5)}function rq(e,t){return(!e||e&&!e.pendingBranch)&&t&&!t.persisted}function rW(e,t,n=!1){let r=e.children,i=t.children;if(A(r)&&A(i))for(let e=0;e<r.length;e++){let t=r[e],l=i[e];!(1&l.shapeFlag)||l.dynamicChildren||((l.patchFlag<=0||32===l.patchFlag)&&((l=i[e]=iA(i[e])).el=t.el),n||-2===l.patchFlag||rW(t,l)),l.type===is&&(l.el=t.el)}}function rK(e){if(e)for(let t=0;t<e.length;t++)e[t].flags|=8}let rz=Symbol.for("v-scx");function rJ(e,t){return rX(e,null,{flush:"post"})}function rG(e,t){return rX(e,null,{flush:"sync"})}function rX(e,t,n=y){let{immediate:r,deep:l,flush:s,once:o}=n,a=k({},n),c=iM;a.call=(e,t,n)=>tW(e,c,t,n);let u=!1;return"post"===s?a.scheduler=e=>{rV(e,c&&c.suspense)}:"sync"!==s&&(u=!0,a.scheduler=(e,t)=>{t?e():t1(e)}),a.augmentJob=e=>{t&&(e.flags|=4),u&&(e.flags|=2,c&&(e.id=c.uid,e.i=c))},function(e,t,n=y){let r,l,s,o;let{immediate:a,deep:c,once:u,scheduler:d,augmentJob:p,call:f}=n,m=e=>c?e:t_(e)||!1===c||0===c?tH(e,1):tH(e),g=!1,b=!1;if(tN(e)?(l=()=>e.value,g=t_(e)):tv(e)?(l=()=>m(e),g=!0):A(e)?(b=!0,g=e.some(e=>tv(e)||t_(e)),l=()=>e.map(e=>tN(e)?e.value:tv(e)?m(e):P(e)?f?f(e,2):e():void 0)):l=P(e)?t?f?()=>f(e,2):e:()=>{if(s){eL();try{s()}finally{e$()}}let t=h;h=r;try{return f?f(e,3,[o]):e(o)}finally{h=t}}:_,t&&c){let e=l,t=!0===c?1/0:c;l=()=>tH(e(),t)}let S=i,x=()=>{r.stop(),S&&T(S.effects,r)};if(u&&t){let e=t;t=(...t)=>{e(...t),x()}}let C=b?Array(e.length).fill(tB):tB,k=e=>{if(1&r.flags&&(r.dirty||e)){if(t){let e=r.run();if(c||g||(b?e.some((e,t)=>Z(e,C[t])):Z(e,C))){s&&s();let n=h;h=r;try{let n=[e,C===tB?void 0:b&&C[0]===tB?[]:C,o];f?f(t,3,n):t(...n),C=e}finally{h=n}}}else r.run()}};return p&&p(k),(r=new ek(l)).scheduler=d?()=>d(k,!1):k,o=e=>tj(e,!1,r),s=r.onStop=()=>{let e=tU.get(r);if(e){if(f)f(e,4);else for(let t of e)t();tU.delete(r)}},t?a?k(!0):C=r.run():d?d(k.bind(null,!0),!0):r.run(),x.pause=r.pause.bind(r),x.resume=r.resume.bind(r),x.stop=x,x}(e,t,a)}function rQ(e,t,n){let r;let i=this.proxy,l=M(e)?e.includes(".")?rZ(i,e):()=>i[e]:e.bind(i,i);P(t)?r=t:(r=t.handler,n=t);let s=i$(this),o=rX(l,r.bind(i),n);return s(),o}function rZ(e,t){let n=t.split(".");return()=>{let t=e;for(let e=0;e<n.length&&t;e++)t=t[n[e]];return t}}let rY=(e,t)=>"modelValue"===t||"model-value"===t?e.modelModifiers:e[`${t}Modifiers`]||e[`${z(t)}Modifiers`]||e[`${G(t)}Modifiers`];function r0(e,t,...n){let r;if(e.isUnmounted)return;let i=e.vnode.props||y,l=n,s=t.startsWith("update:"),o=s&&rY(i,t.slice(7));o&&(o.trim&&(l=n.map(e=>M(e)?e.trim():e)),o.number&&(l=n.map(et)));let a=i[r=Q(t)]||i[r=Q(z(t))];!a&&s&&(a=i[r=Q(G(t))]),a&&tW(a,e,6,l);let c=i[r+"Once"];if(c){if(e.emitted){if(e.emitted[r])return}else e.emitted={};e.emitted[r]=!0,tW(c,e,6,l)}}function r1(e,t){return!!(e&&x(t))&&(w(e,(t=t.slice(2).replace(/Once$/,""))[0].toLowerCase()+t.slice(1))||w(e,G(t))||w(e,t))}function r2(e){let t,n;let{type:r,vnode:i,proxy:l,withProxy:s,propsOptions:[o],slots:a,attrs:c,emit:u,render:d,renderCache:p,props:f,data:h,setupState:m,ctx:g,inheritAttrs:y}=e,b=t7(e);try{if(4&i.shapeFlag){let e=s||l;t=iw(d.call(e,e,p,f,m,h,g)),n=c}else t=iw(r.length>1?r(f,{attrs:c,slots:a,emit:u}):r(f,null)),n=r.props?c:r6(c)}catch(n){ic.length=0,tK(n,e,1),t=iC(io)}let _=t;if(n&&!1!==y){let e=Object.keys(n),{shapeFlag:t}=_;e.length&&7&t&&(o&&e.some(C)&&(n=r3(n,o)),_=iT(_,n,!1,!0))}return i.dirs&&((_=iT(_,null,!1,!0)).dirs=_.dirs?_.dirs.concat(i.dirs):i.dirs),i.transition&&nk(_,i.transition),t=_,t7(b),t}let r6=e=>{let t;for(let n in e)("class"===n||"style"===n||x(n))&&((t||(t={}))[n]=e[n]);return t},r3=(e,t)=>{let n={};for(let r in e)C(r)&&r.slice(9) in t||(n[r]=e[r]);return n};function r4(e,t,n){let r=Object.keys(t);if(r.length!==Object.keys(e).length)return!0;for(let i=0;i<r.length;i++){let l=r[i];if(t[l]!==e[l]&&!r1(n,l))return!0}return!1}function r8({vnode:e,parent:t},n){for(;t;){let r=t.subTree;if(r.suspense&&r.suspense.activeBranch===e&&(r.el=e.el),r===e)(e=t.vnode).el=n,t=t.parent;else break}}let r5=e=>e.__isSuspense,r9=0;function r7(e,t){let n=e.props&&e.props[t];P(n)&&n()}function ie(e,t,n,r,i,l,s,o,a,c,u=!1){let d;let{p:p,m:f,um:h,n:m,o:{parentNode:g,remove:y}}=c,b=function(e){let t=e.props&&e.props.suspensible;return null!=t&&!1!==t}(e);b&&t&&t.pendingBranch&&(d=t.pendingId,t.deps++);let _=e.props?en(e.props.timeout):void 0,S=l,x={vnode:e,parent:t,parentComponent:n,namespace:s,container:r,hiddenContainer:i,deps:0,pendingId:r9++,timeout:"number"==typeof _?_:-1,activeBranch:null,pendingBranch:null,isInFallback:!u,isHydrating:u,isUnmounted:!1,effects:[],resolve(e=!1,n=!1){let{vnode:r,activeBranch:i,pendingBranch:s,pendingId:o,effects:a,parentComponent:c,container:u}=x,p=!1;x.isHydrating?x.isHydrating=!1:e||((p=i&&s.transition&&"out-in"===s.transition.mode)&&(i.transition.afterLeave=()=>{o===x.pendingId&&(f(s,u,l===S?m(i):l,0),t6(a))}),i&&(g(i.el)===u&&(l=m(i)),h(i,c,x,!0)),p||f(s,u,l,0)),ii(x,s),x.pendingBranch=null,x.isInFallback=!1;let y=x.parent,_=!1;for(;y;){if(y.pendingBranch){y.effects.push(...a),_=!0;break}y=y.parent}_||p||t6(a),x.effects=[],b&&t&&t.pendingBranch&&d===t.pendingId&&(t.deps--,0!==t.deps||n||t.resolve()),r7(r,"onResolve")},fallback(e){if(!x.pendingBranch)return;let{vnode:t,activeBranch:n,parentComponent:r,container:i,namespace:l}=x;r7(t,"onFallback");let s=m(n),c=()=>{x.isInFallback&&(p(null,e,i,s,r,null,l,o,a),ii(x,e))},u=e.transition&&"out-in"===e.transition.mode;u&&(n.transition.afterLeave=c),x.isInFallback=!0,h(n,r,null,!0),u||c()},move(e,t,n){x.activeBranch&&f(x.activeBranch,e,t,n),x.container=e},next:()=>x.activeBranch&&m(x.activeBranch),registerDep(e,t,n){let r=!!x.pendingBranch;r&&x.deps++;let i=e.vnode.el;e.asyncDep.catch(t=>{tK(t,e,0)}).then(l=>{if(e.isUnmounted||x.isUnmounted||x.pendingId!==e.suspenseId)return;e.asyncResolved=!0;let{vnode:o}=e;iB(e,l,!1),i&&(o.el=i);let a=!i&&e.subTree.el;t(e,o,g(i||e.subTree.el),i?null:m(e.subTree),x,s,n),a&&y(a),r8(e,o.el),r&&0==--x.deps&&x.resolve()})},unmount(e,t){x.isUnmounted=!0,x.activeBranch&&h(x.activeBranch,n,e,t),x.pendingBranch&&h(x.pendingBranch,n,e,t)}};return x}function it(e){let t;if(P(e)){let n=ih&&e._c;n&&(e._d=!1,id()),e=e(),n&&(e._d=!0,t=iu,ip())}return A(e)&&(e=function(e,t=!0){let n;for(let t=0;t<e.length;t++){let r=e[t];if(!iv(r))return;if(r.type!==io||"v-if"===r.children){if(n)return;n=r}}return n}(e)),e=iw(e),t&&!e.dynamicChildren&&(e.dynamicChildren=t.filter(t=>t!==e)),e}function ir(e,t){t&&t.pendingBranch?A(e)?t.effects.push(...e):t.effects.push(e):t6(e)}function ii(e,t){e.activeBranch=t;let{vnode:n,parentComponent:r}=e,i=t.el;for(;!i&&t.component;)i=(t=t.component.subTree).el;n.el=i,r&&r.subTree===n&&(r.vnode.el=i,r8(r,i))}let il=Symbol.for("v-fgt"),is=Symbol.for("v-txt"),io=Symbol.for("v-cmt"),ia=Symbol.for("v-stc"),ic=[],iu=null;function id(e=!1){ic.push(iu=e?null:[])}function ip(){ic.pop(),iu=ic[ic.length-1]||null}let ih=1;function im(e){ih+=e,e<0&&iu&&(iu.hasOnce=!0)}function ig(e){return e.dynamicChildren=ih>0?iu||b:null,ip(),ih>0&&iu&&iu.push(e),e}function iy(e,t,n,r,i){return ig(iC(e,t,n,r,i,!0))}function iv(e){return!!e&&!0===e.__v_isVNode}function ib(e,t){return e.type===t.type&&e.key===t.key}let i_=({key:e})=>null!=e?e:null,iS=({ref:e,ref_key:t,ref_for:n})=>("number"==typeof e&&(e=""+e),null!=e?M(e)||tN(e)||P(e)?{i:t5,r:e,k:t,f:!!n}:e:null);function ix(e,t=null,n=null,r=0,i=null,l=e===il?0:1,s=!1,o=!1){let a={__v_isVNode:!0,__v_skip:!0,type:e,props:t,key:t&&i_(t),ref:t&&iS(t),scopeId:t9,slotScopeIds:null,children:n,component:null,suspense:null,ssContent:null,ssFallback:null,dirs:null,transition:null,el:null,anchor:null,target:null,targetStart:null,targetAnchor:null,staticCount:0,shapeFlag:l,patchFlag:r,dynamicProps:i,dynamicChildren:null,appContext:null,ctx:t5};return o?(iE(a,n),128&l&&e.normalize(a)):n&&(a.shapeFlag|=M(n)?8:16),ih>0&&!s&&iu&&(a.patchFlag>0||6&l)&&32!==a.patchFlag&&iu.push(a),a}let iC=function(e,t=null,n=null,r=0,i=null,l=!1){var s;if(e&&e!==n7||(e=io),iv(e)){let r=iT(e,t,!0);return n&&iE(r,n),ih>0&&!l&&iu&&(6&r.shapeFlag?iu[iu.indexOf(e)]=r:iu.push(r)),r.patchFlag=-2,r}if(P(s=e)&&"__vccOpts"in s&&(e=e.__vccOpts),t){let{class:e,style:n}=t=ik(t);e&&!M(e)&&(t.class=eu(e)),$(n)&&(tS(n)&&!A(n)&&(n=k({},n)),t.style=el(n))}let o=M(e)?1:r5(e)?128:nr(e)?64:$(e)?4:P(e)?2:0;return ix(e,t,n,r,i,o,l,!0)};function ik(e){return e?tS(e)||rN(e)?k({},e):e:null}function iT(e,t,n=!1,r=!1){let{props:i,ref:l,patchFlag:s,children:o,transition:a}=e,c=t?iI(i||{},t):i,u={__v_isVNode:!0,__v_skip:!0,type:e.type,props:c,key:c&&i_(c),ref:t&&t.ref?n&&l?A(l)?l.concat(iS(t)):[l,iS(t)]:iS(t):l,scopeId:e.scopeId,slotScopeIds:e.slotScopeIds,children:o,target:e.target,targetStart:e.targetStart,targetAnchor:e.targetAnchor,staticCount:e.staticCount,shapeFlag:e.shapeFlag,patchFlag:t&&e.type!==il?-1===s?16:16|s:s,dynamicProps:e.dynamicProps,dynamicChildren:e.dynamicChildren,appContext:e.appContext,dirs:e.dirs,transition:a,component:e.component,suspense:e.suspense,ssContent:e.ssContent&&iT(e.ssContent),ssFallback:e.ssFallback&&iT(e.ssFallback),el:e.el,anchor:e.anchor,ctx:e.ctx,ce:e.ce};return a&&r&&nk(u,a.clone(u)),u}function iN(e=" ",t=0){return iC(is,null,e,t)}function iw(e){return null==e||"boolean"==typeof e?iC(io):A(e)?iC(il,null,e.slice()):iv(e)?iA(e):iC(is,null,String(e))}function iA(e){return null===e.el&&-1!==e.patchFlag||e.memo?e:iT(e)}function iE(e,t){let n=0,{shapeFlag:r}=e;if(null==t)t=null;else if(A(t))n=16;else if("object"==typeof t){if(65&r){let n=t.default;n&&(n._c&&(n._d=!1),iE(e,n()),n._c&&(n._d=!0));return}{n=32;let r=t._;r||rN(t)?3===r&&t5&&(1===t5.slots._?t._=1:(t._=2,e.patchFlag|=1024)):t._ctx=t5}}else P(t)?(t={default:t,_ctx:t5},n=32):(t=String(t),64&r?(n=16,t=[iN(t)]):n=8);e.children=t,e.shapeFlag|=n}function iI(...e){let t={};for(let n=0;n<e.length;n++){let r=e[n];for(let e in r)if("class"===e)t.class!==r.class&&(t.class=eu([t.class,r.class]));else if("style"===e)t.style=el([t.style,r.style]);else if(x(e)){let n=t[e],i=r[e];i&&n!==i&&!(A(n)&&n.includes(i))&&(t[e]=n?[].concat(n,i):i)}else""!==e&&(t[e]=r[e])}return t}function iR(e,t,n,r=null){tW(e,t,7,[n,r])}let iO=rb(),iP=0,iM=null,iL=()=>iM||t5;a=e=>{iM=e},c=e=>{iV=e};let i$=e=>{let t=iM;return a(e),e.scope.on(),()=>{e.scope.off(),a(t)}},iD=()=>{iM&&iM.scope.off(),a(null)};function iF(e){return 4&e.vnode.shapeFlag}let iV=!1;function iB(e,t,n){P(t)?e.render=t:$(t)&&(e.setupState=tP(t)),ij(e,n)}function iU(e){u=e,d=e=>{e.render._rc&&(e.withProxy=new Proxy(e.ctx,rs))}}function ij(e,t,n){let r=e.type;if(!e.render){if(!t&&u&&!r.render){let t=r.template||rd(e).template;if(t){let{isCustomElement:n,compilerOptions:i}=e.appContext.config,{delimiters:l,compilerOptions:s}=r,o=k(k({isCustomElement:n,delimiters:l},i),s);r.render=u(t,o)}}e.render=r.render||_,d&&d(e)}{let t=i$(e);eL();try{!function(e){let t=rd(e),n=e.proxy,r=e.ctx;rc=!1,t.beforeCreate&&ru(t.beforeCreate,e,"bc");let{data:i,computed:l,methods:s,watch:o,provide:a,inject:c,created:u,beforeMount:d,mounted:p,beforeUpdate:f,updated:h,activated:m,deactivated:g,beforeDestroy:y,beforeUnmount:b,destroyed:S,unmounted:x,render:C,renderTracked:k,renderTriggered:T,errorCaptured:N,serverPrefetch:w,expose:E,inheritAttrs:I,components:R,directives:O,filters:L}=t;if(c&&function(e,t,n=_){for(let n in A(e)&&(e=rm(e)),e){let r;let i=e[n];tN(r=$(i)?"default"in i?rC(i.from||n,i.default,!0):rC(i.from||n):rC(i))?Object.defineProperty(t,n,{enumerable:!0,configurable:!0,get:()=>r.value,set:e=>r.value=e}):t[n]=r}}(c,r,null),s)for(let e in s){let t=s[e];P(t)&&(r[e]=t.bind(n))}if(i){let t=i.call(n,n);$(t)&&(e.data=th(t))}if(rc=!0,l)for(let e in l){let t=l[e],i=P(t)?t.bind(n,n):P(t.get)?t.get.bind(n,n):_,s=iz({get:i,set:!P(t)&&P(t.set)?t.set.bind(n):_});Object.defineProperty(r,e,{enumerable:!0,configurable:!0,get:()=>s.value,set:e=>s.value=e})}if(o)for(let e in o)!function e(t,n,r,i){let l=i.includes(".")?rZ(r,i):()=>r[i];if(M(t)){let e=n[t];P(e)&&rX(l,e,void 0)}else if(P(t)){var s;s=t.bind(r),rX(l,s,void 0)}else if($(t)){if(A(t))t.forEach(t=>e(t,n,r,i));else{let e=P(t.handler)?t.handler.bind(r):n[t.handler];P(e)&&rX(l,e,t)}}}(o[e],r,n,e);if(a){let e=P(a)?a.call(n):a;Reflect.ownKeys(e).forEach(t=>{rx(t,e[t])})}function D(e,t){A(t)?t.forEach(t=>e(t.bind(n))):t&&e(t.bind(n))}if(u&&ru(u,e,"c"),D(nZ,d),D(nY,p),D(n0,f),D(n1,h),D(nW,m),D(nK,g),D(n5,N),D(n8,k),D(n4,T),D(n2,b),D(n6,x),D(n3,w),A(E)){if(E.length){let t=e.exposed||(e.exposed={});E.forEach(e=>{Object.defineProperty(t,e,{get:()=>n[e],set:t=>n[e]=t})})}else e.exposed||(e.exposed={})}C&&e.render===_&&(e.render=C),null!=I&&(e.inheritAttrs=I),R&&(e.components=R),O&&(e.directives=O)}(e)}finally{e$(),t()}}}let iH={get:(e,t)=>(eW(e,"get",""),e[t])};function iq(e){return{attrs:new Proxy(e.attrs,iH),slots:e.slots,emit:e.emit,expose:t=>{e.exposed=t||{}}}}function iW(e){return e.exposed?e.exposeProxy||(e.exposeProxy=new Proxy(tP(tC(e.exposed)),{get:(t,n)=>n in t?t[n]:n in rr?rr[n](e):void 0,has:(e,t)=>t in e||t in rr})):e.proxy}function iK(e,t=!0){return P(e)?e.displayName||e.name:e.name||t&&e.__name}let iz=(e,t)=>(function(e,t,n=!1){let r,i;return P(e)?r=e:(r=e.get,i=e.set),new tV(r,i,n)})(e,0,iV);function iJ(e,t,n){let r=arguments.length;return 2!==r?(r>3?n=Array.prototype.slice.call(arguments,2):3===r&&iv(n)&&(n=[n]),iC(e,t,n)):!$(t)||A(t)?iC(e,null,t):iv(t)?iC(e,null,[t]):iC(e,t)}function iG(e,t){let n=e.memo;if(n.length!=t.length)return!1;for(let e=0;e<n.length;e++)if(Z(n[e],t[e]))return!1;return ih>0&&iu&&iu.push(e),!0}let iX="3.5.12",iQ="undefined"!=typeof window&&window.trustedTypes;if(iQ)try{m=/* @__PURE__ */iQ.createPolicy("vue",{createHTML:e=>e})}catch(e){}let iZ=m?e=>m.createHTML(e):e=>e,iY="undefined"!=typeof document?document:null,i0=iY&&/* @__PURE__ */iY.createElement("template"),i1="transition",i2="animation",i6=Symbol("_vtc"),i3={name:String,type:String,css:{type:Boolean,default:!0},duration:[String,Number,Object],enterFromClass:String,enterActiveClass:String,enterToClass:String,appearFromClass:String,appearActiveClass:String,appearToClass:String,leaveFromClass:String,leaveActiveClass:String,leaveToClass:String},i4=/* @__PURE__ */k({},ng,i3),i8=((t=(e,{slots:t})=>iJ(nb,i7(e),t)).displayName="Transition",t.props=i4,t),i5=(e,t=[])=>{A(e)?e.forEach(e=>e(...t)):e&&e(...t)},i9=e=>!!e&&(A(e)?e.some(e=>e.length>1):e.length>1);function i7(e){let t={};for(let n in e)n in i3||(t[n]=e[n]);if(!1===e.css)return t;let{name:n="v",type:r,duration:i,enterFromClass:l=`${n}-enter-from`,enterActiveClass:s=`${n}-enter-active`,enterToClass:o=`${n}-enter-to`,appearFromClass:a=l,appearActiveClass:c=s,appearToClass:u=o,leaveFromClass:d=`${n}-leave-from`,leaveActiveClass:p=`${n}-leave-active`,leaveToClass:f=`${n}-leave-to`}=e,h=function(e){if(null==e)return null;if($(e))return[en(e.enter),en(e.leave)];{let t=en(e);return[t,t]}}(i),m=h&&h[0],g=h&&h[1],{onBeforeEnter:y,onEnter:b,onEnterCancelled:_,onLeave:S,onLeaveCancelled:x,onBeforeAppear:C=y,onAppear:T=b,onAppearCancelled:N=_}=t,w=(e,t,n)=>{lt(e,t?u:o),lt(e,t?c:s),n&&n()},A=(e,t)=>{e._isLeaving=!1,lt(e,d),lt(e,f),lt(e,p),t&&t()},E=e=>(t,n)=>{let i=e?T:b,s=()=>w(t,e,n);i5(i,[t,s]),ln(()=>{lt(t,e?a:l),le(t,e?u:o),i9(i)||li(t,r,m,s)})};return k(t,{onBeforeEnter(e){i5(y,[e]),le(e,l),le(e,s)},onBeforeAppear(e){i5(C,[e]),le(e,a),le(e,c)},onEnter:E(!1),onAppear:E(!0),onLeave(e,t){e._isLeaving=!0;let n=()=>A(e,t);le(e,d),le(e,p),la(),ln(()=>{e._isLeaving&&(lt(e,d),le(e,f),i9(S)||li(e,r,g,n))}),i5(S,[e,n])},onEnterCancelled(e){w(e,!1),i5(_,[e])},onAppearCancelled(e){w(e,!0),i5(N,[e])},onLeaveCancelled(e){A(e),i5(x,[e])}})}function le(e,t){t.split(/\s+/).forEach(t=>t&&e.classList.add(t)),(e[i6]||(e[i6]=/* @__PURE__ */new Set)).add(t)}function lt(e,t){t.split(/\s+/).forEach(t=>t&&e.classList.remove(t));let n=e[i6];n&&(n.delete(t),n.size||(e[i6]=void 0))}function ln(e){requestAnimationFrame(()=>{requestAnimationFrame(e)})}let lr=0;function li(e,t,n,r){let i=e._endId=++lr,l=()=>{i===e._endId&&r()};if(null!=n)return setTimeout(l,n);let{type:s,timeout:o,propCount:a}=ll(e,t);if(!s)return r();let c=s+"end",u=0,d=()=>{e.removeEventListener(c,p),l()},p=t=>{t.target===e&&++u>=a&&d()};setTimeout(()=>{u<a&&d()},o+1),e.addEventListener(c,p)}function ll(e,t){let n=window.getComputedStyle(e),r=e=>(n[e]||"").split(", "),i=r(`${i1}Delay`),l=r(`${i1}Duration`),s=ls(i,l),o=r(`${i2}Delay`),a=r(`${i2}Duration`),c=ls(o,a),u=null,d=0,p=0;t===i1?s>0&&(u=i1,d=s,p=l.length):t===i2?c>0&&(u=i2,d=c,p=a.length):p=(u=(d=Math.max(s,c))>0?s>c?i1:i2:null)?u===i1?l.length:a.length:0;let f=u===i1&&/\b(transform|all)(,|$)/.test(r(`${i1}Property`).toString());return{type:u,timeout:d,propCount:p,hasTransform:f}}function ls(e,t){for(;e.length<t.length;)e=e.concat(e);return Math.max(...t.map((t,n)=>lo(t)+lo(e[n])))}function lo(e){return"auto"===e?0:1e3*Number(e.slice(0,-1).replace(",","."))}function la(){return document.body.offsetHeight}let lc=Symbol("_vod"),lu=Symbol("_vsh");function ld(e,t){e.style.display=t?e[lc]:"none",e[lu]=!t}let lp=Symbol("");function lf(e,t){if(1===e.nodeType){let n=e.style,r="";for(let e in t)n.setProperty(`--${e}`,t[e]),r+=`--${e}: ${t[e]};`;n[lp]=r}}let lh=/(^|;)\s*display\s*:/,lm=/\s*!important$/;function lg(e,t,n){if(A(n))n.forEach(n=>lg(e,t,n));else if(null==n&&(n=""),t.startsWith("--"))e.setProperty(t,n);else{let r=function(e,t){let n=lv[t];if(n)return n;let r=z(t);if("filter"!==r&&r in e)return lv[t]=r;r=X(r);for(let n=0;n<ly.length;n++){let i=ly[n]+r;if(i in e)return lv[t]=i}return t}(e,t);lm.test(n)?e.setProperty(G(r),n.replace(lm,""),"important"):e[r]=n}}let ly=["Webkit","Moz","ms"],lv={},lb="http://www.w3.org/1999/xlink";function l_(e,t,n,r,i,l=em(t)){r&&t.startsWith("xlink:")?null==n?e.removeAttributeNS(lb,t.slice(6,t.length)):e.setAttributeNS(lb,t,n):null==n||l&&!(n||""===n)?e.removeAttribute(t):e.setAttribute(t,l?"":L(n)?String(n):n)}function lS(e,t,n,r,i){if("innerHTML"===t||"textContent"===t){null!=n&&(e[t]="innerHTML"===t?iZ(n):n);return}let l=e.tagName;if("value"===t&&"PROGRESS"!==l&&!l.includes("-")){let r="OPTION"===l?e.getAttribute("value")||"":e.value,i=null==n?"checkbox"===e.type?"on":"":String(n);r===i&&"_value"in e||(e.value=i),null==n&&e.removeAttribute(t),e._value=n;return}let s=!1;if(""===n||null==n){let r=typeof e[t];if("boolean"===r){var o;n=!!(o=n)||""===o}else null==n&&"string"===r?(n="",s=!0):"number"===r&&(n=0,s=!0)}try{e[t]=n}catch(e){}s&&e.removeAttribute(i||t)}function lx(e,t,n,r){e.addEventListener(t,n,r)}let lC=Symbol("_vei"),lk=/(?:Once|Passive|Capture)$/,lT=0,lN=/* @__PURE__ */Promise.resolve(),lw=()=>lT||(lN.then(()=>lT=0),lT=Date.now()),lA=e=>111===e.charCodeAt(0)&&110===e.charCodeAt(1)&&e.charCodeAt(2)>96&&123>e.charCodeAt(2),lE={};/*! #__NO_SIDE_EFFECTS__ */function lI(e,t,n){let r=nN(e,t);U(r)&&k(r,t);class i extends lO{constructor(e){super(r,e,n)}}return i.def=r,i}let lR="undefined"!=typeof HTMLElement?HTMLElement:class{};class lO extends lR{constructor(e,t={},n=l9){super(),this._def=e,this._props=t,this._createApp=n,this._isVueCE=!0,this._instance=null,this._app=null,this._nonce=this._def.nonce,this._connected=!1,this._resolved=!1,this._numberProps=null,this._styleChildren=/* @__PURE__ */new WeakSet,this._ob=null,this.shadowRoot&&n!==l9?this._root=this.shadowRoot:!1!==e.shadowRoot?(this.attachShadow({mode:"open"}),this._root=this.shadowRoot):this._root=this,this._def.__asyncLoader||this._resolveProps(this._def)}connectedCallback(){if(!this.isConnected)return;this.shadowRoot||this._parseSlots(),this._connected=!0;let e=this;for(;e=e&&(e.parentNode||e.host);)if(e instanceof lO){this._parent=e;break}this._instance||(this._resolved?(this._setParent(),this._update()):e&&e._pendingResolve?this._pendingResolve=e._pendingResolve.then(()=>{this._pendingResolve=void 0,this._resolveDef()}):this._resolveDef())}_setParent(e=this._parent){e&&(this._instance.parent=e._instance,this._instance.provides=e._instance.provides)}disconnectedCallback(){this._connected=!1,t0(()=>{this._connected||(this._ob&&(this._ob.disconnect(),this._ob=null),this._app&&this._app.unmount(),this._instance&&(this._instance.ce=void 0),this._app=this._instance=null)})}_resolveDef(){if(this._pendingResolve)return;for(let e=0;e<this.attributes.length;e++)this._setAttr(this.attributes[e].name);this._ob=new MutationObserver(e=>{for(let t of e)this._setAttr(t.attributeName)}),this._ob.observe(this,{attributes:!0});let e=(e,t=!1)=>{let n;this._resolved=!0,this._pendingResolve=void 0;let{props:r,styles:i}=e;if(r&&!A(r))for(let e in r){let t=r[e];(t===Number||t&&t.type===Number)&&(e in this._props&&(this._props[e]=en(this._props[e])),(n||(n=/* @__PURE__ */Object.create(null)))[z(e)]=!0)}this._numberProps=n,t&&this._resolveProps(e),this.shadowRoot&&this._applyStyles(i),this._mount(e)},t=this._def.__asyncLoader;t?this._pendingResolve=t().then(t=>e(this._def=t,!0)):e(this._def)}_mount(e){this._app=this._createApp(e),e.configureApp&&e.configureApp(this._app),this._app._ceVNode=this._createVNode(),this._app.mount(this._root);let t=this._instance&&this._instance.exposed;if(t)for(let e in t)w(this,e)||Object.defineProperty(this,e,{get:()=>tR(t[e])})}_resolveProps(e){let{props:t}=e,n=A(t)?t:Object.keys(t||{});for(let e of Object.keys(this))"_"!==e[0]&&n.includes(e)&&this._setProp(e,this[e]);for(let e of n.map(z))Object.defineProperty(this,e,{get(){return this._getProp(e)},set(t){this._setProp(e,t,!0,!0)}})}_setAttr(e){if(e.startsWith("data-v-"))return;let t=this.hasAttribute(e),n=t?this.getAttribute(e):lE,r=z(e);t&&this._numberProps&&this._numberProps[r]&&(n=en(n)),this._setProp(r,n,!1,!0)}_getProp(e){return this._props[e]}_setProp(e,t,n=!0,r=!1){t!==this._props[e]&&(t===lE?delete this._props[e]:(this._props[e]=t,"key"===e&&this._app&&(this._app._ceVNode.key=t)),r&&this._instance&&this._update(),n&&(!0===t?this.setAttribute(G(e),""):"string"==typeof t||"number"==typeof t?this.setAttribute(G(e),t+""):t||this.removeAttribute(G(e))))}_update(){l5(this._createVNode(),this._root)}_createVNode(){let e={};this.shadowRoot||(e.onVnodeMounted=e.onVnodeUpdated=this._renderSlots.bind(this));let t=iC(this._def,k(e,this._props));return this._instance||(t.ce=e=>{this._instance=e,e.ce=this,e.isCE=!0;let t=(e,t)=>{this.dispatchEvent(new CustomEvent(e,U(t[0])?k({detail:t},t[0]):{detail:t}))};e.emit=(e,...n)=>{t(e,n),G(e)!==e&&t(G(e),n)},this._setParent()}),t}_applyStyles(e,t){if(!e)return;if(t){if(t===this._def||this._styleChildren.has(t))return;this._styleChildren.add(t)}let n=this._nonce;for(let t=e.length-1;t>=0;t--){let r=document.createElement("style");n&&r.setAttribute("nonce",n),r.textContent=e[t],this.shadowRoot.prepend(r)}}_parseSlots(){let e;let t=this._slots={};for(;e=this.firstChild;){let n=1===e.nodeType&&e.getAttribute("slot")||"default";(t[n]||(t[n]=[])).push(e),this.removeChild(e)}}_renderSlots(){let e=(this._teleportTarget||this).querySelectorAll("slot"),t=this._instance.type.__scopeId;for(let n=0;n<e.length;n++){let r=e[n],i=r.getAttribute("name")||"default",l=this._slots[i],s=r.parentNode;if(l)for(let e of l){if(t&&1===e.nodeType){let n;let r=t+"-s",i=document.createTreeWalker(e,1);for(e.setAttribute(r,"");n=i.nextNode();)n.setAttribute(r,"")}s.insertBefore(e,r)}else for(;r.firstChild;)s.insertBefore(r.firstChild,r);s.removeChild(r)}}_injectChildStyle(e){this._applyStyles(e.styles,e)}_removeChildStyle(e){}}function lP(e){let t=iL();return t&&t.ce||null}let lM=/* @__PURE__ */new WeakMap,lL=/* @__PURE__ */new WeakMap,l$=Symbol("_moveCb"),lD=Symbol("_enterCb"),lF=(n={name:"TransitionGroup",props:/* @__PURE__ */k({},i4,{tag:String,moveClass:String}),setup(e,{slots:t}){let n,r;let i=iL(),l=nh();return n1(()=>{if(!n.length)return;let t=e.moveClass||`${e.name||"v"}-move`;if(!function(e,t,n){let r=e.cloneNode(),i=e[i6];i&&i.forEach(e=>{e.split(/\s+/).forEach(e=>e&&r.classList.remove(e))}),n.split(/\s+/).forEach(e=>e&&r.classList.add(e)),r.style.display="none";let l=1===t.nodeType?t:t.parentNode;l.appendChild(r);let{hasTransform:s}=ll(r);return l.removeChild(r),s}(n[0].el,i.vnode.el,t))return;n.forEach(lV),n.forEach(lB);let r=n.filter(lU);la(),r.forEach(e=>{let n=e.el,r=n.style;le(n,t),r.transform=r.webkitTransform=r.transitionDuration="";let i=n[l$]=e=>{(!e||e.target===n)&&(!e||/transform$/.test(e.propertyName))&&(n.removeEventListener("transitionend",i),n[l$]=null,lt(n,t))};n.addEventListener("transitionend",i)})}),()=>{let s=tx(e),o=i7(s),a=s.tag||il;if(n=[],r)for(let e=0;e<r.length;e++){let t=r[e];t.el&&t.el instanceof Element&&(n.push(t),nk(t,nS(t,o,l,i)),lM.set(t,t.el.getBoundingClientRect()))}r=t.default?nT(t.default()):[];for(let e=0;e<r.length;e++){let t=r[e];null!=t.key&&nk(t,nS(t,o,l,i))}return iC(a,null,r)}}},delete n.props.mode,n);function lV(e){let t=e.el;t[l$]&&t[l$](),t[lD]&&t[lD]()}function lB(e){lL.set(e,e.el.getBoundingClientRect())}function lU(e){let t=lM.get(e),n=lL.get(e),r=t.left-n.left,i=t.top-n.top;if(r||i){let t=e.el.style;return t.transform=t.webkitTransform=`translate(${r}px,${i}px)`,t.transitionDuration="0s",e}}let lj=e=>{let t=e.props["onUpdate:modelValue"]||!1;return A(t)?e=>Y(t,e):t};function lH(e){e.target.composing=!0}function lq(e){let t=e.target;t.composing&&(t.composing=!1,t.dispatchEvent(new Event("input")))}let lW=Symbol("_assign"),lK={created(e,{modifiers:{lazy:t,trim:n,number:r}},i){e[lW]=lj(i);let l=r||i.props&&"number"===i.props.type;lx(e,t?"change":"input",t=>{if(t.target.composing)return;let r=e.value;n&&(r=r.trim()),l&&(r=et(r)),e[lW](r)}),n&&lx(e,"change",()=>{e.value=e.value.trim()}),t||(lx(e,"compositionstart",lH),lx(e,"compositionend",lq),lx(e,"change",lq))},mounted(e,{value:t}){e.value=null==t?"":t},beforeUpdate(e,{value:t,oldValue:n,modifiers:{lazy:r,trim:i,number:l}},s){if(e[lW]=lj(s),e.composing)return;let o=(l||"number"===e.type)&&!/^0\d/.test(e.value)?et(e.value):e.value,a=null==t?"":t;o===a||document.activeElement===e&&"range"!==e.type&&(r&&t===n||i&&e.value.trim()===a)||(e.value=a)}},lz={deep:!0,created(e,t,n){e[lW]=lj(n),lx(e,"change",()=>{let t=e._modelValue,n=lZ(e),r=e.checked,i=e[lW];if(A(t)){let e=ey(t,n),l=-1!==e;if(r&&!l)i(t.concat(n));else if(!r&&l){let n=[...t];n.splice(e,1),i(n)}}else if(I(t)){let e=new Set(t);r?e.add(n):e.delete(n),i(e)}else i(lY(e,r))})},mounted:lJ,beforeUpdate(e,t,n){e[lW]=lj(n),lJ(e,t,n)}};function lJ(e,{value:t,oldValue:n},r){let i;if(e._modelValue=t,A(t))i=ey(t,r.props.value)>-1;else if(I(t))i=t.has(r.props.value);else{if(t===n)return;i=eg(t,lY(e,!0))}e.checked!==i&&(e.checked=i)}let lG={created(e,{value:t},n){e.checked=eg(t,n.props.value),e[lW]=lj(n),lx(e,"change",()=>{e[lW](lZ(e))})},beforeUpdate(e,{value:t,oldValue:n},r){e[lW]=lj(r),t!==n&&(e.checked=eg(t,r.props.value))}},lX={deep:!0,created(e,{value:t,modifiers:{number:n}},r){let i=I(t);lx(e,"change",()=>{let t=Array.prototype.filter.call(e.options,e=>e.selected).map(e=>n?et(lZ(e)):lZ(e));e[lW](e.multiple?i?new Set(t):t:t[0]),e._assigning=!0,t0(()=>{e._assigning=!1})}),e[lW]=lj(r)},mounted(e,{value:t}){lQ(e,t)},beforeUpdate(e,t,n){e[lW]=lj(n)},updated(e,{value:t}){e._assigning||lQ(e,t)}};function lQ(e,t){let n=e.multiple,r=A(t);if(!n||r||I(t)){for(let i=0,l=e.options.length;i<l;i++){let l=e.options[i],s=lZ(l);if(n){if(r){let e=typeof s;"string"===e||"number"===e?l.selected=t.some(e=>String(e)===String(s)):l.selected=ey(t,s)>-1}else l.selected=t.has(s)}else if(eg(lZ(l),t)){e.selectedIndex!==i&&(e.selectedIndex=i);return}}n||-1===e.selectedIndex||(e.selectedIndex=-1)}}function lZ(e){return"_value"in e?e._value:e.value}function lY(e,t){let n=t?"_trueValue":"_falseValue";return n in e?e[n]:t}function l0(e,t,n,r,i){let l=function(e,t){switch(e){case"SELECT":return lX;case"TEXTAREA":return lK;default:switch(t){case"checkbox":return lz;case"radio":return lG;default:return lK}}}(e.tagName,n.props&&n.props.type)[i];l&&l(e,t,n,r)}let l1=["ctrl","shift","alt","meta"],l2={stop:e=>e.stopPropagation(),prevent:e=>e.preventDefault(),self:e=>e.target!==e.currentTarget,ctrl:e=>!e.ctrlKey,shift:e=>!e.shiftKey,alt:e=>!e.altKey,meta:e=>!e.metaKey,left:e=>"button"in e&&0!==e.button,middle:e=>"button"in e&&1!==e.button,right:e=>"button"in e&&2!==e.button,exact:(e,t)=>l1.some(n=>e[`${n}Key`]&&!t.includes(n))},l6={esc:"escape",space:" ",up:"arrow-up",left:"arrow-left",right:"arrow-right",down:"arrow-down",delete:"backspace"},l3=/* @__PURE__ */k({patchProp:(e,t,n,r,i,l)=>{let s="svg"===i;"class"===t?function(e,t,n){let r=e[i6];r&&(t=(t?[t,...r]:[...r]).join(" ")),null==t?e.removeAttribute("class"):n?e.setAttribute("class",t):e.className=t}(e,r,s):"style"===t?function(e,t,n){let r=e.style,i=M(n),l=!1;if(n&&!i){if(t){if(M(t))for(let e of t.split(";")){let t=e.slice(0,e.indexOf(":")).trim();null==n[t]&&lg(r,t,"")}else for(let e in t)null==n[e]&&lg(r,e,"")}for(let e in n)"display"===e&&(l=!0),lg(r,e,n[e])}else if(i){if(t!==n){let e=r[lp];e&&(n+=";"+e),r.cssText=n,l=lh.test(n)}}else t&&e.removeAttribute("style");lc in e&&(e[lc]=l?r.display:"",e[lu]&&(r.display="none"))}(e,n,r):x(t)?C(t)||function(e,t,n,r,i=null){let l=e[lC]||(e[lC]={}),s=l[t];if(r&&s)s.value=r;else{let[n,o]=function(e){let t;if(lk.test(e)){let n;for(t={};n=e.match(lk);)e=e.slice(0,e.length-n[0].length),t[n[0].toLowerCase()]=!0}return[":"===e[2]?e.slice(3):G(e.slice(2)),t]}(t);r?lx(e,n,l[t]=function(e,t){let n=e=>{if(e._vts){if(e._vts<=n.attached)return}else e._vts=Date.now();tW(function(e,t){if(!A(t))return t;{let n=e.stopImmediatePropagation;return e.stopImmediatePropagation=()=>{n.call(e),e._stopped=!0},t.map(e=>t=>!t._stopped&&e&&e(t))}}(e,n.value),t,5,[e])};return n.value=e,n.attached=lw(),n}(r,i),o):s&&(!function(e,t,n,r){e.removeEventListener(t,n,r)}(e,n,s,o),l[t]=void 0)}}(e,t,0,r,l):("."===t[0]?(t=t.slice(1),0):"^"===t[0]?(t=t.slice(1),1):!function(e,t,n,r){if(r)return!!("innerHTML"===t||"textContent"===t||t in e&&lA(t)&&P(n));if("spellcheck"===t||"draggable"===t||"translate"===t||"form"===t||"list"===t&&"INPUT"===e.tagName||"type"===t&&"TEXTAREA"===e.tagName)return!1;if("width"===t||"height"===t){let t=e.tagName;if("IMG"===t||"VIDEO"===t||"CANVAS"===t||"SOURCE"===t)return!1}return!(lA(t)&&M(n))&&t in e}(e,t,r,s))?e._isVueCE&&(/[A-Z]/.test(t)||!M(r))?lS(e,z(t),r,l,t):("true-value"===t?e._trueValue=r:"false-value"===t&&(e._falseValue=r),l_(e,t,r,s)):(lS(e,t,r),e.tagName.includes("-")||"value"!==t&&"checked"!==t&&"selected"!==t||l_(e,t,r,s,l,"value"!==t))}},{insert:(e,t,n)=>{t.insertBefore(e,n||null)},remove:e=>{let t=e.parentNode;t&&t.removeChild(e)},createElement:(e,t,n,r)=>{let i="svg"===t?iY.createElementNS("http://www.w3.org/2000/svg",e):"mathml"===t?iY.createElementNS("http://www.w3.org/1998/Math/MathML",e):n?iY.createElement(e,{is:n}):iY.createElement(e);return"select"===e&&r&&null!=r.multiple&&i.setAttribute("multiple",r.multiple),i},createText:e=>iY.createTextNode(e),createComment:e=>iY.createComment(e),setText:(e,t)=>{e.nodeValue=t},setElementText:(e,t)=>{e.textContent=t},parentNode:e=>e.parentNode,nextSibling:e=>e.nextSibling,querySelector:e=>iY.querySelector(e),setScopeId(e,t){e.setAttribute(t,"")},insertStaticContent(e,t,n,r,i,l){let s=n?n.previousSibling:t.lastChild;if(i&&(i===l||i.nextSibling))for(;t.insertBefore(i.cloneNode(!0),n),i!==l&&(i=i.nextSibling););else{i0.innerHTML=iZ("svg"===r?`<svg>${e}</svg>`:"mathml"===r?`<math>${e}</math>`:e);let i=i0.content;if("svg"===r||"mathml"===r){let e=i.firstChild;for(;e.firstChild;)i.appendChild(e.firstChild);i.removeChild(e)}t.insertBefore(i,n)}return[s?s.nextSibling:t.firstChild,n?n.previousSibling:t.lastChild]}}),l4=!1;function l8(){return p=l4?p:rB(l3),l4=!0,p}let l5=(...e)=>{(p||(p=rU(l3))).render(...e)},l9=(...e)=>{let t=(p||(p=rU(l3))).createApp(...e),{mount:n}=t;return t.mount=e=>{let r=st(e);if(!r)return;let i=t._component;P(i)||i.render||i.template||(i.template=r.innerHTML),1===r.nodeType&&(r.textContent="");let l=n(r,!1,se(r));return r instanceof Element&&(r.removeAttribute("v-cloak"),r.setAttribute("data-v-app","")),l},t},l7=(...e)=>{let t=l8().createApp(...e),{mount:n}=t;return t.mount=e=>{let t=st(e);if(t)return n(t,!0,se(t))},t};function se(e){return e instanceof SVGElement?"svg":"function"==typeof MathMLElement&&e instanceof MathMLElement?"mathml":void 0}function st(e){return M(e)?document.querySelector(e):e}let sn=Symbol(""),sr=Symbol(""),si=Symbol(""),sl=Symbol(""),ss=Symbol(""),so=Symbol(""),sa=Symbol(""),sc=Symbol(""),su=Symbol(""),sd=Symbol(""),sp=Symbol(""),sf=Symbol(""),sh=Symbol(""),sm=Symbol(""),sg=Symbol(""),sy=Symbol(""),sv=Symbol(""),sb=Symbol(""),s_=Symbol(""),sS=Symbol(""),sx=Symbol(""),sC=Symbol(""),sk=Symbol(""),sT=Symbol(""),sN=Symbol(""),sw=Symbol(""),sA=Symbol(""),sE=Symbol(""),sI=Symbol(""),sR=Symbol(""),sO=Symbol(""),sP=Symbol(""),sM=Symbol(""),sL=Symbol(""),s$=Symbol(""),sD=Symbol(""),sF=Symbol(""),sV=Symbol(""),sB=Symbol(""),sU={[sn]:"Fragment",[sr]:"Teleport",[si]:"Suspense",[sl]:"KeepAlive",[ss]:"BaseTransition",[so]:"openBlock",[sa]:"createBlock",[sc]:"createElementBlock",[su]:"createVNode",[sd]:"createElementVNode",[sp]:"createCommentVNode",[sf]:"createTextVNode",[sh]:"createStaticVNode",[sm]:"resolveComponent",[sg]:"resolveDynamicComponent",[sy]:"resolveDirective",[sv]:"resolveFilter",[sb]:"withDirectives",[s_]:"renderList",[sS]:"renderSlot",[sx]:"createSlots",[sC]:"toDisplayString",[sk]:"mergeProps",[sT]:"normalizeClass",[sN]:"normalizeStyle",[sw]:"normalizeProps",[sA]:"guardReactiveProps",[sE]:"toHandlers",[sI]:"camelize",[sR]:"capitalize",[sO]:"toHandlerKey",[sP]:"setBlockTracking",[sM]:"pushScopeId",[sL]:"popScopeId",[s$]:"withCtx",[sD]:"unref",[sF]:"isRef",[sV]:"withMemo",[sB]:"isMemoSame"},sj={start:{line:1,column:1,offset:0},end:{line:1,column:1,offset:0},source:""};function sH(e,t,n,r,i,l,s,o=!1,a=!1,c=!1,u=sj){return e&&(o?(e.helper(so),e.helper(e.inSSR||c?sa:sc)):e.helper(e.inSSR||c?su:sd),s&&e.helper(sb)),{type:13,tag:t,props:n,children:r,patchFlag:i,dynamicProps:l,directives:s,isBlock:o,disableTracking:a,isComponent:c,loc:u}}function sq(e,t=sj){return{type:17,loc:t,elements:e}}function sW(e,t=sj){return{type:15,loc:t,properties:e}}function sK(e,t){return{type:16,loc:sj,key:M(e)?sz(e,!0):e,value:t}}function sz(e,t=!1,n=sj,r=0){return{type:4,loc:n,content:e,isStatic:t,constType:t?3:r}}function sJ(e,t=sj){return{type:8,loc:t,children:e}}function sG(e,t=[],n=sj){return{type:14,loc:n,callee:e,arguments:t}}function sX(e,t,n=!1,r=!1,i=sj){return{type:18,params:e,returns:t,newline:n,isSlot:r,loc:i}}function sQ(e,t,n,r=!0){return{type:19,test:e,consequent:t,alternate:n,newline:r,loc:sj}}function sZ(e,{helper:t,removeHelper:n,inSSR:r}){if(!e.isBlock){var i,l;e.isBlock=!0,n((i=e.isComponent,r||i?su:sd)),t(so),t((l=e.isComponent,r||l?sa:sc))}}let sY=new Uint8Array([123,123]),s0=new Uint8Array([125,125]);function s1(e){return e>=97&&e<=122||e>=65&&e<=90}function s2(e){return 32===e||10===e||9===e||12===e||13===e}function s6(e){return 47===e||62===e||s2(e)}function s3(e){let t=new Uint8Array(e.length);for(let n=0;n<e.length;n++)t[n]=e.charCodeAt(n);return t}let s4={Cdata:new Uint8Array([67,68,65,84,65,91]),CdataEnd:new Uint8Array([93,93,62]),CommentEnd:new Uint8Array([45,45,62]),ScriptEnd:new Uint8Array([60,47,115,99,114,105,112,116]),StyleEnd:new Uint8Array([60,47,115,116,121,108,101]),TitleEnd:new Uint8Array([60,47,116,105,116,108,101]),TextareaEnd:new Uint8Array([60,47,116,101,120,116,97,114,101,97])};function s8(e){throw e}function s5(e){}function /*@__PURE__*/s9(e,t,n,r){let i=SyntaxError(String(`https://vuejs.org/error-reference/#compiler-${e}`));return i.code=e,i.loc=t,i}let s7=e=>4===e.type&&e.isStatic;function oe(e){switch(e){case"Teleport":case"teleport":return sr;case"Suspense":case"suspense":return si;case"KeepAlive":case"keep-alive":return sl;case"BaseTransition":case"base-transition":return ss}}let ot=/^\d|[^\$\w\xA0-\uFFFF]/,on=e=>!ot.test(e),or=/[A-Za-z_$\xA0-\uFFFF]/,oi=/[\.\?\w$\xA0-\uFFFF]/,ol=/\s+[.[]\s*|\s*[.[]\s+/g,os=e=>4===e.type?e.content:e.loc.source,oo=e=>{let t=os(e).trim().replace(ol,e=>e.trim()),n=0,r=[],i=0,l=0,s=null;for(let e=0;e<t.length;e++){let o=t.charAt(e);switch(n){case 0:if("["===o)r.push(n),n=1,i++;else if("("===o)r.push(n),n=2,l++;else if(!(0===e?or:oi).test(o))return!1;break;case 1:"'"===o||'"'===o||"`"===o?(r.push(n),n=3,s=o):"["===o?i++:"]"!==o||--i||(n=r.pop());break;case 2:if("'"===o||'"'===o||"`"===o)r.push(n),n=3,s=o;else if("("===o)l++;else if(")"===o){if(e===t.length-1)return!1;--l||(n=r.pop())}break;case 3:o===s&&(n=r.pop(),s=null)}}return!i&&!l},oa=/^\s*(async\s*)?(\([^)]*?\)|[\w$_]+)\s*(:[^=]+)?=>|^\s*(async\s+)?function(?:\s+[\w$]+)?\s*\(/,oc=e=>oa.test(os(e));function ou(e,t,n=!1){for(let r=0;r<e.props.length;r++){let i=e.props[r];if(7===i.type&&(n||i.exp)&&(M(t)?i.name===t:t.test(i.name)))return i}}function od(e,t,n=!1,r=!1){for(let i=0;i<e.props.length;i++){let l=e.props[i];if(6===l.type){if(n)continue;if(l.name===t&&(l.value||r))return l}else if("bind"===l.name&&(l.exp||r)&&op(l.arg,t))return l}}function op(e,t){return!!(e&&s7(e)&&e.content===t)}function of(e){return 5===e.type||2===e.type}function oh(e){return 7===e.type&&"slot"===e.name}function om(e){return 1===e.type&&3===e.tagType}function og(e){return 1===e.type&&2===e.tagType}let oy=/* @__PURE__ */new Set([sw,sA]);function ov(e,t,n){let r,i;let l=13===e.type?e.props:e.arguments[2],s=[];if(l&&!M(l)&&14===l.type){let e=function e(t,n=[]){if(t&&!M(t)&&14===t.type){let r=t.callee;if(!M(r)&&oy.has(r))return e(t.arguments[0],n.concat(t))}return[t,n]}(l);l=e[0],i=(s=e[1])[s.length-1]}if(null==l||M(l))r=sW([t]);else if(14===l.type){let e=l.arguments[0];M(e)||15!==e.type?l.callee===sE?r=sG(n.helper(sk),[sW([t]),l]):l.arguments.unshift(sW([t])):ob(t,e)||e.properties.unshift(t),r||(r=l)}else 15===l.type?(ob(t,l)||l.properties.unshift(t),r=l):(r=sG(n.helper(sk),[sW([t]),l]),i&&i.callee===sA&&(i=s[s.length-2]));13===e.type?i?i.arguments[0]=r:e.props=r:i?i.arguments[0]=r:e.arguments[2]=r}function ob(e,t){let n=!1;if(4===e.key.type){let r=e.key.content;n=t.properties.some(e=>4===e.key.type&&e.key.content===r)}return n}function o_(e,t){return`_${t}_${e.replace(/[^\w]/g,(t,n)=>"-"===t?"_":e.charCodeAt(n).toString())}`}let oS=/([\s\S]*?)\s+(?:in|of)\s+(\S[\s\S]*)/,ox={parseMode:"base",ns:0,delimiters:["{{","}}"],getNamespace:()=>0,isVoidTag:S,isPreTag:S,isIgnoreNewlineTag:S,isCustomElement:S,onError:s8,onWarn:s5,comments:!1,prefixIdentifiers:!1},oC=ox,ok=null,oT="",oN=null,ow=null,oA="",oE=-1,oI=-1,oR=0,oO=!1,oP=null,oM=[],oL=new class{constructor(e,t){this.stack=e,this.cbs=t,this.state=1,this.buffer="",this.sectionStart=0,this.index=0,this.entityStart=0,this.baseState=1,this.inRCDATA=!1,this.inXML=!1,this.inVPre=!1,this.newlines=[],this.mode=0,this.delimiterOpen=sY,this.delimiterClose=s0,this.delimiterIndex=-1,this.currentSequence=void 0,this.sequenceIndex=0}get inSFCRoot(){return 2===this.mode&&0===this.stack.length}reset(){this.state=1,this.mode=0,this.buffer="",this.sectionStart=0,this.index=0,this.baseState=1,this.inRCDATA=!1,this.currentSequence=void 0,this.newlines.length=0,this.delimiterOpen=sY,this.delimiterClose=s0}getPos(e){let t=1,n=e+1;for(let r=this.newlines.length-1;r>=0;r--){let i=this.newlines[r];if(e>i){t=r+2,n=e-i;break}}return{column:n,line:t,offset:e}}peek(){return this.buffer.charCodeAt(this.index+1)}stateText(e){60===e?(this.index>this.sectionStart&&this.cbs.ontext(this.sectionStart,this.index),this.state=5,this.sectionStart=this.index):this.inVPre||e!==this.delimiterOpen[0]||(this.state=2,this.delimiterIndex=0,this.stateInterpolationOpen(e))}stateInterpolationOpen(e){if(e===this.delimiterOpen[this.delimiterIndex]){if(this.delimiterIndex===this.delimiterOpen.length-1){let e=this.index+1-this.delimiterOpen.length;e>this.sectionStart&&this.cbs.ontext(this.sectionStart,e),this.state=3,this.sectionStart=e}else this.delimiterIndex++}else this.inRCDATA?(this.state=32,this.stateInRCDATA(e)):(this.state=1,this.stateText(e))}stateInterpolation(e){e===this.delimiterClose[0]&&(this.state=4,this.delimiterIndex=0,this.stateInterpolationClose(e))}stateInterpolationClose(e){e===this.delimiterClose[this.delimiterIndex]?this.delimiterIndex===this.delimiterClose.length-1?(this.cbs.oninterpolation(this.sectionStart,this.index+1),this.inRCDATA?this.state=32:this.state=1,this.sectionStart=this.index+1):this.delimiterIndex++:(this.state=3,this.stateInterpolation(e))}stateSpecialStartSequence(e){let t=this.sequenceIndex===this.currentSequence.length;if(t?s6(e):(32|e)===this.currentSequence[this.sequenceIndex]){if(!t){this.sequenceIndex++;return}}else this.inRCDATA=!1;this.sequenceIndex=0,this.state=6,this.stateInTagName(e)}stateInRCDATA(e){if(this.sequenceIndex===this.currentSequence.length){if(62===e||s2(e)){let t=this.index-this.currentSequence.length;if(this.sectionStart<t){let e=this.index;this.index=t,this.cbs.ontext(this.sectionStart,t),this.index=e}this.sectionStart=t+2,this.stateInClosingTagName(e),this.inRCDATA=!1;return}this.sequenceIndex=0}(32|e)===this.currentSequence[this.sequenceIndex]?this.sequenceIndex+=1:0===this.sequenceIndex?this.currentSequence!==s4.TitleEnd&&(this.currentSequence!==s4.TextareaEnd||this.inSFCRoot)?this.fastForwardTo(60)&&(this.sequenceIndex=1):this.inVPre||e!==this.delimiterOpen[0]||(this.state=2,this.delimiterIndex=0,this.stateInterpolationOpen(e)):this.sequenceIndex=Number(60===e)}stateCDATASequence(e){e===s4.Cdata[this.sequenceIndex]?++this.sequenceIndex===s4.Cdata.length&&(this.state=28,this.currentSequence=s4.CdataEnd,this.sequenceIndex=0,this.sectionStart=this.index+1):(this.sequenceIndex=0,this.state=23,this.stateInDeclaration(e))}fastForwardTo(e){for(;++this.index<this.buffer.length;){let t=this.buffer.charCodeAt(this.index);if(10===t&&this.newlines.push(this.index),t===e)return!0}return this.index=this.buffer.length-1,!1}stateInCommentLike(e){e===this.currentSequence[this.sequenceIndex]?++this.sequenceIndex===this.currentSequence.length&&(this.currentSequence===s4.CdataEnd?this.cbs.oncdata(this.sectionStart,this.index-2):this.cbs.oncomment(this.sectionStart,this.index-2),this.sequenceIndex=0,this.sectionStart=this.index+1,this.state=1):0===this.sequenceIndex?this.fastForwardTo(this.currentSequence[0])&&(this.sequenceIndex=1):e!==this.currentSequence[this.sequenceIndex-1]&&(this.sequenceIndex=0)}startSpecial(e,t){this.enterRCDATA(e,t),this.state=31}enterRCDATA(e,t){this.inRCDATA=!0,this.currentSequence=e,this.sequenceIndex=t}stateBeforeTagName(e){33===e?(this.state=22,this.sectionStart=this.index+1):63===e?(this.state=24,this.sectionStart=this.index+1):s1(e)?(this.sectionStart=this.index,0===this.mode?this.state=6:this.inSFCRoot?this.state=34:this.inXML?this.state=6:116===e?this.state=30:this.state=115===e?29:6):47===e?this.state=8:(this.state=1,this.stateText(e))}stateInTagName(e){s6(e)&&this.handleTagName(e)}stateInSFCRootTagName(e){if(s6(e)){let t=this.buffer.slice(this.sectionStart,this.index);"template"!==t&&this.enterRCDATA(s3("</"+t),0),this.handleTagName(e)}}handleTagName(e){this.cbs.onopentagname(this.sectionStart,this.index),this.sectionStart=-1,this.state=11,this.stateBeforeAttrName(e)}stateBeforeClosingTagName(e){s2(e)||(62===e?(this.state=1,this.sectionStart=this.index+1):(this.state=s1(e)?9:27,this.sectionStart=this.index))}stateInClosingTagName(e){(62===e||s2(e))&&(this.cbs.onclosetag(this.sectionStart,this.index),this.sectionStart=-1,this.state=10,this.stateAfterClosingTagName(e))}stateAfterClosingTagName(e){62===e&&(this.state=1,this.sectionStart=this.index+1)}stateBeforeAttrName(e){62===e?(this.cbs.onopentagend(this.index),this.inRCDATA?this.state=32:this.state=1,this.sectionStart=this.index+1):47===e?this.state=7:60===e&&47===this.peek()?(this.cbs.onopentagend(this.index),this.state=5,this.sectionStart=this.index):s2(e)||this.handleAttrStart(e)}handleAttrStart(e){118===e&&45===this.peek()?(this.state=13,this.sectionStart=this.index):46===e||58===e||64===e||35===e?(this.cbs.ondirname(this.index,this.index+1),this.state=14,this.sectionStart=this.index+1):(this.state=12,this.sectionStart=this.index)}stateInSelfClosingTag(e){62===e?(this.cbs.onselfclosingtag(this.index),this.state=1,this.sectionStart=this.index+1,this.inRCDATA=!1):s2(e)||(this.state=11,this.stateBeforeAttrName(e))}stateInAttrName(e){(61===e||s6(e))&&(this.cbs.onattribname(this.sectionStart,this.index),this.handleAttrNameEnd(e))}stateInDirName(e){61===e||s6(e)?(this.cbs.ondirname(this.sectionStart,this.index),this.handleAttrNameEnd(e)):58===e?(this.cbs.ondirname(this.sectionStart,this.index),this.state=14,this.sectionStart=this.index+1):46===e&&(this.cbs.ondirname(this.sectionStart,this.index),this.state=16,this.sectionStart=this.index+1)}stateInDirArg(e){61===e||s6(e)?(this.cbs.ondirarg(this.sectionStart,this.index),this.handleAttrNameEnd(e)):91===e?this.state=15:46===e&&(this.cbs.ondirarg(this.sectionStart,this.index),this.state=16,this.sectionStart=this.index+1)}stateInDynamicDirArg(e){93===e?this.state=14:(61===e||s6(e))&&(this.cbs.ondirarg(this.sectionStart,this.index+1),this.handleAttrNameEnd(e))}stateInDirModifier(e){61===e||s6(e)?(this.cbs.ondirmodifier(this.sectionStart,this.index),this.handleAttrNameEnd(e)):46===e&&(this.cbs.ondirmodifier(this.sectionStart,this.index),this.sectionStart=this.index+1)}handleAttrNameEnd(e){this.sectionStart=this.index,this.state=17,this.cbs.onattribnameend(this.index),this.stateAfterAttrName(e)}stateAfterAttrName(e){61===e?this.state=18:47===e||62===e?(this.cbs.onattribend(0,this.sectionStart),this.sectionStart=-1,this.state=11,this.stateBeforeAttrName(e)):s2(e)||(this.cbs.onattribend(0,this.sectionStart),this.handleAttrStart(e))}stateBeforeAttrValue(e){34===e?(this.state=19,this.sectionStart=this.index+1):39===e?(this.state=20,this.sectionStart=this.index+1):s2(e)||(this.sectionStart=this.index,this.state=21,this.stateInAttrValueNoQuotes(e))}handleInAttrValue(e,t){(e===t||this.fastForwardTo(t))&&(this.cbs.onattribdata(this.sectionStart,this.index),this.sectionStart=-1,this.cbs.onattribend(34===t?3:2,this.index+1),this.state=11)}stateInAttrValueDoubleQuotes(e){this.handleInAttrValue(e,34)}stateInAttrValueSingleQuotes(e){this.handleInAttrValue(e,39)}stateInAttrValueNoQuotes(e){s2(e)||62===e?(this.cbs.onattribdata(this.sectionStart,this.index),this.sectionStart=-1,this.cbs.onattribend(1,this.index),this.state=11,this.stateBeforeAttrName(e)):(39===e||60===e||61===e||96===e)&&this.cbs.onerr(18,this.index)}stateBeforeDeclaration(e){91===e?(this.state=26,this.sequenceIndex=0):this.state=45===e?25:23}stateInDeclaration(e){(62===e||this.fastForwardTo(62))&&(this.state=1,this.sectionStart=this.index+1)}stateInProcessingInstruction(e){(62===e||this.fastForwardTo(62))&&(this.cbs.onprocessinginstruction(this.sectionStart,this.index),this.state=1,this.sectionStart=this.index+1)}stateBeforeComment(e){45===e?(this.state=28,this.currentSequence=s4.CommentEnd,this.sequenceIndex=2,this.sectionStart=this.index+1):this.state=23}stateInSpecialComment(e){(62===e||this.fastForwardTo(62))&&(this.cbs.oncomment(this.sectionStart,this.index),this.state=1,this.sectionStart=this.index+1)}stateBeforeSpecialS(e){e===s4.ScriptEnd[3]?this.startSpecial(s4.ScriptEnd,4):e===s4.StyleEnd[3]?this.startSpecial(s4.StyleEnd,4):(this.state=6,this.stateInTagName(e))}stateBeforeSpecialT(e){e===s4.TitleEnd[3]?this.startSpecial(s4.TitleEnd,4):e===s4.TextareaEnd[3]?this.startSpecial(s4.TextareaEnd,4):(this.state=6,this.stateInTagName(e))}startEntity(){}stateInEntity(){}parse(e){for(this.buffer=e;this.index<this.buffer.length;){let e=this.buffer.charCodeAt(this.index);switch(10===e&&this.newlines.push(this.index),this.state){case 1:this.stateText(e);break;case 2:this.stateInterpolationOpen(e);break;case 3:this.stateInterpolation(e);break;case 4:this.stateInterpolationClose(e);break;case 31:this.stateSpecialStartSequence(e);break;case 32:this.stateInRCDATA(e);break;case 26:this.stateCDATASequence(e);break;case 19:this.stateInAttrValueDoubleQuotes(e);break;case 12:this.stateInAttrName(e);break;case 13:this.stateInDirName(e);break;case 14:this.stateInDirArg(e);break;case 15:this.stateInDynamicDirArg(e);break;case 16:this.stateInDirModifier(e);break;case 28:this.stateInCommentLike(e);break;case 27:this.stateInSpecialComment(e);break;case 11:this.stateBeforeAttrName(e);break;case 6:this.stateInTagName(e);break;case 34:this.stateInSFCRootTagName(e);break;case 9:this.stateInClosingTagName(e);break;case 5:this.stateBeforeTagName(e);break;case 17:this.stateAfterAttrName(e);break;case 20:this.stateInAttrValueSingleQuotes(e);break;case 18:this.stateBeforeAttrValue(e);break;case 8:this.stateBeforeClosingTagName(e);break;case 10:this.stateAfterClosingTagName(e);break;case 29:this.stateBeforeSpecialS(e);break;case 30:this.stateBeforeSpecialT(e);break;case 21:this.stateInAttrValueNoQuotes(e);break;case 7:this.stateInSelfClosingTag(e);break;case 23:this.stateInDeclaration(e);break;case 22:this.stateBeforeDeclaration(e);break;case 25:this.stateBeforeComment(e);break;case 24:this.stateInProcessingInstruction(e);break;case 33:this.stateInEntity()}this.index++}this.cleanup(),this.finish()}cleanup(){this.sectionStart!==this.index&&(1===this.state||32===this.state&&0===this.sequenceIndex?(this.cbs.ontext(this.sectionStart,this.index),this.sectionStart=this.index):(19===this.state||20===this.state||21===this.state)&&(this.cbs.onattribdata(this.sectionStart,this.index),this.sectionStart=this.index))}finish(){this.handleTrailingData(),this.cbs.onend()}handleTrailingData(){let e=this.buffer.length;this.sectionStart>=e||(28===this.state?this.currentSequence===s4.CdataEnd?this.cbs.oncdata(this.sectionStart,e):this.cbs.oncomment(this.sectionStart,e):6===this.state||11===this.state||18===this.state||17===this.state||12===this.state||13===this.state||14===this.state||15===this.state||16===this.state||20===this.state||19===this.state||21===this.state||9===this.state||this.cbs.ontext(this.sectionStart,e))}emitCodePoint(e,t){}}(oM,{onerr:oQ,ontext(e,t){oB(oF(e,t),e,t)},ontextentity(e,t,n){oB(e,t,n)},oninterpolation(e,t){if(oO)return oB(oF(e,t),e,t);let n=e+oL.delimiterOpen.length,r=t-oL.delimiterClose.length;for(;s2(oT.charCodeAt(n));)n++;for(;s2(oT.charCodeAt(r-1));)r--;let i=oF(n,r);i.includes("&")&&(i=oC.decodeEntities(i,!1)),oz({type:5,content:oX(i,!1,oJ(n,r)),loc:oJ(e,t)})},onopentagname(e,t){let n=oF(e,t);oN={type:1,tag:n,ns:oC.getNamespace(n,oM[0],oC.ns),tagType:0,props:[],children:[],loc:oJ(e-1,t),codegenNode:void 0}},onopentagend(e){oV(e)},onclosetag(e,t){let n=oF(e,t);if(!oC.isVoidTag(n)){let r=!1;for(let e=0;e<oM.length;e++)if(oM[e].tag.toLowerCase()===n.toLowerCase()){r=!0,e>0&&/* @__PURE__ *//*@__PURE__*/oM[0].loc.start.offset;for(let n=0;n<=e;n++)oU(oM.shift(),t,n<e);break}r||/* @__PURE__ *//*@__PURE__*/oj(e,60)}},onselfclosingtag(e){let t=oN.tag;oN.isSelfClosing=!0,oV(e),oM[0]&&oM[0].tag===t&&oU(oM.shift(),e)},onattribname(e,t){ow={type:6,name:oF(e,t),nameLoc:oJ(e,t),value:void 0,loc:oJ(e)}},ondirname(e,t){let n=oF(e,t),r="."===n||":"===n?"bind":"@"===n?"on":"#"===n?"slot":n.slice(2);if(oO||""===r)ow={type:6,name:n,nameLoc:oJ(e,t),value:void 0,loc:oJ(e)};else if(ow={type:7,name:r,rawName:n,exp:void 0,arg:void 0,modifiers:"."===n?[sz("prop")]:[],loc:oJ(e)},"pre"===r){oO=oL.inVPre=!0,oP=oN;let e=oN.props;for(let t=0;t<e.length;t++)7===e[t].type&&(e[t]=function(e){let t={type:6,name:e.rawName,nameLoc:oJ(e.loc.start.offset,e.loc.start.offset+e.rawName.length),value:void 0,loc:e.loc};if(e.exp){let n=e.exp.loc;n.end.offset<e.loc.end.offset&&(n.start.offset--,n.start.column--,n.end.offset++,n.end.column++),t.value={type:2,content:e.exp.content,loc:n}}return t}(e[t]))}},ondirarg(e,t){if(e===t)return;let n=oF(e,t);if(oO)ow.name+=n,oG(ow.nameLoc,t);else{let r="["!==n[0];ow.arg=oX(r?n:n.slice(1,-1),r,oJ(e,t),r?3:0)}},ondirmodifier(e,t){let n=oF(e,t);if(oO)ow.name+="."+n,oG(ow.nameLoc,t);else if("slot"===ow.name){let e=ow.arg;e&&(e.content+="."+n,oG(e.loc,t))}else{let r=sz(n,!0,oJ(e,t));ow.modifiers.push(r)}},onattribdata(e,t){oA+=oF(e,t),oE<0&&(oE=e),oI=t},onattribentity(e,t,n){oA+=e,oE<0&&(oE=t),oI=n},onattribnameend(e){let t=oF(ow.loc.start.offset,e);7===ow.type&&(ow.rawName=t),oN.props.some(e=>(7===e.type?e.rawName:e.name)===t)},onattribend(e,t){oN&&ow&&(oG(ow.loc,t),0!==e&&(oA.includes("&")&&(oA=oC.decodeEntities(oA,!0)),6===ow.type?("class"===ow.name&&(oA=oK(oA).trim()),ow.value={type:2,content:oA,loc:1===e?oJ(oE,oI):oJ(oE-1,oI+1)},oL.inSFCRoot&&"template"===oN.tag&&"lang"===ow.name&&oA&&"html"!==oA&&oL.enterRCDATA(s3("</template"),0)):(ow.exp=oX(oA,!1,oJ(oE,oI),0,0),"for"===ow.name&&(ow.forParseResult=function(e){let t=e.loc,n=e.content,r=n.match(oS);if(!r)return;let[,i,l]=r,s=(e,n,r=!1)=>{let i=t.start.offset+n,l=i+e.length;return oX(e,!1,oJ(i,l),0,r?1:0)},o={source:s(l.trim(),n.indexOf(l,i.length)),value:void 0,key:void 0,index:void 0,finalized:!1},a=i.trim().replace(oD,"").trim(),c=i.indexOf(a),u=a.match(o$);if(u){let e;a=a.replace(o$,"").trim();let t=u[1].trim();if(t&&(e=n.indexOf(t,c+a.length),o.key=s(t,e,!0)),u[2]){let r=u[2].trim();r&&(o.index=s(r,n.indexOf(r,o.key?e+t.length:c+a.length),!0))}}return a&&(o.value=s(a,c,!0)),o}(ow.exp)))),(7!==ow.type||"pre"!==ow.name)&&oN.props.push(ow)),oA="",oE=oI=-1},oncomment(e,t){oC.comments&&oz({type:3,content:oF(e,t),loc:oJ(e-4,t+3)})},onend(){let e=oT.length;for(let t=0;t<oM.length;t++)oU(oM[t],e-1),/* @__PURE__ *//*@__PURE__*/oM[t].loc.start.offset},oncdata(e,t){0!==oM[0].ns&&oB(oF(e,t),e,t)},onprocessinginstruction(e){(oM[0]?oM[0].ns:oC.ns)===0&&oQ(21,e-1)}}),o$=/,([^,\}\]]*)(?:,([^,\}\]]*))?$/,oD=/^\(|\)$/g;function oF(e,t){return oT.slice(e,t)}function oV(e){oL.inSFCRoot&&(oN.innerLoc=oJ(e+1,e+1)),oz(oN);let{tag:t,ns:n}=oN;0===n&&oC.isPreTag(t)&&oR++,oC.isVoidTag(t)?oU(oN,e):(oM.unshift(oN),(1===n||2===n)&&(oL.inXML=!0)),oN=null}function oB(e,t,n){{let t=oM[0]&&oM[0].tag;"script"!==t&&"style"!==t&&e.includes("&")&&(e=oC.decodeEntities(e,!1))}let r=oM[0]||ok,i=r.children[r.children.length-1];i&&2===i.type?(i.content+=e,oG(i.loc,n)):r.children.push({type:2,content:e,loc:oJ(t,n)})}function oU(e,t,n=!1){n?oG(e.loc,oj(t,60)):oG(e.loc,function(e,t){let n=e;for(;62!==oT.charCodeAt(n)&&n<oT.length-1;)n++;return n}(t,0)+1),oL.inSFCRoot&&(e.children.length?e.innerLoc.end=k({},e.children[e.children.length-1].loc.end):e.innerLoc.end=k({},e.innerLoc.start),e.innerLoc.source=oF(e.innerLoc.start.offset,e.innerLoc.end.offset));let{tag:r,ns:i,children:l}=e;if(!oO&&("slot"===r?e.tagType=2:function({tag:e,props:t}){if("template"===e){for(let e=0;e<t.length;e++)if(7===t[e].type&&oH.has(t[e].name))return!0}return!1}(e)?e.tagType=3:function({tag:e,props:t}){var n;if(oC.isCustomElement(e))return!1;if("component"===e||(n=e.charCodeAt(0))>64&&n<91||oe(e)||oC.isBuiltInComponent&&oC.isBuiltInComponent(e)||oC.isNativeTag&&!oC.isNativeTag(e))return!0;for(let e=0;e<t.length;e++){let n=t[e];if(6===n.type&&"is"===n.name&&n.value&&n.value.content.startsWith("vue:"))return!0}return!1}(e)&&(e.tagType=1)),oL.inRCDATA||(e.children=oW(l)),0===i&&oC.isIgnoreNewlineTag(r)){let e=l[0];e&&2===e.type&&(e.content=e.content.replace(/^\r?\n/,""))}0===i&&oC.isPreTag(r)&&oR--,oP===e&&(oO=oL.inVPre=!1,oP=null),oL.inXML&&(oM[0]?oM[0].ns:oC.ns)===0&&(oL.inXML=!1)}function oj(e,t){let n=e;for(;oT.charCodeAt(n)!==t&&n>=0;)n--;return n}let oH=/* @__PURE__ */new Set(["if","else","else-if","for","slot"]),oq=/\r\n/g;function oW(e,t){let n="preserve"!==oC.whitespace,r=!1;for(let t=0;t<e.length;t++){let i=e[t];if(2===i.type){if(oR)i.content=i.content.replace(oq,"\n");else if(function(e){for(let t=0;t<e.length;t++)if(!s2(e.charCodeAt(t)))return!1;return!0}(i.content)){let l=e[t-1]&&e[t-1].type,s=e[t+1]&&e[t+1].type;!l||!s||n&&(3===l&&(3===s||1===s)||1===l&&(3===s||1===s&&function(e){for(let t=0;t<e.length;t++){let n=e.charCodeAt(t);if(10===n||13===n)return!0}return!1}(i.content)))?(r=!0,e[t]=null):i.content=" "}else n&&(i.content=oK(i.content))}}return r?e.filter(Boolean):e}function oK(e){let t="",n=!1;for(let r=0;r<e.length;r++)s2(e.charCodeAt(r))?n||(t+=" ",n=!0):(t+=e[r],n=!1);return t}function oz(e){(oM[0]||ok).children.push(e)}function oJ(e,t){return{start:oL.getPos(e),end:null==t?t:oL.getPos(t),source:null==t?t:oF(e,t)}}function oG(e,t){e.end=oL.getPos(t),e.source=oF(e.start.offset,t)}function oX(e,t=!1,n,r=0,i=0){return sz(e,t,n,r)}function /*@__PURE__*/oQ(e,t,n){oC.onError(/* @__PURE__ *//*@__PURE__*/s9(e,oJ(t,t)))}function oZ(e,t){let{children:n}=e;return 1===n.length&&1===t.type&&!og(t)}function oY(e,t){let{constantCache:n}=t;switch(e.type){case 1:if(0!==e.tagType)return 0;let r=n.get(e);if(void 0!==r)return r;let i=e.codegenNode;if(13!==i.type||i.isBlock&&"svg"!==e.tag&&"foreignObject"!==e.tag&&"math"!==e.tag)return 0;if(void 0!==i.patchFlag)return n.set(e,0),0;{let r=3,c=o1(e,t);if(0===c)return n.set(e,0),0;c<r&&(r=c);for(let i=0;i<e.children.length;i++){let l=oY(e.children[i],t);if(0===l)return n.set(e,0),0;l<r&&(r=l)}if(r>1)for(let i=0;i<e.props.length;i++){let l=e.props[i];if(7===l.type&&"bind"===l.name&&l.exp){let i=oY(l.exp,t);if(0===i)return n.set(e,0),0;i<r&&(r=i)}}if(i.isBlock){var l,s,o,a;for(let t=0;t<e.props.length;t++)if(7===e.props[t].type)return n.set(e,0),0;t.removeHelper(so),t.removeHelper((l=t.inSSR,s=i.isComponent,l||s?sa:sc)),i.isBlock=!1,t.helper((o=t.inSSR,a=i.isComponent,o||a?su:sd))}return n.set(e,r),r}case 2:case 3:return 3;case 9:case 11:case 10:default:return 0;case 5:case 12:return oY(e.content,t);case 4:return e.constType;case 8:let c=3;for(let n=0;n<e.children.length;n++){let r=e.children[n];if(M(r)||L(r))continue;let i=oY(r,t);if(0===i)return 0;i<c&&(c=i)}return c;case 20:return 2}}let o0=/* @__PURE__ */new Set([sT,sN,sw,sA]);function o1(e,t){let n=3,r=o2(e);if(r&&15===r.type){let{properties:e}=r;for(let r=0;r<e.length;r++){let i;let{key:l,value:s}=e[r],o=oY(l,t);if(0===o)return o;if(o<n&&(n=o),0===(i=4===s.type?oY(s,t):14===s.type?function e(t,n){if(14===t.type&&!M(t.callee)&&o0.has(t.callee)){let r=t.arguments[0];if(4===r.type)return oY(r,n);if(14===r.type)return e(r,n)}return 0}(s,t):0))return i;i<n&&(n=i)}}return n}function o2(e){let t=e.codegenNode;if(13===t.type)return t.props}function o6(e,t){t.currentNode=e;let{nodeTransforms:n}=t,r=[];for(let i=0;i<n.length;i++){let l=n[i](e,t);if(l&&(A(l)?r.push(...l):r.push(l)),!t.currentNode)return;e=t.currentNode}switch(e.type){case 3:t.ssr||t.helper(sp);break;case 5:t.ssr||t.helper(sC);break;case 9:for(let n=0;n<e.branches.length;n++)o6(e.branches[n],t);break;case 10:case 11:case 1:case 0:!function(e,t){let n=0,r=()=>{n--};for(;n<e.children.length;n++){let i=e.children[n];M(i)||(t.grandParent=t.parent,t.parent=e,t.childIndex=n,t.onNodeRemoved=r,o6(i,t))}}(e,t)}t.currentNode=e;let i=r.length;for(;i--;)r[i]()}function o3(e,t){let n=M(e)?t=>t===e:t=>e.test(t);return(e,r)=>{if(1===e.type){let{props:i}=e;if(3===e.tagType&&i.some(oh))return;let l=[];for(let s=0;s<i.length;s++){let o=i[s];if(7===o.type&&n(o.name)){i.splice(s,1),s--;let n=t(e,o,r);n&&l.push(n)}}return l}}}let o4="/*@__PURE__*/",o8=e=>`${sU[e]}: _${sU[e]}`;function o5(e,t,{helper:n,push:r,newline:i,isTS:l}){let s=n("component"===t?sm:sy);for(let n=0;n<e.length;n++){let o=e[n],a=o.endsWith("__self");a&&(o=o.slice(0,-6)),r(`const ${o_(o,t)} = ${s}(${JSON.stringify(o)}${a?", true":""})${l?"!":""}`),n<e.length-1&&i()}}function o9(e,t){let n=e.length>3;t.push("["),n&&t.indent(),o7(e,t,n),n&&t.deindent(),t.push("]")}function o7(e,t,n=!1,r=!0){let{push:i,newline:l}=t;for(let s=0;s<e.length;s++){let o=e[s];M(o)?i(o,-3):A(o)?o9(o,t):ae(o,t),s<e.length-1&&(n?(r&&i(","),l()):r&&i(", "))}}function ae(e,t){if(M(e)){t.push(e,-3);return}if(L(e)){t.push(t.helper(e));return}switch(e.type){case 1:case 9:case 11:case 12:ae(e.codegenNode,t);break;case 2:!function(e,t){t.push(JSON.stringify(e.content),-3,e)}(e,t);break;case 4:at(e,t);break;case 5:!function(e,t){let{push:n,helper:r,pure:i}=t;i&&n(o4),n(`${r(sC)}(`),ae(e.content,t),n(")")}(e,t);break;case 8:an(e,t);break;case 3:!function(e,t){let{push:n,helper:r,pure:i}=t;i&&n(o4),n(`${r(sp)}(${JSON.stringify(e.content)})`,-3,e)}(e,t);break;case 13:!function(e,t){let n;let{push:r,helper:i,pure:l}=t,{tag:s,props:o,children:a,patchFlag:c,dynamicProps:u,directives:d,isBlock:p,disableTracking:f,isComponent:h}=e;c&&(n=String(c)),d&&r(i(sb)+"("),p&&r(`(${i(so)}(${f?"true":""}), `),l&&r(o4),r(i(p?t.inSSR||h?sa:sc:t.inSSR||h?su:sd)+"(",-2,e),o7(function(e){let t=e.length;for(;t--&&null==e[t];);return e.slice(0,t+1).map(e=>e||"null")}([s,o,a,n,u]),t),r(")"),p&&r(")"),d&&(r(", "),ae(d,t),r(")"))}(e,t);break;case 14:!function(e,t){let{push:n,helper:r,pure:i}=t,l=M(e.callee)?e.callee:r(e.callee);i&&n(o4),n(l+"(",-2,e),o7(e.arguments,t),n(")")}(e,t);break;case 15:!function(e,t){let{push:n,indent:r,deindent:i,newline:l}=t,{properties:s}=e;if(!s.length){n("{}",-2,e);return}let o=s.length>1;n(o?"{":"{ "),o&&r();for(let e=0;e<s.length;e++){let{key:r,value:i}=s[e];!function(e,t){let{push:n}=t;8===e.type?(n("["),an(e,t),n("]")):e.isStatic?n(on(e.content)?e.content:JSON.stringify(e.content),-2,e):n(`[${e.content}]`,-3,e)}(r,t),n(": "),ae(i,t),e<s.length-1&&(n(","),l())}o&&i(),n(o?"}":" }")}(e,t);break;case 17:o9(e.elements,t);break;case 18:!function(e,t){let{push:n,indent:r,deindent:i}=t,{params:l,returns:s,body:o,newline:a,isSlot:c}=e;c&&n(`_${sU[s$]}(`),n("(",-2,e),A(l)?o7(l,t):l&&ae(l,t),n(") => "),(a||o)&&(n("{"),r()),s?(a&&n("return "),A(s)?o9(s,t):ae(s,t)):o&&ae(o,t),(a||o)&&(i(),n("}")),c&&n(")")}(e,t);break;case 19:!function(e,t){let{test:n,consequent:r,alternate:i,newline:l}=e,{push:s,indent:o,deindent:a,newline:c}=t;if(4===n.type){let e=!on(n.content);e&&s("("),at(n,t),e&&s(")")}else s("("),ae(n,t),s(")");l&&o(),t.indentLevel++,l||s(" "),s("? "),ae(r,t),t.indentLevel--,l&&c(),l||s(" "),s(": ");let u=19===i.type;!u&&t.indentLevel++,ae(i,t),!u&&t.indentLevel--,l&&a(!0)}(e,t);break;case 20:!function(e,t){let{push:n,helper:r,indent:i,deindent:l,newline:s}=t,{needPauseTracking:o,needArraySpread:a}=e;a&&n("[...("),n(`_cache[${e.index}] || (`),o&&(i(),n(`${r(sP)}(-1),`),s(),n("(")),n(`_cache[${e.index}] = `),ae(e.value,t),o&&(n(`).cacheIndex = ${e.index},`),s(),n(`${r(sP)}(1),`),s(),n(`_cache[${e.index}]`),l()),n(")"),a&&n(")]")}(e,t);break;case 21:o7(e.body,t,!0,!1)}}function at(e,t){let{content:n,isStatic:r}=e;t.push(r?JSON.stringify(n):n,-3,e)}function an(e,t){for(let n=0;n<e.children.length;n++){let r=e.children[n];M(r)?t.push(r,-3):ae(r,t)}}let ar=o3(/^(if|else|else-if)$/,(e,t,n)=>(function(e,t,n,r){if("else"!==t.name&&(!t.exp||!t.exp.content.trim())){let r=t.exp?t.exp.loc:e.loc;n.onError(/* @__PURE__ *//*@__PURE__*/s9(28,t.loc)),t.exp=sz("true",!1,r)}if("if"===t.name){var i;let l=ai(e,t),s={type:9,loc:oJ((i=e.loc).start.offset,i.end.offset),branches:[l]};if(n.replaceNode(s),r)return r(s,l,!0)}else{let i=n.parent.children,l=i.indexOf(e);for(;l-- >=-1;){let s=i[l];if(s&&3===s.type||s&&2===s.type&&!s.content.trim().length){n.removeNode(s);continue}if(s&&9===s.type){"else-if"===t.name&&void 0===s.branches[s.branches.length-1].condition&&n.onError(/* @__PURE__ *//*@__PURE__*/s9(30,e.loc)),n.removeNode();let i=ai(e,t);s.branches.push(i);let l=r&&r(s,i,!1);o6(i,n),l&&l(),n.currentNode=null}else n.onError(/* @__PURE__ *//*@__PURE__*/s9(30,e.loc));break}}})(e,t,n,(e,t,r)=>{let i=n.parent.children,l=i.indexOf(e),s=0;for(;l-- >=0;){let e=i[l];e&&9===e.type&&(s+=e.branches.length)}return()=>{r?e.codegenNode=al(t,s,n):function(e){for(;;)if(19===e.type){if(19!==e.alternate.type)return e;e=e.alternate}else 20===e.type&&(e=e.value)}(e.codegenNode).alternate=al(t,s+e.branches.length-1,n)}}));function ai(e,t){let n=3===e.tagType;return{type:10,loc:e.loc,condition:"else"===t.name?void 0:t.exp,children:n&&!ou(e,"for")?e.children:[e],userKey:od(e,"key"),isTemplateIf:n}}function al(e,t,n){return e.condition?sQ(e.condition,as(e,t,n),sG(n.helper(sp),['""',"true"])):as(e,t,n)}function as(e,t,n){let{helper:r}=n,i=sK("key",sz(`${t}`,!1,sj,2)),{children:l}=e,s=l[0];if(1!==l.length||1!==s.type){if(1!==l.length||11!==s.type)return sH(n,r(sn),sW([i]),l,64,void 0,void 0,!0,!1,!1,e.loc);{let e=s.codegenNode;return ov(e,i,n),e}}{let e=s.codegenNode,t=14===e.type&&e.callee===sV?e.arguments[1].returns:e;return 13===t.type&&sZ(t,n),ov(t,i,n),e}}let ao=(e,t,n)=>{let{modifiers:r,loc:i}=e,l=e.arg,{exp:s}=e;if(s&&4===s.type&&!s.content.trim()&&(s=void 0),!s){if(4!==l.type||!l.isStatic)return n.onError(s9(52,l.loc)),{props:[sK(l,sz("",!0,i))]};aa(e),s=e.exp}return 4!==l.type?(l.children.unshift("("),l.children.push(') || ""')):l.isStatic||(l.content=`${l.content} || ""`),r.some(e=>"camel"===e.content)&&(4===l.type?l.isStatic?l.content=z(l.content):l.content=`${n.helperString(sI)}(${l.content})`:(l.children.unshift(`${n.helperString(sI)}(`),l.children.push(")"))),!n.inSSR&&(r.some(e=>"prop"===e.content)&&ac(l,"."),r.some(e=>"attr"===e.content)&&ac(l,"^")),{props:[sK(l,s)]}},aa=(e,t)=>{let n=e.arg,r=z(n.content);e.exp=sz(r,!1,n.loc)},ac=(e,t)=>{4===e.type?e.isStatic?e.content=t+e.content:e.content=`\`${t}\${${e.content}}\``:(e.children.unshift(`'${t}' + (`),e.children.push(")"))},au=o3("for",(e,t,n)=>{let{helper:r,removeHelper:i}=n;return function(e,t,n,r){if(!t.exp){n.onError(/* @__PURE__ *//*@__PURE__*/s9(31,t.loc));return}let i=t.forParseResult;if(!i){n.onError(/* @__PURE__ *//*@__PURE__*/s9(32,t.loc));return}ad(i);let{addIdentifiers:l,removeIdentifiers:s,scopes:o}=n,{source:a,value:c,key:u,index:d}=i,p={type:11,loc:t.loc,source:a,valueAlias:c,keyAlias:u,objectIndexAlias:d,parseResult:i,children:om(e)?e.children:[e]};n.replaceNode(p),o.vFor++;let f=r&&r(p);return()=>{o.vFor--,f&&f()}}(e,t,n,t=>{let l=sG(r(s_),[t.source]),s=om(e),o=ou(e,"memo"),a=od(e,"key",!1,!0);a&&7===a.type&&!a.exp&&aa(a);let c=a&&(6===a.type?a.value?sz(a.value.content,!0):void 0:a.exp),u=a&&c?sK("key",c):null,d=4===t.source.type&&t.source.constType>0,p=d?64:a?128:256;return t.codegenNode=sH(n,r(sn),void 0,l,p,void 0,void 0,!0,!d,!1,e.loc),()=>{let a;let{children:p}=t,f=1!==p.length||1!==p[0].type,h=og(e)?e:s&&1===e.children.length&&og(e.children[0])?e.children[0]:null;if(h)a=h.codegenNode,s&&u&&ov(a,u,n);else if(f)a=sH(n,r(sn),u?sW([u]):void 0,e.children,64,void 0,void 0,!0,void 0,!1);else{var m,g,y,b,_,S,x,C;a=p[0].codegenNode,s&&u&&ov(a,u,n),!d!==a.isBlock&&(a.isBlock?(i(so),i((m=n.inSSR,g=a.isComponent,m||g?sa:sc))):i((y=n.inSSR,b=a.isComponent,y||b?su:sd))),(a.isBlock=!d,a.isBlock)?(r(so),r((_=n.inSSR,S=a.isComponent,_||S?sa:sc))):r((x=n.inSSR,C=a.isComponent,x||C?su:sd))}if(o){let e=sX(ap(t.parseResult,[sz("_cached")]));e.body={type:21,body:[sJ(["const _memo = (",o.exp,")"]),sJ(["if (_cached",...c?[" && _cached.key === ",c]:[],` && ${n.helperString(sB)}(_cached, _memo)) return _cached`]),sJ(["const _item = ",a]),sz("_item.memo = _memo"),sz("return _item")],loc:sj},l.arguments.push(e,sz("_cache"),sz(String(n.cached.length))),n.cached.push(null)}else l.arguments.push(sX(ap(t.parseResult),a,!0))}})});function ad(e,t){e.finalized||(e.finalized=!0)}function ap({value:e,key:t,index:n},r=[]){return function(e){let t=e.length;for(;t--&&!e[t];);return e.slice(0,t+1).map((e,t)=>e||sz("_".repeat(t+1),!1))}([e,t,n,...r])}let af=sz("undefined",!1),ah=(e,t)=>{if(1===e.type&&(1===e.tagType||3===e.tagType)){let n=ou(e,"slot");if(n)return n.exp,t.scopes.vSlot++,()=>{t.scopes.vSlot--}}},am=(e,t,n,r)=>sX(e,n,!1,!0,n.length?n[0].loc:r);function ag(e,t,n){let r=[sK("name",e),sK("fn",t)];return null!=n&&r.push(sK("key",sz(String(n),!0))),sW(r)}let ay=/* @__PURE__ */new WeakMap,av=(e,t)=>function(){let n,r,i,l,s;if(!(1===(e=t.currentNode).type&&(0===e.tagType||1===e.tagType)))return;let{tag:o,props:a}=e,c=1===e.tagType,u=c?function(e,t,n=!1){let{tag:r}=e,i=aS(r),l=od(e,"is",!1,!0);if(l){if(i){let e;if(6===l.type?e=l.value&&sz(l.value.content,!0):(e=l.exp)||(e=sz("is",!1,l.arg.loc)),e)return sG(t.helper(sg),[e])}else 6===l.type&&l.value.content.startsWith("vue:")&&(r=l.value.content.slice(4))}let s=oe(r)||t.isBuiltInComponent(r);return s?(n||t.helper(s),s):(t.helper(sm),t.components.add(r),o_(r,"component"))}(e,t):`"${o}"`,d=$(u)&&u.callee===sg,p=0,f=d||u===sr||u===si||!c&&("svg"===o||"foreignObject"===o||"math"===o);if(a.length>0){let r=ab(e,t,void 0,c,d);n=r.props,p=r.patchFlag,l=r.dynamicPropNames;let i=r.directives;s=i&&i.length?sq(i.map(e=>(function(e,t){let n=[],r=ay.get(e);r?n.push(t.helperString(r)):(t.helper(sy),t.directives.add(e.name),n.push(o_(e.name,"directive")));let{loc:i}=e;if(e.exp&&n.push(e.exp),e.arg&&(e.exp||n.push("void 0"),n.push(e.arg)),Object.keys(e.modifiers).length){e.arg||(e.exp||n.push("void 0"),n.push("void 0"));let t=sz("true",!1,i);n.push(sW(e.modifiers.map(e=>sK(e,t)),i))}return sq(n,e.loc)})(e,t))):void 0,r.shouldUseBlock&&(f=!0)}if(e.children.length>0){if(u===sl&&(f=!0,p|=1024),c&&u!==sr&&u!==sl){let{slots:n,hasDynamicSlots:i}=function(e,t,n=am){t.helper(s$);let{children:r,loc:i}=e,l=[],s=[],o=t.scopes.vSlot>0||t.scopes.vFor>0,a=ou(e,"slot",!0);if(a){let{arg:e,exp:t}=a;e&&!s7(e)&&(o=!0),l.push(sK(e||sz("default",!0),n(t,void 0,r,i)))}let c=!1,u=!1,d=[],p=/* @__PURE__ */new Set,f=0;for(let e=0;e<r.length;e++){let i,h,m,g;let y=r[e];if(!om(y)||!(i=ou(y,"slot",!0))){3!==y.type&&d.push(y);continue}if(a){t.onError(/* @__PURE__ *//*@__PURE__*/s9(37,i.loc));break}c=!0;let{children:b,loc:_}=y,{arg:S=sz("default",!0),exp:x,loc:C}=i;s7(S)?h=S?S.content:"default":o=!0;let k=ou(y,"for"),T=n(x,k,b,_);if(m=ou(y,"if"))o=!0,s.push(sQ(m.exp,ag(S,T,f++),af));else if(g=ou(y,/^else(-if)?$/,!0)){let n,i=e;for(;i--&&3===(n=r[i]).type;);if(n&&om(n)&&ou(n,/^(else-)?if$/)){let e=s[s.length-1];for(;19===e.alternate.type;)e=e.alternate;e.alternate=g.exp?sQ(g.exp,ag(S,T,f++),af):ag(S,T,f++)}else t.onError(/* @__PURE__ *//*@__PURE__*/s9(30,g.loc))}else if(k){o=!0;let e=k.forParseResult;e?(ad(e),s.push(sG(t.helper(s_),[e.source,sX(ap(e),ag(S,T),!0)]))):t.onError(s9(32,k.loc))}else{if(h){if(p.has(h)){t.onError(s9(38,C));continue}p.add(h),"default"===h&&(u=!0)}l.push(sK(S,T))}}if(!a){let e=(e,t)=>sK("default",n(e,void 0,t,i));c?d.length&&d.some(e=>(function e(t){return 2!==t.type&&12!==t.type||(2===t.type?!!t.content.trim():e(t.content))})(e))&&(u?t.onError(s9(39,d[0].loc)):l.push(e(void 0,d))):l.push(e(void 0,r))}let h=o?2:!function e(t){for(let n=0;n<t.length;n++){let r=t[n];switch(r.type){case 1:if(2===r.tagType||e(r.children))return!0;break;case 9:if(e(r.branches))return!0;break;case 10:case 11:if(e(r.children))return!0}}return!1}(e.children)?1:3,m=sW(l.concat(sK("_",sz(h+"",!1))),i);return s.length&&(m=sG(t.helper(sx),[m,sq(s)])),{slots:m,hasDynamicSlots:o}}(e,t);r=n,i&&(p|=1024)}else if(1===e.children.length&&u!==sr){let n=e.children[0],i=n.type,l=5===i||8===i;l&&0===oY(n,t)&&(p|=1),r=l||2===i?n:e.children}else r=e.children}l&&l.length&&(i=function(e){let t="[";for(let n=0,r=e.length;n<r;n++)t+=JSON.stringify(e[n]),n<r-1&&(t+=", ");return t+"]"}(l)),e.codegenNode=sH(t,u,n,r,0===p?void 0:p,i,s,!!f,!1,c,e.loc)};function ab(e,t,n=e.props,r,i,l=!1){let s;let{tag:o,loc:a,children:c}=e,u=[],d=[],p=[],f=c.length>0,h=!1,m=0,g=!1,y=!1,b=!1,_=!1,S=!1,C=!1,k=[],T=e=>{u.length&&(d.push(sW(a_(u),a)),u=[]),e&&d.push(e)},N=()=>{t.scopes.vFor>0&&u.push(sK(sz("ref_for",!0),sz("true")))},w=({key:e,value:n})=>{if(s7(e)){let l=e.content,s=x(l);s&&(!r||i)&&"onclick"!==l.toLowerCase()&&"onUpdate:modelValue"!==l&&!H(l)&&(_=!0),s&&H(l)&&(C=!0),s&&14===n.type&&(n=n.arguments[0]),20===n.type||(4===n.type||8===n.type)&&oY(n,t)>0||("ref"===l?g=!0:"class"===l?y=!0:"style"===l?b=!0:"key"===l||k.includes(l)||k.push(l),r&&("class"===l||"style"===l)&&!k.includes(l)&&k.push(l))}else S=!0};for(let i=0;i<n.length;i++){let s=n[i];if(6===s.type){let{loc:e,name:t,nameLoc:n,value:r}=s;if("ref"===t&&(g=!0,N()),"is"===t&&(aS(o)||r&&r.content.startsWith("vue:")))continue;u.push(sK(sz(t,!0,n),sz(r?r.content:"",!0,r?r.loc:e)))}else{let{name:n,arg:i,exp:c,loc:g,modifiers:y}=s,b="bind"===n,_="on"===n;if("slot"===n){r||t.onError(/* @__PURE__ *//*@__PURE__*/s9(40,g));continue}if("once"===n||"memo"===n||"is"===n||b&&op(i,"is")&&aS(o)||_&&l)continue;if((b&&op(i,"key")||_&&f&&op(i,"vue:before-update"))&&(h=!0),b&&op(i,"ref")&&N(),!i&&(b||_)){S=!0,c?b?(N(),T(),d.push(c)):T({type:14,loc:g,callee:t.helper(sE),arguments:r?[c]:[c,"true"]}):t.onError(s9(b?34:35,g));continue}b&&y.some(e=>"prop"===e.content)&&(m|=32);let x=t.directiveTransforms[n];if(x){let{props:n,needRuntime:r}=x(s,e,t);l||n.forEach(w),_&&i&&!s7(i)?T(sW(n,a)):u.push(...n),r&&(p.push(s),L(r)&&ay.set(s,r))}else!q(n)&&(p.push(s),f&&(h=!0))}}if(d.length?(T(),s=d.length>1?sG(t.helper(sk),d,a):d[0]):u.length&&(s=sW(a_(u),a)),S?m|=16:(y&&!r&&(m|=2),b&&!r&&(m|=4),k.length&&(m|=8),_&&(m|=32)),!h&&(0===m||32===m)&&(g||C||p.length>0)&&(m|=512),!t.inSSR&&s)switch(s.type){case 15:let A=-1,E=-1,I=!1;for(let e=0;e<s.properties.length;e++){let t=s.properties[e].key;s7(t)?"class"===t.content?A=e:"style"===t.content&&(E=e):t.isHandlerKey||(I=!0)}let R=s.properties[A],O=s.properties[E];I?s=sG(t.helper(sw),[s]):(R&&!s7(R.value)&&(R.value=sG(t.helper(sT),[R.value])),O&&(b||4===O.value.type&&"["===O.value.content.trim()[0]||17===O.value.type)&&(O.value=sG(t.helper(sN),[O.value])));break;case 14:break;default:s=sG(t.helper(sw),[sG(t.helper(sA),[s])])}return{props:s,directives:p,patchFlag:m,dynamicPropNames:k,shouldUseBlock:h}}function a_(e){let t=/* @__PURE__ */new Map,n=[];for(let r=0;r<e.length;r++){let i=e[r];if(8===i.key.type||!i.key.isStatic){n.push(i);continue}let l=i.key.content,s=t.get(l);s?("style"===l||"class"===l||x(l))&&(17===s.value.type?s.value.elements.push(i.value):s.value=sq([s.value,i.value],s.loc)):(t.set(l,i),n.push(i))}return n}function aS(e){return"component"===e||"Component"===e}let ax=(e,t)=>{if(og(e)){let{children:n,loc:r}=e,{slotName:i,slotProps:l}=function(e,t){let n,r='"default"',i=[];for(let t=0;t<e.props.length;t++){let n=e.props[t];if(6===n.type)n.value&&("name"===n.name?r=JSON.stringify(n.value.content):(n.name=z(n.name),i.push(n)));else if("bind"===n.name&&op(n.arg,"name")){if(n.exp)r=n.exp;else if(n.arg&&4===n.arg.type){let e=z(n.arg.content);r=n.exp=sz(e,!1,n.arg.loc)}}else"bind"===n.name&&n.arg&&s7(n.arg)&&(n.arg.content=z(n.arg.content)),i.push(n)}if(i.length>0){let{props:r,directives:l}=ab(e,t,i,!1,!1);n=r,l.length&&t.onError(s9(36,l[0].loc))}return{slotName:r,slotProps:n}}(e,t),s=[t.prefixIdentifiers?"_ctx.$slots":"$slots",i,"{}","undefined","true"],o=2;l&&(s[2]=l,o=3),n.length&&(s[3]=sX([],n,!1,!1,r),o=4),t.scopeId&&!t.slotted&&(o=5),s.splice(o),e.codegenNode=sG(t.helper(sS),s,r)}},aC=(e,t,n,r)=>{let i;let{loc:l,modifiers:s,arg:o}=e;if(e.exp||s.length,4===o.type){if(o.isStatic){let e=o.content;e.startsWith("vue:")&&(e=`vnode-${e.slice(4)}`),i=sz(0!==t.tagType||e.startsWith("vnode")||!/[A-Z]/.test(e)?Q(z(e)):`on:${e}`,!0,o.loc)}else i=sJ([`${n.helperString(sO)}(`,o,")"])}else(i=o).children.unshift(`${n.helperString(sO)}(`),i.children.push(")");let a=e.exp;a&&!a.content.trim()&&(a=void 0);let c=n.cacheHandlers&&!a&&!n.inVOnce;if(a){let e=oo(a),t=!(e||oc(a)),n=a.content.includes(";");(t||c&&e)&&(a=sJ([`${t?"$event":"(...args)"} => ${n?"{":"("}`,a,n?"}":")"]))}let u={props:[sK(i,a||sz("() => {}",!1,l))]};return r&&(u=r(u)),c&&(u.props[0].value=n.cache(u.props[0].value)),u.props.forEach(e=>e.key.isHandlerKey=!0),u},ak=(e,t)=>{if(0===e.type||1===e.type||11===e.type||10===e.type)return()=>{let n;let r=e.children,i=!1;for(let e=0;e<r.length;e++){let t=r[e];if(of(t)){i=!0;for(let i=e+1;i<r.length;i++){let l=r[i];if(of(l))n||(n=r[e]=sJ([t],t.loc)),n.children.push(" + ",l),r.splice(i,1),i--;else{n=void 0;break}}}}if(i&&(1!==r.length||0!==e.type&&(1!==e.type||0!==e.tagType||e.props.find(e=>7===e.type&&!t.directiveTransforms[e.name]))))for(let e=0;e<r.length;e++){let n=r[e];if(of(n)||8===n.type){let i=[];(2!==n.type||" "!==n.content)&&i.push(n),t.ssr||0!==oY(n,t)||i.push("1"),r[e]={type:12,content:n,loc:n.loc,codegenNode:sG(t.helper(sf),i)}}}}},aT=/* @__PURE__ */new WeakSet,aN=(e,t)=>{if(1===e.type&&ou(e,"once",!0)&&!aT.has(e)&&!t.inVOnce&&!t.inSSR)return aT.add(e),t.inVOnce=!0,t.helper(sP),()=>{t.inVOnce=!1;let e=t.currentNode;e.codegenNode&&(e.codegenNode=t.cache(e.codegenNode,!0))}},aw=(e,t,n)=>{let r;let{exp:i,arg:l}=e;if(!i)return n.onError(/* @__PURE__ *//*@__PURE__*/s9(41,e.loc)),aA();let s=i.loc.source.trim(),o=4===i.type?i.content:s,a=n.bindingMetadata[s];if("props"===a||"props-aliased"===a)return /* @__PURE__ */i.loc,aA();if(!o.trim()||!oo(i))return n.onError(/* @__PURE__ *//*@__PURE__*/s9(42,i.loc)),aA();let c=l||sz("modelValue",!0),u=l?s7(l)?`onUpdate:${z(l.content)}`:sJ(['"onUpdate:" + ',l]):"onUpdate:modelValue",d=n.isTS?"($event: any)":"$event";r=sJ([`${d} => ((`,i,") = $event)"]);let p=[sK(c,e.exp),sK(u,r)];if(e.modifiers.length&&1===t.tagType){let t=e.modifiers.map(e=>e.content).map(e=>(on(e)?e:JSON.stringify(e))+": true").join(", "),n=l?s7(l)?`${l.content}Modifiers`:sJ([l,' + "Modifiers"']):"modelModifiers";p.push(sK(n,sz(`{ ${t} }`,!1,e.loc,2)))}return aA(p)};function aA(e=[]){return{props:e}}let aE=/* @__PURE__ */new WeakSet,aI=(e,t)=>{if(1===e.type){let n=ou(e,"memo");if(!(!n||aE.has(e)))return aE.add(e),()=>{let r=e.codegenNode||t.currentNode.codegenNode;r&&13===r.type&&(1!==e.tagType&&sZ(r,t),e.codegenNode=sG(t.helper(sV),[n.exp,sX(void 0,r),"_cache",String(t.cached.length)]),t.cached.push(null))}}},aR=Symbol(""),aO=Symbol(""),aP=Symbol(""),aM=Symbol(""),aL=Symbol(""),a$=Symbol(""),aD=Symbol(""),aF=Symbol(""),aV=Symbol(""),aB=Symbol("");!function(e){Object.getOwnPropertySymbols(e).forEach(t=>{sU[t]=e[t]})}({[aR]:"vModelRadio",[aO]:"vModelCheckbox",[aP]:"vModelText",[aM]:"vModelSelect",[aL]:"vModelDynamic",[a$]:"withModifiers",[aD]:"withKeys",[aF]:"vShow",[aV]:"Transition",[aB]:"TransitionGroup"});let aU={parseMode:"html",isVoidTag:eh,isNativeTag:e=>ed(e)||ep(e)||ef(e),isPreTag:e=>"pre"===e,isIgnoreNewlineTag:e=>"pre"===e||"textarea"===e,decodeEntities:function(e,t=!1){return(f||(f=document.createElement("div")),t)?(f.innerHTML=`<div foo="${e.replace(/"/g,"&quot;")}">`,f.children[0].getAttribute("foo")):(f.innerHTML=e,f.textContent)},isBuiltInComponent:e=>"Transition"===e||"transition"===e?aV:"TransitionGroup"===e||"transition-group"===e?aB:void 0,getNamespace(e,t,n){let r=t?t.ns:n;if(t&&2===r){if("annotation-xml"===t.tag){if("svg"===e)return 1;t.props.some(e=>6===e.type&&"encoding"===e.name&&null!=e.value&&("text/html"===e.value.content||"application/xhtml+xml"===e.value.content))&&(r=0)}else/^m(?:[ions]|text)$/.test(t.tag)&&"mglyph"!==e&&"malignmark"!==e&&(r=0)}else t&&1===r&&("foreignObject"===t.tag||"desc"===t.tag||"title"===t.tag)&&(r=0);if(0===r){if("svg"===e)return 1;if("math"===e)return 2}return r}},aj=(e,t)=>sz(JSON.stringify(ec(e)),!1,t,3),aH=/* @__PURE__ */g("passive,once,capture"),aq=/* @__PURE__ */g("stop,prevent,self,ctrl,shift,alt,meta,exact,middle"),aW=/* @__PURE__ */g("left,right"),aK=/* @__PURE__ */g("onkeyup,onkeydown,onkeypress"),az=(e,t,n,r)=>{let i=[],l=[],s=[];for(let n=0;n<t.length;n++){let r=t[n].content;aH(r)?s.push(r):aW(r)?s7(e)?aK(e.content.toLowerCase())?i.push(r):l.push(r):(i.push(r),l.push(r)):aq(r)?l.push(r):i.push(r)}return{keyModifiers:i,nonKeyModifiers:l,eventOptionModifiers:s}},aJ=(e,t)=>s7(e)&&"onclick"===e.content.toLowerCase()?sz(t,!0):4!==e.type?sJ(["(",e,`) === "onClick" ? "${t}" : (`,e,")"]):e,aG=(e,t)=>{1===e.type&&0===e.tagType&&("script"===e.tag||"style"===e.tag)&&t.removeNode()},aX=[e=>{1===e.type&&e.props.forEach((t,n)=>{6===t.type&&"style"===t.name&&t.value&&(e.props[n]={type:7,name:"bind",arg:sz("style",!0,t.loc),exp:aj(t.value.content,t.loc),modifiers:[],loc:t.loc})})}],aQ={cloak:()=>({props:[]}),html:(e,t,n)=>{let{exp:r,loc:i}=e;return r||n.onError(s9(53,i)),t.children.length&&(n.onError(s9(54,i)),t.children.length=0),{props:[sK(sz("innerHTML",!0,i),r||sz("",!0))]}},text:(e,t,n)=>{let{exp:r,loc:i}=e;return r||n.onError(s9(55,i)),t.children.length&&(n.onError(s9(56,i)),t.children.length=0),{props:[sK(sz("textContent",!0),r?oY(r,n)>0?r:sG(n.helperString(sC),[r],i):sz("",!0))]}},model:(e,t,n)=>{let r=aw(e,t,n);if(!r.props.length||1===t.tagType)return r;e.arg&&n.onError(s9(58,e.arg.loc));let{tag:i}=t,l=n.isCustomElement(i);if("input"===i||"textarea"===i||"select"===i||l){let s=aP,o=!1;if("input"===i||l){let r=od(t,"type");if(r){if(7===r.type)s=aL;else if(r.value)switch(r.value.content){case"radio":s=aR;break;case"checkbox":s=aO;break;case"file":o=!0,n.onError(s9(59,e.loc))}}else t.props.some(e=>7===e.type&&"bind"===e.name&&(!e.arg||4!==e.arg.type||!e.arg.isStatic))&&(s=aL)}else"select"===i&&(s=aM);o||(r.needRuntime=n.helper(s))}else n.onError(s9(57,e.loc));return r.props=r.props.filter(e=>!(4===e.key.type&&"modelValue"===e.key.content)),r},on:(e,t,n)=>aC(e,t,n,t=>{let{modifiers:r}=e;if(!r.length)return t;let{key:i,value:l}=t.props[0],{keyModifiers:s,nonKeyModifiers:o,eventOptionModifiers:a}=az(i,r,n,e.loc);if(o.includes("right")&&(i=aJ(i,"onContextmenu")),o.includes("middle")&&(i=aJ(i,"onMouseup")),o.length&&(l=sG(n.helper(a$),[l,JSON.stringify(o)])),s.length&&(!s7(i)||aK(i.content.toLowerCase()))&&(l=sG(n.helper(aD),[l,JSON.stringify(s)])),a.length){let e=a.map(X).join("");i=s7(i)?sz(`${i.content}${e}`,!0):sJ(["(",i,`) + "${e}"`])}return{props:[sK(i,l)]}}),show:(e,t,n)=>{let{exp:r,loc:i}=e;return!r&&n.onError(s9(61,i)),{props:[],needRuntime:n.helper(aF)}}},aZ=/* @__PURE__ */Object.create(null);function aY(e,t){if(!M(e)){if(!e.nodeType)return _;e=e.innerHTML}let n=e+JSON.stringify(t,(e,t)=>"function"==typeof t?t.toString():t),r=aZ[n];if(r)return r;if("#"===e[0]){let t=document.querySelector(e);e=t?t.innerHTML:""}let i=k({hoistStatic:!0,onError:void 0,onWarn:_},t);i.isCustomElement||"undefined"==typeof customElements||(i.isCustomElement=e=>!!customElements.get(e));let{code:l}=function(e,t={}){return function(e,t={}){let n=t.onError||s8,r="module"===t.mode;!0===t.prefixIdentifiers?n(/* @__PURE__ *//*@__PURE__*/s9(47)):r&&n(/* @__PURE__ *//*@__PURE__*/s9(48)),t.cacheHandlers&&n(/* @__PURE__ *//*@__PURE__*/s9(49)),t.scopeId&&!r&&n(/* @__PURE__ *//*@__PURE__*/s9(50));let i=k({},t,{prefixIdentifiers:!1}),l=M(e)?function(e,t){if(oL.reset(),oN=null,ow=null,oA="",oE=-1,oI=-1,oM.length=0,oT=e,oC=k({},ox),t){let e;for(e in t)null!=t[e]&&(oC[e]=t[e])}oL.mode="html"===oC.parseMode?1:"sfc"===oC.parseMode?2:0,oL.inXML=1===oC.ns||2===oC.ns;let n=t&&t.delimiters;n&&(oL.delimiterOpen=s3(n[0]),oL.delimiterClose=s3(n[1]));let r=ok=function(e,t=""){return{type:0,source:t,children:e,helpers:/* @__PURE__ */new Set,components:[],directives:[],hoists:[],imports:[],cached:[],temps:0,codegenNode:void 0,loc:sj}}([],e);return oL.parse(oT),r.loc=oJ(0,e.length),r.children=oW(r.children),ok=null,r}(e,i):e,[s,o]=[[aN,ar,aI,au,ax,av,ah,ak],{on:aC,bind:ao,model:aw}];return!function(e,t){let n=function(e,{filename:t="",prefixIdentifiers:n=!1,hoistStatic:r=!1,hmr:i=!1,cacheHandlers:l=!1,nodeTransforms:s=[],directiveTransforms:o={},transformHoist:a=null,isBuiltInComponent:c=_,isCustomElement:u=_,expressionPlugins:d=[],scopeId:p=null,slotted:f=!0,ssr:h=!1,inSSR:m=!1,ssrCssVars:g="",bindingMetadata:b=y,inline:S=!1,isTS:x=!1,onError:C=s8,onWarn:k=s5,compatConfig:T}){let N=t.replace(/\?.*$/,"").match(/([^/\\]+)\.\w+$/),w={filename:t,selfName:N&&X(z(N[1])),prefixIdentifiers:n,hoistStatic:r,hmr:i,cacheHandlers:l,nodeTransforms:s,directiveTransforms:o,transformHoist:a,isBuiltInComponent:c,isCustomElement:u,expressionPlugins:d,scopeId:p,slotted:f,ssr:h,inSSR:m,ssrCssVars:g,bindingMetadata:b,inline:S,isTS:x,onError:C,onWarn:k,compatConfig:T,root:e,helpers:/* @__PURE__ */new Map,components:/* @__PURE__ */new Set,directives:/* @__PURE__ */new Set,hoists:[],imports:[],cached:[],constantCache:/* @__PURE__ */new WeakMap,temps:0,identifiers:/* @__PURE__ */Object.create(null),scopes:{vFor:0,vSlot:0,vPre:0,vOnce:0},parent:null,grandParent:null,currentNode:e,childIndex:0,inVOnce:!1,helper(e){let t=w.helpers.get(e)||0;return w.helpers.set(e,t+1),e},removeHelper(e){let t=w.helpers.get(e);if(t){let n=t-1;n?w.helpers.set(e,n):w.helpers.delete(e)}},helperString:e=>`_${sU[w.helper(e)]}`,replaceNode(e){w.parent.children[w.childIndex]=w.currentNode=e},removeNode(e){let t=w.parent.children,n=e?t.indexOf(e):w.currentNode?w.childIndex:-1;e&&e!==w.currentNode?w.childIndex>n&&(w.childIndex--,w.onNodeRemoved()):(w.currentNode=null,w.onNodeRemoved()),w.parent.children.splice(n,1)},onNodeRemoved:_,addIdentifiers(e){},removeIdentifiers(e){},hoist(e){M(e)&&(e=sz(e)),w.hoists.push(e);let t=sz(`_hoisted_${w.hoists.length}`,!1,e.loc,2);return t.hoisted=e,t},cache(e,t=!1){let n=function(e,t,n=!1){return{type:20,index:e,value:t,needPauseTracking:n,needArraySpread:!1,loc:sj}}(w.cached.length,e,t);return w.cached.push(n),n}};return w}(e,t);o6(e,n),t.hoistStatic&&function e(t,n,r,i=!1,l=!1){let{children:s}=t,o=[];for(let n=0;n<s.length;n++){let a=s[n];if(1===a.type&&0===a.tagType){let e=i?0:oY(a,r);if(e>0){if(e>=2){a.codegenNode.patchFlag=-1,o.push(a);continue}}else{let e=a.codegenNode;if(13===e.type){let t=e.patchFlag;if((void 0===t||512===t||1===t)&&o1(a,r)>=2){let t=o2(a);t&&(e.props=r.hoist(t))}e.dynamicProps&&(e.dynamicProps=r.hoist(e.dynamicProps))}}}else if(12===a.type&&(i?0:oY(a,r))>=2){o.push(a);continue}if(1===a.type){let n=1===a.tagType;n&&r.scopes.vSlot++,e(a,t,r,!1,l),n&&r.scopes.vSlot--}else if(11===a.type)e(a,t,r,1===a.children.length,!0);else if(9===a.type)for(let n=0;n<a.branches.length;n++)e(a.branches[n],t,r,1===a.branches[n].children.length,l)}let a=!1;if(o.length===s.length&&1===t.type){if(0===t.tagType&&t.codegenNode&&13===t.codegenNode.type&&A(t.codegenNode.children))t.codegenNode.children=c(sq(t.codegenNode.children)),a=!0;else if(1===t.tagType&&t.codegenNode&&13===t.codegenNode.type&&t.codegenNode.children&&!A(t.codegenNode.children)&&15===t.codegenNode.children.type){let e=u(t.codegenNode,"default");e&&(e.returns=c(sq(e.returns)),a=!0)}else if(3===t.tagType&&n&&1===n.type&&1===n.tagType&&n.codegenNode&&13===n.codegenNode.type&&n.codegenNode.children&&!A(n.codegenNode.children)&&15===n.codegenNode.children.type){let e=ou(t,"slot",!0),r=e&&e.arg&&u(n.codegenNode,e.arg);r&&(r.returns=c(sq(r.returns)),a=!0)}}if(!a)for(let e of o)e.codegenNode=r.cache(e.codegenNode);function c(e){let t=r.cache(e);return l&&r.hmr&&(t.needArraySpread=!0),t}function u(e,t){if(e.children&&!A(e.children)&&15===e.children.type){let n=e.children.properties.find(e=>e.key===t||e.key.content===t);return n&&n.value}}o.length&&r.transformHoist&&r.transformHoist(s,r,t)}(e,void 0,n,oZ(e,e.children[0])),t.ssr||function(e,t){let{helper:n}=t,{children:r}=e;if(1===r.length){let n=r[0];if(oZ(e,n)&&n.codegenNode){let r=n.codegenNode;13===r.type&&sZ(r,t),e.codegenNode=r}else e.codegenNode=n}else r.length>1&&(e.codegenNode=sH(t,n(sn),void 0,e.children,64,void 0,void 0,!0,void 0,!1))}(e,n),e.helpers=/* @__PURE__ */new Set([...n.helpers.keys()]),e.components=[...n.components],e.directives=[...n.directives],e.imports=n.imports,e.hoists=n.hoists,e.temps=n.temps,e.cached=n.cached,e.transformed=!0}(l,k({},i,{nodeTransforms:[...s,...t.nodeTransforms||[]],directiveTransforms:k({},o,t.directiveTransforms||{})})),function(e,t={}){let n=function(e,{mode:t="function",prefixIdentifiers:n="module"===t,sourceMap:r=!1,filename:i="template.vue.html",scopeId:l=null,optimizeImports:s=!1,runtimeGlobalName:o="Vue",runtimeModuleName:a="vue",ssrRuntimeModuleName:c="vue/server-renderer",ssr:u=!1,isTS:d=!1,inSSR:p=!1}){let f={mode:t,prefixIdentifiers:n,sourceMap:r,filename:i,scopeId:l,optimizeImports:s,runtimeGlobalName:o,runtimeModuleName:a,ssrRuntimeModuleName:c,ssr:u,isTS:d,inSSR:p,source:e.source,code:"",column:1,line:1,offset:0,indentLevel:0,pure:!1,map:void 0,helper:e=>`_${sU[e]}`,push(e,t=-2,n){f.code+=e},indent(){h(++f.indentLevel)},deindent(e=!1){e?--f.indentLevel:h(--f.indentLevel)},newline(){h(f.indentLevel)}};function h(e){f.push("\n"+"  ".repeat(e),0)}return f}(e,t);t.onContextCreated&&t.onContextCreated(n);let{mode:r,push:i,prefixIdentifiers:l,indent:s,deindent:o,newline:a,scopeId:c,ssr:u}=n,d=Array.from(e.helpers),p=d.length>0,f=!l&&"module"!==r;(function(e,t){let{ssr:n,prefixIdentifiers:r,push:i,newline:l,runtimeModuleName:s,runtimeGlobalName:o,ssrRuntimeModuleName:a}=t,c=Array.from(e.helpers);if(c.length>0&&(i(`const _Vue = ${o}
  `,-1),e.hoists.length)){let e=[su,sd,sp,sf,sh].filter(e=>c.includes(e)).map(o8).join(", ");i(`const { ${e} } = _Vue
  `,-1)}(function(e,t){if(!e.length)return;t.pure=!0;let{push:n,newline:r}=t;r();for(let i=0;i<e.length;i++){let l=e[i];l&&(n(`const _hoisted_${i+1} = `),ae(l,t),r())}t.pure=!1})(e.hoists,t),l(),i("return ")})(e,n);let h=(u?["_ctx","_push","_parent","_attrs"]:["_ctx","_cache"]).join(", ");if(i(`function ${u?"ssrRender":"render"}(${h}) {`),s(),f&&(i("with (_ctx) {"),s(),p&&(i(`const { ${d.map(o8).join(", ")} } = _Vue
  `,-1),a())),e.components.length&&(o5(e.components,"component",n),(e.directives.length||e.temps>0)&&a()),e.directives.length&&(o5(e.directives,"directive",n),e.temps>0&&a()),e.temps>0){i("let ");for(let t=0;t<e.temps;t++)i(`${t>0?", ":""}_temp${t}`)}return(e.components.length||e.directives.length||e.temps)&&(i(`
  `,0),a()),u||i("return "),e.codegenNode?ae(e.codegenNode,n):i("null"),f&&(o(),i("}")),o(),i("}"),{ast:e,code:n.code,preamble:"",map:n.map?n.map.toJSON():void 0}}(l,i)}(e,k({},aU,t,{nodeTransforms:[aG,...aX,...t.nodeTransforms||[]],directiveTransforms:k({},aQ,t.directiveTransforms||{}),transformHoist:null}))}(e,i),s=Function(l)();return s._rc=!0,aZ[n]=s}return iU(aY),e.BaseTransition=nb,e.BaseTransitionPropsValidators=ng,e.Comment=io,e.DeprecationTypes=null,e.EffectScope=ex,e.ErrorCodes={SETUP_FUNCTION:0,0:"SETUP_FUNCTION",RENDER_FUNCTION:1,1:"RENDER_FUNCTION",NATIVE_EVENT_HANDLER:5,5:"NATIVE_EVENT_HANDLER",COMPONENT_EVENT_HANDLER:6,6:"COMPONENT_EVENT_HANDLER",VNODE_HOOK:7,7:"VNODE_HOOK",DIRECTIVE_HOOK:8,8:"DIRECTIVE_HOOK",TRANSITION_HOOK:9,9:"TRANSITION_HOOK",APP_ERROR_HANDLER:10,10:"APP_ERROR_HANDLER",APP_WARN_HANDLER:11,11:"APP_WARN_HANDLER",FUNCTION_REF:12,12:"FUNCTION_REF",ASYNC_COMPONENT_LOADER:13,13:"ASYNC_COMPONENT_LOADER",SCHEDULER:14,14:"SCHEDULER",COMPONENT_UPDATE:15,15:"COMPONENT_UPDATE",APP_UNMOUNT_CLEANUP:16,16:"APP_UNMOUNT_CLEANUP"},e.ErrorTypeStrings=null,e.Fragment=il,e.KeepAlive={name:"KeepAlive",__isKeepAlive:!0,props:{include:[String,RegExp,Array],exclude:[String,RegExp,Array],max:[String,Number]},setup(e,{slots:t}){let n=iL(),r=n.ctx,i=/* @__PURE__ */new Map,l=/* @__PURE__ */new Set,s=null,o=n.suspense,{renderer:{p:a,m:c,um:u,o:{createElement:d}}}=r,p=d("div");function f(e){nJ(e),u(e,n,o,!0)}function h(e){i.forEach((t,n)=>{let r=iK(t.type);r&&!e(r)&&m(n)})}function m(e){let t=i.get(e);!t||s&&ib(t,s)?s&&nJ(s):f(t),i.delete(e),l.delete(e)}r.activate=(e,t,n,r,i)=>{let l=e.component;c(e,t,n,0,o),a(l.vnode,e,t,n,l,o,r,e.slotScopeIds,i),rV(()=>{l.isDeactivated=!1,l.a&&Y(l.a);let t=e.props&&e.props.onVnodeMounted;t&&iR(t,l.parent,e)},o)},r.deactivate=e=>{let t=e.component;rK(t.m),rK(t.a),c(e,p,null,1,o),rV(()=>{t.da&&Y(t.da);let n=e.props&&e.props.onVnodeUnmounted;n&&iR(n,t.parent,e),t.isDeactivated=!0},o)},rX(()=>[e.include,e.exclude],([e,t])=>{e&&h(t=>nq(e,t)),t&&h(e=>!nq(t,e))},{flush:"post",deep:!0});let g=null,y=()=>{null!=g&&(r5(n.subTree.type)?rV(()=>{i.set(g,nG(n.subTree))},n.subTree.suspense):i.set(g,nG(n.subTree)))};return nY(y),n1(y),n2(()=>{i.forEach(e=>{let{subTree:t,suspense:r}=n,i=nG(t);if(e.type===i.type&&e.key===i.key){nJ(i);let e=i.component.da;e&&rV(e,r);return}f(e)})}),()=>{if(g=null,!t.default)return s=null;let n=t.default(),r=n[0];if(n.length>1)return s=null,n;if(!iv(r)||!(4&r.shapeFlag)&&!(128&r.shapeFlag))return s=null,r;let o=nG(r);if(o.type===io)return s=null,o;let a=o.type,c=iK(nU(o)?o.type.__asyncResolved||{}:a),{include:u,exclude:d,max:p}=e;if(u&&(!c||!nq(u,c))||d&&c&&nq(d,c))return o.shapeFlag&=-257,s=o,r;let f=null==o.key?a:o.key,h=i.get(f);return o.el&&(o=iT(o),128&r.shapeFlag&&(r.ssContent=o)),g=f,h?(o.el=h.el,o.component=h.component,o.transition&&nk(o,o.transition),o.shapeFlag|=512,l.delete(f),l.add(f)):(l.add(f),p&&l.size>parseInt(p,10)&&m(l.values().next().value)),o.shapeFlag|=256,s=o,r5(r.type)?r:o}}},e.ReactiveEffect=ek,e.Static=ia,e.Suspense={name:"Suspense",__isSuspense:!0,process(e,t,n,r,i,l,s,o,a,c){if(null==e)(function(e,t,n,r,i,l,s,o,a){let{p:c,o:{createElement:u}}=a,d=u("div"),p=e.suspense=ie(e,i,r,t,d,n,l,s,o,a);c(null,p.pendingBranch=e.ssContent,d,null,r,p,l,s),p.deps>0?(r7(e,"onPending"),r7(e,"onFallback"),c(null,e.ssFallback,t,n,r,null,l,s),ii(p,e.ssFallback)):p.resolve(!1,!0)})(t,n,r,i,l,s,o,a,c);else{if(l&&l.deps>0&&!e.suspense.isInFallback){t.suspense=e.suspense,t.suspense.vnode=t,t.el=e.el;return}(function(e,t,n,r,i,l,s,o,{p:a,um:c,o:{createElement:u}}){let d=t.suspense=e.suspense;d.vnode=t,t.el=e.el;let p=t.ssContent,f=t.ssFallback,{activeBranch:h,pendingBranch:m,isInFallback:g,isHydrating:y}=d;if(m)d.pendingBranch=p,ib(p,m)?(a(m,p,d.hiddenContainer,null,i,d,l,s,o),d.deps<=0?d.resolve():g&&!y&&(a(h,f,n,r,i,null,l,s,o),ii(d,f))):(d.pendingId=r9++,y?(d.isHydrating=!1,d.activeBranch=m):c(m,i,d),d.deps=0,d.effects.length=0,d.hiddenContainer=u("div"),g?(a(null,p,d.hiddenContainer,null,i,d,l,s,o),d.deps<=0?d.resolve():(a(h,f,n,r,i,null,l,s,o),ii(d,f))):h&&ib(p,h)?(a(h,p,n,r,i,d,l,s,o),d.resolve(!0)):(a(null,p,d.hiddenContainer,null,i,d,l,s,o),d.deps<=0&&d.resolve()));else if(h&&ib(p,h))a(h,p,n,r,i,d,l,s,o),ii(d,p);else if(r7(t,"onPending"),d.pendingBranch=p,512&p.shapeFlag?d.pendingId=p.component.suspenseId:d.pendingId=r9++,a(null,p,d.hiddenContainer,null,i,d,l,s,o),d.deps<=0)d.resolve();else{let{timeout:e,pendingId:t}=d;e>0?setTimeout(()=>{d.pendingId===t&&d.fallback(f)},e):0===e&&d.fallback(f)}})(e,t,n,r,i,s,o,a,c)}},hydrate:function(e,t,n,r,i,l,s,o,a){let c=t.suspense=ie(t,r,n,e.parentNode,document.createElement("div"),null,i,l,s,o,!0),u=a(e,c.pendingBranch=t.ssContent,n,c,l,s);return 0===c.deps&&c.resolve(!1,!0),u},normalize:function(e){let{shapeFlag:t,children:n}=e,r=32&t;e.ssContent=it(r?n.default:n),e.ssFallback=r?it(n.fallback):iC(io)}},e.Teleport={name:"Teleport",__isTeleport:!0,process(e,t,n,r,i,l,s,o,a,c){let{mc:u,pc:d,pbc:p,o:{insert:f,querySelector:h,createText:m,createComment:g}}=c,y=ni(t.props),{shapeFlag:b,children:_,dynamicChildren:S}=t;if(null==e){let e=t.el=m(""),c=t.anchor=m("");f(e,n,r),f(c,n,r);let d=(e,t)=>{16&b&&(i&&i.isCE&&(i.ce._teleportTarget=e),u(_,e,t,i,l,s,o,a))},p=()=>{let e=t.target=na(t.props,h),n=nd(e,t,m,f);e&&("svg"!==s&&ns(e)?s="svg":"mathml"!==s&&no(e)&&(s="mathml"),y||(d(e,n),nu(t,!1)))};y&&(d(n,c),nu(t,!0)),nl(t.props)?rV(p,l):p()}else{t.el=e.el,t.targetStart=e.targetStart;let r=t.anchor=e.anchor,u=t.target=e.target,f=t.targetAnchor=e.targetAnchor,m=ni(e.props),g=m?n:u;if("svg"===s||ns(u)?s="svg":("mathml"===s||no(u))&&(s="mathml"),S?(p(e.dynamicChildren,S,g,i,l,s,o),rW(e,t,!0)):a||d(e,t,g,m?r:f,i,l,s,o,!1),y)m?t.props&&e.props&&t.props.to!==e.props.to&&(t.props.to=e.props.to):nc(t,n,r,c,1);else if((t.props&&t.props.to)!==(e.props&&e.props.to)){let e=t.target=na(t.props,h);e&&nc(t,e,null,c,0)}else m&&nc(t,u,f,c,1);nu(t,y)}},remove(e,t,n,{um:r,o:{remove:i}},l){let{shapeFlag:s,children:o,anchor:a,targetStart:c,targetAnchor:u,target:d,props:p}=e;if(d&&(i(c),i(u)),l&&i(a),16&s){let e=l||!ni(p);for(let i=0;i<o.length;i++){let l=o[i];r(l,t,n,e,!!l.dynamicChildren)}}},move:nc,hydrate:function(e,t,n,r,i,l,{o:{nextSibling:s,parentNode:o,querySelector:a,insert:c,createText:u}},d){let p=t.target=na(t.props,a);if(p){let a=ni(t.props),f=p._lpa||p.firstChild;if(16&t.shapeFlag){if(a)t.anchor=d(s(e),t,o(e),n,r,i,l),t.targetStart=f,t.targetAnchor=f&&s(f);else{t.anchor=s(e);let o=f;for(;o;){if(o&&8===o.nodeType){if("teleport start anchor"===o.data)t.targetStart=o;else if("teleport anchor"===o.data){t.targetAnchor=o,p._lpa=t.targetAnchor&&s(t.targetAnchor);break}}o=s(o)}t.targetAnchor||nd(p,t,u,c),d(f&&s(f),t,p,n,r,i,l)}}nu(t,a)}return t.anchor&&s(t.anchor)}},e.Text=is,e.TrackOpTypes={GET:"get",HAS:"has",ITERATE:"iterate"},e.Transition=i8,e.TransitionGroup=lF,e.TriggerOpTypes={SET:"set",ADD:"add",DELETE:"delete",CLEAR:"clear"},e.VueElement=lO,e.assertNumber=function(e,t){},e.callWithAsyncErrorHandling=tW,e.callWithErrorHandling=tq,e.camelize=z,e.capitalize=X,e.cloneVNode=iT,e.compatUtils=null,e.compile=aY,e.computed=iz,e.createApp=l9,e.createBlock=iy,e.createCommentVNode=function(e="",t=!1){return t?(id(),iy(io,null,e)):iC(io,null,e)},e.createElementBlock=function(e,t,n,r,i,l){return ig(ix(e,t,n,r,i,l,!0))},e.createElementVNode=ix,e.createHydrationRenderer=rB,e.createPropsRestProxy=function(e,t){let n={};for(let r in e)t.includes(r)||Object.defineProperty(n,r,{enumerable:!0,get:()=>e[r]});return n},e.createRenderer=function(e){return rU(e)},e.createSSRApp=l7,e.createSlots=function(e,t){for(let n=0;n<t.length;n++){let r=t[n];if(A(r))for(let t=0;t<r.length;t++)e[r[t].name]=r[t].fn;else r&&(e[r.name]=r.key?(...e)=>{let t=r.fn(...e);return t&&(t.key=r.key),t}:r.fn)}return e},e.createStaticVNode=function(e,t){let n=iC(ia,null,e);return n.staticCount=t,n},e.createTextVNode=iN,e.createVNode=iC,e.customRef=tL,e.defineAsyncComponent=/*! #__NO_SIDE_EFFECTS__ */function(e){let t;P(e)&&(e={loader:e});let{loader:n,loadingComponent:r,errorComponent:i,delay:l=200,hydrate:s,timeout:o,suspensible:a=!0,onError:c}=e,u=null,d=0,p=()=>(d++,u=null,f()),f=()=>{let e;return u||(e=u=n().catch(e=>{if(e=e instanceof Error?e:Error(String(e)),c)return new Promise((t,n)=>{c(e,()=>t(p()),()=>n(e),d+1)});throw e}).then(n=>e!==u&&u?u:(n&&(n.__esModule||"Module"===n[Symbol.toStringTag])&&(n=n.default),t=n,n)))};return nN({name:"AsyncComponentWrapper",__asyncLoader:f,__asyncHydrate(e,n,r){let i=s?()=>{let t=s(r,t=>(function(e,t){if(nM(e)&&"["===e.data){let n=1,r=e.nextSibling;for(;r;){if(1===r.nodeType){if(!1===t(r))break}else if(nM(r)){if("]"===r.data){if(0==--n)break}else"["===r.data&&n++}r=r.nextSibling}}else t(e)})(e,t));t&&(n.bum||(n.bum=[])).push(t)}:r;t?i():f().then(()=>!n.isUnmounted&&i())},get __asyncResolved(){return t},setup(){let e=iM;if(nw(e),t)return()=>nj(t,e);let n=t=>{u=null,tK(t,e,13,!i)};if(a&&e.suspense)return f().then(t=>()=>nj(t,e)).catch(e=>(n(e),()=>i?iC(i,{error:e}):null));let s=tw(!1),c=tw(),d=tw(!!l);return l&&setTimeout(()=>{d.value=!1},l),null!=o&&setTimeout(()=>{if(!s.value&&!c.value){let e=Error(`Async component timed out after ${o}ms.`);n(e),c.value=e}},o),f().then(()=>{s.value=!0,e.parent&&nH(e.parent.vnode)&&e.parent.update()}).catch(e=>{n(e),c.value=e}),()=>s.value&&t?nj(t,e):c.value&&i?iC(i,{error:c.value}):r&&!d.value?iC(r):void 0}})},e.defineComponent=nN,e.defineCustomElement=lI,e.defineEmits=function(){return null},e.defineExpose=function(e){},e.defineModel=function(){},e.defineOptions=function(e){},e.defineProps=function(){return null},e.defineSSRCustomElement=(e,t)=>/* @__PURE__ */lI(e,t,l7),e.defineSlots=function(){return null},e.devtools=void 0,e.effect=function(e,t){e.effect instanceof ek&&(e=e.effect.fn);let n=new ek(e);t&&k(n,t);try{n.run()}catch(e){throw n.stop(),e}let r=n.run.bind(n);return r.effect=n,r},e.effectScope=function(e){return new ex(e)},e.getCurrentInstance=iL,e.getCurrentScope=function(){return i},e.getCurrentWatcher=function(){return h},e.getTransitionRawChildren=nT,e.guardReactiveProps=ik,e.h=iJ,e.handleError=tK,e.hasInjectionContext=function(){return!!(iM||t5||rS)},e.hydrate=(...e)=>{l8().hydrate(...e)},e.hydrateOnIdle=(e=1e4)=>t=>{let n=nV(t,{timeout:e});return()=>nB(n)},e.hydrateOnInteraction=(e=[])=>(t,n)=>{M(e)&&(e=[e]);let r=!1,i=e=>{r||(r=!0,l(),t(),e.target.dispatchEvent(new e.constructor(e.type,e)))},l=()=>{n(t=>{for(let n of e)t.removeEventListener(n,i)})};return n(t=>{for(let n of e)t.addEventListener(n,i,{once:!0})}),l},e.hydrateOnMediaQuery=e=>t=>{if(e){let n=matchMedia(e);if(!n.matches)return n.addEventListener("change",t,{once:!0}),()=>n.removeEventListener("change",t);t()}},e.hydrateOnVisible=e=>(t,n)=>{let r=new IntersectionObserver(e=>{for(let n of e)if(n.isIntersecting){r.disconnect(),t();break}},e);return n(e=>{if(e instanceof Element){if(function(e){let{top:t,left:n,bottom:r,right:i}=e.getBoundingClientRect(),{innerHeight:l,innerWidth:s}=window;return(t>0&&t<l||r>0&&r<l)&&(n>0&&n<s||i>0&&i<s)}(e))return t(),r.disconnect(),!1;r.observe(e)}}),()=>r.disconnect()},e.initCustomFormatter=function(){},e.initDirectivesForSSR=_,e.inject=rC,e.isMemoSame=iG,e.isProxy=tS,e.isReactive=tv,e.isReadonly=tb,e.isRef=tN,e.isRuntimeOnly=()=>!u,e.isShallow=t_,e.isVNode=iv,e.markRaw=tC,e.mergeDefaults=function(e,t){let n=ra(e);for(let e in t){if(e.startsWith("__skip"))continue;let r=n[e];r?A(r)||P(r)?r=n[e]={type:r,default:t[e]}:r.default=t[e]:null===r&&(r=n[e]={default:t[e]}),r&&t[`__skip_${e}`]&&(r.skipFactory=!0)}return n},e.mergeModels=function(e,t){return e&&t?A(e)&&A(t)?e.concat(t):k({},ra(e),ra(t)):e||t},e.mergeProps=iI,e.nextTick=t0,e.normalizeClass=eu,e.normalizeProps=function(e){if(!e)return null;let{class:t,style:n}=e;return t&&!M(t)&&(e.class=eu(t)),n&&(e.style=el(n)),e},e.normalizeStyle=el,e.onActivated=nW,e.onBeforeMount=nZ,e.onBeforeUnmount=n2,e.onBeforeUpdate=n0,e.onDeactivated=nK,e.onErrorCaptured=n5,e.onMounted=nY,e.onRenderTracked=n8,e.onRenderTriggered=n4,e.onScopeDispose=function(e,t=!1){i&&i.cleanups.push(e)},e.onServerPrefetch=n3,e.onUnmounted=n6,e.onUpdated=n1,e.onWatcherCleanup=tj,e.openBlock=id,e.popScopeId=function(){t9=null},e.provide=rx,e.proxyRefs=tP,e.pushScopeId=function(e){t9=e},e.queuePostFlushCb=t6,e.reactive=th,e.readonly=tg,e.ref=tw,e.registerRuntimeCompiler=iU,e.render=l5,e.renderList=function(e,t,n,r){let i;let l=n&&n[r],s=A(e);if(s||M(e)){let n=s&&tv(e),r=!1;n&&(r=!t_(e),e=eJ(e)),i=Array(e.length);for(let n=0,s=e.length;n<s;n++)i[n]=t(r?tk(e[n]):e[n],n,void 0,l&&l[n])}else if("number"==typeof e){i=Array(e);for(let n=0;n<e;n++)i[n]=t(n+1,n,void 0,l&&l[n])}else if($(e)){if(e[Symbol.iterator])i=Array.from(e,(e,n)=>t(e,n,void 0,l&&l[n]));else{let n=Object.keys(e);i=Array(n.length);for(let r=0,s=n.length;r<s;r++){let s=n[r];i[r]=t(e[s],s,r,l&&l[r])}}}else i=[];return n&&(n[r]=i),i},e.renderSlot=function(e,t,n={},r,i){if(t5.ce||t5.parent&&nU(t5.parent)&&t5.parent.ce)return"default"!==t&&(n.name=t),id(),iy(il,null,[iC("slot",n,r&&r())],64);let l=e[t];l&&l._c&&(l._d=!1),id();let s=l&&function e(t){return t.some(t=>!iv(t)||!!(t.type!==io&&(t.type!==il||e(t.children))))?t:null}(l(n)),o=n.key||s&&s.key,a=iy(il,{key:(o&&!L(o)?o:`_${t}`)+(!s&&r?"_fb":"")},s||(r?r():[]),s&&1===e._?64:-2);return!i&&a.scopeId&&(a.slotScopeIds=[a.scopeId+"-s"]),l&&l._c&&(l._d=!0),a},e.resolveComponent=function(e,t){return re(n9,e,!0,t)||e},e.resolveDirective=function(e){return re("directives",e)},e.resolveDynamicComponent=function(e){return M(e)?re(n9,e,!1)||e:e||n7},e.resolveFilter=null,e.resolveTransitionHooks=nS,e.setBlockTracking=im,e.setDevtoolsHook=_,e.setTransitionHooks=nk,e.shallowReactive=tm,e.shallowReadonly=function(e){return ty(e,!0,tt,tc,tf)},e.shallowRef=tA,e.ssrContextKey=rz,e.ssrUtils=null,e.stop=function(e){e.effect.stop()},e.toDisplayString=eb,e.toHandlerKey=Q,e.toHandlers=function(e,t){let n={};for(let r in e)n[t&&/[A-Z]/.test(r)?`on:${r}`:Q(r)]=e[r];return n},e.toRaw=tx,e.toRef=function(e,t,n){return tN(e)?e:P(e)?new tD(e):$(e)&&arguments.length>1?tF(e,t,n):tw(e)},e.toRefs=function(e){let t=A(e)?Array(e.length):{};for(let n in e)t[n]=tF(e,n);return t},e.toValue=function(e){return P(e)?e():tR(e)},e.transformVNodeArgs=function(e){},e.triggerRef=function(e){e.dep&&e.dep.trigger()},e.unref=tR,e.useAttrs=function(){return ro().attrs},e.useCssModule=function(e="$style"){return y},e.useCssVars=function(e){let t=iL();if(!t)return;let n=t.ut=(n=e(t.proxy))=>{Array.from(document.querySelectorAll(`[data-v-owner="${t.uid}"]`)).forEach(e=>lf(e,n))},r=()=>{let r=e(t.proxy);t.ce?lf(t.ce,r):function e(t,n){if(128&t.shapeFlag){let r=t.suspense;t=r.activeBranch,r.pendingBranch&&!r.isHydrating&&r.effects.push(()=>{e(r.activeBranch,n)})}for(;t.component;)t=t.component.subTree;if(1&t.shapeFlag&&t.el)lf(t.el,n);else if(t.type===il)t.children.forEach(t=>e(t,n));else if(t.type===ia){let{el:e,anchor:r}=t;for(;e&&(lf(e,n),e!==r);)e=e.nextSibling}}(t.subTree,r),n(r)};nZ(()=>{rJ(r)}),nY(()=>{let e=new MutationObserver(r);e.observe(t.subTree.el.parentNode,{childList:!0}),n6(()=>e.disconnect())})},e.useHost=lP,e.useId=function(){let e=iL();return e?(e.appContext.config.idPrefix||"v")+"-"+e.ids[0]+e.ids[1]++:""},e.useModel=function(e,t,n=y){let r=iL(),i=z(t),l=G(t),s=rY(e,i),o=tL((s,o)=>{let a,c;let u=y;return rG(()=>{let t=e[i];Z(a,t)&&(a=t,o())}),{get:()=>(s(),n.get?n.get(a):a),set(e){let s=n.set?n.set(e):e;if(!Z(s,a)&&!(u!==y&&Z(e,u)))return;let d=r.vnode.props;d&&(t in d||i in d||l in d)&&(`onUpdate:${t}` in d||`onUpdate:${i}` in d||`onUpdate:${l}` in d)||(a=e,o()),r.emit(`update:${t}`,s),Z(e,s)&&Z(e,u)&&!Z(s,c)&&o(),u=e,c=s}}});return o[Symbol.iterator]=()=>{let e=0;return{next:()=>e<2?{value:e++?s||y:o,done:!1}:{done:!0}}},o},e.useSSRContext=()=>{},e.useShadowRoot=function(){let e=lP();return e&&e.shadowRoot},e.useSlots=function(){return ro().slots},e.useTemplateRef=function(e){let t=iL(),n=tA(null);return t&&Object.defineProperty(t.refs===y?t.refs={}:t.refs,e,{enumerable:!0,get:()=>n.value,set:e=>n.value=e}),n},e.useTransitionState=nh,e.vModelCheckbox=lz,e.vModelDynamic={created(e,t,n){l0(e,t,n,null,"created")},mounted(e,t,n){l0(e,t,n,null,"mounted")},beforeUpdate(e,t,n,r){l0(e,t,n,r,"beforeUpdate")},updated(e,t,n,r){l0(e,t,n,r,"updated")}},e.vModelRadio=lG,e.vModelSelect=lX,e.vModelText=lK,e.vShow={beforeMount(e,{value:t},{transition:n}){e[lc]="none"===e.style.display?"":e.style.display,n&&t?n.beforeEnter(e):ld(e,t)},mounted(e,{value:t},{transition:n}){n&&t&&n.enter(e)},updated(e,{value:t,oldValue:n},{transition:r}){!t!=!n&&(r?t?(r.beforeEnter(e),ld(e,!0),r.enter(e)):r.leave(e,()=>{ld(e,!1)}):ld(e,t))},beforeUnmount(e,{value:t}){ld(e,t)}},e.version=iX,e.warn=_,e.watch=function(e,t,n){return rX(e,t,n)},e.watchEffect=function(e,t){return rX(e,null,t)},e.watchPostEffect=rJ,e.watchSyncEffect=rG,e.withAsyncContext=function(e){let t=iL(),n=e();return iD(),D(n)&&(n=n.catch(e=>{throw i$(t),e})),[n,()=>i$(t)]},e.withCtx=ne,e.withDefaults=function(e,t){return null},e.withDirectives=function(e,t){if(null===t5)return e;let n=iW(t5),r=e.dirs||(e.dirs=[]);for(let e=0;e<t.length;e++){let[i,l,s,o=y]=t[e];i&&(P(i)&&(i={mounted:i,updated:i}),i.deep&&tH(l),r.push({dir:i,instance:n,value:l,oldValue:void 0,arg:s,modifiers:o}))}return e},e.withKeys=(e,t)=>{let n=e._withKeys||(e._withKeys={}),r=t.join(".");return n[r]||(n[r]=n=>{if(!("key"in n))return;let r=G(n.key);if(t.some(e=>e===r||l6[e]===r))return e(n)})},e.withMemo=function(e,t,n,r){let i=n[r];if(i&&iG(i,e))return i;let l=t();return l.memo=e.slice(),l.cacheIndex=r,n[r]=l},e.withModifiers=(e,t)=>{let n=e._withMods||(e._withMods={}),r=t.join(".");return n[r]||(n[r]=(n,...r)=>{for(let e=0;e<t.length;e++){let r=l2[t[e]];if(r&&r(n,t))return}return e(n,...r)})},e.withScopeId=e=>ne,e}({});

/* axios v0.21.4 | (c) 2021 by Matt Zabriskie */
!function(e,t){"object"==typeof exports&&"object"==typeof module?module.exports=t():"function"==typeof define&&define.amd?define([],t):"object"==typeof exports?exports.axios=t():e.axios=t()}(window,(function(){return function(e){var t={};function r(n){if(t[n])return t[n].exports;var o=t[n]={i:n,l:!1,exports:{}};return e[n].call(o.exports,o,o.exports,r),o.l=!0,o.exports}return r.m=e,r.c=t,r.d=function(e,t,n){r.o(e,t)||Object.defineProperty(e,t,{enumerable:!0,get:n})},r.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},r.t=function(e,t){if(1&t&&(e=r(e)),8&t)return e;if(4&t&&"object"==typeof e&&e&&e.__esModule)return e;var n=Object.create(null);if(r.r(n),Object.defineProperty(n,"default",{enumerable:!0,value:e}),2&t&&"string"!=typeof e)for(var o in e)r.d(n,o,function(t){return e[t]}.bind(null,o));return n},r.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return r.d(t,"a",t),t},r.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},r.p="",r(r.s=10)}([function(e,t,r){"use strict";var n=r(2),o=Object.prototype.toString;function i(e){return"[object Array]"===o.call(e)}function s(e){return void 0===e}function a(e){return null!==e&&"object"==typeof e}function u(e){if("[object Object]"!==o.call(e))return!1;var t=Object.getPrototypeOf(e);return null===t||t===Object.prototype}function c(e){return"[object Function]"===o.call(e)}function f(e,t){if(null!=e)if("object"!=typeof e&&(e=[e]),i(e))for(var r=0,n=e.length;r<n;r++)t.call(null,e[r],r,e);else for(var o in e)Object.prototype.hasOwnProperty.call(e,o)&&t.call(null,e[o],o,e)}e.exports={isArray:i,isArrayBuffer:function(e){return"[object ArrayBuffer]"===o.call(e)},isBuffer:function(e){return null!==e&&!s(e)&&null!==e.constructor&&!s(e.constructor)&&"function"==typeof e.constructor.isBuffer&&e.constructor.isBuffer(e)},isFormData:function(e){return"undefined"!=typeof FormData&&e instanceof FormData},isArrayBufferView:function(e){return"undefined"!=typeof ArrayBuffer&&ArrayBuffer.isView?ArrayBuffer.isView(e):e&&e.buffer&&e.buffer instanceof ArrayBuffer},isString:function(e){return"string"==typeof e},isNumber:function(e){return"number"==typeof e},isObject:a,isPlainObject:u,isUndefined:s,isDate:function(e){return"[object Date]"===o.call(e)},isFile:function(e){return"[object File]"===o.call(e)},isBlob:function(e){return"[object Blob]"===o.call(e)},isFunction:c,isStream:function(e){return a(e)&&c(e.pipe)},isURLSearchParams:function(e){return"undefined"!=typeof URLSearchParams&&e instanceof URLSearchParams},isStandardBrowserEnv:function(){return("undefined"==typeof navigator||"ReactNative"!==navigator.product&&"NativeScript"!==navigator.product&&"NS"!==navigator.product)&&("undefined"!=typeof window&&"undefined"!=typeof document)},forEach:f,merge:function e(){var t={};function r(r,n){u(t[n])&&u(r)?t[n]=e(t[n],r):u(r)?t[n]=e({},r):i(r)?t[n]=r.slice():t[n]=r}for(var n=0,o=arguments.length;n<o;n++)f(arguments[n],r);return t},extend:function(e,t,r){return f(t,(function(t,o){e[o]=r&&"function"==typeof t?n(t,r):t})),e},trim:function(e){return e.trim?e.trim():e.replace(/^\s+|\s+$/g,"")},stripBOM:function(e){return 65279===e.charCodeAt(0)&&(e=e.slice(1)),e}}},function(e,t,r){"use strict";var n=r(0),o=r(16),i=r(4),s={"Content-Type":"application/x-www-form-urlencoded"};function a(e,t){!n.isUndefined(e)&&n.isUndefined(e["Content-Type"])&&(e["Content-Type"]=t)}var u,c={transitional:{silentJSONParsing:!0,forcedJSONParsing:!0,clarifyTimeoutError:!1},adapter:(("undefined"!=typeof XMLHttpRequest||"undefined"!=typeof process&&"[object process]"===Object.prototype.toString.call(process))&&(u=r(5)),u),transformRequest:[function(e,t){return o(t,"Accept"),o(t,"Content-Type"),n.isFormData(e)||n.isArrayBuffer(e)||n.isBuffer(e)||n.isStream(e)||n.isFile(e)||n.isBlob(e)?e:n.isArrayBufferView(e)?e.buffer:n.isURLSearchParams(e)?(a(t,"application/x-www-form-urlencoded;charset=utf-8"),e.toString()):n.isObject(e)||t&&"application/json"===t["Content-Type"]?(a(t,"application/json"),function(e,t,r){if(n.isString(e))try{return(t||JSON.parse)(e),n.trim(e)}catch(e){if("SyntaxError"!==e.name)throw e}return(r||JSON.stringify)(e)}(e)):e}],transformResponse:[function(e){var t=this.transitional,r=t&&t.silentJSONParsing,o=t&&t.forcedJSONParsing,s=!r&&"json"===this.responseType;if(s||o&&n.isString(e)&&e.length)try{return JSON.parse(e)}catch(e){if(s){if("SyntaxError"===e.name)throw i(e,this,"E_JSON_PARSE");throw e}}return e}],timeout:0,xsrfCookieName:"XSRF-TOKEN",xsrfHeaderName:"X-XSRF-TOKEN",maxContentLength:-1,maxBodyLength:-1,validateStatus:function(e){return e>=200&&e<300}};c.headers={common:{Accept:"application/json, text/plain, */*"}},n.forEach(["delete","get","head"],(function(e){c.headers[e]={}})),n.forEach(["post","put","patch"],(function(e){c.headers[e]=n.merge(s)})),e.exports=c},function(e,t,r){"use strict";e.exports=function(e,t){return function(){for(var r=new Array(arguments.length),n=0;n<r.length;n++)r[n]=arguments[n];return e.apply(t,r)}}},function(e,t,r){"use strict";var n=r(0);function o(e){return encodeURIComponent(e).replace(/%3A/gi,":").replace(/%24/g,"$").replace(/%2C/gi,",").replace(/%20/g,"+").replace(/%5B/gi,"[").replace(/%5D/gi,"]")}e.exports=function(e,t,r){if(!t)return e;var i;if(r)i=r(t);else if(n.isURLSearchParams(t))i=t.toString();else{var s=[];n.forEach(t,(function(e,t){null!=e&&(n.isArray(e)?t+="[]":e=[e],n.forEach(e,(function(e){n.isDate(e)?e=e.toISOString():n.isObject(e)&&(e=JSON.stringify(e)),s.push(o(t)+"="+o(e))})))})),i=s.join("&")}if(i){var a=e.indexOf("#");-1!==a&&(e=e.slice(0,a)),e+=(-1===e.indexOf("?")?"?":"&")+i}return e}},function(e,t,r){"use strict";e.exports=function(e,t,r,n,o){return e.config=t,r&&(e.code=r),e.request=n,e.response=o,e.isAxiosError=!0,e.toJSON=function(){return{message:this.message,name:this.name,description:this.description,number:this.number,fileName:this.fileName,lineNumber:this.lineNumber,columnNumber:this.columnNumber,stack:this.stack,config:this.config,code:this.code}},e}},function(e,t,r){"use strict";var n=r(0),o=r(17),i=r(18),s=r(3),a=r(19),u=r(22),c=r(23),f=r(6);e.exports=function(e){return new Promise((function(t,r){var p=e.data,l=e.headers,d=e.responseType;n.isFormData(p)&&delete l["Content-Type"];var h=new XMLHttpRequest;if(e.auth){var m=e.auth.username||"",g=e.auth.password?unescape(encodeURIComponent(e.auth.password)):"";l.Authorization="Basic "+btoa(m+":"+g)}var v=a(e.baseURL,e.url);function y(){if(h){var n="getAllResponseHeaders"in h?u(h.getAllResponseHeaders()):null,i={data:d&&"text"!==d&&"json"!==d?h.response:h.responseText,status:h.status,statusText:h.statusText,headers:n,config:e,request:h};o(t,r,i),h=null}}if(h.open(e.method.toUpperCase(),s(v,e.params,e.paramsSerializer),!0),h.timeout=e.timeout,"onloadend"in h?h.onloadend=y:h.onreadystatechange=function(){h&&4===h.readyState&&(0!==h.status||h.responseURL&&0===h.responseURL.indexOf("file:"))&&setTimeout(y)},h.onabort=function(){h&&(r(f("Request aborted",e,"ECONNABORTED",h)),h=null)},h.onerror=function(){r(f("Network Error",e,null,h)),h=null},h.ontimeout=function(){var t="timeout of "+e.timeout+"ms exceeded";e.timeoutErrorMessage&&(t=e.timeoutErrorMessage),r(f(t,e,e.transitional&&e.transitional.clarifyTimeoutError?"ETIMEDOUT":"ECONNABORTED",h)),h=null},n.isStandardBrowserEnv()){var b=(e.withCredentials||c(v))&&e.xsrfCookieName?i.read(e.xsrfCookieName):void 0;b&&(l[e.xsrfHeaderName]=b)}"setRequestHeader"in h&&n.forEach(l,(function(e,t){void 0===p&&"content-type"===t.toLowerCase()?delete l[t]:h.setRequestHeader(t,e)})),n.isUndefined(e.withCredentials)||(h.withCredentials=!!e.withCredentials),d&&"json"!==d&&(h.responseType=e.responseType),"function"==typeof e.onDownloadProgress&&h.addEventListener("progress",e.onDownloadProgress),"function"==typeof e.onUploadProgress&&h.upload&&h.upload.addEventListener("progress",e.onUploadProgress),e.cancelToken&&e.cancelToken.promise.then((function(e){h&&(h.abort(),r(e),h=null)})),p||(p=null),h.send(p)}))}},function(e,t,r){"use strict";var n=r(4);e.exports=function(e,t,r,o,i){var s=new Error(e);return n(s,t,r,o,i)}},function(e,t,r){"use strict";e.exports=function(e){return!(!e||!e.__CANCEL__)}},function(e,t,r){"use strict";var n=r(0);e.exports=function(e,t){t=t||{};var r={},o=["url","method","data"],i=["headers","auth","proxy","params"],s=["baseURL","transformRequest","transformResponse","paramsSerializer","timeout","timeoutMessage","withCredentials","adapter","responseType","xsrfCookieName","xsrfHeaderName","onUploadProgress","onDownloadProgress","decompress","maxContentLength","maxBodyLength","maxRedirects","transport","httpAgent","httpsAgent","cancelToken","socketPath","responseEncoding"],a=["validateStatus"];function u(e,t){return n.isPlainObject(e)&&n.isPlainObject(t)?n.merge(e,t):n.isPlainObject(t)?n.merge({},t):n.isArray(t)?t.slice():t}function c(o){n.isUndefined(t[o])?n.isUndefined(e[o])||(r[o]=u(void 0,e[o])):r[o]=u(e[o],t[o])}n.forEach(o,(function(e){n.isUndefined(t[e])||(r[e]=u(void 0,t[e]))})),n.forEach(i,c),n.forEach(s,(function(o){n.isUndefined(t[o])?n.isUndefined(e[o])||(r[o]=u(void 0,e[o])):r[o]=u(void 0,t[o])})),n.forEach(a,(function(n){n in t?r[n]=u(e[n],t[n]):n in e&&(r[n]=u(void 0,e[n]))}));var f=o.concat(i).concat(s).concat(a),p=Object.keys(e).concat(Object.keys(t)).filter((function(e){return-1===f.indexOf(e)}));return n.forEach(p,c),r}},function(e,t,r){"use strict";function n(e){this.message=e}n.prototype.toString=function(){return"Cancel"+(this.message?": "+this.message:"")},n.prototype.__CANCEL__=!0,e.exports=n},function(e,t,r){e.exports=r(11)},function(e,t,r){"use strict";var n=r(0),o=r(2),i=r(12),s=r(8);function a(e){var t=new i(e),r=o(i.prototype.request,t);return n.extend(r,i.prototype,t),n.extend(r,t),r}var u=a(r(1));u.Axios=i,u.create=function(e){return a(s(u.defaults,e))},u.Cancel=r(9),u.CancelToken=r(26),u.isCancel=r(7),u.all=function(e){return Promise.all(e)},u.spread=r(27),u.isAxiosError=r(28),e.exports=u,e.exports.default=u},function(e,t,r){"use strict";var n=r(0),o=r(3),i=r(13),s=r(14),a=r(8),u=r(24),c=u.validators;function f(e){this.defaults=e,this.interceptors={request:new i,response:new i}}f.prototype.request=function(e){"string"==typeof e?(e=arguments[1]||{}).url=arguments[0]:e=e||{},(e=a(this.defaults,e)).method?e.method=e.method.toLowerCase():this.defaults.method?e.method=this.defaults.method.toLowerCase():e.method="get";var t=e.transitional;void 0!==t&&u.assertOptions(t,{silentJSONParsing:c.transitional(c.boolean,"1.0.0"),forcedJSONParsing:c.transitional(c.boolean,"1.0.0"),clarifyTimeoutError:c.transitional(c.boolean,"1.0.0")},!1);var r=[],n=!0;this.interceptors.request.forEach((function(t){"function"==typeof t.runWhen&&!1===t.runWhen(e)||(n=n&&t.synchronous,r.unshift(t.fulfilled,t.rejected))}));var o,i=[];if(this.interceptors.response.forEach((function(e){i.push(e.fulfilled,e.rejected)})),!n){var f=[s,void 0];for(Array.prototype.unshift.apply(f,r),f=f.concat(i),o=Promise.resolve(e);f.length;)o=o.then(f.shift(),f.shift());return o}for(var p=e;r.length;){var l=r.shift(),d=r.shift();try{p=l(p)}catch(e){d(e);break}}try{o=s(p)}catch(e){return Promise.reject(e)}for(;i.length;)o=o.then(i.shift(),i.shift());return o},f.prototype.getUri=function(e){return e=a(this.defaults,e),o(e.url,e.params,e.paramsSerializer).replace(/^\?/,"")},n.forEach(["delete","get","head","options"],(function(e){f.prototype[e]=function(t,r){return this.request(a(r||{},{method:e,url:t,data:(r||{}).data}))}})),n.forEach(["post","put","patch"],(function(e){f.prototype[e]=function(t,r,n){return this.request(a(n||{},{method:e,url:t,data:r}))}})),e.exports=f},function(e,t,r){"use strict";var n=r(0);function o(){this.handlers=[]}o.prototype.use=function(e,t,r){return this.handlers.push({fulfilled:e,rejected:t,synchronous:!!r&&r.synchronous,runWhen:r?r.runWhen:null}),this.handlers.length-1},o.prototype.eject=function(e){this.handlers[e]&&(this.handlers[e]=null)},o.prototype.forEach=function(e){n.forEach(this.handlers,(function(t){null!==t&&e(t)}))},e.exports=o},function(e,t,r){"use strict";var n=r(0),o=r(15),i=r(7),s=r(1);function a(e){e.cancelToken&&e.cancelToken.throwIfRequested()}e.exports=function(e){return a(e),e.headers=e.headers||{},e.data=o.call(e,e.data,e.headers,e.transformRequest),e.headers=n.merge(e.headers.common||{},e.headers[e.method]||{},e.headers),n.forEach(["delete","get","head","post","put","patch","common"],(function(t){delete e.headers[t]})),(e.adapter||s.adapter)(e).then((function(t){return a(e),t.data=o.call(e,t.data,t.headers,e.transformResponse),t}),(function(t){return i(t)||(a(e),t&&t.response&&(t.response.data=o.call(e,t.response.data,t.response.headers,e.transformResponse))),Promise.reject(t)}))}},function(e,t,r){"use strict";var n=r(0),o=r(1);e.exports=function(e,t,r){var i=this||o;return n.forEach(r,(function(r){e=r.call(i,e,t)})),e}},function(e,t,r){"use strict";var n=r(0);e.exports=function(e,t){n.forEach(e,(function(r,n){n!==t&&n.toUpperCase()===t.toUpperCase()&&(e[t]=r,delete e[n])}))}},function(e,t,r){"use strict";var n=r(6);e.exports=function(e,t,r){var o=r.config.validateStatus;r.status&&o&&!o(r.status)?t(n("Request failed with status code "+r.status,r.config,null,r.request,r)):e(r)}},function(e,t,r){"use strict";var n=r(0);e.exports=n.isStandardBrowserEnv()?{write:function(e,t,r,o,i,s){var a=[];a.push(e+"="+encodeURIComponent(t)),n.isNumber(r)&&a.push("expires="+new Date(r).toGMTString()),n.isString(o)&&a.push("path="+o),n.isString(i)&&a.push("domain="+i),!0===s&&a.push("secure"),document.cookie=a.join("; ")},read:function(e){var t=document.cookie.match(new RegExp("(^|;\\s*)("+e+")=([^;]*)"));return t?decodeURIComponent(t[3]):null},remove:function(e){this.write(e,"",Date.now()-864e5)}}:{write:function(){},read:function(){return null},remove:function(){}}},function(e,t,r){"use strict";var n=r(20),o=r(21);e.exports=function(e,t){return e&&!n(t)?o(e,t):t}},function(e,t,r){"use strict";e.exports=function(e){return/^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(e)}},function(e,t,r){"use strict";e.exports=function(e,t){return t?e.replace(/\/+$/,"")+"/"+t.replace(/^\/+/,""):e}},function(e,t,r){"use strict";var n=r(0),o=["age","authorization","content-length","content-type","etag","expires","from","host","if-modified-since","if-unmodified-since","last-modified","location","max-forwards","proxy-authorization","referer","retry-after","user-agent"];e.exports=function(e){var t,r,i,s={};return e?(n.forEach(e.split("\n"),(function(e){if(i=e.indexOf(":"),t=n.trim(e.substr(0,i)).toLowerCase(),r=n.trim(e.substr(i+1)),t){if(s[t]&&o.indexOf(t)>=0)return;s[t]="set-cookie"===t?(s[t]?s[t]:[]).concat([r]):s[t]?s[t]+", "+r:r}})),s):s}},function(e,t,r){"use strict";var n=r(0);e.exports=n.isStandardBrowserEnv()?function(){var e,t=/(msie|trident)/i.test(navigator.userAgent),r=document.createElement("a");function o(e){var n=e;return t&&(r.setAttribute("href",n),n=r.href),r.setAttribute("href",n),{href:r.href,protocol:r.protocol?r.protocol.replace(/:$/,""):"",host:r.host,search:r.search?r.search.replace(/^\?/,""):"",hash:r.hash?r.hash.replace(/^#/,""):"",hostname:r.hostname,port:r.port,pathname:"/"===r.pathname.charAt(0)?r.pathname:"/"+r.pathname}}return e=o(window.location.href),function(t){var r=n.isString(t)?o(t):t;return r.protocol===e.protocol&&r.host===e.host}}():function(){return!0}},function(e,t,r){"use strict";var n=r(25),o={};["object","boolean","number","function","string","symbol"].forEach((function(e,t){o[e]=function(r){return typeof r===e||"a"+(t<1?"n ":" ")+e}}));var i={},s=n.version.split(".");function a(e,t){for(var r=t?t.split("."):s,n=e.split("."),o=0;o<3;o++){if(r[o]>n[o])return!0;if(r[o]<n[o])return!1}return!1}o.transitional=function(e,t,r){var o=t&&a(t);function s(e,t){return"[Axios v"+n.version+"] Transitional option '"+e+"'"+t+(r?". "+r:"")}return function(r,n,a){if(!1===e)throw new Error(s(n," has been removed in "+t));return o&&!i[n]&&(i[n]=!0,console.warn(s(n," has been deprecated since v"+t+" and will be removed in the near future"))),!e||e(r,n,a)}},e.exports={isOlderVersion:a,assertOptions:function(e,t,r){if("object"!=typeof e)throw new TypeError("options must be an object");for(var n=Object.keys(e),o=n.length;o-- >0;){var i=n[o],s=t[i];if(s){var a=e[i],u=void 0===a||s(a,i,e);if(!0!==u)throw new TypeError("option "+i+" must be "+u)}else if(!0!==r)throw Error("Unknown option "+i)}},validators:o}},function(e){e.exports=JSON.parse('{"name":"axios","version":"0.21.4","description":"Promise based HTTP client for the browser and node.js","main":"index.js","scripts":{"test":"grunt test","start":"node ./sandbox/server.js","build":"NODE_ENV=production grunt build","preversion":"npm test","version":"npm run build && grunt version && git add -A dist && git add CHANGELOG.md bower.json package.json","postversion":"git push && git push --tags","examples":"node ./examples/server.js","coveralls":"cat coverage/lcov.info | ./node_modules/coveralls/bin/coveralls.js","fix":"eslint --fix lib/**/*.js"},"repository":{"type":"git","url":"https://github.com/axios/axios.git"},"keywords":["xhr","http","ajax","promise","node"],"author":"Matt Zabriskie","license":"MIT","bugs":{"url":"https://github.com/axios/axios/issues"},"homepage":"https://axios-http.com","devDependencies":{"coveralls":"^3.0.0","es6-promise":"^4.2.4","grunt":"^1.3.0","grunt-banner":"^0.6.0","grunt-cli":"^1.2.0","grunt-contrib-clean":"^1.1.0","grunt-contrib-watch":"^1.0.0","grunt-eslint":"^23.0.0","grunt-karma":"^4.0.0","grunt-mocha-test":"^0.13.3","grunt-ts":"^6.0.0-beta.19","grunt-webpack":"^4.0.2","istanbul-instrumenter-loader":"^1.0.0","jasmine-core":"^2.4.1","karma":"^6.3.2","karma-chrome-launcher":"^3.1.0","karma-firefox-launcher":"^2.1.0","karma-jasmine":"^1.1.1","karma-jasmine-ajax":"^0.1.13","karma-safari-launcher":"^1.0.0","karma-sauce-launcher":"^4.3.6","karma-sinon":"^1.0.5","karma-sourcemap-loader":"^0.3.8","karma-webpack":"^4.0.2","load-grunt-tasks":"^3.5.2","minimist":"^1.2.0","mocha":"^8.2.1","sinon":"^4.5.0","terser-webpack-plugin":"^4.2.3","typescript":"^4.0.5","url-search-params":"^0.10.0","webpack":"^4.44.2","webpack-dev-server":"^3.11.0"},"browser":{"./lib/adapters/http.js":"./lib/adapters/xhr.js"},"jsdelivr":"dist/axios.min.js","unpkg":"dist/axios.min.js","typings":"./index.d.ts","dependencies":{"follow-redirects":"^1.14.0"},"bundlesize":[{"path":"./dist/axios.min.js","threshold":"5kB"}]}')},function(e,t,r){"use strict";var n=r(9);function o(e){if("function"!=typeof e)throw new TypeError("executor must be a function.");var t;this.promise=new Promise((function(e){t=e}));var r=this;e((function(e){r.reason||(r.reason=new n(e),t(r.reason))}))}o.prototype.throwIfRequested=function(){if(this.reason)throw this.reason},o.source=function(){var e;return{token:new o((function(t){e=t})),cancel:e}},e.exports=o},function(e,t,r){"use strict";e.exports=function(e){return function(t){return e.apply(null,t)}}},function(e,t,r){"use strict";e.exports=function(e){return"object"==typeof e&&!0===e.isAxiosError}}])}));

!function(t,e){"object"==typeof exports&&"undefined"!=typeof module?module.exports=e():"function"==typeof define&&define.amd?define(e):t.ES6Promise=e()}(this,function(){"use strict";function t(t){var e=typeof t;return null!==t&&("object"===e||"function"===e)}function e(t){return"function"==typeof t}function n(t){I=t}function r(t){J=t}function o(){return function(){return process.nextTick(a)}}function i(){return"undefined"!=typeof H?function(){H(a)}:c()}function s(){var t=0,e=new V(a),n=document.createTextNode("");return e.observe(n,{characterData:!0}),function(){n.data=t=++t%2}}function u(){var t=new MessageChannel;return t.port1.onmessage=a,function(){return t.port2.postMessage(0)}}function c(){var t=setTimeout;return function(){return t(a,1)}}function a(){for(var t=0;t<G;t+=2){var e=$[t],n=$[t+1];e(n),$[t]=void 0,$[t+1]=void 0}G=0}function f(){try{var t=require,e=t("vertx");return H=e.runOnLoop||e.runOnContext,i()}catch(n){return c()}}function l(t,e){var n=arguments,r=this,o=new this.constructor(p);void 0===o[et]&&k(o);var i=r._state;return i?!function(){var t=n[i-1];J(function(){return x(i,o,t,r._result)})}():E(r,o,t,e),o}function h(t){var e=this;if(t&&"object"==typeof t&&t.constructor===e)return t;var n=new e(p);return g(n,t),n}function p(){}function v(){return new TypeError("You cannot resolve a promise with itself")}function d(){return new TypeError("A promises callback cannot return that same promise.")}function _(t){try{return t.then}catch(e){return it.error=e,it}}function y(t,e,n,r){try{t.call(e,n,r)}catch(o){return o}}function m(t,e,n){J(function(t){var r=!1,o=y(n,e,function(n){r||(r=!0,e!==n?g(t,n):S(t,n))},function(e){r||(r=!0,j(t,e))},"Settle: "+(t._label||" unknown promise"));!r&&o&&(r=!0,j(t,o))},t)}function b(t,e){e._state===rt?S(t,e._result):e._state===ot?j(t,e._result):E(e,void 0,function(e){return g(t,e)},function(e){return j(t,e)})}function w(t,n,r){n.constructor===t.constructor&&r===l&&n.constructor.resolve===h?b(t,n):r===it?(j(t,it.error),it.error=null):void 0===r?S(t,n):e(r)?m(t,n,r):S(t,n)}function g(e,n){e===n?j(e,v()):t(n)?w(e,n,_(n)):S(e,n)}function A(t){t._onerror&&t._onerror(t._result),T(t)}function S(t,e){t._state===nt&&(t._result=e,t._state=rt,0!==t._subscribers.length&&J(T,t))}function j(t,e){t._state===nt&&(t._state=ot,t._result=e,J(A,t))}function E(t,e,n,r){var o=t._subscribers,i=o.length;t._onerror=null,o[i]=e,o[i+rt]=n,o[i+ot]=r,0===i&&t._state&&J(T,t)}function T(t){var e=t._subscribers,n=t._state;if(0!==e.length){for(var r=void 0,o=void 0,i=t._result,s=0;s<e.length;s+=3)r=e[s],o=e[s+n],r?x(n,r,o,i):o(i);t._subscribers.length=0}}function M(){this.error=null}function P(t,e){try{return t(e)}catch(n){return st.error=n,st}}function x(t,n,r,o){var i=e(r),s=void 0,u=void 0,c=void 0,a=void 0;if(i){if(s=P(r,o),s===st?(a=!0,u=s.error,s.error=null):c=!0,n===s)return void j(n,d())}else s=o,c=!0;n._state!==nt||(i&&c?g(n,s):a?j(n,u):t===rt?S(n,s):t===ot&&j(n,s))}function C(t,e){try{e(function(e){g(t,e)},function(e){j(t,e)})}catch(n){j(t,n)}}function O(){return ut++}function k(t){t[et]=ut++,t._state=void 0,t._result=void 0,t._subscribers=[]}function Y(t,e){this._instanceConstructor=t,this.promise=new t(p),this.promise[et]||k(this.promise),B(e)?(this.length=e.length,this._remaining=e.length,this._result=new Array(this.length),0===this.length?S(this.promise,this._result):(this.length=this.length||0,this._enumerate(e),0===this._remaining&&S(this.promise,this._result))):j(this.promise,q())}function q(){return new Error("Array Methods must be provided an Array")}function F(t){return new Y(this,t).promise}function D(t){var e=this;return new e(B(t)?function(n,r){for(var o=t.length,i=0;i<o;i++)e.resolve(t[i]).then(n,r)}:function(t,e){return e(new TypeError("You must pass an array to race."))})}function K(t){var e=this,n=new e(p);return j(n,t),n}function L(){throw new TypeError("You must pass a resolver function as the first argument to the promise constructor")}function N(){throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.")}function U(t){this[et]=O(),this._result=this._state=void 0,this._subscribers=[],p!==t&&("function"!=typeof t&&L(),this instanceof U?C(this,t):N())}function W(){var t=void 0;if("undefined"!=typeof global)t=global;else if("undefined"!=typeof self)t=self;else try{t=Function("return this")()}catch(e){throw new Error("polyfill failed because global object is unavailable in this environment")}var n=t.Promise;if(n){var r=null;try{r=Object.prototype.toString.call(n.resolve())}catch(e){}if("[object Promise]"===r&&!n.cast)return}t.Promise=U}var z=void 0;z=Array.isArray?Array.isArray:function(t){return"[object Array]"===Object.prototype.toString.call(t)};var B=z,G=0,H=void 0,I=void 0,J=function(t,e){$[G]=t,$[G+1]=e,G+=2,2===G&&(I?I(a):tt())},Q="undefined"!=typeof window?window:void 0,R=Q||{},V=R.MutationObserver||R.WebKitMutationObserver,X="undefined"==typeof self&&"undefined"!=typeof process&&"[object process]"==={}.toString.call(process),Z="undefined"!=typeof Uint8ClampedArray&&"undefined"!=typeof importScripts&&"undefined"!=typeof MessageChannel,$=new Array(1e3),tt=void 0;tt=X?o():V?s():Z?u():void 0===Q&&"function"==typeof require?f():c();var et=Math.random().toString(36).substring(16),nt=void 0,rt=1,ot=2,it=new M,st=new M,ut=0;return Y.prototype._enumerate=function(t){for(var e=0;this._state===nt&&e<t.length;e++)this._eachEntry(t[e],e)},Y.prototype._eachEntry=function(t,e){var n=this._instanceConstructor,r=n.resolve;if(r===h){var o=_(t);if(o===l&&t._state!==nt)this._settledAt(t._state,e,t._result);else if("function"!=typeof o)this._remaining--,this._result[e]=t;else if(n===U){var i=new n(p);w(i,t,o),this._willSettleAt(i,e)}else this._willSettleAt(new n(function(e){return e(t)}),e)}else this._willSettleAt(r(t),e)},Y.prototype._settledAt=function(t,e,n){var r=this.promise;r._state===nt&&(this._remaining--,t===ot?j(r,n):this._result[e]=n),0===this._remaining&&S(r,this._result)},Y.prototype._willSettleAt=function(t,e){var n=this;E(t,void 0,function(t){return n._settledAt(rt,e,t)},function(t){return n._settledAt(ot,e,t)})},U.all=F,U.race=D,U.resolve=h,U.reject=K,U._setScheduler=n,U._setAsap=r,U._asap=J,U.prototype={constructor:U,then:l,"catch":function(t){return this.then(null,t)}},U.polyfill=W,U.Promise=U,U.polyfill(),U});
"use strict";

/**
 * Copyright 2016 Google Inc. All Rights Reserved.
 *
 * Licensed under the W3C SOFTWARE AND DOCUMENT NOTICE AND LICENSE.
 *
 *  https://www.w3.org/Consortium/Legal/2015/copyright-software-and-document
 *
 */

(function (window, document) {
  'use strict';

  // Exits early if all IntersectionObserver and IntersectionObserverEntry
  // features are natively supported.
  if ('IntersectionObserver' in window && 'IntersectionObserverEntry' in window && 'intersectionRatio' in window.IntersectionObserverEntry.prototype) {
    // Minimal polyfill for Edge 15's lack of `isIntersecting`
    // See: https://github.com/w3c/IntersectionObserver/issues/211
    if (!('isIntersecting' in window.IntersectionObserverEntry.prototype)) {
      Object.defineProperty(window.IntersectionObserverEntry.prototype, 'isIntersecting', {
        get: function get() {
          return this.intersectionRatio > 0;
        }
      });
    }
    return;
  }

  /**
  * An IntersectionObserver registry. This registry exists to hold a strong
  * reference to IntersectionObserver instances currently observing a target
  * element. Without this registry, instances without another reference may be
  * garbage collected.
  */
  var registry = [];

  /**
  * Creates the global IntersectionObserverEntry constructor.
  * https://w3c.github.io/IntersectionObserver/#intersection-observer-entry
  * @param {Object} entry A dictionary of instance properties.
  * @constructor
  */
  function IntersectionObserverEntry(entry) {
    this.time = entry.time;
    this.target = entry.target;
    this.rootBounds = entry.rootBounds;
    this.boundingClientRect = entry.boundingClientRect;
    this.intersectionRect = entry.intersectionRect || getEmptyRect();
    this.isIntersecting = !!entry.intersectionRect;

    // Calculates the intersection ratio.
    var targetRect = this.boundingClientRect;
    var targetArea = targetRect.width * targetRect.height;
    var intersectionRect = this.intersectionRect;
    var intersectionArea = intersectionRect.width * intersectionRect.height;

    // Sets intersection ratio.
    if (targetArea) {
      // Round the intersection ratio to avoid floating point math issues:
      // https://github.com/w3c/IntersectionObserver/issues/324
      this.intersectionRatio = Number((intersectionArea / targetArea).toFixed(4));
    } else {
      // If area is zero and is intersecting, sets to 1, otherwise to 0
      this.intersectionRatio = this.isIntersecting ? 1 : 0;
    }
  }

  /**
  * Creates the global IntersectionObserver constructor.
  * https://w3c.github.io/IntersectionObserver/#intersection-observer-interface
  * @param {Function} callback The function to be invoked after intersection
  *     changes have queued. The function is not invoked if the queue has
  *     been emptied by calling the `takeRecords` method.
  * @param {Object=} opt_options Optional configuration options.
  * @constructor
  */
  function IntersectionObserver(callback, opt_options) {
    var options = opt_options || {};
    if (typeof callback != 'function') {
      throw new Error('callback must be a function');
    }
    if (options.root && options.root.nodeType != 1) {
      throw new Error('root must be an Element');
    }

    // Binds and throttles `this._checkForIntersections`.
    this._checkForIntersections = throttle(this._checkForIntersections.bind(this), this.THROTTLE_TIMEOUT);

    // Private properties.
    this._callback = callback;
    this._observationTargets = [];
    this._queuedEntries = [];
    this._rootMarginValues = this._parseRootMargin(options.rootMargin);

    // Public properties.
    this.thresholds = this._initThresholds(options.threshold);
    this.root = options.root || null;
    this.rootMargin = this._rootMarginValues.map(function (margin) {
      return margin.value + margin.unit;
    }).join(' ');
  }

  /**
  * The minimum interval within which the document will be checked for
  * intersection changes.
  */
  IntersectionObserver.prototype.THROTTLE_TIMEOUT = 100;

  /**
  * The frequency in which the polyfill polls for intersection changes.
  * this can be updated on a per instance basis and must be set prior to
  * calling `observe` on the first target.
  */
  IntersectionObserver.prototype.POLL_INTERVAL = null;

  /**
  * Use a mutation observer on the root element
  * to detect intersection changes.
  */
  IntersectionObserver.prototype.USE_MUTATION_OBSERVER = true;

  /**
  * Starts observing a target element for intersection changes based on
  * the thresholds values.
  * @param {Element} target The DOM element to observe.
  */
  IntersectionObserver.prototype.observe = function (target) {
    var isTargetAlreadyObserved = this._observationTargets.some(function (item) {
      return item.element == target;
    });
    if (isTargetAlreadyObserved) {
      return;
    }
    if (!(target && target.nodeType == 1)) {
      throw new Error('target must be an Element');
    }
    this._registerInstance();
    this._observationTargets.push({
      element: target,
      entry: null
    });
    this._monitorIntersections();
    this._checkForIntersections();
  };

  /**
  * Stops observing a target element for intersection changes.
  * @param {Element} target The DOM element to observe.
  */
  IntersectionObserver.prototype.unobserve = function (target) {
    this._observationTargets = this._observationTargets.filter(function (item) {
      return item.element != target;
    });
    if (!this._observationTargets.length) {
      this._unmonitorIntersections();
      this._unregisterInstance();
    }
  };

  /**
  * Stops observing all target elements for intersection changes.
  */
  IntersectionObserver.prototype.disconnect = function () {
    this._observationTargets = [];
    this._unmonitorIntersections();
    this._unregisterInstance();
  };

  /**
  * Returns any queue entries that have not yet been reported to the
  * callback and clears the queue. This can be used in conjunction with the
  * callback to obtain the absolute most up-to-date intersection information.
  * @return {Array} The currently queued entries.
  */
  IntersectionObserver.prototype.takeRecords = function () {
    var records = this._queuedEntries.slice();
    this._queuedEntries = [];
    return records;
  };

  /**
  * Accepts the threshold value from the user configuration object and
  * returns a sorted array of unique threshold values. If a value is not
  * between 0 and 1 and error is thrown.
  * @private
  * @param {Array|number=} opt_threshold An optional threshold value or
  *     a list of threshold values, defaulting to [0].
  * @return {Array} A sorted list of unique and valid threshold values.
  */
  IntersectionObserver.prototype._initThresholds = function (opt_threshold) {
    var threshold = opt_threshold || [0];
    if (!Array.isArray(threshold)) threshold = [threshold];
    return threshold.sort().filter(function (t, i, a) {
      if (typeof t != 'number' || isNaN(t) || t < 0 || t > 1) {
        throw new Error('threshold must be a number between 0 and 1 inclusively');
      }
      return t !== a[i - 1];
    });
  };

  /**
  * Accepts the rootMargin value from the user configuration object
  * and returns an array of the four margin values as an object containing
  * the value and unit properties. If any of the values are not properly
  * formatted or use a unit other than px or %, and error is thrown.
  * @private
  * @param {string=} opt_rootMargin An optional rootMargin value,
  *     defaulting to '0px'.
  * @return {Array<Object>} An array of margin objects with the keys
  *     value and unit.
  */
  IntersectionObserver.prototype._parseRootMargin = function (opt_rootMargin) {
    var marginString = opt_rootMargin || '0px';
    var margins = marginString.split(/\s+/).map(function (margin) {
      var parts = /^(-?\d*\.?\d+)(px|%)$/.exec(margin);
      if (!parts) {
        throw new Error('rootMargin must be specified in pixels or percent');
      }
      return {
        value: parseFloat(parts[1]),
        unit: parts[2]
      };
    });

    // Handles shorthand.
    margins[1] = margins[1] || margins[0];
    margins[2] = margins[2] || margins[0];
    margins[3] = margins[3] || margins[1];
    return margins;
  };

  /**
  * Starts polling for intersection changes if the polling is not already
  * happening, and if the page's visibility state is visible.
  * @private
  */
  IntersectionObserver.prototype._monitorIntersections = function () {
    if (!this._monitoringIntersections) {
      this._monitoringIntersections = true;

      // If a poll interval is set, use polling instead of listening to
      // resize and scroll events or DOM mutations.
      if (this.POLL_INTERVAL) {
        this._monitoringInterval = setInterval(this._checkForIntersections, this.POLL_INTERVAL);
      } else {
        addEvent(window, 'resize', this._checkForIntersections, true);
        addEvent(document, 'scroll', this._checkForIntersections, true);
        if (this.USE_MUTATION_OBSERVER && 'MutationObserver' in window) {
          this._domObserver = new MutationObserver(this._checkForIntersections);
          this._domObserver.observe(document, {
            attributes: true,
            childList: true,
            characterData: true,
            subtree: true
          });
        }
      }
    }
  };

  /**
  * Stops polling for intersection changes.
  * @private
  */
  IntersectionObserver.prototype._unmonitorIntersections = function () {
    if (this._monitoringIntersections) {
      this._monitoringIntersections = false;
      clearInterval(this._monitoringInterval);
      this._monitoringInterval = null;
      removeEvent(window, 'resize', this._checkForIntersections, true);
      removeEvent(document, 'scroll', this._checkForIntersections, true);
      if (this._domObserver) {
        this._domObserver.disconnect();
        this._domObserver = null;
      }
    }
  };

  /**
  * Scans each observation target for intersection changes and adds them
  * to the internal entries queue. If new entries are found, it
  * schedules the callback to be invoked.
  * @private
  */
  IntersectionObserver.prototype._checkForIntersections = function () {
    var rootIsInDom = this._rootIsInDom();
    var rootRect = rootIsInDom ? this._getRootRect() : getEmptyRect();
    this._observationTargets.forEach(function (item) {
      var target = item.element;
      var targetRect = getBoundingClientRect(target);
      var rootContainsTarget = this._rootContainsTarget(target);
      var oldEntry = item.entry;
      var intersectionRect = rootIsInDom && rootContainsTarget && this._computeTargetAndRootIntersection(target, rootRect);
      var newEntry = item.entry = new IntersectionObserverEntry({
        time: now(),
        target: target,
        boundingClientRect: targetRect,
        rootBounds: rootRect,
        intersectionRect: intersectionRect
      });
      if (!oldEntry) {
        this._queuedEntries.push(newEntry);
      } else if (rootIsInDom && rootContainsTarget) {
        // If the new entry intersection ratio has crossed any of the
        // thresholds, add a new entry.
        if (this._hasCrossedThreshold(oldEntry, newEntry)) {
          this._queuedEntries.push(newEntry);
        }
      } else {
        // If the root is not in the DOM or target is not contained within
        // root but the previous entry for this target had an intersection,
        // add a new record indicating removal.
        if (oldEntry && oldEntry.isIntersecting) {
          this._queuedEntries.push(newEntry);
        }
      }
    }, this);
    if (this._queuedEntries.length) {
      this._callback(this.takeRecords(), this);
    }
  };

  /**
  * Accepts a target and root rect computes the intersection between then
  * following the algorithm in the spec.
  * TODO(philipwalton): at this time clip-path is not considered.
  * https://w3c.github.io/IntersectionObserver/#calculate-intersection-rect-algo
  * @param {Element} target The target DOM element
  * @param {Object} rootRect The bounding rect of the root after being
  *     expanded by the rootMargin value.
  * @return {?Object} The final intersection rect object or undefined if no
  *     intersection is found.
  * @private
  */
  IntersectionObserver.prototype._computeTargetAndRootIntersection = function (target, rootRect) {
    // If the element isn't displayed, an intersection can't happen.
    if (window.getComputedStyle(target).display == 'none') return;
    var targetRect = getBoundingClientRect(target);
    var intersectionRect = targetRect;
    var parent = getParentNode(target);
    var atRoot = false;
    while (!atRoot) {
      var parentRect = null;
      var parentComputedStyle = parent.nodeType == 1 ? window.getComputedStyle(parent) : {};

      // If the parent isn't displayed, an intersection can't happen.
      if (parentComputedStyle.display == 'none') return;
      if (parent == this.root || parent == document) {
        atRoot = true;
        parentRect = rootRect;
      } else {
        // If the element has a non-visible overflow, and it's not the <body>
        // or <html> element, update the intersection rect.
        // Note: <body> and <html> cannot be clipped to a rect that's not also
        // the document rect, so no need to compute a new intersection.
        if (parent != document.body && parent != document.documentElement && parentComputedStyle.overflow != 'visible') {
          parentRect = getBoundingClientRect(parent);
        }
      }

      // If either of the above conditionals set a new parentRect,
      // calculate new intersection data.
      if (parentRect) {
        intersectionRect = computeRectIntersection(parentRect, intersectionRect);
        if (!intersectionRect) break;
      }
      parent = getParentNode(parent);
    }
    return intersectionRect;
  };

  /**
  * Returns the root rect after being expanded by the rootMargin value.
  * @return {Object} The expanded root rect.
  * @private
  */
  IntersectionObserver.prototype._getRootRect = function () {
    var rootRect;
    if (this.root) {
      rootRect = getBoundingClientRect(this.root);
    } else {
      // Use <html>/<body> instead of window since scroll bars affect size.
      var html = document.documentElement;
      var body = document.body;
      rootRect = {
        top: 0,
        left: 0,
        right: html.clientWidth || body.clientWidth,
        width: html.clientWidth || body.clientWidth,
        bottom: html.clientHeight || body.clientHeight,
        height: html.clientHeight || body.clientHeight
      };
    }
    return this._expandRectByRootMargin(rootRect);
  };

  /**
  * Accepts a rect and expands it by the rootMargin value.
  * @param {Object} rect The rect object to expand.
  * @return {Object} The expanded rect.
  * @private
  */
  IntersectionObserver.prototype._expandRectByRootMargin = function (rect) {
    var margins = this._rootMarginValues.map(function (margin, i) {
      return margin.unit == 'px' ? margin.value : margin.value * (i % 2 ? rect.width : rect.height) / 100;
    });
    var newRect = {
      top: rect.top - margins[0],
      right: rect.right + margins[1],
      bottom: rect.bottom + margins[2],
      left: rect.left - margins[3]
    };
    newRect.width = newRect.right - newRect.left;
    newRect.height = newRect.bottom - newRect.top;
    return newRect;
  };

  /**
  * Accepts an old and new entry and returns true if at least one of the
  * threshold values has been crossed.
  * @param {?IntersectionObserverEntry} oldEntry The previous entry for a
  *    particular target element or null if no previous entry exists.
  * @param {IntersectionObserverEntry} newEntry The current entry for a
  *    particular target element.
  * @return {boolean} Returns true if a any threshold has been crossed.
  * @private
  */
  IntersectionObserver.prototype._hasCrossedThreshold = function (oldEntry, newEntry) {
    // To make comparing easier, an entry that has a ratio of 0
    // but does not actually intersect is given a value of -1
    var oldRatio = oldEntry && oldEntry.isIntersecting ? oldEntry.intersectionRatio || 0 : -1;
    var newRatio = newEntry.isIntersecting ? newEntry.intersectionRatio || 0 : -1;

    // Ignore unchanged ratios
    if (oldRatio === newRatio) return;
    for (var i = 0; i < this.thresholds.length; i++) {
      var threshold = this.thresholds[i];

      // Return true if an entry matches a threshold or if the new ratio
      // and the old ratio are on the opposite sides of a threshold.
      if (threshold == oldRatio || threshold == newRatio || threshold < oldRatio !== threshold < newRatio) {
        return true;
      }
    }
  };

  /**
  * Returns whether or not the root element is an element and is in the DOM.
  * @return {boolean} True if the root element is an element and is in the DOM.
  * @private
  */
  IntersectionObserver.prototype._rootIsInDom = function () {
    return !this.root || containsDeep(document, this.root);
  };

  /**
  * Returns whether or not the target element is a child of root.
  * @param {Element} target The target element to check.
  * @return {boolean} True if the target element is a child of root.
  * @private
  */
  IntersectionObserver.prototype._rootContainsTarget = function (target) {
    return containsDeep(this.root || document, target);
  };

  /**
  * Adds the instance to the global IntersectionObserver registry if it isn't
  * already present.
  * @private
  */
  IntersectionObserver.prototype._registerInstance = function () {
    if (registry.indexOf(this) < 0) {
      registry.push(this);
    }
  };

  /**
  * Removes the instance from the global IntersectionObserver registry.
  * @private
  */
  IntersectionObserver.prototype._unregisterInstance = function () {
    var index = registry.indexOf(this);
    if (index != -1) registry.splice(index, 1);
  };

  /**
  * Returns the result of the performance.now() method or null in browsers
  * that don't support the API.
  * @return {number} The elapsed time since the page was requested.
  */
  function now() {
    return window.performance && performance.now && performance.now();
  }

  /**
  * Throttles a function and delays its execution, so it's only called at most
  * once within a given time period.
  * @param {Function} fn The function to throttle.
  * @param {number} timeout The amount of time that must pass before the
  *     function can be called again.
  * @return {Function} The throttled function.
  */
  function throttle(fn, timeout) {
    var timer = null;
    return function () {
      if (!timer) {
        timer = setTimeout(function () {
          fn();
          timer = null;
        }, timeout);
      }
    };
  }

  /**
  * Adds an event handler to a DOM node ensuring cross-browser compatibility.
  * @param {Node} node The DOM node to add the event handler to.
  * @param {string} event The event name.
  * @param {Function} fn The event handler to add.
  * @param {boolean} opt_useCapture Optionally adds the even to the capture
  *     phase. Note: this only works in modern browsers.
  */
  function addEvent(node, event, fn, opt_useCapture) {
    if (typeof node.addEventListener == 'function') {
      node.addEventListener(event, fn, opt_useCapture || false);
    } else if (typeof node.attachEvent == 'function') {
      node.attachEvent('on' + event, fn);
    }
  }

  /**
  * Removes a previously added event handler from a DOM node.
  * @param {Node} node The DOM node to remove the event handler from.
  * @param {string} event The event name.
  * @param {Function} fn The event handler to remove.
  * @param {boolean} opt_useCapture If the event handler was added with this
  *     flag set to true, it should be set to true here in order to remove it.
  */
  function removeEvent(node, event, fn, opt_useCapture) {
    if (typeof node.removeEventListener == 'function') {
      node.removeEventListener(event, fn, opt_useCapture || false);
    } else if (typeof node.detatchEvent == 'function') {
      node.detatchEvent('on' + event, fn);
    }
  }

  /**
  * Returns the intersection between two rect objects.
  * @param {Object} rect1 The first rect.
  * @param {Object} rect2 The second rect.
  * @return {?Object} The intersection rect or undefined if no intersection
  *     is found.
  */
  function computeRectIntersection(rect1, rect2) {
    var top = Math.max(rect1.top, rect2.top);
    var bottom = Math.min(rect1.bottom, rect2.bottom);
    var left = Math.max(rect1.left, rect2.left);
    var right = Math.min(rect1.right, rect2.right);
    var width = right - left;
    var height = bottom - top;
    return width >= 0 && height >= 0 && {
      top: top,
      bottom: bottom,
      left: left,
      right: right,
      width: width,
      height: height
    };
  }

  /**
  * Shims the native getBoundingClientRect for compatibility with older IE.
  * @param {Element} el The element whose bounding rect to get.
  * @return {Object} The (possibly shimmed) rect of the element.
  */
  function getBoundingClientRect(el) {
    var rect;
    try {
      rect = el.getBoundingClientRect();
    } catch (err) {
      // Ignore Windows 7 IE11 "Unspecified error"
      // https://github.com/w3c/IntersectionObserver/pull/205
    }
    if (!rect) return getEmptyRect();

    // Older IE
    if (!(rect.width && rect.height)) {
      rect = {
        top: rect.top,
        right: rect.right,
        bottom: rect.bottom,
        left: rect.left,
        width: rect.right - rect.left,
        height: rect.bottom - rect.top
      };
    }
    return rect;
  }

  /**
  * Returns an empty rect object. An empty rect is returned when an element
  * is not in the DOM.
  * @return {Object} The empty rect.
  */
  function getEmptyRect() {
    return {
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      width: 0,
      height: 0
    };
  }

  /**
  * Checks to see if a parent element contains a child element (including inside
  * shadow DOM).
  * @param {Node} parent The parent element.
  * @param {Node} child The child element.
  * @return {boolean} True if the parent node contains the child node.
  */
  function containsDeep(parent, child) {
    var node = child;
    while (node) {
      if (node == parent) return true;
      node = getParentNode(node);
    }
    return false;
  }

  /**
  * Gets the parent node of an element or its host element if the parent node
  * is a shadow root.
  * @param {Node} node The node whose parent to get.
  * @return {Node|null} The parent node or null if no parent exists.
  */
  function getParentNode(node) {
    var parent = node.parentNode;
    if (parent && parent.nodeType == 11 && parent.host) {
      // If the parent is a shadow root, return the host element.
      return parent.host;
    }
    return parent;
  }

  // Exposes the constructors globally.
  window.IntersectionObserver = IntersectionObserver;
  window.IntersectionObserverEntry = IntersectionObserverEntry;
})(window, document);
!function(e,a){"object"==typeof exports&&"undefined"!=typeof module?module.exports=a():"function"==typeof define&&define.amd?define(a):e.moment=a()}(this,function(){"use strict";function e(){return Ea.apply(null,arguments)}function a(e){return e instanceof Array||"[object Array]"===Object.prototype.toString.call(e)}function t(e){return null!=e&&"[object Object]"===Object.prototype.toString.call(e)}function s(e){return void 0===e}function n(e){return"number"==typeof e||"[object Number]"===Object.prototype.toString.call(e)}function d(e){return e instanceof Date||"[object Date]"===Object.prototype.toString.call(e)}function r(e,a){var t,s=[];for(t=0;t<e.length;++t)s.push(a(e[t],t));return s}function _(e,a){return Object.prototype.hasOwnProperty.call(e,a)}function i(e,a){for(var t in a)_(a,t)&&(e[t]=a[t]);return _(a,"toString")&&(e.toString=a.toString),_(a,"valueOf")&&(e.valueOf=a.valueOf),e}function o(e,a,t,s){return Ye(e,a,t,s,!0).utc()}function m(e){return null==e._pf&&(e._pf={empty:!1,unusedTokens:[],unusedInput:[],overflow:-2,charsLeftOver:0,nullInput:!1,invalidMonth:null,invalidFormat:!1,userInvalidated:!1,iso:!1,parsedDateParts:[],meridiem:null,rfc2822:!1,weekdayMismatch:!1}),e._pf}function u(e){if(null==e._isValid){var a=m(e),t=Aa.call(a.parsedDateParts,function(e){return null!=e}),s=!isNaN(e._d.getTime())&&a.overflow<0&&!a.empty&&!a.invalidMonth&&!a.invalidWeekday&&!a.weekdayMismatch&&!a.nullInput&&!a.invalidFormat&&!a.userInvalidated&&(!a.meridiem||a.meridiem&&t);if(e._strict&&(s=s&&0===a.charsLeftOver&&0===a.unusedTokens.length&&void 0===a.bigHour),null!=Object.isFrozen&&Object.isFrozen(e))return s;e._isValid=s}return e._isValid}function l(e){var a=o(NaN);return null!=e?i(m(a),e):m(a).userInvalidated=!0,a}function M(e,a){var t,n,d;if(s(a._isAMomentObject)||(e._isAMomentObject=a._isAMomentObject),s(a._i)||(e._i=a._i),s(a._f)||(e._f=a._f),s(a._l)||(e._l=a._l),s(a._strict)||(e._strict=a._strict),s(a._tzm)||(e._tzm=a._tzm),s(a._isUTC)||(e._isUTC=a._isUTC),s(a._offset)||(e._offset=a._offset),s(a._pf)||(e._pf=m(a)),s(a._locale)||(e._locale=a._locale),Fa.length>0)for(t=0;t<Fa.length;t++)s(d=a[n=Fa[t]])||(e[n]=d);return e}function h(a){M(this,a),this._d=new Date(null!=a._d?a._d.getTime():NaN),this.isValid()||(this._d=new Date(NaN)),!1===za&&(za=!0,e.updateOffset(this),za=!1)}function L(e){return e instanceof h||null!=e&&null!=e._isAMomentObject}function c(e){return e<0?Math.ceil(e)||0:Math.floor(e)}function Y(e){var a=+e,t=0;return 0!==a&&isFinite(a)&&(t=c(a)),t}function y(e,a,t){var s,n=Math.min(e.length,a.length),d=Math.abs(e.length-a.length),r=0;for(s=0;s<n;s++)(t&&e[s]!==a[s]||!t&&Y(e[s])!==Y(a[s]))&&r++;return r+d}function f(a){!1===e.suppressDeprecationWarnings&&"undefined"!=typeof console&&console.warn&&console.warn("Deprecation warning: "+a)}function k(a,t){var s=!0;return i(function(){if(null!=e.deprecationHandler&&e.deprecationHandler(null,a),s){for(var n,d=[],r=0;r<arguments.length;r++){if(n="","object"==typeof arguments[r]){n+="\n["+r+"] ";for(var _ in arguments[0])n+=_+": "+arguments[0][_]+", ";n=n.slice(0,-2)}else n=arguments[r];d.push(n)}f(a+"\nArguments: "+Array.prototype.slice.call(d).join("")+"\n"+(new Error).stack),s=!1}return t.apply(this,arguments)},t)}function p(a,t){null!=e.deprecationHandler&&e.deprecationHandler(a,t),Ja[a]||(f(t),Ja[a]=!0)}function D(e){return e instanceof Function||"[object Function]"===Object.prototype.toString.call(e)}function T(e,a){var s,n=i({},e);for(s in a)_(a,s)&&(t(e[s])&&t(a[s])?(n[s]={},i(n[s],e[s]),i(n[s],a[s])):null!=a[s]?n[s]=a[s]:delete n[s]);for(s in e)_(e,s)&&!_(a,s)&&t(e[s])&&(n[s]=i({},n[s]));return n}function g(e){null!=e&&this.set(e)}function w(e,a){var t=e.toLowerCase();Ra[t]=Ra[t+"s"]=Ra[a]=e}function v(e){return"string"==typeof e?Ra[e]||Ra[e.toLowerCase()]:void 0}function S(e){var a,t,s={};for(t in e)_(e,t)&&(a=v(t))&&(s[a]=e[t]);return s}function H(e,a){Ia[e]=a}function b(e,a,t){var s=""+Math.abs(e),n=a-s.length;return(e>=0?t?"+":"":"-")+Math.pow(10,Math.max(0,n)).toString().substr(1)+s}function j(e,a,t,s){var n=s;"string"==typeof s&&(n=function(){return this[s]()}),e&&(Va[e]=n),a&&(Va[a[0]]=function(){return b(n.apply(this,arguments),a[1],a[2])}),t&&(Va[t]=function(){return this.localeData().ordinal(n.apply(this,arguments),e)})}function x(e){return e.match(/\[[\s\S]/)?e.replace(/^\[|\]$/g,""):e.replace(/\\/g,"")}function P(e,a){return e.isValid()?(a=O(a,e.localeData()),Ua[a]=Ua[a]||function(e){var a,t,s=e.match(Ca);for(a=0,t=s.length;a<t;a++)Va[s[a]]?s[a]=Va[s[a]]:s[a]=x(s[a]);return function(a){var n,d="";for(n=0;n<t;n++)d+=D(s[n])?s[n].call(a,e):s[n];return d}}(a),Ua[a](e)):e.localeData().invalidDate()}function O(e,a){function t(e){return a.longDateFormat(e)||e}var s=5;for(Ga.lastIndex=0;s>=0&&Ga.test(e);)e=e.replace(Ga,t),Ga.lastIndex=0,s-=1;return e}function W(e,a,t){ot[e]=D(a)?a:function(e,s){return e&&t?t:a}}function E(e,a){return _(ot,e)?ot[e](a._strict,a._locale):new RegExp(function(e){return A(e.replace("\\","").replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,function(e,a,t,s,n){return a||t||s||n}))}(e))}function A(e){return e.replace(/[-\/\\^$*+?.()|[\]{}]/g,"\\$&")}function F(e,a){var t,s=a;for("string"==typeof e&&(e=[e]),n(a)&&(s=function(e,t){t[a]=Y(e)}),t=0;t<e.length;t++)mt[e[t]]=s}function z(e,a){F(e,function(e,t,s,n){s._w=s._w||{},a(e,s._w,s,n)})}function J(e,a,t){null!=a&&_(mt,e)&&mt[e](a,t._a,t,e)}function N(e){return R(e)?366:365}function R(e){return e%4==0&&e%100!=0||e%400==0}function I(a,t){return function(s){return null!=s?(G(this,a,s),e.updateOffset(this,t),this):C(this,a)}}function C(e,a){return e.isValid()?e._d["get"+(e._isUTC?"UTC":"")+a]():NaN}function G(e,a,t){e.isValid()&&!isNaN(t)&&("FullYear"===a&&R(e.year())&&1===e.month()&&29===e.date()?e._d["set"+(e._isUTC?"UTC":"")+a](t,e.month(),U(t,e.month())):e._d["set"+(e._isUTC?"UTC":"")+a](t))}function U(e,a){if(isNaN(e)||isNaN(a))return NaN;var t=function(e,a){return(e%a+a)%a}(a,12);return e+=(a-t)/12,1===t?R(e)?29:28:31-t%7%2}function V(e,a){var t;if(!e.isValid())return e;if("string"==typeof a)if(/^\d+$/.test(a))a=Y(a);else if(a=e.localeData().monthsParse(a),!n(a))return e;return t=Math.min(e.date(),U(e.year(),a)),e._d["set"+(e._isUTC?"UTC":"")+"Month"](a,t),e}function K(a){return null!=a?(V(this,a),e.updateOffset(this,!0),this):C(this,"Month")}function Z(){function e(e,a){return a.length-e.length}var a,t,s=[],n=[],d=[];for(a=0;a<12;a++)t=o([2e3,a]),s.push(this.monthsShort(t,"")),n.push(this.months(t,"")),d.push(this.months(t,"")),d.push(this.monthsShort(t,""));for(s.sort(e),n.sort(e),d.sort(e),a=0;a<12;a++)s[a]=A(s[a]),n[a]=A(n[a]);for(a=0;a<24;a++)d[a]=A(d[a]);this._monthsRegex=new RegExp("^("+d.join("|")+")","i"),this._monthsShortRegex=this._monthsRegex,this._monthsStrictRegex=new RegExp("^("+n.join("|")+")","i"),this._monthsShortStrictRegex=new RegExp("^("+s.join("|")+")","i")}function $(e){var a=new Date(Date.UTC.apply(null,arguments));return e<100&&e>=0&&isFinite(a.getUTCFullYear())&&a.setUTCFullYear(e),a}function B(e,a,t){var s=7+a-t;return-((7+$(e,0,s).getUTCDay()-a)%7)+s-1}function q(e,a,t,s,n){var d,r,_=1+7*(a-1)+(7+t-s)%7+B(e,s,n);return _<=0?r=N(d=e-1)+_:_>N(e)?(d=e+1,r=_-N(e)):(d=e,r=_),{year:d,dayOfYear:r}}function Q(e,a,t){var s,n,d=B(e.year(),a,t),r=Math.floor((e.dayOfYear()-d-1)/7)+1;return r<1?s=r+X(n=e.year()-1,a,t):r>X(e.year(),a,t)?(s=r-X(e.year(),a,t),n=e.year()+1):(n=e.year(),s=r),{week:s,year:n}}function X(e,a,t){var s=B(e,a,t),n=B(e+1,a,t);return(N(e)-s+n)/7}function ee(){function e(e,a){return a.length-e.length}var a,t,s,n,d,r=[],_=[],i=[],m=[];for(a=0;a<7;a++)t=o([2e3,1]).day(a),s=this.weekdaysMin(t,""),n=this.weekdaysShort(t,""),d=this.weekdays(t,""),r.push(s),_.push(n),i.push(d),m.push(s),m.push(n),m.push(d);for(r.sort(e),_.sort(e),i.sort(e),m.sort(e),a=0;a<7;a++)_[a]=A(_[a]),i[a]=A(i[a]),m[a]=A(m[a]);this._weekdaysRegex=new RegExp("^("+m.join("|")+")","i"),this._weekdaysShortRegex=this._weekdaysRegex,this._weekdaysMinRegex=this._weekdaysRegex,this._weekdaysStrictRegex=new RegExp("^("+i.join("|")+")","i"),this._weekdaysShortStrictRegex=new RegExp("^("+_.join("|")+")","i"),this._weekdaysMinStrictRegex=new RegExp("^("+r.join("|")+")","i")}function ae(){return this.hours()%12||12}function te(e,a){j(e,0,0,function(){return this.localeData().meridiem(this.hours(),this.minutes(),a)})}function se(e,a){return a._meridiemParse}function ne(e){return e?e.toLowerCase().replace("_","-"):e}function de(e){var a=null;if(!At[e]&&"undefined"!=typeof module&&module&&module.exports)try{a=Ot._abbr;require("./locale/"+e),re(a)}catch(e){}return At[e]}function re(e,a){var t;return e&&(t=s(a)?ie(e):_e(e,a))&&(Ot=t),Ot._abbr}function _e(e,a){if(null!==a){var t=Et;if(a.abbr=e,null!=At[e])p("defineLocaleOverride","use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info."),t=At[e]._config;else if(null!=a.parentLocale){if(null==At[a.parentLocale])return Ft[a.parentLocale]||(Ft[a.parentLocale]=[]),Ft[a.parentLocale].push({name:e,config:a}),null;t=At[a.parentLocale]._config}return At[e]=new g(T(t,a)),Ft[e]&&Ft[e].forEach(function(e){_e(e.name,e.config)}),re(e),At[e]}return delete At[e],null}function ie(e){var t;if(e&&e._locale&&e._locale._abbr&&(e=e._locale._abbr),!e)return Ot;if(!a(e)){if(t=de(e))return t;e=[e]}return function(e){for(var a,t,s,n,d=0;d<e.length;){for(a=(n=ne(e[d]).split("-")).length,t=(t=ne(e[d+1]))?t.split("-"):null;a>0;){if(s=de(n.slice(0,a).join("-")))return s;if(t&&t.length>=a&&y(n,t,!0)>=a-1)break;a--}d++}return null}(e)}function oe(e){var a,t=e._a;return t&&-2===m(e).overflow&&(a=t[lt]<0||t[lt]>11?lt:t[Mt]<1||t[Mt]>U(t[ut],t[lt])?Mt:t[ht]<0||t[ht]>24||24===t[ht]&&(0!==t[Lt]||0!==t[ct]||0!==t[Yt])?ht:t[Lt]<0||t[Lt]>59?Lt:t[ct]<0||t[ct]>59?ct:t[Yt]<0||t[Yt]>999?Yt:-1,m(e)._overflowDayOfYear&&(a<ut||a>Mt)&&(a=Mt),m(e)._overflowWeeks&&-1===a&&(a=yt),m(e)._overflowWeekday&&-1===a&&(a=ft),m(e).overflow=a),e}function me(e,a,t){return null!=e?e:null!=a?a:t}function ue(a){var t,s,n,d,r,_=[];if(!a._d){for(n=function(a){var t=new Date(e.now());return a._useUTC?[t.getUTCFullYear(),t.getUTCMonth(),t.getUTCDate()]:[t.getFullYear(),t.getMonth(),t.getDate()]}(a),a._w&&null==a._a[Mt]&&null==a._a[lt]&&function(e){var a,t,s,n,d,r,_,i;if(null!=(a=e._w).GG||null!=a.W||null!=a.E)d=1,r=4,t=me(a.GG,e._a[ut],Q(ye(),1,4).year),s=me(a.W,1),((n=me(a.E,1))<1||n>7)&&(i=!0);else{d=e._locale._week.dow,r=e._locale._week.doy;var o=Q(ye(),d,r);t=me(a.gg,e._a[ut],o.year),s=me(a.w,o.week),null!=a.d?((n=a.d)<0||n>6)&&(i=!0):null!=a.e?(n=a.e+d,(a.e<0||a.e>6)&&(i=!0)):n=d}s<1||s>X(t,d,r)?m(e)._overflowWeeks=!0:null!=i?m(e)._overflowWeekday=!0:(_=q(t,s,n,d,r),e._a[ut]=_.year,e._dayOfYear=_.dayOfYear)}(a),null!=a._dayOfYear&&(r=me(a._a[ut],n[ut]),(a._dayOfYear>N(r)||0===a._dayOfYear)&&(m(a)._overflowDayOfYear=!0),s=$(r,0,a._dayOfYear),a._a[lt]=s.getUTCMonth(),a._a[Mt]=s.getUTCDate()),t=0;t<3&&null==a._a[t];++t)a._a[t]=_[t]=n[t];for(;t<7;t++)a._a[t]=_[t]=null==a._a[t]?2===t?1:0:a._a[t];24===a._a[ht]&&0===a._a[Lt]&&0===a._a[ct]&&0===a._a[Yt]&&(a._nextDay=!0,a._a[ht]=0),a._d=(a._useUTC?$:function(e,a,t,s,n,d,r){var _=new Date(e,a,t,s,n,d,r);return e<100&&e>=0&&isFinite(_.getFullYear())&&_.setFullYear(e),_}).apply(null,_),d=a._useUTC?a._d.getUTCDay():a._d.getDay(),null!=a._tzm&&a._d.setUTCMinutes(a._d.getUTCMinutes()-a._tzm),a._nextDay&&(a._a[ht]=24),a._w&&void 0!==a._w.d&&a._w.d!==d&&(m(a).weekdayMismatch=!0)}}function le(e){var a,t,s,n,d,r,_=e._i,i=zt.exec(_)||Jt.exec(_);if(i){for(m(e).iso=!0,a=0,t=Rt.length;a<t;a++)if(Rt[a][1].exec(i[1])){n=Rt[a][0],s=!1!==Rt[a][2];break}if(null==n)return void(e._isValid=!1);if(i[3]){for(a=0,t=It.length;a<t;a++)if(It[a][1].exec(i[3])){d=(i[2]||" ")+It[a][0];break}if(null==d)return void(e._isValid=!1)}if(!s&&null!=d)return void(e._isValid=!1);if(i[4]){if(!Nt.exec(i[4]))return void(e._isValid=!1);r="Z"}e._f=n+(d||"")+(r||""),Le(e)}else e._isValid=!1}function Me(e,a,t,s,n,d){var r=[function(e){var a=parseInt(e,10);{if(a<=49)return 2e3+a;if(a<=999)return 1900+a}return a}(e),gt.indexOf(a),parseInt(t,10),parseInt(s,10),parseInt(n,10)];return d&&r.push(parseInt(d,10)),r}function he(e){var a=Gt.exec(function(e){return e.replace(/\([^)]*\)|[\n\t]/g," ").replace(/(\s\s+)/g," ").trim()}(e._i));if(a){var t=Me(a[4],a[3],a[2],a[5],a[6],a[7]);if(!function(e,a,t){if(e&&Ht.indexOf(e)!==new Date(a[0],a[1],a[2]).getDay())return m(t).weekdayMismatch=!0,t._isValid=!1,!1;return!0}(a[1],t,e))return;e._a=t,e._tzm=function(e,a,t){if(e)return Ut[e];if(a)return 0;var s=parseInt(t,10),n=s%100;return(s-n)/100*60+n}(a[8],a[9],a[10]),e._d=$.apply(null,e._a),e._d.setUTCMinutes(e._d.getUTCMinutes()-e._tzm),m(e).rfc2822=!0}else e._isValid=!1}function Le(a){if(a._f!==e.ISO_8601)if(a._f!==e.RFC_2822){a._a=[],m(a).empty=!0;var t,s,n,d,r,_=""+a._i,i=_.length,o=0;for(n=O(a._f,a._locale).match(Ca)||[],t=0;t<n.length;t++)d=n[t],(s=(_.match(E(d,a))||[])[0])&&((r=_.substr(0,_.indexOf(s))).length>0&&m(a).unusedInput.push(r),_=_.slice(_.indexOf(s)+s.length),o+=s.length),Va[d]?(s?m(a).empty=!1:m(a).unusedTokens.push(d),J(d,s,a)):a._strict&&!s&&m(a).unusedTokens.push(d);m(a).charsLeftOver=i-o,_.length>0&&m(a).unusedInput.push(_),a._a[ht]<=12&&!0===m(a).bigHour&&a._a[ht]>0&&(m(a).bigHour=void 0),m(a).parsedDateParts=a._a.slice(0),m(a).meridiem=a._meridiem,a._a[ht]=function(e,a,t){var s;if(null==t)return a;return null!=e.meridiemHour?e.meridiemHour(a,t):null!=e.isPM?((s=e.isPM(t))&&a<12&&(a+=12),s||12!==a||(a=0),a):a}(a._locale,a._a[ht],a._meridiem),ue(a),oe(a)}else he(a);else le(a)}function ce(_){var o=_._i,c=_._f;return _._locale=_._locale||ie(_._l),null===o||void 0===c&&""===o?l({nullInput:!0}):("string"==typeof o&&(_._i=o=_._locale.preparse(o)),L(o)?new h(oe(o)):(d(o)?_._d=o:a(c)?function(e){var a,t,s,n,d;if(0===e._f.length)return m(e).invalidFormat=!0,void(e._d=new Date(NaN));for(n=0;n<e._f.length;n++)d=0,a=M({},e),null!=e._useUTC&&(a._useUTC=e._useUTC),a._f=e._f[n],Le(a),u(a)&&(d+=m(a).charsLeftOver,d+=10*m(a).unusedTokens.length,m(a).score=d,(null==s||d<s)&&(s=d,t=a));i(e,t||a)}(_):c?Le(_):function(_){var i=_._i;s(i)?_._d=new Date(e.now()):d(i)?_._d=new Date(i.valueOf()):"string"==typeof i?function(a){var t=Ct.exec(a._i);null===t?(le(a),!1===a._isValid&&(delete a._isValid,he(a),!1===a._isValid&&(delete a._isValid,e.createFromInputFallback(a)))):a._d=new Date(+t[1])}(_):a(i)?(_._a=r(i.slice(0),function(e){return parseInt(e,10)}),ue(_)):t(i)?function(e){if(!e._d){var a=S(e._i);e._a=r([a.year,a.month,a.day||a.date,a.hour,a.minute,a.second,a.millisecond],function(e){return e&&parseInt(e,10)}),ue(e)}}(_):n(i)?_._d=new Date(i):e.createFromInputFallback(_)}(_),u(_)||(_._d=null),_))}function Ye(e,s,n,d,r){var _={};return!0!==n&&!1!==n||(d=n,n=void 0),(t(e)&&function(e){if(Object.getOwnPropertyNames)return 0===Object.getOwnPropertyNames(e).length;var a;for(a in e)if(e.hasOwnProperty(a))return!1;return!0}(e)||a(e)&&0===e.length)&&(e=void 0),_._isAMomentObject=!0,_._useUTC=_._isUTC=r,_._l=n,_._i=e,_._f=s,_._strict=d,function(e){var a=new h(oe(ce(e)));return a._nextDay&&(a.add(1,"d"),a._nextDay=void 0),a}(_)}function ye(e,a,t,s){return Ye(e,a,t,s,!1)}function fe(e,t){var s,n;if(1===t.length&&a(t[0])&&(t=t[0]),!t.length)return ye();for(s=t[0],n=1;n<t.length;++n)t[n].isValid()&&!t[n][e](s)||(s=t[n]);return s}function ke(e){var a=S(e),t=a.year||0,s=a.quarter||0,n=a.month||0,d=a.week||0,r=a.day||0,_=a.hour||0,i=a.minute||0,o=a.second||0,m=a.millisecond||0;this._isValid=function(e){for(var a in e)if(-1===kt.call(Zt,a)||null!=e[a]&&isNaN(e[a]))return!1;for(var t=!1,s=0;s<Zt.length;++s)if(e[Zt[s]]){if(t)return!1;parseFloat(e[Zt[s]])!==Y(e[Zt[s]])&&(t=!0)}return!0}(a),this._milliseconds=+m+1e3*o+6e4*i+1e3*_*60*60,this._days=+r+7*d,this._months=+n+3*s+12*t,this._data={},this._locale=ie(),this._bubble()}function pe(e){return e instanceof ke}function De(e){return e<0?-1*Math.round(-1*e):Math.round(e)}function Te(e,a){j(e,0,0,function(){var e=this.utcOffset(),t="+";return e<0&&(e=-e,t="-"),t+b(~~(e/60),2)+a+b(~~e%60,2)})}function ge(e,a){var t=(a||"").match(e);if(null===t)return null;var s=((t[t.length-1]||[])+"").match($t)||["-",0,0],n=60*s[1]+Y(s[2]);return 0===n?0:"+"===s[0]?n:-n}function we(a,t){var s,n;return t._isUTC?(s=t.clone(),n=(L(a)||d(a)?a.valueOf():ye(a).valueOf())-s.valueOf(),s._d.setTime(s._d.valueOf()+n),e.updateOffset(s,!1),s):ye(a).local()}function ve(e){return 15*-Math.round(e._d.getTimezoneOffset()/15)}function Se(){return!!this.isValid()&&(this._isUTC&&0===this._offset)}function He(e,a){var t,s,d,r=e,i=null;return pe(e)?r={ms:e._milliseconds,d:e._days,M:e._months}:n(e)?(r={},a?r[a]=e:r.milliseconds=e):(i=Bt.exec(e))?(t="-"===i[1]?-1:1,r={y:0,d:Y(i[Mt])*t,h:Y(i[ht])*t,m:Y(i[Lt])*t,s:Y(i[ct])*t,ms:Y(De(1e3*i[Yt]))*t}):(i=qt.exec(e))?(t="-"===i[1]?-1:(i[1],1),r={y:be(i[2],t),M:be(i[3],t),w:be(i[4],t),d:be(i[5],t),h:be(i[6],t),m:be(i[7],t),s:be(i[8],t)}):null==r?r={}:"object"==typeof r&&("from"in r||"to"in r)&&(d=function(e,a){var t;if(!e.isValid()||!a.isValid())return{milliseconds:0,months:0};a=we(a,e),e.isBefore(a)?t=je(e,a):((t=je(a,e)).milliseconds=-t.milliseconds,t.months=-t.months);return t}(ye(r.from),ye(r.to)),(r={}).ms=d.milliseconds,r.M=d.months),s=new ke(r),pe(e)&&_(e,"_locale")&&(s._locale=e._locale),s}function be(e,a){var t=e&&parseFloat(e.replace(",","."));return(isNaN(t)?0:t)*a}function je(e,a){var t={milliseconds:0,months:0};return t.months=a.month()-e.month()+12*(a.year()-e.year()),e.clone().add(t.months,"M").isAfter(a)&&--t.months,t.milliseconds=+a-+e.clone().add(t.months,"M"),t}function xe(e,a){return function(t,s){var n,d;return null===s||isNaN(+s)||(p(a,"moment()."+a+"(period, number) is deprecated. Please use moment()."+a+"(number, period). See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info."),d=t,t=s,s=d),t="string"==typeof t?+t:t,n=He(t,s),Pe(this,n,e),this}}function Pe(a,t,s,n){var d=t._milliseconds,r=De(t._days),_=De(t._months);a.isValid()&&(n=null==n||n,_&&V(a,C(a,"Month")+_*s),r&&G(a,"Date",C(a,"Date")+r*s),d&&a._d.setTime(a._d.valueOf()+d*s),n&&e.updateOffset(a,r||_))}function Oe(e,a){var t,s=12*(a.year()-e.year())+(a.month()-e.month()),n=e.clone().add(s,"months");return t=a-n<0?(a-n)/(n-e.clone().add(s-1,"months")):(a-n)/(e.clone().add(s+1,"months")-n),-(s+t)||0}function We(e){var a;return void 0===e?this._locale._abbr:(null!=(a=ie(e))&&(this._locale=a),this)}function Ee(){return this._locale}function Ae(e,a){j(0,[e,e.length],0,a)}function Fe(e,a,t,s,n){var d;return null==e?Q(this,s,n).year:(d=X(e,s,n),a>d&&(a=d),function(e,a,t,s,n){var d=q(e,a,t,s,n),r=$(d.year,0,d.dayOfYear);return this.year(r.getUTCFullYear()),this.month(r.getUTCMonth()),this.date(r.getUTCDate()),this}.call(this,e,a,t,s,n))}function ze(e,a){a[Yt]=Y(1e3*("0."+e))}function Je(e){return e}function Ne(e,a,t,s){var n=ie(),d=o().set(s,a);return n[t](d,e)}function Re(e,a,t){if(n(e)&&(a=e,e=void 0),e=e||"",null!=a)return Ne(e,a,t,"month");var s,d=[];for(s=0;s<12;s++)d[s]=Ne(e,s,t,"month");return d}function Ie(e,a,t,s){"boolean"==typeof e?(n(a)&&(t=a,a=void 0),a=a||""):(t=a=e,e=!1,n(a)&&(t=a,a=void 0),a=a||"");var d=ie(),r=e?d._week.dow:0;if(null!=t)return Ne(a,(t+r)%7,s,"day");var _,i=[];for(_=0;_<7;_++)i[_]=Ne(a,(_+r)%7,s,"day");return i}function Ce(e,a,t,s){var n=He(a,t);return e._milliseconds+=s*n._milliseconds,e._days+=s*n._days,e._months+=s*n._months,e._bubble()}function Ge(e){return e<0?Math.floor(e):Math.ceil(e)}function Ue(e){return 4800*e/146097}function Ve(e){return 146097*e/4800}function Ke(e){return function(){return this.as(e)}}function Ze(e){return function(){return this.isValid()?this._data[e]:NaN}}function $e(e){return(e>0)-(e<0)||+e}function Be(){if(!this.isValid())return this.localeData().invalidDate();var e,a,t=vs(this._milliseconds)/1e3,s=vs(this._days),n=vs(this._months);a=c((e=c(t/60))/60),t%=60,e%=60;var d=c(n/12),r=n%=12,_=s,i=a,o=e,m=t?t.toFixed(3).replace(/\.?0+$/,""):"",u=this.asSeconds();if(!u)return"P0D";var l=u<0?"-":"",M=$e(this._months)!==$e(u)?"-":"",h=$e(this._days)!==$e(u)?"-":"",L=$e(this._milliseconds)!==$e(u)?"-":"";return l+"P"+(d?M+d+"Y":"")+(r?M+r+"M":"")+(_?h+_+"D":"")+(i||o||m?"T":"")+(i?L+i+"H":"")+(o?L+o+"M":"")+(m?L+m+"S":"")}function qe(e,a,t){return"m"===t?a?"\u0445\u0432\u0456\u043b\u0456\u043d\u0430":"\u0445\u0432\u0456\u043b\u0456\u043d\u0443":"h"===t?a?"\u0433\u0430\u0434\u0437\u0456\u043d\u0430":"\u0433\u0430\u0434\u0437\u0456\u043d\u0443":e+" "+function(e,a){var t=e.split("_");return a%10==1&&a%100!=11?t[0]:a%10>=2&&a%10<=4&&(a%100<10||a%100>=20)?t[1]:t[2]}({ss:a?"\u0441\u0435\u043a\u0443\u043d\u0434\u0430_\u0441\u0435\u043a\u0443\u043d\u0434\u044b_\u0441\u0435\u043a\u0443\u043d\u0434":"\u0441\u0435\u043a\u0443\u043d\u0434\u0443_\u0441\u0435\u043a\u0443\u043d\u0434\u044b_\u0441\u0435\u043a\u0443\u043d\u0434",mm:a?"\u0445\u0432\u0456\u043b\u0456\u043d\u0430_\u0445\u0432\u0456\u043b\u0456\u043d\u044b_\u0445\u0432\u0456\u043b\u0456\u043d":"\u0445\u0432\u0456\u043b\u0456\u043d\u0443_\u0445\u0432\u0456\u043b\u0456\u043d\u044b_\u0445\u0432\u0456\u043b\u0456\u043d",hh:a?"\u0433\u0430\u0434\u0437\u0456\u043d\u0430_\u0433\u0430\u0434\u0437\u0456\u043d\u044b_\u0433\u0430\u0434\u0437\u0456\u043d":"\u0433\u0430\u0434\u0437\u0456\u043d\u0443_\u0433\u0430\u0434\u0437\u0456\u043d\u044b_\u0433\u0430\u0434\u0437\u0456\u043d",dd:"\u0434\u0437\u0435\u043d\u044c_\u0434\u043d\u0456_\u0434\u0437\u0451\u043d",MM:"\u043c\u0435\u0441\u044f\u0446_\u043c\u0435\u0441\u044f\u0446\u044b_\u043c\u0435\u0441\u044f\u0446\u0430\u045e",yy:"\u0433\u043e\u0434_\u0433\u0430\u0434\u044b_\u0433\u0430\u0434\u043e\u045e"}[t],+e)}function Qe(e,a,t){return e+" "+function(e,a){if(2===a)return function(e){var a={m:"v",b:"v",d:"z"};if(void 0===a[e.charAt(0)])return e;return a[e.charAt(0)]+e.substring(1)}(e);return e}({mm:"munutenn",MM:"miz",dd:"devezh"}[t],e)}function Xe(e){return e>9?Xe(e%10):e}function ea(e,a,t){var s=e+" ";switch(t){case"ss":return s+=1===e?"sekunda":2===e||3===e||4===e?"sekunde":"sekundi";case"m":return a?"jedna minuta":"jedne minute";case"mm":return s+=1===e?"minuta":2===e||3===e||4===e?"minute":"minuta";case"h":return a?"jedan sat":"jednog sata";case"hh":return s+=1===e?"sat":2===e||3===e||4===e?"sata":"sati";case"dd":return s+=1===e?"dan":"dana";case"MM":return s+=1===e?"mjesec":2===e||3===e||4===e?"mjeseca":"mjeseci";case"yy":return s+=1===e?"godina":2===e||3===e||4===e?"godine":"godina"}}function aa(e){return e>1&&e<5&&1!=~~(e/10)}function ta(e,a,t,s){var n=e+" ";switch(t){case"s":return a||s?"p\xe1r sekund":"p\xe1r sekundami";case"ss":return a||s?n+(aa(e)?"sekundy":"sekund"):n+"sekundami";break;case"m":return a?"minuta":s?"minutu":"minutou";case"mm":return a||s?n+(aa(e)?"minuty":"minut"):n+"minutami";break;case"h":return a?"hodina":s?"hodinu":"hodinou";case"hh":return a||s?n+(aa(e)?"hodiny":"hodin"):n+"hodinami";break;case"d":return a||s?"den":"dnem";case"dd":return a||s?n+(aa(e)?"dny":"dn\xed"):n+"dny";break;case"M":return a||s?"m\u011bs\xedc":"m\u011bs\xedcem";case"MM":return a||s?n+(aa(e)?"m\u011bs\xedce":"m\u011bs\xedc\u016f"):n+"m\u011bs\xedci";break;case"y":return a||s?"rok":"rokem";case"yy":return a||s?n+(aa(e)?"roky":"let"):n+"lety";break}}function sa(e,a,t,s){var n={m:["eine Minute","einer Minute"],h:["eine Stunde","einer Stunde"],d:["ein Tag","einem Tag"],dd:[e+" Tage",e+" Tagen"],M:["ein Monat","einem Monat"],MM:[e+" Monate",e+" Monaten"],y:["ein Jahr","einem Jahr"],yy:[e+" Jahre",e+" Jahren"]};return a?n[t][0]:n[t][1]}function na(e,a,t,s){var n={m:["eine Minute","einer Minute"],h:["eine Stunde","einer Stunde"],d:["ein Tag","einem Tag"],dd:[e+" Tage",e+" Tagen"],M:["ein Monat","einem Monat"],MM:[e+" Monate",e+" Monaten"],y:["ein Jahr","einem Jahr"],yy:[e+" Jahre",e+" Jahren"]};return a?n[t][0]:n[t][1]}function da(e,a,t,s){var n={m:["eine Minute","einer Minute"],h:["eine Stunde","einer Stunde"],d:["ein Tag","einem Tag"],dd:[e+" Tage",e+" Tagen"],M:["ein Monat","einem Monat"],MM:[e+" Monate",e+" Monaten"],y:["ein Jahr","einem Jahr"],yy:[e+" Jahre",e+" Jahren"]};return a?n[t][0]:n[t][1]}function ra(e,a,t,s){var n={s:["m\xf5ne sekundi","m\xf5ni sekund","paar sekundit"],ss:[e+"sekundi",e+"sekundit"],m:["\xfche minuti","\xfcks minut"],mm:[e+" minuti",e+" minutit"],h:["\xfche tunni","tund aega","\xfcks tund"],hh:[e+" tunni",e+" tundi"],d:["\xfche p\xe4eva","\xfcks p\xe4ev"],M:["kuu aja","kuu aega","\xfcks kuu"],MM:[e+" kuu",e+" kuud"],y:["\xfche aasta","aasta","\xfcks aasta"],yy:[e+" aasta",e+" aastat"]};return a?n[t][2]?n[t][2]:n[t][1]:s?n[t][0]:n[t][1]}function _a(e,a,t,s){var n="";switch(t){case"s":return s?"muutaman sekunnin":"muutama sekunti";case"ss":return s?"sekunnin":"sekuntia";case"m":return s?"minuutin":"minuutti";case"mm":n=s?"minuutin":"minuuttia";break;case"h":return s?"tunnin":"tunti";case"hh":n=s?"tunnin":"tuntia";break;case"d":return s?"p\xe4iv\xe4n":"p\xe4iv\xe4";case"dd":n=s?"p\xe4iv\xe4n":"p\xe4iv\xe4\xe4";break;case"M":return s?"kuukauden":"kuukausi";case"MM":n=s?"kuukauden":"kuukautta";break;case"y":return s?"vuoden":"vuosi";case"yy":n=s?"vuoden":"vuotta";break}return n=function(e,a){return e<10?a?mn[e]:on[e]:e}(e,s)+" "+n}function ia(e,a,t,s){var n={s:["thodde secondanim","thodde second"],ss:[e+" secondanim",e+" second"],m:["eka mintan","ek minute"],mm:[e+" mintanim",e+" mintam"],h:["eka horan","ek hor"],hh:[e+" horanim",e+" hor"],d:["eka disan","ek dis"],dd:[e+" disanim",e+" dis"],M:["eka mhoinean","ek mhoino"],MM:[e+" mhoineanim",e+" mhoine"],y:["eka vorsan","ek voros"],yy:[e+" vorsanim",e+" vorsam"]};return a?n[t][0]:n[t][1]}function oa(e,a,t){var s=e+" ";switch(t){case"ss":return s+=1===e?"sekunda":2===e||3===e||4===e?"sekunde":"sekundi";case"m":return a?"jedna minuta":"jedne minute";case"mm":return s+=1===e?"minuta":2===e||3===e||4===e?"minute":"minuta";case"h":return a?"jedan sat":"jednog sata";case"hh":return s+=1===e?"sat":2===e||3===e||4===e?"sata":"sati";case"dd":return s+=1===e?"dan":"dana";case"MM":return s+=1===e?"mjesec":2===e||3===e||4===e?"mjeseca":"mjeseci";case"yy":return s+=1===e?"godina":2===e||3===e||4===e?"godine":"godina"}}function ma(e,a,t,s){var n=e;switch(t){case"s":return s||a?"n\xe9h\xe1ny m\xe1sodperc":"n\xe9h\xe1ny m\xe1sodperce";case"ss":return n+(s||a)?" m\xe1sodperc":" m\xe1sodperce";case"m":return"egy"+(s||a?" perc":" perce");case"mm":return n+(s||a?" perc":" perce");case"h":return"egy"+(s||a?" \xf3ra":" \xf3r\xe1ja");case"hh":return n+(s||a?" \xf3ra":" \xf3r\xe1ja");case"d":return"egy"+(s||a?" nap":" napja");case"dd":return n+(s||a?" nap":" napja");case"M":return"egy"+(s||a?" h\xf3nap":" h\xf3napja");case"MM":return n+(s||a?" h\xf3nap":" h\xf3napja");case"y":return"egy"+(s||a?" \xe9v":" \xe9ve");case"yy":return n+(s||a?" \xe9v":" \xe9ve")}return""}function ua(e){return(e?"":"[m\xfalt] ")+"["+Yn[this.day()]+"] LT[-kor]"}function la(e){return e%100==11||e%10!=1}function Ma(e,a,t,s){var n=e+" ";switch(t){case"s":return a||s?"nokkrar sek\xfandur":"nokkrum sek\xfandum";case"ss":return la(e)?n+(a||s?"sek\xfandur":"sek\xfandum"):n+"sek\xfanda";case"m":return a?"m\xedn\xfata":"m\xedn\xfatu";case"mm":return la(e)?n+(a||s?"m\xedn\xfatur":"m\xedn\xfatum"):a?n+"m\xedn\xfata":n+"m\xedn\xfatu";case"hh":return la(e)?n+(a||s?"klukkustundir":"klukkustundum"):n+"klukkustund";case"d":return a?"dagur":s?"dag":"degi";case"dd":return la(e)?a?n+"dagar":n+(s?"daga":"d\xf6gum"):a?n+"dagur":n+(s?"dag":"degi");case"M":return a?"m\xe1nu\xf0ur":s?"m\xe1nu\xf0":"m\xe1nu\xf0i";case"MM":return la(e)?a?n+"m\xe1nu\xf0ir":n+(s?"m\xe1nu\xf0i":"m\xe1nu\xf0um"):a?n+"m\xe1nu\xf0ur":n+(s?"m\xe1nu\xf0":"m\xe1nu\xf0i");case"y":return a||s?"\xe1r":"\xe1ri";case"yy":return la(e)?n+(a||s?"\xe1r":"\xe1rum"):n+(a||s?"\xe1r":"\xe1ri")}}function ha(e,a,t,s){var n={m:["eng Minutt","enger Minutt"],h:["eng Stonn","enger Stonn"],d:["een Dag","engem Dag"],M:["ee Mount","engem Mount"],y:["ee Joer","engem Joer"]};return a?n[t][0]:n[t][1]}function La(e){if(e=parseInt(e,10),isNaN(e))return!1;if(e<0)return!0;if(e<10)return 4<=e&&e<=7;if(e<100){var a=e%10;return La(0===a?e/10:a)}if(e<1e4){for(;e>=10;)e/=10;return La(e)}return e/=1e3,La(e)}function ca(e,a,t,s){return a?ya(t)[0]:s?ya(t)[1]:ya(t)[2]}function Ya(e){return e%10==0||e>10&&e<20}function ya(e){return Dn[e].split("_")}function fa(e,a,t,s){var n=e+" ";return 1===e?n+ca(0,a,t[0],s):a?n+(Ya(e)?ya(t)[1]:ya(t)[0]):s?n+ya(t)[1]:n+(Ya(e)?ya(t)[1]:ya(t)[2])}function ka(e,a,t){return t?a%10==1&&a%100!=11?e[2]:e[3]:a%10==1&&a%100!=11?e[0]:e[1]}function pa(e,a,t){return e+" "+ka(Tn[t],e,a)}function Da(e,a,t){return ka(Tn[t],e,a)}function Ta(e,a,t,s){var n="";if(a)switch(t){case"s":n="\u0915\u093e\u0939\u0940 \u0938\u0947\u0915\u0902\u0926";break;case"ss":n="%d \u0938\u0947\u0915\u0902\u0926";break;case"m":n="\u090f\u0915 \u092e\u093f\u0928\u093f\u091f";break;case"mm":n="%d \u092e\u093f\u0928\u093f\u091f\u0947";break;case"h":n="\u090f\u0915 \u0924\u093e\u0938";break;case"hh":n="%d \u0924\u093e\u0938";break;case"d":n="\u090f\u0915 \u0926\u093f\u0935\u0938";break;case"dd":n="%d \u0926\u093f\u0935\u0938";break;case"M":n="\u090f\u0915 \u092e\u0939\u093f\u0928\u093e";break;case"MM":n="%d \u092e\u0939\u093f\u0928\u0947";break;case"y":n="\u090f\u0915 \u0935\u0930\u094d\u0937";break;case"yy":n="%d \u0935\u0930\u094d\u0937\u0947";break}else switch(t){case"s":n="\u0915\u093e\u0939\u0940 \u0938\u0947\u0915\u0902\u0926\u093e\u0902";break;case"ss":n="%d \u0938\u0947\u0915\u0902\u0926\u093e\u0902";break;case"m":n="\u090f\u0915\u093e \u092e\u093f\u0928\u093f\u091f\u093e";break;case"mm":n="%d \u092e\u093f\u0928\u093f\u091f\u093e\u0902";break;case"h":n="\u090f\u0915\u093e \u0924\u093e\u0938\u093e";break;case"hh":n="%d \u0924\u093e\u0938\u093e\u0902";break;case"d":n="\u090f\u0915\u093e \u0926\u093f\u0935\u0938\u093e";break;case"dd":n="%d \u0926\u093f\u0935\u0938\u093e\u0902";break;case"M":n="\u090f\u0915\u093e \u092e\u0939\u093f\u0928\u094d\u092f\u093e";break;case"MM":n="%d \u092e\u0939\u093f\u0928\u094d\u092f\u093e\u0902";break;case"y":n="\u090f\u0915\u093e \u0935\u0930\u094d\u0937\u093e";break;case"yy":n="%d \u0935\u0930\u094d\u0937\u093e\u0902";break}return n.replace(/%d/i,e)}function ga(e){return e%10<5&&e%10>1&&~~(e/10)%10!=1}function wa(e,a,t){var s=e+" ";switch(t){case"ss":return s+(ga(e)?"sekundy":"sekund");case"m":return a?"minuta":"minut\u0119";case"mm":return s+(ga(e)?"minuty":"minut");case"h":return a?"godzina":"godzin\u0119";case"hh":return s+(ga(e)?"godziny":"godzin");case"MM":return s+(ga(e)?"miesi\u0105ce":"miesi\u0119cy");case"yy":return s+(ga(e)?"lata":"lat")}}function va(e,a,t){var s=" ";return(e%100>=20||e>=100&&e%100==0)&&(s=" de "),e+s+{ss:"secunde",mm:"minute",hh:"ore",dd:"zile",MM:"luni",yy:"ani"}[t]}function Sa(e,a,t){return"m"===t?a?"\u043c\u0438\u043d\u0443\u0442\u0430":"\u043c\u0438\u043d\u0443\u0442\u0443":e+" "+function(e,a){var t=e.split("_");return a%10==1&&a%100!=11?t[0]:a%10>=2&&a%10<=4&&(a%100<10||a%100>=20)?t[1]:t[2]}({ss:a?"\u0441\u0435\u043a\u0443\u043d\u0434\u0430_\u0441\u0435\u043a\u0443\u043d\u0434\u044b_\u0441\u0435\u043a\u0443\u043d\u0434":"\u0441\u0435\u043a\u0443\u043d\u0434\u0443_\u0441\u0435\u043a\u0443\u043d\u0434\u044b_\u0441\u0435\u043a\u0443\u043d\u0434",mm:a?"\u043c\u0438\u043d\u0443\u0442\u0430_\u043c\u0438\u043d\u0443\u0442\u044b_\u043c\u0438\u043d\u0443\u0442":"\u043c\u0438\u043d\u0443\u0442\u0443_\u043c\u0438\u043d\u0443\u0442\u044b_\u043c\u0438\u043d\u0443\u0442",hh:"\u0447\u0430\u0441_\u0447\u0430\u0441\u0430_\u0447\u0430\u0441\u043e\u0432",dd:"\u0434\u0435\u043d\u044c_\u0434\u043d\u044f_\u0434\u043d\u0435\u0439",MM:"\u043c\u0435\u0441\u044f\u0446_\u043c\u0435\u0441\u044f\u0446\u0430_\u043c\u0435\u0441\u044f\u0446\u0435\u0432",yy:"\u0433\u043e\u0434_\u0433\u043e\u0434\u0430_\u043b\u0435\u0442"}[t],+e)}function Ha(e){return e>1&&e<5}function ba(e,a,t,s){var n=e+" ";switch(t){case"s":return a||s?"p\xe1r sek\xfand":"p\xe1r sekundami";case"ss":return a||s?n+(Ha(e)?"sekundy":"sek\xfand"):n+"sekundami";break;case"m":return a?"min\xfata":s?"min\xfatu":"min\xfatou";case"mm":return a||s?n+(Ha(e)?"min\xfaty":"min\xfat"):n+"min\xfatami";break;case"h":return a?"hodina":s?"hodinu":"hodinou";case"hh":return a||s?n+(Ha(e)?"hodiny":"hod\xedn"):n+"hodinami";break;case"d":return a||s?"de\u0148":"d\u0148om";case"dd":return a||s?n+(Ha(e)?"dni":"dn\xed"):n+"d\u0148ami";break;case"M":return a||s?"mesiac":"mesiacom";case"MM":return a||s?n+(Ha(e)?"mesiace":"mesiacov"):n+"mesiacmi";break;case"y":return a||s?"rok":"rokom";case"yy":return a||s?n+(Ha(e)?"roky":"rokov"):n+"rokmi";break}}function ja(e,a,t,s){var n=e+" ";switch(t){case"s":return a||s?"nekaj sekund":"nekaj sekundami";case"ss":return n+=1===e?a?"sekundo":"sekundi":2===e?a||s?"sekundi":"sekundah":e<5?a||s?"sekunde":"sekundah":"sekund";case"m":return a?"ena minuta":"eno minuto";case"mm":return n+=1===e?a?"minuta":"minuto":2===e?a||s?"minuti":"minutama":e<5?a||s?"minute":"minutami":a||s?"minut":"minutami";case"h":return a?"ena ura":"eno uro";case"hh":return n+=1===e?a?"ura":"uro":2===e?a||s?"uri":"urama":e<5?a||s?"ure":"urami":a||s?"ur":"urami";case"d":return a||s?"en dan":"enim dnem";case"dd":return n+=1===e?a||s?"dan":"dnem":2===e?a||s?"dni":"dnevoma":a||s?"dni":"dnevi";case"M":return a||s?"en mesec":"enim mesecem";case"MM":return n+=1===e?a||s?"mesec":"mesecem":2===e?a||s?"meseca":"mesecema":e<5?a||s?"mesece":"meseci":a||s?"mesecev":"meseci";case"y":return a||s?"eno leto":"enim letom";case"yy":return n+=1===e?a||s?"leto":"letom":2===e?a||s?"leti":"letoma":e<5?a||s?"leta":"leti":a||s?"let":"leti"}}function xa(e,a,t,s){var n=function(e){var a=Math.floor(e%1e3/100),t=Math.floor(e%100/10),s=e%10,n="";a>0&&(n+=Qn[a]+"vatlh");t>0&&(n+=(""!==n?" ":"")+Qn[t]+"maH");s>0&&(n+=(""!==n?" ":"")+Qn[s]);return""===n?"pagh":n}(e);switch(t){case"ss":return n+" lup";case"mm":return n+" tup";case"hh":return n+" rep";case"dd":return n+" jaj";case"MM":return n+" jar";case"yy":return n+" DIS"}}function Pa(e,a,t,s){var n={s:["viensas secunds","'iensas secunds"],ss:[e+" secunds",e+" secunds"],m:["'n m\xedut","'iens m\xedut"],mm:[e+" m\xeduts",e+" m\xeduts"],h:["'n \xfeora","'iensa \xfeora"],hh:[e+" \xfeoras",e+" \xfeoras"],d:["'n ziua","'iensa ziua"],dd:[e+" ziuas",e+" ziuas"],M:["'n mes","'iens mes"],MM:[e+" mesen",e+" mesen"],y:["'n ar","'iens ar"],yy:[e+" ars",e+" ars"]};return s?n[t][0]:a?n[t][0]:n[t][1]}function Oa(e,a,t){return"m"===t?a?"\u0445\u0432\u0438\u043b\u0438\u043d\u0430":"\u0445\u0432\u0438\u043b\u0438\u043d\u0443":"h"===t?a?"\u0433\u043e\u0434\u0438\u043d\u0430":"\u0433\u043e\u0434\u0438\u043d\u0443":e+" "+function(e,a){var t=e.split("_");return a%10==1&&a%100!=11?t[0]:a%10>=2&&a%10<=4&&(a%100<10||a%100>=20)?t[1]:t[2]}({ss:a?"\u0441\u0435\u043a\u0443\u043d\u0434\u0430_\u0441\u0435\u043a\u0443\u043d\u0434\u0438_\u0441\u0435\u043a\u0443\u043d\u0434":"\u0441\u0435\u043a\u0443\u043d\u0434\u0443_\u0441\u0435\u043a\u0443\u043d\u0434\u0438_\u0441\u0435\u043a\u0443\u043d\u0434",mm:a?"\u0445\u0432\u0438\u043b\u0438\u043d\u0430_\u0445\u0432\u0438\u043b\u0438\u043d\u0438_\u0445\u0432\u0438\u043b\u0438\u043d":"\u0445\u0432\u0438\u043b\u0438\u043d\u0443_\u0445\u0432\u0438\u043b\u0438\u043d\u0438_\u0445\u0432\u0438\u043b\u0438\u043d",hh:a?"\u0433\u043e\u0434\u0438\u043d\u0430_\u0433\u043e\u0434\u0438\u043d\u0438_\u0433\u043e\u0434\u0438\u043d":"\u0433\u043e\u0434\u0438\u043d\u0443_\u0433\u043e\u0434\u0438\u043d\u0438_\u0433\u043e\u0434\u0438\u043d",dd:"\u0434\u0435\u043d\u044c_\u0434\u043d\u0456_\u0434\u043d\u0456\u0432",MM:"\u043c\u0456\u0441\u044f\u0446\u044c_\u043c\u0456\u0441\u044f\u0446\u0456_\u043c\u0456\u0441\u044f\u0446\u0456\u0432",yy:"\u0440\u0456\u043a_\u0440\u043e\u043a\u0438_\u0440\u043e\u043a\u0456\u0432"}[t],+e)}function Wa(e){return function(){return e+"\u043e"+(11===this.hours()?"\u0431":"")+"] LT"}}var Ea,Aa;Aa=Array.prototype.some?Array.prototype.some:function(e){for(var a=Object(this),t=a.length>>>0,s=0;s<t;s++)if(s in a&&e.call(this,a[s],s,a))return!0;return!1};var Fa=e.momentProperties=[],za=!1,Ja={};e.suppressDeprecationWarnings=!1,e.deprecationHandler=null;var Na;Na=Object.keys?Object.keys:function(e){var a,t=[];for(a in e)_(e,a)&&t.push(a);return t};var Ra={},Ia={},Ca=/(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,Ga=/(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,Ua={},Va={},Ka=/\d/,Za=/\d\d/,$a=/\d{3}/,Ba=/\d{4}/,qa=/[+-]?\d{6}/,Qa=/\d\d?/,Xa=/\d\d\d\d?/,et=/\d\d\d\d\d\d?/,at=/\d{1,3}/,tt=/\d{1,4}/,st=/[+-]?\d{1,6}/,nt=/\d+/,dt=/[+-]?\d+/,rt=/Z|[+-]\d\d:?\d\d/gi,_t=/Z|[+-]\d\d(?::?\d\d)?/gi,it=/[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,ot={},mt={},ut=0,lt=1,Mt=2,ht=3,Lt=4,ct=5,Yt=6,yt=7,ft=8;j("Y",0,0,function(){var e=this.year();return e<=9999?""+e:"+"+e}),j(0,["YY",2],0,function(){return this.year()%100}),j(0,["YYYY",4],0,"year"),j(0,["YYYYY",5],0,"year"),j(0,["YYYYYY",6,!0],0,"year"),w("year","y"),H("year",1),W("Y",dt),W("YY",Qa,Za),W("YYYY",tt,Ba),W("YYYYY",st,qa),W("YYYYYY",st,qa),F(["YYYYY","YYYYYY"],ut),F("YYYY",function(a,t){t[ut]=2===a.length?e.parseTwoDigitYear(a):Y(a)}),F("YY",function(a,t){t[ut]=e.parseTwoDigitYear(a)}),F("Y",function(e,a){a[ut]=parseInt(e,10)}),e.parseTwoDigitYear=function(e){return Y(e)+(Y(e)>68?1900:2e3)};var kt,pt=I("FullYear",!0);kt=Array.prototype.indexOf?Array.prototype.indexOf:function(e){var a;for(a=0;a<this.length;++a)if(this[a]===e)return a;return-1},j("M",["MM",2],"Mo",function(){return this.month()+1}),j("MMM",0,0,function(e){return this.localeData().monthsShort(this,e)}),j("MMMM",0,0,function(e){return this.localeData().months(this,e)}),w("month","M"),H("month",8),W("M",Qa),W("MM",Qa,Za),W("MMM",function(e,a){return a.monthsShortRegex(e)}),W("MMMM",function(e,a){return a.monthsRegex(e)}),F(["M","MM"],function(e,a){a[lt]=Y(e)-1}),F(["MMM","MMMM"],function(e,a,t,s){var n=t._locale.monthsParse(e,s,t._strict);null!=n?a[lt]=n:m(t).invalidMonth=e});var Dt=/D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,Tt="January_February_March_April_May_June_July_August_September_October_November_December".split("_"),gt="Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),wt=it,vt=it;j("w",["ww",2],"wo","week"),j("W",["WW",2],"Wo","isoWeek"),w("week","w"),w("isoWeek","W"),H("week",5),H("isoWeek",5),W("w",Qa),W("ww",Qa,Za),W("W",Qa),W("WW",Qa,Za),z(["w","ww","W","WW"],function(e,a,t,s){a[s.substr(0,1)]=Y(e)});j("d",0,"do","day"),j("dd",0,0,function(e){return this.localeData().weekdaysMin(this,e)}),j("ddd",0,0,function(e){return this.localeData().weekdaysShort(this,e)}),j("dddd",0,0,function(e){return this.localeData().weekdays(this,e)}),j("e",0,0,"weekday"),j("E",0,0,"isoWeekday"),w("day","d"),w("weekday","e"),w("isoWeekday","E"),H("day",11),H("weekday",11),H("isoWeekday",11),W("d",Qa),W("e",Qa),W("E",Qa),W("dd",function(e,a){return a.weekdaysMinRegex(e)}),W("ddd",function(e,a){return a.weekdaysShortRegex(e)}),W("dddd",function(e,a){return a.weekdaysRegex(e)}),z(["dd","ddd","dddd"],function(e,a,t,s){var n=t._locale.weekdaysParse(e,s,t._strict);null!=n?a.d=n:m(t).invalidWeekday=e}),z(["d","e","E"],function(e,a,t,s){a[s]=Y(e)});var St="Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),Ht="Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),bt="Su_Mo_Tu_We_Th_Fr_Sa".split("_"),jt=it,xt=it,Pt=it;j("H",["HH",2],0,"hour"),j("h",["hh",2],0,ae),j("k",["kk",2],0,function(){return this.hours()||24}),j("hmm",0,0,function(){return""+ae.apply(this)+b(this.minutes(),2)}),j("hmmss",0,0,function(){return""+ae.apply(this)+b(this.minutes(),2)+b(this.seconds(),2)}),j("Hmm",0,0,function(){return""+this.hours()+b(this.minutes(),2)}),j("Hmmss",0,0,function(){return""+this.hours()+b(this.minutes(),2)+b(this.seconds(),2)}),te("a",!0),te("A",!1),w("hour","h"),H("hour",13),W("a",se),W("A",se),W("H",Qa),W("h",Qa),W("k",Qa),W("HH",Qa,Za),W("hh",Qa,Za),W("kk",Qa,Za),W("hmm",Xa),W("hmmss",et),W("Hmm",Xa),W("Hmmss",et),F(["H","HH"],ht),F(["k","kk"],function(e,a,t){var s=Y(e);a[ht]=24===s?0:s}),F(["a","A"],function(e,a,t){t._isPm=t._locale.isPM(e),t._meridiem=e}),F(["h","hh"],function(e,a,t){a[ht]=Y(e),m(t).bigHour=!0}),F("hmm",function(e,a,t){var s=e.length-2;a[ht]=Y(e.substr(0,s)),a[Lt]=Y(e.substr(s)),m(t).bigHour=!0}),F("hmmss",function(e,a,t){var s=e.length-4,n=e.length-2;a[ht]=Y(e.substr(0,s)),a[Lt]=Y(e.substr(s,2)),a[ct]=Y(e.substr(n)),m(t).bigHour=!0}),F("Hmm",function(e,a,t){var s=e.length-2;a[ht]=Y(e.substr(0,s)),a[Lt]=Y(e.substr(s))}),F("Hmmss",function(e,a,t){var s=e.length-4,n=e.length-2;a[ht]=Y(e.substr(0,s)),a[Lt]=Y(e.substr(s,2)),a[ct]=Y(e.substr(n))});var Ot,Wt=I("Hours",!0),Et={calendar:{sameDay:"[Today at] LT",nextDay:"[Tomorrow at] LT",nextWeek:"dddd [at] LT",lastDay:"[Yesterday at] LT",lastWeek:"[Last] dddd [at] LT",sameElse:"L"},longDateFormat:{LTS:"h:mm:ss A",LT:"h:mm A",L:"MM/DD/YYYY",LL:"MMMM D, YYYY",LLL:"MMMM D, YYYY h:mm A",LLLL:"dddd, MMMM D, YYYY h:mm A"},invalidDate:"Invalid date",ordinal:"%d",dayOfMonthOrdinalParse:/\d{1,2}/,relativeTime:{future:"in %s",past:"%s ago",s:"a few seconds",ss:"%d seconds",m:"a minute",mm:"%d minutes",h:"an hour",hh:"%d hours",d:"a day",dd:"%d days",M:"a month",MM:"%d months",y:"a year",yy:"%d years"},months:Tt,monthsShort:gt,week:{dow:0,doy:6},weekdays:St,weekdaysMin:bt,weekdaysShort:Ht,meridiemParse:/[ap]\.?m?\.?/i},At={},Ft={},zt=/^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/,Jt=/^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/,Nt=/Z|[+-]\d\d(?::?\d\d)?/,Rt=[["YYYYYY-MM-DD",/[+-]\d{6}-\d\d-\d\d/],["YYYY-MM-DD",/\d{4}-\d\d-\d\d/],["GGGG-[W]WW-E",/\d{4}-W\d\d-\d/],["GGGG-[W]WW",/\d{4}-W\d\d/,!1],["YYYY-DDD",/\d{4}-\d{3}/],["YYYY-MM",/\d{4}-\d\d/,!1],["YYYYYYMMDD",/[+-]\d{10}/],["YYYYMMDD",/\d{8}/],["GGGG[W]WWE",/\d{4}W\d{3}/],["GGGG[W]WW",/\d{4}W\d{2}/,!1],["YYYYDDD",/\d{7}/]],It=[["HH:mm:ss.SSSS",/\d\d:\d\d:\d\d\.\d+/],["HH:mm:ss,SSSS",/\d\d:\d\d:\d\d,\d+/],["HH:mm:ss",/\d\d:\d\d:\d\d/],["HH:mm",/\d\d:\d\d/],["HHmmss.SSSS",/\d\d\d\d\d\d\.\d+/],["HHmmss,SSSS",/\d\d\d\d\d\d,\d+/],["HHmmss",/\d\d\d\d\d\d/],["HHmm",/\d\d\d\d/],["HH",/\d\d/]],Ct=/^\/?Date\((\-?\d+)/i,Gt=/^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,Ut={UT:0,GMT:0,EDT:-240,EST:-300,CDT:-300,CST:-360,MDT:-360,MST:-420,PDT:-420,PST:-480};e.createFromInputFallback=k("value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged and will be removed in an upcoming major release. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.",function(e){e._d=new Date(e._i+(e._useUTC?" UTC":""))}),e.ISO_8601=function(){},e.RFC_2822=function(){};var Vt=k("moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/",function(){var e=ye.apply(null,arguments);return this.isValid()&&e.isValid()?e<this?this:e:l()}),Kt=k("moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/",function(){var e=ye.apply(null,arguments);return this.isValid()&&e.isValid()?e>this?this:e:l()}),Zt=["year","quarter","month","week","day","hour","minute","second","millisecond"];Te("Z",":"),Te("ZZ",""),W("Z",_t),W("ZZ",_t),F(["Z","ZZ"],function(e,a,t){t._useUTC=!0,t._tzm=ge(_t,e)});var $t=/([\+\-]|\d\d)/gi;e.updateOffset=function(){};var Bt=/^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/,qt=/^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;He.fn=ke.prototype,He.invalid=function(){return He(NaN)};var Qt=xe(1,"add"),Xt=xe(-1,"subtract");e.defaultFormat="YYYY-MM-DDTHH:mm:ssZ",e.defaultFormatUtc="YYYY-MM-DDTHH:mm:ss[Z]";var es=k("moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.",function(e){return void 0===e?this.localeData():this.locale(e)});j(0,["gg",2],0,function(){return this.weekYear()%100}),j(0,["GG",2],0,function(){return this.isoWeekYear()%100}),Ae("gggg","weekYear"),Ae("ggggg","weekYear"),Ae("GGGG","isoWeekYear"),Ae("GGGGG","isoWeekYear"),w("weekYear","gg"),w("isoWeekYear","GG"),H("weekYear",1),H("isoWeekYear",1),W("G",dt),W("g",dt),W("GG",Qa,Za),W("gg",Qa,Za),W("GGGG",tt,Ba),W("gggg",tt,Ba),W("GGGGG",st,qa),W("ggggg",st,qa),z(["gggg","ggggg","GGGG","GGGGG"],function(e,a,t,s){a[s.substr(0,2)]=Y(e)}),z(["gg","GG"],function(a,t,s,n){t[n]=e.parseTwoDigitYear(a)}),j("Q",0,"Qo","quarter"),w("quarter","Q"),H("quarter",7),W("Q",Ka),F("Q",function(e,a){a[lt]=3*(Y(e)-1)}),j("D",["DD",2],"Do","date"),w("date","D"),H("date",9),W("D",Qa),W("DD",Qa,Za),W("Do",function(e,a){return e?a._dayOfMonthOrdinalParse||a._ordinalParse:a._dayOfMonthOrdinalParseLenient}),F(["D","DD"],Mt),F("Do",function(e,a){a[Mt]=Y(e.match(Qa)[0])});var as=I("Date",!0);j("DDD",["DDDD",3],"DDDo","dayOfYear"),w("dayOfYear","DDD"),H("dayOfYear",4),W("DDD",at),W("DDDD",$a),F(["DDD","DDDD"],function(e,a,t){t._dayOfYear=Y(e)}),j("m",["mm",2],0,"minute"),w("minute","m"),H("minute",14),W("m",Qa),W("mm",Qa,Za),F(["m","mm"],Lt);var ts=I("Minutes",!1);j("s",["ss",2],0,"second"),w("second","s"),H("second",15),W("s",Qa),W("ss",Qa,Za),F(["s","ss"],ct);var ss=I("Seconds",!1);j("S",0,0,function(){return~~(this.millisecond()/100)}),j(0,["SS",2],0,function(){return~~(this.millisecond()/10)}),j(0,["SSS",3],0,"millisecond"),j(0,["SSSS",4],0,function(){return 10*this.millisecond()}),j(0,["SSSSS",5],0,function(){return 100*this.millisecond()}),j(0,["SSSSSS",6],0,function(){return 1e3*this.millisecond()}),j(0,["SSSSSSS",7],0,function(){return 1e4*this.millisecond()}),j(0,["SSSSSSSS",8],0,function(){return 1e5*this.millisecond()}),j(0,["SSSSSSSSS",9],0,function(){return 1e6*this.millisecond()}),w("millisecond","ms"),H("millisecond",16),W("S",at,Ka),W("SS",at,Za),W("SSS",at,$a);var ns;for(ns="SSSS";ns.length<=9;ns+="S")W(ns,nt);for(ns="S";ns.length<=9;ns+="S")F(ns,ze);var ds=I("Milliseconds",!1);j("z",0,0,"zoneAbbr"),j("zz",0,0,"zoneName");var rs=h.prototype;rs.add=Qt,rs.calendar=function(a,t){var s=a||ye(),n=we(s,this).startOf("day"),d=e.calendarFormat(this,n)||"sameElse",r=t&&(D(t[d])?t[d].call(this,s):t[d]);return this.format(r||this.localeData().calendar(d,this,ye(s)))},rs.clone=function(){return new h(this)},rs.diff=function(e,a,t){var s,n,d;if(!this.isValid())return NaN;if(!(s=we(e,this)).isValid())return NaN;switch(n=6e4*(s.utcOffset()-this.utcOffset()),a=v(a)){case"year":d=Oe(this,s)/12;break;case"month":d=Oe(this,s);break;case"quarter":d=Oe(this,s)/3;break;case"second":d=(this-s)/1e3;break;case"minute":d=(this-s)/6e4;break;case"hour":d=(this-s)/36e5;break;case"day":d=(this-s-n)/864e5;break;case"week":d=(this-s-n)/6048e5;break;default:d=this-s}return t?d:c(d)},rs.endOf=function(e){return void 0===(e=v(e))||"millisecond"===e?this:("date"===e&&(e="day"),this.startOf(e).add(1,"isoWeek"===e?"week":e).subtract(1,"ms"))},rs.format=function(a){a||(a=this.isUtc()?e.defaultFormatUtc:e.defaultFormat);var t=P(this,a);return this.localeData().postformat(t)},rs.from=function(e,a){return this.isValid()&&(L(e)&&e.isValid()||ye(e).isValid())?He({to:this,from:e}).locale(this.locale()).humanize(!a):this.localeData().invalidDate()},rs.fromNow=function(e){return this.from(ye(),e)},rs.to=function(e,a){return this.isValid()&&(L(e)&&e.isValid()||ye(e).isValid())?He({from:this,to:e}).locale(this.locale()).humanize(!a):this.localeData().invalidDate()},rs.toNow=function(e){return this.to(ye(),e)},rs.get=function(e){return e=v(e),D(this[e])?this[e]():this},rs.invalidAt=function(){return m(this).overflow},rs.isAfter=function(e,a){var t=L(e)?e:ye(e);return!(!this.isValid()||!t.isValid())&&("millisecond"===(a=v(s(a)?"millisecond":a))?this.valueOf()>t.valueOf():t.valueOf()<this.clone().startOf(a).valueOf())},rs.isBefore=function(e,a){var t=L(e)?e:ye(e);return!(!this.isValid()||!t.isValid())&&("millisecond"===(a=v(s(a)?"millisecond":a))?this.valueOf()<t.valueOf():this.clone().endOf(a).valueOf()<t.valueOf())},rs.isBetween=function(e,a,t,s){return("("===(s=s||"()")[0]?this.isAfter(e,t):!this.isBefore(e,t))&&(")"===s[1]?this.isBefore(a,t):!this.isAfter(a,t))},rs.isSame=function(e,a){var t,s=L(e)?e:ye(e);return!(!this.isValid()||!s.isValid())&&("millisecond"===(a=v(a||"millisecond"))?this.valueOf()===s.valueOf():(t=s.valueOf(),this.clone().startOf(a).valueOf()<=t&&t<=this.clone().endOf(a).valueOf()))},rs.isSameOrAfter=function(e,a){return this.isSame(e,a)||this.isAfter(e,a)},rs.isSameOrBefore=function(e,a){return this.isSame(e,a)||this.isBefore(e,a)},rs.isValid=function(){return u(this)},rs.lang=es,rs.locale=We,rs.localeData=Ee,rs.max=Kt,rs.min=Vt,rs.parsingFlags=function(){return i({},m(this))},rs.set=function(e,a){if("object"==typeof e)for(var t=function(e){var a=[];for(var t in e)a.push({unit:t,priority:Ia[t]});return a.sort(function(e,a){return e.priority-a.priority}),a}(e=S(e)),s=0;s<t.length;s++)this[t[s].unit](e[t[s].unit]);else if(e=v(e),D(this[e]))return this[e](a);return this},rs.startOf=function(e){switch(e=v(e)){case"year":this.month(0);case"quarter":case"month":this.date(1);case"week":case"isoWeek":case"day":case"date":this.hours(0);case"hour":this.minutes(0);case"minute":this.seconds(0);case"second":this.milliseconds(0)}return"week"===e&&this.weekday(0),"isoWeek"===e&&this.isoWeekday(1),"quarter"===e&&this.month(3*Math.floor(this.month()/3)),this},rs.subtract=Xt,rs.toArray=function(){return[this.year(),this.month(),this.date(),this.hour(),this.minute(),this.second(),this.millisecond()]},rs.toObject=function(){return{years:this.year(),months:this.month(),date:this.date(),hours:this.hours(),minutes:this.minutes(),seconds:this.seconds(),milliseconds:this.milliseconds()}},rs.toDate=function(){return new Date(this.valueOf())},rs.toISOString=function(e){if(!this.isValid())return null;var a=!0!==e,t=a?this.clone().utc():this;return t.year()<0||t.year()>9999?P(t,a?"YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]":"YYYYYY-MM-DD[T]HH:mm:ss.SSSZ"):D(Date.prototype.toISOString)?a?this.toDate().toISOString():new Date(this._d.valueOf()).toISOString().replace("Z",P(t,"Z")):P(t,a?"YYYY-MM-DD[T]HH:mm:ss.SSS[Z]":"YYYY-MM-DD[T]HH:mm:ss.SSSZ")},rs.inspect=function(){if(!this.isValid())return"moment.invalid(/* "+this._i+" */)";var e="moment",a="";this.isLocal()||(e=0===this.utcOffset()?"moment.utc":"moment.parseZone",a="Z");var t="["+e+'("]',s=0<=this.year()&&this.year()<=9999?"YYYY":"YYYYYY",n=a+'[")]';return this.format(t+s+"-MM-DD[T]HH:mm:ss.SSS"+n)},rs.toJSON=function(){return this.isValid()?this.toISOString():null},rs.toString=function(){return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ")},rs.unix=function(){return Math.floor(this.valueOf()/1e3)},rs.valueOf=function(){return this._d.valueOf()-6e4*(this._offset||0)},rs.creationData=function(){return{input:this._i,format:this._f,locale:this._locale,isUTC:this._isUTC,strict:this._strict}},rs.year=pt,rs.isLeapYear=function(){return R(this.year())},rs.weekYear=function(e){return Fe.call(this,e,this.week(),this.weekday(),this.localeData()._week.dow,this.localeData()._week.doy)},rs.isoWeekYear=function(e){return Fe.call(this,e,this.isoWeek(),this.isoWeekday(),1,4)},rs.quarter=rs.quarters=function(e){return null==e?Math.ceil((this.month()+1)/3):this.month(3*(e-1)+this.month()%3)},rs.month=K,rs.daysInMonth=function(){return U(this.year(),this.month())},rs.week=rs.weeks=function(e){var a=this.localeData().week(this);return null==e?a:this.add(7*(e-a),"d")},rs.isoWeek=rs.isoWeeks=function(e){var a=Q(this,1,4).week;return null==e?a:this.add(7*(e-a),"d")},rs.weeksInYear=function(){var e=this.localeData()._week;return X(this.year(),e.dow,e.doy)},rs.isoWeeksInYear=function(){return X(this.year(),1,4)},rs.date=as,rs.day=rs.days=function(e){if(!this.isValid())return null!=e?this:NaN;var a=this._isUTC?this._d.getUTCDay():this._d.getDay();return null!=e?(e=function(e,a){return"string"!=typeof e?e:isNaN(e)?"number"==typeof(e=a.weekdaysParse(e))?e:null:parseInt(e,10)}(e,this.localeData()),this.add(e-a,"d")):a},rs.weekday=function(e){if(!this.isValid())return null!=e?this:NaN;var a=(this.day()+7-this.localeData()._week.dow)%7;return null==e?a:this.add(e-a,"d")},rs.isoWeekday=function(e){if(!this.isValid())return null!=e?this:NaN;if(null!=e){var a=function(e,a){return"string"==typeof e?a.weekdaysParse(e)%7||7:isNaN(e)?null:e}(e,this.localeData());return this.day(this.day()%7?a:a-7)}return this.day()||7},rs.dayOfYear=function(e){var a=Math.round((this.clone().startOf("day")-this.clone().startOf("year"))/864e5)+1;return null==e?a:this.add(e-a,"d")},rs.hour=rs.hours=Wt,rs.minute=rs.minutes=ts,rs.second=rs.seconds=ss,rs.millisecond=rs.milliseconds=ds,rs.utcOffset=function(a,t,s){var n,d=this._offset||0;if(!this.isValid())return null!=a?this:NaN;if(null!=a){if("string"==typeof a){if(null===(a=ge(_t,a)))return this}else Math.abs(a)<16&&!s&&(a*=60);return!this._isUTC&&t&&(n=ve(this)),this._offset=a,this._isUTC=!0,null!=n&&this.add(n,"m"),d!==a&&(!t||this._changeInProgress?Pe(this,He(a-d,"m"),1,!1):this._changeInProgress||(this._changeInProgress=!0,e.updateOffset(this,!0),this._changeInProgress=null)),this}return this._isUTC?d:ve(this)},rs.utc=function(e){return this.utcOffset(0,e)},rs.local=function(e){return this._isUTC&&(this.utcOffset(0,e),this._isUTC=!1,e&&this.subtract(ve(this),"m")),this},rs.parseZone=function(){if(null!=this._tzm)this.utcOffset(this._tzm,!1,!0);else if("string"==typeof this._i){var e=ge(rt,this._i);null!=e?this.utcOffset(e):this.utcOffset(0,!0)}return this},rs.hasAlignedHourOffset=function(e){return!!this.isValid()&&(e=e?ye(e).utcOffset():0,(this.utcOffset()-e)%60==0)},rs.isDST=function(){return this.utcOffset()>this.clone().month(0).utcOffset()||this.utcOffset()>this.clone().month(5).utcOffset()},rs.isLocal=function(){return!!this.isValid()&&!this._isUTC},rs.isUtcOffset=function(){return!!this.isValid()&&this._isUTC},rs.isUtc=Se,rs.isUTC=Se,rs.zoneAbbr=function(){return this._isUTC?"UTC":""},rs.zoneName=function(){return this._isUTC?"Coordinated Universal Time":""},rs.dates=k("dates accessor is deprecated. Use date instead.",as),rs.months=k("months accessor is deprecated. Use month instead",K),rs.years=k("years accessor is deprecated. Use year instead",pt),rs.zone=k("moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/",function(e,a){return null!=e?("string"!=typeof e&&(e=-e),this.utcOffset(e,a),this):-this.utcOffset()}),rs.isDSTShifted=k("isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information",function(){if(!s(this._isDSTShifted))return this._isDSTShifted;var e={};if(M(e,this),(e=ce(e))._a){var a=e._isUTC?o(e._a):ye(e._a);this._isDSTShifted=this.isValid()&&y(e._a,a.toArray())>0}else this._isDSTShifted=!1;return this._isDSTShifted});var _s=g.prototype;_s.calendar=function(e,a,t){var s=this._calendar[e]||this._calendar.sameElse;return D(s)?s.call(a,t):s},_s.longDateFormat=function(e){var a=this._longDateFormat[e],t=this._longDateFormat[e.toUpperCase()];return a||!t?a:(this._longDateFormat[e]=t.replace(/MMMM|MM|DD|dddd/g,function(e){return e.slice(1)}),this._longDateFormat[e])},_s.invalidDate=function(){return this._invalidDate},_s.ordinal=function(e){return this._ordinal.replace("%d",e)},_s.preparse=Je,_s.postformat=Je,_s.relativeTime=function(e,a,t,s){var n=this._relativeTime[t];return D(n)?n(e,a,t,s):n.replace(/%d/i,e)},_s.pastFuture=function(e,a){var t=this._relativeTime[e>0?"future":"past"];return D(t)?t(a):t.replace(/%s/i,a)},_s.set=function(e){var a,t;for(t in e)D(a=e[t])?this[t]=a:this["_"+t]=a;this._config=e,this._dayOfMonthOrdinalParseLenient=new RegExp((this._dayOfMonthOrdinalParse.source||this._ordinalParse.source)+"|"+/\d{1,2}/.source)},_s.months=function(e,t){return e?a(this._months)?this._months[e.month()]:this._months[(this._months.isFormat||Dt).test(t)?"format":"standalone"][e.month()]:a(this._months)?this._months:this._months.standalone},_s.monthsShort=function(e,t){return e?a(this._monthsShort)?this._monthsShort[e.month()]:this._monthsShort[Dt.test(t)?"format":"standalone"][e.month()]:a(this._monthsShort)?this._monthsShort:this._monthsShort.standalone},_s.monthsParse=function(e,a,t){var s,n,d;if(this._monthsParseExact)return function(e,a,t){var s,n,d,r=e.toLocaleLowerCase();if(!this._monthsParse)for(this._monthsParse=[],this._longMonthsParse=[],this._shortMonthsParse=[],s=0;s<12;++s)d=o([2e3,s]),this._shortMonthsParse[s]=this.monthsShort(d,"").toLocaleLowerCase(),this._longMonthsParse[s]=this.months(d,"").toLocaleLowerCase();return t?"MMM"===a?-1!==(n=kt.call(this._shortMonthsParse,r))?n:null:-1!==(n=kt.call(this._longMonthsParse,r))?n:null:"MMM"===a?-1!==(n=kt.call(this._shortMonthsParse,r))?n:-1!==(n=kt.call(this._longMonthsParse,r))?n:null:-1!==(n=kt.call(this._longMonthsParse,r))?n:-1!==(n=kt.call(this._shortMonthsParse,r))?n:null}.call(this,e,a,t);for(this._monthsParse||(this._monthsParse=[],this._longMonthsParse=[],this._shortMonthsParse=[]),s=0;s<12;s++){if(n=o([2e3,s]),t&&!this._longMonthsParse[s]&&(this._longMonthsParse[s]=new RegExp("^"+this.months(n,"").replace(".","")+"$","i"),this._shortMonthsParse[s]=new RegExp("^"+this.monthsShort(n,"").replace(".","")+"$","i")),t||this._monthsParse[s]||(d="^"+this.months(n,"")+"|^"+this.monthsShort(n,""),this._monthsParse[s]=new RegExp(d.replace(".",""),"i")),t&&"MMMM"===a&&this._longMonthsParse[s].test(e))return s;if(t&&"MMM"===a&&this._shortMonthsParse[s].test(e))return s;if(!t&&this._monthsParse[s].test(e))return s}},_s.monthsRegex=function(e){return this._monthsParseExact?(_(this,"_monthsRegex")||Z.call(this),e?this._monthsStrictRegex:this._monthsRegex):(_(this,"_monthsRegex")||(this._monthsRegex=vt),this._monthsStrictRegex&&e?this._monthsStrictRegex:this._monthsRegex)},_s.monthsShortRegex=function(e){return this._monthsParseExact?(_(this,"_monthsRegex")||Z.call(this),e?this._monthsShortStrictRegex:this._monthsShortRegex):(_(this,"_monthsShortRegex")||(this._monthsShortRegex=wt),this._monthsShortStrictRegex&&e?this._monthsShortStrictRegex:this._monthsShortRegex)},_s.week=function(e){return Q(e,this._week.dow,this._week.doy).week},_s.firstDayOfYear=function(){return this._week.doy},_s.firstDayOfWeek=function(){return this._week.dow},_s.weekdays=function(e,t){return e?a(this._weekdays)?this._weekdays[e.day()]:this._weekdays[this._weekdays.isFormat.test(t)?"format":"standalone"][e.day()]:a(this._weekdays)?this._weekdays:this._weekdays.standalone},_s.weekdaysMin=function(e){return e?this._weekdaysMin[e.day()]:this._weekdaysMin},_s.weekdaysShort=function(e){return e?this._weekdaysShort[e.day()]:this._weekdaysShort},_s.weekdaysParse=function(e,a,t){var s,n,d;if(this._weekdaysParseExact)return function(e,a,t){var s,n,d,r=e.toLocaleLowerCase();if(!this._weekdaysParse)for(this._weekdaysParse=[],this._shortWeekdaysParse=[],this._minWeekdaysParse=[],s=0;s<7;++s)d=o([2e3,1]).day(s),this._minWeekdaysParse[s]=this.weekdaysMin(d,"").toLocaleLowerCase(),this._shortWeekdaysParse[s]=this.weekdaysShort(d,"").toLocaleLowerCase(),this._weekdaysParse[s]=this.weekdays(d,"").toLocaleLowerCase();return t?"dddd"===a?-1!==(n=kt.call(this._weekdaysParse,r))?n:null:"ddd"===a?-1!==(n=kt.call(this._shortWeekdaysParse,r))?n:null:-1!==(n=kt.call(this._minWeekdaysParse,r))?n:null:"dddd"===a?-1!==(n=kt.call(this._weekdaysParse,r))?n:-1!==(n=kt.call(this._shortWeekdaysParse,r))?n:-1!==(n=kt.call(this._minWeekdaysParse,r))?n:null:"ddd"===a?-1!==(n=kt.call(this._shortWeekdaysParse,r))?n:-1!==(n=kt.call(this._weekdaysParse,r))?n:-1!==(n=kt.call(this._minWeekdaysParse,r))?n:null:-1!==(n=kt.call(this._minWeekdaysParse,r))?n:-1!==(n=kt.call(this._weekdaysParse,r))?n:-1!==(n=kt.call(this._shortWeekdaysParse,r))?n:null}.call(this,e,a,t);for(this._weekdaysParse||(this._weekdaysParse=[],this._minWeekdaysParse=[],this._shortWeekdaysParse=[],this._fullWeekdaysParse=[]),s=0;s<7;s++){if(n=o([2e3,1]).day(s),t&&!this._fullWeekdaysParse[s]&&(this._fullWeekdaysParse[s]=new RegExp("^"+this.weekdays(n,"").replace(".",".?")+"$","i"),this._shortWeekdaysParse[s]=new RegExp("^"+this.weekdaysShort(n,"").replace(".",".?")+"$","i"),this._minWeekdaysParse[s]=new RegExp("^"+this.weekdaysMin(n,"").replace(".",".?")+"$","i")),this._weekdaysParse[s]||(d="^"+this.weekdays(n,"")+"|^"+this.weekdaysShort(n,"")+"|^"+this.weekdaysMin(n,""),this._weekdaysParse[s]=new RegExp(d.replace(".",""),"i")),t&&"dddd"===a&&this._fullWeekdaysParse[s].test(e))return s;if(t&&"ddd"===a&&this._shortWeekdaysParse[s].test(e))return s;if(t&&"dd"===a&&this._minWeekdaysParse[s].test(e))return s;if(!t&&this._weekdaysParse[s].test(e))return s}},_s.weekdaysRegex=function(e){return this._weekdaysParseExact?(_(this,"_weekdaysRegex")||ee.call(this),e?this._weekdaysStrictRegex:this._weekdaysRegex):(_(this,"_weekdaysRegex")||(this._weekdaysRegex=jt),this._weekdaysStrictRegex&&e?this._weekdaysStrictRegex:this._weekdaysRegex)},_s.weekdaysShortRegex=function(e){return this._weekdaysParseExact?(_(this,"_weekdaysRegex")||ee.call(this),e?this._weekdaysShortStrictRegex:this._weekdaysShortRegex):(_(this,"_weekdaysShortRegex")||(this._weekdaysShortRegex=xt),this._weekdaysShortStrictRegex&&e?this._weekdaysShortStrictRegex:this._weekdaysShortRegex)},_s.weekdaysMinRegex=function(e){return this._weekdaysParseExact?(_(this,"_weekdaysRegex")||ee.call(this),e?this._weekdaysMinStrictRegex:this._weekdaysMinRegex):(_(this,"_weekdaysMinRegex")||(this._weekdaysMinRegex=Pt),this._weekdaysMinStrictRegex&&e?this._weekdaysMinStrictRegex:this._weekdaysMinRegex)},_s.isPM=function(e){return"p"===(e+"").toLowerCase().charAt(0)},_s.meridiem=function(e,a,t){return e>11?t?"pm":"PM":t?"am":"AM"},re("en",{dayOfMonthOrdinalParse:/\d{1,2}(th|st|nd|rd)/,ordinal:function(e){var a=e%10;return e+(1===Y(e%100/10)?"th":1===a?"st":2===a?"nd":3===a?"rd":"th")}}),e.lang=k("moment.lang is deprecated. Use moment.locale instead.",re),e.langData=k("moment.langData is deprecated. Use moment.localeData instead.",ie);var is=Math.abs,os=Ke("ms"),ms=Ke("s"),us=Ke("m"),ls=Ke("h"),Ms=Ke("d"),hs=Ke("w"),Ls=Ke("M"),cs=Ke("y"),Ys=Ze("milliseconds"),ys=Ze("seconds"),fs=Ze("minutes"),ks=Ze("hours"),ps=Ze("days"),Ds=Ze("months"),Ts=Ze("years"),gs=Math.round,ws={ss:44,s:45,m:45,h:22,d:26,M:11},vs=Math.abs,Ss=ke.prototype;Ss.isValid=function(){return this._isValid},Ss.abs=function(){var e=this._data;return this._milliseconds=is(this._milliseconds),this._days=is(this._days),this._months=is(this._months),e.milliseconds=is(e.milliseconds),e.seconds=is(e.seconds),e.minutes=is(e.minutes),e.hours=is(e.hours),e.months=is(e.months),e.years=is(e.years),this},Ss.add=function(e,a){return Ce(this,e,a,1)},Ss.subtract=function(e,a){return Ce(this,e,a,-1)},Ss.as=function(e){if(!this.isValid())return NaN;var a,t,s=this._milliseconds;if("month"===(e=v(e))||"year"===e)return a=this._days+s/864e5,t=this._months+Ue(a),"month"===e?t:t/12;switch(a=this._days+Math.round(Ve(this._months)),e){case"week":return a/7+s/6048e5;case"day":return a+s/864e5;case"hour":return 24*a+s/36e5;case"minute":return 1440*a+s/6e4;case"second":return 86400*a+s/1e3;case"millisecond":return Math.floor(864e5*a)+s;default:throw new Error("Unknown unit "+e)}},Ss.asMilliseconds=os,Ss.asSeconds=ms,Ss.asMinutes=us,Ss.asHours=ls,Ss.asDays=Ms,Ss.asWeeks=hs,Ss.asMonths=Ls,Ss.asYears=cs,Ss.valueOf=function(){return this.isValid()?this._milliseconds+864e5*this._days+this._months%12*2592e6+31536e6*Y(this._months/12):NaN},Ss._bubble=function(){var e,a,t,s,n,d=this._milliseconds,r=this._days,_=this._months,i=this._data;return d>=0&&r>=0&&_>=0||d<=0&&r<=0&&_<=0||(d+=864e5*Ge(Ve(_)+r),r=0,_=0),i.milliseconds=d%1e3,e=c(d/1e3),i.seconds=e%60,a=c(e/60),i.minutes=a%60,t=c(a/60),i.hours=t%24,r+=c(t/24),n=c(Ue(r)),_+=n,r-=Ge(Ve(n)),s=c(_/12),_%=12,i.days=r,i.months=_,i.years=s,this},Ss.clone=function(){return He(this)},Ss.get=function(e){return e=v(e),this.isValid()?this[e+"s"]():NaN},Ss.milliseconds=Ys,Ss.seconds=ys,Ss.minutes=fs,Ss.hours=ks,Ss.days=ps,Ss.weeks=function(){return c(this.days()/7)},Ss.months=Ds,Ss.years=Ts,Ss.humanize=function(e){if(!this.isValid())return this.localeData().invalidDate();var a=this.localeData(),t=function(e,a,t){var s=He(e).abs(),n=gs(s.as("s")),d=gs(s.as("m")),r=gs(s.as("h")),_=gs(s.as("d")),i=gs(s.as("M")),o=gs(s.as("y")),m=n<=ws.ss&&["s",n]||n<ws.s&&["ss",n]||d<=1&&["m"]||d<ws.m&&["mm",d]||r<=1&&["h"]||r<ws.h&&["hh",r]||_<=1&&["d"]||_<ws.d&&["dd",_]||i<=1&&["M"]||i<ws.M&&["MM",i]||o<=1&&["y"]||["yy",o];return m[2]=a,m[3]=+e>0,m[4]=t,function(e,a,t,s,n){return n.relativeTime(a||1,!!t,e,s)}.apply(null,m)}(this,!e,a);return e&&(t=a.pastFuture(+this,t)),a.postformat(t)},Ss.toISOString=Be,Ss.toString=Be,Ss.toJSON=Be,Ss.locale=We,Ss.localeData=Ee,Ss.toIsoString=k("toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)",Be),Ss.lang=es,j("X",0,0,"unix"),j("x",0,0,"valueOf"),W("x",dt),W("X",/[+-]?\d+(\.\d{1,3})?/),F("X",function(e,a,t){t._d=new Date(1e3*parseFloat(e,10))}),F("x",function(e,a,t){t._d=new Date(Y(e))}),e.version="2.20.1",function(e){Ea=e}(ye),e.fn=rs,e.min=function(){return fe("isBefore",[].slice.call(arguments,0))},e.max=function(){return fe("isAfter",[].slice.call(arguments,0))},e.now=function(){return Date.now?Date.now():+new Date},e.utc=o,e.unix=function(e){return ye(1e3*e)},e.months=function(e,a){return Re(e,a,"months")},e.isDate=d,e.locale=re,e.invalid=l,e.duration=He,e.isMoment=L,e.weekdays=function(e,a,t){return Ie(e,a,t,"weekdays")},e.parseZone=function(){return ye.apply(null,arguments).parseZone()},e.localeData=ie,e.isDuration=pe,e.monthsShort=function(e,a){return Re(e,a,"monthsShort")},e.weekdaysMin=function(e,a,t){return Ie(e,a,t,"weekdaysMin")},e.defineLocale=_e,e.updateLocale=function(e,a){if(null!=a){var t,s,n=Et;null!=(s=de(e))&&(n=s._config),(t=new g(a=T(n,a))).parentLocale=At[e],At[e]=t,re(e)}else null!=At[e]&&(null!=At[e].parentLocale?At[e]=At[e].parentLocale:null!=At[e]&&delete At[e]);return At[e]},e.locales=function(){return Na(At)},e.weekdaysShort=function(e,a,t){return Ie(e,a,t,"weekdaysShort")},e.normalizeUnits=v,e.relativeTimeRounding=function(e){return void 0===e?gs:"function"==typeof e&&(gs=e,!0)},e.relativeTimeThreshold=function(e,a){return void 0!==ws[e]&&(void 0===a?ws[e]:(ws[e]=a,"s"===e&&(ws.ss=a-1),!0))},e.calendarFormat=function(e,a){var t=e.diff(a,"days",!0);return t<-6?"sameElse":t<-1?"lastWeek":t<0?"lastDay":t<1?"sameDay":t<2?"nextDay":t<7?"nextWeek":"sameElse"},e.prototype=rs,e.HTML5_FMT={DATETIME_LOCAL:"YYYY-MM-DDTHH:mm",DATETIME_LOCAL_SECONDS:"YYYY-MM-DDTHH:mm:ss",DATETIME_LOCAL_MS:"YYYY-MM-DDTHH:mm:ss.SSS",DATE:"YYYY-MM-DD",TIME:"HH:mm",TIME_SECONDS:"HH:mm:ss",TIME_MS:"HH:mm:ss.SSS",WEEK:"YYYY-[W]WW",MONTH:"YYYY-MM"},e.defineLocale("af",{months:"Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember".split("_"),monthsShort:"Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des".split("_"),weekdays:"Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag".split("_"),weekdaysShort:"Son_Maa_Din_Woe_Don_Vry_Sat".split("_"),weekdaysMin:"So_Ma_Di_Wo_Do_Vr_Sa".split("_"),meridiemParse:/vm|nm/i,isPM:function(e){return/^nm$/i.test(e)},meridiem:function(e,a,t){return e<12?t?"vm":"VM":t?"nm":"NM"},longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[Vandag om] LT",nextDay:"[M\xf4re om] LT",nextWeek:"dddd [om] LT",lastDay:"[Gister om] LT",lastWeek:"[Laas] dddd [om] LT",sameElse:"L"},relativeTime:{future:"oor %s",past:"%s gelede",s:"'n paar sekondes",ss:"%d sekondes",m:"'n minuut",mm:"%d minute",h:"'n uur",hh:"%d ure",d:"'n dag",dd:"%d dae",M:"'n maand",MM:"%d maande",y:"'n jaar",yy:"%d jaar"},dayOfMonthOrdinalParse:/\d{1,2}(ste|de)/,ordinal:function(e){return e+(1===e||8===e||e>=20?"ste":"de")},week:{dow:1,doy:4}}),e.defineLocale("ar-dz",{months:"\u062c\u0627\u0646\u0641\u064a_\u0641\u064a\u0641\u0631\u064a_\u0645\u0627\u0631\u0633_\u0623\u0641\u0631\u064a\u0644_\u0645\u0627\u064a_\u062c\u0648\u0627\u0646_\u062c\u0648\u064a\u0644\u064a\u0629_\u0623\u0648\u062a_\u0633\u0628\u062a\u0645\u0628\u0631_\u0623\u0643\u062a\u0648\u0628\u0631_\u0646\u0648\u0641\u0645\u0628\u0631_\u062f\u064a\u0633\u0645\u0628\u0631".split("_"),monthsShort:"\u062c\u0627\u0646\u0641\u064a_\u0641\u064a\u0641\u0631\u064a_\u0645\u0627\u0631\u0633_\u0623\u0641\u0631\u064a\u0644_\u0645\u0627\u064a_\u062c\u0648\u0627\u0646_\u062c\u0648\u064a\u0644\u064a\u0629_\u0623\u0648\u062a_\u0633\u0628\u062a\u0645\u0628\u0631_\u0623\u0643\u062a\u0648\u0628\u0631_\u0646\u0648\u0641\u0645\u0628\u0631_\u062f\u064a\u0633\u0645\u0628\u0631".split("_"),weekdays:"\u0627\u0644\u0623\u062d\u062f_\u0627\u0644\u0625\u062b\u0646\u064a\u0646_\u0627\u0644\u062b\u0644\u0627\u062b\u0627\u0621_\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621_\u0627\u0644\u062e\u0645\u064a\u0633_\u0627\u0644\u062c\u0645\u0639\u0629_\u0627\u0644\u0633\u0628\u062a".split("_"),weekdaysShort:"\u0627\u062d\u062f_\u0627\u062b\u0646\u064a\u0646_\u062b\u0644\u0627\u062b\u0627\u0621_\u0627\u0631\u0628\u0639\u0627\u0621_\u062e\u0645\u064a\u0633_\u062c\u0645\u0639\u0629_\u0633\u0628\u062a".split("_"),weekdaysMin:"\u0623\u062d_\u0625\u062b_\u062b\u0644\u0627_\u0623\u0631_\u062e\u0645_\u062c\u0645_\u0633\u0628".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},calendar:{sameDay:"[\u0627\u0644\u064a\u0648\u0645 \u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",nextDay:"[\u063a\u062f\u0627 \u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",nextWeek:"dddd [\u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",lastDay:"[\u0623\u0645\u0633 \u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",lastWeek:"dddd [\u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",sameElse:"L"},relativeTime:{future:"\u0641\u064a %s",past:"\u0645\u0646\u0630 %s",s:"\u062b\u0648\u0627\u0646",ss:"%d \u062b\u0627\u0646\u064a\u0629",m:"\u062f\u0642\u064a\u0642\u0629",mm:"%d \u062f\u0642\u0627\u0626\u0642",h:"\u0633\u0627\u0639\u0629",hh:"%d \u0633\u0627\u0639\u0627\u062a",d:"\u064a\u0648\u0645",dd:"%d \u0623\u064a\u0627\u0645",M:"\u0634\u0647\u0631",MM:"%d \u0623\u0634\u0647\u0631",y:"\u0633\u0646\u0629",yy:"%d \u0633\u0646\u0648\u0627\u062a"},week:{dow:0,doy:4}}),e.defineLocale("ar-kw",{months:"\u064a\u0646\u0627\u064a\u0631_\u0641\u0628\u0631\u0627\u064a\u0631_\u0645\u0627\u0631\u0633_\u0623\u0628\u0631\u064a\u0644_\u0645\u0627\u064a_\u064a\u0648\u0646\u064a\u0648_\u064a\u0648\u0644\u064a\u0648\u0632_\u063a\u0634\u062a_\u0634\u062a\u0646\u0628\u0631_\u0623\u0643\u062a\u0648\u0628\u0631_\u0646\u0648\u0646\u0628\u0631_\u062f\u062c\u0646\u0628\u0631".split("_"),monthsShort:"\u064a\u0646\u0627\u064a\u0631_\u0641\u0628\u0631\u0627\u064a\u0631_\u0645\u0627\u0631\u0633_\u0623\u0628\u0631\u064a\u0644_\u0645\u0627\u064a_\u064a\u0648\u0646\u064a\u0648_\u064a\u0648\u0644\u064a\u0648\u0632_\u063a\u0634\u062a_\u0634\u062a\u0646\u0628\u0631_\u0623\u0643\u062a\u0648\u0628\u0631_\u0646\u0648\u0646\u0628\u0631_\u062f\u062c\u0646\u0628\u0631".split("_"),weekdays:"\u0627\u0644\u0623\u062d\u062f_\u0627\u0644\u0625\u062a\u0646\u064a\u0646_\u0627\u0644\u062b\u0644\u0627\u062b\u0627\u0621_\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621_\u0627\u0644\u062e\u0645\u064a\u0633_\u0627\u0644\u062c\u0645\u0639\u0629_\u0627\u0644\u0633\u0628\u062a".split("_"),weekdaysShort:"\u0627\u062d\u062f_\u0627\u062a\u0646\u064a\u0646_\u062b\u0644\u0627\u062b\u0627\u0621_\u0627\u0631\u0628\u0639\u0627\u0621_\u062e\u0645\u064a\u0633_\u062c\u0645\u0639\u0629_\u0633\u0628\u062a".split("_"),weekdaysMin:"\u062d_\u0646_\u062b_\u0631_\u062e_\u062c_\u0633".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},calendar:{sameDay:"[\u0627\u0644\u064a\u0648\u0645 \u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",nextDay:"[\u063a\u062f\u0627 \u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",nextWeek:"dddd [\u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",lastDay:"[\u0623\u0645\u0633 \u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",lastWeek:"dddd [\u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",sameElse:"L"},relativeTime:{future:"\u0641\u064a %s",past:"\u0645\u0646\u0630 %s",s:"\u062b\u0648\u0627\u0646",ss:"%d \u062b\u0627\u0646\u064a\u0629",m:"\u062f\u0642\u064a\u0642\u0629",mm:"%d \u062f\u0642\u0627\u0626\u0642",h:"\u0633\u0627\u0639\u0629",hh:"%d \u0633\u0627\u0639\u0627\u062a",d:"\u064a\u0648\u0645",dd:"%d \u0623\u064a\u0627\u0645",M:"\u0634\u0647\u0631",MM:"%d \u0623\u0634\u0647\u0631",y:"\u0633\u0646\u0629",yy:"%d \u0633\u0646\u0648\u0627\u062a"},week:{dow:0,doy:12}});var Hs={1:"1",2:"2",3:"3",4:"4",5:"5",6:"6",7:"7",8:"8",9:"9",0:"0"},bs=function(e){return 0===e?0:1===e?1:2===e?2:e%100>=3&&e%100<=10?3:e%100>=11?4:5},js={s:["\u0623\u0642\u0644 \u0645\u0646 \u062b\u0627\u0646\u064a\u0629","\u062b\u0627\u0646\u064a\u0629 \u0648\u0627\u062d\u062f\u0629",["\u062b\u0627\u0646\u064a\u062a\u0627\u0646","\u062b\u0627\u0646\u064a\u062a\u064a\u0646"],"%d \u062b\u0648\u0627\u0646","%d \u062b\u0627\u0646\u064a\u0629","%d \u062b\u0627\u0646\u064a\u0629"],m:["\u0623\u0642\u0644 \u0645\u0646 \u062f\u0642\u064a\u0642\u0629","\u062f\u0642\u064a\u0642\u0629 \u0648\u0627\u062d\u062f\u0629",["\u062f\u0642\u064a\u0642\u062a\u0627\u0646","\u062f\u0642\u064a\u0642\u062a\u064a\u0646"],"%d \u062f\u0642\u0627\u0626\u0642","%d \u062f\u0642\u064a\u0642\u0629","%d \u062f\u0642\u064a\u0642\u0629"],h:["\u0623\u0642\u0644 \u0645\u0646 \u0633\u0627\u0639\u0629","\u0633\u0627\u0639\u0629 \u0648\u0627\u062d\u062f\u0629",["\u0633\u0627\u0639\u062a\u0627\u0646","\u0633\u0627\u0639\u062a\u064a\u0646"],"%d \u0633\u0627\u0639\u0627\u062a","%d \u0633\u0627\u0639\u0629","%d \u0633\u0627\u0639\u0629"],d:["\u0623\u0642\u0644 \u0645\u0646 \u064a\u0648\u0645","\u064a\u0648\u0645 \u0648\u0627\u062d\u062f",["\u064a\u0648\u0645\u0627\u0646","\u064a\u0648\u0645\u064a\u0646"],"%d \u0623\u064a\u0627\u0645","%d \u064a\u0648\u0645\u064b\u0627","%d \u064a\u0648\u0645"],M:["\u0623\u0642\u0644 \u0645\u0646 \u0634\u0647\u0631","\u0634\u0647\u0631 \u0648\u0627\u062d\u062f",["\u0634\u0647\u0631\u0627\u0646","\u0634\u0647\u0631\u064a\u0646"],"%d \u0623\u0634\u0647\u0631","%d \u0634\u0647\u0631\u0627","%d \u0634\u0647\u0631"],y:["\u0623\u0642\u0644 \u0645\u0646 \u0639\u0627\u0645","\u0639\u0627\u0645 \u0648\u0627\u062d\u062f",["\u0639\u0627\u0645\u0627\u0646","\u0639\u0627\u0645\u064a\u0646"],"%d \u0623\u0639\u0648\u0627\u0645","%d \u0639\u0627\u0645\u064b\u0627","%d \u0639\u0627\u0645"]},xs=function(e){return function(a,t,s,n){var d=bs(a),r=js[e][bs(a)];return 2===d&&(r=r[t?0:1]),r.replace(/%d/i,a)}},Ps=["\u064a\u0646\u0627\u064a\u0631","\u0641\u0628\u0631\u0627\u064a\u0631","\u0645\u0627\u0631\u0633","\u0623\u0628\u0631\u064a\u0644","\u0645\u0627\u064a\u0648","\u064a\u0648\u0646\u064a\u0648","\u064a\u0648\u0644\u064a\u0648","\u0623\u063a\u0633\u0637\u0633","\u0633\u0628\u062a\u0645\u0628\u0631","\u0623\u0643\u062a\u0648\u0628\u0631","\u0646\u0648\u0641\u0645\u0628\u0631","\u062f\u064a\u0633\u0645\u0628\u0631"];e.defineLocale("ar-ly",{months:Ps,monthsShort:Ps,weekdays:"\u0627\u0644\u0623\u062d\u062f_\u0627\u0644\u0625\u062b\u0646\u064a\u0646_\u0627\u0644\u062b\u0644\u0627\u062b\u0627\u0621_\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621_\u0627\u0644\u062e\u0645\u064a\u0633_\u0627\u0644\u062c\u0645\u0639\u0629_\u0627\u0644\u0633\u0628\u062a".split("_"),weekdaysShort:"\u0623\u062d\u062f_\u0625\u062b\u0646\u064a\u0646_\u062b\u0644\u0627\u062b\u0627\u0621_\u0623\u0631\u0628\u0639\u0627\u0621_\u062e\u0645\u064a\u0633_\u062c\u0645\u0639\u0629_\u0633\u0628\u062a".split("_"),weekdaysMin:"\u062d_\u0646_\u062b_\u0631_\u062e_\u062c_\u0633".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"D/\u200fM/\u200fYYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},meridiemParse:/\u0635|\u0645/,isPM:function(e){return"\u0645"===e},meridiem:function(e,a,t){return e<12?"\u0635":"\u0645"},calendar:{sameDay:"[\u0627\u0644\u064a\u0648\u0645 \u0639\u0646\u062f \u0627\u0644\u0633\u0627\u0639\u0629] LT",nextDay:"[\u063a\u062f\u064b\u0627 \u0639\u0646\u062f \u0627\u0644\u0633\u0627\u0639\u0629] LT",nextWeek:"dddd [\u0639\u0646\u062f \u0627\u0644\u0633\u0627\u0639\u0629] LT",lastDay:"[\u0623\u0645\u0633 \u0639\u0646\u062f \u0627\u0644\u0633\u0627\u0639\u0629] LT",lastWeek:"dddd [\u0639\u0646\u062f \u0627\u0644\u0633\u0627\u0639\u0629] LT",sameElse:"L"},relativeTime:{future:"\u0628\u0639\u062f %s",past:"\u0645\u0646\u0630 %s",s:xs("s"),ss:xs("s"),m:xs("m"),mm:xs("m"),h:xs("h"),hh:xs("h"),d:xs("d"),dd:xs("d"),M:xs("M"),MM:xs("M"),y:xs("y"),yy:xs("y")},preparse:function(e){return e.replace(/\u060c/g,",")},postformat:function(e){return e.replace(/\d/g,function(e){return Hs[e]}).replace(/,/g,"\u060c")},week:{dow:6,doy:12}}),e.defineLocale("ar-ma",{months:"\u064a\u0646\u0627\u064a\u0631_\u0641\u0628\u0631\u0627\u064a\u0631_\u0645\u0627\u0631\u0633_\u0623\u0628\u0631\u064a\u0644_\u0645\u0627\u064a_\u064a\u0648\u0646\u064a\u0648_\u064a\u0648\u0644\u064a\u0648\u0632_\u063a\u0634\u062a_\u0634\u062a\u0646\u0628\u0631_\u0623\u0643\u062a\u0648\u0628\u0631_\u0646\u0648\u0646\u0628\u0631_\u062f\u062c\u0646\u0628\u0631".split("_"),monthsShort:"\u064a\u0646\u0627\u064a\u0631_\u0641\u0628\u0631\u0627\u064a\u0631_\u0645\u0627\u0631\u0633_\u0623\u0628\u0631\u064a\u0644_\u0645\u0627\u064a_\u064a\u0648\u0646\u064a\u0648_\u064a\u0648\u0644\u064a\u0648\u0632_\u063a\u0634\u062a_\u0634\u062a\u0646\u0628\u0631_\u0623\u0643\u062a\u0648\u0628\u0631_\u0646\u0648\u0646\u0628\u0631_\u062f\u062c\u0646\u0628\u0631".split("_"),weekdays:"\u0627\u0644\u0623\u062d\u062f_\u0627\u0644\u0625\u062a\u0646\u064a\u0646_\u0627\u0644\u062b\u0644\u0627\u062b\u0627\u0621_\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621_\u0627\u0644\u062e\u0645\u064a\u0633_\u0627\u0644\u062c\u0645\u0639\u0629_\u0627\u0644\u0633\u0628\u062a".split("_"),weekdaysShort:"\u0627\u062d\u062f_\u0627\u062a\u0646\u064a\u0646_\u062b\u0644\u0627\u062b\u0627\u0621_\u0627\u0631\u0628\u0639\u0627\u0621_\u062e\u0645\u064a\u0633_\u062c\u0645\u0639\u0629_\u0633\u0628\u062a".split("_"),weekdaysMin:"\u062d_\u0646_\u062b_\u0631_\u062e_\u062c_\u0633".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},calendar:{sameDay:"[\u0627\u0644\u064a\u0648\u0645 \u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",nextDay:"[\u063a\u062f\u0627 \u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",nextWeek:"dddd [\u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",lastDay:"[\u0623\u0645\u0633 \u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",lastWeek:"dddd [\u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",sameElse:"L"},relativeTime:{future:"\u0641\u064a %s",past:"\u0645\u0646\u0630 %s",s:"\u062b\u0648\u0627\u0646",ss:"%d \u062b\u0627\u0646\u064a\u0629",m:"\u062f\u0642\u064a\u0642\u0629",mm:"%d \u062f\u0642\u0627\u0626\u0642",h:"\u0633\u0627\u0639\u0629",hh:"%d \u0633\u0627\u0639\u0627\u062a",d:"\u064a\u0648\u0645",dd:"%d \u0623\u064a\u0627\u0645",M:"\u0634\u0647\u0631",MM:"%d \u0623\u0634\u0647\u0631",y:"\u0633\u0646\u0629",yy:"%d \u0633\u0646\u0648\u0627\u062a"},week:{dow:6,doy:12}});var Os={1:"\u0661",2:"\u0662",3:"\u0663",4:"\u0664",5:"\u0665",6:"\u0666",7:"\u0667",8:"\u0668",9:"\u0669",0:"\u0660"},Ws={"\u0661":"1","\u0662":"2","\u0663":"3","\u0664":"4","\u0665":"5","\u0666":"6","\u0667":"7","\u0668":"8","\u0669":"9","\u0660":"0"};e.defineLocale("ar-sa",{months:"\u064a\u0646\u0627\u064a\u0631_\u0641\u0628\u0631\u0627\u064a\u0631_\u0645\u0627\u0631\u0633_\u0623\u0628\u0631\u064a\u0644_\u0645\u0627\u064a\u0648_\u064a\u0648\u0646\u064a\u0648_\u064a\u0648\u0644\u064a\u0648_\u0623\u063a\u0633\u0637\u0633_\u0633\u0628\u062a\u0645\u0628\u0631_\u0623\u0643\u062a\u0648\u0628\u0631_\u0646\u0648\u0641\u0645\u0628\u0631_\u062f\u064a\u0633\u0645\u0628\u0631".split("_"),monthsShort:"\u064a\u0646\u0627\u064a\u0631_\u0641\u0628\u0631\u0627\u064a\u0631_\u0645\u0627\u0631\u0633_\u0623\u0628\u0631\u064a\u0644_\u0645\u0627\u064a\u0648_\u064a\u0648\u0646\u064a\u0648_\u064a\u0648\u0644\u064a\u0648_\u0623\u063a\u0633\u0637\u0633_\u0633\u0628\u062a\u0645\u0628\u0631_\u0623\u0643\u062a\u0648\u0628\u0631_\u0646\u0648\u0641\u0645\u0628\u0631_\u062f\u064a\u0633\u0645\u0628\u0631".split("_"),weekdays:"\u0627\u0644\u0623\u062d\u062f_\u0627\u0644\u0625\u062b\u0646\u064a\u0646_\u0627\u0644\u062b\u0644\u0627\u062b\u0627\u0621_\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621_\u0627\u0644\u062e\u0645\u064a\u0633_\u0627\u0644\u062c\u0645\u0639\u0629_\u0627\u0644\u0633\u0628\u062a".split("_"),weekdaysShort:"\u0623\u062d\u062f_\u0625\u062b\u0646\u064a\u0646_\u062b\u0644\u0627\u062b\u0627\u0621_\u0623\u0631\u0628\u0639\u0627\u0621_\u062e\u0645\u064a\u0633_\u062c\u0645\u0639\u0629_\u0633\u0628\u062a".split("_"),weekdaysMin:"\u062d_\u0646_\u062b_\u0631_\u062e_\u062c_\u0633".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},meridiemParse:/\u0635|\u0645/,isPM:function(e){return"\u0645"===e},meridiem:function(e,a,t){return e<12?"\u0635":"\u0645"},calendar:{sameDay:"[\u0627\u0644\u064a\u0648\u0645 \u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",nextDay:"[\u063a\u062f\u0627 \u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",nextWeek:"dddd [\u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",lastDay:"[\u0623\u0645\u0633 \u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",lastWeek:"dddd [\u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",sameElse:"L"},relativeTime:{future:"\u0641\u064a %s",past:"\u0645\u0646\u0630 %s",s:"\u062b\u0648\u0627\u0646",ss:"%d \u062b\u0627\u0646\u064a\u0629",m:"\u062f\u0642\u064a\u0642\u0629",mm:"%d \u062f\u0642\u0627\u0626\u0642",h:"\u0633\u0627\u0639\u0629",hh:"%d \u0633\u0627\u0639\u0627\u062a",d:"\u064a\u0648\u0645",dd:"%d \u0623\u064a\u0627\u0645",M:"\u0634\u0647\u0631",MM:"%d \u0623\u0634\u0647\u0631",y:"\u0633\u0646\u0629",yy:"%d \u0633\u0646\u0648\u0627\u062a"},preparse:function(e){return e.replace(/[\u0661\u0662\u0663\u0664\u0665\u0666\u0667\u0668\u0669\u0660]/g,function(e){return Ws[e]}).replace(/\u060c/g,",")},postformat:function(e){return e.replace(/\d/g,function(e){return Os[e]}).replace(/,/g,"\u060c")},week:{dow:0,doy:6}}),e.defineLocale("ar-tn",{months:"\u062c\u0627\u0646\u0641\u064a_\u0641\u064a\u0641\u0631\u064a_\u0645\u0627\u0631\u0633_\u0623\u0641\u0631\u064a\u0644_\u0645\u0627\u064a_\u062c\u0648\u0627\u0646_\u062c\u0648\u064a\u0644\u064a\u0629_\u0623\u0648\u062a_\u0633\u0628\u062a\u0645\u0628\u0631_\u0623\u0643\u062a\u0648\u0628\u0631_\u0646\u0648\u0641\u0645\u0628\u0631_\u062f\u064a\u0633\u0645\u0628\u0631".split("_"),monthsShort:"\u062c\u0627\u0646\u0641\u064a_\u0641\u064a\u0641\u0631\u064a_\u0645\u0627\u0631\u0633_\u0623\u0641\u0631\u064a\u0644_\u0645\u0627\u064a_\u062c\u0648\u0627\u0646_\u062c\u0648\u064a\u0644\u064a\u0629_\u0623\u0648\u062a_\u0633\u0628\u062a\u0645\u0628\u0631_\u0623\u0643\u062a\u0648\u0628\u0631_\u0646\u0648\u0641\u0645\u0628\u0631_\u062f\u064a\u0633\u0645\u0628\u0631".split("_"),weekdays:"\u0627\u0644\u0623\u062d\u062f_\u0627\u0644\u0625\u062b\u0646\u064a\u0646_\u0627\u0644\u062b\u0644\u0627\u062b\u0627\u0621_\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621_\u0627\u0644\u062e\u0645\u064a\u0633_\u0627\u0644\u062c\u0645\u0639\u0629_\u0627\u0644\u0633\u0628\u062a".split("_"),weekdaysShort:"\u0623\u062d\u062f_\u0625\u062b\u0646\u064a\u0646_\u062b\u0644\u0627\u062b\u0627\u0621_\u0623\u0631\u0628\u0639\u0627\u0621_\u062e\u0645\u064a\u0633_\u062c\u0645\u0639\u0629_\u0633\u0628\u062a".split("_"),weekdaysMin:"\u062d_\u0646_\u062b_\u0631_\u062e_\u062c_\u0633".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},calendar:{sameDay:"[\u0627\u0644\u064a\u0648\u0645 \u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",nextDay:"[\u063a\u062f\u0627 \u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",nextWeek:"dddd [\u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",lastDay:"[\u0623\u0645\u0633 \u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",lastWeek:"dddd [\u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",sameElse:"L"},relativeTime:{future:"\u0641\u064a %s",past:"\u0645\u0646\u0630 %s",s:"\u062b\u0648\u0627\u0646",ss:"%d \u062b\u0627\u0646\u064a\u0629",m:"\u062f\u0642\u064a\u0642\u0629",mm:"%d \u062f\u0642\u0627\u0626\u0642",h:"\u0633\u0627\u0639\u0629",hh:"%d \u0633\u0627\u0639\u0627\u062a",d:"\u064a\u0648\u0645",dd:"%d \u0623\u064a\u0627\u0645",M:"\u0634\u0647\u0631",MM:"%d \u0623\u0634\u0647\u0631",y:"\u0633\u0646\u0629",yy:"%d \u0633\u0646\u0648\u0627\u062a"},week:{dow:1,doy:4}});var Es={1:"\u0661",2:"\u0662",3:"\u0663",4:"\u0664",5:"\u0665",6:"\u0666",7:"\u0667",8:"\u0668",9:"\u0669",0:"\u0660"},As={"\u0661":"1","\u0662":"2","\u0663":"3","\u0664":"4","\u0665":"5","\u0666":"6","\u0667":"7","\u0668":"8","\u0669":"9","\u0660":"0"},Fs=function(e){return 0===e?0:1===e?1:2===e?2:e%100>=3&&e%100<=10?3:e%100>=11?4:5},zs={s:["\u0623\u0642\u0644 \u0645\u0646 \u062b\u0627\u0646\u064a\u0629","\u062b\u0627\u0646\u064a\u0629 \u0648\u0627\u062d\u062f\u0629",["\u062b\u0627\u0646\u064a\u062a\u0627\u0646","\u062b\u0627\u0646\u064a\u062a\u064a\u0646"],"%d \u062b\u0648\u0627\u0646","%d \u062b\u0627\u0646\u064a\u0629","%d \u062b\u0627\u0646\u064a\u0629"],m:["\u0623\u0642\u0644 \u0645\u0646 \u062f\u0642\u064a\u0642\u0629","\u062f\u0642\u064a\u0642\u0629 \u0648\u0627\u062d\u062f\u0629",["\u062f\u0642\u064a\u0642\u062a\u0627\u0646","\u062f\u0642\u064a\u0642\u062a\u064a\u0646"],"%d \u062f\u0642\u0627\u0626\u0642","%d \u062f\u0642\u064a\u0642\u0629","%d \u062f\u0642\u064a\u0642\u0629"],h:["\u0623\u0642\u0644 \u0645\u0646 \u0633\u0627\u0639\u0629","\u0633\u0627\u0639\u0629 \u0648\u0627\u062d\u062f\u0629",["\u0633\u0627\u0639\u062a\u0627\u0646","\u0633\u0627\u0639\u062a\u064a\u0646"],"%d \u0633\u0627\u0639\u0627\u062a","%d \u0633\u0627\u0639\u0629","%d \u0633\u0627\u0639\u0629"],d:["\u0623\u0642\u0644 \u0645\u0646 \u064a\u0648\u0645","\u064a\u0648\u0645 \u0648\u0627\u062d\u062f",["\u064a\u0648\u0645\u0627\u0646","\u064a\u0648\u0645\u064a\u0646"],"%d \u0623\u064a\u0627\u0645","%d \u064a\u0648\u0645\u064b\u0627","%d \u064a\u0648\u0645"],M:["\u0623\u0642\u0644 \u0645\u0646 \u0634\u0647\u0631","\u0634\u0647\u0631 \u0648\u0627\u062d\u062f",["\u0634\u0647\u0631\u0627\u0646","\u0634\u0647\u0631\u064a\u0646"],"%d \u0623\u0634\u0647\u0631","%d \u0634\u0647\u0631\u0627","%d \u0634\u0647\u0631"],y:["\u0623\u0642\u0644 \u0645\u0646 \u0639\u0627\u0645","\u0639\u0627\u0645 \u0648\u0627\u062d\u062f",["\u0639\u0627\u0645\u0627\u0646","\u0639\u0627\u0645\u064a\u0646"],"%d \u0623\u0639\u0648\u0627\u0645","%d \u0639\u0627\u0645\u064b\u0627","%d \u0639\u0627\u0645"]},Js=function(e){return function(a,t,s,n){var d=Fs(a),r=zs[e][Fs(a)];return 2===d&&(r=r[t?0:1]),r.replace(/%d/i,a)}},Ns=["\u064a\u0646\u0627\u064a\u0631","\u0641\u0628\u0631\u0627\u064a\u0631","\u0645\u0627\u0631\u0633","\u0623\u0628\u0631\u064a\u0644","\u0645\u0627\u064a\u0648","\u064a\u0648\u0646\u064a\u0648","\u064a\u0648\u0644\u064a\u0648","\u0623\u063a\u0633\u0637\u0633","\u0633\u0628\u062a\u0645\u0628\u0631","\u0623\u0643\u062a\u0648\u0628\u0631","\u0646\u0648\u0641\u0645\u0628\u0631","\u062f\u064a\u0633\u0645\u0628\u0631"];e.defineLocale("ar",{months:Ns,monthsShort:Ns,weekdays:"\u0627\u0644\u0623\u062d\u062f_\u0627\u0644\u0625\u062b\u0646\u064a\u0646_\u0627\u0644\u062b\u0644\u0627\u062b\u0627\u0621_\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621_\u0627\u0644\u062e\u0645\u064a\u0633_\u0627\u0644\u062c\u0645\u0639\u0629_\u0627\u0644\u0633\u0628\u062a".split("_"),weekdaysShort:"\u0623\u062d\u062f_\u0625\u062b\u0646\u064a\u0646_\u062b\u0644\u0627\u062b\u0627\u0621_\u0623\u0631\u0628\u0639\u0627\u0621_\u062e\u0645\u064a\u0633_\u062c\u0645\u0639\u0629_\u0633\u0628\u062a".split("_"),weekdaysMin:"\u062d_\u0646_\u062b_\u0631_\u062e_\u062c_\u0633".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"D/\u200fM/\u200fYYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},meridiemParse:/\u0635|\u0645/,isPM:function(e){return"\u0645"===e},meridiem:function(e,a,t){return e<12?"\u0635":"\u0645"},calendar:{sameDay:"[\u0627\u0644\u064a\u0648\u0645 \u0639\u0646\u062f \u0627\u0644\u0633\u0627\u0639\u0629] LT",nextDay:"[\u063a\u062f\u064b\u0627 \u0639\u0646\u062f \u0627\u0644\u0633\u0627\u0639\u0629] LT",nextWeek:"dddd [\u0639\u0646\u062f \u0627\u0644\u0633\u0627\u0639\u0629] LT",lastDay:"[\u0623\u0645\u0633 \u0639\u0646\u062f \u0627\u0644\u0633\u0627\u0639\u0629] LT",lastWeek:"dddd [\u0639\u0646\u062f \u0627\u0644\u0633\u0627\u0639\u0629] LT",sameElse:"L"},relativeTime:{future:"\u0628\u0639\u062f %s",past:"\u0645\u0646\u0630 %s",s:Js("s"),ss:Js("s"),m:Js("m"),mm:Js("m"),h:Js("h"),hh:Js("h"),d:Js("d"),dd:Js("d"),M:Js("M"),MM:Js("M"),y:Js("y"),yy:Js("y")},preparse:function(e){return e.replace(/[\u0661\u0662\u0663\u0664\u0665\u0666\u0667\u0668\u0669\u0660]/g,function(e){return As[e]}).replace(/\u060c/g,",")},postformat:function(e){return e.replace(/\d/g,function(e){return Es[e]}).replace(/,/g,"\u060c")},week:{dow:6,doy:12}});var Rs={1:"-inci",5:"-inci",8:"-inci",70:"-inci",80:"-inci",2:"-nci",7:"-nci",20:"-nci",50:"-nci",3:"-\xfcnc\xfc",4:"-\xfcnc\xfc",100:"-\xfcnc\xfc",6:"-nc\u0131",9:"-uncu",10:"-uncu",30:"-uncu",60:"-\u0131nc\u0131",90:"-\u0131nc\u0131"};e.defineLocale("az",{months:"yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr".split("_"),monthsShort:"yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek".split("_"),weekdays:"Bazar_Bazar ert\u0259si_\xc7\u0259r\u015f\u0259nb\u0259 ax\u015fam\u0131_\xc7\u0259r\u015f\u0259nb\u0259_C\xfcm\u0259 ax\u015fam\u0131_C\xfcm\u0259_\u015e\u0259nb\u0259".split("_"),weekdaysShort:"Baz_BzE_\xc7Ax_\xc7\u0259r_CAx_C\xfcm_\u015e\u0259n".split("_"),weekdaysMin:"Bz_BE_\xc7A_\xc7\u0259_CA_C\xfc_\u015e\u0259".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[bug\xfcn saat] LT",nextDay:"[sabah saat] LT",nextWeek:"[g\u0259l\u0259n h\u0259ft\u0259] dddd [saat] LT",lastDay:"[d\xfcn\u0259n] LT",lastWeek:"[ke\xe7\u0259n h\u0259ft\u0259] dddd [saat] LT",sameElse:"L"},relativeTime:{future:"%s sonra",past:"%s \u0259vv\u0259l",s:"birne\xe7\u0259 saniyy\u0259",ss:"%d saniy\u0259",m:"bir d\u0259qiq\u0259",mm:"%d d\u0259qiq\u0259",h:"bir saat",hh:"%d saat",d:"bir g\xfcn",dd:"%d g\xfcn",M:"bir ay",MM:"%d ay",y:"bir il",yy:"%d il"},meridiemParse:/gec\u0259|s\u0259h\u0259r|g\xfcnd\xfcz|ax\u015fam/,isPM:function(e){return/^(g\xfcnd\xfcz|ax\u015fam)$/.test(e)},meridiem:function(e,a,t){return e<4?"gec\u0259":e<12?"s\u0259h\u0259r":e<17?"g\xfcnd\xfcz":"ax\u015fam"},dayOfMonthOrdinalParse:/\d{1,2}-(\u0131nc\u0131|inci|nci|\xfcnc\xfc|nc\u0131|uncu)/,ordinal:function(e){if(0===e)return e+"-\u0131nc\u0131";var a=e%10;return e+(Rs[a]||Rs[e%100-a]||Rs[e>=100?100:null])},week:{dow:1,doy:7}}),e.defineLocale("be",{months:{format:"\u0441\u0442\u0443\u0434\u0437\u0435\u043d\u044f_\u043b\u044e\u0442\u0430\u0433\u0430_\u0441\u0430\u043a\u0430\u0432\u0456\u043a\u0430_\u043a\u0440\u0430\u0441\u0430\u0432\u0456\u043a\u0430_\u0442\u0440\u0430\u045e\u043d\u044f_\u0447\u044d\u0440\u0432\u0435\u043d\u044f_\u043b\u0456\u043f\u0435\u043d\u044f_\u0436\u043d\u0456\u045e\u043d\u044f_\u0432\u0435\u0440\u0430\u0441\u043d\u044f_\u043a\u0430\u0441\u0442\u0440\u044b\u0447\u043d\u0456\u043a\u0430_\u043b\u0456\u0441\u0442\u0430\u043f\u0430\u0434\u0430_\u0441\u043d\u0435\u0436\u043d\u044f".split("_"),standalone:"\u0441\u0442\u0443\u0434\u0437\u0435\u043d\u044c_\u043b\u044e\u0442\u044b_\u0441\u0430\u043a\u0430\u0432\u0456\u043a_\u043a\u0440\u0430\u0441\u0430\u0432\u0456\u043a_\u0442\u0440\u0430\u0432\u0435\u043d\u044c_\u0447\u044d\u0440\u0432\u0435\u043d\u044c_\u043b\u0456\u043f\u0435\u043d\u044c_\u0436\u043d\u0456\u0432\u0435\u043d\u044c_\u0432\u0435\u0440\u0430\u0441\u0435\u043d\u044c_\u043a\u0430\u0441\u0442\u0440\u044b\u0447\u043d\u0456\u043a_\u043b\u0456\u0441\u0442\u0430\u043f\u0430\u0434_\u0441\u043d\u0435\u0436\u0430\u043d\u044c".split("_")},monthsShort:"\u0441\u0442\u0443\u0434_\u043b\u044e\u0442_\u0441\u0430\u043a_\u043a\u0440\u0430\u0441_\u0442\u0440\u0430\u0432_\u0447\u044d\u0440\u0432_\u043b\u0456\u043f_\u0436\u043d\u0456\u0432_\u0432\u0435\u0440_\u043a\u0430\u0441\u0442_\u043b\u0456\u0441\u0442_\u0441\u043d\u0435\u0436".split("_"),weekdays:{format:"\u043d\u044f\u0434\u0437\u0435\u043b\u044e_\u043f\u0430\u043d\u044f\u0434\u0437\u0435\u043b\u0430\u043a_\u0430\u045e\u0442\u043e\u0440\u0430\u043a_\u0441\u0435\u0440\u0430\u0434\u0443_\u0447\u0430\u0446\u0432\u0435\u0440_\u043f\u044f\u0442\u043d\u0456\u0446\u0443_\u0441\u0443\u0431\u043e\u0442\u0443".split("_"),standalone:"\u043d\u044f\u0434\u0437\u0435\u043b\u044f_\u043f\u0430\u043d\u044f\u0434\u0437\u0435\u043b\u0430\u043a_\u0430\u045e\u0442\u043e\u0440\u0430\u043a_\u0441\u0435\u0440\u0430\u0434\u0430_\u0447\u0430\u0446\u0432\u0435\u0440_\u043f\u044f\u0442\u043d\u0456\u0446\u0430_\u0441\u0443\u0431\u043e\u0442\u0430".split("_"),isFormat:/\[ ?[\u0412\u0432] ?(?:\u043c\u0456\u043d\u0443\u043b\u0443\u044e|\u043d\u0430\u0441\u0442\u0443\u043f\u043d\u0443\u044e)? ?\] ?dddd/},weekdaysShort:"\u043d\u0434_\u043f\u043d_\u0430\u0442_\u0441\u0440_\u0447\u0446_\u043f\u0442_\u0441\u0431".split("_"),weekdaysMin:"\u043d\u0434_\u043f\u043d_\u0430\u0442_\u0441\u0440_\u0447\u0446_\u043f\u0442_\u0441\u0431".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D MMMM YYYY \u0433.",LLL:"D MMMM YYYY \u0433., HH:mm",LLLL:"dddd, D MMMM YYYY \u0433., HH:mm"},calendar:{sameDay:"[\u0421\u0451\u043d\u043d\u044f \u045e] LT",nextDay:"[\u0417\u0430\u045e\u0442\u0440\u0430 \u045e] LT",lastDay:"[\u0423\u0447\u043e\u0440\u0430 \u045e] LT",nextWeek:function(){return"[\u0423] dddd [\u045e] LT"},lastWeek:function(){switch(this.day()){case 0:case 3:case 5:case 6:return"[\u0423 \u043c\u0456\u043d\u0443\u043b\u0443\u044e] dddd [\u045e] LT";case 1:case 2:case 4:return"[\u0423 \u043c\u0456\u043d\u0443\u043b\u044b] dddd [\u045e] LT"}},sameElse:"L"},relativeTime:{future:"\u043f\u0440\u0430\u0437 %s",past:"%s \u0442\u0430\u043c\u0443",s:"\u043d\u0435\u043a\u0430\u043b\u044c\u043a\u0456 \u0441\u0435\u043a\u0443\u043d\u0434",m:qe,mm:qe,h:qe,hh:qe,d:"\u0434\u0437\u0435\u043d\u044c",dd:qe,M:"\u043c\u0435\u0441\u044f\u0446",MM:qe,y:"\u0433\u043e\u0434",yy:qe},meridiemParse:/\u043d\u043e\u0447\u044b|\u0440\u0430\u043d\u0456\u0446\u044b|\u0434\u043d\u044f|\u0432\u0435\u0447\u0430\u0440\u0430/,isPM:function(e){return/^(\u0434\u043d\u044f|\u0432\u0435\u0447\u0430\u0440\u0430)$/.test(e)},meridiem:function(e,a,t){return e<4?"\u043d\u043e\u0447\u044b":e<12?"\u0440\u0430\u043d\u0456\u0446\u044b":e<17?"\u0434\u043d\u044f":"\u0432\u0435\u0447\u0430\u0440\u0430"},dayOfMonthOrdinalParse:/\d{1,2}-(\u0456|\u044b|\u0433\u0430)/,ordinal:function(e,a){switch(a){case"M":case"d":case"DDD":case"w":case"W":return e%10!=2&&e%10!=3||e%100==12||e%100==13?e+"-\u044b":e+"-\u0456";case"D":return e+"-\u0433\u0430";default:return e}},week:{dow:1,doy:7}}),e.defineLocale("bg",{months:"\u044f\u043d\u0443\u0430\u0440\u0438_\u0444\u0435\u0432\u0440\u0443\u0430\u0440\u0438_\u043c\u0430\u0440\u0442_\u0430\u043f\u0440\u0438\u043b_\u043c\u0430\u0439_\u044e\u043d\u0438_\u044e\u043b\u0438_\u0430\u0432\u0433\u0443\u0441\u0442_\u0441\u0435\u043f\u0442\u0435\u043c\u0432\u0440\u0438_\u043e\u043a\u0442\u043e\u043c\u0432\u0440\u0438_\u043d\u043e\u0435\u043c\u0432\u0440\u0438_\u0434\u0435\u043a\u0435\u043c\u0432\u0440\u0438".split("_"),monthsShort:"\u044f\u043d\u0440_\u0444\u0435\u0432_\u043c\u0430\u0440_\u0430\u043f\u0440_\u043c\u0430\u0439_\u044e\u043d\u0438_\u044e\u043b\u0438_\u0430\u0432\u0433_\u0441\u0435\u043f_\u043e\u043a\u0442_\u043d\u043e\u0435_\u0434\u0435\u043a".split("_"),weekdays:"\u043d\u0435\u0434\u0435\u043b\u044f_\u043f\u043e\u043d\u0435\u0434\u0435\u043b\u043d\u0438\u043a_\u0432\u0442\u043e\u0440\u043d\u0438\u043a_\u0441\u0440\u044f\u0434\u0430_\u0447\u0435\u0442\u0432\u044a\u0440\u0442\u044a\u043a_\u043f\u0435\u0442\u044a\u043a_\u0441\u044a\u0431\u043e\u0442\u0430".split("_"),weekdaysShort:"\u043d\u0435\u0434_\u043f\u043e\u043d_\u0432\u0442\u043e_\u0441\u0440\u044f_\u0447\u0435\u0442_\u043f\u0435\u0442_\u0441\u044a\u0431".split("_"),weekdaysMin:"\u043d\u0434_\u043f\u043d_\u0432\u0442_\u0441\u0440_\u0447\u0442_\u043f\u0442_\u0441\u0431".split("_"),longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"D.MM.YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY H:mm",LLLL:"dddd, D MMMM YYYY H:mm"},calendar:{sameDay:"[\u0414\u043d\u0435\u0441 \u0432] LT",nextDay:"[\u0423\u0442\u0440\u0435 \u0432] LT",nextWeek:"dddd [\u0432] LT",lastDay:"[\u0412\u0447\u0435\u0440\u0430 \u0432] LT",lastWeek:function(){switch(this.day()){case 0:case 3:case 6:return"[\u0412 \u0438\u0437\u043c\u0438\u043d\u0430\u043b\u0430\u0442\u0430] dddd [\u0432] LT";case 1:case 2:case 4:case 5:return"[\u0412 \u0438\u0437\u043c\u0438\u043d\u0430\u043b\u0438\u044f] dddd [\u0432] LT"}},sameElse:"L"},relativeTime:{future:"\u0441\u043b\u0435\u0434 %s",past:"\u043f\u0440\u0435\u0434\u0438 %s",s:"\u043d\u044f\u043a\u043e\u043b\u043a\u043e \u0441\u0435\u043a\u0443\u043d\u0434\u0438",ss:"%d \u0441\u0435\u043a\u0443\u043d\u0434\u0438",m:"\u043c\u0438\u043d\u0443\u0442\u0430",mm:"%d \u043c\u0438\u043d\u0443\u0442\u0438",h:"\u0447\u0430\u0441",hh:"%d \u0447\u0430\u0441\u0430",d:"\u0434\u0435\u043d",dd:"%d \u0434\u043d\u0438",M:"\u043c\u0435\u0441\u0435\u0446",MM:"%d \u043c\u0435\u0441\u0435\u0446\u0430",y:"\u0433\u043e\u0434\u0438\u043d\u0430",yy:"%d \u0433\u043e\u0434\u0438\u043d\u0438"},dayOfMonthOrdinalParse:/\d{1,2}-(\u0435\u0432|\u0435\u043d|\u0442\u0438|\u0432\u0438|\u0440\u0438|\u043c\u0438)/,ordinal:function(e){var a=e%10,t=e%100;return 0===e?e+"-\u0435\u0432":0===t?e+"-\u0435\u043d":t>10&&t<20?e+"-\u0442\u0438":1===a?e+"-\u0432\u0438":2===a?e+"-\u0440\u0438":7===a||8===a?e+"-\u043c\u0438":e+"-\u0442\u0438"},week:{dow:1,doy:7}}),e.defineLocale("bm",{months:"Zanwuyekalo_Fewuruyekalo_Marisikalo_Awirilikalo_M\u025bkalo_Zuw\u025bnkalo_Zuluyekalo_Utikalo_S\u025btanburukalo_\u0254kut\u0254burukalo_Nowanburukalo_Desanburukalo".split("_"),monthsShort:"Zan_Few_Mar_Awi_M\u025b_Zuw_Zul_Uti_S\u025bt_\u0254ku_Now_Des".split("_"),weekdays:"Kari_Nt\u025bn\u025bn_Tarata_Araba_Alamisa_Juma_Sibiri".split("_"),weekdaysShort:"Kar_Nt\u025b_Tar_Ara_Ala_Jum_Sib".split("_"),weekdaysMin:"Ka_Nt_Ta_Ar_Al_Ju_Si".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"MMMM [tile] D [san] YYYY",LLL:"MMMM [tile] D [san] YYYY [l\u025br\u025b] HH:mm",LLLL:"dddd MMMM [tile] D [san] YYYY [l\u025br\u025b] HH:mm"},calendar:{sameDay:"[Bi l\u025br\u025b] LT",nextDay:"[Sini l\u025br\u025b] LT",nextWeek:"dddd [don l\u025br\u025b] LT",lastDay:"[Kunu l\u025br\u025b] LT",lastWeek:"dddd [t\u025bm\u025bnen l\u025br\u025b] LT",sameElse:"L"},relativeTime:{future:"%s k\u0254n\u0254",past:"a b\u025b %s b\u0254",s:"sanga dama dama",ss:"sekondi %d",m:"miniti kelen",mm:"miniti %d",h:"l\u025br\u025b kelen",hh:"l\u025br\u025b %d",d:"tile kelen",dd:"tile %d",M:"kalo kelen",MM:"kalo %d",y:"san kelen",yy:"san %d"},week:{dow:1,doy:4}});var Is={1:"\u09e7",2:"\u09e8",3:"\u09e9",4:"\u09ea",5:"\u09eb",6:"\u09ec",7:"\u09ed",8:"\u09ee",9:"\u09ef",0:"\u09e6"},Cs={"\u09e7":"1","\u09e8":"2","\u09e9":"3","\u09ea":"4","\u09eb":"5","\u09ec":"6","\u09ed":"7","\u09ee":"8","\u09ef":"9","\u09e6":"0"};e.defineLocale("bn",{months:"\u099c\u09be\u09a8\u09c1\u09df\u09be\u09b0\u09c0_\u09ab\u09c7\u09ac\u09cd\u09b0\u09c1\u09df\u09be\u09b0\u09bf_\u09ae\u09be\u09b0\u09cd\u099a_\u098f\u09aa\u09cd\u09b0\u09bf\u09b2_\u09ae\u09c7_\u099c\u09c1\u09a8_\u099c\u09c1\u09b2\u09be\u0987_\u0986\u0997\u09b8\u09cd\u099f_\u09b8\u09c7\u09aa\u09cd\u099f\u09c7\u09ae\u09cd\u09ac\u09b0_\u0985\u0995\u09cd\u099f\u09cb\u09ac\u09b0_\u09a8\u09ad\u09c7\u09ae\u09cd\u09ac\u09b0_\u09a1\u09bf\u09b8\u09c7\u09ae\u09cd\u09ac\u09b0".split("_"),monthsShort:"\u099c\u09be\u09a8\u09c1_\u09ab\u09c7\u09ac_\u09ae\u09be\u09b0\u09cd\u099a_\u098f\u09aa\u09cd\u09b0_\u09ae\u09c7_\u099c\u09c1\u09a8_\u099c\u09c1\u09b2_\u0986\u0997_\u09b8\u09c7\u09aa\u09cd\u099f_\u0985\u0995\u09cd\u099f\u09cb_\u09a8\u09ad\u09c7_\u09a1\u09bf\u09b8\u09c7".split("_"),weekdays:"\u09b0\u09ac\u09bf\u09ac\u09be\u09b0_\u09b8\u09cb\u09ae\u09ac\u09be\u09b0_\u09ae\u0999\u09cd\u0997\u09b2\u09ac\u09be\u09b0_\u09ac\u09c1\u09a7\u09ac\u09be\u09b0_\u09ac\u09c3\u09b9\u09b8\u09cd\u09aa\u09a4\u09bf\u09ac\u09be\u09b0_\u09b6\u09c1\u0995\u09cd\u09b0\u09ac\u09be\u09b0_\u09b6\u09a8\u09bf\u09ac\u09be\u09b0".split("_"),weekdaysShort:"\u09b0\u09ac\u09bf_\u09b8\u09cb\u09ae_\u09ae\u0999\u09cd\u0997\u09b2_\u09ac\u09c1\u09a7_\u09ac\u09c3\u09b9\u09b8\u09cd\u09aa\u09a4\u09bf_\u09b6\u09c1\u0995\u09cd\u09b0_\u09b6\u09a8\u09bf".split("_"),weekdaysMin:"\u09b0\u09ac\u09bf_\u09b8\u09cb\u09ae_\u09ae\u0999\u09cd\u0997_\u09ac\u09c1\u09a7_\u09ac\u09c3\u09b9\u0983_\u09b6\u09c1\u0995\u09cd\u09b0_\u09b6\u09a8\u09bf".split("_"),longDateFormat:{LT:"A h:mm \u09b8\u09ae\u09df",LTS:"A h:mm:ss \u09b8\u09ae\u09df",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY, A h:mm \u09b8\u09ae\u09df",LLLL:"dddd, D MMMM YYYY, A h:mm \u09b8\u09ae\u09df"},calendar:{sameDay:"[\u0986\u099c] LT",nextDay:"[\u0986\u0997\u09be\u09ae\u09c0\u0995\u09be\u09b2] LT",nextWeek:"dddd, LT",lastDay:"[\u0997\u09a4\u0995\u09be\u09b2] LT",lastWeek:"[\u0997\u09a4] dddd, LT",sameElse:"L"},relativeTime:{future:"%s \u09aa\u09b0\u09c7",past:"%s \u0986\u0997\u09c7",s:"\u0995\u09df\u09c7\u0995 \u09b8\u09c7\u0995\u09c7\u09a8\u09cd\u09a1",ss:"%d \u09b8\u09c7\u0995\u09c7\u09a8\u09cd\u09a1",m:"\u098f\u0995 \u09ae\u09bf\u09a8\u09bf\u099f",mm:"%d \u09ae\u09bf\u09a8\u09bf\u099f",h:"\u098f\u0995 \u0998\u09a8\u09cd\u099f\u09be",hh:"%d \u0998\u09a8\u09cd\u099f\u09be",d:"\u098f\u0995 \u09a6\u09bf\u09a8",dd:"%d \u09a6\u09bf\u09a8",M:"\u098f\u0995 \u09ae\u09be\u09b8",MM:"%d \u09ae\u09be\u09b8",y:"\u098f\u0995 \u09ac\u099b\u09b0",yy:"%d \u09ac\u099b\u09b0"},preparse:function(e){return e.replace(/[\u09e7\u09e8\u09e9\u09ea\u09eb\u09ec\u09ed\u09ee\u09ef\u09e6]/g,function(e){return Cs[e]})},postformat:function(e){return e.replace(/\d/g,function(e){return Is[e]})},meridiemParse:/\u09b0\u09be\u09a4|\u09b8\u0995\u09be\u09b2|\u09a6\u09c1\u09aa\u09c1\u09b0|\u09ac\u09bf\u0995\u09be\u09b2|\u09b0\u09be\u09a4/,meridiemHour:function(e,a){return 12===e&&(e=0),"\u09b0\u09be\u09a4"===a&&e>=4||"\u09a6\u09c1\u09aa\u09c1\u09b0"===a&&e<5||"\u09ac\u09bf\u0995\u09be\u09b2"===a?e+12:e},meridiem:function(e,a,t){return e<4?"\u09b0\u09be\u09a4":e<10?"\u09b8\u0995\u09be\u09b2":e<17?"\u09a6\u09c1\u09aa\u09c1\u09b0":e<20?"\u09ac\u09bf\u0995\u09be\u09b2":"\u09b0\u09be\u09a4"},week:{dow:0,doy:6}});var Gs={1:"\u0f21",2:"\u0f22",3:"\u0f23",4:"\u0f24",5:"\u0f25",6:"\u0f26",7:"\u0f27",8:"\u0f28",9:"\u0f29",0:"\u0f20"},Us={"\u0f21":"1","\u0f22":"2","\u0f23":"3","\u0f24":"4","\u0f25":"5","\u0f26":"6","\u0f27":"7","\u0f28":"8","\u0f29":"9","\u0f20":"0"};e.defineLocale("bo",{months:"\u0f5f\u0fb3\u0f0b\u0f56\u0f0b\u0f51\u0f44\u0f0b\u0f54\u0f7c_\u0f5f\u0fb3\u0f0b\u0f56\u0f0b\u0f42\u0f49\u0f72\u0f66\u0f0b\u0f54_\u0f5f\u0fb3\u0f0b\u0f56\u0f0b\u0f42\u0f66\u0f74\u0f58\u0f0b\u0f54_\u0f5f\u0fb3\u0f0b\u0f56\u0f0b\u0f56\u0f5e\u0f72\u0f0b\u0f54_\u0f5f\u0fb3\u0f0b\u0f56\u0f0b\u0f63\u0f94\u0f0b\u0f54_\u0f5f\u0fb3\u0f0b\u0f56\u0f0b\u0f51\u0fb2\u0f74\u0f42\u0f0b\u0f54_\u0f5f\u0fb3\u0f0b\u0f56\u0f0b\u0f56\u0f51\u0f74\u0f53\u0f0b\u0f54_\u0f5f\u0fb3\u0f0b\u0f56\u0f0b\u0f56\u0f62\u0f92\u0fb1\u0f51\u0f0b\u0f54_\u0f5f\u0fb3\u0f0b\u0f56\u0f0b\u0f51\u0f42\u0f74\u0f0b\u0f54_\u0f5f\u0fb3\u0f0b\u0f56\u0f0b\u0f56\u0f45\u0f74\u0f0b\u0f54_\u0f5f\u0fb3\u0f0b\u0f56\u0f0b\u0f56\u0f45\u0f74\u0f0b\u0f42\u0f45\u0f72\u0f42\u0f0b\u0f54_\u0f5f\u0fb3\u0f0b\u0f56\u0f0b\u0f56\u0f45\u0f74\u0f0b\u0f42\u0f49\u0f72\u0f66\u0f0b\u0f54".split("_"),monthsShort:"\u0f5f\u0fb3\u0f0b\u0f56\u0f0b\u0f51\u0f44\u0f0b\u0f54\u0f7c_\u0f5f\u0fb3\u0f0b\u0f56\u0f0b\u0f42\u0f49\u0f72\u0f66\u0f0b\u0f54_\u0f5f\u0fb3\u0f0b\u0f56\u0f0b\u0f42\u0f66\u0f74\u0f58\u0f0b\u0f54_\u0f5f\u0fb3\u0f0b\u0f56\u0f0b\u0f56\u0f5e\u0f72\u0f0b\u0f54_\u0f5f\u0fb3\u0f0b\u0f56\u0f0b\u0f63\u0f94\u0f0b\u0f54_\u0f5f\u0fb3\u0f0b\u0f56\u0f0b\u0f51\u0fb2\u0f74\u0f42\u0f0b\u0f54_\u0f5f\u0fb3\u0f0b\u0f56\u0f0b\u0f56\u0f51\u0f74\u0f53\u0f0b\u0f54_\u0f5f\u0fb3\u0f0b\u0f56\u0f0b\u0f56\u0f62\u0f92\u0fb1\u0f51\u0f0b\u0f54_\u0f5f\u0fb3\u0f0b\u0f56\u0f0b\u0f51\u0f42\u0f74\u0f0b\u0f54_\u0f5f\u0fb3\u0f0b\u0f56\u0f0b\u0f56\u0f45\u0f74\u0f0b\u0f54_\u0f5f\u0fb3\u0f0b\u0f56\u0f0b\u0f56\u0f45\u0f74\u0f0b\u0f42\u0f45\u0f72\u0f42\u0f0b\u0f54_\u0f5f\u0fb3\u0f0b\u0f56\u0f0b\u0f56\u0f45\u0f74\u0f0b\u0f42\u0f49\u0f72\u0f66\u0f0b\u0f54".split("_"),weekdays:"\u0f42\u0f5f\u0f60\u0f0b\u0f49\u0f72\u0f0b\u0f58\u0f0b_\u0f42\u0f5f\u0f60\u0f0b\u0f5f\u0fb3\u0f0b\u0f56\u0f0b_\u0f42\u0f5f\u0f60\u0f0b\u0f58\u0f72\u0f42\u0f0b\u0f51\u0f58\u0f62\u0f0b_\u0f42\u0f5f\u0f60\u0f0b\u0f63\u0fb7\u0f42\u0f0b\u0f54\u0f0b_\u0f42\u0f5f\u0f60\u0f0b\u0f55\u0f74\u0f62\u0f0b\u0f56\u0f74_\u0f42\u0f5f\u0f60\u0f0b\u0f54\u0f0b\u0f66\u0f44\u0f66\u0f0b_\u0f42\u0f5f\u0f60\u0f0b\u0f66\u0fa4\u0f7a\u0f53\u0f0b\u0f54\u0f0b".split("_"),weekdaysShort:"\u0f49\u0f72\u0f0b\u0f58\u0f0b_\u0f5f\u0fb3\u0f0b\u0f56\u0f0b_\u0f58\u0f72\u0f42\u0f0b\u0f51\u0f58\u0f62\u0f0b_\u0f63\u0fb7\u0f42\u0f0b\u0f54\u0f0b_\u0f55\u0f74\u0f62\u0f0b\u0f56\u0f74_\u0f54\u0f0b\u0f66\u0f44\u0f66\u0f0b_\u0f66\u0fa4\u0f7a\u0f53\u0f0b\u0f54\u0f0b".split("_"),weekdaysMin:"\u0f49\u0f72\u0f0b\u0f58\u0f0b_\u0f5f\u0fb3\u0f0b\u0f56\u0f0b_\u0f58\u0f72\u0f42\u0f0b\u0f51\u0f58\u0f62\u0f0b_\u0f63\u0fb7\u0f42\u0f0b\u0f54\u0f0b_\u0f55\u0f74\u0f62\u0f0b\u0f56\u0f74_\u0f54\u0f0b\u0f66\u0f44\u0f66\u0f0b_\u0f66\u0fa4\u0f7a\u0f53\u0f0b\u0f54\u0f0b".split("_"),longDateFormat:{LT:"A h:mm",LTS:"A h:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY, A h:mm",LLLL:"dddd, D MMMM YYYY, A h:mm"},calendar:{sameDay:"[\u0f51\u0f72\u0f0b\u0f62\u0f72\u0f44] LT",nextDay:"[\u0f66\u0f44\u0f0b\u0f49\u0f72\u0f53] LT",nextWeek:"[\u0f56\u0f51\u0f74\u0f53\u0f0b\u0f55\u0fb2\u0f42\u0f0b\u0f62\u0f97\u0f7a\u0f66\u0f0b\u0f58], LT",lastDay:"[\u0f41\u0f0b\u0f66\u0f44] LT",lastWeek:"[\u0f56\u0f51\u0f74\u0f53\u0f0b\u0f55\u0fb2\u0f42\u0f0b\u0f58\u0f50\u0f60\u0f0b\u0f58] dddd, LT",sameElse:"L"},relativeTime:{future:"%s \u0f63\u0f0b",past:"%s \u0f66\u0f94\u0f53\u0f0b\u0f63",s:"\u0f63\u0f58\u0f0b\u0f66\u0f44",ss:"%d \u0f66\u0f90\u0f62\u0f0b\u0f46\u0f0d",m:"\u0f66\u0f90\u0f62\u0f0b\u0f58\u0f0b\u0f42\u0f45\u0f72\u0f42",mm:"%d \u0f66\u0f90\u0f62\u0f0b\u0f58",h:"\u0f46\u0f74\u0f0b\u0f5a\u0f7c\u0f51\u0f0b\u0f42\u0f45\u0f72\u0f42",hh:"%d \u0f46\u0f74\u0f0b\u0f5a\u0f7c\u0f51",d:"\u0f49\u0f72\u0f53\u0f0b\u0f42\u0f45\u0f72\u0f42",dd:"%d \u0f49\u0f72\u0f53\u0f0b",M:"\u0f5f\u0fb3\u0f0b\u0f56\u0f0b\u0f42\u0f45\u0f72\u0f42",MM:"%d \u0f5f\u0fb3\u0f0b\u0f56",y:"\u0f63\u0f7c\u0f0b\u0f42\u0f45\u0f72\u0f42",yy:"%d \u0f63\u0f7c"},preparse:function(e){return e.replace(/[\u0f21\u0f22\u0f23\u0f24\u0f25\u0f26\u0f27\u0f28\u0f29\u0f20]/g,function(e){return Us[e]})},postformat:function(e){return e.replace(/\d/g,function(e){return Gs[e]})},meridiemParse:/\u0f58\u0f5a\u0f53\u0f0b\u0f58\u0f7c|\u0f5e\u0f7c\u0f42\u0f66\u0f0b\u0f40\u0f66|\u0f49\u0f72\u0f53\u0f0b\u0f42\u0f74\u0f44|\u0f51\u0f42\u0f7c\u0f44\u0f0b\u0f51\u0f42|\u0f58\u0f5a\u0f53\u0f0b\u0f58\u0f7c/,meridiemHour:function(e,a){return 12===e&&(e=0),"\u0f58\u0f5a\u0f53\u0f0b\u0f58\u0f7c"===a&&e>=4||"\u0f49\u0f72\u0f53\u0f0b\u0f42\u0f74\u0f44"===a&&e<5||"\u0f51\u0f42\u0f7c\u0f44\u0f0b\u0f51\u0f42"===a?e+12:e},meridiem:function(e,a,t){return e<4?"\u0f58\u0f5a\u0f53\u0f0b\u0f58\u0f7c":e<10?"\u0f5e\u0f7c\u0f42\u0f66\u0f0b\u0f40\u0f66":e<17?"\u0f49\u0f72\u0f53\u0f0b\u0f42\u0f74\u0f44":e<20?"\u0f51\u0f42\u0f7c\u0f44\u0f0b\u0f51\u0f42":"\u0f58\u0f5a\u0f53\u0f0b\u0f58\u0f7c"},week:{dow:0,doy:6}}),e.defineLocale("br",{months:"Genver_C'hwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu".split("_"),monthsShort:"Gen_C'hwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker".split("_"),weekdays:"Sul_Lun_Meurzh_Merc'her_Yaou_Gwener_Sadorn".split("_"),weekdaysShort:"Sul_Lun_Meu_Mer_Yao_Gwe_Sad".split("_"),weekdaysMin:"Su_Lu_Me_Mer_Ya_Gw_Sa".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"h[e]mm A",LTS:"h[e]mm:ss A",L:"DD/MM/YYYY",LL:"D [a viz] MMMM YYYY",LLL:"D [a viz] MMMM YYYY h[e]mm A",LLLL:"dddd, D [a viz] MMMM YYYY h[e]mm A"},calendar:{sameDay:"[Hiziv da] LT",nextDay:"[Warc'hoazh da] LT",nextWeek:"dddd [da] LT",lastDay:"[Dec'h da] LT",lastWeek:"dddd [paset da] LT",sameElse:"L"},relativeTime:{future:"a-benn %s",past:"%s 'zo",s:"un nebeud segondenno\xf9",ss:"%d eilenn",m:"ur vunutenn",mm:Qe,h:"un eur",hh:"%d eur",d:"un devezh",dd:Qe,M:"ur miz",MM:Qe,y:"ur bloaz",yy:function(e){switch(Xe(e)){case 1:case 3:case 4:case 5:case 9:return e+" bloaz";default:return e+" vloaz"}}},dayOfMonthOrdinalParse:/\d{1,2}(a\xf1|vet)/,ordinal:function(e){return e+(1===e?"a\xf1":"vet")},week:{dow:1,doy:4}}),e.defineLocale("bs",{months:"januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar".split("_"),monthsShort:"jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.".split("_"),monthsParseExact:!0,weekdays:"nedjelja_ponedjeljak_utorak_srijeda_\u010detvrtak_petak_subota".split("_"),weekdaysShort:"ned._pon._uto._sri._\u010det._pet._sub.".split("_"),weekdaysMin:"ne_po_ut_sr_\u010de_pe_su".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY H:mm",LLLL:"dddd, D. MMMM YYYY H:mm"},calendar:{sameDay:"[danas u] LT",nextDay:"[sutra u] LT",nextWeek:function(){switch(this.day()){case 0:return"[u] [nedjelju] [u] LT";case 3:return"[u] [srijedu] [u] LT";case 6:return"[u] [subotu] [u] LT";case 1:case 2:case 4:case 5:return"[u] dddd [u] LT"}},lastDay:"[ju\u010der u] LT",lastWeek:function(){switch(this.day()){case 0:case 3:return"[pro\u0161lu] dddd [u] LT";case 6:return"[pro\u0161le] [subote] [u] LT";case 1:case 2:case 4:case 5:return"[pro\u0161li] dddd [u] LT"}},sameElse:"L"},relativeTime:{future:"za %s",past:"prije %s",s:"par sekundi",ss:ea,m:ea,mm:ea,h:ea,hh:ea,d:"dan",dd:ea,M:"mjesec",MM:ea,y:"godinu",yy:ea},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:7}}),e.defineLocale("ca",{months:{standalone:"gener_febrer_mar\xe7_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre".split("_"),format:"de gener_de febrer_de mar\xe7_d'abril_de maig_de juny_de juliol_d'agost_de setembre_d'octubre_de novembre_de desembre".split("_"),isFormat:/D[oD]?(\s)+MMMM/},monthsShort:"gen._febr._mar\xe7_abr._maig_juny_jul._ag._set._oct._nov._des.".split("_"),monthsParseExact:!0,weekdays:"diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte".split("_"),weekdaysShort:"dg._dl._dt._dc._dj._dv._ds.".split("_"),weekdaysMin:"dg_dl_dt_dc_dj_dv_ds".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM [de] YYYY",ll:"D MMM YYYY",LLL:"D MMMM [de] YYYY [a les] H:mm",lll:"D MMM YYYY, H:mm",LLLL:"dddd D MMMM [de] YYYY [a les] H:mm",llll:"ddd D MMM YYYY, H:mm"},calendar:{sameDay:function(){return"[avui a "+(1!==this.hours()?"les":"la")+"] LT"},nextDay:function(){return"[dem\xe0 a "+(1!==this.hours()?"les":"la")+"] LT"},nextWeek:function(){return"dddd [a "+(1!==this.hours()?"les":"la")+"] LT"},lastDay:function(){return"[ahir a "+(1!==this.hours()?"les":"la")+"] LT"},lastWeek:function(){return"[el] dddd [passat a "+(1!==this.hours()?"les":"la")+"] LT"},sameElse:"L"},relativeTime:{future:"d'aqu\xed %s",past:"fa %s",s:"uns segons",ss:"%d segons",m:"un minut",mm:"%d minuts",h:"una hora",hh:"%d hores",d:"un dia",dd:"%d dies",M:"un mes",MM:"%d mesos",y:"un any",yy:"%d anys"},dayOfMonthOrdinalParse:/\d{1,2}(r|n|t|\xe8|a)/,ordinal:function(e,a){var t=1===e?"r":2===e?"n":3===e?"r":4===e?"t":"\xe8";return"w"!==a&&"W"!==a||(t="a"),e+t},week:{dow:1,doy:4}});var Vs="leden_\xfanor_b\u0159ezen_duben_kv\u011bten_\u010derven_\u010dervenec_srpen_z\xe1\u0159\xed_\u0159\xedjen_listopad_prosinec".split("_"),Ks="led_\xfano_b\u0159e_dub_kv\u011b_\u010dvn_\u010dvc_srp_z\xe1\u0159_\u0159\xedj_lis_pro".split("_");e.defineLocale("cs",{months:Vs,monthsShort:Ks,monthsParse:function(e,a){var t,s=[];for(t=0;t<12;t++)s[t]=new RegExp("^"+e[t]+"$|^"+a[t]+"$","i");return s}(Vs,Ks),shortMonthsParse:function(e){var a,t=[];for(a=0;a<12;a++)t[a]=new RegExp("^"+e[a]+"$","i");return t}(Ks),longMonthsParse:function(e){var a,t=[];for(a=0;a<12;a++)t[a]=new RegExp("^"+e[a]+"$","i");return t}(Vs),weekdays:"ned\u011ble_pond\u011bl\xed_\xfater\xfd_st\u0159eda_\u010dtvrtek_p\xe1tek_sobota".split("_"),weekdaysShort:"ne_po_\xfat_st_\u010dt_p\xe1_so".split("_"),weekdaysMin:"ne_po_\xfat_st_\u010dt_p\xe1_so".split("_"),longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY H:mm",LLLL:"dddd D. MMMM YYYY H:mm",l:"D. M. YYYY"},calendar:{sameDay:"[dnes v] LT",nextDay:"[z\xedtra v] LT",nextWeek:function(){switch(this.day()){case 0:return"[v ned\u011bli v] LT";case 1:case 2:return"[v] dddd [v] LT";case 3:return"[ve st\u0159edu v] LT";case 4:return"[ve \u010dtvrtek v] LT";case 5:return"[v p\xe1tek v] LT";case 6:return"[v sobotu v] LT"}},lastDay:"[v\u010dera v] LT",lastWeek:function(){switch(this.day()){case 0:return"[minulou ned\u011bli v] LT";case 1:case 2:return"[minul\xe9] dddd [v] LT";case 3:return"[minulou st\u0159edu v] LT";case 4:case 5:return"[minul\xfd] dddd [v] LT";case 6:return"[minulou sobotu v] LT"}},sameElse:"L"},relativeTime:{future:"za %s",past:"p\u0159ed %s",s:ta,ss:ta,m:ta,mm:ta,h:ta,hh:ta,d:ta,dd:ta,M:ta,MM:ta,y:ta,yy:ta},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}}),e.defineLocale("cv",{months:"\u043a\u04d1\u0440\u043b\u0430\u0447_\u043d\u0430\u0440\u04d1\u0441_\u043f\u0443\u0448_\u0430\u043a\u0430_\u043c\u0430\u0439_\u04ab\u04d7\u0440\u0442\u043c\u0435_\u0443\u0442\u04d1_\u04ab\u0443\u0440\u043b\u0430_\u0430\u0432\u04d1\u043d_\u044e\u043f\u0430_\u0447\u04f3\u043a_\u0440\u0430\u0448\u0442\u0430\u0432".split("_"),monthsShort:"\u043a\u04d1\u0440_\u043d\u0430\u0440_\u043f\u0443\u0448_\u0430\u043a\u0430_\u043c\u0430\u0439_\u04ab\u04d7\u0440_\u0443\u0442\u04d1_\u04ab\u0443\u0440_\u0430\u0432\u043d_\u044e\u043f\u0430_\u0447\u04f3\u043a_\u0440\u0430\u0448".split("_"),weekdays:"\u0432\u044b\u0440\u0441\u0430\u0440\u043d\u0438\u043a\u0443\u043d_\u0442\u0443\u043d\u0442\u0438\u043a\u0443\u043d_\u044b\u0442\u043b\u0430\u0440\u0438\u043a\u0443\u043d_\u044e\u043d\u043a\u0443\u043d_\u043a\u04d7\u04ab\u043d\u0435\u0440\u043d\u0438\u043a\u0443\u043d_\u044d\u0440\u043d\u0435\u043a\u0443\u043d_\u0448\u04d1\u043c\u0430\u0442\u043a\u0443\u043d".split("_"),weekdaysShort:"\u0432\u044b\u0440_\u0442\u0443\u043d_\u044b\u0442\u043b_\u044e\u043d_\u043a\u04d7\u04ab_\u044d\u0440\u043d_\u0448\u04d1\u043c".split("_"),weekdaysMin:"\u0432\u0440_\u0442\u043d_\u044b\u0442_\u044e\u043d_\u043a\u04ab_\u044d\u0440_\u0448\u043c".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD-MM-YYYY",LL:"YYYY [\u04ab\u0443\u043b\u0445\u0438] MMMM [\u0443\u0439\u04d1\u0445\u04d7\u043d] D[-\u043c\u04d7\u0448\u04d7]",LLL:"YYYY [\u04ab\u0443\u043b\u0445\u0438] MMMM [\u0443\u0439\u04d1\u0445\u04d7\u043d] D[-\u043c\u04d7\u0448\u04d7], HH:mm",LLLL:"dddd, YYYY [\u04ab\u0443\u043b\u0445\u0438] MMMM [\u0443\u0439\u04d1\u0445\u04d7\u043d] D[-\u043c\u04d7\u0448\u04d7], HH:mm"},calendar:{sameDay:"[\u041f\u0430\u044f\u043d] LT [\u0441\u0435\u0445\u0435\u0442\u0440\u0435]",nextDay:"[\u042b\u0440\u0430\u043d] LT [\u0441\u0435\u0445\u0435\u0442\u0440\u0435]",lastDay:"[\u04d6\u043d\u0435\u0440] LT [\u0441\u0435\u0445\u0435\u0442\u0440\u0435]",nextWeek:"[\u04aa\u0438\u0442\u0435\u0441] dddd LT [\u0441\u0435\u0445\u0435\u0442\u0440\u0435]",lastWeek:"[\u0418\u0440\u0442\u043d\u04d7] dddd LT [\u0441\u0435\u0445\u0435\u0442\u0440\u0435]",sameElse:"L"},relativeTime:{future:function(e){return e+(/\u0441\u0435\u0445\u0435\u0442$/i.exec(e)?"\u0440\u0435\u043d":/\u04ab\u0443\u043b$/i.exec(e)?"\u0442\u0430\u043d":"\u0440\u0430\u043d")},past:"%s \u043a\u0430\u044f\u043b\u043b\u0430",s:"\u043f\u04d7\u0440-\u0438\u043a \u04ab\u0435\u043a\u043a\u0443\u043d\u0442",ss:"%d \u04ab\u0435\u043a\u043a\u0443\u043d\u0442",m:"\u043f\u04d7\u0440 \u043c\u0438\u043d\u0443\u0442",mm:"%d \u043c\u0438\u043d\u0443\u0442",h:"\u043f\u04d7\u0440 \u0441\u0435\u0445\u0435\u0442",hh:"%d \u0441\u0435\u0445\u0435\u0442",d:"\u043f\u04d7\u0440 \u043a\u0443\u043d",dd:"%d \u043a\u0443\u043d",M:"\u043f\u04d7\u0440 \u0443\u0439\u04d1\u0445",MM:"%d \u0443\u0439\u04d1\u0445",y:"\u043f\u04d7\u0440 \u04ab\u0443\u043b",yy:"%d \u04ab\u0443\u043b"},dayOfMonthOrdinalParse:/\d{1,2}-\u043c\u04d7\u0448/,ordinal:"%d-\u043c\u04d7\u0448",week:{dow:1,doy:7}}),e.defineLocale("cy",{months:"Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr".split("_"),monthsShort:"Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag".split("_"),weekdays:"Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn".split("_"),weekdaysShort:"Sul_Llun_Maw_Mer_Iau_Gwe_Sad".split("_"),weekdaysMin:"Su_Ll_Ma_Me_Ia_Gw_Sa".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[Heddiw am] LT",nextDay:"[Yfory am] LT",nextWeek:"dddd [am] LT",lastDay:"[Ddoe am] LT",lastWeek:"dddd [diwethaf am] LT",sameElse:"L"},relativeTime:{future:"mewn %s",past:"%s yn \xf4l",s:"ychydig eiliadau",ss:"%d eiliad",m:"munud",mm:"%d munud",h:"awr",hh:"%d awr",d:"diwrnod",dd:"%d diwrnod",M:"mis",MM:"%d mis",y:"blwyddyn",yy:"%d flynedd"},dayOfMonthOrdinalParse:/\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,ordinal:function(e){var a="";return e>20?a=40===e||50===e||60===e||80===e||100===e?"fed":"ain":e>0&&(a=["","af","il","ydd","ydd","ed","ed","ed","fed","fed","fed","eg","fed","eg","eg","fed","eg","eg","fed","eg","fed"][e]),e+a},week:{dow:1,doy:4}}),e.defineLocale("da",{months:"januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december".split("_"),monthsShort:"jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec".split("_"),weekdays:"s\xf8ndag_mandag_tirsdag_onsdag_torsdag_fredag_l\xf8rdag".split("_"),weekdaysShort:"s\xf8n_man_tir_ons_tor_fre_l\xf8r".split("_"),weekdaysMin:"s\xf8_ma_ti_on_to_fr_l\xf8".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY HH:mm",LLLL:"dddd [d.] D. MMMM YYYY [kl.] HH:mm"},calendar:{sameDay:"[i dag kl.] LT",nextDay:"[i morgen kl.] LT",nextWeek:"p\xe5 dddd [kl.] LT",lastDay:"[i g\xe5r kl.] LT",lastWeek:"[i] dddd[s kl.] LT",sameElse:"L"},relativeTime:{future:"om %s",past:"%s siden",s:"f\xe5 sekunder",ss:"%d sekunder",m:"et minut",mm:"%d minutter",h:"en time",hh:"%d timer",d:"en dag",dd:"%d dage",M:"en m\xe5ned",MM:"%d m\xe5neder",y:"et \xe5r",yy:"%d \xe5r"},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}}),e.defineLocale("de-at",{months:"J\xe4nner_Februar_M\xe4rz_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember".split("_"),monthsShort:"J\xe4n._Feb._M\xe4rz_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.".split("_"),monthsParseExact:!0,weekdays:"Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag".split("_"),weekdaysShort:"So._Mo._Di._Mi._Do._Fr._Sa.".split("_"),weekdaysMin:"So_Mo_Di_Mi_Do_Fr_Sa".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY HH:mm",LLLL:"dddd, D. MMMM YYYY HH:mm"},calendar:{sameDay:"[heute um] LT [Uhr]",sameElse:"L",nextDay:"[morgen um] LT [Uhr]",nextWeek:"dddd [um] LT [Uhr]",lastDay:"[gestern um] LT [Uhr]",lastWeek:"[letzten] dddd [um] LT [Uhr]"},relativeTime:{future:"in %s",past:"vor %s",s:"ein paar Sekunden",ss:"%d Sekunden",m:sa,mm:"%d Minuten",h:sa,hh:"%d Stunden",d:sa,dd:sa,M:sa,MM:sa,y:sa,yy:sa},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}}),e.defineLocale("de-ch",{months:"Januar_Februar_M\xe4rz_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember".split("_"),monthsShort:"Jan._Feb._M\xe4rz_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.".split("_"),monthsParseExact:!0,weekdays:"Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag".split("_"),weekdaysShort:"So_Mo_Di_Mi_Do_Fr_Sa".split("_"),weekdaysMin:"So_Mo_Di_Mi_Do_Fr_Sa".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY HH:mm",LLLL:"dddd, D. MMMM YYYY HH:mm"},calendar:{sameDay:"[heute um] LT [Uhr]",sameElse:"L",nextDay:"[morgen um] LT [Uhr]",nextWeek:"dddd [um] LT [Uhr]",lastDay:"[gestern um] LT [Uhr]",lastWeek:"[letzten] dddd [um] LT [Uhr]"},relativeTime:{future:"in %s",past:"vor %s",s:"ein paar Sekunden",ss:"%d Sekunden",m:na,mm:"%d Minuten",h:na,hh:"%d Stunden",d:na,dd:na,M:na,MM:na,y:na,yy:na},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}}),e.defineLocale("de",{months:"Januar_Februar_M\xe4rz_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember".split("_"),monthsShort:"Jan._Feb._M\xe4rz_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.".split("_"),monthsParseExact:!0,weekdays:"Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag".split("_"),weekdaysShort:"So._Mo._Di._Mi._Do._Fr._Sa.".split("_"),weekdaysMin:"So_Mo_Di_Mi_Do_Fr_Sa".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY HH:mm",LLLL:"dddd, D. MMMM YYYY HH:mm"},calendar:{sameDay:"[heute um] LT [Uhr]",sameElse:"L",nextDay:"[morgen um] LT [Uhr]",nextWeek:"dddd [um] LT [Uhr]",lastDay:"[gestern um] LT [Uhr]",lastWeek:"[letzten] dddd [um] LT [Uhr]"},relativeTime:{future:"in %s",past:"vor %s",s:"ein paar Sekunden",ss:"%d Sekunden",m:da,mm:"%d Minuten",h:da,hh:"%d Stunden",d:da,dd:da,M:da,MM:da,y:da,yy:da},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}});var Zs=["\u0796\u07ac\u0782\u07aa\u0787\u07a6\u0783\u07a9","\u078a\u07ac\u0784\u07b0\u0783\u07aa\u0787\u07a6\u0783\u07a9","\u0789\u07a7\u0783\u07a8\u0797\u07aa","\u0787\u07ad\u0795\u07b0\u0783\u07a9\u078d\u07aa","\u0789\u07ad","\u0796\u07ab\u0782\u07b0","\u0796\u07aa\u078d\u07a6\u0787\u07a8","\u0787\u07af\u078e\u07a6\u0790\u07b0\u0793\u07aa","\u0790\u07ac\u0795\u07b0\u0793\u07ac\u0789\u07b0\u0784\u07a6\u0783\u07aa","\u0787\u07ae\u0786\u07b0\u0793\u07af\u0784\u07a6\u0783\u07aa","\u0782\u07ae\u0788\u07ac\u0789\u07b0\u0784\u07a6\u0783\u07aa","\u0791\u07a8\u0790\u07ac\u0789\u07b0\u0784\u07a6\u0783\u07aa"],$s=["\u0787\u07a7\u078b\u07a8\u0787\u07b0\u078c\u07a6","\u0780\u07af\u0789\u07a6","\u0787\u07a6\u0782\u07b0\u078e\u07a7\u0783\u07a6","\u0784\u07aa\u078b\u07a6","\u0784\u07aa\u0783\u07a7\u0790\u07b0\u078a\u07a6\u078c\u07a8","\u0780\u07aa\u0786\u07aa\u0783\u07aa","\u0780\u07ae\u0782\u07a8\u0780\u07a8\u0783\u07aa"];e.defineLocale("dv",{months:Zs,monthsShort:Zs,weekdays:$s,weekdaysShort:$s,weekdaysMin:"\u0787\u07a7\u078b\u07a8_\u0780\u07af\u0789\u07a6_\u0787\u07a6\u0782\u07b0_\u0784\u07aa\u078b\u07a6_\u0784\u07aa\u0783\u07a7_\u0780\u07aa\u0786\u07aa_\u0780\u07ae\u0782\u07a8".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"D/M/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},meridiemParse:/\u0789\u0786|\u0789\u078a/,isPM:function(e){return"\u0789\u078a"===e},meridiem:function(e,a,t){return e<12?"\u0789\u0786":"\u0789\u078a"},calendar:{sameDay:"[\u0789\u07a8\u0787\u07a6\u078b\u07aa] LT",nextDay:"[\u0789\u07a7\u078b\u07a6\u0789\u07a7] LT",nextWeek:"dddd LT",lastDay:"[\u0787\u07a8\u0787\u07b0\u0794\u07ac] LT",lastWeek:"[\u078a\u07a7\u0787\u07a8\u078c\u07aa\u0788\u07a8] dddd LT",sameElse:"L"},relativeTime:{future:"\u078c\u07ac\u0783\u07ad\u078e\u07a6\u0787\u07a8 %s",past:"\u0786\u07aa\u0783\u07a8\u0782\u07b0 %s",s:"\u0790\u07a8\u0786\u07aa\u0782\u07b0\u078c\u07aa\u0786\u07ae\u0785\u07ac\u0787\u07b0",ss:"d% \u0790\u07a8\u0786\u07aa\u0782\u07b0\u078c\u07aa",m:"\u0789\u07a8\u0782\u07a8\u0793\u07ac\u0787\u07b0",mm:"\u0789\u07a8\u0782\u07a8\u0793\u07aa %d",h:"\u078e\u07a6\u0791\u07a8\u0787\u07a8\u0783\u07ac\u0787\u07b0",hh:"\u078e\u07a6\u0791\u07a8\u0787\u07a8\u0783\u07aa %d",d:"\u078b\u07aa\u0788\u07a6\u0780\u07ac\u0787\u07b0",dd:"\u078b\u07aa\u0788\u07a6\u0790\u07b0 %d",M:"\u0789\u07a6\u0780\u07ac\u0787\u07b0",MM:"\u0789\u07a6\u0790\u07b0 %d",y:"\u0787\u07a6\u0780\u07a6\u0783\u07ac\u0787\u07b0",yy:"\u0787\u07a6\u0780\u07a6\u0783\u07aa %d"},preparse:function(e){return e.replace(/\u060c/g,",")},postformat:function(e){return e.replace(/,/g,"\u060c")},week:{dow:7,doy:12}}),e.defineLocale("el",{monthsNominativeEl:"\u0399\u03b1\u03bd\u03bf\u03c5\u03ac\u03c1\u03b9\u03bf\u03c2_\u03a6\u03b5\u03b2\u03c1\u03bf\u03c5\u03ac\u03c1\u03b9\u03bf\u03c2_\u039c\u03ac\u03c1\u03c4\u03b9\u03bf\u03c2_\u0391\u03c0\u03c1\u03af\u03bb\u03b9\u03bf\u03c2_\u039c\u03ac\u03b9\u03bf\u03c2_\u0399\u03bf\u03cd\u03bd\u03b9\u03bf\u03c2_\u0399\u03bf\u03cd\u03bb\u03b9\u03bf\u03c2_\u0391\u03cd\u03b3\u03bf\u03c5\u03c3\u03c4\u03bf\u03c2_\u03a3\u03b5\u03c0\u03c4\u03ad\u03bc\u03b2\u03c1\u03b9\u03bf\u03c2_\u039f\u03ba\u03c4\u03ce\u03b2\u03c1\u03b9\u03bf\u03c2_\u039d\u03bf\u03ad\u03bc\u03b2\u03c1\u03b9\u03bf\u03c2_\u0394\u03b5\u03ba\u03ad\u03bc\u03b2\u03c1\u03b9\u03bf\u03c2".split("_"),monthsGenitiveEl:"\u0399\u03b1\u03bd\u03bf\u03c5\u03b1\u03c1\u03af\u03bf\u03c5_\u03a6\u03b5\u03b2\u03c1\u03bf\u03c5\u03b1\u03c1\u03af\u03bf\u03c5_\u039c\u03b1\u03c1\u03c4\u03af\u03bf\u03c5_\u0391\u03c0\u03c1\u03b9\u03bb\u03af\u03bf\u03c5_\u039c\u03b1\u0390\u03bf\u03c5_\u0399\u03bf\u03c5\u03bd\u03af\u03bf\u03c5_\u0399\u03bf\u03c5\u03bb\u03af\u03bf\u03c5_\u0391\u03c5\u03b3\u03bf\u03cd\u03c3\u03c4\u03bf\u03c5_\u03a3\u03b5\u03c0\u03c4\u03b5\u03bc\u03b2\u03c1\u03af\u03bf\u03c5_\u039f\u03ba\u03c4\u03c9\u03b2\u03c1\u03af\u03bf\u03c5_\u039d\u03bf\u03b5\u03bc\u03b2\u03c1\u03af\u03bf\u03c5_\u0394\u03b5\u03ba\u03b5\u03bc\u03b2\u03c1\u03af\u03bf\u03c5".split("_"),months:function(e,a){return e?"string"==typeof a&&/D/.test(a.substring(0,a.indexOf("MMMM")))?this._monthsGenitiveEl[e.month()]:this._monthsNominativeEl[e.month()]:this._monthsNominativeEl},monthsShort:"\u0399\u03b1\u03bd_\u03a6\u03b5\u03b2_\u039c\u03b1\u03c1_\u0391\u03c0\u03c1_\u039c\u03b1\u03ca_\u0399\u03bf\u03c5\u03bd_\u0399\u03bf\u03c5\u03bb_\u0391\u03c5\u03b3_\u03a3\u03b5\u03c0_\u039f\u03ba\u03c4_\u039d\u03bf\u03b5_\u0394\u03b5\u03ba".split("_"),weekdays:"\u039a\u03c5\u03c1\u03b9\u03b1\u03ba\u03ae_\u0394\u03b5\u03c5\u03c4\u03ad\u03c1\u03b1_\u03a4\u03c1\u03af\u03c4\u03b7_\u03a4\u03b5\u03c4\u03ac\u03c1\u03c4\u03b7_\u03a0\u03ad\u03bc\u03c0\u03c4\u03b7_\u03a0\u03b1\u03c1\u03b1\u03c3\u03ba\u03b5\u03c5\u03ae_\u03a3\u03ac\u03b2\u03b2\u03b1\u03c4\u03bf".split("_"),weekdaysShort:"\u039a\u03c5\u03c1_\u0394\u03b5\u03c5_\u03a4\u03c1\u03b9_\u03a4\u03b5\u03c4_\u03a0\u03b5\u03bc_\u03a0\u03b1\u03c1_\u03a3\u03b1\u03b2".split("_"),weekdaysMin:"\u039a\u03c5_\u0394\u03b5_\u03a4\u03c1_\u03a4\u03b5_\u03a0\u03b5_\u03a0\u03b1_\u03a3\u03b1".split("_"),meridiem:function(e,a,t){return e>11?t?"\u03bc\u03bc":"\u039c\u039c":t?"\u03c0\u03bc":"\u03a0\u039c"},isPM:function(e){return"\u03bc"===(e+"").toLowerCase()[0]},meridiemParse:/[\u03a0\u039c]\.?\u039c?\.?/i,longDateFormat:{LT:"h:mm A",LTS:"h:mm:ss A",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY h:mm A",LLLL:"dddd, D MMMM YYYY h:mm A"},calendarEl:{sameDay:"[\u03a3\u03ae\u03bc\u03b5\u03c1\u03b1 {}] LT",nextDay:"[\u0391\u03cd\u03c1\u03b9\u03bf {}] LT",nextWeek:"dddd [{}] LT",lastDay:"[\u03a7\u03b8\u03b5\u03c2 {}] LT",lastWeek:function(){switch(this.day()){case 6:return"[\u03c4\u03bf \u03c0\u03c1\u03bf\u03b7\u03b3\u03bf\u03cd\u03bc\u03b5\u03bd\u03bf] dddd [{}] LT";default:return"[\u03c4\u03b7\u03bd \u03c0\u03c1\u03bf\u03b7\u03b3\u03bf\u03cd\u03bc\u03b5\u03bd\u03b7] dddd [{}] LT"}},sameElse:"L"},calendar:function(e,a){var t=this._calendarEl[e],s=a&&a.hours();return D(t)&&(t=t.apply(a)),t.replace("{}",s%12==1?"\u03c3\u03c4\u03b7":"\u03c3\u03c4\u03b9\u03c2")},relativeTime:{future:"\u03c3\u03b5 %s",past:"%s \u03c0\u03c1\u03b9\u03bd",s:"\u03bb\u03af\u03b3\u03b1 \u03b4\u03b5\u03c5\u03c4\u03b5\u03c1\u03cc\u03bb\u03b5\u03c0\u03c4\u03b1",ss:"%d \u03b4\u03b5\u03c5\u03c4\u03b5\u03c1\u03cc\u03bb\u03b5\u03c0\u03c4\u03b1",m:"\u03ad\u03bd\u03b1 \u03bb\u03b5\u03c0\u03c4\u03cc",mm:"%d \u03bb\u03b5\u03c0\u03c4\u03ac",h:"\u03bc\u03af\u03b1 \u03ce\u03c1\u03b1",hh:"%d \u03ce\u03c1\u03b5\u03c2",d:"\u03bc\u03af\u03b1 \u03bc\u03ad\u03c1\u03b1",dd:"%d \u03bc\u03ad\u03c1\u03b5\u03c2",M:"\u03ad\u03bd\u03b1\u03c2 \u03bc\u03ae\u03bd\u03b1\u03c2",MM:"%d \u03bc\u03ae\u03bd\u03b5\u03c2",y:"\u03ad\u03bd\u03b1\u03c2 \u03c7\u03c1\u03cc\u03bd\u03bf\u03c2",yy:"%d \u03c7\u03c1\u03cc\u03bd\u03b9\u03b1"},dayOfMonthOrdinalParse:/\d{1,2}\u03b7/,ordinal:"%d\u03b7",week:{dow:1,doy:4}}),e.defineLocale("en-au",{months:"January_February_March_April_May_June_July_August_September_October_November_December".split("_"),monthsShort:"Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),weekdays:"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),weekdaysShort:"Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),weekdaysMin:"Su_Mo_Tu_We_Th_Fr_Sa".split("_"),longDateFormat:{LT:"h:mm A",LTS:"h:mm:ss A",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY h:mm A",LLLL:"dddd, D MMMM YYYY h:mm A"},calendar:{sameDay:"[Today at] LT",nextDay:"[Tomorrow at] LT",nextWeek:"dddd [at] LT",lastDay:"[Yesterday at] LT",lastWeek:"[Last] dddd [at] LT",sameElse:"L"},relativeTime:{future:"in %s",past:"%s ago",s:"a few seconds",ss:"%d seconds",m:"a minute",mm:"%d minutes",h:"an hour",hh:"%d hours",d:"a day",dd:"%d days",M:"a month",MM:"%d months",y:"a year",yy:"%d years"},dayOfMonthOrdinalParse:/\d{1,2}(st|nd|rd|th)/,ordinal:function(e){var a=e%10;return e+(1==~~(e%100/10)?"th":1===a?"st":2===a?"nd":3===a?"rd":"th")},week:{dow:1,doy:4}}),e.defineLocale("en-ca",{months:"January_February_March_April_May_June_July_August_September_October_November_December".split("_"),monthsShort:"Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),weekdays:"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),weekdaysShort:"Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),weekdaysMin:"Su_Mo_Tu_We_Th_Fr_Sa".split("_"),longDateFormat:{LT:"h:mm A",LTS:"h:mm:ss A",L:"YYYY-MM-DD",LL:"MMMM D, YYYY",LLL:"MMMM D, YYYY h:mm A",LLLL:"dddd, MMMM D, YYYY h:mm A"},calendar:{sameDay:"[Today at] LT",nextDay:"[Tomorrow at] LT",nextWeek:"dddd [at] LT",lastDay:"[Yesterday at] LT",lastWeek:"[Last] dddd [at] LT",sameElse:"L"},relativeTime:{future:"in %s",past:"%s ago",s:"a few seconds",ss:"%d seconds",m:"a minute",mm:"%d minutes",h:"an hour",hh:"%d hours",d:"a day",dd:"%d days",M:"a month",MM:"%d months",y:"a year",yy:"%d years"},dayOfMonthOrdinalParse:/\d{1,2}(st|nd|rd|th)/,ordinal:function(e){var a=e%10;return e+(1==~~(e%100/10)?"th":1===a?"st":2===a?"nd":3===a?"rd":"th")}}),e.defineLocale("en-gb",{months:"January_February_March_April_May_June_July_August_September_October_November_December".split("_"),monthsShort:"Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),weekdays:"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),weekdaysShort:"Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),weekdaysMin:"Su_Mo_Tu_We_Th_Fr_Sa".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[Today at] LT",nextDay:"[Tomorrow at] LT",nextWeek:"dddd [at] LT",lastDay:"[Yesterday at] LT",lastWeek:"[Last] dddd [at] LT",sameElse:"L"},relativeTime:{future:"in %s",past:"%s ago",s:"a few seconds",ss:"%d seconds",m:"a minute",mm:"%d minutes",h:"an hour",hh:"%d hours",d:"a day",dd:"%d days",M:"a month",MM:"%d months",y:"a year",yy:"%d years"},dayOfMonthOrdinalParse:/\d{1,2}(st|nd|rd|th)/,ordinal:function(e){var a=e%10;return e+(1==~~(e%100/10)?"th":1===a?"st":2===a?"nd":3===a?"rd":"th")},week:{dow:1,doy:4}}),e.defineLocale("en-ie",{months:"January_February_March_April_May_June_July_August_September_October_November_December".split("_"),monthsShort:"Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),weekdays:"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),weekdaysShort:"Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),weekdaysMin:"Su_Mo_Tu_We_Th_Fr_Sa".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD-MM-YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},calendar:{sameDay:"[Today at] LT",nextDay:"[Tomorrow at] LT",nextWeek:"dddd [at] LT",lastDay:"[Yesterday at] LT",lastWeek:"[Last] dddd [at] LT",sameElse:"L"},relativeTime:{future:"in %s",past:"%s ago",s:"a few seconds",ss:"%d seconds",m:"a minute",mm:"%d minutes",h:"an hour",hh:"%d hours",d:"a day",dd:"%d days",M:"a month",MM:"%d months",y:"a year",yy:"%d years"},dayOfMonthOrdinalParse:/\d{1,2}(st|nd|rd|th)/,ordinal:function(e){var a=e%10;return e+(1==~~(e%100/10)?"th":1===a?"st":2===a?"nd":3===a?"rd":"th")},week:{dow:1,doy:4}}),e.defineLocale("en-nz",{months:"January_February_March_April_May_June_July_August_September_October_November_December".split("_"),monthsShort:"Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),weekdays:"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),weekdaysShort:"Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),weekdaysMin:"Su_Mo_Tu_We_Th_Fr_Sa".split("_"),longDateFormat:{LT:"h:mm A",LTS:"h:mm:ss A",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY h:mm A",LLLL:"dddd, D MMMM YYYY h:mm A"},calendar:{sameDay:"[Today at] LT",nextDay:"[Tomorrow at] LT",nextWeek:"dddd [at] LT",lastDay:"[Yesterday at] LT",lastWeek:"[Last] dddd [at] LT",sameElse:"L"},relativeTime:{future:"in %s",past:"%s ago",s:"a few seconds",ss:"%d seconds",m:"a minute",mm:"%d minutes",h:"an hour",hh:"%d hours",d:"a day",dd:"%d days",M:"a month",MM:"%d months",y:"a year",yy:"%d years"},dayOfMonthOrdinalParse:/\d{1,2}(st|nd|rd|th)/,ordinal:function(e){var a=e%10;return e+(1==~~(e%100/10)?"th":1===a?"st":2===a?"nd":3===a?"rd":"th")},week:{dow:1,doy:4}}),e.defineLocale("eo",{months:"januaro_februaro_marto_aprilo_majo_junio_julio_a\u016dgusto_septembro_oktobro_novembro_decembro".split("_"),monthsShort:"jan_feb_mar_apr_maj_jun_jul_a\u016dg_sep_okt_nov_dec".split("_"),weekdays:"diman\u0109o_lundo_mardo_merkredo_\u0135a\u016ddo_vendredo_sabato".split("_"),weekdaysShort:"dim_lun_mard_merk_\u0135a\u016d_ven_sab".split("_"),weekdaysMin:"di_lu_ma_me_\u0135a_ve_sa".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"YYYY-MM-DD",LL:"D[-a de] MMMM, YYYY",LLL:"D[-a de] MMMM, YYYY HH:mm",LLLL:"dddd, [la] D[-a de] MMMM, YYYY HH:mm"},meridiemParse:/[ap]\.t\.m/i,isPM:function(e){return"p"===e.charAt(0).toLowerCase()},meridiem:function(e,a,t){return e>11?t?"p.t.m.":"P.T.M.":t?"a.t.m.":"A.T.M."},calendar:{sameDay:"[Hodia\u016d je] LT",nextDay:"[Morga\u016d je] LT",nextWeek:"dddd [je] LT",lastDay:"[Hiera\u016d je] LT",lastWeek:"[pasinta] dddd [je] LT",sameElse:"L"},relativeTime:{future:"post %s",past:"anta\u016d %s",s:"sekundoj",ss:"%d sekundoj",m:"minuto",mm:"%d minutoj",h:"horo",hh:"%d horoj",d:"tago",dd:"%d tagoj",M:"monato",MM:"%d monatoj",y:"jaro",yy:"%d jaroj"},dayOfMonthOrdinalParse:/\d{1,2}a/,ordinal:"%da",week:{dow:1,doy:7}});var Bs="ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.".split("_"),qs="ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic".split("_"),Qs=[/^ene/i,/^feb/i,/^mar/i,/^abr/i,/^may/i,/^jun/i,/^jul/i,/^ago/i,/^sep/i,/^oct/i,/^nov/i,/^dic/i],Xs=/^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;e.defineLocale("es-do",{months:"enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre".split("_"),monthsShort:function(e,a){return e?/-MMM-/.test(a)?qs[e.month()]:Bs[e.month()]:Bs},monthsRegex:Xs,monthsShortRegex:Xs,monthsStrictRegex:/^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,monthsShortStrictRegex:/^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,monthsParse:Qs,longMonthsParse:Qs,shortMonthsParse:Qs,weekdays:"domingo_lunes_martes_mi\xe9rcoles_jueves_viernes_s\xe1bado".split("_"),weekdaysShort:"dom._lun._mar._mi\xe9._jue._vie._s\xe1b.".split("_"),weekdaysMin:"do_lu_ma_mi_ju_vi_s\xe1".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"h:mm A",LTS:"h:mm:ss A",L:"DD/MM/YYYY",LL:"D [de] MMMM [de] YYYY",LLL:"D [de] MMMM [de] YYYY h:mm A",LLLL:"dddd, D [de] MMMM [de] YYYY h:mm A"},calendar:{sameDay:function(){return"[hoy a la"+(1!==this.hours()?"s":"")+"] LT"},nextDay:function(){return"[ma\xf1ana a la"+(1!==this.hours()?"s":"")+"] LT"},nextWeek:function(){return"dddd [a la"+(1!==this.hours()?"s":"")+"] LT"},lastDay:function(){return"[ayer a la"+(1!==this.hours()?"s":"")+"] LT"},lastWeek:function(){return"[el] dddd [pasado a la"+(1!==this.hours()?"s":"")+"] LT"},sameElse:"L"},relativeTime:{future:"en %s",past:"hace %s",s:"unos segundos",ss:"%d segundos",m:"un minuto",mm:"%d minutos",h:"una hora",hh:"%d horas",d:"un d\xeda",dd:"%d d\xedas",M:"un mes",MM:"%d meses",y:"un a\xf1o",yy:"%d a\xf1os"},dayOfMonthOrdinalParse:/\d{1,2}\xba/,ordinal:"%d\xba",week:{dow:1,doy:4}});var en="ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.".split("_"),an="ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic".split("_");e.defineLocale("es-us",{months:"enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre".split("_"),monthsShort:function(e,a){return e?/-MMM-/.test(a)?an[e.month()]:en[e.month()]:en},monthsParseExact:!0,weekdays:"domingo_lunes_martes_mi\xe9rcoles_jueves_viernes_s\xe1bado".split("_"),weekdaysShort:"dom._lun._mar._mi\xe9._jue._vie._s\xe1b.".split("_"),weekdaysMin:"do_lu_ma_mi_ju_vi_s\xe1".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"h:mm A",LTS:"h:mm:ss A",L:"MM/DD/YYYY",LL:"MMMM [de] D [de] YYYY",LLL:"MMMM [de] D [de] YYYY h:mm A",LLLL:"dddd, MMMM [de] D [de] YYYY h:mm A"},calendar:{sameDay:function(){return"[hoy a la"+(1!==this.hours()?"s":"")+"] LT"},nextDay:function(){return"[ma\xf1ana a la"+(1!==this.hours()?"s":"")+"] LT"},nextWeek:function(){return"dddd [a la"+(1!==this.hours()?"s":"")+"] LT"},lastDay:function(){return"[ayer a la"+(1!==this.hours()?"s":"")+"] LT"},lastWeek:function(){return"[el] dddd [pasado a la"+(1!==this.hours()?"s":"")+"] LT"},sameElse:"L"},relativeTime:{future:"en %s",past:"hace %s",s:"unos segundos",ss:"%d segundos",m:"un minuto",mm:"%d minutos",h:"una hora",hh:"%d horas",d:"un d\xeda",dd:"%d d\xedas",M:"un mes",MM:"%d meses",y:"un a\xf1o",yy:"%d a\xf1os"},dayOfMonthOrdinalParse:/\d{1,2}\xba/,ordinal:"%d\xba",week:{dow:0,doy:6}});var tn="ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.".split("_"),sn="ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic".split("_"),nn=[/^ene/i,/^feb/i,/^mar/i,/^abr/i,/^may/i,/^jun/i,/^jul/i,/^ago/i,/^sep/i,/^oct/i,/^nov/i,/^dic/i],dn=/^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;e.defineLocale("es",{months:"enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre".split("_"),monthsShort:function(e,a){return e?/-MMM-/.test(a)?sn[e.month()]:tn[e.month()]:tn},monthsRegex:dn,monthsShortRegex:dn,monthsStrictRegex:/^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,monthsShortStrictRegex:/^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,monthsParse:nn,longMonthsParse:nn,shortMonthsParse:nn,weekdays:"domingo_lunes_martes_mi\xe9rcoles_jueves_viernes_s\xe1bado".split("_"),weekdaysShort:"dom._lun._mar._mi\xe9._jue._vie._s\xe1b.".split("_"),weekdaysMin:"do_lu_ma_mi_ju_vi_s\xe1".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD/MM/YYYY",LL:"D [de] MMMM [de] YYYY",LLL:"D [de] MMMM [de] YYYY H:mm",LLLL:"dddd, D [de] MMMM [de] YYYY H:mm"},calendar:{sameDay:function(){return"[hoy a la"+(1!==this.hours()?"s":"")+"] LT"},nextDay:function(){return"[ma\xf1ana a la"+(1!==this.hours()?"s":"")+"] LT"},nextWeek:function(){return"dddd [a la"+(1!==this.hours()?"s":"")+"] LT"},lastDay:function(){return"[ayer a la"+(1!==this.hours()?"s":"")+"] LT"},lastWeek:function(){return"[el] dddd [pasado a la"+(1!==this.hours()?"s":"")+"] LT"},sameElse:"L"},relativeTime:{future:"en %s",past:"hace %s",s:"unos segundos",ss:"%d segundos",m:"un minuto",mm:"%d minutos",h:"una hora",hh:"%d horas",d:"un d\xeda",dd:"%d d\xedas",M:"un mes",MM:"%d meses",y:"un a\xf1o",yy:"%d a\xf1os"},dayOfMonthOrdinalParse:/\d{1,2}\xba/,ordinal:"%d\xba",week:{dow:1,doy:4}}),e.defineLocale("et",{months:"jaanuar_veebruar_m\xe4rts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember".split("_"),monthsShort:"jaan_veebr_m\xe4rts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets".split("_"),weekdays:"p\xfchap\xe4ev_esmasp\xe4ev_teisip\xe4ev_kolmap\xe4ev_neljap\xe4ev_reede_laup\xe4ev".split("_"),weekdaysShort:"P_E_T_K_N_R_L".split("_"),weekdaysMin:"P_E_T_K_N_R_L".split("_"),longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY H:mm",LLLL:"dddd, D. MMMM YYYY H:mm"},calendar:{sameDay:"[T\xe4na,] LT",nextDay:"[Homme,] LT",nextWeek:"[J\xe4rgmine] dddd LT",lastDay:"[Eile,] LT",lastWeek:"[Eelmine] dddd LT",sameElse:"L"},relativeTime:{future:"%s p\xe4rast",past:"%s tagasi",s:ra,ss:ra,m:ra,mm:ra,h:ra,hh:ra,d:ra,dd:"%d p\xe4eva",M:ra,MM:ra,y:ra,yy:ra},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}}),e.defineLocale("eu",{months:"urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua".split("_"),monthsShort:"urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.".split("_"),monthsParseExact:!0,weekdays:"igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata".split("_"),weekdaysShort:"ig._al._ar._az._og._ol._lr.".split("_"),weekdaysMin:"ig_al_ar_az_og_ol_lr".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"YYYY-MM-DD",LL:"YYYY[ko] MMMM[ren] D[a]",LLL:"YYYY[ko] MMMM[ren] D[a] HH:mm",LLLL:"dddd, YYYY[ko] MMMM[ren] D[a] HH:mm",l:"YYYY-M-D",ll:"YYYY[ko] MMM D[a]",lll:"YYYY[ko] MMM D[a] HH:mm",llll:"ddd, YYYY[ko] MMM D[a] HH:mm"},calendar:{sameDay:"[gaur] LT[etan]",nextDay:"[bihar] LT[etan]",nextWeek:"dddd LT[etan]",lastDay:"[atzo] LT[etan]",lastWeek:"[aurreko] dddd LT[etan]",sameElse:"L"},relativeTime:{future:"%s barru",past:"duela %s",s:"segundo batzuk",ss:"%d segundo",m:"minutu bat",mm:"%d minutu",h:"ordu bat",hh:"%d ordu",d:"egun bat",dd:"%d egun",M:"hilabete bat",MM:"%d hilabete",y:"urte bat",yy:"%d urte"},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:7}});var rn={1:"\u06f1",2:"\u06f2",3:"\u06f3",4:"\u06f4",5:"\u06f5",6:"\u06f6",7:"\u06f7",8:"\u06f8",9:"\u06f9",0:"\u06f0"},_n={"\u06f1":"1","\u06f2":"2","\u06f3":"3","\u06f4":"4","\u06f5":"5","\u06f6":"6","\u06f7":"7","\u06f8":"8","\u06f9":"9","\u06f0":"0"};e.defineLocale("fa",{months:"\u0698\u0627\u0646\u0648\u06cc\u0647_\u0641\u0648\u0631\u06cc\u0647_\u0645\u0627\u0631\u0633_\u0622\u0648\u0631\u06cc\u0644_\u0645\u0647_\u0698\u0648\u0626\u0646_\u0698\u0648\u0626\u06cc\u0647_\u0627\u0648\u062a_\u0633\u067e\u062a\u0627\u0645\u0628\u0631_\u0627\u06a9\u062a\u0628\u0631_\u0646\u0648\u0627\u0645\u0628\u0631_\u062f\u0633\u0627\u0645\u0628\u0631".split("_"),monthsShort:"\u0698\u0627\u0646\u0648\u06cc\u0647_\u0641\u0648\u0631\u06cc\u0647_\u0645\u0627\u0631\u0633_\u0622\u0648\u0631\u06cc\u0644_\u0645\u0647_\u0698\u0648\u0626\u0646_\u0698\u0648\u0626\u06cc\u0647_\u0627\u0648\u062a_\u0633\u067e\u062a\u0627\u0645\u0628\u0631_\u0627\u06a9\u062a\u0628\u0631_\u0646\u0648\u0627\u0645\u0628\u0631_\u062f\u0633\u0627\u0645\u0628\u0631".split("_"),weekdays:"\u06cc\u06a9\u200c\u0634\u0646\u0628\u0647_\u062f\u0648\u0634\u0646\u0628\u0647_\u0633\u0647\u200c\u0634\u0646\u0628\u0647_\u0686\u0647\u0627\u0631\u0634\u0646\u0628\u0647_\u067e\u0646\u062c\u200c\u0634\u0646\u0628\u0647_\u062c\u0645\u0639\u0647_\u0634\u0646\u0628\u0647".split("_"),weekdaysShort:"\u06cc\u06a9\u200c\u0634\u0646\u0628\u0647_\u062f\u0648\u0634\u0646\u0628\u0647_\u0633\u0647\u200c\u0634\u0646\u0628\u0647_\u0686\u0647\u0627\u0631\u0634\u0646\u0628\u0647_\u067e\u0646\u062c\u200c\u0634\u0646\u0628\u0647_\u062c\u0645\u0639\u0647_\u0634\u0646\u0628\u0647".split("_"),weekdaysMin:"\u06cc_\u062f_\u0633_\u0686_\u067e_\u062c_\u0634".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},meridiemParse:/\u0642\u0628\u0644 \u0627\u0632 \u0638\u0647\u0631|\u0628\u0639\u062f \u0627\u0632 \u0638\u0647\u0631/,isPM:function(e){return/\u0628\u0639\u062f \u0627\u0632 \u0638\u0647\u0631/.test(e)},meridiem:function(e,a,t){return e<12?"\u0642\u0628\u0644 \u0627\u0632 \u0638\u0647\u0631":"\u0628\u0639\u062f \u0627\u0632 \u0638\u0647\u0631"},calendar:{sameDay:"[\u0627\u0645\u0631\u0648\u0632 \u0633\u0627\u0639\u062a] LT",nextDay:"[\u0641\u0631\u062f\u0627 \u0633\u0627\u0639\u062a] LT",nextWeek:"dddd [\u0633\u0627\u0639\u062a] LT",lastDay:"[\u062f\u06cc\u0631\u0648\u0632 \u0633\u0627\u0639\u062a] LT",lastWeek:"dddd [\u067e\u06cc\u0634] [\u0633\u0627\u0639\u062a] LT",sameElse:"L"},relativeTime:{future:"\u062f\u0631 %s",past:"%s \u067e\u06cc\u0634",s:"\u0686\u0646\u062f \u062b\u0627\u0646\u06cc\u0647",ss:"\u062b\u0627\u0646\u06cc\u0647 d%",m:"\u06cc\u06a9 \u062f\u0642\u06cc\u0642\u0647",mm:"%d \u062f\u0642\u06cc\u0642\u0647",h:"\u06cc\u06a9 \u0633\u0627\u0639\u062a",hh:"%d \u0633\u0627\u0639\u062a",d:"\u06cc\u06a9 \u0631\u0648\u0632",dd:"%d \u0631\u0648\u0632",M:"\u06cc\u06a9 \u0645\u0627\u0647",MM:"%d \u0645\u0627\u0647",y:"\u06cc\u06a9 \u0633\u0627\u0644",yy:"%d \u0633\u0627\u0644"},preparse:function(e){return e.replace(/[\u06f0-\u06f9]/g,function(e){return _n[e]}).replace(/\u060c/g,",")},postformat:function(e){return e.replace(/\d/g,function(e){return rn[e]}).replace(/,/g,"\u060c")},dayOfMonthOrdinalParse:/\d{1,2}\u0645/,ordinal:"%d\u0645",week:{dow:6,doy:12}});var on="nolla yksi kaksi kolme nelj\xe4 viisi kuusi seitsem\xe4n kahdeksan yhdeks\xe4n".split(" "),mn=["nolla","yhden","kahden","kolmen","nelj\xe4n","viiden","kuuden",on[7],on[8],on[9]];e.defineLocale("fi",{months:"tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kes\xe4kuu_hein\xe4kuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu".split("_"),monthsShort:"tammi_helmi_maalis_huhti_touko_kes\xe4_hein\xe4_elo_syys_loka_marras_joulu".split("_"),weekdays:"sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai".split("_"),weekdaysShort:"su_ma_ti_ke_to_pe_la".split("_"),weekdaysMin:"su_ma_ti_ke_to_pe_la".split("_"),longDateFormat:{LT:"HH.mm",LTS:"HH.mm.ss",L:"DD.MM.YYYY",LL:"Do MMMM[ta] YYYY",LLL:"Do MMMM[ta] YYYY, [klo] HH.mm",LLLL:"dddd, Do MMMM[ta] YYYY, [klo] HH.mm",l:"D.M.YYYY",ll:"Do MMM YYYY",lll:"Do MMM YYYY, [klo] HH.mm",llll:"ddd, Do MMM YYYY, [klo] HH.mm"},calendar:{sameDay:"[t\xe4n\xe4\xe4n] [klo] LT",nextDay:"[huomenna] [klo] LT",nextWeek:"dddd [klo] LT",lastDay:"[eilen] [klo] LT",lastWeek:"[viime] dddd[na] [klo] LT",sameElse:"L"},relativeTime:{future:"%s p\xe4\xe4st\xe4",past:"%s sitten",s:_a,ss:_a,m:_a,mm:_a,h:_a,hh:_a,d:_a,dd:_a,M:_a,MM:_a,y:_a,yy:_a},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}}),e.defineLocale("fo",{months:"januar_februar_mars_apr\xedl_mai_juni_juli_august_september_oktober_november_desember".split("_"),monthsShort:"jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des".split("_"),weekdays:"sunnudagur_m\xe1nadagur_t\xfdsdagur_mikudagur_h\xf3sdagur_fr\xedggjadagur_leygardagur".split("_"),weekdaysShort:"sun_m\xe1n_t\xfds_mik_h\xf3s_fr\xed_ley".split("_"),weekdaysMin:"su_m\xe1_t\xfd_mi_h\xf3_fr_le".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D. MMMM, YYYY HH:mm"},calendar:{sameDay:"[\xcd dag kl.] LT",nextDay:"[\xcd morgin kl.] LT",nextWeek:"dddd [kl.] LT",lastDay:"[\xcd gj\xe1r kl.] LT",lastWeek:"[s\xed\xf0stu] dddd [kl] LT",sameElse:"L"},relativeTime:{future:"um %s",past:"%s s\xed\xf0ani",s:"f\xe1 sekund",ss:"%d sekundir",m:"ein minutt",mm:"%d minuttir",h:"ein t\xedmi",hh:"%d t\xedmar",d:"ein dagur",dd:"%d dagar",M:"ein m\xe1na\xf0i",MM:"%d m\xe1na\xf0ir",y:"eitt \xe1r",yy:"%d \xe1r"},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}}),e.defineLocale("fr-ca",{months:"janvier_f\xe9vrier_mars_avril_mai_juin_juillet_ao\xfbt_septembre_octobre_novembre_d\xe9cembre".split("_"),monthsShort:"janv._f\xe9vr._mars_avr._mai_juin_juil._ao\xfbt_sept._oct._nov._d\xe9c.".split("_"),monthsParseExact:!0,weekdays:"dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi".split("_"),weekdaysShort:"dim._lun._mar._mer._jeu._ven._sam.".split("_"),weekdaysMin:"di_lu_ma_me_je_ve_sa".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"YYYY-MM-DD",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},calendar:{sameDay:"[Aujourd\u2019hui \xe0] LT",nextDay:"[Demain \xe0] LT",nextWeek:"dddd [\xe0] LT",lastDay:"[Hier \xe0] LT",lastWeek:"dddd [dernier \xe0] LT",sameElse:"L"},relativeTime:{future:"dans %s",past:"il y a %s",s:"quelques secondes",ss:"%d secondes",m:"une minute",mm:"%d minutes",h:"une heure",hh:"%d heures",d:"un jour",dd:"%d jours",M:"un mois",MM:"%d mois",y:"un an",yy:"%d ans"},dayOfMonthOrdinalParse:/\d{1,2}(er|e)/,ordinal:function(e,a){switch(a){default:case"M":case"Q":case"D":case"DDD":case"d":return e+(1===e?"er":"e");case"w":case"W":return e+(1===e?"re":"e")}}}),e.defineLocale("fr-ch",{months:"janvier_f\xe9vrier_mars_avril_mai_juin_juillet_ao\xfbt_septembre_octobre_novembre_d\xe9cembre".split("_"),monthsShort:"janv._f\xe9vr._mars_avr._mai_juin_juil._ao\xfbt_sept._oct._nov._d\xe9c.".split("_"),monthsParseExact:!0,weekdays:"dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi".split("_"),weekdaysShort:"dim._lun._mar._mer._jeu._ven._sam.".split("_"),weekdaysMin:"di_lu_ma_me_je_ve_sa".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},calendar:{sameDay:"[Aujourd\u2019hui \xe0] LT",nextDay:"[Demain \xe0] LT",nextWeek:"dddd [\xe0] LT",lastDay:"[Hier \xe0] LT",lastWeek:"dddd [dernier \xe0] LT",sameElse:"L"},relativeTime:{future:"dans %s",past:"il y a %s",s:"quelques secondes",ss:"%d secondes",m:"une minute",mm:"%d minutes",h:"une heure",hh:"%d heures",d:"un jour",dd:"%d jours",M:"un mois",MM:"%d mois",y:"un an",yy:"%d ans"},dayOfMonthOrdinalParse:/\d{1,2}(er|e)/,ordinal:function(e,a){switch(a){default:case"M":case"Q":case"D":case"DDD":case"d":return e+(1===e?"er":"e");case"w":case"W":return e+(1===e?"re":"e")}},week:{dow:1,doy:4}}),e.defineLocale("fr",{months:"janvier_f\xe9vrier_mars_avril_mai_juin_juillet_ao\xfbt_septembre_octobre_novembre_d\xe9cembre".split("_"),monthsShort:"janv._f\xe9vr._mars_avr._mai_juin_juil._ao\xfbt_sept._oct._nov._d\xe9c.".split("_"),monthsParseExact:!0,weekdays:"dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi".split("_"),weekdaysShort:"dim._lun._mar._mer._jeu._ven._sam.".split("_"),weekdaysMin:"di_lu_ma_me_je_ve_sa".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},calendar:{sameDay:"[Aujourd\u2019hui \xe0] LT",nextDay:"[Demain \xe0] LT",nextWeek:"dddd [\xe0] LT",lastDay:"[Hier \xe0] LT",lastWeek:"dddd [dernier \xe0] LT",sameElse:"L"},relativeTime:{future:"dans %s",past:"il y a %s",s:"quelques secondes",ss:"%d secondes",m:"une minute",mm:"%d minutes",h:"une heure",hh:"%d heures",d:"un jour",dd:"%d jours",M:"un mois",MM:"%d mois",y:"un an",yy:"%d ans"},dayOfMonthOrdinalParse:/\d{1,2}(er|)/,ordinal:function(e,a){switch(a){case"D":return e+(1===e?"er":"");default:case"M":case"Q":case"DDD":case"d":return e+(1===e?"er":"e");case"w":case"W":return e+(1===e?"re":"e")}},week:{dow:1,doy:4}});var un="jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.".split("_"),ln="jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des".split("_");e.defineLocale("fy",{months:"jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber".split("_"),monthsShort:function(e,a){return e?/-MMM-/.test(a)?ln[e.month()]:un[e.month()]:un},monthsParseExact:!0,weekdays:"snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon".split("_"),weekdaysShort:"si._mo._ti._wo._to._fr._so.".split("_"),weekdaysMin:"Si_Mo_Ti_Wo_To_Fr_So".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD-MM-YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},calendar:{sameDay:"[hjoed om] LT",nextDay:"[moarn om] LT",nextWeek:"dddd [om] LT",lastDay:"[juster om] LT",lastWeek:"[\xf4fr\xfbne] dddd [om] LT",sameElse:"L"},relativeTime:{future:"oer %s",past:"%s lyn",s:"in pear sekonden",ss:"%d sekonden",m:"ien min\xfat",mm:"%d minuten",h:"ien oere",hh:"%d oeren",d:"ien dei",dd:"%d dagen",M:"ien moanne",MM:"%d moannen",y:"ien jier",yy:"%d jierren"},dayOfMonthOrdinalParse:/\d{1,2}(ste|de)/,ordinal:function(e){return e+(1===e||8===e||e>=20?"ste":"de")},week:{dow:1,doy:4}});e.defineLocale("gd",{months:["Am Faoilleach","An Gearran","Am M\xe0rt","An Giblean","An C\xe8itean","An t-\xd2gmhios","An t-Iuchar","An L\xf9nastal","An t-Sultain","An D\xe0mhair","An t-Samhain","An D\xf9bhlachd"],monthsShort:["Faoi","Gear","M\xe0rt","Gibl","C\xe8it","\xd2gmh","Iuch","L\xf9n","Sult","D\xe0mh","Samh","D\xf9bh"],monthsParseExact:!0,weekdays:["Did\xf2mhnaich","Diluain","Dim\xe0irt","Diciadain","Diardaoin","Dihaoine","Disathairne"],weekdaysShort:["Did","Dil","Dim","Dic","Dia","Dih","Dis"],weekdaysMin:["D\xf2","Lu","M\xe0","Ci","Ar","Ha","Sa"],longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[An-diugh aig] LT",nextDay:"[A-m\xe0ireach aig] LT",nextWeek:"dddd [aig] LT",lastDay:"[An-d\xe8 aig] LT",lastWeek:"dddd [seo chaidh] [aig] LT",sameElse:"L"},relativeTime:{future:"ann an %s",past:"bho chionn %s",s:"beagan diogan",ss:"%d diogan",m:"mionaid",mm:"%d mionaidean",h:"uair",hh:"%d uairean",d:"latha",dd:"%d latha",M:"m\xecos",MM:"%d m\xecosan",y:"bliadhna",yy:"%d bliadhna"},dayOfMonthOrdinalParse:/\d{1,2}(d|na|mh)/,ordinal:function(e){return e+(1===e?"d":e%10==2?"na":"mh")},week:{dow:1,doy:4}}),e.defineLocale("gl",{months:"xaneiro_febreiro_marzo_abril_maio_xu\xf1o_xullo_agosto_setembro_outubro_novembro_decembro".split("_"),monthsShort:"xan._feb._mar._abr._mai._xu\xf1._xul._ago._set._out._nov._dec.".split("_"),monthsParseExact:!0,weekdays:"domingo_luns_martes_m\xe9rcores_xoves_venres_s\xe1bado".split("_"),weekdaysShort:"dom._lun._mar._m\xe9r._xov._ven._s\xe1b.".split("_"),weekdaysMin:"do_lu_ma_m\xe9_xo_ve_s\xe1".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD/MM/YYYY",LL:"D [de] MMMM [de] YYYY",LLL:"D [de] MMMM [de] YYYY H:mm",LLLL:"dddd, D [de] MMMM [de] YYYY H:mm"},calendar:{sameDay:function(){return"[hoxe "+(1!==this.hours()?"\xe1s":"\xe1")+"] LT"},nextDay:function(){return"[ma\xf1\xe1 "+(1!==this.hours()?"\xe1s":"\xe1")+"] LT"},nextWeek:function(){return"dddd ["+(1!==this.hours()?"\xe1s":"a")+"] LT"},lastDay:function(){return"[onte "+(1!==this.hours()?"\xe1":"a")+"] LT"},lastWeek:function(){return"[o] dddd [pasado "+(1!==this.hours()?"\xe1s":"a")+"] LT"},sameElse:"L"},relativeTime:{future:function(e){return 0===e.indexOf("un")?"n"+e:"en "+e},past:"hai %s",s:"uns segundos",ss:"%d segundos",m:"un minuto",mm:"%d minutos",h:"unha hora",hh:"%d horas",d:"un d\xeda",dd:"%d d\xedas",M:"un mes",MM:"%d meses",y:"un ano",yy:"%d anos"},dayOfMonthOrdinalParse:/\d{1,2}\xba/,ordinal:"%d\xba",week:{dow:1,doy:4}}),e.defineLocale("gom-latn",{months:"Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr".split("_"),monthsShort:"Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.".split("_"),monthsParseExact:!0,weekdays:"Aitar_Somar_Mongllar_Budvar_Brestar_Sukrar_Son'var".split("_"),weekdaysShort:"Ait._Som._Mon._Bud._Bre._Suk._Son.".split("_"),weekdaysMin:"Ai_Sm_Mo_Bu_Br_Su_Sn".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"A h:mm [vazta]",LTS:"A h:mm:ss [vazta]",L:"DD-MM-YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY A h:mm [vazta]",LLLL:"dddd, MMMM[achea] Do, YYYY, A h:mm [vazta]",llll:"ddd, D MMM YYYY, A h:mm [vazta]"},calendar:{sameDay:"[Aiz] LT",nextDay:"[Faleam] LT",nextWeek:"[Ieta to] dddd[,] LT",lastDay:"[Kal] LT",lastWeek:"[Fatlo] dddd[,] LT",sameElse:"L"},relativeTime:{future:"%s",past:"%s adim",s:ia,ss:ia,m:ia,mm:ia,h:ia,hh:ia,d:ia,dd:ia,M:ia,MM:ia,y:ia,yy:ia},dayOfMonthOrdinalParse:/\d{1,2}(er)/,ordinal:function(e,a){switch(a){case"D":return e+"er";default:case"M":case"Q":case"DDD":case"d":case"w":case"W":return e}},week:{dow:1,doy:4},meridiemParse:/rati|sokalli|donparam|sanje/,meridiemHour:function(e,a){return 12===e&&(e=0),"rati"===a?e<4?e:e+12:"sokalli"===a?e:"donparam"===a?e>12?e:e+12:"sanje"===a?e+12:void 0},meridiem:function(e,a,t){return e<4?"rati":e<12?"sokalli":e<16?"donparam":e<20?"sanje":"rati"}});var Mn={1:"\u0ae7",2:"\u0ae8",3:"\u0ae9",4:"\u0aea",5:"\u0aeb",6:"\u0aec",7:"\u0aed",8:"\u0aee",9:"\u0aef",0:"\u0ae6"},hn={"\u0ae7":"1","\u0ae8":"2","\u0ae9":"3","\u0aea":"4","\u0aeb":"5","\u0aec":"6","\u0aed":"7","\u0aee":"8","\u0aef":"9","\u0ae6":"0"};e.defineLocale("gu",{months:"\u0a9c\u0abe\u0aa8\u0acd\u0aaf\u0ac1\u0a86\u0ab0\u0ac0_\u0aab\u0ac7\u0aac\u0acd\u0ab0\u0ac1\u0a86\u0ab0\u0ac0_\u0aae\u0abe\u0ab0\u0acd\u0a9a_\u0a8f\u0aaa\u0acd\u0ab0\u0abf\u0ab2_\u0aae\u0ac7_\u0a9c\u0ac2\u0aa8_\u0a9c\u0ac1\u0ab2\u0abe\u0a88_\u0a91\u0a97\u0ab8\u0acd\u0a9f_\u0ab8\u0aaa\u0acd\u0a9f\u0ac7\u0aae\u0acd\u0aac\u0ab0_\u0a91\u0a95\u0acd\u0a9f\u0acd\u0aac\u0ab0_\u0aa8\u0ab5\u0ac7\u0aae\u0acd\u0aac\u0ab0_\u0aa1\u0abf\u0ab8\u0ac7\u0aae\u0acd\u0aac\u0ab0".split("_"),monthsShort:"\u0a9c\u0abe\u0aa8\u0acd\u0aaf\u0ac1._\u0aab\u0ac7\u0aac\u0acd\u0ab0\u0ac1._\u0aae\u0abe\u0ab0\u0acd\u0a9a_\u0a8f\u0aaa\u0acd\u0ab0\u0abf._\u0aae\u0ac7_\u0a9c\u0ac2\u0aa8_\u0a9c\u0ac1\u0ab2\u0abe._\u0a91\u0a97._\u0ab8\u0aaa\u0acd\u0a9f\u0ac7._\u0a91\u0a95\u0acd\u0a9f\u0acd._\u0aa8\u0ab5\u0ac7._\u0aa1\u0abf\u0ab8\u0ac7.".split("_"),monthsParseExact:!0,weekdays:"\u0ab0\u0ab5\u0abf\u0ab5\u0abe\u0ab0_\u0ab8\u0acb\u0aae\u0ab5\u0abe\u0ab0_\u0aae\u0a82\u0a97\u0ab3\u0ab5\u0abe\u0ab0_\u0aac\u0ac1\u0aa7\u0acd\u0ab5\u0abe\u0ab0_\u0a97\u0ac1\u0ab0\u0ac1\u0ab5\u0abe\u0ab0_\u0ab6\u0ac1\u0a95\u0acd\u0ab0\u0ab5\u0abe\u0ab0_\u0ab6\u0aa8\u0abf\u0ab5\u0abe\u0ab0".split("_"),weekdaysShort:"\u0ab0\u0ab5\u0abf_\u0ab8\u0acb\u0aae_\u0aae\u0a82\u0a97\u0ab3_\u0aac\u0ac1\u0aa7\u0acd_\u0a97\u0ac1\u0ab0\u0ac1_\u0ab6\u0ac1\u0a95\u0acd\u0ab0_\u0ab6\u0aa8\u0abf".split("_"),weekdaysMin:"\u0ab0_\u0ab8\u0acb_\u0aae\u0a82_\u0aac\u0ac1_\u0a97\u0ac1_\u0ab6\u0ac1_\u0ab6".split("_"),longDateFormat:{LT:"A h:mm \u0ab5\u0abe\u0a97\u0acd\u0aaf\u0ac7",LTS:"A h:mm:ss \u0ab5\u0abe\u0a97\u0acd\u0aaf\u0ac7",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY, A h:mm \u0ab5\u0abe\u0a97\u0acd\u0aaf\u0ac7",LLLL:"dddd, D MMMM YYYY, A h:mm \u0ab5\u0abe\u0a97\u0acd\u0aaf\u0ac7"},calendar:{sameDay:"[\u0a86\u0a9c] LT",nextDay:"[\u0a95\u0abe\u0ab2\u0ac7] LT",nextWeek:"dddd, LT",lastDay:"[\u0a97\u0a87\u0a95\u0abe\u0ab2\u0ac7] LT",lastWeek:"[\u0aaa\u0abe\u0a9b\u0ab2\u0abe] dddd, LT",sameElse:"L"},relativeTime:{future:"%s \u0aae\u0abe",past:"%s \u0aaa\u0ac7\u0ab9\u0ab2\u0abe",s:"\u0a85\u0aae\u0ac1\u0a95 \u0aaa\u0ab3\u0acb",ss:"%d \u0ab8\u0ac7\u0a95\u0a82\u0aa1",m:"\u0a8f\u0a95 \u0aae\u0abf\u0aa8\u0abf\u0a9f",mm:"%d \u0aae\u0abf\u0aa8\u0abf\u0a9f",h:"\u0a8f\u0a95 \u0a95\u0ab2\u0abe\u0a95",hh:"%d \u0a95\u0ab2\u0abe\u0a95",d:"\u0a8f\u0a95 \u0aa6\u0abf\u0ab5\u0ab8",dd:"%d \u0aa6\u0abf\u0ab5\u0ab8",M:"\u0a8f\u0a95 \u0aae\u0ab9\u0abf\u0aa8\u0acb",MM:"%d \u0aae\u0ab9\u0abf\u0aa8\u0acb",y:"\u0a8f\u0a95 \u0ab5\u0ab0\u0acd\u0ab7",yy:"%d \u0ab5\u0ab0\u0acd\u0ab7"},preparse:function(e){return e.replace(/[\u0ae7\u0ae8\u0ae9\u0aea\u0aeb\u0aec\u0aed\u0aee\u0aef\u0ae6]/g,function(e){return hn[e]})},postformat:function(e){return e.replace(/\d/g,function(e){return Mn[e]})},meridiemParse:/\u0ab0\u0abe\u0aa4|\u0aac\u0aaa\u0acb\u0ab0|\u0ab8\u0ab5\u0abe\u0ab0|\u0ab8\u0abe\u0a82\u0a9c/,meridiemHour:function(e,a){return 12===e&&(e=0),"\u0ab0\u0abe\u0aa4"===a?e<4?e:e+12:"\u0ab8\u0ab5\u0abe\u0ab0"===a?e:"\u0aac\u0aaa\u0acb\u0ab0"===a?e>=10?e:e+12:"\u0ab8\u0abe\u0a82\u0a9c"===a?e+12:void 0},meridiem:function(e,a,t){return e<4?"\u0ab0\u0abe\u0aa4":e<10?"\u0ab8\u0ab5\u0abe\u0ab0":e<17?"\u0aac\u0aaa\u0acb\u0ab0":e<20?"\u0ab8\u0abe\u0a82\u0a9c":"\u0ab0\u0abe\u0aa4"},week:{dow:0,doy:6}}),e.defineLocale("he",{months:"\u05d9\u05e0\u05d5\u05d0\u05e8_\u05e4\u05d1\u05e8\u05d5\u05d0\u05e8_\u05de\u05e8\u05e5_\u05d0\u05e4\u05e8\u05d9\u05dc_\u05de\u05d0\u05d9_\u05d9\u05d5\u05e0\u05d9_\u05d9\u05d5\u05dc\u05d9_\u05d0\u05d5\u05d2\u05d5\u05e1\u05d8_\u05e1\u05e4\u05d8\u05de\u05d1\u05e8_\u05d0\u05d5\u05e7\u05d8\u05d5\u05d1\u05e8_\u05e0\u05d5\u05d1\u05de\u05d1\u05e8_\u05d3\u05e6\u05de\u05d1\u05e8".split("_"),monthsShort:"\u05d9\u05e0\u05d5\u05f3_\u05e4\u05d1\u05e8\u05f3_\u05de\u05e8\u05e5_\u05d0\u05e4\u05e8\u05f3_\u05de\u05d0\u05d9_\u05d9\u05d5\u05e0\u05d9_\u05d9\u05d5\u05dc\u05d9_\u05d0\u05d5\u05d2\u05f3_\u05e1\u05e4\u05d8\u05f3_\u05d0\u05d5\u05e7\u05f3_\u05e0\u05d5\u05d1\u05f3_\u05d3\u05e6\u05de\u05f3".split("_"),weekdays:"\u05e8\u05d0\u05e9\u05d5\u05df_\u05e9\u05e0\u05d9_\u05e9\u05dc\u05d9\u05e9\u05d9_\u05e8\u05d1\u05d9\u05e2\u05d9_\u05d7\u05de\u05d9\u05e9\u05d9_\u05e9\u05d9\u05e9\u05d9_\u05e9\u05d1\u05ea".split("_"),weekdaysShort:"\u05d0\u05f3_\u05d1\u05f3_\u05d2\u05f3_\u05d3\u05f3_\u05d4\u05f3_\u05d5\u05f3_\u05e9\u05f3".split("_"),weekdaysMin:"\u05d0_\u05d1_\u05d2_\u05d3_\u05d4_\u05d5_\u05e9".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D [\u05d1]MMMM YYYY",LLL:"D [\u05d1]MMMM YYYY HH:mm",LLLL:"dddd, D [\u05d1]MMMM YYYY HH:mm",l:"D/M/YYYY",ll:"D MMM YYYY",lll:"D MMM YYYY HH:mm",llll:"ddd, D MMM YYYY HH:mm"},calendar:{sameDay:"[\u05d4\u05d9\u05d5\u05dd \u05d1\u05be]LT",nextDay:"[\u05de\u05d7\u05e8 \u05d1\u05be]LT",nextWeek:"dddd [\u05d1\u05e9\u05e2\u05d4] LT",lastDay:"[\u05d0\u05ea\u05de\u05d5\u05dc \u05d1\u05be]LT",lastWeek:"[\u05d1\u05d9\u05d5\u05dd] dddd [\u05d4\u05d0\u05d7\u05e8\u05d5\u05df \u05d1\u05e9\u05e2\u05d4] LT",sameElse:"L"},relativeTime:{future:"\u05d1\u05e2\u05d5\u05d3 %s",past:"\u05dc\u05e4\u05e0\u05d9 %s",s:"\u05de\u05e1\u05e4\u05e8 \u05e9\u05e0\u05d9\u05d5\u05ea",ss:"%d \u05e9\u05e0\u05d9\u05d5\u05ea",m:"\u05d3\u05e7\u05d4",mm:"%d \u05d3\u05e7\u05d5\u05ea",h:"\u05e9\u05e2\u05d4",hh:function(e){return 2===e?"\u05e9\u05e2\u05ea\u05d9\u05d9\u05dd":e+" \u05e9\u05e2\u05d5\u05ea"},d:"\u05d9\u05d5\u05dd",dd:function(e){return 2===e?"\u05d9\u05d5\u05de\u05d9\u05d9\u05dd":e+" \u05d9\u05de\u05d9\u05dd"},M:"\u05d7\u05d5\u05d3\u05e9",MM:function(e){return 2===e?"\u05d7\u05d5\u05d3\u05e9\u05d9\u05d9\u05dd":e+" \u05d7\u05d5\u05d3\u05e9\u05d9\u05dd"},y:"\u05e9\u05e0\u05d4",yy:function(e){return 2===e?"\u05e9\u05e0\u05ea\u05d9\u05d9\u05dd":e%10==0&&10!==e?e+" \u05e9\u05e0\u05d4":e+" \u05e9\u05e0\u05d9\u05dd"}},meridiemParse:/\u05d0\u05d7\u05d4"\u05e6|\u05dc\u05e4\u05e0\u05d4"\u05e6|\u05d0\u05d7\u05e8\u05d9 \u05d4\u05e6\u05d4\u05e8\u05d9\u05d9\u05dd|\u05dc\u05e4\u05e0\u05d9 \u05d4\u05e6\u05d4\u05e8\u05d9\u05d9\u05dd|\u05dc\u05e4\u05e0\u05d5\u05ea \u05d1\u05d5\u05e7\u05e8|\u05d1\u05d1\u05d5\u05e7\u05e8|\u05d1\u05e2\u05e8\u05d1/i,isPM:function(e){return/^(\u05d0\u05d7\u05d4"\u05e6|\u05d0\u05d7\u05e8\u05d9 \u05d4\u05e6\u05d4\u05e8\u05d9\u05d9\u05dd|\u05d1\u05e2\u05e8\u05d1)$/.test(e)},meridiem:function(e,a,t){return e<5?"\u05dc\u05e4\u05e0\u05d5\u05ea \u05d1\u05d5\u05e7\u05e8":e<10?"\u05d1\u05d1\u05d5\u05e7\u05e8":e<12?t?'\u05dc\u05e4\u05e0\u05d4"\u05e6':"\u05dc\u05e4\u05e0\u05d9 \u05d4\u05e6\u05d4\u05e8\u05d9\u05d9\u05dd":e<18?t?'\u05d0\u05d7\u05d4"\u05e6':"\u05d0\u05d7\u05e8\u05d9 \u05d4\u05e6\u05d4\u05e8\u05d9\u05d9\u05dd":"\u05d1\u05e2\u05e8\u05d1"}});var Ln={1:"\u0967",2:"\u0968",3:"\u0969",4:"\u096a",5:"\u096b",6:"\u096c",7:"\u096d",8:"\u096e",9:"\u096f",0:"\u0966"},cn={"\u0967":"1","\u0968":"2","\u0969":"3","\u096a":"4","\u096b":"5","\u096c":"6","\u096d":"7","\u096e":"8","\u096f":"9","\u0966":"0"};e.defineLocale("hi",{months:"\u091c\u0928\u0935\u0930\u0940_\u092b\u093c\u0930\u0935\u0930\u0940_\u092e\u093e\u0930\u094d\u091a_\u0905\u092a\u094d\u0930\u0948\u0932_\u092e\u0908_\u091c\u0942\u0928_\u091c\u0941\u0932\u093e\u0908_\u0905\u0917\u0938\u094d\u0924_\u0938\u093f\u0924\u092e\u094d\u092c\u0930_\u0905\u0915\u094d\u091f\u0942\u092c\u0930_\u0928\u0935\u092e\u094d\u092c\u0930_\u0926\u093f\u0938\u092e\u094d\u092c\u0930".split("_"),monthsShort:"\u091c\u0928._\u092b\u093c\u0930._\u092e\u093e\u0930\u094d\u091a_\u0905\u092a\u094d\u0930\u0948._\u092e\u0908_\u091c\u0942\u0928_\u091c\u0941\u0932._\u0905\u0917._\u0938\u093f\u0924._\u0905\u0915\u094d\u091f\u0942._\u0928\u0935._\u0926\u093f\u0938.".split("_"),monthsParseExact:!0,weekdays:"\u0930\u0935\u093f\u0935\u093e\u0930_\u0938\u094b\u092e\u0935\u093e\u0930_\u092e\u0902\u0917\u0932\u0935\u093e\u0930_\u092c\u0941\u0927\u0935\u093e\u0930_\u0917\u0941\u0930\u0942\u0935\u093e\u0930_\u0936\u0941\u0915\u094d\u0930\u0935\u093e\u0930_\u0936\u0928\u093f\u0935\u093e\u0930".split("_"),weekdaysShort:"\u0930\u0935\u093f_\u0938\u094b\u092e_\u092e\u0902\u0917\u0932_\u092c\u0941\u0927_\u0917\u0941\u0930\u0942_\u0936\u0941\u0915\u094d\u0930_\u0936\u0928\u093f".split("_"),weekdaysMin:"\u0930_\u0938\u094b_\u092e\u0902_\u092c\u0941_\u0917\u0941_\u0936\u0941_\u0936".split("_"),longDateFormat:{LT:"A h:mm \u092c\u091c\u0947",LTS:"A h:mm:ss \u092c\u091c\u0947",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY, A h:mm \u092c\u091c\u0947",LLLL:"dddd, D MMMM YYYY, A h:mm \u092c\u091c\u0947"},calendar:{sameDay:"[\u0906\u091c] LT",nextDay:"[\u0915\u0932] LT",nextWeek:"dddd, LT",lastDay:"[\u0915\u0932] LT",lastWeek:"[\u092a\u093f\u091b\u0932\u0947] dddd, LT",sameElse:"L"},relativeTime:{future:"%s \u092e\u0947\u0902",past:"%s \u092a\u0939\u0932\u0947",s:"\u0915\u0941\u091b \u0939\u0940 \u0915\u094d\u0937\u0923",ss:"%d \u0938\u0947\u0915\u0902\u0921",m:"\u090f\u0915 \u092e\u093f\u0928\u091f",mm:"%d \u092e\u093f\u0928\u091f",h:"\u090f\u0915 \u0918\u0902\u091f\u093e",hh:"%d \u0918\u0902\u091f\u0947",d:"\u090f\u0915 \u0926\u093f\u0928",dd:"%d \u0926\u093f\u0928",M:"\u090f\u0915 \u092e\u0939\u0940\u0928\u0947",MM:"%d \u092e\u0939\u0940\u0928\u0947",y:"\u090f\u0915 \u0935\u0930\u094d\u0937",yy:"%d \u0935\u0930\u094d\u0937"},preparse:function(e){return e.replace(/[\u0967\u0968\u0969\u096a\u096b\u096c\u096d\u096e\u096f\u0966]/g,function(e){return cn[e]})},postformat:function(e){return e.replace(/\d/g,function(e){return Ln[e]})},meridiemParse:/\u0930\u093e\u0924|\u0938\u0941\u092c\u0939|\u0926\u094b\u092a\u0939\u0930|\u0936\u093e\u092e/,meridiemHour:function(e,a){return 12===e&&(e=0),"\u0930\u093e\u0924"===a?e<4?e:e+12:"\u0938\u0941\u092c\u0939"===a?e:"\u0926\u094b\u092a\u0939\u0930"===a?e>=10?e:e+12:"\u0936\u093e\u092e"===a?e+12:void 0},meridiem:function(e,a,t){return e<4?"\u0930\u093e\u0924":e<10?"\u0938\u0941\u092c\u0939":e<17?"\u0926\u094b\u092a\u0939\u0930":e<20?"\u0936\u093e\u092e":"\u0930\u093e\u0924"},week:{dow:0,doy:6}}),e.defineLocale("hr",{months:{format:"sije\u010dnja_velja\u010de_o\u017eujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca".split("_"),standalone:"sije\u010danj_velja\u010da_o\u017eujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac".split("_")},monthsShort:"sij._velj._o\u017eu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.".split("_"),monthsParseExact:!0,weekdays:"nedjelja_ponedjeljak_utorak_srijeda_\u010detvrtak_petak_subota".split("_"),weekdaysShort:"ned._pon._uto._sri._\u010det._pet._sub.".split("_"),weekdaysMin:"ne_po_ut_sr_\u010de_pe_su".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY H:mm",LLLL:"dddd, D. MMMM YYYY H:mm"},calendar:{sameDay:"[danas u] LT",nextDay:"[sutra u] LT",nextWeek:function(){switch(this.day()){case 0:return"[u] [nedjelju] [u] LT";case 3:return"[u] [srijedu] [u] LT";case 6:return"[u] [subotu] [u] LT";case 1:case 2:case 4:case 5:return"[u] dddd [u] LT"}},lastDay:"[ju\u010der u] LT",lastWeek:function(){switch(this.day()){case 0:case 3:return"[pro\u0161lu] dddd [u] LT";case 6:return"[pro\u0161le] [subote] [u] LT";case 1:case 2:case 4:case 5:return"[pro\u0161li] dddd [u] LT"}},sameElse:"L"},relativeTime:{future:"za %s",past:"prije %s",s:"par sekundi",ss:oa,m:oa,mm:oa,h:oa,hh:oa,d:"dan",dd:oa,M:"mjesec",MM:oa,y:"godinu",yy:oa},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:7}});var Yn="vas\xe1rnap h\xe9tf\u0151n kedden szerd\xe1n cs\xfct\xf6rt\xf6k\xf6n p\xe9nteken szombaton".split(" ");e.defineLocale("hu",{months:"janu\xe1r_febru\xe1r_m\xe1rcius_\xe1prilis_m\xe1jus_j\xfanius_j\xfalius_augusztus_szeptember_okt\xf3ber_november_december".split("_"),monthsShort:"jan_feb_m\xe1rc_\xe1pr_m\xe1j_j\xfan_j\xfal_aug_szept_okt_nov_dec".split("_"),weekdays:"vas\xe1rnap_h\xe9tf\u0151_kedd_szerda_cs\xfct\xf6rt\xf6k_p\xe9ntek_szombat".split("_"),weekdaysShort:"vas_h\xe9t_kedd_sze_cs\xfct_p\xe9n_szo".split("_"),weekdaysMin:"v_h_k_sze_cs_p_szo".split("_"),longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"YYYY.MM.DD.",LL:"YYYY. MMMM D.",LLL:"YYYY. MMMM D. H:mm",LLLL:"YYYY. MMMM D., dddd H:mm"},meridiemParse:/de|du/i,isPM:function(e){return"u"===e.charAt(1).toLowerCase()},meridiem:function(e,a,t){return e<12?!0===t?"de":"DE":!0===t?"du":"DU"},calendar:{sameDay:"[ma] LT[-kor]",nextDay:"[holnap] LT[-kor]",nextWeek:function(){return ua.call(this,!0)},lastDay:"[tegnap] LT[-kor]",lastWeek:function(){return ua.call(this,!1)},sameElse:"L"},relativeTime:{future:"%s m\xfalva",past:"%s",s:ma,ss:ma,m:ma,mm:ma,h:ma,hh:ma,d:ma,dd:ma,M:ma,MM:ma,y:ma,yy:ma},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}}),e.defineLocale("hy-am",{months:{format:"\u0570\u0578\u0582\u0576\u057e\u0561\u0580\u056b_\u0583\u0565\u057f\u0580\u057e\u0561\u0580\u056b_\u0574\u0561\u0580\u057f\u056b_\u0561\u057a\u0580\u056b\u056c\u056b_\u0574\u0561\u0575\u056b\u057d\u056b_\u0570\u0578\u0582\u0576\u056b\u057d\u056b_\u0570\u0578\u0582\u056c\u056b\u057d\u056b_\u0585\u0563\u0578\u057d\u057f\u0578\u057d\u056b_\u057d\u0565\u057a\u057f\u0565\u0574\u0562\u0565\u0580\u056b_\u0570\u0578\u056f\u057f\u0565\u0574\u0562\u0565\u0580\u056b_\u0576\u0578\u0575\u0565\u0574\u0562\u0565\u0580\u056b_\u0564\u0565\u056f\u057f\u0565\u0574\u0562\u0565\u0580\u056b".split("_"),standalone:"\u0570\u0578\u0582\u0576\u057e\u0561\u0580_\u0583\u0565\u057f\u0580\u057e\u0561\u0580_\u0574\u0561\u0580\u057f_\u0561\u057a\u0580\u056b\u056c_\u0574\u0561\u0575\u056b\u057d_\u0570\u0578\u0582\u0576\u056b\u057d_\u0570\u0578\u0582\u056c\u056b\u057d_\u0585\u0563\u0578\u057d\u057f\u0578\u057d_\u057d\u0565\u057a\u057f\u0565\u0574\u0562\u0565\u0580_\u0570\u0578\u056f\u057f\u0565\u0574\u0562\u0565\u0580_\u0576\u0578\u0575\u0565\u0574\u0562\u0565\u0580_\u0564\u0565\u056f\u057f\u0565\u0574\u0562\u0565\u0580".split("_")},monthsShort:"\u0570\u0576\u057e_\u0583\u057f\u0580_\u0574\u0580\u057f_\u0561\u057a\u0580_\u0574\u0575\u057d_\u0570\u0576\u057d_\u0570\u056c\u057d_\u0585\u0563\u057d_\u057d\u057a\u057f_\u0570\u056f\u057f_\u0576\u0574\u0562_\u0564\u056f\u057f".split("_"),weekdays:"\u056f\u056b\u0580\u0561\u056f\u056b_\u0565\u0580\u056f\u0578\u0582\u0577\u0561\u0562\u0569\u056b_\u0565\u0580\u0565\u0584\u0577\u0561\u0562\u0569\u056b_\u0579\u0578\u0580\u0565\u0584\u0577\u0561\u0562\u0569\u056b_\u0570\u056b\u0576\u0563\u0577\u0561\u0562\u0569\u056b_\u0578\u0582\u0580\u0562\u0561\u0569_\u0577\u0561\u0562\u0561\u0569".split("_"),weekdaysShort:"\u056f\u0580\u056f_\u0565\u0580\u056f_\u0565\u0580\u0584_\u0579\u0580\u0584_\u0570\u0576\u0563_\u0578\u0582\u0580\u0562_\u0577\u0562\u0569".split("_"),weekdaysMin:"\u056f\u0580\u056f_\u0565\u0580\u056f_\u0565\u0580\u0584_\u0579\u0580\u0584_\u0570\u0576\u0563_\u0578\u0582\u0580\u0562_\u0577\u0562\u0569".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D MMMM YYYY \u0569.",LLL:"D MMMM YYYY \u0569., HH:mm",LLLL:"dddd, D MMMM YYYY \u0569., HH:mm"},calendar:{sameDay:"[\u0561\u0575\u057d\u0585\u0580] LT",nextDay:"[\u057e\u0561\u0572\u0568] LT",lastDay:"[\u0565\u0580\u0565\u056f] LT",nextWeek:function(){return"dddd [\u0585\u0580\u0568 \u056a\u0561\u0574\u0568] LT"},lastWeek:function(){return"[\u0561\u0576\u0581\u0561\u056e] dddd [\u0585\u0580\u0568 \u056a\u0561\u0574\u0568] LT"},sameElse:"L"},relativeTime:{future:"%s \u0570\u0565\u057f\u0578",past:"%s \u0561\u057c\u0561\u057b",s:"\u0574\u056b \u0584\u0561\u0576\u056b \u057e\u0561\u0575\u0580\u056f\u0575\u0561\u0576",ss:"%d \u057e\u0561\u0575\u0580\u056f\u0575\u0561\u0576",m:"\u0580\u0578\u057a\u0565",mm:"%d \u0580\u0578\u057a\u0565",h:"\u056a\u0561\u0574",hh:"%d \u056a\u0561\u0574",d:"\u0585\u0580",dd:"%d \u0585\u0580",M:"\u0561\u0574\u056b\u057d",MM:"%d \u0561\u0574\u056b\u057d",y:"\u057f\u0561\u0580\u056b",yy:"%d \u057f\u0561\u0580\u056b"},meridiemParse:/\u0563\u056b\u0577\u0565\u0580\u057e\u0561|\u0561\u057c\u0561\u057e\u0578\u057f\u057e\u0561|\u0581\u0565\u0580\u0565\u056f\u057e\u0561|\u0565\u0580\u0565\u056f\u0578\u0575\u0561\u0576/,isPM:function(e){return/^(\u0581\u0565\u0580\u0565\u056f\u057e\u0561|\u0565\u0580\u0565\u056f\u0578\u0575\u0561\u0576)$/.test(e)},meridiem:function(e){return e<4?"\u0563\u056b\u0577\u0565\u0580\u057e\u0561":e<12?"\u0561\u057c\u0561\u057e\u0578\u057f\u057e\u0561":e<17?"\u0581\u0565\u0580\u0565\u056f\u057e\u0561":"\u0565\u0580\u0565\u056f\u0578\u0575\u0561\u0576"},dayOfMonthOrdinalParse:/\d{1,2}|\d{1,2}-(\u056b\u0576|\u0580\u0564)/,ordinal:function(e,a){switch(a){case"DDD":case"w":case"W":case"DDDo":return 1===e?e+"-\u056b\u0576":e+"-\u0580\u0564";default:return e}},week:{dow:1,doy:7}}),e.defineLocale("id",{months:"Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember".split("_"),monthsShort:"Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nov_Des".split("_"),weekdays:"Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu".split("_"),weekdaysShort:"Min_Sen_Sel_Rab_Kam_Jum_Sab".split("_"),weekdaysMin:"Mg_Sn_Sl_Rb_Km_Jm_Sb".split("_"),longDateFormat:{LT:"HH.mm",LTS:"HH.mm.ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY [pukul] HH.mm",LLLL:"dddd, D MMMM YYYY [pukul] HH.mm"},meridiemParse:/pagi|siang|sore|malam/,meridiemHour:function(e,a){return 12===e&&(e=0),"pagi"===a?e:"siang"===a?e>=11?e:e+12:"sore"===a||"malam"===a?e+12:void 0},meridiem:function(e,a,t){return e<11?"pagi":e<15?"siang":e<19?"sore":"malam"},calendar:{sameDay:"[Hari ini pukul] LT",nextDay:"[Besok pukul] LT",nextWeek:"dddd [pukul] LT",lastDay:"[Kemarin pukul] LT",lastWeek:"dddd [lalu pukul] LT",sameElse:"L"},relativeTime:{future:"dalam %s",past:"%s yang lalu",s:"beberapa detik",ss:"%d detik",m:"semenit",mm:"%d menit",h:"sejam",hh:"%d jam",d:"sehari",dd:"%d hari",M:"sebulan",MM:"%d bulan",y:"setahun",yy:"%d tahun"},week:{dow:1,doy:7}}),e.defineLocale("is",{months:"jan\xfaar_febr\xfaar_mars_apr\xedl_ma\xed_j\xfan\xed_j\xfal\xed_\xe1g\xfast_september_okt\xf3ber_n\xf3vember_desember".split("_"),monthsShort:"jan_feb_mar_apr_ma\xed_j\xfan_j\xfal_\xe1g\xfa_sep_okt_n\xf3v_des".split("_"),weekdays:"sunnudagur_m\xe1nudagur_\xferi\xf0judagur_mi\xf0vikudagur_fimmtudagur_f\xf6studagur_laugardagur".split("_"),weekdaysShort:"sun_m\xe1n_\xferi_mi\xf0_fim_f\xf6s_lau".split("_"),weekdaysMin:"Su_M\xe1_\xder_Mi_Fi_F\xf6_La".split("_"),longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY [kl.] H:mm",LLLL:"dddd, D. MMMM YYYY [kl.] H:mm"},calendar:{sameDay:"[\xed dag kl.] LT",nextDay:"[\xe1 morgun kl.] LT",nextWeek:"dddd [kl.] LT",lastDay:"[\xed g\xe6r kl.] LT",lastWeek:"[s\xed\xf0asta] dddd [kl.] LT",sameElse:"L"},relativeTime:{future:"eftir %s",past:"fyrir %s s\xed\xf0an",s:Ma,ss:Ma,m:Ma,mm:Ma,h:"klukkustund",hh:Ma,d:Ma,dd:Ma,M:Ma,MM:Ma,y:Ma,yy:Ma},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}}),e.defineLocale("it",{months:"gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre".split("_"),monthsShort:"gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic".split("_"),weekdays:"domenica_luned\xec_marted\xec_mercoled\xec_gioved\xec_venerd\xec_sabato".split("_"),weekdaysShort:"dom_lun_mar_mer_gio_ven_sab".split("_"),weekdaysMin:"do_lu_ma_me_gi_ve_sa".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},calendar:{sameDay:"[Oggi alle] LT",nextDay:"[Domani alle] LT",nextWeek:"dddd [alle] LT",lastDay:"[Ieri alle] LT",lastWeek:function(){switch(this.day()){case 0:return"[la scorsa] dddd [alle] LT";default:return"[lo scorso] dddd [alle] LT"}},sameElse:"L"},relativeTime:{future:function(e){return(/^[0-9].+$/.test(e)?"tra":"in")+" "+e},past:"%s fa",s:"alcuni secondi",ss:"%d secondi",m:"un minuto",mm:"%d minuti",h:"un'ora",hh:"%d ore",d:"un giorno",dd:"%d giorni",M:"un mese",MM:"%d mesi",y:"un anno",yy:"%d anni"},dayOfMonthOrdinalParse:/\d{1,2}\xba/,ordinal:"%d\xba",week:{dow:1,doy:4}}),e.defineLocale("ja",{months:"1\u6708_2\u6708_3\u6708_4\u6708_5\u6708_6\u6708_7\u6708_8\u6708_9\u6708_10\u6708_11\u6708_12\u6708".split("_"),monthsShort:"1\u6708_2\u6708_3\u6708_4\u6708_5\u6708_6\u6708_7\u6708_8\u6708_9\u6708_10\u6708_11\u6708_12\u6708".split("_"),weekdays:"\u65e5\u66dc\u65e5_\u6708\u66dc\u65e5_\u706b\u66dc\u65e5_\u6c34\u66dc\u65e5_\u6728\u66dc\u65e5_\u91d1\u66dc\u65e5_\u571f\u66dc\u65e5".split("_"),weekdaysShort:"\u65e5_\u6708_\u706b_\u6c34_\u6728_\u91d1_\u571f".split("_"),weekdaysMin:"\u65e5_\u6708_\u706b_\u6c34_\u6728_\u91d1_\u571f".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"YYYY/MM/DD",LL:"YYYY\u5e74M\u6708D\u65e5",LLL:"YYYY\u5e74M\u6708D\u65e5 HH:mm",LLLL:"YYYY\u5e74M\u6708D\u65e5 HH:mm dddd",l:"YYYY/MM/DD",ll:"YYYY\u5e74M\u6708D\u65e5",lll:"YYYY\u5e74M\u6708D\u65e5 HH:mm",llll:"YYYY\u5e74M\u6708D\u65e5 HH:mm dddd"},meridiemParse:/\u5348\u524d|\u5348\u5f8c/i,isPM:function(e){return"\u5348\u5f8c"===e},meridiem:function(e,a,t){return e<12?"\u5348\u524d":"\u5348\u5f8c"},calendar:{sameDay:"[\u4eca\u65e5] LT",nextDay:"[\u660e\u65e5] LT",nextWeek:"[\u6765\u9031]dddd LT",lastDay:"[\u6628\u65e5] LT",lastWeek:"[\u524d\u9031]dddd LT",sameElse:"L"},dayOfMonthOrdinalParse:/\d{1,2}\u65e5/,ordinal:function(e,a){switch(a){case"d":case"D":case"DDD":return e+"\u65e5";default:return e}},relativeTime:{future:"%s\u5f8c",past:"%s\u524d",s:"\u6570\u79d2",ss:"%d\u79d2",m:"1\u5206",mm:"%d\u5206",h:"1\u6642\u9593",hh:"%d\u6642\u9593",d:"1\u65e5",dd:"%d\u65e5",M:"1\u30f6\u6708",MM:"%d\u30f6\u6708",y:"1\u5e74",yy:"%d\u5e74"}}),e.defineLocale("jv",{months:"Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember".split("_"),monthsShort:"Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des".split("_"),weekdays:"Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu".split("_"),weekdaysShort:"Min_Sen_Sel_Reb_Kem_Jem_Sep".split("_"),weekdaysMin:"Mg_Sn_Sl_Rb_Km_Jm_Sp".split("_"),longDateFormat:{LT:"HH.mm",LTS:"HH.mm.ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY [pukul] HH.mm",LLLL:"dddd, D MMMM YYYY [pukul] HH.mm"},meridiemParse:/enjing|siyang|sonten|ndalu/,meridiemHour:function(e,a){return 12===e&&(e=0),"enjing"===a?e:"siyang"===a?e>=11?e:e+12:"sonten"===a||"ndalu"===a?e+12:void 0},meridiem:function(e,a,t){return e<11?"enjing":e<15?"siyang":e<19?"sonten":"ndalu"},calendar:{sameDay:"[Dinten puniko pukul] LT",nextDay:"[Mbenjang pukul] LT",nextWeek:"dddd [pukul] LT",lastDay:"[Kala wingi pukul] LT",lastWeek:"dddd [kepengker pukul] LT",sameElse:"L"},relativeTime:{future:"wonten ing %s",past:"%s ingkang kepengker",s:"sawetawis detik",ss:"%d detik",m:"setunggal menit",mm:"%d menit",h:"setunggal jam",hh:"%d jam",d:"sedinten",dd:"%d dinten",M:"sewulan",MM:"%d wulan",y:"setaun",yy:"%d taun"},week:{dow:1,doy:7}}),e.defineLocale("ka",{months:{standalone:"\u10d8\u10d0\u10dc\u10d5\u10d0\u10e0\u10d8_\u10d7\u10d4\u10d1\u10d4\u10e0\u10d5\u10d0\u10da\u10d8_\u10db\u10d0\u10e0\u10e2\u10d8_\u10d0\u10de\u10e0\u10d8\u10da\u10d8_\u10db\u10d0\u10d8\u10e1\u10d8_\u10d8\u10d5\u10dc\u10d8\u10e1\u10d8_\u10d8\u10d5\u10da\u10d8\u10e1\u10d8_\u10d0\u10d2\u10d5\u10d8\u10e1\u10e2\u10dd_\u10e1\u10d4\u10e5\u10e2\u10d4\u10db\u10d1\u10d4\u10e0\u10d8_\u10dd\u10e5\u10e2\u10dd\u10db\u10d1\u10d4\u10e0\u10d8_\u10dc\u10dd\u10d4\u10db\u10d1\u10d4\u10e0\u10d8_\u10d3\u10d4\u10d9\u10d4\u10db\u10d1\u10d4\u10e0\u10d8".split("_"),format:"\u10d8\u10d0\u10dc\u10d5\u10d0\u10e0\u10e1_\u10d7\u10d4\u10d1\u10d4\u10e0\u10d5\u10d0\u10da\u10e1_\u10db\u10d0\u10e0\u10e2\u10e1_\u10d0\u10de\u10e0\u10d8\u10da\u10d8\u10e1_\u10db\u10d0\u10d8\u10e1\u10e1_\u10d8\u10d5\u10dc\u10d8\u10e1\u10e1_\u10d8\u10d5\u10da\u10d8\u10e1\u10e1_\u10d0\u10d2\u10d5\u10d8\u10e1\u10e2\u10e1_\u10e1\u10d4\u10e5\u10e2\u10d4\u10db\u10d1\u10d4\u10e0\u10e1_\u10dd\u10e5\u10e2\u10dd\u10db\u10d1\u10d4\u10e0\u10e1_\u10dc\u10dd\u10d4\u10db\u10d1\u10d4\u10e0\u10e1_\u10d3\u10d4\u10d9\u10d4\u10db\u10d1\u10d4\u10e0\u10e1".split("_")},monthsShort:"\u10d8\u10d0\u10dc_\u10d7\u10d4\u10d1_\u10db\u10d0\u10e0_\u10d0\u10de\u10e0_\u10db\u10d0\u10d8_\u10d8\u10d5\u10dc_\u10d8\u10d5\u10da_\u10d0\u10d2\u10d5_\u10e1\u10d4\u10e5_\u10dd\u10e5\u10e2_\u10dc\u10dd\u10d4_\u10d3\u10d4\u10d9".split("_"),weekdays:{standalone:"\u10d9\u10d5\u10d8\u10e0\u10d0_\u10dd\u10e0\u10e8\u10d0\u10d1\u10d0\u10d7\u10d8_\u10e1\u10d0\u10db\u10e8\u10d0\u10d1\u10d0\u10d7\u10d8_\u10dd\u10d7\u10ee\u10e8\u10d0\u10d1\u10d0\u10d7\u10d8_\u10ee\u10e3\u10d7\u10e8\u10d0\u10d1\u10d0\u10d7\u10d8_\u10de\u10d0\u10e0\u10d0\u10e1\u10d9\u10d4\u10d5\u10d8_\u10e8\u10d0\u10d1\u10d0\u10d7\u10d8".split("_"),format:"\u10d9\u10d5\u10d8\u10e0\u10d0\u10e1_\u10dd\u10e0\u10e8\u10d0\u10d1\u10d0\u10d7\u10e1_\u10e1\u10d0\u10db\u10e8\u10d0\u10d1\u10d0\u10d7\u10e1_\u10dd\u10d7\u10ee\u10e8\u10d0\u10d1\u10d0\u10d7\u10e1_\u10ee\u10e3\u10d7\u10e8\u10d0\u10d1\u10d0\u10d7\u10e1_\u10de\u10d0\u10e0\u10d0\u10e1\u10d9\u10d4\u10d5\u10e1_\u10e8\u10d0\u10d1\u10d0\u10d7\u10e1".split("_"),isFormat:/(\u10ec\u10d8\u10dc\u10d0|\u10e8\u10d4\u10db\u10d3\u10d4\u10d2)/},weekdaysShort:"\u10d9\u10d5\u10d8_\u10dd\u10e0\u10e8_\u10e1\u10d0\u10db_\u10dd\u10d7\u10ee_\u10ee\u10e3\u10d7_\u10de\u10d0\u10e0_\u10e8\u10d0\u10d1".split("_"),weekdaysMin:"\u10d9\u10d5_\u10dd\u10e0_\u10e1\u10d0_\u10dd\u10d7_\u10ee\u10e3_\u10de\u10d0_\u10e8\u10d0".split("_"),longDateFormat:{LT:"h:mm A",LTS:"h:mm:ss A",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY h:mm A",LLLL:"dddd, D MMMM YYYY h:mm A"},calendar:{sameDay:"[\u10d3\u10e6\u10d4\u10e1] LT[-\u10d6\u10d4]",nextDay:"[\u10ee\u10d5\u10d0\u10da] LT[-\u10d6\u10d4]",lastDay:"[\u10d2\u10e3\u10e8\u10d8\u10dc] LT[-\u10d6\u10d4]",nextWeek:"[\u10e8\u10d4\u10db\u10d3\u10d4\u10d2] dddd LT[-\u10d6\u10d4]",lastWeek:"[\u10ec\u10d8\u10dc\u10d0] dddd LT-\u10d6\u10d4",sameElse:"L"},relativeTime:{future:function(e){return/(\u10ec\u10d0\u10db\u10d8|\u10ec\u10e3\u10d7\u10d8|\u10e1\u10d0\u10d0\u10d7\u10d8|\u10ec\u10d4\u10da\u10d8)/.test(e)?e.replace(/\u10d8$/,"\u10e8\u10d8"):e+"\u10e8\u10d8"},past:function(e){return/(\u10ec\u10d0\u10db\u10d8|\u10ec\u10e3\u10d7\u10d8|\u10e1\u10d0\u10d0\u10d7\u10d8|\u10d3\u10e6\u10d4|\u10d7\u10d5\u10d4)/.test(e)?e.replace(/(\u10d8|\u10d4)$/,"\u10d8\u10e1 \u10e3\u10d9\u10d0\u10dc"):/\u10ec\u10d4\u10da\u10d8/.test(e)?e.replace(/\u10ec\u10d4\u10da\u10d8$/,"\u10ec\u10da\u10d8\u10e1 \u10e3\u10d9\u10d0\u10dc"):void 0},s:"\u10e0\u10d0\u10db\u10d3\u10d4\u10dc\u10d8\u10db\u10d4 \u10ec\u10d0\u10db\u10d8",ss:"%d \u10ec\u10d0\u10db\u10d8",m:"\u10ec\u10e3\u10d7\u10d8",mm:"%d \u10ec\u10e3\u10d7\u10d8",h:"\u10e1\u10d0\u10d0\u10d7\u10d8",hh:"%d \u10e1\u10d0\u10d0\u10d7\u10d8",d:"\u10d3\u10e6\u10d4",dd:"%d \u10d3\u10e6\u10d4",M:"\u10d7\u10d5\u10d4",MM:"%d \u10d7\u10d5\u10d4",y:"\u10ec\u10d4\u10da\u10d8",yy:"%d \u10ec\u10d4\u10da\u10d8"},dayOfMonthOrdinalParse:/0|1-\u10da\u10d8|\u10db\u10d4-\d{1,2}|\d{1,2}-\u10d4/,ordinal:function(e){return 0===e?e:1===e?e+"-\u10da\u10d8":e<20||e<=100&&e%20==0||e%100==0?"\u10db\u10d4-"+e:e+"-\u10d4"},week:{dow:1,doy:7}});var yn={0:"-\u0448\u0456",1:"-\u0448\u0456",2:"-\u0448\u0456",3:"-\u0448\u0456",4:"-\u0448\u0456",5:"-\u0448\u0456",6:"-\u0448\u044b",7:"-\u0448\u0456",8:"-\u0448\u0456",9:"-\u0448\u044b",10:"-\u0448\u044b",20:"-\u0448\u044b",30:"-\u0448\u044b",40:"-\u0448\u044b",50:"-\u0448\u0456",60:"-\u0448\u044b",70:"-\u0448\u0456",80:"-\u0448\u0456",90:"-\u0448\u044b",100:"-\u0448\u0456"};e.defineLocale("kk",{months:"\u049b\u0430\u04a3\u0442\u0430\u0440_\u0430\u049b\u043f\u0430\u043d_\u043d\u0430\u0443\u0440\u044b\u0437_\u0441\u04d9\u0443\u0456\u0440_\u043c\u0430\u043c\u044b\u0440_\u043c\u0430\u0443\u0441\u044b\u043c_\u0448\u0456\u043b\u0434\u0435_\u0442\u0430\u043c\u044b\u0437_\u049b\u044b\u0440\u043a\u04af\u0439\u0435\u043a_\u049b\u0430\u0437\u0430\u043d_\u049b\u0430\u0440\u0430\u0448\u0430_\u0436\u0435\u043b\u0442\u043e\u049b\u0441\u0430\u043d".split("_"),monthsShort:"\u049b\u0430\u04a3_\u0430\u049b\u043f_\u043d\u0430\u0443_\u0441\u04d9\u0443_\u043c\u0430\u043c_\u043c\u0430\u0443_\u0448\u0456\u043b_\u0442\u0430\u043c_\u049b\u044b\u0440_\u049b\u0430\u0437_\u049b\u0430\u0440_\u0436\u0435\u043b".split("_"),weekdays:"\u0436\u0435\u043a\u0441\u0435\u043d\u0431\u0456_\u0434\u04af\u0439\u0441\u0435\u043d\u0431\u0456_\u0441\u0435\u0439\u0441\u0435\u043d\u0431\u0456_\u0441\u04d9\u0440\u0441\u0435\u043d\u0431\u0456_\u0431\u0435\u0439\u0441\u0435\u043d\u0431\u0456_\u0436\u04b1\u043c\u0430_\u0441\u0435\u043d\u0431\u0456".split("_"),weekdaysShort:"\u0436\u0435\u043a_\u0434\u04af\u0439_\u0441\u0435\u0439_\u0441\u04d9\u0440_\u0431\u0435\u0439_\u0436\u04b1\u043c_\u0441\u0435\u043d".split("_"),weekdaysMin:"\u0436\u043a_\u0434\u0439_\u0441\u0439_\u0441\u0440_\u0431\u0439_\u0436\u043c_\u0441\u043d".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[\u0411\u04af\u0433\u0456\u043d \u0441\u0430\u0493\u0430\u0442] LT",nextDay:"[\u0415\u0440\u0442\u0435\u04a3 \u0441\u0430\u0493\u0430\u0442] LT",nextWeek:"dddd [\u0441\u0430\u0493\u0430\u0442] LT",lastDay:"[\u041a\u0435\u0448\u0435 \u0441\u0430\u0493\u0430\u0442] LT",lastWeek:"[\u04e8\u0442\u043a\u0435\u043d \u0430\u043f\u0442\u0430\u043d\u044b\u04a3] dddd [\u0441\u0430\u0493\u0430\u0442] LT",sameElse:"L"},relativeTime:{future:"%s \u0456\u0448\u0456\u043d\u0434\u0435",past:"%s \u0431\u04b1\u0440\u044b\u043d",s:"\u0431\u0456\u0440\u043d\u0435\u0448\u0435 \u0441\u0435\u043a\u0443\u043d\u0434",ss:"%d \u0441\u0435\u043a\u0443\u043d\u0434",m:"\u0431\u0456\u0440 \u043c\u0438\u043d\u0443\u0442",mm:"%d \u043c\u0438\u043d\u0443\u0442",h:"\u0431\u0456\u0440 \u0441\u0430\u0493\u0430\u0442",hh:"%d \u0441\u0430\u0493\u0430\u0442",d:"\u0431\u0456\u0440 \u043a\u04af\u043d",dd:"%d \u043a\u04af\u043d",M:"\u0431\u0456\u0440 \u0430\u0439",MM:"%d \u0430\u0439",y:"\u0431\u0456\u0440 \u0436\u044b\u043b",yy:"%d \u0436\u044b\u043b"},dayOfMonthOrdinalParse:/\d{1,2}-(\u0448\u0456|\u0448\u044b)/,ordinal:function(e){return e+(yn[e]||yn[e%10]||yn[e>=100?100:null])},week:{dow:1,doy:7}}),e.defineLocale("km",{months:"\u1798\u1780\u179a\u17b6_\u1780\u17bb\u1798\u17d2\u1797\u17c8_\u1798\u17b8\u1793\u17b6_\u1798\u17c1\u179f\u17b6_\u17a7\u179f\u1797\u17b6_\u1798\u17b7\u1790\u17bb\u1793\u17b6_\u1780\u1780\u17d2\u1780\u178a\u17b6_\u179f\u17b8\u17a0\u17b6_\u1780\u1789\u17d2\u1789\u17b6_\u178f\u17bb\u179b\u17b6_\u179c\u17b7\u1785\u17d2\u1786\u17b7\u1780\u17b6_\u1792\u17d2\u1793\u17bc".split("_"),monthsShort:"\u1798\u1780\u179a\u17b6_\u1780\u17bb\u1798\u17d2\u1797\u17c8_\u1798\u17b8\u1793\u17b6_\u1798\u17c1\u179f\u17b6_\u17a7\u179f\u1797\u17b6_\u1798\u17b7\u1790\u17bb\u1793\u17b6_\u1780\u1780\u17d2\u1780\u178a\u17b6_\u179f\u17b8\u17a0\u17b6_\u1780\u1789\u17d2\u1789\u17b6_\u178f\u17bb\u179b\u17b6_\u179c\u17b7\u1785\u17d2\u1786\u17b7\u1780\u17b6_\u1792\u17d2\u1793\u17bc".split("_"),weekdays:"\u17a2\u17b6\u1791\u17b7\u178f\u17d2\u1799_\u1785\u17d0\u1793\u17d2\u1791_\u17a2\u1784\u17d2\u1782\u17b6\u179a_\u1796\u17bb\u1792_\u1796\u17d2\u179a\u17a0\u179f\u17d2\u1794\u178f\u17b7\u17cd_\u179f\u17bb\u1780\u17d2\u179a_\u179f\u17c5\u179a\u17cd".split("_"),weekdaysShort:"\u17a2\u17b6\u1791\u17b7\u178f\u17d2\u1799_\u1785\u17d0\u1793\u17d2\u1791_\u17a2\u1784\u17d2\u1782\u17b6\u179a_\u1796\u17bb\u1792_\u1796\u17d2\u179a\u17a0\u179f\u17d2\u1794\u178f\u17b7\u17cd_\u179f\u17bb\u1780\u17d2\u179a_\u179f\u17c5\u179a\u17cd".split("_"),weekdaysMin:"\u17a2\u17b6\u1791\u17b7\u178f\u17d2\u1799_\u1785\u17d0\u1793\u17d2\u1791_\u17a2\u1784\u17d2\u1782\u17b6\u179a_\u1796\u17bb\u1792_\u1796\u17d2\u179a\u17a0\u179f\u17d2\u1794\u178f\u17b7\u17cd_\u179f\u17bb\u1780\u17d2\u179a_\u179f\u17c5\u179a\u17cd".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[\u1790\u17d2\u1784\u17c3\u1793\u17c1\u17c7 \u1798\u17c9\u17c4\u1784] LT",nextDay:"[\u179f\u17d2\u17a2\u17c2\u1780 \u1798\u17c9\u17c4\u1784] LT",nextWeek:"dddd [\u1798\u17c9\u17c4\u1784] LT",lastDay:"[\u1798\u17d2\u179f\u17b7\u179b\u1798\u17b7\u1789 \u1798\u17c9\u17c4\u1784] LT",lastWeek:"dddd [\u179f\u1794\u17d2\u178f\u17b6\u17a0\u17cd\u1798\u17bb\u1793] [\u1798\u17c9\u17c4\u1784] LT",sameElse:"L"},relativeTime:{future:"%s\u1791\u17c0\u178f",past:"%s\u1798\u17bb\u1793",s:"\u1794\u17c9\u17bb\u1793\u17d2\u1798\u17b6\u1793\u179c\u17b7\u1793\u17b6\u1791\u17b8",ss:"%d \u179c\u17b7\u1793\u17b6\u1791\u17b8",m:"\u1798\u17bd\u1799\u1793\u17b6\u1791\u17b8",mm:"%d \u1793\u17b6\u1791\u17b8",h:"\u1798\u17bd\u1799\u1798\u17c9\u17c4\u1784",hh:"%d \u1798\u17c9\u17c4\u1784",d:"\u1798\u17bd\u1799\u1790\u17d2\u1784\u17c3",dd:"%d \u1790\u17d2\u1784\u17c3",M:"\u1798\u17bd\u1799\u1781\u17c2",MM:"%d \u1781\u17c2",y:"\u1798\u17bd\u1799\u1786\u17d2\u1793\u17b6\u17c6",yy:"%d \u1786\u17d2\u1793\u17b6\u17c6"},week:{dow:1,doy:4}});var fn={1:"\u0ce7",2:"\u0ce8",3:"\u0ce9",4:"\u0cea",5:"\u0ceb",6:"\u0cec",7:"\u0ced",8:"\u0cee",9:"\u0cef",0:"\u0ce6"},kn={"\u0ce7":"1","\u0ce8":"2","\u0ce9":"3","\u0cea":"4","\u0ceb":"5","\u0cec":"6","\u0ced":"7","\u0cee":"8","\u0cef":"9","\u0ce6":"0"};e.defineLocale("kn",{months:"\u0c9c\u0ca8\u0cb5\u0cb0\u0cbf_\u0cab\u0cc6\u0cac\u0ccd\u0cb0\u0cb5\u0cb0\u0cbf_\u0cae\u0cbe\u0cb0\u0ccd\u0c9a\u0ccd_\u0c8f\u0caa\u0ccd\u0cb0\u0cbf\u0cb2\u0ccd_\u0cae\u0cc6\u0cd5_\u0c9c\u0cc2\u0ca8\u0ccd_\u0c9c\u0cc1\u0cb2\u0cc6\u0cd6_\u0c86\u0c97\u0cb8\u0ccd\u0c9f\u0ccd_\u0cb8\u0cc6\u0caa\u0ccd\u0c9f\u0cc6\u0c82\u0cac\u0cb0\u0ccd_\u0c85\u0c95\u0ccd\u0c9f\u0cc6\u0cc2\u0cd5\u0cac\u0cb0\u0ccd_\u0ca8\u0cb5\u0cc6\u0c82\u0cac\u0cb0\u0ccd_\u0ca1\u0cbf\u0cb8\u0cc6\u0c82\u0cac\u0cb0\u0ccd".split("_"),monthsShort:"\u0c9c\u0ca8_\u0cab\u0cc6\u0cac\u0ccd\u0cb0_\u0cae\u0cbe\u0cb0\u0ccd\u0c9a\u0ccd_\u0c8f\u0caa\u0ccd\u0cb0\u0cbf\u0cb2\u0ccd_\u0cae\u0cc6\u0cd5_\u0c9c\u0cc2\u0ca8\u0ccd_\u0c9c\u0cc1\u0cb2\u0cc6\u0cd6_\u0c86\u0c97\u0cb8\u0ccd\u0c9f\u0ccd_\u0cb8\u0cc6\u0caa\u0ccd\u0c9f\u0cc6\u0c82\u0cac_\u0c85\u0c95\u0ccd\u0c9f\u0cc6\u0cc2\u0cd5\u0cac_\u0ca8\u0cb5\u0cc6\u0c82\u0cac_\u0ca1\u0cbf\u0cb8\u0cc6\u0c82\u0cac".split("_"),monthsParseExact:!0,weekdays:"\u0cad\u0cbe\u0ca8\u0cc1\u0cb5\u0cbe\u0cb0_\u0cb8\u0cc6\u0cc2\u0cd5\u0cae\u0cb5\u0cbe\u0cb0_\u0cae\u0c82\u0c97\u0cb3\u0cb5\u0cbe\u0cb0_\u0cac\u0cc1\u0ca7\u0cb5\u0cbe\u0cb0_\u0c97\u0cc1\u0cb0\u0cc1\u0cb5\u0cbe\u0cb0_\u0cb6\u0cc1\u0c95\u0ccd\u0cb0\u0cb5\u0cbe\u0cb0_\u0cb6\u0ca8\u0cbf\u0cb5\u0cbe\u0cb0".split("_"),weekdaysShort:"\u0cad\u0cbe\u0ca8\u0cc1_\u0cb8\u0cc6\u0cc2\u0cd5\u0cae_\u0cae\u0c82\u0c97\u0cb3_\u0cac\u0cc1\u0ca7_\u0c97\u0cc1\u0cb0\u0cc1_\u0cb6\u0cc1\u0c95\u0ccd\u0cb0_\u0cb6\u0ca8\u0cbf".split("_"),weekdaysMin:"\u0cad\u0cbe_\u0cb8\u0cc6\u0cc2\u0cd5_\u0cae\u0c82_\u0cac\u0cc1_\u0c97\u0cc1_\u0cb6\u0cc1_\u0cb6".split("_"),longDateFormat:{LT:"A h:mm",LTS:"A h:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY, A h:mm",LLLL:"dddd, D MMMM YYYY, A h:mm"},calendar:{sameDay:"[\u0c87\u0c82\u0ca6\u0cc1] LT",nextDay:"[\u0ca8\u0cbe\u0cb3\u0cc6] LT",nextWeek:"dddd, LT",lastDay:"[\u0ca8\u0cbf\u0ca8\u0ccd\u0ca8\u0cc6] LT",lastWeek:"[\u0c95\u0cc6\u0cc2\u0ca8\u0cc6\u0caf] dddd, LT",sameElse:"L"},relativeTime:{future:"%s \u0ca8\u0c82\u0ca4\u0cb0",past:"%s \u0cb9\u0cbf\u0c82\u0ca6\u0cc6",s:"\u0c95\u0cc6\u0cb2\u0cb5\u0cc1 \u0c95\u0ccd\u0cb7\u0ca3\u0c97\u0cb3\u0cc1",ss:"%d \u0cb8\u0cc6\u0c95\u0cc6\u0c82\u0ca1\u0cc1\u0c97\u0cb3\u0cc1",m:"\u0c92\u0c82\u0ca6\u0cc1 \u0ca8\u0cbf\u0cae\u0cbf\u0cb7",mm:"%d \u0ca8\u0cbf\u0cae\u0cbf\u0cb7",h:"\u0c92\u0c82\u0ca6\u0cc1 \u0c97\u0c82\u0c9f\u0cc6",hh:"%d \u0c97\u0c82\u0c9f\u0cc6",d:"\u0c92\u0c82\u0ca6\u0cc1 \u0ca6\u0cbf\u0ca8",dd:"%d \u0ca6\u0cbf\u0ca8",M:"\u0c92\u0c82\u0ca6\u0cc1 \u0ca4\u0cbf\u0c82\u0c97\u0cb3\u0cc1",MM:"%d \u0ca4\u0cbf\u0c82\u0c97\u0cb3\u0cc1",y:"\u0c92\u0c82\u0ca6\u0cc1 \u0cb5\u0cb0\u0ccd\u0cb7",yy:"%d \u0cb5\u0cb0\u0ccd\u0cb7"},preparse:function(e){return e.replace(/[\u0ce7\u0ce8\u0ce9\u0cea\u0ceb\u0cec\u0ced\u0cee\u0cef\u0ce6]/g,function(e){return kn[e]})},postformat:function(e){return e.replace(/\d/g,function(e){return fn[e]})},meridiemParse:/\u0cb0\u0cbe\u0ca4\u0ccd\u0cb0\u0cbf|\u0cac\u0cc6\u0cb3\u0cbf\u0c97\u0ccd\u0c97\u0cc6|\u0cae\u0ca7\u0ccd\u0caf\u0cbe\u0cb9\u0ccd\u0ca8|\u0cb8\u0c82\u0c9c\u0cc6/,meridiemHour:function(e,a){return 12===e&&(e=0),"\u0cb0\u0cbe\u0ca4\u0ccd\u0cb0\u0cbf"===a?e<4?e:e+12:"\u0cac\u0cc6\u0cb3\u0cbf\u0c97\u0ccd\u0c97\u0cc6"===a?e:"\u0cae\u0ca7\u0ccd\u0caf\u0cbe\u0cb9\u0ccd\u0ca8"===a?e>=10?e:e+12:"\u0cb8\u0c82\u0c9c\u0cc6"===a?e+12:void 0},meridiem:function(e,a,t){return e<4?"\u0cb0\u0cbe\u0ca4\u0ccd\u0cb0\u0cbf":e<10?"\u0cac\u0cc6\u0cb3\u0cbf\u0c97\u0ccd\u0c97\u0cc6":e<17?"\u0cae\u0ca7\u0ccd\u0caf\u0cbe\u0cb9\u0ccd\u0ca8":e<20?"\u0cb8\u0c82\u0c9c\u0cc6":"\u0cb0\u0cbe\u0ca4\u0ccd\u0cb0\u0cbf"},dayOfMonthOrdinalParse:/\d{1,2}(\u0ca8\u0cc6\u0cd5)/,ordinal:function(e){return e+"\u0ca8\u0cc6\u0cd5"},week:{dow:0,doy:6}}),e.defineLocale("ko",{months:"1\uc6d4_2\uc6d4_3\uc6d4_4\uc6d4_5\uc6d4_6\uc6d4_7\uc6d4_8\uc6d4_9\uc6d4_10\uc6d4_11\uc6d4_12\uc6d4".split("_"),monthsShort:"1\uc6d4_2\uc6d4_3\uc6d4_4\uc6d4_5\uc6d4_6\uc6d4_7\uc6d4_8\uc6d4_9\uc6d4_10\uc6d4_11\uc6d4_12\uc6d4".split("_"),weekdays:"\uc77c\uc694\uc77c_\uc6d4\uc694\uc77c_\ud654\uc694\uc77c_\uc218\uc694\uc77c_\ubaa9\uc694\uc77c_\uae08\uc694\uc77c_\ud1a0\uc694\uc77c".split("_"),weekdaysShort:"\uc77c_\uc6d4_\ud654_\uc218_\ubaa9_\uae08_\ud1a0".split("_"),weekdaysMin:"\uc77c_\uc6d4_\ud654_\uc218_\ubaa9_\uae08_\ud1a0".split("_"),longDateFormat:{LT:"A h:mm",LTS:"A h:mm:ss",L:"YYYY.MM.DD",LL:"YYYY\ub144 MMMM D\uc77c",LLL:"YYYY\ub144 MMMM D\uc77c A h:mm",LLLL:"YYYY\ub144 MMMM D\uc77c dddd A h:mm",l:"YYYY.MM.DD",ll:"YYYY\ub144 MMMM D\uc77c",lll:"YYYY\ub144 MMMM D\uc77c A h:mm",llll:"YYYY\ub144 MMMM D\uc77c dddd A h:mm"},calendar:{sameDay:"\uc624\ub298 LT",nextDay:"\ub0b4\uc77c LT",nextWeek:"dddd LT",lastDay:"\uc5b4\uc81c LT",lastWeek:"\uc9c0\ub09c\uc8fc dddd LT",sameElse:"L"},relativeTime:{future:"%s \ud6c4",past:"%s \uc804",s:"\uba87 \ucd08",ss:"%d\ucd08",m:"1\ubd84",mm:"%d\ubd84",h:"\ud55c \uc2dc\uac04",hh:"%d\uc2dc\uac04",d:"\ud558\ub8e8",dd:"%d\uc77c",M:"\ud55c \ub2ec",MM:"%d\ub2ec",y:"\uc77c \ub144",yy:"%d\ub144"},dayOfMonthOrdinalParse:/\d{1,2}(\uc77c|\uc6d4|\uc8fc)/,ordinal:function(e,a){switch(a){case"d":case"D":case"DDD":return e+"\uc77c";case"M":return e+"\uc6d4";case"w":case"W":return e+"\uc8fc";default:return e}},meridiemParse:/\uc624\uc804|\uc624\ud6c4/,isPM:function(e){return"\uc624\ud6c4"===e},meridiem:function(e,a,t){return e<12?"\uc624\uc804":"\uc624\ud6c4"}});var pn={0:"-\u0447\u04af",1:"-\u0447\u0438",2:"-\u0447\u0438",3:"-\u0447\u04af",4:"-\u0447\u04af",5:"-\u0447\u0438",6:"-\u0447\u044b",7:"-\u0447\u0438",8:"-\u0447\u0438",9:"-\u0447\u0443",10:"-\u0447\u0443",20:"-\u0447\u044b",30:"-\u0447\u0443",40:"-\u0447\u044b",50:"-\u0447\u04af",60:"-\u0447\u044b",70:"-\u0447\u0438",80:"-\u0447\u0438",90:"-\u0447\u0443",100:"-\u0447\u04af"};e.defineLocale("ky",{months:"\u044f\u043d\u0432\u0430\u0440\u044c_\u0444\u0435\u0432\u0440\u0430\u043b\u044c_\u043c\u0430\u0440\u0442_\u0430\u043f\u0440\u0435\u043b\u044c_\u043c\u0430\u0439_\u0438\u044e\u043d\u044c_\u0438\u044e\u043b\u044c_\u0430\u0432\u0433\u0443\u0441\u0442_\u0441\u0435\u043d\u0442\u044f\u0431\u0440\u044c_\u043e\u043a\u0442\u044f\u0431\u0440\u044c_\u043d\u043e\u044f\u0431\u0440\u044c_\u0434\u0435\u043a\u0430\u0431\u0440\u044c".split("_"),monthsShort:"\u044f\u043d\u0432_\u0444\u0435\u0432_\u043c\u0430\u0440\u0442_\u0430\u043f\u0440_\u043c\u0430\u0439_\u0438\u044e\u043d\u044c_\u0438\u044e\u043b\u044c_\u0430\u0432\u0433_\u0441\u0435\u043d_\u043e\u043a\u0442_\u043d\u043e\u044f_\u0434\u0435\u043a".split("_"),weekdays:"\u0416\u0435\u043a\u0448\u0435\u043c\u0431\u0438_\u0414\u04af\u0439\u0448\u04e9\u043c\u0431\u04af_\u0428\u0435\u0439\u0448\u0435\u043c\u0431\u0438_\u0428\u0430\u0440\u0448\u0435\u043c\u0431\u0438_\u0411\u0435\u0439\u0448\u0435\u043c\u0431\u0438_\u0416\u0443\u043c\u0430_\u0418\u0448\u0435\u043c\u0431\u0438".split("_"),weekdaysShort:"\u0416\u0435\u043a_\u0414\u04af\u0439_\u0428\u0435\u0439_\u0428\u0430\u0440_\u0411\u0435\u0439_\u0416\u0443\u043c_\u0418\u0448\u0435".split("_"),weekdaysMin:"\u0416\u043a_\u0414\u0439_\u0428\u0439_\u0428\u0440_\u0411\u0439_\u0416\u043c_\u0418\u0448".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[\u0411\u04af\u0433\u04af\u043d \u0441\u0430\u0430\u0442] LT",nextDay:"[\u042d\u0440\u0442\u0435\u04a3 \u0441\u0430\u0430\u0442] LT",nextWeek:"dddd [\u0441\u0430\u0430\u0442] LT",lastDay:"[\u041a\u0435\u0447\u0435 \u0441\u0430\u0430\u0442] LT",lastWeek:"[\u04e8\u0442\u043a\u0435\u043d \u0430\u043f\u0442\u0430\u043d\u044b\u043d] dddd [\u043a\u04af\u043d\u04af] [\u0441\u0430\u0430\u0442] LT",sameElse:"L"},relativeTime:{future:"%s \u0438\u0447\u0438\u043d\u0434\u0435",past:"%s \u043c\u0443\u0440\u0443\u043d",s:"\u0431\u0438\u0440\u043d\u0435\u0447\u0435 \u0441\u0435\u043a\u0443\u043d\u0434",ss:"%d \u0441\u0435\u043a\u0443\u043d\u0434",m:"\u0431\u0438\u0440 \u043c\u04af\u043d\u04e9\u0442",mm:"%d \u043c\u04af\u043d\u04e9\u0442",h:"\u0431\u0438\u0440 \u0441\u0430\u0430\u0442",hh:"%d \u0441\u0430\u0430\u0442",d:"\u0431\u0438\u0440 \u043a\u04af\u043d",dd:"%d \u043a\u04af\u043d",M:"\u0431\u0438\u0440 \u0430\u0439",MM:"%d \u0430\u0439",y:"\u0431\u0438\u0440 \u0436\u044b\u043b",yy:"%d \u0436\u044b\u043b"},dayOfMonthOrdinalParse:/\d{1,2}-(\u0447\u0438|\u0447\u044b|\u0447\u04af|\u0447\u0443)/,ordinal:function(e){return e+(pn[e]||pn[e%10]||pn[e>=100?100:null])},week:{dow:1,doy:7}}),e.defineLocale("lb",{months:"Januar_Februar_M\xe4erz_Abr\xebll_Mee_Juni_Juli_August_September_Oktober_November_Dezember".split("_"),monthsShort:"Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.".split("_"),monthsParseExact:!0,weekdays:"Sonndeg_M\xe9indeg_D\xebnschdeg_M\xebttwoch_Donneschdeg_Freideg_Samschdeg".split("_"),weekdaysShort:"So._M\xe9._D\xeb._M\xeb._Do._Fr._Sa.".split("_"),weekdaysMin:"So_M\xe9_D\xeb_M\xeb_Do_Fr_Sa".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"H:mm [Auer]",LTS:"H:mm:ss [Auer]",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY H:mm [Auer]",LLLL:"dddd, D. MMMM YYYY H:mm [Auer]"},calendar:{sameDay:"[Haut um] LT",sameElse:"L",nextDay:"[Muer um] LT",nextWeek:"dddd [um] LT",lastDay:"[G\xebschter um] LT",lastWeek:function(){switch(this.day()){case 2:case 4:return"[Leschten] dddd [um] LT";default:return"[Leschte] dddd [um] LT"}}},relativeTime:{future:function(e){return La(e.substr(0,e.indexOf(" ")))?"a "+e:"an "+e},past:function(e){return La(e.substr(0,e.indexOf(" ")))?"viru "+e:"virun "+e},s:"e puer Sekonnen",ss:"%d Sekonnen",m:ha,mm:"%d Minutten",h:ha,hh:"%d Stonnen",d:ha,dd:"%d Deeg",M:ha,MM:"%d M\xe9int",y:ha,yy:"%d Joer"},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}}),e.defineLocale("lo",{months:"\u0ea1\u0eb1\u0e87\u0e81\u0ead\u0e99_\u0e81\u0eb8\u0ea1\u0e9e\u0eb2_\u0ea1\u0eb5\u0e99\u0eb2_\u0ec0\u0ea1\u0eaa\u0eb2_\u0e9e\u0eb6\u0e94\u0eaa\u0eb0\u0e9e\u0eb2_\u0ea1\u0eb4\u0e96\u0eb8\u0e99\u0eb2_\u0e81\u0ecd\u0ea5\u0eb0\u0e81\u0ebb\u0e94_\u0eaa\u0eb4\u0e87\u0eab\u0eb2_\u0e81\u0eb1\u0e99\u0e8d\u0eb2_\u0e95\u0eb8\u0ea5\u0eb2_\u0e9e\u0eb0\u0e88\u0eb4\u0e81_\u0e97\u0eb1\u0e99\u0ea7\u0eb2".split("_"),monthsShort:"\u0ea1\u0eb1\u0e87\u0e81\u0ead\u0e99_\u0e81\u0eb8\u0ea1\u0e9e\u0eb2_\u0ea1\u0eb5\u0e99\u0eb2_\u0ec0\u0ea1\u0eaa\u0eb2_\u0e9e\u0eb6\u0e94\u0eaa\u0eb0\u0e9e\u0eb2_\u0ea1\u0eb4\u0e96\u0eb8\u0e99\u0eb2_\u0e81\u0ecd\u0ea5\u0eb0\u0e81\u0ebb\u0e94_\u0eaa\u0eb4\u0e87\u0eab\u0eb2_\u0e81\u0eb1\u0e99\u0e8d\u0eb2_\u0e95\u0eb8\u0ea5\u0eb2_\u0e9e\u0eb0\u0e88\u0eb4\u0e81_\u0e97\u0eb1\u0e99\u0ea7\u0eb2".split("_"),weekdays:"\u0ead\u0eb2\u0e97\u0eb4\u0e94_\u0e88\u0eb1\u0e99_\u0ead\u0eb1\u0e87\u0e84\u0eb2\u0e99_\u0e9e\u0eb8\u0e94_\u0e9e\u0eb0\u0eab\u0eb1\u0e94_\u0eaa\u0eb8\u0e81_\u0ec0\u0eaa\u0ebb\u0eb2".split("_"),weekdaysShort:"\u0e97\u0eb4\u0e94_\u0e88\u0eb1\u0e99_\u0ead\u0eb1\u0e87\u0e84\u0eb2\u0e99_\u0e9e\u0eb8\u0e94_\u0e9e\u0eb0\u0eab\u0eb1\u0e94_\u0eaa\u0eb8\u0e81_\u0ec0\u0eaa\u0ebb\u0eb2".split("_"),weekdaysMin:"\u0e97_\u0e88_\u0ead\u0e84_\u0e9e_\u0e9e\u0eab_\u0eaa\u0e81_\u0eaa".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"\u0ea7\u0eb1\u0e99dddd D MMMM YYYY HH:mm"},meridiemParse:/\u0e95\u0ead\u0e99\u0ec0\u0e8a\u0ebb\u0ec9\u0eb2|\u0e95\u0ead\u0e99\u0ec1\u0ea5\u0e87/,isPM:function(e){return"\u0e95\u0ead\u0e99\u0ec1\u0ea5\u0e87"===e},meridiem:function(e,a,t){return e<12?"\u0e95\u0ead\u0e99\u0ec0\u0e8a\u0ebb\u0ec9\u0eb2":"\u0e95\u0ead\u0e99\u0ec1\u0ea5\u0e87"},calendar:{sameDay:"[\u0ea1\u0eb7\u0ec9\u0e99\u0eb5\u0ec9\u0ec0\u0ea7\u0ea5\u0eb2] LT",nextDay:"[\u0ea1\u0eb7\u0ec9\u0ead\u0eb7\u0ec8\u0e99\u0ec0\u0ea7\u0ea5\u0eb2] LT",nextWeek:"[\u0ea7\u0eb1\u0e99]dddd[\u0edc\u0ec9\u0eb2\u0ec0\u0ea7\u0ea5\u0eb2] LT",lastDay:"[\u0ea1\u0eb7\u0ec9\u0ea7\u0eb2\u0e99\u0e99\u0eb5\u0ec9\u0ec0\u0ea7\u0ea5\u0eb2] LT",lastWeek:"[\u0ea7\u0eb1\u0e99]dddd[\u0ec1\u0ea5\u0ec9\u0ea7\u0e99\u0eb5\u0ec9\u0ec0\u0ea7\u0ea5\u0eb2] LT",sameElse:"L"},relativeTime:{future:"\u0ead\u0eb5\u0e81 %s",past:"%s\u0e9c\u0ec8\u0eb2\u0e99\u0ea1\u0eb2",s:"\u0e9a\u0ecd\u0ec8\u0ec0\u0e97\u0ebb\u0ec8\u0eb2\u0ec3\u0e94\u0ea7\u0eb4\u0e99\u0eb2\u0e97\u0eb5",ss:"%d \u0ea7\u0eb4\u0e99\u0eb2\u0e97\u0eb5",m:"1 \u0e99\u0eb2\u0e97\u0eb5",mm:"%d \u0e99\u0eb2\u0e97\u0eb5",h:"1 \u0e8a\u0ebb\u0ec8\u0ea7\u0ec2\u0ea1\u0e87",hh:"%d \u0e8a\u0ebb\u0ec8\u0ea7\u0ec2\u0ea1\u0e87",d:"1 \u0ea1\u0eb7\u0ec9",dd:"%d \u0ea1\u0eb7\u0ec9",M:"1 \u0ec0\u0e94\u0eb7\u0ead\u0e99",MM:"%d \u0ec0\u0e94\u0eb7\u0ead\u0e99",y:"1 \u0e9b\u0eb5",yy:"%d \u0e9b\u0eb5"},dayOfMonthOrdinalParse:/(\u0e97\u0eb5\u0ec8)\d{1,2}/,ordinal:function(e){return"\u0e97\u0eb5\u0ec8"+e}});var Dn={ss:"sekund\u0117_sekund\u017ei\u0173_sekundes",m:"minut\u0117_minut\u0117s_minut\u0119",mm:"minut\u0117s_minu\u010di\u0173_minutes",h:"valanda_valandos_valand\u0105",hh:"valandos_valand\u0173_valandas",d:"diena_dienos_dien\u0105",dd:"dienos_dien\u0173_dienas",M:"m\u0117nuo_m\u0117nesio_m\u0117nes\u012f",MM:"m\u0117nesiai_m\u0117nesi\u0173_m\u0117nesius",y:"metai_met\u0173_metus",yy:"metai_met\u0173_metus"};e.defineLocale("lt",{months:{format:"sausio_vasario_kovo_baland\u017eio_gegu\u017e\u0117s_bir\u017eelio_liepos_rugpj\u016b\u010dio_rugs\u0117jo_spalio_lapkri\u010dio_gruod\u017eio".split("_"),standalone:"sausis_vasaris_kovas_balandis_gegu\u017e\u0117_bir\u017eelis_liepa_rugpj\u016btis_rugs\u0117jis_spalis_lapkritis_gruodis".split("_"),isFormat:/D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/},monthsShort:"sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd".split("_"),weekdays:{format:"sekmadien\u012f_pirmadien\u012f_antradien\u012f_tre\u010diadien\u012f_ketvirtadien\u012f_penktadien\u012f_\u0161e\u0161tadien\u012f".split("_"),standalone:"sekmadienis_pirmadienis_antradienis_tre\u010diadienis_ketvirtadienis_penktadienis_\u0161e\u0161tadienis".split("_"),isFormat:/dddd HH:mm/},weekdaysShort:"Sek_Pir_Ant_Tre_Ket_Pen_\u0160e\u0161".split("_"),weekdaysMin:"S_P_A_T_K_Pn_\u0160".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"YYYY-MM-DD",LL:"YYYY [m.] MMMM D [d.]",LLL:"YYYY [m.] MMMM D [d.], HH:mm [val.]",LLLL:"YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]",l:"YYYY-MM-DD",ll:"YYYY [m.] MMMM D [d.]",lll:"YYYY [m.] MMMM D [d.], HH:mm [val.]",llll:"YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]"},calendar:{sameDay:"[\u0160iandien] LT",nextDay:"[Rytoj] LT",nextWeek:"dddd LT",lastDay:"[Vakar] LT",lastWeek:"[Pra\u0117jus\u012f] dddd LT",sameElse:"L"},relativeTime:{future:"po %s",past:"prie\u0161 %s",s:function(e,a,t,s){return a?"kelios sekund\u0117s":s?"keli\u0173 sekund\u017ei\u0173":"kelias sekundes"},ss:fa,m:ca,mm:fa,h:ca,hh:fa,d:ca,dd:fa,M:ca,MM:fa,y:ca,yy:fa},dayOfMonthOrdinalParse:/\d{1,2}-oji/,ordinal:function(e){return e+"-oji"},week:{dow:1,doy:4}});var Tn={ss:"sekundes_sekund\u0113m_sekunde_sekundes".split("_"),m:"min\u016btes_min\u016bt\u0113m_min\u016bte_min\u016btes".split("_"),mm:"min\u016btes_min\u016bt\u0113m_min\u016bte_min\u016btes".split("_"),h:"stundas_stund\u0101m_stunda_stundas".split("_"),hh:"stundas_stund\u0101m_stunda_stundas".split("_"),d:"dienas_dien\u0101m_diena_dienas".split("_"),dd:"dienas_dien\u0101m_diena_dienas".split("_"),M:"m\u0113ne\u0161a_m\u0113ne\u0161iem_m\u0113nesis_m\u0113ne\u0161i".split("_"),MM:"m\u0113ne\u0161a_m\u0113ne\u0161iem_m\u0113nesis_m\u0113ne\u0161i".split("_"),y:"gada_gadiem_gads_gadi".split("_"),yy:"gada_gadiem_gads_gadi".split("_")};e.defineLocale("lv",{months:"janv\u0101ris_febru\u0101ris_marts_apr\u012blis_maijs_j\u016bnijs_j\u016blijs_augusts_septembris_oktobris_novembris_decembris".split("_"),monthsShort:"jan_feb_mar_apr_mai_j\u016bn_j\u016bl_aug_sep_okt_nov_dec".split("_"),weekdays:"sv\u0113tdiena_pirmdiena_otrdiena_tre\u0161diena_ceturtdiena_piektdiena_sestdiena".split("_"),weekdaysShort:"Sv_P_O_T_C_Pk_S".split("_"),weekdaysMin:"Sv_P_O_T_C_Pk_S".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY.",LL:"YYYY. [gada] D. MMMM",LLL:"YYYY. [gada] D. MMMM, HH:mm",LLLL:"YYYY. [gada] D. MMMM, dddd, HH:mm"},calendar:{sameDay:"[\u0160odien pulksten] LT",nextDay:"[R\u012bt pulksten] LT",nextWeek:"dddd [pulksten] LT",lastDay:"[Vakar pulksten] LT",lastWeek:"[Pag\u0101ju\u0161\u0101] dddd [pulksten] LT",sameElse:"L"},relativeTime:{future:"p\u0113c %s",past:"pirms %s",s:function(e,a){return a?"da\u017eas sekundes":"da\u017e\u0101m sekund\u0113m"},ss:pa,m:Da,mm:pa,h:Da,hh:pa,d:Da,dd:pa,M:Da,MM:pa,y:Da,yy:pa},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}});var gn={words:{ss:["sekund","sekunda","sekundi"],m:["jedan minut","jednog minuta"],mm:["minut","minuta","minuta"],h:["jedan sat","jednog sata"],hh:["sat","sata","sati"],dd:["dan","dana","dana"],MM:["mjesec","mjeseca","mjeseci"],yy:["godina","godine","godina"]},correctGrammaticalCase:function(e,a){return 1===e?a[0]:e>=2&&e<=4?a[1]:a[2]},translate:function(e,a,t){var s=gn.words[t];return 1===t.length?a?s[0]:s[1]:e+" "+gn.correctGrammaticalCase(e,s)}};e.defineLocale("me",{months:"januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar".split("_"),monthsShort:"jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.".split("_"),monthsParseExact:!0,weekdays:"nedjelja_ponedjeljak_utorak_srijeda_\u010detvrtak_petak_subota".split("_"),weekdaysShort:"ned._pon._uto._sri._\u010det._pet._sub.".split("_"),weekdaysMin:"ne_po_ut_sr_\u010de_pe_su".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY H:mm",LLLL:"dddd, D. MMMM YYYY H:mm"},calendar:{sameDay:"[danas u] LT",nextDay:"[sjutra u] LT",nextWeek:function(){switch(this.day()){case 0:return"[u] [nedjelju] [u] LT";case 3:return"[u] [srijedu] [u] LT";case 6:return"[u] [subotu] [u] LT";case 1:case 2:case 4:case 5:return"[u] dddd [u] LT"}},lastDay:"[ju\u010de u] LT",lastWeek:function(){return["[pro\u0161le] [nedjelje] [u] LT","[pro\u0161log] [ponedjeljka] [u] LT","[pro\u0161log] [utorka] [u] LT","[pro\u0161le] [srijede] [u] LT","[pro\u0161log] [\u010detvrtka] [u] LT","[pro\u0161log] [petka] [u] LT","[pro\u0161le] [subote] [u] LT"][this.day()]},sameElse:"L"},relativeTime:{future:"za %s",past:"prije %s",s:"nekoliko sekundi",ss:gn.translate,m:gn.translate,mm:gn.translate,h:gn.translate,hh:gn.translate,d:"dan",dd:gn.translate,M:"mjesec",MM:gn.translate,y:"godinu",yy:gn.translate},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:7}}),e.defineLocale("mi",{months:"Kohi-t\u0101te_Hui-tanguru_Pout\u016b-te-rangi_Paenga-wh\u0101wh\u0101_Haratua_Pipiri_H\u014dngoingoi_Here-turi-k\u014dk\u0101_Mahuru_Whiringa-\u0101-nuku_Whiringa-\u0101-rangi_Hakihea".split("_"),monthsShort:"Kohi_Hui_Pou_Pae_Hara_Pipi_H\u014dngoi_Here_Mahu_Whi-nu_Whi-ra_Haki".split("_"),monthsRegex:/(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,monthsStrictRegex:/(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,monthsShortRegex:/(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,monthsShortStrictRegex:/(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,weekdays:"R\u0101tapu_Mane_T\u016brei_Wenerei_T\u0101ite_Paraire_H\u0101tarei".split("_"),weekdaysShort:"Ta_Ma_T\u016b_We_T\u0101i_Pa_H\u0101".split("_"),weekdaysMin:"Ta_Ma_T\u016b_We_T\u0101i_Pa_H\u0101".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY [i] HH:mm",LLLL:"dddd, D MMMM YYYY [i] HH:mm"},calendar:{sameDay:"[i teie mahana, i] LT",nextDay:"[apopo i] LT",nextWeek:"dddd [i] LT",lastDay:"[inanahi i] LT",lastWeek:"dddd [whakamutunga i] LT",sameElse:"L"},relativeTime:{future:"i roto i %s",past:"%s i mua",s:"te h\u0113kona ruarua",ss:"%d h\u0113kona",m:"he meneti",mm:"%d meneti",h:"te haora",hh:"%d haora",d:"he ra",dd:"%d ra",M:"he marama",MM:"%d marama",y:"he tau",yy:"%d tau"},dayOfMonthOrdinalParse:/\d{1,2}\xba/,ordinal:"%d\xba",week:{dow:1,doy:4}}),e.defineLocale("mk",{months:"\u0458\u0430\u043d\u0443\u0430\u0440\u0438_\u0444\u0435\u0432\u0440\u0443\u0430\u0440\u0438_\u043c\u0430\u0440\u0442_\u0430\u043f\u0440\u0438\u043b_\u043c\u0430\u0458_\u0458\u0443\u043d\u0438_\u0458\u0443\u043b\u0438_\u0430\u0432\u0433\u0443\u0441\u0442_\u0441\u0435\u043f\u0442\u0435\u043c\u0432\u0440\u0438_\u043e\u043a\u0442\u043e\u043c\u0432\u0440\u0438_\u043d\u043e\u0435\u043c\u0432\u0440\u0438_\u0434\u0435\u043a\u0435\u043c\u0432\u0440\u0438".split("_"),monthsShort:"\u0458\u0430\u043d_\u0444\u0435\u0432_\u043c\u0430\u0440_\u0430\u043f\u0440_\u043c\u0430\u0458_\u0458\u0443\u043d_\u0458\u0443\u043b_\u0430\u0432\u0433_\u0441\u0435\u043f_\u043e\u043a\u0442_\u043d\u043e\u0435_\u0434\u0435\u043a".split("_"),weekdays:"\u043d\u0435\u0434\u0435\u043b\u0430_\u043f\u043e\u043d\u0435\u0434\u0435\u043b\u043d\u0438\u043a_\u0432\u0442\u043e\u0440\u043d\u0438\u043a_\u0441\u0440\u0435\u0434\u0430_\u0447\u0435\u0442\u0432\u0440\u0442\u043e\u043a_\u043f\u0435\u0442\u043e\u043a_\u0441\u0430\u0431\u043e\u0442\u0430".split("_"),weekdaysShort:"\u043d\u0435\u0434_\u043f\u043e\u043d_\u0432\u0442\u043e_\u0441\u0440\u0435_\u0447\u0435\u0442_\u043f\u0435\u0442_\u0441\u0430\u0431".split("_"),weekdaysMin:"\u043de_\u043fo_\u0432\u0442_\u0441\u0440_\u0447\u0435_\u043f\u0435_\u0441a".split("_"),longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"D.MM.YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY H:mm",LLLL:"dddd, D MMMM YYYY H:mm"},calendar:{sameDay:"[\u0414\u0435\u043d\u0435\u0441 \u0432\u043e] LT",nextDay:"[\u0423\u0442\u0440\u0435 \u0432\u043e] LT",nextWeek:"[\u0412\u043e] dddd [\u0432\u043e] LT",lastDay:"[\u0412\u0447\u0435\u0440\u0430 \u0432\u043e] LT",lastWeek:function(){switch(this.day()){case 0:case 3:case 6:return"[\u0418\u0437\u043c\u0438\u043d\u0430\u0442\u0430\u0442\u0430] dddd [\u0432\u043e] LT";case 1:case 2:case 4:case 5:return"[\u0418\u0437\u043c\u0438\u043d\u0430\u0442\u0438\u043e\u0442] dddd [\u0432\u043e] LT"}},sameElse:"L"},relativeTime:{future:"\u043f\u043e\u0441\u043b\u0435 %s",past:"\u043f\u0440\u0435\u0434 %s",s:"\u043d\u0435\u043a\u043e\u043b\u043a\u0443 \u0441\u0435\u043a\u0443\u043d\u0434\u0438",ss:"%d \u0441\u0435\u043a\u0443\u043d\u0434\u0438",m:"\u043c\u0438\u043d\u0443\u0442\u0430",mm:"%d \u043c\u0438\u043d\u0443\u0442\u0438",h:"\u0447\u0430\u0441",hh:"%d \u0447\u0430\u0441\u0430",d:"\u0434\u0435\u043d",dd:"%d \u0434\u0435\u043d\u0430",M:"\u043c\u0435\u0441\u0435\u0446",MM:"%d \u043c\u0435\u0441\u0435\u0446\u0438",y:"\u0433\u043e\u0434\u0438\u043d\u0430",yy:"%d \u0433\u043e\u0434\u0438\u043d\u0438"},dayOfMonthOrdinalParse:/\d{1,2}-(\u0435\u0432|\u0435\u043d|\u0442\u0438|\u0432\u0438|\u0440\u0438|\u043c\u0438)/,ordinal:function(e){var a=e%10,t=e%100;return 0===e?e+"-\u0435\u0432":0===t?e+"-\u0435\u043d":t>10&&t<20?e+"-\u0442\u0438":1===a?e+"-\u0432\u0438":2===a?e+"-\u0440\u0438":7===a||8===a?e+"-\u043c\u0438":e+"-\u0442\u0438"},week:{dow:1,doy:7}}),e.defineLocale("ml",{months:"\u0d1c\u0d28\u0d41\u0d35\u0d30\u0d3f_\u0d2b\u0d46\u0d2c\u0d4d\u0d30\u0d41\u0d35\u0d30\u0d3f_\u0d2e\u0d3e\u0d7c\u0d1a\u0d4d\u0d1a\u0d4d_\u0d0f\u0d2a\u0d4d\u0d30\u0d3f\u0d7d_\u0d2e\u0d47\u0d2f\u0d4d_\u0d1c\u0d42\u0d7a_\u0d1c\u0d42\u0d32\u0d48_\u0d13\u0d17\u0d38\u0d4d\u0d31\u0d4d\u0d31\u0d4d_\u0d38\u0d46\u0d2a\u0d4d\u0d31\u0d4d\u0d31\u0d02\u0d2c\u0d7c_\u0d12\u0d15\u0d4d\u0d1f\u0d4b\u0d2c\u0d7c_\u0d28\u0d35\u0d02\u0d2c\u0d7c_\u0d21\u0d3f\u0d38\u0d02\u0d2c\u0d7c".split("_"),monthsShort:"\u0d1c\u0d28\u0d41._\u0d2b\u0d46\u0d2c\u0d4d\u0d30\u0d41._\u0d2e\u0d3e\u0d7c._\u0d0f\u0d2a\u0d4d\u0d30\u0d3f._\u0d2e\u0d47\u0d2f\u0d4d_\u0d1c\u0d42\u0d7a_\u0d1c\u0d42\u0d32\u0d48._\u0d13\u0d17._\u0d38\u0d46\u0d2a\u0d4d\u0d31\u0d4d\u0d31._\u0d12\u0d15\u0d4d\u0d1f\u0d4b._\u0d28\u0d35\u0d02._\u0d21\u0d3f\u0d38\u0d02.".split("_"),monthsParseExact:!0,weekdays:"\u0d1e\u0d3e\u0d2f\u0d31\u0d3e\u0d34\u0d4d\u0d1a_\u0d24\u0d3f\u0d19\u0d4d\u0d15\u0d33\u0d3e\u0d34\u0d4d\u0d1a_\u0d1a\u0d4a\u0d35\u0d4d\u0d35\u0d3e\u0d34\u0d4d\u0d1a_\u0d2c\u0d41\u0d27\u0d28\u0d3e\u0d34\u0d4d\u0d1a_\u0d35\u0d4d\u0d2f\u0d3e\u0d34\u0d3e\u0d34\u0d4d\u0d1a_\u0d35\u0d46\u0d33\u0d4d\u0d33\u0d3f\u0d2f\u0d3e\u0d34\u0d4d\u0d1a_\u0d36\u0d28\u0d3f\u0d2f\u0d3e\u0d34\u0d4d\u0d1a".split("_"),weekdaysShort:"\u0d1e\u0d3e\u0d2f\u0d7c_\u0d24\u0d3f\u0d19\u0d4d\u0d15\u0d7e_\u0d1a\u0d4a\u0d35\u0d4d\u0d35_\u0d2c\u0d41\u0d27\u0d7b_\u0d35\u0d4d\u0d2f\u0d3e\u0d34\u0d02_\u0d35\u0d46\u0d33\u0d4d\u0d33\u0d3f_\u0d36\u0d28\u0d3f".split("_"),weekdaysMin:"\u0d1e\u0d3e_\u0d24\u0d3f_\u0d1a\u0d4a_\u0d2c\u0d41_\u0d35\u0d4d\u0d2f\u0d3e_\u0d35\u0d46_\u0d36".split("_"),longDateFormat:{LT:"A h:mm -\u0d28\u0d41",LTS:"A h:mm:ss -\u0d28\u0d41",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY, A h:mm -\u0d28\u0d41",LLLL:"dddd, D MMMM YYYY, A h:mm -\u0d28\u0d41"},calendar:{sameDay:"[\u0d07\u0d28\u0d4d\u0d28\u0d4d] LT",nextDay:"[\u0d28\u0d3e\u0d33\u0d46] LT",nextWeek:"dddd, LT",lastDay:"[\u0d07\u0d28\u0d4d\u0d28\u0d32\u0d46] LT",lastWeek:"[\u0d15\u0d34\u0d3f\u0d1e\u0d4d\u0d1e] dddd, LT",sameElse:"L"},relativeTime:{future:"%s \u0d15\u0d34\u0d3f\u0d1e\u0d4d\u0d1e\u0d4d",past:"%s \u0d2e\u0d41\u0d7b\u0d2a\u0d4d",s:"\u0d05\u0d7d\u0d2a \u0d28\u0d3f\u0d2e\u0d3f\u0d37\u0d19\u0d4d\u0d19\u0d7e",ss:"%d \u0d38\u0d46\u0d15\u0d4d\u0d15\u0d7b\u0d21\u0d4d",m:"\u0d12\u0d30\u0d41 \u0d2e\u0d3f\u0d28\u0d3f\u0d31\u0d4d\u0d31\u0d4d",mm:"%d \u0d2e\u0d3f\u0d28\u0d3f\u0d31\u0d4d\u0d31\u0d4d",h:"\u0d12\u0d30\u0d41 \u0d2e\u0d23\u0d3f\u0d15\u0d4d\u0d15\u0d42\u0d7c",hh:"%d \u0d2e\u0d23\u0d3f\u0d15\u0d4d\u0d15\u0d42\u0d7c",d:"\u0d12\u0d30\u0d41 \u0d26\u0d3f\u0d35\u0d38\u0d02",dd:"%d \u0d26\u0d3f\u0d35\u0d38\u0d02",M:"\u0d12\u0d30\u0d41 \u0d2e\u0d3e\u0d38\u0d02",MM:"%d \u0d2e\u0d3e\u0d38\u0d02",y:"\u0d12\u0d30\u0d41 \u0d35\u0d7c\u0d37\u0d02",yy:"%d \u0d35\u0d7c\u0d37\u0d02"},meridiemParse:/\u0d30\u0d3e\u0d24\u0d4d\u0d30\u0d3f|\u0d30\u0d3e\u0d35\u0d3f\u0d32\u0d46|\u0d09\u0d1a\u0d4d\u0d1a \u0d15\u0d34\u0d3f\u0d1e\u0d4d\u0d1e\u0d4d|\u0d35\u0d48\u0d15\u0d41\u0d28\u0d4d\u0d28\u0d47\u0d30\u0d02|\u0d30\u0d3e\u0d24\u0d4d\u0d30\u0d3f/i,meridiemHour:function(e,a){return 12===e&&(e=0),"\u0d30\u0d3e\u0d24\u0d4d\u0d30\u0d3f"===a&&e>=4||"\u0d09\u0d1a\u0d4d\u0d1a \u0d15\u0d34\u0d3f\u0d1e\u0d4d\u0d1e\u0d4d"===a||"\u0d35\u0d48\u0d15\u0d41\u0d28\u0d4d\u0d28\u0d47\u0d30\u0d02"===a?e+12:e},meridiem:function(e,a,t){return e<4?"\u0d30\u0d3e\u0d24\u0d4d\u0d30\u0d3f":e<12?"\u0d30\u0d3e\u0d35\u0d3f\u0d32\u0d46":e<17?"\u0d09\u0d1a\u0d4d\u0d1a \u0d15\u0d34\u0d3f\u0d1e\u0d4d\u0d1e\u0d4d":e<20?"\u0d35\u0d48\u0d15\u0d41\u0d28\u0d4d\u0d28\u0d47\u0d30\u0d02":"\u0d30\u0d3e\u0d24\u0d4d\u0d30\u0d3f"}});var wn={1:"\u0967",2:"\u0968",3:"\u0969",4:"\u096a",5:"\u096b",6:"\u096c",7:"\u096d",8:"\u096e",9:"\u096f",0:"\u0966"},vn={"\u0967":"1","\u0968":"2","\u0969":"3","\u096a":"4","\u096b":"5","\u096c":"6","\u096d":"7","\u096e":"8","\u096f":"9","\u0966":"0"};e.defineLocale("mr",{months:"\u091c\u093e\u0928\u0947\u0935\u093e\u0930\u0940_\u092b\u0947\u092c\u094d\u0930\u0941\u0935\u093e\u0930\u0940_\u092e\u093e\u0930\u094d\u091a_\u090f\u092a\u094d\u0930\u093f\u0932_\u092e\u0947_\u091c\u0942\u0928_\u091c\u0941\u0932\u0948_\u0911\u0917\u0938\u094d\u091f_\u0938\u092a\u094d\u091f\u0947\u0902\u092c\u0930_\u0911\u0915\u094d\u091f\u094b\u092c\u0930_\u0928\u094b\u0935\u094d\u0939\u0947\u0902\u092c\u0930_\u0921\u093f\u0938\u0947\u0902\u092c\u0930".split("_"),monthsShort:"\u091c\u093e\u0928\u0947._\u092b\u0947\u092c\u094d\u0930\u0941._\u092e\u093e\u0930\u094d\u091a._\u090f\u092a\u094d\u0930\u093f._\u092e\u0947._\u091c\u0942\u0928._\u091c\u0941\u0932\u0948._\u0911\u0917._\u0938\u092a\u094d\u091f\u0947\u0902._\u0911\u0915\u094d\u091f\u094b._\u0928\u094b\u0935\u094d\u0939\u0947\u0902._\u0921\u093f\u0938\u0947\u0902.".split("_"),monthsParseExact:!0,weekdays:"\u0930\u0935\u093f\u0935\u093e\u0930_\u0938\u094b\u092e\u0935\u093e\u0930_\u092e\u0902\u0917\u0933\u0935\u093e\u0930_\u092c\u0941\u0927\u0935\u093e\u0930_\u0917\u0941\u0930\u0942\u0935\u093e\u0930_\u0936\u0941\u0915\u094d\u0930\u0935\u093e\u0930_\u0936\u0928\u093f\u0935\u093e\u0930".split("_"),weekdaysShort:"\u0930\u0935\u093f_\u0938\u094b\u092e_\u092e\u0902\u0917\u0933_\u092c\u0941\u0927_\u0917\u0941\u0930\u0942_\u0936\u0941\u0915\u094d\u0930_\u0936\u0928\u093f".split("_"),weekdaysMin:"\u0930_\u0938\u094b_\u092e\u0902_\u092c\u0941_\u0917\u0941_\u0936\u0941_\u0936".split("_"),longDateFormat:{LT:"A h:mm \u0935\u093e\u091c\u0924\u093e",LTS:"A h:mm:ss \u0935\u093e\u091c\u0924\u093e",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY, A h:mm \u0935\u093e\u091c\u0924\u093e",LLLL:"dddd, D MMMM YYYY, A h:mm \u0935\u093e\u091c\u0924\u093e"},calendar:{sameDay:"[\u0906\u091c] LT",nextDay:"[\u0909\u0926\u094d\u092f\u093e] LT",nextWeek:"dddd, LT",lastDay:"[\u0915\u093e\u0932] LT",lastWeek:"[\u092e\u093e\u0917\u0940\u0932] dddd, LT",sameElse:"L"},relativeTime:{future:"%s\u092e\u0927\u094d\u092f\u0947",past:"%s\u092a\u0942\u0930\u094d\u0935\u0940",s:Ta,ss:Ta,m:Ta,mm:Ta,h:Ta,hh:Ta,d:Ta,dd:Ta,M:Ta,MM:Ta,y:Ta,yy:Ta},preparse:function(e){return e.replace(/[\u0967\u0968\u0969\u096a\u096b\u096c\u096d\u096e\u096f\u0966]/g,function(e){return vn[e]})},postformat:function(e){return e.replace(/\d/g,function(e){return wn[e]})},meridiemParse:/\u0930\u093e\u0924\u094d\u0930\u0940|\u0938\u0915\u093e\u0933\u0940|\u0926\u0941\u092a\u093e\u0930\u0940|\u0938\u093e\u092f\u0902\u0915\u093e\u0933\u0940/,meridiemHour:function(e,a){return 12===e&&(e=0),"\u0930\u093e\u0924\u094d\u0930\u0940"===a?e<4?e:e+12:"\u0938\u0915\u093e\u0933\u0940"===a?e:"\u0926\u0941\u092a\u093e\u0930\u0940"===a?e>=10?e:e+12:"\u0938\u093e\u092f\u0902\u0915\u093e\u0933\u0940"===a?e+12:void 0},meridiem:function(e,a,t){return e<4?"\u0930\u093e\u0924\u094d\u0930\u0940":e<10?"\u0938\u0915\u093e\u0933\u0940":e<17?"\u0926\u0941\u092a\u093e\u0930\u0940":e<20?"\u0938\u093e\u092f\u0902\u0915\u093e\u0933\u0940":"\u0930\u093e\u0924\u094d\u0930\u0940"},week:{dow:0,doy:6}}),e.defineLocale("ms-my",{months:"Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember".split("_"),monthsShort:"Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis".split("_"),weekdays:"Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu".split("_"),weekdaysShort:"Ahd_Isn_Sel_Rab_Kha_Jum_Sab".split("_"),weekdaysMin:"Ah_Is_Sl_Rb_Km_Jm_Sb".split("_"),longDateFormat:{LT:"HH.mm",LTS:"HH.mm.ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY [pukul] HH.mm",LLLL:"dddd, D MMMM YYYY [pukul] HH.mm"},meridiemParse:/pagi|tengahari|petang|malam/,meridiemHour:function(e,a){return 12===e&&(e=0),"pagi"===a?e:"tengahari"===a?e>=11?e:e+12:"petang"===a||"malam"===a?e+12:void 0},meridiem:function(e,a,t){return e<11?"pagi":e<15?"tengahari":e<19?"petang":"malam"},calendar:{sameDay:"[Hari ini pukul] LT",nextDay:"[Esok pukul] LT",nextWeek:"dddd [pukul] LT",lastDay:"[Kelmarin pukul] LT",lastWeek:"dddd [lepas pukul] LT",sameElse:"L"},relativeTime:{future:"dalam %s",past:"%s yang lepas",s:"beberapa saat",ss:"%d saat",m:"seminit",mm:"%d minit",h:"sejam",hh:"%d jam",d:"sehari",dd:"%d hari",M:"sebulan",MM:"%d bulan",y:"setahun",yy:"%d tahun"},week:{dow:1,doy:7}}),e.defineLocale("ms",{months:"Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember".split("_"),monthsShort:"Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis".split("_"),weekdays:"Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu".split("_"),weekdaysShort:"Ahd_Isn_Sel_Rab_Kha_Jum_Sab".split("_"),weekdaysMin:"Ah_Is_Sl_Rb_Km_Jm_Sb".split("_"),longDateFormat:{LT:"HH.mm",LTS:"HH.mm.ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY [pukul] HH.mm",LLLL:"dddd, D MMMM YYYY [pukul] HH.mm"},meridiemParse:/pagi|tengahari|petang|malam/,meridiemHour:function(e,a){return 12===e&&(e=0),"pagi"===a?e:"tengahari"===a?e>=11?e:e+12:"petang"===a||"malam"===a?e+12:void 0},meridiem:function(e,a,t){return e<11?"pagi":e<15?"tengahari":e<19?"petang":"malam"},calendar:{sameDay:"[Hari ini pukul] LT",nextDay:"[Esok pukul] LT",nextWeek:"dddd [pukul] LT",lastDay:"[Kelmarin pukul] LT",lastWeek:"dddd [lepas pukul] LT",sameElse:"L"},relativeTime:{future:"dalam %s",past:"%s yang lepas",s:"beberapa saat",ss:"%d saat",m:"seminit",mm:"%d minit",h:"sejam",hh:"%d jam",d:"sehari",dd:"%d hari",M:"sebulan",MM:"%d bulan",y:"setahun",yy:"%d tahun"},week:{dow:1,doy:7}}),e.defineLocale("mt",{months:"Jannar_Frar_Marzu_April_Mejju_\u0120unju_Lulju_Awwissu_Settembru_Ottubru_Novembru_Di\u010bembru".split("_"),monthsShort:"Jan_Fra_Mar_Apr_Mej_\u0120un_Lul_Aww_Set_Ott_Nov_Di\u010b".split("_"),weekdays:"Il-\u0126add_It-Tnejn_It-Tlieta_L-Erbg\u0127a_Il-\u0126amis_Il-\u0120img\u0127a_Is-Sibt".split("_"),weekdaysShort:"\u0126ad_Tne_Tli_Erb_\u0126am_\u0120im_Sib".split("_"),weekdaysMin:"\u0126a_Tn_Tl_Er_\u0126a_\u0120i_Si".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[Illum fil-]LT",nextDay:"[G\u0127ada fil-]LT",nextWeek:"dddd [fil-]LT",lastDay:"[Il-biera\u0127 fil-]LT",lastWeek:"dddd [li g\u0127adda] [fil-]LT",sameElse:"L"},relativeTime:{future:"f\u2019 %s",past:"%s ilu",s:"ftit sekondi",ss:"%d sekondi",m:"minuta",mm:"%d minuti",h:"sieg\u0127a",hh:"%d sieg\u0127at",d:"\u0121urnata",dd:"%d \u0121ranet",M:"xahar",MM:"%d xhur",y:"sena",yy:"%d sni"},dayOfMonthOrdinalParse:/\d{1,2}\xba/,ordinal:"%d\xba",week:{dow:1,doy:4}});var Sn={1:"\u1041",2:"\u1042",3:"\u1043",4:"\u1044",5:"\u1045",6:"\u1046",7:"\u1047",8:"\u1048",9:"\u1049",0:"\u1040"},Hn={"\u1041":"1","\u1042":"2","\u1043":"3","\u1044":"4","\u1045":"5","\u1046":"6","\u1047":"7","\u1048":"8","\u1049":"9","\u1040":"0"};e.defineLocale("my",{months:"\u1007\u1014\u103a\u1014\u101d\u102b\u101b\u102e_\u1016\u1031\u1016\u1031\u102c\u103a\u101d\u102b\u101b\u102e_\u1019\u1010\u103a_\u1027\u1015\u103c\u102e_\u1019\u1031_\u1007\u103d\u1014\u103a_\u1007\u1030\u101c\u102d\u102f\u1004\u103a_\u101e\u103c\u1002\u102f\u1010\u103a_\u1005\u1000\u103a\u1010\u1004\u103a\u1018\u102c_\u1021\u1031\u102c\u1000\u103a\u1010\u102d\u102f\u1018\u102c_\u1014\u102d\u102f\u101d\u1004\u103a\u1018\u102c_\u1012\u102e\u1007\u1004\u103a\u1018\u102c".split("_"),monthsShort:"\u1007\u1014\u103a_\u1016\u1031_\u1019\u1010\u103a_\u1015\u103c\u102e_\u1019\u1031_\u1007\u103d\u1014\u103a_\u101c\u102d\u102f\u1004\u103a_\u101e\u103c_\u1005\u1000\u103a_\u1021\u1031\u102c\u1000\u103a_\u1014\u102d\u102f_\u1012\u102e".split("_"),weekdays:"\u1010\u1014\u1004\u103a\u1039\u1002\u1014\u103d\u1031_\u1010\u1014\u1004\u103a\u1039\u101c\u102c_\u1021\u1004\u103a\u1039\u1002\u102b_\u1017\u102f\u1012\u1039\u1013\u101f\u1030\u1038_\u1000\u103c\u102c\u101e\u1015\u1010\u1031\u1038_\u101e\u1031\u102c\u1000\u103c\u102c_\u1005\u1014\u1031".split("_"),weekdaysShort:"\u1014\u103d\u1031_\u101c\u102c_\u1002\u102b_\u101f\u1030\u1038_\u1000\u103c\u102c_\u101e\u1031\u102c_\u1014\u1031".split("_"),weekdaysMin:"\u1014\u103d\u1031_\u101c\u102c_\u1002\u102b_\u101f\u1030\u1038_\u1000\u103c\u102c_\u101e\u1031\u102c_\u1014\u1031".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},calendar:{sameDay:"[\u101a\u1014\u1031.] LT [\u1019\u103e\u102c]",nextDay:"[\u1019\u1014\u1000\u103a\u1016\u103c\u1014\u103a] LT [\u1019\u103e\u102c]",nextWeek:"dddd LT [\u1019\u103e\u102c]",lastDay:"[\u1019\u1014\u1031.\u1000] LT [\u1019\u103e\u102c]",lastWeek:"[\u1015\u103c\u102e\u1038\u1001\u1032\u1037\u101e\u1031\u102c] dddd LT [\u1019\u103e\u102c]",sameElse:"L"},relativeTime:{future:"\u101c\u102c\u1019\u100a\u103a\u1037 %s \u1019\u103e\u102c",past:"\u101c\u103d\u1014\u103a\u1001\u1032\u1037\u101e\u1031\u102c %s \u1000",s:"\u1005\u1000\u1039\u1000\u1014\u103a.\u1021\u1014\u100a\u103a\u1038\u1004\u101a\u103a",ss:"%d \u1005\u1000\u1039\u1000\u1014\u1037\u103a",m:"\u1010\u1005\u103a\u1019\u102d\u1014\u1005\u103a",mm:"%d \u1019\u102d\u1014\u1005\u103a",h:"\u1010\u1005\u103a\u1014\u102c\u101b\u102e",hh:"%d \u1014\u102c\u101b\u102e",d:"\u1010\u1005\u103a\u101b\u1000\u103a",dd:"%d \u101b\u1000\u103a",M:"\u1010\u1005\u103a\u101c",MM:"%d \u101c",y:"\u1010\u1005\u103a\u1014\u103e\u1005\u103a",yy:"%d \u1014\u103e\u1005\u103a"},preparse:function(e){return e.replace(/[\u1041\u1042\u1043\u1044\u1045\u1046\u1047\u1048\u1049\u1040]/g,function(e){return Hn[e]})},postformat:function(e){return e.replace(/\d/g,function(e){return Sn[e]})},week:{dow:1,doy:4}}),e.defineLocale("nb",{months:"januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember".split("_"),monthsShort:"jan._feb._mars_april_mai_juni_juli_aug._sep._okt._nov._des.".split("_"),monthsParseExact:!0,weekdays:"s\xf8ndag_mandag_tirsdag_onsdag_torsdag_fredag_l\xf8rdag".split("_"),weekdaysShort:"s\xf8._ma._ti._on._to._fr._l\xf8.".split("_"),weekdaysMin:"s\xf8_ma_ti_on_to_fr_l\xf8".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY [kl.] HH:mm",LLLL:"dddd D. MMMM YYYY [kl.] HH:mm"},calendar:{sameDay:"[i dag kl.] LT",nextDay:"[i morgen kl.] LT",nextWeek:"dddd [kl.] LT",lastDay:"[i g\xe5r kl.] LT",lastWeek:"[forrige] dddd [kl.] LT",sameElse:"L"},relativeTime:{future:"om %s",past:"%s siden",s:"noen sekunder",ss:"%d sekunder",m:"ett minutt",mm:"%d minutter",h:"en time",hh:"%d timer",d:"en dag",dd:"%d dager",M:"en m\xe5ned",MM:"%d m\xe5neder",y:"ett \xe5r",yy:"%d \xe5r"},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}});var bn={1:"\u0967",2:"\u0968",3:"\u0969",4:"\u096a",5:"\u096b",6:"\u096c",7:"\u096d",8:"\u096e",9:"\u096f",0:"\u0966"},jn={"\u0967":"1","\u0968":"2","\u0969":"3","\u096a":"4","\u096b":"5","\u096c":"6","\u096d":"7","\u096e":"8","\u096f":"9","\u0966":"0"};e.defineLocale("ne",{months:"\u091c\u0928\u0935\u0930\u0940_\u092b\u0947\u092c\u094d\u0930\u0941\u0935\u0930\u0940_\u092e\u093e\u0930\u094d\u091a_\u0905\u092a\u094d\u0930\u093f\u0932_\u092e\u0908_\u091c\u0941\u0928_\u091c\u0941\u0932\u093e\u0908_\u0905\u0917\u0937\u094d\u091f_\u0938\u0947\u092a\u094d\u091f\u0947\u092e\u094d\u092c\u0930_\u0905\u0915\u094d\u091f\u094b\u092c\u0930_\u0928\u094b\u092d\u0947\u092e\u094d\u092c\u0930_\u0921\u093f\u0938\u0947\u092e\u094d\u092c\u0930".split("_"),monthsShort:"\u091c\u0928._\u092b\u0947\u092c\u094d\u0930\u0941._\u092e\u093e\u0930\u094d\u091a_\u0905\u092a\u094d\u0930\u093f._\u092e\u0908_\u091c\u0941\u0928_\u091c\u0941\u0932\u093e\u0908._\u0905\u0917._\u0938\u0947\u092a\u094d\u091f._\u0905\u0915\u094d\u091f\u094b._\u0928\u094b\u092d\u0947._\u0921\u093f\u0938\u0947.".split("_"),monthsParseExact:!0,weekdays:"\u0906\u0907\u0924\u092c\u093e\u0930_\u0938\u094b\u092e\u092c\u093e\u0930_\u092e\u0919\u094d\u0917\u0932\u092c\u093e\u0930_\u092c\u0941\u0927\u092c\u093e\u0930_\u092c\u093f\u0939\u093f\u092c\u093e\u0930_\u0936\u0941\u0915\u094d\u0930\u092c\u093e\u0930_\u0936\u0928\u093f\u092c\u093e\u0930".split("_"),weekdaysShort:"\u0906\u0907\u0924._\u0938\u094b\u092e._\u092e\u0919\u094d\u0917\u0932._\u092c\u0941\u0927._\u092c\u093f\u0939\u093f._\u0936\u0941\u0915\u094d\u0930._\u0936\u0928\u093f.".split("_"),weekdaysMin:"\u0906._\u0938\u094b._\u092e\u0902._\u092c\u0941._\u092c\u093f._\u0936\u0941._\u0936.".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"A\u0915\u094b h:mm \u092c\u091c\u0947",LTS:"A\u0915\u094b h:mm:ss \u092c\u091c\u0947",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY, A\u0915\u094b h:mm \u092c\u091c\u0947",LLLL:"dddd, D MMMM YYYY, A\u0915\u094b h:mm \u092c\u091c\u0947"},preparse:function(e){return e.replace(/[\u0967\u0968\u0969\u096a\u096b\u096c\u096d\u096e\u096f\u0966]/g,function(e){return jn[e]})},postformat:function(e){return e.replace(/\d/g,function(e){return bn[e]})},meridiemParse:/\u0930\u093e\u0924\u093f|\u092c\u093f\u0939\u093e\u0928|\u0926\u093f\u0909\u0901\u0938\u094b|\u0938\u093e\u0901\u091d/,meridiemHour:function(e,a){return 12===e&&(e=0),"\u0930\u093e\u0924\u093f"===a?e<4?e:e+12:"\u092c\u093f\u0939\u093e\u0928"===a?e:"\u0926\u093f\u0909\u0901\u0938\u094b"===a?e>=10?e:e+12:"\u0938\u093e\u0901\u091d"===a?e+12:void 0},meridiem:function(e,a,t){return e<3?"\u0930\u093e\u0924\u093f":e<12?"\u092c\u093f\u0939\u093e\u0928":e<16?"\u0926\u093f\u0909\u0901\u0938\u094b":e<20?"\u0938\u093e\u0901\u091d":"\u0930\u093e\u0924\u093f"},calendar:{sameDay:"[\u0906\u091c] LT",nextDay:"[\u092d\u094b\u0932\u093f] LT",nextWeek:"[\u0906\u0909\u0901\u0926\u094b] dddd[,] LT",lastDay:"[\u0939\u093f\u091c\u094b] LT",lastWeek:"[\u0917\u090f\u0915\u094b] dddd[,] LT",sameElse:"L"},relativeTime:{future:"%s\u092e\u093e",past:"%s \u0905\u0917\u093e\u0921\u093f",s:"\u0915\u0947\u0939\u0940 \u0915\u094d\u0937\u0923",ss:"%d \u0938\u0947\u0915\u0947\u0923\u094d\u0921",m:"\u090f\u0915 \u092e\u093f\u0928\u0947\u091f",mm:"%d \u092e\u093f\u0928\u0947\u091f",h:"\u090f\u0915 \u0918\u0923\u094d\u091f\u093e",hh:"%d \u0918\u0923\u094d\u091f\u093e",d:"\u090f\u0915 \u0926\u093f\u0928",dd:"%d \u0926\u093f\u0928",M:"\u090f\u0915 \u092e\u0939\u093f\u0928\u093e",MM:"%d \u092e\u0939\u093f\u0928\u093e",y:"\u090f\u0915 \u092c\u0930\u094d\u0937",yy:"%d \u092c\u0930\u094d\u0937"},week:{dow:0,doy:6}});var xn="jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.".split("_"),Pn="jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec".split("_"),On=[/^jan/i,/^feb/i,/^maart|mrt.?$/i,/^apr/i,/^mei$/i,/^jun[i.]?$/i,/^jul[i.]?$/i,/^aug/i,/^sep/i,/^okt/i,/^nov/i,/^dec/i],Wn=/^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;e.defineLocale("nl-be",{months:"januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december".split("_"),monthsShort:function(e,a){return e?/-MMM-/.test(a)?Pn[e.month()]:xn[e.month()]:xn},monthsRegex:Wn,monthsShortRegex:Wn,monthsStrictRegex:/^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,monthsShortStrictRegex:/^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,monthsParse:On,longMonthsParse:On,shortMonthsParse:On,weekdays:"zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag".split("_"),weekdaysShort:"zo._ma._di._wo._do._vr._za.".split("_"),weekdaysMin:"zo_ma_di_wo_do_vr_za".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},calendar:{sameDay:"[vandaag om] LT",nextDay:"[morgen om] LT",nextWeek:"dddd [om] LT",lastDay:"[gisteren om] LT",lastWeek:"[afgelopen] dddd [om] LT",sameElse:"L"},relativeTime:{future:"over %s",past:"%s geleden",s:"een paar seconden",ss:"%d seconden",m:"\xe9\xe9n minuut",mm:"%d minuten",h:"\xe9\xe9n uur",hh:"%d uur",d:"\xe9\xe9n dag",dd:"%d dagen",M:"\xe9\xe9n maand",MM:"%d maanden",y:"\xe9\xe9n jaar",yy:"%d jaar"},dayOfMonthOrdinalParse:/\d{1,2}(ste|de)/,ordinal:function(e){return e+(1===e||8===e||e>=20?"ste":"de")},week:{dow:1,doy:4}});var En="jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.".split("_"),An="jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec".split("_"),Fn=[/^jan/i,/^feb/i,/^maart|mrt.?$/i,/^apr/i,/^mei$/i,/^jun[i.]?$/i,/^jul[i.]?$/i,/^aug/i,/^sep/i,/^okt/i,/^nov/i,/^dec/i],zn=/^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;e.defineLocale("nl",{months:"januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december".split("_"),monthsShort:function(e,a){return e?/-MMM-/.test(a)?An[e.month()]:En[e.month()]:En},monthsRegex:zn,monthsShortRegex:zn,monthsStrictRegex:/^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,monthsShortStrictRegex:/^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,monthsParse:Fn,longMonthsParse:Fn,shortMonthsParse:Fn,weekdays:"zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag".split("_"),weekdaysShort:"zo._ma._di._wo._do._vr._za.".split("_"),weekdaysMin:"zo_ma_di_wo_do_vr_za".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD-MM-YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},calendar:{sameDay:"[vandaag om] LT",nextDay:"[morgen om] LT",nextWeek:"dddd [om] LT",lastDay:"[gisteren om] LT",lastWeek:"[afgelopen] dddd [om] LT",sameElse:"L"},relativeTime:{future:"over %s",past:"%s geleden",s:"een paar seconden",ss:"%d seconden",m:"\xe9\xe9n minuut",mm:"%d minuten",h:"\xe9\xe9n uur",hh:"%d uur",d:"\xe9\xe9n dag",dd:"%d dagen",M:"\xe9\xe9n maand",MM:"%d maanden",y:"\xe9\xe9n jaar",yy:"%d jaar"},dayOfMonthOrdinalParse:/\d{1,2}(ste|de)/,ordinal:function(e){return e+(1===e||8===e||e>=20?"ste":"de")},week:{dow:1,doy:4}}),e.defineLocale("nn",{months:"januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember".split("_"),monthsShort:"jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des".split("_"),weekdays:"sundag_m\xe5ndag_tysdag_onsdag_torsdag_fredag_laurdag".split("_"),weekdaysShort:"sun_m\xe5n_tys_ons_tor_fre_lau".split("_"),weekdaysMin:"su_m\xe5_ty_on_to_fr_l\xf8".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY [kl.] H:mm",LLLL:"dddd D. MMMM YYYY [kl.] HH:mm"},calendar:{sameDay:"[I dag klokka] LT",nextDay:"[I morgon klokka] LT",nextWeek:"dddd [klokka] LT",lastDay:"[I g\xe5r klokka] LT",lastWeek:"[F\xf8reg\xe5ande] dddd [klokka] LT",sameElse:"L"},relativeTime:{future:"om %s",past:"%s sidan",s:"nokre sekund",ss:"%d sekund",m:"eit minutt",mm:"%d minutt",h:"ein time",hh:"%d timar",d:"ein dag",dd:"%d dagar",M:"ein m\xe5nad",MM:"%d m\xe5nader",y:"eit \xe5r",yy:"%d \xe5r"},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}});var Jn={1:"\u0a67",2:"\u0a68",3:"\u0a69",4:"\u0a6a",5:"\u0a6b",6:"\u0a6c",7:"\u0a6d",8:"\u0a6e",9:"\u0a6f",0:"\u0a66"},Nn={"\u0a67":"1","\u0a68":"2","\u0a69":"3","\u0a6a":"4","\u0a6b":"5","\u0a6c":"6","\u0a6d":"7","\u0a6e":"8","\u0a6f":"9","\u0a66":"0"};e.defineLocale("pa-in",{months:"\u0a1c\u0a28\u0a35\u0a30\u0a40_\u0a2b\u0a3c\u0a30\u0a35\u0a30\u0a40_\u0a2e\u0a3e\u0a30\u0a1a_\u0a05\u0a2a\u0a4d\u0a30\u0a48\u0a32_\u0a2e\u0a08_\u0a1c\u0a42\u0a28_\u0a1c\u0a41\u0a32\u0a3e\u0a08_\u0a05\u0a17\u0a38\u0a24_\u0a38\u0a24\u0a70\u0a2c\u0a30_\u0a05\u0a15\u0a24\u0a42\u0a2c\u0a30_\u0a28\u0a35\u0a70\u0a2c\u0a30_\u0a26\u0a38\u0a70\u0a2c\u0a30".split("_"),monthsShort:"\u0a1c\u0a28\u0a35\u0a30\u0a40_\u0a2b\u0a3c\u0a30\u0a35\u0a30\u0a40_\u0a2e\u0a3e\u0a30\u0a1a_\u0a05\u0a2a\u0a4d\u0a30\u0a48\u0a32_\u0a2e\u0a08_\u0a1c\u0a42\u0a28_\u0a1c\u0a41\u0a32\u0a3e\u0a08_\u0a05\u0a17\u0a38\u0a24_\u0a38\u0a24\u0a70\u0a2c\u0a30_\u0a05\u0a15\u0a24\u0a42\u0a2c\u0a30_\u0a28\u0a35\u0a70\u0a2c\u0a30_\u0a26\u0a38\u0a70\u0a2c\u0a30".split("_"),weekdays:"\u0a10\u0a24\u0a35\u0a3e\u0a30_\u0a38\u0a4b\u0a2e\u0a35\u0a3e\u0a30_\u0a2e\u0a70\u0a17\u0a32\u0a35\u0a3e\u0a30_\u0a2c\u0a41\u0a27\u0a35\u0a3e\u0a30_\u0a35\u0a40\u0a30\u0a35\u0a3e\u0a30_\u0a38\u0a3c\u0a41\u0a71\u0a15\u0a30\u0a35\u0a3e\u0a30_\u0a38\u0a3c\u0a28\u0a40\u0a1a\u0a30\u0a35\u0a3e\u0a30".split("_"),weekdaysShort:"\u0a10\u0a24_\u0a38\u0a4b\u0a2e_\u0a2e\u0a70\u0a17\u0a32_\u0a2c\u0a41\u0a27_\u0a35\u0a40\u0a30_\u0a38\u0a3c\u0a41\u0a15\u0a30_\u0a38\u0a3c\u0a28\u0a40".split("_"),weekdaysMin:"\u0a10\u0a24_\u0a38\u0a4b\u0a2e_\u0a2e\u0a70\u0a17\u0a32_\u0a2c\u0a41\u0a27_\u0a35\u0a40\u0a30_\u0a38\u0a3c\u0a41\u0a15\u0a30_\u0a38\u0a3c\u0a28\u0a40".split("_"),longDateFormat:{LT:"A h:mm \u0a35\u0a1c\u0a47",LTS:"A h:mm:ss \u0a35\u0a1c\u0a47",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY, A h:mm \u0a35\u0a1c\u0a47",LLLL:"dddd, D MMMM YYYY, A h:mm \u0a35\u0a1c\u0a47"},calendar:{sameDay:"[\u0a05\u0a1c] LT",nextDay:"[\u0a15\u0a32] LT",nextWeek:"dddd, LT",lastDay:"[\u0a15\u0a32] LT",lastWeek:"[\u0a2a\u0a3f\u0a1b\u0a32\u0a47] dddd, LT",sameElse:"L"},relativeTime:{future:"%s \u0a35\u0a3f\u0a71\u0a1a",past:"%s \u0a2a\u0a3f\u0a1b\u0a32\u0a47",s:"\u0a15\u0a41\u0a1d \u0a38\u0a15\u0a3f\u0a70\u0a1f",ss:"%d \u0a38\u0a15\u0a3f\u0a70\u0a1f",m:"\u0a07\u0a15 \u0a2e\u0a3f\u0a70\u0a1f",mm:"%d \u0a2e\u0a3f\u0a70\u0a1f",h:"\u0a07\u0a71\u0a15 \u0a18\u0a70\u0a1f\u0a3e",hh:"%d \u0a18\u0a70\u0a1f\u0a47",d:"\u0a07\u0a71\u0a15 \u0a26\u0a3f\u0a28",dd:"%d \u0a26\u0a3f\u0a28",M:"\u0a07\u0a71\u0a15 \u0a2e\u0a39\u0a40\u0a28\u0a3e",MM:"%d \u0a2e\u0a39\u0a40\u0a28\u0a47",y:"\u0a07\u0a71\u0a15 \u0a38\u0a3e\u0a32",yy:"%d \u0a38\u0a3e\u0a32"},preparse:function(e){return e.replace(/[\u0a67\u0a68\u0a69\u0a6a\u0a6b\u0a6c\u0a6d\u0a6e\u0a6f\u0a66]/g,function(e){return Nn[e]})},postformat:function(e){return e.replace(/\d/g,function(e){return Jn[e]})},meridiemParse:/\u0a30\u0a3e\u0a24|\u0a38\u0a35\u0a47\u0a30|\u0a26\u0a41\u0a2a\u0a39\u0a3f\u0a30|\u0a38\u0a3c\u0a3e\u0a2e/,meridiemHour:function(e,a){return 12===e&&(e=0),"\u0a30\u0a3e\u0a24"===a?e<4?e:e+12:"\u0a38\u0a35\u0a47\u0a30"===a?e:"\u0a26\u0a41\u0a2a\u0a39\u0a3f\u0a30"===a?e>=10?e:e+12:"\u0a38\u0a3c\u0a3e\u0a2e"===a?e+12:void 0},meridiem:function(e,a,t){return e<4?"\u0a30\u0a3e\u0a24":e<10?"\u0a38\u0a35\u0a47\u0a30":e<17?"\u0a26\u0a41\u0a2a\u0a39\u0a3f\u0a30":e<20?"\u0a38\u0a3c\u0a3e\u0a2e":"\u0a30\u0a3e\u0a24"},week:{dow:0,doy:6}});var Rn="stycze\u0144_luty_marzec_kwiecie\u0144_maj_czerwiec_lipiec_sierpie\u0144_wrzesie\u0144_pa\u017adziernik_listopad_grudzie\u0144".split("_"),In="stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_wrze\u015bnia_pa\u017adziernika_listopada_grudnia".split("_");e.defineLocale("pl",{months:function(e,a){return e?""===a?"("+In[e.month()]+"|"+Rn[e.month()]+")":/D MMMM/.test(a)?In[e.month()]:Rn[e.month()]:Rn},monthsShort:"sty_lut_mar_kwi_maj_cze_lip_sie_wrz_pa\u017a_lis_gru".split("_"),weekdays:"niedziela_poniedzia\u0142ek_wtorek_\u015broda_czwartek_pi\u0105tek_sobota".split("_"),weekdaysShort:"ndz_pon_wt_\u015br_czw_pt_sob".split("_"),weekdaysMin:"Nd_Pn_Wt_\u015ar_Cz_Pt_So".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[Dzi\u015b o] LT",nextDay:"[Jutro o] LT",nextWeek:function(){switch(this.day()){case 0:return"[W niedziel\u0119 o] LT";case 2:return"[We wtorek o] LT";case 3:return"[W \u015brod\u0119 o] LT";case 6:return"[W sobot\u0119 o] LT";default:return"[W] dddd [o] LT"}},lastDay:"[Wczoraj o] LT",lastWeek:function(){switch(this.day()){case 0:return"[W zesz\u0142\u0105 niedziel\u0119 o] LT";case 3:return"[W zesz\u0142\u0105 \u015brod\u0119 o] LT";case 6:return"[W zesz\u0142\u0105 sobot\u0119 o] LT";default:return"[W zesz\u0142y] dddd [o] LT"}},sameElse:"L"},relativeTime:{future:"za %s",past:"%s temu",s:"kilka sekund",ss:wa,m:wa,mm:wa,h:wa,hh:wa,d:"1 dzie\u0144",dd:"%d dni",M:"miesi\u0105c",MM:wa,y:"rok",yy:wa},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}}),e.defineLocale("pt-br",{months:"janeiro_fevereiro_mar\xe7o_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro".split("_"),monthsShort:"jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez".split("_"),weekdays:"Domingo_Segunda-feira_Ter\xe7a-feira_Quarta-feira_Quinta-feira_Sexta-feira_S\xe1bado".split("_"),weekdaysShort:"Dom_Seg_Ter_Qua_Qui_Sex_S\xe1b".split("_"),weekdaysMin:"Do_2\xaa_3\xaa_4\xaa_5\xaa_6\xaa_S\xe1".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D [de] MMMM [de] YYYY",LLL:"D [de] MMMM [de] YYYY [\xe0s] HH:mm",LLLL:"dddd, D [de] MMMM [de] YYYY [\xe0s] HH:mm"},calendar:{sameDay:"[Hoje \xe0s] LT",nextDay:"[Amanh\xe3 \xe0s] LT",nextWeek:"dddd [\xe0s] LT",lastDay:"[Ontem \xe0s] LT",lastWeek:function(){return 0===this.day()||6===this.day()?"[\xdaltimo] dddd [\xe0s] LT":"[\xdaltima] dddd [\xe0s] LT"},sameElse:"L"},relativeTime:{future:"em %s",past:"%s atr\xe1s",s:"poucos segundos",ss:"%d segundos",m:"um minuto",mm:"%d minutos",h:"uma hora",hh:"%d horas",d:"um dia",dd:"%d dias",M:"um m\xeas",MM:"%d meses",y:"um ano",yy:"%d anos"},dayOfMonthOrdinalParse:/\d{1,2}\xba/,ordinal:"%d\xba"}),e.defineLocale("pt",{months:"janeiro_fevereiro_mar\xe7o_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro".split("_"),monthsShort:"jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez".split("_"),weekdays:"Domingo_Segunda-feira_Ter\xe7a-feira_Quarta-feira_Quinta-feira_Sexta-feira_S\xe1bado".split("_"),weekdaysShort:"Dom_Seg_Ter_Qua_Qui_Sex_S\xe1b".split("_"),weekdaysMin:"Do_2\xaa_3\xaa_4\xaa_5\xaa_6\xaa_S\xe1".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D [de] MMMM [de] YYYY",LLL:"D [de] MMMM [de] YYYY HH:mm",LLLL:"dddd, D [de] MMMM [de] YYYY HH:mm"},calendar:{sameDay:"[Hoje \xe0s] LT",nextDay:"[Amanh\xe3 \xe0s] LT",nextWeek:"dddd [\xe0s] LT",lastDay:"[Ontem \xe0s] LT",lastWeek:function(){return 0===this.day()||6===this.day()?"[\xdaltimo] dddd [\xe0s] LT":"[\xdaltima] dddd [\xe0s] LT"},sameElse:"L"},relativeTime:{future:"em %s",past:"h\xe1 %s",s:"segundos",ss:"%d segundos",m:"um minuto",mm:"%d minutos",h:"uma hora",hh:"%d horas",d:"um dia",dd:"%d dias",M:"um m\xeas",MM:"%d meses",y:"um ano",yy:"%d anos"},dayOfMonthOrdinalParse:/\d{1,2}\xba/,ordinal:"%d\xba",week:{dow:1,doy:4}}),e.defineLocale("ro",{months:"ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie".split("_"),monthsShort:"ian._febr._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.".split("_"),monthsParseExact:!0,weekdays:"duminic\u0103_luni_mar\u021bi_miercuri_joi_vineri_s\xe2mb\u0103t\u0103".split("_"),weekdaysShort:"Dum_Lun_Mar_Mie_Joi_Vin_S\xe2m".split("_"),weekdaysMin:"Du_Lu_Ma_Mi_Jo_Vi_S\xe2".split("_"),longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD.MM.YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY H:mm",LLLL:"dddd, D MMMM YYYY H:mm"},calendar:{sameDay:"[azi la] LT",nextDay:"[m\xe2ine la] LT",nextWeek:"dddd [la] LT",lastDay:"[ieri la] LT",lastWeek:"[fosta] dddd [la] LT",sameElse:"L"},relativeTime:{future:"peste %s",past:"%s \xeen urm\u0103",s:"c\xe2teva secunde",ss:va,m:"un minut",mm:va,h:"o or\u0103",hh:va,d:"o zi",dd:va,M:"o lun\u0103",MM:va,y:"un an",yy:va},week:{dow:1,doy:7}});var Cn=[/^\u044f\u043d\u0432/i,/^\u0444\u0435\u0432/i,/^\u043c\u0430\u0440/i,/^\u0430\u043f\u0440/i,/^\u043c\u0430[\u0439\u044f]/i,/^\u0438\u044e\u043d/i,/^\u0438\u044e\u043b/i,/^\u0430\u0432\u0433/i,/^\u0441\u0435\u043d/i,/^\u043e\u043a\u0442/i,/^\u043d\u043e\u044f/i,/^\u0434\u0435\u043a/i];e.defineLocale("ru",{months:{format:"\u044f\u043d\u0432\u0430\u0440\u044f_\u0444\u0435\u0432\u0440\u0430\u043b\u044f_\u043c\u0430\u0440\u0442\u0430_\u0430\u043f\u0440\u0435\u043b\u044f_\u043c\u0430\u044f_\u0438\u044e\u043d\u044f_\u0438\u044e\u043b\u044f_\u0430\u0432\u0433\u0443\u0441\u0442\u0430_\u0441\u0435\u043d\u0442\u044f\u0431\u0440\u044f_\u043e\u043a\u0442\u044f\u0431\u0440\u044f_\u043d\u043e\u044f\u0431\u0440\u044f_\u0434\u0435\u043a\u0430\u0431\u0440\u044f".split("_"),standalone:"\u044f\u043d\u0432\u0430\u0440\u044c_\u0444\u0435\u0432\u0440\u0430\u043b\u044c_\u043c\u0430\u0440\u0442_\u0430\u043f\u0440\u0435\u043b\u044c_\u043c\u0430\u0439_\u0438\u044e\u043d\u044c_\u0438\u044e\u043b\u044c_\u0430\u0432\u0433\u0443\u0441\u0442_\u0441\u0435\u043d\u0442\u044f\u0431\u0440\u044c_\u043e\u043a\u0442\u044f\u0431\u0440\u044c_\u043d\u043e\u044f\u0431\u0440\u044c_\u0434\u0435\u043a\u0430\u0431\u0440\u044c".split("_")},monthsShort:{format:"\u044f\u043d\u0432._\u0444\u0435\u0432\u0440._\u043c\u0430\u0440._\u0430\u043f\u0440._\u043c\u0430\u044f_\u0438\u044e\u043d\u044f_\u0438\u044e\u043b\u044f_\u0430\u0432\u0433._\u0441\u0435\u043d\u0442._\u043e\u043a\u0442._\u043d\u043e\u044f\u0431._\u0434\u0435\u043a.".split("_"),standalone:"\u044f\u043d\u0432._\u0444\u0435\u0432\u0440._\u043c\u0430\u0440\u0442_\u0430\u043f\u0440._\u043c\u0430\u0439_\u0438\u044e\u043d\u044c_\u0438\u044e\u043b\u044c_\u0430\u0432\u0433._\u0441\u0435\u043d\u0442._\u043e\u043a\u0442._\u043d\u043e\u044f\u0431._\u0434\u0435\u043a.".split("_")},weekdays:{standalone:"\u0432\u043e\u0441\u043a\u0440\u0435\u0441\u0435\u043d\u044c\u0435_\u043f\u043e\u043d\u0435\u0434\u0435\u043b\u044c\u043d\u0438\u043a_\u0432\u0442\u043e\u0440\u043d\u0438\u043a_\u0441\u0440\u0435\u0434\u0430_\u0447\u0435\u0442\u0432\u0435\u0440\u0433_\u043f\u044f\u0442\u043d\u0438\u0446\u0430_\u0441\u0443\u0431\u0431\u043e\u0442\u0430".split("_"),format:"\u0432\u043e\u0441\u043a\u0440\u0435\u0441\u0435\u043d\u044c\u0435_\u043f\u043e\u043d\u0435\u0434\u0435\u043b\u044c\u043d\u0438\u043a_\u0432\u0442\u043e\u0440\u043d\u0438\u043a_\u0441\u0440\u0435\u0434\u0443_\u0447\u0435\u0442\u0432\u0435\u0440\u0433_\u043f\u044f\u0442\u043d\u0438\u0446\u0443_\u0441\u0443\u0431\u0431\u043e\u0442\u0443".split("_"),isFormat:/\[ ?[\u0412\u0432] ?(?:\u043f\u0440\u043e\u0448\u043b\u0443\u044e|\u0441\u043b\u0435\u0434\u0443\u044e\u0449\u0443\u044e|\u044d\u0442\u0443)? ?\] ?dddd/},weekdaysShort:"\u0432\u0441_\u043f\u043d_\u0432\u0442_\u0441\u0440_\u0447\u0442_\u043f\u0442_\u0441\u0431".split("_"),weekdaysMin:"\u0432\u0441_\u043f\u043d_\u0432\u0442_\u0441\u0440_\u0447\u0442_\u043f\u0442_\u0441\u0431".split("_"),monthsParse:Cn,longMonthsParse:Cn,shortMonthsParse:Cn,monthsRegex:/^(\u044f\u043d\u0432\u0430\u0440[\u044c\u044f]|\u044f\u043d\u0432\.?|\u0444\u0435\u0432\u0440\u0430\u043b[\u044c\u044f]|\u0444\u0435\u0432\u0440?\.?|\u043c\u0430\u0440\u0442\u0430?|\u043c\u0430\u0440\.?|\u0430\u043f\u0440\u0435\u043b[\u044c\u044f]|\u0430\u043f\u0440\.?|\u043c\u0430[\u0439\u044f]|\u0438\u044e\u043d[\u044c\u044f]|\u0438\u044e\u043d\.?|\u0438\u044e\u043b[\u044c\u044f]|\u0438\u044e\u043b\.?|\u0430\u0432\u0433\u0443\u0441\u0442\u0430?|\u0430\u0432\u0433\.?|\u0441\u0435\u043d\u0442\u044f\u0431\u0440[\u044c\u044f]|\u0441\u0435\u043d\u0442?\.?|\u043e\u043a\u0442\u044f\u0431\u0440[\u044c\u044f]|\u043e\u043a\u0442\.?|\u043d\u043e\u044f\u0431\u0440[\u044c\u044f]|\u043d\u043e\u044f\u0431?\.?|\u0434\u0435\u043a\u0430\u0431\u0440[\u044c\u044f]|\u0434\u0435\u043a\.?)/i,monthsShortRegex:/^(\u044f\u043d\u0432\u0430\u0440[\u044c\u044f]|\u044f\u043d\u0432\.?|\u0444\u0435\u0432\u0440\u0430\u043b[\u044c\u044f]|\u0444\u0435\u0432\u0440?\.?|\u043c\u0430\u0440\u0442\u0430?|\u043c\u0430\u0440\.?|\u0430\u043f\u0440\u0435\u043b[\u044c\u044f]|\u0430\u043f\u0440\.?|\u043c\u0430[\u0439\u044f]|\u0438\u044e\u043d[\u044c\u044f]|\u0438\u044e\u043d\.?|\u0438\u044e\u043b[\u044c\u044f]|\u0438\u044e\u043b\.?|\u0430\u0432\u0433\u0443\u0441\u0442\u0430?|\u0430\u0432\u0433\.?|\u0441\u0435\u043d\u0442\u044f\u0431\u0440[\u044c\u044f]|\u0441\u0435\u043d\u0442?\.?|\u043e\u043a\u0442\u044f\u0431\u0440[\u044c\u044f]|\u043e\u043a\u0442\.?|\u043d\u043e\u044f\u0431\u0440[\u044c\u044f]|\u043d\u043e\u044f\u0431?\.?|\u0434\u0435\u043a\u0430\u0431\u0440[\u044c\u044f]|\u0434\u0435\u043a\.?)/i,monthsStrictRegex:/^(\u044f\u043d\u0432\u0430\u0440[\u044f\u044c]|\u0444\u0435\u0432\u0440\u0430\u043b[\u044f\u044c]|\u043c\u0430\u0440\u0442\u0430?|\u0430\u043f\u0440\u0435\u043b[\u044f\u044c]|\u043c\u0430[\u044f\u0439]|\u0438\u044e\u043d[\u044f\u044c]|\u0438\u044e\u043b[\u044f\u044c]|\u0430\u0432\u0433\u0443\u0441\u0442\u0430?|\u0441\u0435\u043d\u0442\u044f\u0431\u0440[\u044f\u044c]|\u043e\u043a\u0442\u044f\u0431\u0440[\u044f\u044c]|\u043d\u043e\u044f\u0431\u0440[\u044f\u044c]|\u0434\u0435\u043a\u0430\u0431\u0440[\u044f\u044c])/i,monthsShortStrictRegex:/^(\u044f\u043d\u0432\.|\u0444\u0435\u0432\u0440?\.|\u043c\u0430\u0440[\u0442.]|\u0430\u043f\u0440\.|\u043c\u0430[\u044f\u0439]|\u0438\u044e\u043d[\u044c\u044f.]|\u0438\u044e\u043b[\u044c\u044f.]|\u0430\u0432\u0433\.|\u0441\u0435\u043d\u0442?\.|\u043e\u043a\u0442\.|\u043d\u043e\u044f\u0431?\.|\u0434\u0435\u043a\.)/i,longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD.MM.YYYY",LL:"D MMMM YYYY \u0433.",LLL:"D MMMM YYYY \u0433., H:mm",LLLL:"dddd, D MMMM YYYY \u0433., H:mm"},calendar:{sameDay:"[\u0421\u0435\u0433\u043e\u0434\u043d\u044f \u0432] LT",nextDay:"[\u0417\u0430\u0432\u0442\u0440\u0430 \u0432] LT",lastDay:"[\u0412\u0447\u0435\u0440\u0430 \u0432] LT",nextWeek:function(e){if(e.week()===this.week())return 2===this.day()?"[\u0412\u043e] dddd [\u0432] LT":"[\u0412] dddd [\u0432] LT";switch(this.day()){case 0:return"[\u0412 \u0441\u043b\u0435\u0434\u0443\u044e\u0449\u0435\u0435] dddd [\u0432] LT";case 1:case 2:case 4:return"[\u0412 \u0441\u043b\u0435\u0434\u0443\u044e\u0449\u0438\u0439] dddd [\u0432] LT";case 3:case 5:case 6:return"[\u0412 \u0441\u043b\u0435\u0434\u0443\u044e\u0449\u0443\u044e] dddd [\u0432] LT"}},lastWeek:function(e){if(e.week()===this.week())return 2===this.day()?"[\u0412\u043e] dddd [\u0432] LT":"[\u0412] dddd [\u0432] LT";switch(this.day()){case 0:return"[\u0412 \u043f\u0440\u043e\u0448\u043b\u043e\u0435] dddd [\u0432] LT";case 1:case 2:case 4:return"[\u0412 \u043f\u0440\u043e\u0448\u043b\u044b\u0439] dddd [\u0432] LT";case 3:case 5:case 6:return"[\u0412 \u043f\u0440\u043e\u0448\u043b\u0443\u044e] dddd [\u0432] LT"}},sameElse:"L"},relativeTime:{future:"\u0447\u0435\u0440\u0435\u0437 %s",past:"%s \u043d\u0430\u0437\u0430\u0434",s:"\u043d\u0435\u0441\u043a\u043e\u043b\u044c\u043a\u043e \u0441\u0435\u043a\u0443\u043d\u0434",ss:Sa,m:Sa,mm:Sa,h:"\u0447\u0430\u0441",hh:Sa,d:"\u0434\u0435\u043d\u044c",dd:Sa,M:"\u043c\u0435\u0441\u044f\u0446",MM:Sa,y:"\u0433\u043e\u0434",yy:Sa},meridiemParse:/\u043d\u043e\u0447\u0438|\u0443\u0442\u0440\u0430|\u0434\u043d\u044f|\u0432\u0435\u0447\u0435\u0440\u0430/i,isPM:function(e){return/^(\u0434\u043d\u044f|\u0432\u0435\u0447\u0435\u0440\u0430)$/.test(e)},meridiem:function(e,a,t){return e<4?"\u043d\u043e\u0447\u0438":e<12?"\u0443\u0442\u0440\u0430":e<17?"\u0434\u043d\u044f":"\u0432\u0435\u0447\u0435\u0440\u0430"},dayOfMonthOrdinalParse:/\d{1,2}-(\u0439|\u0433\u043e|\u044f)/,ordinal:function(e,a){switch(a){case"M":case"d":case"DDD":return e+"-\u0439";case"D":return e+"-\u0433\u043e";case"w":case"W":return e+"-\u044f";default:return e}},week:{dow:1,doy:4}});var Gn=["\u062c\u0646\u0648\u0631\u064a","\u0641\u064a\u0628\u0631\u0648\u0631\u064a","\u0645\u0627\u0631\u0686","\u0627\u067e\u0631\u064a\u0644","\u0645\u0626\u064a","\u062c\u0648\u0646","\u062c\u0648\u0644\u0627\u0621\u0650","\u0622\u06af\u0633\u067d","\u0633\u064a\u067e\u067d\u0645\u0628\u0631","\u0622\u06aa\u067d\u0648\u0628\u0631","\u0646\u0648\u0645\u0628\u0631","\u068a\u0633\u0645\u0628\u0631"],Un=["\u0622\u0686\u0631","\u0633\u0648\u0645\u0631","\u0627\u06b1\u0627\u0631\u0648","\u0627\u0631\u0628\u0639","\u062e\u0645\u064a\u0633","\u062c\u0645\u0639","\u0687\u0646\u0687\u0631"];e.defineLocale("sd",{months:Gn,monthsShort:Gn,weekdays:Un,weekdaysShort:Un,weekdaysMin:Un,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd\u060c D MMMM YYYY HH:mm"},meridiemParse:/\u0635\u0628\u062d|\u0634\u0627\u0645/,isPM:function(e){return"\u0634\u0627\u0645"===e},meridiem:function(e,a,t){return e<12?"\u0635\u0628\u062d":"\u0634\u0627\u0645"},calendar:{sameDay:"[\u0627\u0684] LT",nextDay:"[\u0633\u0680\u0627\u06bb\u064a] LT",nextWeek:"dddd [\u0627\u06b3\u064a\u0646 \u0647\u0641\u062a\u064a \u062a\u064a] LT",lastDay:"[\u06aa\u0627\u0644\u0647\u0647] LT",lastWeek:"[\u06af\u0632\u0631\u064a\u0644 \u0647\u0641\u062a\u064a] dddd [\u062a\u064a] LT",sameElse:"L"},relativeTime:{future:"%s \u067e\u0648\u0621",past:"%s \u0627\u06b3",s:"\u0686\u0646\u062f \u0633\u064a\u06aa\u0646\u068a",ss:"%d \u0633\u064a\u06aa\u0646\u068a",m:"\u0647\u06aa \u0645\u0646\u067d",mm:"%d \u0645\u0646\u067d",h:"\u0647\u06aa \u06aa\u0644\u0627\u06aa",hh:"%d \u06aa\u0644\u0627\u06aa",d:"\u0647\u06aa \u068f\u064a\u0646\u0647\u0646",dd:"%d \u068f\u064a\u0646\u0647\u0646",M:"\u0647\u06aa \u0645\u0647\u064a\u0646\u0648",MM:"%d \u0645\u0647\u064a\u0646\u0627",y:"\u0647\u06aa \u0633\u0627\u0644",yy:"%d \u0633\u0627\u0644"},preparse:function(e){return e.replace(/\u060c/g,",")},postformat:function(e){return e.replace(/,/g,"\u060c")},week:{dow:1,doy:4}}),e.defineLocale("se",{months:"o\u0111\u0111ajagem\xe1nnu_guovvam\xe1nnu_njuk\u010dam\xe1nnu_cuo\u014bom\xe1nnu_miessem\xe1nnu_geassem\xe1nnu_suoidnem\xe1nnu_borgem\xe1nnu_\u010dak\u010dam\xe1nnu_golggotm\xe1nnu_sk\xe1bmam\xe1nnu_juovlam\xe1nnu".split("_"),monthsShort:"o\u0111\u0111j_guov_njuk_cuo_mies_geas_suoi_borg_\u010dak\u010d_golg_sk\xe1b_juov".split("_"),weekdays:"sotnabeaivi_vuoss\xe1rga_ma\u014b\u014beb\xe1rga_gaskavahkku_duorastat_bearjadat_l\xe1vvardat".split("_"),weekdaysShort:"sotn_vuos_ma\u014b_gask_duor_bear_l\xe1v".split("_"),weekdaysMin:"s_v_m_g_d_b_L".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"MMMM D. [b.] YYYY",LLL:"MMMM D. [b.] YYYY [ti.] HH:mm",LLLL:"dddd, MMMM D. [b.] YYYY [ti.] HH:mm"},calendar:{sameDay:"[otne ti] LT",nextDay:"[ihttin ti] LT",nextWeek:"dddd [ti] LT",lastDay:"[ikte ti] LT",lastWeek:"[ovddit] dddd [ti] LT",sameElse:"L"},relativeTime:{future:"%s gea\u017ees",past:"ma\u014bit %s",s:"moadde sekunddat",ss:"%d sekunddat",m:"okta minuhta",mm:"%d minuhtat",h:"okta diimmu",hh:"%d diimmut",d:"okta beaivi",dd:"%d beaivvit",M:"okta m\xe1nnu",MM:"%d m\xe1nut",y:"okta jahki",yy:"%d jagit"},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}}),e.defineLocale("si",{months:"\u0da2\u0db1\u0dc0\u0dcf\u0dbb\u0dd2_\u0db4\u0dd9\u0db6\u0dbb\u0dc0\u0dcf\u0dbb\u0dd2_\u0db8\u0dcf\u0dbb\u0dca\u0dad\u0dd4_\u0d85\u0db4\u0dca\u200d\u0dbb\u0dda\u0dbd\u0dca_\u0db8\u0dd0\u0dba\u0dd2_\u0da2\u0dd6\u0db1\u0dd2_\u0da2\u0dd6\u0dbd\u0dd2_\u0d85\u0d9c\u0ddd\u0dc3\u0dca\u0dad\u0dd4_\u0dc3\u0dd0\u0db4\u0dca\u0dad\u0dd0\u0db8\u0dca\u0db6\u0dbb\u0dca_\u0d94\u0d9a\u0dca\u0dad\u0ddd\u0db6\u0dbb\u0dca_\u0db1\u0ddc\u0dc0\u0dd0\u0db8\u0dca\u0db6\u0dbb\u0dca_\u0daf\u0dd9\u0dc3\u0dd0\u0db8\u0dca\u0db6\u0dbb\u0dca".split("_"),monthsShort:"\u0da2\u0db1_\u0db4\u0dd9\u0db6_\u0db8\u0dcf\u0dbb\u0dca_\u0d85\u0db4\u0dca_\u0db8\u0dd0\u0dba\u0dd2_\u0da2\u0dd6\u0db1\u0dd2_\u0da2\u0dd6\u0dbd\u0dd2_\u0d85\u0d9c\u0ddd_\u0dc3\u0dd0\u0db4\u0dca_\u0d94\u0d9a\u0dca_\u0db1\u0ddc\u0dc0\u0dd0_\u0daf\u0dd9\u0dc3\u0dd0".split("_"),weekdays:"\u0d89\u0dbb\u0dd2\u0daf\u0dcf_\u0dc3\u0db3\u0dd4\u0daf\u0dcf_\u0d85\u0d9f\u0dc4\u0dbb\u0dd4\u0dc0\u0dcf\u0daf\u0dcf_\u0db6\u0daf\u0dcf\u0daf\u0dcf_\u0db6\u0dca\u200d\u0dbb\u0dc4\u0dc3\u0dca\u0db4\u0dad\u0dd2\u0db1\u0dca\u0daf\u0dcf_\u0dc3\u0dd2\u0d9a\u0dd4\u0dbb\u0dcf\u0daf\u0dcf_\u0dc3\u0dd9\u0db1\u0dc3\u0dd4\u0dbb\u0dcf\u0daf\u0dcf".split("_"),weekdaysShort:"\u0d89\u0dbb\u0dd2_\u0dc3\u0db3\u0dd4_\u0d85\u0d9f_\u0db6\u0daf\u0dcf_\u0db6\u0dca\u200d\u0dbb\u0dc4_\u0dc3\u0dd2\u0d9a\u0dd4_\u0dc3\u0dd9\u0db1".split("_"),weekdaysMin:"\u0d89_\u0dc3_\u0d85_\u0db6_\u0db6\u0dca\u200d\u0dbb_\u0dc3\u0dd2_\u0dc3\u0dd9".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"a h:mm",LTS:"a h:mm:ss",L:"YYYY/MM/DD",LL:"YYYY MMMM D",LLL:"YYYY MMMM D, a h:mm",LLLL:"YYYY MMMM D [\u0dc0\u0dd0\u0db1\u0dd2] dddd, a h:mm:ss"},calendar:{sameDay:"[\u0d85\u0daf] LT[\u0da7]",nextDay:"[\u0dc4\u0dd9\u0da7] LT[\u0da7]",nextWeek:"dddd LT[\u0da7]",lastDay:"[\u0d8a\u0dba\u0dda] LT[\u0da7]",lastWeek:"[\u0db4\u0dc3\u0dd4\u0d9c\u0dd2\u0dba] dddd LT[\u0da7]",sameElse:"L"},relativeTime:{future:"%s\u0d9a\u0dd2\u0db1\u0dca",past:"%s\u0d9a\u0da7 \u0db4\u0dd9\u0dbb",s:"\u0dad\u0dad\u0dca\u0db4\u0dbb \u0d9a\u0dd2\u0dc4\u0dd2\u0db4\u0dba",ss:"\u0dad\u0dad\u0dca\u0db4\u0dbb %d",m:"\u0db8\u0dd2\u0db1\u0dd2\u0dad\u0dca\u0dad\u0dd4\u0dc0",mm:"\u0db8\u0dd2\u0db1\u0dd2\u0dad\u0dca\u0dad\u0dd4 %d",h:"\u0db4\u0dd0\u0dba",hh:"\u0db4\u0dd0\u0dba %d",d:"\u0daf\u0dd2\u0db1\u0dba",dd:"\u0daf\u0dd2\u0db1 %d",M:"\u0db8\u0dcf\u0dc3\u0dba",MM:"\u0db8\u0dcf\u0dc3 %d",y:"\u0dc0\u0dc3\u0dbb",yy:"\u0dc0\u0dc3\u0dbb %d"},dayOfMonthOrdinalParse:/\d{1,2} \u0dc0\u0dd0\u0db1\u0dd2/,ordinal:function(e){return e+" \u0dc0\u0dd0\u0db1\u0dd2"},meridiemParse:/\u0db4\u0dd9\u0dbb \u0dc0\u0dbb\u0dd4|\u0db4\u0dc3\u0dca \u0dc0\u0dbb\u0dd4|\u0db4\u0dd9.\u0dc0|\u0db4.\u0dc0./,isPM:function(e){return"\u0db4.\u0dc0."===e||"\u0db4\u0dc3\u0dca \u0dc0\u0dbb\u0dd4"===e},meridiem:function(e,a,t){return e>11?t?"\u0db4.\u0dc0.":"\u0db4\u0dc3\u0dca \u0dc0\u0dbb\u0dd4":t?"\u0db4\u0dd9.\u0dc0.":"\u0db4\u0dd9\u0dbb \u0dc0\u0dbb\u0dd4"}});var Vn="janu\xe1r_febru\xe1r_marec_apr\xedl_m\xe1j_j\xfan_j\xfal_august_september_okt\xf3ber_november_december".split("_"),Kn="jan_feb_mar_apr_m\xe1j_j\xfan_j\xfal_aug_sep_okt_nov_dec".split("_");e.defineLocale("sk",{months:Vn,monthsShort:Kn,weekdays:"nede\u013ea_pondelok_utorok_streda_\u0161tvrtok_piatok_sobota".split("_"),weekdaysShort:"ne_po_ut_st_\u0161t_pi_so".split("_"),weekdaysMin:"ne_po_ut_st_\u0161t_pi_so".split("_"),longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY H:mm",LLLL:"dddd D. MMMM YYYY H:mm"},calendar:{sameDay:"[dnes o] LT",nextDay:"[zajtra o] LT",nextWeek:function(){switch(this.day()){case 0:return"[v nede\u013eu o] LT";case 1:case 2:return"[v] dddd [o] LT";case 3:return"[v stredu o] LT";case 4:return"[vo \u0161tvrtok o] LT";case 5:return"[v piatok o] LT";case 6:return"[v sobotu o] LT"}},lastDay:"[v\u010dera o] LT",lastWeek:function(){switch(this.day()){case 0:return"[minul\xfa nede\u013eu o] LT";case 1:case 2:return"[minul\xfd] dddd [o] LT";case 3:return"[minul\xfa stredu o] LT";case 4:case 5:return"[minul\xfd] dddd [o] LT";case 6:return"[minul\xfa sobotu o] LT"}},sameElse:"L"},relativeTime:{future:"za %s",past:"pred %s",s:ba,ss:ba,m:ba,mm:ba,h:ba,hh:ba,d:ba,dd:ba,M:ba,MM:ba,y:ba,yy:ba},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}}),e.defineLocale("sl",{months:"januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december".split("_"),monthsShort:"jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.".split("_"),monthsParseExact:!0,weekdays:"nedelja_ponedeljek_torek_sreda_\u010detrtek_petek_sobota".split("_"),weekdaysShort:"ned._pon._tor._sre._\u010det._pet._sob.".split("_"),weekdaysMin:"ne_po_to_sr_\u010de_pe_so".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY H:mm",LLLL:"dddd, D. MMMM YYYY H:mm"},calendar:{sameDay:"[danes ob] LT",nextDay:"[jutri ob] LT",nextWeek:function(){switch(this.day()){case 0:return"[v] [nedeljo] [ob] LT";case 3:return"[v] [sredo] [ob] LT";case 6:return"[v] [soboto] [ob] LT";case 1:case 2:case 4:case 5:return"[v] dddd [ob] LT"}},lastDay:"[v\u010deraj ob] LT",lastWeek:function(){switch(this.day()){case 0:return"[prej\u0161njo] [nedeljo] [ob] LT";case 3:return"[prej\u0161njo] [sredo] [ob] LT";case 6:return"[prej\u0161njo] [soboto] [ob] LT";case 1:case 2:case 4:case 5:return"[prej\u0161nji] dddd [ob] LT"}},sameElse:"L"},relativeTime:{future:"\u010dez %s",past:"pred %s",s:ja,ss:ja,m:ja,mm:ja,h:ja,hh:ja,d:ja,dd:ja,M:ja,MM:ja,y:ja,yy:ja},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:7}}),e.defineLocale("sq",{months:"Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_N\xebntor_Dhjetor".split("_"),monthsShort:"Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_N\xebn_Dhj".split("_"),weekdays:"E Diel_E H\xebn\xeb_E Mart\xeb_E M\xebrkur\xeb_E Enjte_E Premte_E Shtun\xeb".split("_"),weekdaysShort:"Die_H\xebn_Mar_M\xebr_Enj_Pre_Sht".split("_"),weekdaysMin:"D_H_Ma_M\xeb_E_P_Sh".split("_"),weekdaysParseExact:!0,meridiemParse:/PD|MD/,isPM:function(e){return"M"===e.charAt(0)},meridiem:function(e,a,t){return e<12?"PD":"MD"},longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[Sot n\xeb] LT",nextDay:"[Nes\xebr n\xeb] LT",nextWeek:"dddd [n\xeb] LT",lastDay:"[Dje n\xeb] LT",lastWeek:"dddd [e kaluar n\xeb] LT",sameElse:"L"},relativeTime:{future:"n\xeb %s",past:"%s m\xeb par\xeb",s:"disa sekonda",ss:"%d sekonda",m:"nj\xeb minut\xeb",mm:"%d minuta",h:"nj\xeb or\xeb",hh:"%d or\xeb",d:"nj\xeb dit\xeb",dd:"%d dit\xeb",M:"nj\xeb muaj",MM:"%d muaj",y:"nj\xeb vit",yy:"%d vite"},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}});var Zn={words:{ss:["\u0441\u0435\u043a\u0443\u043d\u0434\u0430","\u0441\u0435\u043a\u0443\u043d\u0434\u0435","\u0441\u0435\u043a\u0443\u043d\u0434\u0438"],m:["\u0458\u0435\u0434\u0430\u043d \u043c\u0438\u043d\u0443\u0442","\u0458\u0435\u0434\u043d\u0435 \u043c\u0438\u043d\u0443\u0442\u0435"],mm:["\u043c\u0438\u043d\u0443\u0442","\u043c\u0438\u043d\u0443\u0442\u0435","\u043c\u0438\u043d\u0443\u0442\u0430"],h:["\u0458\u0435\u0434\u0430\u043d \u0441\u0430\u0442","\u0458\u0435\u0434\u043d\u043e\u0433 \u0441\u0430\u0442\u0430"],hh:["\u0441\u0430\u0442","\u0441\u0430\u0442\u0430","\u0441\u0430\u0442\u0438"],dd:["\u0434\u0430\u043d","\u0434\u0430\u043d\u0430","\u0434\u0430\u043d\u0430"],MM:["\u043c\u0435\u0441\u0435\u0446","\u043c\u0435\u0441\u0435\u0446\u0430","\u043c\u0435\u0441\u0435\u0446\u0438"],yy:["\u0433\u043e\u0434\u0438\u043d\u0430","\u0433\u043e\u0434\u0438\u043d\u0435","\u0433\u043e\u0434\u0438\u043d\u0430"]},correctGrammaticalCase:function(e,a){return 1===e?a[0]:e>=2&&e<=4?a[1]:a[2]},translate:function(e,a,t){var s=Zn.words[t];return 1===t.length?a?s[0]:s[1]:e+" "+Zn.correctGrammaticalCase(e,s)}};e.defineLocale("sr-cyrl",{months:"\u0458\u0430\u043d\u0443\u0430\u0440_\u0444\u0435\u0431\u0440\u0443\u0430\u0440_\u043c\u0430\u0440\u0442_\u0430\u043f\u0440\u0438\u043b_\u043c\u0430\u0458_\u0458\u0443\u043d_\u0458\u0443\u043b_\u0430\u0432\u0433\u0443\u0441\u0442_\u0441\u0435\u043f\u0442\u0435\u043c\u0431\u0430\u0440_\u043e\u043a\u0442\u043e\u0431\u0430\u0440_\u043d\u043e\u0432\u0435\u043c\u0431\u0430\u0440_\u0434\u0435\u0446\u0435\u043c\u0431\u0430\u0440".split("_"),monthsShort:"\u0458\u0430\u043d._\u0444\u0435\u0431._\u043c\u0430\u0440._\u0430\u043f\u0440._\u043c\u0430\u0458_\u0458\u0443\u043d_\u0458\u0443\u043b_\u0430\u0432\u0433._\u0441\u0435\u043f._\u043e\u043a\u0442._\u043d\u043e\u0432._\u0434\u0435\u0446.".split("_"),monthsParseExact:!0,weekdays:"\u043d\u0435\u0434\u0435\u0459\u0430_\u043f\u043e\u043d\u0435\u0434\u0435\u0459\u0430\u043a_\u0443\u0442\u043e\u0440\u0430\u043a_\u0441\u0440\u0435\u0434\u0430_\u0447\u0435\u0442\u0432\u0440\u0442\u0430\u043a_\u043f\u0435\u0442\u0430\u043a_\u0441\u0443\u0431\u043e\u0442\u0430".split("_"),weekdaysShort:"\u043d\u0435\u0434._\u043f\u043e\u043d._\u0443\u0442\u043e._\u0441\u0440\u0435._\u0447\u0435\u0442._\u043f\u0435\u0442._\u0441\u0443\u0431.".split("_"),weekdaysMin:"\u043d\u0435_\u043f\u043e_\u0443\u0442_\u0441\u0440_\u0447\u0435_\u043f\u0435_\u0441\u0443".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY H:mm",LLLL:"dddd, D. MMMM YYYY H:mm"},calendar:{sameDay:"[\u0434\u0430\u043d\u0430\u0441 \u0443] LT",nextDay:"[\u0441\u0443\u0442\u0440\u0430 \u0443] LT",nextWeek:function(){switch(this.day()){case 0:return"[\u0443] [\u043d\u0435\u0434\u0435\u0459\u0443] [\u0443] LT";case 3:return"[\u0443] [\u0441\u0440\u0435\u0434\u0443] [\u0443] LT";case 6:return"[\u0443] [\u0441\u0443\u0431\u043e\u0442\u0443] [\u0443] LT";case 1:case 2:case 4:case 5:return"[\u0443] dddd [\u0443] LT"}},lastDay:"[\u0458\u0443\u0447\u0435 \u0443] LT",lastWeek:function(){return["[\u043f\u0440\u043e\u0448\u043b\u0435] [\u043d\u0435\u0434\u0435\u0459\u0435] [\u0443] LT","[\u043f\u0440\u043e\u0448\u043b\u043e\u0433] [\u043f\u043e\u043d\u0435\u0434\u0435\u0459\u043a\u0430] [\u0443] LT","[\u043f\u0440\u043e\u0448\u043b\u043e\u0433] [\u0443\u0442\u043e\u0440\u043a\u0430] [\u0443] LT","[\u043f\u0440\u043e\u0448\u043b\u0435] [\u0441\u0440\u0435\u0434\u0435] [\u0443] LT","[\u043f\u0440\u043e\u0448\u043b\u043e\u0433] [\u0447\u0435\u0442\u0432\u0440\u0442\u043a\u0430] [\u0443] LT","[\u043f\u0440\u043e\u0448\u043b\u043e\u0433] [\u043f\u0435\u0442\u043a\u0430] [\u0443] LT","[\u043f\u0440\u043e\u0448\u043b\u0435] [\u0441\u0443\u0431\u043e\u0442\u0435] [\u0443] LT"][this.day()]},sameElse:"L"},relativeTime:{future:"\u0437\u0430 %s",past:"\u043f\u0440\u0435 %s",s:"\u043d\u0435\u043a\u043e\u043b\u0438\u043a\u043e \u0441\u0435\u043a\u0443\u043d\u0434\u0438",ss:Zn.translate,m:Zn.translate,mm:Zn.translate,h:Zn.translate,hh:Zn.translate,d:"\u0434\u0430\u043d",dd:Zn.translate,M:"\u043c\u0435\u0441\u0435\u0446",MM:Zn.translate,y:"\u0433\u043e\u0434\u0438\u043d\u0443",yy:Zn.translate},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:7}});var $n={words:{ss:["sekunda","sekunde","sekundi"],m:["jedan minut","jedne minute"],mm:["minut","minute","minuta"],h:["jedan sat","jednog sata"],hh:["sat","sata","sati"],dd:["dan","dana","dana"],MM:["mesec","meseca","meseci"],yy:["godina","godine","godina"]},correctGrammaticalCase:function(e,a){return 1===e?a[0]:e>=2&&e<=4?a[1]:a[2]},translate:function(e,a,t){var s=$n.words[t];return 1===t.length?a?s[0]:s[1]:e+" "+$n.correctGrammaticalCase(e,s)}};e.defineLocale("sr",{months:"januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar".split("_"),monthsShort:"jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.".split("_"),monthsParseExact:!0,weekdays:"nedelja_ponedeljak_utorak_sreda_\u010detvrtak_petak_subota".split("_"),weekdaysShort:"ned._pon._uto._sre._\u010det._pet._sub.".split("_"),weekdaysMin:"ne_po_ut_sr_\u010de_pe_su".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY H:mm",LLLL:"dddd, D. MMMM YYYY H:mm"},calendar:{sameDay:"[danas u] LT",nextDay:"[sutra u] LT",nextWeek:function(){switch(this.day()){case 0:return"[u] [nedelju] [u] LT";case 3:return"[u] [sredu] [u] LT";case 6:return"[u] [subotu] [u] LT";case 1:case 2:case 4:case 5:return"[u] dddd [u] LT"}},lastDay:"[ju\u010de u] LT",lastWeek:function(){return["[pro\u0161le] [nedelje] [u] LT","[pro\u0161log] [ponedeljka] [u] LT","[pro\u0161log] [utorka] [u] LT","[pro\u0161le] [srede] [u] LT","[pro\u0161log] [\u010detvrtka] [u] LT","[pro\u0161log] [petka] [u] LT","[pro\u0161le] [subote] [u] LT"][this.day()]},sameElse:"L"},relativeTime:{future:"za %s",past:"pre %s",s:"nekoliko sekundi",ss:$n.translate,m:$n.translate,mm:$n.translate,h:$n.translate,hh:$n.translate,d:"dan",dd:$n.translate,M:"mesec",MM:$n.translate,y:"godinu",yy:$n.translate},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:7}}),e.defineLocale("ss",{months:"Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split("_"),monthsShort:"Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo".split("_"),weekdays:"Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo".split("_"),weekdaysShort:"Lis_Umb_Lsb_Les_Lsi_Lsh_Umg".split("_"),weekdaysMin:"Li_Us_Lb_Lt_Ls_Lh_Ug".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"h:mm A",LTS:"h:mm:ss A",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY h:mm A",LLLL:"dddd, D MMMM YYYY h:mm A"},calendar:{sameDay:"[Namuhla nga] LT",nextDay:"[Kusasa nga] LT",nextWeek:"dddd [nga] LT",lastDay:"[Itolo nga] LT",lastWeek:"dddd [leliphelile] [nga] LT",sameElse:"L"},relativeTime:{future:"nga %s",past:"wenteka nga %s",s:"emizuzwana lomcane",ss:"%d mzuzwana",m:"umzuzu",mm:"%d emizuzu",h:"lihora",hh:"%d emahora",d:"lilanga",dd:"%d emalanga",M:"inyanga",MM:"%d tinyanga",y:"umnyaka",yy:"%d iminyaka"},meridiemParse:/ekuseni|emini|entsambama|ebusuku/,meridiem:function(e,a,t){return e<11?"ekuseni":e<15?"emini":e<19?"entsambama":"ebusuku"},meridiemHour:function(e,a){return 12===e&&(e=0),"ekuseni"===a?e:"emini"===a?e>=11?e:e+12:"entsambama"===a||"ebusuku"===a?0===e?0:e+12:void 0},dayOfMonthOrdinalParse:/\d{1,2}/,ordinal:"%d",week:{dow:1,doy:4}}),e.defineLocale("sv",{months:"januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december".split("_"),monthsShort:"jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec".split("_"),weekdays:"s\xf6ndag_m\xe5ndag_tisdag_onsdag_torsdag_fredag_l\xf6rdag".split("_"),weekdaysShort:"s\xf6n_m\xe5n_tis_ons_tor_fre_l\xf6r".split("_"),weekdaysMin:"s\xf6_m\xe5_ti_on_to_fr_l\xf6".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"YYYY-MM-DD",LL:"D MMMM YYYY",LLL:"D MMMM YYYY [kl.] HH:mm",LLLL:"dddd D MMMM YYYY [kl.] HH:mm",lll:"D MMM YYYY HH:mm",llll:"ddd D MMM YYYY HH:mm"},calendar:{sameDay:"[Idag] LT",nextDay:"[Imorgon] LT",lastDay:"[Ig\xe5r] LT",nextWeek:"[P\xe5] dddd LT",lastWeek:"[I] dddd[s] LT",sameElse:"L"},relativeTime:{future:"om %s",past:"f\xf6r %s sedan",s:"n\xe5gra sekunder",ss:"%d sekunder",m:"en minut",mm:"%d minuter",h:"en timme",hh:"%d timmar",d:"en dag",dd:"%d dagar",M:"en m\xe5nad",MM:"%d m\xe5nader",y:"ett \xe5r",yy:"%d \xe5r"},dayOfMonthOrdinalParse:/\d{1,2}(e|a)/,ordinal:function(e){var a=e%10;return e+(1==~~(e%100/10)?"e":1===a?"a":2===a?"a":"e")},week:{dow:1,doy:4}}),e.defineLocale("sw",{months:"Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba".split("_"),monthsShort:"Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des".split("_"),weekdays:"Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi".split("_"),weekdaysShort:"Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos".split("_"),weekdaysMin:"J2_J3_J4_J5_Al_Ij_J1".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[leo saa] LT",nextDay:"[kesho saa] LT",nextWeek:"[wiki ijayo] dddd [saat] LT",lastDay:"[jana] LT",lastWeek:"[wiki iliyopita] dddd [saat] LT",sameElse:"L"},relativeTime:{future:"%s baadaye",past:"tokea %s",s:"hivi punde",ss:"sekunde %d",m:"dakika moja",mm:"dakika %d",h:"saa limoja",hh:"masaa %d",d:"siku moja",dd:"masiku %d",M:"mwezi mmoja",MM:"miezi %d",y:"mwaka mmoja",yy:"miaka %d"},week:{dow:1,doy:7}});var Bn={1:"\u0be7",2:"\u0be8",3:"\u0be9",4:"\u0bea",5:"\u0beb",6:"\u0bec",7:"\u0bed",8:"\u0bee",9:"\u0bef",0:"\u0be6"},qn={"\u0be7":"1","\u0be8":"2","\u0be9":"3","\u0bea":"4","\u0beb":"5","\u0bec":"6","\u0bed":"7","\u0bee":"8","\u0bef":"9","\u0be6":"0"};e.defineLocale("ta",{months:"\u0b9c\u0ba9\u0bb5\u0bb0\u0bbf_\u0baa\u0bbf\u0baa\u0bcd\u0bb0\u0bb5\u0bb0\u0bbf_\u0bae\u0bbe\u0bb0\u0bcd\u0b9a\u0bcd_\u0b8f\u0baa\u0bcd\u0bb0\u0bb2\u0bcd_\u0bae\u0bc7_\u0b9c\u0bc2\u0ba9\u0bcd_\u0b9c\u0bc2\u0bb2\u0bc8_\u0b86\u0b95\u0bb8\u0bcd\u0b9f\u0bcd_\u0b9a\u0bc6\u0baa\u0bcd\u0b9f\u0bc6\u0bae\u0bcd\u0baa\u0bb0\u0bcd_\u0b85\u0b95\u0bcd\u0b9f\u0bc7\u0bbe\u0baa\u0bb0\u0bcd_\u0ba8\u0bb5\u0bae\u0bcd\u0baa\u0bb0\u0bcd_\u0b9f\u0bbf\u0b9a\u0bae\u0bcd\u0baa\u0bb0\u0bcd".split("_"),monthsShort:"\u0b9c\u0ba9\u0bb5\u0bb0\u0bbf_\u0baa\u0bbf\u0baa\u0bcd\u0bb0\u0bb5\u0bb0\u0bbf_\u0bae\u0bbe\u0bb0\u0bcd\u0b9a\u0bcd_\u0b8f\u0baa\u0bcd\u0bb0\u0bb2\u0bcd_\u0bae\u0bc7_\u0b9c\u0bc2\u0ba9\u0bcd_\u0b9c\u0bc2\u0bb2\u0bc8_\u0b86\u0b95\u0bb8\u0bcd\u0b9f\u0bcd_\u0b9a\u0bc6\u0baa\u0bcd\u0b9f\u0bc6\u0bae\u0bcd\u0baa\u0bb0\u0bcd_\u0b85\u0b95\u0bcd\u0b9f\u0bc7\u0bbe\u0baa\u0bb0\u0bcd_\u0ba8\u0bb5\u0bae\u0bcd\u0baa\u0bb0\u0bcd_\u0b9f\u0bbf\u0b9a\u0bae\u0bcd\u0baa\u0bb0\u0bcd".split("_"),weekdays:"\u0b9e\u0bbe\u0baf\u0bbf\u0bb1\u0bcd\u0bb1\u0bc1\u0b95\u0bcd\u0b95\u0bbf\u0bb4\u0bae\u0bc8_\u0ba4\u0bbf\u0b99\u0bcd\u0b95\u0b9f\u0bcd\u0b95\u0bbf\u0bb4\u0bae\u0bc8_\u0b9a\u0bc6\u0bb5\u0bcd\u0bb5\u0bbe\u0baf\u0bcd\u0b95\u0bbf\u0bb4\u0bae\u0bc8_\u0baa\u0bc1\u0ba4\u0ba9\u0bcd\u0b95\u0bbf\u0bb4\u0bae\u0bc8_\u0bb5\u0bbf\u0baf\u0bbe\u0bb4\u0b95\u0bcd\u0b95\u0bbf\u0bb4\u0bae\u0bc8_\u0bb5\u0bc6\u0bb3\u0bcd\u0bb3\u0bbf\u0b95\u0bcd\u0b95\u0bbf\u0bb4\u0bae\u0bc8_\u0b9a\u0ba9\u0bbf\u0b95\u0bcd\u0b95\u0bbf\u0bb4\u0bae\u0bc8".split("_"),weekdaysShort:"\u0b9e\u0bbe\u0baf\u0bbf\u0bb1\u0bc1_\u0ba4\u0bbf\u0b99\u0bcd\u0b95\u0bb3\u0bcd_\u0b9a\u0bc6\u0bb5\u0bcd\u0bb5\u0bbe\u0baf\u0bcd_\u0baa\u0bc1\u0ba4\u0ba9\u0bcd_\u0bb5\u0bbf\u0baf\u0bbe\u0bb4\u0ba9\u0bcd_\u0bb5\u0bc6\u0bb3\u0bcd\u0bb3\u0bbf_\u0b9a\u0ba9\u0bbf".split("_"),weekdaysMin:"\u0b9e\u0bbe_\u0ba4\u0bbf_\u0b9a\u0bc6_\u0baa\u0bc1_\u0bb5\u0bbf_\u0bb5\u0bc6_\u0b9a".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY, HH:mm",LLLL:"dddd, D MMMM YYYY, HH:mm"},calendar:{sameDay:"[\u0b87\u0ba9\u0bcd\u0bb1\u0bc1] LT",nextDay:"[\u0ba8\u0bbe\u0bb3\u0bc8] LT",nextWeek:"dddd, LT",lastDay:"[\u0ba8\u0bc7\u0bb1\u0bcd\u0bb1\u0bc1] LT",lastWeek:"[\u0b95\u0b9f\u0ba8\u0bcd\u0ba4 \u0bb5\u0bbe\u0bb0\u0bae\u0bcd] dddd, LT",sameElse:"L"},relativeTime:{future:"%s \u0b87\u0bb2\u0bcd",past:"%s \u0bae\u0bc1\u0ba9\u0bcd",s:"\u0b92\u0bb0\u0bc1 \u0b9a\u0bbf\u0bb2 \u0bb5\u0bbf\u0ba8\u0bbe\u0b9f\u0bbf\u0b95\u0bb3\u0bcd",ss:"%d \u0bb5\u0bbf\u0ba8\u0bbe\u0b9f\u0bbf\u0b95\u0bb3\u0bcd",m:"\u0b92\u0bb0\u0bc1 \u0ba8\u0bbf\u0bae\u0bbf\u0b9f\u0bae\u0bcd",mm:"%d \u0ba8\u0bbf\u0bae\u0bbf\u0b9f\u0b99\u0bcd\u0b95\u0bb3\u0bcd",h:"\u0b92\u0bb0\u0bc1 \u0bae\u0ba3\u0bbf \u0ba8\u0bc7\u0bb0\u0bae\u0bcd",hh:"%d \u0bae\u0ba3\u0bbf \u0ba8\u0bc7\u0bb0\u0bae\u0bcd",d:"\u0b92\u0bb0\u0bc1 \u0ba8\u0bbe\u0bb3\u0bcd",dd:"%d \u0ba8\u0bbe\u0b9f\u0bcd\u0b95\u0bb3\u0bcd",M:"\u0b92\u0bb0\u0bc1 \u0bae\u0bbe\u0ba4\u0bae\u0bcd",MM:"%d \u0bae\u0bbe\u0ba4\u0b99\u0bcd\u0b95\u0bb3\u0bcd",y:"\u0b92\u0bb0\u0bc1 \u0bb5\u0bb0\u0bc1\u0b9f\u0bae\u0bcd",yy:"%d \u0b86\u0ba3\u0bcd\u0b9f\u0bc1\u0b95\u0bb3\u0bcd"},dayOfMonthOrdinalParse:/\d{1,2}\u0bb5\u0ba4\u0bc1/,ordinal:function(e){return e+"\u0bb5\u0ba4\u0bc1"},preparse:function(e){return e.replace(/[\u0be7\u0be8\u0be9\u0bea\u0beb\u0bec\u0bed\u0bee\u0bef\u0be6]/g,function(e){return qn[e]})},postformat:function(e){return e.replace(/\d/g,function(e){return Bn[e]})},meridiemParse:/\u0baf\u0bbe\u0bae\u0bae\u0bcd|\u0bb5\u0bc8\u0b95\u0bb1\u0bc8|\u0b95\u0bbe\u0bb2\u0bc8|\u0ba8\u0ba3\u0bcd\u0baa\u0b95\u0bb2\u0bcd|\u0b8e\u0bb1\u0bcd\u0baa\u0bbe\u0b9f\u0bc1|\u0bae\u0bbe\u0bb2\u0bc8/,meridiem:function(e,a,t){return e<2?" \u0baf\u0bbe\u0bae\u0bae\u0bcd":e<6?" \u0bb5\u0bc8\u0b95\u0bb1\u0bc8":e<10?" \u0b95\u0bbe\u0bb2\u0bc8":e<14?" \u0ba8\u0ba3\u0bcd\u0baa\u0b95\u0bb2\u0bcd":e<18?" \u0b8e\u0bb1\u0bcd\u0baa\u0bbe\u0b9f\u0bc1":e<22?" \u0bae\u0bbe\u0bb2\u0bc8":" \u0baf\u0bbe\u0bae\u0bae\u0bcd"},meridiemHour:function(e,a){return 12===e&&(e=0),"\u0baf\u0bbe\u0bae\u0bae\u0bcd"===a?e<2?e:e+12:"\u0bb5\u0bc8\u0b95\u0bb1\u0bc8"===a||"\u0b95\u0bbe\u0bb2\u0bc8"===a?e:"\u0ba8\u0ba3\u0bcd\u0baa\u0b95\u0bb2\u0bcd"===a&&e>=10?e:e+12},week:{dow:0,doy:6}}),e.defineLocale("te",{months:"\u0c1c\u0c28\u0c35\u0c30\u0c3f_\u0c2b\u0c3f\u0c2c\u0c4d\u0c30\u0c35\u0c30\u0c3f_\u0c2e\u0c3e\u0c30\u0c4d\u0c1a\u0c3f_\u0c0f\u0c2a\u0c4d\u0c30\u0c3f\u0c32\u0c4d_\u0c2e\u0c47_\u0c1c\u0c42\u0c28\u0c4d_\u0c1c\u0c42\u0c32\u0c46\u0c56_\u0c06\u0c17\u0c38\u0c4d\u0c1f\u0c41_\u0c38\u0c46\u0c2a\u0c4d\u0c1f\u0c46\u0c02\u0c2c\u0c30\u0c4d_\u0c05\u0c15\u0c4d\u0c1f\u0c4b\u0c2c\u0c30\u0c4d_\u0c28\u0c35\u0c02\u0c2c\u0c30\u0c4d_\u0c21\u0c3f\u0c38\u0c46\u0c02\u0c2c\u0c30\u0c4d".split("_"),monthsShort:"\u0c1c\u0c28._\u0c2b\u0c3f\u0c2c\u0c4d\u0c30._\u0c2e\u0c3e\u0c30\u0c4d\u0c1a\u0c3f_\u0c0f\u0c2a\u0c4d\u0c30\u0c3f._\u0c2e\u0c47_\u0c1c\u0c42\u0c28\u0c4d_\u0c1c\u0c42\u0c32\u0c46\u0c56_\u0c06\u0c17._\u0c38\u0c46\u0c2a\u0c4d._\u0c05\u0c15\u0c4d\u0c1f\u0c4b._\u0c28\u0c35._\u0c21\u0c3f\u0c38\u0c46.".split("_"),monthsParseExact:!0,weekdays:"\u0c06\u0c26\u0c3f\u0c35\u0c3e\u0c30\u0c02_\u0c38\u0c4b\u0c2e\u0c35\u0c3e\u0c30\u0c02_\u0c2e\u0c02\u0c17\u0c33\u0c35\u0c3e\u0c30\u0c02_\u0c2c\u0c41\u0c27\u0c35\u0c3e\u0c30\u0c02_\u0c17\u0c41\u0c30\u0c41\u0c35\u0c3e\u0c30\u0c02_\u0c36\u0c41\u0c15\u0c4d\u0c30\u0c35\u0c3e\u0c30\u0c02_\u0c36\u0c28\u0c3f\u0c35\u0c3e\u0c30\u0c02".split("_"),weekdaysShort:"\u0c06\u0c26\u0c3f_\u0c38\u0c4b\u0c2e_\u0c2e\u0c02\u0c17\u0c33_\u0c2c\u0c41\u0c27_\u0c17\u0c41\u0c30\u0c41_\u0c36\u0c41\u0c15\u0c4d\u0c30_\u0c36\u0c28\u0c3f".split("_"),weekdaysMin:"\u0c06_\u0c38\u0c4b_\u0c2e\u0c02_\u0c2c\u0c41_\u0c17\u0c41_\u0c36\u0c41_\u0c36".split("_"),longDateFormat:{LT:"A h:mm",LTS:"A h:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY, A h:mm",LLLL:"dddd, D MMMM YYYY, A h:mm"},calendar:{sameDay:"[\u0c28\u0c47\u0c21\u0c41] LT",nextDay:"[\u0c30\u0c47\u0c2a\u0c41] LT",nextWeek:"dddd, LT",lastDay:"[\u0c28\u0c3f\u0c28\u0c4d\u0c28] LT",lastWeek:"[\u0c17\u0c24] dddd, LT",sameElse:"L"},relativeTime:{future:"%s \u0c32\u0c4b",past:"%s \u0c15\u0c4d\u0c30\u0c3f\u0c24\u0c02",s:"\u0c15\u0c4a\u0c28\u0c4d\u0c28\u0c3f \u0c15\u0c4d\u0c37\u0c23\u0c3e\u0c32\u0c41",ss:"%d \u0c38\u0c46\u0c15\u0c28\u0c4d\u0c32\u0c41",m:"\u0c12\u0c15 \u0c28\u0c3f\u0c2e\u0c3f\u0c37\u0c02",mm:"%d \u0c28\u0c3f\u0c2e\u0c3f\u0c37\u0c3e\u0c32\u0c41",h:"\u0c12\u0c15 \u0c17\u0c02\u0c1f",hh:"%d \u0c17\u0c02\u0c1f\u0c32\u0c41",d:"\u0c12\u0c15 \u0c30\u0c4b\u0c1c\u0c41",dd:"%d \u0c30\u0c4b\u0c1c\u0c41\u0c32\u0c41",M:"\u0c12\u0c15 \u0c28\u0c46\u0c32",MM:"%d \u0c28\u0c46\u0c32\u0c32\u0c41",y:"\u0c12\u0c15 \u0c38\u0c02\u0c35\u0c24\u0c4d\u0c38\u0c30\u0c02",yy:"%d \u0c38\u0c02\u0c35\u0c24\u0c4d\u0c38\u0c30\u0c3e\u0c32\u0c41"},dayOfMonthOrdinalParse:/\d{1,2}\u0c35/,ordinal:"%d\u0c35",meridiemParse:/\u0c30\u0c3e\u0c24\u0c4d\u0c30\u0c3f|\u0c09\u0c26\u0c2f\u0c02|\u0c2e\u0c27\u0c4d\u0c2f\u0c3e\u0c39\u0c4d\u0c28\u0c02|\u0c38\u0c3e\u0c2f\u0c02\u0c24\u0c4d\u0c30\u0c02/,meridiemHour:function(e,a){return 12===e&&(e=0),"\u0c30\u0c3e\u0c24\u0c4d\u0c30\u0c3f"===a?e<4?e:e+12:"\u0c09\u0c26\u0c2f\u0c02"===a?e:"\u0c2e\u0c27\u0c4d\u0c2f\u0c3e\u0c39\u0c4d\u0c28\u0c02"===a?e>=10?e:e+12:"\u0c38\u0c3e\u0c2f\u0c02\u0c24\u0c4d\u0c30\u0c02"===a?e+12:void 0},meridiem:function(e,a,t){return e<4?"\u0c30\u0c3e\u0c24\u0c4d\u0c30\u0c3f":e<10?"\u0c09\u0c26\u0c2f\u0c02":e<17?"\u0c2e\u0c27\u0c4d\u0c2f\u0c3e\u0c39\u0c4d\u0c28\u0c02":e<20?"\u0c38\u0c3e\u0c2f\u0c02\u0c24\u0c4d\u0c30\u0c02":"\u0c30\u0c3e\u0c24\u0c4d\u0c30\u0c3f"},week:{dow:0,doy:6}}),e.defineLocale("tet",{months:"Janeiru_Fevereiru_Marsu_Abril_Maiu_Juniu_Juliu_Augustu_Setembru_Outubru_Novembru_Dezembru".split("_"),monthsShort:"Jan_Fev_Mar_Abr_Mai_Jun_Jul_Aug_Set_Out_Nov_Dez".split("_"),weekdays:"Domingu_Segunda_Tersa_Kuarta_Kinta_Sexta_Sabadu".split("_"),weekdaysShort:"Dom_Seg_Ters_Kua_Kint_Sext_Sab".split("_"),weekdaysMin:"Do_Seg_Te_Ku_Ki_Sex_Sa".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[Ohin iha] LT",nextDay:"[Aban iha] LT",nextWeek:"dddd [iha] LT",lastDay:"[Horiseik iha] LT",lastWeek:"dddd [semana kotuk] [iha] LT",sameElse:"L"},relativeTime:{future:"iha %s",past:"%s liuba",s:"minutu balun",ss:"minutu %d",m:"minutu ida",mm:"minutus %d",h:"horas ida",hh:"horas %d",d:"loron ida",dd:"loron %d",M:"fulan ida",MM:"fulan %d",y:"tinan ida",yy:"tinan %d"},dayOfMonthOrdinalParse:/\d{1,2}(st|nd|rd|th)/,ordinal:function(e){var a=e%10;return e+(1==~~(e%100/10)?"th":1===a?"st":2===a?"nd":3===a?"rd":"th")},week:{dow:1,doy:4}}),e.defineLocale("th",{months:"\u0e21\u0e01\u0e23\u0e32\u0e04\u0e21_\u0e01\u0e38\u0e21\u0e20\u0e32\u0e1e\u0e31\u0e19\u0e18\u0e4c_\u0e21\u0e35\u0e19\u0e32\u0e04\u0e21_\u0e40\u0e21\u0e29\u0e32\u0e22\u0e19_\u0e1e\u0e24\u0e29\u0e20\u0e32\u0e04\u0e21_\u0e21\u0e34\u0e16\u0e38\u0e19\u0e32\u0e22\u0e19_\u0e01\u0e23\u0e01\u0e0e\u0e32\u0e04\u0e21_\u0e2a\u0e34\u0e07\u0e2b\u0e32\u0e04\u0e21_\u0e01\u0e31\u0e19\u0e22\u0e32\u0e22\u0e19_\u0e15\u0e38\u0e25\u0e32\u0e04\u0e21_\u0e1e\u0e24\u0e28\u0e08\u0e34\u0e01\u0e32\u0e22\u0e19_\u0e18\u0e31\u0e19\u0e27\u0e32\u0e04\u0e21".split("_"),monthsShort:"\u0e21.\u0e04._\u0e01.\u0e1e._\u0e21\u0e35.\u0e04._\u0e40\u0e21.\u0e22._\u0e1e.\u0e04._\u0e21\u0e34.\u0e22._\u0e01.\u0e04._\u0e2a.\u0e04._\u0e01.\u0e22._\u0e15.\u0e04._\u0e1e.\u0e22._\u0e18.\u0e04.".split("_"),monthsParseExact:!0,weekdays:"\u0e2d\u0e32\u0e17\u0e34\u0e15\u0e22\u0e4c_\u0e08\u0e31\u0e19\u0e17\u0e23\u0e4c_\u0e2d\u0e31\u0e07\u0e04\u0e32\u0e23_\u0e1e\u0e38\u0e18_\u0e1e\u0e24\u0e2b\u0e31\u0e2a\u0e1a\u0e14\u0e35_\u0e28\u0e38\u0e01\u0e23\u0e4c_\u0e40\u0e2a\u0e32\u0e23\u0e4c".split("_"),weekdaysShort:"\u0e2d\u0e32\u0e17\u0e34\u0e15\u0e22\u0e4c_\u0e08\u0e31\u0e19\u0e17\u0e23\u0e4c_\u0e2d\u0e31\u0e07\u0e04\u0e32\u0e23_\u0e1e\u0e38\u0e18_\u0e1e\u0e24\u0e2b\u0e31\u0e2a_\u0e28\u0e38\u0e01\u0e23\u0e4c_\u0e40\u0e2a\u0e32\u0e23\u0e4c".split("_"),weekdaysMin:"\u0e2d\u0e32._\u0e08._\u0e2d._\u0e1e._\u0e1e\u0e24._\u0e28._\u0e2a.".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY \u0e40\u0e27\u0e25\u0e32 H:mm",LLLL:"\u0e27\u0e31\u0e19dddd\u0e17\u0e35\u0e48 D MMMM YYYY \u0e40\u0e27\u0e25\u0e32 H:mm"},meridiemParse:/\u0e01\u0e48\u0e2d\u0e19\u0e40\u0e17\u0e35\u0e48\u0e22\u0e07|\u0e2b\u0e25\u0e31\u0e07\u0e40\u0e17\u0e35\u0e48\u0e22\u0e07/,isPM:function(e){return"\u0e2b\u0e25\u0e31\u0e07\u0e40\u0e17\u0e35\u0e48\u0e22\u0e07"===e},meridiem:function(e,a,t){return e<12?"\u0e01\u0e48\u0e2d\u0e19\u0e40\u0e17\u0e35\u0e48\u0e22\u0e07":"\u0e2b\u0e25\u0e31\u0e07\u0e40\u0e17\u0e35\u0e48\u0e22\u0e07"},calendar:{sameDay:"[\u0e27\u0e31\u0e19\u0e19\u0e35\u0e49 \u0e40\u0e27\u0e25\u0e32] LT",nextDay:"[\u0e1e\u0e23\u0e38\u0e48\u0e07\u0e19\u0e35\u0e49 \u0e40\u0e27\u0e25\u0e32] LT",nextWeek:"dddd[\u0e2b\u0e19\u0e49\u0e32 \u0e40\u0e27\u0e25\u0e32] LT",lastDay:"[\u0e40\u0e21\u0e37\u0e48\u0e2d\u0e27\u0e32\u0e19\u0e19\u0e35\u0e49 \u0e40\u0e27\u0e25\u0e32] LT",lastWeek:"[\u0e27\u0e31\u0e19]dddd[\u0e17\u0e35\u0e48\u0e41\u0e25\u0e49\u0e27 \u0e40\u0e27\u0e25\u0e32] LT",sameElse:"L"},relativeTime:{future:"\u0e2d\u0e35\u0e01 %s",past:"%s\u0e17\u0e35\u0e48\u0e41\u0e25\u0e49\u0e27",s:"\u0e44\u0e21\u0e48\u0e01\u0e35\u0e48\u0e27\u0e34\u0e19\u0e32\u0e17\u0e35",ss:"%d \u0e27\u0e34\u0e19\u0e32\u0e17\u0e35",m:"1 \u0e19\u0e32\u0e17\u0e35",mm:"%d \u0e19\u0e32\u0e17\u0e35",h:"1 \u0e0a\u0e31\u0e48\u0e27\u0e42\u0e21\u0e07",hh:"%d \u0e0a\u0e31\u0e48\u0e27\u0e42\u0e21\u0e07",d:"1 \u0e27\u0e31\u0e19",dd:"%d \u0e27\u0e31\u0e19",M:"1 \u0e40\u0e14\u0e37\u0e2d\u0e19",MM:"%d \u0e40\u0e14\u0e37\u0e2d\u0e19",y:"1 \u0e1b\u0e35",yy:"%d \u0e1b\u0e35"}}),e.defineLocale("tl-ph",{months:"Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre".split("_"),monthsShort:"Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis".split("_"),weekdays:"Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado".split("_"),weekdaysShort:"Lin_Lun_Mar_Miy_Huw_Biy_Sab".split("_"),weekdaysMin:"Li_Lu_Ma_Mi_Hu_Bi_Sab".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"MM/D/YYYY",LL:"MMMM D, YYYY",LLL:"MMMM D, YYYY HH:mm",LLLL:"dddd, MMMM DD, YYYY HH:mm"},calendar:{sameDay:"LT [ngayong araw]",nextDay:"[Bukas ng] LT",nextWeek:"LT [sa susunod na] dddd",lastDay:"LT [kahapon]",lastWeek:"LT [noong nakaraang] dddd",sameElse:"L"},relativeTime:{future:"sa loob ng %s",past:"%s ang nakalipas",s:"ilang segundo",ss:"%d segundo",m:"isang minuto",mm:"%d minuto",h:"isang oras",hh:"%d oras",d:"isang araw",dd:"%d araw",M:"isang buwan",MM:"%d buwan",y:"isang taon",yy:"%d taon"},dayOfMonthOrdinalParse:/\d{1,2}/,ordinal:function(e){return e},week:{dow:1,doy:4}});var Qn="pagh_wa\u2019_cha\u2019_wej_loS_vagh_jav_Soch_chorgh_Hut".split("_");e.defineLocale("tlh",{months:"tera\u2019 jar wa\u2019_tera\u2019 jar cha\u2019_tera\u2019 jar wej_tera\u2019 jar loS_tera\u2019 jar vagh_tera\u2019 jar jav_tera\u2019 jar Soch_tera\u2019 jar chorgh_tera\u2019 jar Hut_tera\u2019 jar wa\u2019maH_tera\u2019 jar wa\u2019maH wa\u2019_tera\u2019 jar wa\u2019maH cha\u2019".split("_"),monthsShort:"jar wa\u2019_jar cha\u2019_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa\u2019maH_jar wa\u2019maH wa\u2019_jar wa\u2019maH cha\u2019".split("_"),monthsParseExact:!0,weekdays:"lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj".split("_"),weekdaysShort:"lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj".split("_"),weekdaysMin:"lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[DaHjaj] LT",nextDay:"[wa\u2019leS] LT",nextWeek:"LLL",lastDay:"[wa\u2019Hu\u2019] LT",lastWeek:"LLL",sameElse:"L"},relativeTime:{future:function(e){var a=e;return a=-1!==e.indexOf("jaj")?a.slice(0,-3)+"leS":-1!==e.indexOf("jar")?a.slice(0,-3)+"waQ":-1!==e.indexOf("DIS")?a.slice(0,-3)+"nem":a+" pIq"},past:function(e){var a=e;return a=-1!==e.indexOf("jaj")?a.slice(0,-3)+"Hu\u2019":-1!==e.indexOf("jar")?a.slice(0,-3)+"wen":-1!==e.indexOf("DIS")?a.slice(0,-3)+"ben":a+" ret"},s:"puS lup",ss:xa,m:"wa\u2019 tup",mm:xa,h:"wa\u2019 rep",hh:xa,d:"wa\u2019 jaj",dd:xa,M:"wa\u2019 jar",MM:xa,y:"wa\u2019 DIS",yy:xa},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}});var Xn={1:"'inci",5:"'inci",8:"'inci",70:"'inci",80:"'inci",2:"'nci",7:"'nci",20:"'nci",50:"'nci",3:"'\xfcnc\xfc",4:"'\xfcnc\xfc",100:"'\xfcnc\xfc",6:"'nc\u0131",9:"'uncu",10:"'uncu",30:"'uncu",60:"'\u0131nc\u0131",90:"'\u0131nc\u0131"};e.defineLocale("tr",{months:"Ocak_\u015eubat_Mart_Nisan_May\u0131s_Haziran_Temmuz_A\u011fustos_Eyl\xfcl_Ekim_Kas\u0131m_Aral\u0131k".split("_"),monthsShort:"Oca_\u015eub_Mar_Nis_May_Haz_Tem_A\u011fu_Eyl_Eki_Kas_Ara".split("_"),weekdays:"Pazar_Pazartesi_Sal\u0131_\xc7ar\u015famba_Per\u015fembe_Cuma_Cumartesi".split("_"),weekdaysShort:"Paz_Pts_Sal_\xc7ar_Per_Cum_Cts".split("_"),weekdaysMin:"Pz_Pt_Sa_\xc7a_Pe_Cu_Ct".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[bug\xfcn saat] LT",nextDay:"[yar\u0131n saat] LT",nextWeek:"[gelecek] dddd [saat] LT",lastDay:"[d\xfcn] LT",lastWeek:"[ge\xe7en] dddd [saat] LT",sameElse:"L"},relativeTime:{future:"%s sonra",past:"%s \xf6nce",s:"birka\xe7 saniye",ss:"%d saniye",m:"bir dakika",mm:"%d dakika",h:"bir saat",hh:"%d saat",d:"bir g\xfcn",dd:"%d g\xfcn",M:"bir ay",MM:"%d ay",y:"bir y\u0131l",yy:"%d y\u0131l"},dayOfMonthOrdinalParse:/\d{1,2}'(inci|nci|\xfcnc\xfc|nc\u0131|uncu|\u0131nc\u0131)/,ordinal:function(e){if(0===e)return e+"'\u0131nc\u0131";var a=e%10;return e+(Xn[a]||Xn[e%100-a]||Xn[e>=100?100:null])},week:{dow:1,doy:7}}),e.defineLocale("tzl",{months:"Januar_Fevraglh_Mar\xe7_Avr\xefu_Mai_G\xfcn_Julia_Guscht_Setemvar_Listop\xe4ts_Noemvar_Zecemvar".split("_"),monthsShort:"Jan_Fev_Mar_Avr_Mai_G\xfcn_Jul_Gus_Set_Lis_Noe_Zec".split("_"),weekdays:"S\xfaladi_L\xfane\xe7i_Maitzi_M\xe1rcuri_Xh\xfaadi_Vi\xe9ner\xe7i_S\xe1turi".split("_"),weekdaysShort:"S\xfal_L\xfan_Mai_M\xe1r_Xh\xfa_Vi\xe9_S\xe1t".split("_"),weekdaysMin:"S\xfa_L\xfa_Ma_M\xe1_Xh_Vi_S\xe1".split("_"),longDateFormat:{LT:"HH.mm",LTS:"HH.mm.ss",L:"DD.MM.YYYY",LL:"D. MMMM [dallas] YYYY",LLL:"D. MMMM [dallas] YYYY HH.mm",LLLL:"dddd, [li] D. MMMM [dallas] YYYY HH.mm"},meridiemParse:/d\'o|d\'a/i,isPM:function(e){return"d'o"===e.toLowerCase()},meridiem:function(e,a,t){return e>11?t?"d'o":"D'O":t?"d'a":"D'A"},calendar:{sameDay:"[oxhi \xe0] LT",nextDay:"[dem\xe0 \xe0] LT",nextWeek:"dddd [\xe0] LT",lastDay:"[ieiri \xe0] LT",lastWeek:"[s\xfcr el] dddd [lasteu \xe0] LT",sameElse:"L"},relativeTime:{future:"osprei %s",past:"ja%s",s:Pa,ss:Pa,m:Pa,mm:Pa,h:Pa,hh:Pa,d:Pa,dd:Pa,M:Pa,MM:Pa,y:Pa,yy:Pa},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}}),e.defineLocale("tzm-latn",{months:"innayr_br\u02e4ayr\u02e4_mar\u02e4s\u02e4_ibrir_mayyw_ywnyw_ywlywz_\u0263w\u0161t_\u0161wtanbir_kt\u02e4wbr\u02e4_nwwanbir_dwjnbir".split("_"),monthsShort:"innayr_br\u02e4ayr\u02e4_mar\u02e4s\u02e4_ibrir_mayyw_ywnyw_ywlywz_\u0263w\u0161t_\u0161wtanbir_kt\u02e4wbr\u02e4_nwwanbir_dwjnbir".split("_"),weekdays:"asamas_aynas_asinas_akras_akwas_asimwas_asi\u1e0dyas".split("_"),weekdaysShort:"asamas_aynas_asinas_akras_akwas_asimwas_asi\u1e0dyas".split("_"),weekdaysMin:"asamas_aynas_asinas_akras_akwas_asimwas_asi\u1e0dyas".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},calendar:{sameDay:"[asdkh g] LT",nextDay:"[aska g] LT",nextWeek:"dddd [g] LT",lastDay:"[assant g] LT",lastWeek:"dddd [g] LT",sameElse:"L"},relativeTime:{future:"dadkh s yan %s",past:"yan %s",s:"imik",ss:"%d imik",m:"minu\u1e0d",mm:"%d minu\u1e0d",h:"sa\u025ba",hh:"%d tassa\u025bin",d:"ass",dd:"%d ossan",M:"ayowr",MM:"%d iyyirn",y:"asgas",yy:"%d isgasn"},week:{dow:6,doy:12}}),e.defineLocale("tzm",{months:"\u2d49\u2d4f\u2d4f\u2d30\u2d62\u2d54_\u2d31\u2d55\u2d30\u2d62\u2d55_\u2d4e\u2d30\u2d55\u2d5a_\u2d49\u2d31\u2d54\u2d49\u2d54_\u2d4e\u2d30\u2d62\u2d62\u2d53_\u2d62\u2d53\u2d4f\u2d62\u2d53_\u2d62\u2d53\u2d4d\u2d62\u2d53\u2d63_\u2d56\u2d53\u2d5b\u2d5c_\u2d5b\u2d53\u2d5c\u2d30\u2d4f\u2d31\u2d49\u2d54_\u2d3d\u2d5f\u2d53\u2d31\u2d55_\u2d4f\u2d53\u2d61\u2d30\u2d4f\u2d31\u2d49\u2d54_\u2d37\u2d53\u2d4a\u2d4f\u2d31\u2d49\u2d54".split("_"),monthsShort:"\u2d49\u2d4f\u2d4f\u2d30\u2d62\u2d54_\u2d31\u2d55\u2d30\u2d62\u2d55_\u2d4e\u2d30\u2d55\u2d5a_\u2d49\u2d31\u2d54\u2d49\u2d54_\u2d4e\u2d30\u2d62\u2d62\u2d53_\u2d62\u2d53\u2d4f\u2d62\u2d53_\u2d62\u2d53\u2d4d\u2d62\u2d53\u2d63_\u2d56\u2d53\u2d5b\u2d5c_\u2d5b\u2d53\u2d5c\u2d30\u2d4f\u2d31\u2d49\u2d54_\u2d3d\u2d5f\u2d53\u2d31\u2d55_\u2d4f\u2d53\u2d61\u2d30\u2d4f\u2d31\u2d49\u2d54_\u2d37\u2d53\u2d4a\u2d4f\u2d31\u2d49\u2d54".split("_"),weekdays:"\u2d30\u2d59\u2d30\u2d4e\u2d30\u2d59_\u2d30\u2d62\u2d4f\u2d30\u2d59_\u2d30\u2d59\u2d49\u2d4f\u2d30\u2d59_\u2d30\u2d3d\u2d54\u2d30\u2d59_\u2d30\u2d3d\u2d61\u2d30\u2d59_\u2d30\u2d59\u2d49\u2d4e\u2d61\u2d30\u2d59_\u2d30\u2d59\u2d49\u2d39\u2d62\u2d30\u2d59".split("_"),weekdaysShort:"\u2d30\u2d59\u2d30\u2d4e\u2d30\u2d59_\u2d30\u2d62\u2d4f\u2d30\u2d59_\u2d30\u2d59\u2d49\u2d4f\u2d30\u2d59_\u2d30\u2d3d\u2d54\u2d30\u2d59_\u2d30\u2d3d\u2d61\u2d30\u2d59_\u2d30\u2d59\u2d49\u2d4e\u2d61\u2d30\u2d59_\u2d30\u2d59\u2d49\u2d39\u2d62\u2d30\u2d59".split("_"),weekdaysMin:"\u2d30\u2d59\u2d30\u2d4e\u2d30\u2d59_\u2d30\u2d62\u2d4f\u2d30\u2d59_\u2d30\u2d59\u2d49\u2d4f\u2d30\u2d59_\u2d30\u2d3d\u2d54\u2d30\u2d59_\u2d30\u2d3d\u2d61\u2d30\u2d59_\u2d30\u2d59\u2d49\u2d4e\u2d61\u2d30\u2d59_\u2d30\u2d59\u2d49\u2d39\u2d62\u2d30\u2d59".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},calendar:{sameDay:"[\u2d30\u2d59\u2d37\u2d45 \u2d34] LT",nextDay:"[\u2d30\u2d59\u2d3d\u2d30 \u2d34] LT",nextWeek:"dddd [\u2d34] LT",lastDay:"[\u2d30\u2d5a\u2d30\u2d4f\u2d5c \u2d34] LT",lastWeek:"dddd [\u2d34] LT",sameElse:"L"},relativeTime:{future:"\u2d37\u2d30\u2d37\u2d45 \u2d59 \u2d62\u2d30\u2d4f %s",past:"\u2d62\u2d30\u2d4f %s",s:"\u2d49\u2d4e\u2d49\u2d3d",ss:"%d \u2d49\u2d4e\u2d49\u2d3d",m:"\u2d4e\u2d49\u2d4f\u2d53\u2d3a",mm:"%d \u2d4e\u2d49\u2d4f\u2d53\u2d3a",h:"\u2d59\u2d30\u2d44\u2d30",hh:"%d \u2d5c\u2d30\u2d59\u2d59\u2d30\u2d44\u2d49\u2d4f",d:"\u2d30\u2d59\u2d59",dd:"%d o\u2d59\u2d59\u2d30\u2d4f",M:"\u2d30\u2d62o\u2d53\u2d54",MM:"%d \u2d49\u2d62\u2d62\u2d49\u2d54\u2d4f",y:"\u2d30\u2d59\u2d33\u2d30\u2d59",yy:"%d \u2d49\u2d59\u2d33\u2d30\u2d59\u2d4f"},week:{dow:6,doy:12}}),e.defineLocale("uk",{months:{format:"\u0441\u0456\u0447\u043d\u044f_\u043b\u044e\u0442\u043e\u0433\u043e_\u0431\u0435\u0440\u0435\u0437\u043d\u044f_\u043a\u0432\u0456\u0442\u043d\u044f_\u0442\u0440\u0430\u0432\u043d\u044f_\u0447\u0435\u0440\u0432\u043d\u044f_\u043b\u0438\u043f\u043d\u044f_\u0441\u0435\u0440\u043f\u043d\u044f_\u0432\u0435\u0440\u0435\u0441\u043d\u044f_\u0436\u043e\u0432\u0442\u043d\u044f_\u043b\u0438\u0441\u0442\u043e\u043f\u0430\u0434\u0430_\u0433\u0440\u0443\u0434\u043d\u044f".split("_"),standalone:"\u0441\u0456\u0447\u0435\u043d\u044c_\u043b\u044e\u0442\u0438\u0439_\u0431\u0435\u0440\u0435\u0437\u0435\u043d\u044c_\u043a\u0432\u0456\u0442\u0435\u043d\u044c_\u0442\u0440\u0430\u0432\u0435\u043d\u044c_\u0447\u0435\u0440\u0432\u0435\u043d\u044c_\u043b\u0438\u043f\u0435\u043d\u044c_\u0441\u0435\u0440\u043f\u0435\u043d\u044c_\u0432\u0435\u0440\u0435\u0441\u0435\u043d\u044c_\u0436\u043e\u0432\u0442\u0435\u043d\u044c_\u043b\u0438\u0441\u0442\u043e\u043f\u0430\u0434_\u0433\u0440\u0443\u0434\u0435\u043d\u044c".split("_")},monthsShort:"\u0441\u0456\u0447_\u043b\u044e\u0442_\u0431\u0435\u0440_\u043a\u0432\u0456\u0442_\u0442\u0440\u0430\u0432_\u0447\u0435\u0440\u0432_\u043b\u0438\u043f_\u0441\u0435\u0440\u043f_\u0432\u0435\u0440_\u0436\u043e\u0432\u0442_\u043b\u0438\u0441\u0442_\u0433\u0440\u0443\u0434".split("_"),weekdays:function(e,a){var t={nominative:"\u043d\u0435\u0434\u0456\u043b\u044f_\u043f\u043e\u043d\u0435\u0434\u0456\u043b\u043e\u043a_\u0432\u0456\u0432\u0442\u043e\u0440\u043e\u043a_\u0441\u0435\u0440\u0435\u0434\u0430_\u0447\u0435\u0442\u0432\u0435\u0440_\u043f\u2019\u044f\u0442\u043d\u0438\u0446\u044f_\u0441\u0443\u0431\u043e\u0442\u0430".split("_"),accusative:"\u043d\u0435\u0434\u0456\u043b\u044e_\u043f\u043e\u043d\u0435\u0434\u0456\u043b\u043e\u043a_\u0432\u0456\u0432\u0442\u043e\u0440\u043e\u043a_\u0441\u0435\u0440\u0435\u0434\u0443_\u0447\u0435\u0442\u0432\u0435\u0440_\u043f\u2019\u044f\u0442\u043d\u0438\u0446\u044e_\u0441\u0443\u0431\u043e\u0442\u0443".split("_"),genitive:"\u043d\u0435\u0434\u0456\u043b\u0456_\u043f\u043e\u043d\u0435\u0434\u0456\u043b\u043a\u0430_\u0432\u0456\u0432\u0442\u043e\u0440\u043a\u0430_\u0441\u0435\u0440\u0435\u0434\u0438_\u0447\u0435\u0442\u0432\u0435\u0440\u0433\u0430_\u043f\u2019\u044f\u0442\u043d\u0438\u0446\u0456_\u0441\u0443\u0431\u043e\u0442\u0438".split("_")};return e?t[/(\[[\u0412\u0432\u0423\u0443]\]) ?dddd/.test(a)?"accusative":/\[?(?:\u043c\u0438\u043d\u0443\u043b\u043e\u0457|\u043d\u0430\u0441\u0442\u0443\u043f\u043d\u043e\u0457)? ?\] ?dddd/.test(a)?"genitive":"nominative"][e.day()]:t.nominative},weekdaysShort:"\u043d\u0434_\u043f\u043d_\u0432\u0442_\u0441\u0440_\u0447\u0442_\u043f\u0442_\u0441\u0431".split("_"),weekdaysMin:"\u043d\u0434_\u043f\u043d_\u0432\u0442_\u0441\u0440_\u0447\u0442_\u043f\u0442_\u0441\u0431".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D MMMM YYYY \u0440.",LLL:"D MMMM YYYY \u0440., HH:mm",LLLL:"dddd, D MMMM YYYY \u0440., HH:mm"},calendar:{sameDay:Wa("[\u0421\u044c\u043e\u0433\u043e\u0434\u043d\u0456 "),nextDay:Wa("[\u0417\u0430\u0432\u0442\u0440\u0430 "),lastDay:Wa("[\u0412\u0447\u043e\u0440\u0430 "),nextWeek:Wa("[\u0423] dddd ["),lastWeek:function(){switch(this.day()){case 0:case 3:case 5:case 6:return Wa("[\u041c\u0438\u043d\u0443\u043b\u043e\u0457] dddd [").call(this);case 1:case 2:case 4:return Wa("[\u041c\u0438\u043d\u0443\u043b\u043e\u0433\u043e] dddd [").call(this)}},sameElse:"L"},relativeTime:{future:"\u0437\u0430 %s",past:"%s \u0442\u043e\u043c\u0443",s:"\u0434\u0435\u043a\u0456\u043b\u044c\u043a\u0430 \u0441\u0435\u043a\u0443\u043d\u0434",ss:Oa,m:Oa,mm:Oa,h:"\u0433\u043e\u0434\u0438\u043d\u0443",hh:Oa,d:"\u0434\u0435\u043d\u044c",dd:Oa,M:"\u043c\u0456\u0441\u044f\u0446\u044c",MM:Oa,y:"\u0440\u0456\u043a",yy:Oa},meridiemParse:/\u043d\u043e\u0447\u0456|\u0440\u0430\u043d\u043a\u0443|\u0434\u043d\u044f|\u0432\u0435\u0447\u043e\u0440\u0430/,isPM:function(e){return/^(\u0434\u043d\u044f|\u0432\u0435\u0447\u043e\u0440\u0430)$/.test(e)},meridiem:function(e,a,t){return e<4?"\u043d\u043e\u0447\u0456":e<12?"\u0440\u0430\u043d\u043a\u0443":e<17?"\u0434\u043d\u044f":"\u0432\u0435\u0447\u043e\u0440\u0430"},dayOfMonthOrdinalParse:/\d{1,2}-(\u0439|\u0433\u043e)/,ordinal:function(e,a){switch(a){case"M":case"d":case"DDD":case"w":case"W":return e+"-\u0439";case"D":return e+"-\u0433\u043e";default:return e}},week:{dow:1,doy:7}});var ed=["\u062c\u0646\u0648\u0631\u06cc","\u0641\u0631\u0648\u0631\u06cc","\u0645\u0627\u0631\u0686","\u0627\u067e\u0631\u06cc\u0644","\u0645\u0626\u06cc","\u062c\u0648\u0646","\u062c\u0648\u0644\u0627\u0626\u06cc","\u0627\u06af\u0633\u062a","\u0633\u062a\u0645\u0628\u0631","\u0627\u06a9\u062a\u0648\u0628\u0631","\u0646\u0648\u0645\u0628\u0631","\u062f\u0633\u0645\u0628\u0631"],ad=["\u0627\u062a\u0648\u0627\u0631","\u067e\u06cc\u0631","\u0645\u0646\u06af\u0644","\u0628\u062f\u06be","\u062c\u0645\u0639\u0631\u0627\u062a","\u062c\u0645\u0639\u06c1","\u06c1\u0641\u062a\u06c1"];return e.defineLocale("ur",{months:ed,monthsShort:ed,weekdays:ad,weekdaysShort:ad,weekdaysMin:ad,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd\u060c D MMMM YYYY HH:mm"},meridiemParse:/\u0635\u0628\u062d|\u0634\u0627\u0645/,isPM:function(e){return"\u0634\u0627\u0645"===e},meridiem:function(e,a,t){return e<12?"\u0635\u0628\u062d":"\u0634\u0627\u0645"},calendar:{sameDay:"[\u0622\u062c \u0628\u0648\u0642\u062a] LT",nextDay:"[\u06a9\u0644 \u0628\u0648\u0642\u062a] LT",nextWeek:"dddd [\u0628\u0648\u0642\u062a] LT",lastDay:"[\u06af\u0630\u0634\u062a\u06c1 \u0631\u0648\u0632 \u0628\u0648\u0642\u062a] LT",lastWeek:"[\u06af\u0630\u0634\u062a\u06c1] dddd [\u0628\u0648\u0642\u062a] LT",sameElse:"L"},relativeTime:{future:"%s \u0628\u0639\u062f",past:"%s \u0642\u0628\u0644",s:"\u0686\u0646\u062f \u0633\u06cc\u06a9\u0646\u0688",ss:"%d \u0633\u06cc\u06a9\u0646\u0688",m:"\u0627\u06cc\u06a9 \u0645\u0646\u0679",mm:"%d \u0645\u0646\u0679",h:"\u0627\u06cc\u06a9 \u06af\u06be\u0646\u0679\u06c1",hh:"%d \u06af\u06be\u0646\u0679\u06d2",d:"\u0627\u06cc\u06a9 \u062f\u0646",dd:"%d \u062f\u0646",M:"\u0627\u06cc\u06a9 \u0645\u0627\u06c1",MM:"%d \u0645\u0627\u06c1",y:"\u0627\u06cc\u06a9 \u0633\u0627\u0644",yy:"%d \u0633\u0627\u0644"},preparse:function(e){return e.replace(/\u060c/g,",")},postformat:function(e){return e.replace(/,/g,"\u060c")},week:{dow:1,doy:4}}),e.defineLocale("uz-latn",{months:"Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr".split("_"),monthsShort:"Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek".split("_"),weekdays:"Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba".split("_"),weekdaysShort:"Yak_Dush_Sesh_Chor_Pay_Jum_Shan".split("_"),weekdaysMin:"Ya_Du_Se_Cho_Pa_Ju_Sha".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"D MMMM YYYY, dddd HH:mm"},calendar:{sameDay:"[Bugun soat] LT [da]",nextDay:"[Ertaga] LT [da]",nextWeek:"dddd [kuni soat] LT [da]",lastDay:"[Kecha soat] LT [da]",lastWeek:"[O'tgan] dddd [kuni soat] LT [da]",sameElse:"L"},relativeTime:{future:"Yaqin %s ichida",past:"Bir necha %s oldin",s:"soniya",ss:"%d soniya",m:"bir daqiqa",mm:"%d daqiqa",h:"bir soat",hh:"%d soat",d:"bir kun",dd:"%d kun",M:"bir oy",MM:"%d oy",y:"bir yil",yy:"%d yil"},week:{dow:1,doy:7}}),e.defineLocale("uz",{months:"\u044f\u043d\u0432\u0430\u0440_\u0444\u0435\u0432\u0440\u0430\u043b_\u043c\u0430\u0440\u0442_\u0430\u043f\u0440\u0435\u043b_\u043c\u0430\u0439_\u0438\u044e\u043d_\u0438\u044e\u043b_\u0430\u0432\u0433\u0443\u0441\u0442_\u0441\u0435\u043d\u0442\u044f\u0431\u0440_\u043e\u043a\u0442\u044f\u0431\u0440_\u043d\u043e\u044f\u0431\u0440_\u0434\u0435\u043a\u0430\u0431\u0440".split("_"),monthsShort:"\u044f\u043d\u0432_\u0444\u0435\u0432_\u043c\u0430\u0440_\u0430\u043f\u0440_\u043c\u0430\u0439_\u0438\u044e\u043d_\u0438\u044e\u043b_\u0430\u0432\u0433_\u0441\u0435\u043d_\u043e\u043a\u0442_\u043d\u043e\u044f_\u0434\u0435\u043a".split("_"),weekdays:"\u042f\u043a\u0448\u0430\u043d\u0431\u0430_\u0414\u0443\u0448\u0430\u043d\u0431\u0430_\u0421\u0435\u0448\u0430\u043d\u0431\u0430_\u0427\u043e\u0440\u0448\u0430\u043d\u0431\u0430_\u041f\u0430\u0439\u0448\u0430\u043d\u0431\u0430_\u0416\u0443\u043c\u0430_\u0428\u0430\u043d\u0431\u0430".split("_"),weekdaysShort:"\u042f\u043a\u0448_\u0414\u0443\u0448_\u0421\u0435\u0448_\u0427\u043e\u0440_\u041f\u0430\u0439_\u0416\u0443\u043c_\u0428\u0430\u043d".split("_"),weekdaysMin:"\u042f\u043a_\u0414\u0443_\u0421\u0435_\u0427\u043e_\u041f\u0430_\u0416\u0443_\u0428\u0430".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"D MMMM YYYY, dddd HH:mm"},calendar:{sameDay:"[\u0411\u0443\u0433\u0443\u043d \u0441\u043e\u0430\u0442] LT [\u0434\u0430]",nextDay:"[\u042d\u0440\u0442\u0430\u0433\u0430] LT [\u0434\u0430]",nextWeek:"dddd [\u043a\u0443\u043d\u0438 \u0441\u043e\u0430\u0442] LT [\u0434\u0430]",lastDay:"[\u041a\u0435\u0447\u0430 \u0441\u043e\u0430\u0442] LT [\u0434\u0430]",lastWeek:"[\u0423\u0442\u0433\u0430\u043d] dddd [\u043a\u0443\u043d\u0438 \u0441\u043e\u0430\u0442] LT [\u0434\u0430]",sameElse:"L"},relativeTime:{future:"\u042f\u043a\u0438\u043d %s \u0438\u0447\u0438\u0434\u0430",past:"\u0411\u0438\u0440 \u043d\u0435\u0447\u0430 %s \u043e\u043b\u0434\u0438\u043d",s:"\u0444\u0443\u0440\u0441\u0430\u0442",ss:"%d \u0444\u0443\u0440\u0441\u0430\u0442",m:"\u0431\u0438\u0440 \u0434\u0430\u043a\u0438\u043a\u0430",mm:"%d \u0434\u0430\u043a\u0438\u043a\u0430",h:"\u0431\u0438\u0440 \u0441\u043e\u0430\u0442",hh:"%d \u0441\u043e\u0430\u0442",d:"\u0431\u0438\u0440 \u043a\u0443\u043d",dd:"%d \u043a\u0443\u043d",M:"\u0431\u0438\u0440 \u043e\u0439",MM:"%d \u043e\u0439",y:"\u0431\u0438\u0440 \u0439\u0438\u043b",yy:"%d \u0439\u0438\u043b"},week:{dow:1,doy:7}}),e.defineLocale("vi",{months:"th\xe1ng 1_th\xe1ng 2_th\xe1ng 3_th\xe1ng 4_th\xe1ng 5_th\xe1ng 6_th\xe1ng 7_th\xe1ng 8_th\xe1ng 9_th\xe1ng 10_th\xe1ng 11_th\xe1ng 12".split("_"),monthsShort:"Th01_Th02_Th03_Th04_Th05_Th06_Th07_Th08_Th09_Th10_Th11_Th12".split("_"),monthsParseExact:!0,weekdays:"ch\u1ee7 nh\u1eadt_th\u1ee9 hai_th\u1ee9 ba_th\u1ee9 t\u01b0_th\u1ee9 n\u0103m_th\u1ee9 s\xe1u_th\u1ee9 b\u1ea3y".split("_"),weekdaysShort:"CN_T2_T3_T4_T5_T6_T7".split("_"),weekdaysMin:"CN_T2_T3_T4_T5_T6_T7".split("_"),weekdaysParseExact:!0,meridiemParse:/sa|ch/i,isPM:function(e){return/^ch$/i.test(e)},meridiem:function(e,a,t){return e<12?t?"sa":"SA":t?"ch":"CH"},longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM [n\u0103m] YYYY",LLL:"D MMMM [n\u0103m] YYYY HH:mm",LLLL:"dddd, D MMMM [n\u0103m] YYYY HH:mm",l:"DD/M/YYYY",ll:"D MMM YYYY",lll:"D MMM YYYY HH:mm",llll:"ddd, D MMM YYYY HH:mm"},calendar:{sameDay:"[H\xf4m nay l\xfac] LT",nextDay:"[Ng\xe0y mai l\xfac] LT",nextWeek:"dddd [tu\u1ea7n t\u1edbi l\xfac] LT",lastDay:"[H\xf4m qua l\xfac] LT",lastWeek:"dddd [tu\u1ea7n r\u1ed3i l\xfac] LT",sameElse:"L"},relativeTime:{future:"%s t\u1edbi",past:"%s tr\u01b0\u1edbc",s:"v\xe0i gi\xe2y",ss:"%d gi\xe2y",m:"m\u1ed9t ph\xfat",mm:"%d ph\xfat",h:"m\u1ed9t gi\u1edd",hh:"%d gi\u1edd",d:"m\u1ed9t ng\xe0y",dd:"%d ng\xe0y",M:"m\u1ed9t th\xe1ng",MM:"%d th\xe1ng",y:"m\u1ed9t n\u0103m",yy:"%d n\u0103m"},dayOfMonthOrdinalParse:/\d{1,2}/,ordinal:function(e){return e},week:{dow:1,doy:4}}),e.defineLocale("x-pseudo",{months:"J~\xe1\xf1\xfa\xe1~r\xfd_F~\xe9br\xfa~\xe1r\xfd_~M\xe1rc~h_\xc1p~r\xedl_~M\xe1\xfd_~J\xfa\xf1\xe9~_J\xfal~\xfd_\xc1\xfa~g\xfast~_S\xe9p~t\xe9mb~\xe9r_\xd3~ct\xf3b~\xe9r_\xd1~\xf3v\xe9m~b\xe9r_~D\xe9c\xe9~mb\xe9r".split("_"),monthsShort:"J~\xe1\xf1_~F\xe9b_~M\xe1r_~\xc1pr_~M\xe1\xfd_~J\xfa\xf1_~J\xfal_~\xc1\xfag_~S\xe9p_~\xd3ct_~\xd1\xf3v_~D\xe9c".split("_"),monthsParseExact:!0,weekdays:"S~\xfa\xf1d\xe1~\xfd_M\xf3~\xf1d\xe1\xfd~_T\xfa\xe9~sd\xe1\xfd~_W\xe9d~\xf1\xe9sd~\xe1\xfd_T~h\xfars~d\xe1\xfd_~Fr\xedd~\xe1\xfd_S~\xe1t\xfar~d\xe1\xfd".split("_"),weekdaysShort:"S~\xfa\xf1_~M\xf3\xf1_~T\xfa\xe9_~W\xe9d_~Th\xfa_~Fr\xed_~S\xe1t".split("_"),weekdaysMin:"S~\xfa_M\xf3~_T\xfa_~W\xe9_T~h_Fr~_S\xe1".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[T~\xf3d\xe1~\xfd \xe1t] LT",nextDay:"[T~\xf3m\xf3~rr\xf3~w \xe1t] LT",nextWeek:"dddd [\xe1t] LT",lastDay:"[\xdd~\xe9st~\xe9rd\xe1~\xfd \xe1t] LT",lastWeek:"[L~\xe1st] dddd [\xe1t] LT",sameElse:"L"},relativeTime:{future:"\xed~\xf1 %s",past:"%s \xe1~g\xf3",s:"\xe1 ~f\xe9w ~s\xe9c\xf3~\xf1ds",ss:"%d s~\xe9c\xf3\xf1~ds",m:"\xe1 ~m\xed\xf1~\xfat\xe9",mm:"%d m~\xed\xf1\xfa~t\xe9s",h:"\xe1~\xf1 h\xf3~\xfar",hh:"%d h~\xf3\xfars",d:"\xe1 ~d\xe1\xfd",dd:"%d d~\xe1\xfds",M:"\xe1 ~m\xf3\xf1~th",MM:"%d m~\xf3\xf1t~hs",y:"\xe1 ~\xfd\xe9\xe1r",yy:"%d \xfd~\xe9\xe1rs"},dayOfMonthOrdinalParse:/\d{1,2}(th|st|nd|rd)/,ordinal:function(e){var a=e%10;return e+(1==~~(e%100/10)?"th":1===a?"st":2===a?"nd":3===a?"rd":"th")},week:{dow:1,doy:4}}),e.defineLocale("yo",{months:"S\u1eb9\u0301r\u1eb9\u0301_E\u0300re\u0300le\u0300_\u1eb8r\u1eb9\u0300na\u0300_I\u0300gbe\u0301_E\u0300bibi_O\u0300ku\u0300du_Ag\u1eb9mo_O\u0300gu\u0301n_Owewe_\u1ecc\u0300wa\u0300ra\u0300_Be\u0301lu\u0301_\u1ecc\u0300p\u1eb9\u0300\u0300".split("_"),monthsShort:"S\u1eb9\u0301r_E\u0300rl_\u1eb8rn_I\u0300gb_E\u0300bi_O\u0300ku\u0300_Ag\u1eb9_O\u0300gu\u0301_Owe_\u1ecc\u0300wa\u0300_Be\u0301l_\u1ecc\u0300p\u1eb9\u0300\u0300".split("_"),weekdays:"A\u0300i\u0300ku\u0301_Aje\u0301_I\u0300s\u1eb9\u0301gun_\u1eccj\u1ecd\u0301ru\u0301_\u1eccj\u1ecd\u0301b\u1ecd_\u1eb8ti\u0300_A\u0300ba\u0301m\u1eb9\u0301ta".split("_"),weekdaysShort:"A\u0300i\u0300k_Aje\u0301_I\u0300s\u1eb9\u0301_\u1eccjr_\u1eccjb_\u1eb8ti\u0300_A\u0300ba\u0301".split("_"),weekdaysMin:"A\u0300i\u0300_Aj_I\u0300s_\u1eccr_\u1eccb_\u1eb8t_A\u0300b".split("_"),longDateFormat:{LT:"h:mm A",LTS:"h:mm:ss A",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY h:mm A",LLLL:"dddd, D MMMM YYYY h:mm A"},calendar:{sameDay:"[O\u0300ni\u0300 ni] LT",nextDay:"[\u1ecc\u0300la ni] LT",nextWeek:"dddd [\u1eccs\u1eb9\u0300 to\u0301n'b\u1ecd] [ni] LT",lastDay:"[A\u0300na ni] LT",lastWeek:"dddd [\u1eccs\u1eb9\u0300 to\u0301l\u1ecd\u0301] [ni] LT",sameElse:"L"},relativeTime:{future:"ni\u0301 %s",past:"%s k\u1ecdja\u0301",s:"i\u0300s\u1eb9ju\u0301 aaya\u0301 die",ss:"aaya\u0301 %d",m:"i\u0300s\u1eb9ju\u0301 kan",mm:"i\u0300s\u1eb9ju\u0301 %d",h:"wa\u0301kati kan",hh:"wa\u0301kati %d",d:"\u1ecdj\u1ecd\u0301 kan",dd:"\u1ecdj\u1ecd\u0301 %d",M:"osu\u0300 kan",MM:"osu\u0300 %d",y:"\u1ecddu\u0301n kan",yy:"\u1ecddu\u0301n %d"},dayOfMonthOrdinalParse:/\u1ecdj\u1ecd\u0301\s\d{1,2}/,ordinal:"\u1ecdj\u1ecd\u0301 %d",week:{dow:1,doy:4}}),e.defineLocale("zh-cn",{months:"\u4e00\u6708_\u4e8c\u6708_\u4e09\u6708_\u56db\u6708_\u4e94\u6708_\u516d\u6708_\u4e03\u6708_\u516b\u6708_\u4e5d\u6708_\u5341\u6708_\u5341\u4e00\u6708_\u5341\u4e8c\u6708".split("_"),monthsShort:"1\u6708_2\u6708_3\u6708_4\u6708_5\u6708_6\u6708_7\u6708_8\u6708_9\u6708_10\u6708_11\u6708_12\u6708".split("_"),weekdays:"\u661f\u671f\u65e5_\u661f\u671f\u4e00_\u661f\u671f\u4e8c_\u661f\u671f\u4e09_\u661f\u671f\u56db_\u661f\u671f\u4e94_\u661f\u671f\u516d".split("_"),weekdaysShort:"\u5468\u65e5_\u5468\u4e00_\u5468\u4e8c_\u5468\u4e09_\u5468\u56db_\u5468\u4e94_\u5468\u516d".split("_"),weekdaysMin:"\u65e5_\u4e00_\u4e8c_\u4e09_\u56db_\u4e94_\u516d".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"YYYY/MM/DD",LL:"YYYY\u5e74M\u6708D\u65e5",LLL:"YYYY\u5e74M\u6708D\u65e5Ah\u70b9mm\u5206",LLLL:"YYYY\u5e74M\u6708D\u65e5ddddAh\u70b9mm\u5206",l:"YYYY/M/D",ll:"YYYY\u5e74M\u6708D\u65e5",lll:"YYYY\u5e74M\u6708D\u65e5 HH:mm",llll:"YYYY\u5e74M\u6708D\u65e5dddd HH:mm"},meridiemParse:/\u51cc\u6668|\u65e9\u4e0a|\u4e0a\u5348|\u4e2d\u5348|\u4e0b\u5348|\u665a\u4e0a/,meridiemHour:function(e,a){return 12===e&&(e=0),"\u51cc\u6668"===a||"\u65e9\u4e0a"===a||"\u4e0a\u5348"===a?e:"\u4e0b\u5348"===a||"\u665a\u4e0a"===a?e+12:e>=11?e:e+12},meridiem:function(e,a,t){var s=100*e+a;return s<600?"\u51cc\u6668":s<900?"\u65e9\u4e0a":s<1130?"\u4e0a\u5348":s<1230?"\u4e2d\u5348":s<1800?"\u4e0b\u5348":"\u665a\u4e0a"},calendar:{sameDay:"[\u4eca\u5929]LT",nextDay:"[\u660e\u5929]LT",nextWeek:"[\u4e0b]ddddLT",lastDay:"[\u6628\u5929]LT",lastWeek:"[\u4e0a]ddddLT",sameElse:"L"},dayOfMonthOrdinalParse:/\d{1,2}(\u65e5|\u6708|\u5468)/,ordinal:function(e,a){switch(a){case"d":case"D":case"DDD":return e+"\u65e5";case"M":return e+"\u6708";case"w":case"W":return e+"\u5468";default:return e}},relativeTime:{future:"%s\u5185",past:"%s\u524d",s:"\u51e0\u79d2",ss:"%d \u79d2",m:"1 \u5206\u949f",mm:"%d \u5206\u949f",h:"1 \u5c0f\u65f6",hh:"%d \u5c0f\u65f6",d:"1 \u5929",dd:"%d \u5929",M:"1 \u4e2a\u6708",MM:"%d \u4e2a\u6708",y:"1 \u5e74",yy:"%d \u5e74"},week:{dow:1,doy:4}}),e.defineLocale("zh-hk",{months:"\u4e00\u6708_\u4e8c\u6708_\u4e09\u6708_\u56db\u6708_\u4e94\u6708_\u516d\u6708_\u4e03\u6708_\u516b\u6708_\u4e5d\u6708_\u5341\u6708_\u5341\u4e00\u6708_\u5341\u4e8c\u6708".split("_"),monthsShort:"1\u6708_2\u6708_3\u6708_4\u6708_5\u6708_6\u6708_7\u6708_8\u6708_9\u6708_10\u6708_11\u6708_12\u6708".split("_"),weekdays:"\u661f\u671f\u65e5_\u661f\u671f\u4e00_\u661f\u671f\u4e8c_\u661f\u671f\u4e09_\u661f\u671f\u56db_\u661f\u671f\u4e94_\u661f\u671f\u516d".split("_"),weekdaysShort:"\u9031\u65e5_\u9031\u4e00_\u9031\u4e8c_\u9031\u4e09_\u9031\u56db_\u9031\u4e94_\u9031\u516d".split("_"),weekdaysMin:"\u65e5_\u4e00_\u4e8c_\u4e09_\u56db_\u4e94_\u516d".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"YYYY/MM/DD",LL:"YYYY\u5e74M\u6708D\u65e5",LLL:"YYYY\u5e74M\u6708D\u65e5 HH:mm",LLLL:"YYYY\u5e74M\u6708D\u65e5dddd HH:mm",l:"YYYY/M/D",ll:"YYYY\u5e74M\u6708D\u65e5",lll:"YYYY\u5e74M\u6708D\u65e5 HH:mm",llll:"YYYY\u5e74M\u6708D\u65e5dddd HH:mm"},meridiemParse:/\u51cc\u6668|\u65e9\u4e0a|\u4e0a\u5348|\u4e2d\u5348|\u4e0b\u5348|\u665a\u4e0a/,meridiemHour:function(e,a){return 12===e&&(e=0),"\u51cc\u6668"===a||"\u65e9\u4e0a"===a||"\u4e0a\u5348"===a?e:"\u4e2d\u5348"===a?e>=11?e:e+12:"\u4e0b\u5348"===a||"\u665a\u4e0a"===a?e+12:void 0},meridiem:function(e,a,t){var s=100*e+a;return s<600?"\u51cc\u6668":s<900?"\u65e9\u4e0a":s<1130?"\u4e0a\u5348":s<1230?"\u4e2d\u5348":s<1800?"\u4e0b\u5348":"\u665a\u4e0a"},calendar:{sameDay:"[\u4eca\u5929]LT",nextDay:"[\u660e\u5929]LT",nextWeek:"[\u4e0b]ddddLT",lastDay:"[\u6628\u5929]LT",lastWeek:"[\u4e0a]ddddLT",sameElse:"L"},dayOfMonthOrdinalParse:/\d{1,2}(\u65e5|\u6708|\u9031)/,ordinal:function(e,a){switch(a){case"d":case"D":case"DDD":return e+"\u65e5";case"M":return e+"\u6708";case"w":case"W":return e+"\u9031";default:return e}},relativeTime:{future:"%s\u5167",past:"%s\u524d",s:"\u5e7e\u79d2",ss:"%d \u79d2",m:"1 \u5206\u9418",mm:"%d \u5206\u9418",h:"1 \u5c0f\u6642",hh:"%d \u5c0f\u6642",d:"1 \u5929",dd:"%d \u5929",M:"1 \u500b\u6708",MM:"%d \u500b\u6708",y:"1 \u5e74",yy:"%d \u5e74"}}),e.defineLocale("zh-tw",{months:"\u4e00\u6708_\u4e8c\u6708_\u4e09\u6708_\u56db\u6708_\u4e94\u6708_\u516d\u6708_\u4e03\u6708_\u516b\u6708_\u4e5d\u6708_\u5341\u6708_\u5341\u4e00\u6708_\u5341\u4e8c\u6708".split("_"),monthsShort:"1\u6708_2\u6708_3\u6708_4\u6708_5\u6708_6\u6708_7\u6708_8\u6708_9\u6708_10\u6708_11\u6708_12\u6708".split("_"),weekdays:"\u661f\u671f\u65e5_\u661f\u671f\u4e00_\u661f\u671f\u4e8c_\u661f\u671f\u4e09_\u661f\u671f\u56db_\u661f\u671f\u4e94_\u661f\u671f\u516d".split("_"),weekdaysShort:"\u9031\u65e5_\u9031\u4e00_\u9031\u4e8c_\u9031\u4e09_\u9031\u56db_\u9031\u4e94_\u9031\u516d".split("_"),weekdaysMin:"\u65e5_\u4e00_\u4e8c_\u4e09_\u56db_\u4e94_\u516d".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"YYYY/MM/DD",LL:"YYYY\u5e74M\u6708D\u65e5",LLL:"YYYY\u5e74M\u6708D\u65e5 HH:mm",LLLL:"YYYY\u5e74M\u6708D\u65e5dddd HH:mm",l:"YYYY/M/D",ll:"YYYY\u5e74M\u6708D\u65e5",lll:"YYYY\u5e74M\u6708D\u65e5 HH:mm",llll:"YYYY\u5e74M\u6708D\u65e5dddd HH:mm"},meridiemParse:/\u51cc\u6668|\u65e9\u4e0a|\u4e0a\u5348|\u4e2d\u5348|\u4e0b\u5348|\u665a\u4e0a/,meridiemHour:function(e,a){return 12===e&&(e=0),"\u51cc\u6668"===a||"\u65e9\u4e0a"===a||"\u4e0a\u5348"===a?e:"\u4e2d\u5348"===a?e>=11?e:e+12:"\u4e0b\u5348"===a||"\u665a\u4e0a"===a?e+12:void 0},meridiem:function(e,a,t){var s=100*e+a;return s<600?"\u51cc\u6668":s<900?"\u65e9\u4e0a":s<1130?"\u4e0a\u5348":s<1230?"\u4e2d\u5348":s<1800?"\u4e0b\u5348":"\u665a\u4e0a"},calendar:{sameDay:"[\u4eca\u5929]LT",nextDay:"[\u660e\u5929]LT",nextWeek:"[\u4e0b]ddddLT",lastDay:"[\u6628\u5929]LT",lastWeek:"[\u4e0a]ddddLT",sameElse:"L"},dayOfMonthOrdinalParse:/\d{1,2}(\u65e5|\u6708|\u9031)/,ordinal:function(e,a){switch(a){case"d":case"D":case"DDD":return e+"\u65e5";case"M":return e+"\u6708";case"w":case"W":return e+"\u9031";default:return e}},relativeTime:{future:"%s\u5167",past:"%s\u524d",s:"\u5e7e\u79d2",ss:"%d \u79d2",m:"1 \u5206\u9418",mm:"%d \u5206\u9418",h:"1 \u5c0f\u6642",hh:"%d \u5c0f\u6642",d:"1 \u5929",dd:"%d \u5929",M:"1 \u500b\u6708",MM:"%d \u500b\u6708",y:"1 \u5e74",yy:"%d \u5e74"}}),e.locale("en"),e});
"use strict";

// Start Polyfill
{
  if (!String.prototype.includes) {
    String.prototype.includes = function (search, start) {
      if (typeof start !== 'number') {
        start = 0;
      }
      if (start + search.length > this.length) {
        return false;
      } else {
        return this.indexOf(search, start) !== -1;
      }
    };
  }
  (function () {
    if (typeof NodeList.prototype.forEach === 'function') return false;
    NodeList.prototype.forEach = Array.prototype.forEach;
  })();
  if (!Object.entries) {
    Object.entries = function (obj) {
      var ownProps = Object.keys(obj),
        i = ownProps.length,
        resArray = new Array(i); // preallocate the Array
      while (i--) {
        resArray[i] = [ownProps[i], obj[ownProps[i]]];
      }
      return resArray;
    };
  }

  // Production steps of ECMA-262, Edition 6, 22.1.2.1
  // Reference: https://people.mozilla.org/~jorendorff/es6-draft.html#sec-array.from
  if (!Array.from) {
    Array.from = function () {
      var toStr = Object.prototype.toString;
      var isCallable = function isCallable(fn) {
        return typeof fn === 'function' || toStr.call(fn) === '[object Function]';
      };
      var toInteger = function toInteger(value) {
        var number = Number(value);
        if (isNaN(number)) {
          return 0;
        }
        if (number === 0 || !isFinite(number)) {
          return number;
        }
        return (number > 0 ? 1 : -1) * Math.floor(Math.abs(number));
      };
      var maxSafeInteger = Math.pow(2, 53) - 1;
      var toLength = function toLength(value) {
        var len = toInteger(value);
        return Math.min(Math.max(len, 0), maxSafeInteger);
      };

      // The length property of the from method is 1.
      return function from(arrayLike /*, mapFn, thisArg */) {
        // 1. Let C be the this value.
        var C = this;

        // 2. Let items be ToObject(arrayLike).
        var items = Object(arrayLike);

        // 3. ReturnIfAbrupt(items).
        if (arrayLike == null) {
          throw new TypeError('Array.from requires an array-like object - not null or undefined');
        }

        // 4. If mapfn is undefined, then let mapping be false.
        var mapFn = arguments.length > 1 ? arguments[1] : void undefined;
        var T;
        if (typeof mapFn !== 'undefined') {
          // 5. else
          // 5. a If IsCallable(mapfn) is false, throw a TypeError exception.
          if (!isCallable(mapFn)) {
            throw new TypeError('Array.from: when provided, the second argument must be a function');
          }

          // 5. b. If thisArg was supplied, let T be thisArg; else let T be undefined.
          if (arguments.length > 2) {
            T = arguments[2];
          }
        }

        // 10. Let lenValue be Get(items, "length").
        // 11. Let len be ToLength(lenValue).
        var len = toLength(items.length);

        // 13. If IsConstructor(C) is true, then
        // 13. a. Let A be the result of calling the [[Construct]] internal method of C with an argument list containing the single item len.
        // 14. a. Else, Let A be ArrayCreate(len).
        var A = isCallable(C) ? Object(new C(len)) : new Array(len);

        // 16. Let k be 0.
        var k = 0;
        // 17. Repeat, while k < len… (also steps a - h)
        var kValue;
        while (k < len) {
          kValue = items[k];
          if (mapFn) {
            A[k] = typeof T === 'undefined' ? mapFn(kValue, k) : mapFn.call(T, kValue, k);
          } else {
            A[k] = kValue;
          }
          k += 1;
        }
        // 18. Let putStatus be Put(A, "length", len, true).
        A.length = len;
        // 20. Return A.
        return A;
      };
    }();
  }
  if (!Array.prototype.every) {
    Array.prototype.every = function (callbackfn, thisArg) {
      'use strict';

      var T, k;
      if (this == null) {
        throw new TypeError('this is null or not defined');
      }

      // 1. Let O be the result of calling ToObject passing the this
      //    value as the argument.
      var O = Object(this);

      // 2. Let lenValue be the result of calling the Get internal method
      //    of O with the argument "length".
      // 3. Let len be ToUint32(lenValue).
      var len = O.length >>> 0;

      // 4. If IsCallable(callbackfn) is false, throw a TypeError exception.
      if (typeof callbackfn !== 'function') {
        throw new TypeError();
      }

      // 5. If thisArg was supplied, let T be thisArg; else let T be undefined.
      if (arguments.length > 1) {
        T = thisArg;
      }

      // 6. Let k be 0.
      k = 0;

      // 7. Repeat, while k < len
      while (k < len) {
        var kValue;

        // a. Let Pk be ToString(k).
        //   This is implicit for LHS operands of the in operator
        // b. Let kPresent be the result of calling the HasProperty internal
        //    method of O with argument Pk.
        //   This step can be combined with c
        // c. If kPresent is true, then
        if (k in O) {
          // i. Let kValue be the result of calling the Get internal method
          //    of O with argument Pk.
          kValue = O[k];

          // ii. Let testResult be the result of calling the Call internal method
          //     of callbackfn with T as the this value and argument list
          //     containing kValue, k, and O.
          var testResult = callbackfn.call(T, kValue, k, O);

          // iii. If ToBoolean(testResult) is false, return false.
          if (!testResult) {
            return false;
          }
        }
        k++;
      }
      return true;
    };
  }
}
/*! jQuery v3.6.4 | (c) OpenJS Foundation and other contributors | jquery.org/license */
!function(e,t){"use strict";"object"==typeof module&&"object"==typeof module.exports?module.exports=e.document?t(e,!0):function(e){if(!e.document)throw new Error("jQuery requires a window with a document");return t(e)}:t(e)}("undefined"!=typeof window?window:this,function(C,e){"use strict";var t=[],r=Object.getPrototypeOf,s=t.slice,g=t.flat?function(e){return t.flat.call(e)}:function(e){return t.concat.apply([],e)},u=t.push,i=t.indexOf,n={},o=n.toString,y=n.hasOwnProperty,a=y.toString,l=a.call(Object),v={},m=function(e){return"function"==typeof e&&"number"!=typeof e.nodeType&&"function"!=typeof e.item},x=function(e){return null!=e&&e===e.window},E=C.document,c={type:!0,src:!0,nonce:!0,noModule:!0};function b(e,t,n){var r,i,o=(n=n||E).createElement("script");if(o.text=e,t)for(r in c)(i=t[r]||t.getAttribute&&t.getAttribute(r))&&o.setAttribute(r,i);n.head.appendChild(o).parentNode.removeChild(o)}function w(e){return null==e?e+"":"object"==typeof e||"function"==typeof e?n[o.call(e)]||"object":typeof e}var f="3.6.4",S=function(e,t){return new S.fn.init(e,t)};function p(e){var t=!!e&&"length"in e&&e.length,n=w(e);return!m(e)&&!x(e)&&("array"===n||0===t||"number"==typeof t&&0<t&&t-1 in e)}S.fn=S.prototype={jquery:f,constructor:S,length:0,toArray:function(){return s.call(this)},get:function(e){return null==e?s.call(this):e<0?this[e+this.length]:this[e]},pushStack:function(e){var t=S.merge(this.constructor(),e);return t.prevObject=this,t},each:function(e){return S.each(this,e)},map:function(n){return this.pushStack(S.map(this,function(e,t){return n.call(e,t,e)}))},slice:function(){return this.pushStack(s.apply(this,arguments))},first:function(){return this.eq(0)},last:function(){return this.eq(-1)},even:function(){return this.pushStack(S.grep(this,function(e,t){return(t+1)%2}))},odd:function(){return this.pushStack(S.grep(this,function(e,t){return t%2}))},eq:function(e){var t=this.length,n=+e+(e<0?t:0);return this.pushStack(0<=n&&n<t?[this[n]]:[])},end:function(){return this.prevObject||this.constructor()},push:u,sort:t.sort,splice:t.splice},S.extend=S.fn.extend=function(){var e,t,n,r,i,o,a=arguments[0]||{},s=1,u=arguments.length,l=!1;for("boolean"==typeof a&&(l=a,a=arguments[s]||{},s++),"object"==typeof a||m(a)||(a={}),s===u&&(a=this,s--);s<u;s++)if(null!=(e=arguments[s]))for(t in e)r=e[t],"__proto__"!==t&&a!==r&&(l&&r&&(S.isPlainObject(r)||(i=Array.isArray(r)))?(n=a[t],o=i&&!Array.isArray(n)?[]:i||S.isPlainObject(n)?n:{},i=!1,a[t]=S.extend(l,o,r)):void 0!==r&&(a[t]=r));return a},S.extend({expando:"jQuery"+(f+Math.random()).replace(/\D/g,""),isReady:!0,error:function(e){throw new Error(e)},noop:function(){},isPlainObject:function(e){var t,n;return!(!e||"[object Object]"!==o.call(e))&&(!(t=r(e))||"function"==typeof(n=y.call(t,"constructor")&&t.constructor)&&a.call(n)===l)},isEmptyObject:function(e){var t;for(t in e)return!1;return!0},globalEval:function(e,t,n){b(e,{nonce:t&&t.nonce},n)},each:function(e,t){var n,r=0;if(p(e)){for(n=e.length;r<n;r++)if(!1===t.call(e[r],r,e[r]))break}else for(r in e)if(!1===t.call(e[r],r,e[r]))break;return e},makeArray:function(e,t){var n=t||[];return null!=e&&(p(Object(e))?S.merge(n,"string"==typeof e?[e]:e):u.call(n,e)),n},inArray:function(e,t,n){return null==t?-1:i.call(t,e,n)},merge:function(e,t){for(var n=+t.length,r=0,i=e.length;r<n;r++)e[i++]=t[r];return e.length=i,e},grep:function(e,t,n){for(var r=[],i=0,o=e.length,a=!n;i<o;i++)!t(e[i],i)!==a&&r.push(e[i]);return r},map:function(e,t,n){var r,i,o=0,a=[];if(p(e))for(r=e.length;o<r;o++)null!=(i=t(e[o],o,n))&&a.push(i);else for(o in e)null!=(i=t(e[o],o,n))&&a.push(i);return g(a)},guid:1,support:v}),"function"==typeof Symbol&&(S.fn[Symbol.iterator]=t[Symbol.iterator]),S.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "),function(e,t){n["[object "+t+"]"]=t.toLowerCase()});var d=function(n){var e,d,b,o,i,h,f,g,w,u,l,T,C,a,E,y,s,c,v,S="sizzle"+1*new Date,p=n.document,k=0,r=0,m=ue(),x=ue(),A=ue(),N=ue(),j=function(e,t){return e===t&&(l=!0),0},D={}.hasOwnProperty,t=[],q=t.pop,L=t.push,H=t.push,O=t.slice,P=function(e,t){for(var n=0,r=e.length;n<r;n++)if(e[n]===t)return n;return-1},R="checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",M="[\\x20\\t\\r\\n\\f]",I="(?:\\\\[\\da-fA-F]{1,6}"+M+"?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",W="\\["+M+"*("+I+")(?:"+M+"*([*^$|!~]?=)"+M+"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|("+I+"))|)"+M+"*\\]",F=":("+I+")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|"+W+")*)|.*)\\)|)",$=new RegExp(M+"+","g"),B=new RegExp("^"+M+"+|((?:^|[^\\\\])(?:\\\\.)*)"+M+"+$","g"),_=new RegExp("^"+M+"*,"+M+"*"),z=new RegExp("^"+M+"*([>+~]|"+M+")"+M+"*"),U=new RegExp(M+"|>"),X=new RegExp(F),V=new RegExp("^"+I+"$"),G={ID:new RegExp("^#("+I+")"),CLASS:new RegExp("^\\.("+I+")"),TAG:new RegExp("^("+I+"|[*])"),ATTR:new RegExp("^"+W),PSEUDO:new RegExp("^"+F),CHILD:new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\("+M+"*(even|odd|(([+-]|)(\\d*)n|)"+M+"*(?:([+-]|)"+M+"*(\\d+)|))"+M+"*\\)|)","i"),bool:new RegExp("^(?:"+R+")$","i"),needsContext:new RegExp("^"+M+"*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\("+M+"*((?:-\\d)?\\d*)"+M+"*\\)|)(?=[^-]|$)","i")},Y=/HTML$/i,Q=/^(?:input|select|textarea|button)$/i,J=/^h\d$/i,K=/^[^{]+\{\s*\[native \w/,Z=/^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,ee=/[+~]/,te=new RegExp("\\\\[\\da-fA-F]{1,6}"+M+"?|\\\\([^\\r\\n\\f])","g"),ne=function(e,t){var n="0x"+e.slice(1)-65536;return t||(n<0?String.fromCharCode(n+65536):String.fromCharCode(n>>10|55296,1023&n|56320))},re=/([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,ie=function(e,t){return t?"\0"===e?"\ufffd":e.slice(0,-1)+"\\"+e.charCodeAt(e.length-1).toString(16)+" ":"\\"+e},oe=function(){T()},ae=be(function(e){return!0===e.disabled&&"fieldset"===e.nodeName.toLowerCase()},{dir:"parentNode",next:"legend"});try{H.apply(t=O.call(p.childNodes),p.childNodes),t[p.childNodes.length].nodeType}catch(e){H={apply:t.length?function(e,t){L.apply(e,O.call(t))}:function(e,t){var n=e.length,r=0;while(e[n++]=t[r++]);e.length=n-1}}}function se(t,e,n,r){var i,o,a,s,u,l,c,f=e&&e.ownerDocument,p=e?e.nodeType:9;if(n=n||[],"string"!=typeof t||!t||1!==p&&9!==p&&11!==p)return n;if(!r&&(T(e),e=e||C,E)){if(11!==p&&(u=Z.exec(t)))if(i=u[1]){if(9===p){if(!(a=e.getElementById(i)))return n;if(a.id===i)return n.push(a),n}else if(f&&(a=f.getElementById(i))&&v(e,a)&&a.id===i)return n.push(a),n}else{if(u[2])return H.apply(n,e.getElementsByTagName(t)),n;if((i=u[3])&&d.getElementsByClassName&&e.getElementsByClassName)return H.apply(n,e.getElementsByClassName(i)),n}if(d.qsa&&!N[t+" "]&&(!y||!y.test(t))&&(1!==p||"object"!==e.nodeName.toLowerCase())){if(c=t,f=e,1===p&&(U.test(t)||z.test(t))){(f=ee.test(t)&&ve(e.parentNode)||e)===e&&d.scope||((s=e.getAttribute("id"))?s=s.replace(re,ie):e.setAttribute("id",s=S)),o=(l=h(t)).length;while(o--)l[o]=(s?"#"+s:":scope")+" "+xe(l[o]);c=l.join(",")}try{return H.apply(n,f.querySelectorAll(c)),n}catch(e){N(t,!0)}finally{s===S&&e.removeAttribute("id")}}}return g(t.replace(B,"$1"),e,n,r)}function ue(){var r=[];return function e(t,n){return r.push(t+" ")>b.cacheLength&&delete e[r.shift()],e[t+" "]=n}}function le(e){return e[S]=!0,e}function ce(e){var t=C.createElement("fieldset");try{return!!e(t)}catch(e){return!1}finally{t.parentNode&&t.parentNode.removeChild(t),t=null}}function fe(e,t){var n=e.split("|"),r=n.length;while(r--)b.attrHandle[n[r]]=t}function pe(e,t){var n=t&&e,r=n&&1===e.nodeType&&1===t.nodeType&&e.sourceIndex-t.sourceIndex;if(r)return r;if(n)while(n=n.nextSibling)if(n===t)return-1;return e?1:-1}function de(t){return function(e){return"input"===e.nodeName.toLowerCase()&&e.type===t}}function he(n){return function(e){var t=e.nodeName.toLowerCase();return("input"===t||"button"===t)&&e.type===n}}function ge(t){return function(e){return"form"in e?e.parentNode&&!1===e.disabled?"label"in e?"label"in e.parentNode?e.parentNode.disabled===t:e.disabled===t:e.isDisabled===t||e.isDisabled!==!t&&ae(e)===t:e.disabled===t:"label"in e&&e.disabled===t}}function ye(a){return le(function(o){return o=+o,le(function(e,t){var n,r=a([],e.length,o),i=r.length;while(i--)e[n=r[i]]&&(e[n]=!(t[n]=e[n]))})})}function ve(e){return e&&"undefined"!=typeof e.getElementsByTagName&&e}for(e in d=se.support={},i=se.isXML=function(e){var t=e&&e.namespaceURI,n=e&&(e.ownerDocument||e).documentElement;return!Y.test(t||n&&n.nodeName||"HTML")},T=se.setDocument=function(e){var t,n,r=e?e.ownerDocument||e:p;return r!=C&&9===r.nodeType&&r.documentElement&&(a=(C=r).documentElement,E=!i(C),p!=C&&(n=C.defaultView)&&n.top!==n&&(n.addEventListener?n.addEventListener("unload",oe,!1):n.attachEvent&&n.attachEvent("onunload",oe)),d.scope=ce(function(e){return a.appendChild(e).appendChild(C.createElement("div")),"undefined"!=typeof e.querySelectorAll&&!e.querySelectorAll(":scope fieldset div").length}),d.cssHas=ce(function(){try{return C.querySelector(":has(*,:jqfake)"),!1}catch(e){return!0}}),d.attributes=ce(function(e){return e.className="i",!e.getAttribute("className")}),d.getElementsByTagName=ce(function(e){return e.appendChild(C.createComment("")),!e.getElementsByTagName("*").length}),d.getElementsByClassName=K.test(C.getElementsByClassName),d.getById=ce(function(e){return a.appendChild(e).id=S,!C.getElementsByName||!C.getElementsByName(S).length}),d.getById?(b.filter.ID=function(e){var t=e.replace(te,ne);return function(e){return e.getAttribute("id")===t}},b.find.ID=function(e,t){if("undefined"!=typeof t.getElementById&&E){var n=t.getElementById(e);return n?[n]:[]}}):(b.filter.ID=function(e){var n=e.replace(te,ne);return function(e){var t="undefined"!=typeof e.getAttributeNode&&e.getAttributeNode("id");return t&&t.value===n}},b.find.ID=function(e,t){if("undefined"!=typeof t.getElementById&&E){var n,r,i,o=t.getElementById(e);if(o){if((n=o.getAttributeNode("id"))&&n.value===e)return[o];i=t.getElementsByName(e),r=0;while(o=i[r++])if((n=o.getAttributeNode("id"))&&n.value===e)return[o]}return[]}}),b.find.TAG=d.getElementsByTagName?function(e,t){return"undefined"!=typeof t.getElementsByTagName?t.getElementsByTagName(e):d.qsa?t.querySelectorAll(e):void 0}:function(e,t){var n,r=[],i=0,o=t.getElementsByTagName(e);if("*"===e){while(n=o[i++])1===n.nodeType&&r.push(n);return r}return o},b.find.CLASS=d.getElementsByClassName&&function(e,t){if("undefined"!=typeof t.getElementsByClassName&&E)return t.getElementsByClassName(e)},s=[],y=[],(d.qsa=K.test(C.querySelectorAll))&&(ce(function(e){var t;a.appendChild(e).innerHTML="<a id='"+S+"'></a><select id='"+S+"-\r\\' msallowcapture=''><option selected=''></option></select>",e.querySelectorAll("[msallowcapture^='']").length&&y.push("[*^$]="+M+"*(?:''|\"\")"),e.querySelectorAll("[selected]").length||y.push("\\["+M+"*(?:value|"+R+")"),e.querySelectorAll("[id~="+S+"-]").length||y.push("~="),(t=C.createElement("input")).setAttribute("name",""),e.appendChild(t),e.querySelectorAll("[name='']").length||y.push("\\["+M+"*name"+M+"*="+M+"*(?:''|\"\")"),e.querySelectorAll(":checked").length||y.push(":checked"),e.querySelectorAll("a#"+S+"+*").length||y.push(".#.+[+~]"),e.querySelectorAll("\\\f"),y.push("[\\r\\n\\f]")}),ce(function(e){e.innerHTML="<a href='' disabled='disabled'></a><select disabled='disabled'><option/></select>";var t=C.createElement("input");t.setAttribute("type","hidden"),e.appendChild(t).setAttribute("name","D"),e.querySelectorAll("[name=d]").length&&y.push("name"+M+"*[*^$|!~]?="),2!==e.querySelectorAll(":enabled").length&&y.push(":enabled",":disabled"),a.appendChild(e).disabled=!0,2!==e.querySelectorAll(":disabled").length&&y.push(":enabled",":disabled"),e.querySelectorAll("*,:x"),y.push(",.*:")})),(d.matchesSelector=K.test(c=a.matches||a.webkitMatchesSelector||a.mozMatchesSelector||a.oMatchesSelector||a.msMatchesSelector))&&ce(function(e){d.disconnectedMatch=c.call(e,"*"),c.call(e,"[s!='']:x"),s.push("!=",F)}),d.cssHas||y.push(":has"),y=y.length&&new RegExp(y.join("|")),s=s.length&&new RegExp(s.join("|")),t=K.test(a.compareDocumentPosition),v=t||K.test(a.contains)?function(e,t){var n=9===e.nodeType&&e.documentElement||e,r=t&&t.parentNode;return e===r||!(!r||1!==r.nodeType||!(n.contains?n.contains(r):e.compareDocumentPosition&&16&e.compareDocumentPosition(r)))}:function(e,t){if(t)while(t=t.parentNode)if(t===e)return!0;return!1},j=t?function(e,t){if(e===t)return l=!0,0;var n=!e.compareDocumentPosition-!t.compareDocumentPosition;return n||(1&(n=(e.ownerDocument||e)==(t.ownerDocument||t)?e.compareDocumentPosition(t):1)||!d.sortDetached&&t.compareDocumentPosition(e)===n?e==C||e.ownerDocument==p&&v(p,e)?-1:t==C||t.ownerDocument==p&&v(p,t)?1:u?P(u,e)-P(u,t):0:4&n?-1:1)}:function(e,t){if(e===t)return l=!0,0;var n,r=0,i=e.parentNode,o=t.parentNode,a=[e],s=[t];if(!i||!o)return e==C?-1:t==C?1:i?-1:o?1:u?P(u,e)-P(u,t):0;if(i===o)return pe(e,t);n=e;while(n=n.parentNode)a.unshift(n);n=t;while(n=n.parentNode)s.unshift(n);while(a[r]===s[r])r++;return r?pe(a[r],s[r]):a[r]==p?-1:s[r]==p?1:0}),C},se.matches=function(e,t){return se(e,null,null,t)},se.matchesSelector=function(e,t){if(T(e),d.matchesSelector&&E&&!N[t+" "]&&(!s||!s.test(t))&&(!y||!y.test(t)))try{var n=c.call(e,t);if(n||d.disconnectedMatch||e.document&&11!==e.document.nodeType)return n}catch(e){N(t,!0)}return 0<se(t,C,null,[e]).length},se.contains=function(e,t){return(e.ownerDocument||e)!=C&&T(e),v(e,t)},se.attr=function(e,t){(e.ownerDocument||e)!=C&&T(e);var n=b.attrHandle[t.toLowerCase()],r=n&&D.call(b.attrHandle,t.toLowerCase())?n(e,t,!E):void 0;return void 0!==r?r:d.attributes||!E?e.getAttribute(t):(r=e.getAttributeNode(t))&&r.specified?r.value:null},se.escape=function(e){return(e+"").replace(re,ie)},se.error=function(e){throw new Error("Syntax error, unrecognized expression: "+e)},se.uniqueSort=function(e){var t,n=[],r=0,i=0;if(l=!d.detectDuplicates,u=!d.sortStable&&e.slice(0),e.sort(j),l){while(t=e[i++])t===e[i]&&(r=n.push(i));while(r--)e.splice(n[r],1)}return u=null,e},o=se.getText=function(e){var t,n="",r=0,i=e.nodeType;if(i){if(1===i||9===i||11===i){if("string"==typeof e.textContent)return e.textContent;for(e=e.firstChild;e;e=e.nextSibling)n+=o(e)}else if(3===i||4===i)return e.nodeValue}else while(t=e[r++])n+=o(t);return n},(b=se.selectors={cacheLength:50,createPseudo:le,match:G,attrHandle:{},find:{},relative:{">":{dir:"parentNode",first:!0}," ":{dir:"parentNode"},"+":{dir:"previousSibling",first:!0},"~":{dir:"previousSibling"}},preFilter:{ATTR:function(e){return e[1]=e[1].replace(te,ne),e[3]=(e[3]||e[4]||e[5]||"").replace(te,ne),"~="===e[2]&&(e[3]=" "+e[3]+" "),e.slice(0,4)},CHILD:function(e){return e[1]=e[1].toLowerCase(),"nth"===e[1].slice(0,3)?(e[3]||se.error(e[0]),e[4]=+(e[4]?e[5]+(e[6]||1):2*("even"===e[3]||"odd"===e[3])),e[5]=+(e[7]+e[8]||"odd"===e[3])):e[3]&&se.error(e[0]),e},PSEUDO:function(e){var t,n=!e[6]&&e[2];return G.CHILD.test(e[0])?null:(e[3]?e[2]=e[4]||e[5]||"":n&&X.test(n)&&(t=h(n,!0))&&(t=n.indexOf(")",n.length-t)-n.length)&&(e[0]=e[0].slice(0,t),e[2]=n.slice(0,t)),e.slice(0,3))}},filter:{TAG:function(e){var t=e.replace(te,ne).toLowerCase();return"*"===e?function(){return!0}:function(e){return e.nodeName&&e.nodeName.toLowerCase()===t}},CLASS:function(e){var t=m[e+" "];return t||(t=new RegExp("(^|"+M+")"+e+"("+M+"|$)"))&&m(e,function(e){return t.test("string"==typeof e.className&&e.className||"undefined"!=typeof e.getAttribute&&e.getAttribute("class")||"")})},ATTR:function(n,r,i){return function(e){var t=se.attr(e,n);return null==t?"!="===r:!r||(t+="","="===r?t===i:"!="===r?t!==i:"^="===r?i&&0===t.indexOf(i):"*="===r?i&&-1<t.indexOf(i):"$="===r?i&&t.slice(-i.length)===i:"~="===r?-1<(" "+t.replace($," ")+" ").indexOf(i):"|="===r&&(t===i||t.slice(0,i.length+1)===i+"-"))}},CHILD:function(h,e,t,g,y){var v="nth"!==h.slice(0,3),m="last"!==h.slice(-4),x="of-type"===e;return 1===g&&0===y?function(e){return!!e.parentNode}:function(e,t,n){var r,i,o,a,s,u,l=v!==m?"nextSibling":"previousSibling",c=e.parentNode,f=x&&e.nodeName.toLowerCase(),p=!n&&!x,d=!1;if(c){if(v){while(l){a=e;while(a=a[l])if(x?a.nodeName.toLowerCase()===f:1===a.nodeType)return!1;u=l="only"===h&&!u&&"nextSibling"}return!0}if(u=[m?c.firstChild:c.lastChild],m&&p){d=(s=(r=(i=(o=(a=c)[S]||(a[S]={}))[a.uniqueID]||(o[a.uniqueID]={}))[h]||[])[0]===k&&r[1])&&r[2],a=s&&c.childNodes[s];while(a=++s&&a&&a[l]||(d=s=0)||u.pop())if(1===a.nodeType&&++d&&a===e){i[h]=[k,s,d];break}}else if(p&&(d=s=(r=(i=(o=(a=e)[S]||(a[S]={}))[a.uniqueID]||(o[a.uniqueID]={}))[h]||[])[0]===k&&r[1]),!1===d)while(a=++s&&a&&a[l]||(d=s=0)||u.pop())if((x?a.nodeName.toLowerCase()===f:1===a.nodeType)&&++d&&(p&&((i=(o=a[S]||(a[S]={}))[a.uniqueID]||(o[a.uniqueID]={}))[h]=[k,d]),a===e))break;return(d-=y)===g||d%g==0&&0<=d/g}}},PSEUDO:function(e,o){var t,a=b.pseudos[e]||b.setFilters[e.toLowerCase()]||se.error("unsupported pseudo: "+e);return a[S]?a(o):1<a.length?(t=[e,e,"",o],b.setFilters.hasOwnProperty(e.toLowerCase())?le(function(e,t){var n,r=a(e,o),i=r.length;while(i--)e[n=P(e,r[i])]=!(t[n]=r[i])}):function(e){return a(e,0,t)}):a}},pseudos:{not:le(function(e){var r=[],i=[],s=f(e.replace(B,"$1"));return s[S]?le(function(e,t,n,r){var i,o=s(e,null,r,[]),a=e.length;while(a--)(i=o[a])&&(e[a]=!(t[a]=i))}):function(e,t,n){return r[0]=e,s(r,null,n,i),r[0]=null,!i.pop()}}),has:le(function(t){return function(e){return 0<se(t,e).length}}),contains:le(function(t){return t=t.replace(te,ne),function(e){return-1<(e.textContent||o(e)).indexOf(t)}}),lang:le(function(n){return V.test(n||"")||se.error("unsupported lang: "+n),n=n.replace(te,ne).toLowerCase(),function(e){var t;do{if(t=E?e.lang:e.getAttribute("xml:lang")||e.getAttribute("lang"))return(t=t.toLowerCase())===n||0===t.indexOf(n+"-")}while((e=e.parentNode)&&1===e.nodeType);return!1}}),target:function(e){var t=n.location&&n.location.hash;return t&&t.slice(1)===e.id},root:function(e){return e===a},focus:function(e){return e===C.activeElement&&(!C.hasFocus||C.hasFocus())&&!!(e.type||e.href||~e.tabIndex)},enabled:ge(!1),disabled:ge(!0),checked:function(e){var t=e.nodeName.toLowerCase();return"input"===t&&!!e.checked||"option"===t&&!!e.selected},selected:function(e){return e.parentNode&&e.parentNode.selectedIndex,!0===e.selected},empty:function(e){for(e=e.firstChild;e;e=e.nextSibling)if(e.nodeType<6)return!1;return!0},parent:function(e){return!b.pseudos.empty(e)},header:function(e){return J.test(e.nodeName)},input:function(e){return Q.test(e.nodeName)},button:function(e){var t=e.nodeName.toLowerCase();return"input"===t&&"button"===e.type||"button"===t},text:function(e){var t;return"input"===e.nodeName.toLowerCase()&&"text"===e.type&&(null==(t=e.getAttribute("type"))||"text"===t.toLowerCase())},first:ye(function(){return[0]}),last:ye(function(e,t){return[t-1]}),eq:ye(function(e,t,n){return[n<0?n+t:n]}),even:ye(function(e,t){for(var n=0;n<t;n+=2)e.push(n);return e}),odd:ye(function(e,t){for(var n=1;n<t;n+=2)e.push(n);return e}),lt:ye(function(e,t,n){for(var r=n<0?n+t:t<n?t:n;0<=--r;)e.push(r);return e}),gt:ye(function(e,t,n){for(var r=n<0?n+t:n;++r<t;)e.push(r);return e})}}).pseudos.nth=b.pseudos.eq,{radio:!0,checkbox:!0,file:!0,password:!0,image:!0})b.pseudos[e]=de(e);for(e in{submit:!0,reset:!0})b.pseudos[e]=he(e);function me(){}function xe(e){for(var t=0,n=e.length,r="";t<n;t++)r+=e[t].value;return r}function be(s,e,t){var u=e.dir,l=e.next,c=l||u,f=t&&"parentNode"===c,p=r++;return e.first?function(e,t,n){while(e=e[u])if(1===e.nodeType||f)return s(e,t,n);return!1}:function(e,t,n){var r,i,o,a=[k,p];if(n){while(e=e[u])if((1===e.nodeType||f)&&s(e,t,n))return!0}else while(e=e[u])if(1===e.nodeType||f)if(i=(o=e[S]||(e[S]={}))[e.uniqueID]||(o[e.uniqueID]={}),l&&l===e.nodeName.toLowerCase())e=e[u]||e;else{if((r=i[c])&&r[0]===k&&r[1]===p)return a[2]=r[2];if((i[c]=a)[2]=s(e,t,n))return!0}return!1}}function we(i){return 1<i.length?function(e,t,n){var r=i.length;while(r--)if(!i[r](e,t,n))return!1;return!0}:i[0]}function Te(e,t,n,r,i){for(var o,a=[],s=0,u=e.length,l=null!=t;s<u;s++)(o=e[s])&&(n&&!n(o,r,i)||(a.push(o),l&&t.push(s)));return a}function Ce(d,h,g,y,v,e){return y&&!y[S]&&(y=Ce(y)),v&&!v[S]&&(v=Ce(v,e)),le(function(e,t,n,r){var i,o,a,s=[],u=[],l=t.length,c=e||function(e,t,n){for(var r=0,i=t.length;r<i;r++)se(e,t[r],n);return n}(h||"*",n.nodeType?[n]:n,[]),f=!d||!e&&h?c:Te(c,s,d,n,r),p=g?v||(e?d:l||y)?[]:t:f;if(g&&g(f,p,n,r),y){i=Te(p,u),y(i,[],n,r),o=i.length;while(o--)(a=i[o])&&(p[u[o]]=!(f[u[o]]=a))}if(e){if(v||d){if(v){i=[],o=p.length;while(o--)(a=p[o])&&i.push(f[o]=a);v(null,p=[],i,r)}o=p.length;while(o--)(a=p[o])&&-1<(i=v?P(e,a):s[o])&&(e[i]=!(t[i]=a))}}else p=Te(p===t?p.splice(l,p.length):p),v?v(null,t,p,r):H.apply(t,p)})}function Ee(e){for(var i,t,n,r=e.length,o=b.relative[e[0].type],a=o||b.relative[" "],s=o?1:0,u=be(function(e){return e===i},a,!0),l=be(function(e){return-1<P(i,e)},a,!0),c=[function(e,t,n){var r=!o&&(n||t!==w)||((i=t).nodeType?u(e,t,n):l(e,t,n));return i=null,r}];s<r;s++)if(t=b.relative[e[s].type])c=[be(we(c),t)];else{if((t=b.filter[e[s].type].apply(null,e[s].matches))[S]){for(n=++s;n<r;n++)if(b.relative[e[n].type])break;return Ce(1<s&&we(c),1<s&&xe(e.slice(0,s-1).concat({value:" "===e[s-2].type?"*":""})).replace(B,"$1"),t,s<n&&Ee(e.slice(s,n)),n<r&&Ee(e=e.slice(n)),n<r&&xe(e))}c.push(t)}return we(c)}return me.prototype=b.filters=b.pseudos,b.setFilters=new me,h=se.tokenize=function(e,t){var n,r,i,o,a,s,u,l=x[e+" "];if(l)return t?0:l.slice(0);a=e,s=[],u=b.preFilter;while(a){for(o in n&&!(r=_.exec(a))||(r&&(a=a.slice(r[0].length)||a),s.push(i=[])),n=!1,(r=z.exec(a))&&(n=r.shift(),i.push({value:n,type:r[0].replace(B," ")}),a=a.slice(n.length)),b.filter)!(r=G[o].exec(a))||u[o]&&!(r=u[o](r))||(n=r.shift(),i.push({value:n,type:o,matches:r}),a=a.slice(n.length));if(!n)break}return t?a.length:a?se.error(e):x(e,s).slice(0)},f=se.compile=function(e,t){var n,y,v,m,x,r,i=[],o=[],a=A[e+" "];if(!a){t||(t=h(e)),n=t.length;while(n--)(a=Ee(t[n]))[S]?i.push(a):o.push(a);(a=A(e,(y=o,m=0<(v=i).length,x=0<y.length,r=function(e,t,n,r,i){var o,a,s,u=0,l="0",c=e&&[],f=[],p=w,d=e||x&&b.find.TAG("*",i),h=k+=null==p?1:Math.random()||.1,g=d.length;for(i&&(w=t==C||t||i);l!==g&&null!=(o=d[l]);l++){if(x&&o){a=0,t||o.ownerDocument==C||(T(o),n=!E);while(s=y[a++])if(s(o,t||C,n)){r.push(o);break}i&&(k=h)}m&&((o=!s&&o)&&u--,e&&c.push(o))}if(u+=l,m&&l!==u){a=0;while(s=v[a++])s(c,f,t,n);if(e){if(0<u)while(l--)c[l]||f[l]||(f[l]=q.call(r));f=Te(f)}H.apply(r,f),i&&!e&&0<f.length&&1<u+v.length&&se.uniqueSort(r)}return i&&(k=h,w=p),c},m?le(r):r))).selector=e}return a},g=se.select=function(e,t,n,r){var i,o,a,s,u,l="function"==typeof e&&e,c=!r&&h(e=l.selector||e);if(n=n||[],1===c.length){if(2<(o=c[0]=c[0].slice(0)).length&&"ID"===(a=o[0]).type&&9===t.nodeType&&E&&b.relative[o[1].type]){if(!(t=(b.find.ID(a.matches[0].replace(te,ne),t)||[])[0]))return n;l&&(t=t.parentNode),e=e.slice(o.shift().value.length)}i=G.needsContext.test(e)?0:o.length;while(i--){if(a=o[i],b.relative[s=a.type])break;if((u=b.find[s])&&(r=u(a.matches[0].replace(te,ne),ee.test(o[0].type)&&ve(t.parentNode)||t))){if(o.splice(i,1),!(e=r.length&&xe(o)))return H.apply(n,r),n;break}}}return(l||f(e,c))(r,t,!E,n,!t||ee.test(e)&&ve(t.parentNode)||t),n},d.sortStable=S.split("").sort(j).join("")===S,d.detectDuplicates=!!l,T(),d.sortDetached=ce(function(e){return 1&e.compareDocumentPosition(C.createElement("fieldset"))}),ce(function(e){return e.innerHTML="<a href='#'></a>","#"===e.firstChild.getAttribute("href")})||fe("type|href|height|width",function(e,t,n){if(!n)return e.getAttribute(t,"type"===t.toLowerCase()?1:2)}),d.attributes&&ce(function(e){return e.innerHTML="<input/>",e.firstChild.setAttribute("value",""),""===e.firstChild.getAttribute("value")})||fe("value",function(e,t,n){if(!n&&"input"===e.nodeName.toLowerCase())return e.defaultValue}),ce(function(e){return null==e.getAttribute("disabled")})||fe(R,function(e,t,n){var r;if(!n)return!0===e[t]?t.toLowerCase():(r=e.getAttributeNode(t))&&r.specified?r.value:null}),se}(C);S.find=d,S.expr=d.selectors,S.expr[":"]=S.expr.pseudos,S.uniqueSort=S.unique=d.uniqueSort,S.text=d.getText,S.isXMLDoc=d.isXML,S.contains=d.contains,S.escapeSelector=d.escape;var h=function(e,t,n){var r=[],i=void 0!==n;while((e=e[t])&&9!==e.nodeType)if(1===e.nodeType){if(i&&S(e).is(n))break;r.push(e)}return r},T=function(e,t){for(var n=[];e;e=e.nextSibling)1===e.nodeType&&e!==t&&n.push(e);return n},k=S.expr.match.needsContext;function A(e,t){return e.nodeName&&e.nodeName.toLowerCase()===t.toLowerCase()}var N=/^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;function j(e,n,r){return m(n)?S.grep(e,function(e,t){return!!n.call(e,t,e)!==r}):n.nodeType?S.grep(e,function(e){return e===n!==r}):"string"!=typeof n?S.grep(e,function(e){return-1<i.call(n,e)!==r}):S.filter(n,e,r)}S.filter=function(e,t,n){var r=t[0];return n&&(e=":not("+e+")"),1===t.length&&1===r.nodeType?S.find.matchesSelector(r,e)?[r]:[]:S.find.matches(e,S.grep(t,function(e){return 1===e.nodeType}))},S.fn.extend({find:function(e){var t,n,r=this.length,i=this;if("string"!=typeof e)return this.pushStack(S(e).filter(function(){for(t=0;t<r;t++)if(S.contains(i[t],this))return!0}));for(n=this.pushStack([]),t=0;t<r;t++)S.find(e,i[t],n);return 1<r?S.uniqueSort(n):n},filter:function(e){return this.pushStack(j(this,e||[],!1))},not:function(e){return this.pushStack(j(this,e||[],!0))},is:function(e){return!!j(this,"string"==typeof e&&k.test(e)?S(e):e||[],!1).length}});var D,q=/^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/;(S.fn.init=function(e,t,n){var r,i;if(!e)return this;if(n=n||D,"string"==typeof e){if(!(r="<"===e[0]&&">"===e[e.length-1]&&3<=e.length?[null,e,null]:q.exec(e))||!r[1]&&t)return!t||t.jquery?(t||n).find(e):this.constructor(t).find(e);if(r[1]){if(t=t instanceof S?t[0]:t,S.merge(this,S.parseHTML(r[1],t&&t.nodeType?t.ownerDocument||t:E,!0)),N.test(r[1])&&S.isPlainObject(t))for(r in t)m(this[r])?this[r](t[r]):this.attr(r,t[r]);return this}return(i=E.getElementById(r[2]))&&(this[0]=i,this.length=1),this}return e.nodeType?(this[0]=e,this.length=1,this):m(e)?void 0!==n.ready?n.ready(e):e(S):S.makeArray(e,this)}).prototype=S.fn,D=S(E);var L=/^(?:parents|prev(?:Until|All))/,H={children:!0,contents:!0,next:!0,prev:!0};function O(e,t){while((e=e[t])&&1!==e.nodeType);return e}S.fn.extend({has:function(e){var t=S(e,this),n=t.length;return this.filter(function(){for(var e=0;e<n;e++)if(S.contains(this,t[e]))return!0})},closest:function(e,t){var n,r=0,i=this.length,o=[],a="string"!=typeof e&&S(e);if(!k.test(e))for(;r<i;r++)for(n=this[r];n&&n!==t;n=n.parentNode)if(n.nodeType<11&&(a?-1<a.index(n):1===n.nodeType&&S.find.matchesSelector(n,e))){o.push(n);break}return this.pushStack(1<o.length?S.uniqueSort(o):o)},index:function(e){return e?"string"==typeof e?i.call(S(e),this[0]):i.call(this,e.jquery?e[0]:e):this[0]&&this[0].parentNode?this.first().prevAll().length:-1},add:function(e,t){return this.pushStack(S.uniqueSort(S.merge(this.get(),S(e,t))))},addBack:function(e){return this.add(null==e?this.prevObject:this.prevObject.filter(e))}}),S.each({parent:function(e){var t=e.parentNode;return t&&11!==t.nodeType?t:null},parents:function(e){return h(e,"parentNode")},parentsUntil:function(e,t,n){return h(e,"parentNode",n)},next:function(e){return O(e,"nextSibling")},prev:function(e){return O(e,"previousSibling")},nextAll:function(e){return h(e,"nextSibling")},prevAll:function(e){return h(e,"previousSibling")},nextUntil:function(e,t,n){return h(e,"nextSibling",n)},prevUntil:function(e,t,n){return h(e,"previousSibling",n)},siblings:function(e){return T((e.parentNode||{}).firstChild,e)},children:function(e){return T(e.firstChild)},contents:function(e){return null!=e.contentDocument&&r(e.contentDocument)?e.contentDocument:(A(e,"template")&&(e=e.content||e),S.merge([],e.childNodes))}},function(r,i){S.fn[r]=function(e,t){var n=S.map(this,i,e);return"Until"!==r.slice(-5)&&(t=e),t&&"string"==typeof t&&(n=S.filter(t,n)),1<this.length&&(H[r]||S.uniqueSort(n),L.test(r)&&n.reverse()),this.pushStack(n)}});var P=/[^\x20\t\r\n\f]+/g;function R(e){return e}function M(e){throw e}function I(e,t,n,r){var i;try{e&&m(i=e.promise)?i.call(e).done(t).fail(n):e&&m(i=e.then)?i.call(e,t,n):t.apply(void 0,[e].slice(r))}catch(e){n.apply(void 0,[e])}}S.Callbacks=function(r){var e,n;r="string"==typeof r?(e=r,n={},S.each(e.match(P)||[],function(e,t){n[t]=!0}),n):S.extend({},r);var i,t,o,a,s=[],u=[],l=-1,c=function(){for(a=a||r.once,o=i=!0;u.length;l=-1){t=u.shift();while(++l<s.length)!1===s[l].apply(t[0],t[1])&&r.stopOnFalse&&(l=s.length,t=!1)}r.memory||(t=!1),i=!1,a&&(s=t?[]:"")},f={add:function(){return s&&(t&&!i&&(l=s.length-1,u.push(t)),function n(e){S.each(e,function(e,t){m(t)?r.unique&&f.has(t)||s.push(t):t&&t.length&&"string"!==w(t)&&n(t)})}(arguments),t&&!i&&c()),this},remove:function(){return S.each(arguments,function(e,t){var n;while(-1<(n=S.inArray(t,s,n)))s.splice(n,1),n<=l&&l--}),this},has:function(e){return e?-1<S.inArray(e,s):0<s.length},empty:function(){return s&&(s=[]),this},disable:function(){return a=u=[],s=t="",this},disabled:function(){return!s},lock:function(){return a=u=[],t||i||(s=t=""),this},locked:function(){return!!a},fireWith:function(e,t){return a||(t=[e,(t=t||[]).slice?t.slice():t],u.push(t),i||c()),this},fire:function(){return f.fireWith(this,arguments),this},fired:function(){return!!o}};return f},S.extend({Deferred:function(e){var o=[["notify","progress",S.Callbacks("memory"),S.Callbacks("memory"),2],["resolve","done",S.Callbacks("once memory"),S.Callbacks("once memory"),0,"resolved"],["reject","fail",S.Callbacks("once memory"),S.Callbacks("once memory"),1,"rejected"]],i="pending",a={state:function(){return i},always:function(){return s.done(arguments).fail(arguments),this},"catch":function(e){return a.then(null,e)},pipe:function(){var i=arguments;return S.Deferred(function(r){S.each(o,function(e,t){var n=m(i[t[4]])&&i[t[4]];s[t[1]](function(){var e=n&&n.apply(this,arguments);e&&m(e.promise)?e.promise().progress(r.notify).done(r.resolve).fail(r.reject):r[t[0]+"With"](this,n?[e]:arguments)})}),i=null}).promise()},then:function(t,n,r){var u=0;function l(i,o,a,s){return function(){var n=this,r=arguments,e=function(){var e,t;if(!(i<u)){if((e=a.apply(n,r))===o.promise())throw new TypeError("Thenable self-resolution");t=e&&("object"==typeof e||"function"==typeof e)&&e.then,m(t)?s?t.call(e,l(u,o,R,s),l(u,o,M,s)):(u++,t.call(e,l(u,o,R,s),l(u,o,M,s),l(u,o,R,o.notifyWith))):(a!==R&&(n=void 0,r=[e]),(s||o.resolveWith)(n,r))}},t=s?e:function(){try{e()}catch(e){S.Deferred.exceptionHook&&S.Deferred.exceptionHook(e,t.stackTrace),u<=i+1&&(a!==M&&(n=void 0,r=[e]),o.rejectWith(n,r))}};i?t():(S.Deferred.getStackHook&&(t.stackTrace=S.Deferred.getStackHook()),C.setTimeout(t))}}return S.Deferred(function(e){o[0][3].add(l(0,e,m(r)?r:R,e.notifyWith)),o[1][3].add(l(0,e,m(t)?t:R)),o[2][3].add(l(0,e,m(n)?n:M))}).promise()},promise:function(e){return null!=e?S.extend(e,a):a}},s={};return S.each(o,function(e,t){var n=t[2],r=t[5];a[t[1]]=n.add,r&&n.add(function(){i=r},o[3-e][2].disable,o[3-e][3].disable,o[0][2].lock,o[0][3].lock),n.add(t[3].fire),s[t[0]]=function(){return s[t[0]+"With"](this===s?void 0:this,arguments),this},s[t[0]+"With"]=n.fireWith}),a.promise(s),e&&e.call(s,s),s},when:function(e){var n=arguments.length,t=n,r=Array(t),i=s.call(arguments),o=S.Deferred(),a=function(t){return function(e){r[t]=this,i[t]=1<arguments.length?s.call(arguments):e,--n||o.resolveWith(r,i)}};if(n<=1&&(I(e,o.done(a(t)).resolve,o.reject,!n),"pending"===o.state()||m(i[t]&&i[t].then)))return o.then();while(t--)I(i[t],a(t),o.reject);return o.promise()}});var W=/^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;S.Deferred.exceptionHook=function(e,t){C.console&&C.console.warn&&e&&W.test(e.name)&&C.console.warn("jQuery.Deferred exception: "+e.message,e.stack,t)},S.readyException=function(e){C.setTimeout(function(){throw e})};var F=S.Deferred();function $(){E.removeEventListener("DOMContentLoaded",$),C.removeEventListener("load",$),S.ready()}S.fn.ready=function(e){return F.then(e)["catch"](function(e){S.readyException(e)}),this},S.extend({isReady:!1,readyWait:1,ready:function(e){(!0===e?--S.readyWait:S.isReady)||(S.isReady=!0)!==e&&0<--S.readyWait||F.resolveWith(E,[S])}}),S.ready.then=F.then,"complete"===E.readyState||"loading"!==E.readyState&&!E.documentElement.doScroll?C.setTimeout(S.ready):(E.addEventListener("DOMContentLoaded",$),C.addEventListener("load",$));var B=function(e,t,n,r,i,o,a){var s=0,u=e.length,l=null==n;if("object"===w(n))for(s in i=!0,n)B(e,t,s,n[s],!0,o,a);else if(void 0!==r&&(i=!0,m(r)||(a=!0),l&&(a?(t.call(e,r),t=null):(l=t,t=function(e,t,n){return l.call(S(e),n)})),t))for(;s<u;s++)t(e[s],n,a?r:r.call(e[s],s,t(e[s],n)));return i?e:l?t.call(e):u?t(e[0],n):o},_=/^-ms-/,z=/-([a-z])/g;function U(e,t){return t.toUpperCase()}function X(e){return e.replace(_,"ms-").replace(z,U)}var V=function(e){return 1===e.nodeType||9===e.nodeType||!+e.nodeType};function G(){this.expando=S.expando+G.uid++}G.uid=1,G.prototype={cache:function(e){var t=e[this.expando];return t||(t={},V(e)&&(e.nodeType?e[this.expando]=t:Object.defineProperty(e,this.expando,{value:t,configurable:!0}))),t},set:function(e,t,n){var r,i=this.cache(e);if("string"==typeof t)i[X(t)]=n;else for(r in t)i[X(r)]=t[r];return i},get:function(e,t){return void 0===t?this.cache(e):e[this.expando]&&e[this.expando][X(t)]},access:function(e,t,n){return void 0===t||t&&"string"==typeof t&&void 0===n?this.get(e,t):(this.set(e,t,n),void 0!==n?n:t)},remove:function(e,t){var n,r=e[this.expando];if(void 0!==r){if(void 0!==t){n=(t=Array.isArray(t)?t.map(X):(t=X(t))in r?[t]:t.match(P)||[]).length;while(n--)delete r[t[n]]}(void 0===t||S.isEmptyObject(r))&&(e.nodeType?e[this.expando]=void 0:delete e[this.expando])}},hasData:function(e){var t=e[this.expando];return void 0!==t&&!S.isEmptyObject(t)}};var Y=new G,Q=new G,J=/^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,K=/[A-Z]/g;function Z(e,t,n){var r,i;if(void 0===n&&1===e.nodeType)if(r="data-"+t.replace(K,"-$&").toLowerCase(),"string"==typeof(n=e.getAttribute(r))){try{n="true"===(i=n)||"false"!==i&&("null"===i?null:i===+i+""?+i:J.test(i)?JSON.parse(i):i)}catch(e){}Q.set(e,t,n)}else n=void 0;return n}S.extend({hasData:function(e){return Q.hasData(e)||Y.hasData(e)},data:function(e,t,n){return Q.access(e,t,n)},removeData:function(e,t){Q.remove(e,t)},_data:function(e,t,n){return Y.access(e,t,n)},_removeData:function(e,t){Y.remove(e,t)}}),S.fn.extend({data:function(n,e){var t,r,i,o=this[0],a=o&&o.attributes;if(void 0===n){if(this.length&&(i=Q.get(o),1===o.nodeType&&!Y.get(o,"hasDataAttrs"))){t=a.length;while(t--)a[t]&&0===(r=a[t].name).indexOf("data-")&&(r=X(r.slice(5)),Z(o,r,i[r]));Y.set(o,"hasDataAttrs",!0)}return i}return"object"==typeof n?this.each(function(){Q.set(this,n)}):B(this,function(e){var t;if(o&&void 0===e)return void 0!==(t=Q.get(o,n))?t:void 0!==(t=Z(o,n))?t:void 0;this.each(function(){Q.set(this,n,e)})},null,e,1<arguments.length,null,!0)},removeData:function(e){return this.each(function(){Q.remove(this,e)})}}),S.extend({queue:function(e,t,n){var r;if(e)return t=(t||"fx")+"queue",r=Y.get(e,t),n&&(!r||Array.isArray(n)?r=Y.access(e,t,S.makeArray(n)):r.push(n)),r||[]},dequeue:function(e,t){t=t||"fx";var n=S.queue(e,t),r=n.length,i=n.shift(),o=S._queueHooks(e,t);"inprogress"===i&&(i=n.shift(),r--),i&&("fx"===t&&n.unshift("inprogress"),delete o.stop,i.call(e,function(){S.dequeue(e,t)},o)),!r&&o&&o.empty.fire()},_queueHooks:function(e,t){var n=t+"queueHooks";return Y.get(e,n)||Y.access(e,n,{empty:S.Callbacks("once memory").add(function(){Y.remove(e,[t+"queue",n])})})}}),S.fn.extend({queue:function(t,n){var e=2;return"string"!=typeof t&&(n=t,t="fx",e--),arguments.length<e?S.queue(this[0],t):void 0===n?this:this.each(function(){var e=S.queue(this,t,n);S._queueHooks(this,t),"fx"===t&&"inprogress"!==e[0]&&S.dequeue(this,t)})},dequeue:function(e){return this.each(function(){S.dequeue(this,e)})},clearQueue:function(e){return this.queue(e||"fx",[])},promise:function(e,t){var n,r=1,i=S.Deferred(),o=this,a=this.length,s=function(){--r||i.resolveWith(o,[o])};"string"!=typeof e&&(t=e,e=void 0),e=e||"fx";while(a--)(n=Y.get(o[a],e+"queueHooks"))&&n.empty&&(r++,n.empty.add(s));return s(),i.promise(t)}});var ee=/[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,te=new RegExp("^(?:([+-])=|)("+ee+")([a-z%]*)$","i"),ne=["Top","Right","Bottom","Left"],re=E.documentElement,ie=function(e){return S.contains(e.ownerDocument,e)},oe={composed:!0};re.getRootNode&&(ie=function(e){return S.contains(e.ownerDocument,e)||e.getRootNode(oe)===e.ownerDocument});var ae=function(e,t){return"none"===(e=t||e).style.display||""===e.style.display&&ie(e)&&"none"===S.css(e,"display")};function se(e,t,n,r){var i,o,a=20,s=r?function(){return r.cur()}:function(){return S.css(e,t,"")},u=s(),l=n&&n[3]||(S.cssNumber[t]?"":"px"),c=e.nodeType&&(S.cssNumber[t]||"px"!==l&&+u)&&te.exec(S.css(e,t));if(c&&c[3]!==l){u/=2,l=l||c[3],c=+u||1;while(a--)S.style(e,t,c+l),(1-o)*(1-(o=s()/u||.5))<=0&&(a=0),c/=o;c*=2,S.style(e,t,c+l),n=n||[]}return n&&(c=+c||+u||0,i=n[1]?c+(n[1]+1)*n[2]:+n[2],r&&(r.unit=l,r.start=c,r.end=i)),i}var ue={};function le(e,t){for(var n,r,i,o,a,s,u,l=[],c=0,f=e.length;c<f;c++)(r=e[c]).style&&(n=r.style.display,t?("none"===n&&(l[c]=Y.get(r,"display")||null,l[c]||(r.style.display="")),""===r.style.display&&ae(r)&&(l[c]=(u=a=o=void 0,a=(i=r).ownerDocument,s=i.nodeName,(u=ue[s])||(o=a.body.appendChild(a.createElement(s)),u=S.css(o,"display"),o.parentNode.removeChild(o),"none"===u&&(u="block"),ue[s]=u)))):"none"!==n&&(l[c]="none",Y.set(r,"display",n)));for(c=0;c<f;c++)null!=l[c]&&(e[c].style.display=l[c]);return e}S.fn.extend({show:function(){return le(this,!0)},hide:function(){return le(this)},toggle:function(e){return"boolean"==typeof e?e?this.show():this.hide():this.each(function(){ae(this)?S(this).show():S(this).hide()})}});var ce,fe,pe=/^(?:checkbox|radio)$/i,de=/<([a-z][^\/\0>\x20\t\r\n\f]*)/i,he=/^$|^module$|\/(?:java|ecma)script/i;ce=E.createDocumentFragment().appendChild(E.createElement("div")),(fe=E.createElement("input")).setAttribute("type","radio"),fe.setAttribute("checked","checked"),fe.setAttribute("name","t"),ce.appendChild(fe),v.checkClone=ce.cloneNode(!0).cloneNode(!0).lastChild.checked,ce.innerHTML="<textarea>x</textarea>",v.noCloneChecked=!!ce.cloneNode(!0).lastChild.defaultValue,ce.innerHTML="<option></option>",v.option=!!ce.lastChild;var ge={thead:[1,"<table>","</table>"],col:[2,"<table><colgroup>","</colgroup></table>"],tr:[2,"<table><tbody>","</tbody></table>"],td:[3,"<table><tbody><tr>","</tr></tbody></table>"],_default:[0,"",""]};function ye(e,t){var n;return n="undefined"!=typeof e.getElementsByTagName?e.getElementsByTagName(t||"*"):"undefined"!=typeof e.querySelectorAll?e.querySelectorAll(t||"*"):[],void 0===t||t&&A(e,t)?S.merge([e],n):n}function ve(e,t){for(var n=0,r=e.length;n<r;n++)Y.set(e[n],"globalEval",!t||Y.get(t[n],"globalEval"))}ge.tbody=ge.tfoot=ge.colgroup=ge.caption=ge.thead,ge.th=ge.td,v.option||(ge.optgroup=ge.option=[1,"<select multiple='multiple'>","</select>"]);var me=/<|&#?\w+;/;function xe(e,t,n,r,i){for(var o,a,s,u,l,c,f=t.createDocumentFragment(),p=[],d=0,h=e.length;d<h;d++)if((o=e[d])||0===o)if("object"===w(o))S.merge(p,o.nodeType?[o]:o);else if(me.test(o)){a=a||f.appendChild(t.createElement("div")),s=(de.exec(o)||["",""])[1].toLowerCase(),u=ge[s]||ge._default,a.innerHTML=u[1]+S.htmlPrefilter(o)+u[2],c=u[0];while(c--)a=a.lastChild;S.merge(p,a.childNodes),(a=f.firstChild).textContent=""}else p.push(t.createTextNode(o));f.textContent="",d=0;while(o=p[d++])if(r&&-1<S.inArray(o,r))i&&i.push(o);else if(l=ie(o),a=ye(f.appendChild(o),"script"),l&&ve(a),n){c=0;while(o=a[c++])he.test(o.type||"")&&n.push(o)}return f}var be=/^([^.]*)(?:\.(.+)|)/;function we(){return!0}function Te(){return!1}function Ce(e,t){return e===function(){try{return E.activeElement}catch(e){}}()==("focus"===t)}function Ee(e,t,n,r,i,o){var a,s;if("object"==typeof t){for(s in"string"!=typeof n&&(r=r||n,n=void 0),t)Ee(e,s,n,r,t[s],o);return e}if(null==r&&null==i?(i=n,r=n=void 0):null==i&&("string"==typeof n?(i=r,r=void 0):(i=r,r=n,n=void 0)),!1===i)i=Te;else if(!i)return e;return 1===o&&(a=i,(i=function(e){return S().off(e),a.apply(this,arguments)}).guid=a.guid||(a.guid=S.guid++)),e.each(function(){S.event.add(this,t,i,r,n)})}function Se(e,i,o){o?(Y.set(e,i,!1),S.event.add(e,i,{namespace:!1,handler:function(e){var t,n,r=Y.get(this,i);if(1&e.isTrigger&&this[i]){if(r.length)(S.event.special[i]||{}).delegateType&&e.stopPropagation();else if(r=s.call(arguments),Y.set(this,i,r),t=o(this,i),this[i](),r!==(n=Y.get(this,i))||t?Y.set(this,i,!1):n={},r!==n)return e.stopImmediatePropagation(),e.preventDefault(),n&&n.value}else r.length&&(Y.set(this,i,{value:S.event.trigger(S.extend(r[0],S.Event.prototype),r.slice(1),this)}),e.stopImmediatePropagation())}})):void 0===Y.get(e,i)&&S.event.add(e,i,we)}S.event={global:{},add:function(t,e,n,r,i){var o,a,s,u,l,c,f,p,d,h,g,y=Y.get(t);if(V(t)){n.handler&&(n=(o=n).handler,i=o.selector),i&&S.find.matchesSelector(re,i),n.guid||(n.guid=S.guid++),(u=y.events)||(u=y.events=Object.create(null)),(a=y.handle)||(a=y.handle=function(e){return"undefined"!=typeof S&&S.event.triggered!==e.type?S.event.dispatch.apply(t,arguments):void 0}),l=(e=(e||"").match(P)||[""]).length;while(l--)d=g=(s=be.exec(e[l])||[])[1],h=(s[2]||"").split(".").sort(),d&&(f=S.event.special[d]||{},d=(i?f.delegateType:f.bindType)||d,f=S.event.special[d]||{},c=S.extend({type:d,origType:g,data:r,handler:n,guid:n.guid,selector:i,needsContext:i&&S.expr.match.needsContext.test(i),namespace:h.join(".")},o),(p=u[d])||((p=u[d]=[]).delegateCount=0,f.setup&&!1!==f.setup.call(t,r,h,a)||t.addEventListener&&t.addEventListener(d,a)),f.add&&(f.add.call(t,c),c.handler.guid||(c.handler.guid=n.guid)),i?p.splice(p.delegateCount++,0,c):p.push(c),S.event.global[d]=!0)}},remove:function(e,t,n,r,i){var o,a,s,u,l,c,f,p,d,h,g,y=Y.hasData(e)&&Y.get(e);if(y&&(u=y.events)){l=(t=(t||"").match(P)||[""]).length;while(l--)if(d=g=(s=be.exec(t[l])||[])[1],h=(s[2]||"").split(".").sort(),d){f=S.event.special[d]||{},p=u[d=(r?f.delegateType:f.bindType)||d]||[],s=s[2]&&new RegExp("(^|\\.)"+h.join("\\.(?:.*\\.|)")+"(\\.|$)"),a=o=p.length;while(o--)c=p[o],!i&&g!==c.origType||n&&n.guid!==c.guid||s&&!s.test(c.namespace)||r&&r!==c.selector&&("**"!==r||!c.selector)||(p.splice(o,1),c.selector&&p.delegateCount--,f.remove&&f.remove.call(e,c));a&&!p.length&&(f.teardown&&!1!==f.teardown.call(e,h,y.handle)||S.removeEvent(e,d,y.handle),delete u[d])}else for(d in u)S.event.remove(e,d+t[l],n,r,!0);S.isEmptyObject(u)&&Y.remove(e,"handle events")}},dispatch:function(e){var t,n,r,i,o,a,s=new Array(arguments.length),u=S.event.fix(e),l=(Y.get(this,"events")||Object.create(null))[u.type]||[],c=S.event.special[u.type]||{};for(s[0]=u,t=1;t<arguments.length;t++)s[t]=arguments[t];if(u.delegateTarget=this,!c.preDispatch||!1!==c.preDispatch.call(this,u)){a=S.event.handlers.call(this,u,l),t=0;while((i=a[t++])&&!u.isPropagationStopped()){u.currentTarget=i.elem,n=0;while((o=i.handlers[n++])&&!u.isImmediatePropagationStopped())u.rnamespace&&!1!==o.namespace&&!u.rnamespace.test(o.namespace)||(u.handleObj=o,u.data=o.data,void 0!==(r=((S.event.special[o.origType]||{}).handle||o.handler).apply(i.elem,s))&&!1===(u.result=r)&&(u.preventDefault(),u.stopPropagation()))}return c.postDispatch&&c.postDispatch.call(this,u),u.result}},handlers:function(e,t){var n,r,i,o,a,s=[],u=t.delegateCount,l=e.target;if(u&&l.nodeType&&!("click"===e.type&&1<=e.button))for(;l!==this;l=l.parentNode||this)if(1===l.nodeType&&("click"!==e.type||!0!==l.disabled)){for(o=[],a={},n=0;n<u;n++)void 0===a[i=(r=t[n]).selector+" "]&&(a[i]=r.needsContext?-1<S(i,this).index(l):S.find(i,this,null,[l]).length),a[i]&&o.push(r);o.length&&s.push({elem:l,handlers:o})}return l=this,u<t.length&&s.push({elem:l,handlers:t.slice(u)}),s},addProp:function(t,e){Object.defineProperty(S.Event.prototype,t,{enumerable:!0,configurable:!0,get:m(e)?function(){if(this.originalEvent)return e(this.originalEvent)}:function(){if(this.originalEvent)return this.originalEvent[t]},set:function(e){Object.defineProperty(this,t,{enumerable:!0,configurable:!0,writable:!0,value:e})}})},fix:function(e){return e[S.expando]?e:new S.Event(e)},special:{load:{noBubble:!0},click:{setup:function(e){var t=this||e;return pe.test(t.type)&&t.click&&A(t,"input")&&Se(t,"click",we),!1},trigger:function(e){var t=this||e;return pe.test(t.type)&&t.click&&A(t,"input")&&Se(t,"click"),!0},_default:function(e){var t=e.target;return pe.test(t.type)&&t.click&&A(t,"input")&&Y.get(t,"click")||A(t,"a")}},beforeunload:{postDispatch:function(e){void 0!==e.result&&e.originalEvent&&(e.originalEvent.returnValue=e.result)}}}},S.removeEvent=function(e,t,n){e.removeEventListener&&e.removeEventListener(t,n)},S.Event=function(e,t){if(!(this instanceof S.Event))return new S.Event(e,t);e&&e.type?(this.originalEvent=e,this.type=e.type,this.isDefaultPrevented=e.defaultPrevented||void 0===e.defaultPrevented&&!1===e.returnValue?we:Te,this.target=e.target&&3===e.target.nodeType?e.target.parentNode:e.target,this.currentTarget=e.currentTarget,this.relatedTarget=e.relatedTarget):this.type=e,t&&S.extend(this,t),this.timeStamp=e&&e.timeStamp||Date.now(),this[S.expando]=!0},S.Event.prototype={constructor:S.Event,isDefaultPrevented:Te,isPropagationStopped:Te,isImmediatePropagationStopped:Te,isSimulated:!1,preventDefault:function(){var e=this.originalEvent;this.isDefaultPrevented=we,e&&!this.isSimulated&&e.preventDefault()},stopPropagation:function(){var e=this.originalEvent;this.isPropagationStopped=we,e&&!this.isSimulated&&e.stopPropagation()},stopImmediatePropagation:function(){var e=this.originalEvent;this.isImmediatePropagationStopped=we,e&&!this.isSimulated&&e.stopImmediatePropagation(),this.stopPropagation()}},S.each({altKey:!0,bubbles:!0,cancelable:!0,changedTouches:!0,ctrlKey:!0,detail:!0,eventPhase:!0,metaKey:!0,pageX:!0,pageY:!0,shiftKey:!0,view:!0,"char":!0,code:!0,charCode:!0,key:!0,keyCode:!0,button:!0,buttons:!0,clientX:!0,clientY:!0,offsetX:!0,offsetY:!0,pointerId:!0,pointerType:!0,screenX:!0,screenY:!0,targetTouches:!0,toElement:!0,touches:!0,which:!0},S.event.addProp),S.each({focus:"focusin",blur:"focusout"},function(t,e){S.event.special[t]={setup:function(){return Se(this,t,Ce),!1},trigger:function(){return Se(this,t),!0},_default:function(e){return Y.get(e.target,t)},delegateType:e}}),S.each({mouseenter:"mouseover",mouseleave:"mouseout",pointerenter:"pointerover",pointerleave:"pointerout"},function(e,i){S.event.special[e]={delegateType:i,bindType:i,handle:function(e){var t,n=e.relatedTarget,r=e.handleObj;return n&&(n===this||S.contains(this,n))||(e.type=r.origType,t=r.handler.apply(this,arguments),e.type=i),t}}}),S.fn.extend({on:function(e,t,n,r){return Ee(this,e,t,n,r)},one:function(e,t,n,r){return Ee(this,e,t,n,r,1)},off:function(e,t,n){var r,i;if(e&&e.preventDefault&&e.handleObj)return r=e.handleObj,S(e.delegateTarget).off(r.namespace?r.origType+"."+r.namespace:r.origType,r.selector,r.handler),this;if("object"==typeof e){for(i in e)this.off(i,t,e[i]);return this}return!1!==t&&"function"!=typeof t||(n=t,t=void 0),!1===n&&(n=Te),this.each(function(){S.event.remove(this,e,n,t)})}});var ke=/<script|<style|<link/i,Ae=/checked\s*(?:[^=]|=\s*.checked.)/i,Ne=/^\s*<!\[CDATA\[|\]\]>\s*$/g;function je(e,t){return A(e,"table")&&A(11!==t.nodeType?t:t.firstChild,"tr")&&S(e).children("tbody")[0]||e}function De(e){return e.type=(null!==e.getAttribute("type"))+"/"+e.type,e}function qe(e){return"true/"===(e.type||"").slice(0,5)?e.type=e.type.slice(5):e.removeAttribute("type"),e}function Le(e,t){var n,r,i,o,a,s;if(1===t.nodeType){if(Y.hasData(e)&&(s=Y.get(e).events))for(i in Y.remove(t,"handle events"),s)for(n=0,r=s[i].length;n<r;n++)S.event.add(t,i,s[i][n]);Q.hasData(e)&&(o=Q.access(e),a=S.extend({},o),Q.set(t,a))}}function He(n,r,i,o){r=g(r);var e,t,a,s,u,l,c=0,f=n.length,p=f-1,d=r[0],h=m(d);if(h||1<f&&"string"==typeof d&&!v.checkClone&&Ae.test(d))return n.each(function(e){var t=n.eq(e);h&&(r[0]=d.call(this,e,t.html())),He(t,r,i,o)});if(f&&(t=(e=xe(r,n[0].ownerDocument,!1,n,o)).firstChild,1===e.childNodes.length&&(e=t),t||o)){for(s=(a=S.map(ye(e,"script"),De)).length;c<f;c++)u=e,c!==p&&(u=S.clone(u,!0,!0),s&&S.merge(a,ye(u,"script"))),i.call(n[c],u,c);if(s)for(l=a[a.length-1].ownerDocument,S.map(a,qe),c=0;c<s;c++)u=a[c],he.test(u.type||"")&&!Y.access(u,"globalEval")&&S.contains(l,u)&&(u.src&&"module"!==(u.type||"").toLowerCase()?S._evalUrl&&!u.noModule&&S._evalUrl(u.src,{nonce:u.nonce||u.getAttribute("nonce")},l):b(u.textContent.replace(Ne,""),u,l))}return n}function Oe(e,t,n){for(var r,i=t?S.filter(t,e):e,o=0;null!=(r=i[o]);o++)n||1!==r.nodeType||S.cleanData(ye(r)),r.parentNode&&(n&&ie(r)&&ve(ye(r,"script")),r.parentNode.removeChild(r));return e}S.extend({htmlPrefilter:function(e){return e},clone:function(e,t,n){var r,i,o,a,s,u,l,c=e.cloneNode(!0),f=ie(e);if(!(v.noCloneChecked||1!==e.nodeType&&11!==e.nodeType||S.isXMLDoc(e)))for(a=ye(c),r=0,i=(o=ye(e)).length;r<i;r++)s=o[r],u=a[r],void 0,"input"===(l=u.nodeName.toLowerCase())&&pe.test(s.type)?u.checked=s.checked:"input"!==l&&"textarea"!==l||(u.defaultValue=s.defaultValue);if(t)if(n)for(o=o||ye(e),a=a||ye(c),r=0,i=o.length;r<i;r++)Le(o[r],a[r]);else Le(e,c);return 0<(a=ye(c,"script")).length&&ve(a,!f&&ye(e,"script")),c},cleanData:function(e){for(var t,n,r,i=S.event.special,o=0;void 0!==(n=e[o]);o++)if(V(n)){if(t=n[Y.expando]){if(t.events)for(r in t.events)i[r]?S.event.remove(n,r):S.removeEvent(n,r,t.handle);n[Y.expando]=void 0}n[Q.expando]&&(n[Q.expando]=void 0)}}}),S.fn.extend({detach:function(e){return Oe(this,e,!0)},remove:function(e){return Oe(this,e)},text:function(e){return B(this,function(e){return void 0===e?S.text(this):this.empty().each(function(){1!==this.nodeType&&11!==this.nodeType&&9!==this.nodeType||(this.textContent=e)})},null,e,arguments.length)},append:function(){return He(this,arguments,function(e){1!==this.nodeType&&11!==this.nodeType&&9!==this.nodeType||je(this,e).appendChild(e)})},prepend:function(){return He(this,arguments,function(e){if(1===this.nodeType||11===this.nodeType||9===this.nodeType){var t=je(this,e);t.insertBefore(e,t.firstChild)}})},before:function(){return He(this,arguments,function(e){this.parentNode&&this.parentNode.insertBefore(e,this)})},after:function(){return He(this,arguments,function(e){this.parentNode&&this.parentNode.insertBefore(e,this.nextSibling)})},empty:function(){for(var e,t=0;null!=(e=this[t]);t++)1===e.nodeType&&(S.cleanData(ye(e,!1)),e.textContent="");return this},clone:function(e,t){return e=null!=e&&e,t=null==t?e:t,this.map(function(){return S.clone(this,e,t)})},html:function(e){return B(this,function(e){var t=this[0]||{},n=0,r=this.length;if(void 0===e&&1===t.nodeType)return t.innerHTML;if("string"==typeof e&&!ke.test(e)&&!ge[(de.exec(e)||["",""])[1].toLowerCase()]){e=S.htmlPrefilter(e);try{for(;n<r;n++)1===(t=this[n]||{}).nodeType&&(S.cleanData(ye(t,!1)),t.innerHTML=e);t=0}catch(e){}}t&&this.empty().append(e)},null,e,arguments.length)},replaceWith:function(){var n=[];return He(this,arguments,function(e){var t=this.parentNode;S.inArray(this,n)<0&&(S.cleanData(ye(this)),t&&t.replaceChild(e,this))},n)}}),S.each({appendTo:"append",prependTo:"prepend",insertBefore:"before",insertAfter:"after",replaceAll:"replaceWith"},function(e,a){S.fn[e]=function(e){for(var t,n=[],r=S(e),i=r.length-1,o=0;o<=i;o++)t=o===i?this:this.clone(!0),S(r[o])[a](t),u.apply(n,t.get());return this.pushStack(n)}});var Pe=new RegExp("^("+ee+")(?!px)[a-z%]+$","i"),Re=/^--/,Me=function(e){var t=e.ownerDocument.defaultView;return t&&t.opener||(t=C),t.getComputedStyle(e)},Ie=function(e,t,n){var r,i,o={};for(i in t)o[i]=e.style[i],e.style[i]=t[i];for(i in r=n.call(e),t)e.style[i]=o[i];return r},We=new RegExp(ne.join("|"),"i"),Fe="[\\x20\\t\\r\\n\\f]",$e=new RegExp("^"+Fe+"+|((?:^|[^\\\\])(?:\\\\.)*)"+Fe+"+$","g");function Be(e,t,n){var r,i,o,a,s=Re.test(t),u=e.style;return(n=n||Me(e))&&(a=n.getPropertyValue(t)||n[t],s&&a&&(a=a.replace($e,"$1")||void 0),""!==a||ie(e)||(a=S.style(e,t)),!v.pixelBoxStyles()&&Pe.test(a)&&We.test(t)&&(r=u.width,i=u.minWidth,o=u.maxWidth,u.minWidth=u.maxWidth=u.width=a,a=n.width,u.width=r,u.minWidth=i,u.maxWidth=o)),void 0!==a?a+"":a}function _e(e,t){return{get:function(){if(!e())return(this.get=t).apply(this,arguments);delete this.get}}}!function(){function e(){if(l){u.style.cssText="position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0",l.style.cssText="position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%",re.appendChild(u).appendChild(l);var e=C.getComputedStyle(l);n="1%"!==e.top,s=12===t(e.marginLeft),l.style.right="60%",o=36===t(e.right),r=36===t(e.width),l.style.position="absolute",i=12===t(l.offsetWidth/3),re.removeChild(u),l=null}}function t(e){return Math.round(parseFloat(e))}var n,r,i,o,a,s,u=E.createElement("div"),l=E.createElement("div");l.style&&(l.style.backgroundClip="content-box",l.cloneNode(!0).style.backgroundClip="",v.clearCloneStyle="content-box"===l.style.backgroundClip,S.extend(v,{boxSizingReliable:function(){return e(),r},pixelBoxStyles:function(){return e(),o},pixelPosition:function(){return e(),n},reliableMarginLeft:function(){return e(),s},scrollboxSize:function(){return e(),i},reliableTrDimensions:function(){var e,t,n,r;return null==a&&(e=E.createElement("table"),t=E.createElement("tr"),n=E.createElement("div"),e.style.cssText="position:absolute;left:-11111px;border-collapse:separate",t.style.cssText="border:1px solid",t.style.height="1px",n.style.height="9px",n.style.display="block",re.appendChild(e).appendChild(t).appendChild(n),r=C.getComputedStyle(t),a=parseInt(r.height,10)+parseInt(r.borderTopWidth,10)+parseInt(r.borderBottomWidth,10)===t.offsetHeight,re.removeChild(e)),a}}))}();var ze=["Webkit","Moz","ms"],Ue=E.createElement("div").style,Xe={};function Ve(e){var t=S.cssProps[e]||Xe[e];return t||(e in Ue?e:Xe[e]=function(e){var t=e[0].toUpperCase()+e.slice(1),n=ze.length;while(n--)if((e=ze[n]+t)in Ue)return e}(e)||e)}var Ge=/^(none|table(?!-c[ea]).+)/,Ye={position:"absolute",visibility:"hidden",display:"block"},Qe={letterSpacing:"0",fontWeight:"400"};function Je(e,t,n){var r=te.exec(t);return r?Math.max(0,r[2]-(n||0))+(r[3]||"px"):t}function Ke(e,t,n,r,i,o){var a="width"===t?1:0,s=0,u=0;if(n===(r?"border":"content"))return 0;for(;a<4;a+=2)"margin"===n&&(u+=S.css(e,n+ne[a],!0,i)),r?("content"===n&&(u-=S.css(e,"padding"+ne[a],!0,i)),"margin"!==n&&(u-=S.css(e,"border"+ne[a]+"Width",!0,i))):(u+=S.css(e,"padding"+ne[a],!0,i),"padding"!==n?u+=S.css(e,"border"+ne[a]+"Width",!0,i):s+=S.css(e,"border"+ne[a]+"Width",!0,i));return!r&&0<=o&&(u+=Math.max(0,Math.ceil(e["offset"+t[0].toUpperCase()+t.slice(1)]-o-u-s-.5))||0),u}function Ze(e,t,n){var r=Me(e),i=(!v.boxSizingReliable()||n)&&"border-box"===S.css(e,"boxSizing",!1,r),o=i,a=Be(e,t,r),s="offset"+t[0].toUpperCase()+t.slice(1);if(Pe.test(a)){if(!n)return a;a="auto"}return(!v.boxSizingReliable()&&i||!v.reliableTrDimensions()&&A(e,"tr")||"auto"===a||!parseFloat(a)&&"inline"===S.css(e,"display",!1,r))&&e.getClientRects().length&&(i="border-box"===S.css(e,"boxSizing",!1,r),(o=s in e)&&(a=e[s])),(a=parseFloat(a)||0)+Ke(e,t,n||(i?"border":"content"),o,r,a)+"px"}function et(e,t,n,r,i){return new et.prototype.init(e,t,n,r,i)}S.extend({cssHooks:{opacity:{get:function(e,t){if(t){var n=Be(e,"opacity");return""===n?"1":n}}}},cssNumber:{animationIterationCount:!0,columnCount:!0,fillOpacity:!0,flexGrow:!0,flexShrink:!0,fontWeight:!0,gridArea:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnStart:!0,gridRow:!0,gridRowEnd:!0,gridRowStart:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,widows:!0,zIndex:!0,zoom:!0},cssProps:{},style:function(e,t,n,r){if(e&&3!==e.nodeType&&8!==e.nodeType&&e.style){var i,o,a,s=X(t),u=Re.test(t),l=e.style;if(u||(t=Ve(s)),a=S.cssHooks[t]||S.cssHooks[s],void 0===n)return a&&"get"in a&&void 0!==(i=a.get(e,!1,r))?i:l[t];"string"===(o=typeof n)&&(i=te.exec(n))&&i[1]&&(n=se(e,t,i),o="number"),null!=n&&n==n&&("number"!==o||u||(n+=i&&i[3]||(S.cssNumber[s]?"":"px")),v.clearCloneStyle||""!==n||0!==t.indexOf("background")||(l[t]="inherit"),a&&"set"in a&&void 0===(n=a.set(e,n,r))||(u?l.setProperty(t,n):l[t]=n))}},css:function(e,t,n,r){var i,o,a,s=X(t);return Re.test(t)||(t=Ve(s)),(a=S.cssHooks[t]||S.cssHooks[s])&&"get"in a&&(i=a.get(e,!0,n)),void 0===i&&(i=Be(e,t,r)),"normal"===i&&t in Qe&&(i=Qe[t]),""===n||n?(o=parseFloat(i),!0===n||isFinite(o)?o||0:i):i}}),S.each(["height","width"],function(e,u){S.cssHooks[u]={get:function(e,t,n){if(t)return!Ge.test(S.css(e,"display"))||e.getClientRects().length&&e.getBoundingClientRect().width?Ze(e,u,n):Ie(e,Ye,function(){return Ze(e,u,n)})},set:function(e,t,n){var r,i=Me(e),o=!v.scrollboxSize()&&"absolute"===i.position,a=(o||n)&&"border-box"===S.css(e,"boxSizing",!1,i),s=n?Ke(e,u,n,a,i):0;return a&&o&&(s-=Math.ceil(e["offset"+u[0].toUpperCase()+u.slice(1)]-parseFloat(i[u])-Ke(e,u,"border",!1,i)-.5)),s&&(r=te.exec(t))&&"px"!==(r[3]||"px")&&(e.style[u]=t,t=S.css(e,u)),Je(0,t,s)}}}),S.cssHooks.marginLeft=_e(v.reliableMarginLeft,function(e,t){if(t)return(parseFloat(Be(e,"marginLeft"))||e.getBoundingClientRect().left-Ie(e,{marginLeft:0},function(){return e.getBoundingClientRect().left}))+"px"}),S.each({margin:"",padding:"",border:"Width"},function(i,o){S.cssHooks[i+o]={expand:function(e){for(var t=0,n={},r="string"==typeof e?e.split(" "):[e];t<4;t++)n[i+ne[t]+o]=r[t]||r[t-2]||r[0];return n}},"margin"!==i&&(S.cssHooks[i+o].set=Je)}),S.fn.extend({css:function(e,t){return B(this,function(e,t,n){var r,i,o={},a=0;if(Array.isArray(t)){for(r=Me(e),i=t.length;a<i;a++)o[t[a]]=S.css(e,t[a],!1,r);return o}return void 0!==n?S.style(e,t,n):S.css(e,t)},e,t,1<arguments.length)}}),((S.Tween=et).prototype={constructor:et,init:function(e,t,n,r,i,o){this.elem=e,this.prop=n,this.easing=i||S.easing._default,this.options=t,this.start=this.now=this.cur(),this.end=r,this.unit=o||(S.cssNumber[n]?"":"px")},cur:function(){var e=et.propHooks[this.prop];return e&&e.get?e.get(this):et.propHooks._default.get(this)},run:function(e){var t,n=et.propHooks[this.prop];return this.options.duration?this.pos=t=S.easing[this.easing](e,this.options.duration*e,0,1,this.options.duration):this.pos=t=e,this.now=(this.end-this.start)*t+this.start,this.options.step&&this.options.step.call(this.elem,this.now,this),n&&n.set?n.set(this):et.propHooks._default.set(this),this}}).init.prototype=et.prototype,(et.propHooks={_default:{get:function(e){var t;return 1!==e.elem.nodeType||null!=e.elem[e.prop]&&null==e.elem.style[e.prop]?e.elem[e.prop]:(t=S.css(e.elem,e.prop,""))&&"auto"!==t?t:0},set:function(e){S.fx.step[e.prop]?S.fx.step[e.prop](e):1!==e.elem.nodeType||!S.cssHooks[e.prop]&&null==e.elem.style[Ve(e.prop)]?e.elem[e.prop]=e.now:S.style(e.elem,e.prop,e.now+e.unit)}}}).scrollTop=et.propHooks.scrollLeft={set:function(e){e.elem.nodeType&&e.elem.parentNode&&(e.elem[e.prop]=e.now)}},S.easing={linear:function(e){return e},swing:function(e){return.5-Math.cos(e*Math.PI)/2},_default:"swing"},S.fx=et.prototype.init,S.fx.step={};var tt,nt,rt,it,ot=/^(?:toggle|show|hide)$/,at=/queueHooks$/;function st(){nt&&(!1===E.hidden&&C.requestAnimationFrame?C.requestAnimationFrame(st):C.setTimeout(st,S.fx.interval),S.fx.tick())}function ut(){return C.setTimeout(function(){tt=void 0}),tt=Date.now()}function lt(e,t){var n,r=0,i={height:e};for(t=t?1:0;r<4;r+=2-t)i["margin"+(n=ne[r])]=i["padding"+n]=e;return t&&(i.opacity=i.width=e),i}function ct(e,t,n){for(var r,i=(ft.tweeners[t]||[]).concat(ft.tweeners["*"]),o=0,a=i.length;o<a;o++)if(r=i[o].call(n,t,e))return r}function ft(o,e,t){var n,a,r=0,i=ft.prefilters.length,s=S.Deferred().always(function(){delete u.elem}),u=function(){if(a)return!1;for(var e=tt||ut(),t=Math.max(0,l.startTime+l.duration-e),n=1-(t/l.duration||0),r=0,i=l.tweens.length;r<i;r++)l.tweens[r].run(n);return s.notifyWith(o,[l,n,t]),n<1&&i?t:(i||s.notifyWith(o,[l,1,0]),s.resolveWith(o,[l]),!1)},l=s.promise({elem:o,props:S.extend({},e),opts:S.extend(!0,{specialEasing:{},easing:S.easing._default},t),originalProperties:e,originalOptions:t,startTime:tt||ut(),duration:t.duration,tweens:[],createTween:function(e,t){var n=S.Tween(o,l.opts,e,t,l.opts.specialEasing[e]||l.opts.easing);return l.tweens.push(n),n},stop:function(e){var t=0,n=e?l.tweens.length:0;if(a)return this;for(a=!0;t<n;t++)l.tweens[t].run(1);return e?(s.notifyWith(o,[l,1,0]),s.resolveWith(o,[l,e])):s.rejectWith(o,[l,e]),this}}),c=l.props;for(!function(e,t){var n,r,i,o,a;for(n in e)if(i=t[r=X(n)],o=e[n],Array.isArray(o)&&(i=o[1],o=e[n]=o[0]),n!==r&&(e[r]=o,delete e[n]),(a=S.cssHooks[r])&&"expand"in a)for(n in o=a.expand(o),delete e[r],o)n in e||(e[n]=o[n],t[n]=i);else t[r]=i}(c,l.opts.specialEasing);r<i;r++)if(n=ft.prefilters[r].call(l,o,c,l.opts))return m(n.stop)&&(S._queueHooks(l.elem,l.opts.queue).stop=n.stop.bind(n)),n;return S.map(c,ct,l),m(l.opts.start)&&l.opts.start.call(o,l),l.progress(l.opts.progress).done(l.opts.done,l.opts.complete).fail(l.opts.fail).always(l.opts.always),S.fx.timer(S.extend(u,{elem:o,anim:l,queue:l.opts.queue})),l}S.Animation=S.extend(ft,{tweeners:{"*":[function(e,t){var n=this.createTween(e,t);return se(n.elem,e,te.exec(t),n),n}]},tweener:function(e,t){m(e)?(t=e,e=["*"]):e=e.match(P);for(var n,r=0,i=e.length;r<i;r++)n=e[r],ft.tweeners[n]=ft.tweeners[n]||[],ft.tweeners[n].unshift(t)},prefilters:[function(e,t,n){var r,i,o,a,s,u,l,c,f="width"in t||"height"in t,p=this,d={},h=e.style,g=e.nodeType&&ae(e),y=Y.get(e,"fxshow");for(r in n.queue||(null==(a=S._queueHooks(e,"fx")).unqueued&&(a.unqueued=0,s=a.empty.fire,a.empty.fire=function(){a.unqueued||s()}),a.unqueued++,p.always(function(){p.always(function(){a.unqueued--,S.queue(e,"fx").length||a.empty.fire()})})),t)if(i=t[r],ot.test(i)){if(delete t[r],o=o||"toggle"===i,i===(g?"hide":"show")){if("show"!==i||!y||void 0===y[r])continue;g=!0}d[r]=y&&y[r]||S.style(e,r)}if((u=!S.isEmptyObject(t))||!S.isEmptyObject(d))for(r in f&&1===e.nodeType&&(n.overflow=[h.overflow,h.overflowX,h.overflowY],null==(l=y&&y.display)&&(l=Y.get(e,"display")),"none"===(c=S.css(e,"display"))&&(l?c=l:(le([e],!0),l=e.style.display||l,c=S.css(e,"display"),le([e]))),("inline"===c||"inline-block"===c&&null!=l)&&"none"===S.css(e,"float")&&(u||(p.done(function(){h.display=l}),null==l&&(c=h.display,l="none"===c?"":c)),h.display="inline-block")),n.overflow&&(h.overflow="hidden",p.always(function(){h.overflow=n.overflow[0],h.overflowX=n.overflow[1],h.overflowY=n.overflow[2]})),u=!1,d)u||(y?"hidden"in y&&(g=y.hidden):y=Y.access(e,"fxshow",{display:l}),o&&(y.hidden=!g),g&&le([e],!0),p.done(function(){for(r in g||le([e]),Y.remove(e,"fxshow"),d)S.style(e,r,d[r])})),u=ct(g?y[r]:0,r,p),r in y||(y[r]=u.start,g&&(u.end=u.start,u.start=0))}],prefilter:function(e,t){t?ft.prefilters.unshift(e):ft.prefilters.push(e)}}),S.speed=function(e,t,n){var r=e&&"object"==typeof e?S.extend({},e):{complete:n||!n&&t||m(e)&&e,duration:e,easing:n&&t||t&&!m(t)&&t};return S.fx.off?r.duration=0:"number"!=typeof r.duration&&(r.duration in S.fx.speeds?r.duration=S.fx.speeds[r.duration]:r.duration=S.fx.speeds._default),null!=r.queue&&!0!==r.queue||(r.queue="fx"),r.old=r.complete,r.complete=function(){m(r.old)&&r.old.call(this),r.queue&&S.dequeue(this,r.queue)},r},S.fn.extend({fadeTo:function(e,t,n,r){return this.filter(ae).css("opacity",0).show().end().animate({opacity:t},e,n,r)},animate:function(t,e,n,r){var i=S.isEmptyObject(t),o=S.speed(e,n,r),a=function(){var e=ft(this,S.extend({},t),o);(i||Y.get(this,"finish"))&&e.stop(!0)};return a.finish=a,i||!1===o.queue?this.each(a):this.queue(o.queue,a)},stop:function(i,e,o){var a=function(e){var t=e.stop;delete e.stop,t(o)};return"string"!=typeof i&&(o=e,e=i,i=void 0),e&&this.queue(i||"fx",[]),this.each(function(){var e=!0,t=null!=i&&i+"queueHooks",n=S.timers,r=Y.get(this);if(t)r[t]&&r[t].stop&&a(r[t]);else for(t in r)r[t]&&r[t].stop&&at.test(t)&&a(r[t]);for(t=n.length;t--;)n[t].elem!==this||null!=i&&n[t].queue!==i||(n[t].anim.stop(o),e=!1,n.splice(t,1));!e&&o||S.dequeue(this,i)})},finish:function(a){return!1!==a&&(a=a||"fx"),this.each(function(){var e,t=Y.get(this),n=t[a+"queue"],r=t[a+"queueHooks"],i=S.timers,o=n?n.length:0;for(t.finish=!0,S.queue(this,a,[]),r&&r.stop&&r.stop.call(this,!0),e=i.length;e--;)i[e].elem===this&&i[e].queue===a&&(i[e].anim.stop(!0),i.splice(e,1));for(e=0;e<o;e++)n[e]&&n[e].finish&&n[e].finish.call(this);delete t.finish})}}),S.each(["toggle","show","hide"],function(e,r){var i=S.fn[r];S.fn[r]=function(e,t,n){return null==e||"boolean"==typeof e?i.apply(this,arguments):this.animate(lt(r,!0),e,t,n)}}),S.each({slideDown:lt("show"),slideUp:lt("hide"),slideToggle:lt("toggle"),fadeIn:{opacity:"show"},fadeOut:{opacity:"hide"},fadeToggle:{opacity:"toggle"}},function(e,r){S.fn[e]=function(e,t,n){return this.animate(r,e,t,n)}}),S.timers=[],S.fx.tick=function(){var e,t=0,n=S.timers;for(tt=Date.now();t<n.length;t++)(e=n[t])()||n[t]!==e||n.splice(t--,1);n.length||S.fx.stop(),tt=void 0},S.fx.timer=function(e){S.timers.push(e),S.fx.start()},S.fx.interval=13,S.fx.start=function(){nt||(nt=!0,st())},S.fx.stop=function(){nt=null},S.fx.speeds={slow:600,fast:200,_default:400},S.fn.delay=function(r,e){return r=S.fx&&S.fx.speeds[r]||r,e=e||"fx",this.queue(e,function(e,t){var n=C.setTimeout(e,r);t.stop=function(){C.clearTimeout(n)}})},rt=E.createElement("input"),it=E.createElement("select").appendChild(E.createElement("option")),rt.type="checkbox",v.checkOn=""!==rt.value,v.optSelected=it.selected,(rt=E.createElement("input")).value="t",rt.type="radio",v.radioValue="t"===rt.value;var pt,dt=S.expr.attrHandle;S.fn.extend({attr:function(e,t){return B(this,S.attr,e,t,1<arguments.length)},removeAttr:function(e){return this.each(function(){S.removeAttr(this,e)})}}),S.extend({attr:function(e,t,n){var r,i,o=e.nodeType;if(3!==o&&8!==o&&2!==o)return"undefined"==typeof e.getAttribute?S.prop(e,t,n):(1===o&&S.isXMLDoc(e)||(i=S.attrHooks[t.toLowerCase()]||(S.expr.match.bool.test(t)?pt:void 0)),void 0!==n?null===n?void S.removeAttr(e,t):i&&"set"in i&&void 0!==(r=i.set(e,n,t))?r:(e.setAttribute(t,n+""),n):i&&"get"in i&&null!==(r=i.get(e,t))?r:null==(r=S.find.attr(e,t))?void 0:r)},attrHooks:{type:{set:function(e,t){if(!v.radioValue&&"radio"===t&&A(e,"input")){var n=e.value;return e.setAttribute("type",t),n&&(e.value=n),t}}}},removeAttr:function(e,t){var n,r=0,i=t&&t.match(P);if(i&&1===e.nodeType)while(n=i[r++])e.removeAttribute(n)}}),pt={set:function(e,t,n){return!1===t?S.removeAttr(e,n):e.setAttribute(n,n),n}},S.each(S.expr.match.bool.source.match(/\w+/g),function(e,t){var a=dt[t]||S.find.attr;dt[t]=function(e,t,n){var r,i,o=t.toLowerCase();return n||(i=dt[o],dt[o]=r,r=null!=a(e,t,n)?o:null,dt[o]=i),r}});var ht=/^(?:input|select|textarea|button)$/i,gt=/^(?:a|area)$/i;function yt(e){return(e.match(P)||[]).join(" ")}function vt(e){return e.getAttribute&&e.getAttribute("class")||""}function mt(e){return Array.isArray(e)?e:"string"==typeof e&&e.match(P)||[]}S.fn.extend({prop:function(e,t){return B(this,S.prop,e,t,1<arguments.length)},removeProp:function(e){return this.each(function(){delete this[S.propFix[e]||e]})}}),S.extend({prop:function(e,t,n){var r,i,o=e.nodeType;if(3!==o&&8!==o&&2!==o)return 1===o&&S.isXMLDoc(e)||(t=S.propFix[t]||t,i=S.propHooks[t]),void 0!==n?i&&"set"in i&&void 0!==(r=i.set(e,n,t))?r:e[t]=n:i&&"get"in i&&null!==(r=i.get(e,t))?r:e[t]},propHooks:{tabIndex:{get:function(e){var t=S.find.attr(e,"tabindex");return t?parseInt(t,10):ht.test(e.nodeName)||gt.test(e.nodeName)&&e.href?0:-1}}},propFix:{"for":"htmlFor","class":"className"}}),v.optSelected||(S.propHooks.selected={get:function(e){var t=e.parentNode;return t&&t.parentNode&&t.parentNode.selectedIndex,null},set:function(e){var t=e.parentNode;t&&(t.selectedIndex,t.parentNode&&t.parentNode.selectedIndex)}}),S.each(["tabIndex","readOnly","maxLength","cellSpacing","cellPadding","rowSpan","colSpan","useMap","frameBorder","contentEditable"],function(){S.propFix[this.toLowerCase()]=this}),S.fn.extend({addClass:function(t){var e,n,r,i,o,a;return m(t)?this.each(function(e){S(this).addClass(t.call(this,e,vt(this)))}):(e=mt(t)).length?this.each(function(){if(r=vt(this),n=1===this.nodeType&&" "+yt(r)+" "){for(o=0;o<e.length;o++)i=e[o],n.indexOf(" "+i+" ")<0&&(n+=i+" ");a=yt(n),r!==a&&this.setAttribute("class",a)}}):this},removeClass:function(t){var e,n,r,i,o,a;return m(t)?this.each(function(e){S(this).removeClass(t.call(this,e,vt(this)))}):arguments.length?(e=mt(t)).length?this.each(function(){if(r=vt(this),n=1===this.nodeType&&" "+yt(r)+" "){for(o=0;o<e.length;o++){i=e[o];while(-1<n.indexOf(" "+i+" "))n=n.replace(" "+i+" "," ")}a=yt(n),r!==a&&this.setAttribute("class",a)}}):this:this.attr("class","")},toggleClass:function(t,n){var e,r,i,o,a=typeof t,s="string"===a||Array.isArray(t);return m(t)?this.each(function(e){S(this).toggleClass(t.call(this,e,vt(this),n),n)}):"boolean"==typeof n&&s?n?this.addClass(t):this.removeClass(t):(e=mt(t),this.each(function(){if(s)for(o=S(this),i=0;i<e.length;i++)r=e[i],o.hasClass(r)?o.removeClass(r):o.addClass(r);else void 0!==t&&"boolean"!==a||((r=vt(this))&&Y.set(this,"__className__",r),this.setAttribute&&this.setAttribute("class",r||!1===t?"":Y.get(this,"__className__")||""))}))},hasClass:function(e){var t,n,r=0;t=" "+e+" ";while(n=this[r++])if(1===n.nodeType&&-1<(" "+yt(vt(n))+" ").indexOf(t))return!0;return!1}});var xt=/\r/g;S.fn.extend({val:function(n){var r,e,i,t=this[0];return arguments.length?(i=m(n),this.each(function(e){var t;1===this.nodeType&&(null==(t=i?n.call(this,e,S(this).val()):n)?t="":"number"==typeof t?t+="":Array.isArray(t)&&(t=S.map(t,function(e){return null==e?"":e+""})),(r=S.valHooks[this.type]||S.valHooks[this.nodeName.toLowerCase()])&&"set"in r&&void 0!==r.set(this,t,"value")||(this.value=t))})):t?(r=S.valHooks[t.type]||S.valHooks[t.nodeName.toLowerCase()])&&"get"in r&&void 0!==(e=r.get(t,"value"))?e:"string"==typeof(e=t.value)?e.replace(xt,""):null==e?"":e:void 0}}),S.extend({valHooks:{option:{get:function(e){var t=S.find.attr(e,"value");return null!=t?t:yt(S.text(e))}},select:{get:function(e){var t,n,r,i=e.options,o=e.selectedIndex,a="select-one"===e.type,s=a?null:[],u=a?o+1:i.length;for(r=o<0?u:a?o:0;r<u;r++)if(((n=i[r]).selected||r===o)&&!n.disabled&&(!n.parentNode.disabled||!A(n.parentNode,"optgroup"))){if(t=S(n).val(),a)return t;s.push(t)}return s},set:function(e,t){var n,r,i=e.options,o=S.makeArray(t),a=i.length;while(a--)((r=i[a]).selected=-1<S.inArray(S.valHooks.option.get(r),o))&&(n=!0);return n||(e.selectedIndex=-1),o}}}}),S.each(["radio","checkbox"],function(){S.valHooks[this]={set:function(e,t){if(Array.isArray(t))return e.checked=-1<S.inArray(S(e).val(),t)}},v.checkOn||(S.valHooks[this].get=function(e){return null===e.getAttribute("value")?"on":e.value})}),v.focusin="onfocusin"in C;var bt=/^(?:focusinfocus|focusoutblur)$/,wt=function(e){e.stopPropagation()};S.extend(S.event,{trigger:function(e,t,n,r){var i,o,a,s,u,l,c,f,p=[n||E],d=y.call(e,"type")?e.type:e,h=y.call(e,"namespace")?e.namespace.split("."):[];if(o=f=a=n=n||E,3!==n.nodeType&&8!==n.nodeType&&!bt.test(d+S.event.triggered)&&(-1<d.indexOf(".")&&(d=(h=d.split(".")).shift(),h.sort()),u=d.indexOf(":")<0&&"on"+d,(e=e[S.expando]?e:new S.Event(d,"object"==typeof e&&e)).isTrigger=r?2:3,e.namespace=h.join("."),e.rnamespace=e.namespace?new RegExp("(^|\\.)"+h.join("\\.(?:.*\\.|)")+"(\\.|$)"):null,e.result=void 0,e.target||(e.target=n),t=null==t?[e]:S.makeArray(t,[e]),c=S.event.special[d]||{},r||!c.trigger||!1!==c.trigger.apply(n,t))){if(!r&&!c.noBubble&&!x(n)){for(s=c.delegateType||d,bt.test(s+d)||(o=o.parentNode);o;o=o.parentNode)p.push(o),a=o;a===(n.ownerDocument||E)&&p.push(a.defaultView||a.parentWindow||C)}i=0;while((o=p[i++])&&!e.isPropagationStopped())f=o,e.type=1<i?s:c.bindType||d,(l=(Y.get(o,"events")||Object.create(null))[e.type]&&Y.get(o,"handle"))&&l.apply(o,t),(l=u&&o[u])&&l.apply&&V(o)&&(e.result=l.apply(o,t),!1===e.result&&e.preventDefault());return e.type=d,r||e.isDefaultPrevented()||c._default&&!1!==c._default.apply(p.pop(),t)||!V(n)||u&&m(n[d])&&!x(n)&&((a=n[u])&&(n[u]=null),S.event.triggered=d,e.isPropagationStopped()&&f.addEventListener(d,wt),n[d](),e.isPropagationStopped()&&f.removeEventListener(d,wt),S.event.triggered=void 0,a&&(n[u]=a)),e.result}},simulate:function(e,t,n){var r=S.extend(new S.Event,n,{type:e,isSimulated:!0});S.event.trigger(r,null,t)}}),S.fn.extend({trigger:function(e,t){return this.each(function(){S.event.trigger(e,t,this)})},triggerHandler:function(e,t){var n=this[0];if(n)return S.event.trigger(e,t,n,!0)}}),v.focusin||S.each({focus:"focusin",blur:"focusout"},function(n,r){var i=function(e){S.event.simulate(r,e.target,S.event.fix(e))};S.event.special[r]={setup:function(){var e=this.ownerDocument||this.document||this,t=Y.access(e,r);t||e.addEventListener(n,i,!0),Y.access(e,r,(t||0)+1)},teardown:function(){var e=this.ownerDocument||this.document||this,t=Y.access(e,r)-1;t?Y.access(e,r,t):(e.removeEventListener(n,i,!0),Y.remove(e,r))}}});var Tt=C.location,Ct={guid:Date.now()},Et=/\?/;S.parseXML=function(e){var t,n;if(!e||"string"!=typeof e)return null;try{t=(new C.DOMParser).parseFromString(e,"text/xml")}catch(e){}return n=t&&t.getElementsByTagName("parsererror")[0],t&&!n||S.error("Invalid XML: "+(n?S.map(n.childNodes,function(e){return e.textContent}).join("\n"):e)),t};var St=/\[\]$/,kt=/\r?\n/g,At=/^(?:submit|button|image|reset|file)$/i,Nt=/^(?:input|select|textarea|keygen)/i;function jt(n,e,r,i){var t;if(Array.isArray(e))S.each(e,function(e,t){r||St.test(n)?i(n,t):jt(n+"["+("object"==typeof t&&null!=t?e:"")+"]",t,r,i)});else if(r||"object"!==w(e))i(n,e);else for(t in e)jt(n+"["+t+"]",e[t],r,i)}S.param=function(e,t){var n,r=[],i=function(e,t){var n=m(t)?t():t;r[r.length]=encodeURIComponent(e)+"="+encodeURIComponent(null==n?"":n)};if(null==e)return"";if(Array.isArray(e)||e.jquery&&!S.isPlainObject(e))S.each(e,function(){i(this.name,this.value)});else for(n in e)jt(n,e[n],t,i);return r.join("&")},S.fn.extend({serialize:function(){return S.param(this.serializeArray())},serializeArray:function(){return this.map(function(){var e=S.prop(this,"elements");return e?S.makeArray(e):this}).filter(function(){var e=this.type;return this.name&&!S(this).is(":disabled")&&Nt.test(this.nodeName)&&!At.test(e)&&(this.checked||!pe.test(e))}).map(function(e,t){var n=S(this).val();return null==n?null:Array.isArray(n)?S.map(n,function(e){return{name:t.name,value:e.replace(kt,"\r\n")}}):{name:t.name,value:n.replace(kt,"\r\n")}}).get()}});var Dt=/%20/g,qt=/#.*$/,Lt=/([?&])_=[^&]*/,Ht=/^(.*?):[ \t]*([^\r\n]*)$/gm,Ot=/^(?:GET|HEAD)$/,Pt=/^\/\//,Rt={},Mt={},It="*/".concat("*"),Wt=E.createElement("a");function Ft(o){return function(e,t){"string"!=typeof e&&(t=e,e="*");var n,r=0,i=e.toLowerCase().match(P)||[];if(m(t))while(n=i[r++])"+"===n[0]?(n=n.slice(1)||"*",(o[n]=o[n]||[]).unshift(t)):(o[n]=o[n]||[]).push(t)}}function $t(t,i,o,a){var s={},u=t===Mt;function l(e){var r;return s[e]=!0,S.each(t[e]||[],function(e,t){var n=t(i,o,a);return"string"!=typeof n||u||s[n]?u?!(r=n):void 0:(i.dataTypes.unshift(n),l(n),!1)}),r}return l(i.dataTypes[0])||!s["*"]&&l("*")}function Bt(e,t){var n,r,i=S.ajaxSettings.flatOptions||{};for(n in t)void 0!==t[n]&&((i[n]?e:r||(r={}))[n]=t[n]);return r&&S.extend(!0,e,r),e}Wt.href=Tt.href,S.extend({active:0,lastModified:{},etag:{},ajaxSettings:{url:Tt.href,type:"GET",isLocal:/^(?:about|app|app-storage|.+-extension|file|res|widget):$/.test(Tt.protocol),global:!0,processData:!0,async:!0,contentType:"application/x-www-form-urlencoded; charset=UTF-8",accepts:{"*":It,text:"text/plain",html:"text/html",xml:"application/xml, text/xml",json:"application/json, text/javascript"},contents:{xml:/\bxml\b/,html:/\bhtml/,json:/\bjson\b/},responseFields:{xml:"responseXML",text:"responseText",json:"responseJSON"},converters:{"* text":String,"text html":!0,"text json":JSON.parse,"text xml":S.parseXML},flatOptions:{url:!0,context:!0}},ajaxSetup:function(e,t){return t?Bt(Bt(e,S.ajaxSettings),t):Bt(S.ajaxSettings,e)},ajaxPrefilter:Ft(Rt),ajaxTransport:Ft(Mt),ajax:function(e,t){"object"==typeof e&&(t=e,e=void 0),t=t||{};var c,f,p,n,d,r,h,g,i,o,y=S.ajaxSetup({},t),v=y.context||y,m=y.context&&(v.nodeType||v.jquery)?S(v):S.event,x=S.Deferred(),b=S.Callbacks("once memory"),w=y.statusCode||{},a={},s={},u="canceled",T={readyState:0,getResponseHeader:function(e){var t;if(h){if(!n){n={};while(t=Ht.exec(p))n[t[1].toLowerCase()+" "]=(n[t[1].toLowerCase()+" "]||[]).concat(t[2])}t=n[e.toLowerCase()+" "]}return null==t?null:t.join(", ")},getAllResponseHeaders:function(){return h?p:null},setRequestHeader:function(e,t){return null==h&&(e=s[e.toLowerCase()]=s[e.toLowerCase()]||e,a[e]=t),this},overrideMimeType:function(e){return null==h&&(y.mimeType=e),this},statusCode:function(e){var t;if(e)if(h)T.always(e[T.status]);else for(t in e)w[t]=[w[t],e[t]];return this},abort:function(e){var t=e||u;return c&&c.abort(t),l(0,t),this}};if(x.promise(T),y.url=((e||y.url||Tt.href)+"").replace(Pt,Tt.protocol+"//"),y.type=t.method||t.type||y.method||y.type,y.dataTypes=(y.dataType||"*").toLowerCase().match(P)||[""],null==y.crossDomain){r=E.createElement("a");try{r.href=y.url,r.href=r.href,y.crossDomain=Wt.protocol+"//"+Wt.host!=r.protocol+"//"+r.host}catch(e){y.crossDomain=!0}}if(y.data&&y.processData&&"string"!=typeof y.data&&(y.data=S.param(y.data,y.traditional)),$t(Rt,y,t,T),h)return T;for(i in(g=S.event&&y.global)&&0==S.active++&&S.event.trigger("ajaxStart"),y.type=y.type.toUpperCase(),y.hasContent=!Ot.test(y.type),f=y.url.replace(qt,""),y.hasContent?y.data&&y.processData&&0===(y.contentType||"").indexOf("application/x-www-form-urlencoded")&&(y.data=y.data.replace(Dt,"+")):(o=y.url.slice(f.length),y.data&&(y.processData||"string"==typeof y.data)&&(f+=(Et.test(f)?"&":"?")+y.data,delete y.data),!1===y.cache&&(f=f.replace(Lt,"$1"),o=(Et.test(f)?"&":"?")+"_="+Ct.guid+++o),y.url=f+o),y.ifModified&&(S.lastModified[f]&&T.setRequestHeader("If-Modified-Since",S.lastModified[f]),S.etag[f]&&T.setRequestHeader("If-None-Match",S.etag[f])),(y.data&&y.hasContent&&!1!==y.contentType||t.contentType)&&T.setRequestHeader("Content-Type",y.contentType),T.setRequestHeader("Accept",y.dataTypes[0]&&y.accepts[y.dataTypes[0]]?y.accepts[y.dataTypes[0]]+("*"!==y.dataTypes[0]?", "+It+"; q=0.01":""):y.accepts["*"]),y.headers)T.setRequestHeader(i,y.headers[i]);if(y.beforeSend&&(!1===y.beforeSend.call(v,T,y)||h))return T.abort();if(u="abort",b.add(y.complete),T.done(y.success),T.fail(y.error),c=$t(Mt,y,t,T)){if(T.readyState=1,g&&m.trigger("ajaxSend",[T,y]),h)return T;y.async&&0<y.timeout&&(d=C.setTimeout(function(){T.abort("timeout")},y.timeout));try{h=!1,c.send(a,l)}catch(e){if(h)throw e;l(-1,e)}}else l(-1,"No Transport");function l(e,t,n,r){var i,o,a,s,u,l=t;h||(h=!0,d&&C.clearTimeout(d),c=void 0,p=r||"",T.readyState=0<e?4:0,i=200<=e&&e<300||304===e,n&&(s=function(e,t,n){var r,i,o,a,s=e.contents,u=e.dataTypes;while("*"===u[0])u.shift(),void 0===r&&(r=e.mimeType||t.getResponseHeader("Content-Type"));if(r)for(i in s)if(s[i]&&s[i].test(r)){u.unshift(i);break}if(u[0]in n)o=u[0];else{for(i in n){if(!u[0]||e.converters[i+" "+u[0]]){o=i;break}a||(a=i)}o=o||a}if(o)return o!==u[0]&&u.unshift(o),n[o]}(y,T,n)),!i&&-1<S.inArray("script",y.dataTypes)&&S.inArray("json",y.dataTypes)<0&&(y.converters["text script"]=function(){}),s=function(e,t,n,r){var i,o,a,s,u,l={},c=e.dataTypes.slice();if(c[1])for(a in e.converters)l[a.toLowerCase()]=e.converters[a];o=c.shift();while(o)if(e.responseFields[o]&&(n[e.responseFields[o]]=t),!u&&r&&e.dataFilter&&(t=e.dataFilter(t,e.dataType)),u=o,o=c.shift())if("*"===o)o=u;else if("*"!==u&&u!==o){if(!(a=l[u+" "+o]||l["* "+o]))for(i in l)if((s=i.split(" "))[1]===o&&(a=l[u+" "+s[0]]||l["* "+s[0]])){!0===a?a=l[i]:!0!==l[i]&&(o=s[0],c.unshift(s[1]));break}if(!0!==a)if(a&&e["throws"])t=a(t);else try{t=a(t)}catch(e){return{state:"parsererror",error:a?e:"No conversion from "+u+" to "+o}}}return{state:"success",data:t}}(y,s,T,i),i?(y.ifModified&&((u=T.getResponseHeader("Last-Modified"))&&(S.lastModified[f]=u),(u=T.getResponseHeader("etag"))&&(S.etag[f]=u)),204===e||"HEAD"===y.type?l="nocontent":304===e?l="notmodified":(l=s.state,o=s.data,i=!(a=s.error))):(a=l,!e&&l||(l="error",e<0&&(e=0))),T.status=e,T.statusText=(t||l)+"",i?x.resolveWith(v,[o,l,T]):x.rejectWith(v,[T,l,a]),T.statusCode(w),w=void 0,g&&m.trigger(i?"ajaxSuccess":"ajaxError",[T,y,i?o:a]),b.fireWith(v,[T,l]),g&&(m.trigger("ajaxComplete",[T,y]),--S.active||S.event.trigger("ajaxStop")))}return T},getJSON:function(e,t,n){return S.get(e,t,n,"json")},getScript:function(e,t){return S.get(e,void 0,t,"script")}}),S.each(["get","post"],function(e,i){S[i]=function(e,t,n,r){return m(t)&&(r=r||n,n=t,t=void 0),S.ajax(S.extend({url:e,type:i,dataType:r,data:t,success:n},S.isPlainObject(e)&&e))}}),S.ajaxPrefilter(function(e){var t;for(t in e.headers)"content-type"===t.toLowerCase()&&(e.contentType=e.headers[t]||"")}),S._evalUrl=function(e,t,n){return S.ajax({url:e,type:"GET",dataType:"script",cache:!0,async:!1,global:!1,converters:{"text script":function(){}},dataFilter:function(e){S.globalEval(e,t,n)}})},S.fn.extend({wrapAll:function(e){var t;return this[0]&&(m(e)&&(e=e.call(this[0])),t=S(e,this[0].ownerDocument).eq(0).clone(!0),this[0].parentNode&&t.insertBefore(this[0]),t.map(function(){var e=this;while(e.firstElementChild)e=e.firstElementChild;return e}).append(this)),this},wrapInner:function(n){return m(n)?this.each(function(e){S(this).wrapInner(n.call(this,e))}):this.each(function(){var e=S(this),t=e.contents();t.length?t.wrapAll(n):e.append(n)})},wrap:function(t){var n=m(t);return this.each(function(e){S(this).wrapAll(n?t.call(this,e):t)})},unwrap:function(e){return this.parent(e).not("body").each(function(){S(this).replaceWith(this.childNodes)}),this}}),S.expr.pseudos.hidden=function(e){return!S.expr.pseudos.visible(e)},S.expr.pseudos.visible=function(e){return!!(e.offsetWidth||e.offsetHeight||e.getClientRects().length)},S.ajaxSettings.xhr=function(){try{return new C.XMLHttpRequest}catch(e){}};var _t={0:200,1223:204},zt=S.ajaxSettings.xhr();v.cors=!!zt&&"withCredentials"in zt,v.ajax=zt=!!zt,S.ajaxTransport(function(i){var o,a;if(v.cors||zt&&!i.crossDomain)return{send:function(e,t){var n,r=i.xhr();if(r.open(i.type,i.url,i.async,i.username,i.password),i.xhrFields)for(n in i.xhrFields)r[n]=i.xhrFields[n];for(n in i.mimeType&&r.overrideMimeType&&r.overrideMimeType(i.mimeType),i.crossDomain||e["X-Requested-With"]||(e["X-Requested-With"]="XMLHttpRequest"),e)r.setRequestHeader(n,e[n]);o=function(e){return function(){o&&(o=a=r.onload=r.onerror=r.onabort=r.ontimeout=r.onreadystatechange=null,"abort"===e?r.abort():"error"===e?"number"!=typeof r.status?t(0,"error"):t(r.status,r.statusText):t(_t[r.status]||r.status,r.statusText,"text"!==(r.responseType||"text")||"string"!=typeof r.responseText?{binary:r.response}:{text:r.responseText},r.getAllResponseHeaders()))}},r.onload=o(),a=r.onerror=r.ontimeout=o("error"),void 0!==r.onabort?r.onabort=a:r.onreadystatechange=function(){4===r.readyState&&C.setTimeout(function(){o&&a()})},o=o("abort");try{r.send(i.hasContent&&i.data||null)}catch(e){if(o)throw e}},abort:function(){o&&o()}}}),S.ajaxPrefilter(function(e){e.crossDomain&&(e.contents.script=!1)}),S.ajaxSetup({accepts:{script:"text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"},contents:{script:/\b(?:java|ecma)script\b/},converters:{"text script":function(e){return S.globalEval(e),e}}}),S.ajaxPrefilter("script",function(e){void 0===e.cache&&(e.cache=!1),e.crossDomain&&(e.type="GET")}),S.ajaxTransport("script",function(n){var r,i;if(n.crossDomain||n.scriptAttrs)return{send:function(e,t){r=S("<script>").attr(n.scriptAttrs||{}).prop({charset:n.scriptCharset,src:n.url}).on("load error",i=function(e){r.remove(),i=null,e&&t("error"===e.type?404:200,e.type)}),E.head.appendChild(r[0])},abort:function(){i&&i()}}});var Ut,Xt=[],Vt=/(=)\?(?=&|$)|\?\?/;S.ajaxSetup({jsonp:"callback",jsonpCallback:function(){var e=Xt.pop()||S.expando+"_"+Ct.guid++;return this[e]=!0,e}}),S.ajaxPrefilter("json jsonp",function(e,t,n){var r,i,o,a=!1!==e.jsonp&&(Vt.test(e.url)?"url":"string"==typeof e.data&&0===(e.contentType||"").indexOf("application/x-www-form-urlencoded")&&Vt.test(e.data)&&"data");if(a||"jsonp"===e.dataTypes[0])return r=e.jsonpCallback=m(e.jsonpCallback)?e.jsonpCallback():e.jsonpCallback,a?e[a]=e[a].replace(Vt,"$1"+r):!1!==e.jsonp&&(e.url+=(Et.test(e.url)?"&":"?")+e.jsonp+"="+r),e.converters["script json"]=function(){return o||S.error(r+" was not called"),o[0]},e.dataTypes[0]="json",i=C[r],C[r]=function(){o=arguments},n.always(function(){void 0===i?S(C).removeProp(r):C[r]=i,e[r]&&(e.jsonpCallback=t.jsonpCallback,Xt.push(r)),o&&m(i)&&i(o[0]),o=i=void 0}),"script"}),v.createHTMLDocument=((Ut=E.implementation.createHTMLDocument("").body).innerHTML="<form></form><form></form>",2===Ut.childNodes.length),S.parseHTML=function(e,t,n){return"string"!=typeof e?[]:("boolean"==typeof t&&(n=t,t=!1),t||(v.createHTMLDocument?((r=(t=E.implementation.createHTMLDocument("")).createElement("base")).href=E.location.href,t.head.appendChild(r)):t=E),o=!n&&[],(i=N.exec(e))?[t.createElement(i[1])]:(i=xe([e],t,o),o&&o.length&&S(o).remove(),S.merge([],i.childNodes)));var r,i,o},S.fn.load=function(e,t,n){var r,i,o,a=this,s=e.indexOf(" ");return-1<s&&(r=yt(e.slice(s)),e=e.slice(0,s)),m(t)?(n=t,t=void 0):t&&"object"==typeof t&&(i="POST"),0<a.length&&S.ajax({url:e,type:i||"GET",dataType:"html",data:t}).done(function(e){o=arguments,a.html(r?S("<div>").append(S.parseHTML(e)).find(r):e)}).always(n&&function(e,t){a.each(function(){n.apply(this,o||[e.responseText,t,e])})}),this},S.expr.pseudos.animated=function(t){return S.grep(S.timers,function(e){return t===e.elem}).length},S.offset={setOffset:function(e,t,n){var r,i,o,a,s,u,l=S.css(e,"position"),c=S(e),f={};"static"===l&&(e.style.position="relative"),s=c.offset(),o=S.css(e,"top"),u=S.css(e,"left"),("absolute"===l||"fixed"===l)&&-1<(o+u).indexOf("auto")?(a=(r=c.position()).top,i=r.left):(a=parseFloat(o)||0,i=parseFloat(u)||0),m(t)&&(t=t.call(e,n,S.extend({},s))),null!=t.top&&(f.top=t.top-s.top+a),null!=t.left&&(f.left=t.left-s.left+i),"using"in t?t.using.call(e,f):c.css(f)}},S.fn.extend({offset:function(t){if(arguments.length)return void 0===t?this:this.each(function(e){S.offset.setOffset(this,t,e)});var e,n,r=this[0];return r?r.getClientRects().length?(e=r.getBoundingClientRect(),n=r.ownerDocument.defaultView,{top:e.top+n.pageYOffset,left:e.left+n.pageXOffset}):{top:0,left:0}:void 0},position:function(){if(this[0]){var e,t,n,r=this[0],i={top:0,left:0};if("fixed"===S.css(r,"position"))t=r.getBoundingClientRect();else{t=this.offset(),n=r.ownerDocument,e=r.offsetParent||n.documentElement;while(e&&(e===n.body||e===n.documentElement)&&"static"===S.css(e,"position"))e=e.parentNode;e&&e!==r&&1===e.nodeType&&((i=S(e).offset()).top+=S.css(e,"borderTopWidth",!0),i.left+=S.css(e,"borderLeftWidth",!0))}return{top:t.top-i.top-S.css(r,"marginTop",!0),left:t.left-i.left-S.css(r,"marginLeft",!0)}}},offsetParent:function(){return this.map(function(){var e=this.offsetParent;while(e&&"static"===S.css(e,"position"))e=e.offsetParent;return e||re})}}),S.each({scrollLeft:"pageXOffset",scrollTop:"pageYOffset"},function(t,i){var o="pageYOffset"===i;S.fn[t]=function(e){return B(this,function(e,t,n){var r;if(x(e)?r=e:9===e.nodeType&&(r=e.defaultView),void 0===n)return r?r[i]:e[t];r?r.scrollTo(o?r.pageXOffset:n,o?n:r.pageYOffset):e[t]=n},t,e,arguments.length)}}),S.each(["top","left"],function(e,n){S.cssHooks[n]=_e(v.pixelPosition,function(e,t){if(t)return t=Be(e,n),Pe.test(t)?S(e).position()[n]+"px":t})}),S.each({Height:"height",Width:"width"},function(a,s){S.each({padding:"inner"+a,content:s,"":"outer"+a},function(r,o){S.fn[o]=function(e,t){var n=arguments.length&&(r||"boolean"!=typeof e),i=r||(!0===e||!0===t?"margin":"border");return B(this,function(e,t,n){var r;return x(e)?0===o.indexOf("outer")?e["inner"+a]:e.document.documentElement["client"+a]:9===e.nodeType?(r=e.documentElement,Math.max(e.body["scroll"+a],r["scroll"+a],e.body["offset"+a],r["offset"+a],r["client"+a])):void 0===n?S.css(e,t,i):S.style(e,t,n,i)},s,n?e:void 0,n)}})}),S.each(["ajaxStart","ajaxStop","ajaxComplete","ajaxError","ajaxSuccess","ajaxSend"],function(e,t){S.fn[t]=function(e){return this.on(t,e)}}),S.fn.extend({bind:function(e,t,n){return this.on(e,null,t,n)},unbind:function(e,t){return this.off(e,null,t)},delegate:function(e,t,n,r){return this.on(t,e,n,r)},undelegate:function(e,t,n){return 1===arguments.length?this.off(e,"**"):this.off(t,e||"**",n)},hover:function(e,t){return this.mouseenter(e).mouseleave(t||e)}}),S.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "),function(e,n){S.fn[n]=function(e,t){return 0<arguments.length?this.on(n,null,e,t):this.trigger(n)}});var Gt=/^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g;S.proxy=function(e,t){var n,r,i;if("string"==typeof t&&(n=e[t],t=e,e=n),m(e))return r=s.call(arguments,2),(i=function(){return e.apply(t||this,r.concat(s.call(arguments)))}).guid=e.guid=e.guid||S.guid++,i},S.holdReady=function(e){e?S.readyWait++:S.ready(!0)},S.isArray=Array.isArray,S.parseJSON=JSON.parse,S.nodeName=A,S.isFunction=m,S.isWindow=x,S.camelCase=X,S.type=w,S.now=Date.now,S.isNumeric=function(e){var t=S.type(e);return("number"===t||"string"===t)&&!isNaN(e-parseFloat(e))},S.trim=function(e){return null==e?"":(e+"").replace(Gt,"$1")},"function"==typeof define&&define.amd&&define("jquery",[],function(){return S});var Yt=C.jQuery,Qt=C.$;return S.noConflict=function(e){return C.$===S&&(C.$=Qt),e&&C.jQuery===S&&(C.jQuery=Yt),S},"undefined"==typeof e&&(C.jQuery=C.$=S),S});

"use strict";

/**
 * bxSlider v4.2.1d
 * Copyright 2013-2017 Steven Wanderski
 * Written while drinking Belgian ales and listening to jazz
 * Licensed under MIT (http://opensource.org/licenses/MIT)
 */

;
(function ($) {
  var defaults = {
    // GENERAL
    mode: 'horizontal',
    slideSelector: '',
    infiniteLoop: true,
    hideControlOnEnd: false,
    speed: 500,
    easing: null,
    slideMargin: 0,
    startSlide: 0,
    randomStart: false,
    captions: false,
    ticker: false,
    tickerHover: false,
    adaptiveHeight: false,
    adaptiveHeightSpeed: 500,
    video: false,
    useCSS: true,
    preloadImages: 'visible',
    responsive: true,
    slideZIndex: 50,
    wrapperClass: 'bx-wrapper',
    // TOUCH
    touchEnabled: true,
    swipeThreshold: 50,
    oneToOneTouch: true,
    preventDefaultSwipeX: true,
    preventDefaultSwipeY: false,
    // ACCESSIBILITY
    ariaLive: true,
    ariaHidden: true,
    // KEYBOARD
    keyboardEnabled: false,
    // PAGER
    pager: true,
    pagerType: 'full',
    pagerShortSeparator: ' / ',
    pagerSelector: null,
    buildPager: null,
    pagerCustom: null,
    // CONTROLS
    controls: true,
    nextText: 'Next',
    prevText: 'Prev',
    nextSelector: null,
    prevSelector: null,
    autoControls: false,
    startText: 'Start',
    stopText: 'Stop',
    autoControlsCombine: false,
    autoControlsSelector: null,
    // AUTO
    auto: false,
    pause: 4000,
    autoStart: true,
    autoDirection: 'next',
    stopAutoOnClick: false,
    autoHover: false,
    autoDelay: 0,
    autoSlideForOnePage: false,
    // CAROUSEL
    minSlides: 1,
    maxSlides: 1,
    moveSlides: 0,
    slideWidth: 0,
    shrinkItems: false,
    // CALLBACKS
    onSliderLoad: function onSliderLoad() {
      return true;
    },
    onSlideBefore: function onSlideBefore() {
      return true;
    },
    onSlideAfter: function onSlideAfter() {
      return true;
    },
    onSlideNext: function onSlideNext() {
      return true;
    },
    onSlidePrev: function onSlidePrev() {
      return true;
    },
    onSliderResize: function onSliderResize() {
      return true;
    },
    onAutoChange: function onAutoChange() {
      return true;
    } //calls when auto slides starts and stops
  };
  $.fn.bxSlider = function (options) {
    if (this.length === 0) {
      return this;
    }

    // support multiple elements
    if (this.length > 1) {
      this.each(function () {
        $(this).bxSlider(options);
      });
      return this;
    }

    // create a namespace to be used throughout the plugin
    var slider = {},
      // set a reference to our slider element
      el = this,
      // get the original window dimens (thanks a lot IE)
      windowWidth = $(window).width(),
      windowHeight = $(window).height();

    // Return if slider is already initialized
    if ($(el).data('bxSlider')) {
      return;
    }

    /**
     * ===================================================================================
     * = PRIVATE FUNCTIONS
     * ===================================================================================
     */

    /**
     * Initializes namespace settings to be used throughout plugin
     */
    var init = function init() {
      // Return if slider is already initialized
      if ($(el).data('bxSlider')) {
        return;
      }
      // merge user-supplied options with the defaults
      slider.settings = $.extend({}, defaults, options);
      // parse slideWidth setting
      slider.settings.slideWidth = parseInt(slider.settings.slideWidth);
      // store the original children
      slider.children = el.children(slider.settings.slideSelector);
      // check if actual number of slides is less than minSlides / maxSlides
      if (slider.children.length < slider.settings.minSlides) {
        slider.settings.minSlides = slider.children.length;
      }
      if (slider.children.length < slider.settings.maxSlides) {
        slider.settings.maxSlides = slider.children.length;
      }
      // if random start, set the startSlide setting to random number
      if (slider.settings.randomStart) {
        slider.settings.startSlide = Math.floor(Math.random() * slider.children.length);
      }
      // store active slide information
      slider.active = {
        index: slider.settings.startSlide
      };
      // store if the slider is in carousel mode (displaying / moving multiple slides)
      slider.carousel = slider.settings.minSlides > 1 || slider.settings.maxSlides > 1;
      // if carousel, force preloadImages = 'all'
      if (slider.carousel) {
        slider.settings.preloadImages = 'all';
      }
      // calculate the min / max width thresholds based on min / max number of slides
      // used to setup and update carousel slides dimensions
      slider.minThreshold = slider.settings.minSlides * slider.settings.slideWidth + (slider.settings.minSlides - 1) * slider.settings.slideMargin;
      slider.maxThreshold = slider.settings.maxSlides * slider.settings.slideWidth + (slider.settings.maxSlides - 1) * slider.settings.slideMargin;
      // store the current state of the slider (if currently animating, working is true)
      slider.working = false;
      // initialize the controls object
      slider.controls = {};
      // initialize an auto interval
      slider.interval = null;
      // determine which property to use for transitions
      slider.animProp = slider.settings.mode === 'vertical' ? 'top' : 'left';
      // determine if hardware acceleration can be used
      slider.usingCSS = slider.settings.useCSS && slider.settings.mode !== 'fade' && function () {
        // create our test div element
        var div = document.createElement('div'),
          // css transition properties
          props = ['WebkitPerspective', 'MozPerspective', 'OPerspective', 'msPerspective'];
        // test for each property
        for (var i = 0; i < props.length; i++) {
          if (div.style[props[i]] !== undefined) {
            slider.cssPrefix = props[i].replace('Perspective', '').toLowerCase();
            slider.animProp = '-' + slider.cssPrefix + '-transform';
            return true;
          }
        }
        return false;
      }();
      // if vertical mode always make maxSlides and minSlides equal
      if (slider.settings.mode === 'vertical') {
        slider.settings.maxSlides = slider.settings.minSlides;
      }
      // save original style data
      el.data('origStyle', el.attr('style'));
      el.children(slider.settings.slideSelector).each(function () {
        $(this).data('origStyle', $(this).attr('style'));
      });

      // perform all DOM / CSS modifications
      setup();
    };

    /**
     * Performs all DOM and CSS modifications
     */
    var setup = function setup() {
      var preloadSelector = slider.children.eq(slider.settings.startSlide); // set the default preload selector (visible)

      // wrap el in a wrapper
      el.wrap('<div class="' + slider.settings.wrapperClass + '"><div class="bx-viewport"></div></div>');
      // store a namespace reference to .bx-viewport
      slider.viewport = el.parent();

      // add aria-live if the setting is enabled and ticker mode is disabled
      if (slider.settings.ariaLive && !slider.settings.ticker) {
        slider.viewport.attr('aria-live', 'polite');
      }
      // add a loading div to display while images are loading
      slider.loader = $('<div class="bx-loading" />');
      slider.viewport.prepend(slider.loader);
      // set el to a massive width, to hold any needed slides
      // also strip any margin and padding from el
      el.css({
        width: slider.settings.mode === 'horizontal' ? slider.children.length * 1000 + 215 + '%' : 'auto',
        position: 'relative'
      });
      // if using CSS, add the easing property
      if (slider.usingCSS && slider.settings.easing) {
        el.css('-' + slider.cssPrefix + '-transition-timing-function', slider.settings.easing);
        // if not using CSS and no easing value was supplied, use the default JS animation easing (swing)
      } else if (!slider.settings.easing) {
        slider.settings.easing = 'swing';
      }
      // make modifications to the viewport (.bx-viewport)
      slider.viewport.css({
        width: '100%',
        overflow: 'hidden',
        position: 'relative'
      });
      slider.viewport.parent().css({
        maxWidth: getViewportMaxWidth()
      });
      // apply css to all slider children
      slider.children.css({
        // the float attribute is a reserved word in compressors like YUI compressor and need to be quoted #48
        'float': slider.settings.mode === 'horizontal' ? 'left' : 'none',
        listStyle: 'none',
        position: 'relative'
      });
      // apply the calculated width after the float is applied to prevent scrollbar interference
      slider.children.css('width', getSlideWidth());
      // if slideMargin is supplied, add the css
      if (slider.settings.mode === 'horizontal' && slider.settings.slideMargin > 0) {
        slider.children.css('marginRight', slider.settings.slideMargin);
      }
      if (slider.settings.mode === 'vertical' && slider.settings.slideMargin > 0) {
        slider.children.css('marginBottom', slider.settings.slideMargin);
      }
      // if "fade" mode, add positioning and z-index CSS
      if (slider.settings.mode === 'fade') {
        slider.children.css({
          position: 'absolute',
          zIndex: 0,
          display: 'none'
        });
        // prepare the z-index on the showing element
        slider.children.eq(slider.settings.startSlide).css({
          zIndex: slider.settings.slideZIndex,
          display: 'block'
        });
      }
      // create an element to contain all slider controls (pager, start / stop, etc)
      slider.controls.el = $('<div class="bx-controls" />');
      // if captions are requested, add them
      if (slider.settings.captions) {
        appendCaptions();
      }
      // check if startSlide is last slide
      slider.active.last = slider.settings.startSlide === getPagerQty() - 1;
      // if video is true, set up the fitVids plugin
      if (slider.settings.video) {
        el.fitVids();
      }
      //preloadImages
      if (slider.settings.preloadImages === 'none') {
        preloadSelector = null;
      } else if (slider.settings.preloadImages === 'all' || slider.settings.ticker) {
        preloadSelector = slider.children;
      }
      // only check for control addition if not in "ticker" mode
      if (!slider.settings.ticker) {
        // if controls are requested, add them
        if (slider.settings.controls) {
          appendControls();
        }
        // if auto is true, and auto controls are requested, add them
        if (slider.settings.auto && slider.settings.autoControls) {
          appendControlsAuto();
        }
        // if pager is requested, add it
        if (slider.settings.pager) {
          appendPager();
        }
        // if any control option is requested, add the controls wrapper
        if (slider.settings.controls || slider.settings.autoControls || slider.settings.pager) {
          slider.viewport.after(slider.controls.el);
        }
        // if ticker mode, do not allow a pager
      } else {
        slider.settings.pager = false;
      }
      if (preloadSelector === null) {
        start();
      } else {
        loadElements(preloadSelector, start);
      }
    };
    var loadElements = function loadElements(selector, callback) {
      var total = selector.find('img:not([src=""]), iframe').length,
        count = 0;
      if (total === 0) {
        callback();
        return;
      }
      selector.find('img:not([src=""]), iframe').each(function () {
        $(this).one('load error', function () {
          if (++count === total) {
            callback();
          }
        }).each(function () {
          if (this.complete || this.src == '') {
            $(this).trigger('load');
          }
        });
      });
    };

    /**
     * Start the slider
     */
    var start = function start() {
      // if infinite loop, prepare additional slides
      if (slider.settings.infiniteLoop && slider.settings.mode !== 'fade' && !slider.settings.ticker) {
        var slice = slider.settings.mode === 'vertical' ? slider.settings.minSlides : slider.settings.maxSlides,
          sliceAppend = slider.children.slice(0, slice).clone(true).addClass('bx-clone'),
          slicePrepend = slider.children.slice(-slice).clone(true).addClass('bx-clone');
        if (slider.settings.ariaHidden) {
          sliceAppend.attr('aria-hidden', true);
          slicePrepend.attr('aria-hidden', true);
        }
        el.append(sliceAppend).prepend(slicePrepend);
      }
      // remove the loading DOM element
      slider.loader.remove();
      // set the left / top position of "el"
      setSlidePosition();
      // if "vertical" mode, always use adaptiveHeight to prevent odd behavior
      if (slider.settings.mode === 'vertical') {
        slider.settings.adaptiveHeight = true;
      }
      // set the viewport height
      slider.viewport.height(getViewportHeight());
      // make sure everything is positioned just right (same as a window resize)
      el.redrawSlider();
      // onSliderLoad callback
      slider.settings.onSliderLoad.call(el, slider.active.index);
      // slider has been fully initialized
      slider.initialized = true;
      // add the resize call to the window
      if (slider.settings.responsive) {
        $(window).on('resize', _resizeWindow);
      }
      // if auto is true and has more than 1 page, start the show
      if (slider.settings.auto && slider.settings.autoStart && (getPagerQty() > 1 || slider.settings.autoSlideForOnePage)) {
        initAuto();
      }
      // if ticker is true, start the ticker
      if (slider.settings.ticker) {
        initTicker();
      }
      // if pager is requested, make the appropriate pager link active
      if (slider.settings.pager) {
        updatePagerActive(slider.settings.startSlide);
      }
      // check for any updates to the controls (like hideControlOnEnd updates)
      if (slider.settings.controls) {
        updateDirectionControls();
      }
      // if touchEnabled is true, setup the touch events
      if (slider.settings.touchEnabled && !slider.settings.ticker) {
        initTouch();
      }
      // if keyboardEnabled is true, setup the keyboard events
      if (slider.settings.keyboardEnabled && !slider.settings.ticker) {
        $(document).keydown(keyPress);
      }
    };

    /**
     * Returns the calculated height of the viewport, used to determine either adaptiveHeight or the maxHeight value
     */
    var getViewportHeight = function getViewportHeight() {
      var height = 0;
      // first determine which children (slides) should be used in our height calculation
      var children = $();
      // if mode is not "vertical" and adaptiveHeight is false, include all children
      if (slider.settings.mode !== 'vertical' && !slider.settings.adaptiveHeight) {
        children = slider.children;
      } else {
        // if not carousel, return the single active child
        if (!slider.carousel) {
          children = slider.children.eq(slider.active.index);
          // if carousel, return a slice of children
        } else {
          // get the individual slide index
          var currentIndex = slider.settings.moveSlides === 1 ? slider.active.index : slider.active.index * getMoveBy();
          // add the current slide to the children
          children = slider.children.eq(currentIndex);
          // cycle through the remaining "showing" slides
          for (i = 1; i <= slider.settings.maxSlides - 1; i++) {
            // if looped back to the start
            if (currentIndex + i >= slider.children.length) {
              children = children.add(slider.children.eq(i - 1));
            } else {
              children = children.add(slider.children.eq(currentIndex + i));
            }
          }
        }
      }
      // if "vertical" mode, calculate the sum of the heights of the children
      if (slider.settings.mode === 'vertical') {
        children.each(function (index) {
          height += $(this).outerHeight();
        });
        // add user-supplied margins
        if (slider.settings.slideMargin > 0) {
          height += slider.settings.slideMargin * (slider.settings.minSlides - 1);
        }
        // if not "vertical" mode, calculate the max height of the children
      } else {
        height = Math.max.apply(Math, children.map(function () {
          return $(this).outerHeight(false);
        }).get());
      }
      if (slider.viewport.css('box-sizing') === 'border-box') {
        height += parseFloat(slider.viewport.css('padding-top')) + parseFloat(slider.viewport.css('padding-bottom')) + parseFloat(slider.viewport.css('border-top-width')) + parseFloat(slider.viewport.css('border-bottom-width'));
      } else if (slider.viewport.css('box-sizing') === 'padding-box') {
        height += parseFloat(slider.viewport.css('padding-top')) + parseFloat(slider.viewport.css('padding-bottom'));
      }
      return height;
    };

    /**
     * Returns the calculated width to be used for the outer wrapper / viewport
     */
    var getViewportMaxWidth = function getViewportMaxWidth() {
      var width = '100%';
      if (slider.settings.slideWidth > 0) {
        if (slider.settings.mode === 'horizontal') {
          width = slider.settings.maxSlides * slider.settings.slideWidth + (slider.settings.maxSlides - 1) * slider.settings.slideMargin;
        } else {
          width = slider.settings.slideWidth;
        }
      }
      return width;
    };

    /**
     * Returns the calculated width to be applied to each slide
     */
    var getSlideWidth = function getSlideWidth() {
      var newElWidth = slider.settings.slideWidth,
        // start with any user-supplied slide width
        wrapWidth = slider.viewport.width(); // get the current viewport width
      // if slide width was not supplied, or is larger than the viewport use the viewport width
      if (slider.settings.slideWidth === 0 || slider.settings.slideWidth > wrapWidth && !slider.carousel || slider.settings.mode === 'vertical') {
        newElWidth = wrapWidth;
        // if carousel, use the thresholds to determine the width
      } else if (slider.settings.maxSlides > 1 && slider.settings.mode === 'horizontal') {
        if (wrapWidth > slider.maxThreshold) {
          return newElWidth;
        } else if (wrapWidth < slider.minThreshold) {
          newElWidth = (wrapWidth - slider.settings.slideMargin * (slider.settings.minSlides - 1)) / slider.settings.minSlides;
        } else if (slider.settings.shrinkItems) {
          newElWidth = Math.floor((wrapWidth + slider.settings.slideMargin) / Math.ceil((wrapWidth + slider.settings.slideMargin) / (newElWidth + slider.settings.slideMargin)) - slider.settings.slideMargin);
        }
      }
      return newElWidth;
    };

    /**
     * Returns the number of slides currently visible in the viewport (includes partially visible slides)
     */
    var getNumberSlidesShowing = function getNumberSlidesShowing() {
      var slidesShowing = 1,
        childWidth = null;
      if (slider.settings.mode === 'horizontal' && slider.settings.slideWidth > 0) {
        // if viewport is smaller than minThreshold, return minSlides
        if (slider.viewport.width() < slider.minThreshold) {
          slidesShowing = slider.settings.minSlides;
          // if viewport is larger than maxThreshold, return maxSlides
        } else if (slider.viewport.width() > slider.maxThreshold) {
          slidesShowing = slider.settings.maxSlides;
          // if viewport is between min / max thresholds, divide viewport width by first child width
        } else {
          childWidth = slider.children.first().width() + slider.settings.slideMargin;
          slidesShowing = Math.floor((slider.viewport.width() + slider.settings.slideMargin) / childWidth) || 1;
        }
        // if "vertical" mode, slides showing will always be minSlides
      } else if (slider.settings.mode === 'vertical') {
        slidesShowing = slider.settings.minSlides;
      }
      return slidesShowing;
    };

    /**
     * Returns the number of pages (one full viewport of slides is one "page")
     */
    var getPagerQty = function getPagerQty() {
      var pagerQty = 0,
        breakPoint = 0,
        counter = 0;
      // if moveSlides is specified by the user
      if (slider.settings.moveSlides > 0) {
        if (slider.settings.infiniteLoop) {
          pagerQty = Math.ceil(slider.children.length / getMoveBy());
        } else {
          // when breakpoint goes above children length, counter is the number of pages
          while (breakPoint < slider.children.length) {
            ++pagerQty;
            breakPoint = counter + getNumberSlidesShowing();
            counter += slider.settings.moveSlides <= getNumberSlidesShowing() ? slider.settings.moveSlides : getNumberSlidesShowing();
          }
          return counter;
        }
        // if moveSlides is 0 (auto) divide children length by sides showing, then round up
      } else {
        pagerQty = Math.ceil(slider.children.length / getNumberSlidesShowing());
      }
      return pagerQty;
    };

    /**
     * Returns the number of individual slides by which to shift the slider
     */
    var getMoveBy = function getMoveBy() {
      // if moveSlides was set by the user and moveSlides is less than number of slides showing
      if (slider.settings.moveSlides > 0 && slider.settings.moveSlides <= getNumberSlidesShowing()) {
        return slider.settings.moveSlides;
      }
      // if moveSlides is 0 (auto)
      return getNumberSlidesShowing();
    };

    /**
     * Sets the slider's (el) left or top position
     */
    var setSlidePosition = function setSlidePosition() {
      var position, lastChild, lastShowingIndex;
      // if last slide, not infinite loop, and number of children is larger than specified maxSlides
      if (slider.children.length > slider.settings.maxSlides && slider.active.last && !slider.settings.infiniteLoop) {
        if (slider.settings.mode === 'horizontal') {
          // get the last child's position
          lastChild = slider.children.last();
          position = lastChild.position();
          // set the left position
          _setPositionProperty(-(position.left - (slider.viewport.width() - lastChild.outerWidth())), 'reset', 0);
        } else if (slider.settings.mode === 'vertical') {
          // get the last showing index's position
          lastShowingIndex = slider.children.length - slider.settings.minSlides;
          position = slider.children.eq(lastShowingIndex).position();
          // set the top position
          _setPositionProperty(-position.top, 'reset', 0);
        }
        // if not last slide
      } else {
        // get the position of the first showing slide
        position = slider.children.eq(slider.active.index * getMoveBy()).position();
        // check for last slide
        if (slider.active.index === getPagerQty() - 1) {
          slider.active.last = true;
        }
        // set the respective position
        if (position !== undefined) {
          if (slider.settings.mode === 'horizontal') {
            _setPositionProperty(-position.left, 'reset', 0);
          } else if (slider.settings.mode === 'vertical') {
            _setPositionProperty(-position.top, 'reset', 0);
          }
        }
      }
    };

    /**
     * Sets the el's animating property position (which in turn will sometimes animate el).
     * If using CSS, sets the transform property. If not using CSS, sets the top / left property.
     *
     * @param value (int)
     *  - the animating property's value
     *
     * @param type (string) 'slide', 'reset', 'ticker'
     *  - the type of instance for which the function is being
     *
     * @param duration (int)
     *  - the amount of time (in ms) the transition should occupy
     *
     * @param params (array) optional
     *  - an optional parameter containing any variables that need to be passed in
     */
    var _setPositionProperty = function setPositionProperty(value, type, duration, params) {
      var animateObj, propValue;
      // use CSS transform
      if (slider.usingCSS) {
        // determine the translate3d value
        propValue = slider.settings.mode === 'vertical' ? 'translate3d(0, ' + value + 'px, 0)' : 'translate3d(' + value + 'px, 0, 0)';
        // add the CSS transition-duration
        el.css('-' + slider.cssPrefix + '-transition-duration', duration / 1000 + 's');
        if (type === 'slide') {
          // set the property value
          el.css(slider.animProp, propValue);
          if (duration !== 0) {
            // add a callback method - executes when CSS transition completes
            el.on('transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd', function (e) {
              //make sure it's the correct one
              if (!$(e.target).is(el)) {
                return;
              }
              // remove the callback
              el.off('transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd');
              updateAfterSlideTransition();
            });
          } else {
            //duration = 0
            updateAfterSlideTransition();
          }
        } else if (type === 'reset') {
          el.css(slider.animProp, propValue);
        } else if (type === 'ticker') {
          // make the transition use 'linear'
          el.css('-' + slider.cssPrefix + '-transition-timing-function', 'linear');
          el.css(slider.animProp, propValue);
          if (duration !== 0) {
            el.on('transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd', function (e) {
              //make sure it's the correct one
              if (!$(e.target).is(el)) {
                return;
              }
              // remove the callback
              el.off('transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd');
              // reset the position
              _setPositionProperty(params.resetValue, 'reset', 0);
              // start the loop again
              tickerLoop();
            });
          } else {
            //duration = 0
            _setPositionProperty(params.resetValue, 'reset', 0);
            tickerLoop();
          }
        }
        // use JS animate
      } else {
        animateObj = {};
        animateObj[slider.animProp] = value;
        if (type === 'slide') {
          el.animate(animateObj, duration, slider.settings.easing, function () {
            updateAfterSlideTransition();
          });
        } else if (type === 'reset') {
          el.css(slider.animProp, value);
        } else if (type === 'ticker') {
          el.animate(animateObj, duration, 'linear', function () {
            _setPositionProperty(params.resetValue, 'reset', 0);
            // run the recursive loop after animation
            tickerLoop();
          });
        }
      }
    };

    /**
     * Populates the pager with proper amount of pages
     */
    var populatePager = function populatePager() {
      var pagerHtml = '',
        linkContent = '',
        pagerQty = getPagerQty();
      // loop through each pager item
      for (var i = 0; i < pagerQty; i++) {
        linkContent = '';
        // if a buildPager function is supplied, use it to get pager link value, else use index + 1
        if (slider.settings.buildPager && $.isFunction(slider.settings.buildPager) || slider.settings.pagerCustom) {
          linkContent = slider.settings.buildPager(i);
          slider.pagerEl.addClass('bx-custom-pager');
        } else {
          linkContent = i + 1;
          slider.pagerEl.addClass('bx-default-pager');
        }
        // var linkContent = slider.settings.buildPager && $.isFunction(slider.settings.buildPager) ? slider.settings.buildPager(i) : i + 1;
        // add the markup to the string
        pagerHtml += '<div class="bx-pager-item"><a href="" data-slide-index="' + i + '" class="bx-pager-link">' + linkContent + '</a></div>';
      }
      // populate the pager element with pager links
      slider.pagerEl.html(pagerHtml);
    };

    /**
     * Appends the pager to the controls element
     */
    var appendPager = function appendPager() {
      if (!slider.settings.pagerCustom) {
        // create the pager DOM element
        slider.pagerEl = $('<div class="bx-pager" />');
        // if a pager selector was supplied, populate it with the pager
        if (slider.settings.pagerSelector) {
          $(slider.settings.pagerSelector).html(slider.pagerEl);
          // if no pager selector was supplied, add it after the wrapper
        } else {
          slider.controls.el.addClass('bx-has-pager').append(slider.pagerEl);
        }
        // populate the pager
        populatePager();
      } else {
        slider.pagerEl = $(slider.settings.pagerCustom);
      }
      // assign the pager click binding
      slider.pagerEl.on('click touchend', 'a', clickPagerBind);
    };

    /**
     * Appends prev / next controls to the controls element
     */
    var appendControls = function appendControls() {
      slider.controls.next = $('<a class="bx-next" href="">' + slider.settings.nextText + '</a>');
      slider.controls.prev = $('<a class="bx-prev" href="">' + slider.settings.prevText + '</a>');
      // add click actions to the controls
      slider.controls.next.on('click touchend', clickNextBind);
      slider.controls.prev.on('click touchend', clickPrevBind);
      // if nextSelector was supplied, populate it
      if (slider.settings.nextSelector) {
        $(slider.settings.nextSelector).append(slider.controls.next);
      }
      // if prevSelector was supplied, populate it
      if (slider.settings.prevSelector) {
        $(slider.settings.prevSelector).append(slider.controls.prev);
      }
      // if no custom selectors were supplied
      if (!slider.settings.nextSelector && !slider.settings.prevSelector) {
        // add the controls to the DOM
        slider.controls.directionEl = $('<div class="bx-controls-direction" />');
        // add the control elements to the directionEl
        slider.controls.directionEl.append(slider.controls.prev).append(slider.controls.next);
        // slider.viewport.append(slider.controls.directionEl);
        slider.controls.el.addClass('bx-has-controls-direction').append(slider.controls.directionEl);
      }
    };

    /**
     * Appends start / stop auto controls to the controls element
     */
    var appendControlsAuto = function appendControlsAuto() {
      slider.controls.start = $('<div class="bx-controls-auto-item"><a class="bx-start" href="">' + slider.settings.startText + '</a></div>');
      slider.controls.stop = $('<div class="bx-controls-auto-item"><a class="bx-stop" href="">' + slider.settings.stopText + '</a></div>');
      // add the controls to the DOM
      slider.controls.autoEl = $('<div class="bx-controls-auto" />');
      // on click actions to the controls
      slider.controls.autoEl.on('click', '.bx-start', clickStartBind);
      slider.controls.autoEl.on('click', '.bx-stop', clickStopBind);
      // if autoControlsCombine, insert only the "start" control
      if (slider.settings.autoControlsCombine) {
        slider.controls.autoEl.append(slider.controls.start);
        // if autoControlsCombine is false, insert both controls
      } else {
        slider.controls.autoEl.append(slider.controls.start).append(slider.controls.stop);
      }
      // if auto controls selector was supplied, populate it with the controls
      if (slider.settings.autoControlsSelector) {
        $(slider.settings.autoControlsSelector).html(slider.controls.autoEl);
        // if auto controls selector was not supplied, add it after the wrapper
      } else {
        slider.controls.el.addClass('bx-has-controls-auto').append(slider.controls.autoEl);
      }
      // update the auto controls
      updateAutoControls(slider.settings.autoStart ? 'stop' : 'start');
    };

    /**
     * Appends image captions to the DOM
     */
    var appendCaptions = function appendCaptions() {
      // cycle through each child
      slider.children.each(function (index) {
        // get the image title attribute
        var title = $(this).find('img:first').attr('title');
        // append the caption
        if (title !== undefined && ('' + title).length) {
          $(this).append('<div class="bx-caption"><span>' + title + '</span></div>');
        }
      });
    };

    /**
     * Click next binding
     *
     * @param e (event)
     *  - DOM event object
     */
    var clickNextBind = function clickNextBind(e) {
      e.preventDefault();
      if (slider.controls.el.hasClass('disabled')) {
        return;
      }
      // if auto show is running, stop it
      if (slider.settings.auto && slider.settings.stopAutoOnClick) {
        el.stopAuto();
      }
      el.goToNextSlide();
    };

    /**
     * Click prev binding
     *
     * @param e (event)
     *  - DOM event object
     */
    var clickPrevBind = function clickPrevBind(e) {
      e.preventDefault();
      if (slider.controls.el.hasClass('disabled')) {
        return;
      }
      // if auto show is running, stop it
      if (slider.settings.auto && slider.settings.stopAutoOnClick) {
        el.stopAuto();
      }
      el.goToPrevSlide();
    };

    /**
     * Click start binding
     *
     * @param e (event)
     *  - DOM event object
     */
    var clickStartBind = function clickStartBind(e) {
      el.startAuto();
      e.preventDefault();
    };

    /**
     * Click stop binding
     *
     * @param e (event)
     *  - DOM event object
     */
    var clickStopBind = function clickStopBind(e) {
      el.stopAuto();
      e.preventDefault();
    };

    /**
     * Click pager binding
     *
     * @param e (event)
     *  - DOM event object
     */
    var clickPagerBind = function clickPagerBind(e) {
      var pagerLink, pagerIndex;
      e.preventDefault();
      if (slider.controls.el.hasClass('disabled')) {
        return;
      }
      // if auto show is running, stop it
      if (slider.settings.auto && slider.settings.stopAutoOnClick) {
        el.stopAuto();
      }
      pagerLink = $(e.currentTarget);
      if (pagerLink.attr('data-slide-index') !== undefined) {
        pagerIndex = parseInt(pagerLink.attr('data-slide-index'));
        // if clicked pager link is not active, continue with the goToSlide call
        if (pagerIndex !== slider.active.index) {
          el.goToSlide(pagerIndex);
        }
      }
    };

    /**
     * Updates the pager links with an active class
     *
     * @param slideIndex (int)
     *  - index of slide to make active
     */
    var updatePagerActive = function updatePagerActive(slideIndex) {
      // if "short" pager type
      var len = slider.children.length; // nb of children
      if (slider.settings.pagerType === 'short') {
        if (slider.settings.maxSlides > 1) {
          len = Math.ceil(slider.children.length / slider.settings.maxSlides);
        }
        slider.pagerEl.html(slideIndex + 1 + slider.settings.pagerShortSeparator + len);
        return;
      }
      // remove all pager active classes
      slider.pagerEl.find('a').removeClass('active');
      // apply the active class for all pagers
      slider.pagerEl.each(function (i, el) {
        $(el).find('a').eq(slideIndex).addClass('active');
      });
    };

    /**
     * Performs needed actions after a slide transition
     */
    var updateAfterSlideTransition = function updateAfterSlideTransition() {
      // if infinite loop is true
      if (slider.settings.infiniteLoop) {
        var position = '';
        // first slide
        if (slider.active.index === 0) {
          // set the new position
          position = slider.children.eq(0).position();
          // carousel, last slide
        } else if (slider.active.index === getPagerQty() - 1 && slider.carousel) {
          position = slider.children.eq((getPagerQty() - 1) * getMoveBy()).position();
          // last slide
        } else if (slider.active.index === slider.children.length - 1) {
          position = slider.children.eq(slider.children.length - 1).position();
        }
        if (position) {
          if (slider.settings.mode === 'horizontal') {
            _setPositionProperty(-position.left, 'reset', 0);
          } else if (slider.settings.mode === 'vertical') {
            _setPositionProperty(-position.top, 'reset', 0);
          }
        }
      }
      // declare that the transition is complete
      slider.working = false;
      // onSlideAfter callback
      slider.settings.onSlideAfter.call(el, slider.children.eq(slider.active.index), slider.oldIndex, slider.active.index);
    };

    /**
     * Updates the auto controls state (either active, or combined switch)
     *
     * @param state (string) "start", "stop"
     *  - the new state of the auto show
     */
    var updateAutoControls = function updateAutoControls(state) {
      // if autoControlsCombine is true, replace the current control with the new state
      if (slider.settings.autoControlsCombine) {
        slider.controls.autoEl.html(slider.controls[state]);
        // if autoControlsCombine is false, apply the "active" class to the appropriate control
      } else {
        slider.controls.autoEl.find('a').removeClass('active');
        slider.controls.autoEl.find('a:not(.bx-' + state + ')').addClass('active');
      }
    };

    /**
     * Updates the direction controls (checks if either should be hidden)
     */
    var updateDirectionControls = function updateDirectionControls() {
      if (getPagerQty() === 1) {
        slider.controls.prev.addClass('disabled');
        slider.controls.next.addClass('disabled');
      } else if (!slider.settings.infiniteLoop && slider.settings.hideControlOnEnd) {
        // if first slide
        if (slider.active.index === 0) {
          slider.controls.prev.addClass('disabled');
          slider.controls.next.removeClass('disabled');
          // if last slide
        } else if (slider.active.index === getPagerQty() - 1) {
          slider.controls.next.addClass('disabled');
          slider.controls.prev.removeClass('disabled');
          // if any slide in the middle
        } else {
          slider.controls.prev.removeClass('disabled');
          slider.controls.next.removeClass('disabled');
        }
      }
    };
    /* auto start and stop functions */
    var windowFocusHandler = function windowFocusHandler() {
      el.startAuto();
    };
    var windowBlurHandler = function windowBlurHandler() {
      el.stopAuto();
    };
    /**
     * Initializes the auto process
     */
    var initAuto = function initAuto() {
      // if autoDelay was supplied, launch the auto show using a setTimeout() call
      if (slider.settings.autoDelay > 0) {
        setTimeout(el.startAuto, slider.settings.autoDelay);
        // if autoDelay was not supplied, start the auto show normally
      } else {
        el.startAuto();

        //add focus and blur events to ensure its running if timeout gets paused
        $(window).focus(windowFocusHandler).blur(windowBlurHandler);
      }
      // if autoHover is requested
      if (slider.settings.autoHover) {
        // on el hover
        el.hover(function () {
          // if the auto show is currently playing (has an active interval)
          if (slider.interval) {
            // stop the auto show and pass true argument which will prevent control update
            el.stopAuto(true);
            // create a new autoPaused value which will be used by the relative "mouseout" event
            slider.autoPaused = true;
          }
        }, function () {
          // if the autoPaused value was created be the prior "mouseover" event
          if (slider.autoPaused) {
            // start the auto show and pass true argument which will prevent control update
            el.startAuto(true);
            // reset the autoPaused value
            slider.autoPaused = null;
          }
        });
      }
    };

    /**
     * Initializes the ticker process
     */
    var initTicker = function initTicker() {
      var startPosition = 0,
        position,
        transform,
        value,
        idx,
        ratio,
        property,
        newSpeed,
        totalDimens;
      // if autoDirection is "next", append a clone of the entire slider
      if (slider.settings.autoDirection === 'next') {
        el.append(slider.children.clone().addClass('bx-clone'));
        // if autoDirection is "prev", prepend a clone of the entire slider, and set the left position
      } else {
        el.prepend(slider.children.clone().addClass('bx-clone'));
        position = slider.children.first().position();
        startPosition = slider.settings.mode === 'horizontal' ? -position.left : -position.top;
      }
      _setPositionProperty(startPosition, 'reset', 0);
      // do not allow controls in ticker mode
      slider.settings.pager = false;
      slider.settings.controls = false;
      slider.settings.autoControls = false;
      // if autoHover is requested
      if (slider.settings.tickerHover) {
        if (slider.usingCSS) {
          idx = slider.settings.mode === 'horizontal' ? 4 : 5;
          slider.viewport.hover(function () {
            transform = el.css('-' + slider.cssPrefix + '-transform');
            value = parseFloat(transform.split(',')[idx]);
            _setPositionProperty(value, 'reset', 0);
          }, function () {
            totalDimens = 0;
            slider.children.each(function (index) {
              totalDimens += slider.settings.mode === 'horizontal' ? $(this).outerWidth(true) : $(this).outerHeight(true);
            });
            // calculate the speed ratio (used to determine the new speed to finish the paused animation)
            ratio = slider.settings.speed / totalDimens;
            // determine which property to use
            property = slider.settings.mode === 'horizontal' ? 'left' : 'top';
            // calculate the new speed
            newSpeed = ratio * (totalDimens - Math.abs(parseInt(value)));
            tickerLoop(newSpeed);
          });
        } else {
          // on el hover
          slider.viewport.hover(function () {
            el.stop();
          }, function () {
            // calculate the total width of children (used to calculate the speed ratio)
            totalDimens = 0;
            slider.children.each(function (index) {
              totalDimens += slider.settings.mode === 'horizontal' ? $(this).outerWidth(true) : $(this).outerHeight(true);
            });
            // calculate the speed ratio (used to determine the new speed to finish the paused animation)
            ratio = slider.settings.speed / totalDimens;
            // determine which property to use
            property = slider.settings.mode === 'horizontal' ? 'left' : 'top';
            // calculate the new speed
            newSpeed = ratio * (totalDimens - Math.abs(parseInt(el.css(property))));
            tickerLoop(newSpeed);
          });
        }
      }
      // start the ticker loop
      tickerLoop();
    };

    /**
     * Runs a continuous loop, news ticker-style
     */
    var tickerLoop = function tickerLoop(resumeSpeed) {
      var speed = resumeSpeed ? resumeSpeed : slider.settings.speed,
        position = {
          left: 0,
          top: 0
        },
        reset = {
          left: 0,
          top: 0
        },
        animateProperty,
        resetValue,
        params;

      // if "next" animate left position to last child, then reset left to 0
      if (slider.settings.autoDirection === 'next') {
        position = el.find('.bx-clone').first().position();
        // if "prev" animate left position to 0, then reset left to first non-clone child
      } else {
        reset = slider.children.first().position();
      }
      animateProperty = slider.settings.mode === 'horizontal' ? -position.left : -position.top;
      resetValue = slider.settings.mode === 'horizontal' ? -reset.left : -reset.top;
      params = {
        resetValue: resetValue
      };
      _setPositionProperty(animateProperty, 'ticker', speed, params);
    };

    /**
     * Check if el is on screen
     */
    var isOnScreen = function isOnScreen(el) {
      var win = $(window),
        viewport = {
          top: win.scrollTop(),
          left: win.scrollLeft()
        },
        bounds = el.offset();
      viewport.right = viewport.left + win.width();
      viewport.bottom = viewport.top + win.height();
      bounds.right = bounds.left + el.outerWidth();
      bounds.bottom = bounds.top + el.outerHeight();
      return !(viewport.right < bounds.left || viewport.left > bounds.right || viewport.bottom < bounds.top || viewport.top > bounds.bottom);
    };

    /**
     * Initializes keyboard events
     */
    var keyPress = function keyPress(e) {
      var activeElementTag = document.activeElement.tagName.toLowerCase(),
        tagFilters = 'input|textarea',
        p = new RegExp(activeElementTag, ['i']),
        result = p.exec(tagFilters);
      if (result == null && isOnScreen(el)) {
        if (e.keyCode === 39) {
          clickNextBind(e);
          return false;
        } else if (e.keyCode === 37) {
          clickPrevBind(e);
          return false;
        }
      }
    };

    /**
     * Initializes touch events
     */
    var initTouch = function initTouch() {
      // initialize object to contain all touch values
      slider.touch = {
        start: {
          x: 0,
          y: 0
        },
        end: {
          x: 0,
          y: 0
        }
      };
      slider.viewport.on('touchstart MSPointerDown pointerdown', onTouchStart);

      //for browsers that have implemented pointer events and fire a click after
      //every pointerup regardless of whether pointerup is on same screen location as pointerdown or not
      slider.viewport.on('click', '.bxslider a', function (e) {
        if (slider.viewport.hasClass('click-disabled')) {
          e.preventDefault();
          slider.viewport.removeClass('click-disabled');
        }
      });
    };

    /**
     * Event handler for "touchstart"
     *
     * @param e (event)
     *  - DOM event object
     */
    var onTouchStart = function onTouchStart(e) {
      // watch only for left mouse, touch contact and pen contact
      // touchstart event object doesn`t have button property
      if (e.type !== 'touchstart' && e.button !== 0) {
        return;
      }

      //disable slider controls while user is interacting with slides to avoid slider freeze that happens on touch devices when a slide swipe happens immediately after interacting with slider controls
      slider.controls.el.addClass('disabled');
      if (slider.working) {
        slider.controls.el.removeClass('disabled');
      } else {
        // record the original position when touch starts
        slider.touch.originalPos = el.position();
        var parentHorizontalPadding = slider.viewport.innerWidth() - slider.viewport.width();
        // In case slider parent have horizontal padding recalculate position
        if (parentHorizontalPadding > 0) {
          slider.touch.originalPos.left -= parentHorizontalPadding / 2;
        }
        var orig = e.originalEvent,
          touchPoints = typeof orig.changedTouches !== 'undefined' ? orig.changedTouches : [orig];
        var chromePointerEvents = typeof PointerEvent === 'function';
        if (chromePointerEvents) {
          if (orig.pointerId === undefined) {
            return;
          }
        }
        // record the starting touch x, y coordinates
        slider.touch.start.x = touchPoints[0].pageX;
        slider.touch.start.y = touchPoints[0].pageY;
        if (slider.viewport.get(0).setPointerCapture) {
          slider.pointerId = orig.pointerId;
          slider.viewport.get(0).setPointerCapture(slider.pointerId);
        }
        // store original event data for click fixation
        slider.originalClickTarget = orig.originalTarget || orig.target;
        slider.originalClickButton = orig.button;
        slider.originalClickButtons = orig.buttons;
        slider.originalEventType = orig.type;
        // at this moment we don`t know what it is click or swipe
        slider.hasMove = false;
        // on a "touchmove" event to the viewport
        slider.viewport.on('touchmove MSPointerMove pointermove', onTouchMove);
        // on a "touchend" event to the viewport
        slider.viewport.on('touchend MSPointerUp pointerup', _onTouchEnd);
        slider.viewport.on('MSPointerCancel pointercancel', _onPointerCancel);
      }
    };

    /**
     * Cancel Pointer for Windows Phone
     *
     * @param e (event)
     *  - DOM event object
     */
    var _onPointerCancel = function onPointerCancel(e) {
      e.preventDefault();
      /* onPointerCancel handler is needed to deal with situations when a touchend
      doesn't fire after a touchstart (this happens on windows phones only) */
      _setPositionProperty(slider.touch.originalPos.left, 'reset', 0);

      //remove handlers
      slider.controls.el.removeClass('disabled');
      slider.viewport.off('MSPointerCancel pointercancel', _onPointerCancel);
      slider.viewport.off('touchmove MSPointerMove pointermove', onTouchMove);
      slider.viewport.off('touchend MSPointerUp pointerup', _onTouchEnd);
      if (slider.viewport.get(0).releasePointerCapture) {
        slider.viewport.get(0).releasePointerCapture(slider.pointerId);
      }
    };

    /**
     * Event handler for "touchmove"
     *
     * @param e (event)
     *  - DOM event object
     */
    var onTouchMove = function onTouchMove(e) {
      var orig = e.originalEvent,
        touchPoints = typeof orig.changedTouches !== 'undefined' ? orig.changedTouches : [orig],
        // if scrolling on y axis, do not prevent default
        xMovement = Math.abs(touchPoints[0].pageX - slider.touch.start.x),
        yMovement = Math.abs(touchPoints[0].pageY - slider.touch.start.y),
        value = 0,
        change = 0;

      // this is swipe
      if (xMovement > yMovement && xMovement > 3 || yMovement > xMovement && yMovement > 3) {
        slider.hasMove = true;
      }

      // x axis swipe
      if (xMovement * 3 > yMovement && slider.settings.preventDefaultSwipeX) {
        e.preventDefault();
        // y axis swipe
      } else if (yMovement * 3 > xMovement && slider.settings.preventDefaultSwipeY) {
        e.preventDefault();
      }
      if (e.type !== 'touchmove') {
        e.preventDefault();
      }
      if (slider.settings.mode !== 'fade' && slider.settings.oneToOneTouch) {
        // if horizontal, drag along x axis
        if (slider.settings.mode === 'horizontal') {
          change = touchPoints[0].pageX - slider.touch.start.x;
          value = slider.touch.originalPos.left + change;
          // if vertical, drag along y axis
        } else {
          change = touchPoints[0].pageY - slider.touch.start.y;
          value = slider.touch.originalPos.top + change;
        }
        _setPositionProperty(value, 'reset', 0);
      }
    };

    /**
     * Event handler for "touchend"
     *
     * @param e (event)
     *  - DOM event object
     */
    var _onTouchEnd = function onTouchEnd(e) {
      e.preventDefault();
      slider.viewport.off('touchmove MSPointerMove pointermove', onTouchMove);
      //enable slider controls as soon as user stops interacing with slides
      slider.controls.el.removeClass('disabled');
      var orig = e.originalEvent,
        touchPoints = typeof orig.changedTouches !== 'undefined' ? orig.changedTouches : [orig],
        value = 0,
        distance = 0;
      // record end x, y positions
      slider.touch.end.x = touchPoints[0].pageX;
      slider.touch.end.y = touchPoints[0].pageY;
      // if fade mode, check if absolute x distance clears the threshold
      if (slider.settings.mode === 'fade') {
        distance = Math.abs(slider.touch.start.x - slider.touch.end.x);
        if (distance >= slider.settings.swipeThreshold) {
          if (slider.touch.start.x > slider.touch.end.x) {
            el.goToNextSlide();
          } else {
            el.goToPrevSlide();
          }
          el.stopAuto();
        }
        // not fade mode
      } else {
        // calculate distance and el's animate property
        if (slider.settings.mode === 'horizontal') {
          distance = slider.touch.end.x - slider.touch.start.x;
          value = slider.touch.originalPos.left;
        } else {
          distance = slider.touch.end.y - slider.touch.start.y;
          value = slider.touch.originalPos.top;
        }
        // if not infinite loop and first / last slide, do not attempt a slide transition
        if (!slider.settings.infiniteLoop && (slider.active.index === 0 && distance > 0 || slider.active.last && distance < 0)) {
          _setPositionProperty(value, 'reset', 200);
        } else {
          // check if distance clears threshold
          if (Math.abs(distance) >= slider.settings.swipeThreshold) {
            if (distance < 0) {
              el.goToNextSlide();
            } else {
              el.goToPrevSlide();
            }
            el.stopAuto();
          } else {
            // el.animate(property, 200);
            _setPositionProperty(value, 'reset', 200);
          }
        }
      }
      slider.viewport.off('touchend MSPointerUp pointerup', _onTouchEnd);
      if (slider.viewport.get(0).releasePointerCapture) {
        slider.viewport.get(0).releasePointerCapture(slider.pointerId);
      }
      // if slider had swipe with left mouse, touch contact and pen contact
      if (slider.hasMove === false && (slider.originalClickButton === 0 || slider.originalEventType === 'touchstart')) {
        // trigger click event (fix for Firefox59 and PointerEvent standard compatibility)
        $(slider.originalClickTarget).trigger({
          type: 'click',
          button: slider.originalClickButton,
          buttons: slider.originalClickButtons
        });
      }
    };

    /**
     * Window resize event callback
     */
    var _resizeWindow = function resizeWindow(e) {
      // don't do anything if slider isn't initialized.
      if (!slider.initialized) {
        return;
      }
      // Delay if slider working.
      if (slider.working) {
        window.setTimeout(_resizeWindow, 10);
      } else {
        // get the new window dimens (again, thank you IE)
        var windowWidthNew = $(window).width(),
          windowHeightNew = $(window).height();
        // make sure that it is a true window resize
        // *we must check this because our dinosaur friend IE fires a window resize event when certain DOM elements
        // are resized. Can you just die already?*
        if (windowWidth !== windowWidthNew || windowHeight !== windowHeightNew) {
          // set the new window dimens
          windowWidth = windowWidthNew;
          windowHeight = windowHeightNew;
          // update all dynamic elements
          el.redrawSlider();
          // Call user resize handler
          slider.settings.onSliderResize.call(el, slider.active.index);
        }
      }
    };

    /**
     * Adds an aria-hidden=true attribute to each element
     *
     * @param startVisibleIndex (int)
     *  - the first visible element's index
     */
    var applyAriaHiddenAttributes = function applyAriaHiddenAttributes(startVisibleIndex) {
      var numberOfSlidesShowing = getNumberSlidesShowing();
      // only apply attributes if the setting is enabled and not in ticker mode
      if (slider.settings.ariaHidden && !slider.settings.ticker) {
        // add aria-hidden=true to all elements
        slider.children.attr('aria-hidden', 'true');
        // get the visible elements and change to aria-hidden=false
        slider.children.slice(startVisibleIndex, startVisibleIndex + numberOfSlidesShowing).attr('aria-hidden', 'false');
      }
    };

    /**
     * Returns index according to present page range
     *
     * @param slideOndex (int)
     *  - the desired slide index
     */
    var setSlideIndex = function setSlideIndex(slideIndex) {
      if (slideIndex < 0) {
        if (slider.settings.infiniteLoop) {
          return getPagerQty() - 1;
        } else {
          //we don't go to undefined slides
          return slider.active.index;
        }
        // if slideIndex is greater than children length, set active index to 0 (this happens during infinite loop)
      } else if (slideIndex >= getPagerQty()) {
        if (slider.settings.infiniteLoop) {
          return 0;
        } else {
          //we don't move to undefined pages
          return slider.active.index;
        }
        // set active index to requested slide
      } else {
        return slideIndex;
      }
    };

    /**
     * ===================================================================================
     * = PUBLIC FUNCTIONS
     * ===================================================================================
     */

    /**
     * Performs slide transition to the specified slide
     *
     * @param slideIndex (int)
     *  - the destination slide's index (zero-based)
     *
     * @param direction (string)
     *  - INTERNAL USE ONLY - the direction of travel ("prev" / "next")
     */
    el.goToSlide = function (slideIndex, direction) {
      // onSlideBefore, onSlideNext, onSlidePrev callbacks
      // Allow transition canceling based on returned value
      var performTransition = true,
        moveBy = 0,
        position = {
          left: 0,
          top: 0
        },
        lastChild = null,
        lastShowingIndex,
        eq,
        value,
        requestEl;
      // store the old index
      slider.oldIndex = slider.active.index;
      //set new index
      slider.active.index = setSlideIndex(slideIndex);

      // if plugin is currently in motion, ignore request
      if (slider.working || slider.active.index === slider.oldIndex) {
        return;
      }
      // declare that plugin is in motion
      slider.working = true;
      performTransition = slider.settings.onSlideBefore.call(el, slider.children.eq(slider.active.index), slider.oldIndex, slider.active.index);

      // If transitions canceled, reset and return
      if (typeof performTransition !== 'undefined' && !performTransition) {
        slider.active.index = slider.oldIndex; // restore old index
        slider.working = false; // is not in motion
        return;
      }
      if (direction === 'next') {
        // Prevent canceling in future functions or lack there-of from negating previous commands to cancel
        if (!slider.settings.onSlideNext.call(el, slider.children.eq(slider.active.index), slider.oldIndex, slider.active.index)) {
          performTransition = false;
        }
      } else if (direction === 'prev') {
        // Prevent canceling in future functions or lack there-of from negating previous commands to cancel
        if (!slider.settings.onSlidePrev.call(el, slider.children.eq(slider.active.index), slider.oldIndex, slider.active.index)) {
          performTransition = false;
        }
      }

      // check if last slide
      slider.active.last = slider.active.index >= getPagerQty() - 1;
      // update the pager with active class
      if (slider.settings.pager || slider.settings.pagerCustom) {
        updatePagerActive(slider.active.index);
      }
      // // check for direction control update
      if (slider.settings.controls) {
        updateDirectionControls();
      }
      // if slider is set to mode: "fade"
      if (slider.settings.mode === 'fade') {
        // if adaptiveHeight is true and next height is different from current height, animate to the new height
        if (slider.settings.adaptiveHeight && slider.viewport.height() !== getViewportHeight()) {
          slider.viewport.animate({
            height: getViewportHeight()
          }, slider.settings.adaptiveHeightSpeed);
        }
        // fade out the visible child and reset its z-index value
        slider.children.filter(':visible').fadeOut(slider.settings.speed).css({
          zIndex: 0
        });
        // fade in the newly requested slide
        slider.children.eq(slider.active.index).css('zIndex', slider.settings.slideZIndex + 1).fadeIn(slider.settings.speed, function () {
          $(this).css('zIndex', slider.settings.slideZIndex);
          updateAfterSlideTransition();
        });
        // slider mode is not "fade"
      } else {
        // if adaptiveHeight is true and next height is different from current height, animate to the new height
        if (slider.settings.adaptiveHeight && slider.viewport.height() !== getViewportHeight()) {
          slider.viewport.animate({
            height: getViewportHeight()
          }, slider.settings.adaptiveHeightSpeed);
        }
        // if carousel and not infinite loop
        if (!slider.settings.infiniteLoop && slider.carousel && slider.active.last) {
          if (slider.settings.mode === 'horizontal') {
            // get the last child position
            lastChild = slider.children.eq(slider.children.length - 1);
            position = lastChild.position();
            // calculate the position of the last slide
            moveBy = slider.viewport.width() - lastChild.outerWidth();
          } else {
            // get last showing index position
            lastShowingIndex = slider.children.length - slider.settings.minSlides;
            position = slider.children.eq(lastShowingIndex).position();
          }
          // horizontal carousel, going previous while on first slide (infiniteLoop mode)
        } else if (slider.carousel && slider.active.last && direction === 'prev') {
          // get the last child position
          eq = slider.settings.moveSlides === 1 ? slider.settings.maxSlides - getMoveBy() : (getPagerQty() - 1) * getMoveBy() - (slider.children.length - slider.settings.maxSlides);
          lastChild = el.children('.bx-clone').eq(eq);
          position = lastChild.position();
          // if infinite loop and "Next" is clicked on the last slide
        } else if (direction === 'next' && slider.active.index === 0) {
          // get the last clone position
          position = el.find('> .bx-clone').eq(slider.settings.maxSlides).position();
          slider.active.last = false;
          // normal non-zero requests
        } else if (slideIndex >= 0) {
          //parseInt is applied to allow floats for slides/page
          requestEl = slideIndex * parseInt(getMoveBy());
          position = slider.children.eq(requestEl).position();
        }

        /* If the position doesn't exist
         * (e.g. if you destroy the slider on a next click),
         * it doesn't throw an error.
         */
        if (typeof position !== 'undefined') {
          value = slider.settings.mode === 'horizontal' ? -(position.left - moveBy) : -position.top;
          // plugin values to be animated
          _setPositionProperty(value, 'slide', slider.settings.speed);
        }
        slider.working = false;
      }
      if (slider.settings.ariaHidden) {
        applyAriaHiddenAttributes(slider.active.index * getMoveBy());
      }
    };

    /**
     * Transitions to the next slide in the show
     */
    el.goToNextSlide = function () {
      // if infiniteLoop is false and last page is showing, disregard call
      if (!slider.settings.infiniteLoop && slider.active.last) {
        return;
      }
      if (slider.working === true) {
        return;
      }
      var pagerIndex = parseInt(slider.active.index) + 1;
      el.goToSlide(pagerIndex, 'next');
    };

    /**
     * Transitions to the prev slide in the show
     */
    el.goToPrevSlide = function () {
      // if infiniteLoop is false and last page is showing, disregard call
      if (!slider.settings.infiniteLoop && slider.active.index === 0) {
        return;
      }
      if (slider.working === true) {
        return;
      }
      var pagerIndex = parseInt(slider.active.index) - 1;
      el.goToSlide(pagerIndex, 'prev');
    };

    /**
     * Starts the auto show
     *
     * @param preventControlUpdate (boolean)
     *  - if true, auto controls state will not be updated
     */
    el.startAuto = function (preventControlUpdate) {
      // if an interval already exists, disregard call
      if (slider.interval) {
        return;
      }
      // create an interval
      slider.interval = setInterval(function () {
        if (slider.settings.autoDirection === 'next') {
          el.goToNextSlide();
        } else {
          el.goToPrevSlide();
        }
      }, slider.settings.pause);
      //allback for when the auto rotate status changes
      slider.settings.onAutoChange.call(el, true);
      // if auto controls are displayed and preventControlUpdate is not true
      if (slider.settings.autoControls && preventControlUpdate !== true) {
        updateAutoControls('stop');
      }
    };

    /**
     * Stops the auto show
     *
     * @param preventControlUpdate (boolean)
     *  - if true, auto controls state will not be updated
     */
    el.stopAuto = function (preventControlUpdate) {
      // if slider is auto paused, just clear that state
      if (slider.autoPaused) slider.autoPaused = false;
      // if no interval exists, disregard call
      if (!slider.interval) {
        return;
      }
      // clear the interval
      clearInterval(slider.interval);
      slider.interval = null;
      //allback for when the auto rotate status changes
      slider.settings.onAutoChange.call(el, false);
      // if auto controls are displayed and preventControlUpdate is not true
      if (slider.settings.autoControls && preventControlUpdate !== true) {
        updateAutoControls('start');
      }
    };

    /**
     * Returns current slide index (zero-based)
     */
    el.getCurrentSlide = function () {
      return slider.active.index;
    };

    /**
     * Returns current slide element
     */
    el.getCurrentSlideElement = function () {
      return slider.children.eq(slider.active.index);
    };

    /**
     * Returns a slide element
     * @param index (int)
     *  - The index (zero-based) of the element you want returned.
     */
    el.getSlideElement = function (index) {
      return slider.children.eq(index);
    };

    /**
     * Returns number of slides in show
     */
    el.getSlideCount = function () {
      return slider.children.length;
    };

    /**
     * Return slider.working variable
     */
    el.isWorking = function () {
      return slider.working;
    };

    /**
     * Update all dynamic slider elements
     */
    el.redrawSlider = function () {
      // resize all children in ratio to new screen size
      slider.children.add(el.find('.bx-clone')).outerWidth(getSlideWidth());
      // adjust the height
      slider.viewport.css('height', getViewportHeight());
      // update the slide position
      if (!slider.settings.ticker) {
        setSlidePosition();
      }
      // if active.last was true before the screen resize, we want
      // to keep it last no matter what screen size we end on
      if (slider.active.last) {
        slider.active.index = getPagerQty() - 1;
      }
      // if the active index (page) no longer exists due to the resize, simply set the index as last
      if (slider.active.index >= getPagerQty()) {
        slider.active.last = true;
      }
      // if a pager is being displayed and a custom pager is not being used, update it
      if (slider.settings.pager && !slider.settings.pagerCustom) {
        populatePager();
        updatePagerActive(slider.active.index);
      }
      if (slider.settings.ariaHidden) {
        applyAriaHiddenAttributes(slider.active.index * getMoveBy());
      }
    };

    /**
     * Destroy the current instance of the slider (revert everything back to original state)
     */
    el.destroySlider = function () {
      // don't do anything if slider has already been destroyed
      if (!slider.initialized) {
        return;
      }
      slider.initialized = false;
      $('.bx-clone', this).remove();
      slider.children.each(function () {
        if ($(this).data('origStyle') !== undefined) {
          $(this).attr('style', $(this).data('origStyle'));
        } else {
          $(this).removeAttr('style');
        }
      });
      if ($(this).data('origStyle') !== undefined) {
        this.attr('style', $(this).data('origStyle'));
      } else {
        $(this).removeAttr('style');
      }
      $(this).unwrap().unwrap();
      if (slider.controls.el) {
        slider.controls.el.remove();
      }
      if (slider.controls.next) {
        slider.controls.next.remove();
      }
      if (slider.controls.prev) {
        slider.controls.prev.remove();
      }
      if (slider.pagerEl && slider.settings.controls && !slider.settings.pagerCustom) {
        slider.pagerEl.remove();
      }
      $('.bx-caption', this).remove();
      if (slider.controls.autoEl) {
        slider.controls.autoEl.remove();
      }
      clearInterval(slider.interval);
      if (slider.settings.responsive) {
        $(window).off('resize', _resizeWindow);
      }
      if (slider.settings.keyboardEnabled) {
        $(document).off('keydown', keyPress);
      }
      //remove self reference in data
      $(this).removeData('bxSlider');
      // remove global window handlers
      $(window).off('blur', windowBlurHandler).off('focus', windowFocusHandler);
    };

    /**
     * Reload the slider (revert all DOM changes, and re-initialize)
     */
    el.reloadSlider = function (settings) {
      if (settings !== undefined) {
        options = settings;
      }
      el.destroySlider();
      init();
      //store reference to self in order to access public functions later
      $(el).data('bxSlider', this);
    };
    init();
    $(el).data('bxSlider', this);

    // returns the current jQuery object
    return this;
  };
})(jQuery);
/*! Swipebox v1.4.4 | Constantin Saguin csag.co | MIT License | github.com/brutaldesign/swipebox */
"use strict";!function(a,b,c,d){c.swipebox=function(e,f){var g=void 0,h={useCSS:!0,useSVG:!0,initialIndexOnArray:0,removeBarsOnMobile:!0,hideCloseButtonOnMobile:!1,hideBarsDelay:3e3,videoMaxWidth:1140,vimeoColor:"cccccc",beforeOpen:null,afterOpen:null,afterClose:null,afterMedia:null,nextSlide:null,prevSlide:null,loopAtEnd:!0,autoplayVideos:!1,queryStringData:{},toggleClassOnLoad:""},i=this,j=[],k=void 0,l=e.selector,m=navigator.userAgent.match(/(iPad)|(iPhone)|(iPod)|(Android)|(PlayBook)|(BB10)|(BlackBerry)|(Opera Mini)|(IEMobile)|(webOS)|(MeeGo)/i),n=null!==m||b.createTouch!==d||"ontouchstart"in a||"onmsgesturechange"in a||navigator.msMaxTouchPoints,o=!!b.createElementNS&&!!b.createElementNS("http://www.w3.org/2000/svg","svg").createSVGRect,p=a.innerWidth?a.innerWidth:c(a).width(),q=a.innerHeight?a.innerHeight:c(a).height(),r=0;i.settings={},c.swipebox.close=function(){g.closeSlide()},c.swipebox.extend=function(){return g},i.init=function(){i.settings=c.extend({},h,f),c.isArray(e)?(j=e,g.target=c(a),g.init(i.settings.initialIndexOnArray)):c(b).on("click",l,function(a){if("slide current"===a.target.parentNode.className)return!1;c.isArray(e)||(g.destroy(),k=c(l),g.actions()),j=[];var b=void 0,d=void 0,f=void 0;f||(d="data-rel",f=c(this).attr(d)),f||(d="rel",f=c(this).attr(d)),k=f&&""!==f&&"nofollow"!==f?c(l).filter("["+d+'="'+f+'"]'):c(l),k.each(function(){var a=null,b=null;c(this).attr("title")&&(a=c(this).attr("title")),c(this).attr("href")&&(b=c(this).attr("href")),j.push({href:b,title:a})}),b=k.index(c(this)),a.preventDefault(),a.stopPropagation(),g.target=c(a.target),g.init(b)})},g={init:function(a){i.settings.beforeOpen&&i.settings.beforeOpen(),this.target.trigger("swipebox-start"),c.swipebox.isOpen=!0,this.build(),this.openSlide(a),this.openMedia(a),this.preloadMedia(a+1),this.preloadMedia(a-1),i.settings.afterOpen&&i.settings.afterOpen(a)},build:function(){var a=this,b=void 0;c("body").append('<div id="swipebox-overlay">\t\t\t\t\t<div id="swipebox-container">\t\t\t\t\t\t<div id="swipebox-slider"></div>\t\t\t\t\t\t<div id="swipebox-top-bar">\t\t\t\t\t\t\t<div id="swipebox-title"></div>\t\t\t\t\t\t</div>\t\t\t\t\t\t<div id="swipebox-bottom-bar">\t\t\t\t\t\t\t<div id="swipebox-arrows">\t\t\t\t\t\t\t\t<a id="swipebox-prev"></a>\t\t\t\t\t\t\t\t<span id="swipebox-counter"></span>\t\t\t\t\t\t\t\t<a id="swipebox-next"></a>\t\t\t\t\t\t\t</div>\t\t\t\t\t\t</div>\t\t\t\t\t\t<a id="swipebox-close"></a>\t\t\t\t\t</div>\t\t\t</div>'),o&&!0===i.settings.useSVG&&(b=c("#swipebox-close").css("background-image"),b=b.replace("png","svg"),c("#swipebox-prev, #swipebox-next, #swipebox-close").css({"background-image":b})),m&&i.settings.removeBarsOnMobile&&(c("#swipebox-bottom-bar, #swipebox-top-bar").remove(),c("#swipebox-container").append('<div style="position: absolute; bottom: 0" id="swipebox-arrows">              <span id="swipebox-counter"></span>            </div>          ')),c.each(j,function(){c("#swipebox-slider").append('<div class="slide"></div>')}),a.setDim(),a.actions(),n&&a.gesture(),a.keyboard(),a.animBars(),a.resize()},setDim:function(){var b=void 0,d=void 0,e=void 0;"onorientationchange"in a?a.addEventListener("orientationchange",function(){0===a.orientation?(b=p,d=q):90!==a.orientation&&-90!==a.orientation||(b=q,d=p)},!1):(b=a.innerWidth?a.innerWidth:c(a).width(),d=a.innerHeight?a.innerHeight:c(a).height()),e={width:b,height:d},c("#swipebox-overlay").css(e)},resize:function(){var b=this;c(a).resize(function(){b.setDim()}).resize()},supportTransition:function(){var a="transition WebkitTransition MozTransition OTransition msTransition KhtmlTransition".split(" "),c=void 0;for(c=0;c<a.length;c++)if(b.createElement("div").style[a[c]]!==d)return a[c];return!1},doCssTrans:function(){if(i.settings.useCSS&&this.supportTransition())return!0},gesture:function(){var a=this,b=void 0,d=void 0,e=void 0,f=void 0,g=void 0,h=void 0,i=!1,k=!1,l=10,m=50,n={},o={},q=c("#swipebox-top-bar, #swipebox-bottom-bar"),s=c("#swipebox-slider");q.addClass("visible-bars"),a.setTimeout(),c("body").bind("touchstart",function(a){c(this).addClass("touching");var q=c("#swipebox-slider");return b=q.find(".slide").index(q.find(".slide.current")),o=a.originalEvent.targetTouches[0],n.pageX=a.originalEvent.targetTouches[0].pageX,n.pageY=a.originalEvent.targetTouches[0].pageY,q.css({"-webkit-transform":"translate3d("+r+"%, 0, 0)",transform:"translate3d("+r+"%, 0, 0)"}),c(".touching").bind("touchmove",function(a){if(a.preventDefault(),a.stopPropagation(),o=a.originalEvent.targetTouches[0],!k&&(g=e,e=o.pageY-n.pageY,Math.abs(e)>=m||i)){var q=.75-Math.abs(e)/s.height();s.css({top:e+"px"}),s.css({opacity:q}),i=!0}f=d,d=o.pageX-n.pageX,h=100*d/p,!k&&!i&&Math.abs(d)>=l&&(c("#swipebox-slider").css({"-webkit-transition":"",transition:""}),k=!0),k&&(0<d?0===b?c("#swipebox-overlay").addClass("leftSpringTouch"):(c("#swipebox-overlay").removeClass("leftSpringTouch").removeClass("rightSpringTouch"),c("#swipebox-slider").css({"-webkit-transform":"translate3d("+(r+h)+"%, 0, 0)",transform:"translate3d("+(r+h)+"%, 0, 0)"})):0>d&&(j.length===b+1?c("#swipebox-overlay").addClass("rightSpringTouch"):(c("#swipebox-overlay").removeClass("leftSpringTouch").removeClass("rightSpringTouch"),c("#swipebox-slider").css({"-webkit-transform":"translate3d("+(r+h)+"%, 0, 0)",transform:"translate3d("+(r+h)+"%, 0, 0)"}))))}),!1}).bind("touchend",function(b){if(b.preventDefault(),b.stopPropagation(),c("#swipebox-slider").css({"-webkit-transition":"-webkit-transform 0.4s ease",transition:"transform 0.4s ease"}),e=o.pageY-n.pageY,d=o.pageX-n.pageX,h=100*d/p,i)if(i=!1,Math.abs(e)>=2*m&&Math.abs(e)>Math.abs(g)){var j=e>0?s.height():-s.height();s.animate({top:j+"px",opacity:0},300,function(){a.closeSlide()})}else s.animate({top:0,opacity:1},300);else k?(k=!1,d>=l&&d>=f?a.getPrev():d<=-l&&d<=f&&a.getNext()):q.hasClass("visible-bars")?(a.clearTimeout(),a.hideBars()):(a.showBars(),a.setTimeout());c("#swipebox-slider").css({"-webkit-transform":"translate3d("+r+"%, 0, 0)",transform:"translate3d("+r+"%, 0, 0)"}),c("#swipebox-overlay").removeClass("leftSpringTouch").removeClass("rightSpringTouch"),c(".touching").off("touchmove").removeClass("touching")})},setTimeout:function(){if(i.settings.hideBarsDelay>0){var b=this;b.clearTimeout(),b.timeout=a.setTimeout(function(){b.hideBars()},i.settings.hideBarsDelay)}},clearTimeout:function(){a.clearTimeout(this.timeout),this.timeout=null},showBars:function(){var a=c("#swipebox-top-bar, #swipebox-bottom-bar");this.doCssTrans()?a.addClass("visible-bars"):(c("#swipebox-top-bar").animate({top:0},500),c("#swipebox-bottom-bar").animate({bottom:0},500),setTimeout(function(){a.addClass("visible-bars")},1e3))},hideBars:function(){var a=c("#swipebox-top-bar, #swipebox-bottom-bar");this.doCssTrans()?a.removeClass("visible-bars"):(c("#swipebox-top-bar").animate({top:"-50px"},500),c("#swipebox-bottom-bar").animate({bottom:"-50px"},500),setTimeout(function(){a.removeClass("visible-bars")},1e3))},animBars:function(){var a=this,b=c("#swipebox-top-bar, #swipebox-bottom-bar");b.addClass("visible-bars"),a.setTimeout(),c("#swipebox-slider").click(function(){b.hasClass("visible-bars")||(a.showBars(),a.setTimeout())}),c("#swipebox-bottom-bar").hover(function(){a.showBars(),b.addClass("visible-bars"),a.clearTimeout()},function(){i.settings.hideBarsDelay>0&&(b.removeClass("visible-bars"),a.setTimeout())})},keyboard:function(){var b=this;c(a).bind("keyup",function(a){a.preventDefault(),a.stopPropagation(),37===a.keyCode?b.getPrev():39===a.keyCode?b.getNext():27===a.keyCode&&b.closeSlide()})},actions:function(){var a=this,b="touchend click";j.length<2?(c("#swipebox-bottom-bar").hide(),d===j[1]&&c("#swipebox-top-bar").hide()):(c("#swipebox-prev").bind(b,function(b){b.preventDefault(),b.stopPropagation(),a.getPrev(),a.setTimeout()}),c("#swipebox-next").bind(b,function(b){b.preventDefault(),b.stopPropagation(),a.getNext(),a.setTimeout()})),m||c("#swipebox-container").bind(b,function(b){b.preventDefault(),b.stopPropagation(),b.target.className.includes("current")&&a.closeSlide()}),c("#swipebox-close").bind(b,function(b){b.preventDefault(),b.stopPropagation(),a.closeSlide()})},setSlide:function(a,b){b=b||!1;var d=c("#swipebox-slider");r=100*-a,this.doCssTrans()?d.css({"-webkit-transform":"translate3d("+100*-a+"%, 0, 0)",transform:"translate3d("+100*-a+"%, 0, 0)"}):d.animate({left:100*-a+"%"}),c("#swipebox-slider").find(".slide").removeClass("current"),c("#swipebox-slider").find(".slide").eq(a).addClass("current"),this.setTitle(a),b&&d.fadeIn(),this.setCount(a),c("#swipebox-prev, #swipebox-next").removeClass("disabled"),0===a||a===j.length-1&&!0!==i.settings.loopAtEnd&&c("#swipebox-next").addClass("disabled")},openSlide:function(b){c("html").addClass("swipebox-html"),n?(c("html").addClass("swipebox-touch"),i.settings.hideCloseButtonOnMobile&&c("html").addClass("swipebox-no-close-button")):c("html").addClass("swipebox-no-touch"),c(a).trigger("resize"),this.setSlide(b,!0)},preloadMedia:function(a){var b=this,c=null;j[a]!==d&&(c=j[a].href),b.isVideo(c)?b.openMedia(a):setTimeout(function(){b.openMedia(a)},1e3)},openMedia:function(a){var e=this,f=void 0,g=void 0;if(j[a]!==d&&j[a].href!==d&&(f=j[a].href),j[a]!==d&&j[a].src!==d&&(f=j[a].src),j[a]!==d&&e.isIframe(j[a])&&(f=j[a]),a<0||a>=j.length)return!1;if(g=c("#swipebox-slider").find(".slide").eq(a),e.isIframe(f)){var h=b.createElement("html");h.innerHTML=f,h.querySelector("div").style.padding="5px 0",h.querySelector("div").style.lineHeight=1,f=String(h.innerHTML),g.html(f),i.settings.afterMedia&&i.settings.afterMedia(a)}else e.isVideo(f)?(g.html(e.getVideo(f)),i.settings.afterMedia&&i.settings.afterMedia(a)):(g.addClass("slide-loading"),e.loadMedia(f,function(){g.removeClass("slide-loading"),g.html(this),i.settings.afterMedia&&i.settings.afterMedia(a)}))},setTitle:function(a){var b=null;j.length,c("#swipebox-title").empty(),j[a]!==d&&(b=j[a].title),b?(c("#swipebox-top-bar").show(),c("#swipebox-title").append(b)):c("#swipebox-top-bar").hide()},setCount:function(a){var b=c("#swipebox-counter");b.empty();var d=j.length;if(d>1){var e=a+1,f=e+"/"+d;b.append(f)}},isIframe:function(a){return!(!a||"string"!=typeof a)&&(!!a.includes("<iframe")||void 0)},isVideo:function(a){if(a){if(a.match(/(youtube\.com|youtube-nocookie\.com)\/watch\?v=([a-zA-Z0-9\-_]+)/)||a.match(/vimeo\.com\/([0-9]*)/)||a.match(/youtu\.be\/([a-zA-Z0-9\-_]+)/)||a.match(/(youtube\.com\/embed\/)([a-zA-Z0-9\-_]+)/)||a.match(/(?:uvp\.)?apa\.at\/embed\/([0-9]*)/)||a.match(/(?:uvp\.)/))return!0;if(a.toLowerCase().indexOf("swipeboxvideo=1")>=0)return!0}},parseUri:function(a,d){var e=b.createElement("a"),f={};return e.href=decodeURIComponent(a),e.search&&(f=JSON.parse('{"'+e.search.toLowerCase().replace("?","").replace(/&/g,'","').replace(/=/g,'":"')+'"}')),c.isPlainObject(d)&&(f=c.extend(f,d,i.settings.queryStringData)),c.map(f,function(a,b){if(a&&a>"")return encodeURIComponent(b)+"="+encodeURIComponent(a)}).join("&")},getVideo:function(a){var b="",c=!1,d=a.match(/((?:www\.)?youtube\.com|(?:www\.)?youtube-nocookie\.com)\/watch\?v=([a-zA-Z0-9\-_]+)/),e=a.match(/(?:www\.)?youtu\.be\/([a-zA-Z0-9\-_]+)/),f=a.match(/(?:www\.)?vimeo\.com\/([0-9]*)/),h=void 0,j="";if(a.includes("uvp")&&(h=a),a.match(/(youtube\.com\/embed\/)([a-zA-Z0-9\-_]+)/)&&(c=a.match(/(youtube\.com\/embed\/)([a-zA-Z0-9\-_]+)/)),d||e||c)e&&(d=e),j=g.parseUri(a,{autoplay:i.settings.autoplayVideos?"1":"0",v:""}),b=c?'<iframe src="//'+c[0]+"?"+j+'" frameborder="0" allowfullscreen></iframe>':e?'<iframe src="//youtube.com/embed/'+e[1]+"?"+j+'" frameborder="0" allowfullscreen></iframe>':'<iframe src="//'+d[1]+"/embed/"+d[2]+"?"+j+'" frameborder="0" allowfullscreen></iframe>';else if(f)j=g.parseUri(a,{autoplay:i.settings.autoplayVideos?"1":"0",byline:"0",portrait:"0",color:i.settings.vimeoColor}),b='<iframe src="//player.vimeo.com/video/'+f[1]+"?"+j+'" frameborder="0" webkitAllowFullScreen mozallowfullscreen allowFullScreen></iframe>';else{if(!h)return'<div class="vodl-lightbox__container"><div class="vodl-lightbox__video">'+(b='<iframe class="vodl-lightbox__iframe" src="'+a+'" frameborder="0" allowfullscreen></iframe>')+"</div></div>";j=g.parseUri(a,{autoplay:i.settings.autoplayVideos?"1":"0"}),b='<iframe  src="'+h+'?autoplay=1"></iframe>'}return'<div class="swipebox-video-container" style="max-width:'+i.settings.videoMaxWidth+'px"><div class="swipebox-video">'+b+"</div></div>"},loadMedia:function(a,b){if(0===a.trim().indexOf("#"))b.call(c("<div>",{class:"swipebox-inline-container"}).append(c(a).clone().toggleClass(i.settings.toggleClassOnLoad)));else if(!this.isVideo(a)){var d=c("<img>").on("load",function(){b.call(d)});d.attr("src",a)}},getNext:function(){var a=this,b=void 0,d=c("#swipebox-slider .slide").index(c("#swipebox-slider .slide.current"));d+1<j.length?(b=c("#swipebox-slider .slide").eq(d).contents().find("iframe").attr("src"),c("#swipebox-slider .slide").eq(d).contents().find("iframe").attr("src",b),d++,a.setSlide(d),a.preloadMedia(d+1),i.settings.nextSlide&&i.settings.nextSlide(d)):!0===i.settings.loopAtEnd?(b=c("#swipebox-slider .slide").eq(d).contents().find("iframe").attr("src"),c("#swipebox-slider .slide").eq(d).contents().find("iframe").attr("src",b),d=0,a.preloadMedia(d),a.setSlide(d),a.preloadMedia(d+1),i.settings.nextSlide&&i.settings.nextSlide(d)):(c("#swipebox-overlay").addClass("rightSpring"),setTimeout(function(){c("#swipebox-overlay").removeClass("rightSpring")},500))},getPrev:function(){var a=void 0,b=c("#swipebox-slider .slide").index(c("#swipebox-slider .slide.current"));b>0?(c("#swipebox-slider .slide"),a=c("#swipebox-slider .slide").eq(b).contents().find("iframe").attr("src"),c("#swipebox-slider .slide").eq(b).contents().find("iframe").attr("src",a),b--,this.setSlide(b),this.preloadMedia(b-1),i.settings.prevSlide&&i.settings.prevSlide(b)):0===b&&!0===i.settings.loopAtEnd&&(c("#swipebox-slider .slide"),a=c("#swipebox-slider .slide").eq(b).contents().find("iframe").attr("src"),c("#swipebox-slider .slide").eq(b).contents().find("iframe").attr("src",a),b=j.length-1,this.preloadMedia(b),this.setSlide(b),this.preloadMedia(b-1),i.settings.prevSlide&&i.settings.prevSlide(b))},nextSlide:function(a){},prevSlide:function(a){},closeSlide:function(){var b=c("html");b.removeClass("swipebox-html"),b.removeClass("swipebox-touch"),c(a).trigger("resize"),this.destroy()},destroy:function(){var b=c("body");c(a).unbind("keyup"),b.unbind("touchstart"),b.unbind("touchmove"),b.unbind("touchend"),c("#swipebox-slider").unbind(),c("#swipebox-overlay").remove(),c.isArray(e)||e.removeData("_swipebox"),this.target&&this.target.trigger("swipebox-destroy"),c.swipebox.isOpen=!1,i.settings.afterClose&&i.settings.afterClose()}},i.init()},c.fn.swipebox=function(a){if(!c.data(this,"_swipebox")){var b=new c.swipebox(this,a);this.data("_swipebox",b)}return this.data("_swipebox")}}(window,document,jQuery);
"use strict";

(function (window, document, undefined) {
  'use strict';

  var bgsng = window.Bugsnag || false,
    bgsngEnabled = false,
    bgsngOptions = window.bugsnagOptions || false;

  /**
   * Setup and start Bugsnag
   */
  function init() {
    if (!bgsng || !bgsngOptions) {
      return;
    }

    // Some options from our settings:
    bgsngOptions.apiKey = bgsngOptions.apiKey || false; // required
    bgsngOptions.appVersion = bgsngOptions.appVersion || 'unknown'; // optional
    bgsngOptions.releaseStage = bgsngOptions.releaseStage || 'production'; // optional

    // Required options must be set!
    if (!bgsngOptions.apiKey) {
      return;
    }

    // Some defaults
    bgsngOptions.appType = 'client';
    bgsngOptions.autoDetectErrors = false;

    // Finally we can start bugsnag
    bgsng.start(bgsngOptions);
    bgsngEnabled = true;
  }
  ;

  /**
   * The logging function itself wraps bgsng.notify()
   * and is exposed via window.RussMedia.Bugsnag below.
   *
   * @param  {Error}  error       Error object.
   * @param  {Object} diagnostics Optional diagnostic data, like severity, context and metadata.
   */
  function doLog(error, diagnostics) {
    if (!bgsngEnabled) {
      return;
    }
    diagnostics = diagnostics || {};
    bgsng.notify(error, function (event) {
      event.severity = diagnostics.severity || event.severity;
      event.context = diagnostics.context || event.context;
      if (diagnostics.metaData && Array.isArray(diagnostics.metaData)) {
        diagnostics.metaData.forEach(function (element) {
          if (element.name && element.data) {
            event.addMetadata(element.name, element.data);
          }
        });
      }
    });
  }
  init();
  window.RussMedia = window.RussMedia || {};
  window.RussMedia.Bugsnag = window.RussMedia.Bugsnag || {};
  $.extend(window.RussMedia.Bugsnag, {
    doLog: doLog
  });
})(window, document);
"use strict";

(function (window, document, undefined) {
  'use strict';

  var images = window.document.querySelectorAll('.vodl-lzld');
  var config = {
    rootMargin: '300px 0px',
    threshold: 0.01
  };
  var observer;
  var onIntersection = function onIntersection(entries) {
    entries.forEach(function (entry) {
      if (entry.intersectionRatio > 0) {
        // Stop watching and load the image
        observer.unobserve(entry.target);
        // call our method: preloadImage
        preloadImage(entry.target);
      }
    });
  };

  // Replace the data-src attribute with the value of the data-src attribute
  var preloadImage = function preloadImage(element) {
    var source = element.previousElementSibling !== null && element.previousElementSibling.tagName === 'SOURCE' ? element.previousElementSibling : undefined;
    if (element.dataset && element.dataset.src) {
      if (source !== undefined && source.dataset.src !== undefined) {
        source.src = source.dataset.src;
        delete source.dataset.src;
      }
      element.src = element.dataset.src;
      element.classList.remove('vodl-lzld');
      delete element.dataset.src;
    }
    if (element.dataset && element.dataset.srcset) {
      if (source !== undefined) {
        source.srcset = source.dataset.srcset;
        delete source.dataset.srcset;
      }
      element.srcset = element.dataset.srcset;
      element.classList.remove('vodl-lzld');
      delete element.dataset.srcset;
    }
    if (element.dataset && element.dataset.style) {
      if (source !== undefined) {
        source.style = source.dataset.style;
        delete source.dataset.style;
      }
      element.setAttribute('style', element.dataset.style);
      element.classList.remove('vodl-lzld');
      delete element.dataset.style;
    }
    // Support for <video><source...><source...></video> elements
    if (element.tagName === 'VIDEO') {
      var targets = element.querySelectorAll('source') || false;
      if (targets) {
        targets.forEach(function (target) {
          if (target && target.dataset.src) {
            target.src = target.dataset.src;
            delete target.dataset.src;
          }
        });
      }
      element.load();
      element.classList.remove('vodl-lzld');
    }
  };
  var addNewImagesToObserver = function addNewImagesToObserver() {
    images = window.document.querySelectorAll('.vodl-lzld');
    if (images.length > 0) {
      observer.disconnect();
      images.forEach(function (image) {
        observer.observe(image);
      });
    }
  };
  window.addEventListener('newPage', addNewImagesToObserver);
  window.addEventListener('vodl_lazyload_images', addNewImagesToObserver);

  // If we don't have support for intersection observer, load the images immediately
  if (!('IntersectionObserver' in window)) {
    Array.from(images).forEach(function (image) {
      return preloadImage(image);
    });
  } else {
    // It is supported, load the images by calling our method: onIntersection
    observer = new IntersectionObserver(onIntersection, config);
    images.forEach(function (image) {
      observer.observe(image);
    });
  }
  ;
})(window, document);
"use strict";

(function (window, document, undefined) {
  'use strict';

  var console = window.console || {
    log: function log() {}
  };

  // We cannot be sure that this is defined yet.
  window.RussMedia = window.RussMedia || {};
  window.RussMedia.Utils = window.RussMedia.Utils || {};

  /**
   * A wrapper for console.log()
   */
  window.RussMedia.Utils.Logger = function (prefix) {
    // The name of the GET parameter that needs to be set to allow console.log()
    this.verboseParam = 'verbose',
    // A string that may be used as a marker in front of the console.log() output (info emoji by default)
    this.loggerPrefix = prefix || String.fromCodePoint(0x2139);

    /**
     * Retrieves a GET parameter with the given name in the current URL.
     *
     */
    this.getUrlParam = function (name) {
      name = name.replace(/[\[]/, '\\\[').replace(/[\]]/, '\\\]');
      var regexString = '[\\?&]' + name + '=([^&#]*)';
      var regex = new RegExp(regexString);
      var results = regex.exec(window.location.href);
      if (results == null) {
        return null;
      } else {
        return results[1];
      }
    };
  };

  /**
   * Do a console.log() with any number of passed arguments,
   * but only if this.verboseParam is set to a non-falsy value in the current window.location.href
   */
  window.RussMedia.Utils.Logger.prototype.log = function () {
    if (0 === arguments.length) {
      return; // nothing to do.
    }
    if (!this.getUrlParam(this.verboseParam)) {
      return;
    }

    // Add our prefix.
    var args = Array.prototype.slice.call(arguments);
    args.unshift(this.loggerPrefix);
    console.log.apply(console, args);
  };
})(window, document);
"use strict";

var _excluded = ["window"];
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n4 = 0, F = function F() {}; return { s: F, n: function n() { return _n4 >= r.length ? { done: !0 } : { done: !1, value: r[_n4++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
(function (O, t) {
  (typeof exports === "undefined" ? "undefined" : _typeof(exports)) == "object" && (typeof module === "undefined" ? "undefined" : _typeof(module)) < "u" ? t(exports, require("vue")) : typeof define == "function" && define.amd ? define(["exports", "vue"], t) : (O = (typeof globalThis === "undefined" ? "undefined" : _typeof(globalThis)) < "u" ? globalThis : O || self, t(O["@russmedia-frontend/np-common"] = {}, O.Vue));
})(void 0, function (O, t) {
  "use strict";

  var es = {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  };
  function ts(i, e) {
    return t.openBlock(), t.createElementBlock("svg", es, e[0] || (e[0] = [t.createElementVNode("rect", {
      y: "0.000732422",
      width: "24",
      height: "24",
      rx: "4",
      fill: "currentColor"
    }, null, -1), t.createElementVNode("path", {
      d: "M15 13.0671V11.9372H16.8956V10.0007H18.1067V11.9358H20V13.0657H18.1067V15.0007H16.8956V13.0657L15 13.0671Z",
      fill: "white"
    }, null, -1), t.createElementVNode("path", {
      d: "M7.69288 8.00073L9.99339 13.4793L12.3071 8.00073H15L10.9801 17.0007H9.00758L5 8.00073H7.69288Z",
      fill: "white"
    }, null, -1)]));
  }
  var ft = {
    render: ts
  };
  function Pe(i) {
    return t.getCurrentScope() ? (t.onScopeDispose(i), !0) : !1;
  }
  function ut() {
    var i = new Set(),
      e = function e(a) {
        i["delete"](a);
      };
    return {
      on: function on(a) {
        i.add(a);
        var o = function o() {
          return e(a);
        };
        return Pe(o), {
          off: o
        };
      },
      off: e,
      trigger: function trigger() {
        for (var _len = arguments.length, a = new Array(_len), _key = 0; _key < _len; _key++) {
          a[_key] = arguments[_key];
        }
        return Promise.all(Array.from(i).map(function (o) {
          return o.apply(void 0, a);
        }));
      },
      clear: function clear() {
        i.clear();
      }
    };
  }
  var mt = new WeakMap(),
    is = function is() {
      var e;
      var s = arguments.length <= 0 ? undefined : arguments[0],
        n = (e = t.getCurrentInstance()) == null ? void 0 : e.proxy;
      if (n == null && !t.hasInjectionContext()) throw new Error("injectLocal must be called in setup");
      return n && mt.has(n) && s in mt.get(n) ? mt.get(n)[s] : t.inject.apply(t, arguments);
    },
    _e = (typeof window === "undefined" ? "undefined" : _typeof(window)) < "u" && (typeof document === "undefined" ? "undefined" : _typeof(document)) < "u";
  (typeof WorkerGlobalScope === "undefined" ? "undefined" : _typeof(WorkerGlobalScope)) < "u" && globalThis instanceof WorkerGlobalScope;
  var ss = Object.prototype.toString,
    ns = function ns(i) {
      return ss.call(i) === "[object Object]";
    },
    re = function re() {},
    rs = as();
  function as() {
    var i, e;
    return _e && ((i = window == null ? void 0 : window.navigator) == null ? void 0 : i.userAgent) && (/iP(?:ad|hone|od)/.test(window.navigator.userAgent) || ((e = window == null ? void 0 : window.navigator) == null ? void 0 : e.maxTouchPoints) > 2 && /iPad|Macintosh/.test(window == null ? void 0 : window.navigator.userAgent));
  }
  function Ye() {
    if (arguments.length !== 1) return t.toRef.apply(t, arguments);
    var e = arguments.length <= 0 ? undefined : arguments[0];
    return typeof e == "function" ? t.readonly(t.customRef(function () {
      return {
        get: e,
        set: re
      };
    })) : t.ref(e);
  }
  function ls(i, e) {
    function s() {
      var _this = this;
      for (var _len2 = arguments.length, n = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        n[_key2] = arguments[_key2];
      }
      return new Promise(function (r, a) {
        Promise.resolve(i(function () {
          return e.apply(_this, n);
        }, {
          fn: e,
          thisArg: _this,
          args: n
        })).then(r)["catch"](a);
      });
    }
    return s;
  }
  function os(i) {
    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var s,
      n,
      r = re;
    var a = function a(l) {
      clearTimeout(l), r(), r = re;
    };
    var o;
    return function (l) {
      var d = t.toValue(i),
        f = t.toValue(e.maxWait);
      return s && a(s), d <= 0 || f !== void 0 && f <= 0 ? (n && (a(n), n = null), Promise.resolve(l())) : new Promise(function (h, v) {
        r = e.rejectOnCancel ? v : h, o = l, f && !n && (n = setTimeout(function () {
          s && a(s), n = null, h(o());
        }, f)), s = setTimeout(function () {
          n && a(n), n = null, h(l());
        }, d);
      });
    };
  }
  function Gt(i) {
    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
    var s = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "Timeout";
    return new Promise(function (n, r) {
      setTimeout(e ? function () {
        return r(s);
      } : n, i);
    });
  }
  function cs(i) {
    for (var _len3 = arguments.length, e = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
      e[_key3 - 1] = arguments[_key3];
    }
    return e.some(function (s) {
      return s in i;
    });
  }
  function ds(i, e) {
    var s;
    if (typeof i == "number") return i + e;
    var n = ((s = i.match(/^-?\d+\.?\d*/)) == null ? void 0 : s[0]) || "",
      r = i.slice(n.length),
      a = Number.parseFloat(n) + e;
    return Number.isNaN(a) ? i : a + r;
  }
  function $e(i) {
    return i.endsWith("rem") ? Number.parseFloat(i) * 16 : Number.parseFloat(i);
  }
  function ht(i) {
    return Array.isArray(i) ? i : [i];
  }
  function Yt(i) {
    return t.getCurrentInstance();
  }
  function ps(i) {
    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 200;
    var s = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    return ls(os(e, s), i);
  }
  function Xt(i) {
    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
    var s = arguments.length > 2 ? arguments[2] : undefined;
    Yt() ? t.onMounted(i, s) : e ? i() : t.nextTick(i);
  }
  function fs(i, e) {
    Yt() && t.onUnmounted(i, e);
  }
  function gt(i) {
    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
    function s(h) {
      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref$flush = _ref.flush,
        v = _ref$flush === void 0 ? "sync" : _ref$flush,
        _ref$deep = _ref.deep,
        m = _ref$deep === void 0 ? !1 : _ref$deep,
        p = _ref.timeout,
        u = _ref.throwOnTimeout;
      var b = null;
      var g = [new Promise(function (w) {
        b = t.watch(i, function (y) {
          h(y) !== e && (b ? b() : t.nextTick(function () {
            return b == null ? void 0 : b();
          }), w(y));
        }, {
          flush: v,
          deep: m,
          immediate: !0
        });
      })];
      return p != null && g.push(Gt(p, u).then(function () {
        return t.toValue(i);
      })["finally"](function () {
        return b == null ? void 0 : b();
      })), Promise.race(g);
    }
    function n(h, v) {
      if (!t.isRef(h)) return s(function (y) {
        return y === h;
      }, v);
      var _ref2 = v !== null && v !== void 0 ? v : {},
        _ref2$flush = _ref2.flush,
        m = _ref2$flush === void 0 ? "sync" : _ref2$flush,
        _ref2$deep = _ref2.deep,
        p = _ref2$deep === void 0 ? !1 : _ref2$deep,
        u = _ref2.timeout,
        b = _ref2.throwOnTimeout;
      var C = null;
      var w = [new Promise(function (y) {
        C = t.watch([i, h], function (_ref3) {
          var _ref4 = _slicedToArray(_ref3, 2),
            x = _ref4[0],
            T = _ref4[1];
          e !== (x === T) && (C ? C() : t.nextTick(function () {
            return C == null ? void 0 : C();
          }), y(x));
        }, {
          flush: m,
          deep: p,
          immediate: !0
        });
      })];
      return u != null && w.push(Gt(u, b).then(function () {
        return t.toValue(i);
      })["finally"](function () {
        return C == null || C(), t.toValue(i);
      })), Promise.race(w);
    }
    function r(h) {
      return s(function (v) {
        return !!v;
      }, h);
    }
    function a(h) {
      return n(null, h);
    }
    function o(h) {
      return n(void 0, h);
    }
    function c(h) {
      return s(Number.isNaN, h);
    }
    function l(h, v) {
      return s(function (m) {
        var p = Array.from(m);
        return p.includes(h) || p.includes(t.toValue(h));
      }, v);
    }
    function d(h) {
      return f(1, h);
    }
    function f() {
      var h = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      var v = arguments.length > 1 ? arguments[1] : undefined;
      var m = -1;
      return s(function () {
        return m += 1, m >= h;
      }, v);
    }
    return Array.isArray(t.toValue(i)) ? {
      toMatch: s,
      toContains: l,
      changed: d,
      changedTimes: f,
      get not() {
        return gt(i, !e);
      }
    } : {
      toMatch: s,
      toBe: n,
      toBeTruthy: r,
      toBeNull: a,
      toBeNaN: c,
      toBeUndefined: o,
      changed: d,
      changedTimes: f,
      get not() {
        return gt(i, !e);
      }
    };
  }
  function us(i) {
    return gt(i);
  }
  function Ut(i, e) {
    var s = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var _s$immediate = s.immediate,
      n = _s$immediate === void 0 ? !0 : _s$immediate,
      _s$immediateCallback = s.immediateCallback,
      r = _s$immediateCallback === void 0 ? !1 : _s$immediateCallback,
      a = t.shallowRef(!1);
    var o = null;
    function c() {
      o && (clearTimeout(o), o = null);
    }
    function l() {
      a.value = !1, c();
    }
    function d() {
      for (var _len4 = arguments.length, f = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        f[_key4] = arguments[_key4];
      }
      r && i(), c(), a.value = !0, o = setTimeout(function () {
        a.value = !1, o = null, i.apply(void 0, f);
      }, t.toValue(e));
    }
    return n && (a.value = !0, _e && d()), Pe(l), {
      isPending: t.readonly(a),
      start: d,
      stop: l
    };
  }
  function ms(i, e, s) {
    return t.watch(i, e, _objectSpread(_objectSpread({}, s), {}, {
      immediate: !0
    }));
  }
  var Ee = _e ? window : void 0,
    hs = _e ? window.document : void 0;
  function we(i) {
    var e;
    var s = t.toValue(i);
    return (e = s == null ? void 0 : s.$el) != null ? e : s;
  }
  function ae() {
    for (var _len5 = arguments.length, i = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
      i[_key5] = arguments[_key5];
    }
    var e = [],
      s = function s() {
        e.forEach(function (c) {
          return c();
        }), e.length = 0;
      },
      n = function n(c, l, d, f) {
        return c.addEventListener(l, d, f), function () {
          return c.removeEventListener(l, d, f);
        };
      },
      r = t.computed(function () {
        var c = ht(t.toValue(i[0])).filter(function (l) {
          return l != null;
        });
        return c.every(function (l) {
          return typeof l != "string";
        }) ? c : void 0;
      }),
      a = ms(function () {
        var c, l;
        return [(l = (c = r.value) == null ? void 0 : c.map(function (d) {
          return we(d);
        })) != null ? l : [Ee].filter(function (d) {
          return d != null;
        }), ht(t.toValue(r.value ? i[1] : i[0])), ht(t.unref(r.value ? i[2] : i[1])), t.toValue(r.value ? i[3] : i[2])];
      }, function (_ref5) {
        var _ref6 = _slicedToArray(_ref5, 4),
          c = _ref6[0],
          l = _ref6[1],
          d = _ref6[2],
          f = _ref6[3];
        if (s(), !(c != null && c.length) || !(l != null && l.length) || !(d != null && d.length)) return;
        var h = ns(f) ? _objectSpread({}, f) : f;
        e.push.apply(e, _toConsumableArray(c.flatMap(function (v) {
          return l.flatMap(function (m) {
            return d.map(function (p) {
              return n(v, m, p, h);
            });
          });
        })));
      }, {
        flush: "post"
      }),
      o = function o() {
        a(), s();
      };
    return Pe(s), o;
  }
  var qt = !1;
  function gs(i, e) {
    var s = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var _s$window = s.window,
      n = _s$window === void 0 ? Ee : _s$window,
      _s$ignore = s.ignore,
      r = _s$ignore === void 0 ? [] : _s$ignore,
      _s$capture = s.capture,
      a = _s$capture === void 0 ? !0 : _s$capture,
      _s$detectIframe = s.detectIframe,
      o = _s$detectIframe === void 0 ? !1 : _s$detectIframe,
      _s$controls = s.controls,
      c = _s$controls === void 0 ? !1 : _s$controls;
    if (!n) return c ? {
      stop: re,
      cancel: re,
      trigger: re
    } : re;
    if (rs && !qt) {
      qt = !0;
      var b = {
        passive: !0
      };
      Array.from(n.document.body.children).forEach(function (C) {
        return ae(C, "click", re, b);
      }), ae(n.document.documentElement, "click", re, b);
    }
    var l = !0;
    var d = function d(b) {
      return t.toValue(r).some(function (C) {
        if (typeof C == "string") return Array.from(n.document.querySelectorAll(C)).some(function (g) {
          return g === b.target || b.composedPath().includes(g);
        });
        {
          var g = we(C);
          return g && (b.target === g || b.composedPath().includes(g));
        }
      });
    };
    function f(b) {
      var C = t.toValue(b);
      return C && C.$.subTree.shapeFlag === 16;
    }
    function h(b, C) {
      var g = t.toValue(b),
        w = g.$.subTree && g.$.subTree.children;
      return w == null || !Array.isArray(w) ? !1 : w.some(function (y) {
        return y.el === C.target || C.composedPath().includes(y.el);
      });
    }
    var v = function v(b) {
      var C = we(i);
      if (b.target != null && !(!(C instanceof Element) && f(i) && h(i, b)) && !(!C || C === b.target || b.composedPath().includes(C))) {
        if ("detail" in b && b.detail === 0 && (l = !d(b)), !l) {
          l = !0;
          return;
        }
        e(b);
      }
    };
    var m = !1;
    var p = [ae(n, "click", function (b) {
        m || (m = !0, setTimeout(function () {
          m = !1;
        }, 0), v(b));
      }, {
        passive: !0,
        capture: a
      }), ae(n, "pointerdown", function (b) {
        var C = we(i);
        l = !d(b) && !!(C && !b.composedPath().includes(C));
      }, {
        passive: !0
      }), o && ae(n, "blur", function (b) {
        setTimeout(function () {
          var C;
          var g = we(i);
          ((C = n.document.activeElement) == null ? void 0 : C.tagName) === "IFRAME" && !(g != null && g.contains(n.document.activeElement)) && e(b);
        }, 0);
      }, {
        passive: !0
      })].filter(Boolean),
      u = function u() {
        return p.forEach(function (b) {
          return b();
        });
      };
    return c ? {
      stop: u,
      cancel: function cancel() {
        l = !1;
      },
      trigger: function trigger(b) {
        l = !0, v(b), l = !1;
      }
    } : u;
  }
  function ws() {
    var i = t.shallowRef(!1),
      e = t.getCurrentInstance();
    return e && t.onMounted(function () {
      i.value = !0;
    }, e), i;
  }
  function Kt(i) {
    var e = ws();
    return t.computed(function () {
      return e.value, !!i();
    });
  }
  var bs = Symbol("vueuse-ssr-width");
  function Jt() {
    var i = t.hasInjectionContext() ? is(bs, null) : null;
    return typeof i == "number" ? i : void 0;
  }
  function Ne(i) {
    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _e$window = e.window,
      s = _e$window === void 0 ? Ee : _e$window,
      _e$ssrWidth = e.ssrWidth,
      n = _e$ssrWidth === void 0 ? Jt() : _e$ssrWidth,
      r = Kt(function () {
        return s && "matchMedia" in s && typeof s.matchMedia == "function";
      }),
      a = t.shallowRef(typeof n == "number"),
      o = t.shallowRef(),
      c = t.shallowRef(!1),
      l = function l(d) {
        c.value = d.matches;
      };
    return t.watchEffect(function () {
      if (a.value) {
        a.value = !r.value;
        var d = t.toValue(i).split(",");
        c.value = d.some(function (f) {
          var h = f.includes("not all"),
            v = f.match(/\(\s*min-width:\s*(-?\d+(?:\.\d*)?[a-z]+\s*)\)/),
            m = f.match(/\(\s*max-width:\s*(-?\d+(?:\.\d*)?[a-z]+\s*)\)/);
          var p = !!(v || m);
          return v && p && (p = n >= $e(v[1])), m && p && (p = n <= $e(m[1])), h ? !p : p;
        });
        return;
      }
      r.value && (o.value = s.matchMedia(t.toValue(i)), c.value = o.value.matches);
    }), ae(o, "change", l, {
      passive: !0
    }), t.computed(function () {
      return c.value;
    });
  }
  var vs = {
    sm: 640,
    md: 768,
    lg: 1024,
    xl: 1280,
    "2xl": 1536
  };
  function Cs(i) {
    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    function s(m, p) {
      var u = t.toValue(i[t.toValue(m)]);
      return p != null && (u = ds(u, p)), typeof u == "number" && (u = "".concat(u, "px")), u;
    }
    var _e$window2 = e.window,
      n = _e$window2 === void 0 ? Ee : _e$window2,
      _e$strategy = e.strategy,
      r = _e$strategy === void 0 ? "min-width" : _e$strategy,
      _e$ssrWidth2 = e.ssrWidth,
      a = _e$ssrWidth2 === void 0 ? Jt() : _e$ssrWidth2,
      o = typeof a == "number",
      c = o ? t.shallowRef(!1) : {
        value: !0
      };
    o && Xt(function () {
      return c.value = !!n;
    });
    function l(m, p) {
      return !c.value && o ? m === "min" ? a >= $e(p) : a <= $e(p) : n ? n.matchMedia("(".concat(m, "-width: ").concat(p, ")")).matches : !1;
    }
    var d = function d(m) {
        return Ne(function () {
          return "(min-width: ".concat(s(m), ")");
        }, e);
      },
      f = function f(m) {
        return Ne(function () {
          return "(max-width: ".concat(s(m), ")");
        }, e);
      },
      h = Object.keys(i).reduce(function (m, p) {
        return Object.defineProperty(m, p, {
          get: function get() {
            return r === "min-width" ? d(p) : f(p);
          },
          enumerable: !0,
          configurable: !0
        }), m;
      }, {});
    function v() {
      var m = Object.keys(i).map(function (p) {
        return [p, h[p], $e(s(p))];
      }).sort(function (p, u) {
        return p[2] - u[2];
      });
      return t.computed(function () {
        return m.filter(function (_ref7) {
          var _ref8 = _slicedToArray(_ref7, 2),
            p = _ref8[1];
          return p.value;
        }).map(function (_ref9) {
          var _ref10 = _slicedToArray(_ref9, 1),
            p = _ref10[0];
          return p;
        });
      });
    }
    return Object.assign(h, {
      greaterOrEqual: d,
      smallerOrEqual: f,
      greater: function greater(m) {
        return Ne(function () {
          return "(min-width: ".concat(s(m, .1), ")");
        }, e);
      },
      smaller: function smaller(m) {
        return Ne(function () {
          return "(max-width: ".concat(s(m, -.1), ")");
        }, e);
      },
      between: function between(m, p) {
        return Ne(function () {
          return "(min-width: ".concat(s(m), ") and (max-width: ").concat(s(p, -.1), ")");
        }, e);
      },
      isGreater: function isGreater(m) {
        return l("min", s(m, .1));
      },
      isGreaterOrEqual: function isGreaterOrEqual(m) {
        return l("min", s(m));
      },
      isSmaller: function isSmaller(m) {
        return l("max", s(m, -.1));
      },
      isSmallerOrEqual: function isSmallerOrEqual(m) {
        return l("max", s(m));
      },
      isInBetween: function isInBetween(m, p) {
        return l("min", s(m)) && l("max", s(p, -.1));
      },
      current: v,
      active: function active() {
        var m = v();
        return t.computed(function () {
          return m.value.length === 0 ? "" : m.value.at(r === "min-width" ? -1 : 0);
        });
      }
    });
  }
  function ys(i, e) {
    var s = t.shallowRef(d()),
      n = Ye(i),
      r = t.computed({
        get: function get() {
          var f;
          var v = n.value.indexOf(s.value);
          return v < 0 && (v = (f = void 0) != null ? f : 0), v;
        },
        set: function set(f) {
          a(f);
        }
      });
    function a(f) {
      var h = n.value,
        v = h.length,
        m = (f % v + v) % v,
        p = h[m];
      return s.value = p, p;
    }
    function o() {
      var f = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      return a(r.value + f);
    }
    function c() {
      var f = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      return o(f);
    }
    function l() {
      var f = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      return o(-f);
    }
    function d() {
      var f, h;
      return (h = t.toValue((f = void 0) != null ? f : t.toValue(i)[0])) != null ? h : void 0;
    }
    return t.watch(n, function () {
      return a(r.value);
    }), {
      state: s,
      index: r,
      next: c,
      prev: l,
      go: a
    };
  }
  function Es(i, e) {
    var s = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var _s$window2 = s.window,
      n = _s$window2 === void 0 ? Ee : _s$window2,
      r = _objectWithoutProperties(s, _excluded);
    var a;
    var o = Kt(function () {
        return n && "ResizeObserver" in n;
      }),
      c = function c() {
        a && (a.disconnect(), a = void 0);
      },
      l = t.computed(function () {
        var h = t.toValue(i);
        return Array.isArray(h) ? h.map(function (v) {
          return we(v);
        }) : [we(h)];
      }),
      d = t.watch(l, function (h) {
        if (c(), o.value && n) {
          a = new ResizeObserver(e);
          var _iterator = _createForOfIteratorHelper(h),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var v = _step.value;
              v && a.observe(v, r);
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        }
      }, {
        immediate: !0,
        flush: "post"
      }),
      f = function f() {
        c(), d();
      };
    return Pe(f), {
      isSupported: o,
      stop: f
    };
  }
  var xs = {
    json: "application/json",
    text: "text/plain"
  };
  function Qt(i) {
    return i && cs(i, "immediate", "refetch", "initialData", "timeout", "beforeFetch", "afterFetch", "onFetchError", "fetch", "updateDataOnError");
  }
  function wt(i) {
    return (typeof Headers === "undefined" ? "undefined" : _typeof(Headers)) < "u" && i instanceof Headers ? Object.fromEntries(i.entries()) : i;
  }
  function ks(i) {
    var s;
    var n = typeof AbortController == "function";
    var r = {},
      a = {
        immediate: !0,
        refetch: !1,
        timeout: 0,
        updateDataOnError: !1
      };
    var o = {
      method: "GET",
      type: "text",
      payload: void 0
    };
    (arguments.length <= 1 ? 0 : arguments.length - 1) > 0 && (Qt(arguments.length <= 1 ? undefined : arguments[1]) ? a = _objectSpread(_objectSpread({}, a), arguments.length <= 1 ? undefined : arguments[1]) : r = arguments.length <= 1 ? undefined : arguments[1]), (arguments.length <= 1 ? 0 : arguments.length - 1) > 1 && Qt(arguments.length <= 2 ? undefined : arguments[2]) && (a = _objectSpread(_objectSpread({}, a), arguments.length <= 2 ? undefined : arguments[2]));
    var _a2 = a,
      _a2$fetch = _a2.fetch,
      c = _a2$fetch === void 0 ? (s = Ee) == null ? void 0 : s.fetch : _a2$fetch,
      l = _a2.initialData,
      d = _a2.timeout,
      f = ut(),
      h = ut(),
      v = ut(),
      m = t.shallowRef(!1),
      p = t.shallowRef(!1),
      u = t.shallowRef(!1),
      b = t.shallowRef(null),
      C = t.shallowRef(null),
      g = t.shallowRef(null),
      w = t.shallowRef(l || null),
      y = t.computed(function () {
        return n && p.value;
      });
    var x, T;
    var S = function S() {
        n && (x == null || x.abort(), x = new AbortController(), x.signal.onabort = function () {
          return u.value = !0;
        }, r = _objectSpread(_objectSpread({}, r), {}, {
          signal: x.signal
        }));
      },
      L = function L($) {
        p.value = $, m.value = !$;
      };
    d && (T = Ut(S, d, {
      immediate: !1
    }));
    var E = 0;
    var _M = /*#__PURE__*/function () {
        var _ref11 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
          var $,
            k,
            V,
            A,
            F,
            j,
            _,
            N,
            G,
            X,
            te,
            _args3 = arguments;
          return _regeneratorRuntime().wrap(function _callee3$(_context3) {
            while (1) switch (_context3.prev = _context3.next) {
              case 0:
                $ = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : !1;
                S(), L(!0), g.value = null, b.value = null, u.value = !1, E += 1;
                A = E, F = {
                  method: o.method,
                  headers: {}
                }, j = t.toValue(o.payload);
                if (j) {
                  _ = wt(F.headers), N = Object.getPrototypeOf(j);
                  !o.payloadType && j && (N === Object.prototype || Array.isArray(N)) && !(j instanceof FormData) && (o.payloadType = "json"), o.payloadType && (_["Content-Type"] = (k = xs[o.payloadType]) != null ? k : o.payloadType), F.body = o.payloadType === "json" ? JSON.stringify(j) : j;
                }
                G = !1;
                X = {
                  url: t.toValue(i),
                  options: _objectSpread(_objectSpread({}, F), r),
                  cancel: function cancel() {
                    G = !0;
                  }
                };
                _context3.t0 = a.beforeFetch;
                if (!_context3.t0) {
                  _context3.next = 14;
                  break;
                }
                _context3.t1 = Object;
                _context3.t2 = X;
                _context3.next = 12;
                return a.beforeFetch(X);
              case 12:
                _context3.t3 = _context3.sent;
                _context3.t1.assign.call(_context3.t1, _context3.t2, _context3.t3);
              case 14:
                if (!(G || !c)) {
                  _context3.next = 16;
                  break;
                }
                return _context3.abrupt("return", (L(!1), Promise.resolve(null)));
              case 16:
                te = null;
                return _context3.abrupt("return", (T && T.start(), c(X.url, _objectSpread(_objectSpread(_objectSpread({}, F), X.options), {}, {
                  headers: _objectSpread(_objectSpread({}, wt(F.headers)), wt((V = X.options) == null ? void 0 : V.headers))
                })).then(/*#__PURE__*/function () {
                  var _ref12 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(_) {
                    var _yield$a$afterFetch;
                    return _regeneratorRuntime().wrap(function _callee$(_context) {
                      while (1) switch (_context.prev = _context.next) {
                        case 0:
                          C.value = _;
                          b.value = _.status;
                          _context.next = 4;
                          return _.clone()[o.type]();
                        case 4:
                          te = _context.sent;
                          if (_.ok) {
                            _context.next = 7;
                            break;
                          }
                          throw w.value = l || null, new Error(_.statusText);
                        case 7:
                          _context.t0 = a.afterFetch;
                          if (!_context.t0) {
                            _context.next = 14;
                            break;
                          }
                          _context.next = 11;
                          return a.afterFetch({
                            data: te,
                            response: _,
                            context: X,
                            execute: _M
                          });
                        case 11:
                          _yield$a$afterFetch = _context.sent;
                          te = _yield$a$afterFetch.data;
                          _yield$a$afterFetch;
                        case 14:
                          w.value = te;
                          f.trigger(_);
                          return _context.abrupt("return", _);
                        case 17:
                        case "end":
                          return _context.stop();
                      }
                    }, _callee);
                  }));
                  return function (_x) {
                    return _ref12.apply(this, arguments);
                  };
                }())["catch"](/*#__PURE__*/function () {
                  var _ref13 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(_) {
                    var _yield$a$onFetchError;
                    var N;
                    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
                      while (1) switch (_context2.prev = _context2.next) {
                        case 0:
                          N = _.message || _.name;
                          _context2.t0 = a.onFetchError;
                          if (!_context2.t0) {
                            _context2.next = 9;
                            break;
                          }
                          _context2.next = 5;
                          return a.onFetchError({
                            data: te,
                            error: _,
                            response: C.value,
                            context: X,
                            execute: _M
                          });
                        case 5:
                          _yield$a$onFetchError = _context2.sent;
                          N = _yield$a$onFetchError.error;
                          te = _yield$a$onFetchError.data;
                          _yield$a$onFetchError;
                        case 9:
                          g.value = N;
                          a.updateDataOnError && (w.value = te);
                          h.trigger(_);
                          if (!$) {
                            _context2.next = 14;
                            break;
                          }
                          throw _;
                        case 14:
                          return _context2.abrupt("return", null);
                        case 15:
                        case "end":
                          return _context2.stop();
                      }
                    }, _callee2);
                  }));
                  return function (_x2) {
                    return _ref13.apply(this, arguments);
                  };
                }())["finally"](function () {
                  A === E && L(!1), T && T.stop(), v.trigger(null);
                })));
              case 18:
              case "end":
                return _context3.stop();
            }
          }, _callee3);
        }));
        return function M() {
          return _ref11.apply(this, arguments);
        };
      }(),
      P = Ye(a.refetch);
    t.watch([P, Ye(i)], function (_ref14) {
      var _ref15 = _slicedToArray(_ref14, 1),
        $ = _ref15[0];
      return $ && _M();
    }, {
      deep: !0
    });
    var B = {
      isFinished: t.readonly(m),
      isFetching: t.readonly(p),
      statusCode: b,
      response: C,
      error: g,
      data: w,
      canAbort: y,
      aborted: u,
      abort: S,
      execute: _M,
      onFetchResponse: f.on,
      onFetchError: h.on,
      onFetchFinally: v.on,
      get: H("GET"),
      put: H("PUT"),
      post: H("POST"),
      "delete": H("DELETE"),
      patch: H("PATCH"),
      head: H("HEAD"),
      options: H("OPTIONS"),
      json: I("json"),
      text: I("text"),
      blob: I("blob"),
      arrayBuffer: I("arrayBuffer"),
      formData: I("formData")
    };
    function H($) {
      return function (k, V) {
        if (!p.value) return o.method = $, o.payload = k, o.payloadType = V, t.isRef(o.payload) && t.watch([P, Ye(o.payload)], function (_ref16) {
          var _ref17 = _slicedToArray(_ref16, 1),
            A = _ref17[0];
          return A && _M();
        }, {
          deep: !0
        }), _objectSpread(_objectSpread({}, B), {}, {
          then: function then(A, F) {
            return z().then(A, F);
          }
        });
      };
    }
    function z() {
      return new Promise(function ($, k) {
        us(m).toBe(!0).then(function () {
          return $(B);
        })["catch"](k);
      });
    }
    function I($) {
      return function () {
        if (!p.value) return o.type = $, _objectSpread(_objectSpread({}, B), {}, {
          then: function then(k, V) {
            return z().then(k, V);
          }
        });
      };
    }
    return a.immediate && Promise.resolve().then(function () {
      return _M();
    }), _objectSpread(_objectSpread({}, B), {}, {
      then: function then($, k) {
        return z().then($, k);
      }
    });
  }
  function Ss(i) {
    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : re;
    var s = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var _s$immediate2 = s.immediate,
      n = _s$immediate2 === void 0 ? !0 : _s$immediate2,
      _s$manual = s.manual,
      r = _s$manual === void 0 ? !1 : _s$manual,
      _s$type = s.type,
      a = _s$type === void 0 ? "text/javascript" : _s$type,
      _s$async = s.async,
      o = _s$async === void 0 ? !0 : _s$async,
      c = s.crossOrigin,
      l = s.referrerPolicy,
      d = s.noModule,
      f = s.defer,
      _s$document = s.document,
      h = _s$document === void 0 ? hs : _s$document,
      _s$attrs = s.attrs,
      v = _s$attrs === void 0 ? {} : _s$attrs,
      m = t.shallowRef(null);
    var p = null;
    var u = function u(g) {
        return new Promise(function (w, y) {
          var x = function x(E) {
            return m.value = E, w(E), E;
          };
          if (!h) {
            w(!1);
            return;
          }
          var T = !1,
            S = h.querySelector("script[src=\"".concat(t.toValue(i), "\"]"));
          S ? S.hasAttribute("data-loaded") && x(S) : (S = h.createElement("script"), S.type = a, S.async = o, S.src = t.toValue(i), f && (S.defer = f), c && (S.crossOrigin = c), d && (S.noModule = d), l && (S.referrerPolicy = l), Object.entries(v).forEach(function (_ref18) {
            var _ref19 = _slicedToArray(_ref18, 2),
              E = _ref19[0],
              M = _ref19[1];
            return S == null ? void 0 : S.setAttribute(E, M);
          }), T = !0);
          var L = {
            passive: !0
          };
          ae(S, "error", function (E) {
            return y(E);
          }, L), ae(S, "abort", function (E) {
            return y(E);
          }, L), ae(S, "load", function () {
            S.setAttribute("data-loaded", "true"), e(S), x(S);
          }, L), T && (S = h.head.appendChild(S)), g || x(S);
        });
      },
      b = function b() {
        var g = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !0;
        return p || (p = u(g)), p;
      },
      C = function C() {
        if (!h) return;
        p = null, m.value && (m.value = null);
        var g = h.querySelector("script[src=\"".concat(t.toValue(i), "\"]"));
        g && h.head.removeChild(g);
      };
    return n && !r && Xt(b), r || fs(C), {
      scriptTag: m,
      load: b,
      unload: C
    };
  }
  function Ms(i, e) {
    var s = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var _s$immediate3 = s.immediate,
      n = _s$immediate3 === void 0 ? !0 : _s$immediate3,
      _s$immediateCallback2 = s.immediateCallback,
      r = _s$immediateCallback2 === void 0 ? !1 : _s$immediateCallback2,
      _Ut = Ut(c, e, {
        immediate: n
      }),
      a = _Ut.start,
      o = t.shallowRef(!1);
    function c() {
      return _c.apply(this, arguments);
    }
    function _c() {
      _c = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.t0 = o.value;
              if (!_context4.t0) {
                _context4.next = 5;
                break;
              }
              _context4.next = 4;
              return i();
            case 4:
              a();
            case 5:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }));
      return _c.apply(this, arguments);
    }
    function l() {
      o.value || (o.value = !0, r && i(), a());
    }
    function d() {
      o.value = !1;
    }
    return n && _e && l(), Pe(d), {
      isActive: o,
      pause: d,
      resume: l
    };
  }
  var Vs = {
      key: 0,
      "data-testid": "brightcove-player"
    },
    Ts = {
      "class": "relative w-full"
    },
    Ls = {
      "class": "relative w-full aspect-video"
    },
    Hs = ["data-account", "data-player", "data-embed", "data-video-id", "data-playlist-id", "data-ad-config-id"],
    Bs = {
      key: 0,
      "data-test-id": "bc-detail-info",
      "class": "flex flex-col p-4 md:flex-1 md:px-0 md:py-4"
    },
    zs = {
      key: 0,
      "class": "pb-4 text-lg font-black break-all"
    },
    Ps = {
      key: 1,
      "class": "pb-4 text-base"
    },
    _s = {
      key: 2,
      "class": "pb-4 text-sm opacity-60"
    },
    $s = t.defineComponent({
      __name: "BrightcovePlayer",
      props: {
        item: {
          "default": function _default() {
            return {
              accountId: "",
              id: "",
              playerId: "default",
              isPlaylist: !1,
              embedId: "",
              adConfigId: "",
              title: "",
              description: "",
              formattedDateTime: ""
            };
          }
        },
        detailed: {
          type: Boolean,
          "default": !1
        }
      },
      emits: ["play", "ended"],
      setup: function setup(i, _ref20) {
        var e = _ref20.emit;
        var s = i,
          n = e;
        Ss("https://players.brightcove.net/6292321027001/".concat(s.item.playerId, "_default/index.min.js"), function () {
          l();
        });
        var r = t.ref(null),
          a = t.ref({});
        function o() {
          n("play");
        }
        function c() {
          n("ended");
        }
        function l() {
          return _l2.apply(this, arguments);
        }
        function _l2() {
          _l2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
            return _regeneratorRuntime().wrap(function _callee5$(_context5) {
              while (1) switch (_context5.prev = _context5.next) {
                case 0:
                  !s.item.id || !s.item.accountId || window.videojs && (a.value = window.videojs.getPlayer(r.value) || {}, typeof a.value.on == "function" && (a.value.on("play", o), a.value.on("ended", c)));
                case 1:
                case "end":
                  return _context5.stop();
              }
            }, _callee5);
          }));
          return _l2.apply(this, arguments);
        }
        return t.onBeforeUnmount(function () {
          !a.value || typeof a.value.dispose != "function" || a.value.dispose();
        }), function (d, f) {
          return d.item.id && d.item.accountId ? (t.openBlock(), t.createElementBlock("div", Vs, [t.createElementVNode("div", Ts, [t.createElementVNode("div", Ls, [t.createElementVNode("video-js", {
            ref_key: "video",
            ref: r,
            "class": "w-full h-full md:flex-1",
            "data-account": d.item.accountId,
            "data-player": d.item.playerId,
            "data-embed": d.item.embedId,
            controls: "",
            "data-video-id": d.item.isPlaylist ? "" : d.item.id,
            "data-playlist-id": d.item.isPlaylist ? d.item.id : "",
            "data-ad-config-id": d.item.adConfigId,
            "data-application-id": ""
          }, null, 8, Hs)])]), d.detailed ? (t.openBlock(), t.createElementBlock("div", Bs, [d.item.title ? (t.openBlock(), t.createElementBlock("h1", zs, t.toDisplayString(d.item.title), 1)) : t.createCommentVNode("", !0), d.item.description ? (t.openBlock(), t.createElementBlock("span", Ps, t.toDisplayString(d.item.description), 1)) : t.createCommentVNode("", !0), d.item.formattedDateTime ? (t.openBlock(), t.createElementBlock("span", _s, " test ")) : t.createCommentVNode("", !0)])) : t.createCommentVNode("", !0)])) : t.createCommentVNode("", !0);
        };
      }
    }),
    Ns = {
      width: "5",
      height: "7",
      viewBox: "0 0 5 7",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    };
  function Is(i, e) {
    return t.openBlock(), t.createElementBlock("svg", Ns, e[0] || (e[0] = [t.createElementVNode("path", {
      d: "M0 5.617V1.383A.5.5 0 0 1 .757.954l3.528 2.117a.5.5 0 0 1 0 .858L.757 6.046A.5.5 0 0 1 0 5.616Z",
      fill: "#fff"
    }, null, -1)]));
  }
  var As = {
      render: Is
    },
    Ds = ["href"],
    Os = {
      key: 0,
      "class": "absolute z-10 flex left-2 right-2 top-4"
    },
    Fs = {
      "class": "flex items-center gap-1 px-2 py-1 mx-auto bg-black rounded bg-opacity-70"
    },
    Zs = {
      "class": "text-white typo-label"
    },
    Rs = ["src", "alt"],
    js = {
      key: 2,
      "class": "absolute bottom-0 z-10 px-6 py-4"
    },
    Ws = {
      "class": "w-full text-center text-white typo-teaser-4 line-clamp-2"
    },
    ei = t.defineComponent({
      __name: "Card",
      props: {
        item: {},
        ratio: {
          "default": "small"
        }
      },
      emits: ["cardClicked"],
      setup: function setup(i, _ref21) {
        var e = _ref21.emit;
        var s = e;
        return function (n, r) {
          return t.openBlock(), t.createElementBlock("div", {
            "class": t.normalizeClass(["relative w-full h-full", {
              "aspect-[3/2]": n.ratio === "small" || n.ratio === void 0,
              "aspect-[9/16]": n.ratio === "portrait"
            }]),
            "data-testid": "card"
          }, [t.createElementVNode("div", {
            "class": t.normalizeClass(["absolute bottom-0 left-0 z-10 w-full rounded h-2/5 opacity-80 bg-gradient-to-t from-black to-transparent", {
              "rounded-2xl": n.ratio === "portrait"
            }])
          }, null, 2), t.createElementVNode("a", {
            "class": t.normalizeClass(["block w-full h-full overflow-hidden rounded hover:cursor-pointer", {
              "rounded-2xl": n.ratio === "portrait"
            }]),
            href: n.item.link,
            onClick: r[0] || (r[0] = t.withModifiers(function (a) {
              return s("cardClicked", n.item);
            }, ["prevent"]))
          }, [n.item.formattedDateTime ? (t.openBlock(), t.createElementBlock("div", Os, [t.createElementVNode("div", Fs, [n.item.formattedDuration ? (t.openBlock(), t.createBlock(t.unref(As), {
            key: 0,
            "class": "w-3 h-3"
          })) : t.createCommentVNode("", !0), t.createElementVNode("span", Zs, t.toDisplayString(n.item.formattedDuration ? "".concat(n.item.formattedDuration, " - ").concat(n.item.formattedDateTime) : n.item.formattedDateTime), 1)])])) : t.createCommentVNode("", !0), n.item.image.src ? (t.openBlock(), t.createElementBlock("img", {
            key: 1,
            loading: "lazy",
            "class": t.normalizeClass(["w-full h-full transition-all duration-300 ease-in-out rounded hover:scale-105", {
              "rounded-2xl": n.ratio === "portrait"
            }]),
            src: n.item.image.src,
            alt: n.item.image.alt
          }, null, 10, Rs)) : t.createCommentVNode("", !0), n.item.title ? (t.openBlock(), t.createElementBlock("div", js, [t.createElementVNode("h3", Ws, t.toDisplayString(n.item.title), 1)])) : t.createCommentVNode("", !0)], 10, Ds)], 2);
        };
      }
    }),
    Gs = {
      width: "32",
      height: "32",
      viewBox: "0 0 32 32",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    };
  function Ys(i, e) {
    return t.openBlock(), t.createElementBlock("svg", Gs, e[0] || (e[0] = [t.createElementVNode("g", {
      id: "ArrowRight_svg__Global / Icons"
    }, [t.createElementVNode("path", {
      id: "ArrowRight_svg__Fill 1",
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M12.2978 10.5786L13.8754 9.00102L20.8741 15.9998L13.8754 23L12.2978 21.4224L17.719 15.9998L12.2978 10.5786ZM16 32C24.8373 32 32 24.8373 32 16C32 7.16622 24.8373 6.2618e-07 16 1.39876e-06C7.16266 2.17135e-06 -2.17104e-06 7.16622 -1.39876e-06 16C-6.2618e-07 24.8373 7.16267 32 16 32Z",
      fill: "currentColor"
    })], -1)]));
  }
  var Ie = {
    render: Ys
  };
  function ti(i) {
    return i !== null && _typeof(i) == "object" && "constructor" in i && i.constructor === Object;
  }
  function bt(i, e) {
    i === void 0 && (i = {}), e === void 0 && (e = {});
    var s = ["__proto__", "constructor", "prototype"];
    Object.keys(e).filter(function (n) {
      return s.indexOf(n) < 0;
    }).forEach(function (n) {
      _typeof(i[n]) > "u" ? i[n] = e[n] : ti(e[n]) && ti(i[n]) && Object.keys(e[n]).length > 0 && bt(i[n], e[n]);
    });
  }
  var ii = {
    body: {},
    addEventListener: function addEventListener() {},
    removeEventListener: function removeEventListener() {},
    activeElement: {
      blur: function blur() {},
      nodeName: ""
    },
    querySelector: function querySelector() {
      return null;
    },
    querySelectorAll: function querySelectorAll() {
      return [];
    },
    getElementById: function getElementById() {
      return null;
    },
    createEvent: function createEvent() {
      return {
        initEvent: function initEvent() {}
      };
    },
    createElement: function createElement() {
      return {
        children: [],
        childNodes: [],
        style: {},
        setAttribute: function setAttribute() {},
        getElementsByTagName: function getElementsByTagName() {
          return [];
        }
      };
    },
    createElementNS: function createElementNS() {
      return {};
    },
    importNode: function importNode() {
      return null;
    },
    location: {
      hash: "",
      host: "",
      hostname: "",
      href: "",
      origin: "",
      pathname: "",
      protocol: "",
      search: ""
    }
  };
  function Y() {
    var i = (typeof document === "undefined" ? "undefined" : _typeof(document)) < "u" ? document : {};
    return bt(i, ii), i;
  }
  var Xs = {
    document: ii,
    navigator: {
      userAgent: ""
    },
    location: {
      hash: "",
      host: "",
      hostname: "",
      href: "",
      origin: "",
      pathname: "",
      protocol: "",
      search: ""
    },
    history: {
      replaceState: function replaceState() {},
      pushState: function pushState() {},
      go: function go() {},
      back: function back() {}
    },
    CustomEvent: function CustomEvent() {
      return this;
    },
    addEventListener: function addEventListener() {},
    removeEventListener: function removeEventListener() {},
    getComputedStyle: function getComputedStyle() {
      return {
        getPropertyValue: function getPropertyValue() {
          return "";
        }
      };
    },
    Image: function Image() {},
    Date: function Date() {},
    screen: {},
    setTimeout: function setTimeout() {},
    clearTimeout: function clearTimeout() {},
    matchMedia: function matchMedia() {
      return {};
    },
    requestAnimationFrame: function requestAnimationFrame(i) {
      return (typeof setTimeout === "undefined" ? "undefined" : _typeof(setTimeout)) > "u" ? (i(), null) : setTimeout(i, 0);
    },
    cancelAnimationFrame: function cancelAnimationFrame(i) {
      (typeof setTimeout === "undefined" ? "undefined" : _typeof(setTimeout)) > "u" || clearTimeout(i);
    }
  };
  function W() {
    var i = (typeof window === "undefined" ? "undefined" : _typeof(window)) < "u" ? window : {};
    return bt(i, Xs), i;
  }
  function ce(i) {
    return i === void 0 && (i = ""), i.trim().split(" ").filter(function (e) {
      return !!e.trim();
    });
  }
  function Us(i) {
    var e = i;
    Object.keys(e).forEach(function (s) {
      try {
        e[s] = null;
      } catch (_unused) {}
      try {
        delete e[s];
      } catch (_unused2) {}
    });
  }
  function be(i, e) {
    return e === void 0 && (e = 0), setTimeout(i, e);
  }
  function ie() {
    return Date.now();
  }
  function qs(i) {
    var e = W();
    var s;
    return e.getComputedStyle && (s = e.getComputedStyle(i, null)), !s && i.currentStyle && (s = i.currentStyle), s || (s = i.style), s;
  }
  function vt(i, e) {
    e === void 0 && (e = "x");
    var s = W();
    var n, r, a;
    var o = qs(i);
    return s.WebKitCSSMatrix ? (r = o.transform || o.webkitTransform, r.split(",").length > 6 && (r = r.split(", ").map(function (c) {
      return c.replace(",", ".");
    }).join(", ")), a = new s.WebKitCSSMatrix(r === "none" ? "" : r)) : (a = o.MozTransform || o.OTransform || o.MsTransform || o.msTransform || o.transform || o.getPropertyValue("transform").replace("translate(", "matrix(1, 0, 0, 1,"), n = a.toString().split(",")), e === "x" && (s.WebKitCSSMatrix ? r = a.m41 : n.length === 16 ? r = parseFloat(n[12]) : r = parseFloat(n[4])), e === "y" && (s.WebKitCSSMatrix ? r = a.m42 : n.length === 16 ? r = parseFloat(n[13]) : r = parseFloat(n[5])), r || 0;
  }
  function Ae(i) {
    return _typeof(i) == "object" && i !== null && i.constructor && Object.prototype.toString.call(i).slice(8, -1) === "Object";
  }
  function Ks(i) {
    return (typeof window === "undefined" ? "undefined" : _typeof(window)) < "u" && _typeof(window.HTMLElement) < "u" ? i instanceof HTMLElement : i && (i.nodeType === 1 || i.nodeType === 11);
  }
  function J() {
    var i = Object(arguments.length <= 0 ? void 0 : arguments[0]),
      e = ["__proto__", "constructor", "prototype"];
    for (var s = 1; s < arguments.length; s += 1) {
      var n = s < 0 || arguments.length <= s ? void 0 : arguments[s];
      if (n != null && !Ks(n)) {
        var r = Object.keys(Object(n)).filter(function (a) {
          return e.indexOf(a) < 0;
        });
        for (var a = 0, o = r.length; a < o; a += 1) {
          var c = r[a],
            l = Object.getOwnPropertyDescriptor(n, c);
          l !== void 0 && l.enumerable && (Ae(i[c]) && Ae(n[c]) ? n[c].__swiper__ ? i[c] = n[c] : J(i[c], n[c]) : !Ae(i[c]) && Ae(n[c]) ? (i[c] = {}, n[c].__swiper__ ? i[c] = n[c] : J(i[c], n[c])) : i[c] = n[c]);
        }
      }
    }
    return i;
  }
  function De(i, e, s) {
    i.style.setProperty(e, s);
  }
  function si(i) {
    var e = i.swiper,
      s = i.targetPosition,
      n = i.side;
    var r = W(),
      a = -e.translate;
    var o = null,
      c;
    var l = e.params.speed;
    e.wrapperEl.style.scrollSnapType = "none", r.cancelAnimationFrame(e.cssModeFrameID);
    var d = s > a ? "next" : "prev",
      f = function f(v, m) {
        return d === "next" && v >= m || d === "prev" && v <= m;
      },
      _h = function h() {
        c = new Date().getTime(), o === null && (o = c);
        var v = Math.max(Math.min((c - o) / l, 1), 0),
          m = .5 - Math.cos(v * Math.PI) / 2;
        var p = a + m * (s - a);
        if (f(p, s) && (p = s), e.wrapperEl.scrollTo(_defineProperty({}, n, p)), f(p, s)) {
          e.wrapperEl.style.overflow = "hidden", e.wrapperEl.style.scrollSnapType = "", setTimeout(function () {
            e.wrapperEl.style.overflow = "", e.wrapperEl.scrollTo(_defineProperty({}, n, p));
          }), r.cancelAnimationFrame(e.cssModeFrameID);
          return;
        }
        e.cssModeFrameID = r.requestAnimationFrame(_h);
      };
    _h();
  }
  function ve(i) {
    return i.querySelector(".swiper-slide-transform") || i.shadowRoot && i.shadowRoot.querySelector(".swiper-slide-transform") || i;
  }
  function U(i, e) {
    e === void 0 && (e = "");
    var s = W(),
      n = _toConsumableArray(i.children);
    return s.HTMLSlotElement && i instanceof HTMLSlotElement && n.push.apply(n, _toConsumableArray(i.assignedElements())), e ? n.filter(function (r) {
      return r.matches(e);
    }) : n;
  }
  function Js(i, e) {
    var s = [e];
    for (; s.length > 0;) {
      var n = s.shift();
      if (i === n) return !0;
      s.push.apply(s, _toConsumableArray(n.children).concat(_toConsumableArray(n.shadowRoot ? n.shadowRoot.children : []), _toConsumableArray(n.assignedElements ? n.assignedElements() : [])));
    }
  }
  function Qs(i, e) {
    var s = W();
    var n = e.contains(i);
    return !n && s.HTMLSlotElement && e instanceof HTMLSlotElement && (n = _toConsumableArray(e.assignedElements()).includes(i), n || (n = Js(i, e))), n;
  }
  function Xe(i) {
    try {
      console.warn(i);
      return;
    } catch (_unused3) {}
  }
  function Q(i, e) {
    var _s$classList;
    e === void 0 && (e = []);
    var s = document.createElement(i);
    return (_s$classList = s.classList).add.apply(_s$classList, _toConsumableArray(Array.isArray(e) ? e : ce(e))), s;
  }
  function Ue(i) {
    var e = W(),
      s = Y(),
      n = i.getBoundingClientRect(),
      r = s.body,
      a = i.clientTop || r.clientTop || 0,
      o = i.clientLeft || r.clientLeft || 0,
      c = i === e ? e.scrollY : i.scrollTop,
      l = i === e ? e.scrollX : i.scrollLeft;
    return {
      top: n.top + c - a,
      left: n.left + l - o
    };
  }
  function en(i, e) {
    var s = [];
    for (; i.previousElementSibling;) {
      var n = i.previousElementSibling;
      e ? n.matches(e) && s.push(n) : s.push(n), i = n;
    }
    return s;
  }
  function tn(i, e) {
    var s = [];
    for (; i.nextElementSibling;) {
      var n = i.nextElementSibling;
      e ? n.matches(e) && s.push(n) : s.push(n), i = n;
    }
    return s;
  }
  function de(i, e) {
    return W().getComputedStyle(i, null).getPropertyValue(e);
  }
  function Oe(i) {
    var e = i,
      s;
    if (e) {
      for (s = 0; (e = e.previousSibling) !== null;) e.nodeType === 1 && (s += 1);
      return s;
    }
  }
  function Ce(i, e) {
    var s = [];
    var n = i.parentElement;
    for (; n;) e ? n.matches(e) && s.push(n) : s.push(n), n = n.parentElement;
    return s;
  }
  function Fe(i, e) {
    function s(n) {
      n.target === i && (e.call(i, n), i.removeEventListener("transitionend", s));
    }
    e && i.addEventListener("transitionend", s);
  }
  function Ct(i, e, s) {
    var n = W();
    return i[e === "width" ? "offsetWidth" : "offsetHeight"] + parseFloat(n.getComputedStyle(i, null).getPropertyValue(e === "width" ? "margin-right" : "margin-top")) + parseFloat(n.getComputedStyle(i, null).getPropertyValue(e === "width" ? "margin-left" : "margin-bottom"));
  }
  function Z(i) {
    return (Array.isArray(i) ? i : [i]).filter(function (e) {
      return !!e;
    });
  }
  function qe(i) {
    return function (e) {
      return Math.abs(e) > 0 && i.browser && i.browser.need3dFix && Math.abs(e) % 90 === 0 ? e + .001 : e;
    };
  }
  var yt;
  function sn() {
    var i = W(),
      e = Y();
    return {
      smoothScroll: e.documentElement && e.documentElement.style && "scrollBehavior" in e.documentElement.style,
      touch: !!("ontouchstart" in i || i.DocumentTouch && e instanceof i.DocumentTouch)
    };
  }
  function ni() {
    return yt || (yt = sn()), yt;
  }
  var Et;
  function nn(i) {
    var _ref22 = i === void 0 ? {} : i,
      e = _ref22.userAgent;
    var s = ni(),
      n = W(),
      r = n.navigator.platform,
      a = e || n.navigator.userAgent,
      o = {
        ios: !1,
        android: !1
      },
      c = n.screen.width,
      l = n.screen.height,
      d = a.match(/(Android);?[\s\/]+([\d.]+)?/);
    var f = a.match(/(iPad).*OS\s([\d_]+)/);
    var h = a.match(/(iPod)(.*OS\s([\d_]+))?/),
      v = !f && a.match(/(iPhone\sOS|iOS)\s([\d_]+)/),
      m = r === "Win32";
    var p = r === "MacIntel";
    var u = ["1024x1366", "1366x1024", "834x1194", "1194x834", "834x1112", "1112x834", "768x1024", "1024x768", "820x1180", "1180x820", "810x1080", "1080x810"];
    return !f && p && s.touch && u.indexOf("".concat(c, "x").concat(l)) >= 0 && (f = a.match(/(Version)\/([\d.]+)/), f || (f = [0, 1, "13_0_0"]), p = !1), d && !m && (o.os = "android", o.android = !0), (f || v || h) && (o.os = "ios", o.ios = !0), o;
  }
  function ri(i) {
    return i === void 0 && (i = {}), Et || (Et = nn(i)), Et;
  }
  var xt;
  function rn() {
    var i = W(),
      e = ri();
    var s = !1;
    function n() {
      var c = i.navigator.userAgent.toLowerCase();
      return c.indexOf("safari") >= 0 && c.indexOf("chrome") < 0 && c.indexOf("android") < 0;
    }
    if (n()) {
      var c = String(i.navigator.userAgent);
      if (c.includes("Version/")) {
        var _c$split$1$split$0$sp = c.split("Version/")[1].split(" ")[0].split(".").map(function (f) {
            return Number(f);
          }),
          _c$split$1$split$0$sp2 = _slicedToArray(_c$split$1$split$0$sp, 2),
          l = _c$split$1$split$0$sp2[0],
          d = _c$split$1$split$0$sp2[1];
        s = l < 16 || l === 16 && d < 2;
      }
    }
    var r = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(i.navigator.userAgent),
      a = n(),
      o = a || r && e.ios;
    return {
      isSafari: s || a,
      needPerspectiveFix: s,
      need3dFix: o,
      isWebView: r
    };
  }
  function ai() {
    return xt || (xt = rn()), xt;
  }
  function an(i) {
    var e = i.swiper,
      s = i.on,
      n = i.emit;
    var r = W();
    var a = null,
      o = null;
    var c = function c() {
        !e || e.destroyed || !e.initialized || (n("beforeResize"), n("resize"));
      },
      l = function l() {
        !e || e.destroyed || !e.initialized || (a = new ResizeObserver(function (h) {
          o = r.requestAnimationFrame(function () {
            var v = e.width,
              m = e.height;
            var p = v,
              u = m;
            h.forEach(function (b) {
              var C = b.contentBoxSize,
                g = b.contentRect,
                w = b.target;
              w && w !== e.el || (p = g ? g.width : (C[0] || C).inlineSize, u = g ? g.height : (C[0] || C).blockSize);
            }), (p !== v || u !== m) && c();
          });
        }), a.observe(e.el));
      },
      d = function d() {
        o && r.cancelAnimationFrame(o), a && a.unobserve && e.el && (a.unobserve(e.el), a = null);
      },
      f = function f() {
        !e || e.destroyed || !e.initialized || n("orientationchange");
      };
    s("init", function () {
      if (e.params.resizeObserver && _typeof(r.ResizeObserver) < "u") {
        l();
        return;
      }
      r.addEventListener("resize", c), r.addEventListener("orientationchange", f);
    }), s("destroy", function () {
      d(), r.removeEventListener("resize", c), r.removeEventListener("orientationchange", f);
    });
  }
  function ln(i) {
    var e = i.swiper,
      s = i.extendParams,
      n = i.on,
      r = i.emit;
    var a = [],
      o = W(),
      c = function c(f, h) {
        h === void 0 && (h = {});
        var v = o.MutationObserver || o.WebkitMutationObserver,
          m = new v(function (p) {
            if (e.__preventObserver__) return;
            if (p.length === 1) {
              r("observerUpdate", p[0]);
              return;
            }
            var u = function u() {
              r("observerUpdate", p[0]);
            };
            o.requestAnimationFrame ? o.requestAnimationFrame(u) : o.setTimeout(u, 0);
          });
        m.observe(f, {
          attributes: _typeof(h.attributes) > "u" ? !0 : h.attributes,
          childList: e.isElement || (_typeof(h.childList) > "u" ? !0 : h).childList,
          characterData: _typeof(h.characterData) > "u" ? !0 : h.characterData
        }), a.push(m);
      },
      l = function l() {
        if (e.params.observer) {
          if (e.params.observeParents) {
            var f = Ce(e.hostEl);
            for (var h = 0; h < f.length; h += 1) c(f[h]);
          }
          c(e.hostEl, {
            childList: e.params.observeSlideChildren
          }), c(e.wrapperEl, {
            attributes: !1
          });
        }
      },
      d = function d() {
        a.forEach(function (f) {
          f.disconnect();
        }), a.splice(0, a.length);
      };
    s({
      observer: !1,
      observeParents: !1,
      observeSlideChildren: !1
    }), n("init", l), n("destroy", d);
  }
  var on = {
    on: function on(i, e, s) {
      var n = this;
      if (!n.eventsListeners || n.destroyed || typeof e != "function") return n;
      var r = s ? "unshift" : "push";
      return i.split(" ").forEach(function (a) {
        n.eventsListeners[a] || (n.eventsListeners[a] = []), n.eventsListeners[a][r](e);
      }), n;
    },
    once: function once(i, e, s) {
      var n = this;
      if (!n.eventsListeners || n.destroyed || typeof e != "function") return n;
      function r() {
        n.off(i, r), r.__emitterProxy && delete r.__emitterProxy;
        for (var a = arguments.length, o = new Array(a), c = 0; c < a; c++) o[c] = arguments[c];
        e.apply(n, o);
      }
      return r.__emitterProxy = e, n.on(i, r, s);
    },
    onAny: function onAny(i, e) {
      var s = this;
      if (!s.eventsListeners || s.destroyed || typeof i != "function") return s;
      var n = e ? "unshift" : "push";
      return s.eventsAnyListeners.indexOf(i) < 0 && s.eventsAnyListeners[n](i), s;
    },
    offAny: function offAny(i) {
      var e = this;
      if (!e.eventsListeners || e.destroyed || !e.eventsAnyListeners) return e;
      var s = e.eventsAnyListeners.indexOf(i);
      return s >= 0 && e.eventsAnyListeners.splice(s, 1), e;
    },
    off: function off(i, e) {
      var s = this;
      return !s.eventsListeners || s.destroyed || !s.eventsListeners || i.split(" ").forEach(function (n) {
        _typeof(e) > "u" ? s.eventsListeners[n] = [] : s.eventsListeners[n] && s.eventsListeners[n].forEach(function (r, a) {
          (r === e || r.__emitterProxy && r.__emitterProxy === e) && s.eventsListeners[n].splice(a, 1);
        });
      }), s;
    },
    emit: function emit() {
      var i = this;
      if (!i.eventsListeners || i.destroyed || !i.eventsListeners) return i;
      var e, s, n;
      for (var r = arguments.length, a = new Array(r), o = 0; o < r; o++) a[o] = arguments[o];
      return typeof a[0] == "string" || Array.isArray(a[0]) ? (e = a[0], s = a.slice(1, a.length), n = i) : (e = a[0].events, s = a[0].data, n = a[0].context || i), s.unshift(n), (Array.isArray(e) ? e : e.split(" ")).forEach(function (l) {
        i.eventsAnyListeners && i.eventsAnyListeners.length && i.eventsAnyListeners.forEach(function (d) {
          d.apply(n, [l].concat(_toConsumableArray(s)));
        }), i.eventsListeners && i.eventsListeners[l] && i.eventsListeners[l].forEach(function (d) {
          d.apply(n, s);
        });
      }), i;
    }
  };
  function cn() {
    var i = this;
    var e, s;
    var n = i.el;
    _typeof(i.params.width) < "u" && i.params.width !== null ? e = i.params.width : e = n.clientWidth, _typeof(i.params.height) < "u" && i.params.height !== null ? s = i.params.height : s = n.clientHeight, !(e === 0 && i.isHorizontal() || s === 0 && i.isVertical()) && (e = e - parseInt(de(n, "padding-left") || 0, 10) - parseInt(de(n, "padding-right") || 0, 10), s = s - parseInt(de(n, "padding-top") || 0, 10) - parseInt(de(n, "padding-bottom") || 0, 10), Number.isNaN(e) && (e = 0), Number.isNaN(s) && (s = 0), Object.assign(i, {
      width: e,
      height: s,
      size: i.isHorizontal() ? e : s
    }));
  }
  function dn() {
    var i = this;
    function e(M, P) {
      return parseFloat(M.getPropertyValue(i.getDirectionLabel(P)) || 0);
    }
    var s = i.params,
      n = i.wrapperEl,
      r = i.slidesEl,
      a = i.size,
      o = i.rtlTranslate,
      c = i.wrongRTL,
      l = i.virtual && s.virtual.enabled,
      d = l ? i.virtual.slides.length : i.slides.length,
      f = U(r, ".".concat(i.params.slideClass, ", swiper-slide")),
      h = l ? i.virtual.slides.length : f.length;
    var v = [];
    var m = [],
      p = [];
    var u = s.slidesOffsetBefore;
    typeof u == "function" && (u = s.slidesOffsetBefore.call(i));
    var b = s.slidesOffsetAfter;
    typeof b == "function" && (b = s.slidesOffsetAfter.call(i));
    var C = i.snapGrid.length,
      g = i.slidesGrid.length;
    var w = s.spaceBetween,
      y = -u,
      x = 0,
      T = 0;
    if (_typeof(a) > "u") return;
    typeof w == "string" && w.indexOf("%") >= 0 ? w = parseFloat(w.replace("%", "")) / 100 * a : typeof w == "string" && (w = parseFloat(w)), i.virtualSize = -w, f.forEach(function (M) {
      o ? M.style.marginLeft = "" : M.style.marginRight = "", M.style.marginBottom = "", M.style.marginTop = "";
    }), s.centeredSlides && s.cssMode && (De(n, "--swiper-centered-offset-before", ""), De(n, "--swiper-centered-offset-after", ""));
    var S = s.grid && s.grid.rows > 1 && i.grid;
    S ? i.grid.initSlides(f) : i.grid && i.grid.unsetSlides();
    var L;
    var E = s.slidesPerView === "auto" && s.breakpoints && Object.keys(s.breakpoints).filter(function (M) {
      return _typeof(s.breakpoints[M].slidesPerView) < "u";
    }).length > 0;
    for (var M = 0; M < h; M += 1) {
      L = 0;
      var P = void 0;
      if (f[M] && (P = f[M]), S && i.grid.updateSlide(M, P, f), !(f[M] && de(P, "display") === "none")) {
        if (s.slidesPerView === "auto") {
          E && (f[M].style[i.getDirectionLabel("width")] = "");
          var B = getComputedStyle(P),
            H = P.style.transform,
            z = P.style.webkitTransform;
          if (H && (P.style.transform = "none"), z && (P.style.webkitTransform = "none"), s.roundLengths) L = i.isHorizontal() ? Ct(P, "width") : Ct(P, "height");else {
            var I = e(B, "width"),
              $ = e(B, "padding-left"),
              k = e(B, "padding-right"),
              V = e(B, "margin-left"),
              A = e(B, "margin-right"),
              F = B.getPropertyValue("box-sizing");
            if (F && F === "border-box") L = I + V + A;else {
              var _P = P,
                j = _P.clientWidth,
                G = _P.offsetWidth;
              L = I + $ + k + V + A + (G - j);
            }
          }
          H && (P.style.transform = H), z && (P.style.webkitTransform = z), s.roundLengths && (L = Math.floor(L));
        } else L = (a - (s.slidesPerView - 1) * w) / s.slidesPerView, s.roundLengths && (L = Math.floor(L)), f[M] && (f[M].style[i.getDirectionLabel("width")] = "".concat(L, "px"));
        f[M] && (f[M].swiperSlideSize = L), p.push(L), s.centeredSlides ? (y = y + L / 2 + x / 2 + w, x === 0 && M !== 0 && (y = y - a / 2 - w), M === 0 && (y = y - a / 2 - w), Math.abs(y) < 1 / 1e3 && (y = 0), s.roundLengths && (y = Math.floor(y)), T % s.slidesPerGroup === 0 && v.push(y), m.push(y)) : (s.roundLengths && (y = Math.floor(y)), (T - Math.min(i.params.slidesPerGroupSkip, T)) % i.params.slidesPerGroup === 0 && v.push(y), m.push(y), y = y + L + w), i.virtualSize += L + w, x = L, T += 1;
      }
    }
    if (i.virtualSize = Math.max(i.virtualSize, a) + b, o && c && (s.effect === "slide" || s.effect === "coverflow") && (n.style.width = "".concat(i.virtualSize + w, "px")), s.setWrapperSize && (n.style[i.getDirectionLabel("width")] = "".concat(i.virtualSize + w, "px")), S && i.grid.updateWrapperSize(L, v), !s.centeredSlides) {
      var _M2 = [];
      for (var _P2 = 0; _P2 < v.length; _P2 += 1) {
        var _B = v[_P2];
        s.roundLengths && (_B = Math.floor(_B)), v[_P2] <= i.virtualSize - a && _M2.push(_B);
      }
      v = _M2, Math.floor(i.virtualSize - a) - Math.floor(v[v.length - 1]) > 1 && v.push(i.virtualSize - a);
    }
    if (l && s.loop) {
      var _M3 = p[0] + w;
      if (s.slidesPerGroup > 1) {
        var _P3 = Math.ceil((i.virtual.slidesBefore + i.virtual.slidesAfter) / s.slidesPerGroup),
          _B2 = _M3 * s.slidesPerGroup;
        for (var _H = 0; _H < _P3; _H += 1) v.push(v[v.length - 1] + _B2);
      }
      for (var _P4 = 0; _P4 < i.virtual.slidesBefore + i.virtual.slidesAfter; _P4 += 1) s.slidesPerGroup === 1 && v.push(v[v.length - 1] + _M3), m.push(m[m.length - 1] + _M3), i.virtualSize += _M3;
    }
    if (v.length === 0 && (v = [0]), w !== 0) {
      var _M4 = i.isHorizontal() && o ? "marginLeft" : i.getDirectionLabel("marginRight");
      f.filter(function (P, B) {
        return !s.cssMode || s.loop ? !0 : B !== f.length - 1;
      }).forEach(function (P) {
        P.style[_M4] = "".concat(w, "px");
      });
    }
    if (s.centeredSlides && s.centeredSlidesBounds) {
      var _M5 = 0;
      p.forEach(function (B) {
        _M5 += B + (w || 0);
      }), _M5 -= w;
      var _P5 = _M5 > a ? _M5 - a : 0;
      v = v.map(function (B) {
        return B <= 0 ? -u : B > _P5 ? _P5 + b : B;
      });
    }
    if (s.centerInsufficientSlides) {
      var _M6 = 0;
      p.forEach(function (B) {
        _M6 += B + (w || 0);
      }), _M6 -= w;
      var _P6 = (s.slidesOffsetBefore || 0) + (s.slidesOffsetAfter || 0);
      if (_M6 + _P6 < a) {
        var _B3 = (a - _M6 - _P6) / 2;
        v.forEach(function (H, z) {
          v[z] = H - _B3;
        }), m.forEach(function (H, z) {
          m[z] = H + _B3;
        });
      }
    }
    if (Object.assign(i, {
      slides: f,
      snapGrid: v,
      slidesGrid: m,
      slidesSizesGrid: p
    }), s.centeredSlides && s.cssMode && !s.centeredSlidesBounds) {
      De(n, "--swiper-centered-offset-before", "".concat(-v[0], "px")), De(n, "--swiper-centered-offset-after", "".concat(i.size / 2 - p[p.length - 1] / 2, "px"));
      var _M7 = -i.snapGrid[0],
        _P7 = -i.slidesGrid[0];
      i.snapGrid = i.snapGrid.map(function (B) {
        return B + _M7;
      }), i.slidesGrid = i.slidesGrid.map(function (B) {
        return B + _P7;
      });
    }
    if (h !== d && i.emit("slidesLengthChange"), v.length !== C && (i.params.watchOverflow && i.checkOverflow(), i.emit("snapGridLengthChange")), m.length !== g && i.emit("slidesGridLengthChange"), s.watchSlidesProgress && i.updateSlidesOffset(), i.emit("slidesUpdated"), !l && !s.cssMode && (s.effect === "slide" || s.effect === "fade")) {
      var _M8 = "".concat(s.containerModifierClass, "backface-hidden"),
        _P8 = i.el.classList.contains(_M8);
      h <= s.maxBackfaceHiddenSlides ? _P8 || i.el.classList.add(_M8) : _P8 && i.el.classList.remove(_M8);
    }
  }
  function pn(i) {
    var e = this,
      s = [],
      n = e.virtual && e.params.virtual.enabled;
    var r = 0,
      a;
    typeof i == "number" ? e.setTransition(i) : i === !0 && e.setTransition(e.params.speed);
    var o = function o(c) {
      return n ? e.slides[e.getSlideIndexByData(c)] : e.slides[c];
    };
    if (e.params.slidesPerView !== "auto" && e.params.slidesPerView > 1) {
      if (e.params.centeredSlides) (e.visibleSlides || []).forEach(function (c) {
        s.push(c);
      });else for (a = 0; a < Math.ceil(e.params.slidesPerView); a += 1) {
        var c = e.activeIndex + a;
        if (c > e.slides.length && !n) break;
        s.push(o(c));
      }
    } else s.push(o(e.activeIndex));
    for (a = 0; a < s.length; a += 1) if (_typeof(s[a]) < "u") {
      var _c2 = s[a].offsetHeight;
      r = _c2 > r ? _c2 : r;
    }
    (r || r === 0) && (e.wrapperEl.style.height = "".concat(r, "px"));
  }
  function fn() {
    var i = this,
      e = i.slides,
      s = i.isElement ? i.isHorizontal() ? i.wrapperEl.offsetLeft : i.wrapperEl.offsetTop : 0;
    for (var n = 0; n < e.length; n += 1) e[n].swiperSlideOffset = (i.isHorizontal() ? e[n].offsetLeft : e[n].offsetTop) - s - i.cssOverflowAdjustment();
  }
  var li = function li(i, e, s) {
    e && !i.classList.contains(s) ? i.classList.add(s) : !e && i.classList.contains(s) && i.classList.remove(s);
  };
  function un(i) {
    i === void 0 && (i = this && this.translate || 0);
    var e = this,
      s = e.params,
      n = e.slides,
      r = e.rtlTranslate,
      a = e.snapGrid;
    if (n.length === 0) return;
    _typeof(n[0].swiperSlideOffset) > "u" && e.updateSlidesOffset();
    var o = -i;
    r && (o = i), e.visibleSlidesIndexes = [], e.visibleSlides = [];
    var c = s.spaceBetween;
    typeof c == "string" && c.indexOf("%") >= 0 ? c = parseFloat(c.replace("%", "")) / 100 * e.size : typeof c == "string" && (c = parseFloat(c));
    for (var l = 0; l < n.length; l += 1) {
      var d = n[l];
      var f = d.swiperSlideOffset;
      s.cssMode && s.centeredSlides && (f -= n[0].swiperSlideOffset);
      var h = (o + (s.centeredSlides ? e.minTranslate() : 0) - f) / (d.swiperSlideSize + c),
        v = (o - a[0] + (s.centeredSlides ? e.minTranslate() : 0) - f) / (d.swiperSlideSize + c),
        m = -(o - f),
        p = m + e.slidesSizesGrid[l],
        u = m >= 0 && m <= e.size - e.slidesSizesGrid[l],
        b = m >= 0 && m < e.size - 1 || p > 1 && p <= e.size || m <= 0 && p >= e.size;
      b && (e.visibleSlides.push(d), e.visibleSlidesIndexes.push(l)), li(d, b, s.slideVisibleClass), li(d, u, s.slideFullyVisibleClass), d.progress = r ? -h : h, d.originalProgress = r ? -v : v;
    }
  }
  function mn(i) {
    var e = this;
    if (_typeof(i) > "u") {
      var f = e.rtlTranslate ? -1 : 1;
      i = e && e.translate && e.translate * f || 0;
    }
    var s = e.params,
      n = e.maxTranslate() - e.minTranslate();
    var r = e.progress,
      a = e.isBeginning,
      o = e.isEnd,
      c = e.progressLoop;
    var l = a,
      d = o;
    if (n === 0) r = 0, a = !0, o = !0;else {
      r = (i - e.minTranslate()) / n;
      var _f = Math.abs(i - e.minTranslate()) < 1,
        h = Math.abs(i - e.maxTranslate()) < 1;
      a = _f || r <= 0, o = h || r >= 1, _f && (r = 0), h && (r = 1);
    }
    if (s.loop) {
      var _f2 = e.getSlideIndexByData(0),
        _h2 = e.getSlideIndexByData(e.slides.length - 1),
        v = e.slidesGrid[_f2],
        m = e.slidesGrid[_h2],
        p = e.slidesGrid[e.slidesGrid.length - 1],
        u = Math.abs(i);
      u >= v ? c = (u - v) / p : c = (u + p - m) / p, c > 1 && (c -= 1);
    }
    Object.assign(e, {
      progress: r,
      progressLoop: c,
      isBeginning: a,
      isEnd: o
    }), (s.watchSlidesProgress || s.centeredSlides && s.autoHeight) && e.updateSlidesProgress(i), a && !l && e.emit("reachBeginning toEdge"), o && !d && e.emit("reachEnd toEdge"), (l && !a || d && !o) && e.emit("fromEdge"), e.emit("progress", r);
  }
  var kt = function kt(i, e, s) {
    e && !i.classList.contains(s) ? i.classList.add(s) : !e && i.classList.contains(s) && i.classList.remove(s);
  };
  function hn() {
    var i = this,
      e = i.slides,
      s = i.params,
      n = i.slidesEl,
      r = i.activeIndex,
      a = i.virtual && s.virtual.enabled,
      o = i.grid && s.grid && s.grid.rows > 1,
      c = function c(h) {
        return U(n, ".".concat(s.slideClass).concat(h, ", swiper-slide").concat(h))[0];
      };
    var l, d, f;
    if (a) {
      if (s.loop) {
        var h = r - i.virtual.slidesBefore;
        h < 0 && (h = i.virtual.slides.length + h), h >= i.virtual.slides.length && (h -= i.virtual.slides.length), l = c("[data-swiper-slide-index=\"".concat(h, "\"]"));
      } else l = c("[data-swiper-slide-index=\"".concat(r, "\"]"));
    } else o ? (l = e.find(function (h) {
      return h.column === r;
    }), f = e.find(function (h) {
      return h.column === r + 1;
    }), d = e.find(function (h) {
      return h.column === r - 1;
    })) : l = e[r];
    l && (o || (f = tn(l, ".".concat(s.slideClass, ", swiper-slide"))[0], s.loop && !f && (f = e[0]), d = en(l, ".".concat(s.slideClass, ", swiper-slide"))[0], s.loop && !d === 0 && (d = e[e.length - 1]))), e.forEach(function (h) {
      kt(h, h === l, s.slideActiveClass), kt(h, h === f, s.slideNextClass), kt(h, h === d, s.slidePrevClass);
    }), i.emitSlidesClasses();
  }
  var Ke = function Ke(i, e) {
      if (!i || i.destroyed || !i.params) return;
      var s = function s() {
          return i.isElement ? "swiper-slide" : ".".concat(i.params.slideClass);
        },
        n = e.closest(s());
      if (n) {
        var r = n.querySelector(".".concat(i.params.lazyPreloaderClass));
        !r && i.isElement && (n.shadowRoot ? r = n.shadowRoot.querySelector(".".concat(i.params.lazyPreloaderClass)) : requestAnimationFrame(function () {
          n.shadowRoot && (r = n.shadowRoot.querySelector(".".concat(i.params.lazyPreloaderClass)), r && r.remove());
        })), r && r.remove();
      }
    },
    St = function St(i, e) {
      if (!i.slides[e]) return;
      var s = i.slides[e].querySelector('[loading="lazy"]');
      s && s.removeAttribute("loading");
    },
    Mt = function Mt(i) {
      if (!i || i.destroyed || !i.params) return;
      var e = i.params.lazyPreloadPrevNext;
      var s = i.slides.length;
      if (!s || !e || e < 0) return;
      e = Math.min(e, s);
      var n = i.params.slidesPerView === "auto" ? i.slidesPerViewDynamic() : Math.ceil(i.params.slidesPerView),
        r = i.activeIndex;
      if (i.params.grid && i.params.grid.rows > 1) {
        var o = r,
          c = [o - e];
        c.push.apply(c, _toConsumableArray(Array.from({
          length: e
        }).map(function (l, d) {
          return o + n + d;
        }))), i.slides.forEach(function (l, d) {
          c.includes(l.column) && St(i, d);
        });
        return;
      }
      var a = r + n - 1;
      if (i.params.rewind || i.params.loop) for (var _o2 = r - e; _o2 <= a + e; _o2 += 1) {
        var _c3 = (_o2 % s + s) % s;
        (_c3 < r || _c3 > a) && St(i, _c3);
      } else for (var _o3 = Math.max(r - e, 0); _o3 <= Math.min(a + e, s - 1); _o3 += 1) _o3 !== r && (_o3 > a || _o3 < r) && St(i, _o3);
    };
  function gn(i) {
    var e = i.slidesGrid,
      s = i.params,
      n = i.rtlTranslate ? i.translate : -i.translate;
    var r;
    for (var a = 0; a < e.length; a += 1) _typeof(e[a + 1]) < "u" ? n >= e[a] && n < e[a + 1] - (e[a + 1] - e[a]) / 2 ? r = a : n >= e[a] && n < e[a + 1] && (r = a + 1) : n >= e[a] && (r = a);
    return s.normalizeSlideIndex && (r < 0 || _typeof(r) > "u") && (r = 0), r;
  }
  function wn(i) {
    var e = this,
      s = e.rtlTranslate ? e.translate : -e.translate,
      n = e.snapGrid,
      r = e.params,
      a = e.activeIndex,
      o = e.realIndex,
      c = e.snapIndex;
    var l = i,
      d;
    var f = function f(m) {
      var p = m - e.virtual.slidesBefore;
      return p < 0 && (p = e.virtual.slides.length + p), p >= e.virtual.slides.length && (p -= e.virtual.slides.length), p;
    };
    if (_typeof(l) > "u" && (l = gn(e)), n.indexOf(s) >= 0) d = n.indexOf(s);else {
      var m = Math.min(r.slidesPerGroupSkip, l);
      d = m + Math.floor((l - m) / r.slidesPerGroup);
    }
    if (d >= n.length && (d = n.length - 1), l === a && !e.params.loop) {
      d !== c && (e.snapIndex = d, e.emit("snapIndexChange"));
      return;
    }
    if (l === a && e.params.loop && e.virtual && e.params.virtual.enabled) {
      e.realIndex = f(l);
      return;
    }
    var h = e.grid && r.grid && r.grid.rows > 1;
    var v;
    if (e.virtual && r.virtual.enabled && r.loop) v = f(l);else if (h) {
      var _m = e.slides.find(function (u) {
        return u.column === l;
      });
      var p = parseInt(_m.getAttribute("data-swiper-slide-index"), 10);
      Number.isNaN(p) && (p = Math.max(e.slides.indexOf(_m), 0)), v = Math.floor(p / r.grid.rows);
    } else if (e.slides[l]) {
      var _m2 = e.slides[l].getAttribute("data-swiper-slide-index");
      _m2 ? v = parseInt(_m2, 10) : v = l;
    } else v = l;
    Object.assign(e, {
      previousSnapIndex: c,
      snapIndex: d,
      previousRealIndex: o,
      realIndex: v,
      previousIndex: a,
      activeIndex: l
    }), e.initialized && Mt(e), e.emit("activeIndexChange"), e.emit("snapIndexChange"), (e.initialized || e.params.runCallbacksOnInit) && (o !== v && e.emit("realIndexChange"), e.emit("slideChange"));
  }
  function bn(i, e) {
    var s = this,
      n = s.params;
    var r = i.closest(".".concat(n.slideClass, ", swiper-slide"));
    !r && s.isElement && e && e.length > 1 && e.includes(i) && _toConsumableArray(e.slice(e.indexOf(i) + 1, e.length)).forEach(function (c) {
      !r && c.matches && c.matches(".".concat(n.slideClass, ", swiper-slide")) && (r = c);
    });
    var a = !1,
      o;
    if (r) {
      for (var c = 0; c < s.slides.length; c += 1) if (s.slides[c] === r) {
        a = !0, o = c;
        break;
      }
    }
    if (r && a) s.clickedSlide = r, s.virtual && s.params.virtual.enabled ? s.clickedIndex = parseInt(r.getAttribute("data-swiper-slide-index"), 10) : s.clickedIndex = o;else {
      s.clickedSlide = void 0, s.clickedIndex = void 0;
      return;
    }
    n.slideToClickedSlide && s.clickedIndex !== void 0 && s.clickedIndex !== s.activeIndex && s.slideToClickedSlide();
  }
  var vn = {
    updateSize: cn,
    updateSlides: dn,
    updateAutoHeight: pn,
    updateSlidesOffset: fn,
    updateSlidesProgress: un,
    updateProgress: mn,
    updateSlidesClasses: hn,
    updateActiveIndex: wn,
    updateClickedSlide: bn
  };
  function Cn(i) {
    i === void 0 && (i = this.isHorizontal() ? "x" : "y");
    var e = this,
      s = e.params,
      n = e.rtlTranslate,
      r = e.translate,
      a = e.wrapperEl;
    if (s.virtualTranslate) return n ? -r : r;
    if (s.cssMode) return r;
    var o = vt(a, i);
    return o += e.cssOverflowAdjustment(), n && (o = -o), o || 0;
  }
  function yn(i, e) {
    var s = this,
      n = s.rtlTranslate,
      r = s.params,
      a = s.wrapperEl,
      o = s.progress;
    var c = 0,
      l = 0;
    var d = 0;
    s.isHorizontal() ? c = n ? -i : i : l = i, r.roundLengths && (c = Math.floor(c), l = Math.floor(l)), s.previousTranslate = s.translate, s.translate = s.isHorizontal() ? c : l, r.cssMode ? a[s.isHorizontal() ? "scrollLeft" : "scrollTop"] = s.isHorizontal() ? -c : -l : r.virtualTranslate || (s.isHorizontal() ? c -= s.cssOverflowAdjustment() : l -= s.cssOverflowAdjustment(), a.style.transform = "translate3d(".concat(c, "px, ").concat(l, "px, ").concat(d, "px)"));
    var f;
    var h = s.maxTranslate() - s.minTranslate();
    h === 0 ? f = 0 : f = (i - s.minTranslate()) / h, f !== o && s.updateProgress(i), s.emit("setTranslate", s.translate, e);
  }
  function En() {
    return -this.snapGrid[0];
  }
  function xn() {
    return -this.snapGrid[this.snapGrid.length - 1];
  }
  function kn(i, e, s, n, r) {
    i === void 0 && (i = 0), e === void 0 && (e = this.params.speed), s === void 0 && (s = !0), n === void 0 && (n = !0);
    var a = this,
      o = a.params,
      c = a.wrapperEl;
    if (a.animating && o.preventInteractionOnTransition) return !1;
    var l = a.minTranslate(),
      d = a.maxTranslate();
    var f;
    if (n && i > l ? f = l : n && i < d ? f = d : f = i, a.updateProgress(f), o.cssMode) {
      var h = a.isHorizontal();
      if (e === 0) c[h ? "scrollLeft" : "scrollTop"] = -f;else {
        if (!a.support.smoothScroll) return si({
          swiper: a,
          targetPosition: -f,
          side: h ? "left" : "top"
        }), !0;
        c.scrollTo(_defineProperty(_defineProperty({}, h ? "left" : "top", -f), "behavior", "smooth"));
      }
      return !0;
    }
    return e === 0 ? (a.setTransition(0), a.setTranslate(f), s && (a.emit("beforeTransitionStart", e, r), a.emit("transitionEnd"))) : (a.setTransition(e), a.setTranslate(f), s && (a.emit("beforeTransitionStart", e, r), a.emit("transitionStart")), a.animating || (a.animating = !0, a.onTranslateToWrapperTransitionEnd || (a.onTranslateToWrapperTransitionEnd = function (v) {
      !a || a.destroyed || v.target === this && (a.wrapperEl.removeEventListener("transitionend", a.onTranslateToWrapperTransitionEnd), a.onTranslateToWrapperTransitionEnd = null, delete a.onTranslateToWrapperTransitionEnd, a.animating = !1, s && a.emit("transitionEnd"));
    }), a.wrapperEl.addEventListener("transitionend", a.onTranslateToWrapperTransitionEnd))), !0;
  }
  var Sn = {
    getTranslate: Cn,
    setTranslate: yn,
    minTranslate: En,
    maxTranslate: xn,
    translateTo: kn
  };
  function Mn(i, e) {
    var s = this;
    s.params.cssMode || (s.wrapperEl.style.transitionDuration = "".concat(i, "ms"), s.wrapperEl.style.transitionDelay = i === 0 ? "0ms" : ""), s.emit("setTransition", i, e);
  }
  function oi(i) {
    var e = i.swiper,
      s = i.runCallbacks,
      n = i.direction,
      r = i.step;
    var a = e.activeIndex,
      o = e.previousIndex;
    var c = n;
    if (c || (a > o ? c = "next" : a < o ? c = "prev" : c = "reset"), e.emit("transition".concat(r)), s && a !== o) {
      if (c === "reset") {
        e.emit("slideResetTransition".concat(r));
        return;
      }
      e.emit("slideChangeTransition".concat(r)), c === "next" ? e.emit("slideNextTransition".concat(r)) : e.emit("slidePrevTransition".concat(r));
    }
  }
  function Vn(i, e) {
    i === void 0 && (i = !0);
    var s = this,
      n = s.params;
    n.cssMode || (n.autoHeight && s.updateAutoHeight(), oi({
      swiper: s,
      runCallbacks: i,
      direction: e,
      step: "Start"
    }));
  }
  function Tn(i, e) {
    i === void 0 && (i = !0);
    var s = this,
      n = s.params;
    s.animating = !1, !n.cssMode && (s.setTransition(0), oi({
      swiper: s,
      runCallbacks: i,
      direction: e,
      step: "End"
    }));
  }
  var Ln = {
    setTransition: Mn,
    transitionStart: Vn,
    transitionEnd: Tn
  };
  function Hn(i, e, s, n, r) {
    i === void 0 && (i = 0), s === void 0 && (s = !0), typeof i == "string" && (i = parseInt(i, 10));
    var a = this;
    var o = i;
    o < 0 && (o = 0);
    var c = a.params,
      l = a.snapGrid,
      d = a.slidesGrid,
      f = a.previousIndex,
      h = a.activeIndex,
      v = a.rtlTranslate,
      m = a.wrapperEl,
      p = a.enabled;
    if (!p && !n && !r || a.destroyed || a.animating && c.preventInteractionOnTransition) return !1;
    _typeof(e) > "u" && (e = a.params.speed);
    var u = Math.min(a.params.slidesPerGroupSkip, o);
    var b = u + Math.floor((o - u) / a.params.slidesPerGroup);
    b >= l.length && (b = l.length - 1);
    var C = -l[b];
    if (c.normalizeSlideIndex) for (var S = 0; S < d.length; S += 1) {
      var L = -Math.floor(C * 100),
        E = Math.floor(d[S] * 100),
        M = Math.floor(d[S + 1] * 100);
      _typeof(d[S + 1]) < "u" ? L >= E && L < M - (M - E) / 2 ? o = S : L >= E && L < M && (o = S + 1) : L >= E && (o = S);
    }
    if (a.initialized && o !== h && (!a.allowSlideNext && (v ? C > a.translate && C > a.minTranslate() : C < a.translate && C < a.minTranslate()) || !a.allowSlidePrev && C > a.translate && C > a.maxTranslate() && (h || 0) !== o)) return !1;
    o !== (f || 0) && s && a.emit("beforeSlideChangeStart"), a.updateProgress(C);
    var g;
    o > h ? g = "next" : o < h ? g = "prev" : g = "reset";
    var w = a.virtual && a.params.virtual.enabled;
    if (!(w && r) && (v && -C === a.translate || !v && C === a.translate)) return a.updateActiveIndex(o), c.autoHeight && a.updateAutoHeight(), a.updateSlidesClasses(), c.effect !== "slide" && a.setTranslate(C), g !== "reset" && (a.transitionStart(s, g), a.transitionEnd(s, g)), !1;
    if (c.cssMode) {
      var _S = a.isHorizontal(),
        _L = v ? C : -C;
      if (e === 0) w && (a.wrapperEl.style.scrollSnapType = "none", a._immediateVirtual = !0), w && !a._cssModeVirtualInitialSet && a.params.initialSlide > 0 ? (a._cssModeVirtualInitialSet = !0, requestAnimationFrame(function () {
        m[_S ? "scrollLeft" : "scrollTop"] = _L;
      })) : m[_S ? "scrollLeft" : "scrollTop"] = _L, w && requestAnimationFrame(function () {
        a.wrapperEl.style.scrollSnapType = "", a._immediateVirtual = !1;
      });else {
        if (!a.support.smoothScroll) return si({
          swiper: a,
          targetPosition: _L,
          side: _S ? "left" : "top"
        }), !0;
        m.scrollTo(_defineProperty(_defineProperty({}, _S ? "left" : "top", _L), "behavior", "smooth"));
      }
      return !0;
    }
    var T = ai().isSafari;
    return w && !r && T && a.isElement && a.virtual.update(!1, !1, o), a.setTransition(e), a.setTranslate(C), a.updateActiveIndex(o), a.updateSlidesClasses(), a.emit("beforeTransitionStart", e, n), a.transitionStart(s, g), e === 0 ? a.transitionEnd(s, g) : a.animating || (a.animating = !0, a.onSlideToWrapperTransitionEnd || (a.onSlideToWrapperTransitionEnd = function (L) {
      !a || a.destroyed || L.target === this && (a.wrapperEl.removeEventListener("transitionend", a.onSlideToWrapperTransitionEnd), a.onSlideToWrapperTransitionEnd = null, delete a.onSlideToWrapperTransitionEnd, a.transitionEnd(s, g));
    }), a.wrapperEl.addEventListener("transitionend", a.onSlideToWrapperTransitionEnd)), !0;
  }
  function Bn(i, e, s, n) {
    i === void 0 && (i = 0), s === void 0 && (s = !0), typeof i == "string" && (i = parseInt(i, 10));
    var r = this;
    if (r.destroyed) return;
    _typeof(e) > "u" && (e = r.params.speed);
    var a = r.grid && r.params.grid && r.params.grid.rows > 1;
    var o = i;
    if (r.params.loop) if (r.virtual && r.params.virtual.enabled) o = o + r.virtual.slidesBefore;else {
      var c;
      if (a) {
        var v = o * r.params.grid.rows;
        c = r.slides.find(function (m) {
          return m.getAttribute("data-swiper-slide-index") * 1 === v;
        }).column;
      } else c = r.getSlideIndexByData(o);
      var l = a ? Math.ceil(r.slides.length / r.params.grid.rows) : r.slides.length,
        d = r.params.centeredSlides;
      var f = r.params.slidesPerView;
      f === "auto" ? f = r.slidesPerViewDynamic() : (f = Math.ceil(parseFloat(r.params.slidesPerView, 10)), d && f % 2 === 0 && (f = f + 1));
      var h = l - c < f;
      if (d && (h = h || c < Math.ceil(f / 2)), n && d && r.params.slidesPerView !== "auto" && !a && (h = !1), h) {
        var _v = d ? c < r.activeIndex ? "prev" : "next" : c - r.activeIndex - 1 < r.params.slidesPerView ? "next" : "prev";
        r.loopFix({
          direction: _v,
          slideTo: !0,
          activeSlideIndex: _v === "next" ? c + 1 : c - l + 1,
          slideRealIndex: _v === "next" ? r.realIndex : void 0
        });
      }
      if (a) {
        var _v2 = o * r.params.grid.rows;
        o = r.slides.find(function (m) {
          return m.getAttribute("data-swiper-slide-index") * 1 === _v2;
        }).column;
      } else o = r.getSlideIndexByData(o);
    }
    return requestAnimationFrame(function () {
      r.slideTo(o, e, s, n);
    }), r;
  }
  function zn(i, e, s) {
    e === void 0 && (e = !0);
    var n = this,
      r = n.enabled,
      a = n.params,
      o = n.animating;
    if (!r || n.destroyed) return n;
    _typeof(i) > "u" && (i = n.params.speed);
    var c = a.slidesPerGroup;
    a.slidesPerView === "auto" && a.slidesPerGroup === 1 && a.slidesPerGroupAuto && (c = Math.max(n.slidesPerViewDynamic("current", !0), 1));
    var l = n.activeIndex < a.slidesPerGroupSkip ? 1 : c,
      d = n.virtual && a.virtual.enabled;
    if (a.loop) {
      if (o && !d && a.loopPreventsSliding) return !1;
      if (n.loopFix({
        direction: "next"
      }), n._clientLeft = n.wrapperEl.clientLeft, n.activeIndex === n.slides.length - 1 && a.cssMode) return requestAnimationFrame(function () {
        n.slideTo(n.activeIndex + l, i, e, s);
      }), !0;
    }
    return a.rewind && n.isEnd ? n.slideTo(0, i, e, s) : n.slideTo(n.activeIndex + l, i, e, s);
  }
  function Pn(i, e, s) {
    e === void 0 && (e = !0);
    var n = this,
      r = n.params,
      a = n.snapGrid,
      o = n.slidesGrid,
      c = n.rtlTranslate,
      l = n.enabled,
      d = n.animating;
    if (!l || n.destroyed) return n;
    _typeof(i) > "u" && (i = n.params.speed);
    var f = n.virtual && r.virtual.enabled;
    if (r.loop) {
      if (d && !f && r.loopPreventsSliding) return !1;
      n.loopFix({
        direction: "prev"
      }), n._clientLeft = n.wrapperEl.clientLeft;
    }
    var h = c ? n.translate : -n.translate;
    function v(g) {
      return g < 0 ? -Math.floor(Math.abs(g)) : Math.floor(g);
    }
    var m = v(h),
      p = a.map(function (g) {
        return v(g);
      }),
      u = r.freeMode && r.freeMode.enabled;
    var b = a[p.indexOf(m) - 1];
    if (_typeof(b) > "u" && (r.cssMode || u)) {
      var g;
      a.forEach(function (w, y) {
        m >= w && (g = y);
      }), _typeof(g) < "u" && (b = u ? a[g] : a[g > 0 ? g - 1 : g]);
    }
    var C = 0;
    if (_typeof(b) < "u" && (C = o.indexOf(b), C < 0 && (C = n.activeIndex - 1), r.slidesPerView === "auto" && r.slidesPerGroup === 1 && r.slidesPerGroupAuto && (C = C - n.slidesPerViewDynamic("previous", !0) + 1, C = Math.max(C, 0))), r.rewind && n.isBeginning) {
      var _g = n.params.virtual && n.params.virtual.enabled && n.virtual ? n.virtual.slides.length - 1 : n.slides.length - 1;
      return n.slideTo(_g, i, e, s);
    } else if (r.loop && n.activeIndex === 0 && r.cssMode) return requestAnimationFrame(function () {
      n.slideTo(C, i, e, s);
    }), !0;
    return n.slideTo(C, i, e, s);
  }
  function _n(i, e, s) {
    e === void 0 && (e = !0);
    var n = this;
    if (!n.destroyed) return _typeof(i) > "u" && (i = n.params.speed), n.slideTo(n.activeIndex, i, e, s);
  }
  function $n(i, e, s, n) {
    e === void 0 && (e = !0), n === void 0 && (n = .5);
    var r = this;
    if (r.destroyed) return;
    _typeof(i) > "u" && (i = r.params.speed);
    var a = r.activeIndex;
    var o = Math.min(r.params.slidesPerGroupSkip, a),
      c = o + Math.floor((a - o) / r.params.slidesPerGroup),
      l = r.rtlTranslate ? r.translate : -r.translate;
    if (l >= r.snapGrid[c]) {
      var d = r.snapGrid[c],
        f = r.snapGrid[c + 1];
      l - d > (f - d) * n && (a += r.params.slidesPerGroup);
    } else {
      var _d = r.snapGrid[c - 1],
        _f3 = r.snapGrid[c];
      l - _d <= (_f3 - _d) * n && (a -= r.params.slidesPerGroup);
    }
    return a = Math.max(a, 0), a = Math.min(a, r.slidesGrid.length - 1), r.slideTo(a, i, e, s);
  }
  function Nn() {
    var i = this;
    if (i.destroyed) return;
    var e = i.params,
      s = i.slidesEl,
      n = e.slidesPerView === "auto" ? i.slidesPerViewDynamic() : e.slidesPerView;
    var r = i.clickedIndex,
      a;
    var o = i.isElement ? "swiper-slide" : ".".concat(e.slideClass);
    if (e.loop) {
      if (i.animating) return;
      a = parseInt(i.clickedSlide.getAttribute("data-swiper-slide-index"), 10), e.centeredSlides ? r < i.loopedSlides - n / 2 || r > i.slides.length - i.loopedSlides + n / 2 ? (i.loopFix(), r = i.getSlideIndex(U(s, "".concat(o, "[data-swiper-slide-index=\"").concat(a, "\"]"))[0]), be(function () {
        i.slideTo(r);
      })) : i.slideTo(r) : r > i.slides.length - n ? (i.loopFix(), r = i.getSlideIndex(U(s, "".concat(o, "[data-swiper-slide-index=\"").concat(a, "\"]"))[0]), be(function () {
        i.slideTo(r);
      })) : i.slideTo(r);
    } else i.slideTo(r);
  }
  var In = {
    slideTo: Hn,
    slideToLoop: Bn,
    slideNext: zn,
    slidePrev: Pn,
    slideReset: _n,
    slideToClosest: $n,
    slideToClickedSlide: Nn
  };
  function An(i, e) {
    var s = this,
      n = s.params,
      r = s.slidesEl;
    if (!n.loop || s.virtual && s.params.virtual.enabled) return;
    var a = function a() {
        U(r, ".".concat(n.slideClass, ", swiper-slide")).forEach(function (v, m) {
          v.setAttribute("data-swiper-slide-index", m);
        });
      },
      o = s.grid && n.grid && n.grid.rows > 1,
      c = n.slidesPerGroup * (o ? n.grid.rows : 1),
      l = s.slides.length % c !== 0,
      d = o && s.slides.length % n.grid.rows !== 0,
      f = function f(h) {
        for (var v = 0; v < h; v += 1) {
          var m = s.isElement ? Q("swiper-slide", [n.slideBlankClass]) : Q("div", [n.slideClass, n.slideBlankClass]);
          s.slidesEl.append(m);
        }
      };
    if (l) {
      if (n.loopAddBlankSlides) {
        var h = c - s.slides.length % c;
        f(h), s.recalcSlides(), s.updateSlides();
      } else Xe("Swiper Loop Warning: The number of slides is not even to slidesPerGroup, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)");
      a();
    } else if (d) {
      if (n.loopAddBlankSlides) {
        var _h3 = n.grid.rows - s.slides.length % n.grid.rows;
        f(_h3), s.recalcSlides(), s.updateSlides();
      } else Xe("Swiper Loop Warning: The number of slides is not even to grid.rows, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)");
      a();
    } else a();
    s.loopFix({
      slideRealIndex: i,
      direction: n.centeredSlides ? void 0 : "next",
      initial: e
    });
  }
  function Dn(i) {
    var _ref23 = i === void 0 ? {} : i,
      e = _ref23.slideRealIndex,
      _ref23$slideTo = _ref23.slideTo,
      s = _ref23$slideTo === void 0 ? !0 : _ref23$slideTo,
      n = _ref23.direction,
      r = _ref23.setTranslate,
      a = _ref23.activeSlideIndex,
      o = _ref23.initial,
      c = _ref23.byController,
      l = _ref23.byMousewheel;
    var d = this;
    if (!d.params.loop) return;
    d.emit("beforeLoopFix");
    var f = d.slides,
      h = d.allowSlidePrev,
      v = d.allowSlideNext,
      m = d.slidesEl,
      p = d.params,
      u = p.centeredSlides,
      b = p.initialSlide;
    if (d.allowSlidePrev = !0, d.allowSlideNext = !0, d.virtual && p.virtual.enabled) {
      s && (!p.centeredSlides && d.snapIndex === 0 ? d.slideTo(d.virtual.slides.length, 0, !1, !0) : p.centeredSlides && d.snapIndex < p.slidesPerView ? d.slideTo(d.virtual.slides.length + d.snapIndex, 0, !1, !0) : d.snapIndex === d.snapGrid.length - 1 && d.slideTo(d.virtual.slidesBefore, 0, !1, !0)), d.allowSlidePrev = h, d.allowSlideNext = v, d.emit("loopFix");
      return;
    }
    var C = p.slidesPerView;
    C === "auto" ? C = d.slidesPerViewDynamic() : (C = Math.ceil(parseFloat(p.slidesPerView, 10)), u && C % 2 === 0 && (C = C + 1));
    var g = p.slidesPerGroupAuto ? C : p.slidesPerGroup;
    var w = g;
    w % g !== 0 && (w += g - w % g), w += p.loopAdditionalSlides, d.loopedSlides = w;
    var y = d.grid && p.grid && p.grid.rows > 1;
    f.length < C + w || d.params.effect === "cards" && f.length < C + w * 2 ? Xe("Swiper Loop Warning: The number of slides is not enough for loop mode, it will be disabled or not function properly. You need to add more slides (or make duplicates) or lower the values of slidesPerView and slidesPerGroup parameters") : y && p.grid.fill === "row" && Xe("Swiper Loop Warning: Loop mode is not compatible with grid.fill = `row`");
    var x = [],
      T = [],
      S = y ? Math.ceil(f.length / p.grid.rows) : f.length,
      L = o && S - b < C && !u;
    var E = L ? b : d.activeIndex;
    _typeof(a) > "u" ? a = d.getSlideIndex(f.find(function ($) {
      return $.classList.contains(p.slideActiveClass);
    })) : E = a;
    var M = n === "next" || !n,
      P = n === "prev" || !n;
    var B = 0,
      H = 0;
    var I = (y ? f[a].column : a) + (u && _typeof(r) > "u" ? -C / 2 + .5 : 0);
    if (I < w) {
      B = Math.max(w - I, g);
      for (var $ = 0; $ < w - I; $ += 1) {
        var k = $ - Math.floor($ / S) * S;
        if (y) {
          var V = S - k - 1;
          for (var A = f.length - 1; A >= 0; A -= 1) f[A].column === V && x.push(A);
        } else x.push(S - k - 1);
      }
    } else if (I + C > S - w) {
      H = Math.max(I - (S - w * 2), g), L && (H = Math.max(H, C - S + b + 1));
      var _loop = function _loop() {
        var k = _$ - Math.floor(_$ / S) * S;
        y ? f.forEach(function (V, A) {
          V.column === k && T.push(A);
        }) : T.push(k);
      };
      for (var _$ = 0; _$ < H; _$ += 1) {
        _loop();
      }
    }
    if (d.__preventObserver__ = !0, requestAnimationFrame(function () {
      d.__preventObserver__ = !1;
    }), d.params.effect === "cards" && f.length < C + w * 2 && (T.includes(a) && T.splice(T.indexOf(a), 1), x.includes(a) && x.splice(x.indexOf(a), 1)), P && x.forEach(function ($) {
      f[$].swiperLoopMoveDOM = !0, m.prepend(f[$]), f[$].swiperLoopMoveDOM = !1;
    }), M && T.forEach(function ($) {
      f[$].swiperLoopMoveDOM = !0, m.append(f[$]), f[$].swiperLoopMoveDOM = !1;
    }), d.recalcSlides(), p.slidesPerView === "auto" ? d.updateSlides() : y && (x.length > 0 && P || T.length > 0 && M) && d.slides.forEach(function ($, k) {
      d.grid.updateSlide(k, $, d.slides);
    }), p.watchSlidesProgress && d.updateSlidesOffset(), s) {
      if (x.length > 0 && P) {
        if (_typeof(e) > "u") {
          var _$2 = d.slidesGrid[E],
            _V = d.slidesGrid[E + B] - _$2;
          l ? d.setTranslate(d.translate - _V) : (d.slideTo(E + Math.ceil(B), 0, !1, !0), r && (d.touchEventsData.startTranslate = d.touchEventsData.startTranslate - _V, d.touchEventsData.currentTranslate = d.touchEventsData.currentTranslate - _V));
        } else if (r) {
          var _$3 = y ? x.length / p.grid.rows : x.length;
          d.slideTo(d.activeIndex + _$3, 0, !1, !0), d.touchEventsData.currentTranslate = d.translate;
        }
      } else if (T.length > 0 && M) if (_typeof(e) > "u") {
        var _$4 = d.slidesGrid[E],
          _V2 = d.slidesGrid[E - H] - _$4;
        l ? d.setTranslate(d.translate - _V2) : (d.slideTo(E - H, 0, !1, !0), r && (d.touchEventsData.startTranslate = d.touchEventsData.startTranslate - _V2, d.touchEventsData.currentTranslate = d.touchEventsData.currentTranslate - _V2));
      } else {
        var _$5 = y ? T.length / p.grid.rows : T.length;
        d.slideTo(d.activeIndex - _$5, 0, !1, !0);
      }
    }
    if (d.allowSlidePrev = h, d.allowSlideNext = v, d.controller && d.controller.control && !c) {
      var _$6 = {
        slideRealIndex: e,
        direction: n,
        setTranslate: r,
        activeSlideIndex: a,
        byController: !0
      };
      Array.isArray(d.controller.control) ? d.controller.control.forEach(function (k) {
        !k.destroyed && k.params.loop && k.loopFix(_objectSpread(_objectSpread({}, _$6), {}, {
          slideTo: k.params.slidesPerView === p.slidesPerView ? s : !1
        }));
      }) : d.controller.control instanceof d.constructor && d.controller.control.params.loop && d.controller.control.loopFix(_objectSpread(_objectSpread({}, _$6), {}, {
        slideTo: d.controller.control.params.slidesPerView === p.slidesPerView ? s : !1
      }));
    }
    d.emit("loopFix");
  }
  function On() {
    var i = this,
      e = i.params,
      s = i.slidesEl;
    if (!e.loop || !s || i.virtual && i.params.virtual.enabled) return;
    i.recalcSlides();
    var n = [];
    i.slides.forEach(function (r) {
      var a = _typeof(r.swiperSlideIndex) > "u" ? r.getAttribute("data-swiper-slide-index") * 1 : r.swiperSlideIndex;
      n[a] = r;
    }), i.slides.forEach(function (r) {
      r.removeAttribute("data-swiper-slide-index");
    }), n.forEach(function (r) {
      s.append(r);
    }), i.recalcSlides(), i.slideTo(i.realIndex, 0);
  }
  var Fn = {
    loopCreate: An,
    loopFix: Dn,
    loopDestroy: On
  };
  function Zn(i) {
    var e = this;
    if (!e.params.simulateTouch || e.params.watchOverflow && e.isLocked || e.params.cssMode) return;
    var s = e.params.touchEventsTarget === "container" ? e.el : e.wrapperEl;
    e.isElement && (e.__preventObserver__ = !0), s.style.cursor = "move", s.style.cursor = i ? "grabbing" : "grab", e.isElement && requestAnimationFrame(function () {
      e.__preventObserver__ = !1;
    });
  }
  function Rn() {
    var i = this;
    i.params.watchOverflow && i.isLocked || i.params.cssMode || (i.isElement && (i.__preventObserver__ = !0), i[i.params.touchEventsTarget === "container" ? "el" : "wrapperEl"].style.cursor = "", i.isElement && requestAnimationFrame(function () {
      i.__preventObserver__ = !1;
    }));
  }
  var jn = {
    setGrabCursor: Zn,
    unsetGrabCursor: Rn
  };
  function Wn(i, e) {
    e === void 0 && (e = this);
    function s(n) {
      if (!n || n === Y() || n === W()) return null;
      n.assignedSlot && (n = n.assignedSlot);
      var r = n.closest(i);
      return !r && !n.getRootNode ? null : r || s(n.getRootNode().host);
    }
    return s(e);
  }
  function ci(i, e, s) {
    var n = W(),
      r = i.params,
      a = r.edgeSwipeDetection,
      o = r.edgeSwipeThreshold;
    return a && (s <= o || s >= n.innerWidth - o) ? a === "prevent" ? (e.preventDefault(), !0) : !1 : !0;
  }
  function Gn(i) {
    var e = this,
      s = Y();
    var n = i;
    n.originalEvent && (n = n.originalEvent);
    var r = e.touchEventsData;
    if (n.type === "pointerdown") {
      if (r.pointerId !== null && r.pointerId !== n.pointerId) return;
      r.pointerId = n.pointerId;
    } else n.type === "touchstart" && n.targetTouches.length === 1 && (r.touchId = n.targetTouches[0].identifier);
    if (n.type === "touchstart") {
      ci(e, n, n.targetTouches[0].pageX);
      return;
    }
    var a = e.params,
      o = e.touches,
      c = e.enabled;
    if (!c || !a.simulateTouch && n.pointerType === "mouse" || e.animating && a.preventInteractionOnTransition) return;
    !e.animating && a.cssMode && a.loop && e.loopFix();
    var l = n.target;
    if (a.touchEventsTarget === "wrapper" && !Qs(l, e.wrapperEl) || "which" in n && n.which === 3 || "button" in n && n.button > 0 || r.isTouched && r.isMoved) return;
    var d = !!a.noSwipingClass && a.noSwipingClass !== "",
      f = n.composedPath ? n.composedPath() : n.path;
    d && n.target && n.target.shadowRoot && f && (l = f[0]);
    var h = a.noSwipingSelector ? a.noSwipingSelector : ".".concat(a.noSwipingClass),
      v = !!(n.target && n.target.shadowRoot);
    if (a.noSwiping && (v ? Wn(h, l) : l.closest(h))) {
      e.allowClick = !0;
      return;
    }
    if (a.swipeHandler && !l.closest(a.swipeHandler)) return;
    o.currentX = n.pageX, o.currentY = n.pageY;
    var m = o.currentX,
      p = o.currentY;
    if (!ci(e, n, m)) return;
    Object.assign(r, {
      isTouched: !0,
      isMoved: !1,
      allowTouchCallbacks: !0,
      isScrolling: void 0,
      startMoving: void 0
    }), o.startX = m, o.startY = p, r.touchStartTime = ie(), e.allowClick = !0, e.updateSize(), e.swipeDirection = void 0, a.threshold > 0 && (r.allowThresholdMove = !1);
    var u = !0;
    l.matches(r.focusableElements) && (u = !1, l.nodeName === "SELECT" && (r.isTouched = !1)), s.activeElement && s.activeElement.matches(r.focusableElements) && s.activeElement !== l && (n.pointerType === "mouse" || n.pointerType !== "mouse" && !l.matches(r.focusableElements)) && s.activeElement.blur();
    var b = u && e.allowTouchMove && a.touchStartPreventDefault;
    (a.touchStartForcePreventDefault || b) && !l.isContentEditable && n.preventDefault(), a.freeMode && a.freeMode.enabled && e.freeMode && e.animating && !a.cssMode && e.freeMode.onTouchStart(), e.emit("touchStart", n);
  }
  function Yn(i) {
    var e = Y(),
      s = this,
      n = s.touchEventsData,
      r = s.params,
      a = s.touches,
      o = s.rtlTranslate,
      c = s.enabled;
    if (!c || !r.simulateTouch && i.pointerType === "mouse") return;
    var l = i;
    if (l.originalEvent && (l = l.originalEvent), l.type === "pointermove" && (n.touchId !== null || l.pointerId !== n.pointerId)) return;
    var d;
    if (l.type === "touchmove") {
      if (d = _toConsumableArray(l.changedTouches).find(function (x) {
        return x.identifier === n.touchId;
      }), !d || d.identifier !== n.touchId) return;
    } else d = l;
    if (!n.isTouched) {
      n.startMoving && n.isScrolling && s.emit("touchMoveOpposite", l);
      return;
    }
    var f = d.pageX,
      h = d.pageY;
    if (l.preventedByNestedSwiper) {
      a.startX = f, a.startY = h;
      return;
    }
    if (!s.allowTouchMove) {
      l.target.matches(n.focusableElements) || (s.allowClick = !1), n.isTouched && (Object.assign(a, {
        startX: f,
        startY: h,
        currentX: f,
        currentY: h
      }), n.touchStartTime = ie());
      return;
    }
    if (r.touchReleaseOnEdges && !r.loop) if (s.isVertical()) {
      if (h < a.startY && s.translate <= s.maxTranslate() || h > a.startY && s.translate >= s.minTranslate()) {
        n.isTouched = !1, n.isMoved = !1;
        return;
      }
    } else {
      if (o && (f > a.startX && -s.translate <= s.maxTranslate() || f < a.startX && -s.translate >= s.minTranslate())) return;
      if (!o && (f < a.startX && s.translate <= s.maxTranslate() || f > a.startX && s.translate >= s.minTranslate())) return;
    }
    if (e.activeElement && e.activeElement.matches(n.focusableElements) && e.activeElement !== l.target && l.pointerType !== "mouse" && e.activeElement.blur(), e.activeElement && l.target === e.activeElement && l.target.matches(n.focusableElements)) {
      n.isMoved = !0, s.allowClick = !1;
      return;
    }
    n.allowTouchCallbacks && s.emit("touchMove", l), a.previousX = a.currentX, a.previousY = a.currentY, a.currentX = f, a.currentY = h;
    var v = a.currentX - a.startX,
      m = a.currentY - a.startY;
    if (s.params.threshold && Math.sqrt(Math.pow(v, 2) + Math.pow(m, 2)) < s.params.threshold) return;
    if (_typeof(n.isScrolling) > "u") {
      var x;
      s.isHorizontal() && a.currentY === a.startY || s.isVertical() && a.currentX === a.startX ? n.isScrolling = !1 : v * v + m * m >= 25 && (x = Math.atan2(Math.abs(m), Math.abs(v)) * 180 / Math.PI, n.isScrolling = s.isHorizontal() ? x > r.touchAngle : 90 - x > r.touchAngle);
    }
    if (n.isScrolling && s.emit("touchMoveOpposite", l), _typeof(n.startMoving) > "u" && (a.currentX !== a.startX || a.currentY !== a.startY) && (n.startMoving = !0), n.isScrolling || l.type === "touchmove" && n.preventTouchMoveFromPointerMove) {
      n.isTouched = !1;
      return;
    }
    if (!n.startMoving) return;
    s.allowClick = !1, !r.cssMode && l.cancelable && l.preventDefault(), r.touchMoveStopPropagation && !r.nested && l.stopPropagation();
    var p = s.isHorizontal() ? v : m,
      u = s.isHorizontal() ? a.currentX - a.previousX : a.currentY - a.previousY;
    r.oneWayMovement && (p = Math.abs(p) * (o ? 1 : -1), u = Math.abs(u) * (o ? 1 : -1)), a.diff = p, p *= r.touchRatio, o && (p = -p, u = -u);
    var b = s.touchesDirection;
    s.swipeDirection = p > 0 ? "prev" : "next", s.touchesDirection = u > 0 ? "prev" : "next";
    var C = s.params.loop && !r.cssMode,
      g = s.touchesDirection === "next" && s.allowSlideNext || s.touchesDirection === "prev" && s.allowSlidePrev;
    if (!n.isMoved) {
      if (C && g && s.loopFix({
        direction: s.swipeDirection
      }), n.startTranslate = s.getTranslate(), s.setTransition(0), s.animating) {
        var _x3 = new window.CustomEvent("transitionend", {
          bubbles: !0,
          cancelable: !0,
          detail: {
            bySwiperTouchMove: !0
          }
        });
        s.wrapperEl.dispatchEvent(_x3);
      }
      n.allowMomentumBounce = !1, r.grabCursor && (s.allowSlideNext === !0 || s.allowSlidePrev === !0) && s.setGrabCursor(!0), s.emit("sliderFirstMove", l);
    }
    if (new Date().getTime(), r._loopSwapReset !== !1 && n.isMoved && n.allowThresholdMove && b !== s.touchesDirection && C && g && Math.abs(p) >= 1) {
      Object.assign(a, {
        startX: f,
        startY: h,
        currentX: f,
        currentY: h,
        startTranslate: n.currentTranslate
      }), n.loopSwapReset = !0, n.startTranslate = n.currentTranslate;
      return;
    }
    s.emit("sliderMove", l), n.isMoved = !0, n.currentTranslate = p + n.startTranslate;
    var w = !0,
      y = r.resistanceRatio;
    if (r.touchReleaseOnEdges && (y = 0), p > 0 ? (C && g && n.allowThresholdMove && n.currentTranslate > (r.centeredSlides ? s.minTranslate() - s.slidesSizesGrid[s.activeIndex + 1] - (r.slidesPerView !== "auto" && s.slides.length - r.slidesPerView >= 2 ? s.slidesSizesGrid[s.activeIndex + 1] + s.params.spaceBetween : 0) - s.params.spaceBetween : s.minTranslate()) && s.loopFix({
      direction: "prev",
      setTranslate: !0,
      activeSlideIndex: 0
    }), n.currentTranslate > s.minTranslate() && (w = !1, r.resistance && (n.currentTranslate = s.minTranslate() - 1 + Math.pow(-s.minTranslate() + n.startTranslate + p, y)))) : p < 0 && (C && g && n.allowThresholdMove && n.currentTranslate < (r.centeredSlides ? s.maxTranslate() + s.slidesSizesGrid[s.slidesSizesGrid.length - 1] + s.params.spaceBetween + (r.slidesPerView !== "auto" && s.slides.length - r.slidesPerView >= 2 ? s.slidesSizesGrid[s.slidesSizesGrid.length - 1] + s.params.spaceBetween : 0) : s.maxTranslate()) && s.loopFix({
      direction: "next",
      setTranslate: !0,
      activeSlideIndex: s.slides.length - (r.slidesPerView === "auto" ? s.slidesPerViewDynamic() : Math.ceil(parseFloat(r.slidesPerView, 10)))
    }), n.currentTranslate < s.maxTranslate() && (w = !1, r.resistance && (n.currentTranslate = s.maxTranslate() + 1 - Math.pow(s.maxTranslate() - n.startTranslate - p, y)))), w && (l.preventedByNestedSwiper = !0), !s.allowSlideNext && s.swipeDirection === "next" && n.currentTranslate < n.startTranslate && (n.currentTranslate = n.startTranslate), !s.allowSlidePrev && s.swipeDirection === "prev" && n.currentTranslate > n.startTranslate && (n.currentTranslate = n.startTranslate), !s.allowSlidePrev && !s.allowSlideNext && (n.currentTranslate = n.startTranslate), r.threshold > 0) if (Math.abs(p) > r.threshold || n.allowThresholdMove) {
      if (!n.allowThresholdMove) {
        n.allowThresholdMove = !0, a.startX = a.currentX, a.startY = a.currentY, n.currentTranslate = n.startTranslate, a.diff = s.isHorizontal() ? a.currentX - a.startX : a.currentY - a.startY;
        return;
      }
    } else {
      n.currentTranslate = n.startTranslate;
      return;
    }
    !r.followFinger || r.cssMode || ((r.freeMode && r.freeMode.enabled && s.freeMode || r.watchSlidesProgress) && (s.updateActiveIndex(), s.updateSlidesClasses()), r.freeMode && r.freeMode.enabled && s.freeMode && s.freeMode.onTouchMove(), s.updateProgress(n.currentTranslate), s.setTranslate(n.currentTranslate));
  }
  function Xn(i) {
    var e = this,
      s = e.touchEventsData;
    var n = i;
    n.originalEvent && (n = n.originalEvent);
    var r;
    if (n.type === "touchend" || n.type === "touchcancel") {
      if (r = _toConsumableArray(n.changedTouches).find(function (x) {
        return x.identifier === s.touchId;
      }), !r || r.identifier !== s.touchId) return;
    } else {
      if (s.touchId !== null || n.pointerId !== s.pointerId) return;
      r = n;
    }
    if (["pointercancel", "pointerout", "pointerleave", "contextmenu"].includes(n.type) && !(["pointercancel", "contextmenu"].includes(n.type) && (e.browser.isSafari || e.browser.isWebView))) return;
    s.pointerId = null, s.touchId = null;
    var o = e.params,
      c = e.touches,
      l = e.rtlTranslate,
      d = e.slidesGrid,
      f = e.enabled;
    if (!f || !o.simulateTouch && n.pointerType === "mouse") return;
    if (s.allowTouchCallbacks && e.emit("touchEnd", n), s.allowTouchCallbacks = !1, !s.isTouched) {
      s.isMoved && o.grabCursor && e.setGrabCursor(!1), s.isMoved = !1, s.startMoving = !1;
      return;
    }
    o.grabCursor && s.isMoved && s.isTouched && (e.allowSlideNext === !0 || e.allowSlidePrev === !0) && e.setGrabCursor(!1);
    var h = ie(),
      v = h - s.touchStartTime;
    if (e.allowClick) {
      var x = n.path || n.composedPath && n.composedPath();
      e.updateClickedSlide(x && x[0] || n.target, x), e.emit("tap click", n), v < 300 && h - s.lastClickTime < 300 && e.emit("doubleTap doubleClick", n);
    }
    if (s.lastClickTime = ie(), be(function () {
      e.destroyed || (e.allowClick = !0);
    }), !s.isTouched || !s.isMoved || !e.swipeDirection || c.diff === 0 && !s.loopSwapReset || s.currentTranslate === s.startTranslate && !s.loopSwapReset) {
      s.isTouched = !1, s.isMoved = !1, s.startMoving = !1;
      return;
    }
    s.isTouched = !1, s.isMoved = !1, s.startMoving = !1;
    var m;
    if (o.followFinger ? m = l ? e.translate : -e.translate : m = -s.currentTranslate, o.cssMode) return;
    if (o.freeMode && o.freeMode.enabled) {
      e.freeMode.onTouchEnd({
        currentPos: m
      });
      return;
    }
    var p = m >= -e.maxTranslate() && !e.params.loop;
    var u = 0,
      b = e.slidesSizesGrid[0];
    for (var _x4 = 0; _x4 < d.length; _x4 += _x4 < o.slidesPerGroupSkip ? 1 : o.slidesPerGroup) {
      var T = _x4 < o.slidesPerGroupSkip - 1 ? 1 : o.slidesPerGroup;
      _typeof(d[_x4 + T]) < "u" ? (p || m >= d[_x4] && m < d[_x4 + T]) && (u = _x4, b = d[_x4 + T] - d[_x4]) : (p || m >= d[_x4]) && (u = _x4, b = d[d.length - 1] - d[d.length - 2]);
    }
    var C = null,
      g = null;
    o.rewind && (e.isBeginning ? g = o.virtual && o.virtual.enabled && e.virtual ? e.virtual.slides.length - 1 : e.slides.length - 1 : e.isEnd && (C = 0));
    var w = (m - d[u]) / b,
      y = u < o.slidesPerGroupSkip - 1 ? 1 : o.slidesPerGroup;
    if (v > o.longSwipesMs) {
      if (!o.longSwipes) {
        e.slideTo(e.activeIndex);
        return;
      }
      e.swipeDirection === "next" && (w >= o.longSwipesRatio ? e.slideTo(o.rewind && e.isEnd ? C : u + y) : e.slideTo(u)), e.swipeDirection === "prev" && (w > 1 - o.longSwipesRatio ? e.slideTo(u + y) : g !== null && w < 0 && Math.abs(w) > o.longSwipesRatio ? e.slideTo(g) : e.slideTo(u));
    } else {
      if (!o.shortSwipes) {
        e.slideTo(e.activeIndex);
        return;
      }
      e.navigation && (n.target === e.navigation.nextEl || n.target === e.navigation.prevEl) ? n.target === e.navigation.nextEl ? e.slideTo(u + y) : e.slideTo(u) : (e.swipeDirection === "next" && e.slideTo(C !== null ? C : u + y), e.swipeDirection === "prev" && e.slideTo(g !== null ? g : u));
    }
  }
  function di() {
    var i = this,
      e = i.params,
      s = i.el;
    if (s && s.offsetWidth === 0) return;
    e.breakpoints && i.setBreakpoint();
    var n = i.allowSlideNext,
      r = i.allowSlidePrev,
      a = i.snapGrid,
      o = i.virtual && i.params.virtual.enabled;
    i.allowSlideNext = !0, i.allowSlidePrev = !0, i.updateSize(), i.updateSlides(), i.updateSlidesClasses();
    var c = o && e.loop;
    (e.slidesPerView === "auto" || e.slidesPerView > 1) && i.isEnd && !i.isBeginning && !i.params.centeredSlides && !c ? i.slideTo(i.slides.length - 1, 0, !1, !0) : i.params.loop && !o ? i.slideToLoop(i.realIndex, 0, !1, !0) : i.slideTo(i.activeIndex, 0, !1, !0), i.autoplay && i.autoplay.running && i.autoplay.paused && (clearTimeout(i.autoplay.resizeTimeout), i.autoplay.resizeTimeout = setTimeout(function () {
      i.autoplay && i.autoplay.running && i.autoplay.paused && i.autoplay.resume();
    }, 500)), i.allowSlidePrev = r, i.allowSlideNext = n, i.params.watchOverflow && a !== i.snapGrid && i.checkOverflow();
  }
  function Un(i) {
    var e = this;
    e.enabled && (e.allowClick || (e.params.preventClicks && i.preventDefault(), e.params.preventClicksPropagation && e.animating && (i.stopPropagation(), i.stopImmediatePropagation())));
  }
  function qn() {
    var i = this,
      e = i.wrapperEl,
      s = i.rtlTranslate,
      n = i.enabled;
    if (!n) return;
    i.previousTranslate = i.translate, i.isHorizontal() ? i.translate = -e.scrollLeft : i.translate = -e.scrollTop, i.translate === 0 && (i.translate = 0), i.updateActiveIndex(), i.updateSlidesClasses();
    var r;
    var a = i.maxTranslate() - i.minTranslate();
    a === 0 ? r = 0 : r = (i.translate - i.minTranslate()) / a, r !== i.progress && i.updateProgress(s ? -i.translate : i.translate), i.emit("setTranslate", i.translate, !1);
  }
  function Kn(i) {
    var e = this;
    Ke(e, i.target), !(e.params.cssMode || e.params.slidesPerView !== "auto" && !e.params.autoHeight) && e.update();
  }
  function Jn() {
    var i = this;
    i.documentTouchHandlerProceeded || (i.documentTouchHandlerProceeded = !0, i.params.touchReleaseOnEdges && (i.el.style.touchAction = "auto"));
  }
  var pi = function pi(i, e) {
    var s = Y(),
      n = i.params,
      r = i.el,
      a = i.wrapperEl,
      o = i.device,
      c = !!n.nested,
      l = e === "on" ? "addEventListener" : "removeEventListener",
      d = e;
    !r || typeof r == "string" || (s[l]("touchstart", i.onDocumentTouchStart, {
      passive: !1,
      capture: c
    }), r[l]("touchstart", i.onTouchStart, {
      passive: !1
    }), r[l]("pointerdown", i.onTouchStart, {
      passive: !1
    }), s[l]("touchmove", i.onTouchMove, {
      passive: !1,
      capture: c
    }), s[l]("pointermove", i.onTouchMove, {
      passive: !1,
      capture: c
    }), s[l]("touchend", i.onTouchEnd, {
      passive: !0
    }), s[l]("pointerup", i.onTouchEnd, {
      passive: !0
    }), s[l]("pointercancel", i.onTouchEnd, {
      passive: !0
    }), s[l]("touchcancel", i.onTouchEnd, {
      passive: !0
    }), s[l]("pointerout", i.onTouchEnd, {
      passive: !0
    }), s[l]("pointerleave", i.onTouchEnd, {
      passive: !0
    }), s[l]("contextmenu", i.onTouchEnd, {
      passive: !0
    }), (n.preventClicks || n.preventClicksPropagation) && r[l]("click", i.onClick, !0), n.cssMode && a[l]("scroll", i.onScroll), n.updateOnWindowResize ? i[d](o.ios || o.android ? "resize orientationchange observerUpdate" : "resize observerUpdate", di, !0) : i[d]("observerUpdate", di, !0), r[l]("load", i.onLoad, {
      capture: !0
    }));
  };
  function Qn() {
    var i = this,
      e = i.params;
    i.onTouchStart = Gn.bind(i), i.onTouchMove = Yn.bind(i), i.onTouchEnd = Xn.bind(i), i.onDocumentTouchStart = Jn.bind(i), e.cssMode && (i.onScroll = qn.bind(i)), i.onClick = Un.bind(i), i.onLoad = Kn.bind(i), pi(i, "on");
  }
  function er() {
    pi(this, "off");
  }
  var tr = {
    attachEvents: Qn,
    detachEvents: er
  };
  var fi = function fi(i, e) {
    return i.grid && e.grid && e.grid.rows > 1;
  };
  function ir() {
    var i = this,
      e = i.realIndex,
      s = i.initialized,
      n = i.params,
      r = i.el,
      a = n.breakpoints;
    if (!a || a && Object.keys(a).length === 0) return;
    var o = Y(),
      c = n.breakpointsBase === "window" || !n.breakpointsBase ? n.breakpointsBase : "container",
      l = ["window", "container"].includes(n.breakpointsBase) || !n.breakpointsBase ? i.el : o.querySelector(n.breakpointsBase),
      d = i.getBreakpoint(a, c, l);
    if (!d || i.currentBreakpoint === d) return;
    var h = (d in a ? a[d] : void 0) || i.originalParams,
      v = fi(i, n),
      m = fi(i, h),
      p = i.params.grabCursor,
      u = h.grabCursor,
      b = n.enabled;
    v && !m ? (r.classList.remove("".concat(n.containerModifierClass, "grid"), "".concat(n.containerModifierClass, "grid-column")), i.emitContainerClasses()) : !v && m && (r.classList.add("".concat(n.containerModifierClass, "grid")), (h.grid.fill && h.grid.fill === "column" || !h.grid.fill && n.grid.fill === "column") && r.classList.add("".concat(n.containerModifierClass, "grid-column")), i.emitContainerClasses()), p && !u ? i.unsetGrabCursor() : !p && u && i.setGrabCursor(), ["navigation", "pagination", "scrollbar"].forEach(function (T) {
      if (_typeof(h[T]) > "u") return;
      var S = n[T] && n[T].enabled,
        L = h[T] && h[T].enabled;
      S && !L && i[T].disable(), !S && L && i[T].enable();
    });
    var C = h.direction && h.direction !== n.direction,
      g = n.loop && (h.slidesPerView !== n.slidesPerView || C),
      w = n.loop;
    C && s && i.changeDirection(), J(i.params, h);
    var y = i.params.enabled,
      x = i.params.loop;
    Object.assign(i, {
      allowTouchMove: i.params.allowTouchMove,
      allowSlideNext: i.params.allowSlideNext,
      allowSlidePrev: i.params.allowSlidePrev
    }), b && !y ? i.disable() : !b && y && i.enable(), i.currentBreakpoint = d, i.emit("_beforeBreakpoint", h), s && (g ? (i.loopDestroy(), i.loopCreate(e), i.updateSlides()) : !w && x ? (i.loopCreate(e), i.updateSlides()) : w && !x && i.loopDestroy()), i.emit("breakpoint", h);
  }
  function sr(i, e, s) {
    if (e === void 0 && (e = "window"), !i || e === "container" && !s) return;
    var n = !1;
    var r = W(),
      a = e === "window" ? r.innerHeight : s.clientHeight,
      o = Object.keys(i).map(function (c) {
        if (typeof c == "string" && c.indexOf("@") === 0) {
          var l = parseFloat(c.substr(1));
          return {
            value: a * l,
            point: c
          };
        }
        return {
          value: c,
          point: c
        };
      });
    o.sort(function (c, l) {
      return parseInt(c.value, 10) - parseInt(l.value, 10);
    });
    for (var c = 0; c < o.length; c += 1) {
      var _o$c = o[c],
        l = _o$c.point,
        d = _o$c.value;
      e === "window" ? r.matchMedia("(min-width: ".concat(d, "px)")).matches && (n = l) : d <= s.clientWidth && (n = l);
    }
    return n || "max";
  }
  var nr = {
    setBreakpoint: ir,
    getBreakpoint: sr
  };
  function rr(i, e) {
    var s = [];
    return i.forEach(function (n) {
      _typeof(n) == "object" ? Object.keys(n).forEach(function (r) {
        n[r] && s.push(e + r);
      }) : typeof n == "string" && s.push(e + n);
    }), s;
  }
  function ar() {
    var _r$classList;
    var i = this,
      e = i.classNames,
      s = i.params,
      n = i.rtl,
      r = i.el,
      a = i.device,
      o = rr(["initialized", s.direction, {
        "free-mode": i.params.freeMode && s.freeMode.enabled
      }, {
        autoheight: s.autoHeight
      }, {
        rtl: n
      }, {
        grid: s.grid && s.grid.rows > 1
      }, {
        "grid-column": s.grid && s.grid.rows > 1 && s.grid.fill === "column"
      }, {
        android: a.android
      }, {
        ios: a.ios
      }, {
        "css-mode": s.cssMode
      }, {
        centered: s.cssMode && s.centeredSlides
      }, {
        "watch-progress": s.watchSlidesProgress
      }], s.containerModifierClass);
    e.push.apply(e, _toConsumableArray(o)), (_r$classList = r.classList).add.apply(_r$classList, _toConsumableArray(e)), i.emitContainerClasses();
  }
  function lr() {
    var _e$classList;
    var i = this,
      e = i.el,
      s = i.classNames;
    !e || typeof e == "string" || ((_e$classList = e.classList).remove.apply(_e$classList, _toConsumableArray(s)), i.emitContainerClasses());
  }
  var or = {
    addClasses: ar,
    removeClasses: lr
  };
  function cr() {
    var i = this,
      e = i.isLocked,
      s = i.params,
      n = s.slidesOffsetBefore;
    if (n) {
      var r = i.slides.length - 1,
        a = i.slidesGrid[r] + i.slidesSizesGrid[r] + n * 2;
      i.isLocked = i.size > a;
    } else i.isLocked = i.snapGrid.length === 1;
    s.allowSlideNext === !0 && (i.allowSlideNext = !i.isLocked), s.allowSlidePrev === !0 && (i.allowSlidePrev = !i.isLocked), e && e !== i.isLocked && (i.isEnd = !1), e !== i.isLocked && i.emit(i.isLocked ? "lock" : "unlock");
  }
  var dr = {
      checkOverflow: cr
    },
    Vt = {
      init: !0,
      direction: "horizontal",
      oneWayMovement: !1,
      swiperElementNodeName: "SWIPER-CONTAINER",
      touchEventsTarget: "wrapper",
      initialSlide: 0,
      speed: 300,
      cssMode: !1,
      updateOnWindowResize: !0,
      resizeObserver: !0,
      nested: !1,
      createElements: !1,
      eventsPrefix: "swiper",
      enabled: !0,
      focusableElements: "input, select, option, textarea, button, video, label",
      width: null,
      height: null,
      preventInteractionOnTransition: !1,
      userAgent: null,
      url: null,
      edgeSwipeDetection: !1,
      edgeSwipeThreshold: 20,
      autoHeight: !1,
      setWrapperSize: !1,
      virtualTranslate: !1,
      effect: "slide",
      breakpoints: void 0,
      breakpointsBase: "window",
      spaceBetween: 0,
      slidesPerView: 1,
      slidesPerGroup: 1,
      slidesPerGroupSkip: 0,
      slidesPerGroupAuto: !1,
      centeredSlides: !1,
      centeredSlidesBounds: !1,
      slidesOffsetBefore: 0,
      slidesOffsetAfter: 0,
      normalizeSlideIndex: !0,
      centerInsufficientSlides: !1,
      watchOverflow: !0,
      roundLengths: !1,
      touchRatio: 1,
      touchAngle: 45,
      simulateTouch: !0,
      shortSwipes: !0,
      longSwipes: !0,
      longSwipesRatio: .5,
      longSwipesMs: 300,
      followFinger: !0,
      allowTouchMove: !0,
      threshold: 5,
      touchMoveStopPropagation: !1,
      touchStartPreventDefault: !0,
      touchStartForcePreventDefault: !1,
      touchReleaseOnEdges: !1,
      uniqueNavElements: !0,
      resistance: !0,
      resistanceRatio: .85,
      watchSlidesProgress: !1,
      grabCursor: !1,
      preventClicks: !0,
      preventClicksPropagation: !0,
      slideToClickedSlide: !1,
      loop: !1,
      loopAddBlankSlides: !0,
      loopAdditionalSlides: 0,
      loopPreventsSliding: !0,
      rewind: !1,
      allowSlidePrev: !0,
      allowSlideNext: !0,
      swipeHandler: null,
      noSwiping: !0,
      noSwipingClass: "swiper-no-swiping",
      noSwipingSelector: null,
      passiveListeners: !0,
      maxBackfaceHiddenSlides: 10,
      containerModifierClass: "swiper-",
      slideClass: "swiper-slide",
      slideBlankClass: "swiper-slide-blank",
      slideActiveClass: "swiper-slide-active",
      slideVisibleClass: "swiper-slide-visible",
      slideFullyVisibleClass: "swiper-slide-fully-visible",
      slideNextClass: "swiper-slide-next",
      slidePrevClass: "swiper-slide-prev",
      wrapperClass: "swiper-wrapper",
      lazyPreloaderClass: "swiper-lazy-preloader",
      lazyPreloadPrevNext: 0,
      runCallbacksOnInit: !0,
      _emitClasses: !1
    };
  function pr(i, e) {
    return function (n) {
      n === void 0 && (n = {});
      var r = Object.keys(n)[0],
        a = n[r];
      if (_typeof(a) != "object" || a === null) {
        J(e, n);
        return;
      }
      if (i[r] === !0 && (i[r] = {
        enabled: !0
      }), r === "navigation" && i[r] && i[r].enabled && !i[r].prevEl && !i[r].nextEl && (i[r].auto = !0), ["pagination", "scrollbar"].indexOf(r) >= 0 && i[r] && i[r].enabled && !i[r].el && (i[r].auto = !0), !(r in i && "enabled" in a)) {
        J(e, n);
        return;
      }
      _typeof(i[r]) == "object" && !("enabled" in i[r]) && (i[r].enabled = !0), i[r] || (i[r] = {
        enabled: !1
      }), J(e, n);
    };
  }
  var Tt = {
      eventsEmitter: on,
      update: vn,
      translate: Sn,
      transition: Ln,
      slide: In,
      loop: Fn,
      grabCursor: jn,
      events: tr,
      breakpoints: nr,
      checkOverflow: dr,
      classes: or
    },
    Lt = {};
  var ee = /*#__PURE__*/function () {
    function ee() {
      var _r2, _r3, _c$modules;
      _classCallCheck(this, ee);
      var e, s;
      for (var n = arguments.length, r = new Array(n), a = 0; a < n; a++) r[a] = arguments[a];
      r.length === 1 && r[0].constructor && Object.prototype.toString.call(r[0]).slice(8, -1) === "Object" ? s = r[0] : (_r2 = r, _r3 = _slicedToArray(_r2, 2), e = _r3[0], s = _r3[1], _r2), s || (s = {}), s = J({}, s), e && !s.el && (s.el = e);
      var o = Y();
      if (s.el && typeof s.el == "string" && o.querySelectorAll(s.el).length > 1) {
        var f = [];
        return o.querySelectorAll(s.el).forEach(function (h) {
          var v = J({}, s, {
            el: h
          });
          f.push(new ee(v));
        }), f;
      }
      var c = this;
      c.__swiper__ = !0, c.support = ni(), c.device = ri({
        userAgent: s.userAgent
      }), c.browser = ai(), c.eventsListeners = {}, c.eventsAnyListeners = [], c.modules = _toConsumableArray(c.__modules__), s.modules && Array.isArray(s.modules) && (_c$modules = c.modules).push.apply(_c$modules, _toConsumableArray(s.modules));
      var l = {};
      c.modules.forEach(function (f) {
        f({
          params: s,
          swiper: c,
          extendParams: pr(s, l),
          on: c.on.bind(c),
          once: c.once.bind(c),
          off: c.off.bind(c),
          emit: c.emit.bind(c)
        });
      });
      var d = J({}, Vt, l);
      return c.params = J({}, d, Lt, s), c.originalParams = J({}, c.params), c.passedParams = J({}, s), c.params && c.params.on && Object.keys(c.params.on).forEach(function (f) {
        c.on(f, c.params.on[f]);
      }), c.params && c.params.onAny && c.onAny(c.params.onAny), Object.assign(c, {
        enabled: c.params.enabled,
        el: e,
        classNames: [],
        slides: [],
        slidesGrid: [],
        snapGrid: [],
        slidesSizesGrid: [],
        isHorizontal: function isHorizontal() {
          return c.params.direction === "horizontal";
        },
        isVertical: function isVertical() {
          return c.params.direction === "vertical";
        },
        activeIndex: 0,
        realIndex: 0,
        isBeginning: !0,
        isEnd: !1,
        translate: 0,
        previousTranslate: 0,
        progress: 0,
        velocity: 0,
        animating: !1,
        cssOverflowAdjustment: function cssOverflowAdjustment() {
          return Math.trunc(this.translate / Math.pow(2, 23)) * Math.pow(2, 23);
        },
        allowSlideNext: c.params.allowSlideNext,
        allowSlidePrev: c.params.allowSlidePrev,
        touchEventsData: {
          isTouched: void 0,
          isMoved: void 0,
          allowTouchCallbacks: void 0,
          touchStartTime: void 0,
          isScrolling: void 0,
          currentTranslate: void 0,
          startTranslate: void 0,
          allowThresholdMove: void 0,
          focusableElements: c.params.focusableElements,
          lastClickTime: 0,
          clickTimeout: void 0,
          velocities: [],
          allowMomentumBounce: void 0,
          startMoving: void 0,
          pointerId: null,
          touchId: null
        },
        allowClick: !0,
        allowTouchMove: c.params.allowTouchMove,
        touches: {
          startX: 0,
          startY: 0,
          currentX: 0,
          currentY: 0,
          diff: 0
        },
        imagesToLoad: [],
        imagesLoaded: 0
      }), c.emit("_swiper"), c.params.init && c.init(), c;
    }
    return _createClass(ee, [{
      key: "getDirectionLabel",
      value: function getDirectionLabel(e) {
        return this.isHorizontal() ? e : {
          width: "height",
          "margin-top": "margin-left",
          "margin-bottom ": "margin-right",
          "margin-left": "margin-top",
          "margin-right": "margin-bottom",
          "padding-left": "padding-top",
          "padding-right": "padding-bottom",
          marginRight: "marginBottom"
        }[e];
      }
    }, {
      key: "getSlideIndex",
      value: function getSlideIndex(e) {
        var s = this.slidesEl,
          n = this.params,
          r = U(s, ".".concat(n.slideClass, ", swiper-slide")),
          a = Oe(r[0]);
        return Oe(e) - a;
      }
    }, {
      key: "getSlideIndexByData",
      value: function getSlideIndexByData(e) {
        return this.getSlideIndex(this.slides.find(function (s) {
          return s.getAttribute("data-swiper-slide-index") * 1 === e;
        }));
      }
    }, {
      key: "recalcSlides",
      value: function recalcSlides() {
        var e = this,
          s = e.slidesEl,
          n = e.params;
        e.slides = U(s, ".".concat(n.slideClass, ", swiper-slide"));
      }
    }, {
      key: "enable",
      value: function enable() {
        var e = this;
        e.enabled || (e.enabled = !0, e.params.grabCursor && e.setGrabCursor(), e.emit("enable"));
      }
    }, {
      key: "disable",
      value: function disable() {
        var e = this;
        e.enabled && (e.enabled = !1, e.params.grabCursor && e.unsetGrabCursor(), e.emit("disable"));
      }
    }, {
      key: "setProgress",
      value: function setProgress(e, s) {
        var n = this;
        e = Math.min(Math.max(e, 0), 1);
        var r = n.minTranslate(),
          o = (n.maxTranslate() - r) * e + r;
        n.translateTo(o, _typeof(s) > "u" ? 0 : s), n.updateActiveIndex(), n.updateSlidesClasses();
      }
    }, {
      key: "emitContainerClasses",
      value: function emitContainerClasses() {
        var e = this;
        if (!e.params._emitClasses || !e.el) return;
        var s = e.el.className.split(" ").filter(function (n) {
          return n.indexOf("swiper") === 0 || n.indexOf(e.params.containerModifierClass) === 0;
        });
        e.emit("_containerClasses", s.join(" "));
      }
    }, {
      key: "getSlideClasses",
      value: function getSlideClasses(e) {
        var s = this;
        return s.destroyed ? "" : e.className.split(" ").filter(function (n) {
          return n.indexOf("swiper-slide") === 0 || n.indexOf(s.params.slideClass) === 0;
        }).join(" ");
      }
    }, {
      key: "emitSlidesClasses",
      value: function emitSlidesClasses() {
        var e = this;
        if (!e.params._emitClasses || !e.el) return;
        var s = [];
        e.slides.forEach(function (n) {
          var r = e.getSlideClasses(n);
          s.push({
            slideEl: n,
            classNames: r
          }), e.emit("_slideClass", n, r);
        }), e.emit("_slideClasses", s);
      }
    }, {
      key: "slidesPerViewDynamic",
      value: function slidesPerViewDynamic(e, s) {
        e === void 0 && (e = "current"), s === void 0 && (s = !1);
        var n = this,
          r = n.params,
          a = n.slides,
          o = n.slidesGrid,
          c = n.slidesSizesGrid,
          l = n.size,
          d = n.activeIndex;
        var f = 1;
        if (typeof r.slidesPerView == "number") return r.slidesPerView;
        if (r.centeredSlides) {
          var h = a[d] ? Math.ceil(a[d].swiperSlideSize) : 0,
            v;
          for (var m = d + 1; m < a.length; m += 1) a[m] && !v && (h += Math.ceil(a[m].swiperSlideSize), f += 1, h > l && (v = !0));
          for (var _m3 = d - 1; _m3 >= 0; _m3 -= 1) a[_m3] && !v && (h += a[_m3].swiperSlideSize, f += 1, h > l && (v = !0));
        } else if (e === "current") for (var _h4 = d + 1; _h4 < a.length; _h4 += 1) (s ? o[_h4] + c[_h4] - o[d] < l : o[_h4] - o[d] < l) && (f += 1);else for (var _h5 = d - 1; _h5 >= 0; _h5 -= 1) o[d] - o[_h5] < l && (f += 1);
        return f;
      }
    }, {
      key: "update",
      value: function update() {
        var e = this;
        if (!e || e.destroyed) return;
        var s = e.snapGrid,
          n = e.params;
        n.breakpoints && e.setBreakpoint(), _toConsumableArray(e.el.querySelectorAll('[loading="lazy"]')).forEach(function (o) {
          o.complete && Ke(e, o);
        }), e.updateSize(), e.updateSlides(), e.updateProgress(), e.updateSlidesClasses();
        function r() {
          var o = e.rtlTranslate ? e.translate * -1 : e.translate,
            c = Math.min(Math.max(o, e.maxTranslate()), e.minTranslate());
          e.setTranslate(c), e.updateActiveIndex(), e.updateSlidesClasses();
        }
        var a;
        if (n.freeMode && n.freeMode.enabled && !n.cssMode) r(), n.autoHeight && e.updateAutoHeight();else {
          if ((n.slidesPerView === "auto" || n.slidesPerView > 1) && e.isEnd && !n.centeredSlides) {
            var o = e.virtual && n.virtual.enabled ? e.virtual.slides : e.slides;
            a = e.slideTo(o.length - 1, 0, !1, !0);
          } else a = e.slideTo(e.activeIndex, 0, !1, !0);
          a || r();
        }
        n.watchOverflow && s !== e.snapGrid && e.checkOverflow(), e.emit("update");
      }
    }, {
      key: "changeDirection",
      value: function changeDirection(e, s) {
        s === void 0 && (s = !0);
        var n = this,
          r = n.params.direction;
        return e || (e = r === "horizontal" ? "vertical" : "horizontal"), e === r || e !== "horizontal" && e !== "vertical" || (n.el.classList.remove("".concat(n.params.containerModifierClass).concat(r)), n.el.classList.add("".concat(n.params.containerModifierClass).concat(e)), n.emitContainerClasses(), n.params.direction = e, n.slides.forEach(function (a) {
          e === "vertical" ? a.style.width = "" : a.style.height = "";
        }), n.emit("changeDirection"), s && n.update()), n;
      }
    }, {
      key: "changeLanguageDirection",
      value: function changeLanguageDirection(e) {
        var s = this;
        s.rtl && e === "rtl" || !s.rtl && e === "ltr" || (s.rtl = e === "rtl", s.rtlTranslate = s.params.direction === "horizontal" && s.rtl, s.rtl ? (s.el.classList.add("".concat(s.params.containerModifierClass, "rtl")), s.el.dir = "rtl") : (s.el.classList.remove("".concat(s.params.containerModifierClass, "rtl")), s.el.dir = "ltr"), s.update());
      }
    }, {
      key: "mount",
      value: function mount(e) {
        var s = this;
        if (s.mounted) return !0;
        var n = e || s.params.el;
        if (typeof n == "string" && (n = document.querySelector(n)), !n) return !1;
        n.swiper = s, n.parentNode && n.parentNode.host && n.parentNode.host.nodeName === s.params.swiperElementNodeName.toUpperCase() && (s.isElement = !0);
        var r = function r() {
          return ".".concat((s.params.wrapperClass || "").trim().split(" ").join("."));
        };
        var o = n && n.shadowRoot && n.shadowRoot.querySelector ? n.shadowRoot.querySelector(r()) : U(n, r())[0];
        return !o && s.params.createElements && (o = Q("div", s.params.wrapperClass), n.append(o), U(n, ".".concat(s.params.slideClass)).forEach(function (c) {
          o.append(c);
        })), Object.assign(s, {
          el: n,
          wrapperEl: o,
          slidesEl: s.isElement && !n.parentNode.host.slideSlots ? n.parentNode.host : o,
          hostEl: s.isElement ? n.parentNode.host : n,
          mounted: !0,
          rtl: n.dir.toLowerCase() === "rtl" || de(n, "direction") === "rtl",
          rtlTranslate: s.params.direction === "horizontal" && (n.dir.toLowerCase() === "rtl" || de(n, "direction") === "rtl"),
          wrongRTL: de(o, "display") === "-webkit-box"
        }), !0;
      }
    }, {
      key: "init",
      value: function init(e) {
        var s = this;
        if (s.initialized || s.mount(e) === !1) return s;
        s.emit("beforeInit"), s.params.breakpoints && s.setBreakpoint(), s.addClasses(), s.updateSize(), s.updateSlides(), s.params.watchOverflow && s.checkOverflow(), s.params.grabCursor && s.enabled && s.setGrabCursor(), s.params.loop && s.virtual && s.params.virtual.enabled ? s.slideTo(s.params.initialSlide + s.virtual.slidesBefore, 0, s.params.runCallbacksOnInit, !1, !0) : s.slideTo(s.params.initialSlide, 0, s.params.runCallbacksOnInit, !1, !0), s.params.loop && s.loopCreate(void 0, !0), s.attachEvents();
        var r = _toConsumableArray(s.el.querySelectorAll('[loading="lazy"]'));
        return s.isElement && r.push.apply(r, _toConsumableArray(s.hostEl.querySelectorAll('[loading="lazy"]'))), r.forEach(function (a) {
          a.complete ? Ke(s, a) : a.addEventListener("load", function (o) {
            Ke(s, o.target);
          });
        }), Mt(s), s.initialized = !0, Mt(s), s.emit("init"), s.emit("afterInit"), s;
      }
    }, {
      key: "destroy",
      value: function destroy(e, s) {
        e === void 0 && (e = !0), s === void 0 && (s = !0);
        var n = this,
          r = n.params,
          a = n.el,
          o = n.wrapperEl,
          c = n.slides;
        return _typeof(n.params) > "u" || n.destroyed || (n.emit("beforeDestroy"), n.initialized = !1, n.detachEvents(), r.loop && n.loopDestroy(), s && (n.removeClasses(), a && typeof a != "string" && a.removeAttribute("style"), o && o.removeAttribute("style"), c && c.length && c.forEach(function (l) {
          l.classList.remove(r.slideVisibleClass, r.slideFullyVisibleClass, r.slideActiveClass, r.slideNextClass, r.slidePrevClass), l.removeAttribute("style"), l.removeAttribute("data-swiper-slide-index");
        })), n.emit("destroy"), Object.keys(n.eventsListeners).forEach(function (l) {
          n.off(l);
        }), e !== !1 && (n.el && typeof n.el != "string" && (n.el.swiper = null), Us(n)), n.destroyed = !0), null;
      }
    }], [{
      key: "extendDefaults",
      value: function extendDefaults(e) {
        J(Lt, e);
      }
    }, {
      key: "extendedDefaults",
      get: function get() {
        return Lt;
      }
    }, {
      key: "defaults",
      get: function get() {
        return Vt;
      }
    }, {
      key: "installModule",
      value: function installModule(e) {
        ee.prototype.__modules__ || (ee.prototype.__modules__ = []);
        var s = ee.prototype.__modules__;
        typeof e == "function" && s.indexOf(e) < 0 && s.push(e);
      }
    }, {
      key: "use",
      value: function use(e) {
        return Array.isArray(e) ? (e.forEach(function (s) {
          return ee.installModule(s);
        }), ee) : (ee.installModule(e), ee);
      }
    }]);
  }();
  Object.keys(Tt).forEach(function (i) {
    Object.keys(Tt[i]).forEach(function (e) {
      ee.prototype[e] = Tt[i][e];
    });
  }), ee.use([an, ln]);
  function fr(i) {
    var e = i.swiper,
      s = i.extendParams,
      n = i.on,
      r = i.emit;
    s({
      virtual: {
        enabled: !1,
        slides: [],
        cache: !0,
        renderSlide: null,
        renderExternal: null,
        renderExternalUpdate: !0,
        addSlidesBefore: 0,
        addSlidesAfter: 0
      }
    });
    var a;
    var o = Y();
    e.virtual = {
      cache: {},
      from: void 0,
      to: void 0,
      slides: [],
      offset: 0,
      slidesGrid: []
    };
    var c = o.createElement("div");
    function l(p, u) {
      var b = e.params.virtual;
      if (b.cache && e.virtual.cache[u]) return e.virtual.cache[u];
      var C;
      return b.renderSlide ? (C = b.renderSlide.call(e, p, u), typeof C == "string" && (c.innerHTML = C, C = c.children[0])) : e.isElement ? C = Q("swiper-slide") : C = Q("div", e.params.slideClass), C.setAttribute("data-swiper-slide-index", u), b.renderSlide || (C.innerHTML = p), b.cache && (e.virtual.cache[u] = C), C;
    }
    function d(p, u, b) {
      var _e$params = e.params,
        C = _e$params.slidesPerView,
        g = _e$params.slidesPerGroup,
        w = _e$params.centeredSlides,
        y = _e$params.loop,
        x = _e$params.initialSlide;
      if (u && !y && x > 0) return;
      var _e$params$virtual = e.params.virtual,
        T = _e$params$virtual.addSlidesBefore,
        S = _e$params$virtual.addSlidesAfter,
        _e$virtual = e.virtual,
        L = _e$virtual.from,
        E = _e$virtual.to,
        M = _e$virtual.slides,
        P = _e$virtual.slidesGrid,
        B = _e$virtual.offset;
      e.params.cssMode || e.updateActiveIndex();
      var H = _typeof(b) > "u" ? e.activeIndex || 0 : b;
      var z;
      e.rtlTranslate ? z = "right" : z = e.isHorizontal() ? "left" : "top";
      var I, $;
      w ? (I = Math.floor(C / 2) + g + S, $ = Math.floor(C / 2) + g + T) : (I = C + (g - 1) + S, $ = (y ? C : g) + T);
      var k = H - $,
        V = H + I;
      y || (k = Math.max(k, 0), V = Math.min(V, M.length - 1));
      var A = (e.slidesGrid[k] || 0) - (e.slidesGrid[0] || 0);
      y && H >= $ ? (k -= $, w || (A += e.slidesGrid[0])) : y && H < $ && (k = -$, w && (A += e.slidesGrid[0])), Object.assign(e.virtual, {
        from: k,
        to: V,
        offset: A,
        slidesGrid: e.slidesGrid,
        slidesBefore: $,
        slidesAfter: I
      });
      function F() {
        e.updateSlides(), e.updateProgress(), e.updateSlidesClasses(), r("virtualUpdate");
      }
      if (L === k && E === V && !p) {
        e.slidesGrid !== P && A !== B && e.slides.forEach(function (N) {
          N.style[z] = "".concat(A - Math.abs(e.cssOverflowAdjustment()), "px");
        }), e.updateProgress(), r("virtualUpdate");
        return;
      }
      if (e.params.virtual.renderExternal) {
        e.params.virtual.renderExternal.call(e, {
          offset: A,
          from: k,
          to: V,
          slides: function () {
            var D = [];
            for (var R = k; R <= V; R += 1) D.push(M[R]);
            return D;
          }()
        }), e.params.virtual.renderExternalUpdate ? F() : r("virtualUpdate");
        return;
      }
      var j = [],
        G = [],
        X = function X(N) {
          var D = N;
          return N < 0 ? D = M.length + N : D >= M.length && (D = D - M.length), D;
        };
      if (p) e.slides.filter(function (N) {
        return N.matches(".".concat(e.params.slideClass, ", swiper-slide"));
      }).forEach(function (N) {
        N.remove();
      });else {
        var _loop2 = function _loop2() {
          if (N < k || N > V) {
            var D = X(N);
            e.slides.filter(function (R) {
              return R.matches(".".concat(e.params.slideClass, "[data-swiper-slide-index=\"").concat(D, "\"], swiper-slide[data-swiper-slide-index=\"").concat(D, "\"]"));
            }).forEach(function (R) {
              R.remove();
            });
          }
        };
        for (var N = L; N <= E; N += 1) {
          _loop2();
        }
      }
      var te = y ? -M.length : 0,
        _ = y ? M.length * 2 : M.length;
      for (var _N = te; _N < _; _N += 1) if (_N >= k && _N <= V) {
        var D = X(_N);
        _typeof(E) > "u" || p ? G.push(D) : (_N > E && G.push(D), _N < L && j.push(D));
      }
      if (G.forEach(function (N) {
        e.slidesEl.append(l(M[N], N));
      }), y) for (var _N2 = j.length - 1; _N2 >= 0; _N2 -= 1) {
        var _D = j[_N2];
        e.slidesEl.prepend(l(M[_D], _D));
      } else j.sort(function (N, D) {
        return D - N;
      }), j.forEach(function (N) {
        e.slidesEl.prepend(l(M[N], N));
      });
      U(e.slidesEl, ".swiper-slide, swiper-slide").forEach(function (N) {
        N.style[z] = "".concat(A - Math.abs(e.cssOverflowAdjustment()), "px");
      }), F();
    }
    function f(p) {
      if (_typeof(p) == "object" && "length" in p) for (var u = 0; u < p.length; u += 1) p[u] && e.virtual.slides.push(p[u]);else e.virtual.slides.push(p);
      d(!0);
    }
    function h(p) {
      var u = e.activeIndex;
      var b = u + 1,
        C = 1;
      if (Array.isArray(p)) {
        for (var g = 0; g < p.length; g += 1) p[g] && e.virtual.slides.unshift(p[g]);
        b = u + p.length, C = p.length;
      } else e.virtual.slides.unshift(p);
      if (e.params.virtual.cache) {
        var _g2 = e.virtual.cache,
          w = {};
        Object.keys(_g2).forEach(function (y) {
          var x = _g2[y],
            T = x.getAttribute("data-swiper-slide-index");
          T && x.setAttribute("data-swiper-slide-index", parseInt(T, 10) + C), w[parseInt(y, 10) + C] = x;
        }), e.virtual.cache = w;
      }
      d(!0), e.slideTo(b, 0);
    }
    function v(p) {
      if (_typeof(p) > "u" || p === null) return;
      var u = e.activeIndex;
      if (Array.isArray(p)) for (var b = p.length - 1; b >= 0; b -= 1) e.params.virtual.cache && (delete e.virtual.cache[p[b]], Object.keys(e.virtual.cache).forEach(function (C) {
        C > p && (e.virtual.cache[C - 1] = e.virtual.cache[C], e.virtual.cache[C - 1].setAttribute("data-swiper-slide-index", C - 1), delete e.virtual.cache[C]);
      })), e.virtual.slides.splice(p[b], 1), p[b] < u && (u -= 1), u = Math.max(u, 0);else e.params.virtual.cache && (delete e.virtual.cache[p], Object.keys(e.virtual.cache).forEach(function (b) {
        b > p && (e.virtual.cache[b - 1] = e.virtual.cache[b], e.virtual.cache[b - 1].setAttribute("data-swiper-slide-index", b - 1), delete e.virtual.cache[b]);
      })), e.virtual.slides.splice(p, 1), p < u && (u -= 1), u = Math.max(u, 0);
      d(!0), e.slideTo(u, 0);
    }
    function m() {
      e.virtual.slides = [], e.params.virtual.cache && (e.virtual.cache = {}), d(!0), e.slideTo(0, 0);
    }
    n("beforeInit", function () {
      if (!e.params.virtual.enabled) return;
      var p;
      if (_typeof(e.passedParams.virtual.slides) > "u") {
        var u = _toConsumableArray(e.slidesEl.children).filter(function (b) {
          return b.matches(".".concat(e.params.slideClass, ", swiper-slide"));
        });
        u && u.length && (e.virtual.slides = _toConsumableArray(u), p = !0, u.forEach(function (b, C) {
          b.setAttribute("data-swiper-slide-index", C), e.virtual.cache[C] = b, b.remove();
        }));
      }
      p || (e.virtual.slides = e.params.virtual.slides), e.classNames.push("".concat(e.params.containerModifierClass, "virtual")), e.params.watchSlidesProgress = !0, e.originalParams.watchSlidesProgress = !0, d(!1, !0);
    }), n("setTranslate", function () {
      e.params.virtual.enabled && (e.params.cssMode && !e._immediateVirtual ? (clearTimeout(a), a = setTimeout(function () {
        d();
      }, 100)) : d());
    }), n("init update resize", function () {
      e.params.virtual.enabled && e.params.cssMode && De(e.wrapperEl, "--swiper-virtual-size", "".concat(e.virtualSize, "px"));
    }), Object.assign(e.virtual, {
      appendSlide: f,
      prependSlide: h,
      removeSlide: v,
      removeAllSlides: m,
      update: d
    });
  }
  function ur(i) {
    var e = i.swiper,
      s = i.extendParams,
      n = i.on,
      r = i.emit;
    var a = Y(),
      o = W();
    e.keyboard = {
      enabled: !1
    }, s({
      keyboard: {
        enabled: !1,
        onlyInViewport: !0,
        pageUpDown: !0
      }
    });
    function c(f) {
      if (!e.enabled) return;
      var h = e.rtlTranslate;
      var v = f;
      v.originalEvent && (v = v.originalEvent);
      var m = v.keyCode || v.charCode,
        p = e.params.keyboard.pageUpDown,
        u = p && m === 33,
        b = p && m === 34,
        C = m === 37,
        g = m === 39,
        w = m === 38,
        y = m === 40;
      if (!e.allowSlideNext && (e.isHorizontal() && g || e.isVertical() && y || b) || !e.allowSlidePrev && (e.isHorizontal() && C || e.isVertical() && w || u)) return !1;
      if (!(v.shiftKey || v.altKey || v.ctrlKey || v.metaKey) && !(a.activeElement && a.activeElement.nodeName && (a.activeElement.nodeName.toLowerCase() === "input" || a.activeElement.nodeName.toLowerCase() === "textarea"))) {
        if (e.params.keyboard.onlyInViewport && (u || b || C || g || w || y)) {
          var x = !1;
          if (Ce(e.el, ".".concat(e.params.slideClass, ", swiper-slide")).length > 0 && Ce(e.el, ".".concat(e.params.slideActiveClass)).length === 0) return;
          var T = e.el,
            S = T.clientWidth,
            L = T.clientHeight,
            E = o.innerWidth,
            M = o.innerHeight,
            P = Ue(T);
          h && (P.left -= T.scrollLeft);
          var B = [[P.left, P.top], [P.left + S, P.top], [P.left, P.top + L], [P.left + S, P.top + L]];
          for (var H = 0; H < B.length; H += 1) {
            var z = B[H];
            if (z[0] >= 0 && z[0] <= E && z[1] >= 0 && z[1] <= M) {
              if (z[0] === 0 && z[1] === 0) continue;
              x = !0;
            }
          }
          if (!x) return;
        }
        e.isHorizontal() ? ((u || b || C || g) && (v.preventDefault ? v.preventDefault() : v.returnValue = !1), ((b || g) && !h || (u || C) && h) && e.slideNext(), ((u || C) && !h || (b || g) && h) && e.slidePrev()) : ((u || b || w || y) && (v.preventDefault ? v.preventDefault() : v.returnValue = !1), (b || y) && e.slideNext(), (u || w) && e.slidePrev()), r("keyPress", m);
      }
    }
    function l() {
      e.keyboard.enabled || (a.addEventListener("keydown", c), e.keyboard.enabled = !0);
    }
    function d() {
      e.keyboard.enabled && (a.removeEventListener("keydown", c), e.keyboard.enabled = !1);
    }
    n("init", function () {
      e.params.keyboard.enabled && l();
    }), n("destroy", function () {
      e.keyboard.enabled && d();
    }), Object.assign(e.keyboard, {
      enable: l,
      disable: d
    });
  }
  function mr(i) {
    var e = i.swiper,
      s = i.extendParams,
      n = i.on,
      r = i.emit;
    var a = W();
    s({
      mousewheel: {
        enabled: !1,
        releaseOnEdges: !1,
        invert: !1,
        forceToAxis: !1,
        sensitivity: 1,
        eventsTarget: "container",
        thresholdDelta: null,
        thresholdTime: null,
        noMousewheelClass: "swiper-no-mousewheel"
      }
    }), e.mousewheel = {
      enabled: !1
    };
    var o,
      c = ie(),
      l;
    var d = [];
    function f(w) {
      var S = 0,
        L = 0,
        E = 0,
        M = 0;
      return "detail" in w && (L = w.detail), "wheelDelta" in w && (L = -w.wheelDelta / 120), "wheelDeltaY" in w && (L = -w.wheelDeltaY / 120), "wheelDeltaX" in w && (S = -w.wheelDeltaX / 120), "axis" in w && w.axis === w.HORIZONTAL_AXIS && (S = L, L = 0), E = S * 10, M = L * 10, "deltaY" in w && (M = w.deltaY), "deltaX" in w && (E = w.deltaX), w.shiftKey && !E && (E = M, M = 0), (E || M) && w.deltaMode && (w.deltaMode === 1 ? (E *= 40, M *= 40) : (E *= 800, M *= 800)), E && !S && (S = E < 1 ? -1 : 1), M && !L && (L = M < 1 ? -1 : 1), {
        spinX: S,
        spinY: L,
        pixelX: E,
        pixelY: M
      };
    }
    function h() {
      e.enabled && (e.mouseEntered = !0);
    }
    function v() {
      e.enabled && (e.mouseEntered = !1);
    }
    function m(w) {
      return e.params.mousewheel.thresholdDelta && w.delta < e.params.mousewheel.thresholdDelta || e.params.mousewheel.thresholdTime && ie() - c < e.params.mousewheel.thresholdTime ? !1 : w.delta >= 6 && ie() - c < 60 ? !0 : (w.direction < 0 ? (!e.isEnd || e.params.loop) && !e.animating && (e.slideNext(), r("scroll", w.raw)) : (!e.isBeginning || e.params.loop) && !e.animating && (e.slidePrev(), r("scroll", w.raw)), c = new a.Date().getTime(), !1);
    }
    function p(w) {
      var y = e.params.mousewheel;
      if (w.direction < 0) {
        if (e.isEnd && !e.params.loop && y.releaseOnEdges) return !0;
      } else if (e.isBeginning && !e.params.loop && y.releaseOnEdges) return !0;
      return !1;
    }
    function u(w) {
      var y = w,
        x = !0;
      if (!e.enabled || w.target.closest(".".concat(e.params.mousewheel.noMousewheelClass))) return;
      var T = e.params.mousewheel;
      e.params.cssMode && y.preventDefault();
      var S = e.el;
      e.params.mousewheel.eventsTarget !== "container" && (S = document.querySelector(e.params.mousewheel.eventsTarget));
      var L = S && S.contains(y.target);
      if (!e.mouseEntered && !L && !T.releaseOnEdges) return !0;
      y.originalEvent && (y = y.originalEvent);
      var E = 0;
      var M = e.rtlTranslate ? -1 : 1,
        P = f(y);
      if (T.forceToAxis) {
        if (e.isHorizontal()) {
          if (Math.abs(P.pixelX) > Math.abs(P.pixelY)) E = -P.pixelX * M;else return !0;
        } else if (Math.abs(P.pixelY) > Math.abs(P.pixelX)) E = -P.pixelY;else return !0;
      } else E = Math.abs(P.pixelX) > Math.abs(P.pixelY) ? -P.pixelX * M : -P.pixelY;
      if (E === 0) return !0;
      T.invert && (E = -E);
      var B = e.getTranslate() + E * T.sensitivity;
      if (B >= e.minTranslate() && (B = e.minTranslate()), B <= e.maxTranslate() && (B = e.maxTranslate()), x = e.params.loop ? !0 : !(B === e.minTranslate() || B === e.maxTranslate()), x && e.params.nested && y.stopPropagation(), !e.params.freeMode || !e.params.freeMode.enabled) {
        var H = {
          time: ie(),
          delta: Math.abs(E),
          direction: Math.sign(E),
          raw: w
        };
        d.length >= 2 && d.shift();
        var z = d.length ? d[d.length - 1] : void 0;
        if (d.push(H), z ? (H.direction !== z.direction || H.delta > z.delta || H.time > z.time + 150) && m(H) : m(H), p(H)) return !0;
      } else {
        var _H2 = {
            time: ie(),
            delta: Math.abs(E),
            direction: Math.sign(E)
          },
          _z = l && _H2.time < l.time + 500 && _H2.delta <= l.delta && _H2.direction === l.direction;
        if (!_z) {
          l = void 0;
          var I = e.getTranslate() + E * T.sensitivity;
          var $ = e.isBeginning,
            k = e.isEnd;
          if (I >= e.minTranslate() && (I = e.minTranslate()), I <= e.maxTranslate() && (I = e.maxTranslate()), e.setTransition(0), e.setTranslate(I), e.updateProgress(), e.updateActiveIndex(), e.updateSlidesClasses(), (!$ && e.isBeginning || !k && e.isEnd) && e.updateSlidesClasses(), e.params.loop && e.loopFix({
            direction: _H2.direction < 0 ? "next" : "prev",
            byMousewheel: !0
          }), e.params.freeMode.sticky) {
            clearTimeout(o), o = void 0, d.length >= 15 && d.shift();
            var V = d.length ? d[d.length - 1] : void 0,
              A = d[0];
            if (d.push(_H2), V && (_H2.delta > V.delta || _H2.direction !== V.direction)) d.splice(0);else if (d.length >= 15 && _H2.time - A.time < 500 && A.delta - _H2.delta >= 1 && _H2.delta <= 6) {
              var F = E > 0 ? .8 : .2;
              l = _H2, d.splice(0), o = be(function () {
                e.destroyed || !e.params || e.slideToClosest(e.params.speed, !0, void 0, F);
              }, 0);
            }
            o || (o = be(function () {
              if (e.destroyed || !e.params) return;
              var F = .5;
              l = _H2, d.splice(0), e.slideToClosest(e.params.speed, !0, void 0, F);
            }, 500));
          }
          if (_z || r("scroll", y), e.params.autoplay && e.params.autoplay.disableOnInteraction && e.autoplay.stop(), T.releaseOnEdges && (I === e.minTranslate() || I === e.maxTranslate())) return !0;
        }
      }
      return y.preventDefault ? y.preventDefault() : y.returnValue = !1, !1;
    }
    function b(w) {
      var y = e.el;
      e.params.mousewheel.eventsTarget !== "container" && (y = document.querySelector(e.params.mousewheel.eventsTarget)), y[w]("mouseenter", h), y[w]("mouseleave", v), y[w]("wheel", u);
    }
    function C() {
      return e.params.cssMode ? (e.wrapperEl.removeEventListener("wheel", u), !0) : e.mousewheel.enabled ? !1 : (b("addEventListener"), e.mousewheel.enabled = !0, !0);
    }
    function g() {
      return e.params.cssMode ? (e.wrapperEl.addEventListener(event, u), !0) : e.mousewheel.enabled ? (b("removeEventListener"), e.mousewheel.enabled = !1, !0) : !1;
    }
    n("init", function () {
      !e.params.mousewheel.enabled && e.params.cssMode && g(), e.params.mousewheel.enabled && C();
    }), n("destroy", function () {
      e.params.cssMode && C(), e.mousewheel.enabled && g();
    }), Object.assign(e.mousewheel, {
      enable: C,
      disable: g
    });
  }
  function Ht(i, e, s, n) {
    return i.params.createElements && Object.keys(n).forEach(function (r) {
      if (!s[r] && s.auto === !0) {
        var a = U(i.el, ".".concat(n[r]))[0];
        a || (a = Q("div", n[r]), a.className = n[r], i.el.append(a)), s[r] = a, e[r] = a;
      }
    }), s;
  }
  function Bt(i) {
    var e = i.swiper,
      s = i.extendParams,
      n = i.on,
      r = i.emit;
    s({
      navigation: {
        nextEl: null,
        prevEl: null,
        hideOnClick: !1,
        disabledClass: "swiper-button-disabled",
        hiddenClass: "swiper-button-hidden",
        lockClass: "swiper-button-lock",
        navigationDisabledClass: "swiper-navigation-disabled"
      }
    }), e.navigation = {
      nextEl: null,
      prevEl: null
    };
    function a(p) {
      var u;
      return p && typeof p == "string" && e.isElement && (u = e.el.querySelector(p) || e.hostEl.querySelector(p), u) ? u : (p && (typeof p == "string" && (u = _toConsumableArray(document.querySelectorAll(p))), e.params.uniqueNavElements && typeof p == "string" && u && u.length > 1 && e.el.querySelectorAll(p).length === 1 ? u = e.el.querySelector(p) : u && u.length === 1 && (u = u[0])), p && !u ? p : u);
    }
    function o(p, u) {
      var b = e.params.navigation;
      p = Z(p), p.forEach(function (C) {
        var _C$classList;
        C && ((_C$classList = C.classList)[u ? "add" : "remove"].apply(_C$classList, _toConsumableArray(b.disabledClass.split(" "))), C.tagName === "BUTTON" && (C.disabled = u), e.params.watchOverflow && e.enabled && C.classList[e.isLocked ? "add" : "remove"](b.lockClass));
      });
    }
    function c() {
      var _e$navigation = e.navigation,
        p = _e$navigation.nextEl,
        u = _e$navigation.prevEl;
      if (e.params.loop) {
        o(u, !1), o(p, !1);
        return;
      }
      o(u, e.isBeginning && !e.params.rewind), o(p, e.isEnd && !e.params.rewind);
    }
    function l(p) {
      p.preventDefault(), !(e.isBeginning && !e.params.loop && !e.params.rewind) && (e.slidePrev(), r("navigationPrev"));
    }
    function d(p) {
      p.preventDefault(), !(e.isEnd && !e.params.loop && !e.params.rewind) && (e.slideNext(), r("navigationNext"));
    }
    function f() {
      var p = e.params.navigation;
      if (e.params.navigation = Ht(e, e.originalParams.navigation, e.params.navigation, {
        nextEl: "swiper-button-next",
        prevEl: "swiper-button-prev"
      }), !(p.nextEl || p.prevEl)) return;
      var u = a(p.nextEl),
        b = a(p.prevEl);
      Object.assign(e.navigation, {
        nextEl: u,
        prevEl: b
      }), u = Z(u), b = Z(b);
      var C = function C(g, w) {
        var _g$classList;
        g && g.addEventListener("click", w === "next" ? d : l), !e.enabled && g && (_g$classList = g.classList).add.apply(_g$classList, _toConsumableArray(p.lockClass.split(" ")));
      };
      u.forEach(function (g) {
        return C(g, "next");
      }), b.forEach(function (g) {
        return C(g, "prev");
      });
    }
    function h() {
      var _e$navigation2 = e.navigation,
        p = _e$navigation2.nextEl,
        u = _e$navigation2.prevEl;
      p = Z(p), u = Z(u);
      var b = function b(C, g) {
        var _C$classList2;
        C.removeEventListener("click", g === "next" ? d : l), (_C$classList2 = C.classList).remove.apply(_C$classList2, _toConsumableArray(e.params.navigation.disabledClass.split(" ")));
      };
      p.forEach(function (C) {
        return b(C, "next");
      }), u.forEach(function (C) {
        return b(C, "prev");
      });
    }
    n("init", function () {
      e.params.navigation.enabled === !1 ? m() : (f(), c());
    }), n("toEdge fromEdge lock unlock", function () {
      c();
    }), n("destroy", function () {
      h();
    }), n("enable disable", function () {
      var _e$navigation3 = e.navigation,
        p = _e$navigation3.nextEl,
        u = _e$navigation3.prevEl;
      if (p = Z(p), u = Z(u), e.enabled) {
        c();
        return;
      }
      [].concat(_toConsumableArray(p), _toConsumableArray(u)).filter(function (b) {
        return !!b;
      }).forEach(function (b) {
        return b.classList.add(e.params.navigation.lockClass);
      });
    }), n("click", function (p, u) {
      var _e$navigation4 = e.navigation,
        b = _e$navigation4.nextEl,
        C = _e$navigation4.prevEl;
      b = Z(b), C = Z(C);
      var g = u.target;
      var w = C.includes(g) || b.includes(g);
      if (e.isElement && !w) {
        var y = u.path || u.composedPath && u.composedPath();
        y && (w = y.find(function (x) {
          return b.includes(x) || C.includes(x);
        }));
      }
      if (e.params.navigation.hideOnClick && !w) {
        if (e.pagination && e.params.pagination && e.params.pagination.clickable && (e.pagination.el === g || e.pagination.el.contains(g))) return;
        var _y;
        b.length ? _y = b[0].classList.contains(e.params.navigation.hiddenClass) : C.length && (_y = C[0].classList.contains(e.params.navigation.hiddenClass)), r(_y === !0 ? "navigationShow" : "navigationHide"), [].concat(_toConsumableArray(b), _toConsumableArray(C)).filter(function (x) {
          return !!x;
        }).forEach(function (x) {
          return x.classList.toggle(e.params.navigation.hiddenClass);
        });
      }
    });
    var v = function v() {
        var _e$el$classList;
        (_e$el$classList = e.el.classList).remove.apply(_e$el$classList, _toConsumableArray(e.params.navigation.navigationDisabledClass.split(" "))), f(), c();
      },
      m = function m() {
        var _e$el$classList2;
        (_e$el$classList2 = e.el.classList).add.apply(_e$el$classList2, _toConsumableArray(e.params.navigation.navigationDisabledClass.split(" "))), h();
      };
    Object.assign(e.navigation, {
      enable: v,
      disable: m,
      update: c,
      init: f,
      destroy: h
    });
  }
  function le(i) {
    return i === void 0 && (i = ""), ".".concat(i.trim().replace(/([\.:!+\/])/g, "\\$1").replace(/ /g, "."));
  }
  function ui(i) {
    var e = i.swiper,
      s = i.extendParams,
      n = i.on,
      r = i.emit;
    var a = "swiper-pagination";
    s({
      pagination: {
        el: null,
        bulletElement: "span",
        clickable: !1,
        hideOnClick: !1,
        renderBullet: null,
        renderProgressbar: null,
        renderFraction: null,
        renderCustom: null,
        progressbarOpposite: !1,
        type: "bullets",
        dynamicBullets: !1,
        dynamicMainBullets: 1,
        formatFractionCurrent: function formatFractionCurrent(g) {
          return g;
        },
        formatFractionTotal: function formatFractionTotal(g) {
          return g;
        },
        bulletClass: "".concat(a, "-bullet"),
        bulletActiveClass: "".concat(a, "-bullet-active"),
        modifierClass: "".concat(a, "-"),
        currentClass: "".concat(a, "-current"),
        totalClass: "".concat(a, "-total"),
        hiddenClass: "".concat(a, "-hidden"),
        progressbarFillClass: "".concat(a, "-progressbar-fill"),
        progressbarOppositeClass: "".concat(a, "-progressbar-opposite"),
        clickableClass: "".concat(a, "-clickable"),
        lockClass: "".concat(a, "-lock"),
        horizontalClass: "".concat(a, "-horizontal"),
        verticalClass: "".concat(a, "-vertical"),
        paginationDisabledClass: "".concat(a, "-disabled")
      }
    }), e.pagination = {
      el: null,
      bullets: []
    };
    var o,
      c = 0;
    function l() {
      return !e.params.pagination.el || !e.pagination.el || Array.isArray(e.pagination.el) && e.pagination.el.length === 0;
    }
    function d(g, w) {
      var y = e.params.pagination.bulletActiveClass;
      g && (g = g["".concat(w === "prev" ? "previous" : "next", "ElementSibling")], g && (g.classList.add("".concat(y, "-").concat(w)), g = g["".concat(w === "prev" ? "previous" : "next", "ElementSibling")], g && g.classList.add("".concat(y, "-").concat(w, "-").concat(w))));
    }
    function f(g, w, y) {
      if (g = g % y, w = w % y, w === g + 1) return "next";
      if (w === g - 1) return "previous";
    }
    function h(g) {
      var w = g.target.closest(le(e.params.pagination.bulletClass));
      if (!w) return;
      g.preventDefault();
      var y = Oe(w) * e.params.slidesPerGroup;
      if (e.params.loop) {
        if (e.realIndex === y) return;
        var x = f(e.realIndex, y, e.slides.length);
        x === "next" ? e.slideNext() : x === "previous" ? e.slidePrev() : e.slideToLoop(y);
      } else e.slideTo(y);
    }
    function v() {
      var g = e.rtl,
        w = e.params.pagination;
      if (l()) return;
      var y = e.pagination.el;
      y = Z(y);
      var x, T;
      var S = e.virtual && e.params.virtual.enabled ? e.virtual.slides.length : e.slides.length,
        L = e.params.loop ? Math.ceil(S / e.params.slidesPerGroup) : e.snapGrid.length;
      if (e.params.loop ? (T = e.previousRealIndex || 0, x = e.params.slidesPerGroup > 1 ? Math.floor(e.realIndex / e.params.slidesPerGroup) : e.realIndex) : _typeof(e.snapIndex) < "u" ? (x = e.snapIndex, T = e.previousSnapIndex) : (T = e.previousIndex || 0, x = e.activeIndex || 0), w.type === "bullets" && e.pagination.bullets && e.pagination.bullets.length > 0) {
        var E = e.pagination.bullets;
        var M, P, B;
        if (w.dynamicBullets && (o = Ct(E[0], e.isHorizontal() ? "width" : "height"), y.forEach(function (H) {
          H.style[e.isHorizontal() ? "width" : "height"] = "".concat(o * (w.dynamicMainBullets + 4), "px");
        }), w.dynamicMainBullets > 1 && T !== void 0 && (c += x - (T || 0), c > w.dynamicMainBullets - 1 ? c = w.dynamicMainBullets - 1 : c < 0 && (c = 0)), M = Math.max(x - c, 0), P = M + (Math.min(E.length, w.dynamicMainBullets) - 1), B = (P + M) / 2), E.forEach(function (H) {
          var _H$classList;
          var z = _toConsumableArray(["", "-next", "-next-next", "-prev", "-prev-prev", "-main"].map(function (I) {
            return "".concat(w.bulletActiveClass).concat(I);
          })).map(function (I) {
            return typeof I == "string" && I.includes(" ") ? I.split(" ") : I;
          }).flat();
          (_H$classList = H.classList).remove.apply(_H$classList, _toConsumableArray(z));
        }), y.length > 1) E.forEach(function (H) {
          var _H$classList2, _H$classList3;
          var z = Oe(H);
          z === x ? (_H$classList2 = H.classList).add.apply(_H$classList2, _toConsumableArray(w.bulletActiveClass.split(" "))) : e.isElement && H.setAttribute("part", "bullet"), w.dynamicBullets && (z >= M && z <= P && (_H$classList3 = H.classList).add.apply(_H$classList3, _toConsumableArray("".concat(w.bulletActiveClass, "-main").split(" "))), z === M && d(H, "prev"), z === P && d(H, "next"));
        });else {
          var _H$classList4;
          var H = E[x];
          if (H && (_H$classList4 = H.classList).add.apply(_H$classList4, _toConsumableArray(w.bulletActiveClass.split(" "))), e.isElement && E.forEach(function (z, I) {
            z.setAttribute("part", I === x ? "bullet-active" : "bullet");
          }), w.dynamicBullets) {
            var z = E[M],
              I = E[P];
            for (var $ = M; $ <= P; $ += 1) {
              var _E$$$classList;
              E[$] && (_E$$$classList = E[$].classList).add.apply(_E$$$classList, _toConsumableArray("".concat(w.bulletActiveClass, "-main").split(" ")));
            }
            d(z, "prev"), d(I, "next");
          }
        }
        if (w.dynamicBullets) {
          var _H3 = Math.min(E.length, w.dynamicMainBullets + 4),
            _z2 = (o * _H3 - o) / 2 - B * o,
            _I = g ? "right" : "left";
          E.forEach(function ($) {
            $.style[e.isHorizontal() ? _I : "top"] = "".concat(_z2, "px");
          });
        }
      }
      y.forEach(function (E, M) {
        if (w.type === "fraction" && (E.querySelectorAll(le(w.currentClass)).forEach(function (P) {
          P.textContent = w.formatFractionCurrent(x + 1);
        }), E.querySelectorAll(le(w.totalClass)).forEach(function (P) {
          P.textContent = w.formatFractionTotal(L);
        })), w.type === "progressbar") {
          var _P9;
          w.progressbarOpposite ? _P9 = e.isHorizontal() ? "vertical" : "horizontal" : _P9 = e.isHorizontal() ? "horizontal" : "vertical";
          var _B4 = (x + 1) / L;
          var _H4 = 1,
            _z3 = 1;
          _P9 === "horizontal" ? _H4 = _B4 : _z3 = _B4, E.querySelectorAll(le(w.progressbarFillClass)).forEach(function (I) {
            I.style.transform = "translate3d(0,0,0) scaleX(".concat(_H4, ") scaleY(").concat(_z3, ")"), I.style.transitionDuration = "".concat(e.params.speed, "ms");
          });
        }
        w.type === "custom" && w.renderCustom ? (E.innerHTML = w.renderCustom(e, x + 1, L), M === 0 && r("paginationRender", E)) : (M === 0 && r("paginationRender", E), r("paginationUpdate", E)), e.params.watchOverflow && e.enabled && E.classList[e.isLocked ? "add" : "remove"](w.lockClass);
      });
    }
    function m() {
      var g = e.params.pagination;
      if (l()) return;
      var w = e.virtual && e.params.virtual.enabled ? e.virtual.slides.length : e.grid && e.params.grid.rows > 1 ? e.slides.length / Math.ceil(e.params.grid.rows) : e.slides.length;
      var y = e.pagination.el;
      y = Z(y);
      var x = "";
      if (g.type === "bullets") {
        var T = e.params.loop ? Math.ceil(w / e.params.slidesPerGroup) : e.snapGrid.length;
        e.params.freeMode && e.params.freeMode.enabled && T > w && (T = w);
        for (var S = 0; S < T; S += 1) g.renderBullet ? x += g.renderBullet.call(e, S, g.bulletClass) : x += "<".concat(g.bulletElement, " ").concat(e.isElement ? 'part="bullet"' : "", " class=\"").concat(g.bulletClass, "\"></").concat(g.bulletElement, ">");
      }
      g.type === "fraction" && (g.renderFraction ? x = g.renderFraction.call(e, g.currentClass, g.totalClass) : x = "<span class=\"".concat(g.currentClass, "\"></span> / <span class=\"").concat(g.totalClass, "\"></span>")), g.type === "progressbar" && (g.renderProgressbar ? x = g.renderProgressbar.call(e, g.progressbarFillClass) : x = "<span class=\"".concat(g.progressbarFillClass, "\"></span>")), e.pagination.bullets = [], y.forEach(function (T) {
        var _e$pagination$bullets;
        g.type !== "custom" && (T.innerHTML = x || ""), g.type === "bullets" && (_e$pagination$bullets = e.pagination.bullets).push.apply(_e$pagination$bullets, _toConsumableArray(T.querySelectorAll(le(g.bulletClass))));
      }), g.type !== "custom" && r("paginationRender", y[0]);
    }
    function p() {
      e.params.pagination = Ht(e, e.originalParams.pagination, e.params.pagination, {
        el: "swiper-pagination"
      });
      var g = e.params.pagination;
      if (!g.el) return;
      var w;
      typeof g.el == "string" && e.isElement && (w = e.el.querySelector(g.el)), !w && typeof g.el == "string" && (w = _toConsumableArray(document.querySelectorAll(g.el))), w || (w = g.el), !(!w || w.length === 0) && (e.params.uniqueNavElements && typeof g.el == "string" && Array.isArray(w) && w.length > 1 && (w = _toConsumableArray(e.el.querySelectorAll(g.el)), w.length > 1 && (w = w.find(function (y) {
        return Ce(y, ".swiper")[0] === e.el;
      }))), Array.isArray(w) && w.length === 1 && (w = w[0]), Object.assign(e.pagination, {
        el: w
      }), w = Z(w), w.forEach(function (y) {
        var _y$classList;
        g.type === "bullets" && g.clickable && (_y$classList = y.classList).add.apply(_y$classList, _toConsumableArray((g.clickableClass || "").split(" "))), y.classList.add(g.modifierClass + g.type), y.classList.add(e.isHorizontal() ? g.horizontalClass : g.verticalClass), g.type === "bullets" && g.dynamicBullets && (y.classList.add("".concat(g.modifierClass).concat(g.type, "-dynamic")), c = 0, g.dynamicMainBullets < 1 && (g.dynamicMainBullets = 1)), g.type === "progressbar" && g.progressbarOpposite && y.classList.add(g.progressbarOppositeClass), g.clickable && y.addEventListener("click", h), e.enabled || y.classList.add(g.lockClass);
      }));
    }
    function u() {
      var g = e.params.pagination;
      if (l()) return;
      var w = e.pagination.el;
      w && (w = Z(w), w.forEach(function (y) {
        var _y$classList2;
        y.classList.remove(g.hiddenClass), y.classList.remove(g.modifierClass + g.type), y.classList.remove(e.isHorizontal() ? g.horizontalClass : g.verticalClass), g.clickable && ((_y$classList2 = y.classList).remove.apply(_y$classList2, _toConsumableArray((g.clickableClass || "").split(" "))), y.removeEventListener("click", h));
      })), e.pagination.bullets && e.pagination.bullets.forEach(function (y) {
        var _y$classList3;
        return (_y$classList3 = y.classList).remove.apply(_y$classList3, _toConsumableArray(g.bulletActiveClass.split(" ")));
      });
    }
    n("changeDirection", function () {
      if (!e.pagination || !e.pagination.el) return;
      var g = e.params.pagination;
      var w = e.pagination.el;
      w = Z(w), w.forEach(function (y) {
        y.classList.remove(g.horizontalClass, g.verticalClass), y.classList.add(e.isHorizontal() ? g.horizontalClass : g.verticalClass);
      });
    }), n("init", function () {
      e.params.pagination.enabled === !1 ? C() : (p(), m(), v());
    }), n("activeIndexChange", function () {
      _typeof(e.snapIndex) > "u" && v();
    }), n("snapIndexChange", function () {
      v();
    }), n("snapGridLengthChange", function () {
      m(), v();
    }), n("destroy", function () {
      u();
    }), n("enable disable", function () {
      var g = e.pagination.el;
      g && (g = Z(g), g.forEach(function (w) {
        return w.classList[e.enabled ? "remove" : "add"](e.params.pagination.lockClass);
      }));
    }), n("lock unlock", function () {
      v();
    }), n("click", function (g, w) {
      var y = w.target,
        x = Z(e.pagination.el);
      if (e.params.pagination.el && e.params.pagination.hideOnClick && x && x.length > 0 && !y.classList.contains(e.params.pagination.bulletClass)) {
        if (e.navigation && (e.navigation.nextEl && y === e.navigation.nextEl || e.navigation.prevEl && y === e.navigation.prevEl)) return;
        var T = x[0].classList.contains(e.params.pagination.hiddenClass);
        r(T === !0 ? "paginationShow" : "paginationHide"), x.forEach(function (S) {
          return S.classList.toggle(e.params.pagination.hiddenClass);
        });
      }
    });
    var b = function b() {
        e.el.classList.remove(e.params.pagination.paginationDisabledClass);
        var g = e.pagination.el;
        g && (g = Z(g), g.forEach(function (w) {
          return w.classList.remove(e.params.pagination.paginationDisabledClass);
        })), p(), m(), v();
      },
      C = function C() {
        e.el.classList.add(e.params.pagination.paginationDisabledClass);
        var g = e.pagination.el;
        g && (g = Z(g), g.forEach(function (w) {
          return w.classList.add(e.params.pagination.paginationDisabledClass);
        })), u();
      };
    Object.assign(e.pagination, {
      enable: b,
      disable: C,
      render: m,
      update: v,
      init: p,
      destroy: u
    });
  }
  function hr(i) {
    var e = i.swiper,
      s = i.extendParams,
      n = i.on,
      r = i.emit;
    var a = Y();
    var o = !1,
      c = null,
      l = null,
      d,
      f,
      h,
      v;
    s({
      scrollbar: {
        el: null,
        dragSize: "auto",
        hide: !1,
        draggable: !1,
        snapOnRelease: !0,
        lockClass: "swiper-scrollbar-lock",
        dragClass: "swiper-scrollbar-drag",
        scrollbarDisabledClass: "swiper-scrollbar-disabled",
        horizontalClass: "swiper-scrollbar-horizontal",
        verticalClass: "swiper-scrollbar-vertical"
      }
    }), e.scrollbar = {
      el: null,
      dragEl: null
    };
    function m() {
      if (!e.params.scrollbar.el || !e.scrollbar.el) return;
      var B = e.scrollbar,
        H = e.rtlTranslate,
        z = B.dragEl,
        I = B.el,
        $ = e.params.scrollbar,
        k = e.params.loop ? e.progressLoop : e.progress;
      var V = f,
        A = (h - f) * k;
      H ? (A = -A, A > 0 ? (V = f - A, A = 0) : -A + f > h && (V = h + A)) : A < 0 ? (V = f + A, A = 0) : A + f > h && (V = h - A), e.isHorizontal() ? (z.style.transform = "translate3d(".concat(A, "px, 0, 0)"), z.style.width = "".concat(V, "px")) : (z.style.transform = "translate3d(0px, ".concat(A, "px, 0)"), z.style.height = "".concat(V, "px")), $.hide && (clearTimeout(c), I.style.opacity = 1, c = setTimeout(function () {
        I.style.opacity = 0, I.style.transitionDuration = "400ms";
      }, 1e3));
    }
    function p(B) {
      !e.params.scrollbar.el || !e.scrollbar.el || (e.scrollbar.dragEl.style.transitionDuration = "".concat(B, "ms"));
    }
    function u() {
      if (!e.params.scrollbar.el || !e.scrollbar.el) return;
      var B = e.scrollbar,
        H = B.dragEl,
        z = B.el;
      H.style.width = "", H.style.height = "", h = e.isHorizontal() ? z.offsetWidth : z.offsetHeight, v = e.size / (e.virtualSize + e.params.slidesOffsetBefore - (e.params.centeredSlides ? e.snapGrid[0] : 0)), e.params.scrollbar.dragSize === "auto" ? f = h * v : f = parseInt(e.params.scrollbar.dragSize, 10), e.isHorizontal() ? H.style.width = "".concat(f, "px") : H.style.height = "".concat(f, "px"), v >= 1 ? z.style.display = "none" : z.style.display = "", e.params.scrollbar.hide && (z.style.opacity = 0), e.params.watchOverflow && e.enabled && B.el.classList[e.isLocked ? "add" : "remove"](e.params.scrollbar.lockClass);
    }
    function b(B) {
      return e.isHorizontal() ? B.clientX : B.clientY;
    }
    function C(B) {
      var H = e.scrollbar,
        z = e.rtlTranslate,
        I = H.el;
      var $;
      $ = (b(B) - Ue(I)[e.isHorizontal() ? "left" : "top"] - (d !== null ? d : f / 2)) / (h - f), $ = Math.max(Math.min($, 1), 0), z && ($ = 1 - $);
      var k = e.minTranslate() + (e.maxTranslate() - e.minTranslate()) * $;
      e.updateProgress(k), e.setTranslate(k), e.updateActiveIndex(), e.updateSlidesClasses();
    }
    function g(B) {
      var H = e.params.scrollbar,
        z = e.scrollbar,
        I = e.wrapperEl,
        $ = z.el,
        k = z.dragEl;
      o = !0, d = B.target === k ? b(B) - B.target.getBoundingClientRect()[e.isHorizontal() ? "left" : "top"] : null, B.preventDefault(), B.stopPropagation(), I.style.transitionDuration = "100ms", k.style.transitionDuration = "100ms", C(B), clearTimeout(l), $.style.transitionDuration = "0ms", H.hide && ($.style.opacity = 1), e.params.cssMode && (e.wrapperEl.style["scroll-snap-type"] = "none"), r("scrollbarDragStart", B);
    }
    function w(B) {
      var H = e.scrollbar,
        z = e.wrapperEl,
        I = H.el,
        $ = H.dragEl;
      o && (B.preventDefault && B.cancelable ? B.preventDefault() : B.returnValue = !1, C(B), z.style.transitionDuration = "0ms", I.style.transitionDuration = "0ms", $.style.transitionDuration = "0ms", r("scrollbarDragMove", B));
    }
    function y(B) {
      var H = e.params.scrollbar,
        z = e.scrollbar,
        I = e.wrapperEl,
        $ = z.el;
      o && (o = !1, e.params.cssMode && (e.wrapperEl.style["scroll-snap-type"] = "", I.style.transitionDuration = ""), H.hide && (clearTimeout(l), l = be(function () {
        $.style.opacity = 0, $.style.transitionDuration = "400ms";
      }, 1e3)), r("scrollbarDragEnd", B), H.snapOnRelease && e.slideToClosest());
    }
    function x(B) {
      var H = e.scrollbar,
        z = e.params,
        I = H.el;
      if (!I) return;
      var $ = I,
        k = z.passiveListeners ? {
          passive: !1,
          capture: !1
        } : !1,
        V = z.passiveListeners ? {
          passive: !0,
          capture: !1
        } : !1;
      if (!$) return;
      var A = B === "on" ? "addEventListener" : "removeEventListener";
      $[A]("pointerdown", g, k), a[A]("pointermove", w, k), a[A]("pointerup", y, V);
    }
    function T() {
      !e.params.scrollbar.el || !e.scrollbar.el || x("on");
    }
    function S() {
      !e.params.scrollbar.el || !e.scrollbar.el || x("off");
    }
    function L() {
      var _I$classList;
      var B = e.scrollbar,
        H = e.el;
      e.params.scrollbar = Ht(e, e.originalParams.scrollbar, e.params.scrollbar, {
        el: "swiper-scrollbar"
      });
      var z = e.params.scrollbar;
      if (!z.el) return;
      var I;
      if (typeof z.el == "string" && e.isElement && (I = e.el.querySelector(z.el)), !I && typeof z.el == "string") {
        if (I = a.querySelectorAll(z.el), !I.length) return;
      } else I || (I = z.el);
      e.params.uniqueNavElements && typeof z.el == "string" && I.length > 1 && H.querySelectorAll(z.el).length === 1 && (I = H.querySelector(z.el)), I.length > 0 && (I = I[0]), I.classList.add(e.isHorizontal() ? z.horizontalClass : z.verticalClass);
      var $;
      I && ($ = I.querySelector(le(e.params.scrollbar.dragClass)), $ || ($ = Q("div", e.params.scrollbar.dragClass), I.append($))), Object.assign(B, {
        el: I,
        dragEl: $
      }), z.draggable && T(), I && (_I$classList = I.classList)[e.enabled ? "remove" : "add"].apply(_I$classList, _toConsumableArray(ce(e.params.scrollbar.lockClass)));
    }
    function E() {
      var _H$classList5;
      var B = e.params.scrollbar,
        H = e.scrollbar.el;
      H && (_H$classList5 = H.classList).remove.apply(_H$classList5, _toConsumableArray(ce(e.isHorizontal() ? B.horizontalClass : B.verticalClass))), S();
    }
    n("changeDirection", function () {
      if (!e.scrollbar || !e.scrollbar.el) return;
      var B = e.params.scrollbar;
      var H = e.scrollbar.el;
      H = Z(H), H.forEach(function (z) {
        z.classList.remove(B.horizontalClass, B.verticalClass), z.classList.add(e.isHorizontal() ? B.horizontalClass : B.verticalClass);
      });
    }), n("init", function () {
      e.params.scrollbar.enabled === !1 ? P() : (L(), u(), m());
    }), n("update resize observerUpdate lock unlock changeDirection", function () {
      u();
    }), n("setTranslate", function () {
      m();
    }), n("setTransition", function (B, H) {
      p(H);
    }), n("enable disable", function () {
      var _B$classList;
      var B = e.scrollbar.el;
      B && (_B$classList = B.classList)[e.enabled ? "remove" : "add"].apply(_B$classList, _toConsumableArray(ce(e.params.scrollbar.lockClass)));
    }), n("destroy", function () {
      E();
    });
    var M = function M() {
        var _e$el$classList3, _e$scrollbar$el$class;
        (_e$el$classList3 = e.el.classList).remove.apply(_e$el$classList3, _toConsumableArray(ce(e.params.scrollbar.scrollbarDisabledClass))), e.scrollbar.el && (_e$scrollbar$el$class = e.scrollbar.el.classList).remove.apply(_e$scrollbar$el$class, _toConsumableArray(ce(e.params.scrollbar.scrollbarDisabledClass))), L(), u(), m();
      },
      P = function P() {
        var _e$el$classList4, _e$scrollbar$el$class2;
        (_e$el$classList4 = e.el.classList).add.apply(_e$el$classList4, _toConsumableArray(ce(e.params.scrollbar.scrollbarDisabledClass))), e.scrollbar.el && (_e$scrollbar$el$class2 = e.scrollbar.el.classList).add.apply(_e$scrollbar$el$class2, _toConsumableArray(ce(e.params.scrollbar.scrollbarDisabledClass))), E();
      };
    Object.assign(e.scrollbar, {
      enable: M,
      disable: P,
      updateSize: u,
      setTranslate: m,
      init: L,
      destroy: E
    });
  }
  function gr(i) {
    var e = i.swiper,
      s = i.extendParams,
      n = i.on;
    s({
      parallax: {
        enabled: !1
      }
    });
    var r = "[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]",
      a = function a(l, d) {
        var f = e.rtl,
          h = f ? -1 : 1,
          v = l.getAttribute("data-swiper-parallax") || "0";
        var m = l.getAttribute("data-swiper-parallax-x"),
          p = l.getAttribute("data-swiper-parallax-y");
        var u = l.getAttribute("data-swiper-parallax-scale"),
          b = l.getAttribute("data-swiper-parallax-opacity"),
          C = l.getAttribute("data-swiper-parallax-rotate");
        if (m || p ? (m = m || "0", p = p || "0") : e.isHorizontal() ? (m = v, p = "0") : (p = v, m = "0"), m.indexOf("%") >= 0 ? m = "".concat(parseInt(m, 10) * d * h, "%") : m = "".concat(m * d * h, "px"), p.indexOf("%") >= 0 ? p = "".concat(parseInt(p, 10) * d, "%") : p = "".concat(p * d, "px"), _typeof(b) < "u" && b !== null) {
          var w = b - (b - 1) * (1 - Math.abs(d));
          l.style.opacity = w;
        }
        var g = "translate3d(".concat(m, ", ").concat(p, ", 0px)");
        if (_typeof(u) < "u" && u !== null) {
          var _w = u - (u - 1) * (1 - Math.abs(d));
          g += " scale(".concat(_w, ")");
        }
        if (C && _typeof(C) < "u" && C !== null) {
          var _w2 = C * d * -1;
          g += " rotate(".concat(_w2, "deg)");
        }
        l.style.transform = g;
      },
      o = function o() {
        var l = e.el,
          d = e.slides,
          f = e.progress,
          h = e.snapGrid,
          v = e.isElement,
          m = U(l, r);
        e.isElement && m.push.apply(m, _toConsumableArray(U(e.hostEl, r))), m.forEach(function (p) {
          a(p, f);
        }), d.forEach(function (p, u) {
          var b = p.progress;
          e.params.slidesPerGroup > 1 && e.params.slidesPerView !== "auto" && (b += Math.ceil(u / 2) - f * (h.length - 1)), b = Math.min(Math.max(b, -1), 1), p.querySelectorAll("".concat(r, ", [data-swiper-parallax-rotate]")).forEach(function (C) {
            a(C, b);
          });
        });
      },
      c = function c(l) {
        l === void 0 && (l = e.params.speed);
        var d = e.el,
          f = e.hostEl,
          h = _toConsumableArray(d.querySelectorAll(r));
        e.isElement && h.push.apply(h, _toConsumableArray(f.querySelectorAll(r))), h.forEach(function (v) {
          var m = parseInt(v.getAttribute("data-swiper-parallax-duration"), 10) || l;
          l === 0 && (m = 0), v.style.transitionDuration = "".concat(m, "ms");
        });
      };
    n("beforeInit", function () {
      e.params.parallax.enabled && (e.params.watchSlidesProgress = !0, e.originalParams.watchSlidesProgress = !0);
    }), n("init", function () {
      e.params.parallax.enabled && o();
    }), n("setTranslate", function () {
      e.params.parallax.enabled && o();
    }), n("setTransition", function (l, d) {
      e.params.parallax.enabled && c(d);
    });
  }
  function wr(i) {
    var e = i.swiper,
      s = i.extendParams,
      n = i.on,
      r = i.emit;
    var a = W();
    s({
      zoom: {
        enabled: !1,
        limitToOriginalSize: !1,
        maxRatio: 3,
        minRatio: 1,
        panOnMouseMove: !1,
        toggle: !0,
        containerClass: "swiper-zoom-container",
        zoomedSlideClass: "swiper-slide-zoomed"
      }
    }), e.zoom = {
      enabled: !1
    };
    var o = 1,
      c = !1,
      l = !1,
      d = {
        x: 0,
        y: 0
      };
    var f = -3;
    var h, v;
    var m = [],
      p = {
        originX: 0,
        originY: 0,
        slideEl: void 0,
        slideWidth: void 0,
        slideHeight: void 0,
        imageEl: void 0,
        imageWrapEl: void 0,
        maxRatio: 3
      },
      u = {
        isTouched: void 0,
        isMoved: void 0,
        currentX: void 0,
        currentY: void 0,
        minX: void 0,
        minY: void 0,
        maxX: void 0,
        maxY: void 0,
        width: void 0,
        height: void 0,
        startX: void 0,
        startY: void 0,
        touchesStart: {},
        touchesCurrent: {}
      },
      b = {
        x: void 0,
        y: void 0,
        prevPositionX: void 0,
        prevPositionY: void 0,
        prevTime: void 0
      };
    var C = 1;
    Object.defineProperty(e.zoom, "scale", {
      get: function get() {
        return C;
      },
      set: function set(_) {
        if (C !== _) {
          var N = p.imageEl,
            D = p.slideEl;
          r("zoomChange", _, N, D);
        }
        C = _;
      }
    });
    function g() {
      if (m.length < 2) return 1;
      var _ = m[0].pageX,
        N = m[0].pageY,
        D = m[1].pageX,
        R = m[1].pageY;
      return Math.sqrt(Math.pow(D - _, 2) + Math.pow(R - N, 2));
    }
    function w() {
      var _ = e.params.zoom,
        N = p.imageWrapEl.getAttribute("data-swiper-zoom") || _.maxRatio;
      if (_.limitToOriginalSize && p.imageEl && p.imageEl.naturalWidth) {
        var D = p.imageEl.naturalWidth / p.imageEl.offsetWidth;
        return Math.min(D, N);
      }
      return N;
    }
    function y() {
      if (m.length < 2) return {
        x: null,
        y: null
      };
      var _ = p.imageEl.getBoundingClientRect();
      return [(m[0].pageX + (m[1].pageX - m[0].pageX) / 2 - _.x - a.scrollX) / o, (m[0].pageY + (m[1].pageY - m[0].pageY) / 2 - _.y - a.scrollY) / o];
    }
    function x() {
      return e.isElement ? "swiper-slide" : ".".concat(e.params.slideClass);
    }
    function T(_) {
      var N = x();
      return !!(_.target.matches(N) || e.slides.filter(function (D) {
        return D.contains(_.target);
      }).length > 0);
    }
    function S(_) {
      var N = ".".concat(e.params.zoom.containerClass);
      return !!(_.target.matches(N) || _toConsumableArray(e.hostEl.querySelectorAll(N)).filter(function (D) {
        return D.contains(_.target);
      }).length > 0);
    }
    function L(_) {
      if (_.pointerType === "mouse" && m.splice(0, m.length), !T(_)) return;
      var N = e.params.zoom;
      if (h = !1, v = !1, m.push(_), !(m.length < 2)) {
        if (h = !0, p.scaleStart = g(), !p.slideEl) {
          p.slideEl = _.target.closest(".".concat(e.params.slideClass, ", swiper-slide")), p.slideEl || (p.slideEl = e.slides[e.activeIndex]);
          var D = p.slideEl.querySelector(".".concat(N.containerClass));
          if (D && (D = D.querySelectorAll("picture, img, svg, canvas, .swiper-zoom-target")[0]), p.imageEl = D, D ? p.imageWrapEl = Ce(p.imageEl, ".".concat(N.containerClass))[0] : p.imageWrapEl = void 0, !p.imageWrapEl) {
            p.imageEl = void 0;
            return;
          }
          p.maxRatio = w();
        }
        if (p.imageEl) {
          var _y2 = y(),
            _y3 = _slicedToArray(_y2, 2),
            _D2 = _y3[0],
            R = _y3[1];
          p.originX = _D2, p.originY = R, p.imageEl.style.transitionDuration = "0ms";
        }
        c = !0;
      }
    }
    function E(_) {
      if (!T(_)) return;
      var N = e.params.zoom,
        D = e.zoom,
        R = m.findIndex(function (q) {
          return q.pointerId === _.pointerId;
        });
      R >= 0 && (m[R] = _), !(m.length < 2) && (v = !0, p.scaleMove = g(), p.imageEl && (D.scale = p.scaleMove / p.scaleStart * o, D.scale > p.maxRatio && (D.scale = p.maxRatio - 1 + Math.pow(D.scale - p.maxRatio + 1, .5)), D.scale < N.minRatio && (D.scale = N.minRatio + 1 - Math.pow(N.minRatio - D.scale + 1, .5)), p.imageEl.style.transform = "translate3d(0,0,0) scale(".concat(D.scale, ")")));
    }
    function M(_) {
      if (!T(_) || _.pointerType === "mouse" && _.type === "pointerout") return;
      var N = e.params.zoom,
        D = e.zoom,
        R = m.findIndex(function (q) {
          return q.pointerId === _.pointerId;
        });
      R >= 0 && m.splice(R, 1), !(!h || !v) && (h = !1, v = !1, p.imageEl && (D.scale = Math.max(Math.min(D.scale, p.maxRatio), N.minRatio), p.imageEl.style.transitionDuration = "".concat(e.params.speed, "ms"), p.imageEl.style.transform = "translate3d(0,0,0) scale(".concat(D.scale, ")"), o = D.scale, c = !1, D.scale > 1 && p.slideEl ? p.slideEl.classList.add("".concat(N.zoomedSlideClass)) : D.scale <= 1 && p.slideEl && p.slideEl.classList.remove("".concat(N.zoomedSlideClass)), D.scale === 1 && (p.originX = 0, p.originY = 0, p.slideEl = void 0)));
    }
    var P;
    function B() {
      e.touchEventsData.preventTouchMoveFromPointerMove = !1;
    }
    function H() {
      clearTimeout(P), e.touchEventsData.preventTouchMoveFromPointerMove = !0, P = setTimeout(function () {
        e.destroyed || B();
      });
    }
    function z(_) {
      var N = e.device;
      if (!p.imageEl || u.isTouched) return;
      N.android && _.cancelable && _.preventDefault(), u.isTouched = !0;
      var D = m.length > 0 ? m[0] : _;
      u.touchesStart.x = D.pageX, u.touchesStart.y = D.pageY;
    }
    function I(_) {
      var D = _.pointerType === "mouse" && e.params.zoom.panOnMouseMove;
      if (!T(_) || !S(_)) return;
      var R = e.zoom;
      if (!p.imageEl) return;
      if (!u.isTouched || !p.slideEl) {
        D && V(_);
        return;
      }
      if (D) {
        V(_);
        return;
      }
      u.isMoved || (u.width = p.imageEl.offsetWidth || p.imageEl.clientWidth, u.height = p.imageEl.offsetHeight || p.imageEl.clientHeight, u.startX = vt(p.imageWrapEl, "x") || 0, u.startY = vt(p.imageWrapEl, "y") || 0, p.slideWidth = p.slideEl.offsetWidth, p.slideHeight = p.slideEl.offsetHeight, p.imageWrapEl.style.transitionDuration = "0ms");
      var q = u.width * R.scale,
        me = u.height * R.scale;
      if (u.minX = Math.min(p.slideWidth / 2 - q / 2, 0), u.maxX = -u.minX, u.minY = Math.min(p.slideHeight / 2 - me / 2, 0), u.maxY = -u.minY, u.touchesCurrent.x = m.length > 0 ? m[0].pageX : _.pageX, u.touchesCurrent.y = m.length > 0 ? m[0].pageY : _.pageY, Math.max(Math.abs(u.touchesCurrent.x - u.touchesStart.x), Math.abs(u.touchesCurrent.y - u.touchesStart.y)) > 5 && (e.allowClick = !1), !u.isMoved && !c) {
        if (e.isHorizontal() && (Math.floor(u.minX) === Math.floor(u.startX) && u.touchesCurrent.x < u.touchesStart.x || Math.floor(u.maxX) === Math.floor(u.startX) && u.touchesCurrent.x > u.touchesStart.x)) {
          u.isTouched = !1, B();
          return;
        }
        if (!e.isHorizontal() && (Math.floor(u.minY) === Math.floor(u.startY) && u.touchesCurrent.y < u.touchesStart.y || Math.floor(u.maxY) === Math.floor(u.startY) && u.touchesCurrent.y > u.touchesStart.y)) {
          u.isTouched = !1, B();
          return;
        }
      }
      _.cancelable && _.preventDefault(), _.stopPropagation(), H(), u.isMoved = !0;
      var oe = (R.scale - o) / (p.maxRatio - e.params.zoom.minRatio),
        ge = p.originX,
        K = p.originY;
      u.currentX = u.touchesCurrent.x - u.touchesStart.x + u.startX + oe * (u.width - ge * 2), u.currentY = u.touchesCurrent.y - u.touchesStart.y + u.startY + oe * (u.height - K * 2), u.currentX < u.minX && (u.currentX = u.minX + 1 - Math.pow(u.minX - u.currentX + 1, .8)), u.currentX > u.maxX && (u.currentX = u.maxX - 1 + Math.pow(u.currentX - u.maxX + 1, .8)), u.currentY < u.minY && (u.currentY = u.minY + 1 - Math.pow(u.minY - u.currentY + 1, .8)), u.currentY > u.maxY && (u.currentY = u.maxY - 1 + Math.pow(u.currentY - u.maxY + 1, .8)), b.prevPositionX || (b.prevPositionX = u.touchesCurrent.x), b.prevPositionY || (b.prevPositionY = u.touchesCurrent.y), b.prevTime || (b.prevTime = Date.now()), b.x = (u.touchesCurrent.x - b.prevPositionX) / (Date.now() - b.prevTime) / 2, b.y = (u.touchesCurrent.y - b.prevPositionY) / (Date.now() - b.prevTime) / 2, Math.abs(u.touchesCurrent.x - b.prevPositionX) < 2 && (b.x = 0), Math.abs(u.touchesCurrent.y - b.prevPositionY) < 2 && (b.y = 0), b.prevPositionX = u.touchesCurrent.x, b.prevPositionY = u.touchesCurrent.y, b.prevTime = Date.now(), p.imageWrapEl.style.transform = "translate3d(".concat(u.currentX, "px, ").concat(u.currentY, "px,0)");
    }
    function $() {
      var _ = e.zoom;
      if (m.length = 0, !p.imageEl) return;
      if (!u.isTouched || !u.isMoved) {
        u.isTouched = !1, u.isMoved = !1;
        return;
      }
      u.isTouched = !1, u.isMoved = !1;
      var N = 300,
        D = 300;
      var R = b.x * N,
        q = u.currentX + R,
        me = b.y * D,
        he = u.currentY + me;
      b.x !== 0 && (N = Math.abs((q - u.currentX) / b.x)), b.y !== 0 && (D = Math.abs((he - u.currentY) / b.y));
      var oe = Math.max(N, D);
      u.currentX = q, u.currentY = he;
      var ge = u.width * _.scale,
        K = u.height * _.scale;
      u.minX = Math.min(p.slideWidth / 2 - ge / 2, 0), u.maxX = -u.minX, u.minY = Math.min(p.slideHeight / 2 - K / 2, 0), u.maxY = -u.minY, u.currentX = Math.max(Math.min(u.currentX, u.maxX), u.minX), u.currentY = Math.max(Math.min(u.currentY, u.maxY), u.minY), p.imageWrapEl.style.transitionDuration = "".concat(oe, "ms"), p.imageWrapEl.style.transform = "translate3d(".concat(u.currentX, "px, ").concat(u.currentY, "px,0)");
    }
    function k() {
      var _ = e.zoom;
      p.slideEl && e.activeIndex !== e.slides.indexOf(p.slideEl) && (p.imageEl && (p.imageEl.style.transform = "translate3d(0,0,0) scale(1)"), p.imageWrapEl && (p.imageWrapEl.style.transform = "translate3d(0,0,0)"), p.slideEl.classList.remove("".concat(e.params.zoom.zoomedSlideClass)), _.scale = 1, o = 1, p.slideEl = void 0, p.imageEl = void 0, p.imageWrapEl = void 0, p.originX = 0, p.originY = 0);
    }
    function V(_) {
      if (o <= 1 || !p.imageWrapEl || !T(_) || !S(_)) return;
      var N = a.getComputedStyle(p.imageWrapEl).transform,
        D = new a.DOMMatrix(N);
      if (!l) {
        l = !0, d.x = _.clientX, d.y = _.clientY, u.startX = D.e, u.startY = D.f, u.width = p.imageEl.offsetWidth || p.imageEl.clientWidth, u.height = p.imageEl.offsetHeight || p.imageEl.clientHeight, p.slideWidth = p.slideEl.offsetWidth, p.slideHeight = p.slideEl.offsetHeight;
        return;
      }
      var R = (_.clientX - d.x) * f,
        q = (_.clientY - d.y) * f,
        me = u.width * o,
        he = u.height * o,
        oe = p.slideWidth,
        ge = p.slideHeight,
        K = Math.min(oe / 2 - me / 2, 0),
        ne = -K,
        We = Math.min(ge / 2 - he / 2, 0),
        ct = -We,
        He = Math.max(Math.min(u.startX + R, ne), K),
        Be = Math.max(Math.min(u.startY + q, ct), We);
      p.imageWrapEl.style.transitionDuration = "0ms", p.imageWrapEl.style.transform = "translate3d(".concat(He, "px, ").concat(Be, "px, 0)"), d.x = _.clientX, d.y = _.clientY, u.startX = He, u.startY = Be, u.currentX = He, u.currentY = Be;
    }
    function A(_) {
      var N = e.zoom,
        D = e.params.zoom;
      if (!p.slideEl) {
        _ && _.target && (p.slideEl = _.target.closest(".".concat(e.params.slideClass, ", swiper-slide"))), p.slideEl || (e.params.virtual && e.params.virtual.enabled && e.virtual ? p.slideEl = U(e.slidesEl, ".".concat(e.params.slideActiveClass))[0] : p.slideEl = e.slides[e.activeIndex]);
        var Ge = p.slideEl.querySelector(".".concat(D.containerClass));
        Ge && (Ge = Ge.querySelectorAll("picture, img, svg, canvas, .swiper-zoom-target")[0]), p.imageEl = Ge, Ge ? p.imageWrapEl = Ce(p.imageEl, ".".concat(D.containerClass))[0] : p.imageWrapEl = void 0;
      }
      if (!p.imageEl || !p.imageWrapEl) return;
      e.params.cssMode && (e.wrapperEl.style.overflow = "hidden", e.wrapperEl.style.touchAction = "none"), p.slideEl.classList.add("".concat(D.zoomedSlideClass));
      var R, q, me, he, oe, ge, K, ne, We, ct, He, Be, dt, pt, Ft, Zt, Rt, jt;
      _typeof(u.touchesStart.x) > "u" && _ ? (R = _.pageX, q = _.pageY) : (R = u.touchesStart.x, q = u.touchesStart.y);
      var Wt = o,
        ze = typeof _ == "number" ? _ : null;
      o === 1 && ze && (R = void 0, q = void 0, u.touchesStart.x = void 0, u.touchesStart.y = void 0);
      var Qi = w();
      N.scale = ze || Qi, o = ze || Qi, _ && !(o === 1 && ze) ? (Rt = p.slideEl.offsetWidth, jt = p.slideEl.offsetHeight, me = Ue(p.slideEl).left + a.scrollX, he = Ue(p.slideEl).top + a.scrollY, oe = me + Rt / 2 - R, ge = he + jt / 2 - q, We = p.imageEl.offsetWidth || p.imageEl.clientWidth, ct = p.imageEl.offsetHeight || p.imageEl.clientHeight, He = We * N.scale, Be = ct * N.scale, dt = Math.min(Rt / 2 - He / 2, 0), pt = Math.min(jt / 2 - Be / 2, 0), Ft = -dt, Zt = -pt, Wt > 0 && ze && typeof u.currentX == "number" && typeof u.currentY == "number" ? (K = u.currentX * N.scale / Wt, ne = u.currentY * N.scale / Wt) : (K = oe * N.scale, ne = ge * N.scale), K < dt && (K = dt), K > Ft && (K = Ft), ne < pt && (ne = pt), ne > Zt && (ne = Zt)) : (K = 0, ne = 0), ze && N.scale === 1 && (p.originX = 0, p.originY = 0), u.currentX = K, u.currentY = ne, p.imageWrapEl.style.transitionDuration = "300ms", p.imageWrapEl.style.transform = "translate3d(".concat(K, "px, ").concat(ne, "px,0)"), p.imageEl.style.transitionDuration = "300ms", p.imageEl.style.transform = "translate3d(0,0,0) scale(".concat(N.scale, ")");
    }
    function F() {
      var _ = e.zoom,
        N = e.params.zoom;
      if (!p.slideEl) {
        e.params.virtual && e.params.virtual.enabled && e.virtual ? p.slideEl = U(e.slidesEl, ".".concat(e.params.slideActiveClass))[0] : p.slideEl = e.slides[e.activeIndex];
        var D = p.slideEl.querySelector(".".concat(N.containerClass));
        D && (D = D.querySelectorAll("picture, img, svg, canvas, .swiper-zoom-target")[0]), p.imageEl = D, D ? p.imageWrapEl = Ce(p.imageEl, ".".concat(N.containerClass))[0] : p.imageWrapEl = void 0;
      }
      !p.imageEl || !p.imageWrapEl || (e.params.cssMode && (e.wrapperEl.style.overflow = "", e.wrapperEl.style.touchAction = ""), _.scale = 1, o = 1, u.currentX = void 0, u.currentY = void 0, u.touchesStart.x = void 0, u.touchesStart.y = void 0, p.imageWrapEl.style.transitionDuration = "300ms", p.imageWrapEl.style.transform = "translate3d(0,0,0)", p.imageEl.style.transitionDuration = "300ms", p.imageEl.style.transform = "translate3d(0,0,0) scale(1)", p.slideEl.classList.remove("".concat(N.zoomedSlideClass)), p.slideEl = void 0, p.originX = 0, p.originY = 0, e.params.zoom.panOnMouseMove && (d = {
        x: 0,
        y: 0
      }, l && (l = !1, u.startX = 0, u.startY = 0)));
    }
    function j(_) {
      var N = e.zoom;
      N.scale && N.scale !== 1 ? F() : A(_);
    }
    function G() {
      var _ = e.params.passiveListeners ? {
          passive: !0,
          capture: !1
        } : !1,
        N = e.params.passiveListeners ? {
          passive: !1,
          capture: !0
        } : !0;
      return {
        passiveListener: _,
        activeListenerWithCapture: N
      };
    }
    function X() {
      var _ = e.zoom;
      if (_.enabled) return;
      _.enabled = !0;
      var _G = G(),
        N = _G.passiveListener,
        D = _G.activeListenerWithCapture;
      e.wrapperEl.addEventListener("pointerdown", L, N), e.wrapperEl.addEventListener("pointermove", E, D), ["pointerup", "pointercancel", "pointerout"].forEach(function (R) {
        e.wrapperEl.addEventListener(R, M, N);
      }), e.wrapperEl.addEventListener("pointermove", I, D);
    }
    function te() {
      var _ = e.zoom;
      if (!_.enabled) return;
      _.enabled = !1;
      var _G2 = G(),
        N = _G2.passiveListener,
        D = _G2.activeListenerWithCapture;
      e.wrapperEl.removeEventListener("pointerdown", L, N), e.wrapperEl.removeEventListener("pointermove", E, D), ["pointerup", "pointercancel", "pointerout"].forEach(function (R) {
        e.wrapperEl.removeEventListener(R, M, N);
      }), e.wrapperEl.removeEventListener("pointermove", I, D);
    }
    n("init", function () {
      e.params.zoom.enabled && X();
    }), n("destroy", function () {
      te();
    }), n("touchStart", function (_, N) {
      e.zoom.enabled && z(N);
    }), n("touchEnd", function (_, N) {
      e.zoom.enabled && $();
    }), n("doubleTap", function (_, N) {
      !e.animating && e.params.zoom.enabled && e.zoom.enabled && e.params.zoom.toggle && j(N);
    }), n("transitionEnd", function () {
      e.zoom.enabled && e.params.zoom.enabled && k();
    }), n("slideChange", function () {
      e.zoom.enabled && e.params.zoom.enabled && e.params.cssMode && k();
    }), Object.assign(e.zoom, {
      enable: X,
      disable: te,
      "in": A,
      out: F,
      toggle: j
    });
  }
  function br(i) {
    var e = i.swiper,
      s = i.extendParams,
      n = i.on;
    s({
      controller: {
        control: void 0,
        inverse: !1,
        by: "slide"
      }
    }), e.controller = {
      control: void 0
    };
    function r(d, f) {
      var h = function () {
        var u, b, C;
        return function (g, w) {
          for (b = -1, u = g.length; u - b > 1;) C = u + b >> 1, g[C] <= w ? b = C : u = C;
          return u;
        };
      }();
      this.x = d, this.y = f, this.lastIndex = d.length - 1;
      var v, m;
      return this.interpolate = function (u) {
        return u ? (m = h(this.x, u), v = m - 1, (u - this.x[v]) * (this.y[m] - this.y[v]) / (this.x[m] - this.x[v]) + this.y[v]) : 0;
      }, this;
    }
    function a(d) {
      e.controller.spline = e.params.loop ? new r(e.slidesGrid, d.slidesGrid) : new r(e.snapGrid, d.snapGrid);
    }
    function o(d, f) {
      var h = e.controller.control;
      var v, m;
      var p = e.constructor;
      function u(b) {
        if (b.destroyed) return;
        var C = e.rtlTranslate ? -e.translate : e.translate;
        e.params.controller.by === "slide" && (a(b), m = -e.controller.spline.interpolate(-C)), (!m || e.params.controller.by === "container") && (v = (b.maxTranslate() - b.minTranslate()) / (e.maxTranslate() - e.minTranslate()), (Number.isNaN(v) || !Number.isFinite(v)) && (v = 1), m = (C - e.minTranslate()) * v + b.minTranslate()), e.params.controller.inverse && (m = b.maxTranslate() - m), b.updateProgress(m), b.setTranslate(m, e), b.updateActiveIndex(), b.updateSlidesClasses();
      }
      if (Array.isArray(h)) for (var b = 0; b < h.length; b += 1) h[b] !== f && h[b] instanceof p && u(h[b]);else h instanceof p && f !== h && u(h);
    }
    function c(d, f) {
      var h = e.constructor,
        v = e.controller.control;
      var m;
      function p(u) {
        u.destroyed || (u.setTransition(d, e), d !== 0 && (u.transitionStart(), u.params.autoHeight && be(function () {
          u.updateAutoHeight();
        }), Fe(u.wrapperEl, function () {
          v && u.transitionEnd();
        })));
      }
      if (Array.isArray(v)) for (m = 0; m < v.length; m += 1) v[m] !== f && v[m] instanceof h && p(v[m]);else v instanceof h && f !== v && p(v);
    }
    function l() {
      e.controller.control && e.controller.spline && (e.controller.spline = void 0, delete e.controller.spline);
    }
    n("beforeInit", function () {
      if ((typeof window === "undefined" ? "undefined" : _typeof(window)) < "u" && (typeof e.params.controller.control == "string" || e.params.controller.control instanceof HTMLElement)) {
        (typeof e.params.controller.control == "string" ? _toConsumableArray(document.querySelectorAll(e.params.controller.control)) : [e.params.controller.control]).forEach(function (f) {
          if (e.controller.control || (e.controller.control = []), f && f.swiper) e.controller.control.push(f.swiper);else if (f) {
            var h = "".concat(e.params.eventsPrefix, "init"),
              _v3 = function v(m) {
                e.controller.control.push(m.detail[0]), e.update(), f.removeEventListener(h, _v3);
              };
            f.addEventListener(h, _v3);
          }
        });
        return;
      }
      e.controller.control = e.params.controller.control;
    }), n("update", function () {
      l();
    }), n("resize", function () {
      l();
    }), n("observerUpdate", function () {
      l();
    }), n("setTranslate", function (d, f, h) {
      !e.controller.control || e.controller.control.destroyed || e.controller.setTranslate(f, h);
    }), n("setTransition", function (d, f, h) {
      !e.controller.control || e.controller.control.destroyed || e.controller.setTransition(f, h);
    }), Object.assign(e.controller, {
      setTranslate: o,
      setTransition: c
    });
  }
  function vr(i) {
    var e = i.swiper,
      s = i.extendParams,
      n = i.on;
    s({
      a11y: {
        enabled: !0,
        notificationClass: "swiper-notification",
        prevSlideMessage: "Previous slide",
        nextSlideMessage: "Next slide",
        firstSlideMessage: "This is the first slide",
        lastSlideMessage: "This is the last slide",
        paginationBulletMessage: "Go to slide {{index}}",
        slideLabelMessage: "{{index}} / {{slidesLength}}",
        containerMessage: null,
        containerRoleDescriptionMessage: null,
        containerRole: null,
        itemRoleDescriptionMessage: null,
        slideRole: "group",
        id: null,
        scrollOnFocus: !0
      }
    }), e.a11y = {
      clicked: !1
    };
    var r = null,
      a,
      o,
      c = new Date().getTime();
    function l(k) {
      var V = r;
      V.length !== 0 && (V.innerHTML = "", V.innerHTML = k);
    }
    function d(k) {
      var V = function V() {
        return Math.round(16 * Math.random()).toString(16);
      };
      return "x".repeat(k).replace(/x/g, V);
    }
    function f(k) {
      k = Z(k), k.forEach(function (V) {
        V.setAttribute("tabIndex", "0");
      });
    }
    function h(k) {
      k = Z(k), k.forEach(function (V) {
        V.setAttribute("tabIndex", "-1");
      });
    }
    function v(k, V) {
      k = Z(k), k.forEach(function (A) {
        A.setAttribute("role", V);
      });
    }
    function m(k, V) {
      k = Z(k), k.forEach(function (A) {
        A.setAttribute("aria-roledescription", V);
      });
    }
    function p(k, V) {
      k = Z(k), k.forEach(function (A) {
        A.setAttribute("aria-controls", V);
      });
    }
    function u(k, V) {
      k = Z(k), k.forEach(function (A) {
        A.setAttribute("aria-label", V);
      });
    }
    function b(k, V) {
      k = Z(k), k.forEach(function (A) {
        A.setAttribute("id", V);
      });
    }
    function C(k, V) {
      k = Z(k), k.forEach(function (A) {
        A.setAttribute("aria-live", V);
      });
    }
    function g(k) {
      k = Z(k), k.forEach(function (V) {
        V.setAttribute("aria-disabled", !0);
      });
    }
    function w(k) {
      k = Z(k), k.forEach(function (V) {
        V.setAttribute("aria-disabled", !1);
      });
    }
    function y(k) {
      if (k.keyCode !== 13 && k.keyCode !== 32) return;
      var V = e.params.a11y,
        A = k.target;
      if (!(e.pagination && e.pagination.el && (A === e.pagination.el || e.pagination.el.contains(k.target)) && !k.target.matches(le(e.params.pagination.bulletClass)))) {
        if (e.navigation && e.navigation.prevEl && e.navigation.nextEl) {
          var F = Z(e.navigation.prevEl);
          Z(e.navigation.nextEl).includes(A) && (e.isEnd && !e.params.loop || e.slideNext(), e.isEnd ? l(V.lastSlideMessage) : l(V.nextSlideMessage)), F.includes(A) && (e.isBeginning && !e.params.loop || e.slidePrev(), e.isBeginning ? l(V.firstSlideMessage) : l(V.prevSlideMessage));
        }
        e.pagination && A.matches(le(e.params.pagination.bulletClass)) && A.click();
      }
    }
    function x() {
      if (e.params.loop || e.params.rewind || !e.navigation) return;
      var _e$navigation5 = e.navigation,
        k = _e$navigation5.nextEl,
        V = _e$navigation5.prevEl;
      V && (e.isBeginning ? (g(V), h(V)) : (w(V), f(V))), k && (e.isEnd ? (g(k), h(k)) : (w(k), f(k)));
    }
    function T() {
      return e.pagination && e.pagination.bullets && e.pagination.bullets.length;
    }
    function S() {
      return T() && e.params.pagination.clickable;
    }
    function L() {
      var k = e.params.a11y;
      T() && e.pagination.bullets.forEach(function (V) {
        e.params.pagination.clickable && (f(V), e.params.pagination.renderBullet || (v(V, "button"), u(V, k.paginationBulletMessage.replace(/\{\{index\}\}/, Oe(V) + 1)))), V.matches(le(e.params.pagination.bulletActiveClass)) ? V.setAttribute("aria-current", "true") : V.removeAttribute("aria-current");
      });
    }
    var E = function E(k, V, A) {
        f(k), k.tagName !== "BUTTON" && (v(k, "button"), k.addEventListener("keydown", y)), u(k, A), p(k, V);
      },
      M = function M(k) {
        o && o !== k.target && !o.contains(k.target) && (a = !0), e.a11y.clicked = !0;
      },
      P = function P() {
        a = !1, requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            e.destroyed || (e.a11y.clicked = !1);
          });
        });
      },
      B = function B(k) {
        c = new Date().getTime();
      },
      H = function H(k) {
        if (e.a11y.clicked || !e.params.a11y.scrollOnFocus || new Date().getTime() - c < 100) return;
        var V = k.target.closest(".".concat(e.params.slideClass, ", swiper-slide"));
        if (!V || !e.slides.includes(V)) return;
        o = V;
        var A = e.slides.indexOf(V) === e.activeIndex,
          F = e.params.watchSlidesProgress && e.visibleSlides && e.visibleSlides.includes(V);
        A || F || k.sourceCapabilities && k.sourceCapabilities.firesTouchEvents || (e.isHorizontal() ? e.el.scrollLeft = 0 : e.el.scrollTop = 0, requestAnimationFrame(function () {
          a || (e.params.loop ? e.slideToLoop(parseInt(V.getAttribute("data-swiper-slide-index")), 0) : e.slideTo(e.slides.indexOf(V), 0), a = !1);
        }));
      },
      z = function z() {
        var k = e.params.a11y;
        k.itemRoleDescriptionMessage && m(e.slides, k.itemRoleDescriptionMessage), k.slideRole && v(e.slides, k.slideRole);
        var V = e.slides.length;
        k.slideLabelMessage && e.slides.forEach(function (A, F) {
          var j = e.params.loop ? parseInt(A.getAttribute("data-swiper-slide-index"), 10) : F,
            G = k.slideLabelMessage.replace(/\{\{index\}\}/, j + 1).replace(/\{\{slidesLength\}\}/, V);
          u(A, G);
        });
      },
      I = function I() {
        var k = e.params.a11y;
        e.el.append(r);
        var V = e.el;
        k.containerRoleDescriptionMessage && m(V, k.containerRoleDescriptionMessage), k.containerMessage && u(V, k.containerMessage), k.containerRole && v(V, k.containerRole);
        var A = e.wrapperEl,
          F = k.id || A.getAttribute("id") || "swiper-wrapper-".concat(d(16)),
          j = e.params.autoplay && e.params.autoplay.enabled ? "off" : "polite";
        b(A, F), C(A, j), z();
        var _ref24 = e.navigation ? e.navigation : {},
          G = _ref24.nextEl,
          X = _ref24.prevEl;
        G = Z(G), X = Z(X), G && G.forEach(function (_) {
          return E(_, F, k.nextSlideMessage);
        }), X && X.forEach(function (_) {
          return E(_, F, k.prevSlideMessage);
        }), S() && Z(e.pagination.el).forEach(function (N) {
          N.addEventListener("keydown", y);
        }), Y().addEventListener("visibilitychange", B), e.el.addEventListener("focus", H, !0), e.el.addEventListener("focus", H, !0), e.el.addEventListener("pointerdown", M, !0), e.el.addEventListener("pointerup", P, !0);
      };
    function $() {
      r && r.remove();
      var _ref25 = e.navigation ? e.navigation : {},
        k = _ref25.nextEl,
        V = _ref25.prevEl;
      k = Z(k), V = Z(V), k && k.forEach(function (F) {
        return F.removeEventListener("keydown", y);
      }), V && V.forEach(function (F) {
        return F.removeEventListener("keydown", y);
      }), S() && Z(e.pagination.el).forEach(function (j) {
        j.removeEventListener("keydown", y);
      }), Y().removeEventListener("visibilitychange", B), e.el && typeof e.el != "string" && (e.el.removeEventListener("focus", H, !0), e.el.removeEventListener("pointerdown", M, !0), e.el.removeEventListener("pointerup", P, !0));
    }
    n("beforeInit", function () {
      r = Q("span", e.params.a11y.notificationClass), r.setAttribute("aria-live", "assertive"), r.setAttribute("aria-atomic", "true");
    }), n("afterInit", function () {
      e.params.a11y.enabled && I();
    }), n("slidesLengthChange snapGridLengthChange slidesGridLengthChange", function () {
      e.params.a11y.enabled && z();
    }), n("fromEdge toEdge afterInit lock unlock", function () {
      e.params.a11y.enabled && x();
    }), n("paginationUpdate", function () {
      e.params.a11y.enabled && L();
    }), n("destroy", function () {
      e.params.a11y.enabled && $();
    });
  }
  function Cr(i) {
    var e = i.swiper,
      s = i.extendParams,
      n = i.on;
    s({
      history: {
        enabled: !1,
        root: "",
        replaceState: !1,
        key: "slides",
        keepQuery: !1
      }
    });
    var r = !1,
      a = {};
    var o = function o(m) {
        return m.toString().replace(/\s+/g, "-").replace(/[^\w-]+/g, "").replace(/--+/g, "-").replace(/^-+/, "").replace(/-+$/, "");
      },
      c = function c(m) {
        var p = W();
        var u;
        m ? u = new URL(m) : u = p.location;
        var b = u.pathname.slice(1).split("/").filter(function (y) {
            return y !== "";
          }),
          C = b.length,
          g = b[C - 2],
          w = b[C - 1];
        return {
          key: g,
          value: w
        };
      },
      l = function l(m, p) {
        var u = W();
        if (!r || !e.params.history.enabled) return;
        var b;
        e.params.url ? b = new URL(e.params.url) : b = u.location;
        var C = e.virtual && e.params.virtual.enabled ? e.slidesEl.querySelector("[data-swiper-slide-index=\"".concat(p, "\"]")) : e.slides[p];
        var g = o(C.getAttribute("data-history"));
        if (e.params.history.root.length > 0) {
          var y = e.params.history.root;
          y[y.length - 1] === "/" && (y = y.slice(0, y.length - 1)), g = "".concat(y, "/").concat(m ? "".concat(m, "/") : "").concat(g);
        } else b.pathname.includes(m) || (g = "".concat(m ? "".concat(m, "/") : "").concat(g));
        e.params.history.keepQuery && (g += b.search);
        var w = u.history.state;
        w && w.value === g || (e.params.history.replaceState ? u.history.replaceState({
          value: g
        }, null, g) : u.history.pushState({
          value: g
        }, null, g));
      },
      d = function d(m, p, u) {
        if (p) for (var b = 0, C = e.slides.length; b < C; b += 1) {
          var g = e.slides[b];
          if (o(g.getAttribute("data-history")) === p) {
            var y = e.getSlideIndex(g);
            e.slideTo(y, m, u);
          }
        } else e.slideTo(0, m, u);
      },
      f = function f() {
        a = c(e.params.url), d(e.params.speed, a.value, !1);
      },
      h = function h() {
        var m = W();
        if (e.params.history) {
          if (!m.history || !m.history.pushState) {
            e.params.history.enabled = !1, e.params.hashNavigation.enabled = !0;
            return;
          }
          if (r = !0, a = c(e.params.url), !a.key && !a.value) {
            e.params.history.replaceState || m.addEventListener("popstate", f);
            return;
          }
          d(0, a.value, e.params.runCallbacksOnInit), e.params.history.replaceState || m.addEventListener("popstate", f);
        }
      },
      v = function v() {
        var m = W();
        e.params.history.replaceState || m.removeEventListener("popstate", f);
      };
    n("init", function () {
      e.params.history.enabled && h();
    }), n("destroy", function () {
      e.params.history.enabled && v();
    }), n("transitionEnd _freeModeNoMomentumRelease", function () {
      r && l(e.params.history.key, e.activeIndex);
    }), n("slideChange", function () {
      r && e.params.cssMode && l(e.params.history.key, e.activeIndex);
    });
  }
  function yr(i) {
    var e = i.swiper,
      s = i.extendParams,
      n = i.emit,
      r = i.on,
      a = !1;
    var o = Y(),
      c = W();
    s({
      hashNavigation: {
        enabled: !1,
        replaceState: !1,
        watchState: !1,
        getSlideIndex: function getSlideIndex(v, m) {
          if (e.virtual && e.params.virtual.enabled) {
            var p = e.slides.find(function (b) {
              return b.getAttribute("data-hash") === m;
            });
            return p ? parseInt(p.getAttribute("data-swiper-slide-index"), 10) : 0;
          }
          return e.getSlideIndex(U(e.slidesEl, ".".concat(e.params.slideClass, "[data-hash=\"").concat(m, "\"], swiper-slide[data-hash=\"").concat(m, "\"]"))[0]);
        }
      }
    });
    var l = function l() {
        n("hashChange");
        var v = o.location.hash.replace("#", ""),
          m = e.virtual && e.params.virtual.enabled ? e.slidesEl.querySelector("[data-swiper-slide-index=\"".concat(e.activeIndex, "\"]")) : e.slides[e.activeIndex],
          p = m ? m.getAttribute("data-hash") : "";
        if (v !== p) {
          var u = e.params.hashNavigation.getSlideIndex(e, v);
          if (_typeof(u) > "u" || Number.isNaN(u)) return;
          e.slideTo(u);
        }
      },
      d = function d() {
        if (!a || !e.params.hashNavigation.enabled) return;
        var v = e.virtual && e.params.virtual.enabled ? e.slidesEl.querySelector("[data-swiper-slide-index=\"".concat(e.activeIndex, "\"]")) : e.slides[e.activeIndex],
          m = v ? v.getAttribute("data-hash") || v.getAttribute("data-history") : "";
        e.params.hashNavigation.replaceState && c.history && c.history.replaceState ? (c.history.replaceState(null, null, "#".concat(m) || ""), n("hashSet")) : (o.location.hash = m || "", n("hashSet"));
      },
      f = function f() {
        if (!e.params.hashNavigation.enabled || e.params.history && e.params.history.enabled) return;
        a = !0;
        var v = o.location.hash.replace("#", "");
        if (v) {
          var p = e.params.hashNavigation.getSlideIndex(e, v);
          e.slideTo(p || 0, 0, e.params.runCallbacksOnInit, !0);
        }
        e.params.hashNavigation.watchState && c.addEventListener("hashchange", l);
      },
      h = function h() {
        e.params.hashNavigation.watchState && c.removeEventListener("hashchange", l);
      };
    r("init", function () {
      e.params.hashNavigation.enabled && f();
    }), r("destroy", function () {
      e.params.hashNavigation.enabled && h();
    }), r("transitionEnd _freeModeNoMomentumRelease", function () {
      a && d();
    }), r("slideChange", function () {
      a && e.params.cssMode && d();
    });
  }
  function Er(i) {
    var e = i.swiper,
      s = i.extendParams,
      n = i.on,
      r = i.emit,
      a = i.params;
    e.autoplay = {
      running: !1,
      paused: !1,
      timeLeft: 0
    }, s({
      autoplay: {
        enabled: !1,
        delay: 3e3,
        waitForTransition: !0,
        disableOnInteraction: !1,
        stopOnLastSlide: !1,
        reverseDirection: !1,
        pauseOnMouseEnter: !1
      }
    });
    var o,
      c,
      l = a && a.autoplay ? a.autoplay.delay : 3e3,
      d = a && a.autoplay ? a.autoplay.delay : 3e3,
      f,
      h = new Date().getTime(),
      v,
      m,
      p,
      u,
      b,
      C,
      g;
    function w(V) {
      !e || e.destroyed || !e.wrapperEl || V.target === e.wrapperEl && (e.wrapperEl.removeEventListener("transitionend", w), !(g || V.detail && V.detail.bySwiperTouchMove) && M());
    }
    var _y4 = function y() {
        if (e.destroyed || !e.autoplay.running) return;
        e.autoplay.paused ? v = !0 : v && (d = f, v = !1);
        var V = e.autoplay.paused ? f : h + d - new Date().getTime();
        e.autoplay.timeLeft = V, r("autoplayTimeLeft", V, V / l), c = requestAnimationFrame(function () {
          _y4();
        });
      },
      x = function x() {
        var V;
        return e.virtual && e.params.virtual.enabled ? V = e.slides.find(function (F) {
          return F.classList.contains("swiper-slide-active");
        }) : V = e.slides[e.activeIndex], V ? parseInt(V.getAttribute("data-swiper-autoplay"), 10) : void 0;
      },
      _T = function T(V) {
        if (e.destroyed || !e.autoplay.running) return;
        cancelAnimationFrame(c), _y4();
        var A = _typeof(V) > "u" ? e.params.autoplay.delay : V;
        l = e.params.autoplay.delay, d = e.params.autoplay.delay;
        var F = x();
        !Number.isNaN(F) && F > 0 && _typeof(V) > "u" && (A = F, l = F, d = F), f = A;
        var j = e.params.speed,
          G = function G() {
            !e || e.destroyed || (e.params.autoplay.reverseDirection ? !e.isBeginning || e.params.loop || e.params.rewind ? (e.slidePrev(j, !0, !0), r("autoplay")) : e.params.autoplay.stopOnLastSlide || (e.slideTo(e.slides.length - 1, j, !0, !0), r("autoplay")) : !e.isEnd || e.params.loop || e.params.rewind ? (e.slideNext(j, !0, !0), r("autoplay")) : e.params.autoplay.stopOnLastSlide || (e.slideTo(0, j, !0, !0), r("autoplay")), e.params.cssMode && (h = new Date().getTime(), requestAnimationFrame(function () {
              _T();
            })));
          };
        return A > 0 ? (clearTimeout(o), o = setTimeout(function () {
          G();
        }, A)) : requestAnimationFrame(function () {
          G();
        }), A;
      },
      S = function S() {
        h = new Date().getTime(), e.autoplay.running = !0, _T(), r("autoplayStart");
      },
      L = function L() {
        e.autoplay.running = !1, clearTimeout(o), cancelAnimationFrame(c), r("autoplayStop");
      },
      E = function E(V, A) {
        if (e.destroyed || !e.autoplay.running) return;
        clearTimeout(o), V || (C = !0);
        var F = function F() {
          r("autoplayPause"), e.params.autoplay.waitForTransition ? e.wrapperEl.addEventListener("transitionend", w) : M();
        };
        if (e.autoplay.paused = !0, A) {
          b && (f = e.params.autoplay.delay), b = !1, F();
          return;
        }
        f = (f || e.params.autoplay.delay) - (new Date().getTime() - h), !(e.isEnd && f < 0 && !e.params.loop) && (f < 0 && (f = 0), F());
      },
      M = function M() {
        e.isEnd && f < 0 && !e.params.loop || e.destroyed || !e.autoplay.running || (h = new Date().getTime(), C ? (C = !1, _T(f)) : _T(), e.autoplay.paused = !1, r("autoplayResume"));
      },
      P = function P() {
        if (e.destroyed || !e.autoplay.running) return;
        var V = Y();
        V.visibilityState === "hidden" && (C = !0, E(!0)), V.visibilityState === "visible" && M();
      },
      B = function B(V) {
        V.pointerType === "mouse" && (C = !0, g = !0, !(e.animating || e.autoplay.paused) && E(!0));
      },
      H = function H(V) {
        V.pointerType === "mouse" && (g = !1, e.autoplay.paused && M());
      },
      z = function z() {
        e.params.autoplay.pauseOnMouseEnter && (e.el.addEventListener("pointerenter", B), e.el.addEventListener("pointerleave", H));
      },
      I = function I() {
        e.el && typeof e.el != "string" && (e.el.removeEventListener("pointerenter", B), e.el.removeEventListener("pointerleave", H));
      },
      $ = function $() {
        Y().addEventListener("visibilitychange", P);
      },
      k = function k() {
        Y().removeEventListener("visibilitychange", P);
      };
    n("init", function () {
      e.params.autoplay.enabled && (z(), $(), S());
    }), n("destroy", function () {
      I(), k(), e.autoplay.running && L();
    }), n("_freeModeStaticRelease", function () {
      (p || C) && M();
    }), n("_freeModeNoMomentumRelease", function () {
      e.params.autoplay.disableOnInteraction ? L() : E(!0, !0);
    }), n("beforeTransitionStart", function (V, A, F) {
      e.destroyed || !e.autoplay.running || (F || !e.params.autoplay.disableOnInteraction ? E(!0, !0) : L());
    }), n("sliderFirstMove", function () {
      if (!(e.destroyed || !e.autoplay.running)) {
        if (e.params.autoplay.disableOnInteraction) {
          L();
          return;
        }
        m = !0, p = !1, C = !1, u = setTimeout(function () {
          C = !0, p = !0, E(!0);
        }, 200);
      }
    }), n("touchEnd", function () {
      if (!(e.destroyed || !e.autoplay.running || !m)) {
        if (clearTimeout(u), clearTimeout(o), e.params.autoplay.disableOnInteraction) {
          p = !1, m = !1;
          return;
        }
        p && e.params.cssMode && M(), p = !1, m = !1;
      }
    }), n("slideChange", function () {
      e.destroyed || !e.autoplay.running || (b = !0);
    }), Object.assign(e.autoplay, {
      start: S,
      stop: L,
      pause: E,
      resume: M
    });
  }
  function xr(i) {
    var e = i.swiper,
      s = i.extendParams,
      n = i.on;
    s({
      thumbs: {
        swiper: null,
        multipleActiveThumbs: !0,
        autoScrollOffset: 0,
        slideThumbActiveClass: "swiper-slide-thumb-active",
        thumbsContainerClass: "swiper-thumbs"
      }
    });
    var r = !1,
      a = !1;
    e.thumbs = {
      swiper: null
    };
    function o() {
      var d = e.thumbs.swiper;
      if (!d || d.destroyed) return;
      var f = d.clickedIndex,
        h = d.clickedSlide;
      if (h && h.classList.contains(e.params.thumbs.slideThumbActiveClass) || _typeof(f) > "u" || f === null) return;
      var v;
      d.params.loop ? v = parseInt(d.clickedSlide.getAttribute("data-swiper-slide-index"), 10) : v = f, e.params.loop ? e.slideToLoop(v) : e.slideTo(v);
    }
    function c() {
      var d = e.params.thumbs;
      if (r) return !1;
      r = !0;
      var f = e.constructor;
      if (d.swiper instanceof f) {
        if (d.swiper.destroyed) return r = !1, !1;
        e.thumbs.swiper = d.swiper, Object.assign(e.thumbs.swiper.originalParams, {
          watchSlidesProgress: !0,
          slideToClickedSlide: !1
        }), Object.assign(e.thumbs.swiper.params, {
          watchSlidesProgress: !0,
          slideToClickedSlide: !1
        }), e.thumbs.swiper.update();
      } else if (Ae(d.swiper)) {
        var h = Object.assign({}, d.swiper);
        Object.assign(h, {
          watchSlidesProgress: !0,
          slideToClickedSlide: !1
        }), e.thumbs.swiper = new f(h), a = !0;
      }
      return e.thumbs.swiper.el.classList.add(e.params.thumbs.thumbsContainerClass), e.thumbs.swiper.on("tap", o), !0;
    }
    function l(d) {
      var f = e.thumbs.swiper;
      if (!f || f.destroyed) return;
      var h = f.params.slidesPerView === "auto" ? f.slidesPerViewDynamic() : f.params.slidesPerView;
      var v = 1;
      var m = e.params.thumbs.slideThumbActiveClass;
      if (e.params.slidesPerView > 1 && !e.params.centeredSlides && (v = e.params.slidesPerView), e.params.thumbs.multipleActiveThumbs || (v = 1), v = Math.floor(v), f.slides.forEach(function (b) {
        return b.classList.remove(m);
      }), f.params.loop || f.params.virtual && f.params.virtual.enabled) for (var b = 0; b < v; b += 1) U(f.slidesEl, "[data-swiper-slide-index=\"".concat(e.realIndex + b, "\"]")).forEach(function (C) {
        C.classList.add(m);
      });else for (var _b = 0; _b < v; _b += 1) f.slides[e.realIndex + _b] && f.slides[e.realIndex + _b].classList.add(m);
      var p = e.params.thumbs.autoScrollOffset,
        u = p && !f.params.loop;
      if (e.realIndex !== f.realIndex || u) {
        var _b2 = f.activeIndex;
        var C, g;
        if (f.params.loop) {
          var w = f.slides.find(function (y) {
            return y.getAttribute("data-swiper-slide-index") === "".concat(e.realIndex);
          });
          C = f.slides.indexOf(w), g = e.activeIndex > e.previousIndex ? "next" : "prev";
        } else C = e.realIndex, g = C > e.previousIndex ? "next" : "prev";
        u && (C += g === "next" ? p : -1 * p), f.visibleSlidesIndexes && f.visibleSlidesIndexes.indexOf(C) < 0 && (f.params.centeredSlides ? C > _b2 ? C = C - Math.floor(h / 2) + 1 : C = C + Math.floor(h / 2) - 1 : C > _b2 && f.params.slidesPerGroup, f.slideTo(C, d ? 0 : void 0));
      }
    }
    n("beforeInit", function () {
      var d = e.params.thumbs;
      if (!(!d || !d.swiper)) if (typeof d.swiper == "string" || d.swiper instanceof HTMLElement) {
        var f = Y(),
          h = function h() {
            var m = typeof d.swiper == "string" ? f.querySelector(d.swiper) : d.swiper;
            if (m && m.swiper) d.swiper = m.swiper, c(), l(!0);else if (m) {
              var p = "".concat(e.params.eventsPrefix, "init"),
                _u = function u(b) {
                  d.swiper = b.detail[0], m.removeEventListener(p, _u), c(), l(!0), d.swiper.update(), e.update();
                };
              m.addEventListener(p, _u);
            }
            return m;
          },
          _v4 = function v() {
            if (e.destroyed) return;
            h() || requestAnimationFrame(_v4);
          };
        requestAnimationFrame(_v4);
      } else c(), l(!0);
    }), n("slideChange update resize observerUpdate", function () {
      l();
    }), n("setTransition", function (d, f) {
      var h = e.thumbs.swiper;
      !h || h.destroyed || h.setTransition(f);
    }), n("beforeDestroy", function () {
      var d = e.thumbs.swiper;
      !d || d.destroyed || a && d.destroy();
    }), Object.assign(e.thumbs, {
      init: c,
      update: l
    });
  }
  function kr(i) {
    var e = i.swiper,
      s = i.extendParams,
      n = i.emit,
      r = i.once;
    s({
      freeMode: {
        enabled: !1,
        momentum: !0,
        momentumRatio: 1,
        momentumBounce: !0,
        momentumBounceRatio: 1,
        momentumVelocityRatio: 1,
        sticky: !1,
        minimumVelocity: .02
      }
    });
    function a() {
      if (e.params.cssMode) return;
      var l = e.getTranslate();
      e.setTranslate(l), e.setTransition(0), e.touchEventsData.velocities.length = 0, e.freeMode.onTouchEnd({
        currentPos: e.rtl ? e.translate : -e.translate
      });
    }
    function o() {
      if (e.params.cssMode) return;
      var l = e.touchEventsData,
        d = e.touches;
      l.velocities.length === 0 && l.velocities.push({
        position: d[e.isHorizontal() ? "startX" : "startY"],
        time: l.touchStartTime
      }), l.velocities.push({
        position: d[e.isHorizontal() ? "currentX" : "currentY"],
        time: ie()
      });
    }
    function c(l) {
      var d = l.currentPos;
      if (e.params.cssMode) return;
      var f = e.params,
        h = e.wrapperEl,
        v = e.rtlTranslate,
        m = e.snapGrid,
        p = e.touchEventsData,
        b = ie() - p.touchStartTime;
      if (d < -e.minTranslate()) {
        e.slideTo(e.activeIndex);
        return;
      }
      if (d > -e.maxTranslate()) {
        e.slides.length < m.length ? e.slideTo(m.length - 1) : e.slideTo(e.slides.length - 1);
        return;
      }
      if (f.freeMode.momentum) {
        if (p.velocities.length > 1) {
          var L = p.velocities.pop(),
            E = p.velocities.pop(),
            M = L.position - E.position,
            P = L.time - E.time;
          e.velocity = M / P, e.velocity /= 2, Math.abs(e.velocity) < f.freeMode.minimumVelocity && (e.velocity = 0), (P > 150 || ie() - L.time > 300) && (e.velocity = 0);
        } else e.velocity = 0;
        e.velocity *= f.freeMode.momentumVelocityRatio, p.velocities.length = 0;
        var C = 1e3 * f.freeMode.momentumRatio;
        var g = e.velocity * C;
        var w = e.translate + g;
        v && (w = -w);
        var y = !1,
          x;
        var T = Math.abs(e.velocity) * 20 * f.freeMode.momentumBounceRatio;
        var S;
        if (w < e.maxTranslate()) f.freeMode.momentumBounce ? (w + e.maxTranslate() < -T && (w = e.maxTranslate() - T), x = e.maxTranslate(), y = !0, p.allowMomentumBounce = !0) : w = e.maxTranslate(), f.loop && f.centeredSlides && (S = !0);else if (w > e.minTranslate()) f.freeMode.momentumBounce ? (w - e.minTranslate() > T && (w = e.minTranslate() + T), x = e.minTranslate(), y = !0, p.allowMomentumBounce = !0) : w = e.minTranslate(), f.loop && f.centeredSlides && (S = !0);else if (f.freeMode.sticky) {
          var _L2;
          for (var _E = 0; _E < m.length; _E += 1) if (m[_E] > -w) {
            _L2 = _E;
            break;
          }
          Math.abs(m[_L2] - w) < Math.abs(m[_L2 - 1] - w) || e.swipeDirection === "next" ? w = m[_L2] : w = m[_L2 - 1], w = -w;
        }
        if (S && r("transitionEnd", function () {
          e.loopFix();
        }), e.velocity !== 0) {
          if (v ? C = Math.abs((-w - e.translate) / e.velocity) : C = Math.abs((w - e.translate) / e.velocity), f.freeMode.sticky) {
            var _L3 = Math.abs((v ? -w : w) - e.translate),
              _E2 = e.slidesSizesGrid[e.activeIndex];
            _L3 < _E2 ? C = f.speed : _L3 < 2 * _E2 ? C = f.speed * 1.5 : C = f.speed * 2.5;
          }
        } else if (f.freeMode.sticky) {
          e.slideToClosest();
          return;
        }
        f.freeMode.momentumBounce && y ? (e.updateProgress(x), e.setTransition(C), e.setTranslate(w), e.transitionStart(!0, e.swipeDirection), e.animating = !0, Fe(h, function () {
          !e || e.destroyed || !p.allowMomentumBounce || (n("momentumBounce"), e.setTransition(f.speed), setTimeout(function () {
            e.setTranslate(x), Fe(h, function () {
              !e || e.destroyed || e.transitionEnd();
            });
          }, 0));
        })) : e.velocity ? (n("_freeModeNoMomentumRelease"), e.updateProgress(w), e.setTransition(C), e.setTranslate(w), e.transitionStart(!0, e.swipeDirection), e.animating || (e.animating = !0, Fe(h, function () {
          !e || e.destroyed || e.transitionEnd();
        }))) : e.updateProgress(w), e.updateActiveIndex(), e.updateSlidesClasses();
      } else if (f.freeMode.sticky) {
        e.slideToClosest();
        return;
      } else f.freeMode && n("_freeModeNoMomentumRelease");
      (!f.freeMode.momentum || b >= f.longSwipesMs) && (n("_freeModeStaticRelease"), e.updateProgress(), e.updateActiveIndex(), e.updateSlidesClasses());
    }
    Object.assign(e, {
      freeMode: {
        onTouchStart: a,
        onTouchMove: o,
        onTouchEnd: c
      }
    });
  }
  function Sr(i) {
    var e = i.swiper,
      s = i.extendParams,
      n = i.on;
    s({
      grid: {
        rows: 1,
        fill: "column"
      }
    });
    var r, a, o, c;
    var l = function l() {
        var u = e.params.spaceBetween;
        return typeof u == "string" && u.indexOf("%") >= 0 ? u = parseFloat(u.replace("%", "")) / 100 * e.size : typeof u == "string" && (u = parseFloat(u)), u;
      },
      d = function d(u) {
        var b = e.params.slidesPerView,
          _e$params$grid = e.params.grid,
          C = _e$params$grid.rows,
          g = _e$params$grid.fill,
          w = e.virtual && e.params.virtual.enabled ? e.virtual.slides.length : u.length;
        o = Math.floor(w / C), Math.floor(w / C) === w / C ? r = w : r = Math.ceil(w / C) * C, b !== "auto" && g === "row" && (r = Math.max(r, b * C)), a = r / C;
      },
      f = function f() {
        e.slides && e.slides.forEach(function (u) {
          u.swiperSlideGridSet && (u.style.height = "", u.style[e.getDirectionLabel("margin-top")] = "");
        });
      },
      h = function h(u, b, C) {
        var g = e.params.slidesPerGroup,
          w = l(),
          _e$params$grid2 = e.params.grid,
          y = _e$params$grid2.rows,
          x = _e$params$grid2.fill,
          T = e.virtual && e.params.virtual.enabled ? e.virtual.slides.length : C.length;
        var S, L, E;
        if (x === "row" && g > 1) {
          var M = Math.floor(u / (g * y)),
            P = u - y * g * M,
            B = M === 0 ? g : Math.min(Math.ceil((T - M * y * g) / y), g);
          E = Math.floor(P / B), L = P - E * B + M * g, S = L + E * r / y, b.style.order = S;
        } else x === "column" ? (L = Math.floor(u / y), E = u - L * y, (L > o || L === o && E === y - 1) && (E += 1, E >= y && (E = 0, L += 1))) : (E = Math.floor(u / a), L = u - E * a);
        b.row = E, b.column = L, b.style.height = "calc((100% - ".concat((y - 1) * w, "px) / ").concat(y, ")"), b.style[e.getDirectionLabel("margin-top")] = E !== 0 ? w && "".concat(w, "px") : "", b.swiperSlideGridSet = !0;
      },
      v = function v(u, b) {
        var _e$params2 = e.params,
          C = _e$params2.centeredSlides,
          g = _e$params2.roundLengths,
          w = l(),
          y = e.params.grid.rows;
        if (e.virtualSize = (u + w) * r, e.virtualSize = Math.ceil(e.virtualSize / y) - w, e.params.cssMode || (e.wrapperEl.style[e.getDirectionLabel("width")] = "".concat(e.virtualSize + w, "px")), C) {
          var x = [];
          for (var T = 0; T < b.length; T += 1) {
            var S = b[T];
            g && (S = Math.floor(S)), b[T] < e.virtualSize + b[0] && x.push(S);
          }
          b.splice(0, b.length), b.push.apply(b, x);
        }
      },
      m = function m() {
        c = e.params.grid && e.params.grid.rows > 1;
      },
      p = function p() {
        var u = e.params,
          b = e.el,
          C = u.grid && u.grid.rows > 1;
        c && !C ? (b.classList.remove("".concat(u.containerModifierClass, "grid"), "".concat(u.containerModifierClass, "grid-column")), o = 1, e.emitContainerClasses()) : !c && C && (b.classList.add("".concat(u.containerModifierClass, "grid")), u.grid.fill === "column" && b.classList.add("".concat(u.containerModifierClass, "grid-column")), e.emitContainerClasses()), c = C;
      };
    n("init", m), n("update", p), e.grid = {
      initSlides: d,
      unsetSlides: f,
      updateSlide: h,
      updateWrapperSize: v
    };
  }
  function Mr(i) {
    var e = this,
      s = e.params,
      n = e.slidesEl;
    s.loop && e.loopDestroy();
    var r = function r(a) {
      if (typeof a == "string") {
        var o = document.createElement("div");
        o.innerHTML = a, n.append(o.children[0]), o.innerHTML = "";
      } else n.append(a);
    };
    if (_typeof(i) == "object" && "length" in i) for (var a = 0; a < i.length; a += 1) i[a] && r(i[a]);else r(i);
    e.recalcSlides(), s.loop && e.loopCreate(), (!s.observer || e.isElement) && e.update();
  }
  function Vr(i) {
    var e = this,
      s = e.params,
      n = e.activeIndex,
      r = e.slidesEl;
    s.loop && e.loopDestroy();
    var a = n + 1;
    var o = function o(c) {
      if (typeof c == "string") {
        var l = document.createElement("div");
        l.innerHTML = c, r.prepend(l.children[0]), l.innerHTML = "";
      } else r.prepend(c);
    };
    if (_typeof(i) == "object" && "length" in i) {
      for (var c = 0; c < i.length; c += 1) i[c] && o(i[c]);
      a = n + i.length;
    } else o(i);
    e.recalcSlides(), s.loop && e.loopCreate(), (!s.observer || e.isElement) && e.update(), e.slideTo(a, 0, !1);
  }
  function Tr(i, e) {
    var s = this,
      n = s.params,
      r = s.activeIndex,
      a = s.slidesEl;
    var o = r;
    n.loop && (o -= s.loopedSlides, s.loopDestroy(), s.recalcSlides());
    var c = s.slides.length;
    if (i <= 0) {
      s.prependSlide(e);
      return;
    }
    if (i >= c) {
      s.appendSlide(e);
      return;
    }
    var l = o > i ? o + 1 : o;
    var d = [];
    for (var f = c - 1; f >= i; f -= 1) {
      var h = s.slides[f];
      h.remove(), d.unshift(h);
    }
    if (_typeof(e) == "object" && "length" in e) {
      for (var _f4 = 0; _f4 < e.length; _f4 += 1) e[_f4] && a.append(e[_f4]);
      l = o > i ? o + e.length : o;
    } else a.append(e);
    for (var _f5 = 0; _f5 < d.length; _f5 += 1) a.append(d[_f5]);
    s.recalcSlides(), n.loop && s.loopCreate(), (!n.observer || s.isElement) && s.update(), n.loop ? s.slideTo(l + s.loopedSlides, 0, !1) : s.slideTo(l, 0, !1);
  }
  function Lr(i) {
    var e = this,
      s = e.params,
      n = e.activeIndex;
    var r = n;
    s.loop && (r -= e.loopedSlides, e.loopDestroy());
    var a = r,
      o;
    if (_typeof(i) == "object" && "length" in i) {
      for (var c = 0; c < i.length; c += 1) o = i[c], e.slides[o] && e.slides[o].remove(), o < a && (a -= 1);
      a = Math.max(a, 0);
    } else o = i, e.slides[o] && e.slides[o].remove(), o < a && (a -= 1), a = Math.max(a, 0);
    e.recalcSlides(), s.loop && e.loopCreate(), (!s.observer || e.isElement) && e.update(), s.loop ? e.slideTo(a + e.loopedSlides, 0, !1) : e.slideTo(a, 0, !1);
  }
  function Hr() {
    var i = this,
      e = [];
    for (var s = 0; s < i.slides.length; s += 1) e.push(s);
    i.removeSlide(e);
  }
  function Br(i) {
    var e = i.swiper;
    Object.assign(e, {
      appendSlide: Mr.bind(e),
      prependSlide: Vr.bind(e),
      addSlide: Tr.bind(e),
      removeSlide: Lr.bind(e),
      removeAllSlides: Hr.bind(e)
    });
  }
  function xe(i) {
    var e = i.effect,
      s = i.swiper,
      n = i.on,
      r = i.setTranslate,
      a = i.setTransition,
      o = i.overwriteParams,
      c = i.perspective,
      l = i.recreateShadows,
      d = i.getEffectParams;
    n("beforeInit", function () {
      if (s.params.effect !== e) return;
      s.classNames.push("".concat(s.params.containerModifierClass).concat(e)), c && c() && s.classNames.push("".concat(s.params.containerModifierClass, "3d"));
      var h = o ? o() : {};
      Object.assign(s.params, h), Object.assign(s.originalParams, h);
    }), n("setTranslate", function () {
      s.params.effect === e && r();
    }), n("setTransition", function (h, v) {
      s.params.effect === e && a(v);
    }), n("transitionEnd", function () {
      if (s.params.effect === e && l) {
        if (!d || !d().slideShadows) return;
        s.slides.forEach(function (h) {
          h.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach(function (v) {
            return v.remove();
          });
        }), l();
      }
    });
    var f;
    n("virtualUpdate", function () {
      s.params.effect === e && (s.slides.length || (f = !0), requestAnimationFrame(function () {
        f && s.slides && s.slides.length && (r(), f = !1);
      }));
    });
  }
  function Ze(i, e) {
    var s = ve(e);
    return s !== e && (s.style.backfaceVisibility = "hidden", s.style["-webkit-backface-visibility"] = "hidden"), s;
  }
  function Je(i) {
    var e = i.swiper,
      s = i.duration,
      n = i.transformElements,
      r = i.allSlides;
    var a = e.activeIndex,
      o = function o(c) {
        return c.parentElement ? c.parentElement : e.slides.find(function (d) {
          return d.shadowRoot && d.shadowRoot === c.parentNode;
        });
      };
    if (e.params.virtualTranslate && s !== 0) {
      var c = !1,
        l;
      r ? l = n : l = n.filter(function (d) {
        var f = d.classList.contains("swiper-slide-transform") ? o(d) : d;
        return e.getSlideIndex(f) === a;
      }), l.forEach(function (d) {
        Fe(d, function () {
          if (c || !e || e.destroyed) return;
          c = !0, e.animating = !1;
          var f = new window.CustomEvent("transitionend", {
            bubbles: !0,
            cancelable: !0
          });
          e.wrapperEl.dispatchEvent(f);
        });
      });
    }
  }
  function zr(i) {
    var e = i.swiper,
      s = i.extendParams,
      n = i.on;
    s({
      fadeEffect: {
        crossFade: !1
      }
    }), xe({
      effect: "fade",
      swiper: e,
      on: n,
      setTranslate: function setTranslate() {
        var o = e.slides,
          c = e.params.fadeEffect;
        for (var l = 0; l < o.length; l += 1) {
          var d = e.slides[l];
          var h = -d.swiperSlideOffset;
          e.params.virtualTranslate || (h -= e.translate);
          var v = 0;
          e.isHorizontal() || (v = h, h = 0);
          var m = e.params.fadeEffect.crossFade ? Math.max(1 - Math.abs(d.progress), 0) : 1 + Math.min(Math.max(d.progress, -1), 0),
            p = Ze(c, d);
          p.style.opacity = m, p.style.transform = "translate3d(".concat(h, "px, ").concat(v, "px, 0px)");
        }
      },
      setTransition: function setTransition(o) {
        var c = e.slides.map(function (l) {
          return ve(l);
        });
        c.forEach(function (l) {
          l.style.transitionDuration = "".concat(o, "ms");
        }), Je({
          swiper: e,
          duration: o,
          transformElements: c,
          allSlides: !0
        });
      },
      overwriteParams: function overwriteParams() {
        return {
          slidesPerView: 1,
          slidesPerGroup: 1,
          watchSlidesProgress: !0,
          spaceBetween: 0,
          virtualTranslate: !e.params.cssMode
        };
      }
    });
  }
  function Pr(i) {
    var e = i.swiper,
      s = i.extendParams,
      n = i.on;
    s({
      cubeEffect: {
        slideShadows: !0,
        shadow: !0,
        shadowOffset: 20,
        shadowScale: .94
      }
    });
    var r = function r(l, d, f) {
      var h = f ? l.querySelector(".swiper-slide-shadow-left") : l.querySelector(".swiper-slide-shadow-top"),
        v = f ? l.querySelector(".swiper-slide-shadow-right") : l.querySelector(".swiper-slide-shadow-bottom");
      h || (h = Q("div", "swiper-slide-shadow-cube swiper-slide-shadow-".concat(f ? "left" : "top").split(" ")), l.append(h)), v || (v = Q("div", "swiper-slide-shadow-cube swiper-slide-shadow-".concat(f ? "right" : "bottom").split(" ")), l.append(v)), h && (h.style.opacity = Math.max(-d, 0)), v && (v.style.opacity = Math.max(d, 0));
    };
    xe({
      effect: "cube",
      swiper: e,
      on: n,
      setTranslate: function setTranslate() {
        var l = e.el,
          d = e.wrapperEl,
          f = e.slides,
          h = e.width,
          v = e.height,
          m = e.rtlTranslate,
          p = e.size,
          u = e.browser,
          b = qe(e),
          C = e.params.cubeEffect,
          g = e.isHorizontal(),
          w = e.virtual && e.params.virtual.enabled;
        var y = 0,
          x;
        C.shadow && (g ? (x = e.wrapperEl.querySelector(".swiper-cube-shadow"), x || (x = Q("div", "swiper-cube-shadow"), e.wrapperEl.append(x)), x.style.height = "".concat(h, "px")) : (x = l.querySelector(".swiper-cube-shadow"), x || (x = Q("div", "swiper-cube-shadow"), l.append(x))));
        for (var S = 0; S < f.length; S += 1) {
          var L = f[S];
          var E = S;
          w && (E = parseInt(L.getAttribute("data-swiper-slide-index"), 10));
          var M = E * 90,
            P = Math.floor(M / 360);
          m && (M = -M, P = Math.floor(-M / 360));
          var B = Math.max(Math.min(L.progress, 1), -1);
          var H = 0,
            z = 0,
            I = 0;
          E % 4 === 0 ? (H = -P * 4 * p, I = 0) : (E - 1) % 4 === 0 ? (H = 0, I = -P * 4 * p) : (E - 2) % 4 === 0 ? (H = p + P * 4 * p, I = p) : (E - 3) % 4 === 0 && (H = -p, I = 3 * p + p * 4 * P), m && (H = -H), g || (z = H, H = 0);
          var $ = "rotateX(".concat(b(g ? 0 : -M), "deg) rotateY(").concat(b(g ? M : 0), "deg) translate3d(").concat(H, "px, ").concat(z, "px, ").concat(I, "px)");
          B <= 1 && B > -1 && (y = E * 90 + B * 90, m && (y = -E * 90 - B * 90)), L.style.transform = $, C.slideShadows && r(L, B, g);
        }
        if (d.style.transformOrigin = "50% 50% -".concat(p / 2, "px"), d.style["-webkit-transform-origin"] = "50% 50% -".concat(p / 2, "px"), C.shadow) if (g) x.style.transform = "translate3d(0px, ".concat(h / 2 + C.shadowOffset, "px, ").concat(-h / 2, "px) rotateX(89.99deg) rotateZ(0deg) scale(").concat(C.shadowScale, ")");else {
          var _S2 = Math.abs(y) - Math.floor(Math.abs(y) / 90) * 90,
            _L4 = 1.5 - (Math.sin(_S2 * 2 * Math.PI / 360) / 2 + Math.cos(_S2 * 2 * Math.PI / 360) / 2),
            _E3 = C.shadowScale,
            _M9 = C.shadowScale / _L4,
            _P10 = C.shadowOffset;
          x.style.transform = "scale3d(".concat(_E3, ", 1, ").concat(_M9, ") translate3d(0px, ").concat(v / 2 + _P10, "px, ").concat(-v / 2 / _M9, "px) rotateX(-89.99deg)");
        }
        var T = (u.isSafari || u.isWebView) && u.needPerspectiveFix ? -p / 2 : 0;
        d.style.transform = "translate3d(0px,0,".concat(T, "px) rotateX(").concat(b(e.isHorizontal() ? 0 : y), "deg) rotateY(").concat(b(e.isHorizontal() ? -y : 0), "deg)"), d.style.setProperty("--swiper-cube-translate-z", "".concat(T, "px"));
      },
      setTransition: function setTransition(l) {
        var d = e.el,
          f = e.slides;
        if (f.forEach(function (h) {
          h.style.transitionDuration = "".concat(l, "ms"), h.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach(function (v) {
            v.style.transitionDuration = "".concat(l, "ms");
          });
        }), e.params.cubeEffect.shadow && !e.isHorizontal()) {
          var h = d.querySelector(".swiper-cube-shadow");
          h && (h.style.transitionDuration = "".concat(l, "ms"));
        }
      },
      recreateShadows: function recreateShadows() {
        var l = e.isHorizontal();
        e.slides.forEach(function (d) {
          var f = Math.max(Math.min(d.progress, 1), -1);
          r(d, f, l);
        });
      },
      getEffectParams: function getEffectParams() {
        return e.params.cubeEffect;
      },
      perspective: function perspective() {
        return !0;
      },
      overwriteParams: function overwriteParams() {
        return {
          slidesPerView: 1,
          slidesPerGroup: 1,
          watchSlidesProgress: !0,
          resistanceRatio: 0,
          spaceBetween: 0,
          centeredSlides: !1,
          virtualTranslate: !0
        };
      }
    });
  }
  function ke(i, e, s) {
    var n = "swiper-slide-shadow".concat(s ? "-".concat(s) : "").concat(i ? " swiper-slide-shadow-".concat(i) : ""),
      r = ve(e);
    var a = r.querySelector(".".concat(n.split(" ").join(".")));
    return a || (a = Q("div", n.split(" ")), r.append(a)), a;
  }
  function _r(i) {
    var e = i.swiper,
      s = i.extendParams,
      n = i.on;
    s({
      flipEffect: {
        slideShadows: !0,
        limitRotation: !0
      }
    });
    var r = function r(l, d) {
      var f = e.isHorizontal() ? l.querySelector(".swiper-slide-shadow-left") : l.querySelector(".swiper-slide-shadow-top"),
        h = e.isHorizontal() ? l.querySelector(".swiper-slide-shadow-right") : l.querySelector(".swiper-slide-shadow-bottom");
      f || (f = ke("flip", l, e.isHorizontal() ? "left" : "top")), h || (h = ke("flip", l, e.isHorizontal() ? "right" : "bottom")), f && (f.style.opacity = Math.max(-d, 0)), h && (h.style.opacity = Math.max(d, 0));
    };
    xe({
      effect: "flip",
      swiper: e,
      on: n,
      setTranslate: function setTranslate() {
        var l = e.slides,
          d = e.rtlTranslate,
          f = e.params.flipEffect,
          h = qe(e);
        for (var v = 0; v < l.length; v += 1) {
          var m = l[v];
          var p = m.progress;
          e.params.flipEffect.limitRotation && (p = Math.max(Math.min(m.progress, 1), -1));
          var u = m.swiperSlideOffset;
          var C = -180 * p,
            g = 0,
            w = e.params.cssMode ? -u - e.translate : -u,
            y = 0;
          e.isHorizontal() ? d && (C = -C) : (y = w, w = 0, g = -C, C = 0), m.style.zIndex = -Math.abs(Math.round(p)) + l.length, f.slideShadows && r(m, p);
          var x = "translate3d(".concat(w, "px, ").concat(y, "px, 0px) rotateX(").concat(h(g), "deg) rotateY(").concat(h(C), "deg)"),
            T = Ze(f, m);
          T.style.transform = x;
        }
      },
      setTransition: function setTransition(l) {
        var d = e.slides.map(function (f) {
          return ve(f);
        });
        d.forEach(function (f) {
          f.style.transitionDuration = "".concat(l, "ms"), f.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach(function (h) {
            h.style.transitionDuration = "".concat(l, "ms");
          });
        }), Je({
          swiper: e,
          duration: l,
          transformElements: d
        });
      },
      recreateShadows: function recreateShadows() {
        e.params.flipEffect, e.slides.forEach(function (l) {
          var d = l.progress;
          e.params.flipEffect.limitRotation && (d = Math.max(Math.min(l.progress, 1), -1)), r(l, d);
        });
      },
      getEffectParams: function getEffectParams() {
        return e.params.flipEffect;
      },
      perspective: function perspective() {
        return !0;
      },
      overwriteParams: function overwriteParams() {
        return {
          slidesPerView: 1,
          slidesPerGroup: 1,
          watchSlidesProgress: !0,
          spaceBetween: 0,
          virtualTranslate: !e.params.cssMode
        };
      }
    });
  }
  function $r(i) {
    var e = i.swiper,
      s = i.extendParams,
      n = i.on;
    s({
      coverflowEffect: {
        rotate: 50,
        stretch: 0,
        depth: 100,
        scale: 1,
        modifier: 1,
        slideShadows: !0
      }
    }), xe({
      effect: "coverflow",
      swiper: e,
      on: n,
      setTranslate: function setTranslate() {
        var o = e.width,
          c = e.height,
          l = e.slides,
          d = e.slidesSizesGrid,
          f = e.params.coverflowEffect,
          h = e.isHorizontal(),
          v = e.translate,
          m = h ? -v + o / 2 : -v + c / 2,
          p = h ? f.rotate : -f.rotate,
          u = f.depth,
          b = qe(e);
        for (var C = 0, g = l.length; C < g; C += 1) {
          var w = l[C],
            y = d[C],
            x = w.swiperSlideOffset,
            T = (m - x - y / 2) / y,
            S = typeof f.modifier == "function" ? f.modifier(T) : T * f.modifier;
          var L = h ? p * S : 0,
            E = h ? 0 : p * S,
            M = -u * Math.abs(S),
            P = f.stretch;
          typeof P == "string" && P.indexOf("%") !== -1 && (P = parseFloat(f.stretch) / 100 * y);
          var B = h ? 0 : P * S,
            H = h ? P * S : 0,
            z = 1 - (1 - f.scale) * Math.abs(S);
          Math.abs(H) < .001 && (H = 0), Math.abs(B) < .001 && (B = 0), Math.abs(M) < .001 && (M = 0), Math.abs(L) < .001 && (L = 0), Math.abs(E) < .001 && (E = 0), Math.abs(z) < .001 && (z = 0);
          var I = "translate3d(".concat(H, "px,").concat(B, "px,").concat(M, "px)  rotateX(").concat(b(E), "deg) rotateY(").concat(b(L), "deg) scale(").concat(z, ")"),
            $ = Ze(f, w);
          if ($.style.transform = I, w.style.zIndex = -Math.abs(Math.round(S)) + 1, f.slideShadows) {
            var k = h ? w.querySelector(".swiper-slide-shadow-left") : w.querySelector(".swiper-slide-shadow-top"),
              V = h ? w.querySelector(".swiper-slide-shadow-right") : w.querySelector(".swiper-slide-shadow-bottom");
            k || (k = ke("coverflow", w, h ? "left" : "top")), V || (V = ke("coverflow", w, h ? "right" : "bottom")), k && (k.style.opacity = S > 0 ? S : 0), V && (V.style.opacity = -S > 0 ? -S : 0);
          }
        }
      },
      setTransition: function setTransition(o) {
        e.slides.map(function (l) {
          return ve(l);
        }).forEach(function (l) {
          l.style.transitionDuration = "".concat(o, "ms"), l.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach(function (d) {
            d.style.transitionDuration = "".concat(o, "ms");
          });
        });
      },
      perspective: function perspective() {
        return !0;
      },
      overwriteParams: function overwriteParams() {
        return {
          watchSlidesProgress: !0
        };
      }
    });
  }
  function Nr(i) {
    var e = i.swiper,
      s = i.extendParams,
      n = i.on;
    s({
      creativeEffect: {
        limitProgress: 1,
        shadowPerProgress: !1,
        progressMultiplier: 1,
        perspective: !0,
        prev: {
          translate: [0, 0, 0],
          rotate: [0, 0, 0],
          opacity: 1,
          scale: 1
        },
        next: {
          translate: [0, 0, 0],
          rotate: [0, 0, 0],
          opacity: 1,
          scale: 1
        }
      }
    });
    var r = function r(c) {
      return typeof c == "string" ? c : "".concat(c, "px");
    };
    xe({
      effect: "creative",
      swiper: e,
      on: n,
      setTranslate: function setTranslate() {
        var c = e.slides,
          l = e.wrapperEl,
          d = e.slidesSizesGrid,
          f = e.params.creativeEffect,
          h = f.progressMultiplier,
          v = e.params.centeredSlides,
          m = qe(e);
        if (v) {
          var p = d[0] / 2 - e.params.slidesOffsetBefore || 0;
          l.style.transform = "translateX(calc(50% - ".concat(p, "px))");
        }
        var _loop3 = function _loop3() {
          var u = c[_p],
            b = u.progress,
            C = Math.min(Math.max(u.progress, -f.limitProgress), f.limitProgress);
          var g = C;
          v || (g = Math.min(Math.max(u.originalProgress, -f.limitProgress), f.limitProgress));
          var w = u.swiperSlideOffset,
            y = [e.params.cssMode ? -w - e.translate : -w, 0, 0],
            x = [0, 0, 0];
          var T = !1;
          e.isHorizontal() || (y[1] = y[0], y[0] = 0);
          var S = {
            translate: [0, 0, 0],
            rotate: [0, 0, 0],
            scale: 1,
            opacity: 1
          };
          C < 0 ? (S = f.next, T = !0) : C > 0 && (S = f.prev, T = !0), y.forEach(function (z, I) {
            y[I] = "calc(".concat(z, "px + (").concat(r(S.translate[I]), " * ").concat(Math.abs(C * h), "))");
          }), x.forEach(function (z, I) {
            var $ = S.rotate[I] * Math.abs(C * h);
            x[I] = $;
          }), u.style.zIndex = -Math.abs(Math.round(b)) + c.length;
          var L = y.join(", "),
            E = "rotateX(".concat(m(x[0]), "deg) rotateY(").concat(m(x[1]), "deg) rotateZ(").concat(m(x[2]), "deg)"),
            M = g < 0 ? "scale(".concat(1 + (1 - S.scale) * g * h, ")") : "scale(".concat(1 - (1 - S.scale) * g * h, ")"),
            P = g < 0 ? 1 + (1 - S.opacity) * g * h : 1 - (1 - S.opacity) * g * h,
            B = "translate3d(".concat(L, ") ").concat(E, " ").concat(M);
          if (T && S.shadow || !T) {
            var z = u.querySelector(".swiper-slide-shadow");
            if (!z && S.shadow && (z = ke("creative", u)), z) {
              var I = f.shadowPerProgress ? C * (1 / f.limitProgress) : C;
              z.style.opacity = Math.min(Math.max(Math.abs(I), 0), 1);
            }
          }
          var H = Ze(f, u);
          H.style.transform = B, H.style.opacity = P, S.origin && (H.style.transformOrigin = S.origin);
        };
        for (var _p = 0; _p < c.length; _p += 1) {
          _loop3();
        }
      },
      setTransition: function setTransition(c) {
        var l = e.slides.map(function (d) {
          return ve(d);
        });
        l.forEach(function (d) {
          d.style.transitionDuration = "".concat(c, "ms"), d.querySelectorAll(".swiper-slide-shadow").forEach(function (f) {
            f.style.transitionDuration = "".concat(c, "ms");
          });
        }), Je({
          swiper: e,
          duration: c,
          transformElements: l,
          allSlides: !0
        });
      },
      perspective: function perspective() {
        return e.params.creativeEffect.perspective;
      },
      overwriteParams: function overwriteParams() {
        return {
          watchSlidesProgress: !0,
          virtualTranslate: !e.params.cssMode
        };
      }
    });
  }
  function Ir(i) {
    var e = i.swiper,
      s = i.extendParams,
      n = i.on;
    s({
      cardsEffect: {
        slideShadows: !0,
        rotate: !0,
        perSlideRotate: 2,
        perSlideOffset: 8
      }
    }), xe({
      effect: "cards",
      swiper: e,
      on: n,
      setTranslate: function setTranslate() {
        var o = e.slides,
          c = e.activeIndex,
          l = e.rtlTranslate,
          d = e.params.cardsEffect,
          _e$touchEventsData = e.touchEventsData,
          f = _e$touchEventsData.startTranslate,
          h = _e$touchEventsData.isTouched,
          v = l ? -e.translate : e.translate;
        for (var m = 0; m < o.length; m += 1) {
          var p = o[m],
            u = p.progress,
            b = Math.min(Math.max(u, -4), 4);
          var C = p.swiperSlideOffset;
          e.params.centeredSlides && !e.params.cssMode && (e.wrapperEl.style.transform = "translateX(".concat(e.minTranslate(), "px)")), e.params.centeredSlides && e.params.cssMode && (C -= o[0].swiperSlideOffset);
          var g = e.params.cssMode ? -C - e.translate : -C,
            w = 0;
          var y = -100 * Math.abs(b);
          var x = 1,
            T = -d.perSlideRotate * b,
            S = d.perSlideOffset - Math.abs(b) * .75;
          var L = e.virtual && e.params.virtual.enabled ? e.virtual.from + m : m,
            E = (L === c || L === c - 1) && b > 0 && b < 1 && (h || e.params.cssMode) && v < f,
            M = (L === c || L === c + 1) && b < 0 && b > -1 && (h || e.params.cssMode) && v > f;
          if (E || M) {
            var z = Math.pow(1 - Math.abs((Math.abs(b) - .5) / .5), .5);
            T += -28 * b * z, x += -.5 * z, S += 96 * z, w = "".concat(-25 * z * Math.abs(b), "%");
          }
          if (b < 0 ? g = "calc(".concat(g, "px ").concat(l ? "-" : "+", " (").concat(S * Math.abs(b), "%))") : b > 0 ? g = "calc(".concat(g, "px ").concat(l ? "-" : "+", " (-").concat(S * Math.abs(b), "%))") : g = "".concat(g, "px"), !e.isHorizontal()) {
            var _z4 = w;
            w = g, g = _z4;
          }
          var P = b < 0 ? "".concat(1 + (1 - x) * b) : "".concat(1 - (1 - x) * b),
            B = "\n        translate3d(".concat(g, ", ").concat(w, ", ").concat(y, "px)\n        rotateZ(").concat(d.rotate ? l ? -T : T : 0, "deg)\n        scale(").concat(P, ")\n      ");
          if (d.slideShadows) {
            var _z5 = p.querySelector(".swiper-slide-shadow");
            _z5 || (_z5 = ke("cards", p)), _z5 && (_z5.style.opacity = Math.min(Math.max((Math.abs(b) - .5) / .5, 0), 1));
          }
          p.style.zIndex = -Math.abs(Math.round(u)) + o.length;
          var H = Ze(d, p);
          H.style.transform = B;
        }
      },
      setTransition: function setTransition(o) {
        var c = e.slides.map(function (l) {
          return ve(l);
        });
        c.forEach(function (l) {
          l.style.transitionDuration = "".concat(o, "ms"), l.querySelectorAll(".swiper-slide-shadow").forEach(function (d) {
            d.style.transitionDuration = "".concat(o, "ms");
          });
        }), Je({
          swiper: e,
          duration: o,
          transformElements: c
        });
      },
      perspective: function perspective() {
        return !0;
      },
      overwriteParams: function overwriteParams() {
        return {
          _loopSwapReset: !1,
          watchSlidesProgress: !0,
          loopAdditionalSlides: e.params.cardsEffect.rotate ? 3 : 2,
          centeredSlides: !0,
          virtualTranslate: !e.params.cssMode
        };
      }
    });
  }
  var Ar = [fr, ur, mr, Bt, ui, hr, gr, wr, br, vr, Cr, yr, Er, xr, kr, Sr, Br, zr, Pr, _r, $r, Nr, Ir];
  ee.use(Ar);
  var Qe = ["eventsPrefix", "injectStyles", "injectStylesUrls", "modules", "init", "_direction", "oneWayMovement", "swiperElementNodeName", "touchEventsTarget", "initialSlide", "_speed", "cssMode", "updateOnWindowResize", "resizeObserver", "nested", "focusableElements", "_enabled", "_width", "_height", "preventInteractionOnTransition", "userAgent", "url", "_edgeSwipeDetection", "_edgeSwipeThreshold", "_freeMode", "_autoHeight", "setWrapperSize", "virtualTranslate", "_effect", "breakpoints", "breakpointsBase", "_spaceBetween", "_slidesPerView", "maxBackfaceHiddenSlides", "_grid", "_slidesPerGroup", "_slidesPerGroupSkip", "_slidesPerGroupAuto", "_centeredSlides", "_centeredSlidesBounds", "_slidesOffsetBefore", "_slidesOffsetAfter", "normalizeSlideIndex", "_centerInsufficientSlides", "_watchOverflow", "roundLengths", "touchRatio", "touchAngle", "simulateTouch", "_shortSwipes", "_longSwipes", "longSwipesRatio", "longSwipesMs", "_followFinger", "allowTouchMove", "_threshold", "touchMoveStopPropagation", "touchStartPreventDefault", "touchStartForcePreventDefault", "touchReleaseOnEdges", "uniqueNavElements", "_resistance", "_resistanceRatio", "_watchSlidesProgress", "_grabCursor", "preventClicks", "preventClicksPropagation", "_slideToClickedSlide", "_loop", "loopAdditionalSlides", "loopAddBlankSlides", "loopPreventsSliding", "_rewind", "_allowSlidePrev", "_allowSlideNext", "_swipeHandler", "_noSwiping", "noSwipingClass", "noSwipingSelector", "passiveListeners", "containerModifierClass", "slideClass", "slideActiveClass", "slideVisibleClass", "slideFullyVisibleClass", "slideNextClass", "slidePrevClass", "slideBlankClass", "wrapperClass", "lazyPreloaderClass", "lazyPreloadPrevNext", "runCallbacksOnInit", "observer", "observeParents", "observeSlideChildren", "a11y", "_autoplay", "_controller", "coverflowEffect", "cubeEffect", "fadeEffect", "flipEffect", "creativeEffect", "cardsEffect", "hashNavigation", "history", "keyboard", "mousewheel", "_navigation", "_pagination", "parallax", "_scrollbar", "_thumbs", "virtual", "zoom", "control"];
  function Se(i) {
    return _typeof(i) == "object" && i !== null && i.constructor && Object.prototype.toString.call(i).slice(8, -1) === "Object" && !i.__swiper__;
  }
  function zt(i, e) {
    var s = ["__proto__", "constructor", "prototype"];
    Object.keys(e).filter(function (n) {
      return s.indexOf(n) < 0;
    }).forEach(function (n) {
      _typeof(i[n]) > "u" ? i[n] = e[n] : Se(e[n]) && Se(i[n]) && Object.keys(e[n]).length > 0 ? e[n].__swiper__ ? i[n] = e[n] : zt(i[n], e[n]) : i[n] = e[n];
    });
  }
  function Dr(i) {
    return i === void 0 && (i = {}), i.navigation && _typeof(i.navigation.nextEl) > "u" && _typeof(i.navigation.prevEl) > "u";
  }
  function Or(i) {
    return i === void 0 && (i = {}), i.pagination && _typeof(i.pagination.el) > "u";
  }
  function Fr(i) {
    return i === void 0 && (i = {}), i.scrollbar && _typeof(i.scrollbar.el) > "u";
  }
  function et(i) {
    return i === void 0 && (i = ""), i.replace(/-[a-z]/g, function (e) {
      return e.toUpperCase().replace("-", "");
    });
  }
  function Zr(i) {
    var e = i.swiper,
      s = i.slides,
      n = i.passedParams,
      r = i.changedParams,
      a = i.nextEl,
      o = i.prevEl,
      c = i.scrollbarEl,
      l = i.paginationEl;
    var d = r.filter(function (E) {
        return E !== "children" && E !== "direction" && E !== "wrapperClass";
      }),
      f = e.params,
      h = e.pagination,
      v = e.navigation,
      m = e.scrollbar,
      p = e.virtual,
      u = e.thumbs;
    var b, C, g, w, y, x, T, S;
    r.includes("thumbs") && n.thumbs && n.thumbs.swiper && !n.thumbs.swiper.destroyed && f.thumbs && (!f.thumbs.swiper || f.thumbs.swiper.destroyed) && (b = !0), r.includes("controller") && n.controller && n.controller.control && f.controller && !f.controller.control && (C = !0), r.includes("pagination") && n.pagination && (n.pagination.el || l) && (f.pagination || f.pagination === !1) && h && !h.el && (g = !0), r.includes("scrollbar") && n.scrollbar && (n.scrollbar.el || c) && (f.scrollbar || f.scrollbar === !1) && m && !m.el && (w = !0), r.includes("navigation") && n.navigation && (n.navigation.prevEl || o) && (n.navigation.nextEl || a) && (f.navigation || f.navigation === !1) && v && !v.prevEl && !v.nextEl && (y = !0);
    var L = function L(E) {
      e[E] && (e[E].destroy(), E === "navigation" ? (e.isElement && (e[E].prevEl.remove(), e[E].nextEl.remove()), f[E].prevEl = void 0, f[E].nextEl = void 0, e[E].prevEl = void 0, e[E].nextEl = void 0) : (e.isElement && e[E].el.remove(), f[E].el = void 0, e[E].el = void 0));
    };
    r.includes("loop") && e.isElement && (f.loop && !n.loop ? x = !0 : !f.loop && n.loop ? T = !0 : S = !0), d.forEach(function (E) {
      if (Se(f[E]) && Se(n[E])) Object.assign(f[E], n[E]), (E === "navigation" || E === "pagination" || E === "scrollbar") && "enabled" in n[E] && !n[E].enabled && L(E);else {
        var M = n[E];
        (M === !0 || M === !1) && (E === "navigation" || E === "pagination" || E === "scrollbar") ? M === !1 && L(E) : f[E] = n[E];
      }
    }), d.includes("controller") && !C && e.controller && e.controller.control && f.controller && f.controller.control && (e.controller.control = f.controller.control), r.includes("children") && s && p && f.virtual.enabled ? (p.slides = s, p.update(!0)) : r.includes("virtual") && p && f.virtual.enabled && (s && (p.slides = s), p.update(!0)), r.includes("children") && s && f.loop && (S = !0), b && u.init() && u.update(!0), C && (e.controller.control = f.controller.control), g && (e.isElement && (!l || typeof l == "string") && (l = document.createElement("div"), l.classList.add("swiper-pagination"), l.part.add("pagination"), e.el.appendChild(l)), l && (f.pagination.el = l), h.init(), h.render(), h.update()), w && (e.isElement && (!c || typeof c == "string") && (c = document.createElement("div"), c.classList.add("swiper-scrollbar"), c.part.add("scrollbar"), e.el.appendChild(c)), c && (f.scrollbar.el = c), m.init(), m.updateSize(), m.setTranslate()), y && (e.isElement && ((!a || typeof a == "string") && (a = document.createElement("div"), a.classList.add("swiper-button-next"), a.innerHTML = e.hostEl.constructor.nextButtonSvg, a.part.add("button-next"), e.el.appendChild(a)), (!o || typeof o == "string") && (o = document.createElement("div"), o.classList.add("swiper-button-prev"), o.innerHTML = e.hostEl.constructor.prevButtonSvg, o.part.add("button-prev"), e.el.appendChild(o))), a && (f.navigation.nextEl = a), o && (f.navigation.prevEl = o), v.init(), v.update()), r.includes("allowSlideNext") && (e.allowSlideNext = n.allowSlideNext), r.includes("allowSlidePrev") && (e.allowSlidePrev = n.allowSlidePrev), r.includes("direction") && e.changeDirection(n.direction, !1), (x || S) && e.loopDestroy(), (T || S) && e.loopCreate(), e.update();
  }
  var mi = function mi(i) {
      if (parseFloat(i) === Number(i)) return Number(i);
      if (i === "true" || i === "") return !0;
      if (i === "false") return !1;
      if (i === "null") return null;
      if (i !== "undefined") {
        if (typeof i == "string" && i.includes("{") && i.includes("}") && i.includes('"')) {
          var e;
          try {
            e = JSON.parse(i);
          } catch (_unused4) {
            e = i;
          }
          return e;
        }
        return i;
      }
    },
    hi = ["a11y", "autoplay", "controller", "cards-effect", "coverflow-effect", "creative-effect", "cube-effect", "fade-effect", "flip-effect", "free-mode", "grid", "hash-navigation", "history", "keyboard", "mousewheel", "navigation", "pagination", "parallax", "scrollbar", "thumbs", "virtual", "zoom"];
  function gi(i, e, s) {
    var n = {},
      r = {};
    zt(n, Vt);
    var a = [].concat(Qe, ["on"]),
      o = a.map(function (l) {
        return l.replace(/_/, "");
      });
    a.forEach(function (l) {
      l = l.replace("_", ""), _typeof(i[l]) < "u" && (r[l] = i[l]);
    });
    var c = _toConsumableArray(i.attributes);
    return typeof e == "string" && _typeof(s) < "u" && c.push({
      name: e,
      value: Se(s) ? _objectSpread({}, s) : s
    }), c.forEach(function (l) {
      var d = hi.find(function (f) {
        return l.name.startsWith("".concat(f, "-"));
      });
      if (d) {
        var f = et(d),
          h = et(l.name.split("".concat(d, "-"))[1]);
        _typeof(r[f]) > "u" && (r[f] = {}), r[f] === !0 && (r[f] = {
          enabled: !0
        }), r[f][h] = mi(l.value);
      } else {
        var _f6 = et(l.name);
        if (!o.includes(_f6)) return;
        var _h6 = mi(l.value);
        r[_f6] && hi.includes(l.name) && !Se(_h6) ? (r[_f6].constructor !== Object && (r[_f6] = {}), r[_f6].enabled = !!_h6) : r[_f6] = _h6;
      }
    }), zt(n, r), n.navigation ? n.navigation = _objectSpread({
      prevEl: ".swiper-button-prev",
      nextEl: ".swiper-button-next"
    }, n.navigation !== !0 ? n.navigation : {}) : n.navigation === !1 && delete n.navigation, n.scrollbar ? n.scrollbar = _objectSpread({
      el: ".swiper-scrollbar"
    }, n.scrollbar !== !0 ? n.scrollbar : {}) : n.scrollbar === !1 && delete n.scrollbar, n.pagination ? n.pagination = _objectSpread({
      el: ".swiper-pagination"
    }, n.pagination !== !0 ? n.pagination : {}) : n.pagination === !1 && delete n.pagination, {
      params: n,
      passedParams: r
    };
  }
  var Rr = ":host{--swiper-theme-color:#007aff}:host{position:relative;display:block;margin-left:auto;margin-right:auto;z-index:1}.swiper{width:100%;height:100%;margin-left:auto;margin-right:auto;position:relative;overflow:hidden;list-style:none;padding:0;z-index:1;display:block}.swiper-vertical>.swiper-wrapper{flex-direction:column}.swiper-wrapper{position:relative;width:100%;height:100%;z-index:1;display:flex;transition-property:transform;transition-timing-function:var(--swiper-wrapper-transition-timing-function,initial);box-sizing:content-box}.swiper-android ::slotted(swiper-slide),.swiper-ios ::slotted(swiper-slide),.swiper-wrapper{transform:translate3d(0px,0,0)}.swiper-horizontal{touch-action:pan-y}.swiper-vertical{touch-action:pan-x}::slotted(swiper-slide){flex-shrink:0;width:100%;height:100%;position:relative;transition-property:transform;display:block}::slotted(.swiper-slide-invisible-blank){visibility:hidden}.swiper-autoheight,.swiper-autoheight ::slotted(swiper-slide){height:auto}.swiper-autoheight .swiper-wrapper{align-items:flex-start;transition-property:transform,height}.swiper-backface-hidden ::slotted(swiper-slide){transform:translateZ(0);-webkit-backface-visibility:hidden;backface-visibility:hidden}.swiper-3d.swiper-css-mode .swiper-wrapper{perspective:1200px}.swiper-3d .swiper-wrapper{transform-style:preserve-3d}.swiper-3d{perspective:1200px}.swiper-3d .swiper-cube-shadow,.swiper-3d ::slotted(swiper-slide){transform-style:preserve-3d}.swiper-css-mode>.swiper-wrapper{overflow:auto;scrollbar-width:none;-ms-overflow-style:none}.swiper-css-mode>.swiper-wrapper::-webkit-scrollbar{display:none}.swiper-css-mode ::slotted(swiper-slide){scroll-snap-align:start start}.swiper-css-mode.swiper-horizontal>.swiper-wrapper{scroll-snap-type:x mandatory}.swiper-css-mode.swiper-vertical>.swiper-wrapper{scroll-snap-type:y mandatory}.swiper-css-mode.swiper-free-mode>.swiper-wrapper{scroll-snap-type:none}.swiper-css-mode.swiper-free-mode ::slotted(swiper-slide){scroll-snap-align:none}.swiper-css-mode.swiper-centered>.swiper-wrapper::before{content:'';flex-shrink:0;order:9999}.swiper-css-mode.swiper-centered ::slotted(swiper-slide){scroll-snap-align:center center;scroll-snap-stop:always}.swiper-css-mode.swiper-centered.swiper-horizontal ::slotted(swiper-slide):first-child{margin-inline-start:var(--swiper-centered-offset-before)}.swiper-css-mode.swiper-centered.swiper-horizontal>.swiper-wrapper::before{height:100%;min-height:1px;width:var(--swiper-centered-offset-after)}.swiper-css-mode.swiper-centered.swiper-vertical ::slotted(swiper-slide):first-child{margin-block-start:var(--swiper-centered-offset-before)}.swiper-css-mode.swiper-centered.swiper-vertical>.swiper-wrapper::before{width:100%;min-width:1px;height:var(--swiper-centered-offset-after)}.swiper-virtual ::slotted(swiper-slide){-webkit-backface-visibility:hidden;transform:translateZ(0)}.swiper-virtual.swiper-css-mode .swiper-wrapper::after{content:'';position:absolute;left:0;top:0;pointer-events:none}.swiper-virtual.swiper-css-mode.swiper-horizontal .swiper-wrapper::after{height:1px;width:var(--swiper-virtual-size)}.swiper-virtual.swiper-css-mode.swiper-vertical .swiper-wrapper::after{width:1px;height:var(--swiper-virtual-size)}:host{--swiper-navigation-size:44px}.swiper-button-next,.swiper-button-prev{position:absolute;top:var(--swiper-navigation-top-offset,50%);width:calc(var(--swiper-navigation-size)/ 44 * 27);height:var(--swiper-navigation-size);margin-top:calc(0px - (var(--swiper-navigation-size)/ 2));z-index:10;cursor:pointer;display:flex;align-items:center;justify-content:center;color:var(--swiper-navigation-color,var(--swiper-theme-color))}.swiper-button-next.swiper-button-disabled,.swiper-button-prev.swiper-button-disabled{opacity:.35;cursor:auto;pointer-events:none}.swiper-button-next.swiper-button-hidden,.swiper-button-prev.swiper-button-hidden{opacity:0;cursor:auto;pointer-events:none}.swiper-navigation-disabled .swiper-button-next,.swiper-navigation-disabled .swiper-button-prev{display:none!important}.swiper-button-next svg,.swiper-button-prev svg{width:100%;height:100%;object-fit:contain;transform-origin:center}.swiper-rtl .swiper-button-next svg,.swiper-rtl .swiper-button-prev svg{transform:rotate(180deg)}.swiper-button-prev,.swiper-rtl .swiper-button-next{left:var(--swiper-navigation-sides-offset,10px);right:auto}.swiper-button-next,.swiper-rtl .swiper-button-prev{right:var(--swiper-navigation-sides-offset,10px);left:auto}.swiper-button-lock{display:none}.swiper-pagination{position:absolute;text-align:center;transition:.3s opacity;transform:translate3d(0,0,0);z-index:10}.swiper-pagination.swiper-pagination-hidden{opacity:0}.swiper-pagination-disabled>.swiper-pagination,.swiper-pagination.swiper-pagination-disabled{display:none!important}.swiper-horizontal>.swiper-pagination-bullets,.swiper-pagination-bullets.swiper-pagination-horizontal,.swiper-pagination-custom,.swiper-pagination-fraction{bottom:var(--swiper-pagination-bottom,8px);top:var(--swiper-pagination-top,auto);left:0;width:100%}.swiper-pagination-bullets-dynamic{overflow:hidden;font-size:0}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet{transform:scale(.33);position:relative}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active{transform:scale(1)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-main{transform:scale(1)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev{transform:scale(.66)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev-prev{transform:scale(.33)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next{transform:scale(.66)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next-next{transform:scale(.33)}.swiper-pagination-bullet{width:var(--swiper-pagination-bullet-width,var(--swiper-pagination-bullet-size,8px));height:var(--swiper-pagination-bullet-height,var(--swiper-pagination-bullet-size,8px));display:inline-block;border-radius:var(--swiper-pagination-bullet-border-radius,50%);background:var(--swiper-pagination-bullet-inactive-color,#000);opacity:var(--swiper-pagination-bullet-inactive-opacity, .2)}button.swiper-pagination-bullet{border:none;margin:0;padding:0;box-shadow:none;-webkit-appearance:none;appearance:none}.swiper-pagination-clickable .swiper-pagination-bullet{cursor:pointer}.swiper-pagination-bullet:only-child{display:none!important}.swiper-pagination-bullet-active{opacity:var(--swiper-pagination-bullet-opacity, 1);background:var(--swiper-pagination-color,var(--swiper-theme-color))}.swiper-pagination-vertical.swiper-pagination-bullets,.swiper-vertical>.swiper-pagination-bullets{right:var(--swiper-pagination-right,8px);left:var(--swiper-pagination-left,auto);top:50%;transform:translate3d(0px,-50%,0)}.swiper-pagination-vertical.swiper-pagination-bullets .swiper-pagination-bullet,.swiper-vertical>.swiper-pagination-bullets .swiper-pagination-bullet{margin:var(--swiper-pagination-bullet-vertical-gap,6px) 0;display:block}.swiper-pagination-vertical.swiper-pagination-bullets.swiper-pagination-bullets-dynamic,.swiper-vertical>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic{top:50%;transform:translateY(-50%);width:8px}.swiper-pagination-vertical.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet,.swiper-vertical>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet{display:inline-block;transition:.2s transform,.2s top}.swiper-horizontal>.swiper-pagination-bullets .swiper-pagination-bullet,.swiper-pagination-horizontal.swiper-pagination-bullets .swiper-pagination-bullet{margin:0 var(--swiper-pagination-bullet-horizontal-gap,4px)}.swiper-horizontal>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic,.swiper-pagination-horizontal.swiper-pagination-bullets.swiper-pagination-bullets-dynamic{left:50%;transform:translateX(-50%);white-space:nowrap}.swiper-horizontal>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet,.swiper-pagination-horizontal.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet{transition:.2s transform,.2s left}.swiper-horizontal.swiper-rtl>.swiper-pagination-bullets-dynamic .swiper-pagination-bullet{transition:.2s transform,.2s right}.swiper-pagination-fraction{color:var(--swiper-pagination-fraction-color,inherit)}.swiper-pagination-progressbar{background:var(--swiper-pagination-progressbar-bg-color,rgba(0,0,0,.25));position:absolute}.swiper-pagination-progressbar .swiper-pagination-progressbar-fill{background:var(--swiper-pagination-color,var(--swiper-theme-color));position:absolute;left:0;top:0;width:100%;height:100%;transform:scale(0);transform-origin:left top}.swiper-rtl .swiper-pagination-progressbar .swiper-pagination-progressbar-fill{transform-origin:right top}.swiper-horizontal>.swiper-pagination-progressbar,.swiper-pagination-progressbar.swiper-pagination-horizontal,.swiper-pagination-progressbar.swiper-pagination-vertical.swiper-pagination-progressbar-opposite,.swiper-vertical>.swiper-pagination-progressbar.swiper-pagination-progressbar-opposite{width:100%;height:var(--swiper-pagination-progressbar-size,4px);left:0;top:0}.swiper-horizontal>.swiper-pagination-progressbar.swiper-pagination-progressbar-opposite,.swiper-pagination-progressbar.swiper-pagination-horizontal.swiper-pagination-progressbar-opposite,.swiper-pagination-progressbar.swiper-pagination-vertical,.swiper-vertical>.swiper-pagination-progressbar{width:var(--swiper-pagination-progressbar-size,4px);height:100%;left:0;top:0}.swiper-pagination-lock{display:none}.swiper-scrollbar{border-radius:var(--swiper-scrollbar-border-radius,10px);position:relative;touch-action:none;background:var(--swiper-scrollbar-bg-color,rgba(0,0,0,.1))}.swiper-scrollbar-disabled>.swiper-scrollbar,.swiper-scrollbar.swiper-scrollbar-disabled{display:none!important}.swiper-horizontal>.swiper-scrollbar,.swiper-scrollbar.swiper-scrollbar-horizontal{position:absolute;left:var(--swiper-scrollbar-sides-offset,1%);bottom:var(--swiper-scrollbar-bottom,4px);top:var(--swiper-scrollbar-top,auto);z-index:50;height:var(--swiper-scrollbar-size,4px);width:calc(100% - 2 * var(--swiper-scrollbar-sides-offset,1%))}.swiper-scrollbar.swiper-scrollbar-vertical,.swiper-vertical>.swiper-scrollbar{position:absolute;left:var(--swiper-scrollbar-left,auto);right:var(--swiper-scrollbar-right,4px);top:var(--swiper-scrollbar-sides-offset,1%);z-index:50;width:var(--swiper-scrollbar-size,4px);height:calc(100% - 2 * var(--swiper-scrollbar-sides-offset,1%))}.swiper-scrollbar-drag{height:100%;width:100%;position:relative;background:var(--swiper-scrollbar-drag-bg-color,rgba(0,0,0,.5));border-radius:var(--swiper-scrollbar-border-radius,10px);left:0;top:0}.swiper-scrollbar-cursor-drag{cursor:move}.swiper-scrollbar-lock{display:none}::slotted(.swiper-slide-zoomed){cursor:move;touch-action:none}.swiper .swiper-notification{position:absolute;left:0;top:0;pointer-events:none;opacity:0;z-index:-1000}.swiper-free-mode>.swiper-wrapper{transition-timing-function:ease-out;margin:0 auto}.swiper-grid>.swiper-wrapper{flex-wrap:wrap}.swiper-grid-column>.swiper-wrapper{flex-wrap:wrap;flex-direction:column}.swiper-fade.swiper-free-mode ::slotted(swiper-slide){transition-timing-function:ease-out}.swiper-fade ::slotted(swiper-slide){pointer-events:none;transition-property:opacity}.swiper-fade ::slotted(swiper-slide) ::slotted(swiper-slide){pointer-events:none}.swiper-fade ::slotted(.swiper-slide-active){pointer-events:auto}.swiper-fade ::slotted(.swiper-slide-active) ::slotted(.swiper-slide-active){pointer-events:auto}.swiper.swiper-cube{overflow:visible}.swiper-cube ::slotted(swiper-slide){pointer-events:none;-webkit-backface-visibility:hidden;backface-visibility:hidden;z-index:1;visibility:hidden;transform-origin:0 0;width:100%;height:100%}.swiper-cube ::slotted(swiper-slide) ::slotted(swiper-slide){pointer-events:none}.swiper-cube.swiper-rtl ::slotted(swiper-slide){transform-origin:100% 0}.swiper-cube ::slotted(.swiper-slide-active),.swiper-cube ::slotted(.swiper-slide-active) ::slotted(.swiper-slide-active){pointer-events:auto}.swiper-cube ::slotted(.swiper-slide-active),.swiper-cube ::slotted(.swiper-slide-next),.swiper-cube ::slotted(.swiper-slide-prev){pointer-events:auto;visibility:visible}.swiper-cube .swiper-cube-shadow{position:absolute;left:0;bottom:0px;width:100%;height:100%;opacity:.6;z-index:0}.swiper-cube .swiper-cube-shadow:before{content:'';background:#000;position:absolute;left:0;top:0;bottom:0;right:0;filter:blur(50px)}.swiper-cube ::slotted(.swiper-slide-next)+::slotted(swiper-slide){pointer-events:auto;visibility:visible}.swiper.swiper-flip{overflow:visible}.swiper-flip ::slotted(swiper-slide){pointer-events:none;-webkit-backface-visibility:hidden;backface-visibility:hidden;z-index:1}.swiper-flip ::slotted(swiper-slide) ::slotted(swiper-slide){pointer-events:none}.swiper-flip ::slotted(.swiper-slide-active),.swiper-flip ::slotted(.swiper-slide-active) ::slotted(.swiper-slide-active){pointer-events:auto}.swiper-creative ::slotted(swiper-slide){-webkit-backface-visibility:hidden;backface-visibility:hidden;overflow:hidden;transition-property:transform,opacity,height}.swiper.swiper-cards{overflow:visible}.swiper-cards ::slotted(swiper-slide){transform-origin:center bottom;-webkit-backface-visibility:hidden;backface-visibility:hidden;overflow:hidden}",
    jr = "::slotted(.swiper-slide-shadow),::slotted(.swiper-slide-shadow-bottom),::slotted(.swiper-slide-shadow-left),::slotted(.swiper-slide-shadow-right),::slotted(.swiper-slide-shadow-top){position:absolute;left:0;top:0;width:100%;height:100%;pointer-events:none;z-index:10}::slotted(.swiper-slide-shadow){background:rgba(0,0,0,.15)}::slotted(.swiper-slide-shadow-left){background-image:linear-gradient(to left,rgba(0,0,0,.5),rgba(0,0,0,0))}::slotted(.swiper-slide-shadow-right){background-image:linear-gradient(to right,rgba(0,0,0,.5),rgba(0,0,0,0))}::slotted(.swiper-slide-shadow-top){background-image:linear-gradient(to top,rgba(0,0,0,.5),rgba(0,0,0,0))}::slotted(.swiper-slide-shadow-bottom){background-image:linear-gradient(to bottom,rgba(0,0,0,.5),rgba(0,0,0,0))}.swiper-lazy-preloader{animation:swiper-preloader-spin 1s infinite linear;width:42px;height:42px;position:absolute;left:50%;top:50%;margin-left:-21px;margin-top:-21px;z-index:10;transform-origin:50%;box-sizing:border-box;border:4px solid var(--swiper-preloader-color,var(--swiper-theme-color));border-radius:50%;border-top-color:transparent}@keyframes swiper-preloader-spin{0%{transform:rotate(0deg)}100%{transform:rotate(360deg)}}::slotted(.swiper-slide-shadow-cube.swiper-slide-shadow-bottom),::slotted(.swiper-slide-shadow-cube.swiper-slide-shadow-left),::slotted(.swiper-slide-shadow-cube.swiper-slide-shadow-right),::slotted(.swiper-slide-shadow-cube.swiper-slide-shadow-top){z-index:0;-webkit-backface-visibility:hidden;backface-visibility:hidden}::slotted(.swiper-slide-shadow-flip.swiper-slide-shadow-bottom),::slotted(.swiper-slide-shadow-flip.swiper-slide-shadow-left),::slotted(.swiper-slide-shadow-flip.swiper-slide-shadow-right),::slotted(.swiper-slide-shadow-flip.swiper-slide-shadow-top){z-index:0;-webkit-backface-visibility:hidden;backface-visibility:hidden}::slotted(.swiper-zoom-container){width:100%;height:100%;display:flex;justify-content:center;align-items:center;text-align:center}::slotted(.swiper-zoom-container)>canvas,::slotted(.swiper-zoom-container)>img,::slotted(.swiper-zoom-container)>svg{max-width:100%;max-height:100%;object-fit:contain}";
  var Wr = /*#__PURE__*/_createClass(function Wr() {
    _classCallCheck(this, Wr);
  });
  var wi = (typeof window === "undefined" ? "undefined" : _typeof(window)) > "u" || (typeof HTMLElement === "undefined" ? "undefined" : _typeof(HTMLElement)) > "u" ? Wr : HTMLElement,
    bi = "<svg width=\"11\" height=\"20\" viewBox=\"0 0 11 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M0.38296 20.0762C0.111788 19.805 0.111788 19.3654 0.38296 19.0942L9.19758 10.2796L0.38296 1.46497C0.111788 1.19379 0.111788 0.754138 0.38296 0.482966C0.654131 0.211794 1.09379 0.211794 1.36496 0.482966L10.4341 9.55214C10.8359 9.9539 10.8359 10.6053 10.4341 11.007L1.36496 20.0762C1.09379 20.3474 0.654131 20.3474 0.38296 20.0762Z\" fill=\"currentColor\"/></svg>\n    ",
    vi = function vi(i, e) {
      if ((typeof CSSStyleSheet === "undefined" ? "undefined" : _typeof(CSSStyleSheet)) < "u" && i.adoptedStyleSheets) {
        var s = new CSSStyleSheet();
        s.replaceSync(e), i.adoptedStyleSheets = [s];
      } else {
        var _s2 = document.createElement("style");
        _s2.rel = "stylesheet", _s2.textContent = e, i.appendChild(_s2);
      }
    };
  var Ci = /*#__PURE__*/function (_wi) {
    function Ci() {
      var _this2;
      _classCallCheck(this, Ci);
      _this2 = _callSuper(this, Ci), _this2.attachShadow({
        mode: "open"
      });
      return _this2;
    }
    _inherits(Ci, _wi);
    return _createClass(Ci, [{
      key: "cssStyles",
      value: function cssStyles() {
        return [Rr].concat(_toConsumableArray(this.injectStyles && Array.isArray(this.injectStyles) ? this.injectStyles : [])).join("\n");
      }
    }, {
      key: "cssLinks",
      value: function cssLinks() {
        return this.injectStylesUrls || [];
      }
    }, {
      key: "calcSlideSlots",
      value: function calcSlideSlots() {
        var e = this.slideSlots || 0,
          s = _toConsumableArray(this.querySelectorAll("[slot^=slide-]")).map(function (n) {
            return parseInt(n.getAttribute("slot").split("slide-")[1], 10);
          });
        if (this.slideSlots = s.length ? Math.max.apply(Math, _toConsumableArray(s)) + 1 : 0, !!this.rendered) {
          if (this.slideSlots > e) for (var n = e; n < this.slideSlots; n += 1) {
            var r = document.createElement("swiper-slide");
            r.setAttribute("part", "slide slide-".concat(n + 1));
            var a = document.createElement("slot");
            a.setAttribute("name", "slide-".concat(n + 1)), r.appendChild(a), this.shadowRoot.querySelector(".swiper-wrapper").appendChild(r);
          } else if (this.slideSlots < e) {
            var _n2 = this.swiper.slides;
            for (var _r4 = _n2.length - 1; _r4 >= 0; _r4 -= 1) _r4 > this.slideSlots && _n2[_r4].remove();
          }
        }
      }
    }, {
      key: "render",
      value: function render() {
        var _this3 = this;
        if (this.rendered) return;
        this.calcSlideSlots();
        var e = this.cssStyles();
        this.slideSlots > 0 && (e = e.replace(/::slotted\(([a-z-0-9.]*)\)/g, "$1")), e.length && vi(this.shadowRoot, e), this.cssLinks().forEach(function (n) {
          if (_this3.shadowRoot.querySelector("link[href=\"".concat(n, "\"]"))) return;
          var a = document.createElement("link");
          a.rel = "stylesheet", a.href = n, _this3.shadowRoot.appendChild(a);
        });
        var s = document.createElement("div");
        s.classList.add("swiper"), s.part = "container", s.innerHTML = "\n      <slot name=\"container-start\"></slot>\n      <div class=\"swiper-wrapper\" part=\"wrapper\">\n        <slot></slot>\n        ".concat(Array.from({
          length: this.slideSlots
        }).map(function (n, r) {
          return "\n        <swiper-slide part=\"slide slide-".concat(r, "\">\n          <slot name=\"slide-").concat(r, "\"></slot>\n        </swiper-slide>\n        ");
        }).join(""), "\n      </div>\n      <slot name=\"container-end\"></slot>\n      ").concat(Dr(this.passedParams) ? "\n        <div part=\"button-prev\" class=\"swiper-button-prev\">".concat(this.constructor.prevButtonSvg, "</div>\n        <div part=\"button-next\" class=\"swiper-button-next\">").concat(this.constructor.nextButtonSvg, "</div>\n      ") : "", "\n      ").concat(Or(this.passedParams) ? "\n        <div part=\"pagination\" class=\"swiper-pagination\"></div>\n      " : "", "\n      ").concat(Fr(this.passedParams) ? "\n        <div part=\"scrollbar\" class=\"swiper-scrollbar\"></div>\n      " : "", "\n    "), this.shadowRoot.appendChild(s), this.rendered = !0;
      }
    }, {
      key: "initialize",
      value: function initialize() {
        var e = this;
        if (this.swiper && this.swiper.initialized) return;
        var _gi = gi(this),
          s = _gi.params,
          n = _gi.passedParams;
        this.swiperParams = s, this.passedParams = n, delete this.swiperParams.init, this.render(), this.swiper = new ee(this.shadowRoot.querySelector(".swiper"), _objectSpread(_objectSpread(_objectSpread({}, s.virtual ? {} : {
          observer: !0
        }), s), {}, {
          touchEventsTarget: "container",
          onAny: function onAny(r) {
            r === "observerUpdate" && e.calcSlideSlots();
            var a = s.eventsPrefix ? "".concat(s.eventsPrefix).concat(r.toLowerCase()) : r.toLowerCase();
            for (var o = arguments.length, c = new Array(o > 1 ? o - 1 : 0), l = 1; l < o; l++) c[l - 1] = arguments[l];
            var d = new CustomEvent(a, {
              detail: c,
              bubbles: r !== "hashChange",
              cancelable: !0
            });
            e.dispatchEvent(d);
          }
        }));
      }
    }, {
      key: "connectedCallback",
      value: function connectedCallback() {
        this.swiper && this.swiper.initialized && this.nested && this.closest("swiper-slide") && this.closest("swiper-slide").swiperLoopMoveDOM || this.init === !1 || this.getAttribute("init") === "false" || this.initialize();
      }
    }, {
      key: "disconnectedCallback",
      value: function disconnectedCallback() {
        this.nested && this.closest("swiper-slide") && this.closest("swiper-slide").swiperLoopMoveDOM || this.swiper && this.swiper.destroy && this.swiper.destroy();
      }
    }, {
      key: "updateSwiperOnPropChange",
      value: function updateSwiperOnPropChange(e, s) {
        var _gi2 = gi(this, e, s),
          n = _gi2.params,
          r = _gi2.passedParams;
        this.passedParams = r, this.swiperParams = n, !(this.swiper && this.swiper.params[e] === s) && Zr(_objectSpread(_objectSpread(_objectSpread({
          swiper: this.swiper,
          passedParams: this.passedParams,
          changedParams: [et(e)]
        }, e === "navigation" && r[e] ? {
          prevEl: ".swiper-button-prev",
          nextEl: ".swiper-button-next"
        } : {}), e === "pagination" && r[e] ? {
          paginationEl: ".swiper-pagination"
        } : {}), e === "scrollbar" && r[e] ? {
          scrollbarEl: ".swiper-scrollbar"
        } : {}));
      }
    }, {
      key: "attributeChangedCallback",
      value: function attributeChangedCallback(e, s, n) {
        this.swiper && this.swiper.initialized && (s === "true" && n === null && (n = !1), this.updateSwiperOnPropChange(e, n));
      }
    }], [{
      key: "nextButtonSvg",
      get: function get() {
        return bi;
      }
    }, {
      key: "prevButtonSvg",
      get: function get() {
        return bi.replace("/></svg>", ' transform-origin="center" transform="rotate(180)"/></svg>');
      }
    }, {
      key: "observedAttributes",
      get: function get() {
        return Qe.filter(function (s) {
          return s.includes("_");
        }).map(function (s) {
          return s.replace(/[A-Z]/g, function (n) {
            return "-".concat(n);
          }).replace("_", "").toLowerCase();
        });
      }
    }]);
  }(wi);
  Qe.forEach(function (i) {
    i !== "init" && (i = i.replace("_", ""), Object.defineProperty(Ci.prototype, i, {
      configurable: !0,
      get: function get() {
        return (this.passedParams || {})[i];
      },
      set: function set(e) {
        this.passedParams || (this.passedParams = {}), this.passedParams[i] = e, this.swiper && this.swiper.initialized && this.updateSwiperOnPropChange(i, e);
      }
    }));
  });
  var Gr = /*#__PURE__*/function (_wi2) {
    function Gr() {
      var _this4;
      _classCallCheck(this, Gr);
      _this4 = _callSuper(this, Gr), _this4.attachShadow({
        mode: "open"
      });
      return _this4;
    }
    _inherits(Gr, _wi2);
    return _createClass(Gr, [{
      key: "render",
      value: function render() {
        var e = this.lazy || this.getAttribute("lazy") === "" || this.getAttribute("lazy") === "true";
        if (vi(this.shadowRoot, jr), this.shadowRoot.appendChild(document.createElement("slot")), e) {
          var s = document.createElement("div");
          s.classList.add("swiper-lazy-preloader"), s.part.add("preloader"), this.shadowRoot.appendChild(s);
        }
      }
    }, {
      key: "initialize",
      value: function initialize() {
        this.render();
      }
    }, {
      key: "connectedCallback",
      value: function connectedCallback() {
        this.swiperLoopMoveDOM || this.initialize();
      }
    }]);
  }(wi);
  var yi = function yi() {
    (typeof window === "undefined" ? "undefined" : _typeof(window)) > "u" || (window.customElements.get("swiper-container") || window.customElements.define("swiper-container", Ci), window.customElements.get("swiper-slide") || window.customElements.define("swiper-slide", Gr));
  };
  (typeof window === "undefined" ? "undefined" : _typeof(window)) < "u" && (window.SwiperElementRegisterParams = function (i) {
    Qe.push.apply(Qe, _toConsumableArray(i));
  });
  var Yr = {
      key: 0,
      "data-testid": "card-slider",
      "class": "relative w-full h-full"
    },
    Xr = ["modules", "pagination", "navigation", "breakpoints", "centered-slides", "slides-per-view", "loop"],
    Ur = ["id"],
    Ei = t.defineComponent({
      __name: "CardSlider",
      props: {
        items: {},
        slidesPerView: {
          "default": 1.1
        },
        centeredSlides: {
          type: Boolean,
          "default": !1
        },
        ratio: {
          "default": "small"
        },
        breakpoints: {},
        disableBreakpoints: {
          type: Boolean,
          "default": !1
        },
        id: {
          "default": "default"
        }
      },
      setup: function setup(i) {
        var _ref26;
        var n;
        var e = i;
        yi();
        var s = t.ref({});
        return e.disableBreakpoints || (e.breakpoints ? s.value = e.breakpoints : s.value = {
          592: {
            slidesPerView: e.ratio === "portrait" ? 3 : 2
          },
          800: {
            slidesPerView: "auto",
            loopedSlides: (_ref26 = (n = e.items) == null ? void 0 : n.length) !== null && _ref26 !== void 0 ? _ref26 : !1,
            allowTouchMove: !1
          }
        }), function (r, a) {
          return r.items && r.items.length > 0 ? (t.openBlock(), t.createElementBlock("section", Yr, [t.createElementVNode("swiper-container", {
            modules: [t.unref(ui), t.unref(Bt)],
            pagination: {
              el: "#card-swiper-pagination-".concat(r.id, ".card-swiper-pagination"),
              clickable: !0
            },
            navigation: {
              prevEl: "#card-swiper-button-prev-".concat(r.id, ".card-swiper-button-prev"),
              nextEl: "#card-swiper-button-next-".concat(r.id, ".card-swiper-button-next")
            },
            breakpoints: s.value,
            "centered-slides": r.centeredSlides,
            clickable: !0,
            "slides-per-view": r.slidesPerView,
            "space-between": 10,
            loop: r.items.length > 4
          }, [(t.openBlock(!0), t.createElementBlock(t.Fragment, null, t.renderList(r.items, function (o, c) {
            return t.openBlock(), t.createElementBlock("swiper-slide", {
              key: c,
              "class": t.normalizeClass(["md:max-w-[350px]", {
                "md:max-w-[200px]": r.ratio === "portrait"
              }])
            }, [t.createVNode(ei, t.mergeProps({
              item: o,
              ratio: r.ratio,
              ref_for: !0
            }, r.$attrs), null, 16, ["item", "ratio"])], 2);
          }), 128))], 8, Xr), t.createVNode(t.unref(Ie), {
            id: "card-swiper-button-prev-".concat(r.id),
            "class": "hidden text-white card-swiper-button-prev"
          }, null, 8, ["id"]), t.createVNode(t.unref(Ie), {
            id: "card-swiper-button-next-".concat(r.id),
            "class": "hidden text-white card-swiper-button-next"
          }, null, 8, ["id"]), t.createElementVNode("div", {
            id: "card-swiper-pagination-".concat(r.id),
            "class": "card-swiper-pagination"
          }, null, 8, Ur)])) : t.createCommentVNode("", !0);
        };
      }
    }),
    pe = t.defineComponent({
      __name: "DefaultButton",
      props: {
        color: {
          "default": "Default"
        },
        small: {
          type: Boolean,
          "default": !1
        }
      },
      setup: function setup(i) {
        return function (e, s) {
          return t.openBlock(), t.createElementBlock("button", {
            "class": t.normalizeClass(["w-full mx-auto rounded typo-button-text text-nowrap", {
              "default-button--default": e.color === "Default",
              "default-button--transparent-yellow": e.color === "TransparentYellow",
              "default-button--yellow-transparent": e.color === "YellowTransparent",
              "default-button--grey": e.color === "Grey",
              "default-button--transparent-black": e.color === "TransparentBlack",
              "default-button--red": e.color === "Red",
              "default-button--transparent-red": e.color === "TransparentRed",
              "default-button--transparent-red-border": e.color === "TransparentRedBorder",
              "default-button--black-yellow": e.color === "BlackYellow",
              "p-2": e.small,
              "p-[0.9375rem]": !e.small
            }])
          }, [t.renderSlot(e.$slots, "default")], 2);
        };
      }
    }),
    qr = {
      key: 0,
      "class": "flex flex-col",
      "data-testid": "card-section"
    },
    Kr = {
      "class": "hover:cursor-pointer"
    },
    Jr = {
      "class": "w-full px-4 mt-4 md:max-w-80 md:mx-auto"
    },
    Qr = t.defineComponent({
      __name: "CardSection",
      props: {
        item: {},
        slidesPerView: {
          "default": 1.1
        },
        centeredSlides: {
          type: Boolean,
          "default": !1
        },
        breakpoints: {
          "default": null
        },
        disableBreakpoints: {
          type: Boolean,
          "default": !1
        }
      },
      emits: ["titleClicked", "buttonClicked"],
      setup: function setup(i, _ref27) {
        var e = _ref27.emit;
        var s = e;
        return function (n, r) {
          return n.item.items && n.item.items.length > 0 ? (t.openBlock(), t.createElementBlock("section", qr, [n.item.title ? (t.openBlock(), t.createElementBlock("div", {
            key: 0,
            "class": "flex items-baseline gap-2 pb-4 uppercase typo-artikel-section-1 dark:text-white",
            onClick: r[0] || (r[0] = function (a) {
              return s("titleClicked", n.item);
            })
          }, [t.createElementVNode("h2", Kr, t.toDisplayString(n.item.title), 1), t.createVNode(t.unref(Ie), {
            "class": "w-6 h-6 text-grau-800 hover:cursor-pointer"
          })])) : t.createCommentVNode("", !0), t.createVNode(Ei, t.mergeProps({
            items: n.item.items,
            ratio: n.item.ratio,
            breakpoints: n.breakpoints,
            "slides-per-view": n.slidesPerView,
            "disable-breakpoints": n.disableBreakpoints,
            "centered-slides": n.centeredSlides
          }, n.$attrs), null, 16, ["items", "ratio", "breakpoints", "slides-per-view", "disable-breakpoints", "centered-slides"]), t.createElementVNode("div", Jr, [n.item.buttonText ? (t.openBlock(), t.createBlock(pe, {
            key: 0,
            color: "YellowTransparent",
            onClick: r[1] || (r[1] = function (a) {
              return s("buttonClicked", n.item);
            })
          }, {
            "default": t.withCtx(function () {
              return [t.createTextVNode(t.toDisplayString(n.item.buttonText), 1)];
            }),
            _: 1
          })) : t.createCommentVNode("", !0)])])) : t.createCommentVNode("", !0);
        };
      }
    }),
    xi = t.defineComponent({
      __name: "CategoryLabel",
      props: {
        color: {
          "default": "YELLOW"
        }
      },
      setup: function setup(i) {
        return function (e, s) {
          return t.openBlock(), t.createElementBlock("span", {
            "class": t.normalizeClass(["block p-2 rounded bg-main-600 max-w-fit typo-dachzeile", {
              "bg-white": e.color === "WHITE",
              "bg-red-600 text-white": e.color === "RED"
            }])
          }, [t.renderSlot(e.$slots, "default")], 2);
        };
      }
    }),
    ea = ["href", "target"],
    Re = t.defineComponent({
      __name: "CategoryLinkLabel",
      props: {
        target: {
          "default": ""
        },
        href: {},
        color: {
          "default": "YELLOW"
        }
      },
      setup: function setup(i) {
        return function (e, s) {
          return t.openBlock(), t.createElementBlock("a", {
            href: e.href,
            target: e.target
          }, [t.createVNode(xi, {
            color: e.color
          }, {
            "default": t.withCtx(function () {
              return [t.renderSlot(e.$slots, "default")];
            }),
            _: 3
          }, 8, ["color"])], 8, ea);
        };
      }
    }),
    ta = {
      key: 0,
      width: "16",
      height: "16",
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    ia = {
      key: 1,
      width: "16",
      height: "16",
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    sa = ["onClick"],
    ki = t.defineComponent({
      __name: "Dropdown",
      props: {
        items: {},
        defaultText: {},
        selected: {},
        color: {
          "default": "WHITE"
        }
      },
      emits: ["optionSelected", "optionsOpened"],
      setup: function setup(i, _ref28) {
        var _s$selected;
        var e = _ref28.emit;
        var s = i,
          n = e,
          r = {
            wrapper: {
              open: "bg-white border-white rounded-b-none border-b-0",
              closed: "border-white text-white"
            },
            label: {
              open: "text-text",
              closed: "text-white"
            },
            list: {
              open: "text-text border-white bg-white",
              closed: "text-white"
            }
          },
          a = {
            wrapper: {
              open: "bg-white border-black rounded-b-none",
              closed: "border-black text-black"
            },
            label: {
              open: "text-text",
              closed: "text-text"
            },
            list: {
              open: "text-text border-black bg-white",
              closed: "text-text"
            }
          },
          o = {
            wrapper: {
              open: "h-9 border-grau-500 rounded-b-none typo-meta-2-bold bg-white",
              closed: "h-9 border-grau-500 typo-meta-2-bold rounded mix-blend-multiply"
            },
            label: {
              open: "typo-meta-2-bold",
              closed: "typo-meta-2-bold"
            },
            list: {
              open: "typo-meta-2-bold border-grau-500 bg-white",
              closed: "typo-meta-2-bold"
            }
          },
          c = t.computed(function () {
            switch (s.color) {
              case "BLACK":
                return a;
              case "GRAY":
                return o;
              default:
                return r;
            }
          }),
          l = t.ref(!1),
          d = t.ref((_s$selected = s.selected) !== null && _s$selected !== void 0 ? _s$selected : "");
        function f() {
          l.value || n("optionsOpened"), l.value = !l.value;
        }
        function h(v) {
          d.value = v, n("optionSelected", v);
        }
        return function (v, m) {
          return t.openBlock(), t.createElementBlock("div", {
            "data-testid": "dropdown",
            "class": "relative",
            onClick: f
          }, [t.createElementVNode("div", {
            "class": t.normalizeClass(["flex items-center justify-between min-h-full p-4 border-2 rounded", l.value ? c.value.wrapper.open : c.value.wrapper.closed])
          }, [t.createElementVNode("span", {
            role: "button",
            "class": t.normalizeClass(["leading-5 typo-button-text", l.value ? c.value.label.open : c.value.label.closed])
          }, t.toDisplayString(d.value ? d.value : v.defaultText), 3), l.value ? t.createCommentVNode("", !0) : (t.openBlock(), t.createElementBlock("svg", ta, m[0] || (m[0] = [t.createElementVNode("path", {
            d: "M4 6L7.64645 9.64645C7.84171 9.84171 8.15829 9.84171 8.35355 9.64645L12 6",
            stroke: "currentColor",
            "stroke-width": "2",
            "stroke-linecap": "round"
          }, null, -1)]))), l.value ? (t.openBlock(), t.createElementBlock("svg", ia, m[1] || (m[1] = [t.createElementVNode("path", {
            d: "M12 10L8.35355 6.35355C8.15829 6.15829 7.84171 6.15829 7.64645 6.35355L4 10",
            stroke: "currentColor",
            "stroke-width": "2",
            "stroke-linecap": "round"
          }, null, -1)]))) : t.createCommentVNode("", !0)], 2), l.value ? (t.openBlock(), t.createElementBlock("ul", {
            key: 0,
            "aria-expanded": "false",
            role: "list",
            "class": t.normalizeClass(["absolute z-10 flex flex-col w-full py-4 -mt-1 overflow-y-auto border-2 border-t-0 rounded-b max-h-52 typo-menu-items", l.value ? c.value.list.open : c.value.list.closed])
          }, [(t.openBlock(!0), t.createElementBlock(t.Fragment, null, t.renderList(v.items, function (p, u) {
            return t.openBlock(), t.createElementBlock("li", {
              key: u,
              "class": "px-4 py-3 rounded cursor-pointer hover:bg-off-base",
              onClick: function onClick(b) {
                return h(p);
              }
            }, t.toDisplayString(p), 9, sa);
          }), 128))], 2)) : t.createCommentVNode("", !0)]);
        };
      }
    });
  function Pt() {
    return {
      validateEmailInput: function validateEmailInput(i) {
        return i === "" ? "Bitte gib eine Email-Adresse ein" : /^[^\s@]+@[^\s@][^\s.@]*\.[^\s@]+$/.test(i) ? "" : "Bitte gib eine gültige E-Mail Adresse ein";
      },
      validateCusnoInput: function validateCusnoInput(i) {
        return i === "" ? "Bitte gib deine Abonummer ein" : Number.isNaN(Number(i)) ? "Bitte gib eine gültige Abonummer ein" : "";
      },
      validateEmptyPasswordInput: function validateEmptyPasswordInput(i) {
        return i === "" ? "Bitte gib ein Passwort ein" : "";
      },
      validatePasswordInput: function validatePasswordInput(i) {
        return i === "" ? "Bitte gib ein Passwort ein" : i.length < 6 ? "Bitte wähle ein Passwort mit mind. 6 Zeichen" : /\s/.test(i) ? "Das Passwort darf keine Leerzeichen enthalten" : "";
      },
      validateEmailOrUsernameInput: function validateEmailOrUsernameInput(i) {
        return i === "" ? "Bitte gib eine E-Mail Adresse oder einen Benutzernamen ein" : "";
      }
    };
  }
  var fe = function fe(i, e) {
      var s = i.__vccOpts || i;
      var _iterator2 = _createForOfIteratorHelper(e),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _step2$value = _slicedToArray(_step2.value, 2),
            n = _step2$value[0],
            r = _step2$value[1];
          s[n] = r;
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      return s;
    },
    na = {},
    ra = {
      "class": "flex flex-col w-11/12 max-w-xl max-h-[calc(100vh-4rem)] gap-6 p-6 bg-white rounded-lg md:w-1/2"
    };
  function aa(i, e) {
    return t.openBlock(), t.createElementBlock("div", ra, [t.renderSlot(i.$slots, "default")]);
  }
  var Me = fe(na, [["render", aa]]),
    la = {},
    oa = {
      "class": "fixed top-0 left-0 z-10 flex items-center justify-center w-screen h-screen bg-black/50"
    };
  function ca(i, e) {
    return t.openBlock(), t.createElementBlock("div", oa, [t.renderSlot(i.$slots, "default")]);
  }
  var Ve = fe(la, [["render", ca]]),
    da = {},
    pa = {
      "class": "block mt-2 typo-meta-1-bold text-rot-600 typo-meta-2"
    };
  function fa(i, e) {
    return t.openBlock(), t.createElementBlock("span", pa, [t.renderSlot(i.$slots, "default")]);
  }
  var se = fe(da, [["render", fa]]),
    ua = {},
    ma = {
      "class": "relative flex items-center justify-center w-full h-full"
    };
  function ha(i, e) {
    return t.openBlock(), t.createElementBlock("div", ma, e[0] || (e[0] = [t.createStaticVNode('<div class="relative inline-block w-12 h-12"><div class="absolute inset-0 flex items-center justify-center"><div class="border-2 border-black border-solid rounded-full opacity-100 animate-ripple"></div></div><div class="absolute inset-0 flex items-center justify-center"><div class="border-2 border-black border-solid rounded-full opacity-100 animate-ripple-delay"></div></div></div>', 1)]));
  }
  var _t = fe(ua, [["render", ha]]),
    ga = {
      "class": "absolute inset-0 z-10 flex items-center justify-center bg-opacity-50 bg-grau-600"
    },
    tt = t.defineComponent({
      __name: "LoadingOverlay",
      setup: function setup(i) {
        return function (e, s) {
          return t.openBlock(), t.createElementBlock("div", ga, [t.createVNode(_t)]);
        };
      }
    }),
    wa = ["innerHTML"],
    ba = t.defineComponent({
      __name: "AbocardLoginForm",
      props: {
        errorMessage: {
          "default": ""
        },
        disabled: {
          type: Boolean,
          "default": !1
        },
        buttonText: {
          "default": "Anmelden"
        }
      },
      emits: ["close", "submit"],
      setup: function setup(i, _ref29) {
        var e = _ref29.emit;
        var s = i,
          n = e,
          r = t.ref(""),
          a = t.ref(""),
          o = t.ref(""),
          c = t.ref(""),
          l = t.ref(s.errorMessage),
          d = t.computed(function () {
            return r.value === "" || a.value === "" || s.disabled;
          }),
          f = t.computed(function () {
            return s.disabled;
          });
        t.watch(function () {
          return s.errorMessage;
        }, function () {
          l.value = s.errorMessage;
        });
        function h() {
          o.value = Pt().validateCusnoInput(r.value);
        }
        function v() {
          c.value = "", a.value === "" && (c.value = "Bitte gib deinen Nachnamen ein");
        }
        function m() {
          o.value = "", c.value = "", h(), v(), !(o.value !== "" || c.value !== "") && n("submit", {
            cusno: r.value,
            password: a.value
          });
        }
        return function (p, u) {
          return t.openBlock(), t.createBlock(Ve, {
            "class": "z-[5000101]",
            "data-testid": "abocard-login-form",
            onClick: u[3] || (u[3] = t.withModifiers(function (b) {
              return n("close");
            }, ["self"]))
          }, {
            "default": t.withCtx(function () {
              return [t.createVNode(Me, {
                "class": "relative overflow-hidden"
              }, {
                "default": t.withCtx(function () {
                  return [f.value ? (t.openBlock(), t.createBlock(tt, {
                    key: 0
                  })) : t.createCommentVNode("", !0), t.renderSlot(p.$slots, "default", {}, function () {
                    return [u[4] || (u[4] = t.createElementVNode("h2", {
                      "class": "typo-teaser-3"
                    }, "Anmelden", -1))];
                  }), t.createElementVNode("form", {
                    "class": "typo-body-1",
                    onSubmit: u[2] || (u[2] = t.withModifiers(function () {}, ["prevent"]))
                  }, [t.withDirectives(t.createElementVNode("input", {
                    "onUpdate:modelValue": u[0] || (u[0] = function (b) {
                      return r.value = b;
                    }),
                    type: "text",
                    name: "cusno",
                    "class": t.normalizeClass(["w-full input-field-gray", {
                      "input-field-error": o.value
                    }]),
                    placeholder: "Abonummer",
                    onBlur: h
                  }, null, 34), [[t.vModelText, r.value]]), o.value ? (t.openBlock(), t.createBlock(se, {
                    key: 0
                  }, {
                    "default": t.withCtx(function () {
                      return [t.createTextVNode(t.toDisplayString(o.value), 1)];
                    }),
                    _: 1
                  })) : t.createCommentVNode("", !0), t.withDirectives(t.createElementVNode("input", {
                    "onUpdate:modelValue": u[1] || (u[1] = function (b) {
                      return a.value = b;
                    }),
                    type: "text",
                    name: "password",
                    "class": t.normalizeClass(["w-full input-field-gray", {
                      "input-field-error": c.value
                    }]),
                    placeholder: "Nachname",
                    onBlur: v
                  }, null, 34), [[t.vModelText, a.value]]), c.value ? (t.openBlock(), t.createBlock(se, {
                    key: 1
                  }, {
                    "default": t.withCtx(function () {
                      return [t.createTextVNode(t.toDisplayString(c.value), 1)];
                    }),
                    _: 1
                  })) : t.createCommentVNode("", !0), l.value ? (t.openBlock(), t.createBlock(se, {
                    key: 2
                  }, {
                    "default": t.withCtx(function () {
                      return [t.createElementVNode("div", {
                        innerHTML: l.value
                      }, null, 8, wa)];
                    }),
                    _: 1
                  })) : t.createCommentVNode("", !0), t.createVNode(pe, {
                    "class": "mt-8",
                    disabled: d.value,
                    onClick: m
                  }, {
                    "default": t.withCtx(function () {
                      return [t.createTextVNode(t.toDisplayString(p.buttonText), 1)];
                    }),
                    _: 1
                  }, 8, ["disabled"])], 32)];
                }),
                _: 3
              })];
            }),
            _: 3
          });
        };
      }
    }),
    va = ["disabled"],
    Ca = ["innerHTML"],
    ya = {
      key: 3,
      "class": "w-full mt-4 text-center"
    },
    Ea = t.defineComponent({
      __name: "AbocardRegisterForm",
      props: {
        initialEmail: {
          "default": ""
        },
        errorMessage: {
          "default": ""
        },
        disabled: {
          type: Boolean,
          "default": !1
        },
        hideForgetPassword: {
          type: Boolean,
          "default": !1
        }
      },
      emits: ["close", "submit", "forgetPasswordClick"],
      setup: function setup(i, _ref30) {
        var e = _ref30.emit;
        var s = i,
          n = e,
          r = t.ref(s.initialEmail),
          a = t.ref(""),
          o = t.ref(""),
          c = t.ref(""),
          l = t.ref(s.errorMessage),
          d = t.computed(function () {
            return r.value === "" || a.value === "" || s.disabled;
          }),
          f = t.computed(function () {
            return s.disabled;
          });
        t.watch(function () {
          return s.errorMessage;
        }, function () {
          l.value = s.errorMessage;
        });
        function h() {
          o.value = Pt().validateEmailInput(r.value);
        }
        function v() {
          c.value = Pt().validatePasswordInput(a.value);
        }
        function m() {
          o.value = "", c.value = "", h(), v(), !(o.value !== "" || c.value !== "") && n("submit", {
            email: r.value,
            password: a.value
          });
        }
        return function (p, u) {
          return t.openBlock(), t.createBlock(Ve, {
            "class": "z-[5000101]",
            onClick: u[4] || (u[4] = t.withModifiers(function (b) {
              return n("close");
            }, ["self"]))
          }, {
            "default": t.withCtx(function () {
              return [t.createVNode(Me, {
                "class": "relative overflow-hidden"
              }, {
                "default": t.withCtx(function () {
                  return [f.value ? (t.openBlock(), t.createBlock(tt, {
                    key: 0
                  })) : t.createCommentVNode("", !0), t.renderSlot(p.$slots, "default", {}, function () {
                    return [u[5] || (u[5] = t.createElementVNode("h2", {
                      "class": "typo-teaser-3"
                    }, "Registrieren", -1))];
                  }), t.createElementVNode("form", {
                    "class": "typo-body-1",
                    onSubmit: u[3] || (u[3] = t.withModifiers(function () {}, ["prevent"]))
                  }, [t.withDirectives(t.createElementVNode("input", {
                    "onUpdate:modelValue": u[0] || (u[0] = function (b) {
                      return r.value = b;
                    }),
                    type: "text",
                    name: "email",
                    "class": t.normalizeClass(["w-full input-field-gray", {
                      "input-field-error": o.value,
                      "bg-white  text-grau-600/70": p.initialEmail
                    }]),
                    placeholder: "Email-Adresse",
                    disabled: !!p.initialEmail,
                    onBlur: h
                  }, null, 42, va), [[t.vModelText, r.value]]), o.value ? (t.openBlock(), t.createBlock(se, {
                    key: 0
                  }, {
                    "default": t.withCtx(function () {
                      return [t.createTextVNode(t.toDisplayString(o.value), 1)];
                    }),
                    _: 1
                  })) : t.createCommentVNode("", !0), t.withDirectives(t.createElementVNode("input", {
                    "onUpdate:modelValue": u[1] || (u[1] = function (b) {
                      return a.value = b;
                    }),
                    type: "password",
                    name: "password",
                    "class": t.normalizeClass(["w-full input-field-gray", {
                      "input-field-error": c.value
                    }]),
                    placeholder: "Passwort (mind. 6 Zeichen)",
                    onBlur: v
                  }, null, 34), [[t.vModelText, a.value]]), c.value ? (t.openBlock(), t.createBlock(se, {
                    key: 1
                  }, {
                    "default": t.withCtx(function () {
                      return [t.createTextVNode(t.toDisplayString(c.value), 1)];
                    }),
                    _: 1
                  })) : t.createCommentVNode("", !0), l.value ? (t.openBlock(), t.createBlock(se, {
                    key: 2
                  }, {
                    "default": t.withCtx(function () {
                      return [t.createElementVNode("div", {
                        innerHTML: l.value
                      }, null, 8, Ca)];
                    }),
                    _: 1
                  })) : t.createCommentVNode("", !0), t.createVNode(pe, {
                    "class": "mt-8",
                    disabled: d.value,
                    onClick: m
                  }, {
                    "default": t.withCtx(function () {
                      return u[6] || (u[6] = [t.createTextVNode(" Registrieren ")]);
                    }),
                    _: 1
                  }, 8, ["disabled"]), p.hideForgetPassword ? t.createCommentVNode("", !0) : (t.openBlock(), t.createElementBlock("div", ya, [t.createElementVNode("span", {
                    "class": "cursor-pointer typo-meta-1",
                    "data-testid": "forget-password-button",
                    onClick: u[2] || (u[2] = function (b) {
                      return n("forgetPasswordClick");
                    })
                  }, " Passwort vergessen? ")]))], 32)];
                }),
                _: 3
              })];
            }),
            _: 3
          });
        };
      }
    }),
    xa = t.defineComponent({
      __name: "ChangePasswordForm",
      props: {
        errorMessage: {
          "default": ""
        },
        disabled: {
          type: Boolean,
          "default": !1
        }
      },
      emits: ["click", "submit"],
      setup: function setup(i, _ref31) {
        var e = _ref31.emit;
        var s = i,
          n = e,
          r = t.ref(s.errorMessage),
          a = t.ref(""),
          o = t.ref(""),
          c = t.ref(""),
          l = t.ref(""),
          d = t.ref(""),
          f = t.ref(""),
          h = t.computed(function () {
            return l.value === "" || d.value === "" || f.value === "" || s.disabled;
          }),
          v = t.computed(function () {
            return s.disabled;
          });
        t.watch(function () {
          return s.errorMessage;
        }, function () {
          r.value = s.errorMessage;
        });
        function m() {
          l.value === "" && (a.value = "Bitte gib dein aktuelles Passwort ein");
        }
        function p() {
          if (d.value === "") {
            o.value = "Bitte gib ein neues Passwort ein";
            return;
          }
          if (d.value.length < 6) {
            o.value = "Bitte wähle ein Passwort mit mind. 6 Zeichen";
            return;
          }
          /\s/.test(d.value) && (o.value = "Das Passwort darf keine Leerzeichen enthalten");
        }
        function u() {
          if (f.value === "") {
            c.value = "Bitte gib das neue Passwort noch einmal ein";
            return;
          }
          d.value !== f.value && (c.value = "Die Passwörter stimmen nicht überein");
        }
        function b() {
          a.value = "", o.value = "", c.value = "", m(), p(), u(), !(a.value !== "" || o.value !== "" || c.value !== "") && n("submit", {
            currentPassword: l.value,
            newPassword: d.value,
            newPasswordAgain: f.value
          });
        }
        return function (C, g) {
          return t.openBlock(), t.createBlock(Ve, {
            "class": "z-[5000101]",
            onClick: g[4] || (g[4] = t.withModifiers(function (w) {
              return n("click");
            }, ["self"]))
          }, {
            "default": t.withCtx(function () {
              return [t.createVNode(Me, {
                "class": "overflow-hidden"
              }, {
                "default": t.withCtx(function () {
                  return [v.value ? (t.openBlock(), t.createBlock(tt, {
                    key: 0
                  })) : t.createCommentVNode("", !0), g[6] || (g[6] = t.createElementVNode("h2", {
                    "class": "typo-teaser-3"
                  }, "Passwort ändern", -1)), t.createElementVNode("form", {
                    "class": "typo-body-1",
                    onSubmit: g[3] || (g[3] = t.withModifiers(function () {}, ["prevent"]))
                  }, [t.withDirectives(t.createElementVNode("input", {
                    "onUpdate:modelValue": g[0] || (g[0] = function (w) {
                      return l.value = w;
                    }),
                    type: "password",
                    "class": t.normalizeClass(["w-full input-field-gray", {
                      "input-field-error": a.value
                    }]),
                    placeholder: "Aktuelles Passwort",
                    onBlur: m
                  }, null, 34), [[t.vModelText, l.value]]), a.value ? (t.openBlock(), t.createBlock(se, {
                    key: 0
                  }, {
                    "default": t.withCtx(function () {
                      return [t.createTextVNode(t.toDisplayString(a.value), 1)];
                    }),
                    _: 1
                  })) : t.createCommentVNode("", !0), t.withDirectives(t.createElementVNode("input", {
                    "onUpdate:modelValue": g[1] || (g[1] = function (w) {
                      return d.value = w;
                    }),
                    type: "password",
                    "class": t.normalizeClass(["w-full input-field-gray", {
                      "input-field-error": o.value
                    }]),
                    placeholder: "Neues Passwort",
                    onBlur: p
                  }, null, 34), [[t.vModelText, d.value]]), o.value ? (t.openBlock(), t.createBlock(se, {
                    key: 1
                  }, {
                    "default": t.withCtx(function () {
                      return [t.createTextVNode(t.toDisplayString(o.value), 1)];
                    }),
                    _: 1
                  })) : t.createCommentVNode("", !0), t.withDirectives(t.createElementVNode("input", {
                    "onUpdate:modelValue": g[2] || (g[2] = function (w) {
                      return f.value = w;
                    }),
                    type: "password",
                    "class": t.normalizeClass(["w-full input-field-gray", {
                      "input-field-error": c.value
                    }]),
                    placeholder: "Wiederhole das neue Passwort",
                    onBlur: u
                  }, null, 34), [[t.vModelText, f.value]]), c.value ? (t.openBlock(), t.createBlock(se, {
                    key: 2
                  }, {
                    "default": t.withCtx(function () {
                      return [t.createTextVNode(t.toDisplayString(c.value), 1)];
                    }),
                    _: 1
                  })) : t.createCommentVNode("", !0), r.value ? (t.openBlock(), t.createBlock(se, {
                    key: 3
                  }, {
                    "default": t.withCtx(function () {
                      return [t.createTextVNode(t.toDisplayString(r.value), 1)];
                    }),
                    _: 1
                  })) : t.createCommentVNode("", !0), t.createVNode(pe, {
                    "class": "mt-8",
                    disabled: h.value,
                    onClick: b
                  }, {
                    "default": t.withCtx(function () {
                      return g[5] || (g[5] = [t.createTextVNode(" Abschicken ")]);
                    }),
                    _: 1
                  }, 8, ["disabled"])], 32)];
                }),
                _: 1
              })];
            }),
            _: 1
          });
        };
      }
    }),
    ka = t.defineComponent({
      __name: "ForgetPasswordForm",
      props: {
        initialUsername: {
          "default": ""
        },
        errorMessage: {
          "default": ""
        },
        disabled: {
          type: Boolean,
          "default": !1
        }
      },
      emits: ["close", "submit"],
      setup: function setup(i, _ref32) {
        var e = _ref32.emit;
        var s = i,
          n = e,
          r = t.ref(s.initialUsername),
          a = t.ref(),
          o = t.ref(s.errorMessage),
          c = t.computed(function () {
            return r.value === "" || s.disabled;
          });
        return t.watch(function () {
          return s.errorMessage;
        }, function () {
          o.value = s.errorMessage;
        }), function (l, d) {
          return t.openBlock(), t.createBlock(Ve, {
            "class": "z-[5000101]",
            onClick: d[3] || (d[3] = t.withModifiers(function (f) {
              return n("close");
            }, ["self"]))
          }, {
            "default": t.withCtx(function () {
              return [t.createVNode(Me, {
                "class": "overflow-hidden"
              }, {
                "default": t.withCtx(function () {
                  return [d[5] || (d[5] = t.createElementVNode("h2", {
                    "class": "typo-teaser-3"
                  }, "Passwort Zurücksetzen", -1)), t.createElementVNode("form", {
                    "class": "typo-body-1",
                    onSubmit: d[2] || (d[2] = t.withModifiers(function () {}, ["prevent"]))
                  }, [t.withDirectives(t.createElementVNode("input", {
                    "onUpdate:modelValue": d[0] || (d[0] = function (f) {
                      return r.value = f;
                    }),
                    type: "text",
                    name: "username",
                    "class": t.normalizeClass(["w-full input-field-gray", {
                      "input-field-error": a.value
                    }]),
                    placeholder: "Benutzername oder E-Mail-Adresse"
                  }, null, 2), [[t.vModelText, r.value]]), a.value ? (t.openBlock(), t.createBlock(se, {
                    key: 0
                  }, {
                    "default": t.withCtx(function () {
                      return [t.createTextVNode(t.toDisplayString(a.value), 1)];
                    }),
                    _: 1
                  })) : t.createCommentVNode("", !0), o.value ? (t.openBlock(), t.createBlock(se, {
                    key: 1
                  }, {
                    "default": t.withCtx(function () {
                      return [t.createTextVNode(t.toDisplayString(o.value), 1)];
                    }),
                    _: 1
                  })) : t.createCommentVNode("", !0), t.createVNode(pe, {
                    "class": "mt-8",
                    disabled: c.value,
                    onClick: d[1] || (d[1] = function (f) {
                      return n("submit", r.value);
                    })
                  }, {
                    "default": t.withCtx(function () {
                      return d[4] || (d[4] = [t.createTextVNode(" Passwort zurücksetzen ")]);
                    }),
                    _: 1
                  }, 8, ["disabled"])], 32)];
                }),
                _: 1
              })];
            }),
            _: 1
          });
        };
      }
    }),
    Sa = {
      width: "14",
      height: "14",
      viewBox: "0 0 14 14",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    };
  function Ma(i, e) {
    return t.openBlock(), t.createElementBlock("svg", Sa, e[0] || (e[0] = [t.createStaticVNode('<g id="Fullscreen_svg__Global / Video UI Icons"><path id="Fullscreen_svg__Vector 9" d="M5 13H1V9" stroke="currentColor" stroke-width="2"></path><path id="Fullscreen_svg__Vector 11" d="M9 13H13V9" stroke="currentColor" stroke-width="2"></path><path id="Fullscreen_svg__Vector 10" d="M1 5L1 1L5 1" stroke="currentColor" stroke-width="2"></path><path id="Fullscreen_svg__Vector 12" d="M13 5L13 1L9 1" stroke="currentColor" stroke-width="2"></path></g>', 1)]));
  }
  var Va = {
      render: Ma
    },
    Ta = {
      key: 0,
      "class": "block px-4 pb-4 typo-artikel-sub"
    },
    La = ["modules", "initial-slide"],
    Ha = {
      "class": "inline-flex flex-col w-full h-full"
    },
    Ba = ["src", "alt"],
    za = ["innerHTML"],
    Pa = {
      "class": "absolute z-10 text-white bottom-8 right-8 typo-meta-1-bold"
    },
    _a = t.defineComponent({
      __name: "ImageGallery",
      props: {
        title: {},
        images: {
          "default": function _default() {
            return [];
          }
        },
        inline: {
          type: Boolean,
          "default": !0
        },
        initialSlide: {
          "default": 0
        },
        slidesTotal: {
          "default": 0
        }
      },
      emits: ["fullscreenClicked", "slideChanged"],
      setup: function setup(i, _ref33) {
        var e = _ref33.emit;
        var s = i,
          n = e;
        yi();
        var r = t.ref(1),
          a = t.computed(function () {
            var _s$images$length;
            return s.slidesTotal ? s.slidesTotal : (_s$images$length = s.images.length) !== null && _s$images$length !== void 0 ? _s$images$length : 0;
          }),
          o = t.computed(function () {
            return s.images[r.value - 1].caption;
          });
        function c(l) {
          r.value = l.detail[0].realIndex + 1, n("slideChanged", r.value);
        }
        return function (l, d) {
          var f = t.resolveComponent("client-only");
          return t.openBlock(), t.createElementBlock("section", {
            "data-testid": "image-slider",
            "class": t.normalizeClass({
              "w-screen h-screen": !l.inline
            })
          }, [l.title && l.inline ? (t.openBlock(), t.createElementBlock("h2", Ta, t.toDisplayString(l.title), 1)) : t.createCommentVNode("", !0), t.createElementVNode("div", {
            "class": t.normalizeClass(["relative w-full h-full", {
              "aspect-square md:aspect-video": l.inline
            }])
          }, [l.inline ? t.renderSlot(l.$slots, "icon-top-right", {
            key: 0
          }, function () {
            return [t.createVNode(t.unref(Va), {
              "class": "absolute z-20 text-white cursor-pointer top-8 right-8",
              onClick: d[0] || (d[0] = function (h) {
                return n("fullscreenClicked", l.images);
              })
            })];
          }) : t.createCommentVNode("", !0), t.createVNode(f, null, {
            "default": t.withCtx(function () {
              return [t.createElementVNode("swiper-container", {
                "class": t.normalizeClass(["h-full overflow-hidden bg-black", {
                  "md:rounded-lg": l.inline
                }]),
                modules: [t.unref(Bt)],
                navigation: {
                  prevEl: ".np-swiper-button-prev",
                  nextEl: ".np-swiper-button-next"
                },
                "initial-slide": l.initialSlide,
                loop: !0,
                onSwiperslidechange: c
              }, [t.renderSlot(l.$slots, "slides", {}, function () {
                return [l.images.length > 0 ? (t.openBlock(!0), t.createElementBlock(t.Fragment, {
                  key: 0
                }, t.renderList(l.images, function (h, v) {
                  return t.openBlock(), t.createElementBlock("swiper-slide", {
                    key: v,
                    "class": "swiper-slide"
                  }, [t.createElementVNode("figure", Ha, [t.createElementVNode("img", {
                    loading: "lazy",
                    "class": "object-contain w-full h-full",
                    src: h.src,
                    alt: h.alt
                  }, null, 8, Ba), t.createElementVNode("div", {
                    "class": t.normalizeClass(["absolute z-20 px-4 md:w-1/2 md:left-1/4", {
                      "bottom-6 w-4/5 text-left md:text-center": l.inline,
                      "bottom-16 text-center md:bottom-8": !l.inline
                    }])
                  }, [o.value ? (t.openBlock(), t.createElementBlock("figcaption", {
                    key: 0,
                    "class": "text-white typo-meta-1",
                    innerHTML: o.value
                  }, null, 8, za)) : t.createCommentVNode("", !0)], 2)])]);
                }), 128)) : t.createCommentVNode("", !0)];
              })], 42, La)];
            }),
            _: 3
          }), t.createElementVNode("div", {
            "class": t.normalizeClass(["hidden shadow md:block", {
              "md:after:rounded-lg md:before:rounded-lg": l.inline
            }])
          }, null, 2), t.createVNode(t.unref(Ie), {
            "class": "text-white np-swiper-button-prev"
          }), t.createVNode(t.unref(Ie), {
            "class": "text-white np-swiper-button-next"
          }), t.createElementVNode("span", Pa, t.toDisplayString(r.value) + " / " + t.toDisplayString(a.value), 1)], 2)], 2);
        };
      }
    }),
    $a = {
      width: "18",
      height: "18",
      viewBox: "0 0 18 18",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    };
  function Na(i, e) {
    return t.openBlock(), t.createElementBlock("svg", $a, e[0] || (e[0] = [t.createElementVNode("path", {
      d: "M1 1L17 17M1 17L17 1",
      stroke: "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }, null, -1)]));
  }
  var Si = {
      render: Na
    },
    Ia = {
      "class": "fixed top-0 left-0 flex items-center justify-center w-screen h-screen bg-black z-[5000101]"
    },
    Aa = t.defineComponent({
      __name: "Lightbox",
      emits: ["close"],
      setup: function setup(i, _ref34) {
        var e = _ref34.emit;
        var s = e;
        return t.onMounted(function () {
          document.body.classList.add("overflow-y-hidden");
        }), t.onBeforeUnmount(function () {
          document.body.classList.remove("overflow-y-hidden");
        }), function (n, r) {
          return t.openBlock(), t.createElementBlock("div", Ia, [t.renderSlot(n.$slots, "close-button", {}, function () {
            return [t.createVNode(t.unref(Si), {
              "class": "absolute z-20 text-white cursor-pointer right-8 top-8",
              onClick: r[0] || (r[0] = function (a) {
                return s("close");
              })
            })];
          }), t.renderSlot(n.$slots, "default")]);
        };
      }
    });
  function $t() {
    return {
      getPaginationUrl: function getPaginationUrl(i) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return i === 1 && e.firstPageUrl ? e.firstPageUrl : i >= 1 && e.pageUrlPattern ? e.pageUrlPattern.replace("{page}", i.toString()) : "";
      },
      hasPaginationUrl: function hasPaginationUrl(i) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return !!(i >= 1 && (e.firstPageUrl || e.pageUrlPattern));
      }
    };
  }
  var Da = {
      "class": "flex justify-center gap-3"
    },
    Oa = ["onClick"],
    Fa = ["href"],
    Za = ["onClick"],
    Ra = {
      key: 3,
      "class": "typo-menu-items text-grau-500"
    },
    ja = t.defineComponent({
      __name: "ListingPagination",
      props: {
        totalPages: {
          "default": 1
        },
        currentPage: {
          "default": 1
        },
        paginationUrlConfig: {
          "default": function _default() {
            return {};
          }
        }
      },
      emits: ["pageClicked"],
      setup: function setup(i, _ref35) {
        var e = _ref35.emit;
        var s = i,
          n = e,
          r = t.ref(null),
          a = t.computed(function () {
            var l = [1],
              d = 5,
              f = s.totalPages,
              h = s.currentPage;
            if (f <= d) {
              for (var p = 2; p <= f; p++) l.push(p);
              return l;
            }
            var v = r.value || h;
            var m = Math.max(2, v - Math.floor((d - 3) / 2));
            m = Math.min(m, f - d + 2), m !== 2 && l.push("...");
            for (var _p2 = 0; _p2 < d - 2; _p2++) {
              var u = m + _p2;
              u < f && l.push(u);
            }
            return m + d - 3 < f - 1 && l.push("..."), l.push(f), l;
          });
        function o(l) {
          n("pageClicked", l);
        }
        function c(l) {
          l === 1 ? r.value = a.value[2] : l === a.value.length - 2 && (r.value = a.value[a.value.length - 3]);
        }
        return function (l, d) {
          return t.openBlock(), t.createElementBlock("div", Da, [(t.openBlock(!0), t.createElementBlock(t.Fragment, null, t.renderList(a.value, function (f, h) {
            return t.openBlock(), t.createElementBlock("div", {
              key: h,
              "class": "flex gap-3"
            }, [f === "..." ? (t.openBlock(), t.createElementBlock("span", {
              key: 0,
              "class": "cursor-pointer typo-menu-items text-grau-500",
              onClick: function onClick(v) {
                return c(h);
              }
            }, t.toDisplayString(f), 9, Oa)) : t.unref($t)().hasPaginationUrl(f, l.paginationUrlConfig) ? (t.openBlock(), t.createElementBlock("a", {
              key: 1,
              href: t.unref($t)().getPaginationUrl(f, l.paginationUrlConfig),
              "class": t.normalizeClass(["cursor-pointer typo-menu-items", {
                "text-grau-800": f !== l.currentPage
              }])
            }, t.toDisplayString(f), 11, Fa)) : (t.openBlock(), t.createElementBlock("span", {
              key: 2,
              "class": t.normalizeClass(["cursor-pointer typo-menu-items", {
                "text-grau-800": f !== l.currentPage
              }]),
              onClick: function onClick(v) {
                return o(f);
              }
            }, t.toDisplayString(f), 11, Za)), h + 1 !== a.value.length ? (t.openBlock(), t.createElementBlock("span", Ra, " / ")) : t.createCommentVNode("", !0)]);
          }), 128))]);
        };
      }
    });
  function Wa(i) {
    return i && i.__esModule && Object.prototype.hasOwnProperty.call(i, "default") ? i["default"] : i;
  }
  var it = {}; /*!
               * cookie
               * Copyright(c) 2012-2014 Roman Shtylman
               * Copyright(c) 2015 Douglas Christopher Wilson
               * MIT Licensed
               */
  var Mi;
  function Ga() {
    if (Mi) return it;
    Mi = 1, it.parse = o, it.serialize = d;
    var i = Object.prototype.toString,
      e = Object.prototype.hasOwnProperty,
      s = /^[!#$%&'*+\-.^_`|~0-9A-Za-z]+$/,
      n = /^("?)[\u0021\u0023-\u002B\u002D-\u003A\u003C-\u005B\u005D-\u007E]*\1$/,
      r = /^([.]?[a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?)([.][a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?)*$/i,
      a = /^[\u0020-\u003A\u003D-\u007E]*$/;
    function o(m, p) {
      if (typeof m != "string") throw new TypeError("argument str must be a string");
      var u = {},
        b = m.length;
      if (b < 2) return u;
      var C = p && p.decode || f,
        g = 0,
        w = 0,
        y = 0;
      do {
        if (w = m.indexOf("=", g), w === -1) break;
        if (y = m.indexOf(";", g), y === -1) y = b;else if (w > y) {
          g = m.lastIndexOf(";", w - 1) + 1;
          continue;
        }
        var x = c(m, g, w),
          T = l(m, w, x),
          S = m.slice(x, T);
        if (!e.call(u, S)) {
          var L = c(m, w + 1, y),
            E = l(m, y, L);
          m.charCodeAt(L) === 34 && m.charCodeAt(E - 1) === 34 && (L++, E--);
          var M = m.slice(L, E);
          u[S] = v(M, C);
        }
        g = y + 1;
      } while (g < b);
      return u;
    }
    function c(m, p, u) {
      do {
        var b = m.charCodeAt(p);
        if (b !== 32 && b !== 9) return p;
      } while (++p < u);
      return u;
    }
    function l(m, p, u) {
      for (; p > u;) {
        var b = m.charCodeAt(--p);
        if (b !== 32 && b !== 9) return p + 1;
      }
      return u;
    }
    function d(m, p, u) {
      var b = u && u.encode || encodeURIComponent;
      if (typeof b != "function") throw new TypeError("option encode is invalid");
      if (!s.test(m)) throw new TypeError("argument name is invalid");
      var C = b(p);
      if (!n.test(C)) throw new TypeError("argument val is invalid");
      var g = m + "=" + C;
      if (!u) return g;
      if (u.maxAge != null) {
        var w = Math.floor(u.maxAge);
        if (!isFinite(w)) throw new TypeError("option maxAge is invalid");
        g += "; Max-Age=" + w;
      }
      if (u.domain) {
        if (!r.test(u.domain)) throw new TypeError("option domain is invalid");
        g += "; Domain=" + u.domain;
      }
      if (u.path) {
        if (!a.test(u.path)) throw new TypeError("option path is invalid");
        g += "; Path=" + u.path;
      }
      if (u.expires) {
        var y = u.expires;
        if (!h(y) || isNaN(y.valueOf())) throw new TypeError("option expires is invalid");
        g += "; Expires=" + y.toUTCString();
      }
      if (u.httpOnly && (g += "; HttpOnly"), u.secure && (g += "; Secure"), u.partitioned && (g += "; Partitioned"), u.priority) {
        var x = typeof u.priority == "string" ? u.priority.toLowerCase() : u.priority;
        switch (x) {
          case "low":
            g += "; Priority=Low";
            break;
          case "medium":
            g += "; Priority=Medium";
            break;
          case "high":
            g += "; Priority=High";
            break;
          default:
            throw new TypeError("option priority is invalid");
        }
      }
      if (u.sameSite) {
        var T = typeof u.sameSite == "string" ? u.sameSite.toLowerCase() : u.sameSite;
        switch (T) {
          case !0:
            g += "; SameSite=Strict";
            break;
          case "lax":
            g += "; SameSite=Lax";
            break;
          case "strict":
            g += "; SameSite=Strict";
            break;
          case "none":
            g += "; SameSite=None";
            break;
          default:
            throw new TypeError("option sameSite is invalid");
        }
      }
      return g;
    }
    function f(m) {
      return m.indexOf("%") !== -1 ? decodeURIComponent(m) : m;
    }
    function h(m) {
      return i.call(m) === "[object Date]";
    }
    function v(m, p) {
      try {
        return p(m);
      } catch (_unused5) {
        return m;
      }
    }
    return it;
  }
  var Ya = Ga();
  var Vi = Wa(Ya);
  function Nt() {
    function i(s, n) {
      var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var a = Vi.serialize(s, n, r);
      document.cookie = a;
    }
    function e(s) {
      return Vi.parse(document.cookie)[s] || null;
    }
    return {
      setCookie: i,
      getCookie: e
    };
  }
  var Te = {
    alberschwende: {
      title: "Alberschwende"
    },
    altach: {
      title: "Altach"
    },
    andelsbuch: {
      title: "Andelsbuch"
    },
    au: {
      title: "Au"
    },
    bartholomaeberg: {
      title: "Bartholomäberg"
    },
    bezau: {
      title: "Bezau"
    },
    bildstein: {
      title: "Bildstein"
    },
    bizau: {
      title: "Bizau"
    },
    blons: {
      title: "Blons"
    },
    bludenz: {
      title: "Bludenz"
    },
    bludesch: {
      title: "Bludesch"
    },
    brand: {
      title: "Brand"
    },
    bregenz: {
      title: "Bregenz"
    },
    buch: {
      title: "Buch"
    },
    buers: {
      title: "Bürs"
    },
    buerserberg: {
      title: "Bürserberg"
    },
    dalaas: {
      title: "Dalaas"
    },
    damuels: {
      title: "Damüls"
    },
    doren: {
      title: "Doren"
    },
    dornbirn: {
      title: "Dornbirn"
    },
    duens: {
      title: "Düns"
    },
    duenserberg: {
      title: "Dünserberg"
    },
    egg: {
      title: "Egg"
    },
    eichenberg: {
      title: "Eichenberg"
    },
    feldkirch: {
      title: "Feldkirch"
    },
    fontanella: {
      title: "Fontanella"
    },
    frastanz: {
      title: "Frastanz"
    },
    fraxern: {
      title: "Fraxern"
    },
    fussach: {
      title: "Fußach"
    },
    gaissau: {
      title: "Gaißau"
    },
    gaschurn: {
      title: "Gaschurn"
    },
    goefis: {
      title: "Göfis"
    },
    goetzis: {
      title: "Götzis"
    },
    hard: {
      title: "Hard"
    },
    hittisau: {
      title: "Hittisau"
    },
    hoechst: {
      title: "Höchst"
    },
    hoerbranz: {
      title: "Hörbranz"
    },
    hohenems: {
      title: "Hohenems"
    },
    hohenweiler: {
      title: "Hohenweiler"
    },
    innerbraz: {
      title: "Innerbraz"
    },
    kennelbach: {
      title: "Kennelbach"
    },
    klaus: {
      title: "Klaus"
    },
    kloesterle: {
      title: "Klösterle"
    },
    koblach: {
      title: "Koblach"
    },
    krumbach: {
      title: "Krumbach"
    },
    langenbeibregenz: {
      title: "Langen bei Bregenz"
    },
    langenegg: {
      title: "Langenegg"
    },
    laterns: {
      title: "Laterns"
    },
    lauterach: {
      title: "Lauterach"
    },
    lech: {
      title: "Lech"
    },
    lingenau: {
      title: "Lingenau"
    },
    lochau: {
      title: "Lochau"
    },
    loruens: {
      title: "Lorüns"
    },
    ludesch: {
      title: "Ludesch"
    },
    lustenau: {
      title: "Lustenau"
    },
    maeder: {
      title: "Mäder"
    },
    meiningen: {
      title: "Meiningen"
    },
    mellau: {
      title: "Mellau"
    },
    mittelberg: {
      title: "Mittelberg"
    },
    moeggers: {
      title: "Möggers"
    },
    nenzing: {
      title: "Nenzing"
    },
    nueziders: {
      title: "Nüziders"
    },
    raggal: {
      title: "Raggal"
    },
    rankweil: {
      title: "Rankweil"
    },
    reuthe: {
      title: "Reuthe"
    },
    riefensberg: {
      title: "Riefensberg"
    },
    roens: {
      title: "Röns"
    },
    roethis: {
      title: "Röthis"
    },
    stanton: {
      title: "Sankt Anton im Montafon"
    },
    stgallenkirch: {
      title: "Sankt Gallenkirch"
    },
    stgerold: {
      title: "Sankt Gerold"
    },
    satteins: {
      title: "Satteins"
    },
    schlins: {
      title: "Schlins"
    },
    schnepfau: {
      title: "Schnepfau"
    },
    schnifis: {
      title: "Schnifis"
    },
    schoppernau: {
      title: "Schoppernau"
    },
    schroecken: {
      title: "Schröcken"
    },
    schruns: {
      title: "Schruns"
    },
    schwarzach: {
      title: "Schwarzach"
    },
    schwarzenberg: {
      title: "Schwarzenberg"
    },
    sibratsgfaell: {
      title: "Sibratsgfäll"
    },
    silbertal: {
      title: "Silbertal"
    },
    sonntag: {
      title: "Sonntag"
    },
    stallehr: {
      title: "Stallehr"
    },
    sulz: {
      title: "Sulz"
    },
    sulzberg: {
      title: "Sulzberg"
    },
    thueringen: {
      title: "Thüringen"
    },
    thueringerberg: {
      title: "Thüringerberg"
    },
    tschagguns: {
      title: "Tschagguns"
    },
    uebersaxen: {
      title: "Übersaxen"
    },
    vandans: {
      title: "Vandans"
    },
    viktorsberg: {
      title: "Viktorsberg"
    },
    warth: {
      title: "Warth"
    },
    weiler: {
      title: "Weiler"
    },
    wolfurt: {
      title: "Wolfurt"
    },
    zwischenwasser: {
      title: "Zwischenwasser"
    }
  };
  function Ti(i) {
    return Te[i] || null;
  }
  function Li(i) {
    var n;
    var e = Object.entries(Te),
      s = e.findIndex(function (_ref36) {
        var _ref37 = _slicedToArray(_ref36, 2),
          r = _ref37[0],
          a = _ref37[1];
        return a.title === i;
      });
    return s === -1 ? null : ((n = e[s]) == null ? void 0 : n[0]) || null;
  }
  function It(i) {
    return {
      bartholomaeberg: "bartholomaberg",
      buers: "burs",
      buerserberg: "burserberg",
      damuels: "damuls",
      duens: "duns",
      duenserberg: "dunserberg",
      goefis: "gofis",
      goetzis: "gotzis",
      hoechst: "hochst",
      hoerbranz: "horbranz",
      kloesterle: "klosterle",
      loruens: "loruns",
      maeder: "mader",
      moeggers: "moggers",
      nueziders: "nuziders",
      roens: "rons",
      roethis: "rothis",
      schroecken: "schrocken",
      thueringen: "thuringen",
      thueringerberg: "thuringenberg",
      uebersaxen: "ubersaxen",
      stanton: "st-anton",
      stgallenkirch: "st-gallenkirch",
      stgerold: "st-gerold"
    }[i] || i;
  }
  var Xa = Object.freeze(Object.defineProperty({
      __proto__: null,
      getSlugForGRW: It,
      getSlugFromTitle: Li,
      getTownship: Ti,
      townships: Te
    }, Symbol.toStringTag, {
      value: "Module"
    })),
    Hi = t.defineComponent({
      __name: "MyTownDropdown",
      props: {
        color: {}
      },
      emits: ["optionSelected", "optionsOpened"],
      setup: function setup(i, _ref38) {
        var e = _ref38.emit;
        var s = e,
          n = Object.values(Te).map(function (d) {
            return d.title;
          }),
          _Nt = Nt(),
          r = _Nt.setCookie,
          a = _Nt.getCookie,
          o = t.ref(a("CurrentCity") || "");
        function c(d) {
          var f = Li(d);
          f && (o.value = f, l(), s("optionSelected", f));
        }
        function l() {
          var d = new Date();
          d.setFullYear(d.getFullYear() + 1);
          var f = window.location.hostname;
          var h = f.split(".");
          (h[0] === "www" || h[0] === "nnp") && (f = f.replace(h[0], "")), r("CurrentCity", o.value, {
            expires: d,
            domain: f,
            path: "/"
          });
        }
        return function (d, f) {
          return t.openBlock(), t.createBlock(ki, {
            items: t.unref(n),
            "default-text": o.value || "Gemeinde auswählen",
            color: d.color,
            onOptionSelected: c,
            onOptionsOpened: f[0] || (f[0] = function (h) {
              return d.$emit("optionsOpened");
            })
          }, null, 8, ["items", "default-text", "color"]);
        };
      }
    }),
    Bi = t.ref([]),
    zi = t.ref([]),
    Pi = t.ref([]),
    st = t.ref(!1);
  function nt() {
    return {
      getTopMenu: function getTopMenu() {
        return Bi.value;
      },
      getMainMenu: function getMainMenu() {
        return zi.value;
      },
      getBottomMenu: function getBottomMenu() {
        return Pi.value;
      },
      setMenu: function setMenu(a, o, c) {
        Bi.value = a, zi.value = o, Pi.value = c;
      },
      toggleMenu: function toggleMenu() {
        st.value = !st.value, st.value ? (document.documentElement.style.overflow = "hidden", document.documentElement.style.height = "100%", document.documentElement.style.margin = "0") : (document.documentElement.style.removeProperty("overflow"), document.documentElement.style.removeProperty("height"), document.documentElement.style.removeProperty("margin"));
      },
      menuIsOpen: st
    };
  }
  var At = "EvoSSO",
    _i = "SsoSessionCookie",
    Ua = "#sso-image";
  function $i(i) {
    return i ? i.split("&").reduce(function (e, s) {
      var n = s.split("=");
      return e[n[0]] = decodeURIComponent(n[1].replace(/\+/g, " ")), e;
    }, {}) : {};
  }
  function qa() {
    return document.querySelector(Ua);
  }
  function Ni(i) {
    var e = qa();
    if (!e) return !1;
    var s = document.createElement("div");
    s.innerHTML = i;
    var n = s.firstChild;
    if (!n) return !1;
    e.appendChild(n);
    var r = e == null ? void 0 : e.querySelectorAll("img");
    return !r || r.length === 0 ? !1 : r[r.length - 1];
  }
  function Ii(i) {
    var e = document.cookie.split("; ");
    for (var s = 0; s < e.length; s++) {
      var n = encodeURIComponent(e[s].split(";")[0].split("=")[0]);
      if (i === n) {
        var r = window.location.hostname.split(".");
        for (; r.length > 0;) {
          var a = "".concat(n, "=; expires=Thu, 01-Jan-1970 00:00:01 GMT; domain=").concat(r.join("."), "; path="),
            o = location.pathname.split("/");
          for (document.cookie = "".concat(a, "/"); o.length > 0;) document.cookie = a + o.join("/"), o.pop();
          for (a = "".concat(n, "=; expires=Thu, 01-Jan-1970 00:00:01 GMT; domain=.").concat(r.join("."), "; path="), o = location.pathname.split("/"), document.cookie = "".concat(a, "/"); o.length > 0;) document.cookie = a + o.join("/"), o.pop();
          r.shift();
        }
      }
    }
    return !0;
  }
  function Ai() {
    Ii(At), Ii(_i);
  }
  function Le(i) {
    if (!(document != null && document.cookie)) return;
    var e = document.cookie.split(";");
    var _iterator3 = _createForOfIteratorHelper(e),
      _step3;
    try {
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        var s = _step3.value;
        var _s$split$map = s.split("=").map(function (a) {
            return a.trim();
          }),
          _s$split$map2 = _slicedToArray(_s$split$map, 2),
          n = _s$split$map2[0],
          r = _s$split$map2[1];
        if (n === i) return decodeURI(r);
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }
  }
  function Ka() {
    var i = 0;
    return new Promise(function (e, s) {
      var n = setInterval(function () {
        i < 10 ? (Le(At) && (clearInterval(n), e(!0)), i++) : (clearInterval(n), s(new Error("Could not get cookies")));
      }, 300);
    });
  }
  var ye = t.ref(null),
    rt = "Es ist ein technischer Fehler aufgetreten. Bitte versuche es in wenigen Minuten noch einmal.",
    Ja = "vodl-user-status";
  function at() {
    return {
      getSSOId: function getSSOId() {
        var i;
        return (i = ye.value) == null ? void 0 : i.id;
      },
      getSSO: function getSSO() {
        return ye.value;
      },
      setSSOCookie: function setSSOCookie(i, e) {
        if (!i || !e) {
          ye.value = null;
          return;
        }
        var s = $i(i),
          n = $i(e);
        ye.value = {
          username: s.username,
          fullname: s.fullname,
          id: Number.parseInt(s.id),
          email: s.email,
          h: n.h,
          t: n.t
        };
      },
      isLoggedIn: function isLoggedIn() {
        return ye.value !== null;
      },
      areCookiesSet: function areCookiesSet() {
        return !!Le(At) && !!Le(_i);
      },
      getLocalUserStatus: function getLocalUserStatus() {
        var i = localStorage.getItem(Ja);
        return i ? JSON.parse(i) : null;
      },
      login: function () {
        var _login = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6(i, e) {
          var _n$message, _a$lastname, _a$login, _a$email, _a$hash, _a$token;
          var o, c, n, r, a, l;
          return _regeneratorRuntime().wrap(function _callee6$(_context6) {
            while (1) switch (_context6.prev = _context6.next) {
              case 0:
                if (!(!i || !e)) {
                  _context6.next = 2;
                  break;
                }
                throw new Error("Username and password are required");
              case 2:
                _context6.next = 4;
                return fetch("/wp-json/russmedia-sso/v1/login", {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json"
                  },
                  body: JSON.stringify({
                    log: i,
                    password: e
                  })
                });
              case 4:
                _context6.next = 6;
                return _context6.sent.json();
              case 6:
                n = _context6.sent;
                r = ((o = n.data) == null ? void 0 : o.login_result) || {};
                a = ((c = n.data) == null ? void 0 : c.user_data) || {};
                if (!(r.error !== "0" || !(a != null && a.user_id))) {
                  _context6.next = 11;
                  break;
                }
                throw new Error((_n$message = n.message) !== null && _n$message !== void 0 ? _n$message : rt);
              case 11:
                if (!(ye.value = {
                  id: a.user_id,
                  lastname: (_a$lastname = a.lastname) !== null && _a$lastname !== void 0 ? _a$lastname : "",
                  username: (_a$login = a.login) !== null && _a$login !== void 0 ? _a$login : "",
                  email: (_a$email = a.email) !== null && _a$email !== void 0 ? _a$email : "",
                  h: (_a$hash = a.hash) !== null && _a$hash !== void 0 ? _a$hash : "",
                  t: (_a$token = a.token) !== null && _a$token !== void 0 ? _a$token : ""
                }, r.cookie)) {
                  _context6.next = 25;
                  break;
                }
                l = Ni(r.cookie);
                if (l) {
                  _context6.next = 15;
                  break;
                }
                return _context6.abrupt("return", n);
              case 15:
                _context6.next = 17;
                return new Promise(function (d) {
                  return l.addEventListener("load", d);
                });
              case 17:
                _context6.prev = 17;
                _context6.next = 20;
                return Ka();
              case 20:
                _context6.next = 25;
                break;
              case 22:
                _context6.prev = 22;
                _context6.t0 = _context6["catch"](17);
                return _context6.abrupt("return", n);
              case 25:
                return _context6.abrupt("return", n);
              case 26:
              case "end":
                return _context6.stop();
            }
          }, _callee6, null, [[17, 22]]);
        }));
        function login(_x5, _x6) {
          return _login.apply(this, arguments);
        }
        return login;
      }(),
      logout: function () {
        var _logout = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
          var _ref39;
          var r, a, i, s, n;
          return _regeneratorRuntime().wrap(function _callee7$(_context7) {
            while (1) switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return fetch("/wp-json/russmedia-sso/v1/logout", {
                  method: "POST"
                });
              case 2:
                i = _context7.sent;
                ye.value = null;
                _context7.next = 6;
                return i.json();
              case 6:
                _context7.t1 = r = _context7.sent.data;
                if (!(_context7.t1 == null)) {
                  _context7.next = 11;
                  break;
                }
                _context7.t2 = void 0;
                _context7.next = 12;
                break;
              case 11:
                _context7.t2 = r.logout_result;
              case 12:
                _context7.t3 = a = _context7.t2;
                if (!(_context7.t3 == null)) {
                  _context7.next = 17;
                  break;
                }
                _context7.t4 = void 0;
                _context7.next = 18;
                break;
              case 17:
                _context7.t4 = a.cookie;
              case 18:
                _context7.t5 = _ref39 = _context7.t4;
                _context7.t0 = _context7.t5 !== null;
                if (!_context7.t0) {
                  _context7.next = 22;
                  break;
                }
                _context7.t0 = _ref39 !== void 0;
              case 22:
                if (!_context7.t0) {
                  _context7.next = 26;
                  break;
                }
                _context7.t6 = _ref39;
                _context7.next = 27;
                break;
              case 26:
                _context7.t6 = !1;
              case 27:
                s = _context7.t6;
                if (s) {
                  _context7.next = 30;
                  break;
                }
                return _context7.abrupt("return", (Ai(), !0));
              case 30:
                n = Ni(s);
                if (!n) {
                  _context7.next = 37;
                  break;
                }
                _context7.next = 34;
                return new Promise(function (o) {
                  return n.addEventListener("load", o);
                });
              case 34:
                _context7.t7 = !0;
                _context7.next = 38;
                break;
              case 37:
                _context7.t7 = (Ai(), !0);
              case 38:
                return _context7.abrupt("return", _context7.t7);
              case 39:
              case "end":
                return _context7.stop();
            }
          }, _callee7);
        }));
        function logout() {
          return _logout.apply(this, arguments);
        }
        return logout;
      }(),
      forgetPassword: function () {
        var _forgetPassword = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee8(i) {
          var _s$message, _s$message2;
          var s;
          return _regeneratorRuntime().wrap(function _callee8$(_context8) {
            while (1) switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return fetch("/wp-json/russmedia-sso/v1/forget-password", {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json"
                  },
                  body: JSON.stringify({
                    log: i
                  })
                });
              case 2:
                _context8.next = 4;
                return _context8.sent.json();
              case 4:
                s = _context8.sent;
                if (!(s.sent = s.sent || !1, s.sent === !1)) {
                  _context8.next = 7;
                  break;
                }
                throw new Error((_s$message = s.message) !== null && _s$message !== void 0 ? _s$message : rt);
              case 7:
                return _context8.abrupt("return", (s.message = (_s$message2 = s.message) !== null && _s$message2 !== void 0 ? _s$message2 : "", s));
              case 8:
              case "end":
                return _context8.stop();
            }
          }, _callee8);
        }));
        function forgetPassword(_x7) {
          return _forgetPassword.apply(this, arguments);
        }
        return forgetPassword;
      }(),
      changePassword: function () {
        var _changePassword = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee9(i, e, s, n, r) {
          var _ref40;
          var c, l, d, f, h, o;
          return _regeneratorRuntime().wrap(function _callee9$(_context9) {
            while (1) switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return fetch("/wp-json/russmedia-sso/v1/change-pw/user", {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json"
                  },
                  body: JSON.stringify({
                    old_password: i,
                    new_password: e,
                    new_password_again: s,
                    hash: n,
                    token: r
                  })
                });
              case 2:
                _context9.next = 4;
                return _context9.sent.json();
              case 4:
                o = _context9.sent;
                if (!(((d = (l = (c = o == null ? void 0 : o.additional_data) == null ? void 0 : c.sso) == null ? void 0 : l.change_password_result) == null ? void 0 : d.success) !== "1")) {
                  _context9.next = 7;
                  break;
                }
                throw new Error((_ref40 = (h = (f = o == null ? void 0 : o.additional_data) == null ? void 0 : f.sso) == null ? void 0 : h.user_error_text) !== null && _ref40 !== void 0 ? _ref40 : rt);
              case 7:
                return _context9.abrupt("return", o);
              case 8:
              case "end":
                return _context9.stop();
            }
          }, _callee9);
        }));
        function changePassword(_x8, _x9, _x10, _x11, _x12) {
          return _changePassword.apply(this, arguments);
        }
        return changePassword;
      }(),
      resetPassword: function () {
        var _resetPassword = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee10(i, e, s) {
          var _ref41;
          var a, o, c, l, d, r;
          return _regeneratorRuntime().wrap(function _callee10$(_context10) {
            while (1) switch (_context10.prev = _context10.next) {
              case 0:
                _context10.next = 2;
                return fetch("/wp-json/russmedia-sso/v1/change-pw/user", {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json"
                  },
                  body: JSON.stringify({
                    new_password: i,
                    new_password_again: e,
                    hash: s
                  })
                });
              case 2:
                _context10.next = 4;
                return _context10.sent.json();
              case 4:
                r = _context10.sent;
                if (!(((c = (o = (a = r == null ? void 0 : r.additional_data) == null ? void 0 : a.sso) == null ? void 0 : o.change_password_result) == null ? void 0 : c.success) !== "1")) {
                  _context10.next = 7;
                  break;
                }
                throw new Error((_ref41 = (d = (l = r == null ? void 0 : r.additional_data) == null ? void 0 : l.sso) == null ? void 0 : d.user_error_text) !== null && _ref41 !== void 0 ? _ref41 : rt);
              case 7:
                return _context10.abrupt("return", r);
              case 8:
              case "end":
                return _context10.stop();
            }
          }, _callee10);
        }));
        function resetPassword(_x13, _x14, _x15) {
          return _resetPassword.apply(this, arguments);
        }
        return resetPassword;
      }()
    };
  }
  function Di(i) {
    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      from: "top"
    };
    var r;
    var s = t.ref((r = i.value) == null ? void 0 : r.getBoundingClientRect()[e.from]),
      n = function n() {
        var a;
        s.value = (a = i.value) == null ? void 0 : a.getBoundingClientRect()[e.from];
      };
    return ae("scroll", n, {
      passive: !0
    }), t.onMounted(function () {
      Es(document.body, function () {
        return n();
      });
    }), t.watch(i, n), s;
  }
  var Qa = {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  };
  function el(i, e) {
    return t.openBlock(), t.createElementBlock("svg", Qa, e[0] || (e[0] = [t.createStaticVNode('<g clip-path="url(#Burger_svg__a)"><mask id="Burger_svg__b" width="24" height="24" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:luminance;"><path fill="#fff" d="M24 0H0v24h24V0Z"></path></mask><g mask="url(#Burger_svg__b)"><path fill="#000" d="M13.27 4.5H2a1 1 0 0 0-1 1 1 1 0 0 0 1 1h8.38a7.41 7.41 0 0 1 2.89-2ZM8.5 11.42c0-.31.03-.62.06-.92H2a1 1 0 0 0-1 1 1 1 0 0 0 1 1h6.59a7.61 7.61 0 0 1-.09-1.08ZM10.52 16.5H2a1 1 0 0 0-1 1 1 1 0 0 0 1 1h11.66a7.43 7.43 0 0 1-3.14-2ZM22.29 19.21a1 1 0 1 0 1.41-1.41l-1.41 1.41Zm-4-4 4 4 1.41-1.41-4-4-1.41 1.41Z"></path><path stroke="#000" stroke-width="2" d="M16 15.5a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z"></path></g></g><defs><clipPath id="Burger_svg__a"><path fill="#fff" d="M0 0h24v24H0z"></path></clipPath></defs>', 2)]));
  }
  var tl = {
      render: el
    },
    il = {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 107 22"
    };
  function sl(i, e) {
    return t.openBlock(), t.createElementBlock("svg", il, e[0] || (e[0] = [t.createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M13.354 21.319H8.075L.863.68h5.524l3.272 10.725 1.443 4.85h.176l1.583-4.707L16.556.68h5.173L13.354 21.32ZM46.148.681h4.96v16.85h8.48v3.788h-13.44V.68ZM61.664 19.018c0-1.45 1.161-2.762 2.745-2.762 1.653 0 2.708 1.275 2.708 2.762 0 1.309-1.09 2.584-2.709 2.584-1.583 0-2.744-1.24-2.744-2.584ZM76.335 12.576h4.61l-.528-1.842-1.408-5.098h-.175l-1.83 5.098-.669 1.842ZM76.723.68h5.031L88.65 21.32h-5.242L82 16.363h-7.003l-1.723 4.956h-4.646L76.723.68ZM87.554 1.017H106.2v3.787h-6.896v16.85h-4.961V4.804h-6.79V1.017ZM32.496 17.227c-3.419 0-6.19-2.787-6.19-6.228 0-3.438 2.771-6.227 6.19-6.227 3.418 0 6.19 2.789 6.19 6.227 0 3.44-2.772 6.228-6.19 6.228Zm0-16.935c-5.879 0-10.644 4.793-10.644 10.707 0 5.914 4.765 10.709 10.644 10.709 5.878 0 10.644-4.795 10.644-10.709S38.374.292 32.496.292Z",
      "clip-rule": "evenodd"
    }, null, -1)]));
  }
  var nl = {
    render: sl
  };
  function Oi(i, e) {
    return i === "Main" ? {
      Default: {
        logo: "",
        line: "md:bg-main-600 bg-main-600"
      },
      Red: {
        logo: "text-white",
        line: "bg-rot-600 text-white"
      },
      White: {
        logo: "text-black",
        line: "md:bg-white bg-white"
      }
    }[e] : {
      Default: {
        logo: "",
        line: "bg-main-600 md:bg-black md:text-white"
      },
      Red: {
        logo: "text-white",
        line: "bg-rot-600 text-white"
      },
      White: {
        logo: "text-black",
        line: "md:bg-black bg-white md:text-white"
      }
    }[e];
  }
  var rl = {
      key: 0,
      "class": "flex items-center gap-4 min-w-24"
    },
    al = {
      "class": "hidden md:flex"
    },
    ll = {
      key: 1,
      href: "/",
      "aria-label": "home",
      "class": "w-32 md:w-44"
    },
    ol = {
      "class": "flex gap-6 ml-auto"
    },
    cl = {
      key: 0,
      "class": "flex justify-center gap-4"
    },
    dl = {
      "class": "flex justify-center"
    },
    pl = ["aria-expanded"],
    Fi = fe(t.defineComponent({
      __name: "MainLine",
      props: {
        menu: {
          type: Boolean,
          "default": !1
        },
        color: {}
      },
      emits: ["toggleMenu"],
      setup: function setup(i) {
        var e = Oi("Main", i.color),
          _nt = nt(),
          s = _nt.menuIsOpen,
          n = at(),
          r = t.ref("V+ Testen"),
          a = t.ref("/abo-vplus?utm_source=vplus_vol&utm_medium=vplus_menuleiste_button&utm_campaign=vplus_abo");
        t.onMounted(function () {
          var c = n.getLocalUserStatus();
          c != null && c.hasPlusAccess && (r.value = "MEIN V+", a.value = "/specials/vplus");
        });
        function o(c) {
          window.location.href = c;
        }
        return function (c, l) {
          return t.openBlock(), t.createElementBlock("div", {
            "class": t.normalizeClass(["grid items-center h-12 grid-rows-1 px-4 grid-custom-col md:h-16 md:min-h-16", t.unref(e).line])
          }, [c.menu ? t.createCommentVNode("", !0) : (t.openBlock(), t.createElementBlock("div", rl, [l[5] || (l[5] = t.createElementVNode("div", {
            "class": "laendlepunkte-placeholder min-w-14"
          }, null, -1)), t.createElementVNode("div", al, [t.createVNode(pe, {
            color: "BlackYellow",
            small: !0,
            onClick: l[0] || (l[0] = function (d) {
              return o("/tipp-geben");
            })
          }, {
            "default": t.withCtx(function () {
              return l[4] || (l[4] = [t.createTextVNode(" Tipp geben ")]);
            }),
            _: 1
          })])])), c.menu ? t.createCommentVNode("", !0) : (t.openBlock(), t.createElementBlock("a", ll, [t.createVNode(t.unref(nl), {
            "class": t.normalizeClass(t.unref(e).logo)
          }, null, 8, ["class"])])), t.createElementVNode("div", ol, [c.menu ? t.createCommentVNode("", !0) : (t.openBlock(), t.createElementBlock("div", cl, [t.createElementVNode("button", {
            type: "button",
            small: !0,
            "class": "block md:hidden",
            onClick: l[1] || (l[1] = function (d) {
              return o("/specials/vplus");
            })
          }, [t.createVNode(t.unref(ft), {
            focusable: "false",
            "class": "w-6 h-6 text-rot-600"
          })]), t.createVNode(pe, {
            color: "Red",
            small: !0,
            "class": "hidden md:block",
            onClick: l[2] || (l[2] = function (d) {
              return o(a.value);
            })
          }, {
            "default": t.withCtx(function () {
              return [t.createTextVNode(t.toDisplayString(r.value), 1)];
            }),
            _: 1
          })])), t.createElementVNode("div", dl, [t.createElementVNode("button", {
            id: "nav-burger",
            type: "button",
            "aria-expanded": !t.unref(s),
            "aria-controls": "main-menu",
            "aria-label": "open menu",
            onClick: l[3] || (l[3] = function (d) {
              return c.$emit("toggleMenu");
            })
          }, [t.unref(s) ? (t.openBlock(), t.createBlock(t.unref(Si), {
            key: 1,
            "aria-hidden": "true",
            focusable: "false"
          })) : (t.openBlock(), t.createBlock(t.unref(tl), {
            key: 0,
            "aria-hidden": "true",
            focusable: "false",
            "class": "w-6 h-6"
          }))], 8, pl)])])], 2);
        };
      }
    }), [["__scopeId", "data-v-5ef773bd"]]),
    fl = {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    };
  function ul(i, e) {
    return t.openBlock(), t.createElementBlock("svg", fl, e[0] || (e[0] = [t.createElementVNode("path", {
      d: "M5 4C5 3.44772 5.44771 3 6 3H18C18.5523 3 19 3.44772 19 4V20C19 20.824 18.0592 21.2944 17.4 20.8L13.8 18.1C12.7333 17.3 11.2667 17.3 10.2 18.1L6.6 20.8C5.94076 21.2944 5 20.824 5 20V4Z",
      stroke: "black",
      "stroke-width": "2"
    }, null, -1)]));
  }
  var Zi = {
      render: ul
    },
    ml = {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    };
  function hl(i, e) {
    return t.openBlock(), t.createElementBlock("svg", ml, e[0] || (e[0] = [t.createElementVNode("path", {
      d: "M4 21C4 21 6.5 17 12 17C17.5 17 20 21 20 21",
      stroke: "black",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1), t.createElementVNode("path", {
      d: "M12 13C14.7614 13 17 10.7614 17 8C17 5.23858 14.7614 3 12 3C9.23858 3 7 5.23858 7 8C7 10.7614 9.23858 13 12 13Z",
      stroke: "black",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)]));
  }
  var Ri = {
      render: hl
    },
    gl = {
      id: "nav-login-section",
      "class": "grid grid-cols-2 bg-white rounded-lg",
      "data-allow-mismatch": "children"
    },
    wl = {
      "class": "typo-menu-items"
    },
    bl = t.defineComponent({
      __name: "LoginSection",
      setup: function setup(i) {
        var _nt2 = nt(),
          e = _nt2.toggleMenu,
          s = at();
        function n() {
          window.dispatchEvent(new Event("open_login_form")), e();
        }
        var r = t.computed(function () {
          return s.isLoggedIn() ? [{
            title: "Mein Konto",
            icon: Ri,
            url: "/profil",
            "class": ""
          }, {
            title: "Tipp geben",
            icon: Zi,
            url: "/tipp-geben",
            "class": "tipp-geben"
          }] : [{
            title: "Login",
            icon: Ri,
            action: n,
            "class": ""
          }, {
            title: "Tipp geben",
            icon: Zi,
            url: "/tipp-geben",
            "class": "tipp-geben"
          }];
        });
        return function (a, o) {
          return t.openBlock(), t.createElementBlock("div", gl, [(t.openBlock(!0), t.createElementBlock(t.Fragment, null, t.renderList(r.value, function (c) {
            return t.openBlock(), t.createBlock(t.resolveDynamicComponent(c.action ? "button" : "a"), {
              key: c.title,
              href: c.url,
              "class": t.normalizeClass(["flex flex-col items-center", c["class"]]),
              onClick: function onClick() {
                return c.action && c.action();
              }
            }, {
              "default": t.withCtx(function () {
                return [(t.openBlock(), t.createBlock(t.resolveDynamicComponent(c.icon))), t.createElementVNode("span", wl, t.toDisplayString(c.title), 1)];
              }),
              _: 2
            }, 1032, ["href", "class", "onClick"]);
          }), 128))]);
        };
      }
    }),
    vl = ["href", "target", "innerHTML"],
    Cl = t.defineComponent({
      __name: "MenuItemFooterItem",
      props: {
        item: {}
      },
      setup: function setup(i) {
        var s;
        var e = t.ref((s = i.item.url) == null ? void 0 : s.includes("http"));
        return t.onMounted(function () {
          var n, r, a;
          e.value = ((n = i.item.url) == null ? void 0 : n.includes("http")) && !((a = i.item.url) != null && a.includes((r = window == null ? void 0 : window.location) == null ? void 0 : r.hostname));
        }), function (n, r) {
          return t.openBlock(), t.createElementBlock("li", null, [t.createElementVNode("a", {
            href: n.item.url,
            target: e.value ? "_blank" : "_self",
            "class": "text-xs underline text-text",
            innerHTML: n.item.title
          }, null, 8, vl)]);
        };
      }
    }),
    yl = {
      "class": "flex items-center p-2 rounded typo-menu-items"
    },
    El = ["innerHTML"],
    xl = ["innerHTML"],
    kl = {
      "class": "grid grid-cols-2 p-2 pt-0"
    },
    Sl = t.defineComponent({
      __name: "MenuItemFooter",
      props: {
        item: {}
      },
      setup: function setup(i) {
        return function (e, s) {
          return t.openBlock(), t.createElementBlock("div", null, [t.createElementVNode("div", yl, [e.item.icon ? (t.openBlock(), t.createElementBlock("span", {
            key: 0,
            "class": "mr-2",
            innerHTML: e.item.icon
          }, null, 8, El)) : t.createCommentVNode("", !0), t.createElementVNode("span", {
            innerHTML: e.item.title
          }, null, 8, xl)]), t.createElementVNode("ul", kl, [(t.openBlock(!0), t.createElementBlock(t.Fragment, null, t.renderList(e.item.children, function (n) {
            return t.openBlock(), t.createBlock(Cl, {
              key: n.id,
              item: n
            }, null, 8, ["item"]);
          }), 128))])]);
        };
      }
    }),
    Ml = ["href", "target", "innerHTML"],
    ji = t.defineComponent({
      __name: "MenuItemLink",
      props: {
        item: {}
      },
      setup: function setup(i) {
        var s;
        var e = t.ref((s = i.item.url) == null ? void 0 : s.includes("http"));
        return t.onMounted(function () {
          var n, r, a;
          e.value = ((n = i.item.url) == null ? void 0 : n.includes("http")) && !((a = i.item.url) != null && a.includes((r = window == null ? void 0 : window.location) == null ? void 0 : r.hostname));
        }), function (n, r) {
          return t.openBlock(), t.createElementBlock("a", {
            href: n.item.url,
            target: e.value ? "_blank" : "_self",
            "class": t.normalizeClass(["flex items-center p-2 rounded cursor-pointer typo-menu-items min-h-10", n.item.classes]),
            innerHTML: n.item.title
          }, null, 10, Ml);
        };
      }
    }),
    Vl = t.defineComponent({
      __name: "MenuItemMyTown",
      props: {
        item: {}
      },
      setup: function setup(i) {
        var e = t.ref(void 0);
        t.onMounted(function () {
          var r = Le("CurrentCity");
          r && (e.value = r);
        });
        var s = t.computed(function () {
            if (!e.value) return i.item.title;
            var r = e.value.split("");
            return r[0] = r[0].toUpperCase(), r.join("");
          }),
          n = t.computed(function () {
            return _objectSpread(_objectSpread({}, i.item), {}, {
              title: s.value,
              url: e.value ? "/gemeinde/".concat(e.value) : i.item.url
            });
          });
        return function (r, a) {
          return t.openBlock(), t.createBlock(ji, {
            item: n.value
          }, null, 8, ["item"]);
        };
      }
    }),
    Tl = ["open", "name"],
    Ll = ["innerHTML"],
    Hl = ["innerHTML"],
    Bl = fe(t.defineComponent({
      __name: "MenuItemWithChildren",
      props: {
        item: {},
        firstLevel: {
          type: Boolean,
          "default": !1
        }
      },
      setup: function setup(i) {
        var e = t.computed(function () {
            return i.item.classes.includes("open");
          }),
          s = t.computed(function () {
            return i.firstLevel ? "bg-main-200" : "";
          }),
          n = i.firstLevel ? "first-level" : i.item.title;
        return function (r, a) {
          return t.openBlock(), t.createElementBlock("details", {
            open: e.value,
            "class": "overflow-hidden cursor-pointer typo-menu-items",
            name: t.unref(n)
          }, [t.createElementVNode("summary", {
            "class": t.normalizeClass(["flex items-center p-2 rounded", [s.value].concat(_toConsumableArray(r.item.classes))])
          }, [r.item.icon ? (t.openBlock(), t.createElementBlock("span", {
            key: 0,
            "class": "mr-2",
            innerHTML: r.item.icon
          }, null, 8, Ll)) : t.createCommentVNode("", !0), t.createElementVNode("span", {
            innerHTML: r.item.title
          }, null, 8, Hl)], 2), t.createVNode(Wi, {
            "class": "ml-7",
            items: r.item.children
          }, null, 8, ["items"])], 8, Tl);
        };
      }
    }), [["__scopeId", "data-v-d814a592"]]),
    zl = t.defineComponent({
      __name: "MenuItem",
      props: {
        item: {},
        firstLevel: {
          type: Boolean,
          "default": !1
        }
      },
      setup: function setup(i) {
        var r;
        var e = ((r = i.item.children) == null ? void 0 : r.length) > 0,
          s = i.item.classes.includes("mytown"),
          n = t.computed(function () {
            return s ? Vl : e ? Bl : ji;
          });
        return function (a, o) {
          return t.openBlock(), t.createElementBlock("li", null, [(t.openBlock(), t.createBlock(t.resolveDynamicComponent(n.value), {
            item: a.item,
            "first-level": a.firstLevel,
            "class": "select-none"
          }, null, 8, ["item", "first-level"]))]);
        };
      }
    }),
    Wi = t.defineComponent({
      __name: "MenuSection",
      props: {
        items: {},
        firstLevel: {
          type: Boolean
        }
      },
      setup: function setup(i) {
        return function (e, s) {
          return t.openBlock(), t.createElementBlock("ul", null, [(t.openBlock(!0), t.createElementBlock(t.Fragment, null, t.renderList(e.items, function (n) {
            return t.openBlock(), t.createBlock(zl, {
              key: n.title,
              item: n,
              "first-level": e.firstLevel
            }, null, 8, ["item", "first-level"]);
          }), 128))]);
        };
      }
    }),
    Pl = {
      width: "10",
      height: "10",
      viewBox: "0 0 10 10",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    };
  function _l(i, e) {
    return t.openBlock(), t.createElementBlock("svg", Pl, e[0] || (e[0] = [t.createElementVNode("path", {
      d: "M1 1L9 9",
      stroke: "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }, null, -1), t.createElementVNode("path", {
      d: "M1 9L9 1",
      stroke: "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }, null, -1)]));
  }
  var $l = {
      render: _l
    },
    Nl = {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    };
  function Il(i, e) {
    return t.openBlock(), t.createElementBlock("svg", Nl, e[0] || (e[0] = [t.createElementVNode("path", {
      d: "M20.2929 21.7071C20.6834 22.0976 21.3166 22.0976 21.7071 21.7071C22.0976 21.3166 22.0976 20.6834 21.7071 20.2929L20.2929 21.7071ZM14.6679 16.0821L20.2929 21.7071L21.7071 20.2929L16.0821 14.6679L14.6679 16.0821Z",
      fill: "black"
    }, null, -1), t.createElementVNode("circle", {
      cx: "10.875",
      cy: "10.875",
      r: "6.875",
      stroke: "black",
      "stroke-width": "2"
    }, null, -1)]));
  }
  var Al = {
      render: Il
    },
    Dl = ["placeholder"],
    Gi = t.defineComponent({
      __name: "SearchBox",
      props: {
        modelValue: {},
        placeholderText: {
          "default": "Suchbegriff eingeben"
        },
        color: {}
      },
      emits: ["update:modelValue", "searchEntered"],
      setup: function setup(i, _ref42) {
        var e = _ref42.emit;
        var s = i,
          n = e,
          r = t.computed({
            get: function get() {
              return s.modelValue;
            },
            set: function set(c) {
              return n("update:modelValue", c);
            }
          });
        function a() {
          r.value = "";
        }
        function o() {
          n("searchEntered", r.value);
        }
        return function (c, l) {
          return t.openBlock(), t.createElementBlock("div", {
            "data-testid": "search-box",
            "class": t.normalizeClass(["flex items-center h-12 p-3 rounded mix-blend-multiply bg-grau-300", [c.color]])
          }, [t.createVNode(t.unref(Al), {
            "data-testid": "search-button",
            onClick: o
          }), t.withDirectives(t.createElementVNode("input", {
            "onUpdate:modelValue": l[0] || (l[0] = function (d) {
              return r.value = d;
            }),
            "class": t.normalizeClass(["flex-1 mx-2 focus:outline-none typo-menu-items placeholder-grau-800 bg-grau-300", [c.color]]),
            autocomplete: "off",
            name: "search",
            type: "text",
            placeholder: c.placeholderText,
            onKeyup: t.withKeys(o, ["enter"])
          }, null, 42, Dl), [[t.vModelText, r.value, void 0, {
            lazy: !0
          }]]), t.withDirectives(t.createVNode(t.unref($l), {
            "class": "hidden sm:inline",
            onClick: a
          }, null, 512), [[t.vShow, c.modelValue !== ""]])], 2);
        };
      }
    }),
    Ol = t.defineComponent({
      __name: "SearchSection",
      setup: function setup(i) {
        var e = t.ref("");
        function s(n) {
          window.location.href = "/suche?search=".concat(n, "&page=1&per_page=10&orderby=date");
        }
        return function (n, r) {
          return t.openBlock(), t.createBlock(Gi, {
            id: "nav-search",
            modelValue: e.value,
            "onUpdate:modelValue": r[0] || (r[0] = function (a) {
              return e.value = a;
            }),
            color: "bg-main-200",
            onSearchEntered: s
          }, null, 8, ["modelValue"]);
        };
      }
    }),
    Fl = {
      "class": "z-[5000004] flex flex-col gap-4 bg-white"
    },
    Zl = {
      id: "main-menu",
      "aria-label": "primary",
      "class": "flex flex-col gap-4 mx-2 mt-4 mb-4 overflow-y-scroll pb-60 scrollbar-hide"
    },
    Rl = t.defineComponent({
      __name: "Menu",
      props: {
        color: {
          "default": "Default"
        }
      },
      emits: ["toggleMenu"],
      setup: function setup(i) {
        var _nt3 = nt(),
          e = _nt3.getMainMenu,
          s = t.computed(function () {
            return e();
          }),
          n = t.computed(function () {
            return s.value.find(function (a) {
              return a.classes.includes("footer");
            });
          }),
          r = t.computed(function () {
            return s.value.filter(function (a) {
              return !a.classes.includes("footer");
            });
          });
        return function (a, o) {
          return t.openBlock(), t.createElementBlock("aside", Fl, [t.createVNode(Fi, {
            "class": "hidden md:flex",
            "is-open": !0,
            menu: !0,
            color: a.color,
            onToggleMenu: o[0] || (o[0] = function (c) {
              return a.$emit("toggleMenu");
            })
          }, null, 8, ["color"]), t.createElementVNode("nav", Zl, [t.createVNode(bl), t.createVNode(Ol), t.createVNode(Wi, {
            "class": "nav-menu-group",
            items: r.value,
            "first-level": !0
          }, null, 8, ["items"]), n.value ? (t.openBlock(), t.createBlock(Sl, {
            key: 0,
            "class": "nav-menu-footer",
            item: n.value
          }, null, 8, ["item"])) : t.createCommentVNode("", !0)])]);
        };
      }
    }),
    jl = ["href"],
    Wl = ["innerHTML"],
    Yi = t.defineComponent({
      __name: "Default",
      props: {
        navItem: {}
      },
      setup: function setup(i) {
        return function (e, s) {
          return t.openBlock(), t.createElementBlock("a", {
            href: e.navItem.url,
            "class": "px-1.5 pb-0.5 flex items-center text-black border rounded typo-meta-1-bold whitespace-nowrap border-grau-400 max-h-[27px]"
          }, [e.navItem.icon ? (t.openBlock(), t.createElementBlock("span", {
            key: 0,
            "class": "pt-0.5",
            innerHTML: e.navItem.icon
          }, null, 8, Wl)) : t.createCommentVNode("", !0), t.createElementVNode("span", null, t.toDisplayString(e.navItem.title), 1)], 8, jl);
        };
      }
    }),
    Gl = t.defineComponent({
      __name: "GRW2025",
      props: {
        navItem: {}
      },
      setup: function setup(i) {
        var e = i,
          s = t.ref(void 0);
        t.onMounted(function () {
          var l = Le("CurrentCity");
          l && (s.value = l);
        });
        var n = t.computed(function () {
            return s.value !== void 0;
          }),
          r = t.computed(function () {
            return s.value ? It(s.value) : "";
          }),
          a = t.computed(function () {
            var l;
            return s.value ? (l = Ti(s.value)) == null ? void 0 : l.title : "";
          }),
          o = t.computed(function () {
            return s.value ? "/themen/gemeindewahl-".concat(r.value) : "";
          }),
          c = t.computed(function () {
            return _objectSpread(_objectSpread({}, e.navItem), {}, {
              url: o.value,
              title: a.value
            });
          });
        return function (l, d) {
          return n.value ? (t.openBlock(), t.createBlock(Yi, {
            key: 0,
            "nav-item": c.value
          }, null, 8, ["nav-item"])) : t.createCommentVNode("", !0);
        };
      }
    }),
    Yl = {
      "class": "flex items-center typo-meta-1-bold"
    },
    Xl = {
      key: 0,
      "class": "mr-2 uppercase text-rot-600"
    },
    Ul = ["href"],
    ql = {
      key: 0,
      "class": "h-2.5 w-2.5 rounded-full bg-rot-600 animate-pulse"
    },
    Kl = {
      key: 1,
      "class": "font-normal"
    },
    Jl = t.defineComponent({
      __name: "Tickaroo",
      props: {
        navItem: {}
      },
      setup: function setup(i) {
        var e = t.ref(!1),
          s = t.ref(0);
        function n() {
          return _n3.apply(this, arguments);
        }
        function _n3() {
          _n3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
            var a;
            return _regeneratorRuntime().wrap(function _callee11$(_context11) {
              while (1) switch (_context11.prev = _context11.next) {
                case 0:
                  _context11.next = 2;
                  return fetch("https://www.vol.at/wp-json/russmedia-tickaroo/v1/get-latest/?id=64f1dd33ff38356d05a8f458&limit=2");
                case 2:
                  _context11.next = 4;
                  return _context11.sent.json();
                case 4:
                  a = _context11.sent;
                  a.latest < 120 && (s.value = a.latest), a.latest <= 10 && (e.value = !0);
                case 6:
                case "end":
                  return _context11.stop();
              }
            }, _callee11);
          }));
          return _n3.apply(this, arguments);
        }
        return t.onMounted(function () {
          Ms(n, 6e4, {
            immediate: !0
          });
        }), function (r, a) {
          return t.openBlock(), t.createElementBlock("span", Yl, [e.value ? (t.openBlock(), t.createElementBlock("span", Xl, "Live")) : t.createCommentVNode("", !0), t.createElementVNode("a", {
            href: r.navItem.url,
            "class": "flex items-center gap-1 px-1.5 py-0.5 text-black border rounded whitespace-nowrap border-grau-400"
          }, [e.value ? (t.openBlock(), t.createElementBlock("div", ql)) : t.createCommentVNode("", !0), t.createTextVNode(" " + t.toDisplayString(r.navItem.title) + " ", 1), s.value > 0 ? (t.openBlock(), t.createElementBlock("span", Kl, t.toDisplayString(s.value) + " min", 1)) : t.createCommentVNode("", !0)], 8, Ul)]);
        };
      }
    }),
    Ql = {
      key: 0
    },
    eo = t.defineComponent({
      __name: "Wrapper",
      props: {
        navItem: {}
      },
      setup: function setup(i) {
        var _tickaroo$grw2025$e$n;
        var e = i,
          n = (_tickaroo$grw2025$e$n = {
            tickaroo: Jl,
            grw2025: Gl
          }[e.navItem.classes[0]]) !== null && _tickaroo$grw2025$e$n !== void 0 ? _tickaroo$grw2025$e$n : Yi,
          r = t.ref(void 0);
        t.onMounted(function () {
          var c = Le("CurrentCity");
          c && (r.value = c);
        });
        var a = t.computed(function () {
            return r.value !== void 0;
          }),
          o = t.computed(function () {
            return !(e.navItem.classes[0] === "grw2025" && !a.value);
          });
        return function (c, l) {
          return o.value ? (t.openBlock(), t.createElementBlock("li", Ql, [(t.openBlock(), t.createBlock(t.resolveDynamicComponent(t.unref(n)), {
            "class": "min-h-[27px]",
            "nav-item": c.navItem
          }, null, 8, ["nav-item"]))])) : t.createCommentVNode("", !0);
        };
      }
    }),
    to = {
      "aria-label": "special",
      "class": "flex justify-center h-10 bg-white md:h-11"
    },
    io = {
      "class": "flex items-center gap-4 px-4 overflow-x-scroll scrollbar-hide"
    },
    so = t.defineComponent({
      __name: "BottomLine",
      props: {
        navItems: {}
      },
      setup: function setup(i) {
        return function (e, s) {
          return t.openBlock(), t.createElementBlock(t.Fragment, null, [s[0] || (s[0] = t.createElementVNode("div", {
            "class": "vodl-piano-sticky-note"
          }, null, -1)), t.createElementVNode("nav", to, [t.createElementVNode("ul", io, [(t.openBlock(!0), t.createElementBlock(t.Fragment, null, t.renderList(e.navItems, function (n) {
            return t.openBlock(), t.createBlock(eo, {
              key: n.title,
              "nav-item": n
            }, null, 8, ["nav-item"]);
          }), 128))])])], 64);
        };
      }
    }),
    no = {
      "class": "flex items-center justify-around h-full text-xs uppercase md:gap-8 md:ml-auto"
    },
    ro = ["href"],
    ao = t.defineComponent({
      __name: "TopLine",
      props: {
        navItems: {},
        color: {}
      },
      setup: function setup(i) {
        var e = i,
          s = Oi("Top", e.color),
          n = t.computed(function () {
            return e.navItems;
          });
        return function (r, a) {
          return t.openBlock(), t.createElementBlock("nav", {
            "aria-label": "promo",
            "class": t.normalizeClass([t.unref(s).line, "w-full typo-meta-2-bold md:h-[30px] h-6 px-4"])
          }, [t.createElementVNode("ul", no, [(t.openBlock(!0), t.createElementBlock(t.Fragment, null, t.renderList(n.value, function (o) {
            return t.openBlock(), t.createElementBlock("li", {
              key: o.title
            }, [t.createElementVNode("a", {
              href: o.url
            }, t.toDisplayString(o.title), 9, ro)]);
          }), 128))])], 2);
        };
      }
    }),
    lo = {
      "class": "relative"
    },
    oo = fe(t.defineComponent({
      __name: "Navigation",
      props: {
        color: {
          "default": "Default"
        },
        bottomMenu: {},
        topMenu: {},
        mainMenu: {},
        sessionCookie: {},
        evoSSOCookie: {},
        isHomePage: {
          type: Boolean,
          "default": !1
        }
      },
      setup: function setup(i) {
        t.useCssVars(function (m) {
          return {
            "344bb2ae": v.value
          };
        }), i.sessionCookie && i.evoSSOCookie && at().setSSOCookie(i.sessionCookie, i.evoSSOCookie);
        var _nt4 = nt(),
          e = _nt4.getBottomMenu,
          s = _nt4.getTopMenu,
          n = _nt4.setMenu,
          r = _nt4.toggleMenu,
          a = _nt4.menuIsOpen;
        n(i.topMenu, i.mainMenu, i.bottomMenu);
        var o = t.useTemplateRef("header");
        gs(o, function () {
          return a.value ? r() : "";
        }, {
          ignore: t.ref([".ignore-click-outside", ".shepherd-modal-overlay-container"])
        });
        var c = Di(o);
        function l() {
          var m;
          c.value && c.value > 0 && ((m = o.value) == null || m.scrollIntoView({
            behavior: "smooth"
          })), r();
        }
        var d = t.computed(function () {
            return c.value !== void 0 && c.value <= 0;
          }),
          f = ps(function () {
            var m;
            c.value && c.value <= 0 || (m = o.value) == null || m.scrollIntoView({
              behavior: "instant"
            });
          }, 10);
        t.watch(c, function (m) {
          a.value && m && m > 0 && f();
        });
        var h = Di(o, {
            from: "left"
          }),
          v = t.computed(function () {
            var _h$value;
            return "".concat(Math.max((_h$value = h.value) !== null && _h$value !== void 0 ? _h$value : 0, 0), "px");
          });
        return function (m, p) {
          return t.openBlock(), t.createElementBlock("div", null, [t.createElementVNode("div", {
            ref_key: "header",
            ref: o,
            "class": "w-full h-12 md:h-[94px]"
          }, [t.createElementVNode("header", {
            "class": t.normalizeClass([{
              "fixed top-0 navigation-offset-left right-0 left-0 max-w-screen-lg": d.value,
              relative: !d.value
            }, "vol-navigation-z-index z-[500003] navigation-max-width"])
          }, [t.createElementVNode("div", lo, [t.createVNode(ao, {
            "class": "hidden md:flex",
            "nav-items": t.unref(s)(),
            color: m.color
          }, null, 8, ["nav-items", "color"]), t.createVNode(Fi, {
            color: m.color,
            onToggleMenu: l
          }, null, 8, ["color"]), t.withDirectives(t.createElementVNode("div", null, [t.createVNode(Rl, {
            color: m.color,
            "class": "w-full md:w-80 absolute md:right-0 md:top-[30px] h-screen",
            onToggleMenu: t.unref(r)
          }, null, 8, ["color", "onToggleMenu"]), t.createElementVNode("div", {
            "class": "fixed inset-0 hidden bg-black opacity-50 md:block ignore-click-outside",
            onClick: p[0] || (p[0] = function () {
              return t.unref(r) && t.unref(r).apply(void 0, arguments);
            })
          })], 512), [[t.vShow, t.unref(a)]])])], 2)], 512), m.isHomePage ? (t.openBlock(), t.createBlock(so, {
            key: 0,
            "class": "relative max-w-screen-lg z-[500002] navigation-max-width vol-navigation-z-index",
            "nav-items": t.unref(e)()
          }, null, 8, ["nav-items"])) : t.createCommentVNode("", !0)]);
        };
      }
    }), [["__scopeId", "data-v-2f4522bf"]]),
    co = {
      "data-testid": "responsive-picture"
    },
    po = ["media", "sizes", "srcset"],
    fo = ["src", "sizes", "srcset", "alt", "title"],
    je = t.defineComponent({
      __name: "ResponsivePicture",
      props: {
        picture: {},
        additionalClass: {
          "default": ""
        }
      },
      setup: function setup(i) {
        function e(s) {
          return !s || s.length === 0 ? "" : typeof s == "string" ? s : s.map(function (n) {
            return !n.src || !n.w ? "" : "".concat(n.src, " ").concat(n.w);
          }).join(", ");
        }
        return function (s, n) {
          var r, a;
          return t.openBlock(), t.createElementBlock("div", co, [t.createElementVNode("picture", {
            "class": t.normalizeClass(s.additionalClass)
          }, [(r = s.picture) != null && r.source && s.picture.source.length > 0 ? (t.openBlock(), t.createElementBlock("source", {
            key: 0,
            media: s.picture.source[0].media,
            sizes: s.picture.source[0].sizes,
            srcset: e(s.picture.source[0].srcset)
          }, null, 8, po)) : t.createCommentVNode("", !0), (a = s.picture) != null && a.img ? (t.openBlock(), t.createElementBlock("img", {
            key: 1,
            "class": "w-full rounded",
            src: s.picture.img.src,
            sizes: s.picture.img.sizes ? s.picture.img.sizes : "",
            srcset: e(s.picture.img.srcset),
            alt: s.picture.img.alt ? s.picture.img.alt : "",
            title: s.picture.img.alt ? s.picture.img.alt : ""
          }, null, 8, fo)) : t.createCommentVNode("", !0)], 2)]);
        };
      }
    }),
    uo = {
      viewBox: "0 0 20 19",
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    };
  function mo(i, e) {
    return t.openBlock(), t.createElementBlock("svg", uo, e[0] || (e[0] = [t.createStaticVNode('<g id="CloseBlack_svg__close-icon" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="square"><g transform="translate(-800.000000, -523.000000)" stroke="currentColor" stroke-width="3"><g transform="translate(134.000000, 482.000000)"><g transform="translate(669.000000, 43.000000)"><path d="M0,14.3507917 L13.9560549,0.394736842"></path><path d="M0.394736842,0.394736842 L14.3507917,14.3507917"></path></g></g></g></g>', 1)]));
  }
  var ho = {
      render: mo
    },
    go = {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    };
  function wo(i, e) {
    return t.openBlock(), t.createElementBlock("svg", go, e[0] || (e[0] = [t.createElementVNode("path", {
      d: "M12.0003 8.79732V8.79732C11.1159 7.91286 11.1159 6.47887 12.0003 5.59441L15.2032 2.3915C16.0877 1.50704 17.5217 1.50704 18.4061 2.3915L21.6091 5.59441C22.4935 6.47887 22.4935 7.91286 21.6091 8.79732L18.4061 12.0002C17.5217 12.8847 16.0877 12.8847 15.2032 12.0002V12.0002",
      stroke: "black",
      "stroke-width": "2"
    }, null, -1), t.createElementVNode("path", {
      d: "M11.9997 15.2032V15.2032C12.8841 16.0876 12.8841 17.5216 11.9997 18.4061L8.79677 21.609C7.91231 22.4935 6.47832 22.4935 5.59386 21.609L2.39094 18.4061C1.50648 17.5216 1.50648 16.0876 2.39094 15.2032L5.59385 12.0003C6.47831 11.1158 7.91231 11.1158 8.79677 12.0002V12.0002",
      stroke: "black",
      "stroke-width": "2"
    }, null, -1), t.createElementVNode("path", {
      d: "M16.8047 7.1958L7.19594 16.8045",
      stroke: "black",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }, null, -1)]));
  }
  var bo = {
      render: wo
    },
    vo = t.defineComponent({
      __name: "CopyClipboard",
      props: {
        url: {},
        text: {}
      },
      emits: ["buttonClicked"],
      setup: function setup(i, _ref43) {
        var e = _ref43.emit;
        var s = i,
          n = e;
        function r() {
          return _r5.apply(this, arguments);
        }
        function _r5() {
          _r5 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
            var a;
            return _regeneratorRuntime().wrap(function _callee12$(_context12) {
              while (1) switch (_context12.prev = _context12.next) {
                case 0:
                  if (!(typeof ((a = navigator.clipboard) == null ? void 0 : a.writeText) != "function")) {
                    _context12.next = 3;
                    break;
                  }
                  n("buttonClicked", "clipboard");
                  return _context12.abrupt("return");
                case 3:
                  _context12.next = 5;
                  return navigator.clipboard.writeText(s.url);
                case 5:
                  n("buttonClicked", "clipboard");
                case 6:
                case "end":
                  return _context12.stop();
              }
            }, _callee12);
          }));
          return _r5.apply(this, arguments);
        }
        return function (a, o) {
          return t.openBlock(), t.createElementBlock("button", {
            title: "Clipboard",
            type: "button",
            "class": "flex flex-col items-center gap-2",
            "data-testid": "clipboard",
            onClick: r
          }, [t.createVNode(t.unref(bo)), o[0] || (o[0] = t.createElementVNode("span", {
            "class": "typo-meta-1"
          }, "Link kopieren", -1))]);
        };
      }
    }),
    Co = {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    };
  function yo(i, e) {
    return t.openBlock(), t.createElementBlock("svg", Co, e[0] || (e[0] = [t.createElementVNode("rect", {
      x: "1",
      y: "4",
      width: "22",
      height: "16",
      rx: "1",
      stroke: "black",
      "stroke-width": "2"
    }, null, -1), t.createElementVNode("path", {
      d: "M1 7L10.8236 14.1445C11.525 14.6545 12.475 14.6545 13.1763 14.1445L23 7",
      stroke: "black",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }, null, -1)]));
  }
  var Eo = {
      render: yo
    },
    xo = ["href"],
    ko = t.defineComponent({
      __name: "ShareToEmail",
      props: {
        url: {},
        text: {}
      },
      emits: ["buttonClicked"],
      setup: function setup(i, _ref44) {
        var e = _ref44.emit;
        var s = i,
          n = e,
          r = t.computed(function () {
            var a = "Artikel auf VOL.AT lesen: ".concat(s.url);
            return "mailto:?subject=".concat(s.text, "&body=").concat(a);
          });
        return function (a, o) {
          return t.openBlock(), t.createElementBlock("a", {
            href: r.value,
            "class": "flex flex-col items-center gap-2",
            "data-testid": "email",
            onClick: o[0] || (o[0] = function (c) {
              return n("buttonClicked", "email");
            })
          }, [t.createVNode(t.unref(Eo)), o[1] || (o[1] = t.createElementVNode("span", {
            "class": "text-center typo-meta-1"
          }, "Per Email teilen", -1))], 8, xo);
        };
      }
    }),
    So = {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    };
  function Mo(i, e) {
    return t.openBlock(), t.createElementBlock("svg", So, e[0] || (e[0] = [t.createElementVNode("path", {
      d: "M23.9995 11.9998C23.9995 5.37253 18.627 0 11.9998 0C5.37253 0 0 5.37253 0 11.9998C0 17.6272 3.87448 22.3493 9.1011 23.6462V15.6669H6.62675V11.9998H9.1011V10.4196C9.1011 6.33539 10.9495 4.44231 14.9594 4.44231C15.7197 4.44231 17.0315 4.59159 17.5681 4.74039V8.06432C17.2849 8.03456 16.7929 8.01968 16.1819 8.01968C14.2144 8.01968 13.4541 8.7651 13.4541 10.7028V11.9998H17.3737L16.7003 15.6669H13.4541V23.9117C19.3959 23.1941 24 18.135 24 11.9998H23.9995Z",
      fill: "black"
    }, null, -1), t.createElementVNode("path", {
      d: "M16.7025 15.6674L17.3759 12.0003H13.4563V10.7034C13.4563 8.76566 14.2166 8.02024 16.1841 8.02024C16.7951 8.02024 17.2871 8.03512 17.5703 8.06488V4.74095C17.0337 4.59167 15.7218 4.44287 14.9615 4.44287C10.9517 4.44287 9.10326 6.33595 9.10326 10.4202V12.0003H6.62891V15.6674H9.10326V23.6468C10.0316 23.8772 11.0026 24.0001 12.0019 24.0001C12.4939 24.0001 12.9792 23.9698 13.4558 23.9122V15.6674H16.702H16.7025Z",
      fill: "white"
    }, null, -1)]));
  }
  var Vo = {
      render: Mo
    },
    To = t.defineComponent({
      __name: "ShareToFacebook",
      props: {
        url: {},
        text: {}
      },
      emits: ["buttonClicked"],
      setup: function setup(i, _ref45) {
        var e = _ref45.emit;
        var s = i,
          n = e;
        function r() {
          var a;
          if (typeof ((a = window.FB) == null ? void 0 : a.ui) != "function") {
            n("buttonClicked", "facebook");
            return;
          }
          window.FB.ui({
            method: "share",
            mobile_iframe: !0,
            href: s.url
          }), n("buttonClicked", "facebook");
        }
        return function (a, o) {
          return t.openBlock(), t.createElementBlock("button", {
            title: "Facebook",
            type: "button",
            "class": "flex flex-col items-center gap-2",
            "data-testid": "facebook",
            onClick: r
          }, [t.createVNode(t.unref(Vo)), o[0] || (o[0] = t.createElementVNode("span", {
            "class": "typo-meta-1"
          }, "Auf Facebook teilen", -1))]);
        };
      }
    }),
    Lo = {
      width: "25",
      height: "24",
      viewBox: "0 0 25 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    };
  function Ho(i, e) {
    return t.openBlock(), t.createElementBlock("svg", Lo, e[0] || (e[0] = [t.createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M20.558 3.48773C18.3019 1.23984 15.3014 0.00126346 12.1048 0C5.5182 0 0.15752 5.33464 0.154884 11.8918C0.154006 13.9878 0.704291 16.0338 1.74996 17.8373L0.0546875 24L6.38951 22.3463C8.13487 23.2937 10.1 23.793 12.1 23.7938H12.1049C18.6909 23.7938 24.052 18.4585 24.0547 11.9013C24.056 8.72359 22.8142 5.73561 20.558 3.48773ZM12.1049 21.7852H12.1009C10.3187 21.7845 8.57061 21.308 7.04569 20.4074L6.68298 20.1932L2.92385 21.1746L3.92725 17.527L3.69106 17.153C2.69684 15.5792 2.17171 13.7602 2.17249 11.8925C2.17467 6.4425 6.63029 2.00857 12.1089 2.00857C14.7617 2.00958 17.2555 3.0391 19.1308 4.90746C21.006 6.77583 22.0381 9.25933 22.0371 11.9005C22.0348 17.3509 17.5793 21.7852 12.1049 21.7852ZM17.553 14.3822C17.2543 14.2334 15.7864 13.5145 15.5127 13.4154C15.239 13.3162 15.04 13.2666 14.8409 13.5641C14.6418 13.8616 14.0696 14.5309 13.8954 14.7292C13.7213 14.9276 13.5471 14.9524 13.2485 14.8036C12.9499 14.6549 11.9878 14.3411 10.8473 13.3287C9.95976 12.5409 9.36047 11.5677 9.1863 11.2702C9.01214 10.9727 9.16779 10.8119 9.31725 10.6637C9.45155 10.5306 9.61583 10.3167 9.76513 10.1431C9.9144 9.96962 9.96416 9.84567 10.0637 9.64738C10.1632 9.44905 10.1135 9.2755 10.0388 9.12677C9.96416 8.97803 9.36704 7.5154 9.11819 6.92044C8.87585 6.341 8.62967 6.4194 8.44639 6.41033C8.27243 6.40171 8.07317 6.39987 7.87414 6.39987C7.67508 6.39987 7.35162 6.47425 7.07791 6.77171C6.80423 7.06921 6.03292 7.78812 6.03292 9.25072C6.03292 10.7133 7.1028 12.1263 7.2521 12.3246C7.40137 12.523 9.35754 15.5245 12.3528 16.8116C13.0652 17.1178 13.6213 17.3006 14.0549 17.4376C14.7703 17.6637 15.4212 17.6318 15.9356 17.5553C16.5093 17.47 17.7022 16.8364 17.951 16.1423C18.1999 15.4482 18.1999 14.8532 18.1252 14.7293C18.0506 14.6053 17.8515 14.5309 17.553 14.3822Z",
      fill: "black"
    }, null, -1)]));
  }
  var Bo = {
      render: Ho
    },
    zo = t.defineComponent({
      __name: "ShareToWhatsapp",
      props: {
        url: {},
        text: {}
      },
      emits: ["buttonClicked"],
      setup: function setup(i, _ref46) {
        var e = _ref46.emit;
        var s = i,
          n = e,
          r = t.computed(function () {
            return encodeURI(s.url);
          }),
          a = t.computed(function () {
            return encodeURI(s.text);
          });
        function o() {
          var c = "https://web.whatsapp.com/send?text=".concat(a.value, " - ").concat(r.value);
          /android|iPad|iPhone|iPod/i.test(navigator.userAgent) && (c = "whatsapp://send?text=".concat(a.value, " - ").concat(r.value)), window.open(c, "_blank", "width=650,height=400"), n("buttonClicked", "facebook");
        }
        return function (c, l) {
          return t.openBlock(), t.createElementBlock("button", {
            title: "Whatsapp",
            type: "button",
            "class": "flex flex-col items-center gap-2",
            "data-testid": "whatsapp",
            onClick: o
          }, [t.createVNode(t.unref(Bo)), l[0] || (l[0] = t.createElementVNode("span", {
            "class": "typo-meta-1"
          }, "Auf WhatsApp teilen", -1))]);
        };
      }
    }),
    Po = {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    };
  function _o(i, e) {
    return t.openBlock(), t.createElementBlock("svg", Po, e[0] || (e[0] = [t.createElementVNode("path", {
      d: "M17.7512 3H20.818L14.1179 10.6246L22 21H15.8284L10.9946 14.7074L5.46359 21H2.39494L9.5613 12.8446L2 3H8.32828L12.6976 8.75169L17.7512 3ZM16.6748 19.1723H18.3742L7.4049 4.73169H5.58133L16.6748 19.1723Z",
      fill: "black"
    }, null, -1)]));
  }
  var $o = {
      render: _o
    },
    No = t.defineComponent({
      __name: "ShareToX",
      props: {
        url: {},
        text: {}
      },
      emits: ["buttonClicked"],
      setup: function setup(i, _ref47) {
        var e = _ref47.emit;
        var s = i,
          n = e,
          r = t.computed(function () {
            return encodeURI(s.url);
          }),
          a = t.computed(function () {
            return encodeURI(s.text);
          });
        function o() {
          window.open("https://twitter.com/intent/tweet?text=".concat(a.value, "&url=").concat(r.value), "_blank", "width=500,height=400"), n("buttonClicked", "facebook");
        }
        return function (c, l) {
          return t.openBlock(), t.createElementBlock("button", {
            title: "X",
            type: "button",
            "class": "flex flex-col items-center gap-2",
            "data-testid": "x",
            onClick: o
          }, [t.createVNode(t.unref($o)), l[0] || (l[0] = t.createElementVNode("span", {
            "class": "typo-meta-1"
          }, "Auf X teilen", -1))]);
        };
      }
    }),
    Io = {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    };
  function Ao(i, e) {
    return t.openBlock(), t.createElementBlock("svg", Io, e[0] || (e[0] = [t.createElementVNode("path", {
      d: "M18 10L12.7071 4.70711C12.3166 4.31658 11.6834 4.31658 11.2929 4.70711L6 10",
      stroke: "black",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }, null, -1), t.createElementVNode("path", {
      d: "M4 16V19C4 19.5523 4.44772 20 5 20H19C19.5523 20 20 19.5523 20 19V16",
      stroke: "black",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }, null, -1), t.createElementVNode("path", {
      d: "M12 5L12 15",
      stroke: "black",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }, null, -1)]));
  }
  var Do = {
      render: Ao
    },
    Oo = t.defineComponent({
      __name: "UniversalShare",
      props: {
        url: {},
        text: {}
      },
      emits: ["buttonClicked"],
      setup: function setup(i, _ref48) {
        var e = _ref48.emit;
        var s = i,
          n = e;
        function r() {
          try {
            navigator.share({
              url: s.url,
              text: s.text
            }), n("buttonClicked", "share");
          } catch (_unused7) {}
        }
        return function (a, o) {
          return t.openBlock(), t.createElementBlock("button", {
            title: "Teilen",
            type: "button",
            "class": "flex flex-col items-center gap-2",
            "data-testid": "universal",
            onClick: r
          }, [t.createVNode(t.unref(Do)), o[0] || (o[0] = t.createElementVNode("span", {
            "class": "typo-meta-1"
          }, "Teilen", -1))]);
        };
      }
    }),
    Fo = t.defineComponent({
      __name: "SocialBookmarks",
      props: {
        url: {
          "default": ""
        },
        text: {
          "default": ""
        },
        bookmarks: {
          "default": function _default() {
            return ["clipboard", "universal", "email", "facebook", "x", "whatsapp"];
          }
        },
        useNativeSharing: {
          type: Boolean,
          "default": !0
        }
      },
      setup: function setup(i) {
        var e = i,
          s = {
            clipboard: vo,
            email: ko,
            facebook: To,
            x: No,
            whatsapp: zo,
            universal: Oo
          },
          n = t.computed(function () {
            return !e.useNativeSharing || !navigator.share;
          }),
          r = t.computed(function () {
            return e.bookmarks.map(function (a) {
              return n.value && a !== "universal" ? {
                component: s[a] || null
              } : !n.value && (a === "clipboard" || a === "universal") ? {
                component: s[a] || null
              } : null;
            }).filter(function (a) {
              return a !== null;
            });
          });
        return function (a, o) {
          return t.openBlock(), t.createElementBlock("ul", {
            "class": t.normalizeClass(["flex gap-10 md:flex-row", {
              "flex-col": n.value
            }]),
            "data-testid": "social-bookmarks"
          }, [(t.openBlock(!0), t.createElementBlock(t.Fragment, null, t.renderList(r.value, function (c, l) {
            return t.openBlock(), t.createElementBlock("li", {
              key: l,
              "class": "flex flex-col items-center cursor-pointer"
            }, [(t.openBlock(), t.createBlock(t.resolveDynamicComponent(c.component), t.mergeProps({
              url: a.url,
              text: a.text,
              ref_for: !0
            }, a.$attrs), null, 16, ["url", "text"]))]);
          }), 128))], 2);
        };
      }
    }),
    Zo = {
      "class": "flex flex-col items-center gap-12 pb-8 md:pb-6"
    },
    Ro = {
      "class": "flex items-center w-full pb-4 border-b-2 border-grau-500"
    },
    jo = t.defineComponent({
      __name: "SocialBookmarksModal",
      props: {
        url: {
          "default": ""
        },
        text: {
          "default": ""
        },
        clipboardTransition: {
          type: Boolean
        },
        bookmarks: {
          "default": function _default() {
            return ["clipboard", "universal", "email", "facebook", "x", "whatsapp"];
          }
        },
        useNativeSharing: {
          type: Boolean,
          "default": !0
        }
      },
      emits: ["close"],
      setup: function setup(i, _ref49) {
        var e = _ref49.emit;
        var s = e;
        return function (n, r) {
          return t.openBlock(), t.createBlock(Ve, {
            "class": "z-[5000101]",
            "data-testid": "gift-article-status-modal",
            onClick: r[1] || (r[1] = t.withModifiers(function (a) {
              return s("close");
            }, ["self"]))
          }, {
            "default": t.withCtx(function () {
              return [t.createVNode(Me, {
                "class": "relative overflow-hidden md:w-auto md:min-w-96"
              }, {
                "default": t.withCtx(function () {
                  return [t.createElementVNode("section", Zo, [t.createElementVNode("div", Ro, [r[2] || (r[2] = t.createElementVNode("h1", {
                    "class": "ml-4 text-center grow typo-artikel-section-2"
                  }, " Artikel Teilen ", -1)), t.createVNode(t.unref(ho), {
                    "class": "w-4 h-4 cursor-pointer",
                    onClick: r[0] || (r[0] = function (a) {
                      return s("close");
                    })
                  })]), t.createVNode(Fo, t.mergeProps({
                    url: n.url,
                    text: n.text,
                    "use-native-sharing": n.useNativeSharing
                  }, n.$attrs), null, 16, ["url", "text", "use-native-sharing"])])];
                }),
                _: 1
              })];
            }),
            _: 1
          });
        };
      }
    }),
    Wo = {
      width: "14",
      height: "14",
      viewBox: "0 0 14 14",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    };
  function Go(i, e) {
    return t.openBlock(), t.createElementBlock("svg", Wo, e[0] || (e[0] = [t.createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M11.9996 0H1.99923C0.900211 0 0 0.901611 0 2.00063V7.9997C0 9.10011 0.900211 10.0003 1.99923 10.0003H9.99893L11.9996 11.9996L14.0002 14.0002V7.9997V4.99946V2.00063C14.0002 0.901611 13.0986 0 11.9996 0Z",
      fill: "currentColor"
    }, null, -1)]));
  }
  var Yo = {
      render: Go
    },
    Xo = {
      width: "17",
      height: "14",
      viewBox: "0 0 17 14",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    };
  function Uo(i, e) {
    return t.openBlock(), t.createElementBlock("svg", Xo, e[0] || (e[0] = [t.createElementVNode("rect", {
      x: "0.499268",
      y: "-0.000244141",
      width: "16",
      height: "14",
      rx: "2.28571",
      fill: "black"
    }, null, -1), t.createElementVNode("path", {
      d: "M7.49902 3.99988L3.49902 10.9999H11.499L7.49902 3.99988Z",
      fill: "white"
    }, null, -1), t.createElementVNode("circle", {
      cx: "11.999",
      cy: "4.49988",
      r: "1.5",
      fill: "white"
    }, null, -1)]));
  }
  var qo = {
      render: Uo
    },
    Ko = {
      width: "17",
      height: "14",
      viewBox: "0 0 17 14",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    };
  function Jo(i, e) {
    return t.openBlock(), t.createElementBlock("svg", Ko, e[0] || (e[0] = [t.createElementVNode("rect", {
      x: "0.499268",
      y: "-0.000244141",
      width: "16",
      height: "14",
      rx: "2.28571",
      fill: "white"
    }, null, -1), t.createElementVNode("path", {
      d: "M7.49902 3.99988L3.49902 10.9999H11.499L7.49902 3.99988Z",
      fill: "black"
    }, null, -1), t.createElementVNode("circle", {
      cx: "11.999",
      cy: "4.49988",
      r: "1.5",
      fill: "black"
    }, null, -1)]));
  }
  var Qo = {
      render: Jo
    },
    e1 = ["href"],
    t1 = ["innerHTML"],
    i1 = t.defineComponent({
      __name: "InformantButton",
      props: {
        link: {},
        text: {}
      },
      setup: function setup(i) {
        return function (e, s) {
          return t.openBlock(), t.createElementBlock("a", {
            href: e.link,
            "class": "block rounded-lg mt-2.5 p-2.5 bg-main-600 leading-4"
          }, [t.createElementVNode("span", {
            innerHTML: e.text
          }, null, 8, t1)], 8, e1);
        };
      }
    }),
    s1 = ["href"],
    n1 = {
      key: 0,
      "class": "flex items-center gap-1"
    },
    r1 = {
      key: 1,
      "class": "flex items-center gap-1"
    },
    a1 = {
      key: 0
    },
    Xi = fe(t.defineComponent({
      __name: "ArticleInfo",
      props: {
        title: {},
        link: {},
        commentCount: {},
        pictureCount: {},
        date: {},
        color: {
          "default": "BLACK"
        },
        titleSize: {
          "default": "M"
        },
        showPictureCount: {
          type: Boolean,
          "default": !0
        },
        titleUnderline: {
          type: Boolean,
          "default": !1
        },
        informantButton: {}
      },
      setup: function setup(i) {
        var e = i,
          s = {
            XL: "typo-teaser-1",
            L: "typo-teaser-2",
            M: "typo-teaser-3",
            S: "typo-teaser-4",
            XS: "typo-teaser-5"
          },
          n = t.computed(function () {
            return s[e.titleSize];
          });
        return function (r, a) {
          return t.openBlock(), t.createElementBlock("div", {
            "data-testid": "article-info",
            "class": t.normalizeClass(["flex flex-col", r.titleSize === "S" || r.titleSize === "XS" ? "gap-2" : "gap-4"])
          }, [t.createElementVNode("h2", {
            "class": t.normalizeClass(["pb-1 line-clamp-4 overflow-ellipsis", [n.value, {
              "text-white": r.color === "WHITE"
            }]])
          }, [t.createElementVNode("a", {
            href: r.link,
            "class": t.normalizeClass({
              "yellow-underline": r.color === "BLACK" && r.titleUnderline
            })
          }, t.toDisplayString(r.title), 11, s1)], 2), t.renderSlot(r.$slots, "default", {}, void 0, !0), t.createElementVNode("div", {
            "class": t.normalizeClass(["flex items-center gap-4 leading-none typo-meta-3-bold", {
              "text-white": r.color === "WHITE",
              "hidden md:flex": r.titleSize === "S" || r.titleSize === "XS"
            }])
          }, [r.commentCount && r.commentCount > 0 ? (t.openBlock(), t.createElementBlock("span", n1, [t.createVNode(t.unref(Yo)), t.createTextVNode(" " + t.toDisplayString(r.commentCount === 1 ? "".concat(r.commentCount, " Kommentar") : "".concat(r.commentCount, " Kommentare")), 1)])) : t.createCommentVNode("", !0), r.showPictureCount && r.pictureCount && r.pictureCount > 1 ? (t.openBlock(), t.createElementBlock("span", r1, [r.color === "WHITE" ? (t.openBlock(), t.createBlock(t.unref(Qo), {
            key: 0
          })) : (t.openBlock(), t.createBlock(t.unref(qo), {
            key: 1
          })), t.createTextVNode(" " + t.toDisplayString(r.pictureCount) + " Bilder ", 1)])) : t.createCommentVNode("", !0), t.createElementVNode("span", null, t.toDisplayString(r.date), 1)], 2), r.informantButton ? (t.openBlock(), t.createElementBlock("div", a1, [t.createVNode(i1, {
            link: r.informantButton.link,
            text: r.informantButton.text
          }, null, 8, ["link", "text"])])) : t.createCommentVNode("", !0)], 2);
        };
      }
    }), [["__scopeId", "data-v-a195c3d3"]]),
    l1 = {
      "data-testid": "media-tag",
      "class": "flex gap-1"
    },
    o1 = {
      key: 1,
      "class": "flex items-center h-6 px-2 text-white uppercase rounded bg-black/70 typo-label-vplus"
    },
    lt = t.defineComponent({
      __name: "MediaTag",
      props: {
        isVplus: {
          type: Boolean
        },
        brand: {}
      },
      setup: function setup(i) {
        return function (e, s) {
          return t.openBlock(), t.createElementBlock("div", l1, [e.isVplus ? (t.openBlock(), t.createBlock(t.unref(ft), {
            key: 0,
            "class": "text-rot-600"
          })) : t.createCommentVNode("", !0), e.brand && e.isVplus ? (t.openBlock(), t.createElementBlock("span", o1, t.toDisplayString(e.brand), 1)) : t.createCommentVNode("", !0)]);
        };
      }
    }),
    c1 = {
      "data-testid": "xsmall-teaser",
      "class": "flex gap-4"
    },
    d1 = {
      "class": "flex flex-col flex-1 gap-3"
    },
    p1 = {
      "class": "typo-teaser-5 line-clamp-3 overflow-ellipsis"
    },
    f1 = ["href"],
    u1 = {
      "class": "relative flex-1"
    },
    m1 = ["href"],
    h1 = {
      key: 0,
      "class": "absolute top-2 left-2"
    },
    Ui = t.defineComponent({
      __name: "XSmallTeaser",
      props: {
        post: {},
        labelColor: {}
      },
      setup: function setup(i) {
        return function (e, s) {
          var n, r, a, o;
          return t.openBlock(), t.createElementBlock("article", c1, [t.createElementVNode("div", d1, [(n = e.post.label) != null && n.text ? (t.openBlock(), t.createBlock(Re, {
            key: 0,
            href: (r = e.post.label) == null ? void 0 : r.link,
            color: e.labelColor
          }, {
            "default": t.withCtx(function () {
              return [t.createTextVNode(t.toDisplayString(e.post.label.text), 1)];
            }),
            _: 1
          }, 8, ["href", "color"])) : t.createCommentVNode("", !0), t.createElementVNode("h2", p1, [t.createElementVNode("a", {
            href: e.post.link
          }, t.toDisplayString(e.post.title), 9, f1)])]), t.createElementVNode("div", u1, [(a = e.post.image) != null && a.img ? (t.openBlock(), t.createElementBlock(t.Fragment, {
            key: 0
          }, [t.createElementVNode("a", {
            href: e.post.link
          }, [t.createVNode(je, {
            picture: e.post.image
          }, null, 8, ["picture"])], 8, m1), (o = e.post.image) != null && o.img ? (t.openBlock(), t.createElementBlock("div", h1, [t.createVNode(lt, {
            "is-vplus": e.post.isVplus,
            brand: e.post.brand || ""
          }, null, 8, ["is-vplus", "brand"])])) : t.createCommentVNode("", !0)], 64)) : t.createCommentVNode("", !0)])]);
        };
      }
    }),
    g1 = {
      "data-testid": "large-teaser"
    },
    w1 = {
      "class": "relative"
    },
    b1 = ["href"],
    v1 = {
      "class": "absolute top-4 left-4"
    },
    C1 = {
      key: 0,
      "class": "flex flex-col gap-5 mt-10 md:grid md:grid-cols-2"
    },
    y1 = t.defineComponent({
      __name: "LargeTeaser",
      props: {
        post: {},
        withBoldText: {
          type: Boolean
        }
      },
      setup: function setup(i) {
        var _ref50;
        var n, r;
        var s = ((_ref50 = (r = (n = i.post) == null ? void 0 : n.associated) == null ? void 0 : r.length) !== null && _ref50 !== void 0 ? _ref50 : 0) > 0;
        return function (a, o) {
          var _a$post$formatted_dat;
          var c, l;
          return t.openBlock(), t.createElementBlock("article", g1, [t.createElementVNode("div", w1, [t.createElementVNode("a", {
            href: a.post.link
          }, [t.createVNode(je, {
            picture: a.post.image,
            "additional-class": s ? "associated-teaser-rounded-reset" : "teaser-picture-rounded-reset"
          }, null, 8, ["picture", "additional-class"])], 8, b1), t.createElementVNode("div", v1, [t.createVNode(lt, {
            "is-vplus": a.post.isVplus,
            brand: a.post.brand || ""
          }, null, 8, ["is-vplus", "brand"])]), (c = a.post.label) != null && c.text ? (t.openBlock(), t.createBlock(Re, {
            key: 0,
            "class": "absolute -bottom-3 left-4",
            href: (l = a.post.label) == null ? void 0 : l.link,
            color: s ? "WHITE" : "YELLOW"
          }, {
            "default": t.withCtx(function () {
              return [t.createTextVNode(t.toDisplayString(a.post.label.text), 1)];
            }),
            _: 1
          }, 8, ["href", "color"])) : t.createCommentVNode("", !0)]), t.createElementVNode("div", {
            "class": t.normalizeClass(["px-4 md:px-0 pt-7 md:rounded-b", {
              "bg-main-600 pb-4 md:px-4": s
            }])
          }, [t.createVNode(Xi, {
            title: a.post.title,
            link: a.post.link,
            "comment-count": a.post.commentCount,
            "picture-count": a.post.pictureCount,
            date: (_a$post$formatted_dat = a.post.formatted_date) !== null && _a$post$formatted_dat !== void 0 ? _a$post$formatted_dat : "",
            "title-size": a.withBoldText ? "XL" : "M",
            "informant-button": a.post.informantButton
          }, null, 8, ["title", "link", "comment-count", "picture-count", "date", "title-size", "informant-button"]), s ? (t.openBlock(), t.createElementBlock("div", C1, [(t.openBlock(!0), t.createElementBlock(t.Fragment, null, t.renderList(a.post.associated, function (d) {
            return t.openBlock(), t.createBlock(Ui, {
              key: d.id,
              post: d,
              "label-color": "WHITE"
            }, null, 8, ["post"]);
          }), 128))])) : t.createCommentVNode("", !0)], 2)]);
        };
      }
    }),
    E1 = {
      "class": "flex flex-row-reverse md:flex-col",
      "data-testid": "small-teaser"
    },
    x1 = {
      "class": "relative flex-1 mb-6"
    },
    k1 = ["href"],
    S1 = {
      "class": "absolute top-4 left-4"
    },
    M1 = {
      "class": "flex flex-col flex-1 gap-3 mr-2 md:relative md:mr-0"
    },
    V1 = t.defineComponent({
      __name: "SmallTeaser",
      props: {
        post: {}
      },
      setup: function setup(i) {
        return function (e, s) {
          var _e$post$formatted_dat;
          var n, r;
          return t.openBlock(), t.createElementBlock("article", E1, [t.createElementVNode("div", x1, [t.createElementVNode("a", {
            href: e.post.link
          }, [t.createVNode(je, {
            picture: e.post.image,
            "additional-class": "teaser-picture-rounded-reset"
          }, null, 8, ["picture"])], 8, k1), t.createElementVNode("div", S1, [t.createVNode(lt, {
            "is-vplus": e.post.isVplus,
            brand: e.post.brand || ""
          }, null, 8, ["is-vplus", "brand"])])]), t.createElementVNode("div", M1, [(n = e.post.label) != null && n.text ? (t.openBlock(), t.createBlock(Re, {
            key: 0,
            "class": "md:absolute -top-10 left-4",
            href: (r = e.post.label) == null ? void 0 : r.link
          }, {
            "default": t.withCtx(function () {
              return [t.createTextVNode(t.toDisplayString(e.post.label.text), 1)];
            }),
            _: 1
          }, 8, ["href"])) : t.createCommentVNode("", !0), t.createVNode(Xi, {
            title: e.post.title,
            link: e.post.link,
            "comment-count": e.post.commentCount,
            "picture-count": e.post.pictureCount,
            "show-picture-count": !1,
            date: (_e$post$formatted_dat = e.post.formatted_date) !== null && _e$post$formatted_dat !== void 0 ? _e$post$formatted_dat : "",
            "title-size": "S",
            "informant-button": e.post.informantButton
          }, null, 8, ["title", "link", "comment-count", "picture-count", "date", "informant-button"])])]);
        };
      }
    }),
    Dt = t.defineComponent({
      __name: "UnderlineButton",
      props: {
        textColor: {},
        href: {},
        active: {
          type: Boolean
        }
      },
      emits: ["buttonClicked"],
      setup: function setup(i) {
        var e = i,
          s = {
            href: "border-b-main-600 hover:border-b-black",
            button: "border-b-transparent hover:border-b-main-600"
          },
          n = t.computed(function () {
            return e.active ? s.href : s[e.href ? "href" : "button"];
          });
        return function (r, a) {
          return t.openBlock(), t.createBlock(t.resolveDynamicComponent(r.href ? "a" : "button"), {
            "data-testid": "underline-button",
            "class": t.normalizeClass(["pb-2 border-b-4 typo-button-text w-fit", [r.textColor === "black" ? "text-text" : "text-white", n.value]]),
            href: r.href,
            onClick: a[0] || (a[0] = function (o) {
              return r.href ? null : r.$emit("buttonClicked");
            })
          }, {
            "default": t.withCtx(function () {
              return [t.renderSlot(r.$slots, "default")];
            }),
            _: 3
          }, 8, ["class", "href"]);
        };
      }
    }),
    T1 = t.defineComponent({
      __name: "UserImage",
      props: {
        userName: {}
      },
      setup: function setup(i) {
        var e = i,
          s = t.computed(function () {
            var _ref51;
            var c, l;
            return (_ref51 = (l = (c = e.userName) == null ? void 0 : c[0]) == null ? void 0 : l.toUpperCase()) !== null && _ref51 !== void 0 ? _ref51 : "";
          }),
          n = {
            0: {
              background: "#FFBDE5",
              foreground: "#FF2424"
            },
            1: {
              background: "#FF2424",
              foreground: "#FFBDE5"
            },
            2: {
              background: "#7C15FF",
              foreground: "#FFD200"
            },
            3: {
              background: "#FFD200",
              foreground: "#7C15FF"
            },
            4: {
              background: "#46FFC8",
              foreground: "#3624FF"
            },
            5: {
              background: "#3624FF",
              foreground: "#46FFC8"
            }
          },
          r = t.computed(function () {
            var l = (s.value.charCodeAt(0) - 64) % 6;
            return l < 0 || l > 5 ? n[0] : n[l];
          }),
          a = t.computed(function () {
            var c;
            return (c = r.value) == null ? void 0 : c.background;
          }),
          o = t.computed(function () {
            var c;
            return (c = r.value) == null ? void 0 : c.foreground;
          });
        return function (c, l) {
          return t.openBlock(), t.createElementBlock("div", {
            "data-testid": "user-image",
            "class": "flex items-center justify-center w-10 h-10 rounded-full",
            style: t.normalizeStyle("background:".concat(a.value))
          }, [t.createElementVNode("span", {
            "class": "mb-[4px] typo-artikel-sub",
            style: t.normalizeStyle("color:".concat(o.value))
          }, t.toDisplayString(s.value), 5)], 4);
        };
      }
    }),
    L1 = {
      "class": "snow-report-entry bg-grau-500"
    },
    H1 = {
      "class": "pl-2 rounded-l",
      colspan: "2"
    },
    B1 = {
      "class": "flex gap-2"
    },
    z1 = {
      "class": "rounded-r"
    },
    P1 = t.defineComponent({
      __name: "SnowReportEntry",
      props: {
        item: {}
      },
      setup: function setup(i) {
        var e = i,
          s = e.item.depths.base > 0 ? "".concat(e.item.depths.base, "cm") : "-",
          n = e.item.depths.top > 0 ? "".concat(e.item.depths.top, "cm") : "-",
          r = e.item.openLifts > 0;
        return function (a, o) {
          return t.openBlock(), t.createElementBlock("tr", L1, [t.createElementVNode("td", H1, [t.createElementVNode("div", B1, [(t.openBlock(), t.createElementBlock("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            fill: "none",
            viewBox: "0 0 10 10",
            "class": t.normalizeClass(["w-2.5 min-w-2.5", {
              "text-green-500": r,
              "text-red-500": !r
            }])
          }, o[0] || (o[0] = [t.createElementVNode("circle", {
            cx: "5",
            cy: "5",
            r: "5",
            fill: "currentColor"
          }, null, -1)]), 2)), t.createTextVNode(" " + t.toDisplayString(a.item.resort), 1)])]), t.createElementVNode("td", null, t.toDisplayString(t.unref(s)), 1), t.createElementVNode("td", null, t.toDisplayString(t.unref(n)), 1), t.createElementVNode("td", z1, t.toDisplayString(a.item.openLifts) + "/" + t.toDisplayString(a.item.lifts), 1)]);
        };
      }
    }),
    _1 = {
      "class": "flex items-center justify-center gap-1"
    },
    Ot = t.defineComponent({
      __name: "SnowReportSortableEntry",
      props: {
        isCurrentlySorted: {
          type: Boolean
        }
      },
      emits: ["sortOrderUpdate"],
      setup: function setup(i, _ref52) {
        var e = _ref52.emit;
        var s = i,
          n = e,
          _ys = ys(["none", "ascending", "descending"]),
          r = _ys.state,
          a = _ys.next,
          o = _ys.go;
        function c() {
          var f = a();
          n("sortOrderUpdate", f);
        }
        t.watchEffect(function () {
          s.isCurrentlySorted || o(0);
        });
        var l = t.computed(function () {
            return s.isCurrentlySorted && r.value === "ascending";
          }),
          d = t.computed(function () {
            return s.isCurrentlySorted && r.value === "descending";
          });
        return function (f, h) {
          return t.openBlock(), t.createElementBlock("th", {
            "class": "cursor-pointer",
            onClick: h[0] || (h[0] = function () {
              return c();
            })
          }, [t.createElementVNode("div", _1, [t.createElementVNode("span", null, [(t.openBlock(), t.createElementBlock("svg", {
            "class": t.normalizeClass(["w-1.5", {
              "text-black": l.value,
              "text-black/60": d.value
            }]),
            xmlns: "http://www.w3.org/2000/svg",
            fill: "none",
            viewBox: "0 0 7 5"
          }, h[1] || (h[1] = [t.createElementVNode("path", {
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-width": "1.111",
            d: "M5.667 3.556 3.64 1.53a.278.278 0 0 0-.393 0L1.222 3.556"
          }, null, -1)]), 2)), (t.openBlock(), t.createElementBlock("svg", {
            "class": t.normalizeClass(["w-1.5 rotate-180", {
              "text-black": d.value,
              "text-black/60": l.value
            }]),
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 7 5"
          }, h[2] || (h[2] = [t.createElementVNode("path", {
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-width": "1.111",
            d: "M5.667 3.556 3.64 1.53a.278.278 0 0 0-.393 0L1.222 3.556"
          }, null, -1)]), 2))]), t.renderSlot(f.$slots, "default")])]);
        };
      }
    }),
    $1 = {
      "class": "p-4 bg-main-200"
    },
    N1 = {
      "class": "w-full text-xs border-separate table-fixed border-spacing-y-1 snow-report-widget"
    },
    I1 = t.defineComponent({
      __name: "SnowReportWidget",
      props: {
        items: {}
      },
      setup: function setup(i) {
        var e = i,
          s = t.ref("none"),
          n = t.ref("base"),
          r = t.computed(function () {
            return s.value === "none" ? e.items : e.items.slice().sort(function (o, c) {
              var l = 0,
                d = 0;
              return n.value === "lifts" ? (l = o.openLifts, d = c.openLifts) : (l = o.depths[n.value], d = c.depths[n.value]), s.value === "ascending" ? l - d : d - l;
            });
          });
        function a(o, c) {
          n.value = o, s.value = c;
        }
        return function (o, c) {
          return t.openBlock(), t.createElementBlock("div", $1, [t.createElementVNode("table", N1, [t.createElementVNode("thead", null, [t.createElementVNode("tr", null, [c[6] || (c[6] = t.createElementVNode("th", {
            "class": "text-left",
            colspan: "2"
          }, "Skigebiet", -1)), t.createVNode(Ot, {
            "is-currently-sorted": n.value === "base",
            onSortOrderUpdate: c[0] || (c[0] = function (l) {
              return a("base", l);
            })
          }, {
            "default": t.withCtx(function () {
              return c[3] || (c[3] = [t.createTextVNode(" Tal ")]);
            }),
            _: 1
          }, 8, ["is-currently-sorted"]), t.createVNode(Ot, {
            "is-currently-sorted": n.value === "top",
            onSortOrderUpdate: c[1] || (c[1] = function (l) {
              return a("top", l);
            })
          }, {
            "default": t.withCtx(function () {
              return c[4] || (c[4] = [t.createTextVNode(" Berg ")]);
            }),
            _: 1
          }, 8, ["is-currently-sorted"]), t.createVNode(Ot, {
            "is-currently-sorted": n.value === "lifts",
            onSortOrderUpdate: c[2] || (c[2] = function (l) {
              return a("lifts", l);
            })
          }, {
            "default": t.withCtx(function () {
              return c[5] || (c[5] = [t.createTextVNode(" offene Lifte ")]);
            }),
            _: 1
          }, 8, ["is-currently-sorted"])])]), t.createElementVNode("tbody", null, [(t.openBlock(!0), t.createElementBlock(t.Fragment, null, t.renderList(r.value, function (l) {
            return t.openBlock(), t.createBlock(P1, {
              key: l.resort,
              item: l
            }, null, 8, ["item"]);
          }), 128))])])]);
        };
      }
    }),
    A1 = {
      width: "24",
      height: "24",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 571.62 768"
    };
  function D1(i, e) {
    return t.openBlock(), t.createElementBlock("svg", A1, e[0] || (e[0] = [t.createElementVNode("path", {
      id: "GRW2025_svg__a",
      d: "M496.9 703.84a35.59 35.59 0 0 0-2.56-6.05 35.57 35.57 0 0 0-2.56-6.06c-1-3.23-2.64-6.36-4.05-8.66a48.18 48.18 0 0 0-3.99-7.38h-.14a48.39 48.39 0 0 0-1.79-3.37c.55-.1 1.17-.06 1.94.2-.08-1.8.23-3.23 1.02-4.15a23 23 0 0 1-3.17-3.6c.16-.87.14-1.9.6-2.45a23 23 0 0 1-3.16-3.6c.15-.87.14-1.9.6-2.45a23.04 23.04 0 0 1-3.16-3.61c.15-.87.14-1.9.6-2.44a22.98 22.98 0 0 1-3.16-3.61c.15-.87.13-1.9.6-2.44-.57-.53-.9-.97-1.34-1.45.52.2.97.47 1.4.76 4.8-8.4-2.37-11.75 3.06-19.72-2.46.12-3.45-1.26-4.13-2.93.33-.97.8-2 1.57-3.12-2.46.12-3.45-1.26-4.14-2.94.34-.97.8-1.98 1.58-3.1-2.46.1-3.45-1.27-4.14-2.95.33-.97.8-1.98 1.57-3.11-2.45.11-3.44-1.26-4.13-2.94.33-.97.8-1.99 1.57-3.11-2.67.12-3.66-1.44-4.35-3.33.33-.79.73-1.6 1.34-2.49a3.64 3.64 0 0 1-2.43-.8 5.54 5.54 0 0 0-1.7-2.72c-.1 0-.19.05-.3.05 0-.03-.03-.05-.04-.08.31-.67.61-1.34 1.13-2.1-.93.05-1.42-.35-2-.65-.4-1.22-.89-2.34-1.8-3.03-.24 0-.41.1-.65.1.3-.67.6-1.32 1.1-2.06-.92.05-1.4-.35-2-.65-.4-1.22-.88-2.34-1.8-3.03-.23-.01-.4.1-.64.1.3-.67.6-1.33 1.1-2.06-.93.04-1.41-.36-2-.66-.4-1.21-.88-2.34-1.8-3.03-.24 0-.4.1-.64.1.3-.66.6-1.32 1.1-2.05-.93.04-1.41-.36-2-.66-.4-1.22-.88-2.34-1.8-3.03-.24 0-.41.1-.64.1.3-.66.6-1.32 1.1-2.05-.93.04-1.42-.36-2-.66-.4-1.22-.89-2.34-1.8-3.03-.26-.01-.44.1-.7.1 0-.04-.03-.07-.05-.11.29-.59.52-1.15.96-1.79-.78.04-1.14-.34-1.68-.55-.4-1.32-.9-2.56-1.88-3.3-.36 0-.63.15-.99.15.29-.58.52-1.15.96-1.78-.78.03-1.14-.34-1.67-.55-.41-1.32-.9-2.56-1.88-3.3-.37-.01-.64.14-1 .15.28-.59.52-1.15.95-1.78-.77.03-1.13-.34-1.66-.55-.41-1.32-.9-2.57-1.88-3.3-.37-.02-.64.14-1 .15.28-.59.52-1.15.95-1.79h-.02c44.71-38.95 73.06-95.73 73.06-159.16 0-52.5-19.41-100.47-51.42-137.56.17-.12.32-.16.5-.3 0-1.23.1-2.4.24-3.52.96-.19 1.89-.59 3.08-1.47 0-1.22.1-2.39.24-3.51.96-.2 1.89-.6 3.08-1.47 0-1.22.1-2.39.24-3.51.96-.2 1.88-.6 3.07-1.47 0-1.22.1-2.4.25-3.52.95-.19 1.88-.59 3.07-1.46 0-1.23.1-2.4.24-3.52.96-.19 1.89-.59 3.08-1.47 0-1.22.1-2.39.24-3.51.96-.2 1.88-.6 3.08-1.47 0-1.22.09-2.4.24-3.51.95-.2 1.88-.6 3.07-1.47 0-1.23.1-2.4.24-3.52.96-.19 1.89-.59 3.08-1.47 0-1.22.1-2.39.24-3.51.96-.2 1.89-.6 3.08-1.47 0-9.91 5.99-16.32-1.02-22.81 10.18-20.4.87-51.15-5.1-73.66 12.68-15.65-17.53-32.15-23.96-14.74a11.66 11.66 0 0 0-3.32 4.99 11.66 11.66 0 0 0-3.31 4.98 11.66 11.66 0 0 0-3.32 4.98 11.66 11.66 0 0 0-3.32 4.99 11.66 11.66 0 0 0-3.32 4.98 11.66 11.66 0 0 0-3.32 4.98 11.65 11.65 0 0 0-3.31 4.99 11.65 11.65 0 0 0-3.32 4.98 11.65 11.65 0 0 0-3.32 4.98 11.65 11.65 0 0 0-3.32 4.99 11.2 11.2 0 0 0-2.91 3.96 10.85 10.85 0 0 0-3.76 4.58 10.85 10.85 0 0 0-3.8 4.61 10.85 10.85 0 0 0-3.8 4.61 10.85 10.85 0 0 0-3.8 4.62 10.84 10.84 0 0 0-3.81 4.6 10.84 10.84 0 0 0-3.8 4.62 10.84 10.84 0 0 0-3.8 4.6 10.85 10.85 0 0 0-3.8 4.62 10.84 10.84 0 0 0-3.8 4.61 10.84 10.84 0 0 0-3.8 4.61c-.36.24-.7.5-1.04.8a217.3 217.3 0 0 0-89.53-19.35c-34.74 0-67.45 8.29-96.52 22.66-.24-.36-.37-.84-.72-1.1-.43-.01-.75.17-1.17.18l-.01-.04c.26-.51.45-1 .83-1.56-.67.04-.97-.32-1.46-.48-.42-1.39-.9-2.7-1.93-3.48-.44 0-.76.18-1.18.18v-.03c.26-.52.45-1 .83-1.56-.68.03-.98-.32-1.46-.48-.42-1.39-.91-2.7-1.94-3.48-.43-.01-.75.17-1.17.18l-.01-.04c.26-.51.45-1 .83-1.56-.67.03-.97-.32-1.46-.48-.42-1.39-.9-2.7-1.93-3.48-.44-.01-.76.17-1.18.18l-.01-.03c.26-.52.46-1 .84-1.56-.68.03-.98-.33-1.47-.48-.42-1.4-.9-2.7-1.93-3.48-.43-.02-.75.17-1.17.18l-.02-.04c.27-.51.46-1 .84-1.56-.68.03-.97-.32-1.46-.48-.42-1.39-.91-2.7-1.94-3.48-.43-.01-.75.17-1.17.18l-.01-.03c.26-.52.45-1 .83-1.56-.67.03-.97-.33-1.46-.48-.42-1.4-.9-2.7-1.93-3.48-.44-.02-.76.17-1.18.18v-.04c.26-.51.45-1 .83-1.56-.68.03-.97-.32-1.46-.48-.42-1.39-.91-2.7-1.94-3.48-.43-.01-.75.17-1.17.18l-.01-.04c.26-.51.45-1 .83-1.56-.67.04-.97-.32-1.46-.48-.42-1.38-.9-2.7-1.93-3.47-.44-.02-.76.17-1.18.18l-.01-.04c.26-.52.46-1 .84-1.56-.68.03-.98-.32-1.47-.48-.41-1.39-.9-2.7-1.93-3.48-.43-.01-.75.17-1.18.18v-.04c.26-.51.45-1 .83-1.56-.68.04-.97-.32-1.46-.48-.42-1.38-.91-2.7-1.94-3.47-.43-.02-.75.17-1.17.18l-.01-.04c.26-.52.45-1 .83-1.56-.67.03-.97-.32-1.46-.48-.42-1.39-.9-2.7-1.93-3.48-.43-.01-.75.17-1.16.18.27-.54.47-1.06.87-1.64-.71.03-1.04-.33-1.55-.51-.41-1.36-.9-2.65-1.9-3.4-.32-.02-.55.12-.86.12.3-.6.55-1.2 1.01-1.88-.95.04-1.46-.36-2.05-.68-.4-1.2-.88-2.3-1.79-2.98-.21-.01-.37.09-.58.08.3-.67.61-1.34 1.12-2.09-.95.04-1.46-.36-2.05-.68-.4-1.2-.88-2.3-1.79-2.98-.21-.01-.37.09-.58.08.3-.67.61-1.34 1.12-2.09-.95.04-1.46-.36-2.06-.67a6 6 0 0 0-1.7-2.88c.32-.78.72-1.58 1.32-2.46a3.64 3.64 0 0 1-3.41-1.6c.22-1.46.75-3.02 1.99-4.83a3.64 3.64 0 0 1-3.4-1.6c.21-1.46.74-3.02 1.98-4.83a3.64 3.64 0 0 1-3.4-1.6c.21-1.46.75-3.02 1.99-4.83-5.72.26-4.02-6.98-7.15-9.34-11.6-.37-18.73 7.7-20.38 17.64 1.11.9 1.74 1.93 2.54 2.91-.37 1.18-.92 2.27-1.12 3.52 1.1.9 1.74 1.93 2.54 2.91-.38 1.18-.92 2.27-1.13 3.52 1.12.9 1.75 1.93 2.55 2.91-.38 1.18-.92 2.27-1.13 3.52 1.4 1.12 2.28 2.4 3.2 3.66-.22.8-.62 1.52-.76 2.35a18.25 18.25 0 0 1 3.75 4.3c-.06.23-.18.44-.23.7a50.05 50.05 0 0 0-4.09 4.96 28.4 28.4 0 0 0 2.5 5.04c-.35.47-.74.9-1.08 1.39a28.26 28.26 0 0 0 2.5 5.04c-.35.47-.74.9-1.09 1.39a28.26 28.26 0 0 0 2.5 5.04c-.35.47-.73.9-1.08 1.39a28.5 28.5 0 0 0 2.78 5.59c-.11.14-.23.27-.33.42a28.7 28.7 0 0 0 4.38 7.86c.91 2.03 1.98 3.92 3.3 5.67.7 1.55 1.37 3.11 2.31 4.51-.49 2.7-.15 5.75 1.23 8.6 0 .4-.05.78-.03 1.18-9.38 3.58-8.59 8.9-6.35 15.43.06 1.98.63 4.13 1.42 6.43.06 1.98.63 4.13 1.42 6.43.12 4.18 2.66 9.12 4.14 14.64.18.1.36.12.54.2.67 1.86 1.36 3.79 1.9 5.82.35.16.67.21 1 .36-37.69 38.27-60.99 90.4-60.99 147.94a209.4 209.4 0 0 0 37.35 119.52 11.11 11.11 0 0 0-2.94 3.94 10.8 10.8 0 0 0-3.8 4.55 10.8 10.8 0 0 0-3.84 4.56 10.81 10.81 0 0 0-3.84 4.58 10.8 10.8 0 0 0-3.85 4.57 10.8 10.8 0 0 0-3.84 4.57 10.8 10.8 0 0 0-3.84 4.58 10.97 10.97 0 0 0-4.01 4.98c-1.68 1.2-3.04 3-3.95 5.45a11.62 11.62 0 0 0-3.33 4.97 11.62 11.62 0 0 0-3.33 4.98 11.62 11.62 0 0 0-3.33 4.97 11.62 11.62 0 0 0-3.33 4.98 11.62 11.62 0 0 0-3.33 4.98 12.01 12.01 0 0 0-3.83 6.24c2.37 5.88 11.52 4.87 13.24 11.41-6.75 7.3 1.72 16.96-.4 25.13-.75.69-1.32 1.4-2.38 2.06.33.4.63.7.95 1.05a13.8 13.8 0 0 1-4.28 3.92c2.6 3.27 4.68 4.7 8.15 3.11 2.96 8.36 4 19.95 7.56 31.26-1.08.58-2.1 1.4-3.2 2.15.4.81.64 1.64.77 2.45-1.43.5-2.69 1.57-4.1 2.52a8.87 8.87 0 0 1-1.02 9.34c2.53 1.35 4.23-3.03 5.1 0-5.8 4.19 3.01 10.5 2.03 16.6 3.97.82 5.29 1.07 8.15-1.04 0-1.22.1-2.39.24-3.5.96-.2 1.9-.6 3.09-1.48 0-1.22.1-2.38.24-3.5.96-.19 1.9-.59 3.09-1.47 0-1.22.1-2.39.24-3.5.96-.2 1.89-.6 3.09-1.48 0-1.22.1-2.38.24-3.5.96-.19 1.89-.59 3.09-1.47 0-1.22.09-2.39.24-3.5.96-.2 1.89-.6 3.08-1.48 0-1.22.1-2.38.24-3.5.97-.19 1.9-.59 3.1-1.47 0-1.1.09-2.14.2-3.15 1.1-.14 2.1-.58 3.45-1.57 0-1.03.1-2 .2-2.96 1.18-.1 2.22-.56 3.65-1.61 0-1.03.1-2 .2-2.96 1.17-.1 2.22-.57 3.64-1.62 0-1.03.1-2 .2-2.96 1.18-.1 2.22-.56 3.65-1.61 0-1.03.09-2 .2-2.96 1.17-.1 2.22-.56 3.64-1.61 0-1.03.1-2 .2-2.96 1.18-.1 2.22-.57 3.64-1.62 0-1.03.1-2 .2-2.96 1.18-.1 2.22-.57 3.64-1.62 0-1.04.1-2.02.2-2.99 1.17-.1 2.2-.56 3.62-1.6 0-1.04.1-2.03.2-3 1.17-.1 2.2-.56 3.62-1.6 0-1.04.1-2.02.2-2.99 1.17-.1 2.2-.56 3.62-1.6 0-1.04.1-2.03.2-3 1.17-.1 2.2-.56 3.62-1.6 0-1.04.1-2.02.2-2.99 1.17-.1 2.2-.57 3.62-1.6 0-1.05.09-2.03.2-3 1.16-.1 2.2-.56 3.61-1.6 0-1.04.1-2.02.2-2.99 1.17-.1 2.2-.57 3.62-1.6 0-1.05.1-2.03.2-3 1.17-.1 2.2-.56 3.62-1.6 0-1.04.1-2.02.2-3 1.17-.1 2.2-.56 3.62-1.6 0-1.04.1-2.02.2-2.99 1.17-.1 2.2-.56 3.62-1.6 0-1.04.1-2.03.2-3 1.17-.1 2.2-.56 3.62-1.6 0-1.04.1-2.02.2-2.99 1.16-.1 2.2-.57 3.61-1.6 0-.8.1-1.54.16-2.3a216.85 216.85 0 0 0 109.56 29.68c28.6 0 55.85-5.61 80.84-15.57.06.23.15.44.2.67.76.35 1.46.52 2.19.78.53 1.5 1.05 3.04 1.48 4.65.75.35 1.46.52 2.18.78.53 1.5 1.06 3.05 1.49 4.66.74.35 1.45.52 2.17.77.54 1.51 1.06 3.05 1.5 4.66.74.35 1.44.52 2.17.78.53 1.5 1.06 3.05 1.48 4.66.75.34 1.46.52 2.18.77.54 1.5 1.06 3.05 1.49 4.66.75.35 1.45.52 2.18.77.53 1.51 1.05 3.05 1.48 4.66.75.35 1.45.52 2.18.78.53 1.5 1.06 3.05 1.49 4.66.74.34 1.45.52 2.17.77.54 1.5 1.06 3.05 1.49 4.66.75.35 1.45.52 2.18.77.53 1.51 1.05 3.05 1.48 4.66.72.33 1.39.5 2.08.74.54 1.54 1.08 3.1 1.52 4.74.7.34 1.38.5 2.07.74.55 1.54 1.08 3.1 1.52 4.74.71.34 1.38.5 2.08.74.54 1.54 1.08 3.1 1.51 4.75.72.33 1.39.49 2.08.73.54 1.54 1.08 3.1 1.52 4.75.7.33 1.38.49 2.07.74.55 1.53 1.08 3.1 1.52 4.74.71.33 1.38.49 2.08.74.54 1.53 1.08 3.1 1.51 4.74.72.33 1.39.5 2.08.74.54 1.53 1.08 3.1 1.52 4.74.7.33 1.38.5 2.07.74.55 1.53 1.08 3.1 1.52 4.74.71.33 1.38.5 2.08.74.54 1.54 1.08 3.1 1.51 4.74.71.33 1.38.5 2.07.74a61.98 61.98 0 0 1 1.52 4.75c.6.28 1.15.4 1.72.61a63.7 63.7 0 0 1 1.62 5.03c.6.28 1.15.4 1.73.62a63.7 63.7 0 0 1 1.61 5.03c.6.27 1.15.4 1.73.61a63.7 63.7 0 0 1 1.62 5.03c.59.28 1.14.4 1.72.62a63.67 63.67 0 0 1 1.62 5.03c.59.27 1.15.4 1.72.6a63.7 63.7 0 0 1 1.62 5.04c.44.2.85.28 1.28.45.62 1.73 1.24 3.5 1.74 5.37.22.1.43.14.66.23a71.63 71.63 0 0 1 1.9 5.82c.23.1.44.14.66.23a71.66 71.66 0 0 1 1.9 5.82c.23.1.44.14.66.24a71.66 71.66 0 0 1 1.9 5.81c.23.1.44.14.67.24a72.05 72.05 0 0 1 1.9 5.81c11.69 5.45 20.6-.97 29.55-4.14 2.6-5.8-1.12-8.4-1.02-12.44 6.5-3.24 3.56-11.73.43-17.62a35.59 35.59 0 0 0-2.56-6.05Zm-96.2-209.46c-.7.03-1.02-.32-1.52-.5-.41-1.35-.9-2.63-1.9-3.38-.4-.01-.7.16-1.08.17l-.01-.02c.28-.56.49-1.08.9-1.68-.73.03-1.06-.34-1.57-.52-.42-1.35-.9-2.63-1.9-3.38-.4-.02-.7.15-1.09.16v-.02c.27-.55.49-1.08.9-1.68-.73.04-1.06-.33-1.58-.52-.4-1.35-.9-2.62-1.9-3.38-.4-.01-.7.16-1.08.17v-.02c.27-.55.49-1.08.9-1.68-.73.03-1.07-.34-1.58-.52-.41-1.35-.9-2.63-1.9-3.38-.4-.02-.7.16-1.08.16v-.02c.27-.55.48-1.08.9-1.68-.74.04-1.07-.33-1.58-.51-.41-1.36-.9-2.63-1.9-3.39-.4-.01-.7.16-1.09.17v-.02c.28-.55.49-1.08.9-1.68-.73.03-1.06-.33-1.57-.52-.42-1.35-.9-2.62-1.9-3.38-.4-.01-.7.16-1.09.16v-.02c.27-.55.49-1.08.9-1.67-.73.03-1.06-.34-1.58-.52-.4-1.35-.9-2.63-1.9-3.38-.4-.02-.7.15-1.08.16v-.02c.27-.55.48-1.08.9-1.68-.73.04-1.07-.33-1.58-.52-.41-1.35-.9-2.62-1.9-3.38-.4-.01-.7.16-1.08.17v-.02c.27-.55.48-1.08.89-1.68-.73.03-1.06-.34-1.57-.52-.42-1.35-.9-2.63-1.9-3.38-.4-.02-.7.16-1.09.16v-.02c.27-.55.49-1.08.9-1.68-.73.04-1.06-.33-1.57-.51-.42-1.36-.9-2.63-1.9-3.39-.4-.01-.7.16-1.09.17v-.02c.27-.55.49-1.08.9-1.68-.73.03-1.06-.33-1.58-.52-.41-1.35-.9-2.63-1.9-3.38-.4-.01-.7.16-1.08.16v-.02c.27-.55.48-1.08.9-1.67-.74.03-1.07-.34-1.58-.52-.41-1.35-.9-2.63-1.9-3.38-.4-.02-.7.15-1.08.16l-.01-.02c.28-.55.49-1.08.9-1.68-.73.04-1.06-.33-1.57-.52-.42-1.35-.9-2.62-1.9-3.38-.4-.01-.7.16-1.09.17v-.02c.27-.55.49-1.08.9-1.68-.73.03-1.06-.33-1.58-.52-.41-1.35-.9-2.63-1.9-3.38-.4-.02-.7.16-1.08.16V420c.27-.55.49-1.08.9-1.68-.73.04-1.07-.33-1.58-.51-.41-1.36-.9-2.63-1.9-3.39-.4-.01-.7.16-1.08.17v-.02c.27-.55.48-1.08.9-1.68-.74.03-1.07-.33-1.58-.52-.41-1.35-.9-2.62-1.9-3.38-.4-.01-.7.16-1.08.16l-.01-.02c.28-.55.49-1.08.9-1.67-.73.03-1.06-.34-1.57-.52-.42-1.35-.9-2.63-1.9-3.38-.4-.02-.7.15-1.09.16v-.02c.27-.55.49-1.08.9-1.68-.73.04-1.06-.33-1.58-.52-.41-1.35-.9-2.62-1.9-3.38-.4-.01-.7.16-1.08.17v-.02c.27-.55.48-1.08.9-1.68-.73.03-1.07-.34-1.58-.52l-.07-.23c.5-.25 1-.53 1.6-.97 0-1.05.1-2.04.2-3 1.16-.12 2.2-.58 3.6-1.61 0-1.05.1-2.04.2-3.01 1.16-.11 2.2-.57 3.6-1.6 0-1.05.1-2.04.2-3.01 1.16-.11 2.2-.57 3.6-1.6 0-1.05.1-2.04.2-3.01 1.16-.11 2.2-.57 3.6-1.6 0-1.05.1-2.04.2-3.01 1.16-.12 2.2-.57 3.6-1.6 0-1.05.1-2.04.2-3.01 1.17-.12 2.2-.57 3.6-1.6 0-1.05.1-2.04.21-3.02 1.16-.1 2.19-.56 3.6-1.6 0-1.05.09-2.03.2-3 1.16-.12 2.19-.57 3.6-1.61 0-1.05.1-2.03.2-3 1.16-.12 2.2-.58 3.6-1.61 0-1.05.1-2.04.2-3.01 1.16-.11 2.2-.57 3.6-1.6 0-1.05.1-2.04.2-3.01 1.16-.11 2.2-.57 3.6-1.6 0-1.05.1-2.04.2-3.01 1.16-.11 2.2-.57 3.6-1.6 0-1.05.1-2.04.2-3.01 1.16-.11 2.2-.57 3.6-1.6 0-1.05.1-2.04.2-3.01 1.16-.12 2.2-.57 3.6-1.6 0-1.05.1-2.04.2-3.02 1.16-.1 2.2-.56 3.6-1.6 0-1.05.1-2.03.2-3 1.17-.12 2.2-.57 3.6-1.61 0-1.05.1-2.03.21-3 1.16-.12 2.19-.58 3.6-1.61 0-1.05.09-2.04.2-3 1.16-.12 2.19-.58 3.6-1.61 0-1.05.1-2.04.2-3.01 1.16-.11 2.2-.57 3.6-1.6 0-1.05.1-2.04.2-3.01 1.16-.11 2.2-.57 3.6-1.6 0-1.05.1-2.04.2-3.01 1.16-.11 2.2-.57 3.6-1.6 0-1.05.1-2.04.2-3.01.98-.1 1.92-.52 3.02-1.26 19.19 25.45 30.67 56.73 30.67 90.65 0 43.08-18.36 82.02-47.79 109.95ZM340.72 238.8c-.52.68-.99 1.44-1.4 2.31a10.85 10.85 0 0 0-3.8 4.61 10.84 10.84 0 0 0-3.8 4.61 10.84 10.84 0 0 0-3.8 4.61 10.84 10.84 0 0 0-3.8 4.62 10.85 10.85 0 0 0-3.8 4.6 10.84 10.84 0 0 0-3.8 4.62 10.84 10.84 0 0 0-3.8 4.61 10.84 10.84 0 0 0-3.8 4.61 10.85 10.85 0 0 0-3.8 4.61 10.85 10.85 0 0 0-3.8 4.61 10.84 10.84 0 0 0-3.8 4.61c-1.44.96-2.68 2.3-3.61 4.14a10.6 10.6 0 0 0-3.98 4.37c-1.62.95-3 2.4-4.03 4.4-1.62.96-3 2.41-4.02 4.41-1.62.96-3 2.41-4.03 4.41-.2.12-.37.3-.57.43a5.1 5.1 0 0 0-1.53-2.34c-.43-.01-.75.17-1.18.18v-.04c.26-.51.45-1 .83-1.56-.68.03-.97-.32-1.46-.48-.42-1.39-.91-2.7-1.94-3.48-.43 0-.75.18-1.17.18l-.01-.03c.26-.52.45-1 .83-1.56-.67.03-.97-.32-1.46-.48-.42-1.4-.9-2.7-1.93-3.48-.44-.01-.76.17-1.18.18v-.04c.26-.51.45-1 .83-1.56-.68.03-.98-.32-1.46-.48-.42-1.39-.91-2.7-1.94-3.48-.43-.01-.75.17-1.17.18l-.01-.03c.26-.52.45-1 .83-1.56-.68.03-.97-.33-1.46-.48-.42-1.4-.9-2.7-1.93-3.48-.44-.02-.76.17-1.18.18l-.01-.04c.26-.51.46-1 .84-1.56-.68.03-.98-.32-1.47-.48-.41-1.39-.9-2.7-1.93-3.48-.43-.01-.75.17-1.18.18v-.04c.26-.51.45-1 .83-1.56-.68.04-.97-.32-1.46-.48-.42-1.38-.91-2.7-1.94-3.47-.43-.02-.75.17-1.17.18l-.01-.04c.26-.52.45-1 .83-1.56-.67.03-.97-.32-1.46-.48-.42-1.39-.9-2.7-1.93-3.48-.44-.01-.76.17-1.18.18v-.04c.26-.51.45-1 .83-1.56-.68.04-.98-.32-1.46-.48-.42-1.38-.91-2.7-1.94-3.47-.43-.02-.75.17-1.17.18l-.01-.04c.26-.52.45-1 .83-1.56-.67.03-.97-.32-1.46-.48-.42-1.39-.9-2.7-1.93-3.48-.44-.01-.76.17-1.18.18l-.01-.04c.26-.51.46-1 .83-1.56-.67.03-.97-.32-1.46-.48-.42-1.39-.9-2.7-1.93-3.48-.44 0-.75.18-1.18.18v-.03c.26-.52.45-1 .83-1.56-.68.03-.97-.32-1.46-.48-.42-1.4-.91-2.7-1.94-3.48-.43-.02-.75.17-1.17.18l-.01-.04c.26-.51.45-1 .83-1.56-.67.03-.97-.32-1.46-.48-.42-1.39-.9-2.7-1.93-3.48-.44-.01-.76.17-1.18.18l-.01-.03c.27-.52.46-1 .84-1.56-.68.03-.98-.33-1.46-.48-.22-.73-.59-1.3-.92-1.92a160.6 160.6 0 0 1 112.65-4.54Zm-171.46 47.4.16.05a60.16 60.16 0 0 1 1.45 4.56c.78.36 1.53.55 2.3.81a60.26 60.26 0 0 1 1.44 4.56c.8.37 1.53.55 2.3.82a60.16 60.16 0 0 1 1.45 4.56c.79.37 1.53.55 2.3.81a60.28 60.28 0 0 1 1.45 4.56c.78.37 1.53.56 2.3.82a60.14 60.14 0 0 1 1.44 4.56c.79.37 1.53.55 2.3.82a60.14 60.14 0 0 1 1.45 4.55c.79.37 1.53.56 2.3.82a60.16 60.16 0 0 1 1.44 4.56c.8.37 1.54.55 2.3.82a60.28 60.28 0 0 1 1.45 4.56c.79.36 1.53.55 2.3.81a60.14 60.14 0 0 1 1.45 4.56c.78.37 1.53.55 2.3.82a60.14 60.14 0 0 1 1.44 4.56c.8.36 1.53.55 2.3.81a60.16 60.16 0 0 1 1.45 4.56c.79.37 1.53.55 2.3.82a60.16 60.16 0 0 1 1.45 4.56c.78.37 1.53.55 2.3.82a60.26 60.26 0 0 1 1.44 4.55c.79.37 1.53.56 2.3.82a60.16 60.16 0 0 1 1.45 4.56c.79.37 1.53.55 2.3.82a60.28 60.28 0 0 1 1.44 4.55c.8.37 1.54.56 2.3.82.3.83.55 1.68.82 2.54-.33.46-.66.91-.93 1.45-1.62.95-3 2.4-4.03 4.4-1.62.96-3 2.41-4.03 4.41-1.62.96-3 2.41-4.03 4.41-1.62.95-3 2.41-4.02 4.4-1.62.96-3 2.42-4.03 4.42-1.62.95-3 2.4-4.03 4.4a10.75 10.75 0 0 0-4.18 4.81 10.83 10.83 0 0 0-3.9 4.66 10.82 10.82 0 0 0-3.82 4.6 10.83 10.83 0 0 0-3.82 4.6 10.82 10.82 0 0 0-3.82 4.59 10.83 10.83 0 0 0-3.81 4.6 10.83 10.83 0 0 0-3.82 4.59 10.83 10.83 0 0 0-3.82 4.6 10.83 10.83 0 0 0-3.82 4.6 10.83 10.83 0 0 0-3.82 4.59 10.83 10.83 0 0 0-3.82 4.6 10.82 10.82 0 0 0-3.81 4.59 10.64 10.64 0 0 0-3.66 4.18 149.52 149.52 0 0 1-18.72-72.48c0-37.34 13.77-71.58 36.58-98.24Zm49.96 235.17.04-.68c1.17-.1 2.2-.57 3.62-1.6 0-1.03.09-2 .2-2.95 1.18-.1 2.22-.56 3.65-1.62 0-.97.1-1.89.2-2.8 1.25-.06 2.34-.5 3.83-1.6 0-.98.1-1.9.2-2.8 1.24-.07 2.33-.51 3.83-1.61 0-.98.1-1.9.19-2.8 1.25-.07 2.34-.5 3.84-1.61 0-.97.09-1.89.19-2.8 1.25-.07 2.34-.5 3.83-1.6 0-.98.1-1.9.2-2.8 1.25-.07 2.33-.51 3.83-1.61 0-.98.1-1.9.2-2.8 1.24-.07 2.33-.51 3.83-1.61 0-.98.1-1.89.19-2.8 1.25-.07 2.34-.5 3.83-1.61 0-.97.1-1.89.2-2.8 1.25-.07 2.33-.5 3.83-1.6 0-.98.1-1.9.2-2.8 1.24-.07 2.33-.51 3.83-1.62 0-.97.1-1.88.19-2.8 1.25-.06 2.34-.5 3.84-1.6 0-.98.09-1.89.19-2.8 1.25-.07 2.34-.5 3.83-1.61 0-.97.1-1.89.2-2.8 1.25-.07 2.33-.5 3.83-1.6 0-.98.1-1.9.2-2.8 1.24-.07 2.33-.51 3.83-1.62 0-.97.1-1.88.19-2.8 1.25-.06 2.34-.5 3.83-1.6 0-.33.05-.62.07-.94l.06.18c.78.37 1.53.56 2.29.82a60.16 60.16 0 0 1 1.45 4.56c.79.37 1.53.55 2.3.82a60.28 60.28 0 0 1 1.45 4.55c.78.37 1.53.56 2.3.82a60.16 60.16 0 0 1 1.44 4.56c.79.37 1.54.55 2.3.82a60.26 60.26 0 0 1 1.45 4.56c.79.36 1.53.55 2.3.81a60.16 60.16 0 0 1 1.45 4.56c.77.36 1.51.55 2.27.8.52 1.5 1.03 3.01 1.45 4.59.75.35 1.46.52 2.18.77.54 1.51 1.06 3.05 1.49 4.66.75.35 1.45.52 2.18.78.53 1.5 1.05 3.05 1.48 4.66.75.34 1.45.52 2.18.77.53 1.5 1.06 3.05 1.49 4.66.74.35 1.45.52 2.17.77.54 1.51 1.06 3.05 1.49 4.66.75.35 1.45.52 2.18.78.53 1.5 1.05 3.05 1.48 4.66.75.34 1.46.52 2.18.77.53 1.5 1.06 3.05 1.49 4.66.74.35 1.45.52 2.17.77.54 1.51 1.06 3.05 1.49 4.66.75.35 1.45.52 2.18.78.53 1.5 1.06 3.05 1.48 4.66.75.35 1.46.52 2.18.77.29.81.54 1.64.8 2.48-14.96 4.6-30.88 7.1-47.4 7.1-25.7 0-49.9-6.13-71.36-16.78Z"
    }, null, -1)]));
  }
  var O1 = {
    render: D1
  };
  function qi() {
    return {
      clicktracking: function clicktracking(s, n) {
        var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "next";
        var a = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "";
        var o = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : "";
        var c = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : "";
        if (!window.dataLayer) return;
        var l = {
          click_element_type: n,
          click_element_name: s,
          click_action: r,
          event: "clicktracking"
        };
        a && (l.click_url = a), o && (l.click_element_text = o), c && (l.click_element_position = c), window.dataLayer.push(l);
      },
      virtualPageView: function virtualPageView(s, n) {
        if (!window.dataLayer) return;
        var r = {
          page_type: s,
          page_url: n,
          event: "virtual-pageview"
        };
        window.dataLayer.push(r);
      }
    };
  }
  var F1 = {
      "data-testid": "list-teaser",
      "class": "flex gap-4"
    },
    Z1 = {
      "class": "flex flex-col flex-1 gap-2 max-w-[50%]"
    },
    R1 = {
      "class": "break-words typo-teaser-5 line-clamp-3 overflow-ellipsis overflow-wrap"
    },
    j1 = ["href"],
    W1 = {
      "class": "relative flex-1"
    },
    G1 = ["href"],
    Y1 = {
      key: 0,
      "class": "absolute top-2 left-2"
    },
    X1 = t.defineComponent({
      __name: "ListTeaser",
      props: {
        post: {},
        labelColor: {}
      },
      setup: function setup(i) {
        var e = i,
          s = t.computed(function () {
            var n;
            return !e.post.image.img || !Array.isArray(e.post.image.source) ? e.post.image : _objectSpread(_objectSpread({}, e.post.image), {}, {
              img: _objectSpread(_objectSpread({}, e.post.image.img), {}, {
                srcset: (n = e.post.image.img.srcset) == null ? void 0 : n.filter(function (r) {
                  return r.src.includes("-4-3-");
                })
              }),
              source: e.post.image.source.map(function (r) {
                var a;
                return _objectSpread(_objectSpread({}, r), {}, {
                  srcset: (a = r.srcset) == null ? void 0 : a.filter(function (o) {
                    return o.src.includes("-4-3-");
                  })
                });
              })
            });
          });
        return function (n, r) {
          var a, o;
          return t.openBlock(), t.createElementBlock("article", F1, [t.createElementVNode("div", Z1, [(a = n.post.label) != null && a.text ? (t.openBlock(), t.createBlock(Re, {
            key: 0,
            href: (o = n.post.label) == null ? void 0 : o.link,
            color: n.labelColor
          }, {
            "default": t.withCtx(function () {
              return [t.createTextVNode(t.toDisplayString(n.post.label.text), 1)];
            }),
            _: 1
          }, 8, ["href", "color"])) : t.createCommentVNode("", !0), t.createElementVNode("h2", R1, [t.createElementVNode("a", {
            href: n.post.link
          }, t.toDisplayString(n.post.title), 9, j1)])]), t.createElementVNode("div", W1, [s.value !== void 0 ? (t.openBlock(), t.createElementBlock(t.Fragment, {
            key: 0
          }, [t.createElementVNode("a", {
            href: n.post.link
          }, [t.createVNode(je, {
            picture: s.value
          }, null, 8, ["picture"])], 8, G1), s.value !== void 0 ? (t.openBlock(), t.createElementBlock("div", Y1, [t.createVNode(lt, {
            "is-vplus": n.post.isVplus,
            brand: n.post.brand || ""
          }, null, 8, ["is-vplus", "brand"])])) : t.createCommentVNode("", !0)], 64)) : t.createCommentVNode("", !0)])]);
        };
      }
    }),
    U1 = {
      "class": "py-4 rounded bg-main-200"
    },
    q1 = {
      "class": "mx-6 mt-2"
    },
    K1 = {
      "class": "mt-10"
    },
    J1 = {
      key: 2,
      "class": "flex items-start justify-center gap-1 mt-4"
    },
    Ki = "gemeinde",
    Q1 = t.defineComponent({
      __name: "MyTownTopicWidget",
      props: {
        topic: {},
        button: {},
        maxPosts: {},
        maxPostAge: {},
        dynamicHeight: {
          type: Boolean,
          "default": !0
        },
        postTypes: {
          "default": function _default() {
            return ["nnp_clubs", "nnp_births", "nnp_weddings", "nnp_schools", "nnp_baptism"];
          }
        }
      },
      setup: function setup(i) {
        var e = i,
          _Nt2 = Nt(),
          s = _Nt2.getCookie,
          n = t.ref(s("CurrentCity") || ""),
          r = t.computed(function () {
            var g;
            return ((g = e.topic) == null ? void 0 : g.slug) === "gemeindewahl" ? n.value ? It(n.value) : "" : n.value ? n.value : "";
          }),
          a = t.ref(e.maxPosts || 3),
          o = t.computed(function () {
            var g = e.maxPostAge;
            if (g == null || g <= 0) return null;
            var w = new Date();
            return w.setUTCDate(w.getUTCDate() - g), "".concat(w.toISOString().split(".")[0]);
          }),
          c = t.computed(function () {
            var g = a.value;
            if (!e.topic) {
              var y = o.value ? "&after=".concat(encodeURIComponent(o.value)) : "",
                x = e.postTypes ? "&post_type=".concat(e.postTypes.join(",")) : "",
                T = r.value || "meinegemeinde";
              return "/wp-json/wp/v2/posts?per_page=".concat(g, "&category_slug=news-aus-").concat(T).concat(y).concat(x);
            }
            var w = n.value ? "-".concat(r.value) : "";
            return "/wp-json/russmedia-topics/v1/topics/".concat(e.topic.slug).concat(w, "?per_page=").concat(g);
          }),
          _ks$get$json = ks(c, {
            refetch: !0
          }).get().json(),
          l = _ks$get$json.data,
          d = _ks$get$json.isFetching,
          f = t.computed(function () {
            return l.value ? l.value.hits ? l.value.hits.map(C) : l.value.map(C) : [];
          }),
          h = t.computed(function () {
            var g = a.value;
            return "".concat(g * 105 + (g - 1) * 20, "px");
          });
        function v(g) {
          var w = Te[g].title;
          b("gemeinde-dropdown", "", w, "gemeindename"), n.value = g !== Ki ? g : "";
        }
        var m = t.computed(function () {
            var w;
            if (!e.topic) return "";
            var g = (w = e.button) != null && w.link ? e.button.link : "/themen/".concat(e.topic.slug);
            return n.value === "" ? "".concat(g) : "".concat(g, "-").concat(r.value);
          }),
          p = t.computed(function () {
            var g;
            return e.topic ? e.topic.slug === "gemeindewahl" ? "Zu den Gemeindewahlen" : ((g = e.button) == null ? void 0 : g.text) || "Mehr zu '".concat(e.topic.title, "'") : "";
          }),
          u = t.computed(function () {
            return n.value === "" ? "/gemeinde/".concat(Ki) : "/gemeinde/".concat(n.value);
          });
        function b(g, w, y) {
          var x = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "linkclick";
          var T = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : "";
          var L;
          var S = "hp-sb-widget-".concat(((L = e.topic) == null ? void 0 : L.slug) || "no-topic");
          qi().clicktracking(g, S, x, w, y, T);
        }
        function C(g) {
          var _ref53;
          var $;
          var w = g.id,
            _g$date = g.date,
            y = _g$date === void 0 ? "" : _g$date,
            _g$formatted_date = g.formatted_date,
            x = _g$formatted_date === void 0 ? "" : _g$formatted_date,
            T = g.title,
            _g$slug = g.slug,
            S = _g$slug === void 0 ? "" : _g$slug,
            _g$link = g.link,
            L = _g$link === void 0 ? null : _g$link,
            _g$featured_image = g.featured_image,
            E = _g$featured_image === void 0 ? {} : _g$featured_image,
            _g$comment_count = g.comment_count,
            M = _g$comment_count === void 0 ? 0 : _g$comment_count,
            _g$picture_count = g.picture_count,
            P = _g$picture_count === void 0 ? 0 : _g$picture_count,
            _g$is_premium = g.is_premium,
            B = _g$is_premium === void 0 ? !1 : _g$is_premium,
            _g$brand = g.brand,
            H = _g$brand === void 0 ? "" : _g$brand,
            _g$content_blocks = g.content_blocks,
            z = _g$content_blocks === void 0 ? [] : _g$content_blocks,
            I = {
              text: n.value ? Te[n.value].title : "Gemeinde",
              link: u.value
            };
          return {
            id: w,
            date: y,
            formatted_date: x,
            title: (_ref53 = T == null ? void 0 : T.rendered) !== null && _ref53 !== void 0 ? _ref53 : "",
            slug: S,
            link: L,
            image: E,
            label: {
              text: (($ = e.topic) == null ? void 0 : $.title) || I.text,
              link: e.topic ? "/themen/".concat(e.topic.slug) : I.link
            },
            commentCount: M,
            pictureCount: P,
            isVplus: B,
            brand: H,
            contentBlocks: z
          };
        }
        return function (g, w) {
          var y;
          return t.openBlock(), t.createElementBlock("div", U1, [t.createElementVNode("div", q1, [t.createVNode(Hi, {
            color: "BLACK",
            onOptionSelected: v,
            onOptionsOpened: w[0] || (w[0] = function (x) {
              return b("gemeinde-dropdown", "", "", "dropdown-opened");
            })
          })]), !t.unref(d) && f.value.length > 0 ? (t.openBlock(), t.createElementBlock("div", {
            key: 0,
            "class": "flex flex-col justify-between gap-5 mx-2 mt-10 overflow-hidden",
            style: t.normalizeStyle({
              height: e.dynamicHeight ? "auto" : h.value
            })
          }, [(t.openBlock(!0), t.createElementBlock(t.Fragment, null, t.renderList(f.value, function (x, T) {
            return t.openBlock(), t.createBlock(X1, {
              key: x.id,
              post: x,
              onClick: function onClick(S) {
                return b("artikelliste", x.link, x.title, "linkclick", (T + 1).toString());
              }
            }, null, 8, ["post", "onClick"]);
          }), 128))], 4)) : t.unref(d) || !t.unref(d) && !e.dynamicHeight && f.value.length === 0 ? (t.openBlock(), t.createBlock(_t, {
            key: 1,
            "class": "mt-10",
            style: t.normalizeStyle({
              height: h.value
            })
          }, null, 8, ["style"])) : t.createCommentVNode("", !0), t.createElementVNode("div", K1, [t.createVNode(Dt, {
            href: u.value,
            "class": "block mx-auto",
            "text-color": "black",
            active: !0,
            onClick: w[1] || (w[1] = function (x) {
              return b("link-gemeinde-seite", u.value, "Zur Gemeindeseite");
            })
          }, {
            "default": t.withCtx(function () {
              return w[3] || (w[3] = [t.createTextVNode(" Zur Gemeindeseite ")]);
            }),
            _: 1
          }, 8, ["href"])]), g.topic ? (t.openBlock(), t.createElementBlock("div", J1, [((y = e.topic) == null ? void 0 : y.slug) === "gemeindewahl" ? (t.openBlock(), t.createBlock(t.unref(O1), {
            key: 0,
            "class": "-mt-1.5"
          })) : t.createCommentVNode("", !0), t.createVNode(Dt, {
            href: m.value,
            "text-color": "black",
            active: !0,
            onClick: w[2] || (w[2] = function (x) {
              return b("link-".concat(g.topic.slug, "-seite"), m.value, p.value);
            })
          }, {
            "default": t.withCtx(function () {
              return [t.createTextVNode(t.toDisplayString(p.value), 1)];
            }),
            _: 1
          }, 8, ["href"])])) : t.createCommentVNode("", !0)]);
        };
      }
    });
  var ue = function (i) {
    return i.apa = "apa", i.apalvblg = "apalvblg", i.apavs = "apavs", i.brightcove = "brightcove", i.datawrapper = "datawrapper", i.dpavs = "dpavs", i.elfs = "elfs", i.facebook = "facebook", i.fileinbox = "fileinbox", i.glomex = "glomex", i.iframely = "iframely", i.infogram = "infogram", i.instagram = "instagram", i.lvblg = "lvblg", i.opinionstage = "opinionstage", i.outbrain = "outbrain", i.pdg = "pdg", i.pinpoll = "pinpoll", i.player = "player", i.spotify = "spotify", i.strmp = "strmp", i.tckr = "tckr", i.tickaroo = "tickaroo", i.tiktok = "tiktok", i.twitter = "twitter", i.vi = "vi", i.vimeo = "vimeo", i.youtube = "youtube", i.rotblau = "rotblau", i.vev = "vev", i._generic = "_generic", i;
  }(ue || {});
  var ot = t.ref({
    necessary: !1,
    preferences: !1,
    marketing: !1,
    statistics: !1,
    granular: {}
  });
  function e2() {
    return {
      getSettings: function getSettings() {
        return ot;
      },
      setSettings: t2,
      isProviderEnabled: i2,
      isVideoProvider: s2
    };
  }
  function t2(i) {
    ot.value = i;
  }
  function i2(i) {
    var e;
    return (e = ot.value) != null && e.granular ? i in ot.value.granular : !1;
  }
  function s2(i) {
    return i ? [ue.youtube, ue.apa, ue.vimeo, ue.vi, ue.glomex, ue.brightcove, ue.player].includes(i) : !1;
  }
  function n2() {
    return Cs(vs).greaterOrEqual("md");
  }
  var Ji = 0;
  function r2() {
    return {
      getPostId: function getPostId() {
        return Ji;
      },
      setPostId: function setPostId(i) {
        return Ji = i;
      }
    };
  }
  function a2() {
    return {
      isPremiumUser: function isPremiumUser() {
        var i = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        return !!(i.hasPlusAccess || i.hasPlusPremiumAccess || document.referrer.match(/https:\/\/www.(vn|neue)\.at/i));
      }
    };
  }
  var l2 = {
    items: JSON.parse('[{"headline":"VOL.AT WhatsApp Service","content":"Schnapp dir die heißesten News direkt aufs Handy!<br><a href=\\"https://www.whatsapp.com/channel/0029Va5pnYa96H4JNuBssM1b\\" target=\\"_blank\\">Hier VOL.AT auf WhatsApp folgen.</a><br><span id=\\"newsletter-QRscan\\">Hier QR Code scannen.</span>","schedule":"24/7","list":"","icon":"<svg width=\\"72\\" height=\\"72\\" viewBox=\\"0 0 72 72\\" fill=\\"none\\" xmlns=\\"http://www.w3.org/2000/svg\\">\\n        <g clip-path=\\"url(#clip0_4978_1539)\\">\\n        <path d=\\"M72 36C72 16.1178 55.8822 0 36 0C16.1178 0 0 16.1178 0 36C0 55.8822 16.1178 72 36 72C55.8822 72 72 55.8822 72 36Z\\" fill=\\"url(#paint0_linear_4978_1539)\\"/>\\n        <path d=\\"M35.998 13.5139C23.581 13.5139 13.5137 23.5807 13.5137 36C13.5137 40.2488 14.6935 44.2212 16.7408 47.6113L13.9407 58.4155L25.1302 55.6901C28.3521 57.471 32.0568 58.4867 35.998 58.4867C48.4191 58.4867 58.4865 48.4188 58.4865 36.0006C58.4865 23.5824 48.4191 13.5145 35.998 13.5145V13.5139ZM35.998 54.719C32.198 54.719 28.6567 53.5786 25.7013 51.623L19.137 53.2963L20.8455 46.9743C18.6047 43.8883 17.2819 40.0971 17.2819 35.9994C17.2819 25.6762 25.6789 17.2798 35.9986 17.2798C46.3183 17.2798 54.7182 25.6762 54.7182 35.9994C54.7182 46.3226 46.3218 54.7184 35.9986 54.7184L35.998 54.719Z\\" fill=\\"white\\"/>\\n        <path d=\\"M45.5215 40.5487C45.2074 40.3946 44.8739 40.267 44.6087 40.127C43.8488 39.7259 43.0895 39.3242 42.3296 38.9231C42.0979 38.8007 41.8526 38.6749 41.5903 38.6813C40.5869 38.7066 40.1187 40.1364 39.463 40.6893C39.1942 40.9157 38.883 41.1239 38.5325 41.141C38.2443 41.1551 37.9679 41.038 37.7073 40.9145C36.3928 40.294 35.1795 39.4589 34.1261 38.4572C33.2986 37.6709 32.5722 36.784 31.8923 35.867C31.5806 35.4465 31.2677 34.9936 31.2106 34.4731C31.0707 33.1945 32.888 32.7463 32.9369 31.4606C32.9545 30.9907 32.7369 30.5484 32.5404 30.1208C32.204 29.3886 31.917 28.6334 31.6812 27.8629C31.2477 26.4472 30.4213 25.8385 28.891 26.1796C26.9948 26.6031 25.9961 29.261 25.932 30.9554C25.8361 33.4921 27.5923 36.0135 27.8376 36.3664C29.0068 38.0491 30.1108 39.6947 31.5853 41.1445C33.9832 43.5018 37.2962 45.4145 40.6387 45.9726C41.2845 46.0808 41.9455 46.1314 42.5943 46.0432C43.7059 45.892 44.7451 45.3045 45.475 44.4564C46.1461 43.6771 47.0177 42.2179 46.3714 41.208C46.1873 40.921 45.8655 40.7187 45.5203 40.5493L45.5215 40.5487Z\\" fill=\\"white\\"/>\\n        </g>\\n        <defs>\\n        <linearGradient id=\\"paint0_linear_4978_1539\\" x1=\\"36\\" y1=\\"-0.268784\\" x2=\\"36\\" y2=\\"72.0341\\" gradientUnits=\\"userSpaceOnUse\\">\\n        <stop stop-color=\\"#2AD846\\"/>\\n        <stop offset=\\"1\\" stop-color=\\"#00AB24\\"/>\\n        </linearGradient>\\n        <clipPath id=\\"clip0_4978_1539\\">\\n        <rect width=\\"72\\" height=\\"72\\" fill=\\"white\\"/>\\n        </clipPath>\\n        </defs>\\n        </svg>        \\n        "},{"headline":"V+ News-Update","content":"Täglich die meistgelesenen Artikel aus den drei größten Redaktionen Vorarlbergs: VOL.AT, VN und NEUE.","schedule":"Mo - So | 07:07 Uhr","list":"VPlus_Newsletter","icon":"<svg width=\\"80\\" height=\\"80\\" viewBox=\\"0 0 80 80\\" fill=\\"none\\" xmlns=\\"http://www.w3.org/2000/svg\\">\\n        <circle cx=\\"39.9999\\" cy=\\"40.0001\\" r=\\"36.3636\\" fill=\\"#E0081A\\"/>\\n        <path d=\\"M50 43.5545V39.7881H56.3185V33.3333H60.3555V39.7833H66.6667V43.5498H60.3555V49.9999H56.3185V43.5498L50 43.5545Z\\" fill=\\"white\\"/>\\n        <path d=\\"M25.6428 26.6667L33.3111 44.9287L41.0236 26.6667H49.9998L36.6001 56.6667H30.0251L16.6665 26.6667H25.6428Z\\" fill=\\"white\\"/>\\n        </svg>\\n        ","image":"<svg xmlns=\\"http://www.w3.org/2000/svg\\" viewBox=\\"0 0 203 139\\"  preserveAspectRatio=\\"xMidYMid slice\\"><path fill=\\"#E3051B\\" d=\\"M0 0h203v139H0z\\"/><g transform=\\"translate(45 13.119)\\"><path fill=\\"#fff\\" d=\\"M66.016 60.427v-7.826h12.569V39.188h8.03v13.403H99.17v7.826H86.616V73.82h-8.031V60.417ZM28.763 30.072l12.76 32.192 12.833-32.192h14.937L46.996 82.955H36.055L13.826 30.072Z\\"/></g></svg>","isChecked":true},{"headline":"V+ Wochenrückblick","content":"Erhalte wöchentliche Infos zu VOL.AT-Updates, neuen Features, exklusiven V+ Gewinnspielen und eine Übersicht der meistgelesenen Artikel der letzten Woche.","schedule":"Sa | 10:00 Uhr","list":"VPlus_Subscriber","icon":"<svg width=\\"80\\" height=\\"80\\" viewBox=\\"0 0 80 80\\" fill=\\"none\\" xmlns=\\"http://www.w3.org/2000/svg\\">\\n        <circle cx=\\"39.9999\\" cy=\\"40.0001\\" r=\\"36.3636\\" fill=\\"#E0081A\\"/>\\n        <path d=\\"M50 43.5545V39.7881H56.3185V33.3333H60.3555V39.7833H66.6667V43.5498H60.3555V49.9999H56.3185V43.5498L50 43.5545Z\\" fill=\\"white\\"/>\\n        <path d=\\"M25.6428 26.6667L33.3111 44.9287L41.0236 26.6667H49.9998L36.6001 56.6667H30.0251L16.6665 26.6667H25.6428Z\\" fill=\\"white\\"/>\\n        </svg>\\n        ","image":"<svg xmlns=\\"http://www.w3.org/2000/svg\\" viewBox=\\"0 0 203 139\\"  preserveAspectRatio=\\"xMidYMid slice\\"><path fill=\\"#E3051B\\" d=\\"M0 0h203v139H0z\\"/><g transform=\\"translate(45 13.119)\\"><path fill=\\"#fff\\" d=\\"M66.016 60.427v-7.826h12.569V39.188h8.03v13.403H99.17v7.826H86.616V73.82h-8.031V60.417ZM28.763 30.072l12.76 32.192 12.833-32.192h14.937L46.996 82.955H36.055L13.826 30.072Z\\"/></g></svg>","isChecked":true},{"headline":"V+ Politik Update","content":"Bleib auf dem Laufenden mit den wichtigsten politischen Nachrichten und Analysen aus Österreich und Vorarlberg. Jeden Freitag - direkt in dein Postfach.","schedule":"Fr | 10:00 Uhr","list":"Vplus_Newsletter_Politik","icon":"<img src=\\"/wp-content/themes/vodl/assets/newsletter/policy.png\\" alt=\\"vplus politik\\" >","image":"<img src=\\"https://www.vol.at/2025/01/onboarding-newsletter-politik-resized.jpeg\\" alt=\\"Symbolbild Politik\\" />","isChecked":true},{"headline":"V+ Sport","content":"Deine Sportwoche im Überblick. Erhalte jeden Samstag Ankündigungen, Ergebnisse und die wichtigsten Berichte zum Thema Sport.","schedule":"Sa | 12:00 Uhr","list":"Vplus_Newsletter_Sport","icon":"<img src=\\"/2024/12/Sport.png\\" alt=\\"vplus sport\\" >","image":"<img src=\\"https://www.vol.at/2025/01/onboarding-newsletter-sport-resized.jpeg\\" alt=\\"Symbolbild Sport\\" />","isChecked":true},{"headline":"V+ Kultur","content":"Wöchentlich die interessantesten Kulturberichte sowie Veranstaltungstipps fürs Wochenende.","schedule":"Do | 10:00 Uhr","list":"Vplus_Newsletter_Kultur","icon":"<img src=\\"/2024/12/Kultur.png\\" alt=\\"vplus kultur\\" >","image":"<img src=\\"https://www.vol.at/2025/01/onboarding-newsletter-kultur-resized.jpeg\\" alt=\\"Symbolbild Kultur\\" />","isChecked":true},{"hasOptions":true,"headline":"V+ Bezirks-Newsletter","content":"Wöchentlich die wichtigsten Informationen aus deinem Bezirk direkt in deinem Postfach.","schedule":"So | 08:00 Uhr","list":{"Bregenz":"VPlus_Newsletter_Bregenz","Dornbirn":"VPlus_Newsletter_Dornbirn","Feldkirch":"VPlus_Newsletter_Feldkirch","Bludenz":"VPlus_Newsletter_Bludenz"},"icon":"<svg xmlns=\\"http://www.w3.org/2000/svg\\" width=\\"73\\" height=\\"73\\" viewBox=\\"0 0 72 72\\" fill=\\"none\\"><circle cx=\\"36.364\\" cy=\\"36.364\\" r=\\"35.364\\" fill=\\"#E3051B\\"/><path d=\\"m43.137 66.99-.214-.375a5.332 5.332 0 0 0-2.65-2.306l-.181-.072a5.891 5.891 0 0 0-1.22-.342l-1.5-.25a4.939 4.939 0 0 1-1.64-.583l-.553-.317a3.938 3.938 0 0 1-1.97-3.746l.122-1.474a2.28 2.28 0 0 0-1.824-2.424 2.28 2.28 0 0 1-.92-.411l-.55-.413a5.312 5.312 0 0 0-2.315-.99l-.867-.145a8.92 8.92 0 0 1-1.666-.446l-2.354-.883a3.325 3.325 0 0 0-1.714-.166l-1.109.184a1.587 1.587 0 0 1-1.767-2.068l.488-1.462a2.53 2.53 0 0 0 0-1.602 2.532 2.532 0 0 1-.054-1.414l.172-.69c.1-.395.149-.8.149-1.208v-2.03c0-.57.07-1.136.208-1.688l.145-.582c.097-.389.26-.757.482-1.09l.352-.527c.203-.305.501-.533.848-.648l.036-.012a1.585 1.585 0 0 1 1.621.383l.122.12c.41.41 1.036.512 1.554.253.088-.044.18-.078.275-.102l.774-.193a1.43 1.43 0 0 0 1.083-1.387c0-.542.306-1.037.79-1.28l.698-.348a.927.927 0 0 0 .512-.829c0-.512.415-.927.927-.927h2.117c.3 0 .595.07.864.204.383.192.82.25 1.242.166l.936-.187a4.714 4.714 0 0 0 1.69-.7L37 31.5l.323.215A14.28 14.28 0 0 1 39.5 33.5L41 33l2 1.5.553.276c.294.147.618.224.947.224v1.5h3l.5-1 1.5-.5H51l1.5.5h.75a.75.75 0 0 1 .75.75v2.082c0 .44.102.873.299 1.266l.492.983a3.498 3.498 0 0 1-.89 4.251L52.5 46l-.657.657a3.549 3.549 0 0 0-.97 3.205c.084.422.09.855.02 1.28l-.185 1.11a3.2 3.2 0 0 0 .494 2.301 3.2 3.2 0 0 1-.164 3.774L50.5 59l-.76 1.14A3.853 3.853 0 0 0 49.5 64l.173.259a3.199 3.199 0 0 1-3.54 4.85l-.46-.131a4.273 4.273 0 0 1-2.536-1.989Z\\" fill=\\"#F4DFCA\\"/><path d=\\"m15.953 28.67 1.646-3.019A3.169 3.169 0 0 1 20.381 24c.374 0 .71.228.849.575l.507 1.268c.174.434.433.827.763 1.157l1.792.448a.581.581 0 0 0 .4-.044.831.831 0 0 1 1.143.435l.356.889c.194.485.61.847 1.116.974l.66.165c.349.087.667.267.92.52l.562.562a.733.733 0 0 0 .111.091l.478.319a.883.883 0 0 0 1.328-.456.176.176 0 0 1 .324-.023l.16.318a.9.9 0 0 1-.806 1.302h-1.688a.858.858 0 0 0-.607.251.849.849 0 0 0-.249.6v.149a.809.809 0 0 1-.447.724l-.553.276-.106.053A1.618 1.618 0 0 0 26.5 36c0 .32-.127.627-.354.854l-.005.005c-.093.093-.201.171-.319.23l-.598.3a1.06 1.06 0 0 1-.474.111 1.06 1.06 0 0 0-.474.112l-.023.011c-.45.225-.993.137-1.349-.218l-.22-.221a1.602 1.602 0 0 0-.417-.3l-.114-.057a1.46 1.46 0 0 0-1.868.496l-.39.585a4.106 4.106 0 0 0-.568 1.282l-.216.866a3.722 3.722 0 0 0-.111.902v1.305a.573.573 0 0 1-.89.476l-1.434-.955a2.005 2.005 0 0 1-.833-2.155c.102-.409.073-.84-.084-1.231l-.425-1.064a3.203 3.203 0 0 0-1.053-1.373A3.203 3.203 0 0 1 13 33.398v-.429c0-1.221.641-2.354 1.689-2.982a3.48 3.48 0 0 0 1.264-1.317Z\\" fill=\\"#F4DFCA\\"/><path d=\\"m21.737 25.843-.419-1.047a1.63 1.63 0 0 1 .157-1.51 1.63 1.63 0 0 0 .102-1.632l-.77-1.541A2.042 2.042 0 0 1 21.5 17.5l.479-.24a1.165 1.165 0 0 1 1.042 0l.146.073c.219.11.46.167.706.167.412 0 .82.096 1.188.28l1.439.72.185.093a1.822 1.822 0 0 0 1.63 0 .877.877 0 0 1 .392-.093H30l-.5 2.333.5 1.667 1.5 1.5-1.5 2 .5 1.5V29l.968.968a.08.08 0 0 1 .021.075l-.15.598a.987.987 0 0 1-1.505.582l-.024-.016a3.761 3.761 0 0 1-.573-.47l-.225-.225a2.615 2.615 0 0 0-1.215-.688l-.461-.115A1.685 1.685 0 0 1 26.18 28.7l-.296-.74a.952.952 0 0 0-1.31-.497.226.226 0 0 1-.155.017L22.5 27c-.33-.33-.59-.723-.763-1.157Z\\" fill=\\"#F4DFCA\\"/><path d=\\"M55 26.5c0-.07.107-.172.288-.305 2.395-1.761 1.62-4.203-1.28-4.856l-.76-.17c-.491-.111-1.001-.097-1.484.041l-1.464.419a1.412 1.412 0 0 1-1.8-1.358v-1.647c0-.728-.248-1.434-.702-2.002l-.793-.99a7.64 7.64 0 0 1-.867-1.355 7.635 7.635 0 0 0-3.414-3.415L42 10.5l-.712-.89A3.213 3.213 0 0 0 38 8.5l-1.729-.346a3.512 3.512 0 0 0-1.537.038.992.992 0 0 1-1.234-.959 2.2 2.2 0 0 0-.44-1.32L32 4.5l-.553-.207A4.575 4.575 0 0 0 26 6.09l-1.182 2.686c-.192.436-.096.945.24 1.281l.165.165a1.023 1.023 0 0 1-.971 1.715l-.752-.188a4.124 4.124 0 0 0-2 0l-1 .25-3.321.5c-1.361.408-1.986 1.995-1.164 3.153.5.706.959 1.256 1.164 1.256.428 0 3.071-.44 6.821.591l1.5.5.172.115a3.154 3.154 0 0 0 2.828.34H30L29.5 21l.5 1.576L31.5 24 30 26l.5 1.5V29l1 1-.5 2 2 1 2.5-.5 1.5-1 .323.215A14.28 14.28 0 0 1 39.5 33.5L41 33l1.72 1.375A2.85 2.85 0 0 0 44.5 35v1.5h3l.5-1 1.5-.5H51l1.5.5c1.67 0 3.273-2.825 2.951-4.464A26.554 26.554 0 0 1 55 26.5Z\\" fill=\\"#F4DFCA\\"/><path d=\\"m21.937 17.36 1.105-.975.854.975s1.342-.609 3.234 1.099c0 0 1.342 0 1.342-.55l1.159.184.793-.671s.915.183-.305 3.233l.634 1.708 1.318 1.281v.732l-1.464 1.586.488 1.099-.061.61-.061 1.28.732.915h1.037v.793l-1.464.854 1.464 1.098-1.342 1.22-.854-.792-1.525.549.854.915-.61.548h-.61l-1.316.244v1.507l-.636 1.057h-1.22l-.794.852s-2.698-.122-2.752-1.403l-1.274.061-.61 1.83.244.854-.61.366.149 2.32\\" stroke=\\"#2C2C2C\\" stroke-width=\\".4\\"/><path d=\\"m21.452 24.313.614.736.244 1.28h1.953l.549.61.61-.61 1.647 2.929 1.89.306.672 1.036h1.342l.828.61M32.742 32.612l.488-.67h2.5l.977-.733 1.22-.793.366 1.403 1.281.061v.732s2.074 0 2.013-.488l2.684 2.501 1.281-.549v1.22l-.366.55h2.135l.366-.855.793-.122.366-.854 1.037.122.671-.183 2.552.85\\" stroke=\\"#2C2C2C\\" stroke-width=\\".4\\"/><path d=\\"M22.583 13.158c.373-.05.18.467.485.485.571-.056.418-.425.324-.809.553.264.485-.019.808-.323 1.29.232 2.877.658 3.072-.647.078-.53-.457-1.41-1.455-1.455-.076-.345.23-.308.485-.323-.554-1.085 1.147-1.904.646-2.91.76-1.05 1.379-2.525 3.233-2.101.285.065.59.72 1.132.646.144 1.208.054 2.094-.485 3.072.813.21 1.213.834 2.263.808-.059.705.616.677.97.97.667-.287-.091-1.038.323-1.455 1.264-.079 1.829.542 2.263 1.293 1.088.118 1.143-.796 2.425-.485l.081.243.242-.081v1.132c.383.64 1.088.96 1.617 1.455-.572.704.024 1.252.323 1.94 1.529-.507 3.644-.881 2.91.97.309.553 1.163.561 1.293 1.293.38-.052.607-.256 1.132-.162-.133 1.157.268 1.78.808 2.263-.169.478-.818.475-.646 1.294h-1.294c-.109.809.432.969.809 1.293-.514 1.3.596 2.289.646 3.556.667-.196.844-.88 1.132-1.455.793.34 1.378.886 2.748.647.287-.306.118-1.068.162-1.617.422.046.809.055.646-.485.865-.002.977.748 1.617.97.777.131.584-.709 1.455-.485.245.456-.054.664.161 1.294-.833.621-1.058 1.851-1.778 2.586.148 1.23-.63 1.211.647 2.264-.472.82-.828 1.759-2.263 1.616-.074 1.28-.216 1.886-.162 2.587.829.41 2.08.398 2.748.97-.312.55-1.15.574-1.293 1.293.7.485.884 1.487.808 2.748-.278.369-.778.515-.97.97-.44.615.467.832.647 1.455.251.872-.21 1.889.808 2.102-.114.586-.896.504-1.132.97-.11.434.335.312.486.485-.259.28-.728.35-1.294.323-.357.02-.069.686-.161.97-2.105-.261-2.776 2.28-2.91 4.526.329.263.846.34 1.131.647.182 1.69-1.097 1.92-1.778 2.748.347.839 1.008 1.362 1.94 1.616-.05.88-.237 1.176.162 1.779h-.647c-.667.464-.903 1.36-.808 2.586-.577.879-1.321 1.59-2.102 2.263.672 1.538.428 3.99 2.425 4.203.415 1.978-.717 2.409-1.778 2.91-.742-.175-.917-.915-1.132-1.616-.783-.047-1.296.356-1.94 0-.304-1.582-1.313-2.46-2.263-3.395-.748.41-1.192-.264-1.94-.324v-.808c-.412.403-1.166-.179-1.455-.162-.264.016-.51.38-.808.324-1.323-.247-2.127-1.6-3.718-1.778-.237-1.984-.433-3.403.808-4.689.105-1.102-1.651-1.42-.647-2.424-.75-.739-1.53.257-2.263.485-1.98-.273-2.913-2.986-5.173-1.94-.365-.497-1.07-.654-1.94-.647-.342-.897-1.741-.737-2.101-1.616-.821.418-2.25.227-2.748.97-.63.037-.838-.348-1.294-.486-.122-.564.49-1.22 0-1.616.26-.412.712-.28 1.294-.647-.115-.6.276-.694.161-1.293-.107-.432-.486-.592-.808-.809.051-.703.486-1.023.647-1.616-.688-.067-.46-1.049-.485-1.778-.35-.365-.552.133-1.132 0-.137-1.264-1.009-1.794-2.263-1.94.51-.372.565-1.047.323-1.779.446-.039.493-.476.647-.808-.356-.776-.64-1.624-1.617-1.778.03-.725.511-.998.809-1.455-.363-1.147-1.596-1.422-2.102-2.425.73-.618 1.375-1.32 1.455-2.586.755-.576 1.51-.739 1.94-1.455.75-1.254.304-3.354 1.778-4.042.526-.245 1.195.085 1.778-.162.732-.31 1.035-.838 1.455-1.778-1.428-.593-2.579-4.009-.97-5.173-.28-.636-1.186-.646-2.101-.647-.452-.249-.442-.959-.97-1.131-.44-.116.115.762-.323.646-.916-.324-.813-1.666-1.617-2.101l.275-.113.21-.21c1.573.634 2.552-.518 3.233-1.294.252.23-.315 1.402.485 1.455.718.125.65-.535.97-.808l.242.08.243-.08Z\\" stroke=\\"#2C2C2C\\" stroke-width=\\".4\\"/></svg>","image":"<svg xmlns=\\"http://www.w3.org/2000/svg\\" viewBox=\\"0 0 203 139\\" preserveAspectRatio=\\"xMidYMid slice\\" fill=\\"none\\"><path fill=\\"#E3051B\\" d=\\"M0 0h203v139H0z\\"/><g style=\\"fill:none\\"><path fill=\\"#f4dfca\\" d=\\"m116.785 125.721-.394-.692a9.84 9.84 0 0 0-4.89-4.254l-.335-.134c-.725-.29-1.48-.501-2.251-.63l-2.768-.461a9.13 9.13 0 0 1-3.024-1.077l-1.023-.585a7.265 7.265 0 0 1-3.635-6.911l.226-2.72a4.206 4.206 0 0 0-3.366-4.473 4.206 4.206 0 0 1-1.7-.76l-1.014-.761a9.802 9.802 0 0 0-4.27-1.827l-1.601-.267a16.462 16.462 0 0 1-3.074-.824l-4.344-1.63a6.135 6.135 0 0 0-3.163-.306l-2.045.34a2.93 2.93 0 0 1-3.26-3.815l.9-2.7c.32-.959.32-1.996 0-2.955a4.671 4.671 0 0 1-.1-2.61l.318-1.274a9.18 9.18 0 0 0 .274-2.227V78.42c0-1.05.129-2.095.383-3.114l.269-1.074c.179-.717.48-1.397.89-2.011l.648-.973a3.036 3.036 0 0 1 1.566-1.196l.065-.022a2.924 2.924 0 0 1 2.992.706l.225.224a2.484 2.484 0 0 0 2.867.466c.162-.081.333-.144.509-.188l1.427-.357a2.638 2.638 0 0 0 1.999-2.56c0-1 .564-1.913 1.458-2.36l1.287-.643c.58-.29.945-.882.945-1.53 0-.945.766-1.71 1.71-1.71h3.908c.553 0 1.098.128 1.593.375a3.561 3.561 0 0 0 2.29.307l1.729-.345a8.699 8.699 0 0 0 3.119-1.292l1.336-.89.597.397a26.357 26.357 0 0 1 4.017 3.293l2.767-.923 3.69 2.768 1.02.51a3.909 3.909 0 0 0 1.749.413v2.768h5.536l.923-1.846 2.767-.922h2.769l2.767.922h1.384c.765 0 1.384.62 1.384 1.384v3.841c0 .811.19 1.611.552 2.337l.907 1.814a6.452 6.452 0 0 1-1.64 7.845l-2.587 2.155-1.212 1.213a6.548 6.548 0 0 0-1.79 5.914 6.55 6.55 0 0 1 .037 2.36l-.341 2.05a5.905 5.905 0 0 0 .91 4.246 5.905 5.905 0 0 1-.301 6.964l-.993 1.242-1.402 2.102a7.11 7.11 0 0 0-.444 7.124l.319.478a5.903 5.903 0 0 1-6.533 8.95l-.848-.242a7.883 7.883 0 0 1-4.68-3.669z\\"/><path fill=\\"#f4dfca\\" d=\\"m66.624 55.009 3.037-5.57a5.847 5.847 0 0 1 5.133-3.047c.69 0 1.31.42 1.567 1.06l.936 2.342c.32.8.799 1.525 1.407 2.134l3.306.827c.249.062.51.033.74-.081a1.534 1.534 0 0 1 2.11.802l.655 1.64a3.002 3.002 0 0 0 2.06 1.798l1.219.304a3.65 3.65 0 0 1 1.698.962l1.035 1.035c.063.063.132.12.206.169l.88.587a1.63 1.63 0 0 0 2.45-.84.325.325 0 0 1 .6-.043l.293.587a1.66 1.66 0 0 1-1.484 2.402h-3.118c-.42 0-.823.167-1.12.464a1.566 1.566 0 0 0-.46 1.108v.274c0 .565-.32 1.082-.824 1.335l-1.02.51-.195.097a2.986 2.986 0 0 0-1.65 2.67c0 .592-.235 1.158-.653 1.576l-.01.01a2.242 2.242 0 0 1-.59.424l-1.103.552c-.271.136-.57.207-.874.207-.303 0-.602.07-.874.206l-.042.021a2.156 2.156 0 0 1-2.49-.404l-.407-.407a2.957 2.957 0 0 0-.768-.553l-.21-.106a2.694 2.694 0 0 0-3.448.916l-.72 1.08a7.583 7.583 0 0 0-1.047 2.366l-.4 1.596a6.868 6.868 0 0 0-.204 1.666v2.407a1.057 1.057 0 0 1-1.644.88l-2.645-1.763a3.7 3.7 0 0 1-1.537-3.977 3.7 3.7 0 0 0-.154-2.271l-.786-1.963a5.911 5.911 0 0 0-1.941-2.534 5.911 5.911 0 0 1-2.364-4.73v-.79a6.42 6.42 0 0 1 3.116-5.505 6.42 6.42 0 0 0 2.333-2.43z\\"/><path fill=\\"#f4dfca\\" d=\\"m77.297 49.794-.773-1.933c-.368-.92-.26-1.96.29-2.785.598-.898.67-2.047.187-3.012l-1.422-2.845a3.768 3.768 0 0 1 1.28-4.821l.884-.442a2.15 2.15 0 0 1 1.923 0l.268.134a2.92 2.92 0 0 0 1.303.308c.762 0 1.512.177 2.193.517l2.655 1.328.342.171c.947.473 2.06.473 3.007 0 .225-.112.473-.17.724-.17h2.386l-.923 4.304.923 3.076 2.768 2.768-2.768 3.69.923 2.769v2.768l1.787 1.787c.036.036.05.088.038.138l-.276 1.103a1.822 1.822 0 0 1-2.778 1.074l-.045-.03a6.938 6.938 0 0 1-1.058-.867l-.414-.415a4.826 4.826 0 0 0-2.242-1.27l-.851-.212a3.109 3.109 0 0 1-2.133-1.861l-.546-1.365a1.757 1.757 0 0 0-2.417-.919.415.415 0 0 1-.286.032l-3.542-.886a6.357 6.357 0 0 1-1.407-2.134z\\"/><path fill=\\"#f4dfca\\" d=\\"M138.676 51.005c0-.127.197-.318.53-.563 4.42-3.25 2.99-7.754-2.361-8.96l-1.403-.315a5.54 5.54 0 0 0-2.738.078l-2.7.771a2.606 2.606 0 0 1-3.322-2.505v-3.04a5.913 5.913 0 0 0-1.296-3.694l-1.462-1.828a14.09 14.09 0 0 1-1.6-2.5 14.09 14.09 0 0 0-6.302-6.302l-1.335-.667-1.314-1.643a5.928 5.928 0 0 0-6.067-2.048l-3.19-.638a6.48 6.48 0 0 0-2.837.069c-1.151.288-2.277-.58-2.277-1.768a4.06 4.06 0 0 0-.812-2.436l-1.956-2.607-1.02-.383a8.442 8.442 0 0 0-10.052 3.319l-2.18 4.957a2.13 2.13 0 0 0 .443 2.364l.304.304c1.037 1.037.546 2.809-.877 3.164-.3.075-.615.075-.915 0l-1.388-.347a7.608 7.608 0 0 0-3.69 0l-1.846.462-6.13.922c-2.51.753-3.663 3.682-2.147 5.82.924 1.301 1.77 2.316 2.148 2.316.79 0 5.668-.81 12.588 1.09l2.768.924.317.211a5.822 5.822 0 0 0 5.219.627h2.768l-.923 4.697.923 2.908 2.768 2.628-2.768 3.69.922 2.769v2.768l1.846 1.845-.923 3.69L98.079 63l4.614-.923 2.768-1.845.596.398a26.352 26.352 0 0 1 4.017 3.293l2.768-.923 3.172 2.538a5.26 5.26 0 0 0 3.287 1.153v2.768h5.535l.923-1.846 2.768-.922h2.768l2.768.922c3.08 0 6.04-5.213 5.446-8.237-.792-4.034-.833-7.95-.833-8.37z\\"/><path stroke=\\"#2c2c2c\\" stroke-width=\\".4\\" d=\\"m77.666 34.14 2.04-1.8 1.576 1.8s2.476-1.124 5.966 2.027c0 0 2.476 0 2.476-1.013l2.14.338 1.462-1.238s1.689.338-.562 5.966l1.17 3.152 2.432 2.364v1.35l-2.702 2.928.9 2.026-.112 1.125-.113 2.364 1.35 1.689h1.915v1.463l-2.702 1.576 2.702 2.026-2.477 2.252-1.576-1.464-2.814 1.013 1.576 1.689-1.125 1.013h-1.126l-2.427.45v2.78l-1.175 1.95h-2.252l-1.463 1.573s-4.98-.225-5.08-2.589l-2.35.113-1.125 3.377.45 1.575-1.125.676.273 4.281\\"/><path stroke=\\"#2c2c2c\\" stroke-width=\\".4\\" d=\\"m76.77 46.969 1.134 1.358.45 2.364h3.603l1.013 1.126 1.126-1.126 3.039 5.403 3.49.565 1.238 1.912h2.476l1.529 1.125m1.736 2.588.9-1.238h4.615l1.8-1.351 2.253-1.463.675 2.589 2.364.112v1.351s3.828 0 3.715-.9l4.953 4.615 2.364-1.013v2.251l-.675 1.013h3.94l.675-1.575 1.463-.225.675-1.576 1.914.225 1.238-.338 4.71 1.568\\"/><path stroke=\\"#2c2c2c\\" stroke-width=\\".4\\" d=\\"M78.858 26.385c.688-.092.33.862.895.895 1.053-.103.77-.784.596-1.492 1.02.487.897-.035 1.492-.596 2.38.428 5.31 1.213 5.668-1.194.145-.98-.843-2.601-2.685-2.684-.14-.637.426-.569.895-.597-1.021-2.003 2.117-3.514 1.193-5.37 1.402-1.937 2.545-4.66 5.966-3.878.526.12 1.089 1.33 2.088 1.194.267 2.227.1 3.862-.895 5.668 1.502.387 2.24 1.538 4.176 1.491-.108 1.301 1.138 1.249 1.79 1.79 1.23-.53-.167-1.916.597-2.685 2.333-.146 3.374 1 4.176 2.387 2.007.217 2.11-1.47 4.474-.895l.15.447.447-.15v2.09c.707 1.182 2.006 1.77 2.983 2.684-1.056 1.3.044 2.312.597 3.58 2.82-.935 6.723-1.625 5.37 1.79.57 1.02 2.145 1.036 2.386 2.386.7-.095 1.12-.471 2.088-.298-.245 2.134.494 3.284 1.49 4.176-.31.882-1.51.876-1.192 2.386h-2.386c-.202 1.494.797 1.79 1.49 2.387-.946 2.4 1.102 4.224 1.195 6.563 1.23-.362 1.556-1.626 2.088-2.685 1.462.625 2.542 1.634 5.07 1.193.53-.564.218-1.97.299-2.983.78.084 1.493.1 1.193-.895 1.596-.005 1.802 1.38 2.983 1.79 1.435.241 1.078-1.309 2.685-.895.452.84-.1 1.224.298 2.387-1.537 1.147-1.953 3.416-3.281 4.773.273 2.269-1.162 2.234 1.193 4.176-.87 1.516-1.527 3.246-4.176 2.983-.136 2.36-.398 3.479-.3 4.773 1.53.757 3.84.735 5.073 1.79-.577 1.014-2.122 1.06-2.387 2.386 1.293.895 1.632 2.744 1.492 5.072-.513.68-1.436.95-1.79 1.79-.811 1.135.86 1.535 1.193 2.684.464 1.61-.39 3.486 1.492 3.878-.212 1.081-1.654.932-2.088 1.79-.206.802.616.577.894.895-.476.518-1.342.646-2.386.597-.66.037-.127 1.265-.298 1.79-3.884-.482-5.122 4.209-5.37 8.352.608.486 1.56.626 2.088 1.193.335 3.12-2.025 3.542-3.281 5.071.64 1.548 1.86 2.514 3.58 2.983-.093 1.624-.437 2.17.298 3.282h-1.194c-1.23.857-1.666 2.51-1.49 4.772-1.064 1.622-2.438 2.933-3.88 4.177 1.24 2.836.79 7.364 4.475 7.755.766 3.65-1.322 4.445-3.28 5.37-1.37-.322-1.692-1.689-2.09-2.983-1.445-.086-2.39.658-3.58 0-.56-2.919-2.422-4.537-4.175-6.265-1.38.756-2.2-.487-3.58-.596v-1.492c-.76.744-2.152-.33-2.684-.298-.487.029-.943.699-1.492.596-2.44-.455-3.924-2.951-6.86-3.281-.44-3.66-.8-6.278 1.49-8.65.195-2.034-3.046-2.623-1.192-4.475-1.385-1.363-2.823.474-4.177.895-3.655-.502-5.375-5.509-9.545-3.58-.675-.916-1.975-1.206-3.58-1.193-.631-1.656-3.214-1.36-3.878-2.983-1.515.772-4.153.42-5.071 1.79-1.163.068-1.547-.642-2.387-.896-.226-1.041.903-2.252 0-2.983.48-.759 1.314-.517 2.387-1.193-.211-1.107.51-1.28.298-2.387-.198-.796-.897-1.092-1.492-1.491.095-1.298.897-1.888 1.194-2.983-1.27-.123-.85-1.935-.895-3.282-.645-.672-1.018.247-2.088 0-.253-2.332-1.862-3.309-4.177-3.58.94-.685 1.042-1.93.597-3.28.823-.073.91-.88 1.193-1.492-.656-1.433-1.18-2.997-2.983-3.282.054-1.338.943-1.841 1.492-2.685-.67-2.116-2.945-2.623-3.878-4.474 1.346-1.14 2.537-2.434 2.684-4.773 1.394-1.062 2.788-1.362 3.58-2.685 1.386-2.313.56-6.188 3.28-7.458.972-.453 2.206.158 3.283-.298 1.35-.572 1.91-1.547 2.685-3.282-2.636-1.093-4.76-7.397-1.79-9.545-.516-1.175-2.19-1.192-3.878-1.194-.833-.46-.816-1.77-1.79-2.088-.81-.213.213 1.407-.597 1.194-1.69-.598-1.5-3.075-2.983-3.879l.508-.208.387-.388c2.902 1.171 4.71-.956 5.966-2.387.465.426-.581 2.587.895 2.685 1.324.23 1.2-.987 1.79-1.491l.447.149.448-.15v.002z\\"/></g></svg>","options":["Bregenz","Dornbirn","Feldkirch","Bludenz"],"defaultOption":"Bregenz","dropdownDefaultText":"Dein Bezirk"},{"headline":"VOL.AT News-Update","content":"Täglich die aktuellsten Nachrichten in deinem Postfach.","schedule":"Mo - So | 08:00 Uhr","list":"mh.com.vlbg: news","icon":"<svg width=\\"80\\" height=\\"80\\" viewBox=\\"0 0 80 80\\" fill=\\"none\\" xmlns=\\"http://www.w3.org/2000/svg\\">\\n        <circle cx=\\"40\\" cy=\\"40\\" r=\\"40\\" fill=\\"white\\"/>\\n        <path fill-rule=\\"evenodd\\" clip-rule=\\"evenodd\\" d=\\"M65.7146 14.2874C79.9138 28.4866 79.9138 51.5126 65.7146 65.7142C51.5131 79.9157 28.4895 79.9157 14.2879 65.7142C0.0863266 51.5126 0.0863266 28.489 14.2879 14.2874C28.4895 0.0858381 51.5131 0.0858381 65.7146 14.2874Z\\" fill=\\"#FFD200\\"/>\\n        <path fill-rule=\\"evenodd\\" clip-rule=\\"evenodd\\" d=\\"M19.771 44.3639H17.1721L13.6211 34.093H16.3407L17.9518 39.4306L18.6624 41.8442H18.7492L19.5286 39.5015L21.3478 34.093H23.8945L19.771 44.3639Z\\" fill=\\"black\\"/>\\n        <path fill-rule=\\"evenodd\\" clip-rule=\\"evenodd\\" d=\\"M35.9175 34.093H38.3601V42.4787H42.5355V44.3639H35.9175V34.093Z\\" fill=\\"black\\"/>\\n        <path fill-rule=\\"evenodd\\" clip-rule=\\"evenodd\\" d=\\"M43.5576 43.2187C43.5576 42.4968 44.1293 41.8442 44.9089 41.8442C45.723 41.8442 46.2425 42.4786 46.2425 43.2187C46.2425 43.8702 45.7056 44.5046 44.9089 44.5046C44.1293 44.5046 43.5576 43.8878 43.5576 43.2187Z\\" fill=\\"black\\"/>\\n        <path fill-rule=\\"evenodd\\" clip-rule=\\"evenodd\\" d=\\"M50.7819 40.0124H53.0514L52.7917 39.0957L52.0984 36.5587H52.0121L51.1112 39.0957L50.7819 40.0124ZM50.9726 34.0928H53.45L56.8455 44.3637H54.2641L53.5713 41.897H50.1235L49.275 44.3637H46.9878L50.9726 34.0928Z\\" fill=\\"black\\"/>\\n        <path fill-rule=\\"evenodd\\" clip-rule=\\"evenodd\\" d=\\"M56.2729 34.093H65.4544V35.9777H62.0589V44.3639H59.6164V35.9777H56.2729V34.093Z\\" fill=\\"black\\"/>\\n        <path fill-rule=\\"evenodd\\" clip-rule=\\"evenodd\\" d=\\"M29.1964 42.327C27.5131 42.327 26.149 40.9395 26.149 39.2273C26.149 37.516 27.5131 36.1283 29.1964 36.1283C30.8795 36.1283 32.2441 37.516 32.2441 39.2273C32.2441 40.9395 30.8795 42.327 29.1964 42.327ZM29.1964 33.8987C26.3021 33.8987 23.9561 36.2844 23.9561 39.2276C23.9561 42.171 26.3021 44.5571 29.1964 44.5571C32.0908 44.5571 34.4372 42.171 34.4372 39.2276C34.4372 36.2844 32.0908 33.8987 29.1964 33.8987Z\\" fill=\\"black\\"/>\\n        </svg>","image":"<svg xmlns=\\"http://www.w3.org/2000/svg\\" viewBox=\\"0 0 203 139\\" preserveAspectRatio=\\"xMidYMid slice\\" fill=\\"none\\"><path fill=\\"#ffd200\\" d=\\"M0 0h203v139H0z\\"/><g fill-rule=\\"evenodd\\" clip-rule=\\"evenodd\\" style=\\"fill:none\\"><path fill=\\"#ffd200\\" d=\\"M17.672 99.319h167.657v-60.15H17.672Z\\"/><path fill=\\"#000\\" d=\\"M46.776 83.35h-7.194l-9.83-28.212h7.53l4.46 14.662 1.966 6.63h.24l2.158-6.436 5.037-14.856h7.05zm44.702-28.212h6.763v23.034h11.558v5.179H91.48Zm21.15 25.067c0-1.983 1.584-3.775 3.74-3.775 2.256 0 3.694 1.742 3.694 3.775 0 1.79-1.488 3.532-3.693 3.532-2.158 0-3.74-1.694-3.74-3.532zm19.998-8.806h6.282l-.719-2.518-1.919-6.97h-.239l-2.494 6.97zm.528-16.261h6.858l9.4 28.213h-7.146l-1.917-6.776h-9.545l-2.35 6.776h-6.331zm14.763.458h25.418v5.178h-9.4v23.035h-6.762V60.774h-9.256zM72.87 77.758c-4.66 0-8.437-3.812-8.437-8.515 0-4.7 3.777-8.513 8.437-8.513 4.66 0 8.437 3.812 8.437 8.513 0 4.703-3.778 8.515-8.437 8.515zm0-23.153c-8.013 0-14.508 6.553-14.508 14.638s6.495 14.64 14.508 14.64c8.012 0 14.508-6.555 14.508-14.64s-6.496-14.638-14.507-14.638z\\"/></g></svg>","isChecked":true},{"headline":"Ländlepunkte","content":"Erhalte wöchentlich eine übersichtliche Darstellung der aktuellen Gewinnspiele und Sofortpreise.","schedule":"montags | 08:00 Uhr","list":"mh.com.vlbg: Laendlepunkte.OptIN","icon":"<svg width=\\"80\\" height=\\"80\\" viewBox=\\"0 0 80 80\\" fill=\\"none\\" xmlns=\\"http://www.w3.org/2000/svg\\">\\n        <circle cx=\\"40\\" cy=\\"40\\" r=\\"40\\" fill=\\"white\\"/>\\n        <mask id=\\"mask0_4013_3624\\" style=\\"mask-type:luminance\\" maskUnits=\\"userSpaceOnUse\\" x=\\"3\\" y=\\"3\\" width=\\"74\\" height=\\"74\\">\\n        <path fill-rule=\\"evenodd\\" clip-rule=\\"evenodd\\" d=\\"M3.63623 3.63647H76.3617V76.3635H3.63623V3.63647Z\\" fill=\\"white\\"/>\\n        </mask>\\n        <g mask=\\"url(#mask0_4013_3624)\\">\\n        <path fill-rule=\\"evenodd\\" clip-rule=\\"evenodd\\" d=\\"M65.7128 14.2874C79.9116 28.4863 79.9116 51.5118 65.7128 65.7131C51.5115 79.9143 28.4884 79.9143 14.2872 65.7131C0.0859156 51.5118 0.0859156 28.4887 14.2872 14.2874C28.4884 0.0861595 51.5115 0.0861595 65.7128 14.2874Z\\" fill=\\"#FFD200\\"/>\\n        </g>\\n        <path fill-rule=\\"evenodd\\" clip-rule=\\"evenodd\\" d=\\"M65.7127 14.2859C79.914 28.4871 79.914 51.5103 65.7127 65.7115C51.5139 79.9128 28.4884 79.9128 14.2871 65.7115\\" fill=\\"#FFC200\\"/>\\n        <path d=\\"M10.8823 48.2956L17.2242 40.5962L24.1066 48.2956\\" stroke=\\"#F9EDCE\\" stroke-width=\\"3.52941\\"/>\\n        <path d=\\"M20.8613 44.2314L34.3523 26.8083L49.5596 48.6266\\" stroke=\\"#F9EDCE\\" stroke-width=\\"3.52941\\"/>\\n        <path d=\\"M41.2241 37.6869L49.5587 29.4541L58.1551 42.0141L63.4448 38.0481L70.7176 48.6275\\" stroke=\\"#F9EDCE\\" stroke-width=\\"3.52941\\"/>\\n        </svg>\\n        ","image":"<svg xmlns=\\"http://www.w3.org/2000/svg\\" viewBox=\\"0 0 203 139\\" preserveAspectRatio=\\"xMidYMid slice\\" fill=\\"none\\"><path fill=\\"#ffd200\\" d=\\"M0 0h203v139H0z\\"/><g stroke=\\"#f9edce\\" stroke-width=\\"3.162\\" style=\\"fill:none\\"><path d=\\"m37.285 93.166 13.603-16.515 14.763 16.515M58.689 84.45l28.938-37.373 32.62 46.8\\"/><path d=\\"m102.369 70.41 17.877-17.659 18.44 26.942 11.347-8.508 15.6 22.693\\"/></g></svg>","isChecked":true},{"headline":"VN am Morgen","content":"Gleich am Morgen die wichtigsten Themen des Tages lesen.","schedule":"Mo - Sa | 06:00 Uhr","list":"eugenruss.vlbg: vn.newsletter","icon":"<svg width=\\"44\\" height=\\"44\\" viewBox=\\"0 0 44 44\\" fill=\\"none\\" xmlns=\\"http://www.w3.org/2000/svg\\">\\n        <circle cx=\\"22\\" cy=\\"22\\" r=\\"20\\" fill=\\"#E30613\\"/>\\n        <path d=\\"M25.2063 22.4678C25.2063 21.006 25.1834 18.6199 25.0691 17.8246C25.4785 18.6199 26.8452 20.9289 27.5509 22.0315L31.3537 27.957H34.9517V10H30.7155V14.8999C30.7155 16.3616 30.7383 18.7477 30.8516 19.543C30.5096 18.7995 29.0983 16.4134 28.3698 15.3108L24.862 10H20.9678V27.957H25.204V22.4678H25.2063Z\\" fill=\\"#85C9F0\\"/>\\n        <path d=\\"M21.7572 32.2767H21.3203V34.9574H21.7572V32.2767Z\\" fill=\\"white\\"/>\\n        <path d=\\"M16.2884 29.6754C16.2884 29.1863 16.0951 28.8594 15.4398 28.8594H14.6357V31.5401H15.0726V30.5594H15.3871C15.4169 30.5594 15.4432 30.5594 15.4718 30.556L15.8938 31.5401H16.3719L15.8675 30.4512C16.1305 30.3096 16.2861 30.0449 16.2861 29.6754H16.2884ZM15.3849 30.1934H15.0738V29.2392H15.4329C15.6959 29.2392 15.8401 29.3543 15.8401 29.687C15.8401 30.0196 15.6662 30.1945 15.3849 30.1945V30.1934Z\\" fill=\\"white\\"/>\\n        <path d=\\"M17.3849 28.8582L16.5957 31.5389H17.044L17.2259 30.8563H18.0482L18.2335 31.5389H18.6852L17.9075 28.8582H17.3849ZM17.3071 30.4983L17.633 29.2645L17.9704 30.4983H17.3071Z\\" fill=\\"white\\"/>\\n        <path d=\\"M18.1333 33.4105H17.1783V32.2767H16.7402V34.9574H17.1783V33.8168H18.1333V34.9574H18.5667V32.2767H18.1333V33.4105Z\\" fill=\\"white\\"/>\\n        <path d=\\"M30.1837 29.2162C30.3872 29.2162 30.6057 29.2795 30.7361 29.3428H30.7475L30.7098 28.925C30.6023 28.8801 30.3907 28.8168 30.1471 28.8168C29.3545 28.8168 29.0137 29.4729 29.0137 30.2153C29.0137 30.9577 29.3065 31.5804 30.0659 31.5804C30.3735 31.5804 30.6926 31.4986 30.8184 31.4204V30.1968H30.0361V30.5479H30.3987V31.1407C30.3575 31.1637 30.2546 31.2005 30.099 31.2005C29.669 31.2005 29.462 30.8126 29.462 30.2199C29.462 29.459 29.8028 29.2162 30.1848 29.2162H30.1837Z\\" fill=\\"white\\"/>\\n        <path d=\\"M19.4939 30.5582H19.8084C19.8381 30.5582 19.8644 30.5582 19.893 30.5547L20.315 31.5389H20.7931L20.2887 30.45C20.5518 30.3084 20.7073 30.0437 20.7073 29.6742C20.7073 29.185 20.5152 28.8582 19.8587 28.8582H19.0547V31.5389H19.4916V30.5582H19.4939ZM19.4939 29.238H19.853C20.116 29.238 20.2601 29.3531 20.2601 29.6857C20.2601 30.0184 20.0863 30.1933 19.8038 30.1933H19.4927V29.2391H19.4939V29.238Z\\" fill=\\"white\\"/>\\n        <path d=\\"M20.8128 33.0939C20.8128 32.6059 20.6207 32.2778 19.9642 32.2778H19.1602V34.9585H19.597V33.9779H19.9116C19.9413 33.9779 19.9665 33.9779 19.9962 33.9744L20.4182 34.9585H20.8963L20.3919 33.8697C20.655 33.7281 20.8105 33.4634 20.8105 33.0939H20.8128ZM19.9093 33.6119H19.5982V32.6577H19.9573C20.2204 32.6577 20.3645 32.7728 20.3645 33.1054C20.3645 33.4381 20.1906 33.613 19.9093 33.613V33.6119Z\\" fill=\\"white\\"/>\\n        <path d=\\"M28.6722 29.6754C28.6722 29.1863 28.4789 28.8594 27.8235 28.8594H27.0195V31.5401H27.4564V30.5594H27.7709C27.8007 30.5594 27.827 30.5594 27.8567 30.556L28.2787 31.5401H28.7568L28.2524 30.4512C28.5155 30.3096 28.671 30.0449 28.671 29.6754H28.6722ZM27.7675 30.1934H27.4564V29.2392H27.8155C28.0786 29.2392 28.2227 29.3543 28.2227 29.687C28.2227 30.0196 28.0489 30.1945 27.7664 30.1945H27.7675V30.1934Z\\" fill=\\"white\\"/>\\n        <path d=\\"M11.011 31.0773H11.0007L10.4552 28.8582H10L10.7297 31.5389H11.2558L12.0083 28.8582H11.5783L11.011 31.0773Z\\" fill=\\"white\\"/>\\n        <path d=\\"M11.5965 34.3463H11.5851L10.6999 32.2767H10.1475V34.9574H10.5443V32.9075H10.5512L11.4524 34.9574H11.9888V32.2767H11.5965V34.3463Z\\" fill=\\"white\\"/>\\n        <path d=\\"M13.1502 31.5804C13.9062 31.5804 14.1989 30.9093 14.1989 30.1519C14.1989 29.3946 13.9279 28.8168 13.2028 28.8168C12.4777 28.8168 12.1426 29.4176 12.1426 30.2371C12.1426 30.9231 12.4022 31.5792 13.1502 31.5792V31.5804ZM13.1913 29.2047C13.6065 29.2047 13.7586 29.5695 13.7586 30.1704C13.7586 30.8449 13.5516 31.1925 13.1696 31.1925C12.7876 31.1925 12.5806 30.8978 12.5806 30.2118C12.5806 29.5258 12.8071 29.2047 13.1913 29.2047Z\\" fill=\\"white\\"/>\\n        <path d=\\"M15.7473 34.6041C15.1984 34.6041 15.0691 34.0631 15.0691 33.62C15.0691 32.9489 15.347 32.6359 15.7359 32.6359C15.9177 32.6359 16.1362 32.6957 16.2654 32.751H16.2803L16.2391 32.3446C16.135 32.2998 15.9349 32.2365 15.6867 32.2365C14.9673 32.2365 14.6162 32.8776 14.6162 33.6614C14.6162 34.4452 14.9422 35 15.6684 35C15.8949 35 16.143 34.9367 16.2574 34.8803L16.294 34.4809H16.2791C16.135 34.5477 15.9315 34.6041 15.7462 34.6041H15.7473Z\\" fill=\\"white\\"/>\\n        <path d=\\"M13.1495 32.2767L12.3604 34.9574H12.8087L12.9905 34.2749H13.8128L13.9981 34.9574H14.4499L13.6722 32.2767H13.1495ZM13.0717 33.9169L13.3977 32.683L13.7351 33.9169H13.0717Z\\" fill=\\"white\\"/>\\n        <path d=\\"M31.3555 31.5389H32.7634V31.159H31.7924V30.3568H32.633V29.9884H31.7924V29.2426H32.7634V28.8582H31.3555V31.5389Z\\" fill=\\"white\\"/>\\n        <path d=\\"M26.5596 32.683H27.2309V34.9574H27.6678V32.683H28.3163V32.2767H26.5596V32.683Z\\" fill=\\"white\\"/>\\n        <path d=\\"M25.1104 31.5389H26.5194V31.159H25.5484V30.3568H26.389V29.9884H25.5484V29.2426H26.5194V28.8582H25.1104V31.5389Z\\" fill=\\"white\\"/>\\n        <path d=\\"M25.7622 33.4105H24.8072V32.2767H24.3691V34.9574H24.8072V33.8168H25.7622V34.9574H26.1956V32.2767H25.7622V33.4105Z\\" fill=\\"white\\"/>\\n        <path d=\\"M28.6787 34.9574H30.0866V34.5776H29.1167V33.7754H29.9574V33.407H29.1167V32.6612H30.0866V32.2767H28.6787V34.9574Z\\" fill=\\"white\\"/>\\n        <path d=\\"M34.9153 29.6754C34.9153 29.1863 34.7232 28.8594 34.0667 28.8594H33.2627V31.5401H33.6996V30.5594H34.0141C34.0438 30.5594 34.0701 30.5594 34.0999 30.556L34.5219 31.5401H35L34.4956 30.4512C34.7586 30.3096 34.9142 30.0449 34.9142 29.6754H34.9153ZM34.0118 30.1934H33.7007V29.2392H34.0598C34.3229 29.2392 34.467 29.3543 34.467 29.687C34.467 30.0196 34.2932 30.1945 34.0118 30.1945V30.1934Z\\" fill=\\"white\\"/>\\n        <path d=\\"M23.3762 34.6041C22.8284 34.6041 22.698 34.0631 22.698 33.62C22.698 32.9489 22.9759 32.6359 23.3648 32.6359C23.5466 32.6359 23.7651 32.6957 23.8943 32.751H23.9092L23.868 32.3446C23.7639 32.2998 23.5638 32.2365 23.3156 32.2365C22.5962 32.2365 22.2451 32.8776 22.2451 33.6614C22.2451 34.4452 22.5711 35 23.2973 35C23.5238 35 23.7719 34.9367 23.8863 34.8803L23.9241 34.4809H23.9092C23.7651 34.5477 23.5615 34.6041 23.3762 34.6041Z\\" fill=\\"white\\"/>\\n        <path d=\\"M32.037 34.3463H32.0255L31.1403 32.2767H30.5879V34.9574H30.9848V32.9075H30.9916L31.8917 34.9574H32.4292V32.2767H32.037V34.3463Z\\" fill=\\"white\\"/>\\n        <path d=\\"M22.5793 31.159H21.6392V28.8582H21.2012V31.5389H22.5793V31.159Z\\" fill=\\"white\\"/>\\n        <path d=\\"M24.5625 29.4993C24.5625 29.0999 24.3772 28.8582 23.8626 28.8582H23.0254V31.5389H23.8363C24.4287 31.5389 24.6735 31.2373 24.6735 30.7861C24.6735 30.3349 24.4516 30.1703 24.1588 30.1415V30.1346C24.415 30.0633 24.5625 29.8469 24.5625 29.5004V29.4993ZM23.4623 29.238H23.8065C24.0181 29.238 24.1474 29.3163 24.1474 29.5775C24.1474 29.8388 23.9884 29.9919 23.7322 29.9919H23.4623V29.2391V29.238ZM24.2217 30.7412C24.2217 31.0209 24.0845 31.159 23.7802 31.159H23.4611V30.3614H23.7951C24.0215 30.3614 24.2217 30.4178 24.2217 30.7412Z\\" fill=\\"white\\"/>\\n        <path d=\\"M17.5493 22.0315C18.1897 21.0302 19.3746 19.0355 19.895 18.0813V10.5168L16.7293 15.3096C16.0007 16.4123 14.5883 18.7983 14.2463 19.543C14.3607 18.7477 14.3835 16.3616 14.3835 14.8999V10H10.1484V27.957H13.7465L17.5493 22.0315Z\\" fill=\\"white\\"/>\\n        </svg>        \\n        ","image":"<svg xmlns=\\"http://www.w3.org/2000/svg\\" viewBox=\\"0 0 203 139\\" preserveAspectRatio=\\"xMidYMid slice\\" fill=\\"none\\"><path fill=\\"#E3051B\\" d=\\"M0 0h203v139H0z\\"/><g style=\\"fill:none\\"><path fill=\\"#e30613\\" d=\\"M149.458 21.53H53.542v95.94h95.916z\\"/><path fill=\\"#fff\\" d=\\"M104.39 109.457c-1.772 0-2.237-1.772-2.237-3.26 0-2.237.93-3.26 2.237-3.26.558 0 1.301.186 1.771.372h.093l-.093-1.302c-.372-.186-1.022-.372-1.864-.372-2.33 0-3.538 2.144-3.538 4.655s1.115 4.376 3.445 4.376c.744 0 1.58-.186 1.957-.372l.093-1.302h-.093c-.465.279-1.115.465-1.771.465zM99.08 101.821h-1.396v8.757h1.395zM121.897 93.25c0-1.58-.651-2.702-2.794-2.702H116.4v8.757h1.395v-3.26h1.302l1.394 3.26h1.581l-1.679-3.539c.93-.372 1.488-1.302 1.488-2.516m-2.965 1.772h-1.023v-3.167h1.209c.836 0 1.301.372 1.301 1.488s-.558 1.68-1.487 1.68zM114.915 103.128h2.231v7.45h1.4v-7.45h2.139v-1.307h-5.77ZM97.218 90.646v8.752h4.56v-1.302h-3.073v-7.45zM110.163 99.398h4.659v-1.302h-3.264v-2.609h2.794v-1.209h-2.794v-2.423h3.264v-1.209h-4.66zM112.307 105.546h-3.166v-3.725h-1.4v8.757h1.4v-3.725h3.166v3.725h1.395v-8.757h-1.395ZM84.646 90.646l-2.608 8.757h1.488l.558-2.237h2.7l.652 2.237h1.487l-2.608-8.757h-1.679zm-.279 5.306 1.116-4.004 1.116 4.004h-2.237zM65.558 108.62l-2.98-6.799h-1.767v8.757h1.302v-6.706l2.98 6.706h1.772v-8.757h-1.307zM70.681 99.491c2.516 0 3.445-2.237 3.445-4.655s-.93-4.376-3.259-4.376c-2.33 0-3.538 1.958-3.538 4.655 0 2.237.93 4.376 3.352 4.376zm.186-7.729c1.395 0 1.865 1.21 1.865 3.167 0 2.237-.651 3.353-1.958 3.353-1.209 0-1.957-.93-1.957-3.26 0-2.144.743-3.26 2.05-3.26zM70.681 101.821l-2.608 8.757h1.488l.558-2.237h2.7l.652 2.237h1.487l-2.608-8.757h-1.678zm-.279 5.404 1.116-4.004 1.116 4.004h-2.236zM79.244 109.457c-1.771 0-2.236-1.772-2.236-3.26 0-2.237.93-3.26 2.236-3.26.558 0 1.302.186 1.772.372l-.093-1.302c-.372-.186-1.023-.372-1.865-.372-2.329 0-3.538 2.144-3.538 4.655s1.116 4.376 3.445 4.376c.744 0 1.581-.186 1.958-.372l.093-1.302c-.465.279-1.116.465-1.772.465zM87.163 105.546h-3.166v-3.725h-1.492v8.757h1.492v-3.725h3.166v3.725h1.395v-8.757h-1.395zM81.017 93.25c0-1.58-.651-2.702-2.795-2.702h-2.608v8.757h1.395v-3.26h1.301l1.395 3.26h1.58l-1.678-3.539c.93-.372 1.395-1.302 1.395-2.516m-2.966 1.772h-1.022v-3.167h1.208c.837 0 1.302.372 1.302 1.488s-.558 1.68-1.488 1.68zM108.3 92.692c0-1.302-.65-2.144-2.33-2.144h-2.793v8.757h2.7c1.958 0 2.795-1.023 2.795-2.516s-.744-2.05-1.678-2.144c.836-.093 1.301-.837 1.301-1.958m-3.626-.832h1.116c.65 0 1.116.279 1.116 1.116 0 .93-.558 1.395-1.395 1.395h-.93V91.85h.093zm2.515 4.939c0 .93-.464 1.395-1.487 1.395h-1.023V95.58h1.116c.744-.093 1.394.093 1.394 1.21M90.142 90.646v8.757h1.395v-3.26h1.302l1.395 3.26h1.58l-1.678-3.539c.837-.465 1.394-1.302 1.394-2.516 0-1.58-.65-2.702-2.794-2.702h-2.608zm4.004 2.697c0 1.116-.558 1.68-1.488 1.68h-1.023v-3.168h1.209c.837 0 1.302.372 1.302 1.488zM96.01 104.523c0-1.58-.65-2.702-2.794-2.702h-2.608v8.757h1.395v-3.26h1.302l1.394 3.26h1.581l-1.679-3.539c.837-.465 1.395-1.302 1.395-2.516m-2.965 1.674h-1.023v-3.167h1.209c.836 0 1.301.372 1.301 1.488s-.65 1.68-1.487 1.68zM85.205 68.198c2.144-3.26 6.054-9.78 7.728-12.947V30.472L82.504 46.215c-2.422 3.632-7.076 11.366-8.197 13.877.372-2.61.465-10.431.465-15.184V28.793H60.805V87.66h11.828l12.572-19.467ZM64.442 99.398l2.515-8.752h-1.493L63.6 97.91l-1.767-7.264h-1.492l2.329 8.752zM121.897 110.578h4.654v-1.214h-3.166v-2.604h2.701v-1.214h-2.701v-2.516h3.166v-1.209h-4.654zM142.476 93.25c0-1.58-.651-2.702-2.795-2.702h-2.608v8.757h1.395v-3.26h1.302l1.394 3.26h1.58l-1.678-3.539c.93-.372 1.395-1.302 1.395-2.516m-2.966 1.772h-1.022v-3.167h1.208c.837 0 1.302.372 1.302 1.488s-.558 1.68-1.488 1.68zM130.74 99.398h4.658v-1.302h-3.26v-2.609h2.795v-1.209h-2.794v-2.423h3.259v-1.209h-4.659zM132.978 108.62l-2.98-6.799h-1.767v8.757h1.302v-6.706l2.98 6.706h1.772v-8.757h-1.307zM126.83 91.762c.65 0 1.394.186 1.864.372l-.093-1.395c-.372-.186-1.023-.372-1.864-.372-2.609 0-3.724 2.144-3.724 4.562s.93 4.47 3.445 4.47c1.022 0 2.05-.28 2.515-.559v-4.004h-2.608v1.116h1.208v1.958c-.093.093-.465.186-1.022.186-1.395 0-2.144-1.302-2.144-3.26.093-2.237 1.209-3.074 2.423-3.074z\\"/><path fill=\\"#85c9f0\\" d=\\"M110.442 69.686c0-4.748-.093-12.575-.465-15.184 1.395 2.609 5.868 10.152 8.197 13.784l12.572 19.467h11.828v-58.96h-13.967v16.022c0 4.748.093 12.575.465 15.184-1.115-2.423-5.774-10.245-8.197-13.877l-11.549-17.416h-12.85v58.866h13.966z\\"/></g></svg>","isChecked":true},{"headline":"5 nach 5","content":"Die aktuellsten Artikel um 5 nach 5.","schedule":"So - Fr | 17:05 Uhr","list":"eugenruss.vlbg: vn.abendnewsletter","icon":"<svg width=\\"44\\" height=\\"44\\" viewBox=\\"0 0 44 44\\" fill=\\"none\\" xmlns=\\"http://www.w3.org/2000/svg\\">\\n        <circle cx=\\"22\\" cy=\\"22\\" r=\\"20\\" fill=\\"#E30613\\"/>\\n        <path d=\\"M25.2063 22.4678C25.2063 21.006 25.1834 18.6199 25.0691 17.8246C25.4785 18.6199 26.8452 20.9289 27.5509 22.0315L31.3537 27.957H34.9517V10H30.7155V14.8999C30.7155 16.3616 30.7383 18.7477 30.8516 19.543C30.5096 18.7995 29.0983 16.4134 28.3698 15.3108L24.862 10H20.9678V27.957H25.204V22.4678H25.2063Z\\" fill=\\"#85C9F0\\"/>\\n        <path d=\\"M21.7572 32.2767H21.3203V34.9574H21.7572V32.2767Z\\" fill=\\"white\\"/>\\n        <path d=\\"M16.2884 29.6754C16.2884 29.1863 16.0951 28.8594 15.4398 28.8594H14.6357V31.5401H15.0726V30.5594H15.3871C15.4169 30.5594 15.4432 30.5594 15.4718 30.556L15.8938 31.5401H16.3719L15.8675 30.4512C16.1305 30.3096 16.2861 30.0449 16.2861 29.6754H16.2884ZM15.3849 30.1934H15.0738V29.2392H15.4329C15.6959 29.2392 15.8401 29.3543 15.8401 29.687C15.8401 30.0196 15.6662 30.1945 15.3849 30.1945V30.1934Z\\" fill=\\"white\\"/>\\n        <path d=\\"M17.3849 28.8582L16.5957 31.5389H17.044L17.2259 30.8563H18.0482L18.2335 31.5389H18.6852L17.9075 28.8582H17.3849ZM17.3071 30.4983L17.633 29.2645L17.9704 30.4983H17.3071Z\\" fill=\\"white\\"/>\\n        <path d=\\"M18.1333 33.4105H17.1783V32.2767H16.7402V34.9574H17.1783V33.8168H18.1333V34.9574H18.5667V32.2767H18.1333V33.4105Z\\" fill=\\"white\\"/>\\n        <path d=\\"M30.1837 29.2162C30.3872 29.2162 30.6057 29.2795 30.7361 29.3428H30.7475L30.7098 28.925C30.6023 28.8801 30.3907 28.8168 30.1471 28.8168C29.3545 28.8168 29.0137 29.4729 29.0137 30.2153C29.0137 30.9577 29.3065 31.5804 30.0659 31.5804C30.3735 31.5804 30.6926 31.4986 30.8184 31.4204V30.1968H30.0361V30.5479H30.3987V31.1407C30.3575 31.1637 30.2546 31.2005 30.099 31.2005C29.669 31.2005 29.462 30.8126 29.462 30.2199C29.462 29.459 29.8028 29.2162 30.1848 29.2162H30.1837Z\\" fill=\\"white\\"/>\\n        <path d=\\"M19.4939 30.5582H19.8084C19.8381 30.5582 19.8644 30.5582 19.893 30.5547L20.315 31.5389H20.7931L20.2887 30.45C20.5518 30.3084 20.7073 30.0437 20.7073 29.6742C20.7073 29.185 20.5152 28.8582 19.8587 28.8582H19.0547V31.5389H19.4916V30.5582H19.4939ZM19.4939 29.238H19.853C20.116 29.238 20.2601 29.3531 20.2601 29.6857C20.2601 30.0184 20.0863 30.1933 19.8038 30.1933H19.4927V29.2391H19.4939V29.238Z\\" fill=\\"white\\"/>\\n        <path d=\\"M20.8128 33.0939C20.8128 32.6059 20.6207 32.2778 19.9642 32.2778H19.1602V34.9585H19.597V33.9779H19.9116C19.9413 33.9779 19.9665 33.9779 19.9962 33.9744L20.4182 34.9585H20.8963L20.3919 33.8697C20.655 33.7281 20.8105 33.4634 20.8105 33.0939H20.8128ZM19.9093 33.6119H19.5982V32.6577H19.9573C20.2204 32.6577 20.3645 32.7728 20.3645 33.1054C20.3645 33.4381 20.1906 33.613 19.9093 33.613V33.6119Z\\" fill=\\"white\\"/>\\n        <path d=\\"M28.6722 29.6754C28.6722 29.1863 28.4789 28.8594 27.8235 28.8594H27.0195V31.5401H27.4564V30.5594H27.7709C27.8007 30.5594 27.827 30.5594 27.8567 30.556L28.2787 31.5401H28.7568L28.2524 30.4512C28.5155 30.3096 28.671 30.0449 28.671 29.6754H28.6722ZM27.7675 30.1934H27.4564V29.2392H27.8155C28.0786 29.2392 28.2227 29.3543 28.2227 29.687C28.2227 30.0196 28.0489 30.1945 27.7664 30.1945H27.7675V30.1934Z\\" fill=\\"white\\"/>\\n        <path d=\\"M11.011 31.0773H11.0007L10.4552 28.8582H10L10.7297 31.5389H11.2558L12.0083 28.8582H11.5783L11.011 31.0773Z\\" fill=\\"white\\"/>\\n        <path d=\\"M11.5965 34.3463H11.5851L10.6999 32.2767H10.1475V34.9574H10.5443V32.9075H10.5512L11.4524 34.9574H11.9888V32.2767H11.5965V34.3463Z\\" fill=\\"white\\"/>\\n        <path d=\\"M13.1502 31.5804C13.9062 31.5804 14.1989 30.9093 14.1989 30.1519C14.1989 29.3946 13.9279 28.8168 13.2028 28.8168C12.4777 28.8168 12.1426 29.4176 12.1426 30.2371C12.1426 30.9231 12.4022 31.5792 13.1502 31.5792V31.5804ZM13.1913 29.2047C13.6065 29.2047 13.7586 29.5695 13.7586 30.1704C13.7586 30.8449 13.5516 31.1925 13.1696 31.1925C12.7876 31.1925 12.5806 30.8978 12.5806 30.2118C12.5806 29.5258 12.8071 29.2047 13.1913 29.2047Z\\" fill=\\"white\\"/>\\n        <path d=\\"M15.7473 34.6041C15.1984 34.6041 15.0691 34.0631 15.0691 33.62C15.0691 32.9489 15.347 32.6359 15.7359 32.6359C15.9177 32.6359 16.1362 32.6957 16.2654 32.751H16.2803L16.2391 32.3446C16.135 32.2998 15.9349 32.2365 15.6867 32.2365C14.9673 32.2365 14.6162 32.8776 14.6162 33.6614C14.6162 34.4452 14.9422 35 15.6684 35C15.8949 35 16.143 34.9367 16.2574 34.8803L16.294 34.4809H16.2791C16.135 34.5477 15.9315 34.6041 15.7462 34.6041H15.7473Z\\" fill=\\"white\\"/>\\n        <path d=\\"M13.1495 32.2767L12.3604 34.9574H12.8087L12.9905 34.2749H13.8128L13.9981 34.9574H14.4499L13.6722 32.2767H13.1495ZM13.0717 33.9169L13.3977 32.683L13.7351 33.9169H13.0717Z\\" fill=\\"white\\"/>\\n        <path d=\\"M31.3555 31.5389H32.7634V31.159H31.7924V30.3568H32.633V29.9884H31.7924V29.2426H32.7634V28.8582H31.3555V31.5389Z\\" fill=\\"white\\"/>\\n        <path d=\\"M26.5596 32.683H27.2309V34.9574H27.6678V32.683H28.3163V32.2767H26.5596V32.683Z\\" fill=\\"white\\"/>\\n        <path d=\\"M25.1104 31.5389H26.5194V31.159H25.5484V30.3568H26.389V29.9884H25.5484V29.2426H26.5194V28.8582H25.1104V31.5389Z\\" fill=\\"white\\"/>\\n        <path d=\\"M25.7622 33.4105H24.8072V32.2767H24.3691V34.9574H24.8072V33.8168H25.7622V34.9574H26.1956V32.2767H25.7622V33.4105Z\\" fill=\\"white\\"/>\\n        <path d=\\"M28.6787 34.9574H30.0866V34.5776H29.1167V33.7754H29.9574V33.407H29.1167V32.6612H30.0866V32.2767H28.6787V34.9574Z\\" fill=\\"white\\"/>\\n        <path d=\\"M34.9153 29.6754C34.9153 29.1863 34.7232 28.8594 34.0667 28.8594H33.2627V31.5401H33.6996V30.5594H34.0141C34.0438 30.5594 34.0701 30.5594 34.0999 30.556L34.5219 31.5401H35L34.4956 30.4512C34.7586 30.3096 34.9142 30.0449 34.9142 29.6754H34.9153ZM34.0118 30.1934H33.7007V29.2392H34.0598C34.3229 29.2392 34.467 29.3543 34.467 29.687C34.467 30.0196 34.2932 30.1945 34.0118 30.1945V30.1934Z\\" fill=\\"white\\"/>\\n        <path d=\\"M23.3762 34.6041C22.8284 34.6041 22.698 34.0631 22.698 33.62C22.698 32.9489 22.9759 32.6359 23.3648 32.6359C23.5466 32.6359 23.7651 32.6957 23.8943 32.751H23.9092L23.868 32.3446C23.7639 32.2998 23.5638 32.2365 23.3156 32.2365C22.5962 32.2365 22.2451 32.8776 22.2451 33.6614C22.2451 34.4452 22.5711 35 23.2973 35C23.5238 35 23.7719 34.9367 23.8863 34.8803L23.9241 34.4809H23.9092C23.7651 34.5477 23.5615 34.6041 23.3762 34.6041Z\\" fill=\\"white\\"/>\\n        <path d=\\"M32.037 34.3463H32.0255L31.1403 32.2767H30.5879V34.9574H30.9848V32.9075H30.9916L31.8917 34.9574H32.4292V32.2767H32.037V34.3463Z\\" fill=\\"white\\"/>\\n        <path d=\\"M22.5793 31.159H21.6392V28.8582H21.2012V31.5389H22.5793V31.159Z\\" fill=\\"white\\"/>\\n        <path d=\\"M24.5625 29.4993C24.5625 29.0999 24.3772 28.8582 23.8626 28.8582H23.0254V31.5389H23.8363C24.4287 31.5389 24.6735 31.2373 24.6735 30.7861C24.6735 30.3349 24.4516 30.1703 24.1588 30.1415V30.1346C24.415 30.0633 24.5625 29.8469 24.5625 29.5004V29.4993ZM23.4623 29.238H23.8065C24.0181 29.238 24.1474 29.3163 24.1474 29.5775C24.1474 29.8388 23.9884 29.9919 23.7322 29.9919H23.4623V29.2391V29.238ZM24.2217 30.7412C24.2217 31.0209 24.0845 31.159 23.7802 31.159H23.4611V30.3614H23.7951C24.0215 30.3614 24.2217 30.4178 24.2217 30.7412Z\\" fill=\\"white\\"/>\\n        <path d=\\"M17.5493 22.0315C18.1897 21.0302 19.3746 19.0355 19.895 18.0813V10.5168L16.7293 15.3096C16.0007 16.4123 14.5883 18.7983 14.2463 19.543C14.3607 18.7477 14.3835 16.3616 14.3835 14.8999V10H10.1484V27.957H13.7465L17.5493 22.0315Z\\" fill=\\"white\\"/>\\n        </svg>        \\n        ","image":"<svg xmlns=\\"http://www.w3.org/2000/svg\\" viewBox=\\"0 0 203 139\\" preserveAspectRatio=\\"xMidYMid slice\\" fill=\\"none\\"><path fill=\\"#E3051B\\" d=\\"M0 0h203v139H0z\\"/><g style=\\"fill:none\\"><path fill=\\"#e30613\\" d=\\"M149.458 21.53H53.542v95.94h95.916z\\"/><path fill=\\"#fff\\" d=\\"M104.39 109.457c-1.772 0-2.237-1.772-2.237-3.26 0-2.237.93-3.26 2.237-3.26.558 0 1.301.186 1.771.372h.093l-.093-1.302c-.372-.186-1.022-.372-1.864-.372-2.33 0-3.538 2.144-3.538 4.655s1.115 4.376 3.445 4.376c.744 0 1.58-.186 1.957-.372l.093-1.302h-.093c-.465.279-1.115.465-1.771.465zM99.08 101.821h-1.396v8.757h1.395zM121.897 93.25c0-1.58-.651-2.702-2.794-2.702H116.4v8.757h1.395v-3.26h1.302l1.394 3.26h1.581l-1.679-3.539c.93-.372 1.488-1.302 1.488-2.516m-2.965 1.772h-1.023v-3.167h1.209c.836 0 1.301.372 1.301 1.488s-.558 1.68-1.487 1.68zM114.915 103.128h2.231v7.45h1.4v-7.45h2.139v-1.307h-5.77ZM97.218 90.646v8.752h4.56v-1.302h-3.073v-7.45zM110.163 99.398h4.659v-1.302h-3.264v-2.609h2.794v-1.209h-2.794v-2.423h3.264v-1.209h-4.66zM112.307 105.546h-3.166v-3.725h-1.4v8.757h1.4v-3.725h3.166v3.725h1.395v-8.757h-1.395ZM84.646 90.646l-2.608 8.757h1.488l.558-2.237h2.7l.652 2.237h1.487l-2.608-8.757h-1.679zm-.279 5.306 1.116-4.004 1.116 4.004h-2.237zM65.558 108.62l-2.98-6.799h-1.767v8.757h1.302v-6.706l2.98 6.706h1.772v-8.757h-1.307zM70.681 99.491c2.516 0 3.445-2.237 3.445-4.655s-.93-4.376-3.259-4.376c-2.33 0-3.538 1.958-3.538 4.655 0 2.237.93 4.376 3.352 4.376zm.186-7.729c1.395 0 1.865 1.21 1.865 3.167 0 2.237-.651 3.353-1.958 3.353-1.209 0-1.957-.93-1.957-3.26 0-2.144.743-3.26 2.05-3.26zM70.681 101.821l-2.608 8.757h1.488l.558-2.237h2.7l.652 2.237h1.487l-2.608-8.757h-1.678zm-.279 5.404 1.116-4.004 1.116 4.004h-2.236zM79.244 109.457c-1.771 0-2.236-1.772-2.236-3.26 0-2.237.93-3.26 2.236-3.26.558 0 1.302.186 1.772.372l-.093-1.302c-.372-.186-1.023-.372-1.865-.372-2.329 0-3.538 2.144-3.538 4.655s1.116 4.376 3.445 4.376c.744 0 1.581-.186 1.958-.372l.093-1.302c-.465.279-1.116.465-1.772.465zM87.163 105.546h-3.166v-3.725h-1.492v8.757h1.492v-3.725h3.166v3.725h1.395v-8.757h-1.395zM81.017 93.25c0-1.58-.651-2.702-2.795-2.702h-2.608v8.757h1.395v-3.26h1.301l1.395 3.26h1.58l-1.678-3.539c.93-.372 1.395-1.302 1.395-2.516m-2.966 1.772h-1.022v-3.167h1.208c.837 0 1.302.372 1.302 1.488s-.558 1.68-1.488 1.68zM108.3 92.692c0-1.302-.65-2.144-2.33-2.144h-2.793v8.757h2.7c1.958 0 2.795-1.023 2.795-2.516s-.744-2.05-1.678-2.144c.836-.093 1.301-.837 1.301-1.958m-3.626-.832h1.116c.65 0 1.116.279 1.116 1.116 0 .93-.558 1.395-1.395 1.395h-.93V91.85h.093zm2.515 4.939c0 .93-.464 1.395-1.487 1.395h-1.023V95.58h1.116c.744-.093 1.394.093 1.394 1.21M90.142 90.646v8.757h1.395v-3.26h1.302l1.395 3.26h1.58l-1.678-3.539c.837-.465 1.394-1.302 1.394-2.516 0-1.58-.65-2.702-2.794-2.702h-2.608zm4.004 2.697c0 1.116-.558 1.68-1.488 1.68h-1.023v-3.168h1.209c.837 0 1.302.372 1.302 1.488zM96.01 104.523c0-1.58-.65-2.702-2.794-2.702h-2.608v8.757h1.395v-3.26h1.302l1.394 3.26h1.581l-1.679-3.539c.837-.465 1.395-1.302 1.395-2.516m-2.965 1.674h-1.023v-3.167h1.209c.836 0 1.301.372 1.301 1.488s-.65 1.68-1.487 1.68zM85.205 68.198c2.144-3.26 6.054-9.78 7.728-12.947V30.472L82.504 46.215c-2.422 3.632-7.076 11.366-8.197 13.877.372-2.61.465-10.431.465-15.184V28.793H60.805V87.66h11.828l12.572-19.467ZM64.442 99.398l2.515-8.752h-1.493L63.6 97.91l-1.767-7.264h-1.492l2.329 8.752zM121.897 110.578h4.654v-1.214h-3.166v-2.604h2.701v-1.214h-2.701v-2.516h3.166v-1.209h-4.654zM142.476 93.25c0-1.58-.651-2.702-2.795-2.702h-2.608v8.757h1.395v-3.26h1.302l1.394 3.26h1.58l-1.678-3.539c.93-.372 1.395-1.302 1.395-2.516m-2.966 1.772h-1.022v-3.167h1.208c.837 0 1.302.372 1.302 1.488s-.558 1.68-1.488 1.68zM130.74 99.398h4.658v-1.302h-3.26v-2.609h2.795v-1.209h-2.794v-2.423h3.259v-1.209h-4.659zM132.978 108.62l-2.98-6.799h-1.767v8.757h1.302v-6.706l2.98 6.706h1.772v-8.757h-1.307zM126.83 91.762c.65 0 1.394.186 1.864.372l-.093-1.395c-.372-.186-1.023-.372-1.864-.372-2.609 0-3.724 2.144-3.724 4.562s.93 4.47 3.445 4.47c1.022 0 2.05-.28 2.515-.559v-4.004h-2.608v1.116h1.208v1.958c-.093.093-.465.186-1.022.186-1.395 0-2.144-1.302-2.144-3.26.093-2.237 1.209-3.074 2.423-3.074z\\"/><path fill=\\"#85c9f0\\" d=\\"M110.442 69.686c0-4.748-.093-12.575-.465-15.184 1.395 2.609 5.868 10.152 8.197 13.784l12.572 19.467h11.828v-58.96h-13.967v16.022c0 4.748.093 12.575.465 15.184-1.115-2.423-5.774-10.245-8.197-13.877l-11.549-17.416h-12.85v58.866h13.966z\\"/></g></svg>","isChecked":true},{"headline":"VN am Wochenende","content":"Bestens informiert am Wochenende mit den Top 10 Artikel der vergangenen Woche.","schedule":"samstags | 12:00 Uhr","list":"eugenruss.vlbg: vn.wochenende","icon":"<svg width=\\"44\\" height=\\"44\\" viewBox=\\"0 0 44 44\\" fill=\\"none\\" xmlns=\\"http://www.w3.org/2000/svg\\">\\n        <circle cx=\\"22\\" cy=\\"22\\" r=\\"20\\" fill=\\"#E30613\\"/>\\n        <path d=\\"M25.2063 22.4678C25.2063 21.006 25.1834 18.6199 25.0691 17.8246C25.4785 18.6199 26.8452 20.9289 27.5509 22.0315L31.3537 27.957H34.9517V10H30.7155V14.8999C30.7155 16.3616 30.7383 18.7477 30.8516 19.543C30.5096 18.7995 29.0983 16.4134 28.3698 15.3108L24.862 10H20.9678V27.957H25.204V22.4678H25.2063Z\\" fill=\\"#85C9F0\\"/>\\n        <path d=\\"M21.7572 32.2767H21.3203V34.9574H21.7572V32.2767Z\\" fill=\\"white\\"/>\\n        <path d=\\"M16.2884 29.6754C16.2884 29.1863 16.0951 28.8594 15.4398 28.8594H14.6357V31.5401H15.0726V30.5594H15.3871C15.4169 30.5594 15.4432 30.5594 15.4718 30.556L15.8938 31.5401H16.3719L15.8675 30.4512C16.1305 30.3096 16.2861 30.0449 16.2861 29.6754H16.2884ZM15.3849 30.1934H15.0738V29.2392H15.4329C15.6959 29.2392 15.8401 29.3543 15.8401 29.687C15.8401 30.0196 15.6662 30.1945 15.3849 30.1945V30.1934Z\\" fill=\\"white\\"/>\\n        <path d=\\"M17.3849 28.8582L16.5957 31.5389H17.044L17.2259 30.8563H18.0482L18.2335 31.5389H18.6852L17.9075 28.8582H17.3849ZM17.3071 30.4983L17.633 29.2645L17.9704 30.4983H17.3071Z\\" fill=\\"white\\"/>\\n        <path d=\\"M18.1333 33.4105H17.1783V32.2767H16.7402V34.9574H17.1783V33.8168H18.1333V34.9574H18.5667V32.2767H18.1333V33.4105Z\\" fill=\\"white\\"/>\\n        <path d=\\"M30.1837 29.2162C30.3872 29.2162 30.6057 29.2795 30.7361 29.3428H30.7475L30.7098 28.925C30.6023 28.8801 30.3907 28.8168 30.1471 28.8168C29.3545 28.8168 29.0137 29.4729 29.0137 30.2153C29.0137 30.9577 29.3065 31.5804 30.0659 31.5804C30.3735 31.5804 30.6926 31.4986 30.8184 31.4204V30.1968H30.0361V30.5479H30.3987V31.1407C30.3575 31.1637 30.2546 31.2005 30.099 31.2005C29.669 31.2005 29.462 30.8126 29.462 30.2199C29.462 29.459 29.8028 29.2162 30.1848 29.2162H30.1837Z\\" fill=\\"white\\"/>\\n        <path d=\\"M19.4939 30.5582H19.8084C19.8381 30.5582 19.8644 30.5582 19.893 30.5547L20.315 31.5389H20.7931L20.2887 30.45C20.5518 30.3084 20.7073 30.0437 20.7073 29.6742C20.7073 29.185 20.5152 28.8582 19.8587 28.8582H19.0547V31.5389H19.4916V30.5582H19.4939ZM19.4939 29.238H19.853C20.116 29.238 20.2601 29.3531 20.2601 29.6857C20.2601 30.0184 20.0863 30.1933 19.8038 30.1933H19.4927V29.2391H19.4939V29.238Z\\" fill=\\"white\\"/>\\n        <path d=\\"M20.8128 33.0939C20.8128 32.6059 20.6207 32.2778 19.9642 32.2778H19.1602V34.9585H19.597V33.9779H19.9116C19.9413 33.9779 19.9665 33.9779 19.9962 33.9744L20.4182 34.9585H20.8963L20.3919 33.8697C20.655 33.7281 20.8105 33.4634 20.8105 33.0939H20.8128ZM19.9093 33.6119H19.5982V32.6577H19.9573C20.2204 32.6577 20.3645 32.7728 20.3645 33.1054C20.3645 33.4381 20.1906 33.613 19.9093 33.613V33.6119Z\\" fill=\\"white\\"/>\\n        <path d=\\"M28.6722 29.6754C28.6722 29.1863 28.4789 28.8594 27.8235 28.8594H27.0195V31.5401H27.4564V30.5594H27.7709C27.8007 30.5594 27.827 30.5594 27.8567 30.556L28.2787 31.5401H28.7568L28.2524 30.4512C28.5155 30.3096 28.671 30.0449 28.671 29.6754H28.6722ZM27.7675 30.1934H27.4564V29.2392H27.8155C28.0786 29.2392 28.2227 29.3543 28.2227 29.687C28.2227 30.0196 28.0489 30.1945 27.7664 30.1945H27.7675V30.1934Z\\" fill=\\"white\\"/>\\n        <path d=\\"M11.011 31.0773H11.0007L10.4552 28.8582H10L10.7297 31.5389H11.2558L12.0083 28.8582H11.5783L11.011 31.0773Z\\" fill=\\"white\\"/>\\n        <path d=\\"M11.5965 34.3463H11.5851L10.6999 32.2767H10.1475V34.9574H10.5443V32.9075H10.5512L11.4524 34.9574H11.9888V32.2767H11.5965V34.3463Z\\" fill=\\"white\\"/>\\n        <path d=\\"M13.1502 31.5804C13.9062 31.5804 14.1989 30.9093 14.1989 30.1519C14.1989 29.3946 13.9279 28.8168 13.2028 28.8168C12.4777 28.8168 12.1426 29.4176 12.1426 30.2371C12.1426 30.9231 12.4022 31.5792 13.1502 31.5792V31.5804ZM13.1913 29.2047C13.6065 29.2047 13.7586 29.5695 13.7586 30.1704C13.7586 30.8449 13.5516 31.1925 13.1696 31.1925C12.7876 31.1925 12.5806 30.8978 12.5806 30.2118C12.5806 29.5258 12.8071 29.2047 13.1913 29.2047Z\\" fill=\\"white\\"/>\\n        <path d=\\"M15.7473 34.6041C15.1984 34.6041 15.0691 34.0631 15.0691 33.62C15.0691 32.9489 15.347 32.6359 15.7359 32.6359C15.9177 32.6359 16.1362 32.6957 16.2654 32.751H16.2803L16.2391 32.3446C16.135 32.2998 15.9349 32.2365 15.6867 32.2365C14.9673 32.2365 14.6162 32.8776 14.6162 33.6614C14.6162 34.4452 14.9422 35 15.6684 35C15.8949 35 16.143 34.9367 16.2574 34.8803L16.294 34.4809H16.2791C16.135 34.5477 15.9315 34.6041 15.7462 34.6041H15.7473Z\\" fill=\\"white\\"/>\\n        <path d=\\"M13.1495 32.2767L12.3604 34.9574H12.8087L12.9905 34.2749H13.8128L13.9981 34.9574H14.4499L13.6722 32.2767H13.1495ZM13.0717 33.9169L13.3977 32.683L13.7351 33.9169H13.0717Z\\" fill=\\"white\\"/>\\n        <path d=\\"M31.3555 31.5389H32.7634V31.159H31.7924V30.3568H32.633V29.9884H31.7924V29.2426H32.7634V28.8582H31.3555V31.5389Z\\" fill=\\"white\\"/>\\n        <path d=\\"M26.5596 32.683H27.2309V34.9574H27.6678V32.683H28.3163V32.2767H26.5596V32.683Z\\" fill=\\"white\\"/>\\n        <path d=\\"M25.1104 31.5389H26.5194V31.159H25.5484V30.3568H26.389V29.9884H25.5484V29.2426H26.5194V28.8582H25.1104V31.5389Z\\" fill=\\"white\\"/>\\n        <path d=\\"M25.7622 33.4105H24.8072V32.2767H24.3691V34.9574H24.8072V33.8168H25.7622V34.9574H26.1956V32.2767H25.7622V33.4105Z\\" fill=\\"white\\"/>\\n        <path d=\\"M28.6787 34.9574H30.0866V34.5776H29.1167V33.7754H29.9574V33.407H29.1167V32.6612H30.0866V32.2767H28.6787V34.9574Z\\" fill=\\"white\\"/>\\n        <path d=\\"M34.9153 29.6754C34.9153 29.1863 34.7232 28.8594 34.0667 28.8594H33.2627V31.5401H33.6996V30.5594H34.0141C34.0438 30.5594 34.0701 30.5594 34.0999 30.556L34.5219 31.5401H35L34.4956 30.4512C34.7586 30.3096 34.9142 30.0449 34.9142 29.6754H34.9153ZM34.0118 30.1934H33.7007V29.2392H34.0598C34.3229 29.2392 34.467 29.3543 34.467 29.687C34.467 30.0196 34.2932 30.1945 34.0118 30.1945V30.1934Z\\" fill=\\"white\\"/>\\n        <path d=\\"M23.3762 34.6041C22.8284 34.6041 22.698 34.0631 22.698 33.62C22.698 32.9489 22.9759 32.6359 23.3648 32.6359C23.5466 32.6359 23.7651 32.6957 23.8943 32.751H23.9092L23.868 32.3446C23.7639 32.2998 23.5638 32.2365 23.3156 32.2365C22.5962 32.2365 22.2451 32.8776 22.2451 33.6614C22.2451 34.4452 22.5711 35 23.2973 35C23.5238 35 23.7719 34.9367 23.8863 34.8803L23.9241 34.4809H23.9092C23.7651 34.5477 23.5615 34.6041 23.3762 34.6041Z\\" fill=\\"white\\"/>\\n        <path d=\\"M32.037 34.3463H32.0255L31.1403 32.2767H30.5879V34.9574H30.9848V32.9075H30.9916L31.8917 34.9574H32.4292V32.2767H32.037V34.3463Z\\" fill=\\"white\\"/>\\n        <path d=\\"M22.5793 31.159H21.6392V28.8582H21.2012V31.5389H22.5793V31.159Z\\" fill=\\"white\\"/>\\n        <path d=\\"M24.5625 29.4993C24.5625 29.0999 24.3772 28.8582 23.8626 28.8582H23.0254V31.5389H23.8363C24.4287 31.5389 24.6735 31.2373 24.6735 30.7861C24.6735 30.3349 24.4516 30.1703 24.1588 30.1415V30.1346C24.415 30.0633 24.5625 29.8469 24.5625 29.5004V29.4993ZM23.4623 29.238H23.8065C24.0181 29.238 24.1474 29.3163 24.1474 29.5775C24.1474 29.8388 23.9884 29.9919 23.7322 29.9919H23.4623V29.2391V29.238ZM24.2217 30.7412C24.2217 31.0209 24.0845 31.159 23.7802 31.159H23.4611V30.3614H23.7951C24.0215 30.3614 24.2217 30.4178 24.2217 30.7412Z\\" fill=\\"white\\"/>\\n        <path d=\\"M17.5493 22.0315C18.1897 21.0302 19.3746 19.0355 19.895 18.0813V10.5168L16.7293 15.3096C16.0007 16.4123 14.5883 18.7983 14.2463 19.543C14.3607 18.7477 14.3835 16.3616 14.3835 14.8999V10H10.1484V27.957H13.7465L17.5493 22.0315Z\\" fill=\\"white\\"/>\\n        </svg>        \\n        ","image":"<svg xmlns=\\"http://www.w3.org/2000/svg\\" viewBox=\\"0 0 203 139\\" preserveAspectRatio=\\"xMidYMid slice\\" fill=\\"none\\"><path fill=\\"#E3051B\\" d=\\"M0 0h203v139H0z\\"/><g style=\\"fill:none\\"><path fill=\\"#e30613\\" d=\\"M149.458 21.53H53.542v95.94h95.916z\\"/><path fill=\\"#fff\\" d=\\"M104.39 109.457c-1.772 0-2.237-1.772-2.237-3.26 0-2.237.93-3.26 2.237-3.26.558 0 1.301.186 1.771.372h.093l-.093-1.302c-.372-.186-1.022-.372-1.864-.372-2.33 0-3.538 2.144-3.538 4.655s1.115 4.376 3.445 4.376c.744 0 1.58-.186 1.957-.372l.093-1.302h-.093c-.465.279-1.115.465-1.771.465zM99.08 101.821h-1.396v8.757h1.395zM121.897 93.25c0-1.58-.651-2.702-2.794-2.702H116.4v8.757h1.395v-3.26h1.302l1.394 3.26h1.581l-1.679-3.539c.93-.372 1.488-1.302 1.488-2.516m-2.965 1.772h-1.023v-3.167h1.209c.836 0 1.301.372 1.301 1.488s-.558 1.68-1.487 1.68zM114.915 103.128h2.231v7.45h1.4v-7.45h2.139v-1.307h-5.77ZM97.218 90.646v8.752h4.56v-1.302h-3.073v-7.45zM110.163 99.398h4.659v-1.302h-3.264v-2.609h2.794v-1.209h-2.794v-2.423h3.264v-1.209h-4.66zM112.307 105.546h-3.166v-3.725h-1.4v8.757h1.4v-3.725h3.166v3.725h1.395v-8.757h-1.395ZM84.646 90.646l-2.608 8.757h1.488l.558-2.237h2.7l.652 2.237h1.487l-2.608-8.757h-1.679zm-.279 5.306 1.116-4.004 1.116 4.004h-2.237zM65.558 108.62l-2.98-6.799h-1.767v8.757h1.302v-6.706l2.98 6.706h1.772v-8.757h-1.307zM70.681 99.491c2.516 0 3.445-2.237 3.445-4.655s-.93-4.376-3.259-4.376c-2.33 0-3.538 1.958-3.538 4.655 0 2.237.93 4.376 3.352 4.376zm.186-7.729c1.395 0 1.865 1.21 1.865 3.167 0 2.237-.651 3.353-1.958 3.353-1.209 0-1.957-.93-1.957-3.26 0-2.144.743-3.26 2.05-3.26zM70.681 101.821l-2.608 8.757h1.488l.558-2.237h2.7l.652 2.237h1.487l-2.608-8.757h-1.678zm-.279 5.404 1.116-4.004 1.116 4.004h-2.236zM79.244 109.457c-1.771 0-2.236-1.772-2.236-3.26 0-2.237.93-3.26 2.236-3.26.558 0 1.302.186 1.772.372l-.093-1.302c-.372-.186-1.023-.372-1.865-.372-2.329 0-3.538 2.144-3.538 4.655s1.116 4.376 3.445 4.376c.744 0 1.581-.186 1.958-.372l.093-1.302c-.465.279-1.116.465-1.772.465zM87.163 105.546h-3.166v-3.725h-1.492v8.757h1.492v-3.725h3.166v3.725h1.395v-8.757h-1.395zM81.017 93.25c0-1.58-.651-2.702-2.795-2.702h-2.608v8.757h1.395v-3.26h1.301l1.395 3.26h1.58l-1.678-3.539c.93-.372 1.395-1.302 1.395-2.516m-2.966 1.772h-1.022v-3.167h1.208c.837 0 1.302.372 1.302 1.488s-.558 1.68-1.488 1.68zM108.3 92.692c0-1.302-.65-2.144-2.33-2.144h-2.793v8.757h2.7c1.958 0 2.795-1.023 2.795-2.516s-.744-2.05-1.678-2.144c.836-.093 1.301-.837 1.301-1.958m-3.626-.832h1.116c.65 0 1.116.279 1.116 1.116 0 .93-.558 1.395-1.395 1.395h-.93V91.85h.093zm2.515 4.939c0 .93-.464 1.395-1.487 1.395h-1.023V95.58h1.116c.744-.093 1.394.093 1.394 1.21M90.142 90.646v8.757h1.395v-3.26h1.302l1.395 3.26h1.58l-1.678-3.539c.837-.465 1.394-1.302 1.394-2.516 0-1.58-.65-2.702-2.794-2.702h-2.608zm4.004 2.697c0 1.116-.558 1.68-1.488 1.68h-1.023v-3.168h1.209c.837 0 1.302.372 1.302 1.488zM96.01 104.523c0-1.58-.65-2.702-2.794-2.702h-2.608v8.757h1.395v-3.26h1.302l1.394 3.26h1.581l-1.679-3.539c.837-.465 1.395-1.302 1.395-2.516m-2.965 1.674h-1.023v-3.167h1.209c.836 0 1.301.372 1.301 1.488s-.65 1.68-1.487 1.68zM85.205 68.198c2.144-3.26 6.054-9.78 7.728-12.947V30.472L82.504 46.215c-2.422 3.632-7.076 11.366-8.197 13.877.372-2.61.465-10.431.465-15.184V28.793H60.805V87.66h11.828l12.572-19.467ZM64.442 99.398l2.515-8.752h-1.493L63.6 97.91l-1.767-7.264h-1.492l2.329 8.752zM121.897 110.578h4.654v-1.214h-3.166v-2.604h2.701v-1.214h-2.701v-2.516h3.166v-1.209h-4.654zM142.476 93.25c0-1.58-.651-2.702-2.795-2.702h-2.608v8.757h1.395v-3.26h1.302l1.394 3.26h1.58l-1.678-3.539c.93-.372 1.395-1.302 1.395-2.516m-2.966 1.772h-1.022v-3.167h1.208c.837 0 1.302.372 1.302 1.488s-.558 1.68-1.488 1.68zM130.74 99.398h4.658v-1.302h-3.26v-2.609h2.795v-1.209h-2.794v-2.423h3.259v-1.209h-4.659zM132.978 108.62l-2.98-6.799h-1.767v8.757h1.302v-6.706l2.98 6.706h1.772v-8.757h-1.307zM126.83 91.762c.65 0 1.394.186 1.864.372l-.093-1.395c-.372-.186-1.023-.372-1.864-.372-2.609 0-3.724 2.144-3.724 4.562s.93 4.47 3.445 4.47c1.022 0 2.05-.28 2.515-.559v-4.004h-2.608v1.116h1.208v1.958c-.093.093-.465.186-1.022.186-1.395 0-2.144-1.302-2.144-3.26.093-2.237 1.209-3.074 2.423-3.074z\\"/><path fill=\\"#85c9f0\\" d=\\"M110.442 69.686c0-4.748-.093-12.575-.465-15.184 1.395 2.609 5.868 10.152 8.197 13.784l12.572 19.467h11.828v-58.96h-13.967v16.022c0 4.748.093 12.575.465 15.184-1.115-2.423-5.774-10.245-8.197-13.877l-11.549-17.416h-12.85v58.866h13.966z\\"/></g></svg>","isChecked":true},{"headline":"NEUE täglich informiert","content":"Informiert in den Tag starten mit Themen und Geschichten aus der NEUE Vorarlberger Tageszeitung.","schedule":"Mo - Sa | 06:00 Uhr","list":"NEUE Vorarlberger Tageszeitung","icon":"<svg width=\\"44\\" height=\\"44\\" viewBox=\\"0 0 44 44\\" fill=\\"none\\" xmlns=\\"http://www.w3.org/2000/svg\\">\\n        <circle cx=\\"22\\" cy=\\"22\\" r=\\"20\\" fill=\\"#0062A7\\"/>\\n        <g clip-path=\\"url(#clip0_4561_921)\\">\\n        <path d=\\"M6.0581 27.2087L5.7439 26.34C5.73466 26.3146 5.71387 26.2615 5.71387 26.2361C5.71387 26.1436 5.85248 26.146 5.93334 26.1413V25.9311H5V26.1413C5.20792 26.146 5.23103 26.1945 5.29802 26.377L5.78549 27.673H6.12971L6.60101 26.4209C6.65645 26.2753 6.71883 26.1344 6.89672 26.1413V25.9311H6.18054V26.1413C6.25216 26.1506 6.37691 26.1436 6.37691 26.243C6.37691 26.2799 6.36536 26.3146 6.3515 26.3469L6.05579 27.2087H6.0581ZM31.4686 18.0231H38.9492V19.4023H33.9937V20.3334H38.0297V21.701H33.9937V22.6321H38.9492V24.0113H31.4686V18.0231ZM22.3731 18H25.0715V21.4284C25.0715 21.4284 24.9329 22.5604 26.3629 22.5604C27.8992 22.5604 27.9223 21.4538 27.9223 21.4538V18H30.6207V22.2786C30.6207 22.2786 30.5514 24.0113 26.4807 24.0113C22.119 24.0113 22.3754 22.1492 22.3754 22.1146V18H22.3731ZM14.0331 18.0231H21.4998V19.4023H16.5559V20.3334H20.5919V21.701H16.5559V22.6321H21.4998V24.0113H14.0331V18.0231ZM7.3657 24.009H5.00462V18.1178H7.63369L10.7156 21.3591V18.0231H13.0766V24.009H10.168L7.3657 20.8046V24.009Z\\" fill=\\"white\\"/>\\n        <path fill-rule=\\"evenodd\\" clip-rule=\\"evenodd\\" d=\\"M11.485 26.3885H11.3834L10.9329 26.4555V26.6658H10.9514C11.1339 26.6866 11.1293 26.7374 11.1293 26.906V27.2225C11.1293 27.3981 11.1293 27.4466 10.926 27.4628V27.673H11.7322V27.4628H11.7091C11.5451 27.4466 11.5497 27.3889 11.5497 27.2202V26.7466C11.5497 26.7212 11.5867 26.705 11.626 26.705C11.6883 26.705 11.7253 26.7836 11.8385 26.7836C11.9448 26.7836 12.0372 26.7097 12.0372 26.5942C12.0372 26.4648 11.9355 26.3862 11.8131 26.3862C11.6907 26.3862 11.6006 26.4348 11.485 26.5064V26.3862V26.3885ZM10.2306 27.3219C10.1797 27.375 10.0966 27.412 10.0227 27.412C9.94872 27.412 9.90483 27.3496 9.90483 27.2826C9.90483 27.1324 10.1174 27.0909 10.2306 27.0701V27.3242V27.3219ZM10.7527 27.3866C10.7365 27.4004 10.7019 27.4282 10.6811 27.4282C10.6326 27.4282 10.6372 27.3404 10.6372 27.3103V26.8113C10.6372 26.6565 10.621 26.5272 10.4755 26.4394C10.3669 26.3724 10.2236 26.3562 10.0966 26.3562C9.96259 26.3562 9.82628 26.3724 9.70615 26.4394C9.60681 26.4994 9.52826 26.5965 9.52826 26.7166C9.52826 26.8229 9.61143 26.9037 9.7177 26.9037C9.77546 26.9037 9.84245 26.8783 9.87942 26.8275C9.90483 26.7882 9.90945 26.7466 9.90945 26.7027C9.90945 26.6727 9.90945 26.6496 9.93486 26.6288C9.9649 26.6011 10.0203 26.5918 10.0642 26.5918C10.1081 26.5918 10.1821 26.6011 10.2075 26.6404C10.2329 26.6819 10.2283 26.7513 10.2283 26.7975V26.8645C9.95103 26.8922 9.47281 26.9684 9.47281 27.3404C9.47281 27.576 9.66225 27.6961 9.87711 27.6961C10.0296 27.6961 10.1613 27.6499 10.2837 27.5622C10.3438 27.6476 10.4616 27.6961 10.5656 27.6961C10.6903 27.6961 10.7966 27.6476 10.889 27.5622L10.7504 27.3889L10.7527 27.3866ZM8.85597 26.3885H8.75432L8.30382 26.4555V26.6658H8.32231C8.50482 26.6866 8.5002 26.7374 8.5002 26.906V27.2225C8.5002 27.3981 8.5002 27.4466 8.29689 27.4628V27.673H9.10317V27.4628H9.08007C8.91604 27.4466 8.92066 27.3889 8.92066 27.2202V26.7466C8.92066 26.7212 8.95763 26.705 8.9969 26.705C9.05928 26.705 9.09624 26.7836 9.20944 26.7836C9.31572 26.7836 9.40813 26.7097 9.40813 26.5942C9.40813 26.4648 9.30647 26.3862 9.18403 26.3862C9.06159 26.3862 8.97149 26.4348 8.85597 26.5064V26.3862V26.3885ZM7.45134 27.4351C7.24111 27.4351 7.20876 27.1994 7.20876 27.0331C7.20876 26.8668 7.23187 26.6126 7.45134 26.6126C7.67081 26.6126 7.69392 26.8598 7.69392 27.0331C7.69392 27.2064 7.66388 27.4351 7.45134 27.4351ZM7.44903 27.6938C7.62692 27.6938 7.82329 27.6476 7.95498 27.5206C8.08897 27.3958 8.15135 27.211 8.15135 27.0308C8.15135 26.839 8.07973 26.6404 7.93418 26.511C7.80019 26.3932 7.61075 26.3585 7.43517 26.3585C7.01932 26.3585 6.74902 26.6057 6.74902 27.0285C6.74902 27.2202 6.82295 27.4143 6.96619 27.5391C7.09556 27.6499 7.28038 27.6961 7.44672 27.6961\\" fill=\\"white\\"/>\\n        <path d=\\"M12.6791 25.8179H12.5428C12.388 25.8872 12.224 25.9218 12.0576 25.9311V26.1413C12.1177 26.1413 12.1893 26.1482 12.2263 26.176C12.2609 26.2037 12.2563 26.3076 12.2563 26.3492V27.2202C12.2563 27.3935 12.2609 27.435 12.0853 27.4605V27.6707H12.85V27.4605L12.8108 27.4512C12.7553 27.442 12.7114 27.4327 12.6952 27.375C12.6837 27.3311 12.6837 27.2641 12.6837 27.2225V25.8179H12.6791Z\\" fill=\\"white\\"/>\\n        <path fill-rule=\\"evenodd\\" clip-rule=\\"evenodd\\" d=\\"M16.4936 26.3885H16.3919L15.9414 26.4555V26.6657H15.9599C16.1424 26.6865 16.1378 26.7373 16.1378 26.906V27.2225C16.1378 27.3981 16.1378 27.4466 15.9345 27.4628V27.673H16.7408V27.4628H16.7177C16.5537 27.4466 16.5583 27.3888 16.5583 27.2202V26.7466C16.5583 26.7212 16.5952 26.705 16.6345 26.705C16.6969 26.705 16.7339 26.7835 16.8471 26.7835C16.9533 26.7835 17.0481 26.7096 17.0481 26.5941C17.0481 26.4647 16.9464 26.3862 16.824 26.3862C16.7015 26.3862 16.6114 26.4347 16.4959 26.5063V26.3862L16.4936 26.3885ZM14.9619 26.7928C14.9711 26.6819 15.0589 26.608 15.1583 26.608C15.2576 26.608 15.3338 26.6819 15.3362 26.7928H14.9619ZM15.7682 27.003V26.9499C15.7797 26.5756 15.5071 26.3562 15.156 26.3562C14.7748 26.3562 14.4906 26.6218 14.4906 27.0169C14.4906 27.4119 14.7794 27.6938 15.1767 27.6938C15.4678 27.6938 15.6596 27.5575 15.7982 27.308L15.5857 27.1994C15.5117 27.3218 15.4032 27.435 15.2553 27.435C15.0358 27.435 14.948 27.2456 14.948 27.003H15.7682ZM13.4672 26.7189C13.4903 26.6496 13.5896 26.6149 13.6658 26.6149C13.8622 26.6149 13.9061 26.8482 13.9061 27.003C13.9061 27.1809 13.8761 27.435 13.6474 27.435C13.5919 27.435 13.5134 27.405 13.4649 27.3403V26.7189H13.4672ZM13.4672 25.8179H13.3309C13.1761 25.8872 13.012 25.9218 12.8457 25.9311V26.1413C12.9058 26.1413 12.9774 26.1482 13.0144 26.176C13.049 26.2037 13.0444 26.3076 13.0444 26.3492V27.6707H13.3355L13.3817 27.5898C13.4926 27.6453 13.5965 27.6915 13.7259 27.6915C14.1094 27.6915 14.3335 27.405 14.3335 27.0354C14.3335 26.869 14.285 26.6911 14.1787 26.5641C14.0771 26.4416 13.9107 26.3538 13.749 26.3538C13.652 26.3538 13.5342 26.3954 13.4672 26.437V25.8156V25.8179Z\\" fill=\\"white\\"/>\\n        <path fill-rule=\\"evenodd\\" clip-rule=\\"evenodd\\" d=\\"M20.5665 26.3885H20.4648L20.0143 26.4555V26.6658H20.0328C20.2153 26.6866 20.2107 26.7374 20.2107 26.906V27.2225C20.2107 27.3981 20.2107 27.4466 20.0074 27.4628V27.673H20.8137V27.4628H20.7906C20.6265 27.4466 20.6312 27.3889 20.6312 27.2202V26.7466C20.6312 26.7212 20.6681 26.7051 20.7074 26.7051C20.7698 26.7051 20.8067 26.7836 20.9199 26.7836C21.0262 26.7836 21.1186 26.7097 21.1186 26.5942C21.1186 26.4648 21.017 26.3862 20.8945 26.3862C20.7721 26.3862 20.682 26.4348 20.5665 26.5064V26.3862V26.3885ZM19.0348 26.7928C19.044 26.682 19.1318 26.608 19.2311 26.608C19.3305 26.608 19.4067 26.682 19.409 26.7928H19.0348ZM19.841 27.0031V26.9499C19.8526 26.5757 19.58 26.3562 19.2288 26.3562C18.8476 26.3562 18.5635 26.6219 18.5635 27.0169C18.5635 27.412 18.8523 27.6938 19.2496 27.6938C19.5407 27.6938 19.7325 27.5575 19.8711 27.308L19.6585 27.2018C19.5846 27.3242 19.476 27.4374 19.3282 27.4374C19.1087 27.4374 19.0209 27.248 19.0209 27.0054H19.841V27.0031ZM17.8843 27.8694C17.942 27.8787 18.0529 27.8764 18.0529 27.9618C18.0529 28.0103 18.0183 28.0334 17.9767 28.0496C17.912 28.075 17.7641 28.082 17.6902 28.082C17.6093 28.082 17.3206 28.0635 17.3206 27.9387C17.3206 27.8856 17.3645 27.8394 17.406 27.8163L17.8819 27.8694H17.8843ZM17.7249 26.5919C17.8889 26.5919 17.9143 26.7212 17.9143 26.8598C17.9143 26.9869 17.8819 27.107 17.7318 27.107C17.5816 27.107 17.5562 26.9869 17.5562 26.8598C17.5562 26.742 17.5724 26.5919 17.7225 26.5919M17.6856 27.4466C17.6301 27.442 17.4522 27.4466 17.4522 27.3565C17.4522 27.3265 17.4707 27.2988 17.5031 27.2988C17.5146 27.2988 17.5285 27.3011 17.54 27.3034C17.6047 27.3196 17.6833 27.3265 17.7503 27.3265C18.046 27.3265 18.314 27.1625 18.314 26.839C18.314 26.6866 18.2377 26.5595 18.1199 26.474C18.1407 26.4463 18.1638 26.4394 18.1985 26.4394C18.247 26.4394 18.2839 26.4717 18.3324 26.4717C18.4133 26.4717 18.4919 26.4163 18.4919 26.3308C18.4919 26.2245 18.3948 26.1552 18.2955 26.1552C18.1338 26.1552 18.0206 26.2546 17.9328 26.3839C17.8588 26.3701 17.7872 26.3608 17.7133 26.3608C17.4222 26.3608 17.1542 26.5341 17.1542 26.8529C17.1542 26.9869 17.2166 27.1209 17.3252 27.1948C17.1819 27.2225 17.0849 27.3565 17.0849 27.5044C17.0849 27.5991 17.1334 27.673 17.2097 27.7285C17.1103 27.7701 17.041 27.844 17.041 27.9595C17.041 28.2622 17.4753 28.2991 17.6948 28.2991C17.8496 28.2991 18.0506 28.2783 18.1915 28.2136C18.3417 28.1443 18.4503 27.9919 18.4503 27.8232C18.4503 27.7216 18.4156 27.6315 18.3348 27.5691C18.2493 27.5021 18.1315 27.4882 18.0275 27.479L17.6879 27.449L17.6856 27.4466Z\\" fill=\\"white\\"/>\\n        <path d=\\"M22.4356 27.211C22.4356 27.2618 22.4402 27.3565 22.4079 27.3981C22.3732 27.4466 22.2831 27.4605 22.2277 27.4628H22.1976V27.673H23.1217V27.4628H23.0917C23.0363 27.4605 22.9485 27.4466 22.9115 27.3981C22.8792 27.3565 22.8838 27.2618 22.8838 27.211V26.2245C22.8815 26.176 22.8815 26.1621 22.9323 26.1621C23.027 26.1621 23.1264 26.2268 23.1934 26.2869C23.265 26.3539 23.3112 26.4324 23.3713 26.5317L23.5561 26.4578L23.3528 25.9288H21.9689L21.7656 26.4578L21.9504 26.5317C22.0082 26.4324 22.0567 26.3539 22.1283 26.2869C22.193 26.2245 22.2947 26.1621 22.3894 26.1621C22.4402 26.1621 22.4402 26.176 22.4379 26.2245V27.211H22.4356Z\\" fill=\\"white\\"/>\\n        <path fill-rule=\\"evenodd\\" clip-rule=\\"evenodd\\" d=\\"M26.9683 26.7905C26.9775 26.6796 27.0653 26.6057 27.1646 26.6057C27.264 26.6057 27.3402 26.6796 27.3425 26.7905H26.9683ZM27.7745 27.0007V26.9476C27.7884 26.5733 27.5135 26.3539 27.1623 26.3539C26.7811 26.3539 26.497 26.6195 26.497 27.0146C26.497 27.4097 26.7858 27.6915 27.1831 27.6915C27.4742 27.6915 27.666 27.5552 27.8046 27.3057L27.592 27.1994C27.5181 27.3219 27.4095 27.4351 27.2617 27.4351C27.0422 27.4351 26.9567 27.2456 26.9567 27.003H27.7769L27.7745 27.0007ZM25.8178 27.8671C25.8755 27.8763 25.9864 27.874 25.9864 27.9595C25.9864 28.008 25.9518 28.0311 25.9102 28.0473C25.8455 28.0727 25.6976 28.0796 25.6237 28.0796C25.5428 28.0796 25.2541 28.0611 25.2541 27.9364C25.2541 27.8833 25.298 27.837 25.3395 27.8139L25.8154 27.8671H25.8178ZM25.6584 26.5895C25.8224 26.5895 25.8478 26.7189 25.8478 26.8575C25.8478 26.9846 25.8154 27.1047 25.6653 27.1047C25.5151 27.1047 25.4897 26.9846 25.4897 26.8575C25.4897 26.7397 25.5059 26.5895 25.656 26.5895M25.6191 27.4443C25.5636 27.4397 25.3857 27.4443 25.3857 27.3542C25.3857 27.3242 25.4042 27.2941 25.4366 27.2941C25.4481 27.2941 25.462 27.2965 25.4735 27.2988C25.5382 27.3149 25.6168 27.3219 25.6838 27.3219C25.9795 27.3219 26.2475 27.1578 26.2475 26.8344C26.2475 26.6819 26.1712 26.5549 26.0534 26.4694C26.0742 26.4417 26.0973 26.4324 26.132 26.4324C26.1805 26.4324 26.2174 26.4648 26.2659 26.4648C26.3468 26.4648 26.4254 26.4093 26.4254 26.3238C26.4254 26.2176 26.3283 26.1483 26.229 26.1483C26.0673 26.1483 25.9541 26.2476 25.8663 26.377C25.7923 26.3631 25.7184 26.3539 25.6468 26.3539C25.3557 26.3539 25.0877 26.5271 25.0877 26.8436C25.0877 26.9776 25.1501 27.1116 25.2587 27.1856C25.1154 27.2133 25.0184 27.3473 25.0184 27.4951C25.0184 27.5899 25.0669 27.6638 25.1432 27.7192C25.0438 27.7608 24.9745 27.8347 24.9745 27.9503C24.9745 28.2529 25.4088 28.2899 25.626 28.2899C25.7808 28.2899 25.9818 28.2691 26.1227 28.2044C26.2729 28.1351 26.3815 27.9826 26.3815 27.8139C26.3815 27.7123 26.3468 27.6222 26.2659 27.5598C26.1805 27.4928 26.0626 27.479 25.961 27.4697L25.6214 27.4397L25.6191 27.4443ZM24.3115 27.3219C24.2606 27.375 24.1775 27.412 24.1036 27.412C24.0296 27.412 23.9857 27.3496 23.9857 27.2826C23.9857 27.1324 24.1983 27.0908 24.3115 27.07V27.3242V27.3219ZM24.8336 27.3866C24.8174 27.3981 24.7828 27.4281 24.762 27.4281C24.7135 27.4281 24.7181 27.3403 24.7181 27.3103V26.8113C24.7181 26.6565 24.7019 26.5271 24.5564 26.4393C24.4478 26.3723 24.3045 26.3562 24.1775 26.3562C24.0435 26.3562 23.9072 26.3723 23.787 26.4393C23.6877 26.4994 23.6092 26.5964 23.6092 26.7166C23.6092 26.8228 23.6923 26.9037 23.7986 26.9037C23.8564 26.9037 23.9234 26.8783 23.9603 26.8275C23.9857 26.7882 23.9903 26.7466 23.9903 26.7027C23.9903 26.6727 23.9903 26.6496 24.0158 26.6288C24.0458 26.6011 24.1012 26.5941 24.1451 26.5941C24.189 26.5941 24.263 26.6034 24.2884 26.6426C24.3138 26.6842 24.3092 26.7535 24.3092 26.7974V26.8644C24.0319 26.8922 23.5537 26.9684 23.5537 27.3403C23.5537 27.576 23.7432 27.6961 23.958 27.6961C24.1105 27.6961 24.2422 27.6499 24.3646 27.5621C24.4247 27.6476 24.5425 27.6961 24.6442 27.6961C24.7689 27.6961 24.8752 27.6476 24.9676 27.5621L24.829 27.3889L24.8336 27.3866Z\\" fill=\\"white\\"/>\\n        <path d=\\"M30.5835 27.1948L30.3894 27.1255C30.2855 27.3404 30.1214 27.4328 29.8881 27.4328L29.8119 27.4281L30.5373 26.5757L30.4564 26.3862H29.4515L29.3013 26.809L29.5023 26.8806L29.5115 26.8644C29.6155 26.6981 29.7079 26.6219 29.9135 26.6219H29.9782L29.2528 27.4628L29.3152 27.6707H30.4195L30.5789 27.1948H30.5835ZM28.9917 26.3862H28.8346L28.8023 26.4417C28.696 26.3862 28.599 26.3516 28.4788 26.3516C28.3472 26.3516 28.2155 26.3908 28.1115 26.4786C28.0214 26.5595 27.9614 26.675 27.9614 26.7974C27.9614 26.9314 28.0145 27.0423 28.1277 27.1093C28.227 27.1694 28.3379 27.1809 28.4465 27.1971C28.5181 27.2064 28.6128 27.2179 28.6798 27.241C28.7168 27.2572 28.7538 27.2826 28.7538 27.3288C28.7538 27.4212 28.599 27.4512 28.532 27.4512C28.3495 27.4512 28.2501 27.3542 28.1485 27.2179L27.9429 27.2479L28.0445 27.6684H28.2132L28.2409 27.6176C28.3449 27.6684 28.4511 27.6892 28.5643 27.6892C28.8392 27.6892 29.1303 27.5367 29.1303 27.2271C29.1303 27.1186 29.0841 27.0169 29.001 26.9499C28.9132 26.8783 28.7954 26.8621 28.6845 26.8436L28.5574 26.8182C28.4904 26.8044 28.3287 26.7905 28.3287 26.6935C28.3287 26.6172 28.4465 26.5941 28.5066 26.5941C28.6452 26.5941 28.7561 26.6842 28.8323 26.7928L29.0379 26.7628L28.9894 26.3862H28.9917Z\\" fill=\\"white\\"/>\\n        <path fill-rule=\\"evenodd\\" clip-rule=\\"evenodd\\" d=\\"M32.5247 25.8063C32.3861 25.8063 32.2775 25.9218 32.2775 26.0628C32.2775 26.1875 32.3814 26.303 32.5108 26.303C32.6402 26.303 32.7626 26.1898 32.7626 26.0535C32.7626 25.9172 32.661 25.8086 32.527 25.8086M32.7626 26.3885H32.5963L32.1458 26.4555V26.6657H32.1643C32.3468 26.6865 32.3422 26.7374 32.3422 26.906V27.2225C32.3422 27.3935 32.3445 27.4443 32.1458 27.4628V27.673H32.9382V27.4628C32.758 27.4397 32.7673 27.3889 32.7673 27.2225V26.3885H32.7626ZM31.1686 26.7928C31.1778 26.6819 31.2656 26.608 31.3649 26.608C31.4643 26.608 31.5405 26.6819 31.5428 26.7928H31.1686ZM31.9748 27.003V26.9499C31.9887 26.5757 31.7138 26.3562 31.3626 26.3562C30.9814 26.3562 30.6973 26.6219 30.6973 27.0169C30.6973 27.412 30.986 27.6938 31.3834 27.6938C31.6745 27.6938 31.8663 27.5575 32.0049 27.308L31.7923 27.2017C31.7184 27.3242 31.6098 27.4374 31.462 27.4374C31.2425 27.4374 31.157 27.2479 31.157 27.0054H31.9771L31.9748 27.003Z\\" fill=\\"white\\"/>\\n        <path d=\\"M33.9755 26.6173V26.3862H33.6244V25.9819H33.3772L33.3725 26.0027C33.3518 26.1344 33.3333 26.2314 33.2293 26.3215C33.1716 26.3724 33.1046 26.4047 33.0283 26.4163V26.6149H33.2039V27.2433C33.2039 27.3635 33.1947 27.479 33.2755 27.576C33.3518 27.6661 33.4465 27.6892 33.5597 27.6892C33.7768 27.6892 33.9594 27.6176 34.1003 27.4489L33.9478 27.2664C33.9016 27.3173 33.793 27.4074 33.7283 27.4074C33.6151 27.4074 33.6267 27.2872 33.6267 27.2017V26.6126H33.9778L33.9755 26.6173Z\\" fill=\\"white\\"/>\\n        <path fill-rule=\\"evenodd\\" clip-rule=\\"evenodd\\" d=\\"M38.39 27.8671C38.4477 27.8763 38.5586 27.874 38.5586 27.9595C38.5586 28.008 38.524 28.0311 38.4824 28.0473C38.4177 28.0727 38.2699 28.0796 38.1959 28.0796C38.1151 28.0796 37.8263 28.0612 37.8263 27.9364C37.8263 27.8833 37.8702 27.8371 37.9118 27.814L38.3877 27.8671H38.39ZM38.2306 26.5895C38.3946 26.5895 38.42 26.7189 38.42 26.8575C38.42 26.9846 38.3877 27.1047 38.2375 27.1047C38.0873 27.1047 38.0619 26.9846 38.0619 26.8575C38.0619 26.7397 38.0781 26.5895 38.2283 26.5895M38.1913 27.4443C38.1359 27.4397 37.958 27.4443 37.958 27.3542C37.958 27.3242 37.9764 27.2965 38.0088 27.2965C38.0203 27.2965 38.0342 27.2988 38.0458 27.3011C38.1104 27.3173 38.189 27.3242 38.256 27.3242C38.5517 27.3242 38.8197 27.1602 38.8197 26.8367C38.8197 26.6842 38.7435 26.5572 38.6256 26.4717C38.6464 26.444 38.6695 26.4347 38.7042 26.4347C38.7527 26.4347 38.7897 26.4671 38.8382 26.4671C38.919 26.4671 38.9976 26.4116 38.9976 26.3262C38.9976 26.2176 38.9005 26.1506 38.8012 26.1506C38.6395 26.1506 38.5263 26.2499 38.4385 26.3793C38.3646 26.3654 38.2906 26.3562 38.219 26.3562C37.9279 26.3562 37.6599 26.5295 37.6599 26.846C37.6599 26.98 37.7223 27.1139 37.8309 27.1879C37.6877 27.2156 37.5906 27.3496 37.5906 27.4975C37.5906 27.5922 37.6392 27.6661 37.7154 27.7215C37.616 27.7631 37.5467 27.8371 37.5467 27.9526C37.5467 28.2552 37.9811 28.2922 38.1982 28.2922C38.353 28.2922 38.554 28.2714 38.6949 28.2067C38.8451 28.1374 38.9537 27.9849 38.9537 27.8163C38.9537 27.7146 38.919 27.6245 38.8382 27.5621C38.7527 27.4951 38.6349 27.4813 38.5309 27.472L38.1913 27.442V27.4443ZM36.4771 26.772C36.5395 26.7073 36.6481 26.638 36.7405 26.638C36.856 26.638 36.8583 26.7512 36.8583 26.8344V27.271C36.8583 27.3889 36.8606 27.4351 36.7174 27.4605V27.6707H37.4543V27.4605L37.4081 27.4512C37.355 27.4374 37.3088 27.4328 37.2926 27.3727C37.2811 27.3311 37.2834 27.2664 37.2834 27.2225V26.8021C37.2834 26.6727 37.2787 26.571 37.1794 26.474C37.0939 26.3908 36.9807 26.3539 36.8652 26.3539C36.7081 26.3539 36.5718 26.4093 36.4401 26.4971V26.3862H36.3108L35.8603 26.4532V26.6635H35.8787C36.0612 26.6842 36.0566 26.7351 36.0566 26.9037V27.2179C36.0566 27.3912 36.0589 27.4397 35.8626 27.4605V27.6707H36.6203V27.4605H36.5995C36.5048 27.4328 36.4771 27.4166 36.4771 27.2641V26.7697V26.772ZM34.8068 26.3885H34.6404L34.1899 26.4555V26.6658H34.2084C34.3909 26.6866 34.3863 26.7374 34.3863 26.906V27.2087C34.3863 27.345 34.384 27.479 34.4787 27.5852C34.5619 27.68 34.682 27.6961 34.8022 27.6961C34.9662 27.6961 35.1002 27.6522 35.2365 27.5737V27.6753H35.7863V27.4651H35.7655C35.6061 27.4466 35.6107 27.3912 35.6107 27.2225V26.3908H35.4513L35.0008 26.4578V26.6681H35.0193C35.1949 26.6889 35.188 26.7397 35.188 26.9083V27.3219C35.1117 27.3727 35.0032 27.442 34.9038 27.4374C34.7929 27.4374 34.8045 27.3011 34.8045 27.204V26.3908L34.8068 26.3885Z\\" fill=\\"white\\"/>\\n        </g>\\n        <defs>\\n        <clipPath id=\\"clip0_4561_921\\">\\n        <rect width=\\"34\\" height=\\"10.2922\\" fill=\\"white\\" transform=\\"translate(5 18)\\"/>\\n        </clipPath>\\n        </defs>\\n        </svg>        \\n        ","image":"<svg xmlns=\\"http://www.w3.org/2000/svg\\" viewBox=\\"0 0 203 139\\" preserveAspectRatio=\\"xMidYMid slice\\" fill=\\"none\\"><path fill=\\"#0062a7\\" d=\\"M0 0h203v139H0z\\"/><g style=\\"fill:none\\"><path fill=\\"#0062a7\\" d=\\"M11.411 34.58h180.178v69.84H11.411Z\\"/><path fill=\\"#fff\\" d=\\"M14.71 101.152h173.569V37.858H14.709Zm174.95 1.386H13.329V36.462H189.66v66.085z\\"/><path fill=\\"#fff\\" d=\\"M34.987 77.059H24.16V49.764h12.056l14.13 15.013v-15.45h10.828V77.06H47.839l-12.852-14.85Zm30.566-27.731h34.243v6.385h-22.67v4.313h18.51v6.334h-18.51v4.314h22.67v6.385H65.553Zm38.242-.103h12.377V65.11s-.644 5.239 5.922 5.239c7.04 0 7.15-5.136 7.15-5.136V49.216h12.377V69.03s-.321 8.029-18.985 8.029c-20.002 0-18.824-8.628-18.824-8.79V49.216Zm41.706.103h34.294v6.385h-22.721v4.313h18.511v6.334h-18.511v4.314h22.721v6.385h-34.294ZM28.989 91.883l-1.44-4.031c-.05-.12-.135-.368-.135-.488 0-.428.635-.41 1.008-.436v-.968h-4.279v.968c.95.025 1.06.248 1.373 1.087l2.236 6.008h1.576l2.16-5.803c.255-.676.543-1.327 1.356-1.292v-.968h-3.279v.968c.322.05.907.008.907.47 0 .163-.06.334-.119.488l-1.355 3.989z\\"/><path fill=\\"#fff\\" fill-rule=\\"evenodd\\" d=\\"M35.365 94.117c.814 0 1.72-.214 2.321-.804.61-.582.907-1.43.907-2.277 0-.89-.322-1.814-1-2.405-.618-.548-1.482-.71-2.287-.71-1.906 0-3.143 1.147-3.143 3.107 0 .89.339 1.788 1 2.37.593.514 1.44.72 2.202.72zm.009-1.198c-.966 0-1.11-1.087-1.11-1.857s.102-1.943 1.11-1.943 1.11 1.147 1.11 1.943-.136 1.857-1.11 1.857zm6.438-4.844h-.466l-2.067.308v.967h.085c.839.094.813.334.813 1.113v1.472c0 .822 0 1.044-.932 1.113v.967h3.703v-.968h-.102c-.754-.068-.729-.342-.729-1.12v-2.192c0-.12.178-.188.348-.188.288 0 .449.368.974.368.491 0 .915-.342.915-.873 0-.608-.466-.959-1.034-.959-.567 0-.974.223-1.508.557v-.557zm8.7 4.622c-.067.06-.228.188-.321.188-.22 0-.195-.402-.195-.548v-2.31c0-.72-.068-1.319-.746-1.721-.5-.308-1.16-.394-1.736-.394-.619 0-1.237.069-1.788.394-.449.274-.813.719-.813 1.275 0 .497.381.865.873.865.262 0 .567-.12.745-.351.119-.18.136-.377.136-.582 0-.146 0-.249.118-.343.136-.128.398-.162.593-.162.195 0 .542.051.661.222.119.189.093.514.093.72v.307c-1.279.129-3.465.488-3.465 2.2 0 1.087.873 1.643 1.856 1.643.694 0 1.296-.214 1.863-.616.28.394.814.616 1.288.616.568 0 1.06-.222 1.483-.616l-.636-.804zm-2.388-.3c-.229.248-.61.41-.95.41-.338 0-.541-.282-.541-.607 0-.702.974-.89 1.5-.984v1.173zm5.752-4.322h-.466l-2.067.308v.967h.085c.838.094.813.334.813 1.113v1.472c0 .822 0 1.044-.923 1.113v.967h3.702v-.968h-.102c-.754-.068-.728-.342-.728-1.12v-2.192c0-.12.178-.188.347-.188.288 0 .449.368.974.368.483 0 .915-.342.915-.873 0-.608-.466-.959-1.033-.959-.568 0-.975.223-1.508.557v-.557z\\" clip-rule=\\"evenodd\\"/><path fill=\\"#fff\\" d=\\"M59.346 85.437h-.627a6.144 6.144 0 0 1-2.228.522v.967c.28 0 .602.034.78.163.16.128.135.608.135.804v4.04c0 .805.026.993-.788 1.113v.967h3.499v-.967l-.186-.051c-.254-.052-.45-.086-.534-.36-.06-.205-.06-.505-.06-.71V85.42z\\"/><path fill=\\"#fff\\" fill-rule=\\"evenodd\\" d=\\"M62.961 85.438h-.627a6.103 6.103 0 0 1-2.228.522v.967c.28 0 .602.034.78.163.16.128.135.608.135.804v6.129h1.33l.212-.377c.508.257.983.47 1.576.47 1.762 0 2.787-1.326 2.787-3.046 0-.77-.22-1.6-.712-2.183-.466-.565-1.228-.967-1.974-.967-.44 0-.982.188-1.287.394v-2.876zm0 4.168c.102-.316.56-.488.915-.488.907 0 1.102 1.079 1.102 1.798 0 .83-.136 2.003-1.186 2.003-.255 0-.619-.146-.84-.437v-2.876zm10.548 1.318v-.248c.059-1.729-1.195-2.747-2.804-2.747-1.754 0-3.05 1.232-3.05 3.055 0 1.823 1.321 3.141 3.143 3.141 1.33 0 2.22-.624 2.855-1.788l-.975-.497c-.338.565-.838 1.087-1.516 1.087-1.008 0-1.406-.873-1.406-2.003h3.761zm-3.694-.975c.05-.505.44-.856.906-.856s.797.342.814.856zm7.023-1.875h-.466l-2.067.308v.967h.085c.838.095.813.334.813 1.113v1.472c0 .813 0 1.044-.932 1.113v.967h3.702v-.967h-.101c-.754-.069-.729-.342-.729-1.121v-2.191c0-.12.17-.189.347-.189.288 0 .45.368.975.368.482 0 .915-.342.915-.873 0-.607-.466-.958-1.034-.958-.568 0-.974.222-1.508.556v-.556zM82.31 92.97c-.254-.027-1.068 0-1.068-.42 0-.146.085-.274.229-.274a.64.64 0 0 1 .178.026c.305.068.66.102.966.102 1.355 0 2.584-.761 2.584-2.26 0-.71-.348-1.292-.89-1.694.093-.128.195-.163.356-.163.22 0 .398.154.618.154.373 0 .729-.256.729-.65 0-.496-.44-.822-.907-.822-.745 0-1.262.462-1.66 1.053a5.769 5.769 0 0 0-1.008-.111c-1.33 0-2.567.804-2.567 2.276 0 .617.288 1.242.788 1.584-.661.128-1.102.745-1.102 1.43 0 .436.22.778.568 1.043-.449.189-.78.531-.78 1.062 0 1.395 2 1.575 2.991 1.575.703 0 1.635-.094 2.27-.394.687-.317 1.187-1.027 1.187-1.815 0-.47-.161-.89-.534-1.172-.398-.308-.932-.377-1.406-.411l-1.55-.145zm.178-3.955c.754 0 .872.607.872 1.24 0 .592-.152 1.148-.838 1.148-.687 0-.797-.557-.797-1.147 0-.548.068-1.241.763-1.241zm.728 5.923c.263.051.78.034.78.428 0 .222-.161.333-.348.402-.305.12-.974.154-1.313.154-.373 0-1.694-.086-1.694-.668 0-.248.195-.462.398-.565zm8.98-4.015v-.248c.06-1.729-1.194-2.747-2.804-2.747-1.753 0-3.05 1.232-3.05 3.055 0 1.823 1.322 3.142 3.143 3.142 1.33 0 2.22-.625 2.855-1.79l-.974-.496c-.339.565-.839 1.087-1.516 1.087-1.009 0-1.407-.873-1.407-2.003h3.762zm-3.702-.975c.05-.505.44-.856.907-.856.466 0 .796.342.813.856zm7.023-1.875h-.466l-2.067.308v.976h.085c.839.094.813.334.813 1.113v1.472c0 .813 0 1.044-.923 1.113v.975h3.702v-.975h-.102c-.754-.069-.728-.343-.728-1.122v-2.19c0-.12.178-.189.347-.189.288 0 .449.368.974.368.492 0 .915-.342.915-.873 0-.608-.466-.959-1.033-.959-.568 0-.975.223-1.508.557v-.557z\\" clip-rule=\\"evenodd\\"/><path fill=\\"#fff\\" d=\\"M104.094 91.892c0 .24.025.676-.127.864-.161.223-.568.283-.822.3h-.136v.967h4.236v-.967h-.135c-.255-.009-.661-.069-.822-.3-.153-.188-.127-.625-.127-.864v-4.57c-.009-.224-.009-.283.22-.283.432 0 .89.3 1.194.582.323.308.543.676.814 1.138l.847-.342-.923-2.448h-6.346l-.923 2.448.847.342c.263-.462.491-.83.813-1.138.305-.283.763-.582 1.195-.582.229 0 .229.06.22.282v4.57z\\"/><path fill=\\"#fff\\" fill-rule=\\"evenodd\\" d=\\"M115.089 92.695c-.068.06-.229.188-.322.188-.221 0-.195-.402-.195-.548v-2.31c0-.72-.068-1.319-.746-1.72-.5-.309-1.16-.395-1.736-.395-.619 0-1.246.069-1.788.394-.449.274-.813.72-.813 1.275 0 .497.38.865.872.865.271 0 .568-.12.746-.351.118-.18.135-.377.135-.582 0-.145 0-.248.119-.342.136-.129.398-.163.593-.163.195 0 .542.043.661.223.118.188.093.505.093.719v.308c-1.279.128-3.465.488-3.465 2.2 0 1.086.873 1.643 1.855 1.643.695 0 1.297-.214 1.873-.617.279.394.813.617 1.287.617.568 0 1.059-.223 1.483-.617l-.636-.804zm-2.389-.3c-.229.249-.61.411-.949.411-.339 0-.542-.282-.542-.607 0-.702.974-.89 1.499-.985v1.173zm5.989.574c-.254-.026-1.067 0-1.067-.411 0-.146.084-.274.228-.274.06 0 .119.009.178.026.305.068.661.102.966.102 1.356 0 2.584-.761 2.584-2.26 0-.71-.347-1.292-.89-1.694.094-.128.195-.162.356-.162.22 0 .398.154.619.154.372 0 .728-.257.728-.65 0-.497-.44-.822-.906-.822-.746 0-1.263.462-1.661 1.052a5.754 5.754 0 0 0-1.008-.102c-1.33 0-2.567.804-2.567 2.276 0 .617.288 1.241.788 1.592-.661.129-1.101.745-1.101 1.43 0 .436.22.779.567 1.044-.449.188-.779.53-.779 1.07 0 1.395 1.991 1.575 2.99 1.575.712 0 1.636-.095 2.271-.394.686-.317 1.186-1.027 1.186-1.815 0-.47-.161-.89-.534-1.172-.398-.308-.932-.377-1.406-.411l-1.559-.146zm.178-3.954c.754 0 .873.607.873 1.24 0 .591-.153 1.148-.839 1.148-.686 0-.797-.557-.797-1.147 0-.548.068-1.241.763-1.241zm.729 5.922c.262.052.779.035.779.428 0 .223-.161.334-.347.403-.305.12-.975.154-1.314.154-.372 0-1.694-.086-1.694-.668 0-.248.195-.462.398-.565zm8.98-4.022v-.249c.059-1.728-1.195-2.747-2.805-2.747-1.753 0-3.049 1.232-3.049 3.056 0 1.823 1.321 3.14 3.143 3.14 1.33 0 2.211-.624 2.855-1.788l-.975-.497c-.339.565-.838 1.087-1.516 1.087-1.008 0-1.406-.873-1.406-2.002zm-3.703-.968a.905.905 0 0 1 .907-.855c.466 0 .796.342.813.855z\\" clip-rule=\\"evenodd\\"/><path fill=\\"#fff\\" d=\\"M134.149 88.073h-.72l-.152.257c-.483-.257-.924-.41-1.483-.41-.601 0-1.203.18-1.677.59-.415.377-.686.916-.686 1.48 0 .617.245 1.14.762 1.447.449.274.966.334 1.457.402.322.052.763.095 1.068.206.178.068.339.188.339.402 0 .428-.704.574-1.026.574-.838 0-1.287-.454-1.762-1.079l-.94.146.466 1.943h.779l.127-.24c.475.24.966.334 1.483.334 1.262 0 2.601-.71 2.601-2.14 0-.496-.212-.967-.593-1.275-.407-.334-.941-.403-1.449-.497l-.584-.12c-.314-.06-1.042-.128-1.042-.582 0-.36.542-.462.813-.462.635 0 1.143.411 1.499.925l.941-.146-.221-1.737zm7.303 3.75-.889-.317c-.475.993-1.229 1.42-2.296 1.42l-.348-.025 3.33-3.946-.373-.873h-4.609l-.686 1.952.915.333.051-.068c.474-.77.906-1.121 1.847-1.121h.305l-3.33 3.894.288.959h5.067l.728-2.2z\\"/><path fill=\\"#fff\\" fill-rule=\\"evenodd\\" d=\\"M147.82 90.916v-.249c.059-1.729-1.195-2.747-2.804-2.747-1.754 0-3.05 1.232-3.05 3.055 0 1.824 1.321 3.142 3.143 3.142 1.338 0 2.211-.625 2.855-1.79l-.975-.496c-.338.565-.838 1.087-1.516 1.087-1.008 0-1.406-.873-1.406-2.002zm-3.703-.967c.051-.514.441-.856.907-.856s.796.342.813.855zm7.303-1.875h-.762l-2.067.308v.967h.084c.839.094.814.334.814 1.113v1.472c0 .796.008 1.027-.907 1.113v.967h3.626v-.967c-.822-.103-.788-.342-.788-1.113zm-1.076-2.688c-.635 0-1.135.531-1.135 1.182 0 .582.474 1.112 1.067 1.112.594 0 1.153-.522 1.153-1.164 0-.642-.466-1.138-1.076-1.138\\" clip-rule=\\"evenodd\\"/><path fill=\\"#fff\\" d=\\"M156.993 89.143v-1.07h-1.609V86.2h-1.135l-.026.094c-.093.617-.186 1.053-.661 1.481-.262.24-.567.394-.915.437v.924h.805v2.91c0 .556-.051 1.087.322 1.54.347.411.788.523 1.296.523 1 0 1.83-.334 2.482-1.113l-.694-.839c-.212.24-.712.65-1.008.65-.526 0-.466-.556-.466-.95v-2.721h1.609z\\"/><path fill=\\"#fff\\" fill-rule=\\"evenodd\\" d=\\"M160.823 88.073h-.763l-2.067.308v.968h.085c.838.094.813.333.813 1.112v1.395c0 .625-.008 1.259.432 1.738.381.436.932.505 1.483.505.754 0 1.372-.197 1.999-.565v.47h2.516v-.966h-.093c-.729-.086-.703-.343-.703-1.122v-3.851h-.729l-2.067.308v.967h.085c.796.094.779.334.779 1.113v1.917c-.347.24-.847.556-1.296.53-.508 0-.449-.624-.449-1.078v-3.766zm7.65 1.78c.288-.299.787-.616 1.203-.616.533 0 .542.522.542.916v2.029c0 .547.008.761-.653.873v.967h3.372v-.967l-.212-.052c-.245-.06-.449-.085-.533-.368-.06-.188-.051-.496-.051-.702V89.99c0-.607-.026-1.07-.475-1.514-.389-.394-.915-.557-1.44-.557-.72 0-1.347.257-1.948.66v-.506h-.593l-2.067.308v.968h.084c.839.094.814.333.814 1.112v1.455c0 .805.008 1.027-.898 1.122v.967h3.482v-.967h-.094c-.432-.129-.559-.206-.559-.916v-2.285zm7.87 3.116c-.254-.026-1.068 0-1.068-.41 0-.146.085-.275.229-.275.059 0 .119.009.178.026.305.068.661.103.966.103 1.355 0 2.584-.762 2.584-2.26 0-.71-.348-1.292-.89-1.695.093-.128.195-.162.356-.162.22 0 .398.154.618.154.373 0 .729-.257.729-.65 0-.497-.44-.814-.906-.814-.746 0-1.263.462-1.661 1.053a5.754 5.754 0 0 0-1.008-.103c-1.33 0-2.559.805-2.559 2.277 0 .616.289 1.241.788 1.584-.66.128-1.101.744-1.101 1.429 0 .436.22.779.568 1.044-.449.188-.78.53-.78 1.07 0 1.395 2 1.575 2.991 1.575.703 0 1.635-.094 2.27-.394.686-.317 1.186-1.027 1.186-1.814 0-.471-.161-.89-.533-1.173-.399-.308-.932-.377-1.407-.41l-1.55-.146zm.169-3.954c.754 0 .873.607.873 1.24 0 .591-.153 1.148-.839 1.148-.686 0-.796-.557-.796-1.147 0-.548.068-1.241.762-1.241zm.729 5.923c.271.051.779.034.779.428 0 .222-.161.333-.347.402-.305.12-.974.154-1.313.154-.373 0-1.695-.086-1.695-.66 0-.247.195-.461.399-.564l2.177.248z\\" clip-rule=\\"evenodd\\"/></g></svg>","isChecked":true},{"headline":"NEUE am Sonntag informiert","content":"Spannender Lesestoff und Reportagen für den perfekten Sonntag.","schedule":"sonntags | 06:00 Uhr","list":"NEUE_Wochenende","icon":"<svg width=\\"44\\" height=\\"44\\" viewBox=\\"0 0 44 44\\" fill=\\"none\\" xmlns=\\"http://www.w3.org/2000/svg\\">\\n        <circle cx=\\"22\\" cy=\\"22\\" r=\\"20\\" fill=\\"#CD1719\\"/>\\n        <path d=\\"M7.36499 24.0187H5V18.118H7.63301L10.7201 21.3635V18.0236H13.0851V24.0201H10.1716L7.3636 20.8094V24.0201L7.36499 24.0187ZM14.0419 18.0236H21.5216V19.4054H16.5694V20.3372H20.612V21.7065H16.5694V22.6383H21.5216V24.0187H14.0419V18.0236ZM22.3965 18H25.0989V21.4343C25.0989 21.4343 24.9587 22.5675 26.3918 22.5675C27.9291 22.5675 27.9527 21.4579 27.9527 21.4579V18H30.6566V22.2842C30.6566 22.2842 30.5871 24.0187 26.5085 24.0187C22.1396 24.0187 22.3951 22.1537 22.3951 22.1189V18H22.3965ZM31.5079 18.0236H39V19.4054H34.0367V20.3372H38.0793V21.7065H34.0367V22.6383H39V24.0187H31.5079V18.0236Z\\" fill=\\"white\\"/>\\n        <path d=\\"M29.2393 25.545C29.0643 25.2812 28.8171 25.0881 28.3463 25.0881C27.8158 25.0881 27.4395 25.452 27.4395 25.9825C27.4395 26.3421 27.5673 26.5685 28.0269 26.7574C28.3241 26.8796 28.3422 26.9462 28.3422 27.0462C28.3422 27.1545 28.2769 27.2434 28.1172 27.2434C27.8894 27.2434 27.695 27.0948 27.5645 26.8907L27.084 27.3365C27.2715 27.6337 27.5964 27.8267 28.0797 27.8267C28.6144 27.8267 28.9865 27.4934 28.9865 26.9365C28.9865 26.5685 28.8213 26.3352 28.4241 26.1727C28.1144 26.0436 28.0866 25.9908 28.0866 25.8686C28.0866 25.7686 28.1464 25.6714 28.2991 25.6714C28.4519 25.6714 28.6088 25.7867 28.7393 25.9686L29.2393 25.5464V25.545ZM30.6919 26.4796V26.4727C30.6919 25.9936 30.4544 25.745 30.0197 25.745C29.5226 25.745 29.2393 26.0713 29.1046 26.7018C29.0768 26.8393 29.0546 26.9948 29.0546 27.0948V27.1018C29.0546 27.5809 29.292 27.8295 29.7267 27.8295C30.2239 27.8295 30.5072 27.5031 30.6419 26.8726C30.6697 26.7352 30.6919 26.5796 30.6919 26.4796ZM30.0795 26.3491C30.0795 26.431 30.0614 26.5727 30.0142 26.7865C29.9267 27.1907 29.867 27.3906 29.7642 27.3906C29.6962 27.3906 29.667 27.3531 29.667 27.2309V27.224C29.667 27.142 29.6864 27.0018 29.7323 26.7865C29.8198 26.3824 29.8795 26.1824 29.9822 26.1824C30.0503 26.1824 30.0795 26.2199 30.0795 26.3421V26.3491ZM32.4542 26.1408C32.4542 25.8964 32.3417 25.7547 32.132 25.7547C31.957 25.7547 31.7973 25.8728 31.5626 26.1894H31.5501L31.6404 25.7519L30.9835 25.8408L30.5738 27.792H31.2113L31.5112 26.363C31.5668 26.3296 31.6084 26.3144 31.6487 26.3144C31.7265 26.3144 31.764 26.3546 31.764 26.4324C31.764 26.4657 31.7612 26.5032 31.7515 26.5477L31.489 27.7906H32.1264L32.4264 26.3588C32.4417 26.2769 32.4514 26.2033 32.4514 26.1394M34.1637 26.1394C34.1637 25.895 34.0512 25.7533 33.8415 25.7533C33.6665 25.7533 33.5068 25.8714 33.2735 26.188H33.261L33.3513 25.7506L32.6944 25.8394L32.2847 27.7906H32.9222L33.2221 26.3616C33.2791 26.3283 33.3193 26.313 33.3596 26.313C33.4374 26.313 33.4749 26.3533 33.4749 26.431C33.4749 26.4644 33.4721 26.5019 33.4624 26.5463L33.1999 27.7892H33.8373L34.1373 26.3574C34.1526 26.2755 34.1623 26.2019 34.1623 26.138M35.6246 25.7853H35.2052L35.3524 25.0881L34.7094 25.177L34.5817 25.7853H34.3067L34.2039 26.2824H34.4789L34.297 27.1434C34.2817 27.2212 34.272 27.317 34.272 27.3809C34.272 27.6656 34.4248 27.8253 34.7275 27.8253C34.9247 27.8253 35.0677 27.7989 35.258 27.7184L35.3705 27.1726C35.233 27.2282 35.1608 27.2434 35.0802 27.2434C34.9927 27.2434 34.9358 27.2059 34.9358 27.1143C34.9358 27.0768 34.9455 27.0282 34.9511 26.9948L35.1011 26.2824H35.5191L35.6218 25.7853H35.6246ZM37.2869 25.8367L36.6675 25.7478L36.5995 26.07H36.587C36.4523 25.8325 36.3648 25.7506 36.1843 25.7506C35.7996 25.7506 35.4663 26.5518 35.4663 27.2934V27.3004C35.4663 27.6267 35.5913 27.8128 35.801 27.8128C35.9704 27.8128 36.1079 27.6934 36.3037 27.4351H36.3162L36.2343 27.817L36.8897 27.7281L37.2869 25.8367ZM36.512 26.3894C36.512 26.6824 36.362 27.3101 36.187 27.3101C36.1273 27.3101 36.0995 27.2698 36.0995 27.1171C36.0995 26.824 36.2495 26.1977 36.4245 26.1977C36.4842 26.1977 36.512 26.238 36.512 26.3908M38.995 25.838L38.377 25.7492L38.309 26.0713H38.2965C38.1618 25.8339 38.0743 25.7519 37.8938 25.7519C37.5091 25.7519 37.1744 26.5532 37.1744 27.2948V27.3018C37.1744 27.6281 37.2994 27.8142 37.5091 27.8142C37.6771 27.8142 37.8146 27.6948 38.0118 27.4365H38.0243L37.9646 27.7184C37.9049 27.9961 37.7618 28.1197 37.5591 28.1197C37.3938 28.1197 37.2938 28.0419 37.2466 27.9447H37.1369L37.0397 28.4086C37.18 28.4641 37.3425 28.4974 37.5744 28.4974C38.1896 28.4974 38.477 28.2975 38.6215 27.6184L38.9964 25.838H38.995ZM38.2201 26.3908C38.2201 26.6838 38.0701 27.3115 37.8952 27.3115C37.8354 27.3115 37.8077 27.2712 37.8077 27.1184C37.8077 26.8254 37.9577 26.1991 38.1326 26.1991C38.1923 26.1991 38.2201 26.2394 38.2201 26.3921\\" fill=\\"white\\"/>\\n        <path d=\\"M26.6755 26.3212C26.7089 26.1837 26.7241 26.0837 26.72 26.0226C26.7144 25.9559 26.6936 25.906 26.6547 25.8685C26.6186 25.8337 26.5741 25.8171 26.5186 25.8171C26.4006 25.8171 26.2908 25.8865 26.1895 26.024C26.1714 25.8865 26.1089 25.8171 26.0006 25.8171C25.8923 25.8171 25.7979 25.8712 25.7006 25.9782L25.7326 25.8462H25.5243L25.2424 26.9919H25.4507L25.5757 26.4823C25.6034 26.3726 25.6298 26.292 25.6562 26.2406C25.7118 26.1323 25.777 26.0782 25.852 26.0782C25.8826 26.0782 25.9062 26.0893 25.9228 26.1115C25.9548 26.1559 25.9506 26.2642 25.9076 26.4364L25.7715 26.9905H25.9812L26.1089 26.4739C26.1353 26.3642 26.1631 26.2851 26.1881 26.2351C26.2436 26.1295 26.3089 26.0768 26.3853 26.0768C26.445 26.0768 26.4755 26.1143 26.4783 26.1893C26.4783 26.2365 26.4672 26.3101 26.4436 26.4087L26.3006 26.9892H26.5103L26.6755 26.317V26.3212ZM24.8577 26.6586C24.7994 26.7253 24.7355 26.7586 24.6674 26.7586C24.5994 26.7586 24.5549 26.7253 24.5286 26.6573C24.5036 26.592 24.5036 26.5142 24.5258 26.4198C24.5494 26.3253 24.5883 26.2462 24.6438 26.1837C24.7008 26.117 24.7646 26.0851 24.8313 26.0851C24.898 26.0851 24.9466 26.117 24.973 26.1795C24.9993 26.2434 24.9993 26.3226 24.9757 26.4184C24.9521 26.5156 24.9118 26.5948 24.8563 26.6586M25.3132 25.8476H25.1063L25.0757 25.974C25.0271 25.8698 24.9535 25.8185 24.8535 25.8185C24.7369 25.8185 24.6272 25.8796 24.523 26.0032C24.4258 26.1184 24.3564 26.2587 24.3161 26.4239C24.2772 26.585 24.2786 26.7239 24.3216 26.8406C24.3675 26.9628 24.448 27.0239 24.5619 27.0239C24.6549 27.0239 24.7521 26.9739 24.8535 26.8725L24.823 26.9933H25.0299L25.3118 25.8476H25.3132Z\\" fill=\\"white\\"/>\\n        </svg>        \\n        ","image":"<svg xmlns=\\"http://www.w3.org/2000/svg\\" viewBox=\\"0 0 203 139\\" preserveAspectRatio=\\"xMidYMid slice\\" fill=\\"none\\"><path fill=\\"#cd1719\\" d=\\"M0 0h203v139H0z\\"/><g style=\\"fill:none\\"><path fill=\\"#cd1719\\" d=\\"M191.597 34.445H11.403V104.45H191.599v-.197z\\"/><path fill=\\"#fff\\" d=\\"M15.058 100.95H187.95V37.947H15.058Zm174.332 1.455H13.617V36.492H189.39Z\\"/><path fill=\\"#fff\\" d=\\"M145.667 49.99h34.175v6.367h-22.646v4.297h18.443v6.308h-18.443v4.296h22.645v6.368h-34.174Zm-41.563-.112h12.335v15.825s-.635 5.221 5.905 5.221c7.015 0 7.116-5.11 7.116-5.11V49.879h12.334v19.745s-.322 7.995-18.917 7.995c-19.934 0-18.765-8.594-18.765-8.756V49.878zm-38.115.111h34.125v6.368H77.528v4.297h18.443v6.308H77.528v4.296h22.586v6.368H65.989ZM35.533 77.626H24.74v-27.2h12.013l14.089 14.96V49.99h10.793v27.637H48.35l-12.81-14.798v14.798ZM176.31 88.566c0 1.352-.686 4.236-1.483 4.236-.27 0-.398-.188-.398-.89 0-1.352.687-4.236 1.483-4.236.271 0 .398.188.398.89zm3.533-2.542-2.82-.411-.315 1.49h-.059c-.61-1.096-1.017-1.473-1.838-1.473-1.754 0-3.279 3.697-3.279 7.112v.035c0 1.506.568 2.362 1.525 2.362.772 0 1.399-.548 2.297-1.746h.058l-.27 1.301c-.271 1.284-.923 1.849-1.855 1.849-.754 0-1.212-.36-1.424-.805h-.5l-.44 2.14c.644.257 1.38.41 2.44.41 2.813 0 4.117-.924 4.778-4.056l1.71-8.208zm-11.327 2.542c0 1.352-.686 4.236-1.483 4.236-.27 0-.398-.188-.398-.89 0-1.352.687-4.236 1.483-4.236.271 0 .398.188.398.89zm3.533-2.542-2.82-.411-.315 1.49h-.059c-.61-1.096-1.008-1.473-1.838-1.473-1.754 0-3.279 3.697-3.279 7.112v.035c0 1.506.568 2.362 1.525 2.362.771 0 1.398-.548 2.296-1.746h.06l-.374 1.763 2.991-.41zm-7.582-.24h-1.907l.67-3.218-2.932.41-.584 2.808h-1.254l-.474 2.294h1.253l-.83 3.971a6.64 6.64 0 0 0-.11 1.096c0 1.318.695 2.054 2.084 2.054.898 0 1.55-.12 2.423-.496l.508-2.517c-.627.257-.957.325-1.32.325-.399 0-.662-.17-.662-.599 0-.17.042-.393.068-.548l.686-3.278h1.906l.475-2.293zm-6.668 1.618c0-1.13-.517-1.78-1.465-1.78-.797 0-1.525.547-2.593 2.002h-.059l.415-2.02-2.99.411-1.864 8.996h2.906l1.364-6.582c.254-.154.44-.223.626-.223.356 0 .526.188.526.548 0 .154-.017.325-.06.53l-1.194 5.727h2.906l1.364-6.6c.067-.376.11-.718.11-1.01m-7.802 0c0-1.13-.508-1.78-1.465-1.78-.797 0-1.525.548-2.593 2.003h-.06l.416-2.02-2.99.411-1.864 8.996h2.906l1.372-6.582c.254-.154.44-.223.627-.223.356 0 .525.188.525.548 0 .154-.017.325-.06.53l-1.194 5.727h2.906l1.364-6.6c.068-.376.11-.718.11-1.01zm-10.827.96c0 .376-.084 1.026-.296 2.02-.398 1.865-.67 2.79-1.144 2.79-.313 0-.44-.172-.44-.737V92.4c0-.376.083-1.027.295-2.02.398-1.866.67-2.79 1.144-2.79.313 0 .44.171.44.736zm2.788.598v-.034c0-2.208-1.085-3.355-3.067-3.355-2.262 0-3.558 1.506-4.177 4.408-.127.633-.23 1.352-.23 1.814v.035c0 2.208 1.086 3.355 3.068 3.355 2.262 0 3.558-1.507 4.177-4.417.127-.633.229-1.352.229-1.814m-6.625-4.297c-.797-1.215-1.923-2.105-4.075-2.105-2.423 0-4.134 1.677-4.134 4.117 0 1.66.584 2.704 2.677 3.569 1.355.565 1.44.873 1.44 1.335 0 .496-.297.907-1.025.907-1.042 0-1.923-.685-2.525-1.626l-2.194 2.054c.856 1.37 2.338 2.26 4.54 2.26 2.44 0 4.135-1.54 4.135-4.1 0-1.695-.754-2.773-2.567-3.526-1.406-.6-1.542-.84-1.542-1.404 0-.462.27-.907.974-.907s1.407.53 2.008 1.37l2.279-1.952zM117.422 86.05h-.95l-.143.581c-.22-.48-.56-.719-1.016-.719-.535 0-1.035.283-1.509.848-.44.53-.753 1.18-.94 1.934-.179.745-.17 1.378.025 1.926.213.565.577.847 1.094.847.422 0 .863-.231 1.33-.693l-.137.556h.95l1.287-5.28zm-2.084 3.74c-.271.308-.56.462-.872.462-.314 0-.517-.154-.636-.471-.11-.3-.118-.66-.008-1.096.11-.436.288-.796.542-1.087.262-.308.55-.453.856-.453.304 0 .525.145.643.436.119.291.119.66.017 1.104-.11.445-.288.813-.542 1.104zm8.285-1.558c.152-.634.22-1.096.203-1.378-.025-.3-.118-.54-.296-.71a.872.872 0 0 0-.619-.24c-.541 0-1.041.316-1.5.95-.083-.634-.371-.95-.863-.95s-.924.248-1.373.744l.145-.607h-.95l-1.287 5.28h.958l.576-2.345c.126-.505.244-.881.371-1.112.256-.497.552-.745.899-.745a.37.37 0 0 1 .321.154c.154.206.128.702-.066 1.498l-.627 2.56h.957l.576-2.38c.126-.505.245-.873.363-1.104.256-.48.552-.728.899-.728.27 0 .414.171.423.522 0 .214-.05.556-.16 1.01l-.652 2.68h.956l.755-3.1z\\"/></g></svg>","isChecked":true}]')
  };
  O.AbocardLoginForm = ba, O.AbocardRegisterForm = Ea, O.BrightcovePlayer = $s, O.Card = ei, O.CardSection = Qr, O.CardSlider = Ei, O.CategoryLabel = xi, O.CategoryLinkLabel = Re, O.ChangePasswordForm = xa, O.DefaultButton = pe, O.Dropdown = ki, O.ForgetPasswordForm = ka, O.ImageGallery = _a, O.LargeTeaser = y1, O.Lightbox = Aa, O.ListingPagination = ja, O.LoadingOverlay = tt, O.LoadingSpinner = _t, O.ModalBox = Me, O.ModalWrapper = Ve, O.MyTownDropdown = Hi, O.MyTownTopicWidget = Q1, O.Navigation = oo, O.ResponsivePicture = je, O.SearchBox = Gi, O.SmallTeaser = V1, O.SnowReport = I1, O.SocialBookmarksModal = jo, O.UnderlineButton = Dt, O.UserImage = T1, O.VplusIcon = ft, O.XSmallTeaser = Ui, O.myTownMapping = Xa, O.newsletterConfig = l2, O.useCookie = Nt, O.useGdpr = e2, O.useIsDesktop = n2, O.usePaginationUrl = $t, O.usePostId = r2, O.useSSO = at, O.useSubscription = a2, O.useTracking = qi, Object.defineProperty(O, Symbol.toStringTag, {
    value: "Module"
  });
});
"use strict";

(function (window, document, undefined) {
  'use strict';

  var consentGivenEvent = document.createEvent('CustomEvent'),
    consentGivenEventName = 'vodl_consent_given',
    consentDemandEventName = 'vodl_consent_demand',
    consentOndemandClassName = 'vodl-consent-ondemand',
    pageWrapperClassname = 'vodl-ad-wrapper';
  var consentOndemandPanel = null,
    pageWrapper = null;
  var currentTarget = false;

  // logger with traffic light emoji prefix
  var logger = {};
  try {
    logger = new window.RussMedia.Utils.Logger(String.fromCodePoint(0x1F6A6)) || {
      log: function log() {}
    };
  } catch (e) {
    logger = {
      log: function log() {}
    };
  }
  var settings = {};
  try {
    settings = window.RussMedia.Consent.Settings;
  } catch (e) {
    settings = {
      embed_providers: {
        generic: {
          name: 'Generic',
          description: 'Generic Embed Code'
        }
      },
      i18n: {
        buttons: {
          allow_all: 'Allow all!',
          allow_self: 'Allow %s!'
        }
      }
    };
  }
  var _sprintf = function sprintf(str) {
    for (var _len = arguments.length, argv = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      argv[_key - 1] = arguments[_key];
    }
    return !argv.length ? str : _sprintf.apply(void 0, [str = str.replace(_sprintf.token || '%s', argv.shift())].concat(argv));
  };
  var init = function init() {
    // Get the consentOndemandPanel.
    // We assume there is only one in the DOM!
    consentOndemandPanel = document.querySelector('.' + consentOndemandClassName);
    // Nothing to do, if there is no consentOndemandPanel.
    if (null === consentOndemandPanel) {
      return;
    }

    // Get a handle for the .vodl-ad-wrapper DIV.
    // That wrapper will be blurred, while the consentOndemandPanel is shown.
    pageWrapper = document.querySelector('.' + pageWrapperClassname);

    // Listen to "vodl_consent_demand" custom events.
    document.addEventListener(consentDemandEventName, function (ev) {
      events.onConsentDemand(ev);
    });
  };
  var events = {
    /**
     * This triggers the "vodl_consent_given" custom event.
     * The given data object is set as event detail of the triggered custom event.
     *
     * Furthermore the iOS app is notified via messageHandlers about the given consent.
     *
     * @param  {Object} data Data object with provider property.
     * @return {undefined}
     */
    giveConsent: function giveConsent(data) {
      consentGivenEvent.initCustomEvent(consentGivenEventName, true, true, data);
      document.dispatchEvent(consentGivenEvent);

      // Also notify the iOS app, that the provider was given consent to.
      if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.native_subscription_messanger) {
        window.webkit.messageHandlers.toggleMessageHandler.postMessage({
          'enablePlatform': data.provider
        });
      }
    },
    /**
     * Click event handler for consenting to all embed providers.
     *
     * @return {undefined}
     */
    onButtonConsentAllClick: function onButtonConsentAllClick() {
      if (!currentTarget) {
        return;
      }
      var data = {
        'provider': '*'
      };
      events.giveConsent(data);
      ui.resetConsentOndemandPanel();
      window.setTimeout(ui.triggerOriginalClick, 1000);
    },
    /**
     * Click event handler for consenting to a single embed provider.
     *
     * @return {undefined}
     */
    onButtonConsentSelfClick: function onButtonConsentSelfClick() {
      logger.log('onButtonConsentSelfClick:', currentTarget);
      if (!currentTarget) {
        return;
      }
      var data = {
        'provider': currentTarget.dataset.provider || false
      };
      events.giveConsent(data);
      ui.resetConsentOndemandPanel();
      window.setTimeout(ui.triggerOriginalClick, 1000);
    },
    /**
     * Click event handler for consenting to a single embed provider.
     *
     * @return {undefined}
     */
    onCancelClick: function onCancelClick() {
      logger.log('onCancelClick');
      ui.resetConsentOndemandPanel();
    },
    /**
     * [description]
     *
     * @param  {Event} ev The event object.
     * @return {undefined}
     */
    onConsentDemand: function onConsentDemand(ev) {
      currentTarget = ev.detail || false;
      if (!currentTarget) {
        return;
      }
      logger.log('events.onConsentDemand', currentTarget);
      ui.initConsentOndemandPanel();
    }
  };
  var ui = {
    initConsentOndemandPanel: function initConsentOndemandPanel() {
      if (!currentTarget) {
        return;
      }
      var label;
      var provider = currentTarget.dataset.provider || false;
      if (!provider) {
        return;
      }
      consentOndemandPanel.dataset.provider = provider;
      var cancelButton = consentOndemandPanel.querySelector('.' + consentOndemandClassName + '__cancel');
      logger.log('initConsentOndemandPanel cancelButton:', cancelButton);
      cancelButton.removeEventListener('click', events.onCancelClick);
      cancelButton.addEventListener('click', events.onCancelClick);
      var consentText = consentOndemandPanel.querySelector('.vodl-consent-required-controls__text');
      var consentSubText = consentOndemandPanel.querySelector('.vodl-consent-required-controls__subtext');
      var buttonConsentAll = consentOndemandPanel.querySelector('button[data-consent-to="all"]');
      var buttonConsentSelf = consentOndemandPanel.querySelector('button[data-consent-to="self"]');
      if (consentText) {
        consentText.textContent = settings.embed_providers[provider].consent_text;
      }
      if (consentSubText) {
        consentSubText.innerHTML = settings.i18n.general.consent_subtext;
      }
      buttonConsentAll.removeEventListener('click', events.onButtonConsentAllClick);
      buttonConsentAll.addEventListener('click', events.onButtonConsentAllClick);
      label = buttonConsentAll.querySelector('span.vodl-button__label');
      if (label) {
        label.textContent = settings.i18n.buttons.consent_all;
      }
      var useIcon = buttonConsentSelf.querySelector('svg use');
      if (useIcon && useIcon.attributes['xlink:href'] && settings.embed_providers[provider]) {
        useIcon.attributes['xlink:href'].value = '#vodl-icon-content-providers-' + provider;
      }
      buttonConsentSelf.removeEventListener('click', events.onButtonConsentSelfClick);
      buttonConsentSelf.addEventListener('click', events.onButtonConsentSelfClick);
      label = buttonConsentSelf.querySelector('span.vodl-button__label');
      if (label && provider) {
        label.textContent = _sprintf(settings.i18n.buttons.consent_self, settings.embed_providers[provider].name);
      }
      consentOndemandPanel.style.display = 'block';
      if (pageWrapper && pageWrapper.classList) {
        pageWrapper.classList.add(pageWrapperClassname + '--blurred');
      }
    },
    resetConsentOndemandPanel: function resetConsentOndemandPanel() {
      consentOndemandPanel.style.display = 'none';
      if (pageWrapper && pageWrapper.classList) {
        pageWrapper.classList.remove(pageWrapperClassname + '--blurred');
      }
    },
    triggerOriginalClick: function triggerOriginalClick() {
      logger.log('triggerOriginalClick:', currentTarget);
      if (!currentTarget) {
        return;
      }

      // Fugly, I know. Media item click event handlers in vodl-lightbox.js
      // are attached to the children of <a class="vodl-compact">, not the <a> itself.
      if (currentTarget.classList.contains('vodl-compact')) {
        currentTarget.firstElementChild.click();
      } else {
        currentTarget.click();
      }
      currentTarget = false;
    }
  };
  init();
})(window, document);
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
(function (window, document, undefined) {
  'use strict';

  var consentGivenEvent = document.createEvent('CustomEvent'),
    consentGivenEventName = 'vodl_consent_given',
    consentPreferencesClassName = 'vodl-consent-preferences',
    consentRevokedEvent = document.createEvent('CustomEvent'),
    consentRevokedEventName = 'vodl_consent_revoked',
    openPreferencesEventName = 'vodl_consent_open_preferences',
    pageWrapperClassname = 'vodl-ad-wrapper',
    stateChangeEventName = 'vodl_consent_state_change',
    stateInitializedEventName = 'vodl_consent_state_initialized',
    toggleScope = 'vodl-consent-preferences';

  // logger with gear emoji prefix
  var logger = {};
  try {
    logger = new window.RussMedia.Utils.Logger(String.fromCodePoint(0x2699)) || {
      log: function log() {}
    };
  } catch (e) {
    logger = {
      log: function log() {}
    };
  }
  var controlPanel = null,
    pageWrapper = null;
  var userStateInitialized = false;

  /**
   * Initialize the controlPanel and attach event handlers.
   *
   * @return {undefined}
   */
  var init = function init() {
    // Get the controlPanel.
    // We assume there is only one in the DOM!
    controlPanel = document.querySelector('.' + consentPreferencesClassName);
    // Nothing to do, if there is no controlPanel.
    if (null === controlPanel) {
      return;
    }

    // Get a handle for the .vodl-ad-wrapper DIV.
    // That wrapper will be blurred, while the controlPanel is shown.
    pageWrapper = document.querySelector('.' + pageWrapperClassname);

    // Add click handler to the X Button.
    var closeButton = controlPanel.querySelector('.' + consentPreferencesClassName + '__close');
    closeButton.addEventListener('click', events.onCloseButtonClicked);

    // Gett all toggles in the controlPanel
    // and add a handler for the toggle's checkBox change event.
    var toggles = [];
    toggles = controlPanel.querySelectorAll('.vodl-toggle');
    toggles.forEach(function (toggle) {
      var checkBox = toggle.querySelector('input[type="checkbox"]');
      checkBox.addEventListener('change', function () {
        events.onToggleChange(checkBox);
      });
    });

    // Gett all description toggles (arrow buttons) in the controlPanel
    // and add a handler for the click event.
    var arrows = [];
    arrows = controlPanel.querySelectorAll('.' + consentPreferencesClassName + '__provider-item-desc-toggle');
    arrows.forEach(function (arrow) {
      arrow.addEventListener('click', events.onArrowClicked);
    });

    // Listen to the global 'vodl_consent_state_change' custom events.
    document.addEventListener(stateChangeEventName, events.onStateChange);

    // Listen to the global 'vodl_consent_state_initialized' custom events.
    document.addEventListener(stateInitializedEventName, events.onStateInitialized);
  };

  /**
   * A collection of event handlers.
   *
   * @type {Object}
   */
  var events = {
    /**
     * Event handler for clicks on the arrow buttons.
     * Will show or hide the item description.
     *
     * @param  {Event} ev The event object.
     * @return {undefined}
     */
    onArrowClicked: function onArrowClicked(ev) {
      ev = ev || {};
      var originalTarget = ev.target || false;
      var target = null;
      target = helpers.findSelfOrParentByClassName(originalTarget, consentPreferencesClassName + '__provider-item');
      if (!target) {
        return;
      }
      ui.toggleDescription(target);
    },
    /**
     * Event handler for clicks on the close button.
     * Will hide the controlPanel.
     *
     * @return {undefined}
     */
    onCloseButtonClicked: function onCloseButtonClicked() {
      ui.hide();
    },
    /**
     * Event handler for opening the preferences.
     * Will show the controlPanel.
     *
     * @return {undefined}
     */
    onOpenPreferences: function onOpenPreferences() {
      ui.show();
    },
    /**
     * Change event handler for a toggle checkBox.
     * The provider data attribute is extracted.
     * If the checkBox is checked, the 'vodl_consent_given' event is dispatched
     * with passing the provider in an event details property.
     * If the checkBox is NOT checked, the 'vodl_consent_revoked' event is dispatched
     * with passing the provider in an event details property.
     *
     * @param  {Node} checkBox The checkBox DOM Node that has triggered the change event.
     * @return {undefined}
     */
    onToggleChange: function onToggleChange(checkBox) {
      var provider = checkBox.dataset.provider || false;
      if (!provider) {
        return;
      }
      var data = {
        provider: provider
      };
      logger.log('onToggleChange: ', provider, checkBox.checked);
      if (true === checkBox.checked) {
        consentGivenEvent.initCustomEvent(consentGivenEventName, true, true, data);
        document.dispatchEvent(consentGivenEvent);
      }
      if (false === checkBox.checked) {
        consentRevokedEvent.initCustomEvent(consentRevokedEventName, true, true, data);
        document.dispatchEvent(consentRevokedEvent);
      }
    },
    /**
     * The registered event handler for the 'vodl_consent_state_change' custom event.
     * Will call ui.updateToggle() or ui.updateAllToggles() if there are consentSettings
     * in the event details.
     *
     * @param  {Event} ev The event object.
     * @return {undefined}
     */
    onStateChange: function onStateChange(ev) {
      var evDetails = ev.detail || {},
        keyPath = [],
        len = 0;
      if (evDetails.path) {
        keyPath = evDetails.path.split('.');
        len = keyPath.length;
        if (2 === len && 'consentSettings' === keyPath[0]) {
          if ('*' === keyPath[1]) {
            ui.updateAllToggles(evDetails);
          } else {
            ui.updateToggle(evDetails);
          }
        }
      }
    },
    /**
     * The registered event handler for the 'vodl_consent_state_initialized' custom event.
     * Determines if the controlPanel needs to be shown or not,
     * depending on the users pureSubscriber property.
     *
     * Furthermore updates all toggles in the controlPanel with the given users consentSettings.
     *
     * @param  {Event} ev The event object.
     * @return {undefined}
     */
    onStateInitialized: function onStateInitialized(ev) {
      var evDetails = ev.detail || {};
      if (!evDetails.pureSubscriber || userStateInitialized) {
        return;
      }
      if (evDetails.pureSubscriber) {
        // Listen to the global 'vodl_consent_open_preferences' custom events.
        document.addEventListener(openPreferencesEventName, events.onOpenPreferences);
        ui.injectSettingsButtonToLoginLabel();
      }
      if (!evDetails.consentSettings) {
        return;
      }
      for (var _i = 0, _Object$entries = Object.entries(evDetails.consentSettings); _i < _Object$entries.length; _i++) {
        var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
          provider = _Object$entries$_i[0],
          consent = _Object$entries$_i[1];
        var path = 'consentSettings.' + provider;
        var newValue = consent;
        ui.updateToggle({
          path: path,
          newValue: newValue
        });
      }
      userStateInitialized = true;
    }
  };
  var helpers = {
    /**
     * Finds an DOM Node with the given className by searching the DOM upwards,
     * starting with currentElement itself.
     *
     * @param  {Node} currentElement The DOM Node to start from.
     * @param  {string} className    The name of the class we are looking for.
     * @param  {int} maxDepth        The maximum number of elements to go upwards.
     * @return {Node|null}           The found Node if any, null otherwise.
     */
    findSelfOrParentByClassName: function findSelfOrParentByClassName(currentElement, className, maxDepth) {
      maxDepth = maxDepth || 5;
      var foundElement = null;
      var currentDepth = 0;
      if (currentElement.classList && currentElement.classList.contains(className)) {
        return currentElement;
      } else {
        while ((currentElement = currentElement.parentElement) && currentDepth <= maxDepth) {
          currentDepth++;
          if (currentElement.classList && currentElement.classList.contains(className)) {
            foundElement = currentElement;
            break;
          }
        }
      }
      return foundElement;
    }
  };

  /**
   * Provides access to manipulate the controlPanel UI.
   *
   * @type {Object}
   */
  var ui = {
    classItemExpanded: consentPreferencesClassName + '__provider-item--expanded',
    /**
     * Show the controlPanel by adding the correct modifier class.
     *
     * @return {undefined}
     */
    show: function show() {
      controlPanel.style.display = 'flex';
      if (pageWrapper && pageWrapper.classList) {
        pageWrapper.classList.add(pageWrapperClassname + '--blurred');
      }
    },
    /**
     * Hide the controlPanel by adding the correct modifier class.
     *
     * @return {undefined}
     */
    hide: function hide() {
      controlPanel.style.display = 'none';
      if (pageWrapper && pageWrapper.classList) {
        pageWrapper.classList.remove(pageWrapperClassname + '--blurred');
      }
    },
    /**
     * Inject the settings button into the vodl-login-label component.
     *
     * @return {undefined}
     */
    injectSettingsButtonToLoginLabel: function injectSettingsButtonToLoginLabel() {
      var settingsTarget = document.querySelectorAll('.vodl-login-label__username');
      var settingsIcon = controlPanel.querySelector('.' + consentPreferencesClassName + '__icon');
      if (!settingsTarget.length || !settingsIcon) {
        return;
      }
      var settingsIconClone;
      settingsTarget.forEach(function (target) {
        settingsIconClone = settingsIcon.cloneNode(true);
        settingsIconClone.removeEventListener('click', events.onOpenPreferences);
        settingsIconClone.addEventListener('click', events.onOpenPreferences);
        target.before(settingsIconClone);
      });
    },
    /**
     * Show or hide the item description, depending on the state.
     *
     * @return {undefined}
     */
    toggleDescription: function toggleDescription(target) {
      if (!target || !target.classList) {
        return;
      }
      if (target.classList.contains(this.classItemExpanded)) {
        target.classList.remove(this.classItemExpanded);
      } else {
        target.classList.add(this.classItemExpanded);
      }
    },
    /**
     * Updates a single toggle in the controlPanel.
     *
     * The respective toggle is determined by matching the given data.path parameter
     * with the data-state attribute of the toggle checkBox inside the controlPanel.
     *
     * The checkBox is the set to the value in data.newValue.
     *
     * @param  {Object} data A data object with a (state-)path and newValue property.
     * @return {undefined}
     */
    updateToggle: function updateToggle(data) {
      if (!data.path) {
        return;
      }
      data.newValue = data.newValue || false;
      var toggle = controlPanel.querySelector('label[data-scope="' + toggleScope + '"] input[type="checkbox"][data-state="' + data.path + '"]');
      if (toggle) {
        toggle.checked = data.newValue;
      }
    },
    /**
     * Updates all toggles in the controlPanel.
     *
     * Requires a collection of provider settings in the data.newValue parameter, e.g. { apa: false, twitter: true }
     *
     * @param  {Object} data A data object with a collection of provider settings in the newValue property.
     * @return {undefined}
     */
    updateAllToggles: function updateAllToggles(data) {
      if (!data.newValue) {
        return;
      }
      for (var _i2 = 0, _Object$entries2 = Object.entries(data.newValue); _i2 < _Object$entries2.length; _i2++) {
        var _Object$entries2$_i = _slicedToArray(_Object$entries2[_i2], 2),
          provider = _Object$entries2$_i[0],
          consent = _Object$entries2$_i[1];
        var toggle = controlPanel.querySelector('label[data-scope="' + toggleScope + '"] input[type="checkbox"][data-state="consentSettings.' + provider + '"]');
        if (toggle) {
          toggle.checked = consent;
        }
      }
    }
  };
  init();
})(window, document);
"use strict";

(function (window, document, undefined) {
  "use strict";

  var activateEmbedProviderEventName = "vodl_activate_embed_provider",
    consentRequiredClassName = "vodl-consent-required",
    consentRequiredDatasetKey = "vodlConsentRequired",
    consentGivenEvent = document.createEvent("CustomEvent"),
    consentGivenEventName = "vodl_consent_given",
    newElementsEventName = "newPage",
    openPreferencesEvent = document.createEvent("CustomEvent"),
    openPreferencesEventName = "vodl_consent_open_preferences",
    showEmbedProviderControlsEventName = "vodl_show_embed_provider_control",
    tcfStorageKey = "tcf-status";
  // The list of embed items that require consent.
  var items = [];
  // An array of script URLs with which we can keep track of
  // JS that we already loaded. Some embed codes include the
  // same JS again and again (e.g. twitter), so there is no need
  // to load that multiple times.
  var loadedScripts = [];
  // An array of third-party JS tags that may require consent.
  var thirdPartyLibraries = [];

  // logger with tv emoji prefix
  var logger = {};
  try {
    logger = new window.RussMedia.Utils.Logger(String.fromCodePoint(0x1f4fa)) || {
      log: function log() {}
    };
  } catch (e) {
    logger = {
      log: function log() {}
    };
  }
  var settings = {};
  try {
    settings = window.RussMedia.Consent.Settings;
  } catch (e) {
    settings = {
      embed_providers: {
        generic: {
          name: "Generic",
          description: "Generic Embed Code"
        }
      },
      pure_subscriber_attribute: "pure_subscriber",
      pure_subscriber_consents_attribute: "vol_pure_subscription_consents"
    };
  }
  var storage = {};
  try {
    storage = window.RussMedia.Utils.LocalStorage;
  } catch (e) {
    storage = {
      get: function get() {
        return null;
      },
      set: function set() {
        return false;
      },
      remove: function remove() {
        return;
      }
    };
  }

  /**
   * Initialize handling by checking for
   * embed items in the document that require consent,
   * attach event handlers.
   *
   * @return {undefined}
   */
  var init = function init() {
    // Get all embed items that require consent.
    items = document.querySelectorAll("." + consentRequiredClassName);

    // Add a click event listeners to the placeholder content elements of each embed item,
    // set the correct button texts etc.
    items.forEach(function (item) {
      ui.preparePlaceholderUI(item);
    });

    // Listen to "vodl_activate_embed_provider" custom events.
    document.removeEventListener(activateEmbedProviderEventName, events.onActivateEmbedProvider);
    document.addEventListener(activateEmbedProviderEventName, events.onActivateEmbedProvider);

    //vodl_tcf_state_initialized

    // Listen to "vodl_show_embed_provider_control" custom events.
    document.removeEventListener(showEmbedProviderControlsEventName, events.onShowEmbedProviderControls);
    document.addEventListener(showEmbedProviderControlsEventName, events.onShowEmbedProviderControls);
  };
  var events = {
    /**
     * This triggers the "vodl_consent_given" custom event.
     * The given data object is set as event detail of the triggered custom event.
     *
     * Furthermore the iOS app is notified via messageHandlers about the given consent.
     *
     * @param  {Object} data Data object with provider property.
     * @return {undefined}
     */
    giveConsent: function giveConsent(data) {
      consentGivenEvent.initCustomEvent(consentGivenEventName, true, true, data);
      document.dispatchEvent(consentGivenEvent);

      // Also notify the iOS app, that the provider was given consent to.
      if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.native_subscription_messanger) {
        window.webkit.messageHandlers.toggleMessageHandler.postMessage({
          enablePlatform: data.provider
        });
      }
    },
    /**
     * The registered event handler for the "vodl_activate_embed_provider" custom event
     * (see init() above).
     *
     * @param  {Event} ev The event object.
     * @return {undefined}
     */
    onActivateEmbedProvider: function onActivateEmbedProvider(ev) {
      logger.log("embeds: events.onActivateEmbedProvider", ev.detail);

      // Check if the event has the required detail.provider property.
      var activatedProvider = ev.detail.provider || false;
      if (!activatedProvider) {
        return;
      }
      // There maybe some more context given in the event details,
      // e.g. the tcf data, when the consent is coming from there.
      var context = ev.detail.context || {
        name: "default",
        data: false,
        fromStorage: false
      };
      ui.activateEmbedProvider(activatedProvider, context);
    },
    /**
     * Click event handler for consenting to all embed providers.
     *
     * @return {undefined}
     */
    onButtonConsentAllClick: function onButtonConsentAllClick() {
      var data = {
        provider: "*"
      };
      this.giveConsent(data);
    },
    /**
     * Click event handler determining the provider
     * (e.g. "youtube") of the clicked embed item.
     * That information is extracted from the nodes
     * data-provider attribute and passed on
     * to giveConsent().
     *
     * @param  {Node} clickedItem The DOM Node item that has been clicked.
     * @return {undefined}
     */
    onButtonConsentSelfClick: function onButtonConsentSelfClick(clickedItem) {
      var data = {
        provider: clickedItem.dataset.provider || false
      };
      this.giveConsent(data);
    },
    onOpenPreferencesClick: function onOpenPreferencesClick() {
      openPreferencesEvent.initCustomEvent(openPreferencesEventName, true, true, "");
      document.dispatchEvent(openPreferencesEvent);
    },
    /**
     * The registered event handler for the "vodl_show_embed_provider_control" custom event
     * (see init() above). Makes the control buttons inside the placeholders visible.
     *
     * @return {undefined}
     */
    onShowEmbedProviderControls: function onShowEmbedProviderControls() {
      logger.log("events.onShowEmbedProviderControls");
      ui.showEmbedProviderControls();
    }
  };
  var helpers = {
    /**
     * A simple sprintf implementation for js.
     * Replaces all '%s' with the given arguments in argv.
     *
     * @param  {string} str  Original string with placeholder.
     * @param  {array} argv  Array of replacements.
     * @return {string}      The resulting parsed string.
     */
    sprintf: function sprintf(str) {
      for (var _len = arguments.length, argv = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        argv[_key - 1] = arguments[_key];
      }
      return !argv.length ? str : helpers.sprintf.apply(helpers, [str = str.replace("%s", argv.shift())].concat(argv));
    }
  };
  var ui = {
    /**
     * Activate all embeds of the given activatedProvider type.
     *
     * @param  {string} activatedProvider Name of the provider, e.g. 'youtube' or wildcard '*'
     * @param  {object} context Context object of the activation event.
     * @return {undefined}
     */
    activateEmbedsFallback: function activateEmbedsFallback(activatedProvider, context) {
      items.forEach(function (item) {
        if (item.dataset.waitForTcf) {
          delete item.dataset.waitForTcf;
        }
      });
      var tcData = storage.get(tcfStorageKey);
      if (tcData) {
        logger.log("tcf: fallback load embeds");
        ui.activateEmbedProvider(activatedProvider, context);
      }
    },
    /**
     * Activate all embeds of the given activatedProvider type.
     *
     * @param  {string} activatedProvider Name of the provider, e.g. 'youtube' or wildcard '*'
     * @param  {object} context Context object of the activation event.
     * @return {undefined}
     */
    activateEmbedProvider: function activateEmbedProvider(activatedProvider, context) {
      var _this = this;
      context = context || {};
      var activateFallback = false;

      // Activate third party library that might be required to load for the given embed provider.
      // E.g. pinpoll uses a global script which we now need to load.
      this.activateThirdPartyLibraries(activatedProvider);
      // Loop over our known embed items in the current document...
      items.forEach(function (item) {
        // ... and check if provider matches - skip item if not.
        var itemProvider = item.dataset.provider || false;
        if (itemProvider !== activatedProvider && "*" !== activatedProvider) {
          return;
        }
        var consentFromStorage = context.fromStorage || false;
        if (item.dataset.waitForTcf) {
          if (consentFromStorage) {
            activateFallback = true;
            return;
          } else {
            delete item.dataset.waitForTcf;
          }
        }

        // Aquire the placeholder and the content item.
        var itemPlaceholder = item.querySelector("." + consentRequiredClassName + "__placeholder") || false;
        var itemContent = item.querySelector("." + consentRequiredClassName + "__content") || false;
        // Hide the placeholder...
        if (itemPlaceholder) {
          itemPlaceholder.style.display = "none";
        }
        // ...and show the content itself.
        // Also make sure, iframes and scripts inside the content are now loaded.
        if (itemContent) {
          _this.activateEmbeddedScripts(itemContent);
          _this.activateIframes(itemContent, itemProvider, context);
          itemContent.style.display = "block";
        }
      });
      if (activateFallback) {
        setTimeout(this.activateEmbedsFallback(activatedProvider, context), 2000);
      }

      // Trigger a custom event for special embeds that don't work with the standard workflow.
      // These embeds, like Youtube PfP, rely on multiple third-party scripts and handle script insertion themselves.
      // The `activateEmbedProvider` method is executed when the `vodl_activate_embed_provider` event is dispatched.
      // However, apps execute the `activateEmbedProvider` method directly, bypassing the event.
      // To ensure these special embeds are notified, we dispatch an additional custom event here.
      document.dispatchEvent(new CustomEvent("vodl_activate_special_embed_provider", {
        detail: {
          provider: activatedProvider
        }
      }));
    },
    /**
     * Aquire all script tags inside the embed content item,
     * then maybe load the scripts.
     *
     * @param  {Element} itemContent The content element of the embed item.
     * @return {undefined}
     */
    activateEmbeddedScripts: function activateEmbeddedScripts(itemContent) {
      var _this2 = this;
      var scripts = itemContent.querySelectorAll("script");
      scripts.forEach(function (scriptItem) {
        _this2.maybeLoadScript(scriptItem);
      });
    },
    /**
     * Aquire all iframe tags inside the embed content item and load them
     * by setting the src attribute with the content of the data-src attribute.
     *
     * @param  {Element} itemContent The content element of the embed item.
     * @param  {string} itemProvider The provider of the current itemContent, e.g. 'youtube' or 'apa'.
     * @param  {object} context Context object of the activation event.
     * @return {undefined}
     */
    activateIframes: function activateIframes(itemContent, itemProvider, context) {
      var iframes = itemContent.querySelectorAll("iframe");
      iframes.forEach(function (iframeItem) {
        if (iframeItem.dataset.src) {
          // youtube and apa require a special treatment.
          // there are placeholders in the URL which need to be filled by us,
          // depending on the consent that was given - either via TCF or as
          // a pure subscriber.
          if ("youtube" === itemProvider || "apa" === itemProvider) {
            iframeItem.dataset.src = ui.fillAdParameterPlaceholders(iframeItem.dataset.src, context);
            logger.log("ui.activateIframes with ad parameters:", itemProvider, iframeItem.dataset.src);
          }
          iframeItem.src = iframeItem.dataset.src;
          iframeItem.removeAttribute("data-src");
        }
      });
    },
    /**
     * Check our list of known third-party JS library tags
     * and see if the given provider matches, then maybe load the script.
     *
     * @param  {string} activatedProvider Name of the provider, e.g. 'pinpoll'
     * @return {undefined}
     */
    activateThirdPartyLibraries: function activateThirdPartyLibraries(activatedProvider) {
      var _this3 = this;
      // Get all third party libraries that require constent. Script tags need to have
      //  - a data-src attribute for the script URL
      //  - a data-vodl-consent-required attribute
      //  - a data-provider attribute.
      thirdPartyLibraries = document.querySelectorAll("script[data-" + consentRequiredClassName + "]");
      thirdPartyLibraries.forEach(function (library) {
        var libraryProvider = library.dataset.provider || false;
        if (libraryProvider !== activatedProvider && "*" !== activatedProvider) {
          return;
        }
        logger.log("activateThirdPartyLibraries: ", library);
        _this3.maybeLoadScript(library);
      });
    },
    /**
     * Load a given script tag if
     *  - it has a data-src attribute with the script URL
     *  - it wasn't already loaded
     *
     * @param  {Node|Element} originalItem The DOME Node or Element representing
     *                                     the script tag to load.
     * @return {undefined}
     */
    maybeLoadScript: function maybeLoadScript(originalItem) {
      if (originalItem.dataset.src) {
        // We only load the library or embedded script if it wasn't already loaded.
        var newScriptTag = document.createElement("script");
        newScriptTag.async = true;
        newScriptTag.id = originalItem.id;
        newScriptTag.onload = originalItem.onload;
        newScriptTag.type = originalItem.type;
        var additonalRequirements = false;

        // Copy other possible data-attributes over to the new tag
        for (var d in originalItem.dataset) {
          // We do not want to keep the data-vodl-consent-required attribute.
          if (d !== consentRequiredDatasetKey) {
            newScriptTag.dataset[d] = originalItem.dataset[d];

            // Checking for other "-required" data attributes.
            // If we find something, we should NOT set the src attribute yet,
            // because that may be handled by another library then, e.g. for
            // loading Outbrain on premium content only for premium subscribers.
            if (d.substring(d.length - 8) === "Required") {
              logger.log("maybeLoadScript: found additonal requirement ", d);
              additonalRequirements = true;
            }
          }
        }

        // Only set src if there are no more additonal requirements.
        if (!additonalRequirements) {
          newScriptTag.src = originalItem.dataset.src;
          newScriptTag.removeAttribute("data-src");
        }

        // We also might need the class
        if (originalItem.className) {
          newScriptTag.className = originalItem.className;
        }
        originalItem.id = "";

        // place the newScriptTag right before the originalItem
        originalItem.parentNode.insertBefore(newScriptTag, originalItem);
        // Keep track of the loaded script.
        loadedScripts.push(originalItem.dataset.src);
        logger.log("maybeLoadScript: newScriptTag is ", newScriptTag);
        logger.log("maybeLoadScript: loadedScripts now ", loadedScripts);

        // We can remove the originalItem now.
        originalItem.parentNode.removeChild(originalItem);
      }
    },
    /**
     * Prepare placeholder UI (button texts etc.)
     *
     * @param  {Element} item The embed placeholder item.
     * @return {undefined}
     */
    preparePlaceholderUI: function preparePlaceholderUI(item) {
      if (item.dataset.prepared) {
        return;
      }
      var consentText = item.querySelector(".vodl-consent-required-controls__text");
      var consentSubText = item.querySelector(".vodl-consent-required-controls__subtext");
      var buttonConsentSelf = item.querySelector('button[data-consent-to="self"]');
      var buttonConsentAll = item.querySelector('button[data-consent-to="all"]');
      var label;
      var openPreferences = item.querySelector("." + consentRequiredClassName + "__preferences");
      var provider = item.dataset.provider || false;
      if (consentText && provider) {
        consentText.textContent = settings.embed_providers[provider].consent_text;
      }
      if (consentSubText) {
        consentSubText.innerHTML = settings.i18n.general.consent_subtext;
      }
      if (buttonConsentAll) {
        buttonConsentAll.addEventListener("click", function () {
          events.onButtonConsentAllClick();
        });
        label = buttonConsentAll.querySelector("span.vodl-button__label");
        if (label) {
          label.textContent = settings.i18n.buttons.consent_all;
        }
      }
      if (buttonConsentSelf) {
        var useIcon = buttonConsentSelf.querySelector("svg use");
        if (useIcon && useIcon.attributes["xlink:href"] && settings.embed_providers[provider]) {
          var iconId = this.getProviderIconId(provider);
          if (iconId) {
            useIcon.attributes["xlink:href"].value = "#" + iconId;
          }
        }
        buttonConsentSelf.addEventListener("click", function () {
          events.onButtonConsentSelfClick(item);
        });
        label = buttonConsentSelf.querySelector("span.vodl-button__label");
        if (label && provider) {
          label.textContent = helpers.sprintf(settings.i18n.buttons.consent_self, settings.embed_providers[provider].name);
        }
      }
      if (openPreferences) {
        openPreferences.addEventListener("click", events.onOpenPreferencesClick);
        openPreferences.textContent = settings.i18n.buttons.open_preferences;
      }
      item.dataset.prepared = true;
    },
    /**
     * Makes the control buttons inside the placeholders visible.
     *
     * @return {undefined}
     */
    showEmbedProviderControls: function showEmbedProviderControls() {
      items.forEach(function (item) {
        var controls = item.querySelector("." + consentRequiredClassName + "-controls") || false;
        if (controls) {
          controls.style.visibility = "visible";
        }
        var openPreferences = item.querySelector("." + consentRequiredClassName + "__preferences") || false;
        if (openPreferences) {
          openPreferences.style.display = "block";
        }
      });
    },
    /**
     * Replace placeholders in video iframe URLs with data from the TCF API
     * or some defaults.
     *
     * @param  {string} url     Original URL
     * @param  {object} context Context object of the activation event.
     * @return {string}         Processed URL.
     */
    fillAdParameterPlaceholders: function fillAdParameterPlaceholders(url, context) {
      var adParams = {
        CONSENT: true,
        NPA: false,
        GDPR: "1",
        TCSTRING: false,
        ACSTRING: false
      };
      if ("tcf" === context.name && context.data) {
        // TCF consent
        adParams.TCSTRING = context.data.tcString || "";
        adParams.ACSTRING = context.data.addtlConsent || "";
      } else {
        // Pure subscription consent
        adParams.TCSTRING = "";
        adParams.ACSTRING = "";
      }
      var regex = /\[CONSENT\]|\[NPA\]|\[GDPR\]|\[TCSTRING\]|\[ACSTRING\]/gi;
      var newUrl = url.replace(regex, function (matched) {
        matched = matched.replace(/[\[\]']+/g, "");
        return adParams[matched];
      });
      return newUrl;
    },
    /**
     * Checks if an icon for a given provider exists in the vodl-icon-content-providers icon set.
     * If yes, returns the id (without #), false if not.
     *
     * @param  {string} provider The slug of the provider to find the icon for.
     * @return {string|boolean}  The id of the found icon or false.
     */
    getProviderIconId: function getProviderIconId(provider) {
      var id = "vodl-icon-content-providers-" + provider;
      if (document.getElementById(id)) {
        return id;
      }
      return false;
    }
  };
  window.RussMedia = window.RussMedia || {};
  window.RussMedia.Consent = window.RussMedia.Consent || {};
  window.RussMedia.Consent.Embeds = window.RussMedia.Consent.Embeds || {};
  window.RussMedia.Consent.Embeds.UI = ui;
  init();
  document.addEventListener(newElementsEventName, init);
})(window, document);
"use strict";

(function (window, document, undefined) {
  'use strict';

  var consentRequiredClassName = 'vodl-consent-required',
    consentDemandEvent = document.createEvent('CustomEvent'),
    consentDemandEventName = 'vodl_consent_demand',
    activateEmbedProviderEventName = 'vodl_activate_embed_provider',
    newElementsEventName = 'newPage',
    refreshLightBoxLinksEventName = 'refreshLightBoxLinks',
    refreshLightBoxLinksEvent = document.createEvent('CustomEvent'),
    showEmbedProviderControlsEventName = 'vodl_show_embed_provider_control';

  // logger with tv emoji prefix
  var logger = {};
  try {
    logger = new window.RussMedia.Utils.Logger(String.fromCodePoint(0x1F4FA)) || {
      log: function log() {}
    };
  } catch (e) {
    logger = {
      log: function log() {}
    };
  }

  // An array of media item links that may require consent.
  var mediaItems = [];

  /**
   * Initialize handling by checking for
   * media items in the document that require consent,
   * attach event handlers.
   *
   * @return {undefined}
   */
  var init = function init() {
    // Get all media item links that require constent. Anchor tags need to have
    //  - a data-vodl-consent-required attribute
    //  - a data-provider attribute.
    mediaItems = document.querySelectorAll('a.vodl-compact[data-' + consentRequiredClassName + ']');

    // Nothing to do, if there are no media items to handle.
    if (0 === mediaItems.length) {
      return;
    }

    // Listen to "vodl_activate_embed_provider" custom events.
    document.removeEventListener(activateEmbedProviderEventName, events.onActivateEmbedProvider);
    document.addEventListener(activateEmbedProviderEventName, events.onActivateEmbedProvider);

    // Listen to "vodl_show_embed_provider_control" custom events.
    document.removeEventListener(showEmbedProviderControlsEventName, events.onShowEmbedProviderControls);
    document.addEventListener(showEmbedProviderControlsEventName, events.onShowEmbedProviderControls);
  };
  var events = {
    /**
     * The registered event handler for the "vodl_activate_embed_provider" custom event
     * (see init() above).
     *
     * @param  {Event} ev The event object.
     * @return {undefined}
     */
    onActivateEmbedProvider: function onActivateEmbedProvider(ev) {
      logger.log('media-items: events.onActivateEmbedProvider:', ev.detail);

      // Check if the event has the required detail.provider property.
      var activatedProvider = ev.detail.provider || false;
      if (!activatedProvider) {
        return;
      }
      ui.activateMediaItems(activatedProvider);
    },
    /**
     * The registered event handler for clicks on media item links
     * (see events.onShowEmbedProviderControls).
     * Triggers a 'vodl_consent_demand' event, if necessary.
     *
     * @param  {Event} ev The event object.
     * @return {undefined}
     */
    onMediaItemClicked: function onMediaItemClicked(ev) {
      ev = ev || {};
      var originalTarget = ev.target || false;
      var target = null;
      target = helpers.findSelfOrParentByClassName(originalTarget, 'vodl-compact');
      logger.log('onMediaItemClicked: media item link requires consent: ', target);
      if (!target) {
        return;
      }
      consentDemandEvent.initCustomEvent(consentDemandEventName, true, true, target);
      document.dispatchEvent(consentDemandEvent);
    },
    /**
     * The registered event handler for the "vodl_show_embed_provider_control" custom event
     * (see init() above).
     *
     * @return {undefined}
     */
    onShowEmbedProviderControls: function onShowEmbedProviderControls() {
      logger.log('media items: events.onShowEmbedProviderControls');

      // Add a click event listener for all media teim links that require consent.
      mediaItems.forEach(function (item) {
        item.removeEventListener('click', events.onMediaItemClicked);
        item.addEventListener('click', events.onMediaItemClicked);
      });
    }
  };
  var helpers = {
    /**
     * Finds an DOM Node with the given className by searching the DOM upwards,
     * starting with currentElement itself.
     *
     * @param  {Node} currentElement The DOM Node to start from.
     * @param  {string} className    The name of the class we are looking for.
     * @param  {int} maxDepth        The maximum number of elements to go upwards.
     * @return {Node|null}           The found Node if any, null otherwise.
     */
    findSelfOrParentByClassName: function findSelfOrParentByClassName(currentElement, className, maxDepth) {
      maxDepth = maxDepth || 5;
      var foundElement = null;
      var currentDepth = 0;
      if (currentElement.classList && currentElement.classList.contains(className)) {
        return currentElement;
      } else {
        while ((currentElement = currentElement.parentElement) && currentDepth <= maxDepth) {
          currentDepth++;
          if (currentElement.classList && currentElement.classList.contains(className)) {
            foundElement = currentElement;
            break;
          }
        }
      }
      return foundElement;
    }
  };
  var ui = {
    /**
     * Check our list of known media item links
     * and see if the given provider matches, then activate the link.
     *
     * @param  {string} activatedProvider Name of the provider, e.g. 'youtube' or wildcard '*'
     * @return {undefined}
     */
    activateMediaItems: function activateMediaItems(activatedProvider) {
      mediaItems.forEach(function (item) {
        var itemProvider = item.dataset.provider || false;
        if (itemProvider !== activatedProvider && '*' !== activatedProvider) {
          return;
        }
        if (!item.dataset.href) {
          return;
        }
        item.href = item.dataset.href;
        item.removeAttribute('data-href');
        item.removeAttribute('data-vodl-consent-required');
        item.removeAttribute('data-provider');
        item.removeEventListener('click', events.onMediaItemClicked);
      });
      refreshLightBoxLinksEvent.initCustomEvent(refreshLightBoxLinksEventName, true, true, '');
      document.dispatchEvent(refreshLightBoxLinksEvent);
    }
  };
  init();
  document.addEventListener(newElementsEventName, init);
})(window, document);
"use strict";

(function (window, document, undefined) {
  'use strict';

  var consentRequiredClassName = 'vodl-consent-required',
    consentDemandEvent = document.createEvent('CustomEvent'),
    consentDemandEventName = 'vodl_consent_demand',
    activateEmbedProviderEventName = 'vodl_activate_embed_provider',
    newElementsEventName = 'newPage',
    refreshShareButtonsEventName = 'refreshShareButtons',
    refreshShareButtonsEvent = document.createEvent('CustomEvent'),
    showEmbedProviderControlsEventName = 'vodl_show_embed_provider_control';

  // logger with palms emoji prefix
  var logger = {};
  try {
    logger = new window.RussMedia.Utils.Logger(String.fromCodePoint(0x1F932)) || {
      log: function log() {}
    };
  } catch (e) {
    logger = {
      log: function log() {}
    };
  }

  // An array of share buttons that may require consent.
  var shareButtons = [];

  /**
   * Initialize handling by checking for
   * shar buttons in the document that require consent,
   * attach event handlers.
   *
   * @return {undefined}
   */
  var init = function init() {
    // Get all share buttons that require constent. Anchor tags need to have
    //  - a data-vodl-consent-required attribute
    //  - a data-provider attribute.
    shareButtons = document.querySelectorAll('.vodl-share-button-bar__share[data-' + consentRequiredClassName + ']');

    // Nothing to do, if there are no share buttons to handle.
    if (0 === shareButtons.length) {
      return;
    }

    // Listen to "vodl_activate_embed_provider" custom events.
    document.removeEventListener(activateEmbedProviderEventName, events.onActivateEmbedProvider);
    document.addEventListener(activateEmbedProviderEventName, events.onActivateEmbedProvider);

    // Listen to "vodl_show_embed_provider_control" custom events.
    document.removeEventListener(showEmbedProviderControlsEventName, events.onShowEmbedProviderControls);
    document.addEventListener(showEmbedProviderControlsEventName, events.onShowEmbedProviderControls);
  };
  var events = {
    /**
     * The registered event handler for the "vodl_activate_embed_provider" custom event
     * (see init() above).
     *
     * @param  {Event} ev The event object.
     * @return {undefined}
     */
    onActivateEmbedProvider: function onActivateEmbedProvider(ev) {
      logger.log('share-buttons: events.onActivateEmbedProvider:', ev.detail);

      // Check if the event has the required detail.provider property.
      var activatedProvider = ev.detail.provider || false;
      if (!activatedProvider) {
        return;
      }
      ui.activateShareButtons(activatedProvider);
    },
    /**
     * The registered event handler for clicks on share buttons
     * (see events.onShowEmbedProviderControls).
     * Triggers a 'vodl_consent_demand' event, if necessary.
     *
     * @param  {Event} ev The event object.
     * @return {undefined}
     */
    onShareButtonClicked: function onShareButtonClicked(ev) {
      ev = ev || {};
      ev.preventDefault();
      var originalTarget = ev.target || false;
      var target = null;
      target = helpers.findSelfOrParentByClassName(originalTarget, 'vodl-share-button-bar__share');
      logger.log('onShareButtonClicked: share button requires consent: ', target);
      if (!target) {
        return;
      }
      consentDemandEvent.initCustomEvent(consentDemandEventName, true, true, target);
      document.dispatchEvent(consentDemandEvent);
    },
    /**
     * The registered event handler for the "vodl_show_embed_provider_control" custom event
     * (see init() above).
     *
     * @return {undefined}
     */
    onShowEmbedProviderControls: function onShowEmbedProviderControls() {
      logger.log('share-buttons: events.onShowEmbedProviderControls');

      // Add a click event listener for all share buttons that require consent.
      shareButtons.forEach(function (item) {
        item.removeEventListener('click', events.onShareButtonClicked);
        item.addEventListener('click', events.onShareButtonClicked);
      });
    }
  };
  var helpers = {
    /**
     * Finds an DOM Node with the given className by searching the DOM upwards,
     * starting with currentElement itself.
     *
     * @param  {Node} currentElement The DOM Node to start from.
     * @param  {string} className    The name of the class we are looking for.
     * @param  {int} maxDepth        The maximum number of elements to go upwards.
     * @return {Node|null}           The found Node if any, null otherwise.
     */
    findSelfOrParentByClassName: function findSelfOrParentByClassName(currentElement, className, maxDepth) {
      maxDepth = maxDepth || 5;
      var foundElement = null;
      var currentDepth = 0;
      if (currentElement.classList && currentElement.classList.contains(className)) {
        return currentElement;
      } else {
        while ((currentElement = currentElement.parentElement) && currentDepth <= maxDepth) {
          currentDepth++;
          if (currentElement.classList && currentElement.classList.contains(className)) {
            foundElement = currentElement;
            break;
          }
        }
      }
      return foundElement;
    }
  };
  var ui = {
    /**
     * Check our list of known share buttons
     * and see if the given provider matches, then activate the button.
     *
     * @param  {string} activatedProvider Name of the provider, e.g. 'facebook' or wildcard '*'
     * @return {undefined}
     */
    activateShareButtons: function activateShareButtons(activatedProvider) {
      shareButtons.forEach(function (item) {
        var itemProvider = item.dataset.provider || false;
        if (itemProvider !== activatedProvider && '*' !== activatedProvider) {
          return;
        }
        item.removeAttribute('data-vodl-consent-required');
        item.removeAttribute('data-provider');
        item.removeEventListener('click', events.onShareButtonClicked);
      });
      refreshShareButtonsEvent.initCustomEvent(refreshShareButtonsEventName, true, true, '');
      document.dispatchEvent(refreshShareButtonsEvent);
    }
  };
  init();
  document.addEventListener(newElementsEventName, init);
})(window, document);
"use strict";

(function (window, document, undefined) {
  'use strict';

  var consentRequiredClassName = 'vodl-consent-required',
    consentDemandEvent = document.createEvent('CustomEvent'),
    consentDemandEventName = 'vodl_consent_demand',
    activateEmbedProviderEventName = 'vodl_activate_embed_provider',
    newElementsEventName = 'newPage',
    refreshLightBoxLinksEventName = 'refreshLightBoxLinks',
    refreshLightBoxLinksEvent = document.createEvent('CustomEvent'),
    refreshVideoBoxPreviewsEventName = 'refreshVideoBoxPreviews',
    refreshVideoBoxPreviewsEvent = document.createEvent('CustomEvent'),
    showEmbedProviderControlsEventName = 'vodl_show_embed_provider_control';

  // logger with tv emoji prefix
  var logger = {};
  try {
    logger = new window.RussMedia.Utils.Logger(String.fromCodePoint(0x1F4FA)) || {
      log: function log() {}
    };
  } catch (e) {
    logger = {
      log: function log() {}
    };
  }

  // An array of videobox links that may require consent.
  var videoBoxLinks = [];
  // An array of videobox previews that may require consent.
  var videoBoxPreviews = [];

  /**
   * Initialize handling by checking for
   * videobox links and previews in the document that require consent,
   * attach event handlers.
   *
   * @return {undefined}
   */
  var init = function init() {
    // Get all video-box links that require constent. Tags need to have
    //  - a data-vodl-consent-required attribute
    //  - a data-provider attribute.
    videoBoxLinks = document.querySelectorAll('.vodl-video-box:not(.vodl-video-box--large) .vodl-video-box__wrapper-slider-item[data-' + consentRequiredClassName + ']');

    // Get all videobox previews that require constent. Tags need to have
    //  - a data-vodl-consent-required attribute
    //  - a data-provider attribute.
    videoBoxPreviews = document.querySelectorAll('.vodl-video-box--large .vodl-video-box__video');

    // Nothing to do, if there are no video-box links or previews.
    if (0 === videoBoxLinks.length && 0 === videoBoxPreviews.length) {
      return;
    }

    // Listen to "vodl_activate_embed_provider" custom events.
    document.removeEventListener(activateEmbedProviderEventName, events.onActivateEmbedProvider);
    document.addEventListener(activateEmbedProviderEventName, events.onActivateEmbedProvider);

    // Listen to "vodl_show_embed_provider_control" custom events.
    document.removeEventListener(showEmbedProviderControlsEventName, events.onShowEmbedProviderControls);
    document.addEventListener(showEmbedProviderControlsEventName, events.onShowEmbedProviderControls);
  };
  var events = {
    /**
     * The registered event handler for the "vodl_activate_embed_provider" custom event
     * (see init() above).
     *
     * @param  {Event} ev The event object.
     * @return {undefined}
     */
    onActivateEmbedProvider: function onActivateEmbedProvider(ev) {
      logger.log('video-boxes: events.onActivateEmbedProvider:', ev.detail);

      // Check if the event has the required detail.provider property.
      var activatedProvider = ev.detail.provider || false;
      if (!activatedProvider) {
        return;
      }

      // Enable all videobox links which require consent for the given activatedProvider
      ui.activateVideoBoxLinks(activatedProvider);

      // Enable all videobox previews which require consent for the given activatedProvider
      ui.activateVideoBoxPreviews(activatedProvider);
    },
    /**
     * The registered event handler for the "vodl_show_embed_provider_control" custom event
     * (see init() above).
     *
     * @return {undefined}
     */
    onShowEmbedProviderControls: function onShowEmbedProviderControls() {
      logger.log('video-boxes: events.onShowEmbedProviderControls');
      videoBoxLinks.forEach(function (link) {
        link.removeEventListener('click', events.onVideoBoxLinkClicked);
        link.addEventListener('click', events.onVideoBoxLinkClicked);
      });
      videoBoxPreviews.forEach(function (preview) {
        preview.removeEventListener('click', events.onVideoBoxPreviewClicked);
        preview.addEventListener('click', events.onVideoBoxPreviewClicked);
      });
    },
    /**
     * The registered event handler for clicks on video-box links
     * (see events.onShowEmbedProviderControls).
     * Triggers a 'vodl_consent_demand' event, if necessary.
     *
     * @param  {Event} ev The event object.
     * @return {undefined}
     */
    onVideoBoxLinkClicked: function onVideoBoxLinkClicked(ev) {
      ev = ev || {};
      var originalTarget = ev.target || false;
      var target = null;
      target = helpers.findSelfOrParentByClassName(originalTarget, 'vodl-video-box__wrapper-slider-item');
      logger.log('onVideoBoxLinkClicked: videobox link requires consent: ', target);
      if (!target) {
        return;
      }
      consentDemandEvent.initCustomEvent(consentDemandEventName, true, true, target);
      document.dispatchEvent(consentDemandEvent);
    },
    /**
     * The registered event handler for clicks on videobox previews
     * (see events.onShowEmbedProviderControls).
     * Triggers a 'vodl_consent_demand' event, if necessary.
     *
     * @param  {Event} ev The event object.
     * @return {undefined}
     */
    onVideoBoxPreviewClicked: function onVideoBoxPreviewClicked(ev) {
      ev = ev || {};
      var originalTarget = ev.target || false;
      var target = null;

      // let's find a common parent element (.vodl-video-box__video) first, regardless which element inside
      // the videobox preview was clicked (thumbnail, playbutton...)
      var previewContainer = helpers.findSelfOrParentByClassName(originalTarget, 'vodl-video-box__video');

      // if we cannot find that, bail.
      if (!previewContainer) {
        return;
      }

      // now we should be able to find the target we are interested in (.vodl-video-box__wrapper-slider-item-video)
      target = previewContainer.querySelector('.vodl-video-box__wrapper-slider-item-video');
      if (!target) {
        return;
      }
      if (!target.dataset || !target.dataset.vodlConsentRequired) {
        return;
      }
      logger.log('onVideoBoxPreviewClicked: videobox preview requires consent: ', target);
      consentDemandEvent.initCustomEvent(consentDemandEventName, true, true, target);
      document.dispatchEvent(consentDemandEvent);
    }
  };
  var helpers = {
    /**
     * Finds an DOM Node with the given className by searching the DOM upwards,
     * starting with currentElement itself.
     *
     * @param  {Node} currentElement The DOM Node to start from.
     * @param  {string} className    The name of the class we are looking for.
     * @param  {int} maxDepth        The maximum number of elements to go upwards.
     * @return {Node|null}           The found Node if any, null otherwise.
     */
    findSelfOrParentByClassName: function findSelfOrParentByClassName(currentElement, className, maxDepth) {
      maxDepth = maxDepth || 5;
      var foundElement = null;
      var currentDepth = 0;
      if (currentElement.classList && currentElement.classList.contains(className)) {
        return currentElement;
      } else {
        while ((currentElement = currentElement.parentElement) && currentDepth <= maxDepth) {
          currentDepth++;
          if (currentElement.classList && currentElement.classList.contains(className)) {
            foundElement = currentElement;
            break;
          }
        }
      }
      return foundElement;
    }
  };
  var ui = {
    /**
     * Check our list of known videobox links
     * and see if the given provider matches, then activate the link.
     *
     * @param  {string} activatedProvider Name of the provider, e.g. 'youtube' or wildcard '*'
     * @return {undefined}
     */
    activateVideoBoxLinks: function activateVideoBoxLinks(activatedProvider) {
      videoBoxLinks.forEach(function (link) {
        var linkProvider = link.dataset.provider || false;
        if (linkProvider !== activatedProvider && '*' !== activatedProvider) {
          return;
        }
        link.removeAttribute('data-vodl-consent-required');
        link.removeAttribute('data-provider');
        link.removeEventListener('click', events.onVideoBoxLinkClicked);
      });
      refreshLightBoxLinksEvent.initCustomEvent(refreshLightBoxLinksEventName, true, true, '');
      document.dispatchEvent(refreshLightBoxLinksEvent);
    },
    /**
     * Check our list of known videobox previews
     * and see if the given provider matches, then activate the link.
     *
     * @param  {string} activatedProvider Name of the provider, e.g. 'youtube' or wildcard '*'
     * @return {undefined}
     */
    activateVideoBoxPreviews: function activateVideoBoxPreviews(activatedProvider) {
      logger.log('activateVideoBoxPreviews:', videoBoxPreviews.length);
      if (videoBoxPreviews.length > 0) {
        videoBoxPreviews.forEach(function (preview) {
          var previewVideoItem = preview.querySelector('.vodl-video-box__wrapper-slider-item-video');
          logger.log('activateVideoBoxPreviews:', previewVideoItem);
          if (!previewVideoItem || !previewVideoItem.dataset) {
            return;
          }
          logger.log('activateVideoBoxPreviews:', previewVideoItem.dataset);
          var previewProvider = previewVideoItem.dataset.provider || false;
          if (previewProvider !== activatedProvider && '*' !== activatedProvider) {
            return;
          }
          previewVideoItem.removeAttribute('data-vodl-consent-required');
          previewVideoItem.removeAttribute('data-provider');
        });
        var thumbnails = document.querySelectorAll('.vodl-video-box__wrapper-slider-item-video');
        thumbnails.forEach(function (thumb) {
          var thumbProvider = thumb.dataset.provider || false;
          if (thumbProvider !== activatedProvider && '*' !== activatedProvider) {
            return;
          }
          thumb.removeAttribute('data-vodl-consent-required');
          thumb.removeAttribute('data-provider');
        });
        refreshVideoBoxPreviewsEvent.initCustomEvent(refreshVideoBoxPreviewsEventName, true, true, '');
        document.dispatchEvent(refreshVideoBoxPreviewsEvent);
      }
    }
  };
  init();
  document.addEventListener(newElementsEventName, init);
})(window, document);
"use strict";

(function (window, document, undefined) {
  'use strict';

  var consentRequiredClassName = 'vodl-consent-required',
    consentDemandEvent = document.createEvent('CustomEvent'),
    consentDemandEventName = 'vodl_consent_demand',
    activateEmbedProviderEventName = 'vodl_activate_embed_provider',
    newElementsEventName = 'newPage',
    isVideoPage = document.querySelectorAll('.vodl-video-page').length,
    refreshLightBoxLinksEventName = 'refreshLightBoxLinks',
    refreshLightBoxLinksEvent = document.createEvent('CustomEvent'),
    showEmbedProviderControlsEventName = 'vodl_show_embed_provider_control';

  // logger with tv emoji prefix
  var logger = {};
  try {
    logger = new window.RussMedia.Utils.Logger(String.fromCodePoint(0x1F4FA)) || {
      log: function log() {}
    };
  } catch (e) {
    logger = {
      log: function log() {}
    };
  }

  // An array of video teaser links used e.g. in the homepage river with the play buttons
  var videoTeasers = [];

  /**
   * Initialize handling by checking for
   * embed items in the document that require consent,
   * attach event handlers.
   *
   * @return {undefined}
   */
  var init = function init() {
    // Get all video teaser links that require constent. Tags need to have
    //  - a data-vodl-consent-required attribute
    //  - a data-provider attribute.
    videoTeasers = document.querySelectorAll('.vodl-media__video--play-button[data-' + consentRequiredClassName + ']');

    // Nothing to do, if there are no items, no thirdPartyLibraries and...
    if (0 === videoTeasers.length) {
      return;
    }

    // Listen to "vodl_activate_embed_provider" custom events.
    document.removeEventListener(activateEmbedProviderEventName, events.onActivateEmbedProvider);
    document.addEventListener(activateEmbedProviderEventName, events.onActivateEmbedProvider);

    // Listen to "vodl_show_embed_provider_control" custom events.
    document.removeEventListener(showEmbedProviderControlsEventName, events.onShowEmbedProviderControls);
    document.addEventListener(showEmbedProviderControlsEventName, events.onShowEmbedProviderControls);
  };
  var events = {
    /**
     * The registered event handler for the "vodl_activate_embed_provider" custom event
     * (see init() above).
     *
     * @param  {Event} ev The event object.
     * @return {undefined}
     */
    onActivateEmbedProvider: function onActivateEmbedProvider(ev) {
      logger.log('video-teasers: events.onActivateEmbedProvider', ev.detail);

      // Check if the event has the required detail.provider property.
      var activatedProvider = ev.detail.provider || false;
      if (!activatedProvider) {
        return;
      }
      // There maybe some more context given in the event details,
      // e.g. the tcf data, when the consent is coming from there.
      var context = ev.detail.context || {
        name: 'default',
        data: false
      };
      ui.activateVideoTeasers(activatedProvider, context);
    },
    /**
     * The registered event handler for the "vodl_show_embed_provider_control" custom event
     * (see init() above).
     *
     * @return {undefined}
     */
    onShowEmbedProviderControls: function onShowEmbedProviderControls() {
      logger.log('video teasers: events.onShowEmbedProviderControls');
      videoTeasers.forEach(function (teaser) {
        if (isVideoPage) {
          var parent = helpers.findSelfOrParentByClassName(teaser, 'vodl-lead-square');
          parent.removeEventListener('click', events.onVideoTeaserClicked);
          parent.addEventListener('click', events.onVideoTeaserClicked);
        } else {
          teaser.removeEventListener('click', events.onVideoTeaserClicked);
          teaser.addEventListener('click', events.onVideoTeaserClicked);
        }
      });
    },
    /**
     * The registered event handler for clicks on video teasers
     * (see events.onShowEmbedProviderControls).
     * Triggers a 'vodl_consent_demand' event, if necessary.
     *
     * @param  {Event} ev The event object.
     * @return {undefined}
     */
    onVideoTeaserClicked: function onVideoTeaserClicked(ev) {
      ev.preventDefault();
      ev = ev || {};
      var originalTarget = ev.target || false;
      var target = null;
      if (isVideoPage) {
        var parent = helpers.findSelfOrParentByClassName(originalTarget, 'vodl-lead-square');
        if (parent) {
          target = parent.querySelector('.vodl-media__video--play-button');
        }
      } else {
        target = helpers.findSelfOrParentByClassName(originalTarget, 'vodl-media__video--play-button');
      }
      logger.log('onVideoTeaserClicked: video teaser link requires consent: ', target);
      if (!target) {
        return;
      }
      consentDemandEvent.initCustomEvent(consentDemandEventName, true, true, target);
      document.dispatchEvent(consentDemandEvent);
    }
  };
  var helpers = {
    /**
     * Finds an DOM Node with the given className by searching the DOM upwards,
     * starting with currentElement itself.
     *
     * @param  {Node} currentElement The DOM Node to start from.
     * @param  {string} className    The name of the class we are looking for.
     * @param  {int} maxDepth        The maximum number of elements to go upwards.
     * @return {Node|null}           The found Node if any, null otherwise.
     */
    findSelfOrParentByClassName: function findSelfOrParentByClassName(currentElement, className, maxDepth) {
      maxDepth = maxDepth || 5;
      var foundElement = null;
      var currentDepth = 0;
      if (currentElement.classList && currentElement.classList.contains(className)) {
        return currentElement;
      } else {
        while ((currentElement = currentElement.parentElement) && currentDepth <= maxDepth) {
          currentDepth++;
          if (currentElement.classList && currentElement.classList.contains(className)) {
            foundElement = currentElement;
            break;
          }
        }
      }
      return foundElement;
    }
  };
  var ui = {
    /**
     * Check our list of known video teasers
     * and see if the given provider matches, then activate the button.
     *
     * @param  {string} activatedProvider Name of the provider, e.g. 'youtube' or wildcard '*'
     * @param  {object} context Context object of the activation event.
     * @return {undefined}
     */
    activateVideoTeasers: function activateVideoTeasers(activatedProvider, context) {
      logger.log('activateVideoTeasers:', activatedProvider);
      videoTeasers.forEach(function (teaser) {
        var teaserProvider = teaser.dataset.provider || false;
        if (teaserProvider !== activatedProvider && '*' !== activatedProvider) {
          return;
        }

        // youtube and apa require a special treatment.
        // there are placeholders in the URL which need to be filled by us,
        // depending on the consent that was given - either via TCF or as
        // a pure subscriber.
        if ('youtube' === teaserProvider || 'apa' === teaserProvider) {
          teaser.dataset.href = ui.fillAdParameterPlaceholders(teaser.dataset.href, context);
          logger.log('ui.activateVideoTeasers with ad parameters:', teaserProvider, teaser.dataset.href);
        }
        teaser.removeAttribute('data-vodl-consent-required');
        teaser.removeAttribute('data-provider');
        if (isVideoPage) {
          var parent = helpers.findSelfOrParentByClassName(teaser, 'vodl-lead-square');
          parent.removeEventListener('click', events.onVideoTeaserClicked);
        } else {
          teaser.removeEventListener('click', events.onVideoTeaserClicked);
        }
      });
      refreshLightBoxLinksEvent.initCustomEvent(refreshLightBoxLinksEventName, true, true, '');
      document.dispatchEvent(refreshLightBoxLinksEvent);
    },
    /**
     * Replace placeholders in video iframe URLs with data from the TCF API
     * or some defaults.
     *
     * @param  {string} url     Original URL
     * @param  {object} context Context object of the activation event.
     * @return {string}         Processed URL.
     */
    fillAdParameterPlaceholders: function fillAdParameterPlaceholders(url, context) {
      var adParams = {
        CONSENT: true,
        NPA: false,
        GDPR: '1',
        TCSTRING: false,
        ACSTRING: false
      };
      if ('tcf' === context.name && context.data) {
        // TCF consent
        adParams.TCSTRING = context.data.tcString || '';
        adParams.ACSTRING = context.data.addtlConsent || '';
      } else {
        // Pure subscription consent
        adParams.TCSTRING = '';
        adParams.ACSTRING = '';
      }
      var regex = /\[CONSENT\]|\[NPA\]|\[GDPR\]|\[TCSTRING\]|\[ACSTRING\]/gi;
      var newUrl = url.replace(regex, function (matched) {
        matched = matched.replace(/[\[\]']+/g, '');
        return adParams[matched];
      });
      return newUrl;
    }
  };
  init();
  document.addEventListener(newElementsEventName, init);
})(window, document);
"use strict";

(function (window, document, undefined) {
  "use strict";

  var activateEmbedProviderEvent = document.createEvent("CustomEvent"),
    activateEmbedProviderEventName = "vodl_activate_embed_provider",
    consentManagerLoadedEvent = document.createEvent("CustomEvent"),
    consentManagerLoadedEventName = "tcf_onload",
    newElementsEventName = "newPage",
    tcfStorageKey = "tcf-status",
    tcfStateInitializedEvent = document.createEvent("CustomEvent"),
    tcfStateInitializedEventName = "vodl_tcf_state_initialized",
    userStateInitializedEventName = "vodl_consent_state_initialized";

  // logger with cookie emoji prefix
  var logger = {};
  try {
    logger = new window.RussMedia.Utils.Logger(String.fromCodePoint(0x1f36a));
  } catch (e) {
    logger = {
      log: function log() {}
    };
  }
  var settings = {};
  try {
    settings = window.RussMedia.Consent.Settings.tcf_consent_manager;
  } catch (e) {
    settings = false;
  }
  var userStateInitialized = false;
  var storage = {};
  try {
    storage = window.RussMedia.Utils.LocalStorage;
  } catch (e) {
    storage = {
      get: function get() {
        return null;
      },
      set: function set() {
        return false;
      },
      remove: function remove() {
        return;
      }
    };
  }

  /**
   * Initialize everything.
   *
   * @return {undefined}
   */
  var init = function init() {
    if (!settings) {
      return;
    }
    logger.log("init found settings: ", settings);
    if (ui.cmpDisabledPage()) {
      logger.log("cmp disabled on page, skipping TCF handling");
      return;
    }
    if (helpers.hasUrlParam("noheader") && !helpers.hasUrlParam('mobilecmp')) {
      logger.log("cmp disabled via noheader parameter, skipping TCF handling");
      return;
    }

    // Listen to the global 'tcf_onload' custom events.
    document.addEventListener(consentManagerLoadedEventName, events.onConsentManagerLoaded);

    // Listen to the global 'vodl_consent_state_initialized' custom events.
    document.addEventListener(userStateInitializedEventName, events.onUserStateInitialized);
  };

  /**
   * A collection of event handlers and triggers.
   *
   * @type {Object}
   */
  var events = {
    /**
     * Fires the 'vodl_activate_embed_provider' event with the given data.
     * @param  {object} data The data object that should be attached to the event.
     * @return {undefined}
     */
    activateEmbedProvider: function activateEmbedProvider(data) {
      activateEmbedProviderEvent.initCustomEvent(activateEmbedProviderEventName, true, true, data);
      document.dispatchEvent(activateEmbedProviderEvent);
    },
    /**
     * The registered event handler for the 'tcf_onload' custom event
     * (see init() above).
     * Makes sure we retrieve the data from the tcf api and handle it via events.onTcfResolved.
     *
     * @param  {Event} ev The event object.
     * @return {undefined}
     */
    onConsentManagerLoaded: function onConsentManagerLoaded(ev) {
      logger.log("onConsentManagerLoaded");
      __tcfapi("addEventListener", 2, events.onTcfResolved);

      // Listen to 'newPage' custom events.
      document.addEventListener(newElementsEventName, events.onNewElements);
    },
    /**
     * The registered event handler for the 'newPage' custom event
     * Makes sure we retrieve the data from the tcf api and handle it via events.onTcfResolved.
     * for possible new elements on the page that require consent.
     *
     * @param  {Event} ev The event object.
     * @return {undefined}
     */
    onNewElements: function onNewElements() {
      if (__tcfapi) {
        __tcfapi("addEventListener", 2, events.onTcfResolved);
      }
    },
    /**
     * The registered event handler for the 'vodl_consent_state_initialized' custom event.
     * At this stage we are able to decide if we need to load the third-party consent mananger,
     * which is only allowed for non-pure subscribers.
     *
     * @param  {Event} ev The event object.
     * @return {undefined}
     */
    onUserStateInitialized: function onUserStateInitialized(ev) {
      var evDetails = ev.detail || {};
      ui.setLoginStatusBodyClass(evDetails);
      if (evDetails.pureSubscriber || userStateInitialized) {
        return;
      } else {
        logger.log("onUserStateInitialized: no pureSubscriber!");

        // check tcf state and maybe shortcut here
        var tcData = storage.get(tcfStorageKey);
        if (tcData) {
          events.tcfStateInitialized(tcData, true);
        }
        ui.cmpInitialized();
        userStateInitialized = true;
      }
    },
    /**
     * The handler for the resolved tcf data.
     * Stores the tcf data into the local storage for quicker access next time.
     * Calls events.tcfStateInitialized to trigger the 'vodl_tcf_state_initialized' event.
     *
     * @param  {object} tcData   The data object retrieved from the tcf api.
     * @param  {boolean} success true if the data was retrieved successfully.
     * @return {undefined}
     */
    onTcfResolved: function onTcfResolved(tcData, success) {
      storage.remove(tcfStorageKey);
      if (success && (tcData.eventStatus === "tcloaded" || tcData.eventStatus === "useractioncomplete")) {
        logger.log("tcf resolved", tcData);
        storage.set(tcfStorageKey, tcData);
        events.tcfStateInitialized(tcData);
      }
    },
    /**
     * Triggers the 'vodl_tcf_state_initialized' event which may be used by other components.
     * Activates ALL ('*') embed providers via events.activateEmbedProvider().
     * Loads script tags that require consent via ui.activateTcfDependants().
     *
     * @param  {object} data The data object retrieved from the tcf api.
     * @return {undefined}
     */
    tcfStateInitialized: function tcfStateInitialized(data) {
      var fromStorage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      tcfStateInitializedEvent.initCustomEvent(tcfStateInitializedEventName, true, true, data);
      document.dispatchEvent(tcfStateInitializedEvent);
      events.activateEmbedProvider({
        provider: "*",
        context: {
          name: "tcf",
          data: data,
          fromStorage: fromStorage
        }
      });
      ui.activateTcfDependants();
    }
  };

  /**
   * A collection of helper methods.
   *
   * @type {Object}
   */
  var helpers = {
    /**
     * Read a cookie with the given cookieName.
     *
     * @param  {string} cookieName Name of the cookie to read.
     * @return {string|boolean}    Cookie value if cookie was found, false otherwise.
     */
    getCoookie: function getCoookie(cookieName) {
      var cookieNameEQ = cookieName + "=";
      var ca = document.cookie.split(";");
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) === " ") {
          c = c.substring(1, c.length);
        }
        if (c.indexOf(cookieNameEQ) === 0) {
          return c.substring(cookieNameEQ.length, c.length);
        }
      }
      return false;
    },
    /**
     * Checks if a GET parameter with the given name in the current URL exists.
     *
     * @param  {string} name name of the GET parameter to check for
     * @return {Boolean}     true if GET parameter is present, false if not.
     */
    hasUrlParam: function hasUrlParam(name) {
      name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
      var regexString = "[\\?&]" + name;
      var regex = new RegExp(regexString);
      return regex.test(window.location.href);
    },
    /**
     * Returns a promise that will resolve as soon as window.__tcfapi is available.
     * Will retry 50 times every 100 ms.
     * Promise will be rejected if window.__tcfapi is not available after 50 retries.
     *
     * @return {Promise} A promise object.
     */
    waitForTCFApi: function waitForTCFApi() {
      return new Promise(function (resolve, reject) {
        if (window.__tcfapi) {
          logger.log("__tcfapi available");
          resolve();
          return;
        }
        var retries = 0,
          maxRetries = 50;
        var timer = window.setInterval(function () {
          retries++;
          if (retries <= maxRetries) {
            if (window.__tcfapi) {
              logger.log("waitForTCFApi: __tcfapi now available (" + retries + ". retry)!");
              window.clearInterval(timer);
              resolve();
              return;
            }
          } else {
            reject(new Error("waitForTCFApi: Max retries " + maxRetries + " reached while waiting for __tcfapi"));
            return;
          }
        }, 100);
      });
    }
  };

  /**
   * Provides access to manipulate the UI/DOM.
   *
   * @type {Object}
   */
  var ui = {
    /**
     * Activate a given iframeItem by setting the src attribute
     * to the content of the data-src attribute.
     *
     * @param  {Node|Element} iframeItem The DOME Node or Element representing the iframe to activate.
     * @return {undefined}
     */
    activateEmbeddedIframe: function activateEmbeddedIframe(iframeItem) {
      if (iframeItem.dataset.src) {
        iframeItem.src = iframeItem.dataset.src;
        iframeItem.removeAttribute("data-src");
      }
    },
    /**
     * Activate a script tag given via the originalItem parameter by
     *  - creating a newScriptTag
     *  - setting src of the new script to the data-src of the originalItem
     *  - copying data-, onload, class and id attributes
     *  - placing the newScriptTag right before the originalItem
     *  - removing the originalItem
     * @param  {Node|Element} originalItem [description]
     * @return {undefined}
     */
    activateEmbeddedScript: function activateEmbeddedScript(originalItem) {
      if (originalItem.dataset.src) {
        var newScriptTag = document.createElement("script");
        newScriptTag.async = true;
        newScriptTag.id = originalItem.id;
        newScriptTag.onload = originalItem.onload;
        newScriptTag.src = originalItem.dataset.src;
        newScriptTag.type = originalItem.type;

        // Copy other possible data-attributes over to the new tag
        for (var d in originalItem.dataset) {
          if (d != "src") {
            newScriptTag.dataset[d] = originalItem.dataset[d];
          }
        }

        // We also might need the class
        if (originalItem.className) {
          newScriptTag.className = originalItem.className;
        }
        originalItem.id = "";

        // place the newScriptTag right before the originalItem
        originalItem.parentNode.insertBefore(newScriptTag, originalItem);

        // We can remove the originalItem now.
        originalItem.parentNode.removeChild(originalItem);
      }
    },
    /**
     * Loads scripts and contents that require TCF consent.
     *
     * @return {undefined}
     */
    activateTcfDependants: function activateTcfDependants() {
      // Collect all single script tags that require a TCF consent (trackers etc.).
      var scriptDependants = document.querySelectorAll("script[data-vodl-tcf-consent-required]");
      // Collect all html content items, that require a TCF consent.
      var contentDependants = document.querySelectorAll("div.vodl-tcf-consent-required");
      logger.log("activateTcfDependants", scriptDependants, contentDependants);

      // Process all single scripts that where identified above.
      scriptDependants.forEach(function (dep) {
        if (dep.dataset.src) {
          var newScriptTag = document.createElement("script");
          newScriptTag.async = true;
          newScriptTag.onload = dep.onload;
          newScriptTag.src = dep.dataset.src;
          newScriptTag.type = dep.type;
          document.getElementsByTagName("head")[0].appendChild(newScriptTag);
          dep.removeAttribute("data-src");
        }
      });

      // Process all html content items that where identified above.
      contentDependants.forEach(function (dep) {
        var scripts = dep.querySelectorAll("script");
        scripts.forEach(function (scriptItem) {
          ui.activateEmbeddedScript(scriptItem);
        });
        var iframes = dep.querySelectorAll("iframe");
        iframes.forEach(function (iframeItem) {
          ui.activateEmbeddedIframe(iframeItem);
        });

        // finally make the element visible
        dep.style.display = "block";
      });
    },
    /**
     * Checks, if the <body> has set a data-cmp-disabled attribute.
     *
     * @return {boolean} True, if data-attribute was found, false otherwise.
     */
    cmpDisabledPage: function cmpDisabledPage() {
      var theBody = document.querySelector("body");
      if (theBody.dataset && theBody.dataset.cmpDisabled) {
        return true;
      }
      return false;
    },
    /**
     * Checks if the __tcfapi object is available and if not, waits for it.
     * When available, it will dispatch the 'tcf_onload' event.
     *
     * @return {undefined}
     */
    cmpInitialized: function cmpInitialized() {
      // here we need to actually listen to a promise that tells us
      // when the __tcfapi object is available as we do not know when the used CMP
      // actually loads it.
      helpers.waitForTCFApi().then(function () {
        consentManagerLoadedEvent.initCustomEvent(consentManagerLoadedEventName, true, true, "");
        document.dispatchEvent(consentManagerLoadedEvent);
      }, function (error) {
        logger.log("waitForTCFApi failed:", error);
      });
    },
    /**
     * Sets or removes a CSS class from the body, depending on if the user
     * is logged in or not. The userData object needs to have a ssoId property
     * for the user being considered logged in.
     * The body CSS class may be used by the CMPs to e.g. display varying information
     * depending on the users login status.
     *
     * @param  {object} userData The userData object to check.
     *
     * @return {undefined}
     */
    setLoginStatusBodyClass: function setLoginStatusBodyClass(userData) {
      var loggedInClass = "vodl-is-logged-in";
      if (userData && userData.ssoId) {
        document.body.classList.add(loggedInClass);
      } else {
        document.body.classList.remove(loggedInClass);
      }
    }
  };
  init();
})(window, document);
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
(function (window, document, undefined) {
  'use strict';

  var axios = window.axios,
    activateEmbedProviderEvent = document.createEvent('CustomEvent'),
    activateEmbedProviderEventName = 'vodl_activate_embed_provider',
    apiBase = '/wp-json/russmedia-sso/v1/',
    consentGivenEventName = 'vodl_consent_given',
    consentRevokedEventName = 'vodl_consent_revoked',
    loginStatusResolvedEventName = 'vodl_login_status_event',
    newElementsEventName = 'newPage',
    showEmbedProviderControlsEvent = document.createEvent('CustomEvent'),
    showEmbedProviderControlsEventName = 'vodl_show_embed_provider_control',
    stateChangeEvent = document.createEvent('CustomEvent'),
    stateChangeEventName = 'vodl_consent_state_change',
    stateInitializedEvent = document.createEvent('CustomEvent'),
    stateInitializedEventName = 'vodl_consent_state_initialized',
    storageKey = 'user-status';

  // logger with person emoji prefix
  var logger = {};
  try {
    logger = new window.RussMedia.Utils.Logger(String.fromCodePoint(0x1F9D1));
  } catch (e) {
    logger = {
      log: function log() {}
    };
  }
  var settings = {};
  try {
    settings = window.RussMedia.Consent.Settings;
  } catch (e) {
    settings = {
      embed_providers: {
        generic: {
          name: 'Generic',
          description: 'Generic Embed Code'
        }
      },
      pure_subscriber_attribute: 'pure_subscriber',
      pure_subscriber_consents_attribute: 'vol_pure_subscription_consents'
    };
  }
  var storage = {};
  try {
    storage = window.RussMedia.Utils.LocalStorage;
  } catch (e) {
    storage = {
      get: function get() {
        return null;
      },
      set: function set() {
        return false;
      },
      remove: function remove() {
        return;
      }
    };
  }

  /**
   * Provides access to the SSO API for storing user consent settings.
   *
   * @type {Object}
   */
  var api = {
    /**
     * Low-level access to the API. Will call the given route with the given payload.
     * Returns a promise provided by axios.
     *
     * @param  {string} route   E.g. 'update/user-attribute'.
     * @param  {object} payload Data object to send to the API endpoint.
     * @return {Promise}        Promise provided by the axios call.
     */
    call: function call(route, payload) {
      var url = apiBase + route;
      payload = payload || {};
      return axios({
        method: 'post',
        url: url,
        data: payload
      }).then(function (response) {
        return response.data;
      })["catch"](function (error) {
        if (error.response && error.response.data && error.response.data.message) {
          throw new Error(error.response.data.message);
        } else {
          logger.log('calling ' + url + ' failed: ', error);
          throw error;
        }
      });
    },
    /**
     * Save the users consent settings to a SSO user attribute which is defined
     * in settings.pure_subscriber_consents_attribute.
     *
     * @param  {object} userData User data object with hash, token and the consentSettings.
     * @return {undefined}
     */
    saveConsentSettings: function saveConsentSettings(userData) {
      if (!userData.hash || !userData.token || !userData.pureSubscriber) {
        return;
      }
      var val = {};
      for (var k in userData.consentSettings) {
        val[k] = Number(userData.consentSettings[k]) || 0;
      }
      var payload = {
        h: userData.hash,
        t: userData.token,
        attribute: settings.pure_subscriber_consents_attribute,
        val: JSON.stringify(val)
      };
      this.call('update/user-attribute', payload).then(function (data) {
        logger.log('saveConsentSettings:', data);
      })["catch"](function (error) {
        logger.log('saveConsentSettings:', error);
      });
      return;
    }
  };

  /**
   * A collection of event handlers and triggers.
   *
   * @type {Object}
   */
  var events = {
    /**
     * Fires the 'vodl_activate_embed_provider' event with the given data.
     * This event is used by other modules to activate e.g. embeds and scripts on the page.
     *
     * @param  {object} data The data object that should be attached to the event.
     * @return {undefined}
     */
    activateEmbedProvider: function activateEmbedProvider(data) {
      activateEmbedProviderEvent.initCustomEvent(activateEmbedProviderEventName, true, true, data);
      document.dispatchEvent(activateEmbedProviderEvent);
    },
    /**
     * Event handler for updating the state when the user gives consent to certain provider.
     *
     * @param  {Event} ev The event object.
     * @return {undefined}
     */
    onConsentGiven: function onConsentGiven(ev) {
      var consentedProvider = ev.detail.provider || false;
      if (!consentedProvider) {
        return;
      }
      state.set('consentSettings.' + consentedProvider, true);
    },
    /**
     * Event handler for updating the state when the user revoked consent to certain provider.
     *
     * @param  {Event} ev The event object.
     * @return {undefined}
     */
    onConsentRevoked: function onConsentRevoked(ev) {
      var consentedProvider = ev.detail.provider || false;
      if (!consentedProvider) {
        return;
      }
      state.set('consentSettings.' + consentedProvider, false);
    },
    /**
     * The registered event handler for the 'vodl_login_status_event' custom event.
     * This event is fired by the SSO API as soon as the current user status is available.
     * Extracts if the user is pure subscriber and extracts the users consent settings stored
     * on the SSO.
     * Finally initializes the state with the resolved user information.
     *
     * @param  {Event} ev The event object.
     * @return {undefined}
     */
    onLoginStatusResolved: function onLoginStatusResolved(ev) {
      var userData = {};
      var userDetails = ev.detail || {};
      userDetails.piano = userDetails.piano || {};
      userDetails.piano.abo = userDetails.piano.abo || {};
      userData.ssoId = userDetails.user_id || false;
      userData.email = userDetails.email || false;
      userData.hash = userDetails.hash || false;
      userData.token = userDetails.token || false;
      userData.pureSubscriber = userDetails.piano.abo.isPurSubscriber || false;
      userData.plusSubscriber = userDetails.piano.abo.isPlusSubscriber || false;
      userData.plusPremiumSubscriber = userDetails.piano.abo.isPlusPremiumSubscriber || false;
      userData.VNSubscriber = userDetails.piano.abo.isVNSubscriber || false;
      userData.NeueSubscriber = userDetails.piano.abo.isNeueSubscriber || false;
      userData.googleIAPPlusSubscriber = userDetails.piano.abo.isGoogleIAPPlusSubscriber || false;
      userData.revenueCatPlusSubscriber = userDetails.piano.abo.isRevenueCatPlusSubscriber || false;
      userData.revenueCatPlusPremiumSubscriber = userDetails.piano.abo.isRevenueCatPlusPremiumSubscriber || false;
      userData.revenueCatPurSubscriber = userDetails.piano.abo.isRevenueCatPurSubscriber || false;
      userData.guestPlusPremiumSubscriber = userDetails.piano.abo.isGuestPlusPremiumSubscriber || false;
      userData.guestRevenueCatPlusPremiumSubscriber = userDetails.piano.abo.isGuestRevenueCatPlusPremiumSubscriber || false;
      userData.hasPlusAccess = userDetails.piano.abo.hasPlusAccess || false;
      userData.linkedAccount = userDetails.piano.abo.linkedAccount || false;
      userData.commentBan = userDetails.user_comment_ban || false;

      // Fallback for manual fake pure subscriber set as SSO user attribute.
      // @TODO: We should remove this code later.
      if (!userData.pureSubscriber) {
        var isPureSubscriberSSO = helpers.extractUserAtribute(userDetails, settings.pure_subscriber_attribute);
        if (isPureSubscriberSSO && '1' === isPureSubscriberSSO) {
          userData.pureSubscriber = true;
        }
      }
      var rawConsentJSONString = helpers.extractUserAtribute(userDetails, settings.pure_subscriber_consents_attribute);
      try {
        userData.consentSettings = JSON.parse(rawConsentJSONString) || false;
      } catch (e) {
        userData.consentSettings = false;
      }
      state.init(userData);
    },
    /**
     * Event handler for 'newPage' custom events. This event is fired by the vodl theme whenever
     * new content elements are loaded into the page.
     * This handler makes sure, new elements that may require consent are activated as well
     * by calling events.activateEmbedProvider()
     *
     * @return {undefined}
     */
    onNewElements: function onNewElements() {
      var isPureSubscriber = state.get('pureSubscriber');
      if (!isPureSubscriber) {
        return;
      }
      var consentSettings = state.get('consentSettings');
      if (consentSettings) {
        for (var _i = 0, _Object$entries = Object.entries(consentSettings); _i < _Object$entries.length; _i++) {
          var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
            provider = _Object$entries$_i[0],
            consent = _Object$entries$_i[1];
          if (true === consent) {
            events.activateEmbedProvider({
              provider: provider
            });
          }
        }
      }
      events.showEmbedProviderControls();
    },
    /**
     * Event handler for state changes. Whenever the state is updated, e.g. via the user preferences,
     * we need to make sure to call events.activateEmbedProvider(), so e.g.
     * embeds are actually activated immediately, should the user have given a new consent.
     *
     * @param  {Event} ev The event object.
     * @return {undefined}
     */
    onStateChange: function onStateChange(ev) {
      var evDetails = ev.detail || {},
        keyPath = [],
        len = 0;
      if (evDetails.path) {
        keyPath = evDetails.path.split('.');
        len = keyPath.length;
        if (2 === len && 'consentSettings' === keyPath[0]) {
          if ('*' === keyPath[1]) {
            for (var _i2 = 0, _Object$entries2 = Object.entries(evDetails.newValue); _i2 < _Object$entries2.length; _i2++) {
              var _Object$entries2$_i = _slicedToArray(_Object$entries2[_i2], 2),
                provider = _Object$entries2$_i[0],
                consent = _Object$entries2$_i[1];
              if (true === consent) {
                events.activateEmbedProvider({
                  provider: provider
                });
              }
            }
          } else {
            if (true === evDetails.newValue) {
              events.activateEmbedProvider({
                provider: keyPath[1]
              });
            }
          }
        }
      }
      logger.log('stateChange! - ', evDetails);
    },
    /**
     * Triggers the 'vodl_show_embed_provider_control' event if the user is pure subscriber.
     * The embed placeholders on the page are rendered without controls by default.
     * Only pure subscribers see the controls (buttons, preferences center) to activate specific embed providers.
     *
     * @return {undefined}
     */
    showEmbedProviderControls: function showEmbedProviderControls() {
      showEmbedProviderControlsEvent.initCustomEvent(showEmbedProviderControlsEventName, true, true, '');
      document.dispatchEvent(showEmbedProviderControlsEvent);
    }
  };

  /**
   * A simple state handler for the current user,
   * handling pure subscription state and user consent preferences.
   *
   * @type {Object}
   */
  var state = {
    data: {
      ssoId: null,
      email: null,
      hash: null,
      token: null,
      pureSubscriber: null,
      plusSubscriber: null,
      plusPremiumSubscriber: null,
      VNSubscriber: null,
      NeueSubscriber: null,
      googleIAPPlusSubscriber: null,
      revenueCatPlusPremiumSubscriber: null,
      revenueCatPlusSubscriber: null,
      revenueCatPurSubscriber: null,
      guestPlusPremiumSubscriber: null,
      guestRevenueCatPlusPremiumSubscriber: null,
      hasPlusAccess: null,
      linkedAccount: null,
      consentSettings: {
        fancycorp: null
      },
      commentBan: null
    },
    /**
     * Setup method to fill data.consentSettings with the actually available
     * embed providers defined in settings.embed_providers.
     *
     * @return {undefined}
     */
    setup: function setup() {
      this.data.consentSettings = {};
      for (var k in settings.embed_providers) {
        this.data.consentSettings[k] = null;
      }
    },
    /**
     * Initialize the state with userData retrieved from SSO or the local storage.
     *
     * @param  {object} userData The user data object.
     * @return {undefined}
     */
    init: function init(userData) {
      this.data.ssoId = userData.ssoId || false;
      this.data.email = userData.email || false;
      this.data.hash = userData.hash || false;
      this.data.token = userData.token || false;
      this.data.pureSubscriber = userData.pureSubscriber || false;
      this.data.plusSubscriber = userData.plusSubscriber || false;
      this.data.plusPremiumSubscriber = userData.plusPremiumSubscriber || false;
      this.data.VNSubscriber = userData.VNSubscriber || false;
      this.data.NeueSubscriber = userData.NeueSubscriber || false;
      this.data.googleIAPPlusSubscriber = userData.googleIAPPlusSubscriber || false;
      this.data.revenueCatPlusPremiumSubscriber = userData.revenueCatPlusPremiumSubscriber || false;
      this.data.revenueCatPlusSubscriber = userData.revenueCatPlusSubscriber || false;
      this.data.revenueCatPurSubscriber = userData.revenueCatPurSubscriber || false;
      this.data.guestPlusPremiumSubscriber = userData.guestPlusPremiumSubscriber || false;
      this.data.guestRevenueCatPlusPremiumSubscriber = userData.guestRevenueCatPlusPremiumSubscriber || false;
      this.data.hasPlusAccess = userData.hasPlusAccess || false;
      this.data.linkedAccount = userData.linkedAccount || false;
      this.data.commentBan = userData.commentBan || false;
      for (var k in this.data.consentSettings) {
        if (this.data.consentSettings.hasOwnProperty(k)) {
          this.data.consentSettings[k] = Boolean(Number(userData.consentSettings[k])) || false;
        }
      }
      storage.set(storageKey, this.data);
      logger.log('state initialized', this.data);
      stateInitializedEvent.initCustomEvent(stateInitializedEventName, true, true, this.data);
      document.dispatchEvent(stateInitializedEvent);

      // There is no logged in User, OR the user is no pure pureSubscriber:
      // We cannot do anything here, as this is then up to the tcf api response.
      if (!this.data.ssoId || !this.data.pureSubscriber) {
        return;
      }

      // ...otherwise show the embed provider controls...
      events.showEmbedProviderControls();

      // ...and activate the consented embed provider(s).
      if (this.data.consentSettings) {
        for (var _i3 = 0, _Object$entries3 = Object.entries(this.data.consentSettings); _i3 < _Object$entries3.length; _i3++) {
          var _Object$entries3$_i = _slicedToArray(_Object$entries3[_i3], 2),
            provider = _Object$entries3$_i[0],
            consent = _Object$entries3$_i[1];
          if (true === consent) {
            events.activateEmbedProvider({
              provider: provider
            });
          }
        }
      }
    },
    /**
     * Returns the state data or parts of it defined by path.
     *
     * @param  {string} path The path to the state property we want to get, e.g. 'consentSettings.youtube'
     * @return {object}      The state data object or parts of it.
     */
    get: function get(path) {
      path = path || null;
      var keyPath = [],
        res = this.data,
        i = 0,
        len = 0;
      if (path) {
        keyPath = path.split('.');
        len = keyPath.length;
      }
      for (; i < len; i++) {
        if ('*' === keyPath[i]) {
          break;
        }
        res = res[keyPath[i]];
      }
      return res;
    },
    /**
     * Write the state data to the local storage and
     * save the consentSettings to the SSO.
     *
     * @return {undefined}
     */
    persist: function persist() {
      storage.set(storageKey, this.data);

      // Save to SSO only for pure subscribers.
      if (this.data.pureSubscriber) {
        api.saveConsentSettings(this.data);
      }
    },
    /**
     * Set the state or parts of it defined by path.
     * Triggers the 'vodl_consent_state_change' event if there was an update.
     *
     * @param  {string} path  The path to the state data we want to set, e.g. 'consentSettings.youtube'
     * @param  {object} value The value we want to set.
     * @return {undefined}
     */
    set: function set(path, value) {
      path = path || false;
      if (!path) {
        return false;
      }
      var keyPath = path.split('.'),
        res = this.data,
        i = 0,
        len = keyPath.length - 1;
      for (i = 0; i < len; i++) {
        if ('*' === keyPath[i]) {
          break;
        }
        res = res[keyPath[i]];
      }
      var oldValue,
        newValue,
        updated = false;
      if ('*' === keyPath[i]) {
        oldValue = JSON.parse(JSON.stringify(res));
        for (var k in res) {
          if (res[k] !== value) {
            res[k] = value;
            updated = true;
          }
        }
        newValue = res;
      } else {
        oldValue = res[keyPath[i]];
        if (oldValue !== value) {
          res[keyPath[i]] = value;
          updated = true;
        }
        newValue = value;
      }
      if (updated) {
        this.persist();
        stateChangeEvent.initCustomEvent(stateChangeEventName, true, true, {
          path: path,
          oldValue: oldValue,
          newValue: newValue
        });
        document.dispatchEvent(stateChangeEvent);
      }
    }
  };

  /**
   * A collection of helper methods.
   *
   * @type {Object}
   */
  var helpers = {
    /**
     * Extract a user attribute with the given attributeName from a SSO response provided in userDetails.
     *
     * @param  {object]} userDetails  The user data object returned from the SSO.
     * @param  {string} attributeName The name of the user attribute that should be extracted.
     * @return {string|null}          The found value or null.
     */
    extractUserAtribute: function extractUserAtribute(userDetails, attributeName) {
      var foundValue = null;
      userDetails.user_attributes = userDetails.user_attributes || false;
      if (false === userDetails.user_attributes) {
        return foundValue;
      }
      userDetails.user_attributes.item = userDetails.user_attributes.item || [];

      // .item may be an object or an array :( :
      // user_attributes: {
      //  item: {
      //    name: 'vol_pure_subscription_consents',
      //    value: '{twitter: true}'
      //  }
      // }
      // OR (in case of multiple user_attributes)
      //
      // user_attributes: {
      // item: [
      //  {
      //    name: "verified_phone_number",
      //    value: "+43 6645406284"
      //  },
      //  {
      //    name: "vol_pure_subscription_consents",
      //    value: "{   twitter: false,   youtube: true }"
      //  }
      // ]
      // }
      //

      if (!Array.isArray(userDetails.user_attributes.item)) {
        if (userDetails.user_attributes.item.name && userDetails.user_attributes.item.value && attributeName === userDetails.user_attributes.item.name) {
          foundValue = userDetails.user_attributes.item.value;
        }
      } else {
        userDetails.user_attributes.item.forEach(function (attribute) {
          if (attribute.name && attribute.value && attributeName === attribute.name) {
            foundValue = attribute.value;
          }
        });
      }
      return foundValue;
    }
  };

  /**
   * Initialize the state and attach event handlers.
   *
   * @return {undefined}
   */
  var init = function init() {
    state.setup();

    // Fetch state from local storage if available.
    // It may later be overwritten via events.onLoginStatusResolved()
    var userData = storage.get(storageKey);
    if (userData) {
      state.init(userData);
    }

    // Listen to "vodl_consent_given" custom events.
    document.addEventListener(consentGivenEventName, events.onConsentGiven);

    // Listen to "vodl_consent_revoked" custom events.
    document.addEventListener(consentRevokedEventName, events.onConsentRevoked);

    // Listen to 'vodl_login_status_event' custom events.
    document.addEventListener(loginStatusResolvedEventName, events.onLoginStatusResolved);

    // Listen to 'vodl_consent_state_change' custom events.
    document.addEventListener(stateChangeEventName, events.onStateChange);

    // Listen to 'newPage' custom events.
    document.addEventListener(newElementsEventName, events.onNewElements);
  };
  window.RussMedia = window.RussMedia || {};
  window.RussMedia.Consent = window.RussMedia.Consent || {};
  window.RussMedia.Consent.State = state;
  init();
})(window, document);
"use strict";

(function (window, document, undefined) {
  'use strict';

  var $ = window.jQuery,
    console = window.console || {
      log: function log() {}
    },
    apiUrl = 'https://www.vol.at/services/weather/json/';
  var weatherData = [],
    retrieving = [];

  /**
   * Fetches the value of a cookie with the given cookieName
   * @param  {string}         cookieName Name of the cookie to check, defaults to 'CurrentCity'
   * @return {string|boolean} cookie value if any, otherwise false
   */
  function checkCookiePreference(cookieName) {
    cookieName = cookieName || 'CurrentCity';
    var name = cookieName + '=';
    var allCookies = decodeURIComponent(document.cookie).split(';');
    var cookieVal = [];
    for (var i = 0; i < allCookies.length; i++) {
      if (allCookies[i].trim().indexOf(name) == 0) {
        cookieVal = allCookies[i].trim().split("=");
      }
    }
    return cookieVal.length > 0 ? cookieVal[1] : false;
  }

  /**
   * Fetches the data for the given township and region via the given action
   * @param  {string} township Key of the township. Defaults to 'bregenz'
   * @param  {string} region   Key of the region. Defaults to 'vorarlberg'
   * @param  {string} action   Action to trigger on the API endpoint, defaults to 'vodl-get-weather-data'
   * @return {promise}
   */
  function get(township, region, action) {
    township = township || 'bregenz';
    region = region || 'vorarlberg';
    action = action || 'vodl-get-weather-data';
    var deferred = $.Deferred(),
      key = "".concat(region, "_").concat(township, "_").concat(action);
    var waitCount = 10;
    if (weatherData[key] && weatherData[key] !== null) {
      // if we did already load the data, we can just return it
      deferred.resolve(weatherData[key]);
    } else {
      if (retrieving[key] === true) {
        // we might not have the data yet, but a request might already be on the way, so let's wait a few ticks
        var waitInterval = window.setInterval(function () {
          if (waitCount > 0) {
            if (weatherData[key] && weatherData[key] !== null) {
              window.clearInterval(waitInterval);
              deferred.resolve(weatherData[key]);
            }
            waitCount--;
          } else {
            window.clearInterval(waitInterval);
            console.log("Error: loading weather data for ".concat(region, " and  ").concat(township, " timed out"));
            retrieving[key] = false;
            deferred.reject(false);
          }
        }, 500);
      } else {
        //otherwise set the retrieving flag and load the data
        retrieving[key] = true;
        $.ajax({
          dataType: 'json',
          url: apiUrl,
          data: {
            action: action,
            region: region,
            township: township
          }
        }).then(function (result) {
          weatherData[key] = result;
          deferred.resolve(weatherData[key]);
        }, function (jqXHR, textStatus, errorThrown) {
          console.log("Error loading weather data for ".concat(region, " and  ").concat(township));
          deferred.reject(false);
        }).always(function () {
          retrieving[key] = false;
        });
      }
    }
    return deferred.promise();
  }

  //make methods public via window.RussMedia.ZAMGWeather
  window.RussMedia = window.RussMedia || {};
  window.RussMedia.ZAMGWeather = window.RussMedia.ZAMGWeather || {};
  $.extend(window.RussMedia.ZAMGWeather, {
    get: get,
    checkCookiePreference: checkCookiePreference
  });
})(window, document);
"use strict";

(function (window, document, undefined) {
  'use strict';

  var ZAMGWeather = window.RussMedia.ZAMGWeather,
    forecastTomorrow,
    weatherBox = $('.vodl-weatherapp-township-forecast-weather');
  function init() {
    if (weatherBox.length > 0) {
      checkOnUpdates();
    }
  }
  function checkOnUpdates() {
    weatherBox.each(function () {
      var currentWeatherBox = $(this);
      var isDynamic = currentWeatherBox.data('dynamic') ? true : false,
        currentTownship = currentWeatherBox.data('township') ? currentWeatherBox.data('township') : false,
        cookieTownship = ZAMGWeather.checkCookiePreference('CurrentCity'),
        currentRegion = currentWeatherBox.data('region') ? currentWeatherBox.data('region') : false;

      // should the current widget be updated dynamically?
      if (isDynamic && currentTownship && currentRegion) {
        if (cookieTownship && cookieTownship != currentTownship) {
          ZAMGWeather.get(cookieTownship, currentRegion).then(function (response) {
            renderData(response, currentWeatherBox);
          });
        }
      }
    });
  }
  function renderData(data, currentWeatherBox) {
    forecastTomorrow = currentWeatherBox.find('.vodl-weatherapp-township-forecast-weather__list-wrapper');
    forecastTomorrow.find('.vodl-temperature-display__value').eq(0).text(data['township_forecast_data'][1]['temperature_morning']);
    forecastTomorrow.find('.vodl-temperature-display__value').eq(1).text(data['township_forecast_data'][1]['temperature_noon']);
    forecastTomorrow.find('.vodl-temperature-display__value').eq(2).text(data['township_forecast_data'][1]['temperature_evening']);
    forecastTomorrow.find('.vodl-temperature-display__value').eq(3).text(data['township_forecast_data'][2]['temperature_morning']);
    forecastTomorrow.find('.vodl-temperature-display__value').eq(4).text(data['township_forecast_data'][2]['temperature_noon']);
    forecastTomorrow.find('.vodl-temperature-display__value').eq(5).text(data['township_forecast_data'][2]['temperature_evening']);
    currentWeatherBox.find('.vodl-weatherapp-township-forecast-period__icon').remove();
    forecastTomorrow.find('.vodl-weatherapp-township-forecast-period__data').eq(0).before('<div class="vodl-weatherapp-township-forecast-period__icon"><span class="vodl-svg-sprite vodl-icon-weather-' + data["township_forecast_data"][1]["weather_state_morning"] + '"><svg><use xlink:href="#vodl-icon-weather-' + data["township_forecast_data"][1]["weather_state_morning"] + '"></use></svg></span></div>');
    forecastTomorrow.find('.vodl-weatherapp-township-forecast-period__data').eq(1).before('<div class="vodl-weatherapp-township-forecast-period__icon"><span class="vodl-svg-sprite vodl-icon-weather-' + data["township_forecast_data"][1]["weather_state_noon"] + '"><svg><use xlink:href="#vodl-icon-weather-' + data["township_forecast_data"][1]["weather_state_noon"] + '"></use></svg></span></div>');
    forecastTomorrow.find('.vodl-weatherapp-township-forecast-period__data').eq(2).before('<div class="vodl-weatherapp-township-forecast-period__icon"><span class="vodl-svg-sprite vodl-icon-weather-' + data["township_forecast_data"][1]["weather_state_evening"] + '"><svg><use xlink:href="#vodl-icon-weather-' + data["township_forecast_data"][1]["weather_state_evening"] + '"></use></svg></span></div>');
    forecastTomorrow.find('.vodl-weatherapp-township-forecast-period__data').eq(3).before('<div class="vodl-weatherapp-township-forecast-period__icon"><span class="vodl-svg-sprite vodl-icon-weather-' + data["township_forecast_data"][2]["weather_state_morning"] + '"><svg><use xlink:href="#vodl-icon-weather-' + data["township_forecast_data"][2]["weather_state_morning"] + '"></use></svg></span></div>');
    forecastTomorrow.find('.vodl-weatherapp-township-forecast-period__data').eq(4).before('<div class="vodl-weatherapp-township-forecast-period__icon"><span class="vodl-svg-sprite vodl-icon-weather-' + data["township_forecast_data"][2]["weather_state_noon"] + '"><svg><use xlink:href="#vodl-icon-weather-' + data["township_forecast_data"][2]["weather_state_noon"] + '"></use></svg></span></div>');
    forecastTomorrow.find('.vodl-weatherapp-township-forecast-period__data').eq(5).before('<div class="vodl-weatherapp-township-forecast-period__icon"><span class="vodl-svg-sprite vodl-icon-weather-' + data["township_forecast_data"][2]["weather_state_evening"] + '"><svg><use xlink:href="#vodl-icon-weather-' + data["township_forecast_data"][2]["weather_state_evening"] + '"></use></svg></span></div>');
    currentWeatherBox.find('.vodl-temperature-display__symbol').text('°C');
  }
  init();
})(window, document);
"use strict";

(function (window, document, undefined) {
  'use strict';

  var ZAMGWeather = window.RussMedia.ZAMGWeather,
    weatherCode,
    hoursList,
    weatherWidget = $('.vodl-weatherapp-township-weather.pre-init');
  function init_township_weather() {
    // Re-check for weather widget each newPage event.
    weatherWidget = $('.vodl-weatherapp-township-weather.pre-init');
    if (weatherWidget.length > 0) {
      checkOnUpdates();

      // Initialized - remove lazy stuff (only one widget per page)
      window.removeEventListener('newPage', init_township_weather, false);
    }
  }
  function checkOnUpdates() {
    weatherWidget.each(function () {
      var currentWeatherWidget = $(this);
      var isDynamic = currentWeatherWidget.data('dynamic') ? true : false,
        currentTownship = currentWeatherWidget.data('township') ? currentWeatherWidget.data('township') : false,
        cookieTownship = ZAMGWeather.checkCookiePreference('CurrentCity'),
        currentRegion = currentWeatherWidget.data('region') ? currentWeatherWidget.data('region') : false;

      // should the current widget be updated dynamically?
      if (isDynamic && currentTownship && currentRegion) {
        if (cookieTownship && cookieTownship != currentTownship) {
          ZAMGWeather.get(cookieTownship, currentRegion).then(function (response) {
            renderData(response, currentWeatherWidget);
          });
        }
      }

      // Initialized - remove lazy stuff (only one widget per page).
      $(this).removeClass('pre-init');
    });
  }
  function renderData(data, currentWeatherWidget) {
    currentWeatherWidget.find('.vodl-weatherapp-township-weather__township').text(data["township"]["name"]);
    weatherCode = data["township_forecast_data"][0]["weather_state_day"];
    hoursList = currentWeatherWidget.find('.vodl-weatherapp-township-weather__hours-list');
    currentWeatherWidget.find('.vodl-temperature-display__value').text(data["live_data"]["temperature_live"]);
    currentWeatherWidget.find('.vodl-weatherapp-township-weather-item__temperature').eq(0).text(data["live_data"]["temperature_live"] + '°C');
    currentWeatherWidget.find('.vodl-weatherapp-township-weather__wind-velocity-value').text(data["live_data"]["wind_velocity"] + 'km/h');
    currentWeatherWidget.find('.vodl-weatherapp-township-weather__state').text(data["state_mapping"][weatherCode]["text"]);
    currentWeatherWidget.find('.vodl-weatherapp-township-weather__icon').remove();
    currentWeatherWidget.find('.vodl-weatherapp-township-weather__upper').append('<div class="vodl-weatherapp-township-weather__icon"><span class="vodl-svg-sprite vodl-icon-weather-' + data["township_forecast_data"][0]["weather_state_day"] + '"><svg><use xlink:href="#vodl-icon-weather-' + data["township_forecast_data"][0]["weather_state_day"] + '"></use></svg></span></div>');
    if (data["live_data"]["temperature_live"] > data["township_forecast_data"][0]["temperature_max"]) {
      currentWeatherWidget.find('.vodl-weatherapp-township-weather__temp-max').text('Max. ' + data["live_data"]["temperature_live"] + '°C');
    } else {
      currentWeatherWidget.find('.vodl-weatherapp-township-weather__temp-max').text('Max. ' + data["township_forecast_data"][0]["temperature_max"] + '°C');
    }
    if (data["live_data"]["temperature_live"] < data["township_forecast_data"][0]["temperature_min"]) {
      currentWeatherWidget.find('.vodl-weatherapp-township-weather__temp-min').text('Min. ' + data["live_data"]["temperature_live"] + '°C');
    } else {
      currentWeatherWidget.find('.vodl-weatherapp-township-weather__temp-min').text('Min. ' + data["township_forecast_data"][0]["temperature_min"] + '°C');
    }
    hoursList.find('.vodl-weatherapp-township-weather-item__icon').remove();
    currentWeatherWidget.find('.vodl-weatherapp-township-weather-item__label').eq(0).after('<div class="vodl-weatherapp-township-weather-item__icon"><span class="vodl-svg-sprite vodl-icon-weather-' + data["township_forecast_data"][0]["weather_state_day"] + '"><svg><use xlink:href="#vodl-icon-weather-' + data["township_forecast_data"][0]["weather_state_day"] + '"></use></svg></span></div>');
    for (var i = 1; i < 8; i++) {
      var b = i + 1;
      currentWeatherWidget.find('.vodl-weatherapp-township-weather-item__label').eq(i).after('<div class="vodl-weatherapp-township-weather-item__icon"><span class="vodl-svg-sprite vodl-icon-weather-' + data["48_hours_projection"][b]["weather_state"] + '"><svg><use xlink:href="#vodl-icon-weather-' + data["48_hours_projection"][b]["weather_state"] + '"></use></svg></span></div>');
      currentWeatherWidget.find('.vodl-weatherapp-township-weather-item__temperature').eq(i).text(data["48_hours_projection"][b]["temperature"] + '°C');
    }
    var locale = currentWeatherWidget.data('locale') || 'en';
    moment.locale(locale);
    var sunrise_time = new Date(data["astro_data"]["sunrise_time"] * 1000);
    sunrise_time = moment(sunrise_time).format('LT');
    var sunset_time = new Date(data["astro_data"]["sunset_time"] * 1000);
    sunset_time = moment(sunset_time).format('LT');
    currentWeatherWidget.find('.vodl-weatherapp-township-weather__sunrise-value').text(sunrise_time);
    currentWeatherWidget.find('.vodl-weatherapp-sungraph__label').eq(1).text(sunrise_time);
    currentWeatherWidget.find('.vodl-weatherapp-township-weather__sunset-value').text(sunset_time);
    currentWeatherWidget.find('.vodl-weatherapp-sungraph__label').eq(0).text(sunset_time);
    currentWeatherWidget.find('.vodl-weatherapp-township-weather__humidity-value').text(data["live_data"]["humidity"] + "%");
    currentWeatherWidget.find('.vodl-weatherapp-township-weather__pressure-value').text(data["live_data"]["pressure"] + "hPA");
    currentWeatherWidget.find('.vodl-weatherapp-windgraph__wind-dir-grp').attr('style', 'transform: rotate(' + data["live_data"]["wind_direction"] + 'deg); transform-origin: 50% 50%');
  }

  // init weather widget or add event listener when it's not there
  if (weatherWidget.length > 0) {
    checkOnUpdates();
  } else {
    // Initialize event listener for lazy weather widget.
    window.addEventListener('newPage', init_township_weather, false);
  }
})(window, document);
"use strict";

(function (window, document, undefined) {
  'use strict';

  var countdown = document.querySelectorAll('.vodl-widget-general--countdown.pre-init');

  // re-fetch all available not-intitialized countdown widgets
  var countdown_init_newPage = function countdown_init_newPage() {
    countdown = document.querySelectorAll('.vodl-widget-general--countdown.pre-init');
    countdown.forEach(function (widget) {
      init_countdown(widget);
      widget.classList.remove('pre-init');
    });
  };

  // initialize all countdown widgets
  var init_countdown = function init_countdown(widget) {
    var current_date = moment();
    var target_date = widget.querySelector('.vodl-countdown__date-time').textContent;
    target_date = moment(target_date);
    var interval, duration, days, hours, mins, secs;

    // Counter function.
    var interval_func = function interval_func(widget) {
      current_date = moment().utcOffset(120).format('YYYY-MM-DD HH:mm:ss');
      duration = moment.duration(target_date.diff(current_date, 'milliseconds'), 'milliseconds');
      days = Math.floor(moment.duration(target_date.diff(current_date)).asDays());
      hours = duration.hours();
      mins = duration.minutes();
      secs = duration.seconds();
      secs = secs < 10 ? "0" + secs : secs;
      mins = mins < 10 ? "0" + mins : mins;
      hours = hours < 10 ? "0" + hours : hours;
      days = days < 10 ? "0" + days : days;
      if (days == 0 && hours == 0 && mins == 0 && secs == 0) {
        widget.querySelectorAll('.vodl-countdown__start').forEach(function (elem) {
          elem.style.display = 'none';
        });
        widget.querySelectorAll('.vodl-countdown__end').forEach(function (elem) {
          elem.classList.remove('vodl-countdown__end');
        });
      } else {
        widget.querySelector('.vodl-countdown__element.vodl-countdown_element--days .vodl-countdown__element--number').textContent = days;
        widget.querySelector('.vodl-countdown__element.vodl-countdown_element--hours .vodl-countdown__element--number').textContent = hours;
        widget.querySelector('.vodl-countdown__element.vodl-countdown_element--mins .vodl-countdown__element--number').textContent = mins;
        widget.querySelector('.vodl-countdown__element.vodl-countdown_element--secs .vodl-countdown__element--number').textContent = secs;
      }
    };
    if (target_date > current_date) {
      interval_func(widget);
      interval = setInterval(function () {
        interval_func(widget);
      }, 1000);
    } else {
      clearInterval(interval);
      widget.querySelectorAll('.vodl-countdown__start').forEach(function (elem) {
        elem.style.display = 'none';
      });
      widget.querySelectorAll('.vodl-countdown__end').forEach(function (elem) {
        elem.classList.remove('vodl-countdown__end');
      });
    }
  };
  countdown.forEach(function (widget) {
    init_countdown(widget);
  });

  // Initialize event listener for lazy countdown widget.
  window.addEventListener('newPage', countdown_init_newPage, false);
})(window, document);
"use strict";

(function (window, document, undefined) {
  'use strict';

  var $ = window.jQuery,
    expanded = 'vodl-footer__linklist--expanded';

  /**
   * Initializes the click event for footer lists (in mobile view).
   */
  function init_footer_mobile() {
    $('.vodl-footer__linklist-item--first .vodl-footer__linklist-itemlink').click(function () {
      if ($(this).parents().not('.' + expanded)) {
        $('.' + expanded).removeClass(expanded);
        $(this).parent().parent().addClass(expanded);
      }
      return false;
    });
  }
  $(document).ready(function () {
    init_footer_mobile();
  });
})(window, document);
"use strict";

(function (window, document, undefined) {
  'use strict';

  var stickyFooter = document.querySelector('.vodl-footer-sticky__wrapper'),
    config = {
      rootMargin: '0px',
      threshold: 0
    };
  var newsriver = document.querySelectorAll('.vodl-region-newsriver');
  var observer = new IntersectionObserver(function (entries, SELF) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        stickyFooter.style.display = 'none';
      } else if (entry.boundingClientRect.top < 0) {
        stickyFooter.style.display = 'block';
      }
    });
  }, config);
  var _observeStickyWidget = function observeStickyWidget() {
    newsriver = document.querySelectorAll('.vodl-region-newsriver');
    if (newsriver[2] !== undefined) {
      observer.observe(newsriver[2]);
      window.removeEventListener('newPage', _observeStickyWidget);
    }
  };
  if ('IntersectionObserver' in window && stickyFooter !== undefined) {
    if (newsriver[2] !== undefined) {
      observer.observe(newsriver[2]);
    }
    if (newsriver[2] === undefined) {
      window.addEventListener('newPage', _observeStickyWidget);
    }
  }
})(window, document);
"use strict";

(function (window, document, navigator, undefined) {
  'use strict';

  //evil hack to make sure input fields inside vodl-form--modal scroll into view on Android
  if (/Android/.test(navigator.appVersion)) {
    window.addEventListener("resize", function () {
      if (document.activeElement.tagName == "INPUT" || document.activeElement.tagName == "TEXTAREA") {
        window.setTimeout(function () {
          document.activeElement.scrollIntoView();
        }, 1);
      }
    });
  }
})(window, document, navigator);
"use strict";

function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
(function (document, window, undefined) {
  'use strict';

  var logger = {},
    gallerySlider = document.querySelectorAll('.vodl-gallery-slider.pre-init'),
    slider_index = 0;
  $(document).ready(function () {
    // logger with cookie emoji prefix
    try {
      logger = new window.RussMedia.Utils.Logger('[galleryslider]');
    } catch (e) {
      logger = {
        log: function log() {}
      };
    }
    if (gallerySlider.length > 0) {
      var premium_content = document.querySelector('.vodl-region-article__premium-content');
      if (premium_content) {
        // wait for show full content event to initialize the gallery slider on premium articles
        document.addEventListener('vodl_show_full_content', initGallerySlider_newPage, false);
        return;
      }
      gallerySlider.forEach(function (slider, index) {
        initGallerySlider(slider, index);
        slider_index = index;
      });
    }
    // Initialize event listener for lazy sliders.
    window.addEventListener('newPage', initGallerySlider_newPage, false);
  });

  // re-fetch all available not yet intitialized slider
  var initGallerySlider_newPage = function initGallerySlider_newPage() {
    gallerySlider = document.querySelectorAll('.vodl-gallery-slider.pre-init');
    gallerySlider.forEach(function (slider) {
      slider_index++;
      initGallerySlider(slider, slider_index);
    });
  };
  var handleSlideData = function handleSlideData(slider, slide) {
    var captionBar = slider.querySelector('.vodl-gallery-slider__caption-text'),
      title = slider.querySelector('.vodl-gallery-slider__title').innerText.replace(/[^a-zA-Z0-9]/g, '_'),
      type = '/bildserie/' + title,
      slideImage = slide[0].querySelector('img'),
      bxAuto = slide[0].closest('.bx-wrapper').querySelector('.bx-stop');
    if (captionBar !== null && slideImage !== null) captionBar.innerHTML = slideImage.title;
    if (bxAuto !== null && bxAuto.classList.contains('active') || bxAuto === null) {
      trackOEWA(type);
      trackGA(title);
    }
  };
  var handleSwipingAnimation = function handleSwipingAnimation(slider) {
    if (slider.idx == slider.swipePagerIdx && slider.idx != slider.endOfLoop) {
      $(slider.pagerWrapper).animate({
        "margin-left": slider.swipeValue
      });
      delete slider.firstPager.dataset.slide;
      delete slider.lastPager.dataset.slide;
      slider.pagerLinks[slider.swipeFirst].dataset.slide = 'first';
      slider.pagerLinks[slider.swipeLast].dataset.slide = 'last';
    }
    if (slider.idx == slider.endOfLoopPagerIdx) {
      slider.pagerItems[slider.idx].children[0].classList.remove('active');
      slider.pagerItems[slider.activePagerIdx].children[0].classList.add('active');
      $(slider.pagerWrapper).animate({
        "margin-left": slider.scrollToMax
      });
      delete slider.firstPager.dataset.slide;
      delete slider.lastPager.dataset.slide;
      slider.pagerLinks[slider.endOfLoopPagerFirst].dataset.slide = 'first';
      slider.pagerLinks[slider.endOfLoopPagerLast].dataset.slide = 'last';
    }
  };
  var swipePrev = function swipePrev(slide, oldIndex) {
    var slider = slide[0].closest('.vodl-gallery-slider__wrapper').parentElement,
      idx = oldIndex;
    if (null === slider) {
      return;
    } else {
      handleSlideData(slider, slide);
    }
    var pagerWrapper = slider.querySelector('.vodl-gallery-slider__pager-wrapper'),
      activePager = slider.querySelector('.vodl-gallery-slider__pager-item-link.active'),
      firstPager = slider.querySelector('.vodl-gallery-slider__pager-item-link[data-slide="first"]'),
      lastPager = slider.querySelector('.vodl-gallery-slider__pager-item-link[data-slide="last"]');
    if (null === pagerWrapper) {
      return;
    }
    var pagerItems = pagerWrapper.querySelectorAll('.vodl-gallery-slider__pager-item'),
      pagerLinks = pagerWrapper.querySelectorAll('.vodl-gallery-slider__pager-item-link');
    if (null === pagerItems) {
      return;
    }
    var posFirstPager, posLastPager;
    if (null !== pagerLinks && null !== firstPager && null !== lastPager) {
      posFirstPager = _toConsumableArray(pagerLinks).indexOf(firstPager);
      posLastPager = _toConsumableArray(pagerLinks).indexOf(lastPager);
    }
    var amountPagerItems = pagerItems.length - 1;
    if (8 < pagerItems.length) {
      var attr = {
        idx: idx,
        pagerWrapper: pagerWrapper,
        pagerItems: pagerItems,
        pagerLinks: pagerLinks,
        activePager: activePager,
        firstPager: firstPager,
        lastPager: lastPager,
        posFirstPager: posFirstPager,
        posLastPager: posLastPager,
        swipePagerIdx: posFirstPager + 1,
        swipeFirst: posFirstPager - 1,
        swipeLast: posLastPager - 1,
        swipeValue: '+=30',
        scrollToMax: '-=' + (amountPagerItems - 7) * 30,
        activePagerIdx: amountPagerItems,
        endOfLoop: 1,
        endOfLoopPagerIdx: 0,
        endOfLoopPagerFirst: amountPagerItems - 7,
        endOfLoopPagerLast: amountPagerItems
      };
      handleSwipingAnimation(attr);
    }
    if (idx == 0) {
      pagerItems[idx].children[0].classList.remove('active');
      pagerItems[amountPagerItems].children[0].classList.add('active');
    } else {
      pagerItems[idx].children[0].classList.remove('active');
      pagerItems[idx].previousElementSibling.children[0].classList.add('active');
    }
  };
  var swipeNext = function swipeNext(slide, oldIndex) {
    var slider = slide[0].closest('.vodl-gallery-slider__wrapper').parentElement,
      idx = oldIndex;
    if (null === slider) {
      return;
    } else {
      handleSlideData(slider, slide);
    }
    var pagerWrapper = slider.querySelector('.vodl-gallery-slider__pager-wrapper'),
      activePager = slider.querySelector('.vodl-gallery-slider__pager-item-link.active'),
      firstPager = slider.querySelector('.vodl-gallery-slider__pager-item-link[data-slide="first"]'),
      lastPager = slider.querySelector('.vodl-gallery-slider__pager-item-link[data-slide="last"]');
    if (null === pagerWrapper) {
      return;
    }
    var pagerItems = pagerWrapper.querySelectorAll('.vodl-gallery-slider__pager-item'),
      pagerLinks = pagerWrapper.querySelectorAll('.vodl-gallery-slider__pager-item-link');
    if (null === pagerItems) {
      return;
    }
    var posFirstPager, posLastPager;
    if (null !== pagerLinks && null !== firstPager && null !== lastPager) {
      posFirstPager = _toConsumableArray(pagerLinks).indexOf(firstPager);
      posLastPager = _toConsumableArray(pagerLinks).indexOf(lastPager);
    }
    var amountPagerItems = pagerItems.length - 1;
    if (8 < pagerItems.length) {
      var attr = {
        idx: idx,
        pagerWrapper: pagerWrapper,
        pagerItems: pagerItems,
        pagerLinks: pagerLinks,
        activePager: activePager,
        firstPager: firstPager,
        lastPager: lastPager,
        posFirstPager: posFirstPager,
        posLastPager: posLastPager,
        swipePagerIdx: posLastPager - 1,
        swipeFirst: posFirstPager + 1,
        swipeLast: posLastPager + 1,
        swipeValue: '-=30',
        scrollToMax: 0,
        activePagerIdx: 0,
        endOfLoop: amountPagerItems - 1,
        endOfLoopPagerIdx: amountPagerItems,
        endOfLoopPagerFirst: 0,
        endOfLoopPagerLast: 7
      };
      handleSwipingAnimation(attr);
    }
    if (idx == amountPagerItems) {
      pagerItems[idx].children[0].classList.remove('active');
      pagerItems[0].children[0].classList.add('active');
    } else {
      pagerItems[idx].children[0].classList.remove('active');
      pagerItems[idx].nextElementSibling.children[0].classList.add('active');
    }
  };
  var initGallerySlider = function initGallerySlider(slider, index) {
    var sliderWrapper = slider.querySelector('.vodl-gallery-slider__slides'),
      slider_id = 'vodl-gallery-slider-' + index,
      auto = slider.dataset.auto || false,
      sliderAttr = {
        speed: 250,
        minSlides: 1,
        infiniteLoop: true,
        pager: true,
        pagerType: 'short',
        hideControlOnEnd: true,
        auto: auto,
        autoControls: true,
        stopAutoOnClick: true,
        prevSelector: '#' + slider_id + ' .vodl-gallery-slider__prev',
        nextSelector: '#' + slider_id + ' .vodl-gallery-slider__next',
        prevText: '<div class="vodl-gallery-slider__prev-arrow"></div>',
        nextText: '<div class="vodl-gallery-slider__next-arrow"></div>',
        onSlidePrev: swipePrev,
        onSlideNext: swipeNext
      };
    logger.log('initGallerySlider()', slider_id);

    // remove lazy load class and add id
    slider.classList.remove('pre-init');
    slider.setAttribute('id', slider_id);
    if (sliderWrapper !== null) {
      $(sliderWrapper).bxSlider(sliderAttr);
      var height = slider.querySelector('.bx-wrapper').clientHeight + 'px',
        pagerWrapper = slider.querySelector('.vodl-gallery-slider__pager-wrapper');
      var pagerItems = false;
      if (null !== pagerWrapper) {
        pagerItems = pagerWrapper.querySelectorAll('.vodl-gallery-slider__pager-item');
      }
      if (pagerItems && 8 > pagerItems.length) {
        pagerWrapper.style.justifyContent = 'center';
      }
      slider.querySelector('.bx-viewport').style.height = height;
      slider.addEventListener('touchmove', function (e) {
        e.preventDefault();
      });
    }
  };
  var trackOEWA = function trackOEWA(type) {
    if (typeof oewa_data === 'undefined') {
      return;
    }
    var modOEWA = oewa_data.cp,
      agency = modOEWA.substring(modOEWA.lastIndexOf('/') + 1),
      elements = modOEWA.split('/');
    if (modOEWA.includes('Homepage')) {
      elements[1] = 'Nachrichten';
      elements[2] = 'LokaleNachrichten';
    }
    var userAgent = navigator.userAgent;
    var device = '';
    if (/android/i.test(userAgent)) {
      device = 'Android';
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      device = 'iOS';
    }
    if (device === 'Android' || device === 'iOS') {
      //new OEWA tracking code
      oewa_data['cp'] = elements[0] + '/' + elements[1] + '/' + elements[2] + '/moewa' + type + '/' + agency;
    } else {
      //new OEWA tracking code
      oewa_data['cp'] = elements[0] + '/' + elements[1] + '/' + elements[2] + type + '/' + agency;
    }
    if (typeof window.IOMm !== 'undefined') {
      logger.log('[oewa] trackOEWA() - pageview', oewa_data['cp']);
      window.IOMm('pageview', {
        cp: oewa_data['cp']
      });
    }
  };
  var trackGA = function trackGA(title) {
    if (typeof gtm_tracking_enable !== 'undefined' && true === gtm_tracking_enable) {
      var uaPagePath = window.location.pathname;
      if (uaPagePath.indexOf('/', uaPagePath.length - 1) === -1) {
        uaPagePath += '/';
      }
      uaPagePath += 'galleryslider/' + title;
      logger.log('[ga] trackGA() - virtualPageview', uaPagePath);
      var eventData = {
        event: 'virtualPageview',
        dimension4: title,
        virtualPagePath: uaPagePath
      };
      dataLayer.push(eventData);
      document.dispatchEvent(new CustomEvent('hansrmdtevent', {
        detail: eventData
      }));
    }
  };
})(document, window);
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
(function (document, window, undefined) {
  "use strict";

  var $ = window.jQuery,
    logger = {},
    compact,
    compactType,
    compactVideo,
    teasers,
    galleryPattern,
    galleryLink,
    photoData = [],
    settings = {
      hideBarsDelay: 0,
      loopAtEnd: true,
      autoplayVideos: true,
      afterOpen: trackClicks,
      nextSlide: trackClicks,
      prevSlide: trackClicks,
      showBottomOnly: true
    },
    height,
    width,
    lightbox,
    id;
  var isVideoPage = document.querySelectorAll(".vodl-video-page").length;
  $(document).ready(function () {
    // logger with cookie emoji prefix
    try {
      logger = new window.RussMedia.Utils.Logger("[lightbox]");
    } catch (e) {
      logger = {
        log: function log() {}
      };
    }
    init();
    console.log("Init lightbox Script");
    window.addEventListener("newPage", init);
    window.addEventListener("refreshLightBoxLinks", init);
    // Listening to events fired when DCX galleries on external articles (VN/NEUE) should open.
    window.addEventListener("vodl_open_external_dcx_gallery", openExternalDcxGallery);
    // Eliteliga mediathek: view video item.
    window.addEventListener("vodl_open_elite_liga_video", openEliteligaVideo);

    // No listening to open maps events from external articles --> NNP-3090
    window.addEventListener("vodl_open_external_map", openExternalMap);
  });
  function init() {
    compact = $(".vodl-compact");
    compactType = compact.children();
    selectAllVideos();
    if (isVideoPage) {
      selectAllTeasers();
    }
    selectVideoBox();
    selectAllGaleries();
    selectAllExternalIframeLinks();
  }
  var selectAllExternalIframeLinks = function selectAllExternalIframeLinks() {
    teasers = document.querySelectorAll(".vodl-external-link--iframe");
    teasers.forEach(function (teaser) {
      lightboxEventHandler(teaser, "click", externalArticleIframeHandler);
    });
  };
  var lightboxEventHandler = function lightboxEventHandler(element, event, handler) {
    element.removeEventListener(event, handler);
    element.addEventListener(event, handler);
  };
  var galleryHandler = function galleryHandler(e) {
    e.preventDefault();
    getPhotos(e.currentTarget.href);
  };
  var externalArticleIframeHandler = function externalArticleIframeHandler(e) {
    e.preventDefault();
    var iframeLink = e.currentTarget.getAttribute("href");
    var iFrameHtml = "<div class=\"vodl-lightbox__container vodl-lightbox__container--article\"><div class=\"vodl-lightbox__article\"><iframe class=\"vodl-lightbox__iframe\" src=\"".concat(iframeLink, "\"></div></div>");
    var copyright = "";
    var additional_class = "";

    // ORF iFrame.
    if (iframeLink.includes("vorarlberg.orf.at")) {
      copyright = "Für den Inhalt der nachstehenden fremden Beiträge ist ausschließlich der ORF als Medieninhaber von vorarlberg.orf.at verantwortlich.";
      additional_class = "orf-article";
    }
    initLightBox({
      data: [iFrameHtml]
    }, {
      removeBarsOnMobile: false,
      hideBarsDelay: 0,
      afterClose: function afterClose() {
        if (additional_class) $("#swipebox-overlay").removeClass(additional_class);
      },
      afterOpen: function afterOpen() {
        if (additional_class || copyright) {
          $("#swipebox-overlay").addClass(additional_class);
          $("#swipebox-close").detach().prependTo("#swipebox-container .vodl-lightbox__article");
          $("#swipebox-top-bar").detach().prependTo("#swipebox-container .vodl-lightbox__article").html('<div id="swipebox-title">' + copyright + "</div><div id='swipebox-title__gradient'></div>").show();
        }
      }
    });
  };
  var iframeHandler = function iframeHandler(e) {
    e.preventDefault();
    var htmlIframe = [e.currentTarget.getAttribute("href")];
    initLightBox({
      data: htmlIframe
    });
  };
  var dcxGalleryHandler = function dcxGalleryHandler(e) {
    e.preventDefault();
    var mediaItem = e.currentTarget,
      galleryJSON = mediaItem.querySelector("#dcxGallery");
    if (galleryJSON !== null) {
      var galleryData = JSON.parse(galleryJSON.innerHTML).images.map(function (slide) {
        var slideData = [];
        slideData["title"] = slide.title;
        slideData["href"] = decodeURIComponent(slide.href);
        return slideData;
      });
      var trackingData = [];
      trackingData["name"] = mediaItem.querySelector(".vodl-compact__title-span").innerHTML;
      trackingData["id"] = "dcx";
      trackingData["type"] = "gallery";
      initLightBox({
        tracking: trackingData,
        data: galleryData
      }, {
        afterOpen: function afterOpen() {
          $("#swipebox-counter").detach().appendTo("#swipebox-container");
          trackGADetails();
          trackClicks();
        },
        nextSlide: trackClicks,
        prevSlide: trackClicks,
        loopAtEnd: true,
        hideBarsDelay: 0
      });
    }
  };

  /**
   * Open a DCX gallery from external contents (VN/NEUE).
   *
   * @param  {CustomEvent} e The custom event with data payload.
   * @return {undefined}
   */
  var openExternalDcxGallery = function openExternalDcxGallery(e) {
    var data = e.detail || false;
    if (!data) {
      return;
    }
    if (Array.isArray(data)) {
      var lightboxData = data.map(function (entry) {
        var slideData = [];
        slideData.title = entry.caption;
        slideData.href = entry.img;
        return slideData;
      });
      initLightBox({
        data: lightboxData
      }, {
        afterOpen: function afterOpen() {
          $("#swipebox-counter").detach().appendTo("#swipebox-container");
          trackClicks();
        },
        nextSlide: trackClicks,
        prevSlide: trackClicks,
        loopAtEnd: true,
        hideBarsDelay: 0
      });
    }
  };

  /**
   * Open a map iframe.
   * Currently not tracked --> NNP-3090.
   *
   * @param  {CustomEvent} e The custom event with data payload.
   * @return {undefined}
   */
  var openExternalMap = function openExternalMap(e) {
    var data = e.detail || false;
    if (!data || !data.lat || !data.lng) {
      return;
    }
    var apiKey = "AIzaSyCTJWounio27FBb0jrk_8fWKtOYpQGNL4Q";
    var mapUrl = "https://www.google.com/maps/embed/v1/place?key=".concat(apiKey, "&center=").concat(data.lat, ",").concat(data.lng, "&q=").concat(data.lat, ",").concat(data.lng, "&maptype=satellite&zoom=18");
    var mapHtml = "<div class=\"vodl-lightbox__container\"><div class=\"vodl-lightbox__video\"><iframe class=\"vodl-lightbox__iframe\" src=\"".concat(mapUrl, "\"></div></div>");
    initLightBox({
      data: [mapHtml]
    });
  };

  /**
   * Open an eliteliga video.
   *
   * @param  {CustomEvent} e The custom event with data payload.
   * @return {undefined}
   */
  var openEliteligaVideo = function openEliteligaVideo(e) {
    var data = e.detail || false;
    if (!data || !data.videoUrl) {
      return;
    }

    // We need to append swipeboxvideo=1 to the URL, otherwise
    // swipebox does not recognise this as video.
    if (data.videoUrl.indexOf("?") === -1) {
      data.videoUrl = data.videoUrl + "?swipeboxvideo=1";
    } else {
      data.videoUrl = data.videoUrl + "&swipeboxvideo=1";
    }
    var eliteligaVideo = {
      src: data.videoUrl
    };
    var videoData = [];
    videoData.push(eliteligaVideo);
    var trackingData = [];
    trackingData["provider"] = "eliteliga";
    trackingData["name"] = data.away_team + " - " + data.home_team;
    trackingData["id"] = data.matchId;
    trackingData["type"] = "video";
    var el_settings = settings;
    el_settings.afterOpen = function () {
      trackGADetails();
      trackClicks();
    };
    initLightBox({
      tracking: trackingData,
      data: videoData
    }, el_settings);
  };
  function selectAllGaleries() {
    var links = document.querySelectorAll("a");
    galleryLink = window.location.href;
    galleryPattern = galleryLink.match(/galerie-anzeigen/g);
    if (galleryPattern !== null) {
      getPhotos(galleryLink);
    }
    Array.from(links).forEach(function (link) {
      if (link.href.includes("/galerie-anzeigen")) {
        lightboxEventHandler(link, "click", galleryHandler);
      } else if (link.href.includes("iframe")) {
        lightboxEventHandler(link, "click", iframeHandler);
      } else if (link.href.includes("dcx-gallery")) {
        lightboxEventHandler(link, "click", dcxGalleryHandler);
      }
    });
  }

  // open lightbox after click on video box.
  function selectVideoBox() {
    var videoBox = $(".vodl-video-box"),
      item = videoBox.find(".vodl-video-box__wrapper-slider-item:not([data-vodl-consent-required])");
    item.off("click").on("click", function (e) {
      if ($(e.currentTarget).parents(".vodl-video-box--large").length > 0) {
        return;
      }
      e.preventDefault();
      var video = $(e.currentTarget).find(".vodl-video__iframe");
      video.attr("src", video.attr("data-src"));
      var videoData = [];
      videoData.push(video[0]);
      var trackingData = [];
      var videoUrl = video.attr("data-src");
      if (videoUrl.includes("youtube")) {
        trackingData["provider"] = "youtube";
        trackingData["id"] = getYtId(videoUrl);
      } else if (videoUrl.includes("uvp")) {
        trackingData["provider"] = "apa";
        trackingData["id"] = getApaId(videoUrl);
      } else if (videoUrl.includes("glomex")) {
        trackingData["provider"] = "glomex";
      }
      trackingData["type"] = "video";
      trackingData["name"] = $(e.currentTarget).find(".vodl-video-box__wrapper-slider-item-text-title").text().trim();
      initLightBox({
        data: videoData,
        tracking: trackingData
      }, {
        afterOpen: function afterOpen() {
          trackGADetails();
          trackClicks();
        },
        nextSlide: trackClicks,
        prevSlide: trackClicks,
        loopAtEnd: true,
        hideBarsDelay: 0
      });
    });
  }

  // open lightbox after click on media item video.
  var compactVideoClicked = function compactVideoClicked(e) {
    e.preventDefault();
    var videoData = [];
    videoData.push(e.currentTarget.parentElement);
    var trackingData = [];
    var videoUrl = e.currentTarget.parentElement.getAttribute("href");
    if (videoUrl.includes("youtube")) {
      trackingData["provider"] = "youtube";
      trackingData["id"] = getYtId(videoUrl);
    } else if (videoUrl.includes("uvp")) {
      trackingData["provider"] = "apa";
      trackingData["id"] = getApaId(videoUrl);
    } else if (videoUrl.includes("glomex")) {
      trackingData["provider"] = "glomex";
    }
    trackingData["name"] = e.currentTarget.querySelector(".vodl-compact__title-span").textContent;
    trackingData["type"] = "video";
    initLightBox({
      data: videoData,
      tracking: trackingData
    }, {
      afterOpen: function afterOpen() {
        trackGADetails();
        trackClicks();
      },
      nextSlide: trackClicks,
      prevSlide: trackClicks,
      loopAtEnd: true,
      hideBarsDelay: 0
    });
  };

  // filters all video links for youtube, apa and glomex videos.
  // adds event handler compactVideoClicked() onClick.
  function selectAllVideos() {
    compactVideo = compactType.filter(function () {
      var videoUrl = $(this).parent().attr("href") || false;
      if (!videoUrl) {
        return false;
      }
      if (videoUrl.includes("youtube") || videoUrl.includes("uvp") || videoUrl.includes("glomex")) {
        return $(this).hasClass("vodl-compact--video");
      }
    });
    Array.from(compactVideo).forEach(function (video) {
      lightboxEventHandler(video, "click", compactVideoClicked);
    });
  }

  // inits lightbox for teaser videos (special handling for brightcove).
  function selectTeaserVideo(ev) {
    ev.preventDefault();
    ev = ev || {};
    var originalTarget = ev.target || false,
      target = null,
      mode = "";
    if (isVideoPage) {
      var parent = helpers.findSelfOrParentByClassName(originalTarget, "vodl-lead-square");
      if (parent) {
        target = parent.querySelector(".vodl-media__video--play-button");
      }
    } else {
      target = helpers.findSelfOrParentByClassName(originalTarget, "vodl-media__video--play-button");
    }
    if (!target) {
      return;
    }
    var data = {
      src: target.dataset.href
    };
    var videoData = [];
    videoData.push(data);
    var mediaWrapper = target.closest(".vodl-media__wrapper");
    if (mediaWrapper) {
      var brightcoveData = mediaWrapper.querySelector("#brightcoveData");

      // adapt swipebox container styles if it's a brightcove player.
      if (brightcoveData) {
        initLightBox({
          data: videoData
        }, {
          afterOpen: function afterOpen() {
            var swipeboxContainer = document.querySelector(".swipebox-inline-container");
            if (!swipeboxContainer) {
              return;
            }
            swipeboxContainer.style.width = "100%";
            try {
              var _brightcoveData = mediaWrapper.querySelector("#brightcoveData");
              var _data = JSON.parse(_brightcoveData.innerHTML);
              $(".swipebox-inline-container").append('<div class="swipebox-video-container" style="max-width: 1140px"><div class="swipebox-video"><div class="vodl-brightcove-player"><video-js class="vodl-brightcove-player--video" data-account="" data-player="' + _data.playerId + '" data-embed="default" controls="" data-video-id="' + _data.videoId + '" data-application-id=""></video-js><script src="https://players.brightcove.net/6292321027001/' + _data.playerId + '_default/index.min.js"></script></div></div></div>');
              var brightcoveDataWrapper = swipeboxContainer.querySelector(".vodl-media__brightcove");
              if (brightcoveDataWrapper) {
                brightcoveDataWrapper.remove();
              }
              var _trackingData = [];
              _trackingData["provider"] = "brightcove";
              _trackingData["id"] = _data.videoId;
              _trackingData["type"] = "video";
              lightbox.tracking = _trackingData;
              trackGADetails();
            } catch (error) {
              logger.log("could not parse brightcove video data");
            }
          },
          nextSlide: trackClicks,
          prevSlide: trackClicks,
          loopAtEnd: true,
          hideBarsDelay: 0
        });
        return;
      }
    }
    var trackingData = [];
    var videoUrl = target.dataset.href;
    if (videoUrl.includes("youtube")) {
      trackingData["provider"] = "youtube";
      trackingData["id"] = getYtId(videoUrl);
    } else if (videoUrl.includes("uvp")) {
      trackingData["provider"] = "apa";
      trackingData["id"] = getApaId(videoUrl);
    } else if (videoUrl.includes("glomex")) {
      trackingData["provider"] = "glomex";
    }
    trackingData["type"] = "video";
    initLightBox({
      data: videoData,
      tracking: trackingData
    }, {
      afterOpen: function afterOpen() {
        trackGADetails();
        trackClicks();
      },
      nextSlide: trackClicks,
      prevSlide: trackClicks,
      loopAtEnd: true,
      hideBarsDelay: 0
    });
  }
  function selectAllTeasers() {
    teasers = document.querySelectorAll(".vodl-media__video--play-button[data-href]:not([data-vodl-consent-required])");
    teasers.forEach(function (teaser) {
      if (isVideoPage) {
        var parent = helpers.findSelfOrParentByClassName(teaser, "vodl-lead-square");
        parent.removeEventListener("click", selectTeaserVideo);
        parent.addEventListener("click", selectTeaserVideo);
      } else {
        teaser.removeEventListener("click", selectTeaserVideo);
        teaser.addEventListener("click", selectTeaserVideo);
      }
    });
  }

  // fetch gallery data and initialize lightbox (pass tracking data).
  function getPhotos(event) {
    var link = event,
      apiurl = "/api/nnp/get_imagegallery?p=";
    // apiurl = '/get_imagegallery.json?p='; // for using fake data

    link = link.match(/\/(\d{1,9})\b/g);
    link = link[0].replace(/\//g, "");
    id = link;
    apiurl = apiurl + link;
    photoData = [];
    axios.get(apiurl).then(function (response) {
      var arrayOfData = response.data.p;
      var l = arrayOfData.length;
      for (var i = 0; i < l; i++) {
        var singleData = arrayOfData[i];
        var data = [];
        if (typeof singleData.t !== "undefined" && singleData.t !== null) {
          data.title = singleData.t;
        } else if (typeof response.data.t !== "undefined" && response.data.t !== null) {
          data.title = response.data.t;
        }
        if (typeof singleData.s !== "undefined" && singleData.s !== null) {
          data.title += " &copy; " + singleData.s;
        } else if (typeof response.data.c !== "undefined" && response.data.c !== null) {
          data.title += " &copy; " + response.data.c;
        }
        data["href"] = singleData["u"];
        photoData.push(data);
      }
      var trackingData = [];
      trackingData["id"] = response.data.id;
      trackingData["name"] = response.data.t;
      trackingData["type"] = "gallery";
      initLightBox({
        tracking: trackingData,
        data: photoData
      }, {
        afterOpen: function afterOpen() {
          $("#swipebox-counter").detach().appendTo("#swipebox-container");
          trackGADetails();
          trackClicks();
        },
        nextSlide: trackClicks,
        prevSlide: trackClicks,
        loopAtEnd: true,
        hideBarsDelay: 0
      });
    });
  }
  function changeAfter() {
    var selectedElem = $("div.slide").removeClass("slide");
    selectedElem.addClass("vodl-lightbox__slide");
    var styles = {
      maxWidth: width + "px",
      maxHeight: height + "px"
    };
    $(".vodl-lightbox__iframe").css(styles);
  }
  function trackClicks() {
    trackGAEvents();
    trackOewa();
  }

  // track google analytics events (virtualPageView).
  function trackGAEvents() {
    var dataLayer = window.dataLayer || false;
    if (false === dataLayer) {
      return;
    }
    var type = false,
      id = false;
    if ("undefined" !== typeof lightbox.tracking) {
      type = lightbox.tracking["type"] || false;
      id = lightbox.tracking["id"] || false;
    }
    var url = lightbox.data[0].href || false;
    var uaPagePath = window.location.pathname.replace(/\/$/, ""); // remove single trailing slash.

    if ("gallery" === type && false !== id) {
      dataLayer.push({
        event: "virtualPageview",
        dimension4: id,
        virtualPagePath: uaPagePath + "/gallery/" + id
      });
    } else if ("video" === type && false !== id) {
      dataLayer.push({
        event: "virtualPageview",
        dimension5: id,
        virtualPagePath: uaPagePath + "/video/" + id
      });
    } else if (url.includes("sweepstake.tele.net") || url.includes("gewinnspiel.vol.at") || url.includes("anmeldung.vol.at")) {
      var sweepstakeId = getQuerystringParameter("id", url);
      if (sweepstakeId !== null) {
        var dimensionValue = sweepstakeId;
        uaPagePath += "sweepstake/" + sweepstakeId;
        dataLayer.push({
          event: "virtualPageview",
          dimension6: dimensionValue,
          virtualPagePath: uaPagePath
        });
      }
    }
    logger.log("[ga]", "trackGAEvents: ", Object.values(dataLayer).pop());
  }

  // track object details as provider, name, id and object type (gallery, video, ...).
  function trackGADetails() {
    var details = lightbox.tracking || false;
    var dataLayer = window.dataLayer || false;
    if (false === dataLayer || false === details) {
      return;
    }
    var ds = {};
    var type = details["type"];
    for (var _i = 0, _Object$entries = Object.entries(details); _i < _Object$entries.length; _i++) {
      var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
        key = _Object$entries$_i[0],
        value = _Object$entries$_i[1];
      if ("type" === key) continue;
      ds = {};
      var dimension = type + "_" + key;
      ds[dimension] = value;
      dataLayer.push(ds);
      logger.log("[ga]", "trackGADetails (dataLayer): ", ds);
    }
  }

  // track oewa
  function trackOewa() {
    var type = lightbox.tracking["type"] || false;
    var id = lightbox.tracking["id"] || false;
    var url = lightbox.data[0].href;
    if ("gallery" === type && false !== id) {
      var name = lightbox.tracking["name"] || "Titel";
      var galleryName = "bildserie/" + name.replace(/[^a-zA-Z0-9]/g, "_");
      oewaRequest(galleryName);
    } else if ("video" === type && false !== id) {
      var videoId = "video_" + id;
      oewaRequest(videoId);
    } else if (url.includes("sweepstake.tele.net") || url.includes("gewinnspiel.vol.at") || url.includes("anmeldung.vol.at")) {
      var sweepstakeId = "sweepstake/" + getQuerystringParameter("id", url);
      oewaRequest(sweepstakeId);
    }
  }
  function oewaRequest(type) {
    var oewa_data = window.oewa_data || false;
    if (!oewa_data) {
      return;
    }
    logger.log("[oewa] oewaRequest()");
    var oldOEWA = oewa_data.cp,
      modOEWA = oewa_data.cp,
      //get it from referer page
      agency = modOEWA.substring(modOEWA.lastIndexOf("/") + 1),
      elements = modOEWA.split("/");
    if (type.indexOf("sweepstake") > -1) {
      elements[0] = "UnterhaltungGames";
      elements[1] = "Games";
      elements[2] = "Gewinnspiele";
    } else if (modOEWA.includes("Homepage")) {
      elements[1] = "Nachrichten";
      elements[2] = "LokaleNachrichten";
    }
    var userAgent = navigator.userAgent;
    var device = "";
    if (/android/i.test(userAgent)) {
      device = "Android";
    }
    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      device = "iOS";
    }
    var device_string = "";
    if (device === "Android" || device === "iOS") {
      device_string = "moewa/";
    }
    oewa_data["cp"] = elements[0] + "/" + elements[1] + "/" + elements[2] + "/" + device_string + type + "/" + agency;
    if (typeof window.IOMm !== "undefined") {
      logger.log("[oewa] track pageview - cp", oewa_data["cp"]);
      window.IOMm("pageview", {
        cp: oewa_data["cp"]
      });
    }
    oewa_data["cp"] = oldOEWA; //set OEWA.cp to old value
  }

  // filters youtubeID from url.
  function getYtId(link) {
    var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
    var match = link.match(regExp);
    var matched_id = "";
    if (match[7]) {
      matched_id = match[7].replace(/\/$/, "");
    }
    return match && matched_id.length === 11 ? matched_id : false;
  }

  // filters APA ID from url.
  function getApaId(link) {
    var match = link.match(/embed\/(.*)\?/);
    if (match === null || match.length === 0) {
      return "apa-video";
    }
    return match[1];
  }
  function getQuerystringParameter(name, url) {
    name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
    var regexS = "[\\?&]" + name + "=([^&#]*)",
      regex = new RegExp(regexS),
      results = regex.exec(url);
    if (results === null) return null;else return results[1];
  }

  // Initialize lightbox with given data.
  function initLightBox(data) {
    var s = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : settings;
    lightbox = data;
    $.swipebox(data.data, s);

    // add event when popup is displayed - to avoid loading the tee popup
    var popup_event = document.createEvent("Event");
    popup_event.initEvent("tee_hide_popup", true, true);
    document.dispatchEvent(popup_event);
  }
  var helpers = {
    /**
     * Finds an DOM Node with the given className by searching the DOM upwards,
     * starting with currentElement itself.
     *
     * @param  {Node} currentElement The DOM Node to start from.
     * @param  {string} className    The name of the class we are looking for.
     * @param  {int} maxDepth        The maximum number of elements to go upwards.
     * @return {Node|null}           The found Node if any, null otherwise.
     */
    findSelfOrParentByClassName: function findSelfOrParentByClassName(currentElement, className, maxDepth) {
      maxDepth = maxDepth || 5;
      var foundElement = null;
      var currentDepth = 0;
      if (currentElement.classList && currentElement.classList.contains(className)) {
        return currentElement;
      } else {
        while ((currentElement = currentElement.parentElement) && currentDepth <= maxDepth) {
          currentDepth++;
          if (currentElement.classList && currentElement.classList.contains(className)) {
            foundElement = currentElement;
            break;
          }
        }
      }
      return foundElement;
    }
  };
})(document, window);
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
(function (window, document, undefined) {
  "use strict";

  var pianoEvent = document.createEvent("CustomEvent"),
    appEventTrackingEvent = document.createEvent("CustomEvent"),
    appPageviewTrackingEvent = document.createEvent("CustomEvent"),
    cancelCheckoutEvent = new Event("vodl_piano_checkout_canceled"),
    showFullContentEvent = document.createEvent("CustomEvent"),
    validateBotApiUrl = "/wp-json/russmedia-paywall/v1/validate-bot",
    registerNewsletterApiUrl = "/wp-json/russmedia-sso/v1/newsletter-registration",
    onboardingPath = "/vplus-onboarding";
  var axios = window.axios,
    premiumContent,
    pianoParams = false,
    triggerPaywallManually = false,
    paywallAsModal = false,
    logger = {},
    storage = {};
  window.tp = window.tp || [];
  try {
    logger = new window.RussMedia.Utils.Logger(String.fromCodePoint(0x1f3b9));
  } catch (e) {
    logger = {
      log: function log() {}
    };
  }
  try {
    storage = window.RussMedia.Utils.LocalStorage;
  } catch (e) {
    storage = {
      get: function get() {
        return null;
      },
      set: function set() {
        return false;
      },
      remove: function remove() {
        return;
      }
    };
  }
  var trackGA = function trackGA(data) {
    var trackingData = data || {};
    trackingData.action = trackingData.action || false;
    trackingData.pagePath = trackingData.pagePath || false;
    if (trackingData.action) {
      trackGAEvent(trackingData.action);
    }
    if (trackingData.pagePath) {
      trackGAPageview(trackingData.pagePath);
    }
  };
  var trackGAEvent = function trackGAEvent(action) {
    var urlParams = new URLSearchParams(window.location.search);
    var eventLabel = window.location.href;
    if (urlParams.has("articleURL")) {
      eventLabel = urlParams.get("articleURL");
    }
    if (isRenewal()) {
      action = "renewal-" + action;
    }
    var eventTrackingData = {
      event: "genericEvent",
      eventCategory: "checkout",
      eventAction: action,
      eventLabel: eventLabel
    };
    dataLayer.push(eventTrackingData);
    document.dispatchEvent(new CustomEvent("hansrmdtevent", {
      detail: eventTrackingData
    }));
    appEventTrackingEvent.initCustomEvent("vodl_app_on_event_tracking", true, true, eventTrackingData);
    document.dispatchEvent(appEventTrackingEvent);
  };
  var trackGAPageview = function trackGAPageview(pagePath) {
    if (isRenewal()) {
      pagePath = "renewal-" + pagePath;
    }
    var pageviewTrackingData = {
      event: "virtualPageview",
      virtualPagePath: pagePath
    };
    dataLayer.push(pageviewTrackingData);
    document.dispatchEvent(new CustomEvent("hansrmdtevent", {
      detail: pageviewTrackingData
    }));
    appPageviewTrackingEvent.initCustomEvent("vodl_app_on_pageview_tracking", true, true, pageviewTrackingData);
    document.dispatchEvent(appPageviewTrackingEvent);
  };
  var trackDrive = function trackDrive(data) {
    data = data || {};
    dataLayer.push(data);
  };
  var trackMarfeelLogin = function trackMarfeelLogin(data) {
    var _data$piano;
    var subscriptionInfo = (data === null || data === void 0 || (_data$piano = data.piano) === null || _data$piano === void 0 ? void 0 : _data$piano.abo) || {};

    // track if user is logged in
    window.marfeel = window.marfeel || {
      cmd: []
    };
    window.marfeel.cmd.push(["compass", function (compass) {
      compass.setUserType("logged");
    }]);

    // track premium users except VN and NEUE subscribers.
    if (subscriptionInfo.hasPlusAccess && !subscriptionInfo.isVNSubscriber && !subscriptionInfo.isNeueSubscriber) {
      window.marfeel.cmd.push(["compass", function (compass) {
        compass.setUserType("paid");
      }]);
    }
  };
  var trackMarfeelConversion = function trackMarfeelConversion() {
    window.marfeel = window.marfeel || {
      cmd: []
    };
    window.marfeel.cmd.push(["compass", function (compass) {
      compass.trackConversion("subscribe");
    }]);
  };
  var trackKilkaya = function trackKilkaya(data) {
    var _userData$piano, _document$querySelect;
    var userData = data || {};
    window.k5aMeta = window.k5aMeta || {};
    window.k5aMeta.login = userData.login ? 1 : 0;
    window.k5aMeta.subscriber = (_userData$piano = userData.piano) !== null && _userData$piano !== void 0 && (_userData$piano = _userData$piano.abo) !== null && _userData$piano !== void 0 && _userData$piano.hasPlusAccess ? 1 : 0;
    var isPaid = (_document$querySelect = document.querySelector('meta[property="k5a:paid"]')) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.content;

    // on pages we use a different class for the paywall container.
    var pagePremiumContent = document.querySelector(".vodl-page-wrapper--premium");
    if (isPaid === "1" && (premiumContent || pagePremiumContent)) {
      var _userData$piano2;
      window.k5aMeta.paywall = (_userData$piano2 = userData.piano) !== null && _userData$piano2 !== void 0 && (_userData$piano2 = _userData$piano2.abo) !== null && _userData$piano2 !== void 0 && _userData$piano2.hasPlusAccess ? "open" : "hard";
    }

    // tell kilkaya that we are ready to track user related data now
    document.dispatchEvent(new Event("K5A:PageReady"));

    // window.kilkaya should be available if the event was fired. Retry after 500ms if not.
    if (!window.kilkaya) {
      var retries = 5;
      var interval = setInterval(function () {
        if (window.kilkaya) {
          clearInterval(interval);
          return;
        } else if (retries <= 0) {
          clearInterval(interval);
        } else {
          retries--;
        }
        document.dispatchEvent(new Event("K5A:PageReady"));
      }, 500);
    }
  };

  /**
   * Start the vplus onboarding process by redirecting to the /vplus-onboarding path.
   */
  var startOnboarding = function startOnboarding() {
    var redirectUrl = onboardingPath;

    // Check if the current window.location.pathname matches the an article path like /post-slug/12345...
    var postRegex = /^\/[a-z0-9-]+\/[0-9]+$/i;
    if (postRegex.test(window.location.pathname)) {
      // Add the current location.pathname as targetUrl
      redirectUrl = onboardingPath + "?targetUrl=" + window.location.pathname;
    }
    logger.log("startOnboarding: now redirecting to ".concat(redirectUrl));
    window.location.href = redirectUrl;
  };
  var getArticleTitle = function getArticleTitle() {
    // grab the article title from og:title meta.
    var articleTitleNode = document.querySelector('meta[property="og:articleTitle"][content]'),
      articleTitle = articleTitleNode ? articleTitleNode.attributes["content"].value : null;

    // fallback to the title tag
    if (!articleTitle) {
      articleTitleNode = document.querySelector("title");
      articleTitle = articleTitleNode ? articleTitleNode.innerHTML : "unknown article title";
    }
    return articleTitle;
  };
  var isTagSet = function isTagSet() {
    var tag = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    return tag === tp.tags;
  };
  var isRenewal = function isRenewal() {
    return window.location.href.includes("reactivate_sub");
  };
  var postToPianoIframe = function postToPianoIframe(data) {
    var iFrame = document.getElementById(data.iframeId);
    if (iFrame) {
      iFrame.contentWindow.postMessage({
        piano: {
          success: data.success,
          message: data.message,
          object: data.object
        }
      }, "*");
    }
  };
  var isKayakSubscriber = function isKayakSubscriber(abo) {
    return abo.isKayakPlusSubscriber || abo.isKayakPlusPremiumSubscriber;
  };
  var initMessageEventListener = function initMessageEventListener(data) {
    var accountContainer = document.querySelector(".account-container");
    if (!accountContainer) {
      return;
    }
    data = data || {};
    var userData = data.detail || {};
    userData.piano = userData.piano || {};
    var abo = userData.piano.abo || {};
    window.addEventListener("message", function (e) {
      if (e.data && e.data.rmd) {
        var userStatus = storage.get("user-status") || {};
        var rmd = e.data.rmd;
        rmd.data = rmd.data || {};
        rmd.data.h = userStatus.hash || "";
        rmd.data.t = userStatus.token || "";
        if (rmd.message === "RMD_NEWSPAPER_ACCESS") {
          var access = [];
          if (abo.isVNSubscriber) {
            access.push("VN");
          }
          if (abo.isNeueSubscriber) {
            access.push("NEUE");
          }
          if (abo.isRevenueCatPlusSubscriber) {
            access.push("RevenueCatPlusSubscriber");
          }
          if (abo.isRevenueCatPlusPremiumSubscriber) {
            access.push("RevenueCatPlusPremiumSubscriber");
          }
          if (abo.isGoogleIAPPlusSubscriber) {
            access.push("GoogleIAPPlusSubscriber");
          }
          if (access) {
            postToPianoIframe({
              iframeId: rmd.data.iframeId,
              success: true,
              message: "RMD_NEWSPAPER_ACCESS",
              object: {
                access: access
              }
            });
          }

          // customized workflow for subscriber via kayak
          if (isKayakSubscriber(abo)) {
            axios({
              method: "post",
              timeout: 5000,
              url: "/wp-json/russmedia-paywall/v1/kayak-premium-subscription",
              data: {
                h: rmd.data.h,
                t: rmd.data.t
              }
            }).then(function (response) {
              var _response$data, _response$data$data;
              if ((response === null || response === void 0 || (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.code) !== "success") {
                return;
              }
              var data = (_response$data$data = response.data.data) !== null && _response$data$data !== void 0 ? _response$data$data : {};
              postToPianoIframe(_objectSpread({
                iframeId: rmd.data.iframeId
              }, data));
              return response;
            })["catch"](function (err) {
              logger.log(err);
              return err;
            });
          }
        }
        if (rmd.message === "RMD_AUTORENEW_TRACKING") {
          var action = rmd.data.didCancel ? "autorenew-status-deactivate" : "autorenew-status-activate";
          trackGAEvent(action);

          //notifiy paywall only for non-pur subscriptions where we have an explicit cancel reason!
          if (rmd.data.notifyPaywall) {
            var requestData = {
              uid: rmd.data.uid || "",
              hash: rmd.data.h || "",
              token: rmd.data.t || "",
              subscriptionId: rmd.data.subscriptionId || "",
              cancelReason: rmd.data.cancelReason || "",
              isKayakSubs: isKayakSubscriber(abo),
              didCancel: rmd.data.didCancel || false
            };
            axios({
              method: "post",
              timeout: 2000,
              url: "/wp-json/russmedia-paywall/v1/sync-cancel-reason",
              data: requestData
            }).then(function (response) {
              var _response$data2, _response$data$data2;
              logger.log("sync cancel reason", response);
              if ((response === null || response === void 0 || (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : _response$data2.code) !== "success") {
                return;
              }
              var data = (_response$data$data2 = response.data.data) !== null && _response$data$data2 !== void 0 ? _response$data$data2 : {};
              postToPianoIframe(_objectSpread({
                iframeId: rmd.data.iframeId
              }, data));
              return response;
            })["catch"](function (err) {
              logger.log(err);
              return err;
            });
          }
        }
      }
    });
  };
  var detectBot = function detectBot() {
    var deferred = $.Deferred(),
      userAgent = navigator.userAgent,
      bots = [{
        ua: "cXensebot",
        host: "cxensebot.com"
      }, {
        ua: "googlebot",
        host: "googlebot.com"
      }, {
        ua: "google-inspectiontool",
        host: "googlebot.com"
      }],
      isBot = bots.filter(function (bot) {
        return userAgent.match(new RegExp(bot.ua, "i"));
      });
    if (isBot.length > 0) {
      $.ajax({
        type: "GET",
        cache: false,
        dataType: "json",
        url: validateBotApiUrl,
        data: isBot[0]
      }).then(function (response) {
        response.valid = response.valid || false;
        if (response.valid) {
          deferred.resolve();
        } else {
          deferred.reject();
        }
      }, function () {
        deferred.reject();
      });
    } else {
      deferred.reject();
    }
    return deferred.promise();
  };
  var registerNewsletter = function registerNewsletter(newsletter) {
    var userStatus = storage.get("user-status") || {},
      data = {};
    data.h = userStatus.hash || "", data.t = userStatus.token || "", data.newsletter = newsletter || "";
    return axios({
      method: "post",
      timeout: 2000,
      url: registerNewsletterApiUrl,
      data: data
    }).then(function (response) {
      logger.log("newsletter registration successfull");
      return response;
    })["catch"](function (err) {
      logger.log(err);
      return err;
    });
  };
  var hideTeePopup = function hideTeePopup() {
    if (window.TeeFrontend) {
      window.TeeFrontend.set("disablePopup", true);
    } else {
      window._rm_tee = window._rm_tee || {};
      window._rm_tee.q = window._rm_tee.q || [];
      window._rm_tee.q.push(["set", "disablePopup", true]);
    }
  };
  var setUserRef = function setUserRef(userRef) {
    tp.push(["setUserRef", userRef]);
  };
  var setTags = function setTags(tags) {
    var _window$RussMedia;
    // There may be additional tags that where created server-side,
    // see wp-content/plugins/russmedia-piano/classes/class-hooks.php
    var additionalTags = ((_window$RussMedia = window.RussMedia) === null || _window$RussMedia === void 0 || (_window$RussMedia = _window$RussMedia.Piano) === null || _window$RussMedia === void 0 ? void 0 : _window$RussMedia.additionalTags) || [];
    logger.log("setTags additionalTags:", additionalTags);
    logger.log("setTags combined tags:", [].concat(_toConsumableArray(additionalTags), _toConsumableArray(tags)));
    tp.push(["setTags", [].concat(_toConsumableArray(additionalTags), _toConsumableArray(tags))]);
  };
  var setCustomVariable = function setCustomVariable(name, value) {
    tp.push(["setCustomVariable", name, value]);
  };
  var isPremiumUser = function isPremiumUser() {
    var abo = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    if (abo.hasPlusAccess || document.referrer.match(/https:\/\/www.(vn|neue)\.at/i)) {
      return true;
    }
    return false;
  };
  var isPlusPremiumUser = function isPlusPremiumUser() {
    var abo = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return abo.hasPlusPremiumAccess;
  };
  var removePaywallContainer = function removePaywallContainer() {
    var paywallContainer = document.querySelector(".vodl-paywall");
    if (paywallContainer) {
      paywallContainer.remove();
    }
  };
  var waitForConversionDataOrTimeout = function waitForConversionDataOrTimeout() {
    var apiPromise = new Promise(function (resolve) {
      tp.api.callApi("/conversion/list", {}, function (data) {
        var revokedUniqueAccesses = new Set();
        data.conversions.forEach(function (item) {
          var userAccess = item.user_access;
          if (!item.user_access.granted) {
            revokedUniqueAccesses.add(userAccess.access_id);
          }
        });
        var numberOfChurns = Math.min(revokedUniqueAccesses.size, 3);
        resolve(numberOfChurns); // Resolve after processing the API data
      });
    });
    var timeoutPromise = new Promise(function (resolve) {
      return setTimeout(function () {
        return resolve(0);
      }, 1000);
    });
    return Promise.race([apiPromise, timeoutPromise]);
  };
  var executeExperience = function executeExperience() {
    // Do not execute the experience if the paywall will be triggered manually.
    if (triggerPaywallManually) {
      return;
    }
    var urlParams = new URLSearchParams(window.location.search);
    var noheader = urlParams.get("noheader");

    // Do not execute the experience if the paywall is configured as modal and noheader is set.
    if (paywallAsModal && noheader) {
      return;
    }
    tp.push(["init", function () {
      waitForConversionDataOrTimeout().then(function (numberOfChurns) {
        setCustomVariable("userChurned", numberOfChurns);
        tp.experience.execute();
      });
    }]);
  };
  var startCheckout = function startCheckout() {
    logger.log("startCheckout user valid", tp.user.isUserValid());
    if (tp.user.isUserValid()) {
      var isVNSubscriber = tp.customVariables.isVNSubscriber || false,
        isNeueSubscriber = tp.customVariables.isNeueSubscriber || false;
      logger.log("got params", pianoParams, isVNSubscriber, isNeueSubscriber);
      if (pianoParams && !isVNSubscriber && !isNeueSubscriber) {
        tp.offer.startCheckout(pianoParams);
      }
    }
  };
  var showContent = function showContent() {
    var articleBottomSections = document.querySelectorAll(".vodl-region-article__content");
    if (articleBottomSections) {
      articleBottomSections.forEach(function (sections, idx) {
        if (idx >= 1 && null !== sections) {
          sections.style.display = "block";
        }
      });
    }
    if (premiumContent) {
      premiumContent.style.display = "block";
    }

    // Trigger the event that is used by external content rendering.
    showFullContentEvent.initCustomEvent("vodl_show_full_content", true, true, {});
    document.dispatchEvent(showFullContentEvent);
  };
  var showContentAndClosePaywall = function showContentAndClosePaywall() {
    // close paywall if modal is open.
    // This code is located here, because the vodl-paywall element might already be removed before the modal is loaded.
    var isModal = document.querySelector("body").classList.contains("tp-modal-open");
    if (isModal && tp && tp.offer) {
      tp.offer.close();
    }
    var paywallContainer = document.querySelector(".vodl-paywall");
    if (!paywallContainer) {
      return;
    }
    removePaywallContainer();
    showContent();
  };
  var showContentIfAccess = function showContentIfAccess(abo) {
    var contentType = "";
    if (premiumContent) {
      if (premiumContent.dataset && premiumContent.dataset.content) {
        contentType = premiumContent.dataset.content;
      }
      if ("paid" === contentType) {
        var isPremium = isPremiumUser(abo);
        if (isPremium) {
          showContent();
        }
      }
    }
  };
  var showLoginModal = function showLoginModal(type) {
    if (type) {
      window.dispatchEvent(new Event("open_".concat(type, "_form")));
    }
  };
  var initializePaywall = function initializePaywall(data) {
    var userData = data.detail || {};
    userData.piano = userData.piano || {};
    userData.piano.abo = userData.piano.abo || {};
    userData.piano.userRef = userData.piano.userRef || "";
    setUserRef(userData.piano.userRef);
    if (userData.piano.abo.isVNSubscriber) {
      setCustomVariable("isVNSubscriber", true);
    }
    if (userData.piano.abo.isNeueSubscriber) {
      setCustomVariable("isNeueSubscriber", true);
    }
    if (isPremiumUser(userData.piano.abo)) {
      setCustomVariable("hasPlusAccess", true);
    }
    if (isPlusPremiumUser(userData.piano.abo)) {
      setCustomVariable("hasPlusPremiumAccess", true);
    }
    setCustomVariable("noLinkToShop", true);
    showContentIfAccess(userData.piano.abo);
    executeExperience();
  };
  var handlePaidContent = function handlePaidContent(data) {
    premiumContent = document.querySelector(".vodl-region-article__premium-content");
    if (premiumContent) {
      setTags(["plus"]);
      hideTeePopup();
    }
    initMessageEventListener(data);
    detectBot().then(function () {
      setCustomVariable("isBot", true);
      executeExperience();
      showContent();
    }, function () {
      initializePaywall(data);
    });
  };
  var triggerEventOnLoginResolved = function triggerEventOnLoginResolved(data) {
    pianoEvent.initCustomEvent("vodl_piano_on_login_resolved", true, true, data);
    document.dispatchEvent(pianoEvent);
    trackMarfeelLogin(data);
    trackKilkaya(data);
  };
  var maybeTriggerStartCheckout = function maybeTriggerStartCheckout(context, data) {
    logger.log("maybe trigger startCheckout", context, data);
    if ("register-nopwd" === context) {
      tp.push(["setCustomVariable", "didRegistrationWithoutPassword", true]);
    }
    var userData = data || {},
      isPremium = false;
    userData.piano = userData.piano || {};
    userData.piano.abo = userData.piano.abo || {};
    userData.piano.userRef = userData.piano.userRef || "";

    // trigger event when login completed but the page is not refreshed yet (is needed by tee)
    window.dispatchEvent(new Event("tee_event_on_manual_login_resolved"));
    isPremium = isPremiumUser(userData.piano.abo);
    if (isPremium) {
      trackGAEvent("login_complete_aboexists");
    }
    if (!pianoParams && "register" === context) {
      var notification = document.querySelector(".vodl-notification--modal");
      if (notification) {
        notification.style.display = "flex";
      }
    } else if (isPremium || !pianoParams) {
      window.location.reload();
    } else if (pianoParams) {
      logger.log("maybe - startCheckout", pianoParams);
      setUserRef(userData.piano.userRef);
      startCheckout();
    }
  };
  var addEventListener = function addEventListener() {
    tp.push(["addHandler", "experienceExecute", function (data) {
      logger.log("experienceExecute", data);
    }]);
    tp.push(["addHandler", "showOffer", function (data) {
      logger.log("showOffer", data);
      trackGAEvent("paywall");
    }]);
    tp.push(["addHandler", "loginRequired", function (data) {
      logger.log("loginRequired", data);
      var type = false;
      if (data && "" != data.startScreen) {
        if ("register" === data.startScreen) {
          pianoParams = data;
          type = isTagSet("pur") ? "register" : "register_vplus";

          // This enables the registration without password flow only if
          // the registrationWithoutPassword customVariable is set.
          if ("register_vplus" === type && tp.customVariables.registrationWithoutPassword) {
            type = "register_without_password";
          }
          trackGAEvent("checkout_drive_start");
        }
        if ("login" === data.startScreen) {
          pianoParams = false;
          type = isTagSet("pur") ? "login" : "simple_login_vplus";
        }
        showLoginModal(type);
      }
    }]);
    tp.push(["addHandler", "startCheckout", function (data) {
      logger.log("startCheckout", data);
      if (!pianoParams) {
        trackGAEvent("checkout_drive_start");
      }
    }]);
    tp.push(["addHandler", "checkoutStateChange", function (data) {
      logger.log("checkoutStateChange", data);
      if ("state2" === data.stateName) {
        hideTeePopup();
        if (data.term) {
          trackDrive({
            abo_product: data.term.name,
            abo_price: data.term.displayLine
          });
        }
        trackGA({
          action: "payment",
          pagePath: "vplus/checkout/payment"
        });
      }
      if ("confirmation" === data.stateName) {
        trackGA({
          action: "confirmation",
          pagePath: "vplus/checkout/confirmation"
        });
      }
    }]);
    tp.push(["addHandler", "checkoutClose", function (data) {
      logger.log("checkoutClose", data);
      if ("checkoutCompleted" === data.state) {
        logger.log("checkoutClose with checkoutCompleted", tp.customVariables);
        logger.log("RegistrationWithoutPassword.State step:", window.RussMedia.RegistrationWithoutPassword.State.get("step"));
        trackGA({
          action: "complete",
          pagePath: "vplus/checkout/complete"
        });
        trackMarfeelConversion();
        var event = new Event("pianoConversionCompleted");
        document.dispatchEvent(event);
        if ("afterRegisterComplete" === window.RussMedia.RegistrationWithoutPassword.State.get("step")) {
          logger.log("didRegistrationWithoutPassword");
          removePaywallContainer();
          showContent();
          showLoginModal("register_without_password_set_pwd");
          return;
        }
        startOnboarding();
      }
      if ("close" === data.state) {
        var _tp$customVariables;
        if (pianoParams) {
          window.location.reload();
          return;
        }

        // If we do not reload, fire an event that may notify other components that the checkout was canceled.
        document.dispatchEvent(cancelCheckoutEvent);
        if ((_tp$customVariables = tp.customVariables) !== null && _tp$customVariables !== void 0 && _tp$customVariables.showAsModal || paywallAsModal) {
          // check if previous page was on our page or if it was a direct link to the checkout page
          if (window.history.length > 1) {
            window.history.back();
          } else {
            window.location.href = window.location.origin;
          }
        }
      }
    }]);
    tp.push(["addHandler", "checkoutComplete", function (data) {
      logger.log("checkoutComplete", data);
      if (!isRenewal()) {
        registerNewsletter("VPLUS_Subscriber");
      }
    }]);
    tp.push(["addHandler", "checkoutCustomEvent", function (data) {
      if ("connect_account" === data.eventName) {
        window.dispatchEvent(new Event("start_link_accounts"));
      }
      if ("simple_login_abo" === data.eventName) {
        showLoginModal(data.eventName);
      }
      if ("metered_article" === data.eventName) {
        removePaywallContainer();
        showContent();
        window.dispatchEvent(new CustomEvent("tee_event_plusabo_trigger"));
      }
      if ("open_upsell" === data.eventName) {
        if (!pianoParams) {
          trackGAEvent("checkout_drive_start");
        }
        window.dispatchEvent(new Event("start_upsell_flow"));
      }
    }]);
    document.addEventListener("vodl_piano_on_login_resolved", handlePaidContent);
    window.addEventListener("vodl_close_paywall_and_show_content", showContentAndClosePaywall);
  };
  var setPianoConfig = function setPianoConfig() {
    var pianoData = document.querySelector("#pianoData");
    var parsedData = {};
    if (null !== pianoData) {
      parsedData = JSON.parse(pianoData.innerHTML);
    }
    var pianoScript = document.createElement("script"),
      elem = document.getElementsByTagName("script")[0],
      scriptUrl = parsedData.script_url || "",
      appID = parsedData.app_id || "",
      sandbox = parsedData.sandbox || false,
      debug = parsedData.debug || false,
      cxenseSiteId = parsedData.cxense_site_id || "",
      customVariables = parsedData.custom_variables || {};
    triggerPaywallManually = parsedData.triggerManual || false;
    paywallAsModal = parsedData.paywallAsModal || false;
    if ("" !== scriptUrl) {
      tp.push(["setAid", appID]);
      tp.push(["setCxenseSiteId", cxenseSiteId]);
      if (sandbox) {
        tp.push(["setSandbox", sandbox]);
      }
      if (debug) {
        tp.push(["setDebug", debug]);
      }
      pianoScript.type = "text/javascript";
      pianoScript.async = true;
      var userStatus = storage.get("user-status") || {},
        tcfStatus = storage.get("tcf-status") || {};

      // check if the user is a pur subscriber or if the consent already given and load piano immediately
      if (userStatus && userStatus.pureSubscriber || tcfStatus && tcfStatus.tcString) {
        pianoScript.src = scriptUrl;
      } else {
        // otherwise wait until the consent is given
        pianoScript.dataset.src = scriptUrl;
        pianoScript.dataset.vodlTcfConsentRequired = "1";
      }
      if (Object.entries(customVariables).length > 0) {
        Object.entries(customVariables).forEach(function (variable) {
          return setCustomVariable(variable[0], variable[1]);
        });
      }
      elem.parentNode.insertBefore(pianoScript, elem);
    }
  };
  var init = function init() {
    setPianoConfig();
    addEventListener();
  };
  init();
  window.RussMedia = window.RussMedia || {};
  window.RussMedia.Piano = window.RussMedia.Piano || {};
  $.extend(window.RussMedia.Piano, {
    trackGAEvent: trackGAEvent,
    setTags: setTags,
    setUserRef: setUserRef,
    isPremiumUser: isPremiumUser,
    executeExperience: executeExperience,
    startCheckout: startCheckout,
    triggerEventOnLoginResolved: triggerEventOnLoginResolved,
    maybeTriggerStartCheckout: maybeTriggerStartCheckout,
    showContent: showContent,
    startOnboarding: startOnboarding
  });
})(window, document);
"use strict";

/*
 * provides the sign-on functionality
 *
 */
(function (window, document, undefined) {
  'use strict';

  var $ = window.jQuery,
    isLoggedInAsyncDeffered = null,
    rmBgsng = window.RussMedia.Bugsnag,
    rmPiano = window.RussMedia.Piano || false,
    signonApi = '/api/signon',
    ssoApi = '/api/sso',
    rmSSO = '/wp-json/russmedia-sso/v1/',
    options,
    userData;
  var loginStatusEventHandler = {
    statusEvent: document.createEvent('CustomEvent'),
    statusEventName: 'vodl_login_status_event',
    lastData: {},
    trigger: function trigger(data) {
      //Do not dispatch the event if data actually did not change since the last attempt.
      if (!this.isNewData(data)) {
        return;
      }
      this.statusEvent.initCustomEvent(this.statusEventName, true, true, data);
      document.dispatchEvent(this.statusEvent);
    },
    isNewData: function isNewData(newData) {
      // Only compare the relevant data!
      // The extend_cookie property always changes, so we should ignore it.
      if (this.lastData.extend_cookie) {
        delete this.lastData.extend_cookie;
      }
      if (newData.extend_cookie) {
        delete newData.extend_cookie;
      }

      // Cheap comparison by comparing the result of JSON.stringify().
      if (JSON.stringify(this.lastData) === JSON.stringify(newData)) {
        return false;
      }

      // And now remember the newData.
      this.lastData = newData;
      return true;
    }
  };
  var lastLoggedInAsyncCheck = {
    timestamp: false,
    get: function get() {
      // no valid timestamp
      if (false === this.timestamp) {
        return false;
      }
      var now = Math.floor(Date.now() / 1000);
      // timestamp older than 30s, return false.
      if (now - this.timestamp > 30) {
        return false;
      }

      // timestamp younger than 30s, return true.
      return true;
    },
    set: function set() {
      this.timestamp = Math.floor(Date.now() / 1000);
    }
  };

  /**
   * Initializes everything. Accepts eplicitly passed in options via opt.
   *
   * @param {Object} opt
   */
  function init(opt) {
    var defaults = {};
    $('body').append('<div id="sso-image"></div>');
    defaults.cookies = {
      container: $('#sso-image'),
      ssoCookieName: 'EvoSSO',
      sessionCookieName: 'SsoSessionCookie'
    };

    //explicitly passed in options can override defaults and values from the page primary-config
    opt = opt || {};
    opt.cookies = opt.cookies || {};
    opt.cookies.container = opt.cookies.container || defaults.cookies.container;
    opt.cookies.ssoCookieName = opt.cookies.ssoCookieName || defaults.cookies.ssoCookieName;
    opt.cookies.sessionCookieName = opt.cookies.sessionCookieName || defaults.cookies.sessionCookieName;
    options = opt;
  }
  function getOptions() {
    return options;
  }

  /**
   * Issues a async login request to the SSO and returns a promise
   *
   * @param {string} username
   * @param {string} password
   * @param {boolean} remember
   * @returns {@exp;deferred@call;promise}
   */
  function login(username, password, remember) {
    var deferred = $.Deferred();

    // check to see if user and password are not empty
    if (!username) {
      return deferred.reject('SSO_usernameOrMailInputRequired').promise();
    }
    if (!password) {
      return deferred.reject('SSO_passwordInputRequired').promise();
    }

    // return if already logged in
    if (isLoggedIn()) {
      return deferred.resolve('SSO_ssoLoginAlreadyLoggedInMessage', 'SSO_ssoLoginAlreadyLoggedInMessage', 'Anmeldung').promise();
    }
    var data = {
      log: username,
      pwd: password,
      rememberme: remember,
      time: Date.now()
    };
    $.ajax({
      type: 'POST',
      cache: false,
      dataType: 'json',
      url: signonApi + '/login',
      data: data
    }).then(function (result) {
      result.additional_data = result.additional_data || {};
      result.additional_data.sso = result.additional_data.sso || {};
      result.additional_data.sso.login_result = result.additional_data.sso.login_result || false;
      result.additional_data.sso.user_data = result.additional_data.sso.user_data || false;
      if (result.additional_data.sso.login_result === false) {
        //e.g. username/pwd empty...
        deferred.reject(result.additional_data.sso.user_error_text, {
          cookies: false
        });
      }
      var loginResult = result.additional_data.sso.login_result;
      if (loginResult.error === '0') {
        loginStatusEventHandler.trigger(result.additional_data.sso.user_data);

        //place the cookies if returned by the service
        if (loginResult.cookie) {
          options.cookies.container.append(loginResult.cookie);
          $('img:last', options.cookies.container).on('load', function () {
            waitForCookieAsync().then(function () {
              //login successful, SSO cookies set
              deferred.resolve(result.additional_data.sso, 'SSO_ssoLoginSuccessMessage', 'Anmeldung', {
                cookies: true
              });
            }, function () {
              //login successful,  but SSO cookies could not be set
              deferred.resolve(result.additional_data.sso, 'SSO_ssoLoginSuccessMessage', 'Anmeldung', {
                cookies: false
              });
            });
          });
        } else {
          //login successful, but no SSO cookies to set
          deferred.resolve(result.additional_data.sso, 'SSO_ssoLoginSuccessMessage', 'Anmeldung', {
            cookies: false
          });
        }
      } else {
        //login not successful
        deferred.reject(result.additional_data.sso.user_error_text, {
          cookies: false
        });
      }
    }, function (jqXHR, textStatus, errorThrown) {
      //login not successful, service error
      deferred.reject('SSO_ssoUnknownErrorMessage', {
        cookies: false,
        jqXHR: jqXHR,
        textStatus: textStatus,
        errorThrown: errorThrown
      });
    });
    return deferred.promise();
  }

  /**
   * Issues a async login via oauth request to the SSO and returns a promise
   *
   * @param {string} oauthid (facebook) oauth user id
   * @param {string} oauthtoken a valid oauth token
   * @returns {@exp;deferred@call;promise}
   */
  function loginByOAuth(oauthid, oauthtoken) {
    var deferred = $.Deferred();

    // check to see if user and password are not empty
    if (!oauthid || !oauthtoken) {
      deferred.reject('SSO_validateInputRequired');
      return deferred.promise();
    }

    // return if already logged in
    if (isLoggedIn()) {
      return deferred.resolve('SSO_ssoLoginAlreadyLoggedInMessage', 'SSO_ssoLoginAlreadyLoggedInMessage', 'Anmeldung').promise();
    }
    var data = {
      oauthid: oauthid,
      oauthtoken: oauthtoken
    };
    $.ajax({
      dataType: 'json',
      url: ssoApi + '/login_by_oauth',
      data: data
    }).then(function (result) {
      result.additional_data = result.additional_data || {};
      result.additional_data.sso = result.additional_data.sso || {};
      result.additional_data.sso.login_result = result.additional_data.sso.login_result || false;
      result.additional_data.sso.user_data = result.additional_data.sso.user_data || false;
      if (result.additional_data.sso.login_result === false) {
        //e.g. username/pwd empty...
        return deferred.reject(result.additional_data.sso.user_error_text, {
          cookies: false
        }).promise();
      }
      var loginResult = result.additional_data.sso.login_result;
      if (loginResult.error === '0') {
        loginStatusEventHandler.trigger(result.additional_data.sso.user_data);

        //place the cookies if returned by the service
        if (loginResult.cookie) {
          options.cookies.container.append(loginResult.cookie);
          $('img:last', options.cookies.container).on('load', function () {
            waitForCookieAsync().then(function () {
              //login successful, SSO cookies set
              //deferred.resolve( result, { cookies:true } );
              deferred.resolve(result.additional_data.sso.user_success_text, 'SSO_ssoLoginSuccessMessage', 'Anmeldung', {
                cookies: true
              });
            }, function () {
              //login successful,  but SSO cookies could not be set
              //deferred.reject( result, { cookies:false } );
              deferred.resolve(result.additional_data.sso.user_success_text, 'SSO_ssoLoginSuccessMessage', 'Anmeldung', {
                cookies: false
              });
            });
          });
        } else {
          //login successful, but no SSO cookies to set
          //deferred.resolve( result, { cookies:false } );
          deferred.resolve(result.additional_data.sso.user_success_text, 'SSO_ssoLoginSuccessMessage', 'Anmeldung', {
            cookies: false
          });
        }
      } else {
        //login not successful
        //deferred.reject( result, { cookies:false } );
        deferred.reject(result.additional_data.sso.user_error_text, {
          cookies: false,
          loginResult: loginResult
        });
      }
    }, function (jqXHR, textStatus, errorThrown) {
      //login not successful, service error
      //deferred.reject( false, { cookies:false, jqXHR:jqXHR, textStatus:textStatus, errorThrown:errorThrown } );
      deferred.reject('SSO_ssoUnknownErrorMessage', {
        cookies: false,
        jqXHR: jqXHR,
        textStatus: textStatus,
        errorThrown: errorThrown
      });
    });
    return deferred.promise();
  }

  /**
   * Issues a async SSO request to connect a oauthid to a existing user provided via the credentials
   * Returns a promise
   *
   * @param {string} oauthid
   * @param {string} username
   * @param {string} password
   * @returns {@exp;deferred@call;promise}
   */
  function connectOAuthId(oauthid, username, password) {
    var deferred = $.Deferred();

    // check to see if user and password are not empty
    if (!oauthid) {
      return deferred.reject('SSO_validateInputRequired').promise();
    }
    if (!username) {
      return deferred.reject('SSO_usernameInputRequired').promise();
    }
    if (!password) {
      return deferred.reject('SSO_passwordInputRequired').promise();
    }
    var data = {
      oauthid: oauthid,
      log: username,
      pwd: password
    };
    $.ajax({
      dataType: 'json',
      url: ssoApi + '/connect_oauth_id',
      data: data
    }).then(function (result) {
      //the call is successfull if
      // - the sso login was successfull (result.additional_data.sso.login_result.error === '0') AND
      //	- the oauthid of the SSO user was updated (result.additional_data.sso.change_result.error = '0')
      //	- the oauthid of the SSO user was not updated, because the info was already there (result.additional_data.sso.change_result.error = '5')

      result.additional_data = result.additional_data || {};
      result.additional_data.sso = result.additional_data.sso || {};
      result.additional_data.sso.login_result = result.additional_data.sso.login_result || false;
      result.additional_data.sso.change_result = result.additional_data.sso.change_result || false;
      if (result.additional_data.sso.login_result === false) {
        //e.g. username/pwd empty...
        return deferred.reject(result.additional_data.sso.user_error_text, {
          cookies: false
        }).promise();
      }
      var loginResult = result.additional_data.sso.login_result;
      if (loginResult.error !== '0') {
        //login not successful
        return deferred.reject(result.additional_data.sso.user_error_text, {
          cookies: false
        }).promise();
      }
      if (result.additional_data.sso.change_result === false) {
        //sso update user call somehow failed
        return deferred.reject(result.additional_data.sso.user_error_text, {
          cookies: false
        }).promise();
      }
      var changeResult = result.additional_data.sso.change_result;
      if (loginResult.error === '0' && (changeResult.error === '0' || changeResult.error === '5')) {
        //place the cookies if returned by the service
        if (loginResult.cookie) {
          options.cookies.container.append(loginResult.cookie);
          $('img:last', options.cookies.container).on('load', function () {
            waitForCookieAsync().then(function () {
              //login successful, SSO cookies set
              deferred.resolve(result.additional_data.sso.user_success_text, 'SSO_oauthConnectSuccess', 'Anmeldung', {
                cookies: true
              });
            }, function () {
              //login successful,  but SSO cookies could not be set
              //deferred.reject( result, { cookies:false } );
              deferred.resolve(result.additional_data.sso.user_success_text, 'SSO_oauthConnectSuccess', 'Anmeldung', {
                cookies: false
              });
            });
          });
        } else {
          //login successful, but no SSO cookies to set
          //deferred.resolve( result, { cookies:false } );
          deferred.resolve(result.additional_data.sso.user_success_text, 'SSO_oauthConnectSuccess', 'Anmeldung', {
            cookies: false
          });
        }
      } else {
        //connect not successful
        deferred.reject(result.additional_data.sso.user_error_text, {
          cookies: false
        });
      }
    }, function (jqXHR, textStatus, errorThrown) {
      //connect-login not successful, service error
      //deferred.reject( false, { cookies:false, jqXHR:jqXHR, textStatus:textStatus, errorThrown:errorThrown } );
      deferred.reject('SSO_ssoUnknownErrorMessage', {
        cookies: false,
        jqXHR: jqXHR,
        textStatus: textStatus,
        errorThrown: errorThrown
      });
    });
    return deferred.promise();
  }

  /**
   * Issues a async SSO request to connect a oauthid to a new user registered via the user details in params
   * Returns a promise
   *
   * @param {Object} params
   * @returns {@exp;deferred@call;promise}
   */
  function registerByOAuthId(params) {
    var deferred = $.Deferred();
    params = params || {};
    params.oauthid = params.oauthid || false;
    params.oauthtoken = params.oauthtoken || false;
    params.username = params.username || false;
    params.password = params.password || false;
    params.mailaddress = params.mailaddress || false;
    params.firstname = params.firstname || false;
    params.lastname = params.lastname || false;
    params.nodoi = params.nodoi || false;
    params.agb = params.agb || false;

    // check if the minimum data is given
    if (!params.oauthid || !params.oauthtoken) {
      return deferred.reject('SSO_validateInputRequired').promise();
    }
    var data = {
      oauthid: params.oauthid,
      oauthtoken: params.oauthtoken,
      log: params.username,
      email: params.mailaddress
    };
    if (params.password) {
      data.password = params.password;
    }
    if (params.firstname) {
      data.firstname = params.firstname;
    }
    if (params.lastname) {
      data.lastname = params.lastname;
    }
    if (params.nodoi) {
      data.nodoi = params.nodoi;
    }
    if (params.agb) {
      data.agb = params.agb;
    }

    // Try to "migrate" the user if already present on SSO.
    data.migrate = 1;
    $.ajax({
      dataType: 'json',
      url: ssoApi + '/register_by_oauth_id',
      data: data
    }).then(function (result) {
      result.additional_data = result.additional_data || {};
      result.additional_data.sso = result.additional_data.sso || {};
      result.additional_data.sso.register_result = result.additional_data.sso.register_result || false;
      if (result.additional_data.sso.register_result === false) {
        // general failure
        return deferred.reject(result.additional_data.sso.user_error_text).promise();
      }
      var registerResult = result.additional_data.sso.register_result;
      var registerMigrationResult = result.additional_data.sso.register_migration_result || false;
      if (registerResult.error === '0' && registerResult.success === '1') {
        deferred.resolve(result.additional_data.sso.user_success_text, 'SSO_oauthConnectSuccess', 'Registrierung');
      } else if (registerResult.error !== '0' && registerMigrationResult && registerMigrationResult.success === '1') {
        // The normal registration call failed because the given E-Mail already exists on SSO, but we could "migrate" the user
        // by assigning him the missing NNP aliases.
        deferred.resolve(result.additional_data.sso.user_success_text, 'SSO_oauthConnectSuccess', 'Registrierung');
      } else {
        // registration not successful
        deferred.reject(result.additional_data.sso.user_error_text);
      }
    }, function (jqXHR, textStatus, errorThrown) {
      deferred.reject('SSO_ssoUnknownErrorMessage', {
        cookies: false,
        jqXHR: jqXHR,
        textStatus: textStatus,
        errorThrown: errorThrown
      });
    });
    return deferred.promise();
  }

  /**
   * Issues a async logout request to the SSO and returns a promise
   *
   * @returns {@exp;deferred@call;promise}
   */
  function logout() {
    var deferred = $.Deferred();

    //flush the userData object in any case
    userData = false;
    var cookieDeleted = false;
    $.ajax({
      dataType: 'json',
      url: signonApi + '/logout'
    }).then(function (result) {
      loginStatusEventHandler.trigger(false);
      result.additional_data = result.additional_data || {};
      result.additional_data.sso = result.additional_data.sso || {};
      result.additional_data.sso.logout_result = result.additional_data.sso.logout_result || false;
      if (result.additional_data.sso.logout_result !== false) {
        var logoutResult = result.additional_data.sso.logout_result;
        if (logoutResult.cookie) {
          options.cookies.container.append(logoutResult.cookie);
          $('img:last', options.cookies.container).on('load', function () {
            deferred.resolve();
          });
          cookieDeleted = true;
        } else {
          deferred.resolve();
        }
      } else {
        deferred.resolve();
      }
      // manual delete of the sso cookie in case SSO response contains error
      // posible SSO timeout, invalid token/hash
      if (!cookieDeleted) {
        deleteCookie(options.cookies.ssoCookieName);
      }
    }, function (jqXHR, textStatus, errorThrown) {
      loginStatusEventHandler.trigger(false);
      deleteCookie(options.cookies.ssoCookieName);
      deferred.reject('SSO_ssoUnknownErrorMessage', {
        jqXHR: jqXHR,
        textStatus: textStatus,
        errorThrown: errorThrown
      });
    });
    return deferred.promise();
  }

  /**
   * Checks if the user is considered logged in by checkin on both the SSO Cookie and the SSO session cookie
   * Attention:
   * This does not validate the sso cookie via the sso API!
   * If you need that, use isLoggedInAsync instead
   * This method can be used if a deeper check is not necessary, e.g. when deciding wether to show the user
   * if he is logged in or not.
   *
   * @returns {Boolean}
   */
  function isLoggedIn() {
    //rather weak check
    var ssoCookie = getCookie(options.cookies.ssoCookieName) || false,
      sessionCookie = getCookie(options.cookies.sessionCookieName) || false;
    if (ssoCookie !== false && sessionCookie !== false) {
      return true;
    }

    //no cookie, no parts, no deal!
    return false;
  }

  /**
   * Checks if the user is considered logged in by checkin on both the SSO Cookie and the SSO session cookie.
   * Check if at least the SSO cookie exist, in case it will be valid, the user will be logged in.
   * Additionally it triggers a check via validateSSOCookieAsync to make sure the SSO cookie is valid.
   * Returns a promise. The promise will be resolved if both cookies are there and if the SSO cookie is valid
   * , otherwise the promise will be rejected.
   * This method can be used if a deeper check IS necessary, e.g. before posting a comment or before other user interaction
   * that requires users to be logged in.
   *
   * @returns {@exp;deferred@call;promise}
   */
  function isLoggedInAsync() {
    // If we allready created the deferred object
    // and we consider that as still valid via lastLoggedInAsyncCheck.get()
    // we can just return the promise.
    if (null !== isLoggedInAsyncDeffered && lastLoggedInAsyncCheck.get()) {
      return isLoggedInAsyncDeffered.promise();
    }

    // Otherwise let's create the deferred object and reset the timestamp
    // via lastLoggedInAsyncCheck.set()
    isLoggedInAsyncDeffered = $.Deferred();
    lastLoggedInAsyncCheck.set();
    var ssoCookie = getCookie(options.cookies.ssoCookieName) || false;

    //basic check first
    if (!isLoggedIn() && !ssoCookie) {
      //dispatch event for failed basic login check
      loginStatusEventHandler.trigger(false);
      if (rmPiano) {
        rmPiano.triggerEventOnLoginResolved(false);
      }
      isLoggedInAsyncDeffered.reject();
    } else {
      //run the sso cookie validation
      validateSSOCookieAsync(ssoCookie, 3).then(function (result) {
        // valid, resolve and save result
        isLoggedInAsyncDeffered.resolve(result);
      }, function (result) {
        // invalid, delete the cookies and reject
        deleteCookie(options.cookies.ssoCookieName);
        deleteCookie(options.cookies.sessionCookieName);
        isLoggedInAsyncDeffered.reject(result);
      });
    }
    return isLoggedInAsyncDeffered.promise();
  }

  /**
   *
   * Checks hash and token of a given ssoCookie against the SSO API
   * Returns a promise. The promise will be resolved if the hash/token combination in the ssoCookie is valid
   * , otherwise it will be rejected.
   *
   * @param {string} ssoCookie
   * @param {number} numRetries
   * @param {@exp;deferred@call;promise} deferred
   * @returns {@exp;deferred@call;promise}
   */
  function validateSSOCookieAsync(ssoCookie) {
    var numRetries = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var deferred = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $.Deferred();
    var cookieVals = ssoCookie.split(/\&/);

    //read hash and token from the ssoCookie
    var hash = false,
      token = false,
      login = false;
    for (var i = 0; i < cookieVals.length; i++) {
      var content = cookieVals[i].split(/\=/),
        key = content[0],
        value = content[1];
      switch (key) {
        case 'h':
          hash = value;
          break;
        case 't':
          token = value;
          break;
        case 'l':
          login = value;
          break;
      }
    }

    //if we could not read hash or token - reject, something is wrong
    if (!hash || !token) {
      var ssoError = new Error('Hash and token could not be read from cookie.');
      ssoError.name = 'SSOSessionCookieError';
      rmBgsng.doLog(ssoError, {
        severity: 'warning',
        metaData: [{
          name: 'SSOMeta',
          data: {
            cookie: ssoCookie
          }
        }]
      });
      deferred.reject();
    } else {
      //Still here? let's ask the API if this is a valid hash/token combination
      // - this can be achieved via the /api/sso/autologin method
      var data = {
        h: hash,
        t: token
      };
      $.ajax({
        dataType: 'json',
        url: ssoApi + '/autologin',
        data: data
      }).then(function (result) {
        result.user = result.user || {};
        result.user.errors = result.user.errors || false;
        if (result.user.errors) {
          //invalid hash or token, reject

          //dispatch event for failed hash/token verification
          loginStatusEventHandler.trigger(false);
          if (rmPiano) {
            rmPiano.triggerEventOnLoginResolved(false);
          }

          // This is a "normal" case, not an error, so we set severity to 'info'.
          var _ssoError = new Error("Hash and token validation for ".concat(login, " on server failed."));
          _ssoError.name = 'SSOSessionInvalid';
          rmBgsng.doLog(_ssoError, {
            severity: 'info',
            metaData: [{
              name: 'SSOMeta',
              data: {
                cookie: ssoCookie,
                hash: hash,
                token: token,
                login: login,
                result: result
              }
            }]
          });
          deferred.reject(result);
        } else {
          //valid hash or token, resolve

          // dispatch event for successful hash/token verification
          result.additional_data = result.additional_data || {};
          result.additional_data.sso = result.additional_data.sso || {};
          result.additional_data.sso.user_data = result.additional_data.sso.user_data || {};
          result.additional_data.sso.user_data.user_id = result.additional_data.sso.user_data.user_id || false;
          result.additional_data.sso.user_data.hash = result.additional_data.sso.user_data.hash || hash;
          result.additional_data.sso.user_data.token = result.additional_data.sso.user_data.token || token;
          loginStatusEventHandler.trigger(result.additional_data.sso.user_data);
          if (rmPiano) {
            rmPiano.triggerEventOnLoginResolved(result.additional_data.sso.user_data);
          }
          deferred.resolve(result);
        }
      }, function (jqXHR, textStatus, errorThrown) {
        // On failure we need to reject as well

        if (numRetries > 0) {
          // Try again, if there are attempts left.
          window.setTimeout(function () {
            validateSSOCookieAsync(ssoCookie, numRetries - 1, deferred);
          }, 1000);
        } else {
          // This is a real error, so we set severity to 'error'.
          var _ssoError2 = new Error("Request to validation API endpoint failed for ".concat(login, "!"));
          _ssoError2.name = 'SSOAPIError';
          rmBgsng.doLog(_ssoError2, {
            severity: 'error',
            metaData: [{
              name: 'SSOMeta',
              data: {
                cookie: ssoCookie,
                hash: hash,
                token: token,
                login: login,
                status: textStatus,
                message: errorThrown
              }
            }]
          });

          // Dispatch event for failed hash/token verification
          loginStatusEventHandler.trigger(false);
          if (rmPiano) {
            rmPiano.triggerEventOnLoginResolved(false);
          }
          deferred.reject();
        }
      });
    }
    return deferred.promise();
  }

  /**
   * checks 10 times if the SSO Cookie is set and returns a promise
   *
   * @returns {@exp;deferred@call;promise}
   */
  function waitForCookieAsync() {
    var deferred = $.Deferred();
    var cookieCheckCounter = 0;
    var waitForCookieResolveInterval = window.setInterval(function () {
      if (cookieCheckCounter < 10) {
        var ssoCookie = getCookie(options.cookies.ssoCookieName) || false;
        if (ssoCookie !== false) {
          window.clearInterval(waitForCookieResolveInterval);
          deferred.resolve();
        }
        cookieCheckCounter++;
      } else {
        window.clearInterval(waitForCookieResolveInterval);
        deferred.reject();
      }
    }, 300);
    return deferred.promise();
  }

  /**
   * Get user related stuff from cookie async.
   * Returns a promise.
   *
   * @returns {@exp;deferred@call;promise}
   */
  function getUserAsync() {
    var deferred = $.Deferred(),
      ssoCookie = getCookie(options.cookies.ssoCookieName) || false,
      sessionCookie = getCookie(options.cookies.sessionCookieName) || false;
    var user = {};
    if (!userData) {
      if (ssoCookie === false || sessionCookie === false) {
        userData = false;
        deferred.resolve(false);
      } else {
        var cookieVals = sessionCookie.split(/\&/);
        for (var i = 0; i < cookieVals.length; i++) {
          var content = cookieVals[i].split(/\=/),
            key = content[0],
            value = content[1];
          switch (key) {
            case 'username':
              user.userName = user.displayName = value;
              break;
            case 'fullname':
              user.fullName = decodeURI('' + value).replace(/\+/g, ' ');
              if (user.fullName !== '_') {
                user.displayName = user.fullName;
              }
              break;
            case 'email':
              user.email = unescape(value);
              break;
            case 'id':
              user.ssoId = parseInt(value, 10);
              break;
          }
        }
        userData = user;
      }
    }
    deferred.resolve(userData);
    return deferred.promise();
  }

  /**
   *
   * Issues a async SSO request to register a new user
   * Returns a promise.
   *
   * @param {string} username
   * @param {string} mailaddress
   * @param {string} firstname
   * @param {string} lastname
   * @param {string} password
   * @param {string} passwordSec
   * @returns {@exp;deferred@call;promise}
   */
  function register(username, mailaddress, password, agb) {
    var deferred = $.Deferred();

    // check to see if login, password and mail address, and first- and lastname are not empty
    if (!username) {
      return deferred.reject('SSO_usernameInputRequired').promise();
    }
    if (!mailaddress) {
      return deferred.reject('SSO_mailInputRequired').promise();
    }
    if (!password) {
      return deferred.reject('SSO_registerPasswordInputRequired').promise();
    }
    if (password.length < 6) {
      return deferred.reject('SSO_validatePasswordTooShort').promise();
    }
    checkUserExistsAsync(username).then(function () {
      // create user data object
      var data = {
        log: username,
        email: mailaddress,
        pwd: password,
        pwdsec: password,
        agb: agb,
        migrate: 1 // Try to "migrate" the user if already present on SSO.
      };
      $.ajax({
        url: signonApi + '/register',
        data: data,
        dataType: 'json'
      }).then(function (result) {
        result.additional_data = result.additional_data || {};
        result.additional_data.sso = result.additional_data.sso || {};
        result.additional_data.sso.register_result = result.additional_data.sso.register_result || false;
        if (result.additional_data.sso.register_result === false) {
          // e.g. validation fails...
          deferred.reject('SSO_ssoUnknownErrorMessage');
        }
        var registerResult = result.additional_data.sso.register_result;
        var registerMigrationResult = result.additional_data.sso.register_migration_result || false;
        if (registerResult.error === '0') {
          if (registerResult.success === '1') {
            // There might be a cookie property in the register_result, this means that automatic login without email validation is active.
            // So we need to handle that here.

            if (registerResult.cookie) {
              options.cookies.container.append(registerResult.cookie);
              $('img:last', options.cookies.container).on('load', function () {
                waitForCookieAsync().then(function () {
                  //registration with login successful, SSO cookies set
                  deferred.resolve(result.additional_data.sso, 'SSO_registrationWithLoginOKMessage', 'Registrierung');
                }, function () {
                  //registration with login successful,  but SSO cookies could not be set
                  deferred.resolve(result.additional_data.sso, 'SSO_registrationWithLoginOKMessage', 'Registrierung');
                });
              });
            } else {
              deferred.resolve(result.additional_data.sso, 'SSO_registrationOKMessage', 'Registrierung');
            }
          }
        } else if (registerResult.error !== '0' && registerMigrationResult && registerMigrationResult.success === '1') {
          // The normal registration call failed because the given E-Mail already exists on SSO, but we could "migrate" the user
          // by assigning him the missing NNP aliases.
          var loginResult = result.additional_data.sso.login_result;
          if (loginResult.error === '0') {
            //place the cookies if returned by the service

            if (loginResult.cookie) {
              options.cookies.container.append(loginResult.cookie);
              $('img:last', options.cookies.container).on('load', function () {
                waitForCookieAsync().then(function () {
                  //login successful, SSO cookies set
                  deferred.resolve(result.additional_data.sso, 'SSO_registrationMigrationOKMessage', 'Registrierung');
                }, function () {
                  //login successful,  but SSO cookies could not be set
                  deferred.resolve(result.additional_data.sso, 'SSO_registrationMigrationOKMessage', 'Registrierung');
                });
              });
            } else {
              //login successful, but no SSO cookies to set
              deferred.resolve(result.additional_data.sso, 'SSO_registrationMigrationOKMessage', 'Registrierung');
            }
          } else {
            if (loginResult.error !== '0') {
              deferred.reject(result.additional_data.sso.user_error_text, {
                cookies: false
              });
            }
          }
        } else {
          // registration not successful
          deferred.reject(result.additional_data.sso.user_error_text);
        }
      }, function (jqXHR, textStatus, errorThrown) {
        // registration not successful, service error
        deferred.reject('SSO_ssoUnknownErrorMessage', {
          cookies: false,
          jqXHR: jqXHR,
          textStatus: textStatus,
          errorThrown: errorThrown
        });
      });
    }, function (messageIdentifier) {
      deferred.reject(messageIdentifier);
    });
    return deferred.promise();
  }

  /**
   *
   * Issues a async SSO request to register a new user
   * Returns a promise.
   *
   * @param {string} username
   * @param {string} mailaddress
   * @param {string} firstname
   * @param {string} lastname
   * @param {string} password
   * @param {string} passwordSec
   * @returns {@exp;deferred@call;promise}
   */
  function registerAndValidate(username, mailaddress, password, agb) {
    var deferred = $.Deferred();

    // check to see if login, password and mail address, and first- and lastname are not empty
    if (!username) {
      return deferred.reject('SSO_usernameInputRequired').promise();
    }
    if (!mailaddress) {
      return deferred.reject('SSO_mailInputRequired').promise();
    }
    if (!password) {
      return deferred.reject('SSO_registerPasswordInputRequired').promise();
    }
    if (password.length < 6) {
      return deferred.reject('SSO_validatePasswordTooShort').promise();
    }
    var data = {
      log: username,
      email: mailaddress,
      pwd: password,
      pwdsec: password,
      agb: agb,
      migrate: 1 // Try to "migrate" the user if already present on SSO.
    };
    $.ajax({
      url: signonApi + '/register?nodoi=1',
      data: data,
      dataType: 'json'
    }).then(function (result) {
      result.additional_data = result.additional_data || {};
      result.additional_data.sso = result.additional_data.sso || {};
      result.additional_data.sso.user_data = result.additional_data.sso.user_data || {};
      result.additional_data.sso.register_result = result.additional_data.sso.register_result || false;
      if (result.additional_data.sso.register_result === false) {
        // e.g. validation fails...
        deferred.reject('SSO_ssoUnknownErrorMessage');
      }
      var registerResult = result.additional_data.sso.register_result;
      var registerMigrationResult = result.additional_data.sso.register_migration_result || false;
      if (registerResult.error === '0') {
        if (registerResult.success === '1') {
          // There might be a cookie property in the register_result, this means that automatic login without email validation is active.
          // So we need to handle that here.

          result.additional_data.sso.user_data.token = result.additional_data.sso.register_result.token || false;
          loginStatusEventHandler.trigger(result.additional_data.sso.user_data);
          if (registerResult.cookie) {
            options.cookies.container.append(registerResult.cookie);
            $('img:last', options.cookies.container).on('load', function () {
              waitForCookieAsync().then(function () {
                //registration with login successful, SSO cookies set
                deferred.resolve(result.additional_data.sso, 'SSO_registrationWithLoginOKMessage', 'Registrierung');
              }, function () {
                //registration with login successful,  but SSO cookies could not be set
                deferred.resolve(result.additional_data.sso, 'SSO_registrationWithLoginOKMessage', 'Registrierung');
              });
            });
          } else {
            deferred.resolve(result.additional_data.sso, 'SSO_registrationOKMessage', 'Registrierung');
          }
        }
      } else if (registerResult.error !== '0' && registerMigrationResult && registerMigrationResult.success === '1') {
        // The normal registration call failed because the given E-Mail already exists on SSO, but we could "migrate" the user
        // by assigning him the missing NNP aliases.
        var loginResult = result.additional_data.sso.login_result;
        if (loginResult.error === '0') {
          //place the cookies if returned by the service

          if (loginResult.cookie) {
            options.cookies.container.append(loginResult.cookie);
            $('img:last', options.cookies.container).on('load', function () {
              waitForCookieAsync().then(function () {
                //login successful, SSO cookies set
                deferred.resolve(result.additional_data.sso, 'SSO_registrationMigrationOKMessage', 'Registrierung');
              }, function () {
                //login successful,  but SSO cookies could not be set
                deferred.resolve(result.additional_data.sso, 'SSO_registrationMigrationOKMessage', 'Registrierung');
              });
            });
          } else {
            //login successful, but no SSO cookies to set
            deferred.resolve(result.additional_data.sso, 'SSO_registrationMigrationOKMessage', 'Registrierung');
          }
        } else {
          if (loginResult.error !== '0') {
            deferred.reject(result.additional_data.sso.user_error_text, {
              cookies: false
            });
          }
        }
      } else {
        // registration not successful
        deferred.reject(result.additional_data.sso.user_error_text);
      }
    }, function (jqXHR, textStatus, errorThrown) {
      // registration not successful, service error
      deferred.reject('SSO_ssoUnknownErrorMessage', {
        cookies: false,
        jqXHR: jqXHR,
        textStatus: textStatus,
        errorThrown: errorThrown
      });
    });
    return deferred.promise();
  }

  /**
   * Issues a async SSO request get a new password
   * Returns a promise.
   *
   * @param {string} username
   * @returns {@exp;deferred@call;promise}
   */
  function forgot(username) {
    var deferred = $.Deferred();

    // check to see if user is empty
    if (!username) {
      return deferred.reject('SSO_usernameOrMailInputRequired').promise();
    }
    var data = {
      log: username
    };
    $.ajax({
      url: signonApi + '/forgot',
      data: data,
      dataType: 'json'
    }).then(function (result) {
      if (result) {
        if (result.sent === false) {
          deferred.reject(result.additional_data.sso.user_error_text);
        } else {
          deferred.resolve(result.additional_data.sso.user_success_text, 'SSO_resetPassword', 'Passwort zurücksetzen');
        }
      } else {
        deferred.reject(result.additional_data.sso.user_error_text);
      }
    }, function (jqXHR, textStatus, errorThrown) {
      deferred.reject('SSO_ssoUnknownErrorMessage', {
        jqXHR: jqXHR,
        textStatus: textStatus,
        errorThrown: errorThrown
      });
    });
    return deferred.promise();
  }

  /**
   * Issues a async SSO request to check if a mail address is already taken
   * Returns a promise.
   *
   * @param {string} mailaddress
   * @returns {@exp;deferred@call;promise}
   */
  function checkMailExistsAsync(mailaddress) {
    var deferred = $.Deferred(),
      emailFilter = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    if (mailaddress.search(emailFilter) < 0) {
      deferred.reject('SSO_validateEmailNotValid');
    } else {
      var data = {
        email: mailaddress
      };
      $.ajax({
        url: signonApi + '/email_exists',
        data: data,
        dataType: 'json'
      }).then(function (response) {
        if (response) {
          if (response.exists === true || response.valid === false) {
            deferred.reject(response.additional_data.sso.user_error_text);
          }
        } else {
          deferred.reject('SSO_ssoUnknownErrorMessage');
        }
        deferred.resolve();
      });
    }
    return deferred.promise();
  }

  /**
   * Issues a async SSO request to check if an username is already taken
   * Returns a promise.
   *
   * @param {string} username
   * @returns {@exp;deferred@call;promise}
   */
  function checkUserExistsAsync(username) {
    var deferred = $.Deferred();
    if (username.search(/[^A-Za-z0-9\_\-]/) > -1 || username === '' || username.length < 4 || username.length > 32) {
      deferred.reject('SSO_validateLoginNotValid');
    } else {
      var data = {
        log: username
      };
      $.ajax({
        url: signonApi + '/login_exists',
        data: data,
        dataType: 'json'
      }).then(function (response) {
        if (response) {
          if (response.exists === true) {
            deferred.reject(response.additional_data.sso.user_error_text);
          }
        } else {
          deferred.reject('SSO_ssoUnknownErrorMessage');
        }
        deferred.resolve();
      });
    }
    return deferred.promise();
  }

  // Trying to delete a cookie via brute force.
  // If only the cookieName is known for sure, you can give this a shot.
  // The method will loop over all possible domain name and path scenarios to get rid of that one cookie, e.g. like this:
  // thecookiename=; expires=Thu, 01-Jan-1970 00:00:01 GMT; domain=www.vol.at; path=/
  // thecookiename=; expires=Thu, 01-Jan-1970 00:00:01 GMT; domain=www.vol.at; path=/news/vorarlberg
  // thecookiename=; expires=Thu, 01-Jan-1970 00:00:01 GMT; domain=www.vol.at; path=/news
  // thecookiename=; expires=Thu, 01-Jan-1970 00:00:01 GMT; domain=www.vol.at; path=
  // thecookiename=; expires=Thu, 01-Jan-1970 00:00:01 GMT; domain=.www.vol.at; path=/
  // thecookiename=; expires=Thu, 01-Jan-1970 00:00:01 GMT; domain=.www.vol.at; path=/news/vorarlberg
  // thecookiename=; expires=Thu, 01-Jan-1970 00:00:01 GMT; domain=.www.vol.at; path=/news
  // thecookiename=; expires=Thu, 01-Jan-1970 00:00:01 GMT; domain=.www.vol.at; path=
  // thecookiename=; expires=Thu, 01-Jan-1970 00:00:01 GMT; domain=vol.at; path=/
  // thecookiename=; expires=Thu, 01-Jan-1970 00:00:01 GMT; domain=vol.at; path=/news/vorarlberg
  // thecookiename=; expires=Thu, 01-Jan-1970 00:00:01 GMT; domain=vol.at; path=/news
  // thecookiename=; expires=Thu, 01-Jan-1970 00:00:01 GMT; domain=vol.at; path=
  // thecookiename=; expires=Thu, 01-Jan-1970 00:00:01 GMT; domain=.vol.at; path=/
  // thecookiename=; expires=Thu, 01-Jan-1970 00:00:01 GMT; domain=.vol.at; path=/news/vorarlberg
  // thecookiename=; expires=Thu, 01-Jan-1970 00:00:01 GMT; domain=.vol.at; path=/news
  // thecookiename=; expires=Thu, 01-Jan-1970 00:00:01 GMT; domain=.vol.at; path=
  // thecookiename=; expires=Thu, 01-Jan-1970 00:00:01 GMT; domain=at; path=/
  // thecookiename=; expires=Thu, 01-Jan-1970 00:00:01 GMT; domain=at; path=/news/vorarlberg
  // thecookiename=; expires=Thu, 01-Jan-1970 00:00:01 GMT; domain=at; path=/news
  // thecookiename=; expires=Thu, 01-Jan-1970 00:00:01 GMT; domain=at; path=
  // thecookiename=; expires=Thu, 01-Jan-1970 00:00:01 GMT; domain=.at; path=/
  // thecookiename=; expires=Thu, 01-Jan-1970 00:00:01 GMT; domain=.at; path=/news/vorarlberg
  // thecookiename=; expires=Thu, 01-Jan-1970 00:00:01 GMT; domain=.at; path=/news
  // thecookiename=; expires=Thu, 01-Jan-1970 00:00:01 GMT; domain=.at; path=
  function deleteCookie(cookieName) {
    var allCookies = document.cookie.split('; ');
    for (var c = 0; c < allCookies.length; c++) {
      var currentCookieName = encodeURIComponent(allCookies[c].split(';')[0].split('=')[0]);
      if (cookieName === currentCookieName) {
        var hn = window.location.hostname.split('.');
        while (hn.length > 0) {
          //without leading domain dot
          var cookieBase = currentCookieName + '=; expires=Thu, 01-Jan-1970 00:00:01 GMT; domain=' + hn.join('.') + '; path=',
            p = location.pathname.split('/');
          document.cookie = cookieBase + '/';
          while (p.length > 0) {
            document.cookie = cookieBase + p.join('/');
            p.pop();
          }

          //with leading domain dot
          cookieBase = currentCookieName + '=; expires=Thu, 01-Jan-1970 00:00:01 GMT; domain=.' + hn.join('.') + '; path=';
          p = location.pathname.split('/');
          document.cookie = cookieBase + '/';
          while (p.length > 0) {
            document.cookie = cookieBase + p.join('/');
            p.pop();
          }
          hn.shift();
        }
      }
    }
    return true;
  }
  function setCookie(cookieName, cookieValue, expireDays, forceCookieDomain) {
    var parts = document.location.host.split(/\./);
    var exDate = new Date();
    exDate.setDate(exDate.getDate() + expireDays);
    if (parts.length > 2) {
      parts.shift(); // remove whatever comes before the domain
    }
    var cookieDomain = parts.join('.');
    if (!isNaN(parts[0])) {
      // IP Address?
      cookieDomain = document.location.host;
    }
    if (forceCookieDomain) {
      cookieDomain = forceCookieDomain;
    }
    var theValue = encodeURI(cookieValue) + (exDate === null ? '' : '; expires=' + exDate.toUTCString() + ';path=/;domain=' + cookieDomain);
    document.cookie = cookieName + '=' + theValue;
  }
  function getCookie(cookieName) {
    var i,
      x,
      y,
      ARRcookies = document.cookie.split(';');
    for (i = 0; i < ARRcookies.length; i++) {
      x = ARRcookies[i].substr(0, ARRcookies[i].indexOf('='));
      y = ARRcookies[i].substr(ARRcookies[i].indexOf('=') + 1);
      x = x.replace(/^\s+|\s+$/g, '');
      if (x === cookieName) {
        return decodeURI(y);
      }
    }
  }
  function validatePassword(data) {
    var deferred = $.Deferred();
    data = data.hash.split('/?').pop();
    $.ajax({
      url: signonApi + '/validate_forget_password',
      data: data,
      dataType: 'json'
    }).then(function (result) {
      if (result) {
        if (result.additional_data.sso.validate_forget_password_result.error !== '0') {
          return deferred.reject(result.additional_data.sso.user_error_text, '', 'Passwort zurücksetzen').promise();
        }
        deferred.resolve(result.additional_data.sso.user_success_text, '', 'Passwort zurücksetzen');
      }
    }, function (jqXHR, textStatus, errorThrown) {
      deferred.reject('SSO_ssoUnknownErrorMessage', '', 'Passwort zurücksetzen', {
        jqXHR: jqXHR,
        textStatus: textStatus,
        errorThrown: errorThrown
      });
    });
    return deferred.promise();
  }
  function validateEmail(data) {
    var deferred = $.Deferred();
    data = data.hash.split('/?').pop();
    $.ajax({
      url: signonApi + '/validate_email',
      data: data,
      dataType: 'json'
    }).then(function (result) {
      if (result) {
        result.additional_data = result.additional_data || {};
        result.additional_data.sso = result.additional_data.sso || {};
        result.additional_data.sso.validate_email_result = result.additional_data.sso.validate_email_result || false;
        if (result.additional_data.sso.validate_email_result === false) {
          return deferred.reject('SSO_ssoUnknownErrorMessage', 'SSO_validateEmail', 'Account Bestätigung').promise();
        }
        if (result.additional_data.sso.validate_email_result.error !== '0') {
          return deferred.reject(result.additional_data.sso.user_error_text, 'SSO_validateEmail', 'Account Bestätigung').promise();
        }
        var validateEmailResult = result.additional_data.sso.validate_email_result;

        // There might be a cookie property in the validateEmailResult, this means that automatic login without email validation is active.
        // So we need to handle that here.
        if (validateEmailResult.cookie) {
          options.cookies.container.append(validateEmailResult.cookie);
          $('img:last', options.cookies.container).on('load', function () {
            waitForCookieAsync().always(function () {
              deferred.resolve(result);
            });
          });
        } else {
          deferred.resolve(result);
        }
      }
    }, function (jqXHR, textStatus, errorThrown) {
      deferred.reject('SSO_ssoUnknownErrorMessage', 'SSO_validateEmail', 'Account Bestätigung', {
        jqXHR: jqXHR,
        textStatus: textStatus,
        errorThrown: errorThrown
      });
    });
    return deferred.promise();
  }
  function changeCurrentPassword(userData) {
    var deferred = $.Deferred();
    if (!userData.new_password) {
      return deferred.reject('SSO_newPasswordEmptyMessage').promise();
    }
    if (!userData.new_password_again) {
      return deferred.reject('SSO_newPasswordAgainErrorMessage').promise();
    }
    if (userData.new_password.length < 6) {
      return deferred.reject('SSO_validatePasswordTooShort').promise();
    }
    if (userData.new_password_again.length < 6) {
      return deferred.reject('SSO_validatePasswordTooShort').promise();
    }
    $.ajax({
      method: 'POST',
      url: rmSSO + 'change-pw/user',
      data: userData,
      dataType: 'json'
    }).then(function (result) {
      if (result) {
        if (result.additional_data.sso.change_password_result.error !== '0') {
          deferred.reject(result.additional_data.sso.user_error_text);
        } else {
          deferred.resolve(result.additional_data.sso.user_success_text, 'SSO_changeCurrentPassword', 'Passwort ändern');
        }
      }
    });
    return deferred.promise();
  }
  window.RussMedia = window.RussMedia || {};
  window.RussMedia.SSO = window.RussMedia.SSO || {};
  $.extend(window.RussMedia.SSO, {
    init: init,
    getOptions: getOptions,
    login: login,
    loginByOAuth: loginByOAuth,
    loginStatusEventHandler: loginStatusEventHandler,
    connectOAuthId: connectOAuthId,
    registerByOAuthId: registerByOAuthId,
    logout: logout,
    register: register,
    registerAndValidate: registerAndValidate,
    forgot: forgot,
    isLoggedIn: isLoggedIn,
    isLoggedInAsync: isLoggedInAsync,
    getUserAsync: getUserAsync,
    deleteCookie: deleteCookie,
    getCookie: getCookie,
    setCookie: setCookie,
    validatePassword: validatePassword,
    validateEmail: validateEmail,
    waitForCookieAsync: waitForCookieAsync,
    changeCurrentPassword: changeCurrentPassword,
    checkUserExistsAsync: checkUserExistsAsync,
    checkMailExistsAsync: checkMailExistsAsync
  });
})(window, document);
"use strict";

(function (window, document, undefined) {
  'use strict';

  document.addEventListener('vodl_login_status_event', function (e) {
    pass_sso_user_details_to_vn(e);
  });

  /*
   * Event handler that passes some SSO details of the current user
   * over to vn.at by injecting an image with a vn.at URL that will set
   * a cookie on vn.at with the given information.
   */
  function pass_sso_user_details_to_vn(e) {
    var imageSrc = 'https://www.vn.at/integrations/vol/',
      userDetails,
      piggyBack;
    userDetails = e.detail || {};
    userDetails.user_id = userDetails.user_id || false;
    userDetails.hash = userDetails.hash || false;
    userDetails.token = userDetails.token || false;

    // Results in either
    // https://www.vn.at/integrations/vol/set.gif?ssoId=13441344&hash=2cl399e351364ba606f2a0dc32f856f9f1386&token=606d48222c59ac5034b4ae93ee498688
    // or
    // https://www.vn.at/integrations/vol/delete.gif
    if (userDetails.user_id && userDetails.hash && userDetails.token) {
      imageSrc += 'set.gif?ssoId=' + userDetails.user_id + '&ssoHash=' + userDetails.hash + '&ssoToken=' + userDetails.token;
    } else {
      imageSrc += 'delete.gif';
    }
    piggyBack = document.createElement('img');
    piggyBack.src = imageSrc;
    piggyBack.width = '0';
    piggyBack.height = '0';
    piggyBack.style.cssText = 'width: 0; height: 0; margin: 0; padding: 0; border: 0;';
    document.body.appendChild(piggyBack);
  }
})(window, document);
"use strict";

(function (window, document, undefined) {
  'use strict';

  var axios = window.axios,
    config = {},
    formApi = '/api/nnp/get_form',
    formsCache = {},
    Promise = window.Promise,
    ssoApiBase = '/wp-json/russmedia-sso/v1/',
    userData,
    userDataStorageKey = 'user-status';

  // logger with couple emoji prefix
  var logger = {};
  try {
    logger = new window.RussMedia.Utils.Logger(String.fromCodePoint(0x1F46B));
  } catch (e) {
    logger = {
      log: function log() {}
    };
  }

  // Add access to the local storage handler.
  var storage = {};
  try {
    storage = window.RussMedia.Utils.LocalStorage;
  } catch (e) {
    storage = {
      get: function get() {
        return null;
      },
      set: function set() {
        return false;
      },
      remove: function remove() {
        return;
      }
    };
  }

  /**
   * Initialize and attach event handlers.
   *
   * @return {undefined}
   */
  var _init = function _init() {
    // The event 'start_link_accounts' will trigger the whole process.
    window.addEventListener('start_link_accounts', events.onStartLinkAccounts);
  };

  /**
   * Collection of event handlers.
   *
   * @type {Object}
   */
  var events = {
    /**
     * Handle the form submission event.
     *
     * @param  {Event} ev The event object.
     * @return {Boolean}  Always returns false.
     */
    onFormSubmitted: function onFormSubmitted(ev) {
      ev.preventDefault();
      forms.linkAccounts.doSubmit();
      return false;
    },
    /**
     * Handle the close button click in the modal.
     *
     * @return {undefined}
     */
    onModalCloseButtonClicked: function onModalCloseButtonClicked() {
      modal.close();
    },
    /**
     * Handle the "outside" click of the modal.
     *
     * @param  {Event} ev The event object.
     * @return {undefined}
     */
    onModalWrapperClicked: function onModalWrapperClicked(ev) {
      // We only accept clicks outside the actual form, so...
      if (ev.target === ev.currentTarget) {
        modal.close();
      }
    },
    /**
     * Handle any click on the notfication modal.
     *
     * @return {undefined}
     */
    onNotificationClicked: function onNotificationClicked() {
      window.location.reload();
    },
    /**
     * Handle the event(s) that should trigger the link workflow.
     *
     * @return {undefined}
     */
    onStartLinkAccounts: function onStartLinkAccounts(ev) {
      logger.log('onStartLinkAccounts:', ev);
      forms.linkAccounts._init()["catch"](function (error) {
        logger.log(error);
        modal.close();
      });
    }
  };

  /**
   * Collection of available forms to render.
   *
   * @type {Object}
   */
  var forms = {
    linkAccounts: {
      /**
       * Initialize the linkAccounts form:
       *  - check if the user is logged in by checking the local storage
       *  - load the form via the form API
       *  - open the modal
       *  - attach event handlers
       *
       * @return {Promise} A promise that will either be resolved or rejceted.
       */
      _init: function _init() {
        return new Promise(function (resolve, reject) {
          // Check if we have the current userData in the storage
          userData = storage.get(userDataStorageKey);
          if (!userData || !userData.hash || !userData.token) {
            reject('user not logged in.');
            return;
          }
          logger.log('forms.linkAccounts._init userData:', userData);
          requests.getForm('link-accounts').then(function (data) {
            // Inject the fetched html into the page.
            var form = document.querySelector('.vodl-form');
            form.parentElement.replaceWith(helpers.htmlToElement(data));

            // Fetch the forms configuration.
            config = helpers.fetchFormConfigFromJSON();
            logger.log('forms.linkAccounts._init config:', config);

            // Open the thing
            modal.open();

            // Track the view of this modal.
            helpers.trackAction('aboverknuepfung_step1');

            // Attach events for the form itself
            var theForm = modal.elements.wrapper().querySelector('form');
            theForm.addEventListener('submit', events.onFormSubmitted);

            // Attach events for closing the modal
            modal.elements.wrapper().addEventListener('click', events.onModalWrapperClicked);
            modal.elements.closeButton().addEventListener('click', events.onModalCloseButtonClicked);
            resolve('link-accounts form initialized');
          })["catch"](function (error) {
            logger.log('requests.getForm("link-accounts") failed: ', error);
            reject(error);
          });
        });
      },
      /**
       * Handles the form submission:
       *  - basic client-side form validation
       *  - call the API
       *  - handle the API call result
       *
       * @return {undefined}
       */
      doSubmit: function doSubmit() {
        //clear possible errors
        this.showErrors(false);

        //basic data validation
        var validatedFormData = this.validate();
        logger.log('forms.linkAccounts.doSubmit validation:', validatedFormData);
        if (validatedFormData.errors && validatedFormData.errors.length > 0) {
          this.showErrors(validatedFormData.errors);
          return;
        }
        modal.loadingIndicator.start();
        var apiData = {
          h: userData.hash,
          t: userData.token,
          target_log: validatedFormData.data.login,
          target_pwd: validatedFormData.data.password
        };

        //API call
        requests.callApi('update/user-link', apiData).then(function (responseData) {
          modal.loadingIndicator.end();
          modal.close();
          notification.show(config.messages.notificationSuccessTitle, responseData.user_success_text);

          // Track the view of the notification.
          helpers.trackAction('aboverknuepfung_complete');
          logger.log('forms.linkAccounts.doSubmit responseData:', responseData);
        })["catch"](function (responseError) {
          modal.loadingIndicator.end();
          var errors = [];
          errors.push(responseError.message);
          forms.linkAccounts.showErrors(errors);
          logger.log('forms.linkAccounts.doSubmit responseError:', responseError);
        });
      },
      /**
       * Show one or more errors below the input fields.
       *
       * @param  {Array} errors Array with one or more error messages.
       * @return {undefined}
       */
      showErrors: function showErrors(errors) {
        logger.log('forms.linkAccounts.showErrors errors:', errors);
        var errorTarget = modal.elements.wrapper().querySelector('.vodl-login__error');
        errorTarget.innerHTML = '';
        errors = errors || [];
        errors.forEach(function (errorMessage) {
          if (errorTarget.innerHTML) {
            errorTarget.append(document.createElement('br'));
          }
          errorTarget.append(document.createTextNode(errorMessage));
        });
      },
      /**
       * Basic validation of the form inputs.
       * Gets the trimmed input of the username and password field.
       * If one of them is empty, the resulting object will contain one or more errors.
       * The validated input is assigned to the data property in the resulting object.
       *
       * @return {Object} Object with the validation result.
       */
      validate: function validate() {
        var login = modal.elements.wrapper().querySelector('.vodl-login__username').value.trim() || false;
        var password = modal.elements.wrapper().querySelector('.vodl-login__password').value.trim() || false;
        var result = {};
        result.data = {};
        result.data.login = login;
        result.data.password = password;
        result.errors = [];
        if (!login) {
          result.errors.push(config.messages.errors.emptyLogin);
        }
        if (!password) {
          result.errors.push(config.messages.errors.emptyPassword);
        }
        return result;
      }
    }
  };

  /**
   * Collection of helper methods.
   *
   * @type {Object}
   */
  var helpers = {
    /**
     * Fetches the configNode of the modal, parses the included JSON
     * and returns the resulting object.
     *
     * @return {Object} The parsed config object.
     */
    fetchFormConfigFromJSON: function fetchFormConfigFromJSON() {
      var defaultConfig = {
        messages: {
          errors: {
            emptyLogin: 'Empty login field.',
            emptyPassword: 'Empty password field.'
          },
          notificationSuccessTitle: 'Success!'
        }
      };
      var configNode = modal.elements.configNode(),
        parsedConfig = {};
      if (!configNode) {
        return defaultConfig;
      }
      try {
        parsedConfig = JSON.parse(configNode.innerHTML) || {};
      } catch (e) {
        return defaultConfig;
      }
      return parsedConfig;
    },
    /**
     * Convert a given HTML string to a DOM element.
     *
     * @param  {string} html The source HTML string.
     * @return {Element}     The resulting DOM element.
     */
    htmlToElement: function htmlToElement(html) {
      var template = document.createElement('template');
      html = html.trim();
      template.innerHTML = html;
      return template.content.firstChild;
    },
    /**
     * Track an action in the workflow (Google Analytics only for now).
     *
     * @param  {string} action The identifier of the action to track.
     * @return {undefined}
     */
    trackAction: function trackAction(action) {
      if (window.dataLayer) {
        var payload = {
          event: 'genericEvent',
          eventCategory: 'checkout',
          eventAction: action,
          eventLabel: window.location.href
        };
        logger.log('helpers.trackAction payload:', payload);
        window.dataLayer.push(payload);
        document.dispatchEvent(new CustomEvent('hansrmdtevent', {
          detail: payload
        }));
      }
    }
  };

  /**
   * Collection of methods for handling the modal window.
   *
   * @type {Object}
   */
  var modal = {
    /**
     * Close the modal dialogue.
     *
     * @return {undefined}
     */
    close: function close() {
      logger.log('modal.close');
      this.elements.wrapper().style.display = 'none';
    },
    // Access to DOM elements of the modal.
    elements: {
      closeButton: function closeButton() {
        return document.querySelector('.vodl-form--link-accounts .vodl-form__close');
      },
      configNode: function configNode() {
        return document.querySelector('.vodl-form--link-accounts script[type="application/json"]');
      },
      loadingSpinner: function loadingSpinner() {
        return document.querySelector('.vodl-form--link-accounts .vodl-form__loading');
      },
      loginWrapper: function loginWrapper() {
        return document.querySelector('.vodl-form--link-accounts .vodl-login__wrapper');
      },
      wrapper: function wrapper() {
        return document.querySelector('.vodl-form--modal');
      }
    },
    loadingIndicator: {
      /**
       * End the loading indicator.
       *
       * @return {undefined}
       */
      end: function end() {
        modal.elements.loadingSpinner().style.display = 'none';
        modal.elements.loginWrapper().style.display = 'block';
      },
      /**
       * Start the loading indicator.
       *
       * @return {undefined}
       */
      start: function start() {
        modal.elements.loadingSpinner().style.display = 'block';
        modal.elements.loginWrapper().style.display = 'none';
      }
    },
    /**
     * Open the modal dialogue.
     *
     * @return {undefined}
     */
    open: function open() {
      logger.log('modal.open');
      this.elements.wrapper().style.display = 'flex';
    }
  };

  /**
   * Collection of methods for handling the notifcation modal.
   *
   * @type {Object}
   */
  var notification = {
    // Access to DOM elements of the notification.
    elements: {
      header: function header() {
        return document.querySelector('.vodl-notification .vodl-notification__header');
      },
      headerText: function headerText() {
        return document.querySelector('.vodl-notification .vodl-notification__header-text');
      },
      text: function text() {
        return document.querySelector('.vodl-notification .vodl-notification__text');
      },
      wrapper: function wrapper() {
        return document.querySelector('.vodl-notification--modal');
      },
      notification: function notification() {
        return document.querySelector('.vodl-notification');
      },
      body: function body() {
        return document.querySelector('.vodl-notification .vodl-notification__body');
      },
      button: function button() {
        return document.querySelector('.vodl-notification .vodl-notification__button');
      }
    },
    /**
     * Shows the notifcation with the given title and message.
     *
     * @param  {string} title   The notifcation title.
     * @param  {string} message The notifcation message.
     * @return {undefined}
     */
    show: function show(title, message) {
      // Make the header red.
      this.elements.notification().classList.add('vodl-notification--vplus');

      // Set notification title and message.
      this.elements.headerText().append(document.createTextNode(title));
      this.elements.text().append(document.createTextNode(message));

      // Assign click event handler for closing the notfication.
      this.elements.wrapper().removeEventListener('click', events.onNotificationClicked);
      this.elements.wrapper().addEventListener('click', events.onNotificationClicked);
      if (!this.elements.button()) {
        var notificationButton = document.createElement('div');
        notificationButton.innerHTML = '<div class="vodl-notification__button"><button class="vodl-button vodl-button--red" type="button"><span class="vodl-button__label">OK</span></button></div>';
        this.elements.body().append(notificationButton);
      }

      // Show the thing.
      this.elements.wrapper().style.display = 'flex';
    }
  };

  /**
   * Collection of methods for handling requests to the REST and form APIs.
   *
   * @type {Object}
   */
  var requests = {
    /**
     * Makes a call on the SSO REST API with the given route and payload.
     *
     * @param  {string} route   The route name, e.g. 'update/user-link'.
     * @param  {Object} payload Optional payload to send with the request.
     * @return {Promise}        A promise that will either be resolved or rejected.
     */
    callApi: function callApi(route, payload) {
      var url = ssoApiBase + route;
      payload = payload || {};
      return axios({
        method: 'post',
        url: url,
        data: payload
      }).then(function (response) {
        return response.data;
      })["catch"](function (error) {
        var message = false;
        logger.log('requests.callApi error.response:', error.response);
        if (error.response && error.response.data) {
          if (error.response.data.data && error.response.data.data.user_error_text) {
            message = error.response.data.data.user_error_text;
          } else if (error.response.data.message) {
            message = error.response.data.message;
          }
          if (message) {
            throw new Error(message);
          } else {
            throw error;
          }
        } else {
          throw error;
        }
      });
    },
    /**
     * Fetches a form via the formApi.
     * Saves the result as entry in formsCache, so
     * subsequent calls do not trigger a request again.
     *
     * @param  {string} id  The name/id of the form, e.g. 'send-otp'.
     * @return {Promise}    A promise that will either be resolved or rejected.
     */
    getForm: function getForm(id) {
      // If we already loaded this, no need to do it again.
      if (formsCache[id]) {
        return Promise.resolve(formsCache[id]);
      }
      return axios.get(formApi, {
        params: {
          f: id
        }
      }).then(function (response) {
        var errorMessage = response.data.error || false;
        if (errorMessage) {
          logger.log('getForm error:', errorMessage);
          throw new Error(errorMessage);
        }

        // Save the response data in formsCache, so we do not need to load it again,
        // should we need it.
        formsCache[id] = response.data;
        return response.data;
      })["catch"](function (error) {
        // handle error
        logger.log('getForm error:', error);
        throw error;
      });
    }
  };
  _init();
})(window, document);
"use strict";

(function (window, document, undefined) {
  "use strict";

  var resetPw,
    registerBtn,
    registerWallBtn,
    fbLogin,
    helpBtn,
    helpCloseBtn,
    rmsso,
    rmPiano,
    fbUser,
    fbAPI = false,
    fbTkn = false;
  var resetPasswordHash = "#reset",
    // will trigger the reset password form
    setPasswordWithTokenHash = "#set-pwd",
    // will trigger the SET password form (after password reminder email)
    triggerLoginFormHash = "#signon",
    // will trigger the login/registration form
    validateAccountHash = "#validate",
    // will trigger the account/email validation
    cmpBannerSelectors = ["#cmpbox", "#cmpbox2", "#onetrust-consent-sdk", "#CybotCookiebotDialog", "#CybotCookiebotDialogBodyUnderlay"];
  /**
   * initialize everything
   */
  function init() {
    var signOnDisabled = $("body.signon-disabled").length > 0;
    if (signOnDisabled) {
      return;
    }
    rmsso = window.RussMedia.SSO;
    rmsso.init();
    rmPiano = window.RussMedia.Piano || false;
    var deepLinkFormTriggered = maybe_trigger_password_reset_form_on_init(); // password reset dialog requested?

    if (!deepLinkFormTriggered) {
      deepLinkFormTriggered = maybe_trigger_validate_email_on_init(); // validate account/email workflow  requested?
    }
    if (!deepLinkFormTriggered) {
      deepLinkFormTriggered = maybe_trigger_set_pwd_with_token_on_init(); // set password with token after email reminder requested?
    }

    // perform a validation of the SSO cookie
    // and then always update the login status in the header
    rmsso.isLoggedInAsync().then(function () {
      // nothing to do here really.
    }, function (result) {
      result = result || {};
      result.additional_data = result.additional_data || {};
      result.additional_data.sso = result.additional_data.sso || {};
      result.additional_data.sso.user_data = result.additional_data.sso.user_data || {};
      result.additional_data.sso.user_data.error = result.additional_data.sso.user_data.error || "0";
      if ("20" === result.additional_data.sso.user_data.error) {
        showNotification(result.additional_data.sso.user_error_text, "SSO_graceTimeExpiredMessage", "Abmeldung");
      } else {
        if (!deepLinkFormTriggered) {
          deepLinkFormTriggered = maybe_trigger_login_form_on_init(); // login/register dialog requested?
        }
      }
    }).always(function () {
      checkLoginStatus();
    });
    assignEventHandlers();
  }

  /**
   * Checks if the current window location contains one of the
   * hashes given in the hashes array.
   *
   * @param  {Array}  hashes Array of hashes to check for.
   * @return {Boolean}       true if one of the given hashes was found, false otherwise.
   */
  function isOneOfTheseHashesPresent(hashes) {
    hashes = hashes || [];
    return hashes.some(function (h) {
      return window.location.hash.includes(h);
    });
  }

  /**
   * Trigger the login/register dialog if requested via the URL hash triggerLoginFormHash
   *
   * @return {Boolean} true if login/register dialog was triggered.
   */
  function maybe_trigger_login_form_on_init() {
    if (!isOneOfTheseHashesPresent([triggerLoginFormHash])) {
      return false;
    }
    if (rmsso.isLoggedIn()) {
      return false;
    }
    window.dispatchEvent(new Event("open_login_form"));
    return true;
  }

  /**
   * Trigger the password reset dialog if requested via the URL hash resetPasswordHash
   *
   * @return {Boolean} true if password reset dialog was triggered.
   */
  function maybe_trigger_password_reset_form_on_init() {
    if (!isOneOfTheseHashesPresent([resetPasswordHash])) {
      return false;
    }
    openModal();
    addLoading();
    var url = "/api/nnp/get_form?f=changepw";
    $.ajax({
      url: url,
      type: "get",
      dataType: "json",
      success: function success(result) {
        changePasswordForm(result);
      },
      error: function error(err) {
        return fail(err);
      }
    });
    return true;
  }

  /**
   * Trigger the password set with token dialog, if user clicked on a link in the reminder email.
   *
   * @return {Boolean} true if password set with token dialog was triggered.
   */
  function maybe_trigger_set_pwd_with_token_on_init() {
    if (!isOneOfTheseHashesPresent([setPasswordWithTokenHash])) {
      return false;
    }
    hideTeePopup();
    rmsso.logout().always(function () {
      window.dispatchEvent(new Event("open_register_without_password_set_pwd_with_token_form"));
    });
    return true;
  }

  /**
   * Trigger the validate account/email workflow if requested via the URL hash validateAccountHash
   *
   * @return {Boolean} true if validate account/email workflow  was triggered.
   */
  function maybe_trigger_validate_email_on_init() {
    if (!isOneOfTheseHashesPresent([validateAccountHash])) {
      return false;
    }
    rmsso.validateEmail(location).then(function (result) {
      if (result.valid) {
        if (rmsso.isLoggedIn()) {
          var message = result.additional_data.sso.user_success_text_logged_in || false;
          if (message) {
            success(message, "SSO_validateEmail", "Account Bestätigung");
          }
        } else {
          var username = result.additional_data.sso.validate_email_result.login;
          openModal();
          addLoading();
          var url = "/api/nnp/get_form?f=simple-login";
          $.ajax({
            url: url,
            type: "get",
            dataType: "json",
            success: function success(result) {
              loginForm(result);
              // append username into form input
              document.querySelector(".vodl-login__username").value = username;
            },
            error: function error(err) {
              return fail(err);
            }
          });
        }
      }
    }, function (message, type, header) {
      showNotification(message, type, header);
    });
    return true;
  }
  function textareaFocus() {
    var form = $(".vodl-login__bottom").find("input");
    form.on("focus", function (event) {
      $(".vodl-form").scrollTop(event.target.offsetTop);
    });
  }

  // updates the login status in the header
  // it does NOT do any deep checks but rather tries to gather the state/data for the header
  function checkLoginStatus() {
    //some selectors we need
    var loggedInNode = $(".vodl-login-label__logout"),
      //elements on page that should be visible when logged in
      loggedOutNode = $(".vodl-login-label__login"),
      //elements on page that should be visible when logged out
      userNameNode = $(".vodl-login-label__username a"); //elements on page holding the username
    //"soft" check on login status via rmsso
    if (rmsso.isLoggedIn()) {
      //try to get the user
      rmsso.getUserAsync().done(function (user) {
        //no user? get outa here. (should not happen when user is logged in, but you never know :)
        if (user === false) {
          return;
        }
        //fill the username in the status fields on the page
        userNameNode.empty();
        userNameNode.append(user.userName);

        //show the logged in elements
        loggedInNode.show();
        //hide the logged out elements
        loggedOutNode.hide();
      });
    } else {
      loggedInNode.hide();
      loggedOutNode.show();
    }
  }

  // event handlers to open modal, etc.
  function assignEventHandlers() {
    $("body").on("click", ".vodl-form--modal", closeModal);

    //assign click events for triggering the logout
    $("body").on("click", ".vodl-login-label__action", function (e) {
      e.preventDefault();
      handleLogoutClick();
    });

    // generic event listener needed for DNI/TEE
    // can be triggered via window.dispatchEvent(new Event('open_login_form'));
    window.addEventListener("open_login_form", function (e) {
      openModal();
      addLoading();
      $(".vodl-navigation__nav-items-wrapper").children().removeClass("show");
      var url = "/api/nnp/get_form?f=login";
      ajax(url);
    });
    window.addEventListener("open_register_form", function (e) {
      openModal();
      addLoading();
      $(".vodl-navigation__nav-items-wrapper").children().removeClass("show");
      var url = "/api/nnp/get_form?f=register";
      ajax(url);
    });
    $("body").on("click", ".vodl-login-label__login", function (e) {
      e.preventDefault();
      openModal();
      addLoading();
      $(".vodl-navigation__nav-items-wrapper").children().removeClass("show");
      var url = "/api/nnp/get_form?f=login";
      ajax(url);
    });
    $("body").on("click", ".vodl-login", function (e) {
      e.preventDefault();
      openModal();
      addLoading();
      var url = "/api/nnp/get_form?f=login";
      changeForm(url);
    });
    $("body").on("click", ".vodl-register", function (e) {
      e.preventDefault();
      openModal();
      addLoading();
      var url = "/api/nnp/get_form?f=register";
      changeForm(url);
    });
    $("body").on("click", ".vodl-form__close", closeModal);
    $("body").on("click", ".vodl-login__mediakey", function () {
      if (window.dataLayer) {
        var payload = {
          event: "genericEvent",
          eventCategory: "MediaKey",
          eventAction: "Click",
          eventLabel: "Button_Click"
        };
        window.dataLayer.push(payload);
      }
      return true;
    });
  }

  // ajax call to get data, different callback function for each form
  function ajax(url) {
    if (url.includes("login")) {
      $.ajax({
        url: url,
        type: "get",
        dataType: "json",
        success: function success(result) {
          return loginForm(result);
        },
        error: function error(err) {
          return fail(err);
        }
      });
    } else if (url.includes("register")) {
      $.ajax({
        url: url,
        type: "get",
        dataType: "json",
        success: function success(result) {
          return registerForm(result);
        },
        error: function error(err) {
          return fail(err);
        }
      });
    } else if (url.includes("connect")) {
      $.ajax({
        url: url,
        type: "get",
        dataType: "json",
        success: function success(result) {
          return connectForm(result);
        },
        error: function error(err) {
          return fail(err);
        }
      });
    } else {
      $.ajax({
        url: url,
        type: "get",
        dataType: "json",
        success: function success(result) {
          return resetForm(result);
        },
        error: function error(err) {
          return fail(err);
        }
      });
    }
  }
  function trackGTM(result) {
    if (typeof dataLayer !== "undefined" && typeof gtm_tracking_enable !== "undefined" && true === gtm_tracking_enable) {
      if ("SSO_registrationOKMessage" == result || "SSO_registrationWithLoginOKMessage" == result) {
        dataLayer.push({
          event: "genericEvent",
          eventCategory: "Registration",
          eventAction: "Complete",
          eventLabel: "Standard"
        });
        dataLayer.push({
          event: "virtualPageview",
          virtualPagePath: "/registration/completed_standard"
        });
      } else if ("SSO_oauthConnectSuccess" == result) {
        dataLayer.push({
          event: "virtualPageview",
          virtualPagePath: "/registration/completed_facebook"
        });
        dataLayer.push({
          event: "genericEvent",
          eventCategory: "Registration",
          eventAction: "Complete",
          eventLabel: "Facebook"
        });
      } else if ("connect_form" == result) {
        dataLayer.push({
          event: "virtualPageview",
          virtualPagePath: "/registration/step2_facebook"
        });
      } else if ("SSO_ssoLoginSuccessMessage" == result) {
        dataLayer.push({
          event: "genericEvent",
          eventCategory: "Registration",
          eventAction: "Login",
          eventLabel: "Standard"
        });
      } else if ("SSO_ssoLoginFb" == result) {
        dataLayer.push({
          event: "genericEvent",
          eventCategory: "Registration",
          eventAction: "Login",
          eventLabel: "Facebook"
        });
      }
      if ("newsletter-standard" == result) {
        dataLayer.push({
          event: "genericEvent",
          eventCategory: "Registration",
          eventAction: "Newsletter",
          eventLabel: "Standard"
        });
      } else if ("newsletter-facebook" == result) {
        dataLayer.push({
          event: "genericEvent",
          eventCategory: "Registration",
          eventAction: "Newsletter",
          eventLabel: "Facebook"
        });
      }
      if ("logout-user" == result) {
        dataLayer.push({
          event: "genericEvent",
          eventCategory: "Registration",
          eventAction: "Logout",
          eventLabel: "Standard"
        });
      }
      if ("signon-help" == result) {
        dataLayer.push({
          event: "genericEvent",
          eventCategory: "Registration",
          eventAction: "FAQ",
          eventNI: true
        });
      }
    }
  }
  var loginSuccess = function loginSuccess(data, type, header) {
    var ssoData = data || {};
    ssoData.userData = ssoData.user_data || {};
    var vplusForm = document.querySelector(".vodl-form--vplus");
    if (vplusForm) {
      var rmFormsVplus = window.RussMedia.Forms.Vplus || {};
      rmFormsVplus.success(ssoData.user_success_text, type, header);
      if (rmPiano) {
        rmPiano.maybeTriggerStartCheckout("login", ssoData.userData);
      }
    } else {
      success(ssoData.user_success_text, type, header);
    }
  };
  var registrationSuccess = function registrationSuccess(data, type, header) {
    var ssoData = data || {};
    ssoData.userData = ssoData.user_data || {};
    var vplusForm = document.querySelector(".vodl-form--vplus");
    if (vplusForm) {
      var rmFormsVplus = window.RussMedia.Forms.Vplus || {};
      rmFormsVplus.success(ssoData.user_success_text, type, header);
      if (rmPiano) {
        rmPiano.maybeTriggerStartCheckout("register", ssoData.userData);
      }
    } else {
      success(ssoData.user_success_text, type, header);
    }
  };
  var resetSuccess = function resetSuccess(message, type, header) {
    var vplusForm = document.querySelector(".vodl-form--vplus");
    if (vplusForm) {
      var rmFormsVplus = window.RussMedia.Forms.Vplus || {};
      rmFormsVplus.success(message, type, header);
    } else {
      success(message, type, header);
    }
  };

  // run after ajax completed successful
  function success(message, type, header) {
    var hashesToRemove = [resetPasswordHash, setPasswordWithTokenHash, triggerLoginFormHash, validateAccountHash];
    $(".vodl-login__wrapper").show();
    hideLoading();
    closeModal();
    showNotification(message, type, header);
    trackGTM(type);
    $(window).trigger("login-status-change", type);
    checkLoginStatus();
    if (type === "SSO_ssoLoginSuccessMessage") {
      window.location.reload();
    }
    setTimeout(function () {
      if (type !== "SSO_registrationOKMessage" && !isOneOfTheseHashesPresent(hashesToRemove)) {
        window.location.reload();
      }
      if (isOneOfTheseHashesPresent(hashesToRemove)) {
        window.location.href = window.location.protocol + "//" + window.location.host;
      }
    }, 6000);
  }

  // run after error from ajax (converts error)
  function fail(e) {
    $(".vodl-login__wrapper").show();
    hideLoading();
    switch (e) {
      case "SSO_ssoUnknownErrorMessage":
        showError("Es ist ein technischer Fehler aufgetreten. Bitte versuche es in wenigen Minuten noch einmal.");
        break;
      case "SSO_validateInputRequired":
        showError("Überprüfe deine Eingaben.");
        break;
      case "SSO_usernameOrMailInputRequired":
        showError("Bitte gib deinen Benutzernamen oder deine E-Mail-Adresse an.");
        break;
      case "SSO_passwordInputRequired":
        showError("Bitte gib dein Passwort an.");
        break;
      case "SSO_registerPasswordInputRequired":
        showError("Bitte wähle ein Passwort mit mind. 6 Zeichen.");
        break;
      case "SSO_usernameInputRequired":
        showError("Bitte gib einen Benutzernamen an.");
        break;
      case "SSO_mailInputRequired":
        showError("Bitte gib deine E-Mail-Adresse an.");
        break;
      case "SSO_validateEmailNotValid":
        showError("Bitte gib eine gültige Email Adresse ein.");
        break;
      case "SSO_ssoLoginAlreadyLoggedInMessage":
        showError("Du bist bereits angemeldet.");
        break;
      case "SSO_validateLoginNotValid":
        showError("Bitte wähle einen Benutzernamen mit mind. 4 Zeichen.");
        break;
      case "SSO_oldPasswordEmptyMessage":
        hideLoading();
        showError("Bitte gib dein aktuelles Passwort ein.");
        break;
      case "SSO_newPasswordEmptyMessage":
        hideLoading();
        showError("Bitte gib ein neues Passwort ein.");
        break;
      case "SSO_newPasswordAgainErrorMessage":
        hideLoading();
        showError("Bitte gib das neue Passwort noch einmal ein.");
        break;
      case "SSO_validatePasswordTooShort":
        hideLoading();
        showError("Bitte wähle ein Passwort mit mind. 6 Zeichen.");
        break;
      default:
        showError(e);
        break;
    }
  }

  // shows error
  function showError(e) {
    var error = $(".vodl-login__error");
    error.empty().append(e);
  }

  // login User
  function login(e) {
    var user = e.currentTarget[0].value,
      pw = e.currentTarget[1].value;
    $(".vodl-login__error").empty();
    var vplusForm = document.querySelector(".vodl-form--vplus");
    if (!vplusForm) {
      addLoading();
    }
    rmsso.login(user, pw, true).then(loginSuccess, fail);
    return false;
  }

  // logout User
  function handleLogoutClick() {
    rmsso.logout().then(function (result) {
      //everything cool, just reload the page
      if (fbAPI) {
        //logout the user from facebook if available
        fbAPI.getLoginStatus(function (response) {
          if (response.status === "connected") {
            fbAPI.logout(function () {
              window.location.reload();
            });
          } else {
            trackGTM("logout-user");
            window.location.reload();
          }
        });
      } else {
        window.location.reload();
      }
    }, function (jqXHR, textStatus, errorThrown) {
      //should always work, shouldn' it? :)
    });
  }

  // Login with FB
  function handleFbClick(e) {
    e.preventDefault();
    addLoading();
    $(".vodl-form__header-text--register").empty().append("Account verbinden");
    $(".vodl-form__header-text--login").text("");

    // A promise to load the facebook SDK if not loaded yet.
    var facebookSDKLoader = new Promise(function (resolve, reject) {
      if (window.FB) {
        resolve(true);
      } else {
        document.addEventListener("rmFacebookLoaded", function () {
          resolve(true);
        });
        var activateEmbedProviderEvent = document.createEvent("CustomEvent");
        activateEmbedProviderEvent.initCustomEvent("vodl_activate_embed_provider", true, true, {
          provider: "facebook"
        });
        document.dispatchEvent(activateEmbedProviderEvent);
      }
    });
    facebookSDKLoader.then(function () {
      fbAPI = window.FB;
      if (fbAPI) {
        fbAPI.login(function (response) {
          if (response.authResponse) {
            if (response.status === "connected") {
              fbTkn = response.authResponse.accessToken;
              rmsso.loginByOAuth(response.authResponse.userID, response.authResponse.accessToken).then(function (message, type, header) {
                //everything cool, just do the callback or reload the page
                if (typeof callback === "function") {
                  //close the modal
                  closeModal();
                  showNotification(message, type, header);

                  //update login status, show user data in navi
                  checkLoginStatus();

                  //and finally do the callback the caller passed us
                  callback();
                } else {
                  //if we are one one of the /sso pages we should not just reload but
                  //go to the main page
                  if (window.location.pathname.indexOf("sso") !== -1) {
                    window.location.href = window.location.protocol + "//" + window.location.host;
                  } else {
                    window.location.reload();
                  }
                }
                trackGTM("SSO_ssoLoginFb");
              }, function (messageIdentifier, details) {
                ajax("/api/nnp/get_form?f=connect");
              });
            } else if (response.status === "not_authorized'") {
              ajax("/api/nnp/get_form?f=connect");
            }
          } else {
            fail(response);
          }
        }, {
          scope: "email"
        });
      } else {
        return;
      }
    });
  }

  // register User
  function register(e) {
    var email = e.target.querySelector(".vodl-login__email").value,
      user = e.target.querySelector(".vodl-login__username").value,
      pw = e.target.querySelector(".vodl-login__password").value,
      agb = Array.from(e.target.querySelectorAll(".vodl-login__agb-input"));
    $(".vodl-login__error").empty();
    var verifiedAGB = agb.map(function (a) {
      return checkAGB(a);
    });
    if (verifiedAGB.every(function (agb) {
      return agb === true;
    })) {
      agb = Array.from(agb).map(function (a) {
        return formatAGB(a);
      });
      var hasSpaceAndSpecialChars = false;
      if (user !== email) {
        var format = /[ !@#$%^&äöüÄÖÜ*()+\-=\[\]{};':"\\|,.<>\/?]/;
        hasSpaceAndSpecialChars = format.test(user);
      }
      if (hasSpaceAndSpecialChars) {
        showError("Der Benutzername darf keine Leerzeichen oder Sonderzeichen beinhalten.");
      } else {
        var registerVar;
        if (user === email) {
          registerVar = rmsso.registerAndValidate(user, email, pw, agb);
        } else {
          registerVar = rmsso.register(user, email, pw, agb);
        }
        var vplusForm = document.querySelector(".vodl-form--vplus");
        if (!vplusForm) {
          addLoading();
        }
        registerVar.then(function (data, type, header) {
          registrationSuccess(data, type, header);
          var newsletter = false;
          var newsagb = agb.map(function (elem) {
            if ("E1" == elem.id && true == elem.checked) {
              newsletter = true;
            }
          });
          if (newsletter) {
            trackGTM("newsletter-standard");
          }
        }, function (result) {
          fail(result);
        });
      }
    } else {
      var errorMessage = agb[verifiedAGB.indexOf(false)].dataset.error;
      fail(errorMessage);
    }
    return false;
  }
  var changeCurrentPassword = function changeCurrentPassword(e) {
    var userData = {
      new_password: e.target.querySelector('.vodl-login__password[name="newPassword"]').value,
      new_password_again: e.target.querySelector('.vodl-login__password[name="newPasswordAgain"]').value,
      h: window.location.hash.split("/?h=").pop()
    };
    $(".vodl-login__error").empty();
    addLoading();
    rmsso.changeCurrentPassword(userData).then(success, fail);
    return false;
  };
  function formatAGB(agb) {
    var data = {
      id: agb.dataset.id,
      checked: agb.checked
    };
    return data;
  }
  function checkAGB(agb) {
    if (agb.dataset.required === "false") {
      return true;
    }
    return agb.checked;
  }

  // reset password
  function reset(e) {
    var user = e.currentTarget[0].value;
    $(".vodl-login__error").empty();
    var vplusForm = document.querySelector(".vodl-form--vplus");
    if (!vplusForm) {
      addLoading();
    }
    rmsso.forgot(user).then(resetSuccess, fail);
    return false;
  }

  /**
   * Event handler for the facebook login status triggered after the Facebook API has loaded.
   * Will try an autologin if the local user is not logged in and the facebook user is connected with our app.
   *
   * @param {Object} response Response object of facebook api getLoginStatus method
   */
  function handleFBLoginStatus(response) {
    fbAPI = window.FB;
    if (rmsso.isLoggedIn()) {
      return;
    }

    //otherwise...
    if (response.status === "connected") {
      fbTkn = response.authResponse.accessToken;

      // 2) user is connected but not logged in locally - try logging in via oauth
      rmsso.loginByOAuth(response.authResponse.userID, response.authResponse.accessToken).then(function () {
        //cool, that worked, now just update the login status on the page and we are done
        checkLoginStatus();
      });
    }
  }

  // add event handlers after modal has loaded
  function modalEventHandler() {
    hideLoading();
    resetPw = $(".vodl-login__reset-pw");
    registerBtn = $(".vodl-login__register");
    registerWallBtn = $(".vodl-login__registerwall");
    fbLogin = $(".vodl-login__fb");
    helpBtn = $("#vodl-login__help-button");
    helpCloseBtn = $(".vodl-form__helptext__close");

    // toggle help text overlay
    helpBtn.on("click", toggleHelp);
    helpCloseBtn.on("click", toggleHelp);
    fbLogin.on("click", handleFbClick);
    resetPw.on("click", changeForm);
    registerBtn.on("click", changeForm);
    registerWallBtn.on("click", changeForm);
    $(".vodl-login__bottom form").on("submit", login);
  }

  // show/hide helptext overlay
  function toggleHelp() {
    var helpText = $(".vodl-form__helptext");
    if (helpText.is(":visible")) {
      helpText.hide();
    } else {
      helpText.show();
      trackGTM("signon-help");
    }
  }

  // get Form from api
  function changeForm(e) {
    var url, type;
    if (e.target) {
      e.preventDefault();
      url = "/api/nnp/get_form?f=";
      type = e.target.closest("div");
      type = $(type).attr("class").split("__");
      url = url + type[1];
    } else {
      url = e;
      type = url.split("?");
    }
    ajax(url);
    $(".vodl-login__wraper").empty();
    addLoading();
  }

  // open Modal
  function openModal() {
    // Kill all possible CMPs that may have opened.
    cmpBannerSelectors.forEach(function (selector) {
      var elem = document.querySelector(selector);
      if (elem) {
        elem.parentNode.removeChild(elem);
      }
    });
    $(".vodl-form--modal").css("display", "flex");
    hideTeePopup();
  }

  // closes Modal
  function closeModal(event) {
    var modal = $(".vodl-form--modal"),
      content = $(".vodl-login__wrapper");
    if (event === undefined) {
      content.remove();
      modal.hide();
    } else if ($(event.target).attr("class") === modal.attr("class")) {
      content.remove();
      modal.hide();
    } else if ($(event.currentTarget).attr("class") === "vodl-form__close") {
      content.remove();
      modal.hide();
    }
  }

  // If data is loaded for register this functions execute
  function registerForm(data) {
    var form = $(".vodl-form");
    form.parent().replaceWith(data);
    openModal();
    textareaFocus();
    hideLoading();
    $(".vodl-login__bottom form").on("submit", register);
  }

  // If data for pw reset is loaded execute this
  function resetForm(data) {
    var form = $(".vodl-form");
    form.parent().replaceWith(data);
    openModal();
    textareaFocus();
    hideLoading();
    $(".vodl-login__bottom form").on("submit", reset);
  }
  var changePasswordForm = function changePasswordForm(data) {
    var form = $(".vodl-form");
    form.parent().replaceWith(data);
    openModal();
    textareaFocus();
    hideLoading();
    $(".vodl-login__bottom form").on("submit", changeCurrentPassword);
  };

  // If data for login is loaded execute this
  function loginForm(data) {
    var form = $(".vodl-form");
    form.parent().replaceWith(data);
    openModal();
    hideLoading();
    textareaFocus();
    modalEventHandler();
  }
  function connectForm(data) {
    var form = $(".vodl-form");
    form.parent().replaceWith(data);
    openModal();
    hideLoading();
    textareaFocus();
    connectHandlers();
    trackGTM("connect_form");
    getFBUserAsync().then(function (response) {
      fbUser = response;
    });
  }
  function connectHandlers() {
    var radio = $("input:radio[name='vodl-login__radio']");
    radio.on("change", changeConnect);
    $(".vodl-login__bottom form").on("submit", checkConnect);
  }
  function changeConnect(e) {
    var submit = $(".vodl-login__submit").find("span");
    if (e.target.value === "login") {
      var pw = $(".vodl-login__password");
      submit.empty().append("Anmelden");
      pw.attr("type", "password");
      pw.attr("placeholder", "Passwort");
    } else {
      var _pw = $(".vodl-login__password");
      _pw.empty();
      submit.empty().append("Registrieren");
      _pw.attr("type", "email");
      _pw.attr("placeholder", "Email");
    }
  }
  function checkConnect(e) {
    var target = $(e.target),
      type = target.find("input[name=vodl-login__radio]:checked").attr("value"),
      agb = Array.from(this.querySelectorAll(".vodl-login__agb-input"));
    var verifiedAGB = agb.map(function (a) {
      return checkAGB(a);
    });
    if (!verifiedAGB.every(function (agb) {
      return agb === true;
    })) {
      var errorMessage = agb[verifiedAGB.indexOf(false)].dataset.error;
      fail(errorMessage);
      return false;
    }
    if (type === "login") {
      handleConnectSubmit(target);
    } else {
      handleRegisterConnectSubmit(target);
    }
    return false;
  }

  /**
   * Handles the connect form submit event. Will call callback after successful connection if that is a function.
   *
   * @param {jQuery} form the modal that requested the connection
   * @param {function} callback callback function after successful login/connection
   */
  function handleConnectSubmit(form) {
    var loginInput = form.find('input[name="username"]'),
      pwdInput = form.find('input[name="password"]'),
      agb = form.find(".vodl-login__agb-input");

    //fields empty? show error and return
    if (!Array.from(agb).every(function (a) {
      return checkAGB(a);
    })) {
      fail("SSO_validateInputRequired");
      return;
    }
    if (fbUser === undefined) {
      fail("Keine Verbindung mit Facebook möglich");
      return;
    }
    agb = Array.from(agb).map(function (a) {
      return formatAGB(a);
    });

    //handle the actual connect/login
    rmsso.connectOAuthId(fbUser.id, loginInput.val(), pwdInput.val(), agb).then(function (message, type, header) {
      addLoading();
      success(message, type, header);
      window.location.reload();
    }, function (message) {
      fail(message);
    }).always(function () {
      hideLoading();
    });
  }

  /**
   * Handles the register-and-connect form submit event. Will call callback after successful registration/connection if that is a function.
   *
   * @param {jQuery} currentModal the modal that requested the registration/connection
   * @param {function} callback callback function after successful registration/connection
   */
  function handleRegisterConnectSubmit(form) {
    var loginInput = form.find('input[name="username"]'),
      emailInput = form.find('input[name="password"]'),
      agb = form.find(".vodl-login__agb-input");

    //basic validation
    //fields empty? show error and return
    if (!Array.from(agb).every(function (a) {
      return checkAGB(a);
    })) {
      fail("SSO_validateInputRequired");
      return;
    }
    if (loginInput.length > 0 && !loginInput.val()) {
      fail("SSO_usernameInputRequired");
      return;
    }
    if (emailInput.length > 0 && !emailInput.val()) {
      fail("SSO_mailInputRequired");
      return;
    }
    agb = Array.from(agb).map(function (a) {
      return formatAGB(a);
    });
    addLoading();

    //validate username
    rmsso.checkUserExistsAsync(loginInput.val()).then(function () {
      var params = {
        oauthid: fbUser.id,
        oauthtoken: fbUser.token,
        username: loginInput.val(),
        mailaddress: emailInput.val(),
        firstname: fbUser.first_name,
        lastname: fbUser.last_name,
        nodoi: 1,
        agb: agb
      };
      rmsso.registerByOAuthId(params).then(function (message, type, header) {
        addLoading();
        success(message, type, header);
        //newsletter for facebook
        var newsletterFB = false;
        var newFBsagb = agb.map(function (elem) {
          if ("E1" == elem.id && true == elem.checked) {
            newsletterFB = true;
          }
        });
        if (newsletterFB) {
          trackGTM("newsletter-facebook");
        }
        window.location.reload();
      }, function (message) {
        fail(message);
      });
    }, function (message) {
      fail(message);
    });
  }

  /**
   * Fetches user details of a currently connected facebook user, returns a promise
   *
   * @returns {@exp;deferred@call;promise}
   */
  function getFBUserAsync() {
    var deferred = $.Deferred(),
      avatarUrlPattern = "https://graph.facebook.com/{id}/picture";
    if (fbUser === null) {
      deferred.resolve(fbUser);
    } else {
      //retrieve the fb user data
      fbAPI.api("/me", {
        fields: "name, email, first_name, last_name, gender"
      }, function (meResponse) {
        if (!meResponse || meResponse.error) {
          deferred.reject(false);
        } else {
          fbUser = {
            id: meResponse.id,
            name: meResponse.name || false,
            email: meResponse.email || false,
            first_name: meResponse.first_name || false,
            last_name: meResponse.last_name || false,
            gender: meResponse.gender || false,
            avatar: avatarUrlPattern.replace("{id}", meResponse.id),
            token: fbTkn || false
          };
          deferred.resolve(fbUser);
        }
      });
    }
    return deferred.promise();
  }

  // Loading Animation
  function addLoading() {
    $(".vodl-login__wrapper").hide();
    $(".vodl-form__loading").css("display", "block");
  }
  function hideLoading() {
    $(".vodl-form__loading").css("display", "none");
  }
  function showNotification(e, type, header) {
    if (type === "SSO_ssoLoginSuccessMessage") {
      hideTeePopup();
      return;
    }
    var notification = $(".vodl-notification").not(".vodl-notification--refresh");
    var hashesToRemove = [resetPasswordHash, setPasswordWithTokenHash, triggerLoginFormHash, validateAccountHash];
    notification.find(".vodl-notification__text").empty().append(e);
    notification.find(".vodl-notification__header-text").empty().append(header);
    if (type === "SSO_ssoLoginAlreadyLoggedInMessage") {
      notification.find(".vodl-notification__text").empty().append("Du bist bereits angemeldet");
      notification.find(".vodl-notification__header-text").empty().append(header);
    }
    if (type !== "SSO_registrationOKMessage" && !isOneOfTheseHashesPresent(hashesToRemove)) {
      $("body").on("click", notification, function () {
        window.location.reload();
      });
    }
    if (isOneOfTheseHashesPresent(hashesToRemove)) {
      $("body").on("click", notification, function () {
        window.location.href = window.location.protocol + "//" + window.location.host;
      });
    }
    notification.closest(".vodl-notification--modal").css("display", "flex");
    if (notification.has(".vodl-notification__header-text").length !== 0) {
      $(".vodl-notification__header").addClass("vodl-notification__header--show");
    }
    hideTeePopup();
  }
  var hideTeePopup = function hideTeePopup() {
    // add event when popup is displayed - to avoid loading the tee popup
    var popup_event = document.createEvent("Event");
    popup_event.initEvent("tee_hide_popup", true, true);
    document.dispatchEvent(popup_event);
  };

  // initialize immediately
  init();
  $(document).ready(function () {
    connectHandlers();
  });
  window.RussMedia = window.RussMedia || {};
  window.RussMedia.SSO = window.RussMedia.SSO || {};
  window.RussMedia.SSO.UI = window.RussMedia.SSO.UI || {};
  window.RussMedia.SSO.UTILS = window.RussMedia.SSO.UTILS || {};
  $.extend(window.RussMedia.SSO.UTILS, {
    register: register,
    login: login,
    fail: fail,
    reset: reset
  });
  $.extend(window.RussMedia.SSO.UI, {
    handleFBLoginStatus: handleFBLoginStatus,
    checkLoginStatus: checkLoginStatus
  });
})(window, document);
"use strict";

(function (window, document, undefined) {
  'use strict';

  var formApi = '/api/nnp/get_form',
    rmUI = window.RussMedia.SSO.UI || {},
    rmUtils = window.RussMedia.SSO.UTILS || {};
  var axios = window.axios;
  var trackGA = function trackGA(data) {
    var trackingData = data || {};
    trackingData.action = trackingData.action || false;
    trackingData.pagePath = trackingData.pagePath || false;
    if (trackingData.action) {
      trackGAEvent(trackingData.action);
    }
    if (trackingData.pagePath) {
      trackGAPageview(trackingData.pagePath);
    }
  };
  var trackGAEvent = function trackGAEvent(action) {
    var eventData = {
      event: 'genericEvent',
      eventCategory: 'checkout',
      eventAction: action,
      eventLabel: window.location.href
    };
    dataLayer.push(eventData);
    document.dispatchEvent(new CustomEvent('hansrmdtevent', {
      detail: eventData
    }));
  };
  var trackGAPageview = function trackGAPageview(pagePath) {
    var eventData = {
      event: 'virtualPageview',
      virtualPagePath: pagePath
    };
    dataLayer.push(eventData);
    document.dispatchEvent(new CustomEvent('hansrmdtevent', {
      detail: eventData
    }));
  };
  var hideTeePopup = function hideTeePopup() {
    // add event when popup is displayed - to avoid loading the tee popup
    var popup_event = document.createEvent('Event');
    popup_event.initEvent('tee_hide_popup', true, true);
    document.dispatchEvent(popup_event);
  };
  var success = function success(message, type, header) {
    $('.vodl-login__wrapper').show();
    closeModal();
    showNotification(message, type, header);
    $(window).trigger('login-status-change', type);
    if (rmUI) {
      rmUI.checkLoginStatus();
    }
    if ('SSO_registrationWithLoginOKMessage' === type) {
      trackGA({
        action: 'registration_complete',
        pagePath: 'vplus/checkout/registration_complete'
      });
    } else if ('SSO_ssoLoginSuccessMessage' === type) {
      trackGA({
        action: 'login_complete',
        pagePath: 'vplus/checkout/login_complete'
      });
    }
  };
  var closeModal = function closeModal(event) {
    var modal = $('.vodl-form--modal'),
      content = $('.vodl-login__wrapper');
    if (event === undefined) {
      content.remove();
      modal.hide();
    } else if ($(event.target).attr('class') === modal.attr('class')) {
      content.remove();
      modal.hide();
    } else if ($(event.currentTarget).attr('class') === 'vodl-form__close') {
      content.remove();
      modal.hide();
    }
  };
  var showNotification = function showNotification(e, type, header) {
    if ('SSO_ssoLoginSuccessMessage' === type) {
      hideTeePopup();
      return;
    }
    var notification = $('.vodl-notification').not('.vodl-notification--refresh');
    var notificationButton = notification.find('.vodl-notification__button');
    notification.find('.vodl-notification__header-text').empty().append(header);
    notification.find('.vodl-notification__text').empty().append(e);
    if (type === 'SSO_ssoLoginAlreadyLoggedInMessage') {
      notification.find('.vodl-notification__text').empty().append('Du bist bereits angemeldet');
      notification.find('.vodl-notification__header-text').empty().append(header);
    }
    if ('SSO_registrationOKMessage' !== type && 'SSO_resetPassword' !== type) {
      $('body').on('click', notification, function () {
        window.location.reload();
      });
    }
    notification.addClass('vodl-notification--vplus');
    if (0 === notificationButton.length) {
      notification.find('.vodl-notification__body').append('<div class="vodl-notification__button"><button class="vodl-button vodl-button--red" type="button"><span class="vodl-button__label">OK</span></button></div>');
    }
    notification.find('.vodl-button').on('click', function () {
      notification.closest('.vodl-notification--modal').css('display', 'none');
      if ('SSO_resetPassword' !== type) {
        window.location.reload();
      }
    });
    if ('SSO_registrationWithLoginOKMessage' === type) {
      notification.find('.vodl-notification__text').empty();
      return;
    }
    hideTeePopup();
    notification.closest('.vodl-notification--modal').css('display', 'flex');
    if (notification.has('.vodl-notification__header-text').length !== 0) {
      $('.vodl-notification__header').addClass('vodl-notification__header--show');
    }
  };
  var fillUsername = function fillUsername() {
    var form = document.querySelector('.vodl-form--vplus');
    if (form) {
      var emailInput = form.querySelector('.vodl-login__email'),
        loginInput = form.querySelector('.vodl-login__username');
      if (loginInput && emailInput) {
        loginInput.value = emailInput.value;
      }
    }
  };
  var toggleAgb = function toggleAgb() {
    var agbLabel = document.querySelector('.vodl-login__agb-label');
    if (agbLabel) {
      if (agbLabel.classList.contains('toggle')) {
        agbLabel.classList.remove('toggle');
      } else {
        agbLabel.classList.add('toggle');
      }
    }
  };
  var htmlToElement = function htmlToElement(html) {
    var template = document.createElement('template');
    html = html.trim();
    template.innerHTML = html;
    return template.content.firstChild;
  };
  var openModal = function openModal() {
    hideTeePopup();
    var modal = document.querySelector('.vodl-form--modal');
    if (modal) {
      modal.style.display = 'flex';
    }
  };
  var onLoginSubmit = function onLoginSubmit(e) {
    e.preventDefault();
    if (rmUtils) {
      rmUtils.login(e);
    }
  };
  var onRegistrationSubmit = function onRegistrationSubmit(e) {
    e.preventDefault();
    if (rmUtils) {
      rmUtils.register(e);
    }
  };
  var onResetSubmit = function onResetSubmit(e) {
    e.preventDefault();
    if (rmUtils) {
      rmUtils.reset(e);
    }
  };
  var doFormApiCall = function doFormApiCall(id) {
    return axios.get(formApi, {
      params: {
        f: id
      }
    }).then(function (response) {
      var errorMessage = response.data.error || false;
      if (errorMessage) {
        throw new Error(errorMessage);
      }
      return response.data;
    })["catch"](function (error) {
      throw error;
    });
  };
  var getForm = function getForm(id) {
    doFormApiCall(id).then(function (data) {
      var form = document.querySelector('.vodl-form');
      form.parentElement.replaceWith(htmlToElement(data));
      var modal = document.querySelector('.vodl-form--modal');
      var toggleArrow = modal.querySelector('.vodl-login__agb-arrow');
      if (toggleArrow) {
        toggleArrow.addEventListener('click', toggleAgb);
      }
      if (id.includes('register')) {
        var email = modal.querySelector('.vodl-login__email');
        if (email) {
          email.addEventListener('change', fillUsername);
        }
      }
      openModal();

      // Attach events for the form itself
      var theForm = modal.querySelector('form');
      if (id.includes('login')) {
        trackGA({
          action: 'login_form',
          pagePath: 'vplus/checkout/login_form'
        });
        theForm.addEventListener('submit', onLoginSubmit);
      } else if (id.includes('register')) {
        trackGA({
          action: 'registration_form',
          pagePath: 'vplus/checkout/registration_form'
        });
        theForm.addEventListener('submit', onRegistrationSubmit);
      } else if (id.includes('reset')) {
        theForm.addEventListener('submit', onResetSubmit);
      }
    })["catch"](function (error) {
      if (rmUtils) {
        rmUtils.fail(error);
      } else {
        console.log(error);
      }
    });
  };
  var init = function init() {
    window.addEventListener('open_register_vplus_form', function (e) {
      e.preventDefault();
      getForm('register-vplus');
    });
    window.addEventListener('open_simple_login_vplus_form', function (e) {
      e.preventDefault();
      getForm('simple-login-vplus');
    });
    window.addEventListener('open_simple_login_abo_form', function (e) {
      e.preventDefault();
      getForm('simple-login-abo');
    });
    $('body').on('click', '.vodl-login-vplus', function (e) {
      e.preventDefault();
      trackGA({
        action: 'registration_to_login_form',
        pagePath: 'vplus/checkout/registration_to_login_form'
      });
      getForm('simple-login-vplus');
    });
    $('body').on('click', '.vodl-register-vplus', function (e) {
      e.preventDefault();
      trackGA({
        action: 'login_to_registration_form',
        pagePath: 'vplus/checkout/login_to_registration_form'
      });
      getForm('register-vplus');
    });
    $('body').on('click', '.vodl-login__reset-pw-vplus', function (e) {
      e.preventDefault();
      getForm('reset-vplus');
    });
    window.addEventListener('open_reset_pw_vplus_form', function (e) {
      e.preventDefault();
      getForm('reset-vplus');
    });
  };
  init();
  window.RussMedia.Forms = window.RussMedia.Forms || {};
  window.RussMedia.Forms.Vplus = window.RussMedia.Forms.Vplus || {};
  $.extend(window.RussMedia.Forms.Vplus, {
    success: success
  });
})(window, document);
"use strict";

(function (window, document, undefined) {
  'use strict';

  var axios = window.axios,
    Promise = window.Promise,
    rmPiano = window.RussMedia.Piano,
    rmSSO = window.RussMedia.SSO,
    rmUI = window.RussMedia.SSO.UI;
  var tokenHash = '#set-pwd/';

  // Create a logger instance with 📜 prefix.
  var logger = {};
  try {
    logger = new window.RussMedia.Utils.Logger(String.fromCodePoint(0x1F4DC));
  } catch (e) {
    logger = {
      log: function log() {}
    };
  }

  /**
   * Initialize and attach event handlers.
   *
   * @return {undefined}
   */
  var _init = function _init() {
    // The event 'open_register_without_password_form' will trigger the whole process from start.
    window.addEventListener('open_register_without_password_form', events.onStartRegisterFlow);

    // The event 'open_register_without_password_set_pwd_form' will trigger the step for setting the password AFTER checkout.
    window.addEventListener('open_register_without_password_set_pwd_form', events.onRequestPasswordSetAfterCheckoutComplete);

    // The event 'open_register_without_password_set_pwd_with_token_form' will trigger the step for setting the password
    // when users clicked the link provided in a password reminder email.
    window.addEventListener('open_register_without_password_set_pwd_with_token_form', events.onRequestPasswordSetWithToken);

    // Login status event handler for triggering the password reminder, if requested.
    window.addEventListener('vodl_login_status_event', events.onLoginStatusResolved);
  };

  /**
   * A very basic state handler.
   *
   * @type {Object}
   */
  var state = {
    /**
     * A dummy Element we abuse as proxy for our state event handlers.
     *
     * @type {Element}
     */
    _proxy: document.createElement('proxy'),
    data: {
      error: '',
      login: {
        email: '',
        password: '',
        terms: {
          E1: false,
          agb_vol: true
        }
      },
      notification: {
        title: '',
        message: '',
        button: ''
      },
      sso: {
        didRegister: false,
        loginOrRegisterResult: {},
        userData: {}
      },
      step: ''
    },
    /**
     * Get a value from state identified by path.
     *
     * @param  {String}                       path The path to the state element, e.g. login.email.
     *
     * @return {String|Number|Boolean|Object}      The retrieved value.
     */
    get: function get(path) {
      var keyPath = path.split('.'),
        res = this.data,
        i = 0,
        len = keyPath.length;
      try {
        for (; i < len; i++) {
          res = res[keyPath[i]];
        }
      } catch (e) {
        return null;
      }
      return res;
    },
    /**
     * Set a state value identified by path.
     *
     * @param {String}                       path  The path to the state element, e.g. login.email.
     * @param {String|Number|Boolean|Object} value The value to set.
     */
    set: function set(path, value) {
      var keyPath = path.split('.'),
        res = this.data,
        i = 0,
        len = keyPath.length - 1;
      for (; i < len; i++) {
        res = res[keyPath[i]];
      }
      var oldValue = res[keyPath[i]];
      if (oldValue !== value) {
        res[keyPath[i]] = value;
        // Trigger a custom stateChange event so components may react to it.
        this.trigger('stateChange', {
          path: path,
          oldValue: oldValue,
          value: value
        });
      }
    },
    /**
     * Remove an event handler from state with the given name.
     *
     * @param {String}   eventName The name of the event, e.g. 'stateChange'
     * @param {Function} callback  The callback to remove.
     */
    off: function off(eventName, callback) {
      this._proxy.removeEventListener(eventName, callback);
    },
    /**
     * Add an event handler to state with the given name.
     *
     * @param {String}   eventName The name of the event, e.g. 'stateChange'
     * @param {Function} callback  The callback to add.
     */
    on: function on(eventName, callback) {
      this._proxy.addEventListener(eventName, callback);
    },
    /**
     * Trigger a state event with the given eventName and a given obj as payload.
     *
     * @param {String} eventName The name of the event, e.g. 'stateChange'
     * @param {Object} obj       The event payload.
     */
    trigger: function trigger(eventName, obj) {
      this._proxy.dispatchEvent(new CustomEvent(eventName, {
        detail: obj
      }));
    }
  };

  /**
   * A collection of event handlers.
   *
   * @type {Object}
   */
  var events = {
    /**
     * Event handler for clicks on "choose a different email".
     *
     * @param {Event} e The event object.
     */
    onChooseDifferentEmailClicked: function onChooseDifferentEmailClicked(e) {
      e.preventDefault();
      helpers.trackGA({
        action: 'login_to_registration_form',
        pagePath: 'vplus/checkout/login_to_registration_form'
      });

      // Clear everything to start over.
      state.set('error', '');
      state.set('login.email', '');
      state.set('login.password', '');
      state.set('login.terms', {
        'E1': false,
        'agb_vol': true
      });
      state.set('sso.loginOrRegisterResult', {});
      state.set('sso.userData', {});
      state.set('step', 'showRegisterForm');
      return false;
    },
    /**
     * Event handler for clicks on "forgot password".
     *
     * @param {Event} e The event object.
     */
    onForgotPasswordClicked: function onForgotPasswordClicked(e) {
      e.preventDefault();

      // Clear everything to exit and start the forgot password workflow.
      state.set('error', '');
      state.set('login.email', '');
      state.set('login.password', '');
      state.set('sso.loginOrRegisterResult', {});
      state.set('sso.userData', {});
      state.set('step', 'forgotPassword');
      return false;
    },
    /**
     * Event handler for form input changes.
     *
     * @param {Event} e The event object.
     */
    onInputChange: function onInputChange(e) {
      var currentInput = e.currentTarget || false;
      if (currentInput && currentInput.dataset.state) {
        switch (currentInput.type) {
          case 'checkbox':
          case 'radio':
            logger.log('events.onInputChange: ', currentInput.dataset.state, currentInput.checked);
            state.set(currentInput.dataset.state, currentInput.checked);
            break;
          default:
            var sanitizedValue = helpers.sanitizeFieldValue(currentInput);
            if (sanitizedValue !== currentInput.value) {
              currentInput.value = sanitizedValue;
            }
            logger.log('events.onInputChange: ', currentInput.dataset.state, sanitizedValue);
            state.set(currentInput.dataset.state, sanitizedValue);
            break;
        }
      }
    },
    /**
     * Handler for "vodl_login_status_event" events.
     * Will trigger the password reminder workflow if requested.
     *
     * @param {Event} e
     */
    onLoginStatusResolved: function onLoginStatusResolved(e) {
      var userData = e.detail || {};
      logger.log('events.onLoginStatusResolved', userData);

      // Do not start the process if we already come here via an email reminder link.
      if (document.location.hash.startsWith(tokenHash)) {
        return;
      }

      // Something to do here?
      if (!userData.password_reminder || !userData.hash || !userData.token) {
        return;
      }

      // Default case.
      if ('default' === userData.password_reminder.mode) {
        state.set('sso.userData', userData);
        registerFlow._initReminder();
      }

      // Reminder was triggered during a page reload caused by the piano payment.
      // We need to wait_for_checkout_complete and rebuild the state as it is expected
      // by the set-password-form after checkout.
      if ('wait_for_checkout_complete' === userData.password_reminder.mode) {
        var fauxLoginOrRegisterResult = {};
        fauxLoginOrRegisterResult.hash = userData.hash;
        fauxLoginOrRegisterResult.token = userData.token;
        state.set('sso.userData', userData);
        state.set('sso.loginOrRegisterResult', fauxLoginOrRegisterResult);
        window.tp = window.tp || [];
        window.tp.push(['setCustomVariable', 'didRegistrationWithoutPassword', true]);
        registerFlow._initWaitForCheckoutComplete();
      }
      return;
    },
    /**
     * Handle the login form submission event.
     *
     * @param  {Event}   e The event object.
     */
    onLoginSubmitted: function onLoginSubmitted(e) {
      e.preventDefault();
      state.set('step', 'submitLoginForm');
      return false;
    },
    /**
     * Handle the close button click in the modal.
     */
    onModalCloseButtonClicked: function onModalCloseButtonClicked() {
      var lastStep = state.get('step');
      logger.log('onModalCloseButtonClicked, lastStep: ', lastStep);
      modal.close();

      // Remove all possible hashes if showSetPasswordWithTokenForm was the last step.
      if ('showSetPasswordWithTokenForm' === lastStep) {
        window.location.href = window.location.protocol + '//' + window.location.host;
        return false;
      }
    },
    /**
     * Handle the "outside" click of the modal.
     *
     * @param  {Event} e The event object.
     * @return {undefined}
     */
    onModalWrapperClicked: function onModalWrapperClicked(e) {
      // We only accept clicks outside the actual form, so...
      if (e.target === e.currentTarget) {
        var lastStep = state.get('step');
        logger.log('onModalWrapperClicked, lastStep: ', lastStep);
        modal.close();

        // Remove all possible hashes if showSetPasswordWithTokenForm was the last step.
        if ('showSetPasswordWithTokenForm' === lastStep) {
          window.location.href = window.location.protocol + '//' + window.location.host;
          return false;
        }
      }
    },
    /**
     * Handle any click on the notfication modal.
     */
    onNotificationClicked: function onNotificationClicked() {
      var lastStep = state.get('step');
      logger.log('onNotificationClicked, lastStep: ', lastStep);

      // Remove all possible hashes if setPasswordWithTokenComplete was the last step.
      if ('setPasswordWithTokenComplete' === lastStep) {
        window.location.href = window.location.protocol + '//' + window.location.host;
        return false;
      }
      window.location.reload();
    },
    /**
     * Handle the password reminder form submission event.
     *
     * @param  {Event}   e The event object.
     */
    onPasswordReminderSubmitted: function onPasswordReminderSubmitted(e) {
      e.preventDefault();
      state.set('step', 'submitPasswordReminderForm');
      return false;
    },
    /**
     * Handles clicks on the toggle arrow of the password reminder form,
     * which will expand or minimize the "terms and conditons" section.
     *
     */
    onPasswordReminderToggleArrowClicked: function onPasswordReminderToggleArrowClicked() {
      var termsLabel = forms.passwordReminder.elements.termsLabel();
      if (termsLabel) {
        if (termsLabel.classList.contains('toggle')) {
          termsLabel.classList.remove('toggle');
        } else {
          termsLabel.classList.add('toggle');
        }
      }
    },
    /**
     * Handle the register form submission event.
     *
     * @param  {Event}   e The event object.
     */
    onRegisterSubmitted: function onRegisterSubmitted(e) {
      e.preventDefault();
      state.set('step', 'submitRegisterForm');
      return false;
    },
    /**
     * Handle the "open_register_without_password_set_pwd_form" event.
     */
    onRequestPasswordSetAfterCheckoutComplete: function onRequestPasswordSetAfterCheckoutComplete(e) {
      var lastStep = state.get('step');
      logger.log('onRequestPasswordSetAfterCheckoutComplete - lastStep:', lastStep, 'event e: ', e);
      // Get outa here if we did not finish registration in the last step.
      if ('afterRegisterComplete' !== lastStep) {
        window.location.reload();
      }
      if (e && e.detail && e.detail.termsCompleted) {
        state.set('login.terms', {
          'E1': true,
          'agb_vol': true
        });
      } else {
        state.set('login.terms', {});
      }
      state.set('step', 'showSetPasswordAfterCheckoutForm');
    },
    /**
     * Handle the set password after checkout form submission event.
     *
     * @param  {Event}   e The event object.
     */
    onSetPasswordAfterCheckoutSubmitted: function onSetPasswordAfterCheckoutSubmitted(e) {
      e.preventDefault();
      state.set('step', 'submitSetPasswordAfterCheckoutForm');
      return false;
    },
    /**
     * Handles clicks on the toggle arrow of the set password after checkout form,
     * which will expand or minimize the "terms and conditons" section.
     *
     */
    onSetPasswordAfterCheckoutToggleArrowClicked: function onSetPasswordAfterCheckoutToggleArrowClicked() {
      var termsLabel = forms.setPasswordAfterCheckout.elements.termsLabel();
      if (termsLabel) {
        if (termsLabel.classList.contains('toggle')) {
          termsLabel.classList.remove('toggle');
        } else {
          termsLabel.classList.add('toggle');
        }
      }
    },
    /**
     * Handle the "open_register_without_password_set_pwd_with_token_form" event.
     *
     */
    onRequestPasswordSetWithToken: function onRequestPasswordSetWithToken() {
      logger.log('Password setting requested via email reminder');
      registerFlow._initSetPasswordWithToken();
    },
    /**
     * Handle the set password with token form submission event.
     *
     * @param  {Event}   e The event object.
     */
    onSetPasswordWithTokenSubmitted: function onSetPasswordWithTokenSubmitted(e) {
      e.preventDefault();
      state.set('step', 'submitSetPasswordWithTokenForm');
      return false;
    },
    /**
     * Handles clicks on the toggle arrow of the set password with token form,
     * which will expand or minimize the "terms and conditons" section.
     *
     */
    onSetPasswordWithTokenToggleArrowClicked: function onSetPasswordWithTokenToggleArrowClicked() {
      var termsLabel = forms.setPasswordWithToken.elements.termsLabel();
      if (termsLabel) {
        if (termsLabel.classList.contains('toggle')) {
          termsLabel.classList.remove('toggle');
        } else {
          termsLabel.classList.add('toggle');
        }
      }
    },
    /**
     * Handle the "open_register_without_password_form" event.
     */
    onStartRegisterFlow: function onStartRegisterFlow() {
      registerFlow._init();
    },
    /**
     * Handles general state change events and passes the data on to the form state handlers.
     *
     * @param {Event} e The event object.
     */
    onStateChange: function onStateChange(e) {
      var data = e.detail || {};
      data.path = data.path || false;
      if ('step' !== data.path) {
        forms.login.onStateChange(data);
        forms.passwordReminder.onStateChange(data);
        forms.register.onStateChange(data);
        forms.setPasswordAfterCheckout.onStateChange(data);
        forms.setPasswordWithToken.onStateChange(data);
      }
    },
    /**
     * Handles state changes of the (workflow-) step property.
     *
     * @param {Event} e The event object.
     */
    onStepChange: function onStepChange(e) {
      var data = e.detail || {};
      data.path = data.path || false;
      if ('step' === data.path) {
        if (registerFlow.steps[data.value]) {
          logger.log('now calling registerFlow.steps.' + data.value);
          registerFlow.steps[data.value]();
        } else {
          logger.log('nothing to do for step ', data.value);
        }
      }
    }
  };

  /**
   * A collection of form objects.
   *  - login: The login form for existing users.
   *  - register: The register form.
   *  - passwordReminder: The password reminder form for new users that are still logged in but have not set a password yet.
   *  - setPasswordAfterCheckout: Form for setting a password immediately after checkout.
   *
   * @type {Object}
   */
  var forms = {
    /**
     * The form used for the login step.
     * We show the user a form with a disabled email and a password input.
     *
     * @type {Object}
     */
    login: {
      /**
       * Initialize the login form.
       *
       * @return {Promise} A promise that will be resolved on success.
       */
      _init: function _init() {
        return new Promise(function (resolve, reject) {
          var _this = forms.login;
          if (_this.elements.configNode() && _this.elements.form()) {
            // Make sure the thing is open.
            modal.open();
            resolve('login form already initialized');
            return;
          }

          // Retrieve the form via the form API.
          requests.getForm('register-vplus-nopwd-login').then(function (data) {
            // Inject the fetched html into the page.
            var formContent = document.querySelector('.vodl-form');
            formContent.parentElement.replaceWith(helpers.htmlToElement(data));

            // Fetch the forms configuration.
            _this.config = helpers.parseFormConfig(_this.elements.configNode());
            logger.log('forms.login._init config:', _this.config);

            // Prefill data from state and bind to state changes.
            _this.initFromState();

            // Attach events for the form itself:
            // - submiting the form
            // - clicking the forgot password link
            // - choosing a different email
            _this.elements.form().removeEventListener('submit', events.onLoginSubmitted);
            _this.elements.form().addEventListener('submit', events.onLoginSubmitted);
            _this.elements.forgotPassword().removeEventListener('click', events.onForgotPasswordClicked);
            _this.elements.forgotPassword().addEventListener('click', events.onForgotPasswordClicked);
            _this.elements.chooseDifferentEmail().removeEventListener('click', events.onChooseDifferentEmailClicked);
            _this.elements.chooseDifferentEmail().addEventListener('click', events.onChooseDifferentEmailClicked);

            // Attach events for closing the modal
            modal.elements.wrapper().addEventListener('click', events.onModalWrapperClicked);
            modal.elements.closeButton().addEventListener('click', events.onModalCloseButtonClicked);

            // Open the thing.
            modal.open();
            resolve('login form initialized');
          })["catch"](function (error) {
            logger.log('requests.getForm("register-vplus-nopwd-login") failed: ', error);
            reject(error);
          });
        });
      },
      // Access to DOM elements of the form.
      elements: {
        configNode: function configNode() {
          return document.querySelector('.vodl-form--register-nopwd-login script[type="application/json"]');
        },
        form: function form() {
          return document.querySelector('.vodl-form--register-nopwd-login form');
        },
        forgotPassword: function forgotPassword() {
          return document.querySelector('.vodl-form--register-nopwd-login .vodl-login__reset-pw-vplus');
        },
        chooseDifferentEmail: function chooseDifferentEmail() {
          return document.querySelector('.vodl-form--register-nopwd-login .vodl-login__label');
        }
      },
      /**
       * Prefill form data from state
       * and bind state changes to the form elements.
       *
       */
      initFromState: function initFromState() {
        var _this = forms.login;
        var statefulElements = _this.elements.form().querySelectorAll('[data-state]');
        statefulElements.forEach(function (elem) {
          helpers.setTextOrValue(elem, state.get(elem.dataset.state));
          elem.addEventListener('change', events.onInputChange);
        });
      },
      /**
       * The event handler for state changes.
       *
       * @param {Object} data An object containing information about the changed state value.
       */
      onStateChange: function onStateChange(data) {
        var _this = forms.login;
        if (!_this.elements.form()) {
          return;
        }
        var statefulElements = _this.elements.form().querySelectorAll('[data-state="' + data.path + '"]');
        logger.log('forms.login.onStateChange:', data, statefulElements);
        statefulElements.forEach(function (elem) {
          helpers.setTextOrValue(elem, data.value);
        });
      },
      /**
       * Basic validation of the form inputs.
       * Gets the trimmed input of the username and password field.
       * If one of them is empty, the resulting object will contain one or more errors.
       * The validated input is assigned to the data property in the resulting object.
       *
       * @return {Object} Object with the validation result.
       */
      validate: function validate() {
        var _this = forms.login;
        var password = state.get('login.password') || false;
        var result = {};
        result.data = {};
        result.data.password = password;
        result.errors = [];
        if (!password) {
          result.errors.push(_this.config.messages.errors.emptyPassword);
        }
        return result;
      }
    },
    /**
     * The form used for the register step.
     * We show the user a form just with email input.
     * If the email does not exist, a new user with a random password is created.
     * If the email does exist, the user will be redirected to a login form instead.
     *
     * @type {Object}
     */
    register: {
      /**
       * Initialize the register form.
       *
       * @return {Promise} A promise that will be resolved on success.
       */
      _init: function _init() {
        return new Promise(function (resolve, reject) {
          var _this = forms.register;
          if (_this.elements.configNode() && _this.elements.form()) {
            // Make sure the thing is open.
            modal.open();
            resolve('register form already initialized');
            return;
          }

          // Retrieve the form via the form API.
          requests.getForm('register-vplus-nopwd').then(function (data) {
            // Inject the fetched html into the page.
            var formContent = document.querySelector('.vodl-form');
            formContent.parentElement.replaceWith(helpers.htmlToElement(data));

            // Fetch the forms configuration.
            _this.config = helpers.parseFormConfig(_this.elements.configNode());
            logger.log('forms.register._init config:', _this.config);

            // Prefill data from state and bind to state changes.
            _this.initFromState();

            // Attach events for the form itself:
            // - submiting the form
            _this.elements.form().removeEventListener('submit', events.onRegisterSubmitted);
            _this.elements.form().addEventListener('submit', events.onRegisterSubmitted);

            // Attach events for closing the modal
            modal.elements.wrapper().addEventListener('click', events.onModalWrapperClicked);
            modal.elements.closeButton().addEventListener('click', events.onModalCloseButtonClicked);

            // Open the thing.
            modal.open();
            resolve('register form initialized');
          })["catch"](function (error) {
            logger.log('requests.getForm("register-vplus-nopwd") failed: ', error);
            reject(error);
          });
        });
      },
      // Access to DOM elements of the form.
      elements: {
        configNode: function configNode() {
          return document.querySelector('.vodl-form--register-nopwd script[type="application/json"]');
        },
        form: function form() {
          return document.querySelector('.vodl-form--register-nopwd form');
        }
      },
      /**
       * Prefill form data from state
       * and bind state changes to the form elements.
       *
       */
      initFromState: function initFromState() {
        var _this = forms.register;
        var statefulElements = _this.elements.form().querySelectorAll('[data-state]');
        statefulElements.forEach(function (elem) {
          helpers.setTextOrValue(elem, state.get(elem.dataset.state));
          elem.addEventListener('change', events.onInputChange);
        });
      },
      /**
       * The event handler for state changes.
       *
       * @param {Object} data An object containing information about the changed state value.
       */
      onStateChange: function onStateChange(data) {
        var _this = forms.register;
        if (!_this.elements.form()) {
          return;
        }
        var statefulElements = _this.elements.form().querySelectorAll('[data-state="' + data.path + '"]');
        logger.log('forms.register.onStateChange:', data, statefulElements);
        statefulElements.forEach(function (elem) {
          helpers.setTextOrValue(elem, data.value);
        });
      },
      /**
       * Basic validation of the form inputs.
       * Gets the trimmed input of the username and password field.
       * If one of them is empty, the resulting object will contain one or more errors.
       * The validated input is assigned to the data property in the resulting object.
       *
       * @return {Object} Object with the validation result.
       */
      validate: function validate() {
        var _this = forms.register;
        var email = state.get('login.email') || false;
        var result = {};
        result.data = {};
        result.data.email = email;
        result.errors = [];
        var emailRegex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
        if (!email || !emailRegex.test(email)) {
          result.errors.push(_this.config.messages.errors.invalidEmail);
        }
        return result;
      }
    },
    /**
     * The form used for password reminder step.
     * We show the user a form just with new_password and new_password_again input.
     *
     * @type {Object}
     */
    passwordReminder: {
      /**
       * Initialize the passwordReminder form.
       *
       * @return {Promise} A promise that will be resolved on success.
       */
      _init: function _init() {
        return new Promise(function (resolve, reject) {
          var _this = forms.passwordReminder;
          if (_this.elements.configNode() && _this.elements.form()) {
            // Make sure the thing is open.
            modal.open();
            resolve('passwordReminder form already initialized');
            return;
          }

          // Retrieve the form via the form API.
          requests.getForm('register-vplus-nopwd-password-reminder').then(function (data) {
            // Inject the fetched html into the page.
            var formContent = document.querySelector('.vodl-form');
            formContent.parentElement.replaceWith(helpers.htmlToElement(data));

            // Fetch the forms configuration.
            _this.config = helpers.parseFormConfig(_this.elements.configNode());
            logger.log('forms.passwordReminder._init config:', _this.config);

            // Prefill data from state and bind to state changes.
            _this.initFromState();

            // Attach events for the form itself:
            // - submiting the form
            _this.elements.form().removeEventListener('submit', events.onPasswordReminderSubmitted);
            _this.elements.form().addEventListener('submit', events.onPasswordReminderSubmitted);
            _this.elements.toggleArrow().removeEventListener('click', events.onPasswordReminderToggleArrowClicked);
            _this.elements.toggleArrow().addEventListener('click', events.onPasswordReminderToggleArrowClicked);

            // Attach events for closing the modal
            modal.elements.wrapper().addEventListener('click', events.onModalWrapperClicked);
            modal.elements.closeButton().addEventListener('click', events.onModalCloseButtonClicked);

            // Open the thing.
            modal.open();
            resolve('passwordReminder form initialized');
          })["catch"](function (error) {
            logger.log('requests.getForm("register-vplus-nopwd-password-reminder") failed: ', error);
            reject(error);
          });
        });
      },
      // Access to DOM elements of the form.
      elements: {
        configNode: function configNode() {
          return document.querySelector('.vodl-form--register-nopwd-password-reminder script[type="application/json"]');
        },
        form: function form() {
          return document.querySelector('.vodl-form--register-nopwd-password-reminder form');
        },
        termsLabel: function termsLabel() {
          return document.querySelector('.vodl-form--register-nopwd-password-reminder .vodl-login__agb-label');
        },
        toggleArrow: function toggleArrow() {
          return document.querySelector('.vodl-form--register-nopwd-password-reminder .vodl-login__agb-arrow');
        }
      },
      /**
       * Prefill form data from state
       * and bind state changes to the form elements.
       *
       */
      initFromState: function initFromState() {
        var _this = forms.passwordReminder;
        var statefulElements = _this.elements.form().querySelectorAll('[data-state]');
        statefulElements.forEach(function (elem) {
          helpers.setTextOrValue(elem, state.get(elem.dataset.state));
          elem.addEventListener('change', events.onInputChange);
        });
      },
      /**
       * The event handler for state changes.
       *
       * @param {Object} data An object containing information about the changed state value.
       */
      onStateChange: function onStateChange(data) {
        var _this = forms.passwordReminder;
        if (!_this.elements.form()) {
          return;
        }
        var statefulElements = _this.elements.form().querySelectorAll('[data-state="' + data.path + '"]');
        logger.log('forms.passwordReminder.onStateChange:', data, statefulElements);
        statefulElements.forEach(function (elem) {
          helpers.setTextOrValue(elem, data.value);
        });
      },
      /**
       * Basic validation of the form inputs.
       *
       * @return {Object} Object with the validation result.
       */
      validate: function validate() {
        var _this = forms.passwordReminder;
        var password = state.get('login.password') || false;
        var result = {};
        result.data = {};
        result.data.password = password;
        result.errors = [];
        if (!password || password.length < 6) {
          result.errors.push(_this.config.messages.errors.invalidPassword);
        }
        return result;
      }
    },
    /**
     * The form used for the set password afer checkout step.
     * We show the user a form just with password input.
     *
     * @type {Object}
     */
    setPasswordAfterCheckout: {
      // mode can either be 'showTerms' or 'hideTerms'.
      mode: 'showTerms',
      /**
       * Initialize the setPasswordAfterCheckout form.
       *
       * @return {Promise} A promise that will be resolved on success.
       */
      _init: function _init() {
        return new Promise(function (resolve, reject) {
          var _this = forms.setPasswordAfterCheckout;
          _this.mode = state.get('login.terms.E1') ? 'hideTerms' : 'showTerms';
          if (_this.elements.configNode() && _this.elements.form()) {
            // Apply the mode (hideTerms or showTerms).
            _this.applyMode();
            // Make sure the thing is open.
            modal.open();
            resolve('setPasswordAfterCheckout form already initialized');
            return;
          }

          // Retrieve the form via the form API.
          requests.getForm('register-vplus-nopwd-set-pwd-after-checkout').then(function (data) {
            // Inject the fetched html into the page.
            var formContent = document.querySelector('.vodl-form');
            formContent.parentElement.replaceWith(helpers.htmlToElement(data));

            // Fetch the forms configuration.
            _this.config = helpers.parseFormConfig(_this.elements.configNode());
            logger.log('forms.setPasswordAfterCheckout._init config:', _this.config);

            // Prefill data from state and bind to state changes.
            _this.initFromState();

            // Attach events for the form itself:
            // - submiting the form
            // - clicking the toggle arrow for expanding/minimzing the terms and conditions section.
            _this.elements.form().removeEventListener('submit', events.onSetPasswordAfterCheckoutSubmitted);
            _this.elements.form().addEventListener('submit', events.onSetPasswordAfterCheckoutSubmitted);
            _this.elements.toggleArrow().removeEventListener('click', events.onSetPasswordAfterCheckoutToggleArrowClicked);
            _this.elements.toggleArrow().addEventListener('click', events.onSetPasswordAfterCheckoutToggleArrowClicked);

            // Attach events for closing the modal
            modal.elements.wrapper().addEventListener('click', events.onModalWrapperClicked);
            modal.elements.closeButton().addEventListener('click', events.onModalCloseButtonClicked);

            // Apply the mode (hideTerms or showTerms).
            _this.applyMode();
            // Open the thing.
            modal.open();
            resolve('setPasswordAfterCheckout form initialized');
          })["catch"](function (error) {
            logger.log('requests.getForm("register-vplus-nopwd-set-pwd-after-checkout") failed: ', error);
            reject(error);
          });
        });
      },
      /**
       * Depending on the mode we show or hide certain UI elements.
       */
      applyMode: function applyMode() {
        var _this = forms.setPasswordAfterCheckout;
        if ('hideTerms' === _this.mode) {
          _this.elements.termsWrapper().style.display = 'none';
        } else {
          _this.elements.termsWrapper().style.display = 'block';
        }
      },
      // Access to DOM elements of the form.
      elements: {
        configNode: function configNode() {
          return document.querySelector('.vodl-form--register-nopwd-set-pwd-after-checkout script[type="application/json"]');
        },
        form: function form() {
          return document.querySelector('.vodl-form--register-nopwd-set-pwd-after-checkout form');
        },
        termsLabel: function termsLabel() {
          return document.querySelector('.vodl-form--register-nopwd-set-pwd-after-checkout .vodl-login__agb-label');
        },
        termsWrapper: function termsWrapper() {
          return document.querySelector('.vodl-form--register-nopwd-set-pwd-after-checkout .vodl-login__agb-wrapper');
        },
        toggleArrow: function toggleArrow() {
          return document.querySelector('.vodl-form--register-nopwd-set-pwd-after-checkout .vodl-login__agb-arrow');
        }
      },
      /**
       * Prefill form data from state
       * and bind state changes to the form elements.
       *
       */
      initFromState: function initFromState() {
        var _this = forms.setPasswordAfterCheckout;
        var statefulElements = _this.elements.form().querySelectorAll('[data-state]');
        statefulElements.forEach(function (elem) {
          helpers.setTextOrValue(elem, state.get(elem.dataset.state));
          elem.addEventListener('change', events.onInputChange);
        });
      },
      /**
       * The event handler for state changes.
       *
       * @param {Object} data An object containing information about the changed state value.
       */
      onStateChange: function onStateChange(data) {
        var _this = forms.setPasswordAfterCheckout;
        if (!_this.elements.form()) {
          return;
        }
        var statefulElements = _this.elements.form().querySelectorAll('[data-state="' + data.path + '"]');
        logger.log('forms.setPasswordAfterCheckout.onStateChange:', data, statefulElements);
        statefulElements.forEach(function (elem) {
          helpers.setTextOrValue(elem, data.value);
        });
      },
      /**
       * Basic validation of the form inputs.
       *
       * @return {Object} Object with the validation result.
       */
      validate: function validate() {
        var _this = forms.setPasswordAfterCheckout;
        var password = state.get('login.password') || false;
        var result = {};
        result.data = {};
        result.data.password = password;
        result.errors = [];
        if (!password || password.length < 6) {
          result.errors.push(_this.config.messages.errors.invalidPassword);
        }
        return result;
      }
    },
    setPasswordWithToken: {
      /**
       * Initialize the setPasswordWithToken form.
       *
       * @return {Promise} A promise that will be resolved on success.
       */
      _init: function _init() {
        return new Promise(function (resolve, reject) {
          var _this = forms.setPasswordWithToken;
          if (_this.elements.configNode() && _this.elements.form()) {
            // Make sure the thing is open.
            modal.open();
            resolve('setPasswordWithToken form already initialized');
            return;
          }

          // Retrieve the form via the form API.
          requests.getForm('register-vplus-nopwd-set-pwd-with-token', true).then(function (data) {
            // Inject the fetched html into the page.
            var formContent = document.querySelector('.vodl-form');
            formContent.parentElement.replaceWith(helpers.htmlToElement(data));

            // Fetch the forms configuration.
            _this.config = helpers.parseFormConfig(_this.elements.configNode());
            logger.log('forms.setPasswordWithToken._init config:', _this.config);

            // Prefill data from state and bind to state changes.
            _this.initFromState();

            // Attach events for the form itself:
            // - submiting the form
            // - clicking the toggle arrow for expanding/minimzing the terms and conditions section.
            _this.elements.form().removeEventListener('submit', events.onSetPasswordWithTokenSubmitted);
            _this.elements.form().addEventListener('submit', events.onSetPasswordWithTokenSubmitted);
            if (_this.elements.toggleArrow()) {
              _this.elements.toggleArrow().removeEventListener('click', events.onSetPasswordWithTokenToggleArrowClicked);
              _this.elements.toggleArrow().addEventListener('click', events.onSetPasswordWithTokenToggleArrowClicked);
            }

            // Attach events for closing the modal
            modal.elements.wrapper().addEventListener('click', events.onModalWrapperClicked);
            modal.elements.closeButton().addEventListener('click', events.onModalCloseButtonClicked);

            // Open the thing.
            modal.open();
            resolve('setPasswordWithToken form initialized');
          })["catch"](function (error) {
            logger.log('requests.getForm("register-vplus-nopwd-set-pwd-with-token") failed: ', error);
            reject(error);
          });
        });
      },
      // Access to DOM elements of the form.
      elements: {
        configNode: function configNode() {
          return document.querySelector('.vodl-form--register-nopwd-set-pwd-with-token script[type="application/json"]');
        },
        form: function form() {
          return document.querySelector('.vodl-form--register-nopwd-set-pwd-with-token form');
        },
        termsLabel: function termsLabel() {
          return document.querySelector('.vodl-form--register-nopwd-set-pwd-with-token .vodl-login__agb-label');
        },
        toggleArrow: function toggleArrow() {
          return document.querySelector('.vodl-form--register-nopwd-set-pwd-with-token .vodl-login__agb-arrow');
        }
      },
      /**
       * Prefill form data from state
       * and bind state changes to the form elements.
       *
       */
      initFromState: function initFromState() {
        var _this = forms.setPasswordWithToken;
        var statefulElements = _this.elements.form().querySelectorAll('[data-state]');
        statefulElements.forEach(function (elem) {
          helpers.setTextOrValue(elem, state.get(elem.dataset.state));
          elem.addEventListener('change', events.onInputChange);
        });
      },
      /**
       * The event handler for state changes.
       *
       * @param {Object} data An object containing information about the changed state value.
       */
      onStateChange: function onStateChange(data) {
        var _this = forms.setPasswordWithToken;
        if (!_this.elements.form()) {
          return;
        }
        var statefulElements = _this.elements.form().querySelectorAll('[data-state="' + data.path + '"]');
        logger.log('forms.setPasswordWithToken.onStateChange:', data, statefulElements);
        statefulElements.forEach(function (elem) {
          helpers.setTextOrValue(elem, data.value);
        });
      },
      /**
       * Basic validation of the form inputs.
       *
       * @return {Object} Object with the validation result.
       */
      validate: function validate() {
        var _this = forms.setPasswordWithToken;
        var password = state.get('login.password') || false;
        var result = {};
        result.data = {};
        result.data.password = password;
        result.errors = [];
        if (!password || password.length < 6) {
          result.errors.push(_this.config.messages.errors.invalidPassword);
        }
        return result;
      }
    }
  };

  /**
   * Collection of helper methods.
   *
   * @type {Object}
   */
  var helpers = {
    /**
     * Convert a given HTML string to a DOM element.
     *
     * @param  {String}  html The source HTML string.
     *
     * @return {Element}      The resulting DOM element.
     */
    htmlToElement: function htmlToElement(html) {
      var template = document.createElement('template');
      html = html.trim();
      template.innerHTML = html;
      return template.content.firstChild;
    },
    /**
     * Parses the included JSON of the given configNode
     * and returns the resulting object.
     *
     * @param  {Element} configNode The Element to parse.
     * @return {Object}             The parsed config object.
     */
    parseFormConfig: function parseFormConfig(configNode) {
      var defaultConfig = {
        messages: {
          errors: {
            invalidEmail: 'invalid email'
          }
        }
      };
      var parsedConfig = {};
      if (!configNode) {
        return defaultConfig;
      }
      try {
        parsedConfig = JSON.parse(configNode.innerHTML) || {};
      } catch (e) {
        return defaultConfig;
      }
      return parsedConfig;
    },
    /**
     * Sanitize the value of a given input field.
     * Currently we just trim() the value, but we could do more depending
     * on the input field type.
     *
     * @param {Element} inputField The input field element to check.
     */
    sanitizeFieldValue: function sanitizeFieldValue(inputField) {
      var value = inputField.value.trim();
      // @TODO: Depending on field type we could do different things here.
      return value;
    },
    /**
     * This method is used for setting values on input fields, e.g. on state changes.
     * Depending on the element.type (text, checkbox...) we need to do different things.
     *
     * @param {Element}        element The element node.
     * @param {String|Boolean} value   The value to set.
     *
     */
    setTextOrValue: function setTextOrValue(element, value) {
      var tagName = element.tagName || false;
      if (!tagName) {
        return;
      }
      if ('INPUT' === tagName) {
        switch (element.type) {
          case 'checkbox':
          case 'radio':
            if (value !== element.checked) {
              element.checked = value;
            }
            break;
          default:
            if (value !== element.value) {
              element.value = value;
            }
            break;
        }
      } else {
        if (value !== element.innerHTML) {
          element.innerHTML = value;
        }
      }
    },
    /**
     * Place the SSO cookie images as it would be done in a normal registration or login flow.
     * We use methods from window.RussMedia.SSO as far as possible.
     *
     * @return {Promise} A promise that is resolved on success.
     */
    ssoPlaceCookies: function ssoPlaceCookies() {
      return new Promise(function (resolve, reject) {
        var options = rmSSO.getOptions();

        // Delete possibly existing cookie first.
        rmSSO.deleteCookie(options.cookies.ssoCookieName);

        // Place cookie image tags in the options.cookies.container
        var loginOrRegisterResult = state.get('sso.loginOrRegisterResult');
        var userData = state.get('sso.userData');
        if (!loginOrRegisterResult.cookie) {
          reject('No cookie images to inject!', loginOrRegisterResult);
          return;
        }
        rmSSO.loginStatusEventHandler.trigger(userData);
        // options.cookies.container is actually a jQuery object
        //  - so we are be able to use the jQuery methods append() and find() on it.
        options.cookies.container.append(loginOrRegisterResult.cookie);
        options.cookies.container.find('img:last').on('load', function () {
          rmSSO.waitForCookieAsync().then(function () {
            resolve('Cookie images loaded!');
          }, function () {
            reject('Cookie images did not load!');
          });
        });
        logger.log('helpers.ssoPlaceCookies SSO options, ssoResult: ', options, loginOrRegisterResult);
      });
    },
    /**
     * Track either an action or virtual page view via Google Analytics,
     * depending on the given data properties.
     *
     * @param {Object} data
     */
    trackGA: function trackGA(data) {
      var trackingData = data || {};
      logger.log('trackGA: ', data);
      trackingData.action = trackingData.action || false;
      trackingData.pagePath = trackingData.pagePath || false;
      if (trackingData.action) {
        this.trackGAEvent(trackingData.action);
      }
      if (trackingData.pagePath) {
        this.trackGAPageview(trackingData.pagePath);
      }
    },
    /**
     * Track a given action as event via Google Analytics.
     *
     * @param {string} action
     */
    trackGAEvent: function trackGAEvent(action) {
      var eventData = {
        event: 'genericEvent',
        eventCategory: 'checkout',
        eventAction: action,
        eventLabel: window.location.href
      };
      dataLayer.push(eventData);
      document.dispatchEvent(new CustomEvent("hansrmdtevent", {
        detail: eventData
      }));
    },
    /**
     * Track a given pagePath as virtual page view via Google Analytics.
     *
     * @param {string} pagePath
     */
    trackGAPageview: function trackGAPageview(pagePath) {
      var eventData = {
        event: 'virtualPageview',
        virtualPagePath: pagePath
      };
      dataLayer.push(eventData);
      document.dispatchEvent(new CustomEvent("hansrmdtevent", {
        detail: eventData
      }));
    }
  };

  /**
   * Collection of methods for handling the modal window.
   *
   * @type {Object}
   */
  var modal = {
    /**
     * Close the modal dialogue.
     */
    close: function close() {
      logger.log('modal.close');
      this.elements.wrapper().style.display = 'none';
    },
    // Access to DOM elements of the modal.
    elements: {
      closeButton: function closeButton() {
        return document.querySelector('.vodl-form--modal .vodl-form__close');
      },
      loadingSpinner: function loadingSpinner() {
        return document.querySelector('.vodl-form--modal .vodl-form__loading');
      },
      loginWrapper: function loginWrapper() {
        return document.querySelector('.vodl-form--modal .vodl-login__wrapper');
      },
      wrapper: function wrapper() {
        return document.querySelector('.vodl-form--modal');
      }
    },
    loadingIndicator: {
      /**
       * End the loading indicator.
       */
      end: function end() {
        var _this = modal;
        _this.elements.loadingSpinner().style.display = 'none';
        _this.elements.loginWrapper().style.display = 'block';
      },
      /**
       * Start the loading indicator.
       */
      start: function start() {
        var _this = modal;
        _this.elements.loadingSpinner().style.display = 'block';
        _this.elements.loginWrapper().style.display = 'none';
      }
    },
    /**
     * Open the modal dialogue.
     */
    open: function open() {
      this.elements.wrapper().style.display = 'flex';
    }
  };

  /**
   * Collection of methods for handling the notifcation modal.
   *
   * @type {Object}
   */
  var notification = {
    // Access to DOM elements of the notification.
    elements: {
      header: function header() {
        return document.querySelector('.vodl-notification .vodl-notification__header');
      },
      headerText: function headerText() {
        return document.querySelector('.vodl-notification .vodl-notification__header-text');
      },
      headerBadge: function headerBadge() {
        return document.querySelector('.vodl-notification .vodl-notification__header-badge');
      },
      text: function text() {
        return document.querySelector('.vodl-notification .vodl-notification__text');
      },
      wrapper: function wrapper() {
        return document.querySelector('.vodl-notification--modal');
      },
      notification: function notification() {
        return document.querySelector('.vodl-notification');
      },
      body: function body() {
        return document.querySelector('.vodl-notification .vodl-notification__body');
      },
      button: function button() {
        return document.querySelector('.vodl-notification .vodl-notification__button');
      },
      buttonLabel: function buttonLabel() {
        return document.querySelector('.vodl-notification .vodl-notification__button .vodl-button__label');
      },
      submitButton: function submitButton() {
        return document.querySelector('.vodl-notification .vodl-notification__button button');
      }
    },
    /**
     * Show the notification.
     * Data is picked from state.
     */
    show: function show() {
      var titleText = state.get('notification.title') || 'Finished!';
      var messageText = state.get('notification.message') || 'We are totally done here...';
      var buttonText = state.get('notification.button') || 'Got it';

      // Set notification title and message.
      this.elements.headerText().append(document.createTextNode(titleText));
      this.elements.text().append(document.createTextNode(messageText));

      // Assign click event handler for closing the notfication.
      this.elements.wrapper().removeEventListener('click', events.onNotificationClicked);
      this.elements.wrapper().addEventListener('click', events.onNotificationClicked);

      // Addding the button if needed.
      if (!this.elements.button()) {
        var notificationButton = document.createElement('div');
        notificationButton.innerHTML = '<div class="vodl-notification__button"><button class="vodl-button vodl-button--red" type="button"><span class="vodl-button__label">OK</span></button></div>';
        this.elements.body().append(notificationButton);
      }
      this.elements.buttonLabel().innerHTML = buttonText;

      // Use the V+ style.
      this.elements.notification().classList.add('vodl-notification--vplus');

      // BUT: if the current step is 'passwordReminderComplete' OR 'setPasswordWithTokenComplete'
      // we actually want make the notification more neutral and so we omit the V+ header badge and use a yellow button.
      var currentStep = state.get('step');
      if ('passwordReminderComplete' === currentStep || 'setPasswordWithTokenComplete' === currentStep) {
        this.elements.headerBadge().style.display = 'none';
        this.elements.submitButton().classList.remove('vodl-button--red');
        this.elements.submitButton().classList.add('vodl-button--yellow');
      }

      // Show the thing.
      this.elements.wrapper().style.display = 'flex';
    }
  };

  /**
   * The definition of the register flow steps.
   * Each step can be triggered by changing the states step property.
   *
   * @type {Object}
   */
  var registerFlow = {
    /**
     * Initialize the register flow.
     */
    _init: function _init() {
      state.set('error', '');
      state.set('step', '');
      state.set('login.email', '');
      state.set('login.password', '');
      state.set('login.username', '');
      state.set('login.terms', {
        'E1': false,
        'agb_vol': true
      });

      // Subscribe to state changes.
      state.on('stateChange', events.onStepChange);
      state.on('stateChange', events.onStateChange);
      state.set('step', 'showRegisterForm');
    },
    /**
     * Initialize, but start with showPasswordReminderForm
     */
    _initReminder: function _initReminder() {
      state.set('error', '');
      state.set('step', '');
      state.set('login.email', '');
      state.set('login.password', '');
      state.set('login.username', '');
      state.set('login.terms', {});

      // Subscribe to state changes.
      state.on('stateChange', events.onStepChange);
      state.on('stateChange', events.onStateChange);
      state.set('step', 'showPasswordReminderForm');
    },
    /**
     * Initialize, but start with showSetPasswordWithTokenForm
     */
    _initSetPasswordWithToken: function _initSetPasswordWithToken() {
      state.set('error', '');
      state.set('step', '');
      state.set('login.email', '');
      state.set('login.password', '');
      state.set('login.username', '');
      state.set('login.terms', {});

      // Subscribe to state changes.
      state.on('stateChange', events.onStepChange);
      state.on('stateChange', events.onStateChange);
      state.set('step', 'showSetPasswordWithTokenForm');
    },
    /**
     * Initialize, but wait for checkout being complete.
     */
    _initWaitForCheckoutComplete: function _initWaitForCheckoutComplete() {
      state.set('error', '');
      state.set('step', '');
      state.set('login.email', '');
      state.set('login.password', '');
      state.set('login.username', '');
      state.set('login.terms', {});

      // Subscribe to state changes.
      state.on('stateChange', events.onStepChange);
      state.on('stateChange', events.onStateChange);
      state.set('step', 'afterRegisterComplete');
    },
    steps: {
      /**
       * Step for showing the register form.
       */
      showRegisterForm: function showRegisterForm() {
        logger.log('steps.showRegisterForm');
        forms.register._init().then(function () {
          helpers.trackGA({
            action: 'registration_form',
            pagePath: 'vplus/checkout/registration_form'
          });
        })["catch"](function (error) {
          logger.log(error);
          modal.close();
        });
      },
      /**
       * Step for processing the submitted register form.
       */
      submitRegisterForm: function submitRegisterForm() {
        logger.log('steps.submitRegisterForm');
        var form = forms.register;
        // Clear any possible errors.
        state.set('error', '');

        // Basic data validation.
        var validatedFormData = form.validate();
        logger.log('steps.submitRegisterForm validation:', validatedFormData);
        if (validatedFormData.errors && validatedFormData.errors.length > 0) {
          state.set('error', validatedFormData.errors.join('<br> '));
          state.set('step', 'showRegisterForm');
          return;
        }

        // Still here? Call the register REST API.
        modal.loadingIndicator.start();
        var apiTerms = [];
        var stateTerms = state.get('login.terms');
        for (var id in stateTerms) {
          if (stateTerms.hasOwnProperty(id)) {
            apiTerms.push({
              id: id,
              checked: stateTerms[id]
            });
          }
        }
        var apiData = {
          email: state.get('login.email'),
          terms: apiTerms
        };
        logger.log('steps.submitRegisterForm apiData:', apiData);

        // Call the register-by-email-only API endpoint and handle the result.
        requests.ssoRestApi('register-by-email-only', apiData).then(function (responseData) {
          // We only get here if the API returned a 200.

          modal.loadingIndicator.end();
          modal.close();
          logger.log('steps.submitRegisterForm responseData:', responseData);
          responseData.additional_data = responseData.additional_data || {};
          responseData.additional_data.sso = responseData.additional_data.sso || {};
          responseData.additional_data.sso.register_result = responseData.additional_data.sso.register_result || {};
          responseData.additional_data.sso.user_data = responseData.additional_data.sso.user_data || {};
          state.set('sso.loginOrRegisterResult', responseData.additional_data.sso.register_result);
          state.set('sso.userData', responseData.additional_data.sso.user_data);
          state.set('error', '');
          if (responseData.register) {
            // The call resulted in a registration.
            // We are basically done here.
            state.set('step', 'registerComplete');
            return;
          } else {
            // I turned out, that a user with the given email already exists.
            // Forward the user to the login form with pre-filledd email.
            helpers.trackGA({
              action: 'registration_to_login_form',
              pagePath: 'vplus/checkout/registration_to_login_form'
            });
            state.set('step', 'showLoginForm');
            return;
          }
        })["catch"](function (responseError) {
          // We only get here if the API did NOT return a 200.
          // This can happpen e.g. if a parameter is missing.
          modal.loadingIndicator.end();
          var errors = [];
          errors.push(responseError.message);
          // helpers.trackEventAction('upsell_abort');
          state.set('error', errors.join('<br> '));
          logger.log('steps.submitRegisterForm responseError:', responseError);
          state.set('step', 'showRegisterForm');
        });
      },
      /**
       * Step for completed registration.
       */
      registerComplete: function registerComplete() {
        logger.log('steps.registerComplete');
        helpers.trackGA({
          action: 'registration_complete',
          pagePath: 'vplus/checkout/registration_complete'
        });

        // Trigger actual login mechanism (setting cookies)
        helpers.ssoPlaceCookies().then(function () {
          // Make sure no more modals are open.
          modal.close();
          // Make sure the username already shows up in the navigation bar.
          rmUI.checkLoginStatus();
          // Try to trigger the checkout.
          rmPiano.maybeTriggerStartCheckout('register-nopwd', state.get('sso.userData'));
          // Set final step state.
          state.set('step', 'afterRegisterComplete');
        }, function (error) {
          logger.log('helpers.ssoPlaceCookies failed:', error);
        });
      },
      /**
       * Step for showing the login form.
       */
      showLoginForm: function showLoginForm() {
        logger.log('steps.showLoginForm');
        forms.login._init().then(function () {
          helpers.trackGA({
            action: 'login_form',
            pagePath: 'vplus/checkout/login_form'
          });
        })["catch"](function (error) {
          logger.log(error);
          modal.close();
        });
      },
      /**
       * Step for submitting the login form.
       */
      submitLoginForm: function submitLoginForm() {
        logger.log('steps.submitLoginForm');
        var form = forms.login;
        // Clear any possible errors.
        state.set('error', '');

        // Basic data validation.
        var validatedFormData = form.validate();
        logger.log('steps.submitLoginForm validation:', validatedFormData);
        if (validatedFormData.errors && validatedFormData.errors.length > 0) {
          state.set('error', validatedFormData.errors.join('<br> '));
          state.set('step', 'showLoginForm');
          return;
        }

        // Still here? Call the register REST API.
        modal.loadingIndicator.start();

        // Try the login via rmSSO.
        // This is actually using jQuery Deferred, so this looks a bit different here:
        rmSSO.login(state.get('login.email'), state.get('login.password'), true).then(function (responseData) {
          // Resolved, we only get here if the login succeeded.
          modal.loadingIndicator.end();
          modal.close();
          logger.log('steps.submitLoginForm responseData:', responseData);
          responseData.login_result = responseData.login_result || {};
          responseData.user_data = responseData.user_data || {};
          state.set('sso.loginOrRegisterResult', responseData.login_result);
          state.set('sso.userData', responseData.user_data);
          state.set('error', '');
          state.set('step', 'loginComplete');
        }, function (message) {
          // Rejected, we only get here if the login did not succeed for any reason.
          modal.loadingIndicator.end();
          var errors = [];
          if (form.config.messages.errors[message]) {
            // The message is either a message identifier...
            errors.push(form.config.messages.errors[message]);
          } else {
            // ... or the message itself.
            errors.push(message);
          }
          state.set('error', errors.join('<br> '));
          logger.log('steps.submitLoginForm responseError:', message);
          state.set('step', 'showLoginForm');
        });
      },
      /**
       * Step for completed login.
       */
      loginComplete: function loginComplete() {
        logger.log('steps.loginComplete');
        helpers.trackGA({
          action: 'login_complete',
          pagePath: 'vplus/checkout/login_complete'
        });

        // Make sure the username already shows up in the navigation bar.
        rmUI.checkLoginStatus();
        // Try to trigger the checkout.
        rmPiano.maybeTriggerStartCheckout('register-nopwd-login', state.get('sso.userData'));
      },
      /**
       * Step for showing the set password after checkout form.
       */
      showSetPasswordAfterCheckoutForm: function showSetPasswordAfterCheckoutForm() {
        logger.log('steps.showSetPasswordAfterCheckoutForm', state.get('sso.loginOrRegisterResult'));
        var loginOrRegisterResult = state.get('sso.loginOrRegisterResult') || {};
        if (!loginOrRegisterResult.hash || !loginOrRegisterResult.token) {
          return;
        }
        forms.setPasswordAfterCheckout._init().then(function () {
          helpers.trackGA({
            action: 'set_password_after_checkout_form',
            pagePath: 'vplus/checkout/set_password_after_checkout_form'
          });
        })["catch"](function (error) {
          logger.log(error);
          modal.close();
        });
      },
      /**
       * Step for submitting the set password after checkout form.
       */
      submitSetPasswordAfterCheckoutForm: function submitSetPasswordAfterCheckoutForm() {
        logger.log('steps.submitSetPasswordAfterCheckoutForm');
        var form = forms.setPasswordAfterCheckout;
        // Clear any possible errors.
        state.set('error', '');

        // Basic data validation.
        var validatedFormData = form.validate();
        logger.log('steps.submitSetPasswordAfterCheckoutForm validation:', validatedFormData);
        if (validatedFormData.errors && validatedFormData.errors.length > 0) {
          state.set('error', validatedFormData.errors.join('<br> '));
          state.set('step', 'showSetPasswordAfterCheckoutForm');
          return;
        }

        // Still here? Call the register REST API.
        modal.loadingIndicator.start();
        var apiTerms = [];
        var stateTerms = state.get('login.terms');
        for (var id in stateTerms) {
          if (stateTerms.hasOwnProperty(id)) {
            apiTerms.push({
              id: id,
              checked: stateTerms[id]
            });
          }
        }
        var apiData = {
          hash: state.get('sso.loginOrRegisterResult.hash'),
          token: state.get('sso.loginOrRegisterResult.token'),
          new_password: state.get('login.password'),
          new_password_again: state.get('login.password'),
          terms: apiTerms
        };
        logger.log('steps.submitSetPasswordAfterCheckoutForm apiData:', apiData);

        // Call the set-pw/user API endpoint and handle the result.
        requests.ssoRestApi('set-pw/user', apiData).then(function (responseData) {
          // We only get here if the API returned a 200.
          modal.loadingIndicator.end();
          modal.close();
          logger.log('steps.submitSetPasswordAfterCheckoutForm responseData:', responseData);
          if (!responseData.password_set.success) {
            var errors = [];
            errors.push(responseData.additional_data.sso.user_error_text);
            state.set('error', errors.join('<br> '));
            state.set('step', 'showSetPasswordAfterCheckoutForm');
            return;
          }
          state.set('step', 'setPasswordAfterCheckoutComplete');
          return;
        })["catch"](function (responseError) {
          // We only get here if the API did NOT return a 200.
          // This can happpen e.g. if a parameter is missing.
          modal.loadingIndicator.end();
          var errors = [];
          errors.push(responseError.message);
          // helpers.trackEventAction('upsell_abort');
          state.set('error', errors.join('<br> '));
          logger.log('steps.submitSetPasswordAfterCheckoutForm responseError:', responseError);
          state.set('step', 'showSetPasswordAfterCheckoutForm');
        });
      },
      /**
       * Step for completed password set after checkout.
       */
      setPasswordAfterCheckoutComplete: function setPasswordAfterCheckoutComplete() {
        logger.log('steps.setPasswordAfterCheckoutComplete');
        helpers.trackGA({
          action: 'set_password_after_checkout_complete',
          pagePath: 'vplus/checkout/set_password_after_checkout_complete'
        });
        window.location.reload();
      },
      /**
       * Step for showing the password reminder form.
       */
      showPasswordReminderForm: function showPasswordReminderForm() {
        logger.log('steps.showPasswordReminderForm');
        forms.passwordReminder._init().then(function () {
          helpers.trackGA({
            action: 'password_reminder_form',
            pagePath: 'vplus/checkout/password_reminder_form'
          });
        })["catch"](function (error) {
          logger.log(error);
          modal.close();
        });
      },
      /**
       * Step for submitting the password reminder form.
       */
      submitPasswordReminderForm: function submitPasswordReminderForm() {
        logger.log('steps.submitPasswordReminderForm');
        var form = forms.passwordReminder;
        // Clear any possible errors.
        state.set('error', '');

        // Basic data validation.
        var validatedFormData = form.validate();
        logger.log('steps.submitPasswordReminderForm validation:', validatedFormData);
        if (validatedFormData.errors && validatedFormData.errors.length > 0) {
          state.set('error', validatedFormData.errors.join('<br> '));
          state.set('step', 'showPasswordReminderForm');
          return;
        }

        // Still here? Call the register REST API.
        modal.loadingIndicator.start();
        var apiTerms = [];
        var stateTerms = state.get('login.terms');
        for (var id in stateTerms) {
          if (stateTerms.hasOwnProperty(id)) {
            apiTerms.push({
              id: id,
              checked: stateTerms[id]
            });
          }
        }
        var apiData = {
          hash: state.get('sso.userData.hash'),
          token: state.get('sso.userData.token'),
          new_password: state.get('login.password'),
          new_password_again: state.get('login.password'),
          terms: apiTerms
        };
        logger.log('steps.submitPasswordReminderForm apiData:', apiData);

        // Call the set-pw/user API endpoint and handle the result.
        requests.ssoRestApi('set-pw/user', apiData).then(function (responseData) {
          // We only get here if the API returned a 200.
          modal.loadingIndicator.end();
          modal.close();
          logger.log('steps.submitPasswordReminderForm responseData:', responseData);
          if (!responseData.password_set.success) {
            var errors = [];
            errors.push(responseData.additional_data.sso.user_error_text);
            state.set('error', errors.join('<br> '));
            state.set('step', 'showPasswordReminderForm');
            return;
          }
          state.set('notification', forms.passwordReminder.config.notifications.setPasswordComplete);
          state.set('step', 'passwordReminderComplete');
          return;
        })["catch"](function (responseError) {
          // We only get here if the API did NOT return a 200.
          // This can happpen e.g. if a parameter is missing.
          modal.loadingIndicator.end();
          var errors = [];
          errors.push(responseError.message);
          // helpers.trackEventAction('upsell_abort');
          state.set('error', errors.join('<br> '));
          logger.log('steps.submitPasswordReminderForm responseError:', responseError);
          state.set('step', 'showPasswordReminderForm');
        });
      },
      /**
       * Step for completed password reminder.
       */
      passwordReminderComplete: function passwordReminderComplete() {
        logger.log('steps.passwordReminderComplete');
        helpers.trackGA({
          action: 'password_reminder_complete',
          pagePath: 'vplus/checkout/password_reminder_complete'
        });

        // Show notification with the success message.
        notification.show();
      },
      /**
       * Step for showing the set password with token form.
       */
      showSetPasswordWithTokenForm: function showSetPasswordWithTokenForm() {
        logger.log('steps.showSetPasswordWithTokenForm');
        forms.setPasswordWithToken._init().then(function () {
          helpers.trackGA({
            action: 'email_password_reminder_form',
            pagePath: 'vplus/checkout/email_password_reminder_form'
          });
        })["catch"](function (error) {
          logger.log(error);
          modal.close();
        });
      },
      submitSetPasswordWithTokenForm: function submitSetPasswordWithTokenForm() {
        logger.log('steps.submitSetPasswordWithTokenForm');
        var form = forms.setPasswordWithToken;
        // Clear any possible errors.
        state.set('error', '');

        // Basic data validation.
        var validatedFormData = form.validate();
        logger.log('steps.submitSetPasswordWithTokenForm validation:', validatedFormData);
        if (validatedFormData.errors && validatedFormData.errors.length > 0) {
          state.set('error', validatedFormData.errors.join('<br> '));
          state.set('step', 'showSetPasswordWithTokenForm');
          return;
        }

        // Still here? Call the register REST API.
        modal.loadingIndicator.start();
        var apiTerms = [];
        var stateTerms = state.get('login.terms');
        for (var id in stateTerms) {
          if (stateTerms.hasOwnProperty(id)) {
            apiTerms.push({
              id: id,
              checked: stateTerms[id]
            });
          }
        }

        // URL will e.g. look like this:
        // ?verbose=1&forcerefresh=1#set-pwd/eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJleHAiOjEasasdasd
        // so we need to search for token in the document.location.hash
        var set_password_token = document.location.hash.split(tokenHash).pop();
        var apiData = {
          set_password_token: set_password_token,
          new_password: state.get('login.password'),
          new_password_again: state.get('login.password'),
          terms: apiTerms
        };
        logger.log('steps.submitSetPasswordWithTokenForm apiData:', apiData);

        // Call the set-pw/user API endpoint and handle the result.
        requests.ssoRestApi('set-pw/user', apiData).then(function (responseData) {
          // We only get here if the API returned a 200.
          modal.loadingIndicator.end();
          modal.close();
          logger.log('steps.submitSetPasswordWithTokenForm responseData:', responseData);
          if (!responseData.password_set.success) {
            var errors = [];
            if (responseData.additional_data.sso.user_error_text) {
              errors.push(responseData.additional_data.sso.user_error_text);
            } else {
              errors.push(responseData.password_set.user_error_text);
            }
            state.set('error', errors.join('<br> '));
            state.set('step', 'showSetPasswordWithTokenForm');
            return;
          }
          state.set('notification', forms.setPasswordWithToken.config.notifications.setPasswordComplete);
          state.set('step', 'setPasswordWithTokenComplete');
          return;
        })["catch"](function (responseError) {
          // We only get here if the API did NOT return a 200.
          // This can happpen e.g. if a parameter is missing.
          modal.loadingIndicator.end();
          var errors = [];
          errors.push(responseError.message);
          // helpers.trackEventAction('upsell_abort');
          state.set('error', errors.join('<br> '));
          logger.log('steps.submitSetPasswordWithTokenForm responseError:', responseError);
          state.set('step', 'showSetPasswordWithTokenForm');
        });
      },
      setPasswordWithTokenComplete: function setPasswordWithTokenComplete() {
        logger.log('steps.setPasswordWithTokenComplete');
        helpers.trackGA({
          action: 'email_password_reminder_complete',
          pagePath: 'vplus/checkout/email_password_reminder_complete'
        });

        // Show notification with the success message.
        notification.show();
      },
      /**
       * Step for showing the forgot password dialogue.
       */
      forgotPassword: function forgotPassword() {
        logger.log('steps.forgotPassword');
        state.set('error', '');
        modal.close();
        window.dispatchEvent(new Event('open_reset_pw_vplus_form'));
      }
    }
  };

  /**
   * Collection of methods for handling requests to the REST and form APIs.
   *
   * @type {Object}
   */
  var requests = {
    formApi: '/api/nnp/get_form',
    formsCache: {},
    ssoRestApiBase: '/wp-json/russmedia-sso/v1/',
    /**
     * Makes a call on the SSO REST API with the given route and payload.
     *
     * @param  {String}  route   The route name, e.g. 'upsell/entitlement'.
     * @param  {Object}  payload Optional payload to send with the request.
     *
     * @return {Promise}         A promise that will either be resolved or rejected.
     */
    ssoRestApi: function ssoRestApi(route, payload) {
      var url = this.ssoRestApiBase + route;
      payload = payload || {};
      return axios({
        method: 'post',
        url: url,
        data: payload,
        withCredentials: true
      }).then(function (response) {
        logger.log('called ' + route + ' , response is', response);
        return response.data;
      })["catch"](function (error) {
        var message = false;
        logger.log('requests.ssoRestApi error.response:', error.response);
        if (error.response && error.response.data) {
          if (error.response.data.data && error.response.data.data.user_error_text) {
            message = error.response.data.data.user_error_text;
          } else if (error.response.data.message) {
            message = error.response.data.message;
          }
          if (message) {
            throw new Error(message);
          } else {
            throw error;
          }
        } else {
          throw error;
        }
      });
    },
    /**
     * Fetches a form via the formApi.
     * Saves the result as entry in formsCache, so
     * subsequent calls do not trigger a request again.
     *
     * @param  {String}  id  The name/id of the form, e.g. 'send-otp'.
     * @param  {Boolean}  withToken  Wether to use a token in the current URL for the form request as well.
     *
     * @return {Promise}     A promise that will either be resolved or rejected.
     */
    getForm: function getForm(id) {
      var withToken = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var token = '';

      // URL will e.g. look like this:
      // ?verbose=1&forcerefresh=1#set-pwd/eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJleHAiOjEasasdasd
      // so we need to search for token in the document.location.hash
      if (withToken && document.location.hash.startsWith(tokenHash)) {
        token = document.location.hash.split(tokenHash).pop();
      }

      // If we already loaded this, no need to do it again.
      // But we only use the cache if we do not have a token.
      if (!token && requests.formsCache[id]) {
        return Promise.resolve(this.formsCache[id]);
      }
      return axios.get(this.formApi, {
        params: {
          f: id,
          token: token
        }
      }).then(function (response) {
        var errorMessage = response.data.error || false;
        if (errorMessage) {
          logger.log('getForm error:', errorMessage);
          throw new Error(errorMessage);
        }

        // Save the response data in formsCache, so we do not need to load it again,
        // should we need it.
        // But we only use the cache if we do not have a token.
        if (!token) {
          requests.formsCache[id] = response.data;
        }
        return response.data;
      })["catch"](function (error) {
        // Handle error.
        logger.log('getForm error:', error);
        throw error;
      });
    }
  };
  window.RussMedia = window.RussMedia || {};
  window.RussMedia.RegistrationWithoutPassword = window.RussMedia.RegistrationWithoutPassword || {};
  window.RussMedia.RegistrationWithoutPassword.State = state;
  _init();
})(window, document);
"use strict";

(function (window, document, $, undefined) {
  var desktopBp = em(50) + 'px',
    town_tab = document.querySelector('.vodl-navigation__nav-item--mytown'),
    ugc_tab = document.querySelector('.vodl-navigation__nav-item--ugc'),
    grw2025_tab = document.querySelector('.vodl-navigation__special-item--grw2025');
  var navDetailed;
  $(document).ready(function () {
    var navigation = document.querySelector('.vodl-navigation__main');
    if (!navigation) {
      return;
    }
    stick();
    townCookie();
    var mediaQuery = window.matchMedia('(min-width:' + desktopBp + ')');
    if (mediaQuery.matches) {
      desktopNavigation();
    } else {
      mobileNavigation();
    }
    mediaQuery.addListener(function (mq) {
      $('.vodl-navigation__nav-tab-wrapper').find('.show').removeClass('show');
      if (mq.matches) {
        desktopNavigation();
      } else {
        $('.vodl-navigation__nav-tab-wrapper').find('.show').removeClass('show');
        mobileNavigation();
      }
    });
    var logos = document.querySelectorAll(".vodl-navigation__logos a");
    logos.forEach(function (logo) {
      logo.addEventListener("click", function () {
        trackGA('logo', 'click', logo.getAttribute('title'));
      });
    });
  });

  // google analytics tracking - event.
  function trackGA() {
    var cat = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var label = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    var dataLayer = window.dataLayer || false;
    var eventData = {
      event: 'genericEvent',
      eventCategory: cat,
      eventAction: action,
      eventLabel: label
    };
    dataLayer.push(eventData);
    document.dispatchEvent(new CustomEvent('hansrmdtevent', {
      detail: eventData
    }));
  }
  ;

  // read out 'CurrentCity' cookie value and initiate TownTab link adaptions in navigation.
  function townCookie() {
    var cookies = document.cookie.split('; ');
    var setTown = false;
    for (var i = 0; i <= cookies.length; i++) {
      if (cookies[i] !== undefined) {
        var name = cookies[i].split('=')[0];
        if (name === 'CurrentCity') {
          var value = cookies[i].split('=')[1];
          var town_prefix = 'gemeinde'; // Default value.

          if (null === town_tab) {
            break;
          }

          // check for the data-attribute containing the mytown prefix
          if (null !== town_tab.dataset.prefix) {
            town_prefix = town_tab.dataset.prefix;
          }
          setTown = true;

          // get city name and change links and texts accordingly
          changeTownTab(value, town_prefix);
          break;
        }
      }
    }
    if (!setTown && null !== grw2025_tab) {
      grw2025_tab.style.display = 'none';
    }
  }

  // Change TownTab.
  function changeTownTab(slug, prefix) {
    var url = '/api/nnp/get_hyperlocal_name?t=';
    axios.get(url + slug).then(function (response) {
      if (response.data) {
        if (null !== ugc_tab) {
          ugc_tab.href = '/' + prefix + '/' + slug + '/neuer-artikel';
        }
        town_tab.innerText = response.data;
        town_tab.href = '/' + prefix + '/' + slug;
        var highlight_tab = town_tab.parentNode.querySelector('.vodl-category-label-highlight');
        if (null !== highlight_tab) {
          highlight_tab.href = '/' + prefix + '/' + slug;
        }
        if (null !== grw2025_tab) {
          var mapping = {
            bartholomaeberg: 'bartholomaberg',
            buers: 'burs',
            buerserberg: 'burserberg',
            damuels: 'damuls',
            duens: 'duns',
            duenserberg: 'dunserberg',
            goefis: 'gofis',
            goetzis: 'gotzis',
            hoechst: 'hochst',
            hoerbranz: 'horbranz',
            kloesterle: 'klosterle',
            loruens: 'loruns',
            maeder: 'mader',
            moeggers: 'moggers',
            nueziders: 'nuziders',
            roens: 'rons',
            roethis: 'rothis',
            schroecken: 'schrocken',
            thueringen: 'thuringen',
            thueringerberg: 'thuringenberg',
            uebersaxen: 'ubersaxen',
            stanton: 'st-anton',
            stgallenkirch: 'st-gallenkirch',
            stgerold: 'st-gerold'
          };
          grw2025_tab.href = "/themen/gemeindewahl-".concat(mapping[slug] || slug);
          grw2025_tab.querySelector('span').innerText = response.data;
        }
      }
    })["catch"](function (err) {
      console.log(err + '( vodl-navigation__main.js - changeTownTab )');
    });
  }
  var stick = function stick() {
    $(document).scroll(function () {
      var scrollTop = $(this).scrollTop(),
        navbar = document.querySelector('.vodl-navigation__main'),
        y_pos = $('.vodl-navigation__wrapper').offset().top,
        placeholder = document.querySelector('.vodl-navigation__placeholder'),
        black_bar = document.querySelector('.vodl-navigation__black-line');
      if (scrollTop >= y_pos) {
        navbar.classList.add('vodl-navigation--fixed');
        if (placeholder !== null && black_bar.classList.contains('show')) {
          placeholder.classList.add('show');
        }
      } else if (scrollTop < y_pos) {
        navbar.classList.remove('vodl-navigation--fixed');
        if (placeholder !== null) {
          placeholder.classList.remove('show');
        }
      }
    });
  };
  function desktopNavigation() {
    var navItem = document.querySelectorAll('.vodl-navigation__nav-tab-wrapper');
    var navItemsWrapper = document.querySelector('ul.vodl-navigation__nav-items-wrapper');
    var current_navItem, navDetailed;
    if (!navItemsWrapper) {
      return;
    }
    navItemsWrapper.style.width = '';
    navItem[0].classList.remove('show'); // hide search box

    navItem.forEach(function (item) {
      item.addEventListener('mouseenter', function (e) {
        var that = e.target;
        current_navItem = navItemsWrapper.querySelectorAll('.show');
        navDetailed = that.querySelector('.vodl-navigation__detail-box');

        // if that is not yet selected (has class 'show')
        if (!that.classList.contains('show')) {
          // unselect all tabs
          current_navItem.forEach(function (item) {
            item.classList.remove('show');
          });

          // select current tab
          that.classList.add('show');

          // when there's a sub tab - select it
          if (null !== navDetailed) {
            navDetailed.classList.add('show'); // show detail box
            that.querySelector('.vodl-navigation__nav-triangle').classList.add('show'); // show triangle

            var leftPos = document.querySelector('.vodl-page-wrapper').offsetWidth - navDetailed.offsetWidth;
            navDetailed.style.left = leftPos + 'px';
          }
        }
        // lazy load images
        var tabImage = that.querySelector('.lazy-sample-img');
        if (null !== tabImage && tabImage.dataset.src) {
          tabImage.src = tabImage.dataset.src;
          tabImage.classList.remove('lazy-sample-img');
          delete tabImage.dataset.src;
        }
      });
    });
    navItemsWrapper.addEventListener('mouseleave', function (et) {
      var elemShown = et.target.querySelectorAll('.show');
      elemShown.forEach(function (elem) {
        elem.classList.remove('show');
      });
    });
  }
  function mobileNavigation() {
    var navItem = $('.vodl-navigation__nav-tab-wrapper'),
      // all Items
      navItemDetailed = $('.vodl-navigation__nav-tab-wrapper').has('.vodl-navigation__detail'),
      // only items with details
      navItemDirectClick = $('.vodl-navigation__nav-tab-wrapper:not(:has(.vodl-navigation__detail))').has('> a.vodl-navigation__nav-item'),
      navItemsWrapper = $('.vodl-navigation__nav-items-wrapper'),
      navIconMobile = $('.vodl-navigation__mobile-nav');
    navItem.find('.show').removeClass('show');
    navItem.children().css('left', 0);
    navItem.off();
    navItemDetailed.on('click', function () {
      var otherDetailed = $(this).siblings().children('.show');
      otherDetailed.removeClass('show');
      navDetailed = $(this).find('.vodl-navigation__detail-box, .vodl-navigation__nav-item-rotating-arrow');
      navDetailed.toggleClass('show');
      if (navDetailed.hasClass('show')) {
        navItemsWrapper.css('width', '100vw');
      } else {
        navItemsWrapper.css('width', '100%');
      }
    });
    navIconMobile.off().on('click', function () {
      navItemsWrapper.toggleClass('show');
    });
    navItemDirectClick.on('click', function () {
      $(this).find('a').get(0).click();
    });
  }
  function em(input) {
    var emSize = parseFloat($('html').css('font-size'));
    return emSize * input;
  }
})(window, document, jQuery);
"use strict";

(function (window, document, undefined) {
  "use strict";

  var Vue = window.Vue || false,
    logger;

  /**
   * Renders the forum component in the specified wrapper element.
   *
   * This function initializes a Vue.js app to render a forum component within
   * a designated HTML element. The forum component is sourced from the
   * "@russmedia-frontend/np-forum" library. It is passed various properties
   * required for configuring the forum, such as postId, ssoId, and commentData.
   *
   * @function renderForum
   * @global
   */
  var renderNavigation = function renderNavigation(navigationData) {
    Vue.createApp({
      components: {
        Navigation: window["@russmedia-frontend/np-common"].Navigation
      },
      setup: function setup() {
        var evoSSOCookie = "";
        var sessionCookie = "";
        document.cookie.split(";").forEach(function (cookie) {
          cookie = cookie.trim();
          if (cookie.startsWith("EvoSSO=")) {
            evoSSOCookie = cookie.substring("EvoSSO=".length);
          }
          if (cookie.startsWith("SsoSessionCookie=")) {
            sessionCookie = cookie.substring("SsoSessionCookie=".length);
          }
        });
        return {
          bottomMenu: navigationData.bottom,
          topMenu: navigationData.top,
          mainMenu: navigationData.main,
          sessionCookie: sessionCookie,
          evoSSOCookie: evoSSOCookie,
          isHomePage: window.location.pathname === "/"
        };
      },
      template: "<Navigation\n          :bottomMenu=\"bottomMenu\"\n          :topMenu=\"topMenu\"\n          :mainMenu=\"mainMenu\"\n          :sessionCookie=\"sessionCookie\"\n          :evoSSOCookie=\"evoSSOCookie\"\n          :isHomePage=\"isHomePage\"\n        ></Navigation>"
    }).mount("#vodl-navigation-wrapper");
  };

  /**
   * Grab the JSON that should be provided in the page and parse it.
   *
   * @return {object|boolean} The post data object on success, false otherwise.
   */
  var parseNavigationData = function parseNavigationData() {
    var navigationDataNode = document.querySelector("#navigationDataNode");
    var parsedNavigationData = {};
    try {
      parsedNavigationData = JSON.parse(navigationDataNode.innerHTML) || false;
    } catch (e) {
      return false;
    }
    return parsedNavigationData;
  };
  var _init = function _init() {
    try {
      logger = new window.RussMedia.Utils.Logger("[navigation] ") || {
        log: function log() {}
      };
    } catch (e) {
      logger = {
        log: function log() {}
      };
    }
    if (!Vue) {
      logger.log("_init: No Vue!");
      return;
    } else {
      logger.log("Load Vue component.");
    }
    var navigationData = parseNavigationData();
    if (!navigationData) {
      logger.log("_init: Missing mavigation data.");
      return;
    }
    renderNavigation(navigationData);
  };
  _init();
})(window, document);
"use strict";

(function (window, document, undefined) {
  'use strict';

  var axios = window.axios,
    Promise = window.Promise,
    rmSSO = window.RussMedia.SSO;
  window.tp = window.tp || [];

  // Create a logger instance with 💰 prefix.
  var logger = {};
  try {
    logger = new window.RussMedia.Utils.Logger(String.fromCodePoint(0x1F4B0));
  } catch (e) {
    logger = {
      log: function log() {}
    };
  }

  /**
   * Initialize and attach event handlers.
   *
   * @return {undefined}
   */
  var _init = function _init() {
    // The event 'start_upsell_flow' will trigger the whole process.
    window.addEventListener('start_upsell_flow', events.onStartUpsellFlow);
  };

  /**
   * A very basic state handler.
   *
   * @type {Object}
   */
  var state = {
    /**
     * A dummy Element we abuse as proxy for our state event handlers.
     *
     * @type {Element}
     */
    _proxy: document.createElement('proxy'),
    data: {
      error: '',
      entitlement: {},
      login: {
        email: '',
        password: '',
        username: '',
        terms: {
          E1: false,
          agb_vol: true
        }
      },
      notification: {
        title: '',
        message: '',
        button: ''
      },
      sso: {
        loginOrRegisterResult: {},
        userData: {}
      },
      step: '',
      upsell: {
        campno: ''
      },
      post: {
        id: null
      }
    },
    /**
     * Get a value from state identified by path.
     *
     * @param  {String}                       path The path to the state element, e.g. notification.title.
     *
     * @return {String|Number|Boolean|Object}      The retrieved value.
     */
    get: function get(path) {
      var keyPath = path.split('.'),
        res = this.data,
        i = 0,
        len = keyPath.length;
      try {
        for (; i < len; i++) {
          res = res[keyPath[i]];
        }
      } catch (e) {
        return null;
      }
      return res;
    },
    /**
     * Set a state value identified by path.
     *
     * @param {String}                       path  The path to the state element, e.g. notification.title.
     * @param {String|Number|Boolean|Object} value The value to set.
     */
    set: function set(path, value) {
      var keyPath = path.split('.'),
        res = this.data,
        i = 0,
        len = keyPath.length - 1;
      for (; i < len; i++) {
        res = res[keyPath[i]];
      }
      var oldValue = res[keyPath[i]];
      if (oldValue !== value) {
        res[keyPath[i]] = value;
        // Trigger a custom stateChange event so components may react to it.
        this.trigger('stateChange', {
          path: path,
          oldValue: oldValue,
          value: value
        });
      }
    },
    /**
     * Remove an event handler from state with the given name.
     *
     * @param {String}   eventName The name of the event, e.g. 'stateChange'
     * @param {Function} callback  The callback to remove.
     */
    off: function off(eventName, callback) {
      this._proxy.removeEventListener(eventName, callback);
    },
    /**
     * Add an event handler to state with the given name.
     *
     * @param {String}   eventName The name of the event, e.g. 'stateChange'
     * @param {Function} callback  The callback to add.
     */
    on: function on(eventName, callback) {
      this._proxy.addEventListener(eventName, callback);
    },
    /**
     * Trigger a state event with the given eventName and a given obj as payload.
     *
     * @param {String} eventName The name of the event, e.g. 'stateChange'
     * @param {Object} obj       The event payload.
     */
    trigger: function trigger(eventName, obj) {
      this._proxy.dispatchEvent(new CustomEvent(eventName, {
        detail: obj
      }));
    }
  };

  /**
   * A collection of event handlers.
   *
   * @type {Object}
   */
  var events = {
    /**
     * Event handler for form input changes.
     *
     * @param {Event} e The event object.
     */
    onInputChange: function onInputChange(e) {
      var currentInput = e.currentTarget || false;
      if (currentInput && currentInput.dataset.state) {
        switch (currentInput.type) {
          case 'checkbox':
          case 'radio':
            logger.log('events.onInputChange: ', currentInput.dataset.state, currentInput.checked);
            state.set(currentInput.dataset.state, currentInput.checked);
            break;
          default:
            var sanitizedValue = helpers.sanitizeFieldValue(currentInput);
            if (sanitizedValue !== currentInput.value) {
              currentInput.value = sanitizedValue;
            }
            logger.log('events.onInputChange: ', currentInput.dataset.state, sanitizedValue);
            state.set(currentInput.dataset.state, sanitizedValue);
            break;
        }
      }
    },
    /**
     * Handle the close button click in the modal.
     *
     * @return {undefined}
     */
    onModalCloseButtonClicked: function onModalCloseButtonClicked() {
      var currentStep = state.get('step');
      if ('showEntitlementForm' === currentStep) {
        helpers.trackEventAction('upsell_login_closebutton');
      }
      if ('showUpsellSaveForm' === currentStep) {
        var form = forms.upsellSave;
        if ('existingUser' === form.mode) {
          helpers.trackEventAction('upsell_digi_closebutton');
        }
        if ('newUser' === form.mode) {
          helpers.trackEventAction('upsell_print_closebutton');
        }
      }
      modal.close();
    },
    /**
     * Handle the "outside" click of the modal.
     *
     * @param  {Event} ev The event object.
     * @return {undefined}
     */
    onModalWrapperClicked: function onModalWrapperClicked(ev) {
      // We only accept clicks outside the actual form, so...
      if (ev.target === ev.currentTarget) {
        var currentStep = state.get('step');
        if ('showEntitlementForm' === currentStep) {
          helpers.trackEventAction('upsell_login_closebutton');
        }
        if ('showUpsellSaveForm' === currentStep) {
          var form = forms.upsellSave;
          if ('existingUser' === form.mode) {
            helpers.trackEventAction('upsell_digi_closebutton');
          }
          if ('newUser' === form.mode) {
            helpers.trackEventAction('upsell_print_closebutton');
          }
        }
        modal.close();
      }
    },
    /**
     * Handle any click on the notfication modal.
     */
    onNotificationClicked: function onNotificationClicked() {
      window.location.reload();
    },
    /**
     * Handle the 'start_upsell_flow' event.
     */
    onStartUpsellFlow: function onStartUpsellFlow() {
      upsellFlow._init();
    },
    /**
     * Handles general state change events and passes the data on to the form state handlers.
     *
     * @param {Event} e The event object.
     */
    onStateChange: function onStateChange(e) {
      var data = e.detail || {};
      data.path = data.path || false;
      if ('step' !== data.path) {
        // logger.log('state ' + data.path + ' changed from: ', data.oldValue, 'to: ', data.value);
        forms.upsellEntitlement.onStateChange(data);
        forms.upsellSave.onStateChange(data);
      }
    },
    /**
     * Handles state changes of the (workflow-) step property.
     *
     * @param {Event} e The event object.
     */
    onStepChange: function onStepChange(e) {
      var data = e.detail || {};
      data.path = data.path || false;
      if ('step' === data.path) {
        // logger.log('step changed from: ', data.oldValue, 'to: ', data.value);

        if (upsellFlow.steps[data.value]) {
          logger.log('now calling upsellFlow.steps.' + data.value);
          upsellFlow.steps[data.value]();
        } else {
          logger.log('nothing to do for step ', data.value);
        }
      }
    },
    /**
     * Handle the upsell entitlement form submission event.
     *
     * @param  {Event}   e The event object.
     *
     * @return {Boolean}   Always returns false.
     */
    onUpsellEntitlementSubmitted: function onUpsellEntitlementSubmitted(e) {
      e.preventDefault();
      state.set('step', 'submitEntitlementForm');
      return false;
    },
    /**
     * Handle the upsell save form submission event.
     *
     * @param  {Event}   e The event object.
     *
     * @return {Boolean}   Always returns false.
     */
    onUpsellSaveSubmitted: function onUpsellSaveSubmitted(e) {
      e.preventDefault();
      state.set('step', 'submitUpsellSaveForm');
      return false;
    },
    /**
     * Handles clicks on the toggle arrow of the upsell save form,
     * which will expand or minimize the "terms and conditons" section.
     *
     */
    onUpsellSaveToggleArrowClicked: function onUpsellSaveToggleArrowClicked() {
      var termsLabel = forms.upsellSave.elements.termsLabel();
      if (termsLabel) {
        if (termsLabel.classList.contains('toggle')) {
          termsLabel.classList.remove('toggle');
        } else {
          termsLabel.classList.add('toggle');
        }
      }
    }
  };

  /**
   * A collection of form objects.
   *
   * @type {Object}
   */
  var forms = {
    /**
     * The form used for checking the upsell entitlement.
     * A valid submission entitles the user for doing the upsell in the next step.
     *
     * @type {Object}
     */
    upsellEntitlement: {
      config: {},
      /**
       * Initialize the upsell entitlement form.
       *
       * @return {Promise} A promise that will be resolved on success.
       */
      _init: function _init() {
        return new Promise(function (resolve, reject) {
          // Get the form only if it is not already loaded.
          var _this = forms.upsellEntitlement;
          if (_this.elements.configNode() && _this.elements.form()) {
            // Make sure the thing is open.
            modal.open();
            resolve('upsellEntitlement form already initialized');
            return;
          }

          // Retrieve the form via the form API.
          requests.getForm('upsell-entitlement').then(function (data) {
            // Inject the fetched html into the page.
            var formContent = document.querySelector('.vodl-form');
            formContent.parentElement.replaceWith(helpers.htmlToElement(data));

            // Fetch the forms configuration.
            _this.config = helpers.parseFormConfig(_this.elements.configNode());
            logger.log('forms.upsellEntitlement._init config:', _this.config);

            // Prefill data from state and bind to state changes.
            _this.initFromState();

            // Attach the submit event for the form itself.
            _this.elements.form().removeEventListener('submit', events.onUpsellEntitlementSubmitted);
            _this.elements.form().addEventListener('submit', events.onUpsellEntitlementSubmitted);

            // Attach events for closing the modal
            modal.elements.wrapper().addEventListener('click', events.onModalWrapperClicked);
            modal.elements.closeButton().addEventListener('click', events.onModalCloseButtonClicked);

            // Open the thing.
            modal.open();
            resolve('upsellEntitlement form initialized');
          })["catch"](function (error) {
            logger.log('requests.getForm("upsell-entitlement") failed: ', error);
            reject(error);
          });
        });
      },
      // Access to DOM elements of the form.
      elements: {
        configNode: function configNode() {
          return document.querySelector('.vodl-form--upsell-entitlement script[type="application/json"]');
        },
        form: function form() {
          return document.querySelector('.vodl-form--upsell-entitlement form');
        }
      },
      /**
       * Prefill form data from state
       * and bind state changes to the form elements.
       *
       */
      initFromState: function initFromState() {
        var _this = forms.upsellEntitlement;
        var statefulElements = _this.elements.form().querySelectorAll('[data-state]');
        statefulElements.forEach(function (elem) {
          helpers.setTextOrValue(elem, state.get(elem.dataset.state));
          elem.addEventListener('change', events.onInputChange);
        });
      },
      /**
       * The event handler for state changes.
       *
       * @param {Object} data An object containing information about the changed state value.
       */
      onStateChange: function onStateChange(data) {
        var _this = forms.upsellEntitlement;
        if (!_this.elements.form()) {
          return;
        }
        var statefulElements = _this.elements.form().querySelectorAll('[data-state="' + data.path + '"]');
        logger.log('forms.upsellEntitlement.onStateChange:', data, statefulElements);
        statefulElements.forEach(function (elem) {
          helpers.setTextOrValue(elem, data.value);
        });
      },
      /**
       * Basic validation of the form inputs.
       * Gets the trimmed input of the username and password field.
       * If one of them is empty, the resulting object will contain one or more errors.
       * The validated input is assigned to the data property in the resulting object.
       *
       * @return {Object} Object with the validation result.
       */
      validate: function validate() {
        var _this = forms.upsellEntitlement;
        var login = state.get('login.username') || false;
        var password = state.get('login.password') || false;
        var result = {};
        result.data = {};
        result.data.login = login;
        result.data.password = password;
        result.errors = [];
        if (!login) {
          result.errors.push(_this.config.messages.errors.emptyLogin);
        }
        if (!password) {
          result.errors.push(_this.config.messages.errors.emptyPassword);
        }
        return result;
      }
    },
    /**
     * The form used for the final upsell step.
     * If the user is not in the SSO we will show input fields for email and password
     * which then will be used to create a new user on the SSO.
     * If the user is already in the SSO we will just show a confirmation button to finalize the upsell.
     *
     * @type {Object}
     */
    upsellSave: {
      config: {},
      // mode can either be 'existingUser' or 'newUser'.
      mode: 'existingUser',
      // upsellType can either be 'vn' or 'neue'.
      upsellType: 'vn',
      // long offer description
      offerLong: '',
      // short offer description
      offerShort: '',
      /**
       * Initialize the upsell save form.
       *
       * @return {Promise} A promise that will be resolved on success.
       */
      _init: function _init() {
        // Grab some info from the entitlement:
        // - newUser or existingUser?
        // - upsellType vn or neue?
        // - long and short offer texts
        var entitlement = state.get('entitlement');
        this.mode = entitlement.sso_id ? 'existingUser' : 'newUser';
        this.upsellType = 'vn' === entitlement.upsell_type ? 'vn' : 'neue';
        this.offerLong = entitlement.offer_long;
        this.offerShort = entitlement.offer_short;
        return new Promise(function (resolve, reject) {
          // Get the form only if it is not already loaded.
          var _this = forms.upsellSave;
          if (_this.elements.configNode() && _this.elements.form()) {
            // Apply the mode (newUser or existingUser).
            _this.applyMode();
            // Make sure the thing is open.
            modal.open();
            resolve(_this.mode);
            return;
          }

          // Retrieve the form via the form API.
          requests.getForm('upsell-save').then(function (data) {
            // Inject the fetched html into the page.
            var formContent = document.querySelector('.vodl-form');
            formContent.parentElement.replaceWith(helpers.htmlToElement(data));

            // Fetch the forms configuration.
            _this.config = helpers.parseFormConfig(_this.elements.configNode());
            logger.log('forms.upsellSave._init config:', _this.config, _this.upsellType, _this.mode);

            // Prefill data from state and bind to state changes.
            _this.initFromState();

            // Set short and long offer texts.
            _this.elements.description().innerHTML = _this.offerLong;
            _this.elements.existingUserPlaceholder().innerHTML = _this.offerShort;
            // Set terms policy text depending on upsellType (VN or NEUE).
            _this.elements.termsPolicy().innerHTML = _this.config.texts[_this.upsellType].termsAndConditions;

            // Attach events for the form itself:
            // - submiting the form
            // - clicking the toggle arrow for expanding/minimzing the terms and conditions section.
            _this.elements.form().removeEventListener('submit', events.onUpsellSaveSubmitted);
            _this.elements.form().addEventListener('submit', events.onUpsellSaveSubmitted);
            _this.elements.toggleArrow().removeEventListener('click', events.onUpsellSaveToggleArrowClicked);
            _this.elements.toggleArrow().addEventListener('click', events.onUpsellSaveToggleArrowClicked);

            // Attach events for closing the modal
            modal.elements.wrapper().addEventListener('click', events.onModalWrapperClicked);
            modal.elements.closeButton().addEventListener('click', events.onModalCloseButtonClicked);

            // Apply the mode (newUser or existingUser).
            _this.applyMode();
            // Open the thing.
            modal.open();
            resolve(_this.mode);
          })["catch"](function (error) {
            logger.log('requests.getForm("upsell-save") failed: ', error);
            reject(error);
          });
        });
      },
      /**
       * Depending on the mode we show or hide certian UI elements.
       */
      applyMode: function applyMode() {
        var _this = forms.upsellSave;
        if ('existingUser' === _this.mode) {
          _this.elements.emailField().style.display = 'none';
          _this.elements.passwordField().style.display = 'none';
          _this.elements.existingUserPlaceholder().style.display = 'flex';
          _this.elements.visibleTerms().forEach(function (item) {
            item.style.display = 'none';
          });
        } else {
          _this.elements.emailField().style.display = 'block';
          _this.elements.passwordField().style.display = 'block';
          _this.elements.existingUserPlaceholder().style.display = 'none';
          _this.elements.visibleTerms().forEach(function (item) {
            item.style.display = 'flex';
          });
        }
      },
      // Access to DOM elements of the form.
      elements: {
        configNode: function configNode() {
          return document.querySelector('.vodl-form--upsell-save script[type="application/json"]');
        },
        description: function description() {
          return document.querySelector('.vodl-form--upsell-save .vodl-form__description');
        },
        emailField: function emailField() {
          return document.querySelector('.vodl-form--upsell-save .vodl-login__email');
        },
        existingUserPlaceholder: function existingUserPlaceholder() {
          return document.querySelector('.vodl-form--upsell-save .vodl-form__existing-user-placeholder');
        },
        form: function form() {
          return document.querySelector('.vodl-form--upsell-save form');
        },
        passwordField: function passwordField() {
          return document.querySelector('.vodl-form--upsell-save .vodl-login__password');
        },
        termsLabel: function termsLabel() {
          return document.querySelector('.vodl-form--upsell-save .vodl-login__agb-label');
        },
        termsPolicy: function termsPolicy() {
          return document.querySelector('.vodl-form--upsell-save .vodl-login__agb-policy');
        },
        toggleArrow: function toggleArrow() {
          return document.querySelector('.vodl-form--upsell-save .vodl-login__agb-arrow');
        },
        visibleTerms: function visibleTerms() {
          return document.querySelectorAll('.vodl-form--upsell-save .vodl-login__agb-wrapper:not(.vodl-login__agb-wrapper--policy):not(.vodl-login__agb-wrapper--hidden)');
        }
      },
      /**
       * Prefill form data from state
       * and bind state changes to the form elements.
       *
       */
      initFromState: function initFromState() {
        var _this = forms.upsellSave;
        var statefulElements = _this.elements.form().querySelectorAll('[data-state]');
        statefulElements.forEach(function (elem) {
          helpers.setTextOrValue(elem, state.get(elem.dataset.state));
          elem.addEventListener('change', events.onInputChange);
        });
      },
      /**
       * The event handler for state changes.
       *
       * @param {Object} data An object containing information about the changed state value.
       */
      onStateChange: function onStateChange(data) {
        var _this = forms.upsellSave;
        if (!_this.elements.form()) {
          return;
        }
        var statefulElements = _this.elements.form().querySelectorAll('[data-state="' + data.path + '"]');
        logger.log('forms.upsellSave.onStateChange:', data, statefulElements);
        statefulElements.forEach(function (elem) {
          helpers.setTextOrValue(elem, data.value);
        });
      },
      /**
       * Basic validation of the form inputs.
       * Gets the trimmed input of the email and password field.
       * If one of them is empty or too short, the resulting object will contain one or more errors.
       * The validated input is assigned to the data property in the resulting object.
       *
       * @return {Object} Object with the validation result.
       */
      validate: function validate() {
        var _this = forms.upsellSave;
        var email = state.get('login.email') || false;
        var password = state.get('login.password') || false;
        var result = {};
        result.data = {};
        result.data.email = email;
        result.data.password = password;
        result.errors = [];

        // No inputs to check really in this case.
        if ('existingUser' === _this.mode) {
          return result;
        }
        if (!email || email.length < 6) {
          result.errors.push(_this.config.messages.errors.invalidEmail);
        }
        if (!password || password.length < 6) {
          result.errors.push(_this.config.messages.errors.invalidPassword);
        }
        return result;
      }
    }
  };

  /**
   * Collection of helper methods.
   *
   * @type {Object}
   */
  var helpers = {
    /**
     * Parses the included JSON of the given configNode
     * and returns the resulting object.
     *
     * @param  {Element} configNode The Element to parse.
     * @return {Object}             The parsed config object.
     */
    parseFormConfig: function parseFormConfig(configNode) {
      var defaultConfig = {
        messages: {
          errors: {
            emptyLogin: 'Empty login field.',
            emptyPassword: 'Empty password field.'
          }
        }
      };
      var parsedConfig = {};
      if (!configNode) {
        return defaultConfig;
      }
      try {
        parsedConfig = JSON.parse(configNode.innerHTML) || {};
      } catch (e) {
        return defaultConfig;
      }
      return parsedConfig;
    },
    /**
     * Convert a given HTML string to a DOM element.
     *
     * @param  {String}  html The source HTML string.
     *
     * @return {Element}      The resulting DOM element.
     */
    htmlToElement: function htmlToElement(html) {
      var template = document.createElement('template');
      html = html.trim();
      template.innerHTML = html;
      return template.content.firstChild;
    },
    /**
     * Sanitize the value of a given input field.
     * Currently we just trim() the value, but we could do more depending
     * on the input field type.
     *
     * @param {Element} inputField The input field element to check.
     */
    sanitizeFieldValue: function sanitizeFieldValue(inputField) {
      var value = inputField.value.trim();
      // @TODO: Depending on field type we could do different things here.
      return value;
    },
    /**
     * This method is used for setting values on input fields, e.g. on state changes.
     * Depending on the element.type (text, checkbox...) we need to do different things.
     *
     * @param {Element}        element The element node.
     * @param {String|Boolean} value   The value to set.
     *
     */
    setTextOrValue: function setTextOrValue(element, value) {
      var tagName = element.tagName || false;
      if (!tagName) {
        return;
      }
      if ('INPUT' === tagName) {
        switch (element.type) {
          case 'checkbox':
          case 'radio':
            if (value !== element.checked) {
              element.checked = value;
            }
            break;
          default:
            if (value !== element.value) {
              element.value = value;
            }
            break;
        }
      } else {
        if (value !== element.innerHTML) {
          element.innerHTML = value;
        }
      }
    },
    /**
     * Place the SSO cookie images as it would be done in a normal registration or login flow.
     * We use methods from window.RussMedia.SSO as far as possible.
     *
     * @return {Promise} A promise that is resolved on success.
     */
    ssoPlaceCookies: function ssoPlaceCookies() {
      return new Promise(function (resolve, reject) {
        var options = rmSSO.getOptions();

        // Delete possibly existing cookies first.
        rmSSO.deleteCookie(options.cookies.ssoCookieName);
        rmSSO.deleteCookie(options.cookies.sessionCookieName);

        // Place cookie image tags in the options.cookies.container
        var loginOrRegisterResult = state.get('sso.loginOrRegisterResult');
        var userData = state.get('sso.userData');
        if (!loginOrRegisterResult.cookie) {
          reject('No cookie images to inject!', loginOrRegisterResult);
          return;
        }
        rmSSO.loginStatusEventHandler.trigger(userData);
        // options.cookies.container is actually a jQuery object
        //  - so we are be able to use the jQuery methods append() and find() on it.
        options.cookies.container.append(loginOrRegisterResult.cookie);
        options.cookies.container.find('img:last').on('load', function () {
          rmSSO.waitForCookieAsync().then(function () {
            resolve('Cookie images loaded!');
          }, function () {
            reject('Cookie images did not load!');
          });
        });
        logger.log('helpers.ssoPlaceCookies SSO options, ssoResult: ', options, loginOrRegisterResult);
      });
    },
    /**
     * Track a given event action in the workflow (Google Analytics only for now).
     *
     * @param  {string} action The identifier of the action to track.
     */
    trackEventAction: function trackEventAction(action) {
      if (window.dataLayer) {
        var payload = {
          event: 'genericEvent',
          eventCategory: 'checkout',
          eventAction: action,
          eventLabel: window.location.href
        };
        logger.log('helpers.trackEventAction payload:', payload);
        window.dataLayer.push(payload);
        document.dispatchEvent(new CustomEvent('hansrmdtevent', {
          detail: payload
        }));
      }
    },
    /**
     * Track a virtual pageview with the given path (Google Analytics only for now).
     *
     * @param  {string} action The pageview path to track.
     */
    trackPageView: function trackPageView(path) {
      if (window.dataLayer) {
        var payload = {
          event: 'virtualPageview',
          virtualPagePath: path
        };
        logger.log('helpers.trackPageView payload:', payload);
        window.dataLayer.push(payload);
        document.dispatchEvent(new CustomEvent('hansrmdtevent', {
          detail: payload
        }));
      }
    }
  };

  /**
   * Collection of methods for handling the modal window.
   *
   * @type {Object}
   */
  var modal = {
    /**
     * Close the modal dialogue.
     */
    close: function close() {
      logger.log('modal.close');
      this.elements.wrapper().style.display = 'none';
    },
    // Access to DOM elements of the modal.
    elements: {
      closeButton: function closeButton() {
        return document.querySelector('.vodl-form--modal .vodl-form__close');
      },
      loadingSpinner: function loadingSpinner() {
        return document.querySelector('.vodl-form--modal .vodl-form__loading');
      },
      loginWrapper: function loginWrapper() {
        return document.querySelector('.vodl-form--modal .vodl-login__wrapper');
      },
      wrapper: function wrapper() {
        return document.querySelector('.vodl-form--modal');
      }
    },
    loadingIndicator: {
      /**
       * End the loading indicator.
       */
      end: function end() {
        var _this = modal;
        _this.elements.loadingSpinner().style.display = 'none';
        _this.elements.loginWrapper().style.display = 'block';
      },
      /**
       * Start the loading indicator.
       */
      start: function start() {
        var _this = modal;
        _this.elements.loadingSpinner().style.display = 'block';
        _this.elements.loginWrapper().style.display = 'none';
      }
    },
    /**
     * Open the modal dialogue.
     */
    open: function open() {
      this.elements.wrapper().style.display = 'flex';
    }
  };

  /**
   * Collection of methods for handling the notifcation modal.
   *
   * @type {Object}
   */
  var notification = {
    // Access to DOM elements of the notification.
    elements: {
      header: function header() {
        return document.querySelector('.vodl-notification .vodl-notification__header');
      },
      headerText: function headerText() {
        return document.querySelector('.vodl-notification .vodl-notification__header-text');
      },
      text: function text() {
        return document.querySelector('.vodl-notification .vodl-notification__text');
      },
      wrapper: function wrapper() {
        return document.querySelector('.vodl-notification--modal');
      },
      notification: function notification() {
        return document.querySelector('.vodl-notification');
      },
      body: function body() {
        return document.querySelector('.vodl-notification .vodl-notification__body');
      },
      button: function button() {
        return document.querySelector('.vodl-notification .vodl-notification__button');
      },
      buttonLabel: function buttonLabel() {
        return document.querySelector('.vodl-notification .vodl-notification__button .vodl-button__label');
      }
    },
    /**
     * Show the notification.
     * Data is picked from state.
     */
    show: function show() {
      var titleText = state.get('notification.title') || 'Finished!';
      var messageText = state.get('notification.message') || 'We are totally done here...';
      var buttonText = state.get('notification.button') || 'Got it';

      // Use the V+ style.
      this.elements.notification().classList.add('vodl-notification--vplus');

      // Set notification title and message.
      this.elements.headerText().append(document.createTextNode(titleText));
      this.elements.text().append(document.createTextNode(messageText));

      // Assign click event handler for closing the notfication.
      this.elements.wrapper().removeEventListener('click', events.onNotificationClicked);
      this.elements.wrapper().addEventListener('click', events.onNotificationClicked);

      // Addding the button if needed.
      if (!this.elements.button()) {
        var notificationButton = document.createElement('div');
        notificationButton.innerHTML = '<div class="vodl-notification__button"><button class="vodl-button vodl-button--red" type="button"><span class="vodl-button__label">OK</span></button></div>';
        this.elements.body().append(notificationButton);
      }
      this.elements.buttonLabel().innerHTML = buttonText;

      // Show the thing.
      this.elements.wrapper().style.display = 'flex';
    }
  };

  /**
   * Collection of methods for handling requests to the REST and form APIs.
   *
   * @type {Object}
   */
  var requests = {
    formApi: '/api/nnp/get_form',
    formsCache: {},
    upsellApiBase: '/wp-json/russmedia-newspaper-upsell/v1/',
    /**
     * Makes a call on the upsell REST API with the given route and payload.
     *
     * @param  {String}  route   The route name, e.g. 'upsell/entitlement'.
     * @param  {Object}  payload Optional payload to send with the request.
     *
     * @return {Promise}         A promise that will either be resolved or rejected.
     */
    callApi: function callApi(route, payload) {
      var url = this.upsellApiBase + route;
      payload = payload || {};
      return axios({
        method: 'post',
        url: url,
        data: payload
      }).then(function (response) {
        return response.data;
      })["catch"](function (error) {
        var message = false;
        logger.log('requests.callApi error.response:', error.response);
        if (error.response && error.response.data) {
          if (error.response.data.data && error.response.data.data.user_error_text) {
            message = error.response.data.data.user_error_text;
          } else if (error.response.data.message) {
            message = error.response.data.message;
          }
          if (message) {
            throw new Error(message);
          } else {
            throw error;
          }
        } else {
          throw error;
        }
      });
    },
    /**
     * Fetches a form via the formApi.
     * Saves the result as entry in formsCache, so
     * subsequent calls do not trigger a request again.
     *
     * @param  {String}  id  The name/id of the form, e.g. 'send-otp'.
     *
     * @return {Promise}     A promise that will either be resolved or rejected.
     */
    getForm: function getForm(id) {
      // If we already loaded this, no need to do it again.
      if (requests.formsCache[id]) {
        return Promise.resolve(this.formsCache[id]);
      }
      return axios.get(this.formApi, {
        params: {
          f: id
        }
      }).then(function (response) {
        var errorMessage = response.data.error || false;
        if (errorMessage) {
          logger.log('getForm error:', errorMessage);
          throw new Error(errorMessage);
        }

        // Save the response data in formsCache, so we do not need to load it again,
        // should we need it.
        requests.formsCache[id] = response.data;
        return response.data;
      })["catch"](function (error) {
        // Handle error.
        logger.log('getForm error:', error);
        throw error;
      });
    }
  };

  /**
   * The definition of the upsell flow steps.
   * Each step can be triggered by changing the states step property.
   *
   * @type {Object}
   */
  var upsellFlow = {
    /**
     * Initialize the upsell flow.
     */
    _init: function _init() {
      state.set('error', '');
      state.set('step', '');
      state.set('login.email', '');
      state.set('login.password', '');
      state.set('login.username', '');
      tp.customVariables = tp.customVariables || {};
      tp.customVariables.upsellCampaign = tp.customVariables.upsellCampaign || '';
      state.set('upsell.campno', tp.customVariables.upsellCampaign);
      var upsellData = document.querySelector('#upsellData');
      var parsedData = {};
      try {
        parsedData = JSON.parse(upsellData.innerHTML);
        state.set('post.id', parsedData.postId);
      } catch (e) {
        logger.log('could not parse upsellData');
      }

      // Subscribe to state changes.
      state.on('stateChange', events.onStepChange);
      state.on('stateChange', events.onStateChange);
      state.set('step', 'showEntitlementForm');
    },
    steps: {
      /**
       * Step for showing the upsell-entitlement form.
       */
      showEntitlementForm: function showEntitlementForm() {
        logger.log('steps.showEntitlementForm');
        forms.upsellEntitlement._init().then(function () {
          helpers.trackEventAction('upsell_login');
          helpers.trackPageView('/vplus/checkout/upsell/login');
        })["catch"](function (error) {
          logger.log(error);
          modal.close();
        });
      },
      /**
       * Step for showing the upsell-save form.
       */
      showUpsellSaveForm: function showUpsellSaveForm() {
        logger.log('steps.showUpsellSaveForm');
        forms.upsellSave._init().then(function (mode) {
          if ('existingUser' === mode) {
            helpers.trackEventAction('upsell_digi_start');
            helpers.trackPageView('/vplus/checkout/upsell/digi/offer');
          }
          if ('newUser' === mode) {
            helpers.trackEventAction('upsell_print_start');
            helpers.trackPageView('/vplus/checkout/upsell/print/offer');
          }
        })["catch"](function (error) {
          logger.log(error);
          modal.close();
        });
      },
      /**
       * Step for processing the submitted upsell-entitlement form.
       */
      submitEntitlementForm: function submitEntitlementForm() {
        logger.log('steps.submitEntitlementForm');
        var form = forms.upsellEntitlement;

        // Clear any possible errors.
        state.set('error', '');

        // Basic data validation.
        var validatedFormData = form.validate();
        logger.log('steps.submitEntitlementForm validation:', validatedFormData);
        if (validatedFormData.errors && validatedFormData.errors.length > 0) {
          state.set('error', validatedFormData.errors.join('<br> '));
          state.set('step', 'showEntitlementForm');
          return;
        }

        // Still here? Call the upsell REST API.
        modal.loadingIndicator.start();
        var apiData = {
          log: validatedFormData.data.login,
          pwd: validatedFormData.data.password,
          campno: state.get('upsell.campno'),
          postId: state.get('post.id')
        };

        // Call the upsell-entitlement API and handle the result.
        requests.callApi('upsell/entitlement', apiData).then(function (responseData) {
          // We only get here if the API returned a 200.

          modal.loadingIndicator.end();
          modal.close();
          logger.log('steps.submitEntitlementForm responseData:', responseData);
          var entitlement = responseData.entitlement;
          state.set('entitlement', entitlement);
          responseData.additional_data = responseData.additional_data || {};
          responseData.additional_data.sso = responseData.additional_data.sso || {};
          responseData.additional_data.sso.login_result = responseData.additional_data.sso.login_result || {};
          responseData.additional_data.sso.user_data = responseData.additional_data.sso.user_data || {};
          state.set('sso.loginOrRegisterResult', responseData.additional_data.sso.login_result);
          state.set('sso.userData', responseData.additional_data.sso.user_data);

          // Entitlement granted:
          // Save result in state and go to next step to finish the upsell.
          if (entitlement.grant) {
            state.set('error', '');
            if (entitlement.subscriber.email) {
              state.set('login.email', entitlement.subscriber.email);
            }
            state.set('login.password', '');
            state.set('login.username', '');
            state.set('step', 'showUpsellSaveForm');
            return;
          }

          // Entitlement not granted:
          // Save result in state. Depending on refusal:
          //  - has_digital_access: inform user, login, done
          //  - invalid_credentials: stay here & let user try again
          //  - no_active_print_subscription: stay here & let user try again
          //  - paywall_error: technical issue, stay here & let user tr again.
          if (!entitlement.grant) {
            logger.log('entitlement not granted');
            switch (entitlement.refusal.code) {
              case 'has_digital_access':
                // This is actually the only case, where a non-granted entitlement results in a finishing notification.
                // The user already has digital access, so we just need to make sure he is logged-in correctly, then we
                // may show him a notication that he does not need to upgrade his subscription.
                helpers.trackEventAction('upsell_digi_alreadyaccess');
                state.set('notification', {
                  title: forms.upsellEntitlement.config.notifications.hasDigitalAccess.title,
                  message: entitlement.refusal.message,
                  button: forms.upsellEntitlement.config.notifications.hasDigitalAccess.button
                });
                state.set('step', 'upsellComplete');
                break;
              default:
                // Everything else is an error and we need to go back to the upsell-entitlement form.
                helpers.trackEventAction('upsell_abort');
                state.set('error', entitlement.refusal.message);
                state.set('step', 'showEntitlementForm');
                break;
            }
          }
        })["catch"](function (responseError) {
          // We only get here if the API did NOT return a 200.
          // This can happpen e.g. if a parameter is missing.
          modal.loadingIndicator.end();
          var errors = [];
          errors.push(responseError.message);
          helpers.trackEventAction('upsell_abort');
          state.set('error', errors.join('<br> '));
          logger.log('steps.submitEntitlementForm responseError:', responseError);
          state.set('step', 'showEntitlementForm');
        });
      },
      /**
       * Step for processing the submitted upsell-save form.
       */
      submitUpsellSaveForm: function submitUpsellSaveForm() {
        logger.log('steps.submitUpsellSaveForm');
        var form = forms.upsellSave;
        // Clear any possible errors.
        state.set('error', '');

        // Basic data validation.
        var validatedFormData = form.validate();
        logger.log('steps.submitUpsellSaveForm validation:', validatedFormData);
        if (validatedFormData.errors && validatedFormData.errors.length > 0) {
          state.set('error', validatedFormData.errors.join('<br> '));
          state.set('step', 'showUpsellSaveForm');
          return;
        }

        // Still here? Call the upsell REST API.
        modal.loadingIndicator.start();
        var entitlement = state.get('entitlement') || {};
        var upsellType = 'vn' === entitlement.upsell_type ? 'vn' : 'neue';

        // Build the payload for the API call below.
        var apiData = {};
        switch (form.mode) {
          case 'existingUser':
            // In this mode we only need the token we got from the upsell-entitlement API call.
            apiData = {
              token: state.get('entitlement.token'),
              campno: state.get('upsell.campno'),
              postId: state.get('post.id'),
              upsellType: upsellType
            };
            break;
          case 'newUser':
            // In this mode we need the token we got from the upsell-entitlement API call,
            // plus email, password and the terms&conditons.
            var apiTerms = [];
            var stateTerms = state.get('login.terms');
            for (var id in stateTerms) {
              if (stateTerms.hasOwnProperty(id)) {
                apiTerms.push({
                  id: id,
                  checked: stateTerms[id]
                });
              }
            }
            apiData = {
              email: state.get('login.email'),
              pwd: state.get('login.password'),
              terms: apiTerms,
              token: state.get('entitlement.token'),
              campno: state.get('upsell.campno'),
              postId: state.get('post.id'),
              upsellType: upsellType
            };
            break;
        }
        logger.log('steps.submitUpsellSaveForm apiData:', apiData);

        // Call the upsell-save API and handle the result.
        requests.callApi('upsell/save', apiData).then(function (responseData) {
          modal.loadingIndicator.end();
          modal.close();
          logger.log('steps.submitUpsellSaveForm responseData:', responseData);
          var form = forms.upsellSave;
          var upsell = responseData.upsell;
          state.set('upsell', upsell);

          // This is only available when upselling NEW users.
          if (responseData.additional_data) {
            responseData.additional_data = responseData.additional_data || {};
            responseData.additional_data.sso = responseData.additional_data.sso || {};
            responseData.additional_data.sso.register_result = responseData.additional_data.sso.register_result || {};
            responseData.additional_data.sso.user_data = responseData.additional_data.sso.user_data || {};
            state.set('sso.loginOrRegisterResult', responseData.additional_data.sso.register_result);
            state.set('sso.userData', responseData.additional_data.sso.user_data);
          }

          // Upsell successful:
          // - set correct state values, e.g. for the notification
          // - trigger the upsellComplete step
          if (upsell.success) {
            state.set('error', '');
            state.set('login.email', '');
            state.set('login.password', '');
            state.set('notification', {
              title: forms.upsellSave.config.notifications.upsellComplete.title,
              message: forms.upsellSave.config.notifications.upsellComplete.message,
              button: forms.upsellSave.config.notifications.upsellComplete.button
            });
            if ('existingUser' === form.mode) {
              helpers.trackEventAction('upsell_digi_complete');
              helpers.trackPageView('/vplus/checkout/upsell/digi/complete');
            }
            if ('newUser' === form.mode) {
              helpers.trackEventAction('upsell_print_complete');
              helpers.trackPageView('/vplus/checkout/upsell/print/complete');
            }
            state.set('step', 'upsellComplete');
            return;
          }

          // Upsell NOT successful:
          // Save result in state. Depending on failure:
          //  - no_upsell_available: should not happen, as we would not have gotten an entitlement in the first place.
          //  - paywall_error: technical issue, stay here & let user try again.
          //  - sso_email_in_use: stay here and let the user pick another email
          //  - sso_email_invalid: stay here and let the user pick another email
          //  - sso_email_provider_blacklisted: stay here and let the user pick another email
          //  - sso_password_invalid: stay here and let the user pick another password
          //  - sso_technical_issues: technical issue, stay here & let user try again.
          //  - sso_terms_and_conditions_not_accepted: stay here & let user try again
          if (!upsell.success) {
            logger.log('upsell not successful');
            switch (upsell.failure.code) {
              case 'no_upsell_available':
                state.set('error', upsell.failure.message);
                state.set('login.email', '');
                state.set('login.password', '');
                state.set('login.username', '');
                state.set('step', 'showEntitlementForm');
                break;
              default:
                state.set('error', upsell.failure.message);
                state.set('step', 'showUpsellSaveForm');
                break;
            }
          }
        })["catch"](function (responseError) {
          modal.loadingIndicator.end();
          var errors = [];
          errors.push(responseError.message);
          logger.log('steps.submitUpsellSaveForm responseError:', responseError);
          state.set('error', errors.join('<br> '));
          state.set('login.email', '');
          state.set('login.password', '');
          state.set('login.username', '');
          state.set('step', 'showEntitlementForm');
        });
      },
      /**
       * The final step.
       * We make sure the user is logged in by setting the SSO cookies,
       * then we show the notification modal.
       */
      upsellComplete: function upsellComplete() {
        // Trigger actual login mechanism (setting cookies)
        helpers.ssoPlaceCookies().then(function () {
          // Make sure no more modals are open.
          modal.close();
          notification.show();
        }, function (error) {
          logger.log('helpers.ssoPlaceCookies failed:', error);
        });
      }
    }
  };
  _init();
})(window, document);
"use strict";

// actualization popup
(function (document, window, undefined) {
  "use strict";

  var maxTime;

  // initialize counter for refresh popup
  function init(timer_value) {
    $(".vodl-notification__header span").on("click", close);
    $(".vodl-notification--modal").on("click", close);
    maxTime = timer_value;
    count();
  }

  // hide current modal
  function close(e) {
    $(e.target).closest(".vodl-notification--modal").hide();
  }

  //
  function count() {
    var time = new Date().getTime();
    $(document).on("scroll click keypress", function (e) {
      time = new Date().getTime();
    });
    function refresh() {
      var displayRefresh = true;

      // Check if there's an open lightbox (video or gallery)
      // or if actualization popup is disabled.
      if ($('#swipebox-overlay').length !== 0 || $('.vodl-login__wrapper').length !== 0) {
        displayRefresh = false;
      }
      if (new Date().getTime() - time >= maxTime && displayRefresh) {
        // if not yet there get data via API call and add it to document
        if ($('.vodl-notification--refresh').length === 0) {
          axios.get("/api/refresh_popup/get_refresh").then(function (response) {
            $(document.body).append(response.data);
            showModal();
          })["catch"](function (error) {
            return console.log(error);
          });
        } else {
          showModal();
        }
      } else {
        setTimeout(refresh, maxTime);
      }
    }

    // close current modal and start counting again
    function closeRecount(notification) {
      notification.parent().css('display', 'none');
      count();
    }
    function showLoginModal(notification) {
      $('.vodl-login-label__login:first').click();
      closeRecount(notification);
    }

    // display modal
    function showModal() {
      var notification = $('.vodl-notification--refresh');
      notification.parent().css('display', 'flex');

      // add event when popup is displayed - to avoid loading the tee popup
      var popup_event = document.createEvent('Event');
      popup_event.initEvent('tee_hide_popup', true, true);
      document.dispatchEvent(popup_event);
      var button = notification.find('.vodl-notification__button');
      button.on('click', function () {
        if (typeof dataLayer !== 'undefined' && typeof gtm_tracking_enable !== 'undefined' && true === gtm_tracking_enable) {
          var eventData = {
            event: 'genericEvent',
            eventCategory: 'Aktualisieren_Pop-Up',
            eventAction: 'Klick-OK'
          };
          dataLayer.push(eventData);
          document.dispatchEvent(new CustomEvent('hansrmdtevent', {
            detail: eventData
          }));
        } else if (typeof _rm_gua !== "undefined") {
          _rm_gua('send', 'event', 'Aktualisieren_Pop-Up', 'Klick-OK');
        }
        window.location.href = '/';
      });
      var close = notification.find('.vodl-notification__close');
      close.on('click', function () {
        if (typeof dataLayer !== 'undefined' && typeof gtm_tracking_enable !== 'undefined' && true === gtm_tracking_enable) {
          var eventData = {
            event: 'genericEvent',
            eventCategory: 'Aktualisieren_Pop-Up',
            eventAction: 'Klick-X'
          };
          dataLayer.push(eventData);
          document.dispatchEvent(new CustomEvent('hansrmdtevent', {
            detail: eventData
          }));
        } else if (typeof _rm_gua !== "undefined") {
          _rm_gua('send', 'event', 'Aktualisieren_Pop-Up', 'Klick-X');
        }
        closeRecount(notification);
      });
      var loginLink = notification.find('.vodl-notification__login--link');
      loginLink.off('click').on('click', function () {
        if (typeof dataLayer !== 'undefined' && typeof gtm_tracking_enable !== 'undefined' && true === gtm_tracking_enable) {
          var eventData = {
            event: 'genericEvent',
            eventCategory: 'Aktualisieren_Pop-Up',
            eventAction: 'Klick-Login'
          };
          dataLayer.push(eventData);
          document.dispatchEvent(new CustomEvent('hansrmdtevent', {
            detail: eventData
          }));
        } else if (typeof _rm_gua !== "undefined") {
          _rm_gua('send', 'event', 'Aktualisieren_Pop-Up', 'Klick-Login');
        }
        showLoginModal(notification);
      });
    }
    setTimeout(refresh, maxTime);
  }
  window.RussMedia = window.RussMedia || {};
  window.RussMedia.RefreshPopup = window.RussMedia.RefreshPopup || {};
  $.extend(window.RussMedia.RefreshPopup, {
    init: init
  });
})(document, window);

// comment notification
(function (document, window, undefined) {
  "use strict";

  $(document).ready(function () {
    $(".vodl-notification__header span").on("click", close);
    $(".vodl-notification--modal").on("click", close);
    window.RussMedia = window.RussMedia || {};
    var rmsso = window.RussMedia.SSO || false;
    if (rmsso && rmsso.isLoggedIn()) {
      // check if there are any comment and display notification
      var localStorageComment = localStorage.getItem('comment_data');
      if (localStorageComment) {
        var comment_data = JSON.parse(localStorageComment);
        if (!window.location.pathname.includes(comment_data.comment_post_id)) {
          localStorageCommentNotification(comment_data);
        }
      }
    }
  });
  function close(e) {
    $(e.target).closest(".vodl-notification--modal").hide();
  }
  function localStorageCommentNotification(comment_data) {
    axios.get("/api/nnp/get_storage_comment", {
      params: {
        post_id: comment_data.comment_post_id
      }
    }).then(function (response) {
      return showCommentModal(response);
    })["catch"](function (error) {
      return console.log(error);
    });
  }
  function showCommentModal(response) {
    $(document.body).append(response.data);
    var notification = $('.vodl-notification--comment');
    notification.parent().css('display', 'flex');

    // add event when popup is displayed - to avoid loading the tee popup
    var popup_event = document.createEvent('Event');
    popup_event.initEvent('tee_hide_popup', true, true);
    document.dispatchEvent(popup_event);
    var close = notification.find('.vodl-notification__close');
    var closeBtn = notification.find('.vodl-button--no');
    close.on('click', function () {
      notification.parent().remove();
      localStorage.removeItem('comment_data');
    });
    closeBtn.on('click', function () {
      notification.parent().remove();
      localStorage.removeItem('comment_data');
    });
  }
})(document, window);
"use strict";

(function (window, document, undefined) {
  'use strict';

  var init = function init() {
    var widgets = document.querySelectorAll('.vodl-reviews');
    if (widgets.length > 0) {
      widgets.forEach(function (widget) {
        var districts = widget.querySelectorAll('.vodl-select__item');
        districts.forEach(function (district) {
          district.addEventListener('click', fetchReviewData);
        });
      });
    }
  };
  var fetchReviewData = function fetchReviewData(e) {
    var widget = e.currentTarget.closest('.vodl-reviews');
    if (widget) {
      var nr = widget.dataset.amount || 3,
        api_url = widget.dataset.url || '',
        reviewItems = widget.querySelectorAll('.vodl-reviews__item'),
        district = e.currentTarget.innerHTML;
      if (reviewItems.length > 0) {
        var data = {
          district: district,
          nr: nr,
          api_url: api_url
        };
        $.ajax({
          url: '/wp-json/essen-vol/v1/get_review_data',
          data: data,
          dataType: 'json'
        }).then(function (response) {
          if (response) {
            response.forEach(function (item, idx) {
              var restaurant = reviewItems[idx].querySelector('.vodl-reviews__item-detail-title'),
                location = reviewItems[idx].querySelector('.vodl-reviews__item-detail-location'),
                text = reviewItems[idx].querySelector('.vodl-reviews__item-review'),
                stars = reviewItems[idx].querySelector('.vodl-reviews__item-rating');
              var newStars = '';
              reviewItems[idx].href = item['link'];
              if (restaurant) {
                restaurant.innerHTML = item['restaurant'];
              }
              if (location) {
                location.innerHTML = item['city'];
              }
              if (stars) {
                stars.innerHTML = '';
                item['stars'].forEach(function (star) {
                  newStars += '<span class="vodl-svg-sprite vodl-icon-widgets-star-yellow"><svg><use xlink:href="#vodl-icon-widgets-' + star['type'] + '"></use></svg></span>';
                });
                stars.innerHTML = newStars;
              }
              if (text) {
                text.innerHTML = item['text'];
              }
            });
          }
        });
      }
    }
  };
  $(document).ready(function () {
    init();
    window.addEventListener('newPage', init);
  });
})(window, document);
"use strict";

{
  var init = function init() {
    var select = document.querySelector('.vodl-select');
    if (select !== null) {
      vodlSelect.box = select;
      vodlSelect.current = select.querySelector('.vodl-select__current');
      vodlSelect.dropdown = select.querySelector('.vodl-select__dropdown');
      vodlSelect.items = select.querySelectorAll('.vodl-select__item');
      vodlSelect.arrow = select.querySelector('.vodl-select__arrow');
      vodlSelect.arrowDown = select.querySelector('.vodl-select__arrow-down');
      attachHandlers();
    }
  };
  var attachHandlers = function attachHandlers() {
    vodlSelect.current.addEventListener('click', vodlSelect.toggle);
    vodlSelect.arrow.addEventListener('click', vodlSelect.toggle);
    vodlSelect.arrowDown.addEventListener('click', vodlSelect.scroll);
    var itemsArray = Array.from(vodlSelect.items);
    itemsArray.forEach(function (element) {
      return attachHandlersToItem(element);
    });
  };
  var attachHandlersToItem = function attachHandlersToItem(element) {
    element.addEventListener('click', vodlSelect.makeCurrent);
    element.addEventListener('click', vodlSelect.toggle);
  };
  var vodlSelect = {
    isOpen: false,
    hideClass: 'vodl-select__hide',
    rotateClass: 'vodl-select__rotate'
  };
  vodlSelect.toggle = function () {
    var state = vodlSelect.toggleHide();
    vodlSelect.isOpen = state;
    vodlSelect.toggleArrow();
  };
  vodlSelect.checkIfOpen = function () {
    return vodlSelect.isOpen;
  };
  vodlSelect.toggleArrow = function () {
    if (vodlSelect.checkIfOpen()) {
      vodlSelect.arrow.classList.add(vodlSelect.rotateClass);
    } else {
      vodlSelect.arrow.classList.remove(vodlSelect.rotateClass);
    }
  };
  vodlSelect.toggleHide = function () {
    var items = [vodlSelect.dropdown, vodlSelect.arrowDown];
    var state = items.map(function (item) {
      if (vodlSelect.checkIfHide(item)) {
        vodlSelect.removeHide(item);
        return true;
      }
      vodlSelect.addHide(item);
      return false;
    });
    return state.every(function (item) {
      return item;
    });
  };
  vodlSelect.checkIfHide = function (item) {
    return item.classList.contains(vodlSelect.hideClass);
  };
  vodlSelect.addHide = function (item) {
    item.classList.add(vodlSelect.hideClass);
  };
  vodlSelect.removeHide = function (item) {
    item.classList.remove(vodlSelect.hideClass);
  };
  vodlSelect.makeCurrent = function () {
    vodlSelect.current.dataset.selectSlug = this.dataset.selectSlug;
    vodlSelect.current.dataset.selectName = this.dataset.selectName;
    vodlSelect.current.innerText = this.dataset.selectName;
  };
  vodlSelect.scroll = function () {
    var maxHeight = 270,
      scroll = maxHeight / 3;
    vodlSelect.dropdown.scrollBy(0, scroll);
  };
  document.addEventListener('DOMContentLoaded', function () {
    init();
    window.addEventListener('newPage', init);
  });
}
"use strict";

(function (window, document, undefined) {
  'use strict';

  var allowedCountryCodes = ['+41', '+43', '+49'],
    allowedModes = ['login', 'register'],
    axios = window.axios,
    config = window.RMTrialSubscription || null,
    Promise = window.Promise,
    rmRegistrationWithoutPassword = window.RussMedia.RegistrationWithoutPassword || {},
    rmSSO = window.RussMedia.SSO,
    rmUI = window.RussMedia.SSO.UI,
    tp = window.tp || [];
  var pianoIframeId = null;

  // Create a logger instance with 📞 prefix.
  var logger = {};
  try {
    logger = new window.RussMedia.Utils.Logger(String.fromCodePoint(0x1F4DE));
  } catch (e) {
    logger = {
      log: function log() {}
    };
  }

  /**
   * Initialize and attach event handlers.
   *
   * @return {undefined}
   */
  var _init = function _init() {
    if (!config) {
      logger.log('_init: no config found, skipping.');
      return;
    }
    logger.log('_init: found config:', config);

    // Piano will trigger this custom event.
    tp.push(["addHandler", "customEvent", function (event, b, c, d) {
      switch (event.eventName) {
        case 'tsub_request_subscription_perk':
          events.onSubscriptionPerkRequest(event);
          break;
        case 'tsub_switch_to_register':
          events.onSwitchToRegisterClicked(event);
          break;
        case 'tsub_forgot_password':
          events.onForgotPasswordClicked(event);
          break;
      }
    }]);
  };

  /**
   * A collection of event handlers.
   *
   * @type {Object}
  */
  var events = {
    onForgotPasswordClicked: function onForgotPasswordClicked(e) {
      // Do we need to do anything more here?
      window.dispatchEvent(new Event('open_reset_pw_vplus_form'));
    },
    onNotificationClicked: function onNotificationClicked(registerResult) {
      logger.log('events.onNotificationClicked', registerResult);
      if (registerResult && rmRegistrationWithoutPassword.State) {
        // If we did a registration before, the registerResult is not empty here.
        // Instead of doing a window.location.reload, we hijack the set password functionality of the RegistrationWithoutPassword module.
        notification.close();
        rmRegistrationWithoutPassword.State.set('sso.loginOrRegisterResult', registerResult);
        rmRegistrationWithoutPassword.State.set('step', 'afterRegisterComplete');
        window.dispatchEvent(new CustomEvent('open_register_without_password_set_pwd_form', {
          detail: {
            termsCompleted: true
          }
        }));
        return;
      }
      window.location.reload();
    },
    /**
     * Event handler for the custom event triggered by piano on form sumission.
     *
     * @param {Event} e The event object.
     */
    onSubscriptionPerkRequest: function onSubscriptionPerkRequest(e) {
      if (!e || !e.params || !e.params.meta || !e.params.tsub) {
        logger.log('events.onSubscriptionPerkRequest: invalid event data, skipping.');
        return;
      }
      var eventMeta = JSON.parse(e.params.meta) || null;
      var tsubState = JSON.parse(e.params.tsub) || null;
      logger.log('events.onSubscriptionPerkRequest eventMeta:', eventMeta);
      logger.log('events.onSubscriptionPerkRequest tsubState:', tsubState);
      if (!eventMeta || !tsubState) {
        logger.log('events.onSubscriptionPerkRequest: insufficient event data, skipping.');
        return;
      }
      pianoIframeId = eventMeta.iframeId || null;
      if (!pianoIframeId) {
        logger.log('events.onSubscriptionPerkRequest: unknown pianoIframeId, skipping.');
        return;
      }
      if (!tsubState.mode || !allowedModes.includes(tsubState.mode)) {
        logger.log('events.onSubscriptionPerkRequest: invalid mode, skipping.');
        return;
      }
      trialSubscription[tsubState.mode](tsubState);
    },
    onSwitchToRegisterClicked: function onSwitchToRegisterClicked(e) {
      if (!e || !e.params || !e.params.meta) {
        logger.log('events.onSwitchToRegisterClicked: invalid event data, skipping.');
        return;
      }
      var eventMeta = JSON.parse(e.params.meta) || null;
      logger.log('events.onSwitchToRegisterClicked eventMeta:', eventMeta);
      if (!eventMeta) {
        logger.log('events.onSwitchToRegisterClicked: insufficient event data, skipping.');
        return;
      }
      pianoIframeId = eventMeta.iframeId || null;
      if (!pianoIframeId) {
        logger.log('events.onSwitchToRegisterClicked: unknown pianoIframeId, skipping.');
        return;
      }
      events.propagateStateToPiano({
        password: '',
        mode: 'register',
        processing: false
      });
    },
    /**
     * As discussed with the data team, we should
     * notify them via a postMessage, whenever a trial subscription
     * was completed successfully.
     */
    onTrialSubscriptionCompleted: function onTrialSubscriptionCompleted() {
      window.postMessage({
        message: 'trial-subscription-completed'
      }, '*');
    },
    /**
     * Propagate updated state data back to the piano iframe via postMessage().
     *
     * @param {Object} stateUpdate The updated state object.
     */
    propagateStateToPiano: function propagateStateToPiano(stateUpdate) {
      var pianoIframe = document.querySelector('#' + pianoIframeId) || null;
      if (!pianoIframe) {
        logger.log('helpers.propagateStateToPiano: invalid pianoIframeId, skipping.');
        return;
      }
      pianoIframe.contentWindow.postMessage({
        tsub: stateUpdate
      }, '*');
    }
  };

  /**
   * A collection of helper methods
   */
  var helpers = {
    /**
     * Get a nested object property identified by key.
     *
     * @param {Object} obj The object to check for the nested key.
     * @param {String} key A string identifying the nested key, e.g. "additional_data.sso.login_result"
     * @returns
     */
    getNestedObjectProperty: function getNestedObjectProperty(obj, key) {
      return key.split(".").reduce(function (o, x) {
        return typeof o == "undefined" || o === null ? o : o[x];
      }, obj);
    },
    processingBegin: function processingBegin() {
      events.propagateStateToPiano({
        processing: true
      });
    },
    processingEnd: function processingEnd() {
      events.propagateStateToPiano({
        processing: false
      });
    },
    /**
     * Place the SSO cookie images as it would be done in a normal registration or login flow.
     * We use methods from window.RussMedia.SSO as far as possible.
     *
     * @param {Object} loginOrRegisterResult The login result object.
     * @param {Object} loginOrRegisterResult The login result object.
     *
     * @return {Promise} A promise that is resolved on success.
     */
    ssoPlaceCookies: function ssoPlaceCookies(loginOrRegisterResult, userData) {
      return new Promise(function (resolve, reject) {
        var options = rmSSO.getOptions();

        // Delete possibly existing cookie first.
        rmSSO.deleteCookie(options.cookies.ssoCookieName);

        // Place cookie image tags in the options.cookies.container
        if (!loginOrRegisterResult.cookie) {
          reject('No cookie images to inject!', loginOrRegisterResult);
          return;
        }
        rmSSO.loginStatusEventHandler.trigger(userData);
        // options.cookies.container is actually a jQuery object
        //  - so we are be able to use the jQuery methods append() and find() on it.
        options.cookies.container.append(loginOrRegisterResult.cookie);
        options.cookies.container.find('img:last').on('load', function () {
          rmSSO.waitForCookieAsync().then(function () {
            resolve('Cookie images loaded!');
          }, function () {
            reject('Cookie images did not load!');
          });
        });
        logger.log('helpers.ssoPlaceCookies SSO options, loginOrRegisterResult, userData: ', options, loginOrRegisterResult, userData);
      });
    }
  };
  var notification = {
    // Access to DOM elements of the notification.
    elements: {
      header: function header() {
        return document.querySelector('.vodl-notification .vodl-notification__header');
      },
      headerText: function headerText() {
        return document.querySelector('.vodl-notification .vodl-notification__header-text');
      },
      headerBadge: function headerBadge() {
        return document.querySelector('.vodl-notification .vodl-notification__header-badge');
      },
      text: function text() {
        return document.querySelector('.vodl-notification .vodl-notification__text');
      },
      wrapper: function wrapper() {
        return document.querySelector('.vodl-notification--modal');
      },
      notification: function notification() {
        return document.querySelector('.vodl-notification');
      },
      body: function body() {
        return document.querySelector('.vodl-notification .vodl-notification__body');
      },
      button: function button() {
        return document.querySelector('.vodl-notification .vodl-notification__button');
      },
      buttonLabel: function buttonLabel() {
        return document.querySelector('.vodl-notification .vodl-notification__button .vodl-button__label');
      },
      submitButton: function submitButton() {
        return document.querySelector('.vodl-notification .vodl-notification__button button');
      }
    },
    success: function success() {
      var registerResult = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      logger.log('notification.success!', registerResult);
      events.onTrialSubscriptionCompleted();
      var titleText = config.texts.notifications.success.title;
      var messageText = config.texts.notifications.success.message;
      var buttonText = config.texts.notifications.success.button;

      // Set notification title and message.
      this.elements.headerText().append(document.createTextNode(titleText));
      this.elements.text().innerHTML = messageText;

      // Assign click event handler for closing the notfication.
      this.elements.wrapper().removeEventListener('click', events.onNotificationClicked);
      this.elements.wrapper().addEventListener('click', function () {
        events.onNotificationClicked(registerResult);
      });

      // Addding the button if needed.
      if (!this.elements.button()) {
        var notificationButton = document.createElement('div');
        notificationButton.innerHTML = '<div class="vodl-notification__button"><button class="vodl-button vodl-button--red" type="button"><span class="vodl-button__label">OK</span></button></div>';
        this.elements.body().append(notificationButton);
      }
      this.elements.buttonLabel().innerHTML = buttonText;

      // Use the V+ style.
      this.elements.notification().classList.add('vodl-notification--vplus');

      // Show the thing.
      this.elements.wrapper().style.display = 'flex';
      return;
    },
    activeSubscription: function activeSubscription() {
      logger.log('notification.activeSubscription!');
      var titleText = config.texts.notifications.activeSubscription.title;
      var messageText = config.texts.notifications.activeSubscription.message;
      var buttonText = config.texts.notifications.activeSubscription.button;

      // Set notification title and message.
      this.elements.headerText().append(document.createTextNode(titleText));
      this.elements.text().append(document.createTextNode(messageText));

      // Assign click event handler for closing the notfication.
      this.elements.wrapper().removeEventListener('click', events.onNotificationClicked);
      this.elements.wrapper().addEventListener('click', function () {
        events.onNotificationClicked(false);
      });

      // Addding the button if needed.
      if (!this.elements.button()) {
        var notificationButton = document.createElement('div');
        notificationButton.innerHTML = '<div class="vodl-notification__button"><button class="vodl-button vodl-button--red" type="button"><span class="vodl-button__label">OK</span></button></div>';
        this.elements.body().append(notificationButton);
      }
      this.elements.buttonLabel().innerHTML = buttonText;

      // Use the V+ style.
      this.elements.notification().classList.add('vodl-notification--vplus');

      // Show the thing.
      this.elements.wrapper().style.display = 'flex';
      return;
    },
    close: function close() {
      // Hide the thing.
      this.elements.wrapper().style.display = 'none';
    }
  };

  /**
   * Collection of methods for handling requests to the REST API.
   *
   * @type {Object}
   */
  var requests = {
    ssoRestApiBase: '/wp-json/russmedia-sso/v1/',
    /**
     * Makes a call on the SSO REST API with the given route and payload.
     *
     * @param  {String}  route   The route name, e.g. 'register-for-phone-leads'.
     * @param  {Object}  payload Optional payload to send with the request.
     *
     * @return {Promise}         A promise that will either be resolved or rejected.
     */
    ssoRestApi: function ssoRestApi(route, payload) {
      var url = this.ssoRestApiBase + route;
      payload = payload || {};
      return axios({
        method: 'post',
        url: url,
        data: payload,
        withCredentials: true
      }).then(function (response) {
        logger.log('called ' + route + ' , response is', response);
        return response.data;
      })["catch"](function (error) {
        var message = false;
        var cause = {};
        logger.log('requests.ssoRestApi error.response:', error.response);
        if (error.response && error.response.data) {
          cause = error.response.data;
          if (error.response.data.data && error.response.data.data.user_error_text) {
            message = error.response.data.data.user_error_text;
          } else if (error.response.data.message) {
            message = error.response.data.message;
          }
          if (message) {
            throw new Error(message, {
              cause: cause
            });
          } else {
            throw error;
          }
        } else {
          throw error;
        }
      });
    }
  };

  /**
   * Collection of methods for starting a trial subscription.
   *
   * @type {Object}
   */
  var trialSubscription = {
    /**
     * Try to get a trial subsciption by login.
     *
     * @param {Object} state The state as forwarded from the piano iframe.
     */
    login: function login(state) {
      logger.log('trialSubscription.login state:', state);
      helpers.processingBegin();
      var errors = validate.loginData(state);
      events.propagateStateToPiano({
        errors: errors
      });
      if (Object.keys(errors).length > 0) {
        helpers.processingEnd();
        return;
      }

      // Still here? Let's try a login.
      var apiData = {
        email: state.email,
        firstName: state.firstName,
        lastName: state.lastName,
        phone: {
          countryCode: state.phone.countryCode,
          subscriberNumber: state.phone.subscriberNumber
        },
        pwd: state.password,
        terms: [{
          id: 'agb_vol',
          checked: state.terms.agb_vol
        }, {
          id: 'E1',
          checked: state.terms.E1
        }]
      };
      requests.ssoRestApi('login-for-phone-leads', apiData).then(function (responseData) {
        // We only get here if the API returned a 200 and the login was successful.
        logger.log('trialSubscription.login responseData:', responseData);

        // Check the response. We need:
        // - a succesful login (we know we have that here)
        // - a succesful trial_subscription_perk OR
        // - the user already has some kind of subscription

        var loginResult = helpers.getNestedObjectProperty(responseData, 'additional_data.sso.login_result') || {};
        var userData = helpers.getNestedObjectProperty(responseData, 'additional_data.sso.user_data') || {};
        var pianoData = helpers.getNestedObjectProperty(responseData, 'additional_data.sso.user_data.piano.abo') || {};
        var trialSubscriptionPerk = helpers.getNestedObjectProperty(responseData, 'trial_subscription_perk.response') || {};
        logger.log('trialSubscription.login details:', loginResult, userData, pianoData, trialSubscriptionPerk);

        // We still may fail, if the login was succesful BUT
        // - the user is not eligible for a free trial subscription
        if (trialSubscriptionPerk.success !== 1) {
          // ... but the user may have a subscription already - show notifcation and continue.
          if (pianoData && pianoData.hasPlusAccess) {
            // Trigger actual login mechanism (setting cookies) and show notification.
            helpers.ssoPlaceCookies(loginResult, userData).then(function () {
              // Make sure the username already shows up in the navigation bar.
              rmUI.checkLoginStatus();
              notification.activeSubscription();
            }, function (error) {
              logger.log('helpers.ssoPlaceCookies failed:', error);
            });
            return;
          }

          // ... if not: show the error from the trial subscription, switch to register mode and exit.
          errors['email'] = trialSubscriptionPerk.object.information;
          events.propagateStateToPiano({
            errors: errors,
            mode: 'register'
          });
          helpers.processingEnd();
          return;
        }

        // Still here? That means all is good and we can show the user the success notification.
        // Trigger actual login mechanism (setting cookies) and show notification.
        helpers.ssoPlaceCookies(loginResult, userData).then(function () {
          // Make sure the username already shows up in the navigation bar.
          rmUI.checkLoginStatus();
          notification.success(null);
        }, function (error) {
          logger.log('helpers.ssoPlaceCookies failed:', error);
        });
        return;
      })["catch"](function (responseError) {
        // We only get here if the API did NOT return a 200, e.g. when the login failed.
        logger.log('trialSubscription.login responseError:', responseError, responseError.cause);
        var field = 'generic';
        var message = responseError.message;
        if (responseError.cause && responseError.cause.data && responseError.cause.data.params && responseError.cause.data.params[0]) {
          field = responseError.cause.data.params[0];
        }
        errors[field] = message;
        events.propagateStateToPiano({
          errors: errors
        });
        helpers.processingEnd();
      });
    },
    /**
     * Try to get a trial subsciption by registration.
     *
     * @param {Object} state The state as forwarded from the piano iframe.
     */
    register: function register(state) {
      logger.log('trialSubscription.register state:', state);
      helpers.processingBegin();
      var errors = validate.registerData(state);
      events.propagateStateToPiano({
        errors: errors
      });
      if (Object.keys(errors).length > 0) {
        helpers.processingEnd();
        return;
      }

      // Still here? Try to call the API with our data!
      var apiData = {
        email: state.email,
        firstName: state.firstName,
        lastName: state.lastName,
        phone: {
          countryCode: state.phone.countryCode,
          subscriberNumber: state.phone.subscriberNumber
        },
        terms: [{
          id: 'agb_vol',
          checked: state.terms.agb_vol
        }, {
          id: 'E1',
          checked: state.terms.E1
        }]
      };
      requests.ssoRestApi('register-for-phone-leads', apiData).then(function (responseData) {
        // We only get here if the API returned a 200.
        logger.log('trialSubscription.register responseData:', responseData);

        // If the user already exists, we switch to login mode now and exit early.
        if (!responseData.register && responseData.email_exists) {
          events.propagateStateToPiano({
            mode: 'login'
          });
          helpers.processingEnd();
          return;
        }

        // Check the response. We need:
        // - a succesful registration (we know we have that here)
        // - a succesful trial_subscription_perk OR
        // - the user already has some kind of subscription

        var registerResult = helpers.getNestedObjectProperty(responseData, 'additional_data.sso.register_result') || {};
        var userData = helpers.getNestedObjectProperty(responseData, 'additional_data.sso.user_data') || {};
        var trialSubscriptionPerk = helpers.getNestedObjectProperty(responseData, 'trial_subscription_perk.response') || {};
        logger.log('trialSubscription.register details:', registerResult, userData, trialSubscriptionPerk);

        // We still may fail, if the registration was succesful BUT
        // the user is not eligible for a free trial subscription
        if (trialSubscriptionPerk.success !== 1) {
          // ... so we show the error from the trial subscription and exit.
          errors['email'] = trialSubscriptionPerk.object.information;
          events.propagateStateToPiano({
            errors: errors
          });
          helpers.processingEnd();
          return;
        }

        // Still here? That means all is good and we can show the user the success notification.
        // Trigger actual login mechanism (setting cookies) and show notification.
        helpers.ssoPlaceCookies(registerResult, userData).then(function () {
          // Make sure the username already shows up in the navigation bar.
          rmUI.checkLoginStatus();
          notification.success(registerResult);
        }, function (error) {
          logger.log('helpers.ssoPlaceCookies failed:', error);
        });
        return;
      })["catch"](function (responseError) {
        // We only get here if the API did NOT return a 200.
        // This can happpen e.g. if a parameter is missing.
        logger.log('trialSubscription.register responseError:', responseError, responseError.cause);
        var field = 'generic';
        var message = responseError.message;
        if (responseError.cause && responseError.cause.data && responseError.cause.data.params && responseError.cause.data.params[0]) {
          field = responseError.cause.data.params[0];
        }
        errors[field] = message;
        events.propagateStateToPiano({
          errors: errors
        });
        helpers.processingEnd();
      });
    }
  };

  /**
   * Collection of methods for basic data validation.
   *
   * @type {Object}
   */
  var validate = {
    loginData: function loginData(state) {
      var errors = {};
      if (!validate.email(state.email)) {
        errors.email = config.texts.errors.email;
      }
      if (!validate.name(state.firstName)) {
        errors.firstName = config.texts.errors.firstName;
      }
      if (!validate.name(state.lastName)) {
        errors.lastName = config.texts.errors.lastName;
      }
      if (!validate.loginPassword(state.password)) {
        errors.password = config.texts.errors.login.emptyPassword;
      }
      if (!validate.phoneCountryCode(state.phone.countryCode)) {
        errors.phone = config.texts.errors.phone.countryCode;
      }
      if (!validate.phoneSubscriberNumber(state.phone.subscriberNumber)) {
        errors.phone = config.texts.errors.phone.subscriberNumber;
        ;
      }
      if (!validate.terms(state.terms)) {
        errors.terms = config.texts.errors.terms;
      }
      logger.log('validate.loginData errors:', errors);
      return errors;
    },
    /**
     * Validate the state data required for getting a trial subscription by registration.
     *
     * @param {Object} state The state as forwarded from the piano iframe.
     */
    registerData: function registerData(state) {
      var errors = {};
      if (!validate.email(state.email)) {
        errors.email = config.texts.errors.email;
      }
      if (!validate.name(state.firstName)) {
        errors.firstName = config.texts.errors.firstName;
      }
      if (!validate.name(state.lastName)) {
        errors.lastName = config.texts.errors.lastName;
      }
      if (!validate.phoneCountryCode(state.phone.countryCode)) {
        errors.phone = config.texts.errors.phone.countryCode;
      }
      if (!validate.phoneSubscriberNumber(state.phone.subscriberNumber)) {
        errors.phone = config.texts.errors.phone.subscriberNumber;
        ;
      }
      if (!validate.terms(state.terms)) {
        errors.terms = config.texts.errors.terms;
      }
      return errors;
    },
    /**
     * Validate an email address.
     *
     * @param {String} email The email address to validate.
     * @return {Boolean}
     */
    email: function email(_email) {
      var emailRegex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
      if (!_email || !emailRegex.test(_email)) {
        return false;
      }
      return true;
    },
    /**
     * Validate a password string.
     *
     * @param {String} name The password string to validate.
     * @return {Boolean}
     */
    loginPassword: function loginPassword(password) {
      return password && password.trim().length >= 1;
    },
    /**
     * Validate a name string.
     *
     * @param {String} name The name string to validate.
     * @return {Boolean}
     */
    name: function name(_name) {
      return _name && _name.trim().length >= 2;
    },
    /**
     * Validate a phone country code.
     *
     * @param {String} countryCode The country code to validate.
     * @return {Boolean}
     */
    phoneCountryCode: function phoneCountryCode(countryCode) {
      return allowedCountryCodes.includes(countryCode);
    },
    /**
     * Validate a phone subscriber number.
     *
     * @param {String} subscriberNumber The subscriber number to validate.
     * @return {Boolean}
     */
    phoneSubscriberNumber: function phoneSubscriberNumber(subscriberNumber) {
      return subscriberNumber && subscriberNumber.trim().length >= 5 && subscriberNumber.trim().length <= 20;
    },
    /**
     * Validate (required) terms and conditions.
     *
     * @param {Object} terms The terms and conditions to validate.
     * @return {Boolean}
     */
    terms: function terms(_terms) {
      return _terms.agb_vol && _terms.E1;
    }
  };
  _init();
})(window, document);
"use strict";

(function (window, document, undefined) {
  "use strict";

  var $ = window.jQuery,
    featured_video = $(".vodl-region-article__featured-video"),
    container = featured_video.find(".vodl-video__container"),
    video = featured_video.find(".vodl-video__iframe"),
    video_break = featured_video.find(".vodl-video__break"),
    closeBtn = featured_video.find(".vodl-video__close"),
    config = {
      rootMargin: "0px 0px"
    };
  var isPlaying = false,
    hideSticky = false,
    player,
    playerIframeWindow;
  var init = function init() {
    if (0 === featured_video.length || 0 === video.length) {
      return;
    }
    closeBtn.on("click", function () {
      container.removeClass("sticky-video");
      player.stopVideo();
      hideSticky = true;
    });
    initPlayer();
    document.addEventListener("vodl_activate_embed_provider", maybeInitPlayer);
    if ("IntersectionObserver" in window && video.attr("id") === "video-sticky" && video_break[0] !== undefined) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting || entry.boundingClientRect.bottom >= 0) {
            container.removeClass("sticky-video");
            video_break.removeClass("show-placeholder");
          }
          if (entry.boundingClientRect.bottom < 0 && isPlaying === true && !hideSticky) {
            container.addClass("sticky-video");
            video_break.addClass("show-placeholder");
          }
        });
      }, config);
      observer.observe(video_break[0]);
    }
  };
  var maybeInitPlayer = function maybeInitPlayer(ev) {
    var activatedProvider = ev.detail.provider || false;
    if (!activatedProvider || "youtube" != activatedProvider && "*" != activatedProvider) {
      return;
    }
    if (!player) {
      initPlayer();
    }
  };
  var loadYoutubeApi = function loadYoutubeApi() {
    return new Promise(function (resolve, reject) {
      if ("undefined" === typeof window.YT || "undefined" === typeof window.YT.Player) {
        var tag = document.createElement("script");
        tag.async = true;
        tag.src = "https://www.youtube.com/iframe_api";
        tag.type = "text/javascript";
        tag.onerror = function (error) {
          reject(error);
        };
        tag.onload = function () {
          window.YT.ready(function () {
            resolve();
          });
        };
        var firstScriptTag = document.getElementsByTagName("script")[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
      } else {
        resolve();
      }
    });
  };
  var initPlayer = function initPlayer() {
    // check if the consent is still missing...
    var consentRequiredContent = featured_video.find(".vodl-consent-required__content");
    if (0 !== consentRequiredContent.length && consentRequiredContent.is(":hidden")) {
      return;
    }
    if (video.attr("id") === "video-sticky") {
      loadYoutubeApi().then(function () {
        YouTubeVideoPlayer();
      });
    }
  };
  var onPostMessage = function onPostMessage(e) {
    if (e.source === playerIframeWindow) {
      var data = JSON.parse(e.data);
      if (data.event === "infoDelivery" && data.info && data.info.hasOwnProperty("playerState")) {
        if (0 === data.info.playerState) {
          isPlaying = false;
        }
        if (1 === data.info.playerState) {
          isPlaying = true;
        }
      }
    }
  };
  var onPlayerReady = function onPlayerReady(e) {
    playerIframeWindow = e.target.getIframe().contentWindow;
    window.addEventListener("message", onPostMessage);
    player.mute();
    player.playVideo();
  };
  var YouTubeVideoPlayer = function YouTubeVideoPlayer() {
    player = new window.YT.Player("video-sticky", {
      events: {
        onReady: onPlayerReady
      }
    });
  };
  $(document).ready(function () {
    init();
  });
})(window, document);
"use strict";

(function (window, document, undefined) {
  "use strict";

  var videos,
    isPlayingSticky = false,
    stickyPlayer,
    stickyObserver,
    container,
    videoBreak,
    adTagUrl;

  /**
   * Stops the 'sticky' behavior of a video player.
   *
   * This function removes the sticky related classes,
   * pauses the sticky player, and stops observing the video break with the sticky observer.
   *
   * @returns {void}
   */
  var stopStickyPlayer = function stopStickyPlayer() {
    container.classList.remove("sticky-video");
    videoBreak.classList.remove("show-placeholder");
    stickyPlayer.pauseVideo();
    stickyObserver.unobserve(videoBreak);
  };

  /**
   * Initializes an Intersection Observer to handle the 'sticky' behavior of a video player.
   *
   * This function selects the video break and container elements, and sets up an Intersection Observer
   * to add or remove the 'sticky-video' and 'show-placeholder' classes based on whether the video break
   * is intersecting the viewport or not. It also sets up a click event listener on the close button to pause the sticky player.
   *
   * If the video break or container elements do not exist, or if the Intersection Observer API is not available,
   * the function returns early.
   *
   * @returns {void}
   */
  var initIntersectionObserver = function initIntersectionObserver() {
    var featuredVideo = document.querySelector(".vodl-region-article__featured-video");
    if (!featuredVideo) {
      return;
    }
    videoBreak = featuredVideo.querySelector(".vodl-video__break");
    if (!videoBreak || !("IntersectionObserver" in window)) {
      return;
    }
    container = featuredVideo.querySelector(".vodl-video__container");
    if (!container) {
      return;
    }
    var closeButton = featuredVideo.querySelector(".vodl-video__close");
    if (closeButton) {
      closeButton.addEventListener("click", stopStickyPlayer);
    }
    stickyObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting || entry.boundingClientRect.bottom >= 0) {
          container.classList.remove("sticky-video");
          videoBreak.classList.remove("show-placeholder");
        }
        if (entry.boundingClientRect.bottom < 0 && isPlayingSticky === true) {
          container.classList.add("sticky-video");
          videoBreak.classList.add("show-placeholder");
        }
      });
    }, {
      rootMargin: "0px 0px"
    });
    stickyObserver.observe(videoBreak);
  };

  /**
   * Initializes YouTube players based on the provided event.
   *
   * This function checks if the event detail contains a provider. If the provider is not 'youtube' or '*',
   * the function returns early. It then selects all YouTube player elements that have not been initialized yet.
   * If there are no such elements, the function returns early. Otherwise, it initializes the players.
   *
   * @param {Event} ev - The event that triggered the function. The detail property of the event should contain a provider.
   */
  var maybeInitPlayer = function maybeInitPlayer(ev) {
    var activatedProvider = ev.detail.provider || false;
    if (!activatedProvider || "youtube" != activatedProvider && "*" != activatedProvider) {
      return;
    }
    videos = document.querySelectorAll('.youtube-pfp__wrapper[data-is-initialized="false"]');
    if (videos.length === 0) {
      return;
    }
    initPlayers();
  };

  /**
   * Inserts a script tag before the first script tag.
   *
   * @param {Object} tag - The script tag.
   * @returns {void}
   */
  var insertScriptTag = function insertScriptTag(tag) {
    var firstScriptTag = document.getElementsByTagName("script")[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
  };

  /**
   * Loads the YouTube Player API.
   *
   * The function returns a promise that resolves when the YouTube Player API has loaded or if it's already loaded.
   * If there's an error loading the YouTube Player API, the promise is rejected with the error.
   *
   * The ?ima=1 parameter loads Player with IMA support.
   *
   * @returns {Promise} A promise that resolves when the YouTube Player API has loaded or if it's already loaded,
   * and rejects if there's an error loading the YouTube Player API.
   */
  var loadYoutubeApi = function loadYoutubeApi() {
    return new Promise(function (resolve, reject) {
      if ("undefined" === typeof window.YT || "undefined" === typeof window.YT.Player) {
        var tag = document.createElement("script");
        tag.async = true;
        tag.src = "https://www.youtube.com/iframe_api?ima=1";
        tag.type = "text/javascript";
        tag.onerror = function (error) {
          reject(error);
        };
        tag.onload = function () {
          window.YT.ready(function () {
            resolve();
          });
        };
        insertScriptTag(tag);
      } else {
        resolve();
      }
    });
  };

  /**
   * Loads the IMA SDK required for initializing customized prerolls.
   *
   * The function returns a promise that resolves when the IMA SDK has loaded or if it's already loaded.
   * If there's an error loading the IMA SDK, the promise still resolves because the IMA SDK only affects ads.
   *
   * @returns {Promise} A promise that resolves when the IMA SDK has loaded or if it's already loaded.
   */
  var loadImaSdk = function loadImaSdk() {
    return new Promise(function (resolve) {
      if ("undefined" === typeof window.google || "undefined" === typeof window.google.ima) {
        var tag = document.createElement("script");
        tag.async = true;
        tag.src = "https://imasdk.googleapis.com/js/sdkloader/ima3.js";
        tag.type = "text/javascript";
        tag.onerror = function (error) {
          // resolve anyway, because it just affects ads.
          resolve();
        };
        tag.onload = function () {
          resolve();
        };
        insertScriptTag(tag);
      } else {
        resolve();
      }
    });
  };

  /**
   * Loads the YouTube Player API and the IMA SDK.
   *
   * @returns {Promise} A promise that resolves when the YouTube Player API and the IMA SDK have loaded or if they're already loaded.
   */
  function loadScripts() {
    return Promise.all([loadYoutubeApi(), loadImaSdk()]);
  }

  /**
   * Sets the base ad tag URL for the YouTube player.
   *
   * This function retrieves data from the RMYoutubePfpData global variable and uses it to construct the base ad tag URL.
   * The URL includes parameters for various categories, the article ID, the page type, the Glimr ID, and the CX segments.
   * The URL also includes the current page location and some fixed parameters.
   *
   * If the RMYoutubePfpData global variable or the video variable is not defined, the function returns an empty string.
   *
   * @returns {void}
   */
  var setBaseAdTagUrl = function setBaseAdTagUrl() {
    var RMYoutubePfpData = window.RMYoutubePfpData || false;
    if (!RMYoutubePfpData) {
      return "";
    }
    var urlData = {};
    urlData.topCategory = RMYoutubePfpData.topCategory || "";
    urlData.allCategories = RMYoutubePfpData.allCategories || "";
    urlData.category = RMYoutubePfpData.category || "";
    urlData.articleID = RMYoutubePfpData.articleID || "";
    urlData.pageType = RMYoutubePfpData.pageType || "";
    urlData.glimr = RMYoutubePfpData.glimr || "";
    urlData.cxSegments = RMYoutubePfpData.cxSegments || "";
    var currentLocation = encodeURIComponent(window.location.href);
    adTagUrl = "https://pubads.g.doubleclick.net/gampad/ads?iu=/1044774/video.vol.at/youtube-pfp/preroll_1&description_url=".concat(currentLocation, "&tfcd=0&npa=0&sz=480x360%7C480x361%7C640x360%7C640x480&cust_params=glimr%3D").concat(urlData.glimr, "%26pageType%3D").concat(urlData.pageType, "%26CxSegments%3D").concat(urlData.cxSegments, "%26category%3D").concat(urlData.category, "%26allcategories%3D").concat(urlData.allCategories, "%26topcategory%3D").concat(urlData.topCategory, "%26articleID%3D").concat(urlData.articleID, "%26yt_video_id%3D[VIDEO_ID]&vpmute=[VIDEO_MUTE]&plcmt=2&gdfp_req=1&output=vast&env=vp&unviewed_position_start=1&impl=s&correlator=");
  };

  /**
   * Returns the ad tag URL for a video element.
   *
   * @param {Object} video - The video element.
   * @returns {string} The ad tag URL for the video element.
   */
  var getVideoAdTagUrl = function getVideoAdTagUrl(video) {
    if (!video || adTagUrl === "") {
      return adTagUrl;
    }
    var _video$dataset = video.dataset,
      videoId = _video$dataset.videoId,
      autoplay = _video$dataset.autoplay;
    if (!videoId) {
      return adTagUrl;
    }
    var videoMuted = autoplay === "true" ? "1" : "0";
    var updatedAdTagUrl = adTagUrl.replace("[VIDEO_ID]", videoId);
    return updatedAdTagUrl.replace("[VIDEO_MUTE]", videoMuted);
  };

  /**
   * This function is called by the YouTube Player API when it needs to request ads.
   *
   * @param {Object} video - The video element.
   * @returns {Function} A function that is called by the YouTube Player API when it needs to request ads.
   */
  var makeAdsRequest = function makeAdsRequest(video) {
    return function (adsRequest, adsRenderingSettings) {
      adsRequest.adTagUrl = getVideoAdTagUrl(video);
      adsRenderingSettings.useStyledNonLinearAds = true;
    };
  };

  /**
   * This function is called by the YouTube Player API when the player's state changes.
   *
   * It sets the isPlayingSticky variable to true when the player is playing.
   * It sets the isPlayingSticky variable to false when the player is paused or ended.
   *
   * @param {Object} event - The event object.
   * @returns {void}
   */
  var onPlayerStateChange = function onPlayerStateChange(event) {
    if (event.data === window.YT.PlayerState.PLAYING) {
      isPlayingSticky = true;
    }
    if (event.data === window.YT.PlayerState.PAUSED || event.data === window.YT.PlayerState.ENDED) {
      isPlayingSticky = false;
    }
  };

  /**
   * This function is called by the YouTube Player API when the player is ready.
   *
   * It sets the stickyPlayer variable to the player instance if the player is sticky.
   *
   * @param {Object} player - The player instance.
   * @returns {void}
   */
  var onPfPPlayerReady = function onPfPPlayerReady(player) {
    if (!player.getIframe().parentNode) {
      return;
    }
    var playerWrapper = player.getIframe().parentNode;
    if (playerWrapper.dataset.isSticky !== "true") {
      return;
    }
    stickyPlayer = player;
  };

  /**
   * Initializes the YouTube Player API for each video.
   *
   * @returns {void}
   */
  var initPlayer = function initPlayer(video) {
    var playerVars = {};
    if (video.dataset.autoplay === "true") {
      playerVars = {
        autoplay: 1,
        mute: 1
      };
    }

    // start video after x seconds if set
    if (video.dataset.startAt) {
      var startAt = parseInt(video.dataset.startAt);
      if (startAt > 0) {
        playerVars.start = startAt;
      }
    }
    var playerOptions = {
      youtubeOptions: {
        videoId: video.dataset.videoId,
        playerVars: playerVars
      }
    };
    if (video.dataset.isSticky === "true") {
      playerOptions.youtubeOptions.events = {
        onStateChange: onPlayerStateChange
      };
    }
    new window.YT.createPlayerForPublishers("pfp-player-".concat(video.dataset.videoId), makeAdsRequest(video), playerOptions, onPfPPlayerReady);
    video.dataset.isInitialized = true;
  };

  /**
   * Initializes YouTube players for all video elements.
   *
   * This function first checks if consent is required and has been given for YouTube content. If consent is required but not given,
   * the function returns early. It then loads the necessary scripts and initializes a YouTube player for each video element.
   *
   * If a video element is already initialized, or if it doesn't exist or doesn't have a video ID, the function skips it.
   * If a video element is marked as 'sticky', the function also initializes an Intersection Observer for it.
   *
   * @returns {void}
   */
  var initPlayers = function initPlayers() {
    var consentRequiredContent = videos[0].parentNode.parentNode;

    // check if the consent is still missing for youtube.
    if (!consentRequiredContent || window.getComputedStyle(consentRequiredContent).display === "none") {
      return;
    }
    loadScripts().then(function () {
      if (!window.YT.createPlayerForPublishers) {
        return;
      }
      setBaseAdTagUrl();
      videos.forEach(function (video) {
        if (video.dataset.isInitialized === "true" || !video || !video.dataset.videoId) {
          return;
        }
        initPlayer(video);
        if (video.dataset.isSticky === "true") {
          initIntersectionObserver();
        }
      });
    });
  };

  /**
   * Initializes the YouTube player functionality.
   *
   * This function selects all YouTube player wrapper elements that have not been initialized yet.
   * If there are no such elements, the function returns early. Otherwise, it initializes the players
   * and sets up an event listener for the 'vodl_activate_embed_provider' event.
   *
   * @returns {void}
   */
  var init = function init() {
    videos = document.querySelectorAll('.youtube-pfp__wrapper[data-is-initialized="false"]');
    if (videos.length === 0) {
      return;
    }
    initPlayers();
  };
  document.addEventListener("vodl_activate_special_embed_provider", maybeInitPlayer);
  document.addEventListener("newPage", init);
  init();
})(window, document);
"use strict";

function vodlInitSelectRegion() {
  var prefix = $('.vodl-select-region__current').attr('data-mytown-prefix');
  var vodlSelectRegion = $('.vodl-select-region__select'),
    vodlCurrentRegion = $('.vodl-select-region__current');
  vodlSelectRegion.each(function () {
    var vodlSelectRegionDropdown = $(this).find('.vodl-select-region__dropdown'),
      vodlSelectRegionDropdownElement = $(this).find('.vodl-select-region__dropdown li'),
      vodlScrollBtn = $(this).find('.vodl-select-region__arrow-down'),
      vodlCustomEvent = $(this).data('custom-event') || false,
      endOfDD = false;

    /**
    * toggle dropdown on click
    */

    $(this).unbind('click');
    $(this).click(function () {
      if (vodlScrollBtn.data('clicked')) {
        vodlSelectRegionDropdown.scrollTop(200 + vodlSelectRegionDropdown.scrollTop());
        vodlScrollBtn.data('clicked', false);
      } else {
        $(this).toggleClass('vodl-select-region--show');

        // no need for the scroll button if the list is not overflowing, right?
        if (vodlSelectRegionDropdown[0].clientHeight === vodlSelectRegionDropdown[0].scrollHeight) {
          endOfDD = true;
        } else {
          endOfDD = false;
        }
        if ($(this).hasClass('vodl-select-region--show') && endOfDD === false) {
          vodlScrollBtn.addClass('vodl-select-region__arrow-down--show');
        } else {
          vodlScrollBtn.removeClass('vodl-select-region__arrow-down--show');
        }
      }
    });

    /**
       * Hide big arrow at the end of the dropdown list.
       */
    vodlSelectRegionDropdown.scroll(function () {
      if (vodlSelectRegionDropdown[0].offsetHeight + vodlSelectRegionDropdown[0].scrollTop >= vodlSelectRegionDropdown[0].scrollHeight) {
        vodlScrollBtn.removeClass('vodl-select-region__arrow-down--show');
        endOfDD = true;
      } else {
        vodlScrollBtn.addClass('vodl-select-region__arrow-down--show');
        endOfDD = false;
      }
    });

    /**
       * search with getEventTarget for the selected list item
       * and transfer its text to all current region spans on the page
       */
    vodlSelectRegionDropdownElement.click(function (event) {
      var target = vodlGetEventTarget(event),
        slug = $(this).attr('data-mytown-slug');
      vodlCurrentRegion.each(function () {
        $(this).trigger('gemeindechanged');
        $(this)[0].innerHTML = target.innerText;
        this.setAttribute('data-mytown-slug', slug);
      });

      //allow custom event handlers in other scripts if data-custom-event was set
      if (vodlCustomEvent) {
        $(window).trigger(vodlCustomEvent, slug);
        return;
      }
      if (window.location.pathname !== '/' && window.location.pathname !== '/gemeinde/gemeinde') {
        window.location = '/' + prefix + '/' + slug;
      }
    });
    vodlScrollBtn.click(function () {
      $(this).data('clicked', true);
    });
  });

  /**
     * close dropdown on click outside / anywhere on the page
     */
  window.addEventListener('mouseup', function (event) {
    vodlSelectRegion.each(function (key, value) {
      if (!$(value).is(event.target) &&
      // if the target of the click isn't on of the existing selectors
      $(value).has(event.target).length === 0) {
        // ... nor a descendant
        $(this).removeClass('vodl-select-region--show');
        $(this).find('.vodl-select-region__arrow-down').removeClass('vodl-select-region__arrow-down--show');
      }
    });
  });
}

// Sets Region gets Cookie data from getRegion()
function VodlSetCookieRegion() {
  var current = vodlGetCookieRegion(),
    vodlCurrentRegion = $('.vodl-select-region__current'),
    region = $('.vodl-select-region__dropdown li'),
    selected = null;
  region.each(function () {
    if ($(this).attr('data-mytown-slug') === current) {
      selected = this.innerHTML;
    }
  });
  if (current !== null && selected !== null) {
    vodlCurrentRegion.map(function () {
      this.innerHTML = selected;
      this.setAttribute('data-mytown-slug', current);
    });
  }
}

// Gets Current Region from Cookie "currentcity"
function vodlGetCookieRegion() {
  var search = 'currentcity',
    cookies = document.cookie.split(';');
  if (document.cookie.includes('CurrentCity')) {
    for (var i = 0; i < cookies.length; i++) {
      var name = cookies[i].split('=')[0].toLowerCase().replace(/\s/g, ''),
        value = cookies[i].split('=')[1].toLowerCase();
      if (name === search) {
        return value;
      }
    }
  } else {
    return null;
  }
}
$(document).ready(function () {
  if (window.location.pathname === '/') {
    VodlSetCookieRegion();
  }
  vodlInitSelectRegion();
});
function vodlGetEventTarget(e) {
  e = e || window.event;
  return e.target || e.srcElement;
}
"use strict";

(function (window, document, undefined) {
  'use strict';

  var newssliderbox = document.querySelectorAll('.vodl-newsslider.pre-init');
  var slider_count = document.querySelectorAll('.vodl-newsslider').length;

  // Re-fetch all available non-intitialized news-slider(s).
  var init_news_slider_newpage = function init_news_slider_newpage() {
    newssliderbox = document.querySelectorAll('.vodl-newsslider.pre-init');
    slider_count = document.querySelectorAll('.vodl-newsslider').length;
    newssliderbox.forEach(function (sliderbox) {
      init_news_sliderbox(sliderbox);
    });
  };

  // Initialize current sliderbox - there can be multiple of them.
  var init_news_sliderbox = function init_news_sliderbox(sliderbox) {
    // some slider specific values
    var sliderInit = []; // array of (initialized) slider lists
    var newsslider = sliderbox.querySelectorAll('.vodl-newsslider__slider') // All available sliders in box.
      ,
      slider_cat_tabs = sliderbox.querySelectorAll('.vodl-newsslider__category-list-item'); // All available category tabs.

    var sliderbox_id = 'vodl-newsslider-' + slider_count; // ID for current slider.

    // set slider id to e able to have multiple players per page.
    sliderbox.id = sliderbox_id;
    slider_count = slider_count - 1;

    // Init category tab event handlers
    var init_event_handlers = function init_event_handlers(slider, i) {
      var category = slider.getAttribute('data-category'),
        curr_cat_link_1 = sliderbox.querySelector('.vodl-newsslider__category .vodl-newsslider__category-list-item[data-category="' + category + '"] a'),
        curr_cat_link_2 = slider.querySelector('.vodl-newsslider__slider-category a');
      var change_slider = function change_slider(event) {
        // Don't follow the link.
        event.preventDefault();
        var prev_category = sliderbox.querySelector('.vodl-newsslider__category-list-item.vodl-newsslider__active').getAttribute('data-category');
        if (category !== prev_category) {
          var curr_cat_item_1 = sliderbox.querySelector('.vodl-newsslider__category .vodl-newsslider__category-list-item[data-category="' + category + '"]'),
            curr_cat_item_2 = slider.querySelector('.vodl-newsslider__slider-category');
          var prev_slider = sliderbox.querySelector('.vodl-newsslider__slider[data-category="' + prev_category + '"]'),
            prev_cat_item_1 = sliderbox.querySelector('.vodl-newsslider__category-list .vodl-newsslider__active');

          // deactivate previous slider
          prev_cat_item_1.classList.remove('vodl-newsslider__active');
          prev_slider.querySelector('.vodl-newsslider__slider-category').classList.remove('vodl-newsslider__active');
          prev_slider.querySelector('.vodl-newsslider__slider-wrapper').classList.add('vodl-newsslider__hide');

          // activate current slider
          curr_cat_item_1.classList.add('vodl-newsslider__active');
          curr_cat_item_2.classList.add('vodl-newsslider__active');
          slider.querySelector('.vodl-newsslider__slider-wrapper').classList.remove('vodl-newsslider__hide');
          sliderInit[i].redrawSlider();
        }
      };
      curr_cat_link_1.addEventListener('click', change_slider, false);
      curr_cat_link_2.addEventListener('click', change_slider, false);
      slider.querySelector('.vodl-newsslider__slider-wrapper').addEventListener('touchmove', function (e) {
        console.log('touchmove slider ' + category);
        e.preventDefault();
      });
    };

    // Init bxSlider for each slider in the box
    var init_news_slider = function init_news_slider(slider, i) {
      var category = slider.getAttribute('data-category');
      if ("" !== category) {
        var slider_to_init = '#' + sliderbox_id + ' #vodl-newsslider__list-' + category;
        var sliderAttr = {
          speed: 250,
          slideWidth: 224,
          minSlides: 1,
          maxSlides: 4,
          slideMargin: 15,
          nextSelector: '#' + sliderbox_id + ' #vodl-newsslider__next-slide-' + category,
          prevSelector: '#' + sliderbox_id + ' #vodl-newsslider__prev-slide-' + category,
          pagerSelector: '#' + sliderbox_id + ' #vodl-newsslider__slider-pager-' + category,
          infiniteLoop: false,
          hideControlOnEnd: true
        };
        sliderInit.push($(slider_to_init).bxSlider(sliderAttr));
        if (0 === i) {
          // Enable first slider of the box.
          slider.querySelector('.vodl-newsslider__slider-wrapper').classList.remove('vodl-newsslider__hide');
          sliderInit[i].redrawSlider();
        }
        init_event_handlers(slider, i);
      }
    };
    newsslider.forEach(function (slider) {
      var cat = slider.querySelector('.vodl-newsslider__slider-category').getAttribute('data-category');
      if ('' === cat) {
        slider.parentNode.removeChild(slider);
      }
    });
    slider_cat_tabs.forEach(function (cat_item) {
      if ('' === cat_item.getAttribute('data-category')) {
        cat_item.parentNode.removeChild(cat_item);
      }
      ;
    });
    newsslider = sliderbox.querySelectorAll('.vodl-newsslider__slider');
    newsslider.forEach(function (slider, i) {
      init_news_slider(slider, i);
    });

    // Initialized - remove lazy stuff.
    sliderbox.classList.remove('pre-init');
    // window.removeEventListener( 'newPage', init_news_slider_newpage, false );
    // console.log('lazy widget news slider - remove event listener for newPage event');
  };
  window.addEventListener('load', function () {
    newssliderbox.forEach(function (sliderbox) {
      init_news_sliderbox(sliderbox);
    });

    // Initialize event listener for lazy news slider.
    window.addEventListener('newPage', init_news_slider_newpage, false);
  });
})(window, document);
"use strict";

(function (window, document) {
  'use strict';

  var x = window.matchMedia("(min-width: 37rem)"); // ugly hack to change desktop slider functionality on mobile

  var hide = 'vodl-video-box__hide',
    active = 'vodl-video-box__category-item-active',
    videoBox = $('.vodl-video-box.pre-init');
  function widgetSlider(box) {
    // ugly hack to change desktop slider functionality on mobile
    if ($(box).hasClass('vodl-video-box--large')) {
      $(box).removeClass('vodl-video-box--large');
    }
    var catLink = box.find('.vodl-video-box__category-item'),
      slider = box.find('.vodl-video-box__wrapper-slider'),
      category,
      attr = {
        speed: 250,
        slideMargin: 20,
        minSlides: 1,
        maxSlides: 3,
        moveSlides: 1,
        controls: false
      };
    slider = initSlider(attr, slider);
    category = catLink.first().attr('data-category');
    var selectedSlider = slider.filter(function (slider) {
      return $(slider).attr('data-category') === category;
    });
    selectedSlider[0].closest('.vodl-video-box__wrapper').removeClass(hide);
    selectedSlider[0].redrawSlider();
    catLink.click(function (event) {
      event.preventDefault();
      category = $(this).attr('data-category');
      var selectedSlider = slider.filter(function (slider) {
        return $(slider).attr('data-category') === category;
      });
      catLink.removeClass(active);
      $(this).addClass(active);
      $(slider).each(function () {
        $(this).closest('.vodl-video-box__wrapper').addClass(hide);
      });
      selectedSlider[0].closest('.vodl-video-box__wrapper').removeClass(hide);
      selectedSlider[0].redrawSlider();
    });
    slider.forEach(function (wrapper) {
      wrapper[0].addEventListener('touchmove', function (e) {
        e.preventDefault();
      });
    });
  }
  function desktopSlider(box) {
    var catLink = box.find('.vodl-video-box__category-item'),
      videoBox = box.find('.vodl-video-box__video'),
      slider = box.find('.vodl-video-box__wrapper-slider'),
      category,
      attr = {
        speed: 250,
        slideWidth: 150,
        slideMargin: 20,
        minSlides: 5,
        maxSlides: 5,
        infiniteLoop: false,
        hideControlOnEnd: true,
        pager: false
      };
    slider = initSlider(attr, slider);
    slider.map(function () {
      box.find('.bx-prev').addClass('invisible');
    });
    category = catLink.first().attr('data-category');
    var selectedSlider = slider.filter(function (value) {
        return value.attr('data-category') === category;
      }),
      item = box.find('.vodl-video-box__wrapper-slider-item'),
      firstItem = item.first().children();
    selectedSlider[0].closest('.vodl-video-box__wrapper').removeClass(hide);
    selectedSlider[0].redrawSlider();
    changeVideo(videoBox, firstItem);
    catLink.click(function (event) {
      event.preventDefault();
      category = $(this).attr('data-category');
      var selectedSlider = slider.filter(function (slider) {
        return slider.attr('data-category') === category;
      });
      catLink.removeClass(active);
      $(this).addClass(active);
      $(slider).each(function () {
        $(this).closest('.vodl-video-box__wrapper').addClass(hide);
      });
      selectedSlider[0].closest('.vodl-video-box__wrapper').removeClass(hide);
      selectedSlider[0].redrawSlider();
      selectedSlider[0].children().children().removeClass('vodl-video-box__active');
      changeVideo(videoBox, selectedSlider[0].children().first().children());
    });
    item.click(function (event) {
      event.preventDefault();
      var selected = $(this).children();
      changeVideo(videoBox, selected);
    });
    videoBox.change(function () {
      videoBox[0].removeEventListener('click', onVideoBoxClick);
      if (videoBox.find('.vodl-video-box__wrapper-slider-item-video').data('vodl-consent-required')) {
        return;
      }
      videoBox[0].addEventListener('click', onVideoBoxClick);
    });
  }
  function changeVideo(box, item) {
    item.parent().parent().children().children().removeClass('vodl-video-box__active');
    box.children().remove();
    var itemS = item.clone();
    item.addClass('vodl-video-box__active');
    box.append(itemS);
    box.change();
  }
  function playIframe(videoWrapper) {
    var iframe = videoWrapper.find('iframe');
    iframe.attr('src', function () {
      var value = $(this).attr('data-src');
      value = value + '?modestbranding=1&rel=0&autoplay=1&cc_load_policy=1';
      return value;
    });
    iframe.on('load', function () {
      videoWrapper.removeClass(hide);
      videoWrapper.parent().parent().children().last().hide();
      videoWrapper.parent().children().first().hide();
    });
  }
  function initSlider(attr, slider) {
    var slides = [];
    slider.each(function () {
      var id = [];
      $(this).siblings().each(function () {
        id.push($(this).attr('id'));
      });
      slides.push($(this).bxSlider(attr));
    });
    return slides;
  }

  /**
  * Initialization of video boxes by choosing the correct slider function.
  */
  function init_videoboxes() {
    videoBox = $('.vodl-video-box.pre-init');
    if (videoBox.length > 0) {
      videoBox.each(function () {
        if ($(this).hasClass('vodl-video-box--large') && x.matches) {
          desktopSlider($(this));
        } else {
          widgetSlider($(this));
        }
        // Initialized - remove lazy stuff.
        $(this).removeClass('pre-init');
      });
    }
  }
  function refresh_large_videoboxes() {
    console.log('refresh_large_videoboxes');
    var largeVideoBoxes = $('.vodl-video-box--large');
    if (largeVideoBoxes.length > 0) {
      largeVideoBoxes.each(function () {
        if ($(this).hasClass('vodl-video-box--large')) {
          refresh_large_preview($(this));
        }
      });
    }
  }
  function refresh_large_preview(box) {
    var videoBox = box.find('.vodl-video-box__video');
    videoBox[0].removeEventListener('click', onVideoBoxClick);
    if (!videoBox.find('.vodl-video-box__wrapper-slider-item-video').data('vodl-consent-required')) {
      videoBox[0].addEventListener('click', onVideoBoxClick);
    }
    videoBox.change(function () {
      videoBox[0].removeEventListener('click', onVideoBoxClick);
      if (videoBox.find('.vodl-video-box__wrapper-slider-item-video').data('vodl-consent-required')) {
        return;
      }
      videoBox[0].addEventListener('click', onVideoBoxClick);
    });
  }
  function onVideoBoxClick(event) {
    console.log('onVideoBoxClick');
    event.preventDefault();
    var iframe = $(this).find('.vodl-video-box__wrapper-slider-item-video-box');
    playIframe(iframe);
  }
  $(document).ready(function () {
    // Do the stuff only when box is already there and wasn't initialized, yet.
    if (videoBox.length > 0) {
      init_videoboxes();
    }
    // Initialize event listener for lazy videobox.
    window.addEventListener('newPage', init_videoboxes, false);
    window.addEventListener('refreshVideoBoxPreviews', refresh_large_videoboxes, false);
  });
})(window, document);
"use strict";

(function (window, document, undefined) {
  'use strict';

  var $ = window.jQuery,
    moment = window.moment,
    console = window.console || {
      log: function log() {}
    },
    ZAMGWeather = window.RussMedia.ZAMGWeather;
  var weatherBoxes = null;

  /**
   * Checks if weather boxes are in the DOM and we actually need to do something
   * @return {undefined} Has no return value
   */
  function init() {
    weatherBoxes = $('.vodl-weather-overview');
    if (weatherBoxes.length > 0) {
      checkOnUpdates();
    }
  }

  /**
   * For each found weather box it will
   *  - check if the weather box is in dynamic mode
   *  - check if the user has a township preference set
   *    that is different from the current (default) data displayed
   *  - if both conditions are met, fetch fresh data from the API and call
   *    renderData()
   * @return {undefined} Has no return value
   */
  function checkOnUpdates() {
    weatherBoxes.each(function () {
      var currentWeatherBox = $(this);
      var isDynamic = currentWeatherBox.data('dynamic') ? true : false,
        currentTownship = currentWeatherBox.data('township') ? currentWeatherBox.data('township') : false,
        cookieTownship = ZAMGWeather.checkCookiePreference('CurrentCity'),
        currentRegion = currentWeatherBox.data('region') ? currentWeatherBox.data('region') : false;

      // should the current widget be updated dynamically?
      if (isDynamic && currentTownship && currentRegion) {
        if (cookieTownship && cookieTownship != currentTownship) {
          ZAMGWeather.get(cookieTownship, currentRegion).then(function (response) {
            renderData(response, currentWeatherBox);
          });
        }
      }
    });
  }

  /**
   * Renders the data fetched from the API
   * @param  {object} data              Response object from the weather API
   * @param  {jQuery} currentWeatherBox jQuery object representing the current weather box
   * @return {undefined}                Has no return value
   */
  function renderData(data, currentWeatherBox) {
    // Try to read the config in <script type="application/json"> inside
    // the weather box.
    // There we should find some translated strings/string patterns
    var strings = {};
    try {
      var config = currentWeatherBox.find('script[type="application/json"]');
      strings = $.parseJSON(config.html());
    } catch (e) {
      // if we could not read config we fall back to some reasonable defaults.
      console.log(e);
      strings = {
        itemTitleToday: '{dayName}: {temp}°C - {stateText}',
        itemTitle: '{dayName}: {temp}°C - {stateText}'
      };
    }

    // grab the weather box items (=days) currently displayed
    var weatherBoxItems = currentWeatherBox.find('.vodl-weather-overview__item');
    // if we do not have enough data returned from the API, we do not do anything
    if (weatherBoxItems.length > data.township_forecast_data.length) {
      return;
    }

    // set locale for the date formatting or fallback to a default
    var locale = currentWeatherBox.data('locale') || 'en';
    moment.locale(locale);
    var d = 0;
    weatherBoxItems.each(function () {
      var item = $(this);

      // raw item data
      var dataItem = {
        dayName: moment.unix(data.township_forecast_data[d].valid_from).format('dddd'),
        temp: data.township_forecast_data[d].temperature_max,
        state: data.township_forecast_data[d].weather_state_day,
        stateText: data.state_mapping[data.township_forecast_data[d].weather_state_day].text,
        townshipName: data.township.name
      };

      // computed strings...
      var itemTitle = d === 0 ? strings.itemTitleToday : strings.itemTitle;
      // ...may contain placeholders, so let's process them.
      itemTitle = formatString(itemTitle, dataItem);
      item.find('.vodl-weather-compact').attr('title', itemTitle);
      item.find('.vodl-weather-compact__day').text(dataItem.dayName);
      item.find('.vodl-weather-compact__status').text(dataItem.stateText);
      item.find('.vodl-temperature-display__value').text(dataItem.temp);
      item.find('.vodl-weather-compact__icon .vodl-svg-sprite').removeClass().addClass('vodl-svg-sprite vodl-icon-weather-' + dataItem.state);
      item.find('svg use').attr('xlink:href', '#vodl-icon-weather-' + dataItem.state);
      d++;
    });
  }

  /**
   * Will replace every occurence of each props' property name in template
   * with the given property value.
   * Example:
   * props = { company: 'Apple', product: 'MacBook' }
   * template = 'The {product} is a notebook by {company}'
   * result: 'The MacBook is a notebook by Apple'
   *
   * @param  {string} template Template string with placeholders
   * @param  {object} props    Properties object with named properties
   * @return {string}          Resulting string with all placeholders replaced
   */
  function formatString(template, props) {
    var result = template;
    Object.keys(props).forEach(function (e) {
      var replace = "{".concat(e, "}");
      var re = new RegExp(replace, 'g');
      result = result.replace(re, props[e]);
    });
    return result;
  }
  init();
})(window, document);